export function TestCivitai(): any {
    return {
        "status": "success",
        "data": {
            "items": [
                {
                    "id": 58390,
                    "name": "Detail Tweaker LoRA (细节调整LoRA)",
                    "description": "<p>HF: <a target=\"_blank\" rel=\"ugc\" href=\"https://huggingface.co/OedoSoldier/detail-tweaker-lora\">https://huggingface.co/OedoSoldier/detail-tweaker-lora</a></p><p>This is a LoRA for enhancing/diminishing detail while keeping the overall style/character; it works well with all kinds of base models (incl anime &amp; realistic models)/style LoRA/character LoRA, etc.</p><p>Apply your own weight; this LoRA can be utilized for any weight up/down to 2/-2!</p><p><strong>Note: use a negative weight to reduce details!</strong></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 3,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 383007,
                        "favoriteCount": 0,
                        "thumbsUpCount": 27872,
                        "thumbsDownCount": 8,
                        "commentCount": 122,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 1764
                    },
                    "creator": {
                        "username": "CyberAIchemist",
                        "image": "https://lh3.googleusercontent.com/a/AEdFTp7wdMG_twkGoSPl9QFSRrBhaXvnEmP_l69xiJbH6g=s96-c"
                    },
                    "tags": [
                        "anime",
                        "photorealistic",
                        "concept",
                        "detailed",
                        "lora",
                        "undetailed"
                    ],
                    "modelVersions": [
                        {
                            "id": 62833,
                            "name": "v1.0",
                            "index": 0,
                            "modelId": 58390,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-05-05T07:28:19.122",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 383007,
                                "ratingCount": 19113,
                                "rating": 5,
                                "thumbsUpCount": 27872,
                                "thumbsDownCount": 8
                            },
                            "files": [
                                {
                                    "id": 44319,
                                    "sizeKB": 36973.8046875,
                                    "name": "add_detail.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-05T06:50:46.007Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "2DAE719F",
                                        "AutoV2": "47AAAF0D29",
                                        "SHA256": "47AAAF0D2945CA937151D61304946DD229B3F072140B85484BC93E38F2A6E2F7",
                                        "CRC32": "F1D60397",
                                        "BLAKE3": "5664139789418CE9328FB4E71FF9380FFDBBA2268747A40C428ED9D35501C047",
                                        "AutoV3": "7C6BAD76EB54"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/62833",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 692411,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8db45d23-7bcf-4979-8b35-0e7779c5a8f8/width=450/692411.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1920,
                                    "height": 3840,
                                    "hash": "UHHfVC~pI8M{XqkDact3RpRlocofXWkDjEob",
                                    "type": "image"
                                },
                                {
                                    "id": 692487,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5db97082-a909-4c3e-b6d1-2a46318f29a0/width=450/692487.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3840,
                                    "height": 2154,
                                    "hash": "UlI}YIaej@ae_4WBWVjZ?voffkj?%Nj]a}of",
                                    "type": "image"
                                },
                                {
                                    "id": 692332,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6e467dc7-45e9-435f-8aee-63fe9a098809/width=450/692332.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 6400,
                                    "height": 2154,
                                    "hash": "UXIOFTxFaet6Ipa}azWB~qbHfjof%Mj[ayof",
                                    "type": "image"
                                },
                                {
                                    "id": 692354,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a59e953b-c84d-490d-9b85-18d2dc2d2588/width=450/692354.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 6400,
                                    "height": 2154,
                                    "hash": "UZI5MYxYjYt6NfofWVWV~qjbf6oM-;t7fkof",
                                    "type": "image"
                                },
                                {
                                    "id": 692540,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/82175cf8-2a27-4173-9a8e-21108b885336/width=450/692540.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3072,
                                    "height": 1723,
                                    "hash": "UTKA~WxajYof~qj]j[ay?vWBa|ay_2t7j[of",
                                    "type": "image"
                                },
                                {
                                    "id": 692537,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6473e0c8-693a-46d8-a747-a27b6d3b5e27/width=450/692537.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3072,
                                    "height": 1723,
                                    "hash": "UVJ8t:aeWBt7~qj[a|jt-;kCayof_3ofj[fk",
                                    "type": "image"
                                },
                                {
                                    "id": 692538,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/60727991-d5b2-4aad-a7eb-628c8ad95653/width=450/692538.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3072,
                                    "height": 1723,
                                    "hash": "USIh1_WXfkj[?woLjtj].9j@j[az_Nj@a{js",
                                    "type": "image"
                                },
                                {
                                    "id": 692539,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/306491ca-ec13-4876-a9d2-983268ecc478/width=450/692539.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3072,
                                    "height": 1723,
                                    "hash": "UJPQ4~ITRjt7~qozayof?boft7ay-;oft7of",
                                    "type": "image"
                                },
                                {
                                    "id": 692536,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2971a79a-2c19-4851-a2c7-5c436dfb8083/width=450/692536.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3072,
                                    "height": 1723,
                                    "hash": "UUN,-Tt6WBai-@ockAt5x{a$oMWC_3kBj[of",
                                    "type": "image"
                                },
                                {
                                    "id": 692547,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b471fda3-28bb-4ce5-ab58-5b3ae9dbbc99/width=450/692547.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1920,
                                    "height": 3933,
                                    "hash": "UlL;T^~q?b?bxabHayj[s;j@ayWVxuoLayay",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/62833"
                        }
                    ]
                },
                {
                    "id": 12597,
                    "name": "墨心 MoXin",
                    "description": "<h3><strong>《墨心》—— 昔涓子《琴心》，王孙《巧心》，心哉美矣，故用之焉。</strong></h3><p>本品由安吉吴仓石、兴化板桥先生、八大山人、山阴伯年等大师之大小写意作品辅以现代人物训练而成。辅以恰当之提示词，诵先贤尊号，襄古今并用之意，明雅俗共举之美。</p><p></p><h3><strong>《疏可走马》—— <em>字画疏处可以走马，密处不使透风。</em></strong></h3><p>这是一个和<strong>墨心</strong>搭配使用的构图Lora, 一旦使用并再最前前置提示词后，就会采用较大面积留白的构图风格。可以在版本处找到他</p><p></p><p></p><p>注意事项：<br />1.）CFG范围将会改变风格</p><ul><li><p>1~3 : 大小写意</p></li><li><p>3~7 : 逐渐工笔</p></li></ul><p>2.）推荐基础模型为ChilloutMix、国风3.2等</p><p>3.）《墨心》的推荐Lora权重为0.85以下</p><p>4.）《疏可走马》推荐Lora权重为0.7~1</p><p>====================================</p><p></p><p><strong>\"MoXin\"<br /><em>Xi Juanzi \"Qinxin\". Wangsun \"QiaoXin\", Xin zai mei yi, gu yong zhi yan.</em></strong></p><p>MoXin is a Lora trained from on Chinese painting Masters lived in Ming and Qing dynasties.</p><p><br />“<strong>Shukezouma”<em><br />Zi hua shu chu ke yi zou ma, mi chu bu shi tou feng.</em></strong><br />This is a Lora that major functions in Traditionla Chinese painting composition. Once it is used and preceded by \"shukezouma\" prompts in the very beginning, it adopts a composition style featuring a large area of negative space.</p><p></p><p>Tips:</p><p>1.) The result style will change within the following CFG ranges:</p><ul><li><p>1~3 : Xieyi Painting</p></li><li><p>3~7 : Gongbi Painting</p></li></ul><p>2.) It is recommended to use with ChilloutMix, GuoFeng3.2, etc.</p><p>3.) It is recommended to use \"MoXin\"'s Lora weight of 0.85 or lower.</p><p>4.) It is recommended to use \"Shukezouma\"'s Lora weight between 0.7~1</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": false,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 150361,
                        "favoriteCount": 0,
                        "thumbsUpCount": 22370,
                        "thumbsDownCount": 0,
                        "commentCount": 190,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 986
                    },
                    "creator": {
                        "username": "simhuang",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c326741c-cef0-4fae-d12d-c11bfcf53300/width=96/simhuang.jpeg"
                    },
                    "tags": [
                        "chinese",
                        "chinese dress",
                        "style",
                        "hanfu",
                        "paintings",
                        "artstyle"
                    ],
                    "modelVersions": [
                        {
                            "id": 14856,
                            "name": "墨心 MoXin 1.0",
                            "index": 0,
                            "modelId": 12597,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p></p>",
                            "publishedAt": "2023-02-24T13:42:23.454",
                            "availability": "Public",
                            "trainedWords": [
                                "shuimobysim",
                                "wuchangshuo",
                                "bonian",
                                "zhenbanqiao",
                                "badashanren"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 124871,
                                "ratingCount": 790,
                                "rating": 4.97,
                                "thumbsUpCount": 992,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 12781,
                                    "sizeKB": 147598.38671875,
                                    "name": "MoXinV1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-24T13:56:11.469Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "AEA008EF",
                                        "AutoV2": "3FD52C707C",
                                        "SHA256": "3FD52C707C31B9AF2207F697D9DD26B400683D011914471814BB33645F518F07",
                                        "CRC32": "BFCFABD6",
                                        "BLAKE3": "FA614C32106A84590C0C3B407AAD99CE74950DF635403191C475C1BF214AF004",
                                        "AutoV3": "17CD20C7B6EA"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/14856",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 212957,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2fff45f4-5e4d-4c4c-0e54-c293b26aee00/width=450/212957.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UEK^g3~V^+oL00xZE1oexv%1RjozoMbbxuoK",
                                    "type": "image"
                                },
                                {
                                    "id": 214667,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f71d712-f412-43f9-da02-00e290af2d00/width=450/214667.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "U8M?@#%M_2~V?Hxt9Gt6?a?G9ZM{9at7kBD*",
                                    "type": "image"
                                },
                                {
                                    "id": 212954,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1d182216-d897-4b1a-aff3-769e4f8bb200/width=450/212954.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UBOfoX-.?a-oxu-:j?Io~Vt7D*-p%L9aIp-:",
                                    "type": "image"
                                },
                                {
                                    "id": 212953,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6ad48fd8-b87b-4fc1-c387-e07fdb45b300/width=450/212953.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UGPF+L%L-p%MkVxts.Rj~VRk9Z%1-;M|IV%f",
                                    "type": "image"
                                },
                                {
                                    "id": 162847,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4e5b6ac8-345f-490c-7c00-3809dd432300/width=450/162847.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 656,
                                    "height": 834,
                                    "hash": "UbOM{Rx]_N?b%LofIot7_3oLWBIV?HRjWVWB",
                                    "type": "image"
                                },
                                {
                                    "id": 162846,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a37541e9-2746-4c6c-c74f-4bc7aae2aa00/width=450/162846.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 656,
                                    "height": 834,
                                    "hash": "UeMaIm?b~q-;xtIVWCxu?bofM{M{?HM{NGt7",
                                    "type": "image"
                                },
                                {
                                    "id": 212952,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f2e21f7e-fb7e-4f47-9f50-8d80d462e900/width=450/212952.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UAO3LIs.~B^*?G^*%LRj~UIV0LoJ-oIVIpt6",
                                    "type": "image"
                                },
                                {
                                    "id": 212955,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5d9fcb8c-b1d9-44b4-0cfc-55e534a6ef00/width=450/212955.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "U7MZp,_M~W?H-oIp9t%1-:%1M{IVRkt6j]oL",
                                    "type": "image"
                                },
                                {
                                    "id": 214666,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aa77e228-10b5-4eeb-fb71-99723e3ff900/width=450/214666.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UAK^c[~V_2~V~VaeIo-o?bt6IUIVE2j?WCM{",
                                    "type": "image"
                                },
                                {
                                    "id": 212956,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/653374e4-97cb-4354-9db9-b38005f87800/width=450/212956.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UFLzT*-:~pjENFofD%WC?bWBD*WBRjj[xuxu",
                                    "type": "image"
                                },
                                {
                                    "id": 162880,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/845b0aae-34ec-49d9-1246-9e855c886f00/width=450/162880.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 656,
                                    "height": 834,
                                    "hash": "UkNw1U%g_Nx]%1j[RkfQ-;ayM{ayM|oft7j[",
                                    "type": "image"
                                },
                                {
                                    "id": 162297,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0cf1f2ca-cc17-485f-565c-e9dfb9e9dd00/width=450/162297.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 656,
                                    "height": 834,
                                    "hash": "UhM%o@_3_NtSt6t7Ipof_2NGM{oLRjWBxts:",
                                    "type": "image"
                                },
                                {
                                    "id": 162036,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/215995f8-5a24-4011-6d03-de278c19e200/width=450/162036.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 650,
                                    "height": 1075,
                                    "hash": "UlLzpo-=_N?bt6ayj[j[-:ayRjWBM{t7ofaz",
                                    "type": "image"
                                },
                                {
                                    "id": 162298,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f5907d2f-0905-42ac-a0cd-4cfe2168c600/width=450/162298.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 656,
                                    "height": 834,
                                    "hash": "UeNJ%j%g_4-;xZj[t7Rj?bIoM{xaf6s:NGt7",
                                    "type": "image"
                                },
                                {
                                    "id": 148061,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/293fe55d-3f65-45f7-cb1c-362c49640f00/width=450/148061.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2090,
                                    "height": 2527,
                                    "hash": "UgK1]:smt6Wp_3a|kCof~qkCa#j??bj]WBof",
                                    "type": "image"
                                },
                                {
                                    "id": 148060,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4992cf0f-e72d-4ab2-a965-d65db3ec1900/width=450/148060.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2090,
                                    "height": 2527,
                                    "hash": "UcKno7oht7tR~qj@WBf6~qj@WBWU?boeoeof",
                                    "type": "image"
                                },
                                {
                                    "id": 145336,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9f5430b5-b408-4edc-1439-f369d3094300/width=450/145336.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1360,
                                    "hash": "UCH_##-p4ob^NFk9xaIBIoxae.NF~WR*%gbb",
                                    "type": "image"
                                },
                                {
                                    "id": 172365,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9a268643-64bc-4647-5c89-d74ec8433800/width=450/172365.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UQGuwJWVoLxu~Wxaazxa-;ays:j[t7j[ayt6",
                                    "type": "image"
                                },
                                {
                                    "id": 172364,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d532aef-34bd-46ba-3556-a388f98d1f00/width=450/172364.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UZI5Pat7t7t6~Wa|WBoLM|M{RkofRQWBWBj[",
                                    "type": "image"
                                },
                                {
                                    "id": 172363,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/462bcaab-1b75-4d3d-33a7-77df0c78a500/width=450/172363.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UPFrt:t7xuxu~WWBj[%2-:f6ayjZt7t7ofay",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/14856"
                        },
                        {
                            "id": 20143,
                            "name": "疏可走马 Shukezouma 1.1",
                            "index": 1,
                            "modelId": 12597,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p><strong>疏可走马<br /><em>字画疏处可以走马，密处不使透风。</em></strong></p><p>这是一个和墨心搭配使用的构图Lora, 一旦使用并再最前前置提示词后，就会采用较大面积留白的构图风格。(具体咒语用法的样本请看附图)<br /></p><p>1.1更新：</p><ul><li><p>更疏了</p></li><li><p>落款、用印装的更像了</p></li></ul><p></p><p><strong>Shukezouma<em><br />Zi hua shu chu ke yi zou ma, mi chu bu shi tou feng.</em></strong><br />This is a Lora that major functions in Traditionla Chinese painting composition. Once it is used and preceded by \"shukezouma\" prompts in the very beginning, it adopts a composition style featuring a large area of negative space.</p><p></p><p>Update 1.1 : </p><ul><li><p>more shukezouma </p></li><li><p>better Luokuan and Yongyin.</p></li></ul>",
                            "publishedAt": "2023-03-08T08:02:13.202",
                            "availability": "Public",
                            "trainedWords": [
                                "shukezouma"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 19550,
                                "ratingCount": 15511,
                                "rating": 5,
                                "thumbsUpCount": 18267,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16805,
                                    "sizeKB": 147573.50390625,
                                    "name": "shukezouma_v1_1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-08T08:06:14.080Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {},
                                    "downloadUrl": "https://civitai.com/api/download/models/20143",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 212951,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a4b045e0-07ec-498e-63f3-850c11d9fc00/width=450/212951.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UEK^g3~V^+oL00xZE1oexv%1RjozoMbbxuoK",
                                    "type": "image"
                                },
                                {
                                    "id": 212950,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eff14bbf-e6cc-4c39-98b7-65bec03b7900/width=450/212950.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "U7MZp,_M~W?H-oIp9t%1-:%1M{IVRkt6j]oL",
                                    "type": "image"
                                },
                                {
                                    "id": 212949,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/35f06fc6-dc03-40d2-cb67-1d5cf1a8ba00/width=450/212949.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UGPF+L%L-p%MkVxts.Rj~VRk9Z%1-;M|IV%f",
                                    "type": "image"
                                },
                                {
                                    "id": 212948,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c68da939-7e71-4034-2caa-35594057b500/width=450/212948.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UBOfoX-.?a-oxu-:j?Io~Vt7D*-p%L9aIp-:",
                                    "type": "image"
                                },
                                {
                                    "id": 212947,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f3a435c7-2d19-4919-cdda-f7004c2b4700/width=450/212947.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UELN3$~V?aRk%Lf6IVxt?aofIUoLsoNGt7R*",
                                    "type": "image"
                                },
                                {
                                    "id": 212946,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/629f0ef5-1dba-4427-5eac-43c8f9882a00/width=450/212946.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UGO3a%?G^*%2~VjGNGf6^*WVR*xuE1s:IVWB",
                                    "type": "image"
                                },
                                {
                                    "id": 213864,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cbc7f5d3-8daf-4180-cece-b7d3574a7700/width=450/213864.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UFN]%*~V?HNG^+-pNGbH-pRjRjxtD*R*t7E2",
                                    "type": "image"
                                },
                                {
                                    "id": 214489,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/438199b8-c7ed-460c-26ab-abb0fa049800/width=450/214489.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "U8OW1p-p~V~V~V^*xZM{^*4o4oRj?G%LNGRk",
                                    "type": "image"
                                },
                                {
                                    "id": 213027,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ee3be969-55c6-4530-de5b-a4cdd4c47200/width=450/213027.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UEPiko-:?a^*~Vn%IVWBt7%LIoE1s:WBNG%L",
                                    "type": "image"
                                },
                                {
                                    "id": 214563,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eecd8a0c-f067-4ac4-7385-bf05e1bb5200/width=450/214563.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UFO{,F?H^+^*~WIoM{%MxuxtV@RQxu-:RjD*",
                                    "type": "image"
                                },
                                {
                                    "id": 214562,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b807589d-db66-4a1a-13f3-4ed3677b7600/width=450/214562.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UHOpD7-p~V%2?Gt6M|WC^*M{IVxa%2t6WXof",
                                    "type": "image"
                                },
                                {
                                    "id": 214561,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4a4fd7bd-61b3-4347-e6e2-80b7c72ae700/width=450/214561.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 1024,
                                    "hash": "UEP6a4_2^*~V^*NGRkxa~VWB9GRjE2xuIV%2",
                                    "type": "image"
                                },
                                {
                                    "id": 233737,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8ee5d508-417f-45ed-7c74-4b91844fde00/width=450/233737.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 894,
                                    "height": 1118,
                                    "hash": "UAGI17-o~U^*-o^*WBIVxaxtjFIo4:IVNG?G",
                                    "type": "image"
                                },
                                {
                                    "id": 233736,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/53d715a8-4e92-4a9f-a5d7-d85929fe3a00/width=450/233736.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UGI#DRxt%L%L-:bHj[j[~VWBIVRkRkR*ayWV",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/20143"
                        },
                        {
                            "id": 16075,
                            "name": "疏可走马 Shukezouma 1.0",
                            "index": 2,
                            "modelId": 12597,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p><strong>疏可走马<br /><em>字画疏处可以走马，密处不使透风。</em></strong></p><p>这是一个和墨心搭配使用的构图Lora, 一旦使用并再最前前置提示词后，就会采用较大面积留白的构图风格。(具体咒语用法的样本请看附图)<br /><br /><strong>Shukezouma<em><br />Zi hua shu chu ke yi zou ma, mi chu bu shi tou feng.</em></strong><br />This is a Lora that major functions in Traditionla Chinese painting composition. Once it is used and preceded by \"shukezouma\" prompts in the very beginning, it adopts a composition style featuring a large area of negative space.</p><p><br /></p>",
                            "publishedAt": "2023-02-27T08:21:45.067",
                            "availability": "Public",
                            "trainedWords": [
                                "shukezouma"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5940,
                                "ratingCount": 3345,
                                "rating": 5,
                                "thumbsUpCount": 3348,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 13673,
                                    "sizeKB": 147570.6435546875,
                                    "name": "shukezouma.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-27T08:26:19.311Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "9FA7990A",
                                        "AutoV2": "D8349A9D48",
                                        "SHA256": "D8349A9D48A5E74143611F3F7B6A95DD3C78642596E057ABFBB55508CF9D5774",
                                        "CRC32": "D8CA534F",
                                        "BLAKE3": "9783ACDA9F1FC29DC816756EE6353F468CB411AE0FA7E152491AEAE0F839B851",
                                        "AutoV3": "6A6858CB4531"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/16075",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 161956,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4d1d8e75-29eb-4099-65e6-d8d07332d500/width=450/161956.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UGF}+TockB%1aet6M|Rk~UWB%2NG?GRkNG-o",
                                    "type": "image"
                                },
                                {
                                    "id": 161955,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eb49527f-c356-4e0c-e6f1-abdf66373500/width=450/161955.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UOKwk1M|-:oe~VIoIV%2^*?Hj[RkE2WVt7NG",
                                    "type": "image"
                                },
                                {
                                    "id": 161954,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2ee9ff67-01bc-4008-f10c-55496bd71900/width=450/161954.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "U8KAf+xt?G?GoL%1~V9aNF-p?G-o^%E2D*~U",
                                    "type": "image"
                                },
                                {
                                    "id": 161953,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80d890d3-78fb-4248-a1de-4a76cfb0d300/width=450/161953.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UKHB#aIURkt7kWt6s:of~ANbRjoJ%1oLt6xt",
                                    "type": "image"
                                },
                                {
                                    "id": 162059,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aa98bd3c-219d-4a4e-0a37-fbc30c12be00/width=450/162059.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "ULGRI-~BxtM|xZt6oes:^jNGNHt6%1IpNGWC",
                                    "type": "image"
                                },
                                {
                                    "id": 162303,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/42e888fe-e1f2-4b46-e18a-31c4dd663d00/width=450/162303.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "ULKdJ9E2IoNG-:t6?Gay~V9a9a%1t6%L9at6",
                                    "type": "image"
                                },
                                {
                                    "id": 162577,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eecadea1-3d15-402b-14da-19cda779b400/width=450/162577.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UbI}bFxaxa-p-pD*IVNG?a%Mt6Rj~WD*IVR*",
                                    "type": "image"
                                },
                                {
                                    "id": 162302,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a65e2f64-0a5d-4606-4285-0bd7b2188700/width=450/162302.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "URLpv=?Gxtxt~CWBR*WV~VIoxaxtayt6IpM|",
                                    "type": "image"
                                },
                                {
                                    "id": 162576,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3dd7063d-8f8f-47b4-7597-00216e324800/width=450/162576.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UZL:}uIooL-o-:t7E1s:_2xa-pWB~VWBayWB",
                                    "type": "image"
                                },
                                {
                                    "id": 162301,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/082ba325-38b3-41d0-fa3e-769a2f091800/width=450/162301.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UWJaWH^*%Lxt%2%LD*s:~VWBRjoeM|M|ofxa",
                                    "type": "image"
                                },
                                {
                                    "id": 162300,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c78dc3ee-6ac9-4e63-cad7-c5c468d08200/width=450/162300.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UKLDoVaz^*%2~VxtIooe-ot6E1M|9aays:WC",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/16075"
                        }
                    ]
                },
                {
                    "id": 16014,
                    "name": "Anime Lineart / Manga-like (线稿/線画/マンガ風/漫画风) Style",
                    "description": "<h2>Update information</h2><p></p><p>V3.0 updated. Fine-tuned LoRA to improve the effects of generating characters with complex body limbs and backgrounds. The overall styling is more toward manga style rather than simple lineart. A lower CFG scale can make lines thinner.</p><p></p><p>V3.0更新。对LoRA进行了微调，改善生成人物肢体和复杂背景的效果。整体更趋向漫画风而非纯线稿。低CFG scale可以让线条变细。</p><p></p><h2>Recommend settings</h2><p>Model: Anything V4.5</p><p>VAE: Orangemix (the same with NAI)</p><p>LoRA Strength: 1</p><p>Sampler: DPM++ 2M Karras</p><p>Sampling steps: 20</p><p>CFG: 7</p><p>Negative embedding: <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7808/easynegative\">EasyNegative</a>、<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/16993/badhandv4-animeillustdiffusion\">badhandv4</a></p><p>Highres fix is also recommended.</p><p>Note: all the LoRA names used in sample images are my local name, you need to change them to your saved LoRA filename!</p><p>基模：Anything V4.5</p><p>VAE：Orangemix（同NAI）</p><p>LoRA强度：1</p><p>采样器：DPM++ 2M Karras</p><p>采样步数：20</p><p>CFG：7</p><p>负面embedding：<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7808/easynegative\">EasyNegative</a>、<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/16993/badhandv4-animeillustdiffusion\">badhandv4</a></p><p>推荐使用高清修复。</p><p>注意：样图中的LoRA名称是我本地文件名，要改成你保存的文件名！</p><p></p><h2>Difference</h2><p></p><p>Here's a comparision of V2.0 and V3.0 (locally called V3 and V4 on my machine - V2 on my machine is not published):</p><p>V2.0和V3.0的对比（在我的本地机器上命名为V3和V4——本地的V2我并未发布）：</p><p></p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/38354d83-7523-4334-c3de-1a3a493e5a00/width=525/38354d83-7523-4334-c3de-1a3a493e5a00\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cc03ae1f-4391-4ff5-4850-d9478d78c600/width=525/cc03ae1f-4391-4ff5-4850-d9478d78c600\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4c7eaa16-9f4d-4545-dc36-c2d3f43b9d00/width=525/4c7eaa16-9f4d-4545-dc36-c2d3f43b9d00\" /><p></p><p>Comparision of different CFG scale:</p><p>不同CFG scale对比：</p><p></p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/845cf24a-c5c6-4ee0-a999-d7130ecb7e00/width=525/845cf24a-c5c6-4ee0-a999-d7130ecb7e00\" />",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 29,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 141490,
                        "favoriteCount": 0,
                        "thumbsUpCount": 18848,
                        "thumbsDownCount": 0,
                        "commentCount": 62,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 340
                    },
                    "creator": {
                        "username": "CyberAIchemist",
                        "image": "https://lh3.googleusercontent.com/a/AEdFTp7wdMG_twkGoSPl9QFSRrBhaXvnEmP_l69xiJbH6g=s96-c"
                    },
                    "tags": [
                        "anime",
                        "girl",
                        "lineart",
                        "female",
                        "manga",
                        "monochrome",
                        "style",
                        "art style",
                        "woman",
                        "illustration",
                        "digital illustration",
                        "girls"
                    ],
                    "modelVersions": [
                        {
                            "id": 28907,
                            "name": "v3.0 manga-like",
                            "index": 0,
                            "modelId": 16014,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 23,
                            "description": null,
                            "publishedAt": "2023-03-25T13:39:23.464",
                            "availability": "Public",
                            "trainedWords": [
                                "lineart, monochrome"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 115274,
                                "ratingCount": 10940,
                                "rating": 5,
                                "thumbsUpCount": 13834,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 23894,
                                    "sizeKB": 18541.3203125,
                                    "name": "animeoutlineV4_16.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-25T13:41:36.762Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "37B1EC55",
                                        "AutoV2": "2FCD88E6AA",
                                        "SHA256": "2FCD88E6AA07B2DB73BEFCA54B3956131E1DECC8E6E719508CE32C28768F9B91",
                                        "CRC32": "EFC67C04",
                                        "BLAKE3": "A5F526048C00C17373CDA01DEED76C7C50632DA4A62FFCE1EA8ED1478FE86018",
                                        "AutoV3": "9B0C9BEB764D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/28907",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 326152,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fab28432-7d00-43c4-fbd6-ac5989ebf000/width=450/326152.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UGPjDVxuxu-p~qof_3t8?bt7%MWB_3WBIUt7",
                                    "type": "image"
                                },
                                {
                                    "id": 326151,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/50e107f9-7c60-465d-0112-9fe09acd4900/width=450/326151.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UBQ0UA?b4nxu_3D%%2%M~q-;M{%M%MM{M{IU",
                                    "type": "image"
                                },
                                {
                                    "id": 326150,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0c3c2e05-49e4-4123-72ca-abb270617300/width=450/326150.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UHLqb24n00_3?bD%?b-;_3%M-;9F~qfQD%Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 326149,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d973555b-c9c0-4079-333c-a7316dabef00/width=450/326149.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U9O40b%M00?H00-;00IU~qM{9FM{-pIU%2t7",
                                    "type": "image"
                                },
                                {
                                    "id": 326148,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1472757c-d69c-42b9-5efd-ebd2b3ee0300/width=450/326148.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UNN,[5-q~qt74nIURjRjWU%M4nM{%NIURjof",
                                    "type": "image"
                                },
                                {
                                    "id": 326147,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1d66f9df-83c6-4e21-e099-534322500c00/width=450/326147.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UOQ]$o%MRjxu~qayxuofogWBR%of%Mt7WBof",
                                    "type": "image"
                                },
                                {
                                    "id": 326146,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/99148fa8-3d12-42f1-ac02-ceb8a3fd8000/width=450/326146.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "ULO40bt700xu4nRj4nRjWBxuM{M{~q%MM_IU",
                                    "type": "image"
                                },
                                {
                                    "id": 326145,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cbd1c297-1fdb-4266-6088-01a236d2d400/width=450/326145.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UHQ,H^9FM{_3~qj[xu-;IUt7%M%M_3aeofRj",
                                    "type": "image"
                                },
                                {
                                    "id": 326144,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/58efcac1-34c0-434c-2564-2e229da6be00/width=450/326144.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UEON8-%MD%M_~q00D%9F00of9FRj_39ZD%t7",
                                    "type": "image"
                                },
                                {
                                    "id": 326143,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2872eef5-dcb7-422a-57f2-54dae3aace00/width=450/326143.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UPPGjX_3ofRj~qD%?b%M%MxuM{Rj_3ayM{WB",
                                    "type": "image"
                                },
                                {
                                    "id": 326142,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c9fc5e9e-95f6-4265-e12d-6ee8c9331300/width=450/326142.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UDQvtK?b?b-;?bxu~qM{%Moft7WB?bj[IURj",
                                    "type": "image"
                                },
                                {
                                    "id": 326141,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5d1578f8-d5fb-4a3a-a74e-34607b017f00/width=450/326141.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UAQT1F?bIU?bxaRj?bIU~qayxut7~qRjofM{",
                                    "type": "image"
                                },
                                {
                                    "id": 326140,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/25c0fec4-1d3b-4082-6929-19e3e4f58700/width=450/326140.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UcNKCrt7M{WB~qj[%Mj[xuRjE0ayM{WB%MWB",
                                    "type": "image"
                                },
                                {
                                    "id": 326139,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/feec308d-6506-4c69-aeea-3911d50c7800/width=450/326139.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UKO:;L~qayxu00WB-qaz4n9F-;IU4na|juj]",
                                    "type": "image"
                                },
                                {
                                    "id": 326138,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/081b8c6c-2f2c-4842-77b4-578e4ab3f700/width=450/326138.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U3MHGb-pIo0000009F~q4.00t7?b00D%M{WB",
                                    "type": "image"
                                },
                                {
                                    "id": 326137,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/22fe8286-8c89-4c14-1198-643554b57400/width=450/326137.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U7O40b~q-;xu00D%IUIU004nD%0000M{?bIU",
                                    "type": "image"
                                },
                                {
                                    "id": 326136,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/554ad745-4e24-4c1a-4d2b-d5d7c49bff00/width=450/326136.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U6Qck=D%00?b009FD%Rj~qxut7xu-;%Mxu?b",
                                    "type": "image"
                                },
                                {
                                    "id": 326135,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d83185dd-f1bd-45bb-6d87-4193fd1d9100/width=450/326135.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UWP6{p-;-;RjxuIUIUxu~qM{WUt7M{xu%MRj",
                                    "type": "image"
                                },
                                {
                                    "id": 326134,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/656a9a61-3f5a-4458-66bf-07647912c200/width=450/326134.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UFO:;L?b_3IU~qD%WB-;t7ay4nof00WBM{IU",
                                    "type": "image"
                                },
                                {
                                    "id": 326133,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/37811d54-6bab-4004-42ab-042ec41b5700/width=450/326133.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UGQ]$p%M~q?b%MayM{Rj_3ayRjof?bayxuof",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/28907"
                        },
                        {
                            "id": 19075,
                            "name": "v2.0 offset",
                            "index": 1,
                            "modelId": 16014,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 29,
                            "description": "<p>V2.0 is updated! Trained with offset noise, and all demos are generated with Anything V4.5 base model and orange mix VAE.</p><p>What this model does: to generate true linearts! (not that manga-like monochrome illustrations)</p><p>You can use it without trigger words, but sometimes there will be some unwanted colors, you can use <code>monochrome</code> and <code>lineart</code> to avoid that! (also, remove all colors from your prompt if you don't bother)</p><p>And, with the help of ControlNet, you can convert any image into lineart. I made a <a target=\"_blank\" rel=\"ugc\" href=\"https://www.bilibili.com/video/av568016537/\">video</a> to describe the process. <em>If the line is too thin, try lowering the low threshold for the canny preprocessor. Also, you can use multi-ControlNet to assist.</em></p><p>Try applying prompts like <code>sketch</code> or <code>doodles</code> , and you can get a cleaned sketch; by applying <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7252\">chartuner LoRA</a> and <a target=\"_blank\" rel=\"ugc\" href=\"https://twitter.com/DiffusionPics/status/1627990713546813443\">openpose helper image</a>, you can get a decent character reference sheet ... this LoRA is full of possibilities!</p><p>But sometimes it doesn't go well with character LoRAs, you can either lower the strength of the character LoRA or this LoRA. This LoRA should work fine with a strength of 0.8~1.</p><p><em>Note: since this LoRA is trained based on Anything V4.5, using other base models may have some deteriorations, and you may need to adjust the strength for different base models. Check this reference sheet for different models:</em></p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a8a7f93-32ff-4c9d-9689-197ca1ae7600/width=3968/203078\">https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a8a7f93-32ff-4c9d-9689-197ca1ae7600/width=3968/203078</a></p><p></p><p>V2.0已更新，基于offset noise训练，所有展示图片均使用Anything V4.5作为基模，并使用orange mix的VAE。</p><p>本模型目的：生成干净的线稿图，而非漫画风黑板图。</p><p>正常时无需使用触发词，但有时会出现不想要的颜色，可以使用 <code>monochrome</code> 或 <code>lineart</code> 来加以辅助。</p><p>辅以ControlNet，即可将任何图片均转化为线稿风格，我做了一个<a target=\"_blank\" rel=\"ugc\" href=\"https://www.bilibili.com/video/av568016537/\">视频</a>来简单讲解。<em>如果生成的线太细，可以尝试降低canny预处理器的low threshold，也可使用multi-ControlNet来辅助。</em></p><p>使用诸如 <code>sketch</code> 或 <code>doodles</code> 之类的prompt可以生成更干净的草稿风格图片；使用<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7252\">chartuner LoRA</a>和<a target=\"_blank\" rel=\"ugc\" href=\"https://twitter.com/DiffusionPics/status/1627990713546813443\">openpose helper image</a>则可以生成人物三视图。本LoRA可玩度很高！</p><p>有时使用人物LoRA可能会出现问题，可以通过降低人物LoRA的权重或者降低本LoRA权重来调整效果。本LoRA强度推荐0.8~1。</p><p><em>注：因本模型是基于Anything V4.5进行训练的，故使用其他基模时可能性能会有所下降，可能需要对强度进行调整。下图为不同模型的强度参考：<br /></em><a target=\"_blank\" rel=\"ugc\" href=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a8a7f93-32ff-4c9d-9689-197ca1ae7600/width=3968/203078\">https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a8a7f93-32ff-4c9d-9689-197ca1ae7600/width=3968/203078</a></p>",
                            "publishedAt": "2023-03-05T20:00:31.679",
                            "availability": "Public",
                            "trainedWords": [
                                "monochrome",
                                "lineart"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 23614,
                                "ratingCount": 4745,
                                "rating": 5,
                                "thumbsUpCount": 4746,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 15959,
                                    "sizeKB": 13946.3134765625,
                                    "name": "animeoutlineV3-000008.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-05T20:05:52.007Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "E2EDA5C3",
                                        "AutoV2": "84841BC5F8",
                                        "SHA256": "84841BC5F84C3BF6FEEAA2B3E20041DC423D1FCBE1EB04EDFF49F53CBB09DDE0",
                                        "CRC32": "B10AC843",
                                        "BLAKE3": "D2B9855C192C66C91ACE435EE18FEA9BEF16751BAD8460B7DFBEB85250143D97",
                                        "AutoV3": "119B46168213"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/19075",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 199597,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/035006e7-6522-48bb-2be8-38ee10329500/width=450/199597.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UAQm9k-;D%-;~qM{xu%M%MWBxu%M_3WBt7of",
                                    "type": "image"
                                },
                                {
                                    "id": 199596,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c045cf4f-f97a-4e9b-7ca1-1741ac963400/width=450/199596.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UBQm9k-;D%?b~qxu%Mt7WBRiWBWB~qofayRj",
                                    "type": "image"
                                },
                                {
                                    "id": 199595,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/27dedb38-f365-42fe-3330-83418a19c400/width=450/199595.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U9P?,a-;%M?b~qofM{t79FofD%WB^,t7RjWB",
                                    "type": "image"
                                },
                                {
                                    "id": 199629,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9e120a19-107d-4deb-1bc5-c5f473849d00/width=450/199629.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UBRfh4?bxu?b~qxu-;WB_3WB-;j[aeWB9FM{",
                                    "type": "image"
                                },
                                {
                                    "id": 199563,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2d174364-4a2b-4f83-45ad-3c15085b2f00/width=450/199563.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UAQvtK4n9F9F~qay-;%M?bjt-;?bD%Rj9F9F",
                                    "type": "image"
                                },
                                {
                                    "id": 199627,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/82c61304-7f40-4a06-cbea-c19ee00cac00/width=450/199627.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UARV|U%M%M~qxuWBt7t7~qt7-;ay-;ofoft7",
                                    "type": "image"
                                },
                                {
                                    "id": 199851,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d232b3e-27c0-41dd-276b-1a50394a1400/width=450/199851.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UAQ9[,D%4m~q0000_3xbIU-;?bayoft7xuRj",
                                    "type": "image"
                                },
                                {
                                    "id": 199566,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5d13399d-c4f5-4dd4-bcc7-36ae0abb1c00/width=450/199566.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U7Q0UAIU4n?bxuD%Rj_3_34nxuM{~qxuM{IU",
                                    "type": "image"
                                },
                                {
                                    "id": 199626,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/93b34daa-98b0-4c82-106a-93e763e56300/width=450/199626.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UDRypa-=~q?I%Mj[Rjt7?bWB-;xu%MWBt7j[",
                                    "type": "image"
                                },
                                {
                                    "id": 199625,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4c86b6af-9fd9-43e7-5b19-16c645bb7700/width=450/199625.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U7RC;~~q?b_3?bM{xu_3Rjj[IUj[?bM{Rjxu",
                                    "type": "image"
                                },
                                {
                                    "id": 199628,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/039a621f-a602-4c73-53ad-452f1cb74f00/width=450/199628.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 1280,
                                    "hash": "UGR:B1xuay-;?Iofaeof~qofayay_3ayofay",
                                    "type": "image"
                                },
                                {
                                    "id": 199768,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f88ea0d7-7612-463a-1702-88bbee4bcd00/width=450/199768.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 1920,
                                    "hash": "U8RMb$_3t7%3%MRjM{IU%MxuRjRj~qofxvof",
                                    "type": "image"
                                },
                                {
                                    "id": 199624,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5f2a796e-a2d0-46b0-5edc-f6fbf3498500/width=450/199624.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U7Q]$p~qRj?bj[~q%MM{WB-;xuoft7t7WBIU",
                                    "type": "image"
                                },
                                {
                                    "id": 199565,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/45860760-d06b-477a-02d8-cb5d0f936500/width=450/199565.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UDQ]$p%MIU-;_3s;?bt7-;t7M{IU~qM{WBof",
                                    "type": "image"
                                },
                                {
                                    "id": 199564,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4c900af8-f0c1-4bdf-9ff3-6bec955f8100/width=450/199564.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UAQ,H]~qIT-;IUM{t7t7?bRj%Mt7_3M{t7t7",
                                    "type": "image"
                                },
                                {
                                    "id": 199623,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e52f6da-5cb2-4613-1d89-225b18f6e000/width=450/199623.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UARV|U_3Rj_3~qxu%MWBfQoft6t7_3ayxut7",
                                    "type": "image"
                                },
                                {
                                    "id": 199622,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e8840b37-fc48-4cc3-53c2-7242568ab000/width=450/199622.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U6RMYu~Xx]^,~qD%M{xu_3M{?bD%~qoft7of",
                                    "type": "image"
                                },
                                {
                                    "id": 199620,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e8a1016-9c42-488d-7520-acf8c97b1d00/width=450/199620.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U7PZov~qxt_300?H004n00-;t7M{00Rj-;xb",
                                    "type": "image"
                                },
                                {
                                    "id": 199562,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fb61960c-c67c-47d0-150e-ddbc3be3dd00/width=450/199562.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UCRp5z%MRj-;xuofayM{RjRjxuof~qt7ofof",
                                    "type": "image"
                                },
                                {
                                    "id": 199619,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e364a707-1cd3-4ada-04df-19f1cbb6f900/width=450/199619.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UARp5z?bxv?b%Mof%MoM-;j[ayay~qj[WBt7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/19075"
                        },
                        {
                            "id": 18906,
                            "name": "v1.0 offset",
                            "index": 2,
                            "modelId": 16014,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 31,
                            "description": "<p>Lineart style LoRA trained with offset noise, use <code>monochrome</code> or <code>lineart</code> to trigger, I highly recommend removing any color words from your prompt, like:</p><ul><li><p><s>purple eyes</s></p></li><li><p><s>blue</s> flower</p></li><li><p><s>red</s> dress</p></li></ul><p>线稿风LoRA，使用时请添加<code>monochrome</code> 或<code>lineart</code> 开启。推荐将prompt中与颜色相关的单词去掉。</p><p>The demo images are generated w/ Anything V4.5 (orangemix VAE).</p><p>如何利用ControlNet提取线稿（using ContorlNet to extract linearts from illustrations）：<a target=\"_blank\" rel=\"ugc\" href=\"https://www.bilibili.com/video/BV1Nv4y1a7ts\">https://www.bilibili.com/video/BV1Nv4y1a7ts</a></p>",
                            "publishedAt": "2023-03-05T12:54:20.645",
                            "availability": "Public",
                            "trainedWords": [
                                "monochrome",
                                "lineart"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2602,
                                "ratingCount": 287,
                                "rating": 5,
                                "thumbsUpCount": 288,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 15829,
                                    "sizeKB": 36986.6044921875,
                                    "name": "animeoutline-000008.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-05T12:55:58.637Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "4FCCD80E",
                                        "AutoV2": "9FB5EA0E8B",
                                        "SHA256": "9FB5EA0E8B421105296154510F86190DA0540EA89FEDDDFD555B5FDB39A71C4E",
                                        "CRC32": "22144D53",
                                        "BLAKE3": "E911F2553F083379328C2BFB8008305DD62C1D747519946241EA3B0A31B65762",
                                        "AutoV3": "AC0E61A5AF38"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/18906",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 197168,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aab2c97d-50f4-4248-596e-6ebc900ccd00/width=450/197168.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UCQ]yh%Mj[_3?bt7?bof~qj[t7IUj[WBD%Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 197137,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/29c68ba5-8bbb-4281-1485-1a920319aa00/width=450/197137.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UBQ]$p-;9F%M~qWB_3xu_3IUxuxuM{-;Inj[",
                                    "type": "image"
                                },
                                {
                                    "id": 197149,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fae1862f-d847-4e23-f41c-5e97f0633a00/width=450/197149.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UAQvtK?b-;-;RjWB?bRj~qRj-;xu%NofD%ay",
                                    "type": "image"
                                },
                                {
                                    "id": 197167,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e99cbd4e-d401-456c-aa52-20dbcbae7000/width=450/197167.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U6Qck=~q00_300xu~qxu_3Rj?bt7-;9FIUt7",
                                    "type": "image"
                                },
                                {
                                    "id": 197148,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0a12515f-775d-4887-9835-b14ea3024f00/width=450/197148.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UHQJcfM{WBxu~qj[M{Rj%Mxu%Mj[%MD%IUWB",
                                    "type": "image"
                                },
                                {
                                    "id": 197147,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5660a661-2922-4302-2808-44b6e1853000/width=450/197147.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UCPZov-;M{%M-;IUayt7~q-;?bof9FWBWBD%",
                                    "type": "image"
                                },
                                {
                                    "id": 197177,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e7be922a-00d7-41a8-164f-b9121115b200/width=450/197177.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U6RMVm~q_3?b_3WBt7%M~qt7-;M{xuIUD%t7",
                                    "type": "image"
                                },
                                {
                                    "id": 197145,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f8117d79-bbb0-4eb8-6ddd-eb5cb0127b00/width=450/197145.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U7Rfh4-;IU?b009FM{WB-=IU-;WB~q%LofWB",
                                    "type": "image"
                                },
                                {
                                    "id": 197144,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/07284f89-3631-46a0-8f2b-42e0398a5a00/width=450/197144.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U8RC;~?bt7_34nt7~qofofof?bRjD%xuIURj",
                                    "type": "image"
                                },
                                {
                                    "id": 197166,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bb4c49ae-60f6-4a82-e5b1-b00a9dbe6400/width=450/197166.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UDRV|U~qt7?b?bxus;t7Rjt7D%M{~qt7t7%M",
                                    "type": "image"
                                },
                                {
                                    "id": 197165,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4fe22e9d-057e-49aa-75f3-8eeab0b91b00/width=450/197165.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "ULQT1FxuM{t7~qxu-;xuxut7WBofxuRjt7M{",
                                    "type": "image"
                                },
                                {
                                    "id": 197143,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d616ac81-8b57-49d9-0c60-4c5c71875b00/width=450/197143.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UHR{x+t7-;~q-;M{ofWBM{oft7WBt7t7ofxu",
                                    "type": "image"
                                },
                                {
                                    "id": 197176,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/094f8f9e-bb7f-4bcf-1feb-e6e6ec9e8d00/width=450/197176.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U9Q0XHIUD%~qD%M{WBxu00M{t7ofj[WU-;ay",
                                    "type": "image"
                                },
                                {
                                    "id": 197141,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c8ad686b-201b-4477-f968-6352c7f1eb00/width=450/197141.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UVQJcfof?bxuWBRjRjof~qt7M{WB%Mt7WBWB",
                                    "type": "image"
                                },
                                {
                                    "id": 197140,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0b08ee7d-ad63-4e7b-7f5b-4c1070bb8300/width=450/197140.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U8ON8-~q00_300IU00%M4nIU?b%MR*WB-;ay",
                                    "type": "image"
                                },
                                {
                                    "id": 197138,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2019c914-420b-4b86-61c5-91ece51bfb00/width=450/197138.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U8Rp5z~qM{~qt7j[%MRjt7j[%Mf6xu-;9Fay",
                                    "type": "image"
                                },
                                {
                                    "id": 203078,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a8a7f93-32ff-4c9d-9689-197ca1ae7600/width=450/203078.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3968,
                                    "height": 4042,
                                    "hash": "UJP%L#~q%f-;4n%Mt7oLRjWVofj[-;RjRjof",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/18906"
                        }
                    ]
                },
                {
                    "id": 14171,
                    "name": "Cute_girl_mix4",
                    "description": "<p>work with Chilloutmix, can generate natural, cute, girls.</p><p>Mix from chinese tiktok influencers, not any specific real person.</p><p></p><p>The third example used my other lora <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/15271\"><strong>20D.</strong></a></p><p></p><p>&lt;lora:cuteGirlMix4_v10:<strong>(<u>recommend0.4-0.7 here)</u></strong>&gt;,</p><p><strong>Trigger Word is '<u>mix4</u>' .</strong></p><p></p><p><strong>hope to receive your works!!!</strong></p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent",
                        "Sell"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 23,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 171840,
                        "favoriteCount": 0,
                        "thumbsUpCount": 17155,
                        "thumbsDownCount": 1,
                        "commentCount": 46,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 51
                    },
                    "creator": {
                        "username": "mpmp",
                        "image": "https://avatars.githubusercontent.com/u/69283412?v=4"
                    },
                    "tags": [
                        "girl",
                        "photorealistic",
                        "asian",
                        "woman",
                        "cute"
                    ],
                    "modelVersions": [
                        {
                            "id": 16677,
                            "name": "v1.0",
                            "index": 0,
                            "modelId": 14171,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 23,
                            "description": null,
                            "publishedAt": "2023-02-28T14:12:04.511",
                            "availability": "Public",
                            "trainedWords": [
                                "mix4"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 171840,
                                "ratingCount": 15546,
                                "rating": 5,
                                "thumbsUpCount": 17155,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 14058,
                                    "sizeKB": 147570.8681640625,
                                    "name": "mix4.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-28T14:17:28.982Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "32E2CB9D",
                                        "AutoV2": "9F3B38BF66",
                                        "SHA256": "9F3B38BF660E91B464C5A25D790F53EB876AC8CF17B479974D426B9732ACAC56",
                                        "CRC32": "4FD24168",
                                        "BLAKE3": "BF6FA2B53324C23E8583E317597AA8E0BE2AA301D2CF2AF544249FCC31628CFE",
                                        "AutoV3": "4768D15B1B67"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/16677",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 168196,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71e7486c-8daf-4225-1a7f-90fd21134600/width=450/168196.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U5HBuY00000000_Ntm^k00Xn.9Rp?bIU8_XT",
                                    "type": "image"
                                },
                                {
                                    "id": 168195,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c2525382-1f83-40a4-5efd-0a648249cc00/width=450/168195.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "ULI#Gl_2JCM|9ut7xuM{bw%1s8M{~p%LM{Io",
                                    "type": "image"
                                },
                                {
                                    "id": 244295,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ec94541c-1ca4-41ad-a911-062fe198e700/width=450/244295.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 614,
                                    "height": 1228,
                                    "hash": "UAHn:3~V0000004n9F9F?G?G_4?b00t7_N-=",
                                    "type": "image"
                                },
                                {
                                    "id": 168197,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/24ac2393-5acd-4f5e-6f8e-5cff4635db00/width=450/168197.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDIXz0~ATLE15U9ao~bc57$f^*^*?bxvDiV@",
                                    "type": "image"
                                },
                                {
                                    "id": 171633,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1d44451c-3097-4c43-b71a-3963dc5a8100/width=450/171633.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAJto6L35t~V%~u4=EE19GOt$%0L_2o#xZoz",
                                    "type": "image"
                                },
                                {
                                    "id": 171634,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/40e71ab1-245c-4bde-6bea-3c88850a7700/width=450/171634.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAFP51~1}OE,D+IU15Ip0KNF-=-oO]IVaJjE",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/16677"
                        }
                    ]
                },
                {
                    "id": 82098,
                    "name": "Add More Details - Detail Enhancer / Tweaker (细节调整) LoRA",
                    "description": "<h2 id=\"heading-734\">Add More Details - Detail Enhancer / Tweaker</h2><p><strong>Do you like what I do? Consider supporting me on </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/Lykon275\"><strong>Patreon</strong></a><strong> 🅿️ or feel free to </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://snipfeed.co/lykon\"><strong>buy me a coffee</strong></a><strong> ☕</strong><br /></p><p>I've been using the (great) Detail Tweaker by CyberAIchemist for a while now, and I was really curious. I really just wanted to know if I was capable of doing something similar. </p><p>I had a lot of fun doing this, and I think it came out pretty great. I wil ldefinitely incorporate it in most of my work going forward. </p><p>You should use this <strong>between 0.5 and 1 weight</strong>, depending on your preference. You can go lower than 0.5 for a more subtle effect, of course.</p><p>I also found out that this gives some interesting results at negative weight, sometimes. See the examples to see what I mean. <br /></p><p><strong>How to use LoRA's in auto1111:</strong></p><ul><li><p>Update webui (use <code>git pull</code> <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/embed/mn8fMF10XN4?start=31&amp;end=60\">like here</a> or redownload it)</p></li><li><p>Copy the file to <code>stable-diffusion-webui/models/lora</code></p></li><li><p>Select your LoRA like in <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/watch?v=-bMeyXOZwN0\">this video</a></p></li><li><p><strong>Make sure to change the weight</strong> (by default it's <code>:1</code> which is usually too high)</p></li></ul>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 3,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 256105,
                        "favoriteCount": 0,
                        "thumbsUpCount": 16224,
                        "thumbsDownCount": 10,
                        "commentCount": 37,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 2642
                    },
                    "creator": {
                        "username": "Lykon",
                        "image": "https://cdn.discordapp.com/avatars/180327464155742208/59254be18ccd627daf138d053327485d.png"
                    },
                    "tags": [
                        "portraits",
                        "landscape",
                        "detail",
                        "tool",
                        "lora",
                        "enhancer",
                        "detailer",
                        "details",
                        "backgrounds",
                        "detail tweaker"
                    ],
                    "modelVersions": [
                        {
                            "id": 87153,
                            "name": "v1.0",
                            "index": 0,
                            "modelId": 82098,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-06-01T17:50:20.439",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 256105,
                                "ratingCount": 10052,
                                "rating": 4.99,
                                "thumbsUpCount": 16224,
                                "thumbsDownCount": 10
                            },
                            "files": [
                                {
                                    "id": 59655,
                                    "sizeKB": 9324.0185546875,
                                    "name": "more_details.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-01T17:51:26.439Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "6CA57A45",
                                        "AutoV2": "D9CF2F88DE",
                                        "SHA256": "D9CF2F88DEC53A8DD8C09ABA2B1D67963B265EBDF8255660F5BCD7F1C8EDBA33",
                                        "CRC32": "2689A350",
                                        "BLAKE3": "F11043E61653E9554B228ABD28720AD6DD21294F6C2452DA6D8ADC8AAFC1E38D",
                                        "AutoV3": "3B8AA1D351EF"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/87153",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 995787,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1697174-7c8d-4bde-b053-7b1ec0692b64/width=450/995787.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1197,
                                    "height": 1708,
                                    "hash": "UcJaTG9Gbvoe~WR*t7xu%Lxajat7t7WBxtWB",
                                    "type": "image"
                                },
                                {
                                    "id": 995798,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5157d52c-8b21-4e48-a726-8ea220617d12/width=450/995798.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 4000,
                                    "height": 1301,
                                    "hash": "UmNdEu~ptS%Ox]WYs.o0tSWBj[a|%NjYaef6",
                                    "type": "image"
                                },
                                {
                                    "id": 995801,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7e6fc261-8d8c-431a-9905-a8ec3464379e/width=450/995801.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 4000,
                                    "height": 1261,
                                    "hash": "UjIE|h~q?b?b-;WBa|ofxuWCj[WB?bRjWBay",
                                    "type": "image"
                                },
                                {
                                    "id": 995802,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a685fb44-d7d4-459b-9a20-9772bf1ceb96/width=450/995802.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 4000,
                                    "height": 1451,
                                    "hash": "UjIr85~q?c?b_3RjRjay-;WBV@ae?bWBWBay",
                                    "type": "image"
                                },
                                {
                                    "id": 995804,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/594c3c85-062b-4cf5-a3c2-9337acc1ec23/width=450/995804.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 4000,
                                    "height": 1190,
                                    "hash": "UmIOFO~W?v.8?vWBWBa#-=RjWBay?bR*WBae",
                                    "type": "image"
                                },
                                {
                                    "id": 995806,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/65723580-78c1-40c9-8590-44672e151221/width=450/995806.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 4000,
                                    "height": 1694,
                                    "hash": "UiK1OD~q?v?b%goKe.oJ%gV@WBjs_2RjRkWB",
                                    "type": "image"
                                },
                                {
                                    "id": 995812,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f273059b-5479-4d1d-be81-cc0fe528e18a/width=450/995812.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 4000,
                                    "height": 1458,
                                    "hash": "URR34o~pNx.8~pD*xuWBx]RjoLV@?cofRjn$",
                                    "type": "image"
                                },
                                {
                                    "id": 995813,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4276b23d-6b92-4817-ac96-aff94b44a7ff/width=450/995813.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3648,
                                    "height": 1085,
                                    "hash": "UlH.KH~q?b-=_3ayRkR*-;WBj?j?-;WBayax",
                                    "type": "image"
                                },
                                {
                                    "id": 995814,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/98062983-8751-49b3-a762-47a68f5d2a6c/width=450/995814.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 4000,
                                    "height": 1301,
                                    "hash": "UjIq+K~q?v.8x^WBs:fQ-;R*aejZx^WVjsoL",
                                    "type": "image"
                                },
                                {
                                    "id": 995816,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/47450ab7-1eb0-48a0-94da-6a6a8135dc31/width=450/995816.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 4000,
                                    "height": 1301,
                                    "hash": "UhHU%+~q_3?b-=WBjsjs%gaeoLa|%gWBjZf6",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/87153"
                        }
                    ]
                },
                {
                    "id": 8730,
                    "name": "Hipoly 3D Model LoRA",
                    "description": "<p><strong><u>(日本語は後半にあります)</u></strong></p><p></p><h2>High-poly 3D Model LoRA</h2><p>This is a LoRA trained on high-polygon 3D model images.</p><p>It can provide clean, high-resolution skin and hair materials, as well as detailed clothing elements.</p><p></p><p>For those interested, I have compiled the technical insights gained during the training of ver.2 in the following article.</p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://note.com/takumi__ncr/n/n21016c358ea5\">https://note.com/takumi__ncr/n/n21016c358ea5</a></p><p></p><h2>Changes in 2.0</h2><ul><li><p>Increased the number of training images</p></li><li><p>Increased the training resolution (ver.1: 768, ver.2: 896)</p></li><li><p>Revised the tagging</p><ul><li><p>Removed the trigger word as well</p></li></ul></li><li><p>Reviewed the training parameters</p></li></ul><p></p><h2>Improvements in 2.0</h2><ul><li><p>It can reproduce a more 3D-like texture and stereoscopi effect than ver.1</p></li><li><p>LoRA can be applied without a trigger word</p></li><li><p>The style can be controlled using <code>3d</code> and <code>realistic</code> tags</p><ul><li><p>When added to Positive Prompt, it enhances the 3D feel</p></li><li><p>When added to Negative Prompt, it adds details such as clothing while maintaining the model's art style</p></li></ul></li><li><p>The issue of eroding the model's art style with tags such as <code>intricate</code>, <code>detailed</code> has been alleviated</p></li></ul><p></p><h2>Additional information</h2><p>The effect of LoRA was confirmed using the following my custom merged models:</p><ul><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/38606/alstroemeria-mix\">Alstroemeria Mix</a></p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/38619/bougainvillea-mix\">Bougainvillea Mix</a></p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/38636/chrysanthemum-mix\">Chrysanthemum Mix</a></p></li></ul><p></p><p></p><p></p><h2>High-poly 3D Model LoRA</h2><p>ハイポリゴン 3D モデル画像を学習した LoRA です。</p><p>3D らしいクリーンで高精細な肌・髪の質感や、衣服のディテールを与えることができます。</p><p></p><p>ver.2 の学習時に得られた技術的知見をまとめましたので、興味がある方は次の記事をご覧ください。</p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://note.com/takumi__ncr/n/n2fb9d265ffa9\">https://note.com/takumi__ncr/n/n2fb9d265ffa9</a></p><p></p><h2>2.0 での変更点</h2><ul><li><p>教師画像を増やしました</p></li><li><p>学習解像度を向上しました (ver.1: 768, ver.2: 896)</p></li><li><p>タグ付けを見直しました</p><ul><li><p>トリガーワードも削除しました</p></li></ul></li><li><p>学習パラメータを見直しました</p></li></ul><p></p><h2>2.0 での改善点</h2><ul><li><p>ver.1 よりも 3D らしいテクスチャ感、奥行き感が再現できます</p></li><li><p>トリガーワードなしで LoRA を適用することが可能です</p></li><li><p><code>3d</code>, <code>realistic</code> タグを使用することで絵柄のコントロールが可能です</p><ul><li><p>Positive Prompt に入れた場合、より 3D 感を強化します</p></li><li><p>Negative Prompt に入れた場合、モデルの絵柄を保ちつつ、衣装などのディテールを追加することができます</p></li></ul></li><li><p><code>intricate</code>, <code>detailed</code> などのタグによってモデルの絵柄を侵食してしまう問題が緩和されました</p></li></ul><p></p><h2>その他</h2><p>LoRA の動作確認は以下の自作マージモデルを使用して行いました。</p><ul><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/38606/alstroemeria-mix\">Alstroemeria Mix</a></p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/38619/bougainvillea-mix\">Bougainvillea Mix</a></p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/38636/chrysanthemum-mix\">Chrysanthemum Mix</a></p></li></ul>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [
                        "Image"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 123687,
                        "favoriteCount": 0,
                        "thumbsUpCount": 15379,
                        "thumbsDownCount": 1,
                        "commentCount": 47,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 20
                    },
                    "creator": {
                        "username": "NeoClassicalRibbon",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9ec3588e-bd6c-4dcd-46da-a3592e592300/width=96/NeoClassicalRibbon.jpeg"
                    },
                    "tags": [
                        "girl",
                        "3d",
                        "style",
                        "woman",
                        "fantasy",
                        "game character",
                        "girls",
                        "realistic"
                    ],
                    "modelVersions": [
                        {
                            "id": 44566,
                            "name": "v2.0",
                            "index": 0,
                            "modelId": 8730,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<ul><li><p>Increased the number of training images</p></li><li><p>Increased the training resolution (ver.1: 768, ver.2: 896)</p></li><li><p>Revised the tagging</p><ul><li><p>Removed the trigger word as well</p></li></ul></li><li><p>Reviewed the training parameters</p></li></ul>",
                            "publishedAt": "2023-04-13T10:16:52.886",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 73322,
                                "ratingCount": 5800,
                                "rating": 5,
                                "thumbsUpCount": 6952,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 33579,
                                    "sizeKB": 73870.203125,
                                    "name": "hipoly_3dcg_v7-epoch-000012.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-13T10:16:37.741Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "8448873C",
                                        "AutoV2": "3BE24D2E6D",
                                        "SHA256": "3BE24D2E6D581BAEC264ECAA843B0CA45524C95984C576DA641E8A8406F0EC5F",
                                        "CRC32": "6874765F",
                                        "BLAKE3": "708EDBD394699197450F0272A0F1D84475D93DEBAD50907C8E9D3CA60409A0A8",
                                        "AutoV3": "28C410185E6B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/44566",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 485327,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e28cc7f-dd15-4dbf-0981-b840dc19fc00/width=450/485327.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1344,
                                    "hash": "UHFh|*9FV=-:00?GodWB4.%2?HIo~qM{E1kC",
                                    "type": "image"
                                },
                                {
                                    "id": 485328,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d341fd8e-c6f6-4e14-3af1-58a97a5d5c00/width=450/485328.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1344,
                                    "hash": "UDE:MX.AyC4nD#4n-;D%0KDirrxZ?H-:M{t7",
                                    "type": "image"
                                },
                                {
                                    "id": 485329,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/97774583-5906-4ab5-9b3f-0292142c8300/width=450/485329.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UWF~HpIUoyV@_NM{bbadx]RjRkj[a#R+n$t7",
                                    "type": "image"
                                },
                                {
                                    "id": 485330,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5c84cc2e-aa60-44d0-3e63-453c2177b900/width=450/485330.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UUHdvmxuIVM|~UIpRjWBIoE2WCoexZafWBj[",
                                    "type": "image"
                                },
                                {
                                    "id": 485331,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ff865f98-cacc-4e8d-05ad-6f7450205400/width=450/485331.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEFYlV4:0M.700~VtQ4oW.r=WVxab]bb=xJB",
                                    "type": "image"
                                },
                                {
                                    "id": 485332,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5d33a71f-e9d4-4593-7519-76a0c070fa00/width=450/485332.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UOI4e54;Vr-:~A9bNG%24:xZg3M|D*%LNIM|",
                                    "type": "image"
                                },
                                {
                                    "id": 485333,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0ccf6bfd-7b9a-4e25-59f3-d9ec0f5e4b00/width=450/485333.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCD,WUyE4:tSHqxv9ZM{00NGozxtOsV?~qt7",
                                    "type": "image"
                                },
                                {
                                    "id": 485334,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71b8936d-aae1-4233-026c-3fe4c899e900/width=450/485334.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCE{On~T00-=ISbIpJS1IT%2xuE1xHIqxa-7",
                                    "type": "image"
                                },
                                {
                                    "id": 485335,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4fb0caa1-2316-48ef-ac1c-08f76d689000/width=450/485335.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCF=?koc4mxZ00k8_4tQ00IU^kIotSIV9FIV",
                                    "type": "image"
                                },
                                {
                                    "id": 485336,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4cb7c0f7-1007-4dc5-166c-f93ab36a5100/width=450/485336.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEFsSd0000^Roo?v9[RQuhnhQ-S~%fIBt8IU",
                                    "type": "image"
                                },
                                {
                                    "id": 485337,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80b0bcfd-a231-433c-41c6-304e3d828b00/width=450/485337.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U7A,%q-=9Z4nbE4nxuof00D%?H%M~q_3aeRj",
                                    "type": "image"
                                },
                                {
                                    "id": 485339,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9bcc7f93-c361-4a9d-6bae-a6f85167e700/width=450/485339.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UZHLuY?b_4%MD*MxRPRjITD%IoM{D%t7jYxu",
                                    "type": "image"
                                },
                                {
                                    "id": 485340,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cc586454-f7b5-482a-da0a-f9ac9b5bf100/width=450/485340.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UUGj~PWB};xZ4;WXM}NH5Rof9]kCxtn%%2oJ",
                                    "type": "image"
                                },
                                {
                                    "id": 485341,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e62df06e-4420-4ae8-ac7c-7f949e233b00/width=450/485341.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1344,
                                    "hash": "U9GR-xE-[j+?DNwG?w%g00-:ERtmDkK6R7D%",
                                    "type": "image"
                                },
                                {
                                    "id": 485342,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9107b6ef-e3b2-4a6a-45a9-18ffb1e14a00/width=450/485342.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1344,
                                    "hash": "UEF=5S%MNG=|9FxtNH~CkV4:juW:Swozo2Io",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/44566"
                        },
                        {
                            "id": 10301,
                            "name": "v1.0",
                            "index": 1,
                            "modelId": 8730,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 6,
                            "description": null,
                            "publishedAt": "2023-02-14T10:05:11.498",
                            "availability": "Public",
                            "trainedWords": [
                                "hiqcgbody"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 50365,
                                "ratingCount": 8443,
                                "rating": 5,
                                "thumbsUpCount": 8457,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 9820,
                                    "sizeKB": 147576.8359375,
                                    "name": "hiqcg_body_768_epoch-000005.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-14T10:06:35.894Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "8ACA88C2",
                                        "AutoV2": "B7E6D2EB35",
                                        "SHA256": "B7E6D2EB35EA33E7FF2E1D8D8313805448540F06D08B0477F0E8E1FC9970D0A5",
                                        "CRC32": "F9B52A97",
                                        "BLAKE3": "1939B544F256C503C8BC33CC0BF7806B69D0D7F2E85624BEA3D57AD6312B7F99",
                                        "AutoV3": "7CC1730C0BCD"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/10301",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 100657,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2338276a-87f7-4a1e-f92a-776a18ee4200/width=450/100657.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1368,
                                    "hash": "U5Exz_00.8D$t89Z%M0100~VD*RktQxaIU~p",
                                    "type": "image"
                                },
                                {
                                    "id": 100665,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8c671685-7024-4f91-0e6d-f473d628df00/width=450/100665.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1432,
                                    "hash": "URJj_39ayD%M~W%gW=%M-;Shs:%M%LIoofxt",
                                    "type": "image"
                                },
                                {
                                    "id": 100664,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f5fd5e58-fb62-447b-bccc-9db1a653c800/width=450/100664.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1344,
                                    "hash": "U4BV;G024-xZ~Vxu0L%0^iIVI[-o4ooIXTxt",
                                    "type": "image"
                                },
                                {
                                    "id": 100663,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/de5a22b1-a623-4c5a-d019-344e90a11900/width=450/100663.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDGkE]9G-N9a~B9a?G-n-n0fNaR+E09v-V-V",
                                    "type": "image"
                                },
                                {
                                    "id": 100662,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a2c58e4d-e964-4153-04b7-4700e4f60700/width=450/100662.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U8DSBxIo01~V%2E2Ioo30Loexut7-p-oD*NG",
                                    "type": "image"
                                },
                                {
                                    "id": 100661,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/843379c4-d5e0-4edb-1d6b-aa04b6845d00/width=450/100661.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U7C~n}0001?G_N01-:e:%3MxozE1E1WC^*9a",
                                    "type": "image"
                                },
                                {
                                    "id": 100660,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eca40cc2-dbc0-4a23-0940-c83aabe92600/width=450/100660.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UMIqT24U.8e-?w9F-:R*9ZE2E1xuMxozE1xu",
                                    "type": "image"
                                },
                                {
                                    "id": 100659,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e89b0ba3-75d4-433c-b22f-22093fe74e00/width=450/100659.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGGt?1NxOBxZ~W%2f*ae-;M|^*D*4:of?HM{",
                                    "type": "image"
                                },
                                {
                                    "id": 100658,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4462445b-4485-44c8-9178-6ee9a8912700/width=450/100658.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGIg.Y~W0KemyX-=nhIU~VR+%LMxb_ozROni",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/10301"
                        }
                    ]
                },
                {
                    "id": 8484,
                    "name": "Yae Miko | Realistic Genshin LORA",
                    "description": "<p>Realistic Yae Miko from Genshin Impact. All samples generate with <strong>Ulzzang-6500</strong>\" embeddings, \"<strong>vae-ft-mse-840000\" </strong>VAE.</p><p><em>For everyone: I am not using the official lora loader, so you should use the</em><strong><em> additional-network </em></strong><em>webui plugin to use my lora setting.</em><br />Recommended weights for txt2img - 0.45-0.75, higher weights may cause bad face generate.</p><ul><li><p><strong><em>Update 23/3/1: </em>I believe it's illegal if you made any works/Loras/Embeddings that using actual person‘s face without admission.</strong></p></li></ul><ul><li><p>Update 23/2/23: Shogun is here. <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/11896/raiden-shogun-or-realistic-genshin\">Raiden Shogun | Realistic Genshin | Stable Diffusion LORA | Civitai</a></p></li><li><p>Update 23/2/17: The new <strong>Mixed version</strong> using new dataset, I think it work better with other lora or different sd model now. <em>(Recommended weights for txt2img in this version - 0.65-0.85)</em></p></li></ul><p><strong>The Standard version</strong> working better only 1 lora model, will not missing characteristics, but sometimes will overfitting.</p><p><strong>The Full version</strong> use bigger dataset and working better with other face lora model, but missing some of characteristics.</p><p><em>Thank you for downloading!<br />Please leave a image with comment if you like it, I would love to see.</em></p><p><strong>If you see anyone selling images that generated by this model on pixiv or other platform please message me on twitter.</strong></p><p>(Perfroms better when prompt includes 'yae_sakura' :] )</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 112313,
                        "favoriteCount": 0,
                        "thumbsUpCount": 13792,
                        "thumbsDownCount": 4,
                        "commentCount": 66,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 23
                    },
                    "creator": {
                        "username": "Cy1zu_",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e20eb40c-bf3d-4e9e-730d-b2e9661ee100/width=96/Cy1zu_.jpeg"
                    },
                    "tags": [
                        "anime",
                        "character",
                        "girl",
                        "person",
                        "photorealistic",
                        "genshin impact",
                        "yae miko",
                        "woman",
                        "game character",
                        "girls",
                        "realistic",
                        "video game",
                        "lora"
                    ],
                    "modelVersions": [
                        {
                            "id": 11523,
                            "name": "YaeMiko-Mixed",
                            "index": 0,
                            "modelId": 8484,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p><em>(Recommended weights for txt2img in this version - 0.65-0.8)</em></p>",
                            "publishedAt": "2023-02-17T05:12:35.241",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 104203,
                                "ratingCount": 12978,
                                "rating": 5,
                                "thumbsUpCount": 13468,
                                "thumbsDownCount": 3
                            },
                            "files": [
                                {
                                    "id": 10691,
                                    "sizeKB": 59701.4453125,
                                    "name": "YaeMiko_Test.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-17T05:16:35.467Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "A05557CA",
                                        "AutoV2": "336CA6AFBC",
                                        "SHA256": "336CA6AFBCD712B14FDFC7C3F9DB044AB6020BDCBEC5ED66C926CAF639FD2691",
                                        "CRC32": "A6033DE1",
                                        "BLAKE3": "02B71EE5D5365DCB53664211ED6AF11C0B6B9B71C32DBF9D458EBD107BB852C3",
                                        "AutoV3": "8EAFB307ECF8"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/11523",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 173273,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/84735137-e96a-4d8b-9db1-96f44c1f8b00/width=450/173273.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 720,
                                    "height": 960,
                                    "hash": "UBJ%95AV00}SzANe1e^l00i^xurq_NE1VXVs",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/11523"
                        },
                        {
                            "id": 10003,
                            "name": "YaeMiko-Full",
                            "index": 1,
                            "modelId": 8484,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Working better with other face lora model.</p>",
                            "publishedAt": "2023-02-13T12:17:20.739",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5744,
                                "ratingCount": 198,
                                "rating": 4.98,
                                "thumbsUpCount": 201,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 9620,
                                    "sizeKB": 79571.40625,
                                    "name": "YaeMiko_Full.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-13T12:21:13.668Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "EE71C992",
                                        "AutoV2": "54DD534CE6",
                                        "SHA256": "54DD534CE659BF212A356B28BF77DA18A2152AD18EF060414D70B87373A4BFD1",
                                        "CRC32": "B8B3ECDD",
                                        "BLAKE3": "DF4BE902F1DD6853341263DCE347C0EEACD1D14FBEE76A67DAA007145D0A4418",
                                        "AutoV3": "0010A090A887"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/10003",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 173274,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/12b19039-a866-46ce-48b7-b6de1b82c400/width=450/173274.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 720,
                                    "height": 960,
                                    "hash": "UBJ%95AV00}SzANe1e^l00i^xurq_NE1VXVs",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/10003"
                        },
                        {
                            "id": 10002,
                            "name": "YaeMiko-Standard",
                            "index": 2,
                            "modelId": 8484,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Working better when only itself.</p>",
                            "publishedAt": "2023-02-13T12:17:20.739",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2366,
                                "ratingCount": 169,
                                "rating": 4.98,
                                "thumbsUpCount": 169,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 9622,
                                    "sizeKB": 79571.40234375,
                                    "name": "YaeMiko.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-13T12:26:13.105Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "DA7B875C",
                                        "AutoV2": "AEB5B922EC",
                                        "SHA256": "AEB5B922ECE8711E5D1D39A9324E73C2D3513EF681E3A18C352A87EE1D809178",
                                        "CRC32": "7A5799CC",
                                        "BLAKE3": "14E0BB37C6D1D7B71C04D24BA6361174322FE8FFC8DD43B7704A5E0EE7E8CD9E",
                                        "AutoV3": "7A52C16BA71A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/10002",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 173275,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/83e89d2e-5994-4993-9ff0-c16855a70100/width=450/173275.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 720,
                                    "height": 960,
                                    "hash": "UBJ%95AV00}SzANe1e^l00i^xurq_NE1VXVs",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/10002"
                        }
                    ]
                },
                {
                    "id": 88132,
                    "name": "LEOSAM's Clothing +/-  Adjuster  衣物增/减  LoRA",
                    "description": "<p>🖥️Welcome to try out the open-source <a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/jiayev/GPT4V-Image-Captioner\"><strong><u>GPT4V-Image-Captioner</u></strong></a>, developed by my friend and me. It offers a one-click installation and comes integrated with multiple features including image pre-compression, image tagging, and tag statistics. Recently, we also launched the <a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/SleeeepyZhou/sd-webui-GPT4V-Image-Captioner\"><strong><u>webui plugin version</u></strong></a> of this tool, everyone is welcome to use it!</p><p></p><p>🌍<span style=\"color:rgba(255, 255, 255, 0.8)\">欢迎加入</span>QQ群\"兔狲·AIGC梦工北厂\"，群号 ：<span style=\"color:#fab005\">780132897</span> ；\"兔狲·AIGC梦工南厂\"，群号 ：<span style=\"color:#fab005\">835297318</span>（入群答案：兔狲）。<span style=\"color:rgba(255, 255, 255, 0.8)\">Telegram群聊“兔狲的SDXL百老汇”，链接：</span><a target=\"_blank\" rel=\"ugc\" href=\"https://t.me/+KkflmfLTAdwzMzI1\"><span style=\"color:rgb(250, 176, 5)\">https://t.me/+KkflmfLTAdwzMzI1</span></a></p><p></p><p><strong>📖这是一个调节所绘制对象衣物多少的功能性LoRA。通过将LoRA权重从-1.0调节至1.0，可以实现绘制对象衣物的逐步减少。</strong></p><p><strong>This is a functional LoRA for adjusting the amount of clothing on the drawn objects. By adjusting the LoRA weight from -1.0 to 1.0, a gradual reduction of the clothing on the drawn objects can be achieved.</strong></p><p></p><p><strong><u>如何制作与封面示意图类似的gif：</u></strong></p><p>SD 文生图界面下方\"脚本\"的 \"XYZ plot\" 里有个“提示词搜索/替换”的选项。可以使用这个功能，以固定间隔从-1 到 1，改变lora模型使用权重。然后SD就可以依次同一提示词下、lora权重渐变的一系列图像。得到这些图像后，可使用ffmpeg工具包或者其他 gif 制作工具，将这些图像制作成 gif 动图。</p><p>建议使用controlnet中的openpose功能来固定人物姿态。如果你想进一步固定背景，则需要使用inpaint功能。</p><p></p><p><strong><u>How to create a gif similar to the cover gif:</u></strong></p><p>In the \"XYZ plot\" under the \"Script\" section of the SD interface, there is an option for \"Prompt S/R (Prompt search/replacement)\". You can use this feature to change the weighting of the Lora model at fixed intervals from -1 to 1. SD can then generate a series of images with the same Prompt and gradually changing Lora weights. After obtaining these images, you can use the FFmpeg toolkit or other GIF creation tools to create animated GIFs from these images.</p><p>It is recommended to use the 'OpenPose' feature in ControlNet to fix the character's pose. If you want to further fix the background, you will need to use the 'Inpaint' feature.\"</p><p></p><p><strong><u>如何制作与“Clothing +/- Adjuster”类似的LoRA：</u></strong></p><p>本模型受青龙大佬在<a target=\"_blank\" rel=\"ugc\" href=\"https://www.bilibili.com/video/BV11m4y147WQ/?spm_id_from=333.337.search-card.all.click&amp;vd_source=98fa411a98cd1aa45fe8235bb8207969\">此视频</a>中所介绍的第一种方法“复印学习法”启发。我进行了一些改进以实现多张图情况下的批量训练。具体的步骤如下：</p><p>步骤一：挑选N组不同人物的状态A与状态B对比图片，并形成状态A图像训练集与状态B图像训练集。保证相同人物的状态A与状态B两张图片的文件名相同。</p><p>步骤二：对状态A训练集添加txt标签，每个图片只打一个可以区分不同人物的特殊词汇标签。比如有10个人物，那就给每个人物从jinitaimei1至jinitaimei10分配各自的标签。然后将状态A训练集的所有标签复制粘贴进状态B图像训练集中。</p><p>步骤三：选择与训练集画风相近的底模C，使用状态A图像训练集进行Lora训练直至模型过拟合，输入人物N的对应标签后，只能生成人物N的状态A照片。</p><p>步骤四：将训练得到的过拟合LoRA模型以1.0的比例融合进底模C中（更新：经进一步测试，勾选上same to strength效果会更好），然后用状态B图��训练集基于新底模进行Lora训练。该训练过程不一定要训练至严重过拟合，可以选择LoRA过程文件进行AI绘图测试，只要能通过调节权重，实现状态A至状态B的过渡即可。（更新：经进一步测试，甜蜜点大概在每张图片400在800步范围内）</p><p>步骤五：如果训练的LoRA所涉及场景较复杂，在高权重下会出现过拟合的情况。有两种改良的建议：一是进行LoRA分层调节，降低LoRA中与A/B状态切换无关的层数的权重；二是压缩LoRA的维度，比如从64压缩至4。</p><p></p><p><strong><u>How to make a LoRA similar to \"Clothing +/- Adjuster\":</u></strong></p><p>This model is inspired by the first method \"Copy Learning\" introduced by Qinglong in <a target=\"_blank\" rel=\"ugc\" href=\"https://www.bilibili.com/video/BV11m4y147WQ/?spm_id_from=333.337.search-card.all.click&amp;vd_source=98fa411a98cd1aa45fe8235bb8207969\">this video</a>. I made some improvements to implement batch training in the case of multiple images. The specific steps are as follows:</p><p>Step 1: Select N groups of comparison images of different characters in State A and State B. Put them into the State A image training set and the State B image training set, respectively. Please ensure that the file names of the two images of State A and State B for the same character are the same.</p><p>Step 2: Add txt labels to the State A training set, with each image receiving only one unique word label that distinguishes different characters. For example, if there are 10 characters, assign each character a label from jinitaimei1 to jinitaimei10. Then copy and paste all labels from the State A training set into the State B image training set.</p><p>Step 3: Choose a base model C with a similar style to the training set. Use the State A image training set for Lora training until the model overfits.</p><p>Step 4: Merge the overfitted LoRA model obtained from training into the base model C at a ratio of 1.0 (Update: After further testing, it will be better to choose same to strength). Then, use the State B image training set for Lora training based on the new base model. This training process does not necessarily need to be trained until severe overfitting occurs; you can choose the LoRA process file for AI drawing tests, as long as the transition from State A to State B can be achieved by adjusting the weight. (Update: 400～800 steps for single pic)</p><p>Step 5: If the LoRA training involves complex scenes, overfitting may occur at high weights. There are two suggested improvements: one is to perform layer-by-layer adjustment of LoRA, reducing the weights of layers unrelated to the A/B state switch; the other is to compress the dimensions of LoRA, such as from 64 to 4.</p><p></p><p></p><p>除了这个LoRA之外，我的作品还包括：</p><ul><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/33208/filmgirl-film-grain-lora-and-loha\"><strong>FilmGirl/胶片风</strong></a><strong> </strong>Lora<strong>模型：如果你想增加你所绘制人物的真实感，这个Lora就是目前最佳的选择。</strong></p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/43977/moonfilm\"><strong>MoonFilm</strong></a><strong> </strong>CheckPoint模型<strong>：可能是整个civitai上皮肤真实感Top5的写实模型。</strong></p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/33194/pallass-catmanul-lora\"><strong>Pallas's cat/兔狲</strong></a><strong> </strong>LoRA<strong>模型：兔狲是这个世界最有趣的猫科动物，请将你的GPU算力献给可爱的猫猫。</strong></p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/52652/instant-photo-polaroid-loha-and-lora\"><strong>拍立得/Polaroid</strong></a><strong> </strong>Lora<strong>模型：一个实现拍立得照片质感的LoRA，目前还在进一步改进中。</strong></p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/51484/eva-neon-genesis-evangelion-lora\"><strong>EVA『新世纪エヴァンゲリオン』</strong></a>LoRA<strong>模型：</strong><span style=\"color:rgb(193, 194, 197)\">可以生成类EVA风格泛用人型决战兵器的LoRA，适配EVA 00、EVA 01、EVA 02、EVA 08四款机型。</span></p></li></ul><p>In addition to this LoRA, my works also include:</p><ul><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/33208/filmgirl-film-grain-lora-and-loha\"><strong>FilmGirl Film Style Lora</strong></a> Model: If you want to increase the realism of the characters you draw, this Lora is currently the best choice.</p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/43977/moonfilm\"><strong>MoonFilm CheckPoint</strong></a> Model: Possibly one of the top 5 most realistic skin models on Civitai.</p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/33194/pallass-catmanul-lora\"><strong>Pallas's Cat LoRA</strong></a> Model: Pallas's cat is the most interesting feline in the world. Please dedicate your GPU power to these adorable cats.</p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/52652/instant-photo-polaroid-loha-and-lora\"><strong>Polaroid Lora</strong></a> Model: A LoRA that achieves the texture of Polaroid photos, currently undergoing further improvements.</p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/51484/eva-neon-genesis-evangelion-lora\"><strong>EVA \"Neon Genesis Evangelion\" LoRA</strong></a> Model: A LoRA that generates EVA-style general-purpose humanoid combat weapons, compatible with EVA 00, EVA 01, EVA 02, and EVA 08 models.</p></li></ul><p></p><p></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 25,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 106353,
                        "favoriteCount": 0,
                        "thumbsUpCount": 13747,
                        "thumbsDownCount": 2,
                        "commentCount": 80,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 141
                    },
                    "creator": {
                        "username": "LEOSAM",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a20200e6-02ed-4115-a756-754aacfea68e/width=96/LEOSAM.jpeg"
                    },
                    "tags": [
                        "photorealistic",
                        "style",
                        "woman",
                        "furry",
                        "cloth"
                    ],
                    "modelVersions": [
                        {
                            "id": 117151,
                            "name": "ClothingAdjuster 3.0",
                            "index": 0,
                            "modelId": 88132,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 25,
                            "description": "<p>通过分层融合，改善了权重1时的皮肤质感</p><p>Improved skin texture at weight 1 with layered fusion</p>",
                            "publishedAt": "2023-07-14T02:10:00",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 76091,
                                "ratingCount": 4734,
                                "rating": 5,
                                "thumbsUpCount": 8618,
                                "thumbsDownCount": 2
                            },
                            "files": [
                                {
                                    "id": 83715,
                                    "sizeKB": 4715.828125,
                                    "name": "ClothingAdjuster3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-14T02:04:54.016Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "4C2BE859",
                                        "AutoV2": "13F67CA924",
                                        "SHA256": "13F67CA924AEB9AB8D93739D84DB0F8205A8CFB83EE05AF74F3F169CB47F2E38",
                                        "CRC32": "F54A2469",
                                        "BLAKE3": "7C809FBFCD5D78F3D68A621496604A3DF794A8CDF95423AAA492BFD9A1E0222B",
                                        "AutoV3": "D376664395F1"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/117151",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1546097,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/49653eab-3431-4e09-a1f4-c65f627c0f25/width=450/1546097.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 832,
                                    "hash": "U5CsdT_300}@00ofK+4:00IA}?S2%gD%00?b",
                                    "type": "video"
                                },
                                {
                                    "id": 1546048,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04d62acc-f826-418e-bf25-60c843e042bf/width=450/1546048.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 896,
                                    "hash": "U87d?~-pDOM{_NxuM{Rjt-kqELM{.9kWD%Rj",
                                    "type": "video"
                                },
                                {
                                    "id": 1546049,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0e80bd93-e818-4ae5-be3f-97756c9377e3/width=450/1546049.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 896,
                                    "hash": "UBBxczkDzqV@{ys.V[Rk#lRkkp%19vWCXSoz",
                                    "type": "video"
                                },
                                {
                                    "id": 1546050,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/729e3e4c-ddb4-42de-8553-35990b810d6b/width=450/1546050.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3072,
                                    "height": 1874,
                                    "hash": "UWEyVzRjRjof~qt7fkj[_3t7f6fR~qWBayj[",
                                    "type": "image"
                                },
                                {
                                    "id": 1546055,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5afbce17-7462-426d-90b3-c0b4dcc3efe7/width=450/1546055.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3072,
                                    "height": 1874,
                                    "hash": "UcKJoeRRWBay~q%2j]bH%#kCa|j[?bNGayoL",
                                    "type": "image"
                                },
                                {
                                    "id": 1546056,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/64e0b1aa-ae28-402c-a29f-821979038d58/width=450/1546056.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3072,
                                    "height": 1874,
                                    "hash": "UgI#cINGxtWV~qt7ozt6?bbIWBof-;oLWBWB",
                                    "type": "image"
                                },
                                {
                                    "id": 1546057,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aae621f3-0266-4d1d-b612-3a3b9d094c1d/width=450/1546057.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3072,
                                    "height": 1874,
                                    "hash": "UVKx9yRjV@WB-;t7ofxu~qt7j[fRRkj[WBWB",
                                    "type": "image"
                                },
                                {
                                    "id": 1546058,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/293fea52-cf3a-4c65-bf09-0e36c1eb3a1e/width=450/1546058.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 3072,
                                    "height": 1874,
                                    "hash": "UTDv7rNGf6a|~qs:j[j[~qt6WVj[_NkCj@j[",
                                    "type": "image"
                                },
                                {
                                    "id": 1546060,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d671e03c-5ee9-4783-8034-90f3105fc666/width=450/1546060.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3072,
                                    "height": 1874,
                                    "hash": "UcD]SVbHoLt7~qt7ayof?vt6WBj[?cbHjtj[",
                                    "type": "image"
                                },
                                {
                                    "id": 1546063,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c579547f-9a1e-4f40-a83b-6bb60b9e9436/width=450/1546063.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3072,
                                    "height": 1874,
                                    "hash": "UXE{IRs;jFt6_3kBj[WV_3aybHWC~qt7jZoe",
                                    "type": "image"
                                },
                                {
                                    "id": 1546065,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0c5dbed8-e64c-48aa-86df-fb1b81d97eb1/width=450/1546065.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3072,
                                    "height": 1874,
                                    "hash": "UVE{kPRkjtoz~qt7oej[_3t7WBjs?boffkf5",
                                    "type": "image"
                                },
                                {
                                    "id": 1546080,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/11bd3a87-b48c-4fc0-a95c-ee9fbc37ec9d/width=450/1546080.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3072,
                                    "height": 1927,
                                    "hash": "UWJ*hzR.Rjof?wsmj[ay-;t6kCay~qW=f5j[",
                                    "type": "image"
                                },
                                {
                                    "id": 1546087,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8eeec1c3-a908-40da-957a-538cd9b123a2/width=450/1546087.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3072,
                                    "height": 1874,
                                    "hash": "UUFO}xo#WEof?vn$offQ_3aeRjWB~qkCkCfk",
                                    "type": "image"
                                },
                                {
                                    "id": 1546093,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/516b8029-6443-47c1-9345-f82c95ea1b0d/width=450/1546093.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3072,
                                    "height": 2012,
                                    "hash": "UYBN4qs;j[of~qoLjtof_3j[fkof_3j[j[j[",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/117151"
                        },
                        {
                            "id": 95588,
                            "name": "ClothingAdjuster 2.0",
                            "index": 1,
                            "modelId": 88132,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 8,
                            "description": "<p>2.0 版本更新内容：</p><p>将衣服的变化范围扩大了10%；</p><p>小幅度优化了权重1.0时的肤色</p><p>Version 2.0 updates:</p><p>Expanded the change range of clothes by 10%;</p><p>Slightly optimized skin tone at weight 1.0</p>",
                            "publishedAt": "2023-06-14T03:55:49.308",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 26053,
                                "ratingCount": 3927,
                                "rating": 5,
                                "thumbsUpCount": 4651,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 66309,
                                    "sizeKB": 4715.828125,
                                    "name": "ClothingAdjuster2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-14T04:06:36.590Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "C7A2B55C",
                                        "AutoV2": "8B7D122497",
                                        "SHA256": "8B7D122497295D91C9C238E263DCBE2F3E63993AE1D1F5386F890DA6AD3C7C15",
                                        "CRC32": "3C613DE6",
                                        "BLAKE3": "AC9C06A20A70B6C01588363ED33F5F3EDD1D79512725C449B794984860DF9E3C",
                                        "AutoV3": "F038E3A5B67B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/95588",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1137985,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a5e44609-a2a3-4621-b9c3-2dc5a38d134b/width=450/1137985.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 400,
                                    "height": 720,
                                    "hash": "UGGuOJ4Tk?^5?^IAa0so0Lk?PUEk02x[-;I;",
                                    "type": "video"
                                },
                                {
                                    "id": 1138037,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9a804b3b-8681-4953-93a1-872b7c2e0c64/width=450/1138037.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 320,
                                    "height": 569,
                                    "hash": "U6GuRMo#00_3r;t7^,R*00oy~qM__3of4nV@",
                                    "type": "video"
                                },
                                {
                                    "id": 1138044,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a3c4d84-1a06-457b-b877-f80717067bc2/width=450/1138044.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3072,
                                    "height": 2349,
                                    "hash": "UgHBl8s:WCof~qs:aeoe?vkBWBfQ%gWBfkj[",
                                    "type": "image"
                                },
                                {
                                    "id": 1138049,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/348fef11-595a-4792-b95a-4601647ca9a4/width=450/1138049.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3072,
                                    "height": 2349,
                                    "hash": "UTHUh4WBxaj[_NjZWBt6.SR*Rkay~qoLbHWC",
                                    "type": "image"
                                },
                                {
                                    "id": 1138174,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/498f156c-3ebd-43f5-a16f-6e9804f3d228/width=450/1138174.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3072,
                                    "height": 2349,
                                    "hash": "UUDcO1bIRkay~qofoej[_3s:kCfk~qa#ayay",
                                    "type": "image"
                                },
                                {
                                    "id": 1505627,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5af18efa-501e-473a-b5ad-68b4f921003c/width=450/1505627.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 400,
                                    "height": 720,
                                    "hash": "UDF6IJ*w%e~BY68^OsM{kAKQO]S%01%M$%IV",
                                    "type": "video"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/95588"
                        },
                        {
                            "id": 93792,
                            "name": "ClothingAdjuster 1.0",
                            "index": 2,
                            "modelId": 88132,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 13,
                            "description": null,
                            "publishedAt": "2023-06-11T13:20:43.883",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4209,
                                "ratingCount": 513,
                                "rating": 5,
                                "thumbsUpCount": 515,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 64832,
                                    "sizeKB": 4715.828125,
                                    "name": "ClothingAdjuster.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-11T13:01:18.089Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "A0B991D7",
                                        "AutoV2": "4C88E32B74",
                                        "SHA256": "4C88E32B74269E4D82F71B80290E933819716BD90F1B925B4B624EC565E7178B",
                                        "CRC32": "C8766E6F",
                                        "BLAKE3": "9900D5EE04706610FC9CAB4A18E5AB099549924107D8D045CFF5A7102043E3D2",
                                        "AutoV3": "D62BB542C844"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/93792",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1120351,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b4ccb7f6-3598-4d05-a85d-f70e09a587de/width=450/1120351.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 540,
                                    "height": 960,
                                    "hash": "UFECa$S6~U9G^%IV-:NHs.$*Ipt7^+?G^*xZ",
                                    "type": "video"
                                },
                                {
                                    "id": 1109394,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/09843b11-4ef0-4374-86ec-0a4423957510/width=450/1109394.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 3046,
                                    "height": 4950,
                                    "hash": "U2F#]w00%g00?7o}sp58-;%1xtE2_002-:00",
                                    "type": "image"
                                },
                                {
                                    "id": 1109133,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eee06a5c-b623-4cf8-84bd-80f37be7d433/width=450/1109133.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 2829,
                                    "height": 4950,
                                    "hash": "U4By~k?G%1~VORVsNGt7^*xsn%xtys%Mt6NG",
                                    "type": "image"
                                },
                                {
                                    "id": 1109939,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/39778fac-6c79-4de4-91d3-893d0bac1136/width=450/1109939.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 4000,
                                    "height": 2155,
                                    "hash": "UYHBrNkXWCs:_3jsj[az?baxj[j[~qoeayof",
                                    "type": "image"
                                },
                                {
                                    "id": 1109831,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/18d06c14-81aa-425b-809b-65109d7c9157/width=450/1109831.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 4000,
                                    "height": 2155,
                                    "hash": "UeGug#R-afs:.8oeWXWV.8s:oefk~qayjtoe",
                                    "type": "image"
                                },
                                {
                                    "id": 1109333,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9edb8f83-4cb9-4360-b09c-e572d7a55c63/width=450/1109333.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 2048,
                                    "height": 3840,
                                    "hash": "U9FYcG_300o}pGxXn$j?t7s:WBIU~o-pM|9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 1109343,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3f8f88fd-32ff-4f79-837a-e33e756e822a/width=450/1109343.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 2048,
                                    "height": 3840,
                                    "hash": "U8FFa2VD0L0h4,?wxbIA?aM{IVogIq%1j=Ip",
                                    "type": "image"
                                },
                                {
                                    "id": 1109525,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f4c22383-2527-4e78-8342-e857ea4d8700/width=450/1109525.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 4000,
                                    "height": 2155,
                                    "hash": "UTHLYkIoWBa}_4ozoJof_3oeW=of~qxaaej[",
                                    "type": "image"
                                },
                                {
                                    "id": 1109549,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8d63128a-6c60-44e8-9ea2-9eeb15bb3517/width=450/1109549.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 4000,
                                    "height": 2155,
                                    "hash": "UdF=muxakCoe?vWVoJoL.8j@WCfk~ps:fkj[",
                                    "type": "image"
                                },
                                {
                                    "id": 1109609,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6312ef0c-56bb-46d4-b08b-091df30dd2ab/width=450/1109609.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 4000,
                                    "height": 2155,
                                    "hash": "UdE.;DM|WBof~qoLfRfk?vt7oLaf?bj[fPof",
                                    "type": "image"
                                },
                                {
                                    "id": 1109867,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0e2536b1-057a-4666-bc92-90089d7b4064/width=450/1109867.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 4000,
                                    "height": 2155,
                                    "hash": "UWG8yKNHjZa}_3t6j[j[?vt6WVj[~qR*ayoe",
                                    "type": "image"
                                },
                                {
                                    "id": 1109892,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/acc19066-8eb2-4633-a45b-93ffaa3cd302/width=450/1109892.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 4000,
                                    "height": 2155,
                                    "hash": "UYG8$QWYoLoz~qj?ayj[.8oLWBj[_NofoLj[",
                                    "type": "image"
                                },
                                {
                                    "id": 1109952,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/971ff524-8356-4906-857e-8aa17e93f4f8/width=450/1109952.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 4096,
                                    "height": 2207,
                                    "hash": "UWHB-%ais,j]?cofj[j[~qoeWDfP~qWDofkC",
                                    "type": "image"
                                },
                                {
                                    "id": 1110027,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/12a57b8c-9519-4f84-8bcd-6f1837a79b0a/width=450/1110027.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 4000,
                                    "height": 2155,
                                    "hash": "UdFP86ogayjZ_Nj[fkfQ_3ayfQj[_3j[j@j[",
                                    "type": "image"
                                },
                                {
                                    "id": 1110060,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5cc4b5a2-59f4-4ae8-b3d7-24d060d67c1f/width=450/1110060.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 4000,
                                    "height": 2155,
                                    "hash": "UYD9SLW;WVbH~qofoLj[_Nj]j@j[~qa}ayj[",
                                    "type": "image"
                                },
                                {
                                    "id": 1110268,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/41175201-9db8-4472-9503-fd86fb5ff81d/width=450/1110268.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3072,
                                    "height": 2349,
                                    "hash": "UZIOLdt8e.s:~qs:WBof~qayoffk.8oLfQj@",
                                    "type": "image"
                                },
                                {
                                    "id": 1110271,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a08cfc24-255a-4ef3-a9c7-343b2d3bfe53/width=450/1110271.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3072,
                                    "height": 2349,
                                    "hash": "UVIOCB%3V@s:_Ns:oLt6~qt6ayof?cR*WBWV",
                                    "type": "image"
                                },
                                {
                                    "id": 1110288,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/61b85130-cf99-4bcb-bbfa-868a030b1c89/width=450/1110288.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3072,
                                    "height": 2349,
                                    "hash": "UZH2D%jvWVs:_NxaazWV~qayaya}?cRkj[j[",
                                    "type": "image"
                                },
                                {
                                    "id": 1110353,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9894c3e4-619a-4ead-9459-1cc0fdfab72c/width=450/1110353.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 3072,
                                    "height": 2349,
                                    "hash": "UbHBxgxus;xu%hfkf6j[?bRjWBWB~pt6bHja",
                                    "type": "image"
                                },
                                {
                                    "id": 1110369,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4d63252d-398d-48c2-9b74-497256d0ad16/width=450/1110369.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3072,
                                    "height": 2349,
                                    "hash": "UUHn{Rn%R*of_4WBt7WB~qkBRkt6~qofWBa}",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/93792"
                        }
                    ]
                },
                {
                    "id": 8217,
                    "name": "【Character / Art Style】Fashion Girl",
                    "description": "<h3 id=\"heading-22\">2024/2/22 update</h3><p><span style=\"color:rgb(193, 194, 197)\">Upload Lycoris version. Remove SDXL version temporarily from the archives, and a new page will be created for the SDXL version to facilitate management.</span></p><h3 id=\"heading-99\">2023/7/30 experimental update</h3><p>Upload sdxl version trained using <a target=\"_blank\" rel=\"ugc\" href=\"https://huggingface.co/stabilityai/stable-diffusion-xl-base-1.0\"><strong>sdxl v1.0 base model</strong></a>. <strong>Running SDXL on webui requires at least 8GB of CUDA memory.</strong> <strong>Currently, the generating quality of this version is lower than 6.0 anime version.</strong></p><h3 id=\"heading-22\">2023/7/30 update</h3><p>Update dataset. <strong>Remove trigger tag, so there is no need to input trigger tag when generating images using the latest version.</strong> Retrain the model using new craft.</p><h3 id=\"heading-971\">2023/6/4 update</h3><p>Clean up the old versions and retain the versions with good generated results.</p><h3 id=\"heading-972\">2023/5/11 update</h3><p>Update dataset. <strong>Adjust trigger tag to 'fashi-girl'.</strong></p><h3 id=\"heading-973\"><strong><u>BTW, make sure set this option in 'Stable Diffusion' settings to 'CPU' to successfully regenerate the preview images with the same seed.</u></strong></h3><p><img src=\"https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1e77cab-093f-44e5-803b-1afcf2d42df4/width=525/c1e77cab-093f-44e5-803b-1afcf2d42df4.jpeg\" /></p><h3 id=\"heading-974\">2023/4/20 update</h3><p>Update dataset. Slightly optimize body shape. Try to make the face more alluring. <strong>v5.4 version is conventional LoRA model.</strong></p><h3 id=\"heading-975\">2023/4/12 update</h3><p><strong>Upload Lycoris version (v5.3).</strong> Remove hyper-realistic images in dataset that may cause bad results. Try to make face more natural and beautiful.</p><h3 id=\"heading-976\">2023/3/29 update</h3><p>Due to the instability of Lycoris caused by sensitivity to learning rate settings, <strong>the updated model (5.2 version) is still conventional LoRA model. </strong>Use images published by some users as dataset to train the model.<strong> </strong>Fix the compatibility problem of non-NAI-based checkpoints. Now arbitrary anime model with NAI's VAE or kl-f8-anime2 VAE can also generate good results using this LoRA, theoretically. This version is a bit overfitted that will be fixed next time.</p><h3 id=\"heading-977\">2023/3/24 Experimental Update</h3><p>New model is trained using <a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/KohakuBlueleaf/LyCORIS\"><strong>Lycoris</strong></a> method <strong>(all versions before 5.1 version are conventional LoRA model)</strong>, <strong>pls install this </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/KohakuBlueleaf/a1111-sd-webui-locon\"><strong>extension</strong></a><strong> to use this new model in webui.</strong> <strong>Adjust trigger tag to 'fashi-g'</strong>. If some problem occur during generating pls use old version.</p><h3 id=\"heading-978\">2023/3/8 update</h3><p>Update dataset and model. Decide to upload 5-epoch version whose color saturation is a bit better than higher-epoch version after careful consideration. Adjust rank to 128 to keep perfect face. The trigger tag is unchanged. <strong>The preview images are generated using latest version of </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/9139/yesmix\"><strong>YesMix</strong></a><strong> and </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7808/easynegative\"><strong>EasyNegative</strong></a><strong> embedding.</strong></p><h3 id=\"heading-979\">2023/3/3 update</h3><p>Reduce loss to ~0.11 using Lion optimizer. <strong>Btw, if you use Hires. fix, 0.55~0.6 weights of Denoising should be enough, otherwise the face may be slightly deformed. Btw, the preview images are generated using latest version of </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/9139/yesmix\"><strong>YesMix</strong></a><strong> and </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7808/easynegative\"><strong>EasyNegative</strong></a><strong> embedding.</strong></p><h3 id=\"heading-980\">2023/2/28 update</h3><p>Update dataset and model. Add trigger tag <strong>'fashi-girl'</strong> to improve generating probability. Adjust rank to 32 to balance file size and quality.</p><h3 id=\"heading-981\">2023/2/24 update</h3><p>Prune tags to make the description more accurate.</p><h3 id=\"heading-982\">2023/2/23 update</h3><p>Merge previous LORA model that is easy to generate nice images to slightly improve color saturation and optimize face. Adjust rank to 32 to balance file size and quality. <strong>The preview images of new version are generated using latest version of </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/9139/yesmix\"><strong>YesMix</strong></a><strong>.</strong></p><h3 id=\"heading-983\">2023/2/21 update</h3><p>Adjust dataset to fix bad philtrum. Reduce training epochs to fix deformed limbs. <strong>The preview images of new version are generated using latest version of </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/9139/yesmix\"><strong>YesMix</strong></a><strong>.</strong></p><p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b41cac39-371a-46bc-de1e-0d308b29b500/width=525\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/37b4b98a-f3d1-401a-d470-50a602297300/width=525\" /></p><h3 id=\"heading-984\">2023/2/20 update</h3><p>Update and balance dataset to remain the images of mature female that fit personal aesthetics. New version of LORA model is trained using Lion optimizer discovered by Google Brain that is purportedly better than Adam(w). <strong>The preview images of new version are generated using latest version of </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/9139/yesmix\"><strong>YesMix</strong></a><strong>.</strong></p><h3 id=\"heading-985\">2023/2/18 update</h3><p>Update dataset and model. <strong>The preview images of new version are generated using latest version of </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/9139/yesmix\"><strong>YesMix</strong></a><strong>.</strong></p><h3 id=\"heading-986\">2023/2/16 update</h3><p>Clean the dataset to remove the images of unattractive characters. Use offset noise to improve ability to generate lighter/darker images. <strong>The preview images are generated using latest version of </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/9139/yesmix\"><strong>YesMix</strong></a><strong>.</strong></p><h3 id=\"heading-987\">2023/2/14 update</h3><p>Dataset is updated, so model is updated. Reduce the model file size to 1MB. The generating quality is unchanged.</p><h1 id=\"heading-988\">Introduction</h1><p>This is an experimental LORA model trained with about 100 images of fashionable girls that fit personal aesthetics. Therefore, this model is named as \"Fashion Girl\". <strong>Due to the small-scale dataset that are composed of realistic/photorealistic images, some output images will remain anime style.</strong> The 784mb VAEs (NAI, Orangemix, Anything, Counterfeit) are recommended. 0.6~0.8 weights should be enough. This model will be continuously updated as the dataset is updated.</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 15,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 117427,
                        "favoriteCount": 0,
                        "thumbsUpCount": 13647,
                        "thumbsDownCount": 0,
                        "commentCount": 64,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 40
                    },
                    "creator": {
                        "username": "zakp",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/82d458b6-5669-447f-a826-7de19e18f9e9/width=96/zakp.jpeg"
                    },
                    "tags": [
                        "anime",
                        "concept",
                        "girls",
                        "realistic"
                    ],
                    "modelVersions": [
                        {
                            "id": 355704,
                            "name": "v7.0",
                            "index": 0,
                            "modelId": 8217,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>Upload Lycoris version. Remove SDXL version temporarily from the archives, and a new page will be created for the SDXL version to facilitate management.</p>",
                            "publishedAt": "2024-02-22T13:38:23.399",
                            "availability": "Public",
                            "trainedWords": [
                                "realistic"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3830,
                                "ratingCount": 63,
                                "rating": 5,
                                "thumbsUpCount": 300,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 283661,
                                    "sizeKB": 10876.796875,
                                    "name": "fashigirl-v7-lokr-7ep.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-22T13:40:59.180Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "163958BA",
                                        "AutoV2": "E8DDB27D88",
                                        "SHA256": "E8DDB27D8894673573896F2344669AC0FAF17FF2ACAF1959D97A8B9A5BD05509",
                                        "CRC32": "31B8BA03",
                                        "BLAKE3": "F5AF19BAF2A38D9AC007466E6116A70ACCD65AEEC4A7CB5826B3C35D127B036B",
                                        "AutoV3": "605AE0B21A44"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/355704",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 6966254,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6fe6dcf6-0326-40f9-9569-59ab204e5ff4/width=450/6966254.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1120,
                                    "height": 1680,
                                    "hash": "UdJ7zt~CK5M{,K$,RORkR6WFacs:-ps:OUoe",
                                    "type": "image"
                                },
                                {
                                    "id": 6966259,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b7f46847-6a84-490a-948a-facd8f048444/width=450/6966259.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1120,
                                    "height": 1680,
                                    "hash": "UBF$bG009FIU00%MM{~q~qM_M{%M%MIUxu?b",
                                    "type": "image"
                                },
                                {
                                    "id": 6966241,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a9fbe03a-cfce-41d7-8bcb-18e97bd44230/width=450/6966241.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1120,
                                    "height": 1680,
                                    "hash": "UZK-2*_N.Sb_GHJA%NW=x^IpxGIoKPShaKxt",
                                    "type": "image"
                                },
                                {
                                    "id": 6966237,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/51e09623-d70f-40b2-8177-db6bce45511f/width=450/6966237.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1120,
                                    "height": 1680,
                                    "hash": "U9JG{74:D%_300^+yC^*0yxu?H$%^+~V^6xu",
                                    "type": "image"
                                },
                                {
                                    "id": 6966242,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/27b0ceb9-f1c8-4f89-afe9-02cc47ee9778/width=450/6966242.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1120,
                                    "height": 1680,
                                    "hash": "UJKATk?FAC9ZovS5i^t7_NtQM|xZ~pxaD%R+",
                                    "type": "image"
                                },
                                {
                                    "id": 6966238,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/243b6534-b9ac-4d85-89d5-a38848dedd76/width=450/6966238.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1120,
                                    "height": 1680,
                                    "hash": "URHd,d^-?dkEN3xZRnRP%NtP%LM|ItIV-WWU",
                                    "type": "image"
                                },
                                {
                                    "id": 6966243,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/57799bc7-c25b-43fb-acd2-b0bb651d9957/width=450/6966243.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1120,
                                    "height": 1680,
                                    "hash": "UlHLe^_4.TkBXVNeEOn$IwNdR:t6RjRPxDbH",
                                    "type": "image"
                                },
                                {
                                    "id": 6966247,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/89680dc1-1618-4e08-baf1-c53cc77c83d9/width=450/6966247.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1120,
                                    "height": 1680,
                                    "hash": "UVJt#g~qtmjFE1M{xuM{SiR*xaxa^+tRE1M{",
                                    "type": "image"
                                },
                                {
                                    "id": 6966248,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e4b38877-b5df-4423-9881-ea99d102d88e/width=450/6966248.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1120,
                                    "height": 1680,
                                    "hash": "U9KmeG0000*JBDKOMJ560K?vIA9t-:D%=|s:",
                                    "type": "image"
                                },
                                {
                                    "id": 6966250,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3b4d8430-6a00-4e24-9f40-fdcd295226b7/width=450/6966250.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1120,
                                    "height": 1680,
                                    "hash": "UIK0se#PDh~V8^?axu%0R*R*^ja0%g9uMxog",
                                    "type": "image"
                                },
                                {
                                    "id": 6966249,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/490b437d-9491-478c-84e9-831b2f2197d8/width=450/6966249.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1120,
                                    "height": 1680,
                                    "hash": "UoMjRA%1?^NHtlM{%MxukDIUxaxut7t7M{t6",
                                    "type": "image"
                                },
                                {
                                    "id": 6966252,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d440d01b-04f4-4df7-add8-e3b45cd86790/width=450/6966252.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1120,
                                    "height": 1680,
                                    "hash": "UQKw2[~p9s%2I9Rjkpnh57e:oe%3%LogIUM{",
                                    "type": "image"
                                },
                                {
                                    "id": 6966255,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e10ba4e8-8837-4037-a96f-d42db0a9f802/width=450/6966255.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1120,
                                    "height": 1680,
                                    "hash": "UKJt6w4T*J_3O;%MH?%M0KpHwwrr,pD%Shoe",
                                    "type": "image"
                                },
                                {
                                    "id": 6966257,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/29c2d315-7ff8-4265-947b-609c900fd7cd/width=450/6966257.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1120,
                                    "height": 1680,
                                    "hash": "UUJs@H4n?^H?9tM{IBX89Zxuw^t7R5tQtRV@",
                                    "type": "image"
                                },
                                {
                                    "id": 6966256,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6047f1e1-268e-408b-9e5b-30ab419f1430/width=450/6966256.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1120,
                                    "height": 1680,
                                    "hash": "UQK1qG%$E0_NEL.8Jox]9aE1xZIUMwRkRORj",
                                    "type": "image"
                                },
                                {
                                    "id": 6966258,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/93561b51-06e5-4394-abbf-fd3376ce76d1/width=450/6966258.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1120,
                                    "height": 1680,
                                    "hash": "UMKv~v000|og%IM{bws:9ZNG?HD%~Wn%IUR+",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/355704"
                        },
                        {
                            "id": 128793,
                            "name": "v6.0 (anime)",
                            "index": 1,
                            "modelId": 8217,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>Update dataset. <strong>Remove trigger tag, so there is no need to input trigger tag when generating images using the latest version.</strong> Retrain the model using new craft.</p>",
                            "publishedAt": "2023-07-29T17:52:20.31",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4224,
                                "ratingCount": 447,
                                "rating": 5,
                                "thumbsUpCount": 889,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 93287,
                                    "sizeKB": 73293.3046875,
                                    "name": "fashigirl-v6-nai-5ep-resize.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-29T17:55:43.619Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "AE8D8075",
                                        "AutoV2": "07B7022F77",
                                        "SHA256": "07B7022F77C51ABA24D786A09F12E86B7B53544724B1DE2DA8F9CC2F3CE11871",
                                        "CRC32": "526704F0",
                                        "BLAKE3": "B4F46DC843989E474BD2F8F0F02BCA845CF332736637050A46D6C785799EF25C",
                                        "AutoV3": "4E0173AE8CEF"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/128793",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1778514,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a910c2a9-d1ee-4dc9-831d-b1db1357448f/width=450/1778514.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UUIOe8-;xuD%-;WB~qj[D%IURjxuWBM{IURj",
                                    "type": "image"
                                },
                                {
                                    "id": 1778515,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/43eb2a76-b3be-4d0f-b847-308827f856a6/width=450/1778515.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJEx#5x[I:~Wtl-p%M%g9GozxGD%smIoNGR*",
                                    "type": "image"
                                },
                                {
                                    "id": 1778518,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04dc935a-1f2f-4c52-8711-5e7f3d9052a4/width=450/1778518.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U{L;Npxax]j]~qfkozofSOayRjaybIjtn$ay",
                                    "type": "image"
                                },
                                {
                                    "id": 1778517,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4f7bc02b-e41c-4864-953f-9e30571cd049/width=450/1778517.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKKTug010KE%?9Ir9uxUEKD*-pt7~WxaIpj[",
                                    "type": "image"
                                },
                                {
                                    "id": 1778516,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9e589146-6456-4c2e-94c0-541f7fcada53/width=450/1778516.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFJa1Y00S#Zh~W4T-oMx9tM{tlxtxaxF%MtR",
                                    "type": "image"
                                },
                                {
                                    "id": 1778520,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4a5fd518-6384-40e5-af1f-a8a0318acbec/width=450/1778520.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9IXgX0000s:00E2_3%20K?b00M{4nax~WD%",
                                    "type": "image"
                                },
                                {
                                    "id": 1778519,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a31e3d22-b150-4840-a2c8-f69a7c341b1e/width=450/1778519.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USK1zXM{~q%Mt7xu-;%MD%j[xuRjWV-;t7Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 1778521,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/14a7b353-bfc1-44bb-b7fa-f7ab7c827b6b/width=450/1778521.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULJ*M3?b?^-p_NtR~pxu0et7wwNG^+%1M{4.",
                                    "type": "image"
                                },
                                {
                                    "id": 1778522,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5f2c7d32-1e64-492f-83ab-8272a3590229/width=450/1778522.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UhLNiOt7_NWB-;RjozofM{t7xufkt7fkWVjZ",
                                    "type": "image"
                                },
                                {
                                    "id": 1778523,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/332f10c2-694c-46b0-8016-b85c4a63e173/width=450/1778523.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UXKdue^+~qay~qWBRjIoD%ayD%oL%2xaMyWB",
                                    "type": "image"
                                },
                                {
                                    "id": 1778524,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/564edefc-447c-4f59-b161-2d6cdb5e5b51/width=450/1778524.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFH.B2xt019F.mtRtRSh-;RkITxZ-oR5IURP",
                                    "type": "image"
                                },
                                {
                                    "id": 1778526,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/08640f5a-461e-4178-9fbe-afacfc18c945/width=450/1778526.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDGl0N_30K$epfIt4.4nENxwIA4.~q9t4.^*",
                                    "type": "image"
                                },
                                {
                                    "id": 1778525,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04783f11-c787-464f-a666-f194f112485d/width=450/1778525.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USJaDy~VI:%L9]ozofRjIUM|V[WB-:RjMxRj",
                                    "type": "image"
                                },
                                {
                                    "id": 1778529,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4c532a6e-f9ec-48e0-9a3e-f00b15e5484c/width=450/1778529.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UXL|o=oy%#-;tmRj_3Rj~pofWBxZ-;j]WExt",
                                    "type": "image"
                                },
                                {
                                    "id": 1778530,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a22eb89-5412-47ab-8332-f47d3ef8818a/width=450/1778530.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1224,
                                    "height": 1536,
                                    "hash": "UTHKwv~V9sobE1t7?HNGR%Ios:-pE1Rjxas:",
                                    "type": "image"
                                },
                                {
                                    "id": 1778527,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/085914fa-c5bd-449c-bfe5-849c8bccf22f/width=450/1778527.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1224,
                                    "height": 1536,
                                    "hash": "UbH-fM~VI.%2E1%1?GNGNtR*xb-pxas:WUt6",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/128793"
                        },
                        {
                            "id": 67935,
                            "name": "v5.5",
                            "index": 2,
                            "modelId": 8217,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>Update dataset. <strong>Adjust trigger tag to 'fashi-girl'.</strong></p>",
                            "publishedAt": "2023-05-11T12:17:43.434",
                            "availability": "Public",
                            "trainedWords": [
                                "fashi-girl",
                                "red lips",
                                "mature female",
                                "makeup"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 17356,
                                "ratingCount": 1500,
                                "rating": 5,
                                "thumbsUpCount": 1589,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 47523,
                                    "sizeKB": 73849.7109375,
                                    "name": "fashigirl-v5.5-lora-naivae-64dim.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-11T12:21:07.734Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "3FF1B753",
                                        "AutoV2": "19CB180BF1",
                                        "SHA256": "19CB180BF15D2EB384255C8E7E5FF6797625CA9A7E700435CD114606A42C93B6",
                                        "CRC32": "28DD0EFA",
                                        "BLAKE3": "E2107462B8D81CCA619BBE0A04802B6D932F26614822F10C8DB907408D1BDB8B",
                                        "AutoV3": "2DDA5FFAA304"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/67935",
                                    "primary": true
                                },
                                {
                                    "id": 47522,
                                    "sizeKB": 73849.7109375,
                                    "name": "fashigirl-v5.5-lora-naivae-64dim.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-11T12:16:21.525Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "3FF1B753",
                                        "AutoV2": "19CB180BF1",
                                        "SHA256": "19CB180BF15D2EB384255C8E7E5FF6797625CA9A7E700435CD114606A42C93B6",
                                        "CRC32": "28DD0EFA",
                                        "BLAKE3": "E2107462B8D81CCA619BBE0A04802B6D932F26614822F10C8DB907408D1BDB8B",
                                        "AutoV3": "2DDA5FFAA304"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/67935?type=Model&format=SafeTensor"
                                }
                            ],
                            "images": [
                                {
                                    "id": 756403,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/01115d0d-cd92-4685-8cec-67cf8a6e50f6/width=450/756403.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHJ?vx00AtkWy=0e$%t64.M{R6o#sDRQ-:-V",
                                    "type": "image"
                                },
                                {
                                    "id": 756406,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/683a022a-11ce-46f7-9bef-d5b628606688/width=450/756406.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMO3hC}@EftRKQIAozI:%hDiM{s.ELjF%MkW",
                                    "type": "image"
                                },
                                {
                                    "id": 756402,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1fc12c26-5c6d-496e-a4eb-f962f7493588/width=450/756402.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDEVd5KR4:?v~WE100?H4.MwaJt79s-otRIo",
                                    "type": "image"
                                },
                                {
                                    "id": 756401,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5ff616e8-4adc-4b9e-94d6-ef6957b3e2b9/width=450/756401.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDI50.0100~Vp0~D4T-p9]WV^kIV-;IoIUIn",
                                    "type": "image"
                                },
                                {
                                    "id": 756404,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a1441df-7a7c-4fca-849c-de472a841fbe/width=450/756404.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGHT~w_3S0%LNrMy~BR,000fr=Mx?G%2xZ%2",
                                    "type": "image"
                                },
                                {
                                    "id": 756412,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a80a28cc-dc8a-47ae-b863-0d6125cc5c88/width=450/756412.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAHBuT010g?a4oS$4:~p00Vtrsn4-nIAs:%f",
                                    "type": "image"
                                },
                                {
                                    "id": 756407,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a060e872-dc08-4c18-bacd-1cc552db304c/width=450/756407.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKIqcN-U0K%LoaE2D*-o~pIoMx?G?GxaD%WB",
                                    "type": "image"
                                },
                                {
                                    "id": 756409,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e96ac18-ecb1-411f-9b3f-294049fa4db7/width=450/756409.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7N0k{0000XR.m-Ofhkq174T^jxZE3-5a0H@",
                                    "type": "image"
                                },
                                {
                                    "id": 756408,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2c591a22-010d-478d-ac65-eb3f091549a9/width=450/756408.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UVLW|tV??^NGt6%Ms.j[xutRs:ae_3t7^+t7",
                                    "type": "image"
                                },
                                {
                                    "id": 756410,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fa24ee02-d07f-4bfd-b246-2ba8bd66ab42/width=450/756410.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCK1E,0y0J+[-W8_]:yCNEEN%#Md.m018_9a",
                                    "type": "image"
                                },
                                {
                                    "id": 756415,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0bca2db6-a472-455c-8e1a-5b3e9f8e607a/width=450/756415.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFID:m-oK%NaKPR%%3E2Td56$+-;4.rr_Nt6",
                                    "type": "image"
                                },
                                {
                                    "id": 756414,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f174965e-8a13-432f-8fcb-3fad71ac7eff/width=450/756414.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UZLgCT?a_NE1tQjFRPaex]Ios:jZs:WBt7R*",
                                    "type": "image"
                                },
                                {
                                    "id": 756400,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/47df5bb8-c902-442d-9d5a-c41d7f8fe8e0/width=450/756400.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UILW9Q0f00^*l69GI[-:00o~?HWB~UE2M{EL",
                                    "type": "image"
                                },
                                {
                                    "id": 756413,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/601f7985-1285-4fb9-9bab-a9eda85f2849/width=450/756413.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKMPtK%N0f%2?]yXI;M_9ZkD^+-VtS^+xu%f",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/67935"
                        },
                        {
                            "id": 50709,
                            "name": "v5.4",
                            "index": 3,
                            "modelId": 8217,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>Update dataset. Slightly optimize body shape. Try to make the face more alluring. <strong>v5.4 version is conventional LoRA model.</strong></p>",
                            "publishedAt": "2023-04-20T12:43:39.325",
                            "availability": "Public",
                            "trainedWords": [
                                "fashi-g",
                                "mature female",
                                "red lips"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 15073,
                                "ratingCount": 1569,
                                "rating": 5,
                                "thumbsUpCount": 1571,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 37134,
                                    "sizeKB": 147579.48828125,
                                    "name": "fashigirl-v5.4-lora-64dim-naivae-5ep.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-20T12:45:51.491Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "7C75C38A",
                                        "AutoV2": "7B11E611CB",
                                        "SHA256": "7B11E611CBF70CCB112804282425BA822EF7BFA27B248C1AD810568F87307E3D",
                                        "CRC32": "9437278D",
                                        "BLAKE3": "461D8009F3E2BC731CDC64D2B6730C2A2CAB7CD38845FDBB4A8DE7DC9540700F",
                                        "AutoV3": "3D6F91A50F05"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/50709",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 545325,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8660dcfe-6c18-457c-5008-4efc92e94c00/width=450/545325.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "UCG8+h0000?G~XSh8_.74:x@RPWTX-RPRj$*",
                                    "type": "image"
                                },
                                {
                                    "id": 545321,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/581c84b3-98b1-4800-63c2-682f90863b00/width=450/545321.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "UMK1F5-;ITIV?wpI9FNbDjxu$*V?tQg3s:of",
                                    "type": "image"
                                },
                                {
                                    "id": 545318,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/41adfcff-6bdf-4084-fe46-e43796451c00/width=450/545318.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1600,
                                    "height": 2400,
                                    "hash": "UAHo5u00$I~VHqM_r?-oR4s.?wDP14w^-7Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 545320,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3c496435-afda-40a6-d2d6-65b9cf21b400/width=450/545320.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "UCEe_f4.Fz~W^,xa9tRj00-;slE10KRj?GM{",
                                    "type": "image"
                                },
                                {
                                    "id": 545315,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/338dc380-0c54-4441-0132-dc0f146d2900/width=450/545315.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "USIOCK4nEKRj~qMxWBj[9txuMxR%9YkCR*Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 545316,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/68879bfa-f44a-4a6b-1395-81ce0f46b400/width=450/545316.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UQLp:U~pOXxut3%MSONGWBt6ai%MSgxuj]Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 545324,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a03ef96-b150-4ada-119f-2739711b1e00/width=450/545324.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "UJGt{P%h9uRj%z^kIVM{D%t7aKE1~WRPNGM{",
                                    "type": "image"
                                },
                                {
                                    "id": 545327,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/029657b2-9288-4435-cc05-5c7fb2d71300/width=450/545327.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "UCE2U_xc00NI_4WV4-NG9FsTs.sU=|xH9ts:",
                                    "type": "image"
                                },
                                {
                                    "id": 545326,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c0198874-17ef-4acb-20b7-cd3c5b7de100/width=450/545326.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "UMH^;u~WD*D%01V@$*RjNDInWA%2bvWBNGNG",
                                    "type": "image"
                                },
                                {
                                    "id": 545322,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cf457002-7713-41d2-a347-d99fb50d1300/width=450/545322.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "UND9G4%2v$nN~XajIAVtNtNJE1V@WmR+WGxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 545323,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e7d2e20-ff89-43f5-7a07-19a81d9c0a00/width=450/545323.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "U7E.Iy0K00x]0MxaxnRR0L~CND9Z0K%M~B4.",
                                    "type": "image"
                                },
                                {
                                    "id": 545317,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e96d1d0-9e46-4857-8796-0258a57e9600/width=450/545317.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "UKD07TDj56Mx~WS59EkCMwOFn4%MD$Nd-Vof",
                                    "type": "image"
                                },
                                {
                                    "id": 545319,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6b714e03-085f-487c-d0b5-03898c5acb00/width=450/545319.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "UMLWkq00TdM{_NR59[-oE1M{V@WBSzo0ni9t",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/50709"
                        },
                        {
                            "id": 42959,
                            "name": "v5.3",
                            "index": 4,
                            "modelId": 8217,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p><strong>Upload Lycoris version (v5.3).</strong> Remove hyper-realistic images in dataset that may cause bad results. Try to make face more natural and beautiful.</p>",
                            "publishedAt": "2023-04-11T17:47:42.91",
                            "availability": "Public",
                            "trainedWords": [
                                "fashi-g",
                                "red lips",
                                "makeup",
                                "mature female"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 8043,
                                "ratingCount": 911,
                                "rating": 5,
                                "thumbsUpCount": 916,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 32807,
                                    "sizeKB": 22821.021484375,
                                    "name": "fashigirl-v5.3-lycoris-16dim-9ep-novae.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-11T17:45:46.783Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "6F21E4D1",
                                        "AutoV2": "8CB57BBB32",
                                        "SHA256": "8CB57BBB3211DE74010B4B69ACDA627CA36584FF2B1DBA2B028789F92F725F91",
                                        "CRC32": "2842F551",
                                        "BLAKE3": "97405D8966640B05FB408156984B8EA8ACA804A3A34E455C247D80A1701F087C",
                                        "AutoV3": "D5033C74E37A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/42959",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 470752,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/54ee0352-75da-47ee-8938-026cec1d0800/width=450/470752.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULF#H^~WpIozcY-pxZt79[kCw{M{#Tt7Xm%2",
                                    "type": "image"
                                },
                                {
                                    "id": 470763,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4e255f02-15d5-4e92-3fe7-e0d8b696af00/width=450/470763.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "USHe8.~W0g9ZroNF4=IWobxaxaV[R:kCoJbI",
                                    "type": "image"
                                },
                                {
                                    "id": 470757,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a9649f36-3b08-4cdf-4e11-babba6124900/width=450/470757.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBK,aVx[+bNM00?F?]%1Gh00-;$*@qcD+uNG",
                                    "type": "image"
                                },
                                {
                                    "id": 470746,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e2ef5f10-cafb-41a8-9310-eafce8cde700/width=450/470746.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTGu%k9F_NoL?HM_kC-;-;-;t7ofNGoMs:M{",
                                    "type": "image"
                                },
                                {
                                    "id": 470758,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/01750502-a6a1-4ae1-2c6b-ae6d7140b500/width=450/470758.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNHU5|00_Nv#PAD%xaIo9Fbct7Rkxtxaxuj[",
                                    "type": "image"
                                },
                                {
                                    "id": 470751,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1d7d69a6-9d43-4382-8906-4526c0b7ea00/width=450/470751.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UWNTOK.7_N?H4mM{-pjZT0xu%2WC%2S2f8xu",
                                    "type": "image"
                                },
                                {
                                    "id": 470754,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9e3c11c8-6293-4011-1953-2b32ccfcff00/width=450/470754.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIG*[{}[4:^+EJE0RRJ74.IBbbEy$4-pofJj",
                                    "type": "image"
                                },
                                {
                                    "id": 470747,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/85f6a240-3745-4b75-10f7-6fedf368f200/width=450/470747.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UOLq9B00.S%MjX-;~qxayDRj?H%2bvWB%2t7",
                                    "type": "image"
                                },
                                {
                                    "id": 470753,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b50319cd-798f-4849-9e0b-fa98b57a0300/width=450/470753.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UmL4W.%M_Mxu^+bHt8aex]WBxaayE0WBt7R*",
                                    "type": "image"
                                },
                                {
                                    "id": 470745,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8d0d4539-f187-475b-d5e9-199cc6d3d900/width=450/470745.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAHK|s9h03_400%NOGxu00oH-hD$--Mx-OWB",
                                    "type": "image"
                                },
                                {
                                    "id": 470755,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3d907d25-94f3-4044-7fa8-c0ef3fdb0e00/width=450/470755.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UbIqZDog%1oe~URjs:j@V?RjV@ay?GofR*oL",
                                    "type": "image"
                                },
                                {
                                    "id": 470761,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e5c9e26c-d332-422c-9877-9fa46118cc00/width=450/470761.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDG[.+_N00$%@@-o%#9F5-E2^Ro}?bS~kVrX",
                                    "type": "image"
                                },
                                {
                                    "id": 470744,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/68a8a4cd-a438-4b65-1d28-ae720687f000/width=450/470744.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQN+|uDjTH%M~pIAyCbuFxnlIoXR%Nt7MxSg",
                                    "type": "image"
                                },
                                {
                                    "id": 470759,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ce776589-a579-4b2c-39a9-18cd87ff3e00/width=450/470759.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHHx4:4n0L^+VrNbE3W=0JW==|M{~WM{RPkC",
                                    "type": "image"
                                },
                                {
                                    "id": 470750,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/182551e7-c329-43e5-1109-43eb8f1fcb00/width=450/470750.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UaIXQ]~VRj%M-:-:x]xvNHtRbHIpRjj[t7V[",
                                    "type": "image"
                                },
                                {
                                    "id": 470762,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6377799e-551b-4dfd-f8d4-8cc207fcb900/width=450/470762.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAHAz__2uh?Hx]%101E14UM{4.oy0La%?ao|",
                                    "type": "image"
                                },
                                {
                                    "id": 470756,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4509a402-9203-4b46-db00-4a2d0d809a00/width=450/470756.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQIq[zt7OYIotmj@-mROENoet8RP~qt7M|af",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/42959"
                        },
                        {
                            "id": 20073,
                            "name": "v5.0",
                            "index": 5,
                            "modelId": 8217,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>Update dataset and model. Decide to upload 5-epoch version whose color saturation is a bit better than higher-epoch version after careful consideration. Adjust rank to 128 to keep perfect face. The trigger tag is unchanged.</p>",
                            "publishedAt": "2023-03-08T04:11:27.791",
                            "availability": "Public",
                            "trainedWords": [
                                "fashi-girl",
                                "red lips",
                                "makeup",
                                "realistic"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 23879,
                                "ratingCount": 4882,
                                "rating": 5,
                                "thumbsUpCount": 4884,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16758,
                                    "sizeKB": 147581.41015625,
                                    "name": "fashigirl-lora-v5-128dim-5ep.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-08T04:16:43.158Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "FB1B4BCB",
                                        "AutoV2": "3A79BE5E8B",
                                        "SHA256": "3A79BE5E8B202CAF8EDB675E2893ED4B8593B5177310F9AB171AE702FD27873E",
                                        "CRC32": "847BC76D",
                                        "BLAKE3": "61A6F5390C021806B07B015AD4848A9003A880AAE28F3C74A1C233C15F442A9D",
                                        "AutoV3": "718D1CD168E7"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/20073",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 212136,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/74e22545-df7a-4754-b194-5618241eec00/width=450/212136.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDHBD9^j00^+00?G~q%L4;9GD*4.9GE1D%My",
                                    "type": "image"
                                },
                                {
                                    "id": 212138,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dd9566c2-4b91-4f56-0bd5-416009cb4400/width=450/212138.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGI=Ji00Vt%M-WDiOYxa4n$%-:Nd?^M|Mxxa",
                                    "type": "image"
                                },
                                {
                                    "id": 212137,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/67b9ba00-8656-4be8-0524-20874dc68000/width=450/212137.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UILp?f00yXR5.T9F?aD%9aozxGIU?aodNGIV",
                                    "type": "image"
                                },
                                {
                                    "id": 212135,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a7baec4b-b4b5-4860-831c-0d71ef76c600/width=450/212135.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGI}9c00yCsA?]nh-:kW0Lt6~pxa?HWAs;WB",
                                    "type": "image"
                                },
                                {
                                    "id": 212134,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d70b1f34-c356-4102-2aba-ea9dde616500/width=450/212134.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULJt-vIU?v%1_3~qxu9FShWBxuNGNGNHt7xu",
                                    "type": "image"
                                },
                                {
                                    "id": 212133,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5352136c-c9db-4b04-3f65-bf50607d3100/width=450/212133.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJEoDXIoSuIUfBIpknRjV|RkXNaf~Wt79ZR*",
                                    "type": "image"
                                },
                                {
                                    "id": 212132,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e6e77c7-aa37-4fd3-c782-b62dbc0aa600/width=450/212132.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UeJtxe?a%zM{_4WU-:M{o}xuxaf5%2ofIUjZ",
                                    "type": "image"
                                },
                                {
                                    "id": 212131,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/196d9bac-5243-4de1-6c5d-c18ac91dca00/width=450/212131.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMH1*[~C4nM{9FMxROjFnj-V$*aeen$*?Gf6",
                                    "type": "image"
                                },
                                {
                                    "id": 212130,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2bea308d-439f-474f-19c7-cd3600a48e00/width=450/212130.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEI4*F0L00019bIp$_t7IokCV?s:~pj]D*oJ",
                                    "type": "image"
                                },
                                {
                                    "id": 212129,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/45ba289c-df9d-48d3-a09c-5269b08bc500/width=450/212129.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDHK|Y00tKR-I.E1Rjxa00~W9Goz0K%Mxuax",
                                    "type": "image"
                                },
                                {
                                    "id": 212128,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4b7f0afc-7035-49f5-53b3-8adaef5dc900/width=450/212128.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1760,
                                    "height": 2034,
                                    "hash": "UyM7M%_N?b%Mozayj[oLxuWBaeWVt7f7WVs:",
                                    "type": "image"
                                },
                                {
                                    "id": 212127,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a13616c3-3f63-4d22-0013-d7e52d483100/width=450/212127.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1760,
                                    "height": 2034,
                                    "hash": "U*K^:D~q?bx]xuWBWBj[xuWBaejtt7ayfQfQ",
                                    "type": "image"
                                },
                                {
                                    "id": 212126,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cec7f0ea-cb43-45bf-c86f-42d1634d9f00/width=450/212126.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1760,
                                    "height": 2034,
                                    "hash": "U$M7S}_N?bxut7aej[j[xuWBWBfPs:aykCj[",
                                    "type": "image"
                                },
                                {
                                    "id": 212125,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/169cc83b-6606-478b-3400-87f2f5405c00/width=450/212125.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1760,
                                    "height": 2034,
                                    "hash": "UqNTXm_N?bxuxuWBjujtt7WBWBj[tRWAjZs:",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/20073"
                        },
                        {
                            "id": 18070,
                            "name": "v4.7",
                            "index": 6,
                            "modelId": 8217,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>Reduce loss to ~0.11 using Lion optimizer.</p>",
                            "publishedAt": "2023-03-03T16:04:27.122",
                            "availability": "Public",
                            "trainedWords": [
                                "fashi-girl",
                                "makeup",
                                "realistic",
                                "red lips"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 10091,
                                "ratingCount": 1086,
                                "rating": 5,
                                "thumbsUpCount": 1088,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 15111,
                                    "sizeKB": 36990.25390625,
                                    "name": "fashigirl-lora-v4.7-32dim-5ep.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-03T16:05:41.392Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "DCCB4EB7",
                                        "AutoV2": "2AF78EA6BC",
                                        "SHA256": "2AF78EA6BC6A17F6C350F636B21DE72535C97F32CEC6741461EFF2A5A8F7EDBC",
                                        "CRC32": "1E60357F",
                                        "BLAKE3": "47BC5E7F2EDF4D2BC253045B866F9325FF95FDB4834430027736D6E25EC54338",
                                        "AutoV3": "F3DB8BC6BE56"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/18070",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 185461,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/44d132d8-709d-4ef9-b50e-82784e633400/width=450/185461.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UOL47]jvyCtQ?vM{~p-oIUx[azRP-;s:D*%2",
                                    "type": "image"
                                },
                                {
                                    "id": 185460,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f05d349d-340f-495b-a942-a2e664f1a100/width=450/185460.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKJ7:pxY?^-oNx9F?bR*_2?H$*IV%Nof-;X9",
                                    "type": "image"
                                },
                                {
                                    "id": 185459,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b968d19c-3529-4149-16b3-18be11002800/width=450/185459.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "ULGkqE~V%fR*0KM{M{jsIVRjRQM{oza}%Mt7",
                                    "type": "image"
                                },
                                {
                                    "id": 185458,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c07defc7-aac5-4362-fe85-254484c8c800/width=450/185458.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHIE@S01Q,OsKj9Z-pIU0Ks8={nh~CWAIVxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 185457,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bd0e438b-764b-4a83-fb52-0a1cae4da200/width=450/185457.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPG8c=o#9vs;%%kWW;oM5RS2W+og?bjYD$og",
                                    "type": "image"
                                },
                                {
                                    "id": 185456,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7c946744-8308-46bb-960c-2102c4cc4200/width=450/185456.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UNH2D{NxTKR5~pbwS3V@WTXmnNtR^*xDE1Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 185455,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/532d84fe-8372-4464-f367-c80ffa3c6800/width=450/185455.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNIXjf%M00IU9ZWBRjWBD%RjIooz~pofMxae",
                                    "type": "image"
                                },
                                {
                                    "id": 185454,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/77b761f8-0eb9-474f-3893-7315b46d5e00/width=450/185454.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHI#4J~VEL%M56tT9aob00D%VYD%-pInoet8",
                                    "type": "image"
                                },
                                {
                                    "id": 185453,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d06f2545-ae21-421c-733e-a150f5455f00/width=450/185453.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFH_V^4n68-UB?Z#_NskxxV?RQoy?HnNIA%M",
                                    "type": "image"
                                },
                                {
                                    "id": 185452,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c3750bc3-98ce-4592-2015-ddd03f84e700/width=450/185452.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "URK-FG9Z9tof?wIU_2xu?bsoM_xuNGofoIX8",
                                    "type": "image"
                                },
                                {
                                    "id": 185451,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5cdc2d5a-34e2-4ee0-0f46-c809fc652300/width=450/185451.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UDIg.g}@%#57-WDi%#%g00t7yCEftltlt6bv",
                                    "type": "image"
                                },
                                {
                                    "id": 185450,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cb355062-b48b-4dc4-6669-6e1707c9cc00/width=450/185450.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPIXdSD%9Z?v~qRQWB%gE1NHogt7%3WUxFju",
                                    "type": "image"
                                },
                                {
                                    "id": 185449,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3a98124c-996f-49d0-582d-7a2f7c45d900/width=450/185449.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNI;-Y%ME0jE~qe=9FD*-:aes.xFIpWXkAWA",
                                    "type": "image"
                                },
                                {
                                    "id": 185448,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4e7b9a5b-71ad-4bf7-96d4-32589829e400/width=450/185448.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8F}[-~p00-;0J4n4oIVsk?HNf?H_29Z01ob",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/18070"
                        },
                        {
                            "id": 16516,
                            "name": "v4.5",
                            "index": 7,
                            "modelId": 8217,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>Update dataset and model. Add trigger tag <strong>'fashi-girl'</strong> to improve generating probability. Adjust rank to 32 to balance file size and quality.</p>",
                            "publishedAt": "2023-02-28T06:32:02.914",
                            "availability": "Public",
                            "trainedWords": [
                                "fashi-girl",
                                "red lips",
                                "realistic",
                                "makeup"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 18016,
                                "ratingCount": 825,
                                "rating": 5,
                                "thumbsUpCount": 828,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 13956,
                                    "sizeKB": 36989.658203125,
                                    "name": "fashiongirl-lora-v4.5-32dim.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-28T06:36:10.416Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "42ECCAA1",
                                        "AutoV2": "AB0EDE68E6",
                                        "SHA256": "AB0EDE68E664F730FC8DB56FA99D568D0E9B08B1C3F48514E98C23D44ACCC74C",
                                        "CRC32": "997D2F12",
                                        "BLAKE3": "69755AF3C54B5CBC8B26B0058BD254720FA1AD4D9FDA4E1658AC25866D3B822D",
                                        "AutoV3": "FD4644A6BFB4"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/16516",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 166942,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9d2d5992-2e4c-4199-083c-cd53c4a4ce00/width=450/166942.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UKJHm_a0_MNdoz9a_3ITxwD%xsnh?bR*WA^+",
                                    "type": "image"
                                },
                                {
                                    "id": 166913,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/295cf573-1d66-4682-4ec1-1df406e40700/width=450/166913.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "U8Jj}O0000NI03?a00srx[_29Gs:xbNK~9oa",
                                    "type": "image"
                                },
                                {
                                    "id": 166664,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c454be17-5bf8-410b-7574-b0db878d0e00/width=450/166664.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGEeS;4:AB^Q~VMy-:NHWTRk~W9a-:e.xsM{",
                                    "type": "image"
                                },
                                {
                                    "id": 166662,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/41fc00a6-6080-4cb9-5a4e-dbd1b1096600/width=450/166662.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDKm;H00pFxC_NIU?aIU9]-:i^oe${bGIVt7",
                                    "type": "image"
                                },
                                {
                                    "id": 166661,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e94dee2c-ebab-4d38-15ec-07cd393b1b00/width=450/166661.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UILW|uIqtTt6-=-;~WMxIUNG?Ht7?vM{D%jF",
                                    "type": "image"
                                },
                                {
                                    "id": 166660,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/48608f6e-b41d-45ab-b12f-71dc336aa700/width=450/166660.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "ULLD7L~p00Vst7xZI.xa-pt6-pxu9Zs.t7S2",
                                    "type": "image"
                                },
                                {
                                    "id": 166941,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ae05ef01-e5d4-4916-5123-7a634c914300/width=450/166941.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UAIhBORlS4?b%#^*000K?b~qD%014.NG^*Di",
                                    "type": "image"
                                },
                                {
                                    "id": 166658,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/df0fd8d5-85b1-46c9-f498-f7f4de808400/width=450/166658.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UdK^:8WC_Nxu%gofxaRj-;S3M{-p-;s:R*NG",
                                    "type": "image"
                                },
                                {
                                    "id": 166657,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c3cc12d9-a658-42c5-9268-2c21a4b93c00/width=450/166657.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UDG*+*Rj009G00t7.8x]x^WV$*E1~Wj[RPNG",
                                    "type": "image"
                                },
                                {
                                    "id": 166655,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/408b419e-f90c-4e80-b2bf-69b8e40c3700/width=450/166655.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEIELpR50L~pDh%1E2IU00%M9FWB?HRjxaRk",
                                    "type": "image"
                                },
                                {
                                    "id": 166654,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6040b589-ba2a-412b-573a-f35004826d00/width=450/166654.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5HL3s^i00$m00X8~U#,00$%x]4:0001e.EO",
                                    "type": "image"
                                },
                                {
                                    "id": 166653,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/98fac115-7108-45b2-cd70-a38973a7b900/width=450/166653.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHHxc~~qK5%MNHbbNa9a8_MxIU-U00s+$#Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 166940,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9ae92616-2899-48cc-d899-b1a8612d1300/width=450/166940.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UDK0$+0000n5?^9FtRo}9Ztl^*IBNawvM{xu",
                                    "type": "image"
                                },
                                {
                                    "id": 166651,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8528ad20-d4ab-41d1-17bd-c5dc08bd9700/width=450/166651.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPJaWT9FW-ai~qRPtRRPIos:%MIVbcRj%2t7",
                                    "type": "image"
                                },
                                {
                                    "id": 166650,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/582c9ddd-e561-4312-31e6-fac0628f0d00/width=450/166650.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7Kmwtm+V;4T0000_44n.5R*}?_2pxo|?vgN",
                                    "type": "image"
                                },
                                {
                                    "id": 166648,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/83452cda-d631-4592-90b8-2ecca93af400/width=450/166648.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMJjb+^kE1E1R6sWNZ569Zof-:E1~WNGIBoL",
                                    "type": "image"
                                },
                                {
                                    "id": 166647,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7e9b3217-c40c-4e41-62e6-e4715b642d00/width=450/166647.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIL4Nl%%0L^+0m9bS%xZRoMyVsMxIVngRkxu",
                                    "type": "image"
                                },
                                {
                                    "id": 166907,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3d0467e7-d343-4435-2147-c0a606c1cc00/width=450/166907.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UEH^|w~C9sM{E1Ri~B%19ZRP?GR*?b^*RjRQ",
                                    "type": "image"
                                },
                                {
                                    "id": 166646,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d419df48-3d3d-4705-4e9b-2abdf2fbff00/width=450/166646.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGIqfas;0K~W-:%2t7t7E0xtM{xaawIU-pof",
                                    "type": "image"
                                },
                                {
                                    "id": 166645,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4e12cd96-a6ad-4107-d609-cd5117cf2000/width=450/166645.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEJtVYv~9Y%f?^00Rjx]OsD$%Mxt^+odIVM{",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/16516"
                        },
                        {
                            "id": 13479,
                            "name": "v3.6",
                            "index": 8,
                            "modelId": 8217,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 31,
                            "description": "<p>Adjust dataset to fix bad philtrum. Reduce training steps to fix deformed limbs. <strong>The preview images of new version are generated using latest version of </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/9139/yesmix\"><strong>YesMix</strong></a><strong>.</strong></p>",
                            "publishedAt": "2023-02-21T10:10:14.844",
                            "availability": "Public",
                            "trainedWords": [
                                "1girl",
                                "realistic",
                                "makeup",
                                "lips",
                                "lipstick"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3679,
                                "ratingCount": 972,
                                "rating": 5,
                                "thumbsUpCount": 975,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 11936,
                                    "sizeKB": 1751.7177734375,
                                    "name": "fashiongirl-lora-v3.6fix-waifu-2ep.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-21T10:12:21.223Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV2": "83A344BC2A",
                                        "SHA256": "83A344BC2A6ACD3879A1A76E44656B3E2FE8910769D65A5E1E990D0CA971BE99",
                                        "CRC32": "6F67F4AC",
                                        "BLAKE3": "8F37E2CA932079202900986924D3120E5ACA752036E9DC68712E5D7F72CB9D11",
                                        "AutoV3": "3E905AD484E9"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/13479",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 130315,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/02a6d25f-38ef-4cfc-ba57-7e60135e8200/width=450/130315.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "ULKK7]NN4:-o4-IVIUxp.AD*4obY^%s,n%WD",
                                    "type": "image"
                                },
                                {
                                    "id": 130314,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/27b8f59e-1dfe-4844-bd8c-8b69f1045e00/width=450/130314.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UFKdGO~E9kD=s|-h?XE00L?ZIURi-V-;02xb",
                                    "type": "image"
                                },
                                {
                                    "id": 130313,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d56ac27-faa2-4fa6-c483-f46a0aa9df00/width=450/130313.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "ULQu,9_NT{a1+[R6XSg3nnpHR%nO.SWBkBWr",
                                    "type": "image"
                                },
                                {
                                    "id": 130312,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6fd6ae4c-a32e-4d1e-93b3-0d8977663c00/width=450/130312.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UJLW^q~q21IoF$Iqb{ozM~kXH@ninmRj?Gg3",
                                    "type": "image"
                                },
                                {
                                    "id": 130311,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d2f3fa37-1424-472a-4a19-9c1a58fa9a00/width=450/130311.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UEL:=l00*0^j?^4.~qNG0LWV~W-pNGoz9Ft7",
                                    "type": "image"
                                },
                                {
                                    "id": 130310,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5f1baf79-2d48-44ba-3952-536f565a9800/width=450/130310.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1920,
                                    "height": 1280,
                                    "hash": "UEGIyH?[000000M{}rx]5i-WIU^QFp-CXSV?",
                                    "type": "image"
                                },
                                {
                                    "id": 130309,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fe1365a6-0191-4615-7dd3-a9b08ff97a00/width=450/130309.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 3040,
                                    "height": 2034,
                                    "hash": "UdKn9._N_3?b?IWBRjayx]WBWBay%MayR*of",
                                    "type": "image"
                                },
                                {
                                    "id": 130308,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7df00cd5-c511-4f46-3df7-565f3bdf2900/width=450/130308.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 3040,
                                    "height": 2034,
                                    "hash": "UZL|r:_N_4.8?bWBRjf5x]aejZax%NayWBjZ",
                                    "type": "image"
                                },
                                {
                                    "id": 130307,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/802836e0-1fcb-4150-5849-3e855ddf5700/width=450/130307.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 3040,
                                    "height": 2034,
                                    "hash": "UYMjXZ~q?u?v%NayWBod%MWBafWB.8WBRkax",
                                    "type": "image"
                                },
                                {
                                    "id": 130306,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f1b9684-e642-4478-99c4-c0dcdebfe000/width=450/130306.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 3040,
                                    "height": 2034,
                                    "hash": "UZKUG|~q~q_3_3WBM{WB%MRjaeay-;aeWBWB",
                                    "type": "image"
                                },
                                {
                                    "id": 130305,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/23ed7626-44c1-4cce-21c3-5e388df77d00/width=450/130305.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 3040,
                                    "height": 2034,
                                    "hash": "UbL4KU~q_4?v-=ayWBR*x]WBWBaxx]f6WBoL",
                                    "type": "image"
                                },
                                {
                                    "id": 130304,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2b00b701-ec35-44a1-53ab-a9b0bcd76b00/width=450/130304.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3040,
                                    "height": 2034,
                                    "hash": "UgKU4i~q?b?b?aRjRjWC%MRkWBf6x]f6ayj[",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/13479"
                        },
                        {
                            "id": 12104,
                            "name": "v3.0 (For SD1.5 and waifu VAEs)",
                            "index": 9,
                            "modelId": 8217,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p><strong>This version is optimized for the checkpoints with vae-ft-mse-840000-ema-pruned.vae.pt and kl-f8-anime2.vae.pt.</strong> It's found that the above checkpoints will generate over-saturated images when using the LORA modules trained with 784mb VAE. This version will make it more natural. The models with 784mb VAE can also use this version if you don't care about slightly low-saturated generating images. <strong>The preview images of this version are generated using merged model based on </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/9139/yesmix\"><strong>YesMix </strong></a><strong>(70%) and </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/8281/perfect-world\"><strong>Perfect World</strong></a><strong> (30%) and baked with vae-ft-mse-840000-ema-pruned.vae.pt.</strong></p>",
                            "publishedAt": "2023-02-18T11:50:51.419",
                            "availability": "Public",
                            "trainedWords": [
                                "1girl",
                                "realistic",
                                "makeup",
                                "lips"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3730,
                                "ratingCount": 329,
                                "rating": 5,
                                "thumbsUpCount": 331,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 11083,
                                    "sizeKB": 1753.640625,
                                    "name": "fashiongirl-lora-v3-waifuvae.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-18T11:56:02.192Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV2": "471BB74B78",
                                        "SHA256": "471BB74B786C5D24C2821805DCE054343285BC9C435123C835F4FD18AC8F3CF6",
                                        "CRC32": "9C6324A9",
                                        "BLAKE3": "E665B9B7C1B37C55221A0D877475B603EA61D069DB10B874A971F26FEBA4B785",
                                        "AutoV3": "2896C47EAB5F"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/12104",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 116043,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/75596181-3699-44b8-5185-d89c0d43ae00/width=450/116043.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UMM7S:yB9=4nx[-;.7of?wE1RQR%t7WE4TkB",
                                    "type": "image"
                                },
                                {
                                    "id": 116042,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5f64781f-3076-44c9-c6c4-53770f8af200/width=450/116042.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UDG[H2%g0Mbv00-VD%M{9ZD%iwRPE1NG~p^+",
                                    "type": "image"
                                },
                                {
                                    "id": 116041,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9771a052-f775-4592-b0df-74f48af11900/width=450/116041.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "ULLg94E2.7?ZxdxtJP%256ba?GIV~VRkV@In",
                                    "type": "image"
                                },
                                {
                                    "id": 116040,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c40fbf2c-3c23-4db5-5b45-fad23b1b5700/width=450/116040.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "U7I|]-~B*0j=,k$e4nIA00_2$#M|jDoz%g%2",
                                    "type": "image"
                                },
                                {
                                    "id": 116039,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6de2d2a6-2a3c-4031-e148-16fca47c0e00/width=450/116039.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UEJ%%w00x?D*+@EL~qDi^,9Z0K-;8w.8ozIB",
                                    "type": "image"
                                },
                                {
                                    "id": 116038,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f3bc51d4-e49c-427f-8de6-c29e45d43c00/width=450/116038.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UNNTg-t-3X~qL4D*x^Ip%No#v}R.O@KjW;S~",
                                    "type": "image"
                                },
                                {
                                    "id": 116037,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2ee9631f-cb96-4632-4803-a20fa7943d00/width=450/116037.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UDK^.z^~00krLopB?s%M_3x@~V-oM*i{R5I.",
                                    "type": "image"
                                },
                                {
                                    "id": 116036,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7fe8a77e-9508-429c-2e88-31ea75982700/width=450/116036.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UAJ7R3~W00aJ00nj~V9u00E1j^?Gr=%Lt69b",
                                    "type": "image"
                                },
                                {
                                    "id": 116035,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e13989a4-c6cb-4c58-71c9-b9f57d17bc00/width=450/116035.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UKI=S,~W3sRPT|Pp?btRT}-V?vD%KjE29uMe",
                                    "type": "image"
                                },
                                {
                                    "id": 116034,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/605de635-8597-4cbc-2cad-07529fe3bf00/width=450/116034.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UiN,PkDj?^%L?ujX%L%NE1t8%ftQjJbIRPRP",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/12104"
                        },
                        {
                            "id": 11965,
                            "name": "v3.0",
                            "index": 10,
                            "modelId": 8217,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>Update dataset and model. <strong>The preview images of new version are generated using latest version of </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/9139/yesmix\"><strong>YesMix</strong></a><strong>.</strong></p>",
                            "publishedAt": "2023-02-18T03:38:25.431",
                            "availability": "Public",
                            "trainedWords": [
                                "1girl",
                                "makeup",
                                "realistic",
                                "lips"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2531,
                                "ratingCount": 74,
                                "rating": 5,
                                "thumbsUpCount": 77,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 11008,
                                    "sizeKB": 1753.6904296875,
                                    "name": "fashiongirl-lora-v3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-18T03:41:15.596Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV2": "8B569CDF70",
                                        "SHA256": "8B569CDF70D513D3BEEA4BC160200A7162F3A141319BED455DBFFF15EB7F4900",
                                        "CRC32": "3F04BD6D",
                                        "BLAKE3": "BE84DC0DD7FA52E7C0C5F23ED04906AF9159DF2785E7C24215C573D414551D47",
                                        "AutoV3": "066D0F506ACA"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/11965",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 114417,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a0f00101-d848-44a7-cf62-d5cadb5abb00/width=450/114417.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UPK^sq_3l9EL9uM{_3s,_2WA~WbIo~bI%M-p",
                                    "type": "image"
                                },
                                {
                                    "id": 114416,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5d0ec5f9-c2c2-4009-aff6-9d923a8b8700/width=450/114416.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UYNA3b_NyX%MFf^+_2M{t6M{nhE1S#WV%2s:",
                                    "type": "image"
                                },
                                {
                                    "id": 114415,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e73dd1b-b54f-4e2e-a32c-db8cd2237b00/width=450/114415.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "URLW#59Zpcs:E*s:~qof%ft7^kxuE2s:%MWV",
                                    "type": "image"
                                },
                                {
                                    "id": 114414,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0e644573-50b6-4233-1993-5eb851238b00/width=450/114414.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UPK^gA_2J+kW4.Mx~WRj.8IowwIpITRQRkjF",
                                    "type": "image"
                                },
                                {
                                    "id": 114413,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c93c5869-55c3-4bc3-f057-443033766c00/width=450/114413.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UDKJ_RJFF:0L00I9^Q={xZ_NE2%gDiIA9aI:",
                                    "type": "image"
                                },
                                {
                                    "id": 114412,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3b5b2120-85f4-446c-9779-6d7789221800/width=450/114412.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UCJZ_7E19D~A00-qROE19GIoX9xu~WV?-oWE",
                                    "type": "image"
                                },
                                {
                                    "id": 114411,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e7225a83-baa5-4563-f8ac-abb645653600/width=450/114411.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UXMZj*~WT0R*X4%MM{tQEMWCxvM|MykCa#t7",
                                    "type": "image"
                                },
                                {
                                    "id": 114410,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2b3a5c2d-5c6c-484f-3b40-a61b5f478500/width=450/114410.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UJLf%F~V0JjEDgRP-UjYbWt7?Ht7rqa}SjWB",
                                    "type": "image"
                                },
                                {
                                    "id": 114409,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/294bc86b-76fa-4002-62b9-2fc52f84c800/width=450/114409.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "U9Msl@w20JpGE+^+H@-p55J7^j~V?HV@oz9a",
                                    "type": "image"
                                },
                                {
                                    "id": 114408,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e4036acd-069e-4104-e71e-6281649e0800/width=450/114408.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "ULK^1;~V00R555ad^*ozELbaxtazIAadspfS",
                                    "type": "image"
                                },
                                {
                                    "id": 114407,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f6c7cbae-c7b2-44a5-344f-b118d348aa00/width=450/114407.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "U6KcFX0000DP7Znlbd0fLItlHr5k}t0f?aD*",
                                    "type": "image"
                                },
                                {
                                    "id": 114406,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7c30ce8c-7477-43d1-011e-043eb9f0f500/width=450/114406.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UGHd]c=xV@~VT19YS0Nb%3-pE1jIjcSiIUxa",
                                    "type": "image"
                                },
                                {
                                    "id": 114405,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/78aac8d3-6472-4912-2782-7db0ff184200/width=450/114405.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UKJ%zj_20fM|4;s:~VR*D*n$%2-o-:tQV]t7",
                                    "type": "image"
                                },
                                {
                                    "id": 114404,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9049d575-3aa9-4c64-77b4-3d9f1a5b0900/width=450/114404.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UIM?r6_N0v-o0z^%Rixu9Ia0RSM|r;4:MxRk",
                                    "type": "image"
                                },
                                {
                                    "id": 114403,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cabb9ccb-e281-46a2-9e30-1586d4f0e600/width=450/114403.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UCK-2u_3?u%g4mS$0Lt-004.-B^%uPIqVs9Z",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/11965"
                        },
                        {
                            "id": 10337,
                            "name": "v2.0 (small file size)",
                            "index": 11,
                            "modelId": 8217,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>Dataset and model are updated. Reduce the model file size to 1MB.</p>",
                            "publishedAt": "2023-02-14T12:33:51.524",
                            "availability": "Public",
                            "trainedWords": [
                                "1girl",
                                "realistic",
                                "makeup",
                                "lips"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3700,
                                "ratingCount": 242,
                                "rating": 5,
                                "thumbsUpCount": 245,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 9848,
                                    "sizeKB": 1747.0927734375,
                                    "name": "fashiongirl-lora-v2.0-small.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-14T12:36:15.048Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV2": "6A6DC5CF0A",
                                        "SHA256": "6A6DC5CF0A538A1EDFB484DD52EA146BB7F5F4B2A278F99409FC7896A98F3974",
                                        "CRC32": "14372AB7",
                                        "BLAKE3": "44F6C8FEFA08717651E550FC39E64B1EF50FF674CDFD230CADC79E96AEFCF91A",
                                        "AutoV3": "F1B9175175BD"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/10337",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 100871,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f9c2ed6e-76bc-4745-cae7-5a7799f93800/width=450/100871.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UTKT=F~p%h?b%fog?He.-=W9xb9Z-;ogbb%2",
                                    "type": "image"
                                },
                                {
                                    "id": 100870,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e6319196-fed6-4010-26aa-711965d60b00/width=450/100870.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UFJHH,oz00V@McIUmmx]_M?H+]9ZZ$MxD*Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 100869,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e8a35b85-bb66-4847-7d5b-815b3530fc00/width=450/100869.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UBIOtv.T3?8wALgOrCrp0056Mco#DPDi,mKQ",
                                    "type": "image"
                                },
                                {
                                    "id": 100868,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/520e3287-7435-4b92-2a02-bdbfc3f5ea00/width=450/100868.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UPKwRtT0%$?bJ8?b~pspS~xtoeE1?HayV[Na",
                                    "type": "image"
                                },
                                {
                                    "id": 100867,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a9b298a4-850f-4a78-de13-43d59010d000/width=450/100867.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UNK1g?M{ysb^pyV@J:Ip01NGrrM|^+g3$%M{",
                                    "type": "image"
                                },
                                {
                                    "id": 100866,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad39a799-7431-47e2-242d-5525f18c5e00/width=450/100866.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UMIOOs?bx[9Z~Xt7D%Io4.M{%MxaRjWBtRj[",
                                    "type": "image"
                                },
                                {
                                    "id": 100865,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d8561ceb-16a5-4844-0799-5386c1a4bd00/width=450/100865.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UJHLPbt79[?vM{_3%gSf_4%ND%kWw#IBxvIq",
                                    "type": "image"
                                },
                                {
                                    "id": 100864,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1319430d-a1da-4735-03cb-1815d940f400/width=450/100864.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UHIg.b~p4.t79Xt7-q-pD%IoR.Ri-:R*IVxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 100863,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a95b8496-41c0-4a57-11ff-81f9fc3d3800/width=450/100863.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UFHUnN^*00E2NFDi4:x]J8s:~Vt7D%IVIUxu",
                                    "type": "image"
                                },
                                {
                                    "id": 100862,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4793b6d4-11e2-44c2-cd7c-e039456da300/width=450/100862.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UVHo5zrWIoE2?wRORPf+JDt2s:ofR;xZS3IU",
                                    "type": "image"
                                },
                                {
                                    "id": 100861,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7ce06bfb-9772-4518-bb09-0d77f8248500/width=450/100861.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UUIE9Q~CM{XTcZjbD%N_%#SgV?xuMxRjX7S2",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/10337"
                        },
                        {
                            "id": 10252,
                            "name": "v2.0",
                            "index": 12,
                            "modelId": 8217,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 9,
                            "description": null,
                            "publishedAt": "2023-02-14T07:21:50.557",
                            "availability": "Public",
                            "trainedWords": [
                                "1girl",
                                "makeup",
                                "realistic",
                                "lips"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2018,
                                "ratingCount": 23,
                                "rating": 5,
                                "thumbsUpCount": 25,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 9792,
                                    "sizeKB": 147576.6044921875,
                                    "name": "fashiongirl-lora-v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-14T07:26:33.896Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "F26274F9",
                                        "AutoV2": "DEEA289230",
                                        "SHA256": "DEEA2892303B04A80057A19A5069BC65BCCC1385894A981AC6345DAB996AB1B3",
                                        "CRC32": "74429160",
                                        "BLAKE3": "140129ECEFFDB2F8F544949153830E19F930A61A5BAE13CFA822020A8C4DE412",
                                        "AutoV3": "5DEB7D2AD00C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/10252",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 100263,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/da57039e-77d6-4c69-fe4a-fb83b8a03100/width=450/100263.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UGI|^1}?00H=9ED%s:xtD*sA^6wc0Js:xZRj",
                                    "type": "image"
                                },
                                {
                                    "id": 100262,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a5f81d9f-b38b-4a59-f7eb-d007be16aa00/width=450/100262.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UPK1aq8__N9Zx]M{?b%M.8t7xb-;oJS2xG-p",
                                    "type": "image"
                                },
                                {
                                    "id": 100261,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/522e0d29-d4ee-41d2-4e97-e61824bf7300/width=450/100261.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UOKKm8~qtnIUbw.8_MM{9YaJ-Tt6x^t7M{IU",
                                    "type": "image"
                                },
                                {
                                    "id": 100260,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0e41aae5-99c2-4153-0192-5e33d00a1400/width=450/100260.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UTJ*6i9FXS9Ft,M{~q%Mxt%Mxa%Mo#bI%MR*",
                                    "type": "image"
                                },
                                {
                                    "id": 100256,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aca03fa8-0908-475e-ccd9-62692cd1fe00/width=450/100256.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UTI}kwJD9u-;9ttS-=%N-:WFxZxu~qM{Mx%2",
                                    "type": "image"
                                },
                                {
                                    "id": 100258,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/05a6fd3b-9bc1-4616-8118-2a1d5a843700/width=450/100258.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UDJtPMe.0$t6_NE1%h~VS$%M~WxZ-oIo%Ma{",
                                    "type": "image"
                                },
                                {
                                    "id": 100255,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/10eecdf3-f87a-418a-402a-6e454f2b8800/width=450/100255.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "ULI#7M~VNsSh4-M_-UD*9ZRkI=kC?HozIUxa",
                                    "type": "image"
                                },
                                {
                                    "id": 100257,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ba855746-41cb-499c-fd78-b95c3962b100/width=450/100257.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UNJQ{3t7%$R.9YWBInxt9aRj?aWB~pxuWCWC",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/10252"
                        },
                        {
                            "id": 10253,
                            "name": "v1.0",
                            "index": 13,
                            "modelId": 8217,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-02-14T07:21:50.557",
                            "availability": "Public",
                            "trainedWords": [
                                "1girl",
                                "lips",
                                "realistic"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1257,
                                "ratingCount": 34,
                                "rating": 5,
                                "thumbsUpCount": 38,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 9793,
                                    "sizeKB": 147575.736328125,
                                    "name": "fashiongirl-lora-ucg-v1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-14T07:26:28.604Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "6A76FFEF",
                                        "AutoV2": "9CB296533B",
                                        "SHA256": "9CB296533B1EB47CCDC22A0025D6B5FCED903EB2AC455E7FCA7C20E51EAB87D1",
                                        "CRC32": "6CB8BDD9",
                                        "BLAKE3": "D74EAB86C0AC7B425D9227F0A188AD490193DFF4D482EC396334445F5589108C",
                                        "AutoV3": "7090E30279C2"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/10253",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 100271,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71be221c-95cd-4d06-eda7-798258b68a00/width=450/100271.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UHIN?k?HEy4.OsM{-;M{%#of~Wof~W%Mxuoz",
                                    "type": "image"
                                },
                                {
                                    "id": 100270,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7c76aa17-2abb-4947-0bb9-6114eb79c000/width=450/100270.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UPIqu}xuEz?H?ut7~WRjtQM{s9Rjxtt7WAWC",
                                    "type": "image"
                                },
                                {
                                    "id": 100269,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bdd0ce1d-91db-459c-cead-3d6bceb41500/width=450/100269.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UHJHR6VsyD-;9uWqxC%M0MofD%WB~Wae9GRj",
                                    "type": "image"
                                },
                                {
                                    "id": 100268,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/01560cfc-8e2d-455f-4bc4-2e623e23ec00/width=450/100268.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UOJ*3d_N%~?Gxu%M.8IVg3RjaeDi%MofRP%2",
                                    "type": "image"
                                },
                                {
                                    "id": 100267,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d9230b71-36eb-4799-610d-a79bacbc8100/width=450/100267.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UDHC4I,_00009D9Z.8~p0fni?GxuOs%Lr?IV",
                                    "type": "image"
                                },
                                {
                                    "id": 100266,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5eacbf37-f164-41d3-bb0e-1a435849fc00/width=450/100266.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "ULI;epxH0extQ-={JTOE4o?Gn#WU~WIqo#ax",
                                    "type": "image"
                                },
                                {
                                    "id": 100265,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3b740444-523b-44d4-55d2-106493de6b00/width=450/100265.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "URK1E*4rR|%M-zM#?F-oIl${xT${}?xUsjxV",
                                    "type": "image"
                                },
                                {
                                    "id": 100264,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f32a27ad-485a-419a-a559-2916b04cf700/width=450/100264.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UMJt_5M{LNx^K,%0o#-;Mzx]v~Mxx]M{%0-:",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/10253"
                        }
                    ]
                },
                {
                    "id": 25995,
                    "name": "blindbox/大概是盲盒",
                    "description": "<h1>BlindBox Artstyle</h1><p>更新了V3版本，调整了眼睛，俗话说眼睛是心灵的窗口。但是目前还是实验性质的，从稳定性上还是推荐v1_mix版本。</p><p>如果你喜欢我的作品，可以点个Like，或者请我 <a target=\"_blank\" rel=\"ugc\" href=\"https://ko-fi.com/samecorners\">喝杯咖啡</a>。</p><p>爱来自瓷器。</p><p>[机翻英语]</p><p>Updated v3 version, adjusted the eyes, as the saying goes, the eyes are the windows to the soul. But it is still experimental, from the stability or recommended v1_mix version.</p><p>If you like my work, you can click \"Like\" or <a target=\"_blank\" rel=\"ugc\" href=\"https://ko-fi.com/samecorners\">buy me a coffee</a>.</p><p>Love from China.</p><p></p><h2>blindbox_v1_mix 👍</h2><ul><li><p>Add the prompt <strong>full body,chibi,</strong></p></li><li><p>weigh : 1</p></li><li><p>checkpoint : <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7371/rev-animated\">RevAnimated</a> or other you like</p></li><li><p></p></li></ul><p>mix PVC material, is good.</p><p>🖖<strong>I would appreciate it if you could share with me the results of your use.</strong></p><p></p><h2>blindbox v1</h2><ul><li><p>Add the prompt <strong>full body,chibi,</strong></p></li><li><p>Recommeneded weigh : 1</p></li><li><p>checkpoint : <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7371/rev-animated\">RevAnimated</a></p></li><li><p></p></li></ul><p>Other checkpoint may produce fantastic results, try it yourself.</p><p>Can be used with other LoRA.</p><p></p><p></p><h2>blindbox v2</h2><ul><li><p>Reduces the probability of a big head (maybe)</p></li><li><p>Lowered network_dim value, smaller file size</p></li><li><p>More Chibi, Less blindbox</p></li><li><p></p></li></ul><p>v1 version has good blindbox artstyle</p><p></p><h2>blindbox v3</h2><ul><li><p>调整眼部细节</p></li></ul><p></p><p>ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー</p><p></p><p>盲盒风格的LoRA，一开始是这么想的。</p><p><strong>v1版本 </strong>还是比较盲盒的。</p><p>增加了PVC的质感，更新了v1_mix，效果很不错，建议使用👍</p><p>增加关键词<strong>chibi, full body,</strong></p><p>减少负面描述会好一点，也可自行尝试。</p><p><strong>经过测试，如果要和别的LoRA一起使用，还是把那些负面关键词加上吧</strong>😅</p><p>推荐使用<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7371/rev-animated\">RevAnimated</a>模型。</p><p>跟一些角色LoRA也有比较好的相性。</p><p></p><p><strong>v2版本</strong>减少了大头的概率，更偏向二头身。</p><p>适合一些动漫画风了，也许。</p><p></p><p>有问题可以去B站问，如果我能解决的话😄</p><p>姑且放上一个没人气的视频</p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://www.bilibili.com/video/BV1Ah411G7Zs/\">https://www.bilibili.com/video/BV1Ah411G7Zs/</a></p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 145133,
                        "favoriteCount": 0,
                        "thumbsUpCount": 13348,
                        "thumbsDownCount": 0,
                        "commentCount": 60,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 150
                    },
                    "creator": {
                        "username": "samecorner",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bc322522-813d-49c0-ad3e-ff199e180f00/width=96/samecorner.jpeg"
                    },
                    "tags": [
                        "anime",
                        "style",
                        "artstyle",
                        "chibi",
                        "cute"
                    ],
                    "modelVersions": [
                        {
                            "id": 32988,
                            "name": "blindbox_v1_mix",
                            "index": 0,
                            "modelId": 25995,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>mix PVC material.</p><p></p>",
                            "publishedAt": "2023-04-01T06:55:32.66",
                            "availability": "Public",
                            "trainedWords": [
                                "full body, chibi,"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 134142,
                                "ratingCount": 3581,
                                "rating": 5,
                                "thumbsUpCount": 3749,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 27171,
                                    "sizeKB": 147567.2177734375,
                                    "name": "blindbox_v1_mix.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-01T06:56:16.680Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "088B509A",
                                        "AutoV2": "525491E628",
                                        "SHA256": "525491E6289D1912839C0BB5E3C3C390FEAD13C46CDD435C1B6A6AB3EA9AC14F",
                                        "CRC32": "01B4AF78",
                                        "BLAKE3": "78195C5CFF4C6D83A61B0D6B836D59F85EFEE66FBB953758E4B2AF0389F8A802",
                                        "AutoV3": "EE3FBE5A8576"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/32988",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 375791,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f39bbb06-3d4b-40cf-36ef-0abac596a000/width=450/375791.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "UEJ8FW^j.m9cBrJ6NNo4KLS4r:XO*IbuMeMz",
                                    "type": "image"
                                },
                                {
                                    "id": 375790,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f2286b2-8738-4cce-0cac-2284f2400f00/width=450/375790.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "UFJ7OD0f9F~W68RO9F%19@M{-;D*9Z-:snRk",
                                    "type": "image"
                                },
                                {
                                    "id": 375789,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/24b1e6cb-e494-4ee9-e842-4bd7993ec500/width=450/375789.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "UBJR8NOmyF~WK8AvtS?H4-b^IURi_1xv+cnO",
                                    "type": "image"
                                },
                                {
                                    "id": 375788,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6126b473-548a-460e-56cc-d3ee0ff46400/width=450/375788.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "UMKKD]-p-;Nb^-ogs;-p%3RjxvNK={%MSJk9",
                                    "type": "image"
                                },
                                {
                                    "id": 375787,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4b7a4f48-77a5-4f0f-745b-d80df908dc00/width=450/375787.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "UAKv~%0f0000_3E14.4-y?IUtRa~00^*r@M|",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/32988"
                        },
                        {
                            "id": 48150,
                            "name": "blindbox_v3",
                            "index": 1,
                            "modelId": 25995,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>调整眼部细节，实验版本</p>",
                            "publishedAt": "2023-04-17T14:47:04.489",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5075,
                                "ratingCount": 7296,
                                "rating": 5,
                                "thumbsUpCount": 9039,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 35621,
                                    "sizeKB": 147567.572265625,
                                    "name": "blindbox_v3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-17T14:47:11.244Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "A96CA9BA",
                                        "AutoV2": "976D161B85",
                                        "SHA256": "976D161B85C7DE755C2084A94FF3645127862CEC3EE3A6F44721C51C743FD96F",
                                        "CRC32": "9F77C609",
                                        "BLAKE3": "5B31A30C50248C0FC00A2928299CC08D97C62C8DED038E566157BE5797074192",
                                        "AutoV3": "F221DBFED0D8"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/48150",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 517448,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/82dd913f-4038-4e0f-7f1f-06494208d700/width=450/517448.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "U9G*+#0000~Wq?-;4:xtt,D%-VM|01^+^jD*",
                                    "type": "image"
                                },
                                {
                                    "id": 517449,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d04be295-b26c-42d2-bd3f-be26c74c7000/width=450/517449.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "UIEn|zskE0~VI]%0t3-pM_E2kCE20fs:IVE2",
                                    "type": "image"
                                },
                                {
                                    "id": 517451,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/76a888ab-4244-4e81-3c43-b0093ddccd00/width=450/517451.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "UMHC1Zxa?wWq00Rj9FRj?vkB%0t7R:azt7ay",
                                    "type": "image"
                                },
                                {
                                    "id": 517455,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5c3ece40-cf95-4636-1af8-7346d1b1e000/width=450/517455.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "UMKApL^+~poz0KIoIoWB-pj[M{s:bvbHoLay",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/48150"
                        },
                        {
                            "id": 32376,
                            "name": "blindbox_v2",
                            "index": 2,
                            "modelId": 25995,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>blindbox v2</p><ul><li><p>Reduces the probability of a big head (maybe)</p></li><li><p>Lowered network_dim value, smaller file size</p></li><li><p>More Chibi, Less blindbox</p><p></p></li></ul><p>v1 version has good blindbox artstyle</p>",
                            "publishedAt": "2023-03-31T07:50:26.636",
                            "availability": "Public",
                            "trainedWords": [
                                "full body,chibi,"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2170,
                                "ratingCount": 256,
                                "rating": 5,
                                "thumbsUpCount": 257,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 26677,
                                    "sizeKB": 36986.541015625,
                                    "name": "blindbox_v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-31T07:55:55.934Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "72EBA5CA",
                                        "AutoV2": "13262C02D2",
                                        "SHA256": "13262C02D22A70535902E2C283ADAE7B445B227E04A54A1C501D036552D6843C",
                                        "CRC32": "F5F63DEB",
                                        "BLAKE3": "E0F5268EB3E82EE00B60036E03503A9BCE0F36043BEC15649BC210FDC8B692CD",
                                        "AutoV3": "A4881924090A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/32376",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 368734,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/28a2af12-3b69-40c2-289d-d0e395b81000/width=450/368734.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "UCKecl%3_3o#0hw[=|IppIn3v0EN_4+[mQEM",
                                    "type": "image"
                                },
                                {
                                    "id": 368733,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6e3300d7-7c0a-4847-a687-574ef2dc7900/width=450/368733.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "UHL4y#?H~WyEnB=an#tRh|adMcVs^kcF-7s:",
                                    "type": "image"
                                },
                                {
                                    "id": 368732,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1be4468c-81ce-4b51-fa59-0b7593fd0600/width=450/368732.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "UJK1I0IoNfIp%QIp-U%19sS$RPw]kkNaS0My",
                                    "type": "image"
                                },
                                {
                                    "id": 368731,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ee5399d0-c216-495f-9c2c-1726c7015500/width=450/368731.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "UHK-F4Xn.A%2J@S~tmof0ybbNLafXQEOggM{",
                                    "type": "image"
                                },
                                {
                                    "id": 368730,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dccc2b7b-ddff-4287-e357-451b816dbf00/width=450/368730.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "ULJ83A?GXoI;u6xbo~ozPVSh-:kW5;OrEeIp",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/32376"
                        },
                        {
                            "id": 31123,
                            "name": "blindbox_v1",
                            "index": 3,
                            "modelId": 25995,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>blindbox v1</p><ul><li><p>Add the prompt <strong>chibi, full body,</strong></p></li><li><p>Recommeneded weigh : 1 </p></li><li><p>checkpoint : <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7371/rev-animated\">RevAnimated</a></p><p></p></li></ul><p>Other checkpoint may produce fantastic results, try it yourself.</p><p>Can be used with other LoRA.</p>",
                            "publishedAt": "2023-03-29T06:55:37.112",
                            "availability": "Public",
                            "trainedWords": [
                                "full body, chibi,"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3746,
                                "ratingCount": 379,
                                "rating": 5,
                                "thumbsUpCount": 382,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 25678,
                                    "sizeKB": 147574.978515625,
                                    "name": "blindbox_v1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-29T07:10:59.018Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "9A7C365C",
                                        "AutoV2": "C37305360E",
                                        "SHA256": "C37305360ECD271CFCB97C9EE41CD2E8E737DE5C117C340F7DA3CD0053E5FF2C",
                                        "CRC32": "A1DE1A64",
                                        "BLAKE3": "4D07F8987C75A8D14C9F564536BCAC32034DB66696DD7ACD33645ACBBDBF291A",
                                        "AutoV3": "3EA5E8A1602A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/31123",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 354042,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8a96f430-8d1d-449f-f28a-9e875d5aa000/width=450/354042.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 768,
                                    "hash": "UGKmR:4:}Z^+00XmDiE19aEL.8sp-V$%wuxt",
                                    "type": "image"
                                },
                                {
                                    "id": 368736,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c8e0ab68-01b0-4e00-bd0e-0219c2b0dd00/width=450/368736.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 768,
                                    "hash": "UDJQ=+4VIW.9~Uxu-B%L8ww[x[Mx;JMxJ6R+",
                                    "type": "image"
                                },
                                {
                                    "id": 368735,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/397d4c3e-ff6a-4ff5-8dbb-fa3dd827c300/width=450/368735.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 768,
                                    "hash": "UOKANW~VV]IVt,NbNHNHI-xt-UbH^it7R*Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 354041,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4ee80666-7033-471c-afe8-d9d75d6be700/width=450/354041.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 768,
                                    "hash": "UEKd3.D%000L0LD%~CR,00IV%2%Liv%fIoIU",
                                    "type": "image"
                                },
                                {
                                    "id": 354040,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/171250eb-f409-4ecb-aa10-544458249500/width=450/354040.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "UCKdlHEf1NFr}l9F9uFdvL%M4:XT0ycDVYoK",
                                    "type": "image"
                                },
                                {
                                    "id": 354039,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c3f90286-070f-406a-d8a6-50c186baa000/width=450/354039.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 768,
                                    "hash": "UFO.dm5?DP{dxv8{?v-:=v-9E%xu~VxaNHIV",
                                    "type": "image"
                                },
                                {
                                    "id": 354038,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2b93395e-c717-467a-d215-593569489700/width=450/354038.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "UIKd0rV@00-;Dht7%2s.=d9txaxu~pxa4.NG",
                                    "type": "image"
                                },
                                {
                                    "id": 354037,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/deec9264-ad51-45b8-912e-71e80a703700/width=450/354037.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "USM6M5$iD%xu00xts.Rjw^aJx]bb~B-pIUNG",
                                    "type": "image"
                                },
                                {
                                    "id": 354036,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c3cc8027-6bd6-4f90-a81d-228c5cd9c500/width=450/354036.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1152,
                                    "hash": "UFKm;S~V0Maj9YRk9GIWImxa?Ioz-qRkE1V@",
                                    "type": "image"
                                },
                                {
                                    "id": 354033,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/81db38da-84ce-4a6b-c339-5cd228246000/width=450/354033.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 768,
                                    "hash": "UQM7r#_37MM{HCkWbIi_K5ayVYt6?we.v}X8",
                                    "type": "image"
                                },
                                {
                                    "id": 354032,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f69f00ec-a610-41c4-9967-867aa61ef900/width=450/354032.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 768,
                                    "hash": "USIs5rE25pxu_MS4w[a#-pR*w]WB~VWYe:WB",
                                    "type": "image"
                                },
                                {
                                    "id": 354031,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a67247b2-633f-4cf0-5ee6-122540745900/width=450/354031.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 768,
                                    "hash": "UTKLdeIqKQ.73sxF%1ozrXNdrXRjPCWXRjRj",
                                    "type": "image"
                                },
                                {
                                    "id": 354030,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f7337af8-ff90-4021-f084-311a41cf1500/width=450/354030.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 768,
                                    "hash": "UFKmR+Qm$f-pkW~V?IIUBQ9at7IVDii^IURj",
                                    "type": "image"
                                },
                                {
                                    "id": 354028,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6c50c480-7d1c-4c7f-eeca-9188891dea00/width=450/354028.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 768,
                                    "hash": "UHM~;FTK}Z=yt,-;=|a09t$*9FIVv2WB8wjt",
                                    "type": "image"
                                },
                                {
                                    "id": 354027,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4cb8e0e4-98cb-4908-a1f9-b9c86f636300/width=450/354027.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 768,
                                    "hash": "UCLWI+IWDO^Q_3%MvhniPARj^k9a|^xt00t5",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/31123"
                        }
                    ]
                },
                {
                    "id": 13090,
                    "name": "Gacha splash LORA",
                    "description": "<p>The training dataset is 100% generated by NovelAI. No real artwork is used.</p><h3 id=\"heading-16\">Checkout my Alter version, which uses real artwork: <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/85859/gacha-splash-alter\">https://civitai.com/models/85859/gacha-splash-alter</a></h3><p></p><hr /><p></p><p>3.0 version is released. I rebuilt the entire training set for this version.</p><p>Notes:</p><ol><li><p>Use hires fix + SD upscale or MultiDiffusion to get better face details.</p></li><li><p>Try adding <strong>wood, stone</strong> in negative prompt if you see too many woods, stones, structures. You may also emphasize it. For example, the bottle keeps getting transformed into structures till I add <strong>wood, stone</strong>.</p><p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0f22fd23-ec7b-412e-3510-b2eb1b939300/width=525/0f22fd23-ec7b-412e-3510-b2eb1b939300\" /></p></li></ol><p></p><p>A 2.0 version is released:</p><p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d581a9e1-feba-4e9e-5e5b-77a9620aa100/width=525/d581a9e1-feba-4e9e-5e5b-77a9620aa100\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c769bab0-33fa-41b8-a078-aa74960e7e00/width=525/c769bab0-33fa-41b8-a078-aa74960e7e00\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f0923741-80ed-47d6-a907-c735d8870700/width=525/f0923741-80ed-47d6-a907-c735d8870700\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8c61993b-b369-4db3-ca80-5cb1f97b5e00/width=525/8c61993b-b369-4db3-ca80-5cb1f97b5e00\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/29bbb4b7-c376-46dc-0707-160f2c748800/width=525/29bbb4b7-c376-46dc-0707-160f2c748800\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a1a6e79c-fc71-4d6d-e97a-c8ce76800c00/width=525/a1a6e79c-fc71-4d6d-e97a-c8ce76800c00\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f8ee28bb-46df-4a8b-509a-09a307409300/width=525/f8ee28bb-46df-4a8b-509a-09a307409300\" /></p><p></p><p>A gacha splash style lora. Make sure you start with the following template and add your background prompts.</p><p>[(white background:1.5)::5], isometric <strong>OR </strong>hexagon , 1 girl, mid shot, full body, &lt;add your background prompts here&gt;</p><p>Suggested resolution: 640X640 with hires fix. You may modify your prompt and resolution after successfully getting the effect.</p><p></p><p>I trained two different versions with different learning rate and scheduler.</p><p>Gacha Splash Fantasy fits more in abstract backgrounds.</p><p>Gacha Splash is intentionally trained to be slightly overfit. It fits greatly for architectures.</p><p>See compares from sample images</p><p></p><p>Notes:</p><p>1. If your characters are always wearing jackets/half off jackets, try adding \"off shoulder\" in negative prompt. You may further add \"jackets\"/ \"bare shoulders\" if the issue persists.</p><p>2. Similar as the jacket issue, if you find any elements that are always being generated, try adding them into negative prompt first. The training dataset is well tagged. Therefore AI should be able to remove these elements.</p><p></p><p>Prompts like hexagon and isometric help to shape the gacha splash effect. There are some alternative choices.</p><p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fce99058-b1b4-4c11-2d73-a2f6d2cfef00/width=525/fce99058-b1b4-4c11-2d73-a2f6d2cfef00\" /></p><p></p><p></p><p></p><p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3d0c31d6-d02f-4f4f-c0e8-81eabac72d00/width=525/3d0c31d6-d02f-4f4f-c0e8-81eabac72d00\" /></p><p></p><p></p><p></p><p></p><p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8405dea0-5eb3-4a0a-33ac-4d9a6b17dd00/width=525/8405dea0-5eb3-4a0a-33ac-4d9a6b17dd00\" /></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 85257,
                        "favoriteCount": 0,
                        "thumbsUpCount": 12978,
                        "thumbsDownCount": 0,
                        "commentCount": 56,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 66
                    },
                    "creator": {
                        "username": "silvermoong",
                        "image": "https://lh3.googleusercontent.com/a/AEdFTp6hjv-geDSynTd9QNXn-WGlxnkzBUMLoQRYjBNc=s96-c"
                    },
                    "tags": [
                        "anime",
                        "background"
                    ],
                    "modelVersions": [
                        {
                            "id": 38884,
                            "name": "v4.0",
                            "index": 0,
                            "modelId": 13090,
                            "baseModel": "Other",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-04-07T06:36:24.284",
                            "availability": "Public",
                            "trainedWords": [
                                "(white background:1.5)",
                                "[(white background:1.5),::5]"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 38212,
                                "ratingCount": 4321,
                                "rating": 5,
                                "thumbsUpCount": 5367,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 30374,
                                    "sizeKB": 147584.091796875,
                                    "name": "GachaSplash4.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-07T06:36:16.225Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "EC5DE9DB",
                                        "AutoV2": "EEBDB8E46F",
                                        "SHA256": "EEBDB8E46FAFDAF3FCA98D0B3ADB0CBB16F71E138B65DDF8E43288D0B4A511EB",
                                        "CRC32": "896F7A6C",
                                        "BLAKE3": "711D67FFA377A99156D2B1FD22E84E81D5ACC51A4BEEA89949C72638FD4675FD",
                                        "AutoV3": "DBFD1E49E2D9"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/38884",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 430722,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b811f07d-83c6-4add-c841-ccc1c5235700/width=450/430722.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2048,
                                    "hash": "UiNB4JWB_3t8xbkCt7WC~Vt6V@ofW=aeRjkC",
                                    "type": "image"
                                },
                                {
                                    "id": 430724,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e0501888-ce11-4a2c-cdd8-511d7b474d00/width=450/430724.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2048,
                                    "hash": "UZHe,^%M~qM{4-t7RjWC-:s:jEbID%jFofRk",
                                    "type": "image"
                                },
                                {
                                    "id": 913822,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2f23227f-24fb-4db4-94c8-59f6ca3d3b13/width=450/913822.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1229,
                                    "hash": "UdL|G%-;?^fl^+WWSOj[_NofxuRPkDRjIoWB",
                                    "type": "image"
                                },
                                {
                                    "id": 913689,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1607e195-7261-4505-937d-1b5a27f81288/width=450/913689.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1920,
                                    "hash": "UlKnSqt8~qf5%MazRjaf_Loft7kBtRj[WnWU",
                                    "type": "image"
                                },
                                {
                                    "id": 913835,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2fe81433-32e3-4044-b7cc-db6908b3ec10/width=450/913835.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1536,
                                    "hash": "UdIh5Bae?bt7?Hj[tSbH~qof%gWX-:j@M{j[",
                                    "type": "image"
                                },
                                {
                                    "id": 913657,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71f6226d-b596-4ebc-a22b-e3019152554a/width=450/913657.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1536,
                                    "hash": "U.NT?yoh~qn}t7ofjbWB%MoKa$kCocaza#a{",
                                    "type": "image"
                                },
                                {
                                    "id": 913656,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7ce4ead9-d26c-4dd5-82c6-e84e13bf644d/width=450/913656.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1536,
                                    "height": 1536,
                                    "hash": "UaNmc$s._N%MENs.nhfi?cbb%haxxtWD%MR,",
                                    "type": "image"
                                },
                                {
                                    "id": 913683,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9d97c0cd-d8bb-41a2-9596-0c5f3e5f4611/width=450/913683.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2304,
                                    "height": 1920,
                                    "hash": "UbLhA2-;~qS4n5xuWAoz%LIU%2xaELRjx]j?",
                                    "type": "image"
                                },
                                {
                                    "id": 913699,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/396a8118-e0cf-4422-a7e1-5cddc96eab90/width=450/913699.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1600,
                                    "hash": "UjNwvP%2~VRj%iWFxst6xsj=agj]e?j[M_Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 913705,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cc2f4557-1e6d-4abe-a47e-fdd312f327fe/width=450/913705.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1920,
                                    "hash": "UrJayQ%M_NIox^kCn%V@t7WBxat7IURjW=t7",
                                    "type": "image"
                                },
                                {
                                    "id": 913681,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d09663a7-3989-490c-900e-b78a63a19ffe/width=450/913681.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1920,
                                    "height": 1536,
                                    "hash": "UVLh3.xu~qfk~WfQRjof.7azVsoL.9ayITt7",
                                    "type": "image"
                                },
                                {
                                    "id": 430736,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c06a5216-e503-4547-57c3-d8a468d3f300/width=450/430736.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2048,
                                    "hash": "UiHoa.%M~qWBxtt7t7WA_3j?t8WBafWAaeay",
                                    "type": "image"
                                },
                                {
                                    "id": 430733,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/343bd58a-1605-4785-e993-ff70ac8c4400/width=450/430733.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2048,
                                    "hash": "UfHokA%h~qaK9FozM{Rj%2RjV@ayIUoft6WB",
                                    "type": "image"
                                },
                                {
                                    "id": 430721,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e58c2809-6822-4e50-f65b-c92b6d3b2400/width=450/430721.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2048,
                                    "hash": "UlNJ^6Rk_Nt7.8WARjt7?bayM{t6WCayofof",
                                    "type": "image"
                                },
                                {
                                    "id": 430725,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a7f4db1d-cd38-4a29-0f35-56feff2ad200/width=450/430725.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2048,
                                    "hash": "UZLzs.S*.9?F?HR,xtoK?woz-:aKRkxZNGM|",
                                    "type": "image"
                                },
                                {
                                    "id": 430727,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b7ac8568-a4aa-4d90-6550-d7cdff9b2e00/width=450/430727.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2048,
                                    "hash": "UbI;*Tof_4xa9|fPs.kCkXfPt6j[~VoJt7ay",
                                    "type": "image"
                                },
                                {
                                    "id": 430731,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/22a0394e-fd86-4182-94f3-9ce501b2e900/width=450/430731.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2048,
                                    "hash": "UoM7cPWB_NtRkCfQWBof_3WVM{t7oLWBWWof",
                                    "type": "image"
                                },
                                {
                                    "id": 430735,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1fee888-fc70-466a-29c8-71456606d500/width=450/430735.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2048,
                                    "hash": "UZI~MpbI~qxuDioex]og~WoexGofo~n%kCae",
                                    "type": "image"
                                },
                                {
                                    "id": 430729,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ce9ace28-58d5-4b6c-bfe1-54d0177d8700/width=450/430729.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2048,
                                    "hash": "UkK-a;xu?wt8bct8IUoJ?bt7M{jYxZxut7NG",
                                    "type": "image"
                                },
                                {
                                    "id": 430730,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/64a1b328-cab6-4794-8a76-bfab6cd2aa00/width=450/430730.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2048,
                                    "hash": "UoLhJTj@_2ogn$aet8of~pogR-oetRj]V@WB",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/38884"
                        },
                        {
                            "id": 23513,
                            "name": "Gacha Splash 3.0",
                            "index": 1,
                            "modelId": 13090,
                            "baseModel": "Other",
                            "nsfwLevel": 1,
                            "description": "<p></p>",
                            "publishedAt": "2023-03-15T09:18:14.065",
                            "availability": "Public",
                            "trainedWords": [
                                "[(white background:1.5),::5] hexagon, 1 girl, mid shot, full body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 8088,
                                "ratingCount": 1276,
                                "rating": 5,
                                "thumbsUpCount": 1278,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 19519,
                                    "sizeKB": 36989.001953125,
                                    "name": "Gacha Splash 3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-15T09:21:36.953Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "991C27BB",
                                        "AutoV2": "30885670D8",
                                        "SHA256": "30885670D820B906657D41DFF2FDAC6F52B401AF6B976746CC64CC2867D69AC9",
                                        "CRC32": "23D5A28F",
                                        "BLAKE3": "5A7DDA06769C62FA85B01A678D06F9E3B1A462FCF5DC7E93E50027EDC219D2BB",
                                        "AutoV3": "B6C94DE7DE00"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/23513",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 254934,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/709353cf-f093-474b-7bde-d9234f6c4d00/width=450/254934.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2560,
                                    "hash": "UWI$BDRP_N%g-ot7%gs:^*bcxZoe%gRiM_R*",
                                    "type": "image"
                                },
                                {
                                    "id": 254932,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/33414929-75b8-44ac-3391-382ddc4b4f00/width=450/254932.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1024,
                                    "hash": "UPKU4nay.TtS?IaytQxuOsoM%Loc9uM{s:t6",
                                    "type": "image"
                                },
                                {
                                    "id": 254933,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ef3ccf4a-b8ea-4414-f893-6208031db600/width=450/254933.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2048,
                                    "hash": "UdKUZloz_3xatSo0xZWq_Nxt-pIpn$kCR,jE",
                                    "type": "image"
                                },
                                {
                                    "id": 254931,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d345b88c-f085-4183-158b-cd492047b800/width=450/254931.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UYJR8XIq%g?F?HRjWVoJ~qkD%Ls.bdj]NFWB",
                                    "type": "image"
                                },
                                {
                                    "id": 254930,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7c0db476-5573-4aff-c467-abefe770ab00/width=450/254930.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1280,
                                    "hash": "UXKUK4Rmx]xu_3NGS2oc~qfl-;t6-qayWYof",
                                    "type": "image"
                                },
                                {
                                    "id": 254929,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6ed60192-0020-47e1-22ff-701ba5250400/width=450/254929.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1280,
                                    "hash": "UOIP6=9Z?a%M~BNG?cxu=pofxa%LyERiIUof",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/23513"
                        },
                        {
                            "id": 20012,
                            "name": "old:Gacha Splash far shot",
                            "index": 2,
                            "modelId": 13090,
                            "baseModel": "Other",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-03-08T01:12:44.431",
                            "availability": "Public",
                            "trainedWords": [
                                "[(white background:1.5),::5] hexagon, 1 girl, mid shot, full body",
                                "[(white background:1.5),::5] isometric, 1 girl, mid shot, full body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 9926,
                                "ratingCount": 2381,
                                "rating": 5,
                                "thumbsUpCount": 2383,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16713,
                                    "sizeKB": 36988.5322265625,
                                    "name": "Gacha Splash far shot.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-08T01:16:29.282Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "0ACC7A6E",
                                        "AutoV2": "B7405399F3",
                                        "SHA256": "B7405399F34C06AD2C25AF83ED749CFAEC627E13D3BE7387200CC41F0E0B98B2",
                                        "CRC32": "9C00E7CB",
                                        "BLAKE3": "0A22F5676A7AE16AFFADC3DF8B11A0643545F21E3F18D6CB06968618A49F30CC",
                                        "AutoV3": "B4C7A0E3B027"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/20012",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 211524,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/16c03646-5987-4c8c-bd29-70862a840b00/width=450/211524.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "UbLqeDbd?v-:xaRkW=of~WoJtRjYTJoeaebI",
                                    "type": "image"
                                },
                                {
                                    "id": 211525,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c92217c5-dccf-4e2c-504e-5bad8c4f8700/width=450/211525.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "URKx9+WY?^-:IWRkM|xt~VxaR-fkEKt6M|Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 211519,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b2179fc1-02aa-4e03-d69e-93edae0e9600/width=450/211519.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2560,
                                    "hash": "UMJ*Yd?a_4M{?dxZ%1sl%#WsoHs-NeR%IUoc",
                                    "type": "image"
                                },
                                {
                                    "id": 211526,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/99b6906e-02cc-4fdc-f581-18b2ee08ad00/width=450/211526.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2560,
                                    "hash": "UgLXA1xv%gxt-;WVoyof~qoft7oJWBayWEWB",
                                    "type": "image"
                                },
                                {
                                    "id": 211523,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d4f28430-3f0a-478c-71c9-113195d08a00/width=450/211523.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "UfHMN2s;_NS5Rkj[t7V@%1t7%2ogMxofs:W;",
                                    "type": "image"
                                },
                                {
                                    "id": 211522,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80ba0dc0-f44d-41fa-75fe-c92bba17bf00/width=450/211522.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "UeJuffo~.Ts,?HnhNHkC?Haee.aeROWqR+j]",
                                    "type": "image"
                                },
                                {
                                    "id": 211521,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e3691019-a7e1-4dfc-eb84-544b87b16200/width=450/211521.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "UTKnVVS%~Xxt#qW=Nsa#.SM_RkR%t7axjdM|",
                                    "type": "image"
                                },
                                {
                                    "id": 217621,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5caa2345-6b31-4032-8d9b-34b43d41e300/width=450/217621.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 2560,
                                    "hash": "UdO3|Xt7.S%MIUV[X9X8~qj[s:oz-pfjt6s.",
                                    "type": "image"
                                },
                                {
                                    "id": 217620,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d047111a-6871-42c9-318b-2ee766cc8d00/width=450/217620.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1280,
                                    "height": 2560,
                                    "hash": "UcNwKBxu?v-pMyRjSef+~payt7kCtRofxakC",
                                    "type": "image"
                                },
                                {
                                    "id": 217625,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eaa5abf6-fc0d-4366-4184-b6ec85e43f00/width=450/217625.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1280,
                                    "height": 2560,
                                    "hash": "UeN^e]tR?vx]%3xZozbb~pV@aet7R,M|Rij@",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/20012"
                        },
                        {
                            "id": 20008,
                            "name": "old:Gacha Splash wide shot",
                            "index": 3,
                            "modelId": 13090,
                            "baseModel": "Other",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-03-08T01:07:36.609",
                            "availability": "Public",
                            "trainedWords": [
                                "[(white background:1.5),::5] hexagon, 1 girl, mid shot, full body",
                                "[(white background:1.5),::5] isometric, 1 girl, mid shot, full body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2759,
                                "ratingCount": 3,
                                "rating": 5,
                                "thumbsUpCount": 4,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16710,
                                    "sizeKB": 36988.537109375,
                                    "name": "Gacha Splash wide shot.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-08T01:11:39.086Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "70E5F5C2",
                                        "AutoV2": "CF17B02B7A",
                                        "SHA256": "CF17B02B7A032B44389F745A5A0C07D05D19CC757AE5CE0EDD966E391E082C3A",
                                        "CRC32": "EF9B5437",
                                        "BLAKE3": "46BC5074A9DDE7B7472F9C178CA3112421DD7A03F32BA8857C98A91D3E6727C5",
                                        "AutoV3": "E982456A60F2"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/20008",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 211504,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6b73f5f4-a12a-47e8-9c39-d8af2bc7ce00/width=450/211504.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2560,
                                    "height": 2560,
                                    "hash": "UIH-rl};.8WZE5sRxCxYGJM{-=NH9aslIVod",
                                    "type": "image"
                                },
                                {
                                    "id": 211535,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/06f7d68c-abe4-47c3-668f-d517b3738400/width=450/211535.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 2560,
                                    "height": 2560,
                                    "hash": "UIJ@wPR:X:-n-TWYjEoe_Nxtt7t70Ls.xtIp",
                                    "type": "image"
                                },
                                {
                                    "id": 211534,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e6e48433-b98c-427e-2523-354803753400/width=450/211534.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "UJIrgLNG~p-;DOay4.s.~URjIqxuEMWUIUIU",
                                    "type": "image"
                                },
                                {
                                    "id": 211533,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a052b233-a59c-4e18-166a-8d3b65239600/width=450/211533.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "UXIiIJxu-pIoN1M{aej[~Bn$kCWBEKRjM{j]",
                                    "type": "image"
                                },
                                {
                                    "id": 211532,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/76c671f4-51ad-44f3-81aa-ee6b22c3a000/width=450/211532.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "UgG,9Yof~qWEsAjYxua$-Ut6xZogM{ogWBn*",
                                    "type": "image"
                                },
                                {
                                    "id": 211531,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2825ee94-c6cf-4ea7-3a6f-23514759ea00/width=450/211531.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "UhHp0Mof~pbcjZaet7WC?Gofoef5s.ozozn%",
                                    "type": "image"
                                },
                                {
                                    "id": 211530,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3a5b3dfa-ec1f-4f3f-6d2f-387b124a7e00/width=450/211530.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "UVJ7]#x]_NI@?HIooLxtyExtbING9taLoeWp",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/20008"
                        },
                        {
                            "id": 20009,
                            "name": "old:Gacha Splash mid shot",
                            "index": 4,
                            "modelId": 13090,
                            "baseModel": "Other",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-03-08T01:07:36.609",
                            "availability": "Public",
                            "trainedWords": [
                                "[(white background:1.5),::5] hexagon, 1 girl, mid shot, full body",
                                "[(white background:1.5),::5] isometric, 1 girl, mid shot, full body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2357,
                                "ratingCount": 6,
                                "rating": 5,
                                "thumbsUpCount": 7,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16711,
                                    "sizeKB": 36988.53515625,
                                    "name": "Gacha Splash mid shot.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-08T01:11:41.064Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "BD7BCD23",
                                        "AutoV2": "A58B66DF03",
                                        "SHA256": "A58B66DF03CE1AF4C5236CA6B358540BB1B2B9850A1D330BE69548E53B784A88",
                                        "CRC32": "50D792E6",
                                        "BLAKE3": "63D5E0793ED08123C84D0940537B8A4B24C6B4B3B3FABE3CDF58896E12158C85",
                                        "AutoV3": "906D02BC6071"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/20009",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 211505,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/51135608-487a-4f4e-4e60-e105a78b7400/width=450/211505.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2560,
                                    "height": 2560,
                                    "hash": "UOJ*Cy=^.T9v^,s:%Mt6?aoKbbt7M|adM{of",
                                    "type": "image"
                                },
                                {
                                    "id": 211555,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7c4d61d6-e275-48a9-d879-dde321c4a800/width=450/211555.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 2560,
                                    "height": 2560,
                                    "hash": "UJJ*F+tS*0?Z^+kD-;R*_3of?cxaNIofIUNG",
                                    "type": "image"
                                },
                                {
                                    "id": 211554,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4506daa9-bde6-4707-18f3-4f4fbf3d4800/width=450/211554.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "URIYX?WX~q-:IBoet7s:^it7a}t7SdRkM{oL",
                                    "type": "image"
                                },
                                {
                                    "id": 211553,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dc700180-daf1-4ce3-3b14-0fecf269a500/width=450/211553.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "UTJ8*Gt6.9MyIWM{RPR+~UxaxaR+o{RjMxof",
                                    "type": "image"
                                },
                                {
                                    "id": 211552,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c81ecb3f-d4ee-48da-ba29-558c04a26f00/width=450/211552.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "UWFjHIbw_NRPIUaytSof$%adnNo#IAoJi^oJ",
                                    "type": "image"
                                },
                                {
                                    "id": 211551,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/624c6a3f-9c17-4f07-13ca-5324ad282900/width=450/211551.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "UZH2~Coz_Nbcs-jZ%MoL?GRjjFWBo}bbkWWB",
                                    "type": "image"
                                },
                                {
                                    "id": 211550,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/74e03e81-cb85-4052-83e8-4baec8eaa900/width=450/211550.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "UcL4A_x]x_xv-pW?aeof~ps:WXWXx[o0f,R*",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/20009"
                        },
                        {
                            "id": 20010,
                            "name": "old:Gacha Splash fantasy 2.0",
                            "index": 5,
                            "modelId": 13090,
                            "baseModel": "Other",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-03-08T01:07:36.609",
                            "availability": "Public",
                            "trainedWords": [
                                "[(white background:1.5),::5] hexagon, 1 girl, mid shot, full body",
                                "[(white background:1.5),::5] isometric, 1 girl, mid shot, full body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2758,
                                "ratingCount": 5,
                                "rating": 5,
                                "thumbsUpCount": 5,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16712,
                                    "sizeKB": 36988.533203125,
                                    "name": "Gacha Splash fantasy 2.0.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-08T01:11:39.117Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "09EDBD63",
                                        "AutoV2": "EE84B50618",
                                        "SHA256": "EE84B50618923E4E116720328605D9AE598F545419D80F395F1E5645720992ED",
                                        "CRC32": "21FC52FC",
                                        "BLAKE3": "296638F32FEAFFEC5D9D649A7C273CCB6920599DB5963BA46C96934CE888C2F2",
                                        "AutoV3": "D26269D2CB5E"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/20010",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 211512,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d6e2bb7-4646-4239-3746-39644cf99400/width=450/211512.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2560,
                                    "hash": "UOJj-w%2yES5?H%L-;Rj~qxux^R+wIRkM{xt",
                                    "type": "image"
                                },
                                {
                                    "id": 211511,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fda07f64-82c8-493a-a089-5469623c2200/width=450/211511.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 2560,
                                    "hash": "UUKKi^oN%$%1?HbIxtof~qWCtR%1E1ofWBRk",
                                    "type": "image"
                                },
                                {
                                    "id": 211510,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cf40595d-2a08-4bc2-1ed4-70e077311900/width=450/211510.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "UJIO;ERj%#-:i^xaRlxu~Ut7M|%MS1j]IUof",
                                    "type": "image"
                                },
                                {
                                    "id": 211509,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9b3649e4-4d7c-481b-bdd5-fa83ef91f200/width=450/211509.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "URKUcsIVElVr$$RPE1M|~qoeW=NGS3RPNGkB",
                                    "type": "image"
                                },
                                {
                                    "id": 211508,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a2e78566-fdd8-46a3-e152-f85006afc100/width=450/211508.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "UbHMTKoM~padIUoLxuoJ%1t7xZjtD*kDWUof",
                                    "type": "image"
                                },
                                {
                                    "id": 211507,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0c0d9fdf-8fa8-4526-9021-5cc0c025c500/width=450/211507.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "URHfSRt8~VkXtSay%1kD^%o0xuWBIAWBWYRP",
                                    "type": "image"
                                },
                                {
                                    "id": 211506,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3540ad16-1ab7-4a05-d621-873f98b88f00/width=450/211506.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "UYI#V}R+-oRj?vWVtRjY_NoetRoMIVjZt7kD",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/20010"
                        },
                        {
                            "id": 15439,
                            "name": "old:Gacha Splash fantasy",
                            "index": 6,
                            "modelId": 13090,
                            "baseModel": "Other",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-02-26T02:11:37.997",
                            "availability": "Public",
                            "trainedWords": [
                                "[(white background:1.5)::5], (bottle bottom:0.9), 1 girl, mid shot, full body, "
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 6394,
                                "ratingCount": 1591,
                                "rating": 5,
                                "thumbsUpCount": 1592,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 13237,
                                    "sizeKB": 36989.013671875,
                                    "name": "Gacha Splash fantasy.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-26T02:16:18.942Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "0294A76E",
                                        "AutoV2": "24899F80E2",
                                        "SHA256": "24899F80E24651DABDB6A297D1DE2F3189A0D7B02C51E538223962236B7A86C9",
                                        "CRC32": "6E68BA49",
                                        "BLAKE3": "DD193B83399C41D3E2A8D613D7F023A0C1D1B83F2E9A7B5784AE0C4E5E7D91A0",
                                        "AutoV3": "6B1BABD507B8"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/15439",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 153858,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/df2ad670-620f-40c0-0863-d7ca8131c200/width=450/153858.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 1482,
                                    "hash": "UjK-zpW?WWNc?bo0jsn$~paej[t6%MkCa}Wr",
                                    "type": "image"
                                },
                                {
                                    "id": 153857,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5cfc8aaf-fb81-40da-5b8f-7690379aab00/width=450/153857.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 1482,
                                    "hash": "UhL;BLxZj[xu~qofazaz?vflayWCR-Rjj[Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 153856,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c310de2d-da50-4c51-5cf5-e01881d6f800/width=450/153856.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 1482,
                                    "hash": "UdL}1;t6NG-o~pjXWBbH_3t7t7RkOsWXofRk",
                                    "type": "image"
                                },
                                {
                                    "id": 153855,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e56a0403-cace-40bb-7ea7-7fe30c7f8e00/width=450/153855.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 1482,
                                    "hash": "UjLD_Wa#M|M|_NWCe.oe-;jsWBjZofoft6t7",
                                    "type": "image"
                                },
                                {
                                    "id": 154308,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1171564d-127c-4dc8-4809-3e74a3573f00/width=450/154308.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 1482,
                                    "hash": "UkJR~=kXR*V??GoJaebc~VWVjZWCx^WAogoJ",
                                    "type": "image"
                                },
                                {
                                    "id": 154307,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/674c8bd0-032c-47fe-4f9d-07d439069400/width=450/154307.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 1482,
                                    "hash": "UkMG^woeWAkC_3a}ofxa_NjtWBj?kDR*j[WC",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/15439"
                        },
                        {
                            "id": 15438,
                            "name": "old:Gacha Splash",
                            "index": 7,
                            "modelId": 13090,
                            "baseModel": "Other",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-02-26T02:09:48.444",
                            "availability": "Public",
                            "trainedWords": [
                                "[(white background:1.5)::5], (bottle bottom:0.9), 1 girl, mid shot, full body, "
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1750,
                                "ratingCount": 7,
                                "rating": 4.86,
                                "thumbsUpCount": 7,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 13236,
                                    "sizeKB": 73853.2412109375,
                                    "name": "Gacha Splash.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-26T02:11:16.417Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "C4E52628",
                                        "AutoV2": "F0A66F710E",
                                        "SHA256": "F0A66F710E574CB8E95FFC22DA9B7CE11B5E141620C5B77E6E22ACD604FBF66A",
                                        "CRC32": "3DC97F35",
                                        "BLAKE3": "F8CF5874B001B243E7B17D5628AA916F8AB71F36F60B6F1619F05855A9C280C9",
                                        "AutoV3": "9817FC26705F"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/15438",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 153830,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/df2ad670-620f-40c0-0863-d7ca8131c200/width=450/153830.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 1482,
                                    "hash": "UjK-zpW?WWNc?bo0jsn$~paej[t6%MkCa}Wr",
                                    "type": "image"
                                },
                                {
                                    "id": 153829,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5cfc8aaf-fb81-40da-5b8f-7690379aab00/width=450/153829.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 1482,
                                    "hash": "UhL;BLxZj[xu~qofazaz?vflayWCR-Rjj[Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 153828,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c310de2d-da50-4c51-5cf5-e01881d6f800/width=450/153828.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 1482,
                                    "hash": "UdL}1;t6NG-o~pjXWBbH_3t7t7RkOsWXofRk",
                                    "type": "image"
                                },
                                {
                                    "id": 153827,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e56a0403-cace-40bb-7ea7-7fe30c7f8e00/width=450/153827.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 1482,
                                    "hash": "UjLD_Wa#M|M|_NWCe.oe-;jsWBjZofoft6t7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/15438"
                        },
                        {
                            "id": 26536,
                            "name": "Gacha Splash 3.1",
                            "index": 8,
                            "modelId": 13090,
                            "baseModel": "Other",
                            "nsfwLevel": 3,
                            "description": "<p>Now supports male characters</p>",
                            "publishedAt": "2023-03-21T05:40:30.204",
                            "availability": "Public",
                            "trainedWords": [
                                "[(white background:1.5),::5] hexagon, 1girl/1boy, mid shot, full body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 13013,
                                "ratingCount": 2381,
                                "rating": 5,
                                "thumbsUpCount": 2382,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 21996,
                                    "sizeKB": 36990.34375,
                                    "name": "Gacha Splash 3.1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-21T05:41:30.060Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "AB0A3617",
                                        "AutoV2": "38D86A83C7",
                                        "SHA256": "38D86A83C789F6BD277003ED0D7DF979AEE1B1871260CF9A13DC8E56F2261480",
                                        "CRC32": "7DDD66F0",
                                        "BLAKE3": "52CC2289CEC061E2C6491E9A76141D0785F2428D59CE994007868F06B8843382",
                                        "AutoV3": "2CBC14C11C1B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/26536",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 292448,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e1b50fbc-dbea-4376-beae-8d08ed663900/width=450/292448.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UeH{KKWE_NxuRORjofkC?ZRPn$t7x]RjWAs:",
                                    "type": "image"
                                },
                                {
                                    "id": 292447,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ceb4c89a-8bcd-47a4-9eec-74f716a73c00/width=450/292447.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UcH.+-WB~qx]R4R-f,e-^*RPadogx]RPV@xu",
                                    "type": "image"
                                },
                                {
                                    "id": 292450,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aca83fb8-256f-43ef-54c8-de633de72400/width=450/292450.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UPJICNM|?w-:?IIp-;xt~VkBsSt5%hRjkCkC",
                                    "type": "image"
                                },
                                {
                                    "id": 292449,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bacc9c86-a1fe-4aaa-0ed9-e6a9cd63aa00/width=450/292449.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UWIi2tbc?^s-^,M{xus-~WoyMxof%NWCt7tR",
                                    "type": "image"
                                },
                                {
                                    "id": 292446,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8c82ae75-553b-4749-a836-6e123030e500/width=450/292446.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UvJ*h#R*WBxa%2aeflbH~qoft7oe%MW;Rjay",
                                    "type": "image"
                                },
                                {
                                    "id": 292445,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1c649b3a-2009-4c98-0c25-a4efec9a7500/width=450/292445.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UyJu4IWExuxt%MoLR*oM~qkCt6j?xuR+WBfk",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/26536"
                        }
                    ]
                },
                {
                    "id": 11177,
                    "name": "Anime Tarot Card Art Style LoRA (塔罗牌/タロットカード)",
                    "description": "<p>Trained on Phantom Star illustrations.</p><p>V3.1 updated. Improve consistency. Support for more varied backgrounds (use <code>{} background</code> to set). </p><p>V3.1 更新，提高稳定性。支持更多元的背景（使用<code>{} background</code>来设置）。</p><p>All examples are generated with Anything V4.5 &amp; orange-mix VAE. Recommend strength: 0.8~1.</p><p>所有样图均使用Anything V4.5 &amp; orangeminx VAE生成。推荐强度：0.8~1。</p><p>Recommend negative embeddings: <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7808/easynegative\">EasyNegative</a> and <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/16993/badhandv4-animeillustdiffusion\">badhandv4</a>.</p><p>推荐负面embedding：<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7808/easynegative\">EasyNegative</a>、<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/16993/badhandv4-animeillustdiffusion\">badhandv4</a>。</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 73260,
                        "favoriteCount": 0,
                        "thumbsUpCount": 12677,
                        "thumbsDownCount": 2,
                        "commentCount": 38,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 21
                    },
                    "creator": {
                        "username": "CyberAIchemist",
                        "image": "https://lh3.googleusercontent.com/a/AEdFTp7wdMG_twkGoSPl9QFSRrBhaXvnEmP_l69xiJbH6g=s96-c"
                    },
                    "tags": [
                        "anime",
                        "card",
                        "tarot",
                        "style",
                        "illustration",
                        "artstyle"
                    ],
                    "modelVersions": [
                        {
                            "id": 28609,
                            "name": "v3.1",
                            "index": 0,
                            "modelId": 11177,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Improve performance</p>",
                            "publishedAt": "2023-03-24T22:12:16.903",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 42429,
                                "ratingCount": 6171,
                                "rating": 5,
                                "thumbsUpCount": 7505,
                                "thumbsDownCount": 2
                            },
                            "files": [
                                {
                                    "id": 23644,
                                    "sizeKB": 36973.80078125,
                                    "name": "animetarotV51.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-24T22:16:16.907Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "FCA9C630",
                                        "AutoV2": "8A122035C8",
                                        "SHA256": "8A122035C8F93558B5B6DD7F09F0855DA0EA42C8D1DD0E72A83522BFAF23CBD9",
                                        "CRC32": "53535EDD",
                                        "BLAKE3": "2CD68144AD36BE788ADC569934DFCD13FB163555CD947E0F253D5E5548AC6998",
                                        "AutoV3": "F106864EF42A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/28609",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 322490,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/102cf8f7-9a88-45c3-776d-209a9e3e0700/width=450/322490.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UGJIa^M|9c-:_Nxv?HRjR;%gMwV[_MM|f,%L",
                                    "type": "image"
                                },
                                {
                                    "id": 322489,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/36a75dc0-2fa3-4009-a7d2-78d45df78900/width=450/322489.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UUJaZjay%gt7^+ays;f6~WofIoof-ps:M{WV",
                                    "type": "image"
                                },
                                {
                                    "id": 322488,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f6951406-2e6b-4195-bda0-668eec2cac00/width=450/322488.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "ULI4Itg3b^w{H?n%Vrf+~pj[%2of?HofM{V@",
                                    "type": "image"
                                },
                                {
                                    "id": 322487,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/42695bd6-bfc8-4c2a-af02-dfa0a92ac600/width=450/322487.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UPGS4Tt6o#WC~qofD%WC%gofIUay%MRkoIof",
                                    "type": "image"
                                },
                                {
                                    "id": 322486,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/29422e83-8c22-4fd8-4742-76dd394ee200/width=450/322486.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UIK1XcozT0en~WNGkr%2?FRjWB%M0L%MMxD*",
                                    "type": "image"
                                },
                                {
                                    "id": 322485,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/051455cb-055a-4476-ded8-7b7c3542f400/width=450/322485.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UIIOz+xu?vs:R+a{bboM?wkC%Lj[E1j]%2Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 322484,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c4d32ec2-f9ee-484c-91a3-a6e732fca700/width=450/322484.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UAJt^~ml.T9uTdOs?b$*_NkCE1%2IAZ#t6Xm",
                                    "type": "image"
                                },
                                {
                                    "id": 322517,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/09d54287-d84d-42de-63a3-026ad33e5600/width=450/322517.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UIF?Ln%M_3xuIURPIoWA_4R*MwaeD%ofRja#",
                                    "type": "image"
                                },
                                {
                                    "id": 322483,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f9230f97-9b0e-4e53-7454-dde7db41c900/width=450/322483.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UCLXMeM{0g_N0fxu%LRP_No}%2Vs-=RPV?tl",
                                    "type": "image"
                                },
                                {
                                    "id": 322482,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/df2a51db-2300-42b6-57d1-269dc2541f00/width=450/322482.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UMIOb0t7o~%3~Xn$%ModSwRjoIoe?cxaIVkC",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/28609"
                        },
                        {
                            "id": 28248,
                            "name": "v3.0",
                            "index": 1,
                            "modelId": 11177,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 31,
                            "description": "<p>V3.0 updated. Support for more varied backgrounds (use <code>{} background</code> to set). You can use it without any additional prompts, but if you want a more distinguishable border, use <code>border</code>. If you want the classical blue background, use <code>blue background</code>.</p>",
                            "publishedAt": "2023-03-24T06:16:39.064",
                            "availability": "Public",
                            "trainedWords": [
                                "tarot"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2063,
                                "ratingCount": 224,
                                "rating": 5,
                                "thumbsUpCount": 224,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 23340,
                                    "sizeKB": 36973.80078125,
                                    "name": "animetarotV41.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-24T06:20:39.330Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "1D380DA9",
                                        "AutoV2": "68FEA4368C",
                                        "SHA256": "68FEA4368C383C0812BD9620E44A27BB0DDAB925EEF674225EFA77887689F6B3",
                                        "CRC32": "065ECED2",
                                        "BLAKE3": "D721BF90E7378C66E0D54E43E71E42303B635647F45167573B452C811DB3BED3",
                                        "AutoV3": "D00F8B674F7B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/28248",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 317800,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/65c210fd-bcd6-4812-66d3-32beeebcd800/width=450/317800.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UTJ?:Pxarrxu~Cofxaof~BWp-We.%MR*V@oL",
                                    "type": "image"
                                },
                                {
                                    "id": 317798,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/37aadf72-4239-4b7a-fb29-584114bf8400/width=450/317798.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UCKnPT_3?^o}009FNGoz%#-;rXR54ntRs;sB",
                                    "type": "image"
                                },
                                {
                                    "id": 317797,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8ea7f139-b9cf-4086-77f4-315417185100/width=450/317797.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UdG[f+a#Rjxu%MofoJof~WbHoft6-;bHRjj[",
                                    "type": "image"
                                },
                                {
                                    "id": 317796,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2d52a02e-b9da-4482-f488-024aa8875900/width=450/317796.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UCF~5Gxu4:oJ9aWV-:fkEMWBxat7};oL9us.",
                                    "type": "image"
                                },
                                {
                                    "id": 317795,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b5b545a2-62ca-4013-0903-99fdb4631500/width=450/317795.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UQL;Hgs:~p?H%MRjIUxu%gIURjoz~qofNHIo",
                                    "type": "image"
                                },
                                {
                                    "id": 317816,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f79cfecb-b3f0-4635-b69c-99a33fb47200/width=450/317816.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UFLWqx~WR3-p=]$yRj~V?GjEENxvtQS%D%IU",
                                    "type": "image"
                                },
                                {
                                    "id": 317815,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/75e19af8-a30a-444a-0ccb-dbc6140f6900/width=450/317815.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "U7Ip3r0~F]jF2];30|E2zAk;IW?GOZ-q~V%M",
                                    "type": "image"
                                },
                                {
                                    "id": 317814,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/98613d1f-891b-4dc8-3de6-db3dbae5c900/width=450/317814.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UIHBlZt6E3o#_4t7M^WA~WRj9FRi%hNG-pxu",
                                    "type": "image"
                                },
                                {
                                    "id": 317813,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/326307f3-98a2-4f80-cdd2-c59a356f4c00/width=450/317813.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UGIO60~V^*I@wa=|~pWBI9%LR5R*9aMx9GM{",
                                    "type": "image"
                                },
                                {
                                    "id": 317812,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1b398cdc-6122-4c68-90a6-1c1305cadc00/width=450/317812.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UQJkM_kDkrxa~WNGf,t7X5RQ%2%M?bo0R+tR",
                                    "type": "image"
                                },
                                {
                                    "id": 317811,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d3df4df2-1913-4f80-d6f0-cb66cf715d00/width=450/317811.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UgNJE{s:NGxt?Hoe%LWV~9j@RjoLxZjuROoJ",
                                    "type": "image"
                                },
                                {
                                    "id": 317836,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/298745eb-2098-4d70-9be6-a524f814c000/width=450/317836.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UEKKpG%MpcbI?bozMxaK~qbFROaeo~ae_3oz",
                                    "type": "image"
                                },
                                {
                                    "id": 317835,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8ddcf363-3ccf-4556-9c02-7acf1e18ab00/width=450/317835.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UGH2D+%M_Nxu00M|9FxZ.9WBD%oLWVxa?HE3",
                                    "type": "image"
                                },
                                {
                                    "id": 317834,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1eb8289a-90a1-4f87-e99b-1de53f8e7a00/width=450/317834.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UIJ93w9uE#W=Kh-pM|f+_NNIWVS4E4RPRjM{",
                                    "type": "image"
                                },
                                {
                                    "id": 317833,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aa3cd014-c93a-466a-6ec5-4d15c307c300/width=450/317833.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UEGbl1%2Y6x^=|s.T0W?~qs.^+bbyER,Vrso",
                                    "type": "image"
                                },
                                {
                                    "id": 317832,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e62f0547-1d42-456f-5d57-008b06746600/width=450/317832.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "U9Ig.qlo00MyyXjI4mM{4ms;.8jY54smO@ae",
                                    "type": "image"
                                },
                                {
                                    "id": 317831,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/08085c90-6210-4e0a-6a66-319132e25c00/width=450/317831.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UBOo^*=|?b~W?HoM~W%M,r%MoING^*bI9ZM{",
                                    "type": "image"
                                },
                                {
                                    "id": 317830,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d13080da-798b-4585-155c-0f0d8ede9000/width=450/317830.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 576,
                                    "height": 1024,
                                    "hash": "ULMivh%NTe%1~Be.xERj$gn,x]bcx^s:WWRi",
                                    "type": "image"
                                },
                                {
                                    "id": 317829,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ec64093a-39b3-4b66-e97b-1133994c3700/width=450/317829.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UTOCQ^xuOr%M~Wsobbt7%gofxuozVtbvNHWW",
                                    "type": "image"
                                },
                                {
                                    "id": 317828,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/108b8aa4-df8e-42d8-b9f2-643d07527300/width=450/317828.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UYK1OKt7Iot7M{fQ%MoeNHoft7of~WayR+j[",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/28248"
                        },
                        {
                            "id": 19859,
                            "name": "v2.0 offset",
                            "index": 2,
                            "modelId": 11177,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 23,
                            "description": "<p>V2.0 updated. Normally, you can use it without trigger words. If you want to add more background elements or change the background color (you can set it by adding <code>{color} background</code>to your prompt), try lower the strength and using the trigger word <code>tarot</code>.</p>",
                            "publishedAt": "2023-03-07T14:28:57.855",
                            "availability": "Public",
                            "trainedWords": [
                                "tarot"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 22272,
                                "ratingCount": 3174,
                                "rating": 5,
                                "thumbsUpCount": 3175,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16569,
                                    "sizeKB": 13942.7490234375,
                                    "name": "animetarotV2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-07T14:40:53.919Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "3C70DE71",
                                        "AutoV2": "F9521DE433",
                                        "SHA256": "F9521DE4330BFD9900BE6AB864907427A1770DB039E5C149BDB419A83629CB0F",
                                        "CRC32": "3E28E211",
                                        "BLAKE3": "262D7167CF21875D596AE4F4DAC9CE48378BC37B23673B73A7D2A66482817E16",
                                        "AutoV3": "47D152524F6E"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/19859",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 209203,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c67ad417-c029-4956-eac7-a8261b35e100/width=450/209203.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UDLEf^%M0g%gT_oe-pt7_MRjIWjZN4M{v~ae",
                                    "type": "image"
                                },
                                {
                                    "id": 209186,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f15f7b43-e69f-45b8-259b-693ea8d0c900/width=450/209186.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UEK_I6~pyY4p_NR*-;^+%No#9ZWAXUW?xCIU",
                                    "type": "image"
                                },
                                {
                                    "id": 209202,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f779b144-a17e-4e91-c7e6-4d827aa08d00/width=450/209202.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "URLXV$t8WTR._NfQIoaebcoLkXxtx]kBs8t8",
                                    "type": "image"
                                },
                                {
                                    "id": 209169,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2569bc46-1de3-4b30-f97f-f643ba7ccb00/width=450/209169.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UCL4?8~VR-58pJt6={%L-:9FRj?bIU9G9Fod",
                                    "type": "image"
                                },
                                {
                                    "id": 209185,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1a32eec5-71f6-4e8b-dc0d-66fdb45a6900/width=450/209185.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UMK_5xt8.9%MM{j[kWoL?^ozR*Rj$*kC%LRj",
                                    "type": "image"
                                },
                                {
                                    "id": 209184,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b43840ad-8066-4d69-f28e-565c2717fb00/width=450/209184.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UJMa6Fxu.SM{~Uk9Ioxu?cj[E2%N%htRITIU",
                                    "type": "image"
                                },
                                {
                                    "id": 209183,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/520c99f8-384a-46ef-f9ee-0e64879c9e00/width=450/209183.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UEMa3Bv}F}Fz~q%LRkt7yDn$tmozEQs:VrWA",
                                    "type": "image"
                                },
                                {
                                    "id": 209182,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d6a928c-c4f7-4ed8-5566-8e8ea4575d00/width=450/209182.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UGL;gO~WXS9FFz9anh-pyYxZ?aoz%gxuwbRj",
                                    "type": "image"
                                },
                                {
                                    "id": 209170,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b7f324ef-3b1a-42e1-d3f4-dc5f6dc01400/width=450/209170.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UOI=Z3IUyD%M~qxuIon%_Nay%2WCD%oej[M{",
                                    "type": "image"
                                },
                                {
                                    "id": 209201,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ea524e0c-75f2-4f34-5e30-bb43e1b1f900/width=450/209201.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UHNK3Qoz0M-;Tfn%%1ax~qxuWXE1tStSr=%1",
                                    "type": "image"
                                },
                                {
                                    "id": 209260,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/09b22e7e-41aa-4818-9466-2f2fb4306900/width=450/209260.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UEN0*msoYR.8M|Rko#ofGGx[-9RP~qt6E2Io",
                                    "type": "image"
                                },
                                {
                                    "id": 209168,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b41fcee6-2a44-427e-dd24-858685459000/width=450/209168.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UFLEWu%L_N-;_4ofIUof?vRkROays:aykWa}",
                                    "type": "image"
                                },
                                {
                                    "id": 209199,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/15585245-a95c-497b-b59f-8bf61a97ad00/width=450/209199.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UKIr1{Rj*0E2VYIpx]-p?^bwxDxaJ6RixGoK",
                                    "type": "image"
                                },
                                {
                                    "id": 209167,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/181a1fd7-9690-49ca-d498-dbe64c1f3000/width=450/209167.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UBL4:2kXF2M|%NxtofM{_M%Mxvj?-SIo9tkC",
                                    "type": "image"
                                },
                                {
                                    "id": 209166,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0de0a725-fead-459e-bb09-710d55877800/width=450/209166.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UPLqLfxaEla~5qof%LfkogR*?Ha}~Vxuocoe",
                                    "type": "image"
                                },
                                {
                                    "id": 209198,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/768fd39d-cbfc-4218-1fc9-97e82c0f9d00/width=450/209198.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UDMaO.xulAE24nV@%gog.SjuRO%2~qxuITRP",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/19859"
                        },
                        {
                            "id": 13240,
                            "name": "v1.0",
                            "index": 3,
                            "modelId": 11177,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>Generate anime-like tarot card design. Recommend strenth: <strong>~0.8</strong>.</p><p>动漫风塔罗牌卡面设计，推荐强度<strong>0.8</strong>。</p>",
                            "publishedAt": "2023-02-20T19:52:28.501",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 6496,
                                "ratingCount": 1785,
                                "rating": 5,
                                "thumbsUpCount": 1788,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 11785,
                                    "sizeKB": 147572.2373046875,
                                    "name": "animetarot.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-20T19:56:35.213Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "68BC8A43",
                                        "AutoV2": "A16E50D8A6",
                                        "SHA256": "A16E50D8A68A66C7968FB2914DAEE19F2B919091CD86890ABF7B192EF0C456FB",
                                        "CRC32": "8A95306B",
                                        "BLAKE3": "76E6289BC17648D8914104F25B533F5F38CA197FE9F0840D6443D2B8EDAE8ED8",
                                        "AutoV3": "65D5701F6845"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/13240",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 127972,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b51f5bd1-c0e5-44ea-2ba3-9cc322de9000/width=450/127972.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UDIiLNkqBD%N%~RPIVR+~oxZ?Gt8IAX9azV@",
                                    "type": "image"
                                },
                                {
                                    "id": 127975,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cd3ce646-079f-419a-07b0-53a74344a000/width=450/127975.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UOGu|7fkcFt7%MofbboL_NWXRioeS#ofVsWB",
                                    "type": "image"
                                },
                                {
                                    "id": 127974,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/01524834-de40-4d4a-3025-ec7241963000/width=450/127974.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "UCGST0IAEk.8tRX8%M-p?wxZ$gIoXSRjIUIo",
                                    "type": "image"
                                },
                                {
                                    "id": 127973,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8e54ee21-0112-4981-7663-6011f54e5c00/width=450/127973.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1440,
                                    "height": 2560,
                                    "hash": "ULN17W%M%$%M~Bf6tRWBE3azs.R*-pofM{j[",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/13240"
                        }
                    ]
                },
                {
                    "id": 13941,
                    "name": "epi_noiseoffset",
                    "description": "<p><strong>UPDATE: v2-pynoise released, read the Version changes/notes</strong></p><p>LORA based on the <a target=\"_blank\" rel=\"ugc\" href=\"https://www.crosslabs.org//blog/diffusion-with-offset-noise\">Noise Offset post</a> for better contrast and darker images.</p><p></p><p>Weighting depends often on Sampler, kept it in the low-middle range (Maybe i will put up a stronger one).</p><p>Custom weighting is needed sometimes.</p><p>Works better if u use good keywords like: <code>dark studio, rim lighting, two tone lighting, dimly lit, low key</code> etc.</p><p></p><p>Didn't like the color saturation and image compositions from the <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/8765/theovercomer8s-contrast-fix-sd15sd21-768\">theovercomer8sContrastFix_sd15</a> so i made this one.</p><p></p><p>UPDATE: v2 is slightly stronger in the whole composition</p><p>Update 2: added safetensor file</p><p></p><p><strong><em>Quick Comparsion</em></strong></p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/af07d184-3f37-40bb-526e-a6cf9d41bf00/width=525/af07d184-3f37-40bb-526e-a6cf9d41bf00\" />",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 3,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 169853,
                        "favoriteCount": 0,
                        "thumbsUpCount": 11956,
                        "thumbsDownCount": 6,
                        "commentCount": 105,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 70
                    },
                    "creator": {
                        "username": "epinikion",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/529b3628-8929-4ef6-b63f-16d2999faa41/width=96/epinikion.jpeg"
                    },
                    "tags": [
                        "dark",
                        "noise offset",
                        "high contrast",
                        "tool"
                    ],
                    "modelVersions": [
                        {
                            "id": 16576,
                            "name": "v2",
                            "index": 0,
                            "modelId": 13941,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>bigger and <strong>a bit </strong>better</p>",
                            "publishedAt": "2023-02-28T09:16:23.924",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 155499,
                                "ratingCount": 1087,
                                "rating": 4.95,
                                "thumbsUpCount": 1404,
                                "thumbsDownCount": 5
                            },
                            "files": [
                                {
                                    "id": 13989,
                                    "sizeKB": 79736.4384765625,
                                    "name": "epi_noiseoffset2.pt",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-28T09:21:14.124Z",
                                    "metadata": {
                                        "format": "PickleTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "5E1481B8",
                                        "AutoV2": "3775AAD8A0",
                                        "SHA256": "3775AAD8A02DC5CA4E411F812B9B68B7539DB2A4074B0577CE9B033B5779C0B1",
                                        "CRC32": "CCB599BE",
                                        "BLAKE3": "A98700D41202C0DAAEBDA6A136E08DDEE1DA55DB1C62E350A464AD8904B4F9AE"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/16576?type=Model&format=PickleTensor&size=full&fp=fp16"
                                },
                                {
                                    "id": 14333,
                                    "sizeKB": 79570.1171875,
                                    "name": "epi_noiseoffset2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-01T09:12:53.453Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "2B07E97F",
                                        "AutoV2": "81680C064E",
                                        "SHA256": "81680C064E9F50DFCC11EC5E25DA1832F523EC84AFD544F372C7786F3DDCBBAC",
                                        "CRC32": "75D88A54",
                                        "BLAKE3": "65DC209E97D0D703FD0414A09344662077BDBA32A9354EFECC71D011C4861035",
                                        "AutoV3": "D1131F7207D6"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/16576",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 167154,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1068e7d8-e7ed-49a9-ae61-ae7e7cbb0f00/width=450/167154.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UA84b?El0f~V%LShNb$%9axZ-VE2Mxs9n%Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 178275,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/22f5f5b4-d106-4019-32f3-ed3d64ac1800/width=450/178275.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAAvXk02o~rqr]bFNHxZ03~ARPozELxaxFNH",
                                    "type": "image"
                                },
                                {
                                    "id": 167153,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bd17d3db-aa7a-429f-8b87-7063f0615000/width=450/167153.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFDu#t~BR$s,?H={E2I;5Q9wIVaK0fIp-pof",
                                    "type": "image"
                                },
                                {
                                    "id": 167152,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/11466716-a836-4772-7f10-be3e382bb700/width=450/167152.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UOD+rk~W%$o{xIxb={xCITOEV?xubYrqo}W?",
                                    "type": "image"
                                },
                                {
                                    "id": 178281,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b35e93dd-c8c3-4e6c-88ba-87f5aac11500/width=450/178281.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UA7Un|00R%-=_N9Fn#xvs:NGxZkC%2IUt7tR",
                                    "type": "image"
                                },
                                {
                                    "id": 178280,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dbc8b8b2-a489-46be-501e-5fd423ca3c00/width=450/178280.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U67BG$~qIU4no~tRIUDjIoM{-p-:4nIVtR%M",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/16576"
                        },
                        {
                            "id": 18445,
                            "name": "v2-pynoise",
                            "index": 1,
                            "modelId": 13941,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>I found an <a target=\"_blank\" rel=\"ugc\" href=\"https://wandb.ai/johnowhitaker/multires_noise/reports/Multi-Resolution-Noise-for-Diffusion-Model-Training--VmlldzozNjYyOTU2\">article </a>of @<a target=\"_blank\" rel=\"ugc\" href=\"https://twitter.com/johnowhitaker\">johnowhitaker</a> for another noise offset method called \"pyramid noise\" - gave it a shot. It's very subtle and starts to kick in at a weighting at 2-3, because i had a settings error, so the outcome wasn't as i thought it was. At least the bleeding on high weights are now almost gone, therefore its loses much saturation i guess. Just play around.<br /><br /><em>If u use Additional Networks u have to push the Max Limit in the config file over 2 to get more depth.</em></p>",
                            "publishedAt": "2023-03-04T11:52:07.028",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 12151,
                                "ratingCount": 8401,
                                "rating": 5,
                                "thumbsUpCount": 10627,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 47043,
                                    "sizeKB": 20120.0634765625,
                                    "name": "epiNoiseoffset_v2-pynoise.pt",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-10T14:40:50.079Z",
                                    "metadata": {
                                        "format": "PickleTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "428E17CC",
                                        "AutoV2": "B32C5D0601",
                                        "SHA256": "B32C5D0601393BA371C62B9785722F8367F86A3698AA5910DA0707EC4A10622D",
                                        "CRC32": "D0283425",
                                        "BLAKE3": "09E7F0CECF66E2BA28EAB1A0328754C5607E44737E253540E45F07FD6CE06600"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/18445?type=Model&format=PickleTensor"
                                },
                                {
                                    "id": 47045,
                                    "sizeKB": 19954.10546875,
                                    "name": "epiNoiseoffset_v2-pynoise.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-10T14:45:47.276Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "971249D7",
                                        "AutoV2": "895A889FEE",
                                        "SHA256": "895A889FEE57E41C111EDD53A58E5F2512B2264D288D68C6B7E57230C33F2460",
                                        "CRC32": "DB436134",
                                        "BLAKE3": "469F7F8A0F64B264BFE0F490011421C997332E96D4132C40B29D0E83923A5E1A",
                                        "AutoV3": "DA15901CDF16"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/18445",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 190326,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5a7a9f62-93e3-4431-c0ee-07bce869f800/width=450/190326.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UC9Gp-E20f~V-VR+Naxa9ZxZ%1E2IooeniRk",
                                    "type": "image"
                                },
                                {
                                    "id": 190325,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3ae2102d-1117-4677-e42c-7575d85d6400/width=450/190325.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8CrQ5021h^OR-f6NGxt02~AwII;NZxt$*E2",
                                    "type": "image"
                                },
                                {
                                    "id": 190324,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b8b9eaee-c42e-4111-2f64-b2a0a0055400/width=450/190324.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UACYt4~B9[xt-o-oNGE25R9uIoxZ0LS3?GWB",
                                    "type": "image"
                                },
                                {
                                    "id": 190323,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3dc7c637-0800-4740-dc00-29bafd62e600/width=450/190323.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UREVNo~W.8tkxc%3-VxaInW:Rixtt6s9ozfl",
                                    "type": "image"
                                },
                                {
                                    "id": 190322,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dda5ce6c-f508-4361-9719-5f5bf5dc5600/width=450/190322.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJB3]A4nWA-;~q9FM{%M%MRjM{t7ofofRjaz",
                                    "type": "image"
                                },
                                {
                                    "id": 190321,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ae0b56fd-19d6-4143-82bc-81be42380200/width=450/190321.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U36kO^~q4.0K%Nxu0K9F9tM{^*-o01IU-p-;",
                                    "type": "image"
                                },
                                {
                                    "id": 190327,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f0648486-cfd8-4e5d-ce99-e19958f68d00/width=450/190327.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2048,
                                    "height": 895,
                                    "hash": "UhE33dxukCkC~qj@jZj[_3WBjsjt_3ayayj[",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/18445"
                        },
                        {
                            "id": 16407,
                            "name": "v1",
                            "index": 2,
                            "modelId": 13941,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-02-27T23:38:11.347",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2203,
                                "ratingCount": 64,
                                "rating": 5,
                                "thumbsUpCount": 69,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 13889,
                                    "sizeKB": 39992.1259765625,
                                    "name": "epi_noiseoffset.pt",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-27T23:41:15.551Z",
                                    "metadata": {
                                        "format": "PickleTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "8BD97D5B",
                                        "AutoV2": "EC8D4B39B5",
                                        "SHA256": "EC8D4B39B5F74ED12171173D01FA0955F98B9C5EA9729F3D530DBD456369722F",
                                        "CRC32": "9E27ADC2",
                                        "BLAKE3": "4B7DFA3F28204989BF1F75CD546796F93FEBEC6E8124CE34EEFACB88CB646366"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/16407",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 165569,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ded8e577-8b8d-48fd-4439-7064cdfc1a00/width=450/165569.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UA8NtjAb0g~V%LShSNxZ4.$$-VD*M_s9enRj",
                                    "type": "image"
                                },
                                {
                                    "id": 165568,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f6a5f4d-58bf-430b-f84c-a9facdd5c600/width=450/165568.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHELW,~BR$t6?H={IoIq9a9vIVae0fI:=|oe",
                                    "type": "image"
                                },
                                {
                                    "id": 165567,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dfb2f1bf-cdb6-4610-01a7-4d6910f1b100/width=450/165567.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UKEVEV~V?H%LxIKi-:ozJPNFs:%MRjoMNb$k",
                                    "type": "image"
                                },
                                {
                                    "id": 165566,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b44beee0-241e-41e0-3ade-d0e6995c5d00/width=450/165566.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UG8O6s4nV@-=_NDiad%M%MM{n$xuxaRjayxu",
                                    "type": "image"
                                },
                                {
                                    "id": 165565,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04a845fb-ce62-458e-959f-028da1fb5a00/width=450/165565.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U56[2E~pD%4nx^tR4:9GIURP?G-p0LIU%M-;",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/16407"
                        }
                    ]
                },
                {
                    "id": 73756,
                    "name": "3D rendering style",
                    "description": "<p><span style=\"color:rgb(193, 194, 197)\">If there is no problem with your test, please upload a picture, thank you！That's important to me~欢迎返图、一键三连，这对我很重要~</span><strong><span style=\"color:rgb(253, 126, 20)\">If possible, don't forget to order 5 stars⭐️⭐️⭐️⭐️⭐️ and 1 like❤️ ^_^ Please~</span></strong></p><p><strong><span style=\"color:rgb(253, 126, 20)\">如果搬运模型，请联系并注明作者~（Draft等网站要点脸行不行）</span></strong></p><h3 id=\"heading-17\"><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/images/1348087?period=Year&amp;periodMode=published&amp;sort=Newest&amp;view=categories&amp;modelVersionId=107366&amp;modelId=73756&amp;postId=347931\"><span style=\"color:rgb(76, 110, 245)\">The larger the version number, the more mature and realistic the rendering style will be. You can choose to download according to your needs(V5 V7 V10 V11 V12↓)</span><u><span style=\"color:rgb(76, 110, 245)\">check it</span></u></a></h3><p><img src=\"https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bb5ffe22-7839-4f12-b211-7675f9a77e57/width=525/bb5ffe22-7839-4f12-b211-7675f9a77e57.jpeg\" /></p><p>别忘了切换模型版本下载~~<strong><span style=\"color:rgb(253, 126, 20)\">Recommend </span></strong><span style=\"color:rgb(253, 126, 20)\">Can switch model versions for download ↑</span></p><p>试试用这些大模型生成图片try use <strong>ReV Animated</strong></p><p><strong><span style=\"color:rgb(253, 126, 20)\">范例使用了</span></strong><em><span style=\"color:rgb(253, 126, 20)\">Additional Networks</span></em><span style=\"color:rgb(253, 126, 20)\">插件来调用LoRA</span></p><p>试试这些提示词 try prompt like this：</p><p>1girl,Look straight ahead, long hair, Straight hair, a dark room with lights, close-up shot, Street Background, masterpiece, best quality,3dmm style,3d,realistic, high-quality, 3D realistic works, ultra-high details, 4k, real skin materials,simple background,</p><p>Negative prompt: tattooing,lowres, bad anatomy, bad hands, text, error, missing fingers, extra digit, fewer digits, cropped, worst quality, low quality, normal quality, jpeg artifacts, signature, watermark, username, blurry,braid hair</p><p>~~~~~~~~~~~~~~~~~~~~~~~o(*￣︶￣*)o~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~</p><p></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 3,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 143367,
                        "favoriteCount": 0,
                        "thumbsUpCount": 11360,
                        "thumbsDownCount": 1,
                        "commentCount": 55,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 172
                    },
                    "creator": {
                        "username": "LONGD",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/88499e54-c90c-4a6a-c642-42d398bb8f00/width=96/LONGD.jpeg"
                    },
                    "tags": [
                        "anime",
                        "3d",
                        "midjourney",
                        "female",
                        "cg",
                        "niji",
                        "style",
                        "girls",
                        "cute girl",
                        "3d style"
                    ],
                    "modelVersions": [
                        {
                            "id": 107366,
                            "name": "3DMM_V12",
                            "index": 0,
                            "modelId": 73756,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2023-06-30T15:20:46.608",
                            "availability": "Public",
                            "trainedWords": [
                                "3DMM"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 79978,
                                "ratingCount": 3788,
                                "rating": 5,
                                "thumbsUpCount": 6489,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 75626,
                                    "sizeKB": 36973.8046875,
                                    "name": "3DMM_V12.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-30T15:15:41.107Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "3E371480",
                                        "AutoV2": "8A419D0AA6",
                                        "SHA256": "8A419D0AA649BF496A6182E34C67FCF45E85ADEEADD26831D5537409F10DB88A",
                                        "CRC32": "259D9D0A",
                                        "BLAKE3": "FFE2891677A145F546685BD57693626B2DBFE79419B197DF3632296E65CA5027",
                                        "AutoV3": "7D5C705F0FF8"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/107366",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1347968,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/24c1812a-e535-43bb-8607-54fab869cfda/width=450/1347968.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEBoUZRj9Y=|}^EM0xt7S4s.WTocEOxFt0R%",
                                    "type": "image"
                                },
                                {
                                    "id": 1347977,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3eebaa84-da67-4ef1-9c9a-c85837104fed/width=450/1347977.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 792,
                                    "height": 1184,
                                    "hash": "U7Cs:aeT0KH=K7I;00%N_4?bv|9F0fDiz:%g",
                                    "type": "image"
                                },
                                {
                                    "id": 1347973,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f7753a3c-e979-4de4-8f28-045cfff63a59/width=450/1347973.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U7DSRItiOTE2~p^k5QRl00-:^*niXmtR-UE1",
                                    "type": "image"
                                },
                                {
                                    "id": 1348011,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/30e4df3e-0c5c-4281-87a7-bc405afdbec6/width=450/1348011.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UWF}i?~BtR%M~V-:S~xut6xuSLaeWBjao1ay",
                                    "type": "image"
                                },
                                {
                                    "id": 1347984,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b9cbaedc-051b-4b26-aa6b-f90d51e5b689/width=450/1347984.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UUDbsU-:ELjb~B?GSMM|%1%2bbRQxuj@Rjay",
                                    "type": "image"
                                },
                                {
                                    "id": 1347993,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ec1c92e0-fb82-4cae-9b14-8b049e1f5454/width=450/1347993.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U18W%M,8005v~B~E0000v_IBE7.800oO~WIR",
                                    "type": "image"
                                },
                                {
                                    "id": 1347983,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9e5b4b61-3be2-4b6a-9a8d-5901ed2fcc60/width=450/1347983.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U6ATAx4.01~Bodja9Zxv02%MxY9aS~IV-U-p",
                                    "type": "image"
                                },
                                {
                                    "id": 1348000,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/01bdd017-34ea-47f8-91e5-eb1fab76181d/width=450/1348000.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U4A]y.~C0000#]V[0Jx[00Io-j^*_3?I-70K",
                                    "type": "image"
                                },
                                {
                                    "id": 1348013,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6ab36585-1494-4a31-bebd-378c4dd4e132/width=450/1348013.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U9DSdt5800~B?c-:4nE19]nhVrM|oyRj$%f+",
                                    "type": "image"
                                },
                                {
                                    "id": 1348017,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9fc05c35-65ab-4146-9f17-a5ea04d068dc/width=450/1348017.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAD8wc$%X20g~A^P9uEM0yNdMzNH0yt7rt$j",
                                    "type": "image"
                                },
                                {
                                    "id": 1348031,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/adda28dd-4d76-403c-b5fe-c7fdec4323cd/width=450/1348031.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UKGRo6MeKgAG_4r?9stltTn+NZW;-=xZ%MIo",
                                    "type": "image"
                                },
                                {
                                    "id": 1348018,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/61197a2c-16e2-4002-a44b-139445acd2f9/width=450/1348018.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U5DbysPU009EDND%t-^+00-p~V4.Otx];{EL",
                                    "type": "image"
                                },
                                {
                                    "id": 1348008,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0a09e641-4b9f-4037-8878-a6c6922b4e42/width=450/1348008.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UJFrVDE10Kxu00xaxujZ9at7-VM|~qRjnit7",
                                    "type": "image"
                                },
                                {
                                    "id": 1354033,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0038e0a9-7543-482b-93bd-e855d2389028/width=450/1354033.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U5B{7g171R%4.kNIDi$f0f,.-U,:DPXm~COY",
                                    "type": "image"
                                },
                                {
                                    "id": 1347967,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4495c838-7372-4ce6-86d1-c4bed9fe38b1/width=450/1347967.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U7BC=QIV01~BRo%3-oNG00xa~AE2kqoIWBIo",
                                    "type": "image"
                                },
                                {
                                    "id": 1347982,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/420bb1f4-f167-43cc-88f9-c7e72d6e7c09/width=450/1347982.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U5C5^z^J00~Ds=9]56=|56w]^jE201xu~C4:",
                                    "type": "image"
                                },
                                {
                                    "id": 1348033,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fd76ffc6-21ee-4c09-b36d-6be75e5ad271/width=450/1348033.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGH21gcG9E-pI94.X8xa%M-;o#k8~qoM9Ft6",
                                    "type": "image"
                                },
                                {
                                    "id": 1348087,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dea02d01-b6d8-4ca2-a05f-494b8f250cb1/width=450/1348087.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 4727,
                                    "height": 1345,
                                    "hash": "UeDvcxaejZof_NWBf6of?bWBayj[_2WCj[j[",
                                    "type": "image"
                                },
                                {
                                    "id": 1348093,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2000261d-bc0b-4032-b86a-93493bd20c41/width=450/1348093.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8A9sV=_01R+={t6579t9uIpxat757j[~B-V",
                                    "type": "image"
                                },
                                {
                                    "id": 1348098,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4828ef7a-b16f-428f-8c2f-7851e4893dca/width=450/1348098.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U6HKqb0n00}kH;$10MXU*I_3a4E2004n9b~V",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/107366"
                        },
                        {
                            "id": 96573,
                            "name": "3DMM_V11",
                            "index": 1,
                            "modelId": 73756,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>The larger the version number, the more mature and realistic the rendering style tends to be. The smaller the version number, the more cartoonish the style is</p>",
                            "publishedAt": "2023-06-15T13:59:48.962",
                            "availability": "Public",
                            "trainedWords": [
                                "3DMM"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 20446,
                                "ratingCount": 1832,
                                "rating": 5,
                                "thumbsUpCount": 1838,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 67066,
                                    "sizeKB": 36973.8046875,
                                    "name": "3DMM_V11.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-15T13:46:26.591Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "6D250A1C",
                                        "AutoV2": "30747A486B",
                                        "SHA256": "30747A486BD7448EC54A4F502A4E562E11F233DB518FF13FDE6144954A076926",
                                        "CRC32": "70707E96",
                                        "BLAKE3": "7B94C9DA2444875DB8C05B8FC4F65891D8D8EFA2DDFEF9E130A98A50D4C60E42",
                                        "AutoV3": "41A1E60595B6"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/96573",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1153918,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e8e22c90-2f5a-40b9-9d0a-32f2de0972d8/width=450/1153918.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDE3Yh0000GcCT-n8_-5t+O[:$Ip3F+ZMx-:",
                                    "type": "image"
                                },
                                {
                                    "id": 1153921,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/11e660c3-0fc4-442f-923d-2e8cdc9ab33d/width=450/1153921.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8C?Gn56t2xY?a?GKJxt00~V=_RkyCoz,XIp",
                                    "type": "image"
                                },
                                {
                                    "id": 1153906,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3c837802-faad-4171-8c38-a66acd1beb0d/width=450/1153906.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UQCrNkNF9tn,}^oL9sa#kC$+I-S1NdoMR~WU",
                                    "type": "image"
                                },
                                {
                                    "id": 1153912,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b865f594-16c3-490a-8d1c-edd9d17ae688/width=450/1153912.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCELyy9w01%1~W%14.Mxb_^*8{M{x[kDv}9a",
                                    "type": "image"
                                },
                                {
                                    "id": 1153905,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d86d3a49-8a1f-4e7c-91bf-6d09800bed96/width=450/1153905.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "ULG7[B}@0eOs^5^*pII:%1%2xunitlNGIUxa",
                                    "type": "image"
                                },
                                {
                                    "id": 1153904,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e95b64c5-0d07-4505-870a-8120b01b5b06/width=450/1153904.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UFC~#r_30c9FH_IUEJtQ9es;feR$_4%NsQM^",
                                    "type": "image"
                                },
                                {
                                    "id": 1153908,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/25988c0b-bc0b-46d6-811c-a28d5495a49e/width=450/1153908.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UIHmJ_}t0foz~CxaE1s:J6EfNZ%1xFNGW;S#",
                                    "type": "image"
                                },
                                {
                                    "id": 1153920,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d55a44f0-c554-448c-9284-baf6e788204e/width=450/1153920.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UUGaUnIrEK9u}:xWItR.X2t6Rn$f$*NGNZxt",
                                    "type": "image"
                                },
                                {
                                    "id": 1153919,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/67c30a6b-f498-4103-917f-7dbc7c596cf6/width=450/1153919.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCFYAS~B000f00E1%L?a0eE2$gxGcE%f-UMx",
                                    "type": "image"
                                },
                                {
                                    "id": 1153932,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bfec4151-1fd3-4ba4-873f-01ab3f9386d6/width=450/1153932.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULELBJbp0dxt}[bY9@xZWFkBaesq-CR*I:ah",
                                    "type": "image"
                                },
                                {
                                    "id": 1153895,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d983c83c-2d35-42ae-905a-74184ef0617d/width=450/1153895.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U3AvVH}u0001^d%N0J9[53%4bF0cEgEcI*$l",
                                    "type": "image"
                                },
                                {
                                    "id": 1153900,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3846f311-6020-4232-962e-3d32a0846fff/width=450/1153900.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UVFrCjM{9tkC4ot6t7WBM{oyw^n%~WM|WBt6",
                                    "type": "image"
                                },
                                {
                                    "id": 1153899,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7ef327a1-6595-4135-9cb7-3f71cf619667/width=450/1153899.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U7CP6G^j01-p9Ha|NFWC-,t4sDM|02Nb~BWA",
                                    "type": "image"
                                },
                                {
                                    "id": 1153934,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c6316de2-026d-4e7b-9bb7-be13df45ac2f/width=450/1153934.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U28zlfH]00qD:O^*0L0L_MI.rEV@00tR-B$Q",
                                    "type": "image"
                                },
                                {
                                    "id": 1153901,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/55fbac85-ac52-4130-b9f3-7a9fd7ce58b2/width=450/1153901.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U6CryOxs009v175SV=slEd^iw|WE01NH~B=|",
                                    "type": "image"
                                },
                                {
                                    "id": 1153902,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ecd12078-ab05-45b4-add6-972d42dc8912/width=450/1153902.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U5B3Wzvz00%Lt8R-4:xu00t8R.D*OX9awc~V",
                                    "type": "image"
                                },
                                {
                                    "id": 1153935,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/59c42bbc-7c85-4726-ae6b-993910dfba0a/width=450/1153935.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEATm5Z~0KxvPXwurWS$6AV?,AkXo~WAn3R+",
                                    "type": "image"
                                },
                                {
                                    "id": 1154991,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/abd6490d-3a49-441e-8cee-96b133086cf5/width=450/1154991.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "URIXHnS~9FD*RjIB_2oL?HNHtRWA~VofM|RQ",
                                    "type": "image"
                                },
                                {
                                    "id": 1155016,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4c766f6e-383c-4024-ab07-155ce176d275/width=450/1155016.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9HB#v_400D%0000SixZPV%grrM{00%M%KM{",
                                    "type": "image"
                                },
                                {
                                    "id": 1155018,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/efa83a7b-f4c9-4c3d-8c34-b8cbe0584f0a/width=450/1155018.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBDI@4tS00kD:NIU0exZO_tRjDWC4ms:_3Io",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/96573"
                        },
                        {
                            "id": 78467,
                            "name": "3DMM_V10",
                            "index": 2,
                            "modelId": 73756,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-05-23T04:23:35.666",
                            "availability": "Public",
                            "trainedWords": [
                                "3DMM"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 11312,
                                "ratingCount": 72,
                                "rating": 5,
                                "thumbsUpCount": 73,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 53955,
                                    "sizeKB": 36981.140625,
                                    "name": "3DMM_V10.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-23T04:26:17.918Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "31BCB3A1",
                                        "AutoV2": "24BB0DF0AB",
                                        "SHA256": "24BB0DF0AB3D2F2C673B671E9C358ABD358372D910446014B1DADB1F9752D866",
                                        "CRC32": "536B419C",
                                        "BLAKE3": "B0B332C56105331E5FC1F18E9C5DB5D890685DB1BC859B4319F62F6F82F4645A",
                                        "AutoV3": "961067567E34"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/78467",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 879906,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ff68edff-19fb-4719-9264-b5c375a299ff/width=450/879906.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 696,
                                    "hash": "UcJt#bs;?wxtg4t7jYRj%Mj[f6WVx]a}MyjY",
                                    "type": "image"
                                },
                                {
                                    "id": 893571,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/30885e74-a8e5-4c46-b597-21f271d5250c/width=450/893571.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 640,
                                    "hash": "U7EUu;9c0eT_%%$~4.V@_3=|01Sw.mEjq[-C",
                                    "type": "image"
                                },
                                {
                                    "id": 891316,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/41c23df9-7d26-46d9-b151-2eaff645785c/width=450/891316.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 640,
                                    "hash": "UBFhSA~C00VsD*9aNG-:F2?G-U9a0eNZoy9G",
                                    "type": "image"
                                },
                                {
                                    "id": 891314,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8f0e0387-6548-4140-8ef1-1c8cf5d2e8ab/width=450/891314.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 640,
                                    "hash": "UBE{eG0f00ElI]MxxTo}_NI9MI$gROV@9u?H",
                                    "type": "image"
                                },
                                {
                                    "id": 891324,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9b4f3ea5-9264-4351-a4c1-ee1e1ad02916/width=450/891324.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 640,
                                    "hash": "UBEVmV9b00%#ibr@57-;-:n$DhxA?wV@MctR",
                                    "type": "image"
                                },
                                {
                                    "id": 879905,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3d609a9c-c7d7-4aa7-afd9-75fcfefe49ec/width=450/879905.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 696,
                                    "hash": "UCHn?It7*0%M00xaM{Iox]R+E0xZ%MM{MxR+",
                                    "type": "image"
                                },
                                {
                                    "id": 891322,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ff29dbb6-fd73-47d9-b564-df589645b952/width=450/891322.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 640,
                                    "hash": "UIH_x[AE.S#l9waeITX9Text=xWB~qadR$V_",
                                    "type": "image"
                                },
                                {
                                    "id": 2174258,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5742fd4b-5417-44bb-84ad-d6dc732d0ea6/width=450/2174258.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCFYr=-pI=SP03tRs*bv.TIUvexFtRt6?Gs9",
                                    "type": "image"
                                },
                                {
                                    "id": 2174261,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/988c82f5-72ee-4bd1-be32-447acea89f0b/width=450/2174261.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UABWuo-n00NL?w$zDiN{E+M{vyo#5lW;#kV?",
                                    "type": "image"
                                },
                                {
                                    "id": 2174257,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c922fe28-a1f5-4ae5-ae3e-7107c746dbbc/width=450/2174257.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UFDIta-;0KIUt8xan}NH^Q-oIoE2~W%2M{E2",
                                    "type": "image"
                                },
                                {
                                    "id": 2174259,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d4690f93-4f19-4397-9294-3848b95daffc/width=450/2174259.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8DufDs.00r@}It75PWC9Z9t%1xuX,xtr@Io",
                                    "type": "image"
                                },
                                {
                                    "id": 2174260,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/63d3efbc-4c6d-4d00-8a61-2215a575e383/width=450/2174260.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U4FY$81600}?D4$*00_2QkXn?vivpwT08w$L",
                                    "type": "image"
                                },
                                {
                                    "id": 2174262,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/605398fa-7fce-41cf-9a01-e0f60c35cde3/width=450/2174262.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U68qKl%M00I;yZs:I8X9EhM_rVt89]NG-6xu",
                                    "type": "image"
                                },
                                {
                                    "id": 2174263,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ee438b78-df3c-48c3-959a-7d6dee08341d/width=450/2174263.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8GIZV~A0001x]kWD$%300I;s,%2?a?bt7Mw",
                                    "type": "image"
                                },
                                {
                                    "id": 2174271,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b3a4a460-dec8-4178-970e-858f32905979/width=450/2174271.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UABp2_wID$a$?wRiD%NyTJIorro#%#IoM{xb",
                                    "type": "image"
                                },
                                {
                                    "id": 2174269,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad537101-e4be-4256-8c14-87c8b8ad899f/width=450/2174269.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UVJRK,-p?uRkIUoexua}~qV@%MoztlxvniRj",
                                    "type": "image"
                                },
                                {
                                    "id": 2174267,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d2488f5c-fa29-405d-b45f-168c41761e1a/width=450/2174267.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U59jDznN0eW-~EELE1EKE2I-ogNF9uoZ=|M{",
                                    "type": "image"
                                },
                                {
                                    "id": 2174270,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3d46cc39-09a7-4c52-b264-50c3c71e3f4b/width=450/2174270.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "ULMjBxEl_N-;?HR*E1t6OqtQ%gjFXlRPsmtR",
                                    "type": "image"
                                },
                                {
                                    "id": 2174268,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b3a48fe8-5251-48e7-b6d7-4beb21a57af3/width=450/2174268.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UKG8p1-q.TTKD*x]D*Rj=v%3M_%M%gRjxujb",
                                    "type": "image"
                                },
                                {
                                    "id": 879896,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0e374d3a-5fba-4d52-8bd7-fd2cd0f2123c/width=450/879896.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 696,
                                    "hash": "UEHeLM4n%#Iobdxv?ut8~p%2-ps:E*bbDit7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/78467"
                        },
                        {
                            "id": 88206,
                            "name": "3DMM_V7",
                            "index": 3,
                            "modelId": 73756,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-06-03T06:26:04.825",
                            "availability": "Public",
                            "trainedWords": [
                                "3DMM"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 17114,
                                "ratingCount": 1689,
                                "rating": 5,
                                "thumbsUpCount": 1691,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 60475,
                                    "sizeKB": 36973.8046875,
                                    "name": "3DMM_V7.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-03T06:20:54.401Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "688097CD",
                                        "AutoV2": "357975D7D2",
                                        "SHA256": "357975D7D27A69FBE571D7BB113A5DFD0D8E0D2F611CD2B22F6C9F59644F3353",
                                        "CRC32": "17D5CCD6",
                                        "BLAKE3": "07CB82C1B3E55295CC73844987ED7B71A10706A6BECDBBFB57EA524CB0E10521",
                                        "AutoV3": "5A479C75E1CA"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/88206",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1014276,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/82b53c83-63f9-4c61-82a3-5f01f9eba3e8/width=450/1014276.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9CGJiaj2wIU:5NZ4nx[};nP9uE1Tdt,xvaK",
                                    "type": "image"
                                },
                                {
                                    "id": 1013925,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/79b1fd1d-21da-4495-969d-2885d6a3ea7d/width=450/1013925.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9C?A+0L00~WvZ?bEu9ZD;ocs~WE.R9ZR4?a",
                                    "type": "image"
                                },
                                {
                                    "id": 1013921,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5f495ab4-db15-475f-bc7c-972c4b480d1f/width=450/1013921.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCGG|fo$0L=GIp}t5R9[o%S0E09uI:I=xXI:",
                                    "type": "image"
                                },
                                {
                                    "id": 1013917,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cf540015-f02f-4344-bcbe-df6651caa59b/width=450/1013917.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1000,
                                    "hash": "U7EMF1D%00~B00?b-44oKRjZ?us:Z2tRMxD%",
                                    "type": "image"
                                },
                                {
                                    "id": 1029052,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/559efff7-4d33-4cbb-a5b1-d2acdf2103b8/width=450/1029052.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCC$f$~W0eW=4UIUoIof9aRi-BM|.8xv$*$*",
                                    "type": "image"
                                },
                                {
                                    "id": 1013922,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/05921eb6-666b-4a19-ab0e-bae75fe728dc/width=450/1013922.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7DR?5}n5R0LI=-o9Zo#005SM{-p}@4:-qIT",
                                    "type": "image"
                                },
                                {
                                    "id": 1014012,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b2b078c2-a525-486a-a389-9ff6c0efa633/width=450/1014012.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJDR]A-T0gE2};xZ5SNbEMNIadoINfNHaxoc",
                                    "type": "image"
                                },
                                {
                                    "id": 1013916,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d74c3bae-dbde-4afb-abc2-2f8312a84541/width=450/1013916.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1000,
                                    "hash": "U7C?4S~X?u-rJVa#%1-o00IT00E1E1RjD%9a",
                                    "type": "image"
                                },
                                {
                                    "id": 1013929,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/376d97a1-31b8-41f3-b976-c3f7f1b2a6c7/width=450/1013929.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8C$$R}l005r.SrqDOEj0etR$eIV[S.8XAVX",
                                    "type": "image"
                                },
                                {
                                    "id": 1013924,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a23a24fa-3fd7-494d-a0da-d6a05cfcad05/width=450/1013924.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBG%yR5k00^R0~jYaHs;9v%2RzIo}^kB9rae",
                                    "type": "image"
                                },
                                {
                                    "id": 1013918,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dc5f51f3-f08c-4879-9cdb-803b6edd92d3/width=450/1013918.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1000,
                                    "hash": "UBCidf.T4.D*.9?H9uE2D%Io-p-oE2RPoIt6",
                                    "type": "image"
                                },
                                {
                                    "id": 1013964,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ed3aaa9e-4563-4f26-b9fc-57005b1f3bbe/width=450/1013964.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCD9Cw^*009GE4f+%0fSs;bbt6s:~VxtE1M|",
                                    "type": "image"
                                },
                                {
                                    "id": 1014036,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/34b28967-70ce-490e-95be-591c7b0f525d/width=450/1014036.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1000,
                                    "hash": "U8EoS;D}000f%f#QX8NI0e}ukQyC={Inwft+",
                                    "type": "image"
                                },
                                {
                                    "id": 1014039,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/42fe7963-6a18-40f8-9ddc-c3ae32fce1ba/width=450/1014039.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1000,
                                    "hash": "UAC~rD%LE0~X_3s:ngX900IU4.MyE1M{IUt7",
                                    "type": "image"
                                },
                                {
                                    "id": 1014037,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f3ba6840-18f8-4e4e-8d0d-7bd7b9fa32d6/width=450/1014037.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1000,
                                    "hash": "UBDSE$~A00030pbI^GRiE6Iq$_=_%LkCIVRP",
                                    "type": "image"
                                },
                                {
                                    "id": 1014034,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/86eb034a-16eb-4995-8ced-320db9ab0b1a/width=450/1014034.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1000,
                                    "hash": "UFGkwS9a0f~p4:-;R-oz00MxMxD%RjV@oKWB",
                                    "type": "image"
                                },
                                {
                                    "id": 1014038,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dc1913f2-8e8f-403d-a94e-4c799e4ab39d/width=450/1014038.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1000,
                                    "hash": "U7H-oe000QE*Eg0f~q0L00={00w^9Z=_aKM{",
                                    "type": "image"
                                },
                                {
                                    "id": 1014041,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a4c1e600-3fc3-45cb-aed3-1eaad35899ab/width=450/1014041.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1200,
                                    "hash": "UQHnmdWo.8S~NGD%XSM{-=xue.R5~qNa$j-;",
                                    "type": "image"
                                },
                                {
                                    "id": 1014044,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f9c0034-7ea3-4380-9b38-7bbaad801956/width=450/1014044.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1200,
                                    "hash": "UPHUqa?H~C%2%2$*niD%_2%2x]RPIoxubHxu",
                                    "type": "image"
                                },
                                {
                                    "id": 1014043,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/54f8ce03-296e-4b2c-aaac-1f0640466b3b/width=450/1014043.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNKAvh?v~qNaNtj[%Moz-pDiRjw__N%2IURj",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/88206"
                        },
                        {
                            "id": 79334,
                            "name": "3DMM_V6",
                            "index": 4,
                            "modelId": 73756,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-05-24T01:02:00.787",
                            "availability": "Public",
                            "trainedWords": [
                                "3DMM"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2132,
                                "ratingCount": 1163,
                                "rating": 5,
                                "thumbsUpCount": 1164,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 54482,
                                    "sizeKB": 36973.8046875,
                                    "name": "3DMM_V6.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-24T01:01:33.765Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "F2C2CD55",
                                        "AutoV2": "18A546DFFD",
                                        "SHA256": "18A546DFFDD7445488B3813A36BC3D52AEDA2D77136A038F440A057723CE8B16",
                                        "CRC32": "F8BFC44A",
                                        "BLAKE3": "8855C9F33F9670374F4D371B225F1677924D0BBD884B3E8694080874988EC582",
                                        "AutoV3": "1C694B2F3C22"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/79334",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 890202,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7be6769a-8feb-455d-bb73-b722e7fdafa8/width=450/890202.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 509,
                                    "height": 693,
                                    "hash": "URK1j_%1~qxuIooekXRis:t7jakC%NRjMxaz",
                                    "type": "image"
                                },
                                {
                                    "id": 891466,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3bc34f96-a6cf-4b22-8718-abcb7fed52f0/width=450/891466.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 640,
                                    "hash": "U7Avh6~W9t01M|i_M|EM5Sbvr=-9K5Sh$h$%",
                                    "type": "image"
                                },
                                {
                                    "id": 891477,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71e6efbe-f922-479a-a346-3e6db51eed80/width=450/891477.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 640,
                                    "hash": "U9Cij.~B000K59jx$0I.0fNb=^-oyDoaVrVr",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/79334"
                        },
                        {
                            "id": 78559,
                            "name": "3DMM_V5",
                            "index": 5,
                            "modelId": 73756,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>Stronger 3D effect, more cute</p>",
                            "publishedAt": "2023-05-23T06:56:59.875",
                            "availability": "Public",
                            "trainedWords": [
                                "3DMM"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 10003,
                                "ratingCount": 17,
                                "rating": 5,
                                "thumbsUpCount": 18,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 54004,
                                    "sizeKB": 36973.8046875,
                                    "name": "3DMM_V5.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-23T07:01:26.536Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "F3FC39E7",
                                        "AutoV2": "5ED2960EF0",
                                        "SHA256": "5ED2960EF0B71D9E1DE5954077CFC815639DE385A0029AC712E8BE11D9AF87D7",
                                        "CRC32": "4847104F",
                                        "BLAKE3": "FAF2AA38B5D18E02F438DC68E8FD93332177989A4A5346AD9E5D09D0A10B1CE2",
                                        "AutoV3": "D52097B11DFC"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/78559",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2055525,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8cbe2fcb-04f1-4991-a45a-9acd507894ed/width=450/2055525.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDCiak{mF1nT7wbw:q-CITJ$9ZKJ5%InI-KJ",
                                    "type": "image"
                                },
                                {
                                    "id": 2066541,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1a2d6d2d-ffc8-4f94-a6b1-ecd07aa3516e/width=450/2066541.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJI5A3%1*0bINHRjtRV@4nt8%2NH_2Rji^xa",
                                    "type": "image"
                                },
                                {
                                    "id": 2055529,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/84e6206c-31a8-496d-9c38-ff735ceaeaa9/width=450/2055529.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U48;Z9M_00$zCAx^8^E1?Go#rBNGENZ~rpxu",
                                    "type": "image"
                                },
                                {
                                    "id": 2055522,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8d2f46a8-1eba-48d1-b93c-d3db4bc71e13/width=450/2055522.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8CYH|-:0K9Z}s%2WUNG}@^P5l5R5RR%bvt7",
                                    "type": "image"
                                },
                                {
                                    "id": 2055523,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a21935bd-878b-48ec-91df-f0ed372dfdbe/width=450/2055523.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEF5gQ$*00tR01%2?af50LIp-poe~pe.IAxu",
                                    "type": "image"
                                },
                                {
                                    "id": 2055516,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d439a5e3-c0ab-46b2-9ae5-1fd8bffecac2/width=450/2055516.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8J$]oD,1F?bYpFvUeoI2[vziP%1#b=}0{AV",
                                    "type": "image"
                                },
                                {
                                    "id": 2055517,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a41a6d52-fd56-489a-b0cf-e03204fc011b/width=450/2055517.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAD**JBh0eOW{-#p0{IpH@sDTE-B1tE|-B-V",
                                    "type": "image"
                                },
                                {
                                    "id": 2055519,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fd64835d-a917-482a-90b7-564b45412e87/width=450/2055519.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDIXEXRj00n4MwofEQW=IoM|E3%2_Nt79FM{",
                                    "type": "image"
                                },
                                {
                                    "id": 2055515,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/db2046d2-1339-4025-b2d1-17030a8f5aa9/width=450/2055515.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCDb59O=5Nre%Co#oFRO7i-UnhEM-@ot#4Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 2055518,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/617dc2de-1c82-4513-83d8-eb55513c4cb1/width=450/2055518.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U7A0qE~A0M0Ls9S6IoSOHqWZo~oIT2#jx^EQ",
                                    "type": "image"
                                },
                                {
                                    "id": 2055520,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f7de7445-4b95-47e6-b92c-b40a54570684/width=450/2055520.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U5C$.t$e7#yE19$yDhTL0*E2|:jG?c-7}?E2",
                                    "type": "image"
                                },
                                {
                                    "id": 2055521,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/88263d94-061d-4a3f-9f95-6f21da23f8b7/width=450/2055521.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAE2,^NH00?H_NNG00xaV=s.0LRjo}t7niRk",
                                    "type": "image"
                                },
                                {
                                    "id": 2055524,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b00a7f42-4f50-4193-9a2f-0dfe5f46a7b1/width=450/2055524.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6AJZ$RP00pH~pIU0e-:IVIooe-pIqt7^jWA",
                                    "type": "image"
                                },
                                {
                                    "id": 2055526,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/290e560d-f18a-4df4-bab3-ac12c3df725c/width=450/2055526.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U4A,9C?J00NX}xsq0vNF4ZahpQInxdV|ND%F",
                                    "type": "image"
                                },
                                {
                                    "id": 2055530,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f07b17da-23a9-4c45-b1b7-e2ea42241ea7/width=450/2055530.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNGkzeM{00R*}=s;9ubat-ozVYi_$$RPI;%M",
                                    "type": "image"
                                },
                                {
                                    "id": 2055528,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/11cfc069-495b-452f-b123-bfd8c8bf07c3/width=450/2055528.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8AcPh5656%2=#s:9ZkCwOt7=yS158oe}[Io",
                                    "type": "image"
                                },
                                {
                                    "id": 2066542,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/190f7632-9471-4b71-b4f7-9904ebcd2b60/width=450/2066542.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8HKnR%M00-A^is:02NG014:E3-:_N%14ot7",
                                    "type": "image"
                                },
                                {
                                    "id": 2066544,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a9d838d4-006e-4f74-a362-a6a6efdb4e7a/width=450/2066544.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAELHX^Q0L={}[xHjJ$*^PW?E2jI0|E2xGxa",
                                    "type": "image"
                                },
                                {
                                    "id": 881679,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/65c2a0b1-b957-49fb-9ad0-5fdae3d828e8/width=450/881679.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "U27UF{-3ogo#%%ZzXnxv%MwacFJUpyR*slxv",
                                    "type": "image"
                                },
                                {
                                    "id": 883840,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/840397c0-1ea0-4e3a-92b0-a52f77d31a5e/width=450/883840.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 696,
                                    "hash": "UOHeLQ?b%#?G~q%M_39Z%gxZ?HX8IpM{MxRj",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/78559"
                        },
                        {
                            "id": 78564,
                            "name": "3DMM_V3",
                            "index": 6,
                            "modelId": 73756,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 11,
                            "description": "<p>最可爱版，The cutest, the characters will look very cute</p>",
                            "publishedAt": "2023-05-23T07:07:10.971",
                            "availability": "Public",
                            "trainedWords": [
                                "3DMM"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2382,
                                "ratingCount": 218,
                                "rating": 5,
                                "thumbsUpCount": 220,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 54009,
                                    "sizeKB": 36973.8046875,
                                    "name": "3DMM_V3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-23T07:11:19.160Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "E3C39FFB",
                                        "AutoV2": "39F649E1DA",
                                        "SHA256": "39F649E1DA07ABD5AE62CA3AE8D99777274D92F1680A1FA353C4A6453BDA2B1E",
                                        "CRC32": "67C0E163",
                                        "BLAKE3": "4C2C8CAE91F9AF7E0879C361E5BB170EBD1CF54F58BD1AE167A8ECDDED432576",
                                        "AutoV3": "E3EC6C1BC115"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/78564",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2026935,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7fd08172-02b4-480b-bc45-161f4f913181/width=450/2026935.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U9I|,.]$00JD{N.80dM{0K5Q.7S2F^j^4.w^",
                                    "type": "image"
                                },
                                {
                                    "id": 2026919,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/29624ced-d4c5-4db3-8c1d-07ba741c81b2/width=450/2026919.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UKD9F-RPNZI;~VM|NGNaE1ofIojY4:%LRjWB",
                                    "type": "image"
                                },
                                {
                                    "id": 2026918,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/047104be-8c29-493d-8728-7c7e59a99ddb/width=450/2026918.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDCPbP%fx9NN_N?GInV[X7xa-8NGogxZi_bc",
                                    "type": "image"
                                },
                                {
                                    "id": 2026920,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0c0d444d-f949-46d0-b29f-f659a64e87fc/width=450/2026920.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAF?Lq01J;_NAJso4Tt7ITxuRPM|o|W;$Mt7",
                                    "type": "image"
                                },
                                {
                                    "id": 2026915,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7c8273c6-aeb1-4ed7-8b01-833e3cb591b9/width=450/2026915.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEC$s7$%4nNG~Wt701IoR%R*D*WB%MoLnixa",
                                    "type": "image"
                                },
                                {
                                    "id": 2026925,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cef92e1b-b005-413f-b58e-fb392a635e92/width=450/2026925.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U7Dc5nvzGv00ALx^9DRO0fNH}?-oxVs.VrNH",
                                    "type": "image"
                                },
                                {
                                    "id": 2026930,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7fe9e7ca-ee86-4b11-a839-1beebf52c746/width=450/2026930.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDEU[f9v01~B?aRj4.xYDiSeg2WB0Lxa%2R*",
                                    "type": "image"
                                },
                                {
                                    "id": 2026929,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/87f0a225-5293-4c96-a4cb-12f5e9d7c827/width=450/2026929.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UZJHp_xv~qbaM{kC%MRj.8V@xuoJbwt7IUV@",
                                    "type": "image"
                                },
                                {
                                    "id": 2026921,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/13d4b628-38b3-4d05-b62d-3d28e35cc489/width=450/2026921.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U59%VU4:00}@u59tDh^P^kxGM{I:4.Shog-p",
                                    "type": "image"
                                },
                                {
                                    "id": 2026928,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/12426804-18ba-4522-a986-61e4223bbf75/width=450/2026928.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U9H^qv~A04020#t70Lt70f57rsg3IoaKwI$*",
                                    "type": "image"
                                },
                                {
                                    "id": 2026934,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f994a71-d8fe-44d9-ad0e-22fb7d4d1f2c/width=450/2026934.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U4Bo{=0O5-OQIl%M0exw5O9Y$%M}01^*~VV?",
                                    "type": "image"
                                },
                                {
                                    "id": 2026924,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f636965d-57e8-4b6f-b1ba-d906643fb756/width=450/2026924.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UADIwW4.0L01#k~V01xuwG9Z?bR+R+t7M{t7",
                                    "type": "image"
                                },
                                {
                                    "id": 2026917,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0529858f-0ca8-47ee-ba8d-64202ebc1413/width=450/2026917.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U4Al|l0f00^k^SR%00~Cob9t%2$+0d}]xu5Q",
                                    "type": "image"
                                },
                                {
                                    "id": 2026922,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/13d5bb3c-4b02-4f1b-931e-a312c0a5c216/width=450/2026922.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U2B{fh},000ME--o00%300I]-;oa00Rn~CxD",
                                    "type": "image"
                                },
                                {
                                    "id": 2026923,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/721fd266-ce8a-4836-b54c-4588125212d3/width=450/2026923.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UMHKUu~V%N^j~B-p9wWX57IoV@M|9bIpr?oI",
                                    "type": "image"
                                },
                                {
                                    "id": 2026932,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f38ab4fb-2f52-43e6-b882-18c3dab37956/width=450/2026932.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8H^I,9]1O]:~mrE019@1hJ59c=|Ee=yIUJA",
                                    "type": "image"
                                },
                                {
                                    "id": 2026926,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/206311b5-8705-4867-bd63-48e37bc09dc9/width=450/2026926.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U29jl?+E00yG_4%h00s*009s.99Y4nt8~Wo~",
                                    "type": "image"
                                },
                                {
                                    "id": 2026927,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad996c2e-ce9f-473a-9700-66a5ad03b2d5/width=450/2026927.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDEBaN?H0eE1}us:5PaeIo5Qax$*0|Sd%0$*",
                                    "type": "image"
                                },
                                {
                                    "id": 2026931,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/583d3ea2-418a-428b-8f52-3886da24b58e/width=450/2026931.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAIDv|^%00M|_1%103D*0fNGIVX8~V%L$hxF",
                                    "type": "image"
                                },
                                {
                                    "id": 2026933,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/87bda4c8-f301-4301-86b7-66b63ded9a3f/width=450/2026933.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U9D+PY-p00}??bkC4.NG0LM{nOEME2n%%1%1",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/78564"
                        }
                    ]
                },
                {
                    "id": 15365,
                    "name": "hanfu 汉服",
                    "description": "<p>Thank Support Contribution 感谢以下人员的支持与贡献</p><ul><li><p><span data-type=\"mention\" class=\"mantine-1yiar0p\" data-id=\"mention:456494\" data-label=\"liaoliaojun\">@liaoliaojun</span> <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/user/ChitandaEru\">@明月明月 </a><a target=\"_blank\" rel=\"ugc\" href=\"https://space.bilibili.com/225168173\">@南陌 </a>@现代汉服研习小组 @小千 @善果心花 @WEN @科晓生 @林子安 <a target=\"_blank\" rel=\"ugc\" href=\"https://www.xiaohongshu.com/user/profile/6134a9fc0000000002026a79?xhsshare=CopyLink&amp;appuid=6134a9fc0000000002026a79&amp;apptime=1681707943\">@A++</a> <a target=\"_blank\" rel=\"ugc\" href=\"https://v.douyin.com/DFCxhyD/\">设计师雨晨</a></p></li><li><p>首页精修图作者：设计师雨晨 <a target=\"_blank\" rel=\"ugc\" href=\"https://v.douyin.com/DFCxhyD/\">https://v.douyin.com/DFCxhyD/</a></p></li><li><p>感谢所有已经为汉服模型做出贡献的人，汉服模型的持续发展离不开你们的支持与贡献！交流分享汉服素材贡献和资源、汉服素材的处理。如果你想加入我们，请联系邮件至me@liaoliaojun.com</p></li></ul><p><strong>郑重声明：本模型禁止用于训练基于明星、公众人物肖像的风格模型训练。</strong></p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://sleepy-oyster-204.notion.site/hanfu-e7a2aab3ea58451bbe2400bb08955bb6\">hanfu汉服总文档 hanfu ALL Document</a></p><p>高质量汉服lora模型，感受汉服之美。请不要犹豫，立即下载试用吧！</p><p>High quality hanfu lora model, feel the beauty of hanfu. Please don't hesitate to download and try it now!</p><p><strong>!!!汉服整合版本污染较大，需要高清修复。单朝代风格汉服污染较轻。</strong></p><p></p><p><strong>v3.0 - v1.0 版本支持多风格：</strong><a target=\"_blank\" rel=\"ugc\" href=\"https://sleepy-oyster-204.notion.site/han-style-566fad9a5e134c9f80cf40f40cdd6bb5\"><strong>汉风</strong></a><strong>、</strong><a target=\"_blank\" rel=\"ugc\" href=\"https://sleepy-oyster-204.notion.site/tang-style-c4a0af02d2a844d1b8a4406e282291b7\"><strong>唐风</strong></a><strong>、</strong><a target=\"_blank\" rel=\"ugc\" href=\"https://sleepy-oyster-204.notion.site/song-style-766a8b462f654d7597164351581a4f7b\"><strong>宋风</strong></a><strong>、</strong><a target=\"_blank\" rel=\"ugc\" href=\"https://sleepy-oyster-204.notion.site/ming-style-6afc9d984e644946b6c31f8fd6db1c8b\"><strong>明风</strong></a><strong>、</strong><a target=\"_blank\" rel=\"ugc\" href=\"https://sleepy-oyster-204.notion.site/weijin-style-4a0888bd001d4788a0d070406258d672\"><strong>晋风</strong></a></p><p><strong>v3.0 - v1.0 Supported multiple styles: </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://sleepy-oyster-204.notion.site/han-style-566fad9a5e134c9f80cf40f40cdd6bb5\"><strong>han style</strong></a><strong>、</strong><a target=\"_blank\" rel=\"ugc\" href=\"https://sleepy-oyster-204.notion.site/tang-style-c4a0af02d2a844d1b8a4406e282291b7\"><strong>tang style</strong></a><strong>、 </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://sleepy-oyster-204.notion.site/song-style-766a8b462f654d7597164351581a4f7b\"><strong>song style</strong></a><strong>、 </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://sleepy-oyster-204.notion.site/ming-style-6afc9d984e644946b6c31f8fd6db1c8b\"><strong>ming style</strong></a><strong>、</strong><a target=\"_blank\" rel=\"ugc\" href=\"https://sleepy-oyster-204.notion.site/weijin-style-4a0888bd001d4788a0d070406258d672\"><strong> jin style</strong></a></p><p>v3.0 Weight (权重): 0.5~0.7</p><p></p><p>微信交流群添加小助手: hanfuaigc</p><p>QQ交流群: 390640380</p><p>Tag参考下方文档或各版本的图片信息。</p><p></p><h3>v3.0 tags 触发词</h3><p>明风汉服: hanfu, ming style</p><p>宋风汉服: hanfu, song style</p><p>唐风汉服: hanfu, tang style</p><p>晋风汉服: hanfu, jin style</p><p>汉风汉服: hanfu, han style</p><p></p><h3>v2.9 tags 触发词</h3><p>明风汉服: ming hanfu, ming style outfits</p><p>宋风汉服: song hanfu, song style outfits</p><p>唐风汉服: tang hanfu, tang style outfits</p><p>汉风汉服: han hanfu, han style outfits</p><p></p><h3>v2.8 tags 触发词</h3><p>明风汉服: mingstyle, ming clothing, hanfu</p><p>宋风汉服: songstyle, song clothing, hanfu</p><p>唐风汉服: tangstyle, tang clothing, hanfu</p><p>晋风汉服: jinstyle, jin clothing, hanfu</p><p>汉风汉服: hanstyle, han clothing, hanfu</p><p></p><h3>v2.0 tags 触发词</h3><p>明风汉服: hanfu, ming, ming dynasty, ming clothing</p><p>宋风汉服: hanfu, song, song dynasty, song clothing</p><p>唐风汉服: hanfu, tang, tang dynasty, tang clothing</p><p>晋风汉服: hanfu, jin, jin dynasty, jin clothing</p><p>汉风汉服: hanfu, han, han dynasty, han clothing</p><p></p><h3>Tang Style（汉服唐风）: <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/44395\">https://civitai.com/models/44395</a></h3><h3>Song Style（汉服宋风）: <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/47916\">https://civitai.com/models/47916</a></h3><h3><strong>Ming</strong> Style（汉服明风）<strong>: </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/65314/hanfu-ming\"><strong>https://civitai.com/models/65314/hanfu-ming</strong></a></h3><p></p><h3>未来计划：</h3><p>- [√] 唐风拆分</p><p>- [√] 宋风拆分</p><p>- [√] 明风拆分</p><p>- [x] 汉服男生版本</p><p>- [ ] 高跟鞋支持</p><p>- [ ] 整合版本支持</p><p></p><p><strong>郑重声明：本模型禁止用于训练基于明星、公众人物肖像的风格模型训练。</strong></p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 93307,
                        "favoriteCount": 0,
                        "thumbsUpCount": 11286,
                        "thumbsDownCount": 16,
                        "commentCount": 171,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 100
                    },
                    "creator": {
                        "username": "liaoliaojun",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8f9ebef1-d7cc-4647-16a8-c0a3e1c89900/width=96/liaoliaojun.jpeg"
                    },
                    "tags": [
                        "hanfu",
                        "clothing",
                        "hanstyle",
                        "jinstyle",
                        "tangstyle",
                        "songstyle",
                        "mingstyle"
                    ],
                    "modelVersions": [
                        {
                            "id": 54777,
                            "name": "v3.0",
                            "index": 0,
                            "modelId": 15365,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>update</p>",
                            "publishedAt": "2023-04-25T07:22:59.624",
                            "availability": "Public",
                            "trainedWords": [
                                "hanfu",
                                "ming style",
                                "tang style",
                                "song style",
                                "jin style",
                                "han style"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 36045,
                                "ratingCount": 3592,
                                "rating": 4.99,
                                "thumbsUpCount": 3635,
                                "thumbsDownCount": 13
                            },
                            "files": [
                                {
                                    "id": 39535,
                                    "sizeKB": 147573.2880859375,
                                    "name": "hanfu_v30.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-25T07:15:49.482Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "73A2E49C",
                                        "AutoV2": "F8B56CFAAA",
                                        "SHA256": "F8B56CFAAAFA5FEFE7778C5BAFB95D79BD11D7D7615F083158A3BEA1F8EB73DF",
                                        "CRC32": "760E6B53",
                                        "BLAKE3": "7BD09BAE9EACD2321DF6AEB6C4E1B71ADF237F0A9AA80EFC7F729BF5E0AE4959",
                                        "AutoV3": "C246FD5E690E"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/54777",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 592643,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04a43bd2-a6f2-493f-ba86-c677fe642f00/width=450/592643.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMMr3+ay?@wg9YxZ8yELENShS#j]XTV@%Mt7",
                                    "type": "image"
                                },
                                {
                                    "id": 592645,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cfd1a48e-2b20-4287-cbcb-13fc5db59d00/width=450/592645.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDECUp-o0PE3$xROx^Rj0TIr~8$$9ZRiwGoe",
                                    "type": "image"
                                },
                                {
                                    "id": 592646,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f2baba41-1b34-49e4-5693-ffc449d3f500/width=450/592646.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKGkRa4n_M$jMd-o9tof5QD%RQEMOEE2xGae",
                                    "type": "image"
                                },
                                {
                                    "id": 592650,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/786c9c8a-66ec-4cd2-8515-f9e88ec2fe00/width=450/592650.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1248,
                                    "hash": "UAGum}HrQ800_}57pxIU59IA~p^j-prqoJo}",
                                    "type": "image"
                                },
                                {
                                    "id": 592657,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f9a15191-7a68-41b6-f9f7-4e74f9946500/width=450/592657.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMKAf@9a~B?HxY-pNKxZIAs:NHofJBxa%1t6",
                                    "type": "image"
                                },
                                {
                                    "id": 592652,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/52281eb7-f498-4ec5-02d5-2a4f9d399500/width=450/592652.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1248,
                                    "hash": "UEK9V?=sI.}@000g,@-UR5.7S~9a={r?J7I;",
                                    "type": "image"
                                },
                                {
                                    "id": 592656,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2d07ee38-bcfc-4b38-12fb-e535a1a45900/width=450/592656.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UANJUZo#00IA0000RjNG00X9.8%M00~WIV-:",
                                    "type": "image"
                                },
                                {
                                    "id": 592769,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6c181558-246d-42b4-ca12-2791b5133a00/width=450/592769.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPF5v?~AVXRjD*R-RlbF4.IpxuR*NeM{s.xt",
                                    "type": "image"
                                },
                                {
                                    "id": 592928,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d5ad54b5-27ed-4173-3409-977d47048d00/width=450/592928.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMKAf@9a~B?HxY-pNKxZIAs:NHofJBxa%1t6",
                                    "type": "image"
                                },
                                {
                                    "id": 592929,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/07e021c0-ece5-400a-64c9-5d7af358bf00/width=450/592929.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9E.Ot00~9?b00_30f%0}:V[EkxZ-;IU?GWC",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/54777"
                        },
                        {
                            "id": 27946,
                            "name": "v2.9",
                            "index": 1,
                            "modelId": 15365,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p><strong>BaseModel: </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/6424/chilloutmix\"><strong>chilloutmix</strong></a><strong>、</strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/4201/realistic-vision-v13\"><strong>RealisticVision</strong></a><strong>、SD1.5....</strong></p><p>DPM++ 2S a Karras</p>",
                            "publishedAt": "2023-03-23T16:13:39.848",
                            "availability": "Public",
                            "trainedWords": [
                                "hanfu"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 12654,
                                "ratingCount": 1073,
                                "rating": 5,
                                "thumbsUpCount": 1072,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 23083,
                                    "sizeKB": 73846.5859375,
                                    "name": "hanfu2.92.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-23T16:15:49.566Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "57026113",
                                        "AutoV2": "C12A83B094",
                                        "SHA256": "C12A83B0947AB541253E55EEF1BF54CA585646A65FBC5936864E99D97FE2518D",
                                        "CRC32": "019FFA42",
                                        "BLAKE3": "504D4F81C44FE49D161740913F9F9DFA3A56CAD474FD16A810366E6CC7D0584F",
                                        "AutoV3": "D44B45BDB32D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/27946",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 314105,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/08d0e110-f3cd-442f-480f-c4d18c109200/width=450/314105.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIIhZ.D%4m%2tvROxwWY4VE0ams;_MM{Vroz",
                                    "type": "image"
                                },
                                {
                                    "id": 314104,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1aeb7aa-9083-4ca4-0151-5d35b8154e00/width=450/314104.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UaIXKo?w-pxtJ.xCIpWC~W.8x]ofMxR*%1oL",
                                    "type": "image"
                                },
                                {
                                    "id": 314103,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9d60fc8c-d035-4a30-79cb-6e281cb09800/width=450/314103.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8H_i6t,00PA00ROt,8{By?G_3xH~nbvaL_2",
                                    "type": "image"
                                },
                                {
                                    "id": 314102,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fdc1f36d-246e-42ec-0c9d-d8f18e281500/width=450/314102.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UYJ@|2Dhxu%MxuNHM{s;~qD$xuxuM|xuoLj[",
                                    "type": "image"
                                },
                                {
                                    "id": 314101,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ab8d62e7-f7f9-46b1-1430-935dc5b3a400/width=450/314101.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "URKd@uIVOO-:JBImj1Ip9bM_Rrjd~oMx%Lof",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/27946"
                        },
                        {
                            "id": 21656,
                            "name": "v2.8",
                            "index": 2,
                            "modelId": 15365,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p><strong>Breakthrough Update</strong></p><p><strong>refactor keywords!!!</strong></p>",
                            "publishedAt": "2023-03-11T14:28:45.973",
                            "availability": "Public",
                            "trainedWords": [
                                "mingstyle",
                                "songstyle",
                                "tangstyle",
                                "jinstyle",
                                "hanstyle",
                                "hanfu"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 11777,
                                "ratingCount": 1446,
                                "rating": 5,
                                "thumbsUpCount": 1446,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 18052,
                                    "sizeKB": 147570.044921875,
                                    "name": "hanfu2.8.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-11T14:31:32.808Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "E441EB5E",
                                        "AutoV2": "A6FB7662E3",
                                        "SHA256": "A6FB7662E34CBEB1D5B166F3D4AC8B44B40F7508644C1BEC74537A779372300A",
                                        "CRC32": "F4A0345F",
                                        "BLAKE3": "BB8A8F55F27B6E61F8AC43E0835277EBB5EE3B70AB6DAD727C70E5160ABC605F",
                                        "AutoV3": "F3068F803B8D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/21656",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 566586,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f77787fa-f8c9-4c5d-4012-570d5e32f700/width=450/566586.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1560,
                                    "height": 2340,
                                    "hash": "U9JuDg.8~ot,af~p?IRoxabu%N00yExZMxo0",
                                    "type": "image"
                                },
                                {
                                    "id": 230456,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c51b6235-ee1c-4559-b15e-761338080f00/width=450/230456.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1344,
                                    "height": 896,
                                    "hash": "UBHU|Bev000J00-8~EIU=e9FXf-?TUs[$%jD",
                                    "type": "image"
                                },
                                {
                                    "id": 230462,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/85cd5f6d-0df6-4457-226e-4f12da440f00/width=450/230462.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UMH-[Qxu00~W9a%g-;WEx@?H?bR*bXxvo#Ip",
                                    "type": "image"
                                },
                                {
                                    "id": 230461,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9a92e2fb-2639-45c0-42cd-2773cdeb5000/width=450/230461.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UWKU1O~oE0WA0KxpWAt7oGIU%Lj?t7xut7t6",
                                    "type": "image"
                                },
                                {
                                    "id": 230460,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c9f083cb-afb7-48f5-a188-79209d163c00/width=450/230460.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UZKdSW~oImRiInInRiR*xpoc?GWWxXbFxts:",
                                    "type": "image"
                                },
                                {
                                    "id": 230459,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/38d1908c-fdb3-4269-b6d5-9870112af100/width=450/230459.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "U7J@,o000000H?00%$_1Dg02~q?H00E4xb-=",
                                    "type": "image"
                                },
                                {
                                    "id": 230458,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b54fb6df-67d3-4ebb-51a7-4cdc0c325f00/width=450/230458.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UDJ*F*_L00?J00D~VsID??%f_4ogb9tRahIB",
                                    "type": "image"
                                },
                                {
                                    "id": 230457,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b91432c7-88bc-4c4a-aaf1-3703b0de2800/width=450/230457.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1344,
                                    "height": 896,
                                    "hash": "UJH2il~qR#or4T--xuIWx-E1xt%L.6of%0%M",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/21656"
                        },
                        {
                            "id": 18795,
                            "name": "v2.0",
                            "index": 3,
                            "modelId": 15365,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p><strong>hanfu, ming, Ming Dynasty, Ming clothing  </strong></p><p><strong>hanfu, jin, Jin Dynasty, Jin clothing  </strong></p><p><strong>hanfu, tang, tang  Dynasty, Tang clothing</strong></p><p><strong>hanfu, han Dynasty, Han clothing</strong></p><p></p><p>To be supported styles: Republic, Qing, Wei-Jin style</p><p>Base model: chilloutmix</p>",
                            "publishedAt": "2023-03-05T07:18:46.003",
                            "availability": "Public",
                            "trainedWords": [
                                " han, jin, tang, song, ming"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 7186,
                                "ratingCount": 540,
                                "rating": 5,
                                "thumbsUpCount": 540,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 15743,
                                    "sizeKB": 147570.1640625,
                                    "name": "hanfu2.0.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-05T07:21:07.263Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "83270779",
                                        "AutoV2": "206E7C8AEE",
                                        "SHA256": "206E7C8AEE7FDA25F3307E355DF779D9AE1A4A010B1C427F0BE2699083C048CC",
                                        "CRC32": "80023688",
                                        "BLAKE3": "FD903DBBCD23EB91A6F616E960ED88A9DBD8338CC351EB7BB3C5C8084DD37F50",
                                        "AutoV3": "69E80CF42F3C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/18795",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 195522,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4d415cbc-6b46-4742-8378-3443d5ed5a00/width=450/195522.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFI}w|008^~VxjbItmM{?ZIT?cf9~qRinPof",
                                    "type": "image"
                                },
                                {
                                    "id": 195524,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bfcb7492-4fb4-4669-934b-74eb008c9800/width=450/195524.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UPK1Bx?w4;?F9x_M^*MxD%i_tRozt2D%IUbI",
                                    "type": "image"
                                },
                                {
                                    "id": 195525,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f09e9b23-8921-45aa-c09b-595819ecdd00/width=450/195525.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJKwk7?a8w9D0w9ZNfWU~Pxs%N%M~S-oxHxu",
                                    "type": "image"
                                },
                                {
                                    "id": 195523,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d3c9694e-7a16-4685-61a6-23928af3bb00/width=450/195523.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHIY5*ITR1_N~QR$EOf5DzNFbLM{IUt7bKjw",
                                    "type": "image"
                                },
                                {
                                    "id": 196325,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3ffc41a7-de63-46ae-f2a0-bb269b99fb00/width=450/196325.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBJ8Fdu%qt0h_200TK~qQ:-qb=?aRO-Vx]oK",
                                    "type": "image"
                                },
                                {
                                    "id": 195520,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c9a802bc-e36a-4e03-4240-4cac467e6e00/width=450/195520.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "ULJH]oD%Dg?Gs#RiXmM{sjRO-;o#~pI:xaxa",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/18795"
                        },
                        {
                            "id": 18106,
                            "name": "v1.0",
                            "index": 4,
                            "modelId": 15365,
                            "baseModel": "Other",
                            "nsfwLevel": 1,
                            "description": "<p>Base model: chilloutmix</p><p></p><p>A variety of high-quality Hanfu LORA models show the beauty and magnificence of Hanfu and feel the beauty of Hanfu. Please do not hesitate to download the trial now!</p><p>Keywords: <strong>\"hanfu\", \"hanfu dress\", \"chinese hanfu\", \"colors+hanfu\"</strong></p><p>Weight: about 0.6</p><p>Combine face: (lora: hanfu: 0.6),&lt;lora: face lora: 0.8&gt;</p><p></p><p>多样性的高质量汉服lora模型，呈现出汉服的优美和华丽，感受汉服之美。请不要犹豫，立即下载试用吧！</p><p>关键词: <strong>\"hanfu\"、\"hanfu dress\"、\"chinese Hanfu\"、“颜色 + 汉服”</strong></p><p>权重: 0.6 左右</p><p>融合人脸: (lora:hanfu:0.6),&lt;lora:某人的lora:0.8&gt;</p><p></p><p><strong>Example1: </strong>1 girl wearing blue hanfu dress in bedroom</p><p><strong>Example2: </strong>1 girl wearing pink and blue hanfu dress</p><p><strong>Example3: </strong>1 girl Wearing blue hanfu dress in bedroom, beautiful vintage color, (photorealistic, high resolution:1.4),platinum hair, ((puffy eyes)), looking at viewer, happy, (8k, RAW photo, best quality, masterpiece:1.2), (realistic, photo-realistic:1.37),(sharp focus:1.2), professional lighting, photon mapping, radiosity, physically-based rendering, (Close-up angle photo:1.4), (close-up:0.9), (pale skin:1.2),&lt;lora:hanfu:0.65&gt;,(full body,hanfu:1.2)</p>",
                            "publishedAt": "2023-03-03T17:14:38.641",
                            "availability": "Public",
                            "trainedWords": [
                                "hanfu",
                                "hanfu dress",
                                "colors+hanfu",
                                "chinese hanfu"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2573,
                                "ratingCount": 329,
                                "rating": 5,
                                "thumbsUpCount": 329,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 15133,
                                    "sizeKB": 147575.0830078125,
                                    "name": "hanfu.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-03T17:15:49.298Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "65E61030",
                                        "AutoV2": "0C1A7AAA9C",
                                        "SHA256": "0C1A7AAA9C549236415F202B9A49B15ABEB2A67CD404FC44609E514141AB1D91",
                                        "CRC32": "B426A4AA",
                                        "BLAKE3": "42E8C29E5F83EFEE0E45B1ECA94A0EC6A444892E0AE837F9A02D0C67CC354C3F",
                                        "AutoV3": "DCE2C48569F8"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/18106",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 189607,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bf9de629-ebc7-45e7-af77-4e64f1119900/width=450/189607.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 832,
                                    "hash": "UEKKvL00u%_N+F%2PVxFnh9a?vD%yY9E^*R+",
                                    "type": "image"
                                },
                                {
                                    "id": 189747,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9e0ddffd-601f-4d8c-6030-7601e9dbfa00/width=450/189747.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGK1E%5t00-N8^IA_3E29Z4.~BoNxvWBW@jI",
                                    "type": "image"
                                },
                                {
                                    "id": 186050,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/800a165d-4670-4e0d-7dec-29218ae83e00/width=450/186050.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHHxj6D%00${4mR%?wE1D%Io?HnlaQadsCkE",
                                    "type": "image"
                                },
                                {
                                    "id": 185912,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f132fd88-7f77-4da3-d861-ad66ea846200/width=450/185912.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHHeB]{w00x]00Ip_2adw@iv?vxa.8V@RjkW",
                                    "type": "image"
                                },
                                {
                                    "id": 185911,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e1675a6-534d-40a0-95ea-9b3e10b88300/width=450/185911.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UIJRN@=^H=%g]x_29F%1_2?ax]nh~W$*xat6",
                                    "type": "image"
                                },
                                {
                                    "id": 186035,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bf3c253b-8528-4657-73fc-daab8a8e7800/width=450/186035.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGIzeR~TF_kU0M4;IV-T-nS~OYWooy5SD*Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 186036,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a05a16ff-9dba-4299-5a79-a732da7b5c00/width=450/186036.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBI}R;~A00E2000i_2xp9Z9a-p-o-nt7NLIV",
                                    "type": "image"
                                },
                                {
                                    "id": 186049,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/26d4c24f-f4bb-4e83-01b8-e93d266c4500/width=450/186049.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCIhW_0000~B00%LyE9Z00M^~XM}_4s.t8RP",
                                    "type": "image"
                                },
                                {
                                    "id": 186048,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/de2be190-91a0-4944-cf17-167730927200/width=450/186048.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UPJtSHIp00IVD%4:xus:-oE2xuX8~VxaMyt6",
                                    "type": "image"
                                },
                                {
                                    "id": 186034,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/09a1f8cd-0670-46c2-182e-994c5371bd00/width=450/186034.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UNJaJ,M|00Ip9F0f%M%1VsNHxuoe~VsTM{xa",
                                    "type": "image"
                                },
                                {
                                    "id": 186033,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d72c0228-80aa-4b78-f066-6975a47da200/width=450/186033.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UMI;-WES00Io4m0L-=-;-TM|%MW;~VIpMxxu",
                                    "type": "image"
                                },
                                {
                                    "id": 185908,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b7fcc287-35cd-4cf8-bab2-e299c084ad00/width=450/185908.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UDIqr-8wrB00009a^+Z~ITO[xZ_N00Rk%gNd",
                                    "type": "image"
                                },
                                {
                                    "id": 186047,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/adee1160-5e7c-4fbd-eee7-947b023e1600/width=450/186047.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDJkT40=00vy00t7_4E200x8%4t7N3RjNg-;",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/18106"
                        },
                        {
                            "id": 19475,
                            "name": "v2.1(Focus Clothes)",
                            "index": 5,
                            "modelId": 15365,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>v2.1模型<strong>人脸，手指</strong>效果欠佳。<strong>汉服质量</strong>提升。</p><p>Version 2.1 model face and finger effects are not good. Improve the quality of clothes。</p>",
                            "publishedAt": "2023-03-06T16:11:57.569",
                            "availability": "Public",
                            "trainedWords": [
                                " han, jin, tang, song, ming"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1952,
                                "ratingCount": 785,
                                "rating": 4.99,
                                "thumbsUpCount": 786,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 16254,
                                    "sizeKB": 147570.169921875,
                                    "name": "hanfu2.1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-06T16:16:05.877Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "D4A03A74",
                                        "AutoV2": "F41221D19A",
                                        "SHA256": "F41221D19A3A8785D5A7B50F01699B96D16ADFF0C0AE59DD1976D45F0B48E3B8",
                                        "CRC32": "8BFE7A7F",
                                        "BLAKE3": "5671F4DFD36D1B326BDAD96FB1D8601FB20AD89E6F3AECE4342295A2E2363537",
                                        "AutoV3": "1162E65C1256"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/19475",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 204390,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2b7209a6-67a1-4255-e066-a58d23b95a00/width=450/204390.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 720,
                                    "height": 912,
                                    "hash": "U9I#uo00t1W1009Gk[$cTeDO-B5Q~VX3t8WX",
                                    "type": "image"
                                },
                                {
                                    "id": 204388,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e7a971b0-b607-4fde-d938-00b7533f4200/width=450/204388.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMJ%g_~B5P.7EfIqDjIU.mtRnO%L?bWERjt7",
                                    "type": "image"
                                },
                                {
                                    "id": 204385,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b3275313-3802-43d8-c836-0f311aa89500/width=450/204385.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 720,
                                    "height": 912,
                                    "hash": "UBK12Z?w54-30Jvf$gEemROp?c$7X-#,xuyD",
                                    "type": "image"
                                },
                                {
                                    "id": 204387,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ec4edb1a-03b0-417e-369a-d0755f5e2a00/width=450/204387.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 720,
                                    "height": 912,
                                    "hash": "UBHB@]_LD~4T00em.9Oq?af}xY^+?s-:xGbW",
                                    "type": "image"
                                },
                                {
                                    "id": 204401,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e7e7319-bd7c-4417-2a33-f1bba97d9000/width=450/204401.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7D+[2~V00tn00IXnmMvM}xVs+-;$KDiWAIo",
                                    "type": "image"
                                },
                                {
                                    "id": 204386,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8e8a9355-60d9-41a6-4077-686e80db1a00/width=450/204386.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 720,
                                    "height": 912,
                                    "hash": "UCIhpY~V00x=RxNF-=xt00j^%ORj8|oft8WY",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/19475"
                        },
                        {
                            "id": 39043,
                            "name": "v3.0-song",
                            "index": 6,
                            "modelId": 15365,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>宋3.0 song</p><p><strong>☑️ 长衫 long shan☑️ 短衫 short shan</strong></p><p>☑️ green/white/pink/red/blue/black/purple/yellow</p><p>☑️ 绿/白/粉/红/蓝/黑/紫/黄 + 长衫或短衫<br />☑️ 浅蓝 light blue ☑️ 浅绿 light green ☑️ 黄白 yellow with white<br />☑️ 浅黄和白绿相间的短衫 light yellow with green with white short shan</p><p><strong>☑️ 百迭裙 pleated skirt</strong></p><p>☑️ white/red/green/blue/pink + pleated skirt</p><p>☑️ 白/红/绿/蓝/粉 + pleated skirt</p><p>☑️ 白金 white golden ☑️ 浅蓝 light blue ☑️ 渐变绿 gradient green</p><p>☑️ 半透明白 translucent white</p><p>☑️ 红青渐变 red cyan gradient ☑️ 红绿渐变 red green gradient</p><p>☑️ 白绿相间的百迭裙 green with white</p><p>☑️ 浅黄和白绿相间的百迭裙 light yellow with green with white pleated skirt</p><p><strong>☑️ 宋抹 songmo</strong></p><p>☑️ red/green/blue/white/orange/pink/yellow/purple</p><p>☑️ 红/绿/蓝/白/橘/粉/黄/紫 + songmo</p><p>☑️ 绿色碎花宋抹 green floral songmo</p><p>☑️ 紫色碎花宋抹 purple floral songmo</p><p>☑️ 青色碎花宋抹 cyan floral songmo</p>",
                            "publishedAt": "2023-04-07T10:32:11.628",
                            "availability": "Public",
                            "trainedWords": [
                                "long shan",
                                "short shan",
                                "pleated skirt",
                                "songmo"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 12752,
                                "ratingCount": 2165,
                                "rating": 5,
                                "thumbsUpCount": 2167,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 30453,
                                    "sizeKB": 147577.8779296875,
                                    "name": "hanfuSongStyle30.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-07T10:30:41.738Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "9ED3571D",
                                        "AutoV2": "55AEF96286",
                                        "SHA256": "55AEF962864E844CF426C518C2A13A38073B8C078C3CD1D600DC6DEBB4C4FA32",
                                        "CRC32": "856307B4",
                                        "BLAKE3": "FA0B4AF2102B0A1AFE6D8803D8D4AB1BF1A71DADDDA95DA47691010AE18527DE",
                                        "AutoV3": "0C8A57723293"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/39043",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 526395,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c8fab15f-d63e-4a32-eed4-ca57d6407400/width=450/526395.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1560,
                                    "height": 2340,
                                    "hash": "U9JuDg.8~ot,af~p?IRoxabu%N00yExZMxo0",
                                    "type": "image"
                                },
                                {
                                    "id": 432274,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a1a8b225-23ff-46d0-d41c-024e53fd9100/width=450/432274.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8JHX4^%004-00~V?bozJ40K~Vob%gx[IB?F",
                                    "type": "image"
                                },
                                {
                                    "id": 432246,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/66e5c2fd-84a7-4171-f93b-d132e4a60000/width=450/432246.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "ULIhKY~pNYM_E2S#%MWD%M-;xbkWIoM|V[Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 432277,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1417588-f961-4f16-6748-5ad451ad2800/width=450/432277.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UHIXEZ}@ITR*OY9tNeRj4:NbxFnNxGxZxaS2",
                                    "type": "image"
                                },
                                {
                                    "id": 432272,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/db34b68b-52f8-4a92-a0f3-8514101df700/width=450/432272.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCKd9;E2~Wt7?bD*WXfkxZ%2IooJIoNGROxY",
                                    "type": "image"
                                },
                                {
                                    "id": 432273,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e9f0db5-6302-4e43-3ee5-fe3969326b00/width=450/432273.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEJQcqIp56VrK4Ip~WIU56-o%MIqMxadRjNH",
                                    "type": "image"
                                },
                                {
                                    "id": 432250,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/46c38163-1159-4318-fc44-4de824d89500/width=450/432250.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAJHEn~A$x00.800?bs;^N-o-;tmE1xuRQOY",
                                    "type": "image"
                                },
                                {
                                    "id": 432280,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c63da017-03e8-44d2-c5e5-2ddc36a59200/width=450/432280.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8INmw~W004mIC00~VM|D~^*?c-p00NeWF9Z",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/39043"
                        },
                        {
                            "id": 30796,
                            "name": "v3.0-ming",
                            "index": 7,
                            "modelId": 15365,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Document: https://sleepy-oyster-204.notion.site/hanfu-e7a2aab3ea58451bbe2400bb08955bb6</p>",
                            "publishedAt": "2023-03-28T17:10:54.182",
                            "availability": "Public",
                            "trainedWords": [
                                "ming hanfu",
                                "ming style outfits",
                                "long coat",
                                "mamian skirt",
                                "short shan"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 8368,
                                "ratingCount": 1396,
                                "rating": 5,
                                "thumbsUpCount": 1396,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 25383,
                                    "sizeKB": 230521.201171875,
                                    "name": "hanfuMing30.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-28T17:11:52.916Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "359E596D",
                                        "AutoV2": "2285D82B69",
                                        "SHA256": "2285D82B69A166F3E1771F6B45515A3A3EBE712CEE1231C0F163E123D4F100AA",
                                        "CRC32": "5D5C5E8C",
                                        "BLAKE3": "D295FBC0F25C573A5E10AECD6EE725A00438609F44DCE4E1F1FAE3E1D52F62A5",
                                        "AutoV3": "86CCEB4051C4"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/30796",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 349812,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a0bf3de8-9034-4bea-93a4-3f35a0738c00/width=450/349812.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5I#S$0M00~U00bt.8D*D#0e?c%N?c?aH@wM",
                                    "type": "image"
                                },
                                {
                                    "id": 349803,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/494b85b6-39f6-48ae-ba04-37e11bc60500/width=450/349803.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U9ELsbNe00%L4:D*MyozvfW=~q%04UNK-:D%",
                                    "type": "image"
                                },
                                {
                                    "id": 349804,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/873de8b7-aedf-47a0-42c5-b37cc11a6b00/width=450/349804.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBF}[oNH00%1D#kXxVs+nfI@~Wi_-nR.WGae",
                                    "type": "image"
                                },
                                {
                                    "id": 349800,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1f8ad827-9480-49a7-0529-6669a0484200/width=450/349800.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAFYPb0OV:-:57ae0NM|MbRn~Wae-z9b?Gt6",
                                    "type": "image"
                                },
                                {
                                    "id": 349801,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/de955dc9-27ff-40a1-172b-37697bef5500/width=450/349801.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCF5W[Wr00xt9aE2RjozZ#W=~on~DiRlg4Io",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/30796"
                        }
                    ]
                },
                {
                    "id": 13213,
                    "name": "ShojoVibe少女感 ",
                    "description": "<p>带私房写真风的2D-3D泛用少女感混血脸</p><p>词条写上&lt;lora:shojovibe_v11:1&gt;即可, 建议0.6-0.8</p><p>Shojo's boudoir photography, a doll face LORA，suitable for most styles from 2d to 3d. </p><p>&lt;lora:shojovibe_v11:1&gt;，0.6-0.8 recommended.</p><p>=======================================</p><p>v1.1 样图用 <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/8281/perfect-world\">Perfect World 完美世界</a> 模型生成，推荐首选用这个模型。想要长腿或者更多可塑性的模型推荐<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/13034\">Lucky Strike Mix</a>，配合的也不错，脸会显得稍幼一点。</p><p>二次元推荐用<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7240/meinamix\">meinamix</a>或<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7152/facebombmix\">facebombmix</a></p><p></p><p>v1.1 Samples generated by <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/8281/perfect-world\">Perfect World</a>, recommend primary choice</p><p>also recommend <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/13034\">Lucky Strike Mix</a> for longer legs and better background.</p><p>also work for anime style. recommend: <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7240/meinamix\">meinamix</a> or <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7152/facebombmix\">facebombmix</a></p><p>=======================================</p><p>v1.1 Update: 增加混血感、少女感。减少明星相似度。增加稳定性。略微改善皮肤过暗。减小无相应词条下裸露的几率。</p><p>已知问题：发色比较难改。服装和背景相似性较高。目前解决方案是使用<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/13034\">Lucky Strike Mix</a>。</p><p></p><p>v1.1 Update: add little bit biracial feel, more shojo, improve stability, better lighting, reduce resemblance of celebrity</p><p><u>Known issues</u>: difficult to change hair color or clothes. similar background (too much wood element).</p><p><strong>Solution: </strong>use<strong> </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/13034\">Lucky Strike Mix</a>. add wood, wood texture, wood floor, etc., in negative prompt</p><p>=======================================</p><p>不加服装词条容易露胸请注意（因为徐若瑄写真集你懂的</p><p>warning: to avoid nude picture, try add clothes description, add 'topless', 'nude' in negative prompt.</p><p>禁止将此模型商业使用或传播成人内容。</p><p></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 85529,
                        "favoriteCount": 0,
                        "thumbsUpCount": 10670,
                        "thumbsDownCount": 1,
                        "commentCount": 47,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 90
                    },
                    "creator": {
                        "username": "SennaK",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/14586e8e-7424-43e3-b113-dd30c78e1e00/width=96/SennaK.jpeg"
                    },
                    "tags": [
                        "anime",
                        "girl",
                        "3d",
                        "person",
                        "photorealistic",
                        "female",
                        "style",
                        "portraits",
                        "realistic"
                    ],
                    "modelVersions": [
                        {
                            "id": 16557,
                            "name": "v1.1",
                            "index": 0,
                            "modelId": 13213,
                            "baseModel": "SD 2.0",
                            "nsfwLevel": 7,
                            "description": "<p>v1.1 Update: add biracial feel, more shojo, improve stability, better lighting</p><p>known issues: hard to change hair color or clothes (except for sundress or lingerie etc,.,)</p>",
                            "publishedAt": "2023-02-28T08:31:58.12",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 82668,
                                "ratingCount": 9778,
                                "rating": 5,
                                "thumbsUpCount": 10309,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 13981,
                                    "sizeKB": 36976.9091796875,
                                    "name": "shojovibe_v11.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-28T08:36:06.213Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "A970EA28",
                                        "AutoV2": "FCB2FA4F6F",
                                        "SHA256": "FCB2FA4F6F1F81EFDDE20EB2AD6F60E4FC665F9978832B989F8CD56379EECFF1",
                                        "CRC32": "1AEE9421",
                                        "BLAKE3": "CC081579A02FBA9402EABB4B1A4297ABF92CCC82A5725346384D3F2EEEE14728",
                                        "AutoV3": "65ECE304AC27"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/16557",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 166937,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/531149de-4e4e-4764-01c0-01032340e400/width=450/166937.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UFF}$ewH00%200o}x^s:NeD%nh-:~WxunOV@",
                                    "type": "image"
                                },
                                {
                                    "id": 166934,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1335de3-501e-4083-b653-9cd30db44c00/width=450/166934.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UdIg_z_Nx[f+NZ%L%MtRR.a$xat7x]xuxaae",
                                    "type": "image"
                                },
                                {
                                    "id": 166935,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5a97e52f-8a15-454e-6261-6fc8ca540e00/width=450/166935.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UFIXN%%#~p_3x^_3?bad0L-oM{V?xZD*xXE1",
                                    "type": "image"
                                },
                                {
                                    "id": 166936,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f7c0ddd5-e4ab-4ad2-d563-7a7d106e8a00/width=450/166936.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UDH_3]00D#00In4n~qWY0fjE-;x[_Nxu9FD%",
                                    "type": "image"
                                },
                                {
                                    "id": 166930,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/58c3b20d-4ad9-4d8e-bf7d-623f18962800/width=450/166930.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "U9HKqf00?a^j?^4n?b01004:x]8{RO~V?bxt",
                                    "type": "image"
                                },
                                {
                                    "id": 166932,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d4e6c2cc-4456-43c5-969e-b63b1c35c300/width=450/166932.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "U9Fhei=y00At4.M{RPs,gNtSjG?G~p9FIp?u",
                                    "type": "image"
                                },
                                {
                                    "id": 166931,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4ed17f3c-2f88-4643-f384-2366cce35400/width=450/166931.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "U7Gazp00%#RQ00_NMxV@GGMwnN_3Mx^+-VRj",
                                    "type": "image"
                                },
                                {
                                    "id": 167255,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2a322679-2e79-40f0-e2a6-4ce117466f00/width=450/167255.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "UFH-#}00?]?IE100?a4nNMoa?HE0_3Risq%f",
                                    "type": "image"
                                },
                                {
                                    "id": 172035,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d13a0a64-26d8-4e61-a735-d0ea55b55b00/width=450/172035.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDFh-c}[_NyX~W4n4:4:Mc?b9aof00.8V@-o",
                                    "type": "image"
                                },
                                {
                                    "id": 172037,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9cf4cc8b-9079-4edf-7967-27868ccdce00/width=450/172037.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1150,
                                    "hash": "UEH-iX0fX2E300~V9bWVb_aeD*xZE2Ip$%-p",
                                    "type": "image"
                                },
                                {
                                    "id": 172036,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0c0f460c-120e-48a4-42c5-590dc4af5100/width=450/172036.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1093,
                                    "height": 1313,
                                    "hash": "UHGk^7s.InR*00_3S6%MV?%0-oV?_4M{?F$$",
                                    "type": "image"
                                },
                                {
                                    "id": 172034,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/79d6cfa3-0209-4866-032b-b3ac24026f00/width=450/172034.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UGFOcR~W-:4:%LR%xuM{V@s:R-of?G%2E1of",
                                    "type": "image"
                                },
                                {
                                    "id": 172033,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0b729bbc-b514-4ac5-4702-bb766a8a0700/width=450/172033.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UPGuwO?d.7xu-?x]IoV??c%gkCt6IW-;xvWC",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/16557"
                        },
                        {
                            "id": 15574,
                            "name": "v1.0",
                            "index": 1,
                            "modelId": 13213,
                            "baseModel": "SD 2.0",
                            "nsfwLevel": 7,
                            "description": "<p></p>",
                            "publishedAt": "2023-02-26T07:47:12.76",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2861,
                                "ratingCount": 364,
                                "rating": 4.99,
                                "thumbsUpCount": 365,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 13333,
                                    "sizeKB": 36976.4814453125,
                                    "name": "vivian.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-26T07:51:22.752Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "78CD24BF",
                                        "AutoV2": "4BF87C5598",
                                        "SHA256": "4BF87C55986D3B3DB44D52FF5D1321C3F17142CABADA0517CD5332AF5A2212AF",
                                        "CRC32": "6EFB4942",
                                        "BLAKE3": "CFC0587303EB757D27CACECD9A62BF98486F04C8D78F27B1D2D845B5E2D770ED",
                                        "AutoV3": "BE79AD46AD9B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/15574",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 155327,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c6d54576-67e0-4952-b514-079af85e2600/width=450/155327.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "UHG*.nH_54%L00OApIIpbaM|nPxa~oIYr;-n",
                                    "type": "image"
                                },
                                {
                                    "id": 155539,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/19bd9cfd-d5fa-4046-c67e-4d08baefed00/width=450/155539.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "UZGbCw_NcES$9#R=%OtmXAR:RQV@a^oHskt4",
                                    "type": "image"
                                },
                                {
                                    "id": 155324,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cafe3cf2-c9d0-4950-8bf1-9cd554764000/width=450/155324.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "UWFrxAIA?wWV-=%MNfxvbxIUkEM{JDM|ogn*",
                                    "type": "image"
                                },
                                {
                                    "id": 156166,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1af783d8-3ddf-431e-8f6e-e4c6ce8f8300/width=450/156166.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "UJJ86E4TJ4^$K-M^_4ITAgxZnnD%~qt9H=Sh",
                                    "type": "image"
                                },
                                {
                                    "id": 155796,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/068ab3aa-d71b-40b3-5195-c2f308e6f500/width=450/155796.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "UKG[yaMxoxNH~p9GayM|IUM{aet7%MIUM{xu",
                                    "type": "image"
                                },
                                {
                                    "id": 155951,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2ad6527b-a87c-4ec8-e7b4-a331cb3c4800/width=450/155951.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "UJGk:#~pJ6?b9FIUW.xaM{flxujsxujFRPM{",
                                    "type": "image"
                                },
                                {
                                    "id": 156164,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4da30fea-faad-40f3-650a-381ec9289b00/width=450/156164.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "UHF$O#~p4no3W8InM{RQbct7%2NG?aoeRiWC",
                                    "type": "image"
                                },
                                {
                                    "id": 155797,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8cb5332d-ce39-4b6e-2844-cb147219d000/width=450/155797.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "U9Gk,u00yB-p_M00~p%L00s.o44nWF9ZIVE1",
                                    "type": "image"
                                },
                                {
                                    "id": 167250,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8f604551-34d0-49a7-1cfd-53d575014200/width=450/167250.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "UgI;en~pg2nioyWBM{IUE2jcs;bbE2M{WAbc",
                                    "type": "image"
                                },
                                {
                                    "id": 167249,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8dc8aec4-03de-40c9-d042-8f5e308bd300/width=450/167249.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "UJJG]60M.mMy004nV@Rj57_2$jx]?bM|M|X9",
                                    "type": "image"
                                },
                                {
                                    "id": 167248,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1222a855-792d-4029-233a-7260b68acb00/width=450/167248.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 836,
                                    "height": 1195,
                                    "hash": "UFH1=9o#cY={00M{9YIoNG-;4:%L4:E0~DRk",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/15574"
                        }
                    ]
                },
                {
                    "id": 6638,
                    "name": "SamDoesArts (Sam Yang) Style LoRA ",
                    "description": "<h2>SamDoesArts (Sam Yang) style LoRA</h2><p><strong>Making models can be expensive. Do you like what I do? Consider supporting me on </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/Lykon275\"><strong>Patreon</strong></a><strong> 🅿️ or feel free to </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://snipfeed.co/lykon\"><strong>buy me a coffee</strong></a><strong> ☕</strong></p><p>There are already countless models for this artstyle, but I still wanted to test out how LoRA's can handle it. I also wanted to experiment with <a target=\"_blank\" rel=\"ugc\" href=\"https://huggingface.co/m4gnett/any-pastel\"><strong>AnyPastel</strong></a> (or <a rel=\"ugc\" href=\"https://civitai.com/models/23521?modelVersionId=28100\">Anime Pastel Dream - Soft</a>). This LoRA didn't come out super strong, so it has the right flexibility to get a style that's closer to Sam Yang's on AnyPastel, while still reminding of him on other models. Check the examples (mainly the model hash) to get what I mean. Triggers with <code>sam yang</code> and I suggest AnyPastel as base model (or, if you don't care about having a more matching artstyle, AnyLoRA or AbyssOrangeMix2). <strong>Use weight=1 for the offset version or 0.65 for the original (check \"original\" tab for a comparison)</strong>.</p><p>The pic of Melina is also using my Melina LoRA.</p><p>Pic 3 and last 4 ones (all the realistic ones) have been made by <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/10028/neverending-dream-ned?reviewId=16388&amp;modal=reviewThread\">kaynite</a> using <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/10028/neverending-dream-ned\">NED</a>.</p><p><br /><strong>How to use LoRA's in auto1111:</strong></p><ul><li><p>Update webui (use <code>git pull</code> <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/embed/mn8fMF10XN4?start=31&amp;end=60\">like here</a> or redownload it)</p></li><li><p>Copy the file to <code>stable-diffusion-webui/models/lora</code></p></li><li><p>Select your LoRA like in <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/watch?v=-bMeyXOZwN0\">this video</a></p></li><li><p><strong>Make sure to change the weight according to the instructions</strong> (by default it's <code>:1</code>)</p></li></ul><p></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 64413,
                        "favoriteCount": 0,
                        "thumbsUpCount": 9451,
                        "thumbsDownCount": 0,
                        "commentCount": 26,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 312
                    },
                    "creator": {
                        "username": "Lykon",
                        "image": "https://cdn.discordapp.com/avatars/180327464155742208/59254be18ccd627daf138d053327485d.png"
                    },
                    "tags": [
                        "anime",
                        "girl",
                        "samdoesarts",
                        "sam yang",
                        "style",
                        "art style",
                        "woman",
                        "artstyle",
                        "digital illustration",
                        "girls",
                        "women"
                    ],
                    "modelVersions": [
                        {
                            "id": 7804,
                            "name": "offset",
                            "index": 0,
                            "modelId": 6638,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-04-07T07:24:15.108",
                            "availability": "Public",
                            "trainedWords": [
                                "sam yang"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 61428,
                                "ratingCount": 558,
                                "rating": 4.97,
                                "thumbsUpCount": 695,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 10223,
                                    "sizeKB": 147567.2177734375,
                                    "name": "sam_yang_offset_right_filesize.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-15T16:01:07.536Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "C147D1B4",
                                        "AutoV2": "B67FFF7A42",
                                        "SHA256": "B67FFF7A42E85FAF612BC6635C3915645112BA3692A8124D7F4E822C97947657",
                                        "CRC32": "FB5FA3B7",
                                        "BLAKE3": "CD7E5BD2FCC3BD7396C0885433E92CE08EAB2077D7FA744C84A031C8864B312A",
                                        "AutoV3": "351A678917D2"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/7804",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 73354,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/676532a0-04ad-41c0-cac4-d6d1fa595400/width=450/73354.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UCIzxP000K-;9aRi4n=|00_3w]Si~VNG%L9Y",
                                    "type": "image"
                                },
                                {
                                    "id": 73379,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e7b21e65-258f-4aa0-ebae-12adbc05dd00/width=450/73379.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UmK^{o?b^+M{.ANbRPn~o#RiMw%2xHs9$gof",
                                    "type": "image"
                                },
                                {
                                    "id": 126879,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e41b5d6b-2052-4684-6024-8d9ba70c0f00/width=450/126879.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 784,
                                    "height": 1120,
                                    "hash": "UMF=Hm^+x:56~9E2ITE1.6kXxC%0t*S$aJxC",
                                    "type": "image"
                                },
                                {
                                    "id": 126881,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/92dd6c56-2fd2-470c-1e31-747772f46900/width=450/126881.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 784,
                                    "height": 1120,
                                    "hash": "U9Gk^1Dj0h_N?Hs8ELE100%Mvzs:PBx]v#xF",
                                    "type": "image"
                                },
                                {
                                    "id": 73494,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/66e918ae-f101-418d-7d95-6a53867bb000/width=450/73494.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UOJa.#-UNGO@4T?cJBE1ELo}x]Vr.TS4%M%M",
                                    "type": "image"
                                },
                                {
                                    "id": 73365,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/06387b61-6ebb-47a7-10d4-4e3e7dc2d100/width=450/73365.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UQK^jW00Eg-;~DRjD%XS~CWBnhIo~WaJIpoz",
                                    "type": "image"
                                },
                                {
                                    "id": 76023,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8039cf69-3e4a-4ba1-e0a9-a4e46bd45300/width=450/76023.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UJG*Z$~9.7-.~Wi^adxZ0LShMyxuX7?HRkWY",
                                    "type": "image"
                                },
                                {
                                    "id": 73362,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad4cc7e5-0393-4499-f997-a32e8f107c00/width=450/73362.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 936,
                                    "height": 1408,
                                    "hash": "UqLNS,NI~Wf,.9bIIoWXkXWWRPs:o}WBe-n$",
                                    "type": "image"
                                },
                                {
                                    "id": 73360,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a885bb79-c2b2-48ea-e028-555216f5a100/width=450/73360.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UPI$1]ro*0x]Ox=^WBx]D.oI-Q%1cG-pWURP",
                                    "type": "image"
                                },
                                {
                                    "id": 708301,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d17db7e4-a198-450f-81e4-47dd54716398/width=450/708301.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1304,
                                    "hash": "UQH-S=019]9tNGD%~WD*yDIoV@=|EKNGxa%2",
                                    "type": "image"
                                },
                                {
                                    "id": 73361,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/14e9f9c6-2882-46d5-cfff-5a0512281a00/width=450/73361.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UOK^Z_001$~B4n?v?GspDhOaVrIoF{rDs*Ne",
                                    "type": "image"
                                },
                                {
                                    "id": 73358,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8c24d464-587a-4555-d2d6-dea793cb3a00/width=450/73358.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UCHw=X00G]DN00S5~VR5AGkD,pkq9Z^jbw0L",
                                    "type": "image"
                                },
                                {
                                    "id": 73378,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6381f43a-8938-4b2d-1de8-7d4ccdaea100/width=450/73378.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UKIEka0L0Kt,?^$*xvxvTKoz$%?H-ptSRPM_",
                                    "type": "image"
                                },
                                {
                                    "id": 73356,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3120466c-03d7-4cc8-ae57-a4908ecfe800/width=450/73356.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UPIh86IB_MIp~WD*4nbH?vIV-6x[%#jYRPoz",
                                    "type": "image"
                                },
                                {
                                    "id": 73363,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e4be084d-7dc7-4351-3b2c-d72523783c00/width=450/73363.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UOIhdL00PU,D%Moy-US5%NtS,-E1.TwHIUkq",
                                    "type": "image"
                                },
                                {
                                    "id": 73408,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/92e2ec95-713a-4a0e-a5c9-ceb13db2b900/width=450/73408.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UBHnvx00vv1k?c#+^a0M01~CX89F^JIqI]${",
                                    "type": "image"
                                },
                                {
                                    "id": 126880,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/993001b5-0c6c-4a69-34bb-8810306c3d00/width=450/126880.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 784,
                                    "height": 1120,
                                    "hash": "UKG@.6}@J;%35@sp^+t8-;jF-p-V%2xZ=|xa",
                                    "type": "image"
                                },
                                {
                                    "id": 126878,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/66b853f9-b339-49a0-0c52-ce67c1205500/width=450/126878.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 784,
                                    "height": 1120,
                                    "hash": "UJHoRR-;T|Q-Xk%2?vI;00I=rD%L}prqMJM{",
                                    "type": "image"
                                },
                                {
                                    "id": 126877,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f08efae-e4e2-4f08-4c63-2e5575bd0f00/width=450/126877.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 784,
                                    "height": 1120,
                                    "hash": "UdIEOyNHyX$*%#t6%LM{S~%2RPNG~WWrozt6",
                                    "type": "image"
                                },
                                {
                                    "id": 708278,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4db19a1f-2e54-4cba-a509-fba6f34bdfec/width=450/708278.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 864,
                                    "height": 1304,
                                    "hash": "UJIW.s4:AX-:ELIU9Zxa00^*r=xv~CRkkWE1",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/7804"
                        },
                        {
                            "id": 64140,
                            "name": "offset 32dim",
                            "index": 1,
                            "modelId": 6638,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": "<p>resized to 32 dim</p>",
                            "publishedAt": "2023-05-06T17:30:32.759",
                            "availability": "Public",
                            "trainedWords": [
                                "sam yang"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1175,
                                "ratingCount": 2256,
                                "rating": 5,
                                "thumbsUpCount": 3188,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 45083,
                                    "sizeKB": 36136.96484375,
                                    "name": "sam_yang_offset32dim.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-06T17:30:50.094Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "3DC71E0B",
                                        "AutoV2": "7075DE3A79",
                                        "SHA256": "7075DE3A79E77926D006411D89E80B517D29ED6FDFB2F4644E76638682B5FC96",
                                        "CRC32": "7BC5D8EB",
                                        "BLAKE3": "469DA2B1C35E6DAD2030FB7A295A1D9DE4C820C01887F16E527E4DD254FEDD95",
                                        "AutoV3": "0AD624DC30B1"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/64140",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 708163,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fed5855f-3ad2-44a9-8352-1ef4d359bd59/width=450/708163.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 895,
                                    "hash": "UYKdD5WCofNG?^ofaysm%#j[ofkD~qkDf6of",
                                    "type": "image"
                                },
                                {
                                    "id": 708205,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/01f5269c-5c67-44d3-9748-1e84c64c7c54/width=450/708205.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 895,
                                    "hash": "UcM?=3nOaeR5~Wo#oftRx@axW=X9u4aeaxRP",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/64140"
                        },
                        {
                            "id": 10864,
                            "name": "original",
                            "index": 2,
                            "modelId": 6638,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 4,
                            "description": null,
                            "publishedAt": "2023-04-29T17:43:03.412",
                            "availability": "Public",
                            "trainedWords": [
                                "sam yang"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1810,
                                "ratingCount": 5628,
                                "rating": 5,
                                "thumbsUpCount": 5631,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 10224,
                                    "sizeKB": 147568.921875,
                                    "name": "sam_yang.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-15T16:01:06.977Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "1A7AE9FF",
                                        "AutoV2": "1348C8FB60",
                                        "SHA256": "1348C8FB60CB2054349D9FEAC19CF193A658E89102E1ACFFB45A1BEAA5F30949",
                                        "CRC32": "6A76010B",
                                        "BLAKE3": "480ECC23BF021943C7144E935AE23BA22A5BAB6AEF7411C66983E25387CC567F",
                                        "AutoV3": "28043248B18F"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/10864",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 105008,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bcf75f7c-df0a-424a-36ec-80ecc4eaf700/width=450/105008.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 895,
                                    "hash": "UjKKA]RkayM|.8j@ayofpIs:fQxu~pWBfQWB",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/10864"
                        }
                    ]
                },
                {
                    "id": 18323,
                    "name": "小人书·连环画  xiaorenshu",
                    "description": "<h1 id=\"heading-17\">小人书·连环画</h1><p></p><p>[ENG version below]</p><p>607323927751959196</p><p><strong>和</strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/16055/colorwater\"><strong>沁彩</strong></a><strong>一样，本模型也会不断完善，请期待后续各种风格的版本！</strong></p><p><strong>Like </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/16055/colorwater\"><strong>Colorwater</strong></a><strong>, this model will continue to be improved, so look forward to the subsequent versions in various styles!</strong></p><p></p><p>20世纪初叶，在上海形成并开始广泛流传的通俗图画读物始称<strong>连环画</strong>，俗称“<strong>小人书</strong>”。中华人民共和国成立后，连环画作为一种通俗的传播文化的艺术形式得到迅速发展，形成中国现代美术的一个主要画种。谨以此LOAR模型纪念这种离我们越来越远的艺术风格。</p><p>（但有些模型会有一种非常令人脑洞大开的艺术效果，出乎意料，XD）</p><p></p><p>In the early 20th century, popular pictorial books formed in Shanghai and began to circulate widely were called comic books, commonly known as \"Little People's Books\". After the founding of the People's Republic of China, comic books developed rapidly as a popular art form for spreading culture, forming one of the main types of modern Chinese art.<br />This LOAR model commemorates this art style that is getting farther and farther away from us.<br />(But some models will have a very mind-blowing artistic effect, unexpectedly, XD)</p><p></p><h2 id=\"heading-18\">使用说明：</h2><p><strong>请注意阅读位于版本页面右侧的更新说明！这里只更新参数类问题了。</strong></p><p><strong>Please pay attention to the update notes located on the right side of the version page! Only parameter class issues are updated here.</strong></p><p>v2.0版本：</p><ul><li><p>同1.5版本</p></li></ul><p>v1.5版本：</p><ul><li><p>CFG&lt;8，权重&lt;=0.9</p></li><li><p>不同的CFG会带来背景和细节的变化，请自行尝试。</p></li></ul><p>v1.0版本：</p><ul><li><p>原始风格所使用的推荐设置：CFG=3，权重=0.9</p></li><li><p>一些二次元模型使用高CFG后会得到一种奇妙的抽色效果，有兴趣的请尝试</p></li></ul><p></p><h2 id=\"heading-19\">Instructions for v1.5:</h2><ul><li><p>CFG&lt;8，权重&lt;=0.9</p></li><li><p>Different CFG's will bring changes in background and details, please try it yourself.</p></li></ul><h2 id=\"heading-20\">Instructions for v1.0:</h2><ul><li><p>Original style recommended settings: CFG=3, weight=0.9</p></li><li><p>Some Anime models will get a wonderful color pumping effect after using high CFG, please try if you are interested</p></li></ul><p></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 38459,
                        "favoriteCount": 0,
                        "thumbsUpCount": 9130,
                        "thumbsDownCount": 1,
                        "commentCount": 44,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 24
                    },
                    "creator": {
                        "username": "AlchemistW",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6192f367-0fdf-46ca-ed08-c61d64b90a00/width=96/AlchemistW.jpeg"
                    },
                    "tags": [
                        "monochrome",
                        "style",
                        "art style",
                        "illustration",
                        "2d",
                        "artstyle"
                    ],
                    "modelVersions": [
                        {
                            "id": 25661,
                            "name": "v2.0",
                            "index": 0,
                            "modelId": 18323,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>我们现在进入了彩色时代，可以更好的用传统色调来表现一些二次元模型了，多人场景依然可以发挥出很多故事画面，期待您的创作！</p><p></p><p>We are now entering the era of color, you can better use the traditional tone to show some anime models, multiplayer scenes can still play a lot of story screen, look forward to your creation!</p>",
                            "publishedAt": "2023-03-19T13:53:29.621",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 33314,
                                "ratingCount": 6762,
                                "rating": 5,
                                "thumbsUpCount": 7839,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 21302,
                                    "sizeKB": 147572.544921875,
                                    "name": "xrs2.0.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-19T13:56:28.990Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "7D364C75",
                                        "AutoV2": "50D66BDC57",
                                        "SHA256": "50D66BDC578E56E368CB4756284313168B0B67AF64DB3305FDF30B7C67E37C1F",
                                        "CRC32": "85F370AF",
                                        "BLAKE3": "A5FBEF58E20A749DE9B2B517392B8025DB0D3A5D778018771CBD5EA2D0C1DFCE",
                                        "AutoV3": "97413AD0D80D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/25661",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 282059,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/86c3c217-f715-450d-de1d-470d9ef1e900/width=450/282059.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMLqOMbD4o%M~Vspa{%La0aeWsxGWCxaNGoy",
                                    "type": "image"
                                },
                                {
                                    "id": 282058,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/416cc500-d896-46e9-3fcf-637e7247b100/width=450/282058.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAK^mF_M?DIA~XEOR6NGcrWAa1tS.Rb]NG%L",
                                    "type": "image"
                                },
                                {
                                    "id": 282057,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e6bdb156-5451-4512-8729-2f07e6883200/width=450/282057.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1920,
                                    "height": 1280,
                                    "hash": "UBLz84^j0MRmR:RQM|oe~oxaRj-:?u?GM|t7",
                                    "type": "image"
                                },
                                {
                                    "id": 282056,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/38b632f1-994c-4583-a2f0-5ab46e2a7700/width=450/282056.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBLW%-O=Iq~o~q0MS$RkNhNtW9Ro59tQVs-:",
                                    "type": "image"
                                },
                                {
                                    "id": 282055,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b63f9f94-4b21-408f-50f0-a067531ca500/width=450/282055.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UEL:[i,=$0IX}@i_?uNI.Sx]EN-n^*RjD%xa",
                                    "type": "image"
                                },
                                {
                                    "id": 282054,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/725da425-a423-42c2-2f41-2f9e875fa600/width=450/282054.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9HxKL~V4n_3?vDioHD*%L%MNFD*^$aJ9Z?a",
                                    "type": "image"
                                },
                                {
                                    "id": 282053,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3070c0e9-83b3-4586-0d7e-f5f5d7913f00/width=450/282053.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDN^6a~p4n%3.6-oRRR*t6oh?ajYVvaxNFs;",
                                    "type": "image"
                                },
                                {
                                    "id": 282052,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5bd81f52-d7e2-4ec9-eea8-10d06e1f6500/width=450/282052.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8J*CV^N005T1jAJD*R4yC_LRQiw4@Vt=sI]",
                                    "type": "image"
                                },
                                {
                                    "id": 282051,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4cbccd1a-b437-414c-c78d-a54f4dc06600/width=450/282051.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAJ*CUt04T9$Os0g9a$}_Kt7NM-7t,-nnOIt",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/25661"
                        },
                        {
                            "id": 22652,
                            "name": "v1.5",
                            "index": 1,
                            "modelId": 18323,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 9,
                            "description": "<p>多人场景显著改善，你可以从例图中得到更多灵感。得益于数据集本身的故事性，画面感明显更有趣了</p><p>强烈推荐尝试骑马动作，有惊喜也有惊吓，毕竟马有四条腿，出问题的可能性大增。</p><p>添加了两个触发词“sgyy”“shz”，可以在使用一些三次元模型时改变一些人物的服装风格，比如例图中的三个大汉</p><p>Multiplayer scenes are significantly better, and you can get more inspiration from the example images. Thanks to the storytelling of the dataset itself, the graphics feel significantly more interesting.</p><p>Highly recommended to try the horse riding action, there are surprises and scares, after all, the horse has four legs and the possibility of problems is greatly increased.</p><p>Added two trigger words \"sgyy\" and \"shz\", which can change the clothing style of some characters when using some realistic models, such as the three guys in the example picture.</p>",
                            "publishedAt": "2023-03-13T15:53:23.51",
                            "availability": "Public",
                            "trainedWords": [
                                "sgyy",
                                "shz"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2947,
                                "ratingCount": 712,
                                "rating": 5,
                                "thumbsUpCount": 712,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 18841,
                                    "sizeKB": 147569.3486328125,
                                    "name": "xiaorenshu_v1.5.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-13T15:56:50.127Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "BED01C2B",
                                        "AutoV2": "DD9EAD4035",
                                        "SHA256": "DD9EAD4035C17D3169FBB4A34A720B4909D54A5C367EAAB5AE4B9E91EAEBEA3C",
                                        "CRC32": "E07859DB",
                                        "BLAKE3": "16AEB5BE4356603D464FD0CFC51BAF8AE9843DDDE732924A600A8B074D1A4319",
                                        "AutoV3": "CA39B9EF4B7B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/22652",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 243996,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f2b4d601-dffc-4efa-64a4-980af14c2400/width=450/243996.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UHOprWD*~Waz~pIV9GxtxuRjt6IVxuM|WBRj",
                                    "type": "image"
                                },
                                {
                                    "id": 243995,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6206674c-432a-482e-4d83-926e67708000/width=450/243995.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UON^PFRk%MIVt7IVxut7~pRjM{t7?bM{Rj%L",
                                    "type": "image"
                                },
                                {
                                    "id": 243999,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ddc959ea-5b09-4c76-a563-0cd995077600/width=450/243999.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UQOzC{%MD*M{~pRjM|t7ofj[WBof-;t6t7t6",
                                    "type": "image"
                                },
                                {
                                    "id": 243998,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2fc8383d-1554-4a6d-5e8d-85dc4b60c100/width=450/243998.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UTPGTu-pRjj[~payNGxtj[ofRjof%Lofj[of",
                                    "type": "image"
                                },
                                {
                                    "id": 243997,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4003905f-4c94-4f74-d627-a7268dddd900/width=450/243997.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHQ9y5~p_2%L?axtRkRjD*xtofRj?aIVWBxt",
                                    "type": "image"
                                },
                                {
                                    "id": 244038,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f7d199cd-7390-4ab9-d37e-74392fec9f00/width=450/244038.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "ULNTj$?bIV~p?bxtRj-:j[IVRjt7%MWBj[xu",
                                    "type": "image"
                                },
                                {
                                    "id": 244037,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7a7e237a-0f09-49bf-07c4-22d10301a900/width=450/244037.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UMOg4oj[xuE1~pRjxuofWBt7xtM{ofWBayWB",
                                    "type": "image"
                                },
                                {
                                    "id": 244036,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d6782c94-edd9-4ec5-c40b-63fa1bdc1800/width=450/244036.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UENwJ[t69GWC00ayj[%M~pM{t7t7xuxut7Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 244035,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ab0c465b-e755-4c30-1d9a-78695d0e2c00/width=450/244035.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1920,
                                    "height": 1280,
                                    "hash": "UEP?s*ofRj-paxNGt7%L~pt7M|-pxuWBM|xt",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/22652"
                        },
                        {
                            "id": 21712,
                            "name": "v1.0 ",
                            "index": 2,
                            "modelId": 18323,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-03-11T16:21:17.316",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2198,
                                "ratingCount": 584,
                                "rating": 5,
                                "thumbsUpCount": 585,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 18098,
                                    "sizeKB": 147571.2470703125,
                                    "name": "xiaorenshu_v1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-11T16:26:31.789Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "B4303593",
                                        "AutoV2": "E3530C2751",
                                        "SHA256": "E3530C2751914813427E10549B92A405DC26CC5D2BC9C0948406F2C566227504",
                                        "CRC32": "030FE344",
                                        "BLAKE3": "1AF8218A3A2A71664B16922BC802A5EFD26D25C29B0EB9CD3249A52FCB7737D7",
                                        "AutoV3": "A36A60DD8241"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/21712",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 231464,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/92a3480b-673e-4a9f-9e50-c8a4a89e8000/width=450/231464.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "U8P%95_3?G?Zs=-;~pxF_1Rkoz4o.7IUbIIp",
                                    "type": "image"
                                },
                                {
                                    "id": 233726,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/be2cd77e-4421-49b5-dfba-b067a67a2900/width=450/233726.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7Pj0yIu~o^+00Ri?bof00%L%Mxt?G-:%Lxt",
                                    "type": "image"
                                },
                                {
                                    "id": 233725,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/76674935-b5f9-42a2-fab4-e70e285f5800/width=450/233725.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHPj3+?H%Kt7IV~p-:D*Rk%L%2RkRkM|Rkxt",
                                    "type": "image"
                                },
                                {
                                    "id": 233724,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/371dcba3-5509-4d30-2d03-9a9e9a26b800/width=450/233724.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1440,
                                    "hash": "UINwGz~p-.Io%M%MWBIUE1xt%2IUE1E1%2%L",
                                    "type": "image"
                                },
                                {
                                    "id": 231461,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04f195b7-0063-4b91-cc0c-b1b705fb6c00/width=450/231461.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBQ9+JxuxUxtIV_2%MM|8{-pozD*~oRiD*Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 231316,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fac17cf4-dd55-4fea-ed71-19adfc73bd00/width=450/231316.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UHOgA#D*M{xa_2t6IURk~pRjWCE1-:oft7fR",
                                    "type": "image"
                                },
                                {
                                    "id": 233723,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6215bdfe-29bf-4f6a-b1b6-5edf5bfc8c00/width=450/233723.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNP6:3xu~V%L~pofj[oe^*f6ayWBt7s:IVWB",
                                    "type": "image"
                                },
                                {
                                    "id": 231462,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/72fd15f5-0912-4d3e-ce4f-17d667b2d900/width=450/231462.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5Ql~|~pxr%MR,Rkxu4oxt?a-:D*IV%2?HIo",
                                    "type": "image"
                                },
                                {
                                    "id": 231458,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dcf26fbc-f4f6-4d85-f71e-d1931cc4e900/width=450/231458.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UDPj6[?b-oRj-;t7t7M{~V%1xaay~ojsj@ay",
                                    "type": "image"
                                },
                                {
                                    "id": 231545,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2a53498f-7f7f-4c0f-944b-0a414cd72400/width=450/231545.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "ULQceZxtt6?a-:t6WVbF~oWVRQWB%LWCM|Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 231463,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a940ff15-dc5a-499b-0347-3556b1611c00/width=450/231463.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIODajayob-:Ipazodt7~VoLD*M{-oxtM|Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 231468,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0cc5ca61-621d-47df-4e8f-672bb24b0200/width=450/231468.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBQJAS~qM}-;-;xuaxoe~WIUxZs.%LIVIVs:",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/21712"
                        }
                    ]
                },
                {
                    "id": 52652,
                    "name": "LEOSAM's Instant photo 拍立得/Polaroid LoRA & LoHA",
                    "description": "<p>🖥️Welcome to try out the open-source <a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/jiayev/GPT4V-Image-Captioner\"><strong><u>GPT4V-Image-Captioner</u></strong></a>, developed by my friend and me. It offers a one-click installation and comes integrated with multiple features including image pre-compression, image tagging, and tag statistics. Recently, we also launched the <a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/SleeeepyZhou/sd-webui-GPT4V-Image-Captioner\"><strong><u>webui plugin version</u></strong></a> of this tool, everyone is welcome to use it!</p><p></p><p>🌍<span style=\"color:rgba(255, 255, 255, 0.8)\">欢迎加入</span>QQ群\"兔狲·AIGC梦工北厂\"，群号 ：<span style=\"color:rgb(250, 176, 5)\">780132897</span> ；\"兔狲·AIGC梦工南厂\"，群号 ：<span style=\"color:rgb(250, 176, 5)\">835297318</span>（入群答案：兔狲）。<span style=\"color:rgba(255, 255, 255, 0.8)\">Telegram群聊“兔狲的SDXL百老汇”，链接：</span><a target=\"_blank\" rel=\"ugc\" href=\"https://t.me/+KkflmfLTAdwzMzI1\"><span style=\"color:rgb(250, 176, 5)\">https://t.me/+KkflmfLTAdwzMzI1</span></a></p><p></p><p><strong>📖</strong>2023.6.24 Update</p><p>许多朋友反馈希望出一版不带白色边框、只保留拍立得照片质感的模型版本。因此InspX Borderless Version 在InspX Lora的基础上，通过分层调节，使得白色边框的出现概率大大降低，同时对人脸的干扰也有所降低。但作为代价，Borderless Version 的拍立得照片质感相比InspX Lora略有下降，但尚在可接受范围内</p><p>Many users have requested a model version that removes the white borders and retains only the Polaroid photo texture.</p><p>As a result, the InspX Borderless Version has been developed based on InspX Lora. By employing a layered adjustment approach, the probability of white borders appearing has been significantly reduced, and the interference with facial features is also minimized.</p><p>However, as a trade-off, the Polaroid photo texture of the Borderless Version is slightly lower than that of InspX Lora, but it is still within an acceptable range.</p><p></p><p>2023.6.3 Update</p><p>InsPX LoRA版本重新采用LoRA模型进行训练，采用了新的打标方法，并扩大了训练集与训练图像分辨率。</p><p>The InsPX LoRA version re-trains with the LoRA model, adopts a new marking method, and expands the training set and training image resolution.</p><p></p><p>2023.5.19 Update</p><p>InsPX LoHA版本不同于之前的1.0和2.0版本LoRA模型，InsPX是全新训练得到的LoHA模型，感觉要比之前的Lora版本效果上要略好一些，建议搭配<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/33208/filmgirl-film-grain-loha-and-lora\">FilmGirl Provia LoHA</a> 一起使用，否则面部容易崩坏。</p><p>请注意，因为这个版本没有触发词，白色画框在某些提示词以及大模型下有一定概率并不会出现，但仍会保持Polaroid 相片的色彩质感。</p><p>InsPX LoHA version is different from the previous 1.0 and 2.0 LoRA models. InsPX is a brand new trained LoHA model. It feels slightly better than the previous Lora versions in terms of effect. It is recommended to use with FilmGirl Provia LoHA, otherwise the face is easy to collapse.</p><p>Please note that because this version does not have trigger words, the white picture frame may not appear under certain prompt words and large models, but the color texture of Polaroid photos will still be maintained</p><p></p><p><strong><u>使用Loha模型的一种方法:</u></strong></p><p>请安装以下插件，<a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/KohakuBlueleaf/a1111-sd-webui-locon\">https://github.com/KohakuBlueleaf/a1111-sd-webui-locon</a>，然后调用方法与Lora类似，需要将模型放入...\\models\\Lora文件夹中，随后使用&lt;lora:FilmGX2:XXX&gt;指令调用。</p><p>另一种使用Loha模型的方法: → <a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/KohakuBlueleaf/a1111-sd-webui-lycoris\">https://github.com/KohakuBlueleaf/a1111-sd-webui-lycoris</a></p><p><strong><u>How to use the Loha model:</u></strong></p><p>Please install the following plugins, <a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/KohakuBlueleaf/a1111-sd-webui-locon\">https://github.com/KohakuBlueleaf/a1111-sd-webui-locon</a>, then use the same method as Lora. You need to place the model in the \\models\\Lora folder, and then call it with the lora:FilmGX2:XXX command.</p><p>Another way to use the Loha model → <a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/KohakuBlueleaf/a1111-sd-webui-lycoris\">https://github.com/KohakuBlueleaf/a1111-sd-webui-lycoris</a></p><p></p><p></p><p>This is a Polaroid-style LoRA, where version 2.0 has become much more stable compared to version 1.0. However, in some complex scenarios, limbs and facial features may still experience distortion. The main reason is that the training set consists of 512x768 photos, and the white frame of the Polaroid occupies a significant portion of the image, which leaves limited content for actual training.</p><p>这是一个拍立得风格的LoRA，2.0版本相比1.0版本已经稳定很多，不过在某些复杂的场景下，肢体和面部还是会出现崩坏的情况。主要是因为512*768的训练集照片，拍立得的白色相框占了不小的面积，真正可供训练的照片内容就比较有限了。</p><p>If you want to fully replicate the white frame of a Polaroid photo, it is recommended to set the Lora weight between 0.55 and 0.7. Lower weights can display the effect of the Polaroid filter, but the frame size may be inconsistent.</p><p>如果要完全复现拍立得照片的白色相框，建议的Lora weight为0.55~0.7。较低的权重可以呈现拍立得滤镜的效果，但相框可能会时大时小。</p><p>It is suggested to use this LoRA in combination with <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/33208/filmgirl-film-grain-lora\">FilmGirl LoRA</a> for a synergistic effect in terms of appearance and color correction.</p><p>建议搭配<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/33208/filmgirl-film-grain-lora\">FilmGirl LoRA</a>使用，可以起到在形貌和色彩上的增益矫正效果。</p><p>After testing, this model works quite well with <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/43977/moonmix\">MoonMIX</a>, <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/43331/majicmix-realistic\">majicMIX realistic</a>, and <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/6424/chilloutmix\">ChilloutMix</a>. Other realistic models should also perform well, so feel free to experiment with different options.</p><p>测试了下，本模型在使用<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/43977/moonmix\">MoonMIX</a>、<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/43331/majicmix-realistic\">majicMIX realistic</a>和<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/6424/chilloutmix\">ChilloutMix</a>，效果蛮不错。其他真实系模型应该也不差，大家可以多自行尝试。</p><p>Occasionally, the generated photos may show body parts extending beyond the white frame. However, this minor flaw does not detract from the overall image and may even add a sense of depth to the picture.</p><p>生成的照片偶尔会出现身体超出白色相框的情况，不过这个感觉无伤大雅，反而会有点立体感增强的效果。</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 83294,
                        "favoriteCount": 0,
                        "thumbsUpCount": 9056,
                        "thumbsDownCount": 0,
                        "commentCount": 41,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 30
                    },
                    "creator": {
                        "username": "LEOSAM",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a20200e6-02ed-4115-a756-754aacfea68e/width=96/LEOSAM.jpeg"
                    },
                    "tags": [
                        "film",
                        "photo",
                        "style",
                        "nsfw",
                        "ins",
                        "拍立得",
                        "instantphoto"
                    ],
                    "modelVersions": [
                        {
                            "id": 102533,
                            "name": "InspX Borderless Version",
                            "index": 0,
                            "modelId": 52652,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>许多朋友反馈希望出一版不带白色边框、只保留拍立得照片质感的模型版本。因此InspX Borderless Version 在InspX Lora的基础上，通过分层调节，使得白色边框的出现概率大大降低，同时对人脸的干扰也有所降低。但作为代价，Borderless Version 的拍立得照片质感相比InspX Lora略有下降，但尚在可接受范围内</p><p>Many users have requested a model version that removes the white borders and retains only the Polaroid photo texture.</p><p>As a result, the InspX Borderless Version has been developed based on InspX Lora. By employing a layered adjustment approach, the probability of white borders appearing has been significantly reduced, and the interference with facial features is also minimized.</p><p>However, as a trade-off, the Polaroid photo texture of the Borderless Version is slightly lower than that of InspX Lora, but it is still within an acceptable range.</p>",
                            "publishedAt": "2023-06-23T23:04:51.468",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 60977,
                                "ratingCount": 3908,
                                "rating": 5,
                                "thumbsUpCount": 6649,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 71874,
                                    "sizeKB": 147567.21875,
                                    "name": "InstantPhotoX3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-23T22:40:59.890Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "443ADF37",
                                        "AutoV2": "D4969DA4A7",
                                        "SHA256": "D4969DA4A70D0EAEC5EB76AA6746D1A9B177C9FE58558878D9725B460C4A44B9",
                                        "CRC32": "38E61745",
                                        "BLAKE3": "5704CE71E234DA066F79BC21D0AC10AE8922E52D16A62B9A902C298417145D01",
                                        "AutoV3": "7036B103FEF3"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/102533",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1628228,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cec847bf-887a-49f4-ba69-cc98910e44ec/width=450/1628228.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3893,
                                    "height": 6326,
                                    "hash": "U9EeMv-V00aK8xr?~BjZMIjZx]t7%$R+ELt7",
                                    "type": "image"
                                },
                                {
                                    "id": 1263785,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8b97c691-2891-4e1d-9893-75690ab09e5d/width=450/1263785.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "U9En#F-V00Vt4Twc~BWBH=n%yDt6%#R+ELoz",
                                    "type": "image"
                                },
                                {
                                    "id": 1263786,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7580a8f8-bba5-4542-aec3-e655c13c223a/width=450/1263786.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "UIB:st%L01Ioxuxt%MkCxuxa%MtR_NxuIUs:",
                                    "type": "image"
                                },
                                {
                                    "id": 1263213,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bd97a5bb-66f8-47d4-b716-7af4cd6af60b/width=450/1263213.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "U684MX-p01x]j^%M-;tR0Kt7~Wflt6NGE1jF",
                                    "type": "image"
                                },
                                {
                                    "id": 1263223,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f794668-9946-49c6-a185-3c5dacefb23e/width=450/1263223.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "UC9s@$~V4:014.D*oL%2M|t7-:xaNHM{M{xZ",
                                    "type": "image"
                                },
                                {
                                    "id": 1263226,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/64266722-fba1-428b-9058-5c1db38e2c0a/width=450/1263226.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "U98;GV%M9aR+9v%2%1NGT0t7xaWB~WozoLj[",
                                    "type": "image"
                                },
                                {
                                    "id": 1263228,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/115cf91a-07a9-4da2-be97-27bfd09fbc4d/width=450/1263228.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "UFF=s^00k?000f-;sl9F~q-;IAIoROozE1s.",
                                    "type": "image"
                                },
                                {
                                    "id": 1263236,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d281d4e4-f7a0-4885-a6c0-5b68febe9116/width=450/1263236.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "U67^=2^+0101E2Rk%L%M01M|~V-;-;t7IVNG",
                                    "type": "image"
                                },
                                {
                                    "id": 1263231,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9f4d79d7-1d29-4ca2-83fc-0fcc85bfbb71/width=450/1263231.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "UOF65;~q.StR.8?b%MkCD%fkRPofW;Rj%2s:",
                                    "type": "image"
                                },
                                {
                                    "id": 1263241,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3668e1aa-f62e-4f83-8652-4f8e18d54c59/width=450/1263241.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "ULE3F;?vM{xZ.T?vozIUtm%M%2M{s:IVM{t6",
                                    "type": "image"
                                },
                                {
                                    "id": 1263245,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e6b22eb0-8661-4a1d-b2f7-1637039e46e5/width=450/1263245.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "UAB:gID%00n%00xu?bV@?^RQr=RjxWj[t7NG",
                                    "type": "image"
                                },
                                {
                                    "id": 1263244,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/25118c50-dfe1-41bc-bcf8-04b1b57cbd98/width=450/1263244.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "UGCsU2?b4.E100R*-;xuE2t7-ot7~qxtIoRj",
                                    "type": "image"
                                },
                                {
                                    "id": 1263264,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d691f00f-d647-4a7d-b358-c876cd94c7dd/width=450/1263264.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "UDFXr1NG00OX01s.?HX84ojuxubH~WayNGR*",
                                    "type": "image"
                                },
                                {
                                    "id": 1263247,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/64cc1116-8f50-4066-b642-c3f7a6d256db/width=450/1263247.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "UEFEl,-;00RQHYjE}@RjMcaKtRog-;kCIpxu",
                                    "type": "image"
                                },
                                {
                                    "id": 1263246,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0e0e1122-7c4f-4d54-839e-12e227cdeec6/width=450/1263246.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "UHFqUX~BMKM{DjIo-VxZ9ZM|xts:?HxtNGoJ",
                                    "type": "image"
                                },
                                {
                                    "id": 1263251,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c7d4aa80-a507-4320-afe4-1b4f7466ac9f/width=450/1263251.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "UDHxmJ0000t7_ND%-;t79bxuMxNG-pWBM{s:",
                                    "type": "image"
                                },
                                {
                                    "id": 1263276,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c091dc6b-5939-4668-9397-ec212af2cb7f/width=450/1263276.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "U7BDKF~q01?a9a-;^+D%004n^jIV^*4n00_3",
                                    "type": "image"
                                },
                                {
                                    "id": 1263278,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1d2d586e-8557-47fe-9de3-6534c9f37b47/width=450/1263278.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "UGI4;Y7FVuof~Cb]o}$k00n%?a%2^+R*M|t7",
                                    "type": "image"
                                },
                                {
                                    "id": 1263285,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f9ef49b5-8466-4b58-b483-7d9491ae759f/width=450/1263285.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1664,
                                    "hash": "U36kCi-p019Gt6WBIpR+00Io~V-:D*V[%Lxt",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/102533"
                        },
                        {
                            "id": 88101,
                            "name": "InsPX LoRA",
                            "index": 1,
                            "modelId": 52652,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>InsPX LoRA版本重新采用LoRA模型进行训练，采用了新的打标方法，并扩大了训练集与训练图像分辨率。</p><p>The InsPX LoRA version re-trains with the LoRA model, adopts a new marking method, and expands the training set and training image resolution.</p>",
                            "publishedAt": "2023-06-03T02:48:28.036",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 11207,
                                "ratingCount": 1032,
                                "rating": 4.99,
                                "thumbsUpCount": 1035,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 60394,
                                    "sizeKB": 147578.0869140625,
                                    "name": "InstantPhotoX2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-03T02:25:41.447Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "C3FD8C2F",
                                        "AutoV2": "78DAF2A7EA",
                                        "SHA256": "78DAF2A7EA4AD29245C3619F24ABC239AA299118AC7B2346624DC6AB68288865",
                                        "CRC32": "A8664B3A",
                                        "BLAKE3": "2D1865B22BBE1B2B032D83C22D118EBC8ACD65834EA18BE13B39B07B4872F83F",
                                        "AutoV3": "4E627D96336F"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/88101",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1048277,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/926ffb9d-1775-4925-9400-37a9f5d80016/width=450/1048277.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAA^awxu00Ip00Rj_Nxa9vWB-oWX_4t7D%Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 1012400,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1d5efcbd-57d8-4282-96e4-0ebd6cb38a3a/width=450/1012400.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPIEnaWVIqxt9aWC-poe_Nxaw]R*~VayM|R*",
                                    "type": "image"
                                },
                                {
                                    "id": 1012377,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/55ef8b6d-ce52-4998-a3cc-e336bd7a4f50/width=450/1012377.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9Bp;C%g00Rj00t8x^RjOtR*~Vt7tmRi00az",
                                    "type": "image"
                                },
                                {
                                    "id": 1012379,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4260828c-ad38-44f9-ab4c-c31cd4f6d598/width=450/1012379.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKI#P#oz-;-;~WIobcxu9aof?HxuxvxaoKR*",
                                    "type": "image"
                                },
                                {
                                    "id": 1012381,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d213fac6-5be7-45b9-8068-a41f96f53b52/width=450/1012381.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAEL~UD%0Lof00n,-:WB?cMy-TD*~pM|Myxu",
                                    "type": "image"
                                },
                                {
                                    "id": 1012386,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1330232e-3507-40ad-b71f-526a2c0c8a35/width=450/1012386.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULH.4uD%~q-;_3R*f6t7?b%MDiaet6s:aeR*",
                                    "type": "image"
                                },
                                {
                                    "id": 1012387,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8fc09cfe-067f-4816-a2e3-66fd4149e28a/width=450/1012387.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UiHB*uxuxtoef,WBfka|~pt6WXofxuayo0j@",
                                    "type": "image"
                                },
                                {
                                    "id": 1012389,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c4c51b5f-f30d-4034-8cd6-7b14d272ceca/width=450/1012389.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "URG[Zmof-;of^+kCozay~qbHM{j[%fj[ofoL",
                                    "type": "image"
                                },
                                {
                                    "id": 1012410,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c3b0e68b-d653-4ea5-a879-47da1373b807/width=450/1012410.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTJRHo~p?c9Z-;ofofoft8IUn$xu%MofM{WB",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/88101"
                        },
                        {
                            "id": 74932,
                            "name": "InsPX LoHA",
                            "index": 2,
                            "modelId": 52652,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>InsPX版本不同于之前的1.0和2.0版本LoRA模型，InsPX是全新训练得到的LoHA模型，感觉要比之前的Lora版本效果上要略好一些，建议搭配<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/33208/filmgirl-film-grain-loha-and-lora\">FilmGirl Provia LoHA</a> 一起使用，否则面部容易崩坏。</p><p>InsPX LoHA version is different from the previous 1.0 and 2.0 LoRA models. InsPX is a brand new trained LoHA model. It feels slightly better than the previous Lora versions in terms of effect. It is recommended to use with FilmGirl Provia LoHA, otherwise the face is easy to collapse.</p>",
                            "publishedAt": "2023-05-19T12:52:28.377",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5139,
                                "ratingCount": 661,
                                "rating": 5,
                                "thumbsUpCount": 665,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 51744,
                                    "sizeKB": 29754.19140625,
                                    "name": "InsPX.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-19T12:41:26.929Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "A36552FD",
                                        "AutoV2": "4F3C9E2E1B",
                                        "SHA256": "4F3C9E2E1B79A0CBDB99B249E1F78BC7492A20B399868A1D4C37A985982834B6",
                                        "CRC32": "6F686B33",
                                        "BLAKE3": "BB73AF3CA223BD87879E09145440992D6DA6F7EFB81E5BE248999E4B2DC725BC",
                                        "AutoV3": "A4EAFF7DE7A0"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/74932",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 871277,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/43761535-b82b-4a37-9d3a-4005bbd43033/width=450/871277.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1600,
                                    "hash": "UCHUXz-;0Moe00M{MxNHJobb^kt7~pM{RPad",
                                    "type": "image"
                                },
                                {
                                    "id": 871293,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e8766ca4-81c9-4d11-855e-61e96f1b8d5e/width=450/871293.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "UPK-8;~qKQ9FEO%gRP9FpJa}sSRPxZofIURj",
                                    "type": "image"
                                },
                                {
                                    "id": 837320,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/546cd7db-f85a-4888-beb6-830911621ef5/width=450/837320.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U-I#$7j[t7of~qj[ofj[-pj[WBj[ogfQRifk",
                                    "type": "image"
                                },
                                {
                                    "id": 837321,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/21eef9b2-c3d6-49fd-9c79-c135bbf8b312/width=450/837321.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UoJuAdWBIoj]~qoft8ay%gofxaof?bofM{of",
                                    "type": "image"
                                },
                                {
                                    "id": 837319,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a55856bf-b500-4e92-a3eb-714b80ff032f/width=450/837319.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U]J*xMfRt7t7~qfkj]j[x[j[RjWBR*j[Rjay",
                                    "type": "image"
                                },
                                {
                                    "id": 837322,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4b1b4229-a524-4b1e-917c-11d825d4dd16/width=450/837322.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHEo#+%M00ae00M{x]of00j]_3WW~qayD$WB",
                                    "type": "image"
                                },
                                {
                                    "id": 837336,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6876b5a9-44a2-4912-926c-71a444ae8ab4/width=450/837336.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UZLENS%L-=RjE0t7xvRj_4j]nioft8WDV@oL",
                                    "type": "image"
                                },
                                {
                                    "id": 837346,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8d67b307-bebc-41d0-8436-100c05dd604e/width=450/837346.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTI}hc9G_N?G_4s.xufl4.%LIAIVi^R*M{ae",
                                    "type": "image"
                                },
                                {
                                    "id": 837344,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a403e338-0935-4b08-9428-f3e13fce09a6/width=450/837344.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UVHU;0ofyEof9Zayxuay_4ofs,j]%1j[M|ay",
                                    "type": "image"
                                },
                                {
                                    "id": 837345,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e9fc1cc-fc3f-4f37-a21f-1052da2e25d4/width=450/837345.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFI4@QIAVq?c~qt6MwWY00bcIVV@xFR*Iojt",
                                    "type": "image"
                                },
                                {
                                    "id": 837347,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/be86e4cd-bfea-448d-87bf-7d5560b4d34c/width=450/837347.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UYJ*r4t7%gaz9FWBxuj[_NWVjFof%1ofWXay",
                                    "type": "image"
                                },
                                {
                                    "id": 837359,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a006929b-47cd-4f44-bbe2-a04f8baeac69/width=450/837359.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULNKCsRP.SxuM{oz-=t7.TtRs8ofRjRiD$RP",
                                    "type": "image"
                                },
                                {
                                    "id": 837360,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bf9d2c3d-8b47-4914-87ed-84d4386f4d35/width=450/837360.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UXLEKNe.?v%MjYaeogt7_NozIUaeIUkCV@Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 837383,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/13330ed0-8cd4-45a1-82c8-4e0da5723c80/width=450/837383.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UkJb24t6.8WXD%fjt7ay_NkCV?oet7j[j]ay",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/74932"
                        },
                        {
                            "id": 57774,
                            "name": "v2.0 LoRA",
                            "index": 3,
                            "modelId": 52652,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>本版本对训练集的照片进行了精选，并对图片tag进行了增减。新版本生成图片的畸变概率大大降低。</p><p>In this version, the training set photos have been carefully selected, and the image tags have been adjusted accordingly. As a result, the likelihood of generating distorted images in the new version has been significantly reduced.</p>",
                            "publishedAt": "2023-04-29T01:55:58.452",
                            "availability": "Public",
                            "trainedWords": [
                                "instantphoto"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4059,
                                "ratingCount": 477,
                                "rating": 5,
                                "thumbsUpCount": 482,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 41166,
                                    "sizeKB": 73842.1044921875,
                                    "name": "INSPHOT2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-29T01:50:46.466Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "3A03A316",
                                        "AutoV2": "CAFC7C46CF",
                                        "SHA256": "CAFC7C46CFED4ADC6AD1530E177CD09EC3D2724BC870D75767BF36A3C928D2F0",
                                        "CRC32": "C7E38F5C",
                                        "BLAKE3": "EE6A755E9288A108EA2F86D9E60008512869B3E80181496EC61590EAC5AF04CB",
                                        "AutoV3": "F611AD1C0A08"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/57774",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 627902,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/acff8afb-929d-43ae-d8e8-106148bf0900/width=450/627902.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UUL;dI_3_NIUROofxukC.9IUVs%MNGt7WBWA",
                                    "type": "image"
                                },
                                {
                                    "id": 627880,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8f43fe97-b4e1-4804-aef9-4a9245230200/width=450/627880.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPL}BGs:?w%gD%R*%Mt8yYbbi^aeoet7M_M{",
                                    "type": "image"
                                },
                                {
                                    "id": 627904,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/09448775-58e2-4c63-9c5e-aae77e359a00/width=450/627904.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UYJ8R[t7%#og9FayxufP?wj[s8j]s:f6RkWV",
                                    "type": "image"
                                },
                                {
                                    "id": 627903,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9f624b9b-d2c9-47d7-c3dc-2e6b0a31a200/width=450/627903.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULJa_?9F?wx]9FV@t7kC*0.8r;WBoJt8ozWA",
                                    "type": "image"
                                },
                                {
                                    "id": 631735,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/498efed2-703b-45b1-24ce-1532b9225800/width=450/631735.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UWKd[6o0.9ozV@ayt8of?^ogVsoLM_j@R*Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 631744,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6b66306b-a790-439f-69c9-d149b3655800/width=450/631744.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULIhdGxuOsaeE2aexabH?wWB%Loz?HozNGsm",
                                    "type": "image"
                                },
                                {
                                    "id": 631742,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/68a784b5-fcd9-48d7-d5a0-c18d9358c900/width=450/631742.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBI=44jE.m4n01xu%29FlUxt%2az^iM_kD-;",
                                    "type": "image"
                                },
                                {
                                    "id": 631747,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b4aa475d-ff7c-4bf9-1cfb-dd707c16ee00/width=450/631747.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UbK1wQf5x^of9Fayxbay_NofsokC$*ayW=j[",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/57774"
                        },
                        {
                            "id": 57050,
                            "name": "v1.0 LoRA",
                            "index": 4,
                            "modelId": 52652,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-04-28T02:50:40.769",
                            "availability": "Public",
                            "trainedWords": [
                                "instantphoto"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1912,
                                "ratingCount": 255,
                                "rating": 5,
                                "thumbsUpCount": 255,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 40740,
                                    "sizeKB": 73840.0224609375,
                                    "name": "INSPHOT.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-28T02:45:50.616Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "09239514",
                                        "AutoV2": "84548BF784",
                                        "SHA256": "84548BF784FB11AC1BF5C057EC264B4C3D9077F67967B212AFA39C7D89150DCE",
                                        "CRC32": "5A87E276",
                                        "BLAKE3": "B94B508945A5B49E076DA9BF5EDB6BD56044B464B7FAFA77F1950C8E84739951",
                                        "AutoV3": "9A46DB1AFC35"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/57050",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 620943,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ee528d72-ac91-410d-3802-07f4e69c0d00/width=450/620943.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USIX~txu%$bIENj]%Lj[_NWBV?oK-:jZM|a}",
                                    "type": "image"
                                },
                                {
                                    "id": 619174,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a34f16e4-afea-4a82-025b-4646acf55e00/width=450/619174.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGIr86-;?^?b_3t7WYR+0KWB?bM{D%bI%1jE",
                                    "type": "image"
                                },
                                {
                                    "id": 619171,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7b1972fc-8912-4454-5188-2f3a3db38f00/width=450/619171.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNLXY=Ri?wx]DhWB-=xu%ht7tRt7IUaxMxRP",
                                    "type": "image"
                                },
                                {
                                    "id": 619176,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2b2d0857-c2fe-47a2-d2cf-78d16e626900/width=450/619176.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UZJ*r54T.9xu-;t7x]t7kXxusljs_NofMxkC",
                                    "type": "image"
                                },
                                {
                                    "id": 620886,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e99d22ad-dc64-4d7f-a8c5-87d579573b00/width=450/620886.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U$KK[~R*o#t7ofWBofof_4ofe-a}s:ofRjae",
                                    "type": "image"
                                },
                                {
                                    "id": 620893,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cca46ff7-662a-401a-e02a-160088aedb00/width=450/620893.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UcKne-t7?wfkkCkCt8js?wflROoeRPf5R*WB",
                                    "type": "image"
                                },
                                {
                                    "id": 620953,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b3ed468c-e75c-430a-b654-e36b1ef9e000/width=450/620953.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UZMaR_NG?w-;o#oM%MkCbct7oLRj%NkCRPae",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/57050"
                        }
                    ]
                },
                {
                    "id": 44960,
                    "name": "M_Pixel  像素人人",
                    "description": "<p>可以出各种像素小人人儿！可以配合其他lora来玩！也可以出像素场景！权重0.5就行！</p><ul><li><p><strong><u>画人像素推荐512X768，高清修复1.5.重绘幅度0.4,再高就没有像素感了。</u></strong></p></li><li><p><strong><u>画建筑推荐768X768,高清修复1.2</u></strong></p></li><li><p><strong><u>触发关键词：pixel</u></strong></p></li></ul><img src=\"http://127.0.0.1:7861/file=D:/novelai-webui-aki-v3/outputs/txt2img-grids/2023-05-22/xyz_grid-0006-66666666.png\" /><p>You can make all kinds of pixel charactor! You can play with other lora! You can also create pixel scenes! A weight of 0.5 &lt;local lora name:0.5&gt;will do!</p><ul><li><p><strong><u>512X768 pixel is recommended for drawing character, hires fix: Upscale by 1.5, Denoising strength 0.4, no pixel feeling if it is higher.</u></strong></p></li><li><p><strong><u>Drawing buildings recommended 768X768, hires fix Upscale by1.2,</u></strong></p></li><li><p><strong><u>Trigger Words: pixel</u></strong></p></li></ul><p>いろんなピクセルキャラが作れます！ 他のローラと遊べる！ ピクセルシーンも作れます！ 0.5 の重みで十分です。また、</p><ul><li><p><strong><u>人物を描くなら512X768ピクセル推奨、HDリペア1.5、再描画範囲0.4、それ以上だとピクセル感なし。</u></strong></p></li><li><p><strong><u>建物の描画推奨 768X768、HD リペア 1.2</u></strong></p></li></ul><p>-- -- -- -- -- -- --</p><p>3.0整合了前两版的优点，增加大模型兼容性的同时，现在能生成更加精细，符合现代审美及设计感的像素画了。同时场景生成方面也获得了强化。建筑，室内，SLG等等都可以尝试下。</p><p>像素画起源于上世纪末，是电脑/游戏机/显示器机能不足下妥协的产物。力求在有限的算力和分辨率限制下绘制出精细的画作。21世纪后，渐渐的硬件水平提高了，像素画也获得了精细度的解放。同时3D技术大行其道，像素艺术家们只能在独立游戏和任天堂掌机上继续创作，同时像素画也作为一种风格继承了下来，由于细节的缺失，反而给人一定的想象的空间。以歧路旅人为代表的HD2D则是其现代精神继任者。</p><p>以此来缅怀那个像素艺术的黄金年代。</p><p>This version integrates the advantages of the previous two versions. While increasing the compatibility of large models, it can now generate more detailed pixel paintings that meet modern aesthetics and design. At the same time, scene generation has also been enhanced. Architecture, interior, SLG, etc. can all be tried.</p><p>Pixel art originated at the end of the last century, and it is the product of compromise under the insufficient performance of computers/game consoles/monitors. Strive to draw fine paintings under the limitation of limited computing power and resolution. After the 21st century, the level of hardware has gradually improved, and pixel art has also been liberated in fineness. At the same time, 3D technology is popular, and pixel artists can only continue to create on independent games and Nintendo handhelds. At the same time, pixel art has also been inherited as a style. Due to the lack of details, it gives people a certain space for imagination. by HD2D represented by Octopath Traveler is its modern spiritual successor. In order to remember the golden age of pixel art.</p><p>このバージョンは、前の 2 つのバージョンの利点を統合し、大規模なモデルの互換性を高めながら、現代の美学とデザインを満たす、より詳細なピクセル ペインティングを生成できるようになりました。 同時に、シーン生成も強化されました。 建築、インテリア、SLGなど、すべてお試しいただけます。</p><p>ドット絵は前世紀末に誕生したもので、パソコン・ゲーム機・モニターの性能不足による妥協の産物です。 限られた計算能力と解像度の中で、精巧な絵を描くように努めます。 21世紀以降、ハードウェアのレベルが徐々に向上し、ドット絵も細かさが解放されてきました。 同時に、3D 技術が普及し、ピクセル アーティストは、独立したゲームや任天堂のハンドヘルドでのみ作成を続けることができます. 同時に、ピクセル アートもスタイルとして継承されています. 詳細が不足しているため、人々に想像力のための特定のスペース。 に オクトパス トラベラーに代表される HD2D は、その現代的なスピリチュアルな後継者です。 ピクセルアートの黄金時代を思い出すために。</p><p>-- -- -- -- -- -- --</p><p>2.0降低了拟合度。能更好的适配各种大模型。更能出结合场景的角色，和更丰富的画面。相对的像素感没那么严格了，比如像素描边少了，更色块化，所以说是像素风更合适，不再是像素画了。喜欢传统像素的推荐继续用1.0.</p><p>2.0 reduces the fit. It can better adapt to various large models. More characters that can combine scenes, and richer pictures. Relatively, the pixel sense is not so strict, for example, there are fewer pixel strokes and more color blocks, so it is more appropriate to say that the pixel style is no longer a pixel painting.Those who like traditional pixels are recommended to continue to use 1.0.</p><p>2.0 ではフィット感が低下します。 さまざまな大型モデルによりよく適応できます。 シーンを組み合わせることができるより多くのキャラクター、およびより豊かな写真。 比較的、ピクセルセンスはそれほど厳密ではありません。たとえば、ピクセルストロークが少なく、カラーブロックが多いため、ピクセルスタイルはもはやピクセルペインティングではないと言う方が適切です.従来のピクセルが好きな方は、引き続き 1.0 を使用することをお勧めします。</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent",
                        "Sell"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 11,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 66336,
                        "favoriteCount": 0,
                        "thumbsUpCount": 8835,
                        "thumbsDownCount": 3,
                        "commentCount": 65,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 10
                    },
                    "creator": {
                        "username": "metalmouse",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a05e3d50-dc08-4679-5e7b-b79c7c9ef900/width=96/metalmouse.jpeg"
                    },
                    "tags": [
                        "anime",
                        "landscapes",
                        "pixel art",
                        "pixel",
                        "style",
                        "video game",
                        "pixelart"
                    ],
                    "modelVersions": [
                        {
                            "id": 52870,
                            "name": "v3.0 (morden_pixel) 现代像素",
                            "index": 0,
                            "modelId": 44960,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>这一版整合了前两版的优点，现在能生成更加精细，符合现代审美的像素画了。</p>",
                            "publishedAt": "2023-04-23T02:40:49.029",
                            "availability": "Public",
                            "trainedWords": [
                                "pixel"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 55655,
                                "ratingCount": 5770,
                                "rating": 5,
                                "thumbsUpCount": 7407,
                                "thumbsDownCount": 3
                            },
                            "files": [
                                {
                                    "id": 38468,
                                    "sizeKB": 147587.1181640625,
                                    "name": "pixel_f2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-23T02:37:09.278Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "8EF00151",
                                        "AutoV2": "DC9DE8C8BA",
                                        "SHA256": "DC9DE8C8BAE899466DF0340A29FF79CF86765A8BE77975EE57EB438BBCFEA433",
                                        "CRC32": "EB0A8BFF",
                                        "BLAKE3": "4A2455ACBA46AF5A8EE382E2312709D0416DF10A6535CC890929120BCF866C25",
                                        "AutoV3": "9D49CA20880D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/52870",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 570669,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/98851cd4-175c-4930-1330-3cfa51676800/width=450/570669.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UeRMVlxu_Nxur?f6tRj[?bjtD%j[%MfQNGaz",
                                    "type": "image"
                                },
                                {
                                    "id": 570632,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/567900d8-db5a-4f03-0dee-cbbb705aef00/width=450/570632.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UdRo~it8_N-;tRWBs:j@%#t6IARjxaayf+WB",
                                    "type": "image"
                                },
                                {
                                    "id": 570634,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f560fae0-93d7-4b7c-71b7-b6db3bad4d00/width=450/570634.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UNOgA:xu_M-:%ffkV@WB%zt6IBRksAV[kWoy",
                                    "type": "image"
                                },
                                {
                                    "id": 570674,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6fbe65d5-c14a-4599-f745-6f03f8e6c700/width=450/570674.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U5LNVy~p=^sD~pxtDjM|00IU0K%MMdIVtS-:",
                                    "type": "image"
                                },
                                {
                                    "id": 570668,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c755a331-01ed-4b0e-2d25-12008fe56200/width=450/570668.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UgRygAxa_Nx]xaafbbkC?ba{D%oLtQofayV@",
                                    "type": "image"
                                },
                                {
                                    "id": 570635,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f0008fe2-f75b-4e01-5c4a-68376995fa00/width=450/570635.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UpQm6ct7~q%M%Mj@RjWC%Mj[M{oeofayofjs",
                                    "type": "image"
                                },
                                {
                                    "id": 570670,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2c389363-b2dc-4d4c-0530-1a1d0007bd00/width=450/570670.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "USPGW@xu?^%MozfQs.ayyDofR5Rj$*aeS4of",
                                    "type": "image"
                                },
                                {
                                    "id": 570640,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80e71323-986d-4f99-be95-6e1a18a7b600/width=450/570640.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 768,
                                    "hash": "UzL4Wxj[?cofogjtayfQ_Noft7of%1fjRkay",
                                    "type": "image"
                                },
                                {
                                    "id": 570641,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5801e4f5-acef-46bc-9c15-01428f4e2500/width=450/570641.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 768,
                                    "hash": "U:NKL=WB~qxutSayjEkC%gofjFafs:bHfkjF",
                                    "type": "image"
                                },
                                {
                                    "id": 570663,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8863dd2e-64e9-4f51-b802-b09bc3032900/width=450/570663.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 768,
                                    "hash": "UIJ@t3IV~W?Zt7t6t6Rk~WxtNERk%0RkRls:",
                                    "type": "image"
                                },
                                {
                                    "id": 570677,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d2f4bdf3-12f9-4627-3a18-93c863324000/width=450/570677.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UcPP+Axa~WxuV@f6WWWV-:jtIoofxuWWxas:",
                                    "type": "image"
                                },
                                {
                                    "id": 570667,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/89683942-6fd5-444d-b99b-69db7f380d00/width=450/570667.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UqOzJQs:_NtRM{ayt7j[x]bHRjoJIUjuxvay",
                                    "type": "image"
                                },
                                {
                                    "id": 570633,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c8fde429-5b16-4c22-10b5-3dd7c6c26800/width=450/570633.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UbRp5zt7~q-:xuj[R*ay-;ofIURktRayjYoe",
                                    "type": "image"
                                },
                                {
                                    "id": 570676,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/37cf6e7d-8355-442b-2ac7-4b34bf478d00/width=450/570676.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UXPGW@%M~paexuf6WCWV-pjsIUofbIayxajZ",
                                    "type": "image"
                                },
                                {
                                    "id": 570664,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b87671e4-b590-4000-8a72-db5215081000/width=450/570664.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 768,
                                    "hash": "UEG[J{xa5ZofTKaywbjs~pfk4oWB-Tj@Ncaz",
                                    "type": "image"
                                },
                                {
                                    "id": 570642,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7da57b9b-630f-43cc-5be9-4ab51eed7600/width=450/570642.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 768,
                                    "hash": "U.Lgqkay_4t7oybHjbjZ%NoetRa}t7ayWXkC",
                                    "type": "image"
                                },
                                {
                                    "id": 570639,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/258e447e-cd52-4c49-f5cf-4e8ce7197a00/width=450/570639.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U,PZllof_NxuIUfQxuayogayWAkCxuj[f5f6",
                                    "type": "image"
                                },
                                {
                                    "id": 570636,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b12e1eca-b796-4fae-dedb-af574cc58b00/width=450/570636.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UpQ9=yof~q%Moff6jsWVx[ofM{aytRWBfkj[",
                                    "type": "image"
                                },
                                {
                                    "id": 581724,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6ee4e2c5-c8eb-4a63-458c-244617ca4a00/width=450/581724.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 920,
                                    "hash": "UAF5y$9ar=?a~W%1M{M|-mxuE2M|9aM|Rjt6",
                                    "type": "image"
                                },
                                {
                                    "id": 581721,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9b436466-72b7-41ad-c015-200ccbabd800/width=450/581721.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 920,
                                    "hash": "U8He8w4:~B~V^+%1%1bb~Vxt01xZSwEM4paL",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/52870"
                        },
                        {
                            "id": 50623,
                            "name": "v2.0 (pixel_style) 像素风",
                            "index": 1,
                            "modelId": 44960,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 11,
                            "description": "<p>2.0降低了拟合度。能更好的适配各种大模型。更能出结合场景的角色，和更丰富的画面。相对的像素感没那么严格了，比如像素描边少了，更色块化，所以说是像素风更合适，不再是像素画了。</p>",
                            "publishedAt": "2023-04-20T09:58:02.844",
                            "availability": "Public",
                            "trainedWords": [
                                "pixel"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 6047,
                                "ratingCount": 901,
                                "rating": 5,
                                "thumbsUpCount": 908,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 37081,
                                    "sizeKB": 147578.986328125,
                                    "name": "pixel_5.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-20T09:55:50.982Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "FFDD6973",
                                        "AutoV2": "A4A3DA4121",
                                        "SHA256": "A4A3DA41217F3867F0BD35EE6B2C4B26323A4BADDC7219C0D70444289B1EF151",
                                        "CRC32": "5B9B9ABF",
                                        "BLAKE3": "D92F35263B8A787FABFE9CD1DD2BC6EF5272F0C4FA6D6048C7866C30F9882029",
                                        "AutoV3": "7A0A1D1524E9"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/50623",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 544319,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7ad7c372-b2fd-4289-8016-d09d642da300/width=450/544319.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UzNAhvj^-=%MWBazfkof~qa_n$R*ofWUn%WB",
                                    "type": "image"
                                },
                                {
                                    "id": 544309,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/28063fac-4ffc-43a9-4444-0b686a77dd00/width=450/544309.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UjP?wBso_Nx]IUayxua{_NkDITjF-;jsaeof",
                                    "type": "image"
                                },
                                {
                                    "id": 544308,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f12d430-5d39-4f02-5c4b-d05512d32b00/width=450/544308.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UzOpx$xa-;o#M{WVt7jZ~qbIaeoJxuoLofW=",
                                    "type": "image"
                                },
                                {
                                    "id": 544322,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5ed868d4-f8d4-4ec4-4df9-b1b470f89900/width=450/544322.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UjOzGNof~qtRMxoybbV[~qofIBnitRRjs:t7",
                                    "type": "image"
                                },
                                {
                                    "id": 544315,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dd9c7507-8a45-4a6c-e58d-1b396a227c00/width=450/544315.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UzPP[lRl.8xts:aykDju_NxaRPa#X9f8n#kB",
                                    "type": "image"
                                },
                                {
                                    "id": 544305,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7592f2e2-33ca-46e3-987d-f7b765153100/width=450/544305.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UJF5$]bbJ.of0Xo0R+Wq~7aywboeE3bHxZWB",
                                    "type": "image"
                                },
                                {
                                    "id": 544312,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/33d51d76-30dd-4f63-98e7-cf58333e3a00/width=450/544312.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UqM%$T%2%#ozD%%2xuay_NozsmaybXRjnlM|",
                                    "type": "image"
                                },
                                {
                                    "id": 544317,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f1bf5126-e296-4d0d-7c80-3f89f828f600/width=450/544317.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UaIEkJ9aOrrs~VIpNwnPIANHRjofwHNGn$oz",
                                    "type": "image"
                                },
                                {
                                    "id": 544320,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/63d6f74d-af46-4c79-c30e-81dfc31b1400/width=450/544320.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKGugeMf0L%e}?RQNIx@E0={w3Na~n$%NH$%",
                                    "type": "image"
                                },
                                {
                                    "id": 544306,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1ca81b64-b175-4343-32a8-8f81caa93500/width=450/544306.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UaQm9moz~p%M%MoMoLj[~pofDjfkjbRjaxja",
                                    "type": "image"
                                },
                                {
                                    "id": 544310,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4ce3866d-0b84-4841-fd5d-9c620ab70500/width=450/544310.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UmQ0Hxs._Nx]MyWBt7of_Nf+D%n$%Ms:V[R*",
                                    "type": "image"
                                },
                                {
                                    "id": 544321,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/494eb5fd-2ae5-4175-78ca-afbfd9f3c900/width=450/544321.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U;N^J8oftTt7skj[WYWB_NoLxZj]XAayxYof",
                                    "type": "image"
                                },
                                {
                                    "id": 544304,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/163a22d8-df8c-43d6-2533-d6a7024dbe00/width=450/544304.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFMtUAxv%#-;~qt6IAX8pIRjMeaL00R,?bVs",
                                    "type": "image"
                                },
                                {
                                    "id": 544307,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d2a0b31-d134-4bdb-2d08-672aedf23e00/width=450/544307.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UKK-B{xuLNs:Fzs-$xNHJCX9xYaJ$xWWWGxD",
                                    "type": "image"
                                },
                                {
                                    "id": 544316,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9c5e15f5-9d7a-4e8c-979c-bdf2ef642100/width=450/544316.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAC$$L^*00D*9FIV%M%200Rj-pa{~pxt4:Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 544311,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e27361b7-b3a8-4a6e-b6f5-bcbf0cc48100/width=450/544311.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UxOWmRkC.8xaV@oLkDWC~qoeRij]x[WVjFt6",
                                    "type": "image"
                                },
                                {
                                    "id": 544314,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/474c7ef4-32d5-4893-039f-6700143a7a00/width=450/544314.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDC%Kj9H0N_2_NaKNZx[0o%1+[IpRNNcZ%aL",
                                    "type": "image"
                                },
                                {
                                    "id": 544323,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a3ad14ff-9614-41e5-ab46-f903cbd76f00/width=450/544323.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8CsBaE300?F?cR%M_t800xs~BNLZ|s;NgM_",
                                    "type": "image"
                                },
                                {
                                    "id": 544318,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f6e7a6c-051f-4364-9f50-5761c21c1500/width=450/544318.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UUKAf#s.9t~8%e-TbIxYnNS#RQs:IVofMyIq",
                                    "type": "image"
                                },
                                {
                                    "id": 544313,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad385bc4-7863-4568-99d9-4c99b2342400/width=450/544313.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UxOplUs.?btRnifRW;of_4WXRPt6ShWBs.a}",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/50623"
                        },
                        {
                            "id": 49584,
                            "name": "v1.0 (pixel_art) 传统像素",
                            "index": 2,
                            "modelId": 44960,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>传统像素画，有着20世纪相对传统的像素笔触。</p><p>Traditional pixel art, with relatively traditional pixel strokes in the 20th century.</p>",
                            "publishedAt": "2023-04-19T05:03:07.853",
                            "availability": "Public",
                            "trainedWords": [
                                "pixel"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4634,
                                "ratingCount": 538,
                                "rating": 5,
                                "thumbsUpCount": 545,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 36496,
                                    "sizeKB": 147578.9921875,
                                    "name": "pixel_4.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-19T05:01:30.693Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "B194C63B",
                                        "AutoV2": "59BCCADA7A",
                                        "SHA256": "59BCCADA7A4A84026E06DA55372D0543A348C46221A20821426C165B7DD359A2",
                                        "CRC32": "2ADB3C46",
                                        "BLAKE3": "83F9CAA7B65BCC951C6AE2D831478AC5CBB2C1019F5AE92E05C7053395E55F3C",
                                        "AutoV3": "B20E6069C7B5"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/49584",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 533208,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f7717bf8-82c6-4320-a4eb-555e3c2c7e00/width=450/533208.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UYRfh3jZ_N?bo0ayxut7.8ofIAV[%MofRPV@",
                                    "type": "image"
                                },
                                {
                                    "id": 533203,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1483a5d2-379b-48bd-ad1d-b9b1aea95100/width=450/533203.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UsRoy;s:?^x]xaj[WWazx]WVMxofofoffkWB",
                                    "type": "image"
                                },
                                {
                                    "id": 533205,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/39f3ef23-3fe8-4bc7-c33e-ccb5668cfb00/width=450/533205.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U45h.FXS00rsE1o0%MSN0Lae~Co|%NW;InsA",
                                    "type": "image"
                                },
                                {
                                    "id": 533210,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0804c106-995e-437c-00ab-4bb9c1777600/width=450/533210.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UeRfd{t7~qxut7j[kCay.7a|IAj[tRj[aef6",
                                    "type": "image"
                                },
                                {
                                    "id": 533211,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/58769240-7321-4cd8-b15d-824de30b4300/width=450/533211.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEC?}{4.00~C1PRjnN%3HX%N-qEK9vxa%hE1",
                                    "type": "image"
                                },
                                {
                                    "id": 533197,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2c428b95-bcb9-4860-0e4f-47d89877f000/width=450/533197.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UCA0zKxY0PSi59NHxYs.05t6^gM|~9xYNdkC",
                                    "type": "image"
                                },
                                {
                                    "id": 533207,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f1badf5f-38bf-4227-4a24-b860c9030800/width=450/533207.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 768,
                                    "hash": "U7FrtVxu2$NF%g-oxV9b1=jb-BobwG9HEM~U",
                                    "type": "image"
                                },
                                {
                                    "id": 533199,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bd2fb163-7bc4-45c9-7317-d61534fb0b00/width=450/533199.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U6KdYnoz03~ocsMyaKt701%M029H$*%LxtE2",
                                    "type": "image"
                                },
                                {
                                    "id": 533215,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f8da7bf7-3944-4f08-425e-2fbb9beff600/width=450/533215.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U.O|FPkC_NxuV@jtozWW%hoeROaykCazoLoe",
                                    "type": "image"
                                },
                                {
                                    "id": 533206,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c24b4f10-eb82-4f15-82b5-a01f0e97c600/width=450/533206.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UCDc25~A9#S5x]xaxas:0zELs*WBIBM{IoIo",
                                    "type": "image"
                                },
                                {
                                    "id": 533196,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c0962a78-91a1-4fb0-94d5-f0fd6daf7e00/width=450/533196.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UnRMVjt8?boet7ofj[WB_4WBD$ofbIV@axt7",
                                    "type": "image"
                                },
                                {
                                    "id": 533212,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/70a5391b-faba-4bc8-5825-8f9d9dca4f00/width=450/533212.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 896,
                                    "hash": "U5E3d.4=TA~lOS%1%0Ip?j?XV#D,^j9bE4-.",
                                    "type": "image"
                                },
                                {
                                    "id": 533198,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/10e86eed-c669-4f12-ee8e-da93dca14900/width=450/533198.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UMN,;}xu_N-;tRfQn%j[%#ofIARj%LfRNGj@",
                                    "type": "image"
                                },
                                {
                                    "id": 533204,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/697cf3aa-6a14-43f0-5fd2-bae08f071700/width=450/533204.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "U-P%CVkC_NxZxvjZbFbHx]s:RPNHWAWCofoe",
                                    "type": "image"
                                },
                                {
                                    "id": 533209,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e172f616-ce05-4b1b-8498-000838e41800/width=450/533209.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UeRW0bxu~qxatRaye.of-;ayIAkC%2ofNHWB",
                                    "type": "image"
                                },
                                {
                                    "id": 533202,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c5b5aa18-8d92-4fe2-1b31-953d2a192000/width=450/533202.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UYR:HGxu~qxu-:j[M{ay?bayD%kCRjfQxuj[",
                                    "type": "image"
                                },
                                {
                                    "id": 533195,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/573460b6-0baa-4821-2e69-a3347402ec00/width=450/533195.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8I5Sp-;.mn,tlWBr=tQ%hWBIAtQ-VozNbM{",
                                    "type": "image"
                                },
                                {
                                    "id": 533201,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/81502d34-2020-42ed-f003-73863d6d2500/width=450/533201.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UiQ]$ofk~q-;M{Rjxuxu-;WBIAozxtj[ayWC",
                                    "type": "image"
                                },
                                {
                                    "id": 533200,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8cbe3d61-5bf2-4502-95d9-b6959aa88200/width=450/533200.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "U68;0]t604IqShoLsoR*0%f8};fixGa#Nboc",
                                    "type": "image"
                                },
                                {
                                    "id": 533214,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ae48c5e7-75ba-45c0-2d1a-5274809b2400/width=450/533214.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U56Rfdt701Ir%0oeIrR*0KWC~Vt5ERWB-Qt7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/49584"
                        }
                    ]
                },
                {
                    "id": 6526,
                    "name": "Studio Ghibli Style LoRA",
                    "description": "<h2>Studio Ghibli style LoRA</h2><p><strong>Making models can be expensive. Do you like what I do? Consider supporting me on </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/Lykon275\"><strong>Patreon</strong></a><strong> 🅿️ or feel free to </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://snipfeed.co/lykon\"><strong>buy me a coffee</strong></a><strong> ☕</strong></p><p>I know there are already various Ghibli models, but with LoRA being a thing now it's time to bring this style into 2023. This is good around <strong>1 weight for the offset version and 0.65 for the old one, </strong>on <strong>Anything v4.</strong>5 for a more authentic style, but it's also good on AbyssOrangeMix2. Triggers with <code>ghibli style</code> and, as you can see, it should work with any character LoRA or TI that didn't overfit on style too. Keep in mind, this is a <strong>style </strong>model not a \"Ghibli characters\" model, so movie characters in the examples are made using careful prompting, meaning it can reproduce similar characters, but it won't make them perfectly (unless you also use other TI/LoRA's).</p><p>4th pic by <strong>Karkaz </strong>using also his own character LoRA.</p><p>Last pic by <strong>LottaLewds</strong>.</p><p><br /><strong>How to use LoRA's in auto1111:</strong></p><ul><li><p>Update webui (use <code>git pull</code> <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/embed/mn8fMF10XN4?start=31&amp;end=60\">like here</a> or redownload it)</p></li><li><p>Copy the file to <code>stable-diffusion-webui/models/lora</code></p></li><li><p>Select your LoRA like in <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/watch?v=-bMeyXOZwN0\">this video</a></p></li><li><p><strong>Make sure to change the weight if needed</strong> (by default it's <code>:1</code>)</p></li></ul>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 67052,
                        "favoriteCount": 0,
                        "thumbsUpCount": 8168,
                        "thumbsDownCount": 0,
                        "commentCount": 40,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 10
                    },
                    "creator": {
                        "username": "Lykon",
                        "image": "https://cdn.discordapp.com/avatars/180327464155742208/59254be18ccd627daf138d053327485d.png"
                    },
                    "tags": [
                        "anime",
                        "landscapes",
                        "studio ghibli",
                        "ghibli",
                        "style",
                        "art style",
                        "artstyle"
                    ],
                    "modelVersions": [
                        {
                            "id": 7657,
                            "name": "offset",
                            "index": 0,
                            "modelId": 6526,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-02-04T00:58:03.443",
                            "availability": "Public",
                            "trainedWords": [
                                "ghibli style"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 65425,
                                "ratingCount": 439,
                                "rating": 4.99,
                                "thumbsUpCount": 580,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 10272,
                                    "sizeKB": 147567.2177734375,
                                    "name": "ghibli_style_offset.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-15T18:55:51.864Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "FE6DEB79",
                                        "AutoV2": "6BB3719E90",
                                        "SHA256": "6BB3719E90D33A9E88EA090CD4463D15EF68234E2ACAAC2A482186A8B7A30878",
                                        "CRC32": "0448A7C0",
                                        "BLAKE3": "98CEF41BEFBE984F865F4D5D68DDC1A444C61CD48D56197387C7C2EBA4FD324F",
                                        "AutoV3": "708C39069BA6"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/7657",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 71811,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/56eb9234-3106-48b2-14b2-ee622841b500/width=450/71811.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UHHe|5Me9@%gPlMy9^g200E1~Wt7?uE1wzxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 71820,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6fd51fbd-2bee-4eed-014a-75497496f300/width=450/71820.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UfM%4ToJ9GD*~oRPx^xux]oLogxa%1t7RkWY",
                                    "type": "image"
                                },
                                {
                                    "id": 71819,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dc09fe58-9049-4f17-c3fe-75e618f6a600/width=450/71819.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UQGlt#*IJP%g^%krI]$gE1spIrV?Its+wbOW",
                                    "type": "image"
                                },
                                {
                                    "id": 71818,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cbcb61f6-938e-40a8-55cb-5519b0e62700/width=450/71818.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UDH2QRTL00?b=Xnf,;M{yX_4T1I;4:$%-nkC",
                                    "type": "image"
                                },
                                {
                                    "id": 71817,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5540b8ad-fb1b-42c0-20fb-0e1c8d135000/width=450/71817.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "USGv37Mey?eo-oRjXRM|Z$R%-okB4oxExtay",
                                    "type": "image"
                                },
                                {
                                    "id": 71816,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/be9dcd80-0cd4-46de-dd5d-4407dfedee00/width=450/71816.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UGG9pJ%LudcX~m?aI:Rj56S$Iqv$x[S5ayV[",
                                    "type": "image"
                                },
                                {
                                    "id": 71815,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/40cf9fdd-32a9-4df9-3e50-3cb5a1aced00/width=450/71815.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UFJHwB~W00xaMIw{014n0$?v^j%1?u4.r=tl",
                                    "type": "image"
                                },
                                {
                                    "id": 71814,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bd9db829-82a1-470b-1539-c47d1d622900/width=450/71814.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UWNJOH^*~6oynMxtyDo#adofs:RkShs:jYR+",
                                    "type": "image"
                                },
                                {
                                    "id": 71813,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ee9b6d26-c3ce-442b-c648-646e1935fe00/width=450/71813.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UBGb@y0000~W-1DPF@nU57M{~VRPcuI:rsxa",
                                    "type": "image"
                                },
                                {
                                    "id": 71812,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ae7c6304-ea2d-4377-be91-d24ad6c21200/width=450/71812.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UIJt|*~S0NX8S*9z5rn$f3NH$*%1%Es+I^Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 72022,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/abbe2a24-480d-422d-c8f5-ca26e98ed900/width=450/72022.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1408,
                                    "height": 896,
                                    "hash": "U3CZLxD%00%M^Exu0Qs;00xa?=R*5RovMcjc",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/7657"
                        },
                        {
                            "id": 10913,
                            "name": "original",
                            "index": 1,
                            "modelId": 6526,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-02-15T18:54:02.861",
                            "availability": "Public",
                            "trainedWords": [
                                "ghibli style"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1627,
                                "ratingCount": 6184,
                                "rating": 5,
                                "thumbsUpCount": 7640,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 10273,
                                    "sizeKB": 147568.7265625,
                                    "name": "ghibli_style.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-15T18:55:52.177Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "89A9200C",
                                        "AutoV2": "7DE0EDB2D1",
                                        "SHA256": "7DE0EDB2D147F7E5ACD11F50DBB3A3D3434BBE50A54D146EEAA901C48BC25A33",
                                        "CRC32": "33550288",
                                        "BLAKE3": "22C3E8E801FC624845EB418F39C2438E3AC9924EC80797F71C995D91F8035C88",
                                        "AutoV3": "60BA476B8038"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/10913",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 105528,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a93ef105-3b50-4948-b4c6-b910b6adcc00/width=450/105528.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 895,
                                    "hash": "UqNJXjoLfQs:_Maxj[Rj%gofj[ofxvkCfkof",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/10913"
                        }
                    ]
                },
                {
                    "id": 15464,
                    "name": "A-Mecha Musume A素体机娘",
                    "description": "<p>SSS: you can try super_robot_joints</p><p>=============</p><p>Thanks to the original author 搞事德·乔斯达's wonderful thought and generosity, now A-Mecha Musume is released on Civitai.</p><p>感谢原作者搞事德·乔斯达的奇思妙想和慷慨大方，A素体机娘在Civitai上发布了。</p><p>Credit to 宫下雫空 for his help.</p><p>感谢宫下雫空的帮助。</p><p>==========================</p><p>REN: You can add color to mecha.</p><p>你可以给机甲加颜色。</p><p>==========================</p><p>Before SuperMecha</p><p><strong>Trigger Words: mecha musume, mechanical arms, headgear, bodysuit (Optional)</strong></p><p>Suggested Weight: 1~ 1.5</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 58839,
                        "favoriteCount": 0,
                        "thumbsUpCount": 8006,
                        "thumbsDownCount": 1,
                        "commentCount": 15,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 130
                    },
                    "creator": {
                        "username": "rerorerorero",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fb9a79d9-87e3-412f-a5fa-d60911ba67db/width=96/rerorerorero.jpeg"
                    },
                    "tags": [
                        "anime",
                        "girl",
                        "science",
                        "female",
                        "cyborg",
                        "science fiction",
                        "mecha",
                        "android",
                        "highly detailed",
                        "clothing",
                        "mechanized",
                        "mecha musume"
                    ],
                    "modelVersions": [
                        {
                            "id": 97207,
                            "name": "SSS",
                            "index": 0,
                            "modelId": 15464,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>You can choose color theme too.</p><p>Headgear is optional.</p><p>Should work well with character loras. (Mecha Aqua!)</p>",
                            "publishedAt": "2023-06-16T11:32:13.634",
                            "availability": "Public",
                            "trainedWords": [
                                "mecha musume",
                                "mechanical parts",
                                "robot joints",
                                "headgear"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 24940,
                                "ratingCount": 1406,
                                "rating": 4.99,
                                "thumbsUpCount": 2670,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 67574,
                                    "sizeKB": 73838.029296875,
                                    "name": "AMechaSSS[color_theme,mecha musume, mechanical parts,robot joints,headgear].safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-16T11:30:52.368Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "F088B6AA",
                                        "AutoV2": "0E8235519A",
                                        "SHA256": "0E8235519AA94F17A06388110DEBC1E6B92984C26FAE7E917CBA5814274208E4",
                                        "CRC32": "20D74F8C",
                                        "BLAKE3": "9183A87A7B1372E053E3C39EE995C5F3264EF8C9278B7D4D796194A2E147A799",
                                        "AutoV3": "8120C60161EC"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/97207",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1165567,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/735bcec7-0ec8-4176-9b0b-f75dd8cb2aa7/width=450/1165567.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1152,
                                    "hash": "UBA13M4n9ER+~WD$ITMxs+X9t8MxawRPofoz",
                                    "type": "image"
                                },
                                {
                                    "id": 1165568,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3d71ec43-9438-4b92-9eb1-c647b14b955a/width=450/1165568.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "UFCP^tRkD$xu~pM|R%ofD$M{-;RjIUM{jbIU",
                                    "type": "image"
                                },
                                {
                                    "id": 1165566,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/94381f6d-c03a-431b-8ea8-3e32404b6af3/width=450/1165566.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "UDC6lo%29E%2~W%2D%xZ00oLM{oME0IoR-R*",
                                    "type": "image"
                                },
                                {
                                    "id": 1165569,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/357ca614-c996-4fc2-b07e-16efd9b340ff/width=450/1165569.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "UTJt}Cs8yWb_~qxuoyxa_3of.7t7?bM{xtoz",
                                    "type": "image"
                                },
                                {
                                    "id": 1165574,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d3844b61-c78e-4978-ad27-8175730aedba/width=450/1165574.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "UdLE7}s-_NtS~Woz%LWB%Mj[W.fPR+RjWBt7",
                                    "type": "image"
                                },
                                {
                                    "id": 1165586,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f8e541c2-cd47-4a07-bebe-f89d11dab5bd/width=450/1165586.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "UUJt@@xatmR*~qkCRjRP_3ay-;oe_3oft7t7",
                                    "type": "image"
                                },
                                {
                                    "id": 1165595,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e8e3659-0e34-4c00-aaf0-803594c2a70d/width=450/1165595.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "UYKK+$sRXQNe_Nt8xZWB~qWY-pt6%MoexaR*",
                                    "type": "image"
                                },
                                {
                                    "id": 1165655,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/de318da8-137c-4cb1-b2a3-ff837796fd9c/width=450/1165655.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "UPJ*h,?bXStl%LtRD%WB~qWB%MRj_Nays:WA",
                                    "type": "image"
                                },
                                {
                                    "id": 1165667,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2ab9538c-e61b-4111-b4e1-7981a7e52578/width=450/1165667.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "USK1j~s:OsXT?vt7Riad_4of-pt7~qWBxuWX",
                                    "type": "image"
                                },
                                {
                                    "id": 1165704,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dcf6d533-1d24-44ba-8ae9-1276489b1949/width=450/1165704.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "UQK-a@~Wt,?vx]%NV?%2?cIVV@xZxuM{RkM|",
                                    "type": "image"
                                },
                                {
                                    "id": 1165719,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/99f2cfa9-78f0-4f7a-9ec5-cf226e5e7662/width=450/1165719.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "U3B{$J~V0000.8oe4TIV0K9Z}[~W?HRjEK%f",
                                    "type": "image"
                                },
                                {
                                    "id": 1165725,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7d70a016-1803-4c26-bb48-20602993add2/width=450/1165725.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "U4Db._^+00010JW;DNRP00E1~V?G^+xaxvS1",
                                    "type": "image"
                                },
                                {
                                    "id": 1165821,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c183f8d3-4fb4-4dfe-82a5-3d07eef031a8/width=450/1165821.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "UADlWq~V00IVELRkD%E10Ks.~Ct7RkE19txH",
                                    "type": "image"
                                },
                                {
                                    "id": 1165859,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cd49271b-a4d6-482f-8244-f366b6754d0f/width=450/1165859.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "UXHeC6~WELofIos:xZNaE1M|V@RPs;ofWVoL",
                                    "type": "image"
                                },
                                {
                                    "id": 1165953,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/62a88e19-2ee2-493b-ac28-ca6f47c97e1e/width=450/1165953.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "U7CPbUR+00%2~XWB9F%29ut7$*Rj~Vjb4.of",
                                    "type": "image"
                                },
                                {
                                    "id": 1173910,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c4d7dc01-6c15-4de4-a4c8-fab2d878d7d7/width=450/1173910.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "U9EVTz9t00~WENxaRiR*oeIonht7jqofNH%M",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/97207"
                        },
                        {
                            "id": 58149,
                            "name": "REN",
                            "index": 1,
                            "modelId": 15464,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>Use \"color_theme\" like \"black theme\" \"red theme\" \"blue theme\" to get the color you want.</p>",
                            "publishedAt": "2023-04-29T13:51:46.315",
                            "availability": "Public",
                            "trainedWords": [
                                "mecha musume",
                                "mechanical parts",
                                "robot joints",
                                "headgear",
                                "full armor"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 12724,
                                "ratingCount": 1908,
                                "rating": 5,
                                "thumbsUpCount": 1910,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 41382,
                                    "sizeKB": 73838.029296875,
                                    "name": "A-Mecha-REN[color_theme,mecha musume, mechanical parts, robot joints,headgear,full armor].safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-29T13:55:36.048Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "A3C27432",
                                        "AutoV2": "9F269D9701",
                                        "SHA256": "9F269D97010AB144E3B16805FC4C7A1EAB5CFA16A2880807530D2D1F2EFF0EA9",
                                        "CRC32": "DAA8C027",
                                        "BLAKE3": "8DD8B227EA8DC628245DAD38F496BF63107681215643F717EE6F5F3F261352B4",
                                        "AutoV3": "C0048738E492"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/58149",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 632444,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/199ca7f1-c6a9-4406-124f-b1f764dc7500/width=450/632444.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6A,qY0000%N~Wen00oe4m?c9FoznMj?%hR%",
                                    "type": "image"
                                },
                                {
                                    "id": 632455,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3a56c0c8-124f-42d7-dec8-bedf0086c400/width=450/632455.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UCDc,t%i00Dh%J_44mD%D%xu?H9F%gM{xb%N",
                                    "type": "image"
                                },
                                {
                                    "id": 632456,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/deafad3b-fe31-4b23-d284-12ddb5898300/width=450/632456.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "U7FEl|0e00:P*0tR000e00-=9FaJ9ttS-VSM",
                                    "type": "image"
                                },
                                {
                                    "id": 632457,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4c54d6bc-3d94-4ed5-4c35-a33dcf896900/width=450/632457.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UBF6CI~XIn4.^*of009Z9EWCNGRjoyog%MoI",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/58149"
                        },
                        {
                            "id": 19689,
                            "name": "ARC",
                            "index": 2,
                            "modelId": 15464,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 10,
                            "description": null,
                            "publishedAt": "2023-03-07T04:49:03.021",
                            "availability": "Public",
                            "trainedWords": [
                                "mecha_musume",
                                "headgear",
                                "mechanical_arms",
                                "bodysuit"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 9004,
                                "ratingCount": 2085,
                                "rating": 5,
                                "thumbsUpCount": 2085,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16439,
                                    "sizeKB": 147567.2177734375,
                                    "name": "A素体机娘ARC【mecha musume, mechanical arms, headgear可选bodysuit,】.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-07T04:51:44.200Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "F9A1DA45",
                                        "AutoV2": "C5212E4D46",
                                        "SHA256": "C5212E4D462865A219256DC6F155CAB453BA1619B48D635D5584C1A2E1BEC03C",
                                        "CRC32": "26E75EAB",
                                        "BLAKE3": "504C8F3DD4C469F1B86BFF7AAE9AA8FD50EBEBDDF1FC59BED205760F3F9D6499",
                                        "AutoV3": "4C3627787245"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/19689",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 207202,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/033e1dbb-c1f9-4d83-7984-0cc6966a8600/width=450/207202.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UJIOY5NFE0-;~pxu00xt?axuRPof~qtSsmM|",
                                    "type": "image"
                                },
                                {
                                    "id": 207201,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7eb99cad-6dcb-453d-3a7f-7913d0b63600/width=450/207201.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UkIOhPx]xu-;~qofod%M%LV@s:s:xujZt7ae",
                                    "type": "image"
                                },
                                {
                                    "id": 207208,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c0712308-a43c-4317-62a0-af19fa0f2c00/width=450/207208.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UmJ8bSIV%M%M~qM{t7t7-:aebIa{t6%Moef6",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/19689"
                        },
                        {
                            "id": 79956,
                            "name": "SuperMecha",
                            "index": 3,
                            "modelId": 15464,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>highly mechanized</p><p>suggested weight 0.65~0.85</p>",
                            "publishedAt": "2023-05-24T16:07:49.131",
                            "availability": "Public",
                            "trainedWords": [
                                "mecha musume",
                                "mechanical parts",
                                "super robot joints",
                                "full armor",
                                "headgear"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 9826,
                                "ratingCount": 1014,
                                "rating": 5,
                                "thumbsUpCount": 1017,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 54858,
                                    "sizeKB": 73838.029296875,
                                    "name": "A-RandomSuper[mecha musume,mechanical parts,super robot joints,headgear,full armor].safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-24T16:06:10.314Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "04BE0A79",
                                        "AutoV2": "18979373C4",
                                        "SHA256": "18979373C4E32C964B88B630472C152797C2CD79C70497B3025381BB2BF96A7C",
                                        "CRC32": "338A4E9E",
                                        "BLAKE3": "693723B3478D01957B1B0A2E3FBB38F28917907EAEFD15A22C6E200826809C32",
                                        "AutoV3": "76B4400E5E2B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/79956",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 897264,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/81d01ff1-e1e5-4912-ac37-fbdc8a018eaa/width=450/897264.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6Aw9*0000_4~XR500M_4T?vIARO9Z-pxvx^",
                                    "type": "image"
                                },
                                {
                                    "id": 897243,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4a66729e-e23a-4c8a-8079-8602b1c32815/width=450/897243.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5AwG05lDk0J}7?v4T550w=}9[$Q8^4-_3-p",
                                    "type": "image"
                                },
                                {
                                    "id": 897238,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/306053f1-f883-4f6d-9c12-7a2403883b4e/width=450/897238.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBA,^F?wNFNGvzRODhV@D%j]R*WAyDx]%ho#",
                                    "type": "image"
                                },
                                {
                                    "id": 897247,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/004cc816-0452-49f5-90c5-74449e365862/width=450/897247.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBEC%%oL8w%M00t7o|D%?^t7Ipt7rrD%-pxu",
                                    "type": "image"
                                },
                                {
                                    "id": 897239,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0488af65-f1bd-421e-a992-92948d383a1c/width=450/897239.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8Av|Z4.0JRi~Wt80JInE0%NIUoz$*Inx]-q",
                                    "type": "image"
                                },
                                {
                                    "id": 897241,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fee0680d-687e-4810-a449-b788528ddc96/width=450/897241.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7C?+cI@5r_44T%10KDhS|%hado}004n^OgO",
                                    "type": "image"
                                },
                                {
                                    "id": 897240,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f7aa323d-c655-4dcf-89dd-ade2333f4d99/width=450/897240.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCBgSn?wIUtlL#I9D%D$.9tRt7%gEMR*p0WB",
                                    "type": "image"
                                },
                                {
                                    "id": 897242,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7280265a-2dea-42ca-849e-2c71cadbe17c/width=450/897242.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFB|mcMzDhVr4T-=XSR-?wbJM|tRozWCxvV?",
                                    "type": "image"
                                },
                                {
                                    "id": 897244,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4ff1a1bf-7aa6-4d8f-aa87-7202a4954520/width=450/897244.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7BV@g0%8w=_~qEM9E-V0e-TNHIo01^PtmR-",
                                    "type": "image"
                                },
                                {
                                    "id": 897246,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/27df4e1c-4e5c-4522-b83f-b7d9842ba49d/width=450/897246.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAAdN9?w4.EM-9VX4mIA9FSix^x]S1WA%2xa",
                                    "type": "image"
                                },
                                {
                                    "id": 897245,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/62c85ccf-26cc-4076-a796-db2d2868fc1b/width=450/897245.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9AKBqE100%M?wt78^t700s:%MR*ELWBxDRk",
                                    "type": "image"
                                },
                                {
                                    "id": 897261,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ea5a09d8-2ad5-4afa-97ea-7021b77650cb/width=450/897261.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7DI^90000?bFd~C9GEK4TR+o#$+Dh9Z=}JB",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/79956"
                        },
                        {
                            "id": 18237,
                            "name": "V1",
                            "index": 4,
                            "modelId": 15464,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-03-04T00:58:28.203",
                            "availability": "Public",
                            "trainedWords": [
                                "mecha musume",
                                "mechanical arms",
                                "headgear",
                                "bodysuit"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2345,
                                "ratingCount": 370,
                                "rating": 5,
                                "thumbsUpCount": 371,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 15260,
                                    "sizeKB": 147567.2177734375,
                                    "name": "A-MechaMusume[mecha musume, mechanical arms, headgear][bodysuit].safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-04T01:01:37.839Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "B2D1A8F8",
                                        "AutoV2": "04EFF387B9",
                                        "SHA256": "04EFF387B9CCE1669FF89AC70C47951D93CF1DAE8E5E6995EE60B440F6755167",
                                        "CRC32": "408AA557",
                                        "BLAKE3": "65ABD44F58566829289BD222E7F38C35CE2FA14905D18244175AD4E0AE3912B6",
                                        "AutoV3": "5E99A356B893"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/18237",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 187681,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/153f1806-f258-44f4-9a9d-86586dfc2a00/width=450/187681.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UZIh:MRj%L.8~qx]oIjY-;M{RPWVx]Rjaef6",
                                    "type": "image"
                                },
                                {
                                    "id": 187686,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d5ee64f7-e4dd-4e16-3571-157e9a085500/width=450/187686.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UBGc4D#jE0%$00IoMcD%?wi_4:xuDO9a?bt8",
                                    "type": "image"
                                },
                                {
                                    "id": 187685,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2899a4c5-2dfa-414c-f57a-19aecaf79500/width=450/187685.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UaJI34~px]x]IUt7RPM{9GIUM{aeRPayayWC",
                                    "type": "image"
                                },
                                {
                                    "id": 187684,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9f382510-2e4f-4b28-758b-f23eb86ec100/width=450/187684.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "UGI#$9%L_N%g00Ri00M{_Mt7s9xaRjV[~q-;",
                                    "type": "image"
                                },
                                {
                                    "id": 187683,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a98ad8ae-5390-4965-7ad1-b0090383d900/width=450/187683.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "UZI#u?-;xux]~qMxj]%M?voz%2-:?HRjM{M{",
                                    "type": "image"
                                },
                                {
                                    "id": 187731,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a19fdaf4-f19c-486c-6534-a9aaa3d5cc00/width=450/187731.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "UQJt*o_Nt7ozIV4.MxNGROShsooen~bct7e.",
                                    "type": "image"
                                },
                                {
                                    "id": 187730,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1432fe85-853b-4bce-0100-ef7d06579b00/width=450/187730.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1408,
                                    "hash": "UPJkfp~qNZ?b_2-:Mx%2ozNHIUW;s.ITV?Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 187682,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/01eab50f-7515-47c8-d6a0-f4c6730f8300/width=450/187682.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UAHLMI010001E3v|9F?b9^n$9t?H?^XTn24U",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/18237"
                        }
                    ]
                },
                {
                    "id": 7563,
                    "name": "【Character】alice (nikke)",
                    "description": "<h3>2023/3/3 update</h3><p>Update dataset and model. Reduce loss to ~0.1 using Lion optimizer. Adjust rank to 32 to balance file size and quality.</p><h3>2023/2/16 update</h3><p>Use offset noise to improve ability to generate lighter/darker images. Reduce model file size to ~1MB. <strong>Preview images of new version are generated using Abyss Orangemix2 Hardcore.</strong></p><h3>2023/2/11 update</h3><p>Use tag dropout to prevent overfitting and enhance unconditional generating.</p><h1>Introduction</h1><p>A LORA model of alice in Goddess of Victory: NIKKE. The NAI's VAE is recommended. 0.6~0.8 weights are good.</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 25,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 48955,
                        "favoriteCount": 0,
                        "thumbsUpCount": 7224,
                        "thumbsDownCount": 1,
                        "commentCount": 11,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 40
                    },
                    "creator": {
                        "username": "zakp",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/82d458b6-5669-447f-a826-7de19e18f9e9/width=96/zakp.jpeg"
                    },
                    "tags": [
                        "anime",
                        "character",
                        "girl",
                        "game character",
                        "girls"
                    ],
                    "modelVersions": [
                        {
                            "id": 18060,
                            "name": "v3.0",
                            "index": 0,
                            "modelId": 7563,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 31,
                            "description": "<p>Update dataset and model. Reduce loss to ~0.1 using Lion optimizer. Adjust rank to 32 to balance file size and quality.</p>",
                            "publishedAt": "2023-03-03T15:50:06.847",
                            "availability": "Public",
                            "trainedWords": [
                                "alice \\(nikke\\)",
                                "pink bodysuit",
                                "animal ear headphones",
                                "shiny clothes",
                                "twintails",
                                "latex bodysuit"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 40490,
                                "ratingCount": 5194,
                                "rating": 5,
                                "thumbsUpCount": 5898,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 15103,
                                    "sizeKB": 36984.3193359375,
                                    "name": "alice-lora-v3-32dim-20ep.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-03T15:55:40.462Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "C88ABECB",
                                        "AutoV2": "226040C30E",
                                        "SHA256": "226040C30E3F0F1BF5728848195B4013A9C060F6914F65E86D57E15791A82501",
                                        "CRC32": "86975D85",
                                        "BLAKE3": "0FC2A1F5A6F7BA1B50F46652F351518776F9235C4F2A7CE6CEE2C0711A36A366",
                                        "AutoV3": "606518FB9A1F"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/18060",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 185348,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/482fad17-956c-43b6-d815-a9aefce57300/width=450/185348.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USMZXkNHu4xv?^RjxZRP%NsoRjtQ-V%MRjWV",
                                    "type": "image"
                                },
                                {
                                    "id": 185347,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/93a4bd0d-0f13-4cec-9748-ebb50682e600/width=450/185347.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7HBJM~V000002E14.E15k?H^js:Mx0LD%^+",
                                    "type": "image"
                                },
                                {
                                    "id": 185346,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/47d6852b-fc19-41d5-d184-d0103295a200/width=450/185346.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USL:p2^+TwWB?^jtxaM|%2M{NZV@t7aK%2of",
                                    "type": "image"
                                },
                                {
                                    "id": 185345,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/444035ad-54db-490f-31f4-ef625f8e9e00/width=450/185345.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQI;VcWU7K^kp{%1?IofS*xtRk%Msq%2E1oz",
                                    "type": "image"
                                },
                                {
                                    "id": 185344,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c50ed7bb-475e-4eb5-b8bb-ba55fa2e2400/width=450/185344.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIHmyO-;0d}[I.rr#SEK56V@RP9sJ8o}%M-V",
                                    "type": "image"
                                },
                                {
                                    "id": 185343,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f3e0df7e-ae14-419c-6328-36b116d62c00/width=450/185343.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNMZg:-;y=s:%fa0a0o}?bSLs:eTNbM{V@of",
                                    "type": "image"
                                },
                                {
                                    "id": 185342,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c5ee161f-3e14-48bf-41d3-7b5d2b14bf00/width=450/185342.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UeOy-SMy?^%gx]tRo0RP_Naes.tRogoLWVof",
                                    "type": "image"
                                },
                                {
                                    "id": 185341,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a4da574e-559f-4414-1a7e-5b45d54ca100/width=450/185341.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9IgNC001E4:0LxGDiozXN^*VE-:}vSg0dxa",
                                    "type": "image"
                                },
                                {
                                    "id": 185340,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2f1d5f33-f3d1-4806-49b6-377ac356c000/width=450/185340.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKL:ySRQ%#xuyCkVNZ%2y?RjsTkBrE%2nOt7",
                                    "type": "image"
                                },
                                {
                                    "id": 185339,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/23a6425f-e4e1-43ef-380a-d459b9775e00/width=450/185339.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNJsw,~C0eNGGZX8r?w{D*s:tQR*ScWBE1WB",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/18060"
                        },
                        {
                            "id": 11075,
                            "name": "v2.5",
                            "index": 1,
                            "modelId": 7563,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 25,
                            "description": "<p>Use offset noise to improve ability to generate lighter/darker images. Reduce model file size to ~1MB. <strong>Preview images are generated using Abyss Orangemix2 Hardcore.</strong></p>",
                            "publishedAt": "2023-02-16T06:01:56.647",
                            "availability": "Public",
                            "trainedWords": [
                                "alice \\(nikke\\)",
                                "latex bodysuit",
                                "pink bodysuit",
                                "headphones",
                                "twintails",
                                "animal ear headphones",
                                "shiny clothes"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5751,
                                "ratingCount": 1050,
                                "rating": 5,
                                "thumbsUpCount": 1050,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 10380,
                                    "sizeKB": 1268.2451171875,
                                    "name": "alice-lora-v3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-16T06:05:52.486Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV2": "D05093E38F",
                                        "SHA256": "D05093E38FC00256E0887E9E43CB0DEACC06E42D93FE2EE1143AE91E4A2A8972",
                                        "CRC32": "7823E314",
                                        "BLAKE3": "C4E92738A7FE3A090E37BD19010A3B4E7B8E5575CFC9C635E79B36D3F1D8596C",
                                        "AutoV3": "68A41090DF31"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/11075",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 106800,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/abf27216-f85c-4528-ce7d-3ff165677a00/width=450/106800.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "ULMGh$4o*Itl~qtl$+%M?vn%ozNGtl8_yC%2",
                                    "type": "image"
                                },
                                {
                                    "id": 106799,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80e68021-6697-4878-a0d7-e19f833a0800/width=450/106799.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UUJaA;~WFwI:pHt7r@sp9FRQRPR*ozWBjYRj",
                                    "type": "image"
                                },
                                {
                                    "id": 106798,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/74f8298a-c9e7-46d4-57a3-2eb3c49e6100/width=450/106798.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UUJ7B.~VAA%LKOx[WrxutQkC=|xukEt8NGWW",
                                    "type": "image"
                                },
                                {
                                    "id": 106797,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9909c551-d0c4-4d07-d83c-f0b5f205bb00/width=450/106797.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UcMZn5-;yXS4_NaKxaWBx[t7oykBV@M{ofWB",
                                    "type": "image"
                                },
                                {
                                    "id": 106796,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e7811a24-9761-4cce-bb98-dc63e16b1e00/width=450/106796.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UUKJx~~WF^$*.8x]Rjf*tlxuw}$*%MtRkWI:",
                                    "type": "image"
                                },
                                {
                                    "id": 106795,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/519552b3-32ff-4bdc-8a5e-a45933b0b400/width=450/106795.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UGLMeg~B0d%L0Mo}nO9Z00xus:R*?bM{E1-:",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/11075"
                        },
                        {
                            "id": 8886,
                            "name": "v2.0",
                            "index": 2,
                            "modelId": 7563,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 24,
                            "description": null,
                            "publishedAt": "2023-02-09T03:02:28.789",
                            "availability": "Public",
                            "trainedWords": [
                                "alice \\(nikke\\)",
                                "latex bodysuit",
                                "pink bodysuit",
                                "headphones",
                                "twintails",
                                ":d",
                                "animal ear headphones",
                                "shiny clothes",
                                "sniper rifle",
                                "rifle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2714,
                                "ratingCount": 287,
                                "rating": 5,
                                "thumbsUpCount": 287,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 9141,
                                    "sizeKB": 147576.6162109375,
                                    "name": "alice-lora-ucg-v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-11T10:06:07.580Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "DFD5753F",
                                        "AutoV2": "9004362296",
                                        "SHA256": "90043622969AC8AD66B051A1F7E41CAA7BE656C9BA76D9140654F30F17C5C572",
                                        "CRC32": "BC185979",
                                        "BLAKE3": "334363CEB81063AF5F362FE5006234123714C67AEB8B6ADC4363BC6388E77136",
                                        "AutoV3": "F63EDE70B21D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/8886",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 90725,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/81ecf9d6-bd2d-4a61-b09b-227da0c1a700/width=450/90725.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UVMspObbYOoM_3oz-pnj_NRjxat7%M%MoyS1",
                                    "type": "image"
                                },
                                {
                                    "id": 90724,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/84a23bb4-58b1-43d8-ac48-e5b5b9943600/width=450/90724.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UGMs1;Q.%$pv|5u3+L#U^,tRzrxu:?a1M{NZ",
                                    "type": "image"
                                },
                                {
                                    "id": 90723,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d3c6f26-77fa-4c85-01ec-2c1fcde16c00/width=450/90723.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "USLf|5Or%~-o_M%3%2WU.8XR-qr]%Ms.NGo#",
                                    "type": "image"
                                },
                                {
                                    "id": 90722,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bf3bcc2b-67e5-4abc-e8de-f9a8c038be00/width=450/90722.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UUH_JzizKK5;*0E2xaWtSiWCRjM{xHoKRjVs",
                                    "type": "image"
                                },
                                {
                                    "id": 90721,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c46fc9ef-10ac-4826-71ee-0b450ac70700/width=450/90721.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "U4JGjN0000~q0]00?|xu00kS8w?HcsIUS|^l",
                                    "type": "image"
                                },
                                {
                                    "id": 90720,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/90aaa43a-dd18-4872-ab0f-abf937475300/width=450/90720.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "U9H,*u0K1txbG[R79?~C0vniMd%N}wtR4nIn",
                                    "type": "image"
                                },
                                {
                                    "id": 90719,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/08352500-8df8-4cf5-5b3d-70fe4a653900/width=450/90719.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "U9K9=o1ZUFzY0_HY9F0dUG?^#q9Y4nO=WA?H",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/8886"
                        }
                    ]
                },
                {
                    "id": 5373,
                    "name": "Makima (Chainsaw Man) LoRA",
                    "description": "<h2>Makima (Chainsaw Man) LoRA</h2><p><strong>Making models can be expensive. Do you like what I do? Consider supporting me on </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/Lykon275\"><strong>Patreon</strong></a><strong> 🅿️ or feel free to </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://snipfeed.co/lykon\"><strong>buy me a coffee</strong></a><strong> ☕</strong></p><p>There is already a pretty good embedding, but this was still requested as a LoRA net, so I made it.</p><p>I've tested it on some of my anime models and seems to work as per usual. You find prompts and models in the PNG data reported in the info (bottom right corner of the pics). <strong>Pic 2 and 5 have been made using </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/10028\"><strong>NeverEnding Dream (NED)</strong></a><strong>.</strong><br /><br />The main trigger word is <code>makima \\(chainsaw man\\)</code> but, as usual, you need to describe how you want her, as the model is not overfitted. Weight should be <strong>between 1 and 1.4 for the offset version (0.5-0.7 for the original one)</strong>. The pic with the bunny costume is also using my <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/4844/ratatatat74-style-lora\">ratatatat74 LoRA</a>. Pic 1, 3, and 10 have been made by <strong>Joobilee</strong>.</p><p></p><p><strong>How to use LoRA's in auto1111:</strong></p><ul><li><p>Update webui (use <code>git pull</code> <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/embed/mn8fMF10XN4?start=31&amp;end=60\">like here</a> or redownload it)</p></li><li><p>Copy the file to <code>stable-diffusion-webui/models/lora</code></p></li><li><p>Select your LoRA like in <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/watch?v=-bMeyXOZwN0\">this video</a></p></li><li><p><strong>Make sure to change the weight according to the instructions </strong>(by default it's <code>:1</code>)</p></li></ul>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 5,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 62236,
                        "favoriteCount": 0,
                        "thumbsUpCount": 7010,
                        "thumbsDownCount": 1,
                        "commentCount": 38,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 110
                    },
                    "creator": {
                        "username": "Lykon",
                        "image": "https://cdn.discordapp.com/avatars/180327464155742208/59254be18ccd627daf138d053327485d.png"
                    },
                    "tags": [
                        "anime",
                        "character",
                        "girl",
                        "manga",
                        "makima",
                        "chainsaw man",
                        "woman",
                        "girls"
                    ],
                    "modelVersions": [
                        {
                            "id": 6244,
                            "name": "offset",
                            "index": 0,
                            "modelId": 5373,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": null,
                            "publishedAt": "2023-01-26T21:44:45.652",
                            "availability": "Public",
                            "trainedWords": [
                                "makima \\(chainsaw man\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 60363,
                                "ratingCount": 543,
                                "rating": 4.95,
                                "thumbsUpCount": 619,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 10246,
                                    "sizeKB": 147532.8759765625,
                                    "name": "makima_offset.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-15T16:45:55.568Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "4566EB02",
                                        "AutoV2": "EF403E13F7",
                                        "SHA256": "EF403E13F794421C26E7575636696FD6453DE691CF8E10B4027C9A68A0C28AB8",
                                        "CRC32": "5F6658AA",
                                        "BLAKE3": "7A826A6D48D3982633CE86030369975818D438B7334573A02A51DC1905F7D0FE",
                                        "AutoV3": "44ED933D26F3"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/6244",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 56704,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/65f4efa0-c412-4532-69e6-120edba40000/width=450/56704.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 960,
                                    "height": 1280,
                                    "hash": "UIGRbp0L0x^P:*NxAE-B00tlX-aK~CM|E2xD",
                                    "type": "image"
                                },
                                {
                                    "id": 709482,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8c371b9f-ca81-4835-a640-198baabb9ee6/width=450/709482.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1304,
                                    "hash": "UYI4*F~VF1I:4TM{IoIpbbRjoeof%Mxtx]WW",
                                    "type": "image"
                                },
                                {
                                    "id": 56705,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dc38cd8f-bb50-40c7-cc52-9dc75b247600/width=450/56705.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 960,
                                    "height": 1280,
                                    "hash": "U8GuBzRO0LI:00-p0zNbt6xZRlE1_MbHD%Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 55153,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/39ec32f8-0d42-4918-1fd6-aa99213b7a00/width=450/55153.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UPL41$MvNE?H~BSeS$Vs8_NHx]M{w|RjWAxa",
                                    "type": "image"
                                },
                                {
                                    "id": 117718,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e101f16d-5c9a-4add-a26c-e429dc2c2f00/width=450/117718.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1304,
                                    "hash": "UBLgFc002v0L004n0fM{.7%f~Uw[9b0K.7rr",
                                    "type": "image"
                                },
                                {
                                    "id": 54841,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bb082aae-c04b-44c4-9e49-bfa95287ae00/width=450/54841.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UDK1RIm*.654_N009~Nu00e-tSE39G_3^*$*",
                                    "type": "image"
                                },
                                {
                                    "id": 55154,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4fbdd56e-be0a-4eb2-0432-3158a06fa200/width=450/55154.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UdJ*M6ofRj%L~WbGR*jF9FofkCRjIUWBNGjs",
                                    "type": "image"
                                },
                                {
                                    "id": 54830,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/385f0a4c-2c04-428b-5688-832254e79800/width=450/54830.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1304,
                                    "hash": "UMKT*^9GBoxu8w%L9[xt~WIptQxaIBM{x]t7",
                                    "type": "image"
                                },
                                {
                                    "id": 54839,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/281f8e31-52ee-4ab2-5569-f7ebd516f300/width=450/54839.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "URGl9g4nI:D%~pWV9FjZMxxubbxaMxWBxuWB",
                                    "type": "image"
                                },
                                {
                                    "id": 55569,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3cfbf706-7fe9-4c00-cf56-73d7e26da700/width=450/55569.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 960,
                                    "height": 1280,
                                    "hash": "UZI;SD~UX2-ov{-;%gxuJ8tRx]o#yER-M{M|",
                                    "type": "image"
                                },
                                {
                                    "id": 54928,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1985826f-60d8-43b1-d643-5439d6f0b300/width=450/54928.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UJLD.F={.T564.4TH?oz01%g%1-pNHIoRjxa",
                                    "type": "image"
                                },
                                {
                                    "id": 54838,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e4670ba-d8d7-48cb-662d-e7a3e4f6a500/width=450/54838.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1304,
                                    "hash": "UXLqCR0f_N?HQ+%L-;t79Ze:f7M{9af8%LIU",
                                    "type": "image"
                                },
                                {
                                    "id": 54836,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/901a53d0-5051-4834-fb8c-13d922d2b800/width=450/54836.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UPL44?~B?^bc8^?bEL?bIAs;RPIUR*aK?aoz",
                                    "type": "image"
                                },
                                {
                                    "id": 54932,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/54ad59ac-a8c7-424a-d613-1bf0c053c800/width=450/54932.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UIIO2^Ripwt,_NIAw^xua1R*xuofM{Ioxu-o",
                                    "type": "image"
                                },
                                {
                                    "id": 54837,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1c3ea02c-6c91-4957-c098-f7ce1d0c8800/width=450/54837.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1304,
                                    "hash": "UXNdL2RP-;~q%1n%o}xu00s:W;x]WCj[M_WV",
                                    "type": "image"
                                },
                                {
                                    "id": 54840,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/02c9e4cf-72e9-459c-6049-e688b305b000/width=450/54840.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UiN9|K_Ntm-;vfNGS5-;Mwt7M{M{s,j[ozRj",
                                    "type": "image"
                                },
                                {
                                    "id": 54834,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b8da2bca-d17e-4896-3145-35e008019900/width=450/54834.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UnKBH@%M?v-;~qxuR*oLs:t7RkMxjYxuf+M{",
                                    "type": "image"
                                },
                                {
                                    "id": 54833,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/37c67a0c-e030-435c-4319-3f3ce97b2a00/width=450/54833.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UeNJ,+?b_NflH?-;o}-;IAV[fkNGogxt%LE1",
                                    "type": "image"
                                },
                                {
                                    "id": 54866,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e246d4d2-fc60-42ef-bd6e-45b597ab6b00/width=450/54866.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UJIqy8ob0LRn00%29F9ZrBIp?w-:jFxZWoNG",
                                    "type": "image"
                                },
                                {
                                    "id": 54929,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9d023a75-02d4-497d-3e6e-b34f65151c00/width=450/54929.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UBI}S7Uv_N0K]U^6Md9@00,D$Q%z00R5?Ixb",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/6244"
                        },
                        {
                            "id": 10886,
                            "name": "offset_64_dim",
                            "index": 1,
                            "modelId": 5373,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-02-15T16:46:52.536",
                            "availability": "Public",
                            "trainedWords": [
                                "makima \\(chainsaw man\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 974,
                                "ratingCount": 5557,
                                "rating": 5,
                                "thumbsUpCount": 6432,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 10250,
                                    "sizeKB": 73838.265625,
                                    "name": "makima_offset_small.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-15T16:50:55.287Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "B00B80E7",
                                        "AutoV2": "3981E810E1",
                                        "SHA256": "3981E810E149C34B6204B2C49F4F6B116AD67048080708C903D43DA780B371F8",
                                        "CRC32": "24C37821",
                                        "BLAKE3": "045459B900372FA98CB5BEBDDC6E496508CB7231F3243E2904BA47DB0C05592E",
                                        "AutoV3": "2E62EC6D9B31"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/10886",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 105209,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ca270d61-24df-4b2f-92ca-652cc3256800/width=450/105209.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 887,
                                    "hash": "UjLNrnxus:t7~qayayofNFayayWB%gaeazWB",
                                    "type": "image"
                                },
                                {
                                    "id": 105238,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f47383ad-5874-4c5a-74e9-658e72e10500/width=450/105238.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2048,
                                    "height": 887,
                                    "hash": "UlKw@Ct7ayt7~qoLj[ofbbaxayj[-;bHayWB",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/10886"
                        },
                        {
                            "id": 10883,
                            "name": "original",
                            "index": 2,
                            "modelId": 5373,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>reupload of the original lora file (trick to avoid reuploading all the example images)</p>",
                            "publishedAt": "2023-02-15T16:42:30.168",
                            "availability": "Public",
                            "trainedWords": [
                                "makima \\(chainsaw man\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 899,
                                "ratingCount": 23,
                                "rating": 4.91,
                                "thumbsUpCount": 24,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 10247,
                                    "sizeKB": 147533.75,
                                    "name": "makima.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-15T16:45:55.618Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "783BCA51",
                                        "AutoV2": "6B56AD4C6D",
                                        "SHA256": "6B56AD4C6D238E6647AD01D1D77D1B3EA50084916B70E5AA2DEE44CF81FCB1D4",
                                        "CRC32": "CCCAFB1B",
                                        "BLAKE3": "65BADFC9E1857E9FFD7EE09BF031C9EC987402D01E3DC8841B4D526CC12F712F",
                                        "AutoV3": "0EB4661A17D1"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/10883",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 105187,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/40df3554-b8f8-4d76-4344-a650e96f6000/width=450/105187.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 887,
                                    "hash": "UjLNrnxus:t7~qayayofNFayayWB%gaeazWB",
                                    "type": "image"
                                },
                                {
                                    "id": 105239,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3dcfc333-7cb3-4e33-5bf6-b56d41914500/width=450/105239.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2048,
                                    "height": 887,
                                    "hash": "UlKw@Ct7ayt7~qoLj[ofbbaxayj[-;bHayWB",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/10883"
                        }
                    ]
                },
                {
                    "id": 122359,
                    "name": "Detail Tweaker XL",
                    "description": "<p>Detail tweaker for SDXL.</p><p>Works with weights [-3, 3]</p><p>Use positive weight to increase details and negative weight to reduce details.</p><p>Good weight depends on your prompt and number of sampling steps, I recommend starting at 1.5 and then adjusting it.</p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 89943,
                        "favoriteCount": 0,
                        "thumbsUpCount": 6940,
                        "thumbsDownCount": 12,
                        "commentCount": 28,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 2450
                    },
                    "creator": {
                        "username": "w4r10ck",
                        "image": "https://lh3.googleusercontent.com/a/AAcHTteNN1NjuPJVdxuJEu6YKAGW4_OLYzed3y0xbLe9=s96-c"
                    },
                    "tags": [
                        "concept",
                        "detailed",
                        "detail",
                        "enhancer",
                        "undetailed"
                    ],
                    "modelVersions": [
                        {
                            "id": 135867,
                            "name": "v1.0",
                            "index": 0,
                            "modelId": 122359,
                            "baseModel": "SDXL 1.0",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-08-07T14:55:02.627",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 89390,
                                "ratingCount": 4079,
                                "rating": 4.98,
                                "thumbsUpCount": 6854,
                                "thumbsDownCount": 12
                            },
                            "files": [
                                {
                                    "id": 99264,
                                    "sizeKB": 223097.9921875,
                                    "name": "add-detail-xl.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-08-07T14:55:53.517Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "29A40D2E",
                                        "AutoV2": "0D9BD1B873",
                                        "SHA256": "0D9BD1B873A7863E128B4672E3E245838858F71469A3CEC58123C16C06F83BD7",
                                        "CRC32": "A94E124F",
                                        "BLAKE3": "595854A2079ABB9AF0FD84830DDF1142ABFFAA70DEBF51C25C2E73A248CB11CA",
                                        "AutoV3": "9C783C8CE46C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/135867",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1917130,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/217179cb-87a0-4e96-8d77-e410f757aba0/width=450/1917130.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2698,
                                    "height": 1158,
                                    "hash": "UUHK;5WYoJR*~qWCj[j[_Ns:a}of_3s:azof",
                                    "type": "image"
                                },
                                {
                                    "id": 1917133,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1132c8aa-053e-468b-9f80-32a071f73f57/width=450/1917133.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2698,
                                    "height": 1158,
                                    "hash": "UWDb~Kofa|of?vj[j[kC~WbHj[kC~qoffkof",
                                    "type": "image"
                                },
                                {
                                    "id": 1917136,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/270b159f-d91b-424b-8ac6-14857726f1f1/width=450/1917136.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2698,
                                    "height": 1158,
                                    "hash": "UjHBSroJays._4oJazs.?cWDayWXpJa}oLWX",
                                    "type": "image"
                                },
                                {
                                    "id": 1917137,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f7cef77a-eabb-4d89-9faa-399bef495e32/width=450/1917137.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2698,
                                    "height": 1158,
                                    "hash": "UgF5]ot7ayt8_Mofjtof?cbHfQfk-=ayj[ay",
                                    "type": "image"
                                },
                                {
                                    "id": 1917142,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4d6138b0-6e54-4331-8326-1b5291fed0d8/width=450/1917142.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2698,
                                    "height": 1158,
                                    "hash": "UONAYXIUbIs;_Ns:ayof.Aayjsof~Vofofof",
                                    "type": "image"
                                },
                                {
                                    "id": 1917146,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fc49dbba-7f86-4d9d-a8cb-bfc8e483e3af/width=450/1917146.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2698,
                                    "height": 1158,
                                    "hash": "UTE{h0t7e=of_Na#jubH~qofa{oM?vodj@of",
                                    "type": "image"
                                },
                                {
                                    "id": 1917151,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f7a46c72-8d6e-41fe-b6e1-3b093039b036/width=450/1917151.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2698,
                                    "height": 1158,
                                    "hash": "UYF#,ho#ofoz~podj[oe_4WXfQbI?vofj[bH",
                                    "type": "image"
                                },
                                {
                                    "id": 1917152,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/41d4eb52-3728-4fd1-864b-73f23cfd969b/width=450/1917152.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2698,
                                    "height": 1158,
                                    "hash": "UnNvrYt7WBt6?wV@j[bHpJkCj[j?%Ms.bIkC",
                                    "type": "image"
                                },
                                {
                                    "id": 1917153,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0e537b14-d13c-4053-90f8-4ccc081fdf74/width=450/1917153.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1797,
                                    "height": 1158,
                                    "hash": "UFON2nRjRj={~qM{RjS$?c%2t7R-%gNGWVaK",
                                    "type": "image"
                                },
                                {
                                    "id": 1917154,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/08a14430-af56-40a1-971f-4180f187626d/width=450/1917154.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2698,
                                    "height": 1158,
                                    "hash": "URIXv?RQkCV@?wRjt7kC~qkCbHWV_3t7R*t7",
                                    "type": "image"
                                },
                                {
                                    "id": 1917155,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ead63f62-9ff0-48d8-a8bf-fd8f56143c39/width=450/1917155.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2698,
                                    "height": 1158,
                                    "hash": "UVLD+8n,t7o5yFs;jcag+yOpW.X5.laiaekW",
                                    "type": "image"
                                },
                                {
                                    "id": 1917168,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5b03768e-bcfe-42c1-be9a-0c4dd26bd5cb/width=450/1917168.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2698,
                                    "height": 1158,
                                    "hash": "UVFE+Sflj[of_NkCbHj]_NoLazof_4ofoLkC",
                                    "type": "image"
                                },
                                {
                                    "id": 1917169,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/be7f5ba7-c9f0-49ba-b786-a04a1db71502/width=450/1917169.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2698,
                                    "height": 1158,
                                    "hash": "UfG[[|t7t7s:_4WAfjjt-;ofayof-;kCWVof",
                                    "type": "image"
                                },
                                {
                                    "id": 1917170,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4c525cf5-c14e-4602-9e9d-0e602baa9de6/width=450/1917170.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2698,
                                    "height": 1158,
                                    "hash": "UbG*$tWBkCay~qWBj[WU.8kCayof?bj[ayj[",
                                    "type": "image"
                                },
                                {
                                    "id": 1917171,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9b7fcef1-bf83-4a11-bce0-8875158dc912/width=450/1917171.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2698,
                                    "height": 1158,
                                    "hash": "URFh|*W=RjWW_Nt6ofjZ~payays:_Nofj[j[",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/135867"
                        },
                        {
                            "id": 133241,
                            "name": "v0.3",
                            "index": 1,
                            "modelId": 122359,
                            "baseModel": "SDXL 1.0",
                            "nsfwLevel": 5,
                            "description": null,
                            "publishedAt": "2023-08-04T07:53:00.654",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 553,
                                "ratingCount": 86,
                                "rating": 5,
                                "thumbsUpCount": 103,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 97113,
                                    "sizeKB": 166544.4453125,
                                    "name": "tweak-detail-xl.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-08-04T07:25:45.241Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "25D7E652",
                                        "AutoV2": "A5E633C9AF",
                                        "SHA256": "A5E633C9AFD9D12DA2D34A2FD691E74D3E5FDA19DF8AD4B73B7F94E65F1FB168",
                                        "CRC32": "0B1AB6FD",
                                        "BLAKE3": "E207C3548FDB9E7F929E925D313AA4F3C656BC6813F2873EC8A0C130215FCA3E",
                                        "AutoV3": "2FE68B23E748"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/133241",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1867497,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fe78b324-2c06-419f-9465-d9a56d6a6276/width=450/1867497.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3072,
                                    "height": 1166,
                                    "hash": "UUF~5Js:oeae~qofayfP_3t7ayof?wWBjtWB",
                                    "type": "image"
                                },
                                {
                                    "id": 1867498,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b9f5c0ff-7833-43d8-8a7f-3f36ccf30d5e/width=450/1867498.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3072,
                                    "height": 1166,
                                    "hash": "UbFsi9t7aekW-@jZj[oL-iWBWXV@?abFfPj[",
                                    "type": "image"
                                },
                                {
                                    "id": 1867500,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c44a059a-282f-416b-bdb5-92d725ad602e/width=450/1867500.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3072,
                                    "height": 1166,
                                    "hash": "UiHxyss:j[WB~qf6ayWB-;j[aykC-;j[ayof",
                                    "type": "image"
                                },
                                {
                                    "id": 1867503,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/25f930f2-4151-4b5c-b45e-39ceb3394bed/width=450/1867503.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 3072,
                                    "height": 1183,
                                    "hash": "UZJHp=x]aexu%#WVazj[-=jsj]jZ~qoLj[j[",
                                    "type": "image"
                                },
                                {
                                    "id": 1867505,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1da8c212-6f3a-4503-b826-be1ec347e69d/width=450/1867505.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3072,
                                    "height": 1183,
                                    "hash": "UeC%EZt7fQoL~qj]fQj[^+aya|j[?bayfQj[",
                                    "type": "image"
                                },
                                {
                                    "id": 1867511,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/24ab1827-20f4-4e2a-9fef-2d2ebe05c4a1/width=450/1867511.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3072,
                                    "height": 1183,
                                    "hash": "UWE{nWxuaet6_3WCj[a}?va#a#az~qayWBj[",
                                    "type": "image"
                                },
                                {
                                    "id": 1867597,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3cab02ab-6e5d-485a-8532-7b92a726c0d6/width=450/1867597.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3087,
                                    "height": 1183,
                                    "hash": "UaEMwOoybFoz_Naefjof^kWBazay_Na|f6j[",
                                    "type": "image"
                                },
                                {
                                    "id": 1867664,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/356743dd-df6f-4c7c-b858-506e31b45efb/width=450/1867664.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3087,
                                    "height": 1183,
                                    "hash": "UWFYZAt7jrof~qWBj[oM?vayj@a|~qj[ayof",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/133241"
                        }
                    ]
                },
                {
                    "id": 16055,
                    "name": "沁彩 Colorwater",
                    "description": "<h1 id=\"heading-23\">沁彩</h1><p></p><p><strong>润物以水，纳彩于心。</strong></p><p>[ENG Instructions below]</p><p>tusi.art/u/607323927751959196</p><ul><li><p>请注意，每个版本的倾向各不相同，<s>如果你喜欢最有透明感的水彩效果，请选择v1，但它适配的模型相对较少。</s></p></li><li><p>v4是目前最推荐的版本了。</p></li><li><p>其他版本各有进化的方向，有兴趣欢迎多多尝试！</p><p></p></li><li><p>Please note that each version has a different tendency.</p></li><li><p><s>If you like the most transparent watercolor effect, please choose the original v1, but it fits relatively few models.</s></p></li><li><p>v4 is the most recommended version right now.</p></li><li><p>Other versions have their own evolutionary direction, so feel free to try more if you're interested!</p></li></ul><p></p><ul><li><p>这是一个水彩风格的LoRA，还在不断完善中，欢迎各种feedback！</p></li></ul><ul><li><p>This is a watercolor style LoRA, still in the process of improvement, welcome all kinds of feedbacks!</p></li></ul><p></p><h3 id=\"heading-24\">v4 使用说明：</h3><ul><li><p>v4 版本在适配多个模型的能力上有了极大改进，不再赘述，请参考sample图片就会马上明白了。同样的，也可以和大量的其他优秀lora一起工作，只需要注意组合权重。</p></li><li><p>推荐设置：权重=0.8-1，CFG=3-6</p></li><li><p>The v4 version is a great improvement in the ability to adapt multiple models, so without further ado, please refer to the sample image and you will understand immediately. Likewise, it can work with a large number of other lora, just be careful with the combination weights.</p></li><li><p>Recommended settings: weight=0.8-1, CFG=3-6</p></li></ul><p></p><p></p><h3 id=\"heading-25\">v3 使用说明：</h3><p>全面强化！</p><ul><li><p>通用的模型推荐配置：CFG&lt;7，权重0.65-0.75，CFG与色彩浓淡完全挂钩，但请注意，根据模型不同，有些在7左右就会出现过拟合的现象。但有一些三次元模型会在7之上有比较复古的重水彩表现。</p></li><li><p>和其他LoRA配合使用时请注意避免加权和过高的情况，一般来说，加权总值不超过1.2比较合适，如果需要水彩风格较多的显现，则需要保持沁彩的权重为最高的那个。</p><p>举例：下图为使用墨心和疏可走马共3个LORA的效果，权重比为0.5+0.35+0.35</p><p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0f4b8de6-162a-4d28-32a5-1b6ca7e94b00/width=525/0f4b8de6-162a-4d28-32a5-1b6ca7e94b00\" /></p></li></ul><p>Instructions for v3</p><p>Power Enhanced!</p><p>Generic model recommended configuration: CFG&lt;7, weight 0.65-0.75, CFG is fully linked to color intensity, but please note that depending on the model, some overfitting will occur at around 7.But there are some realistic models will have a more vintage heavy watercolor performance on top of 7.</p><p>When using with other LoRA, please pay attention to avoid weighting and too high, generally speaking, the total weighted value is not more than 1.2 is more appropriate, if you need more watercolor style to appear, you need to keep the weight of the QIN color as the highest one.</p><p>Example: The image upstairs shows the effect of using Coloerwater, Moxin and Shukezouma total of 3 LORA, the weighting ratio is 0.5 + 0.35 + 0.35</p><p></p><p></p><p></p><p></p><h3 id=\"heading-26\">v2 使用说明：</h3><p>现在的沁彩进行了各种强化，有了一定的写实能力！</p><ul><li><p>二次元类模型推荐配置：CFG&lt;6，权重0.85-1</p></li></ul><ul><li><p>三次元类模型推荐配置：CFG&lt;5，权重0.5-0.7</p></li></ul><p>目前对于人物面部的风格还是最大限度保留了模型的原始风格，v3版会对这部分尝试进行改进，追求写实风格，到时候会将二、三次元分开版本供大家尝试。</p><p>感谢各位的好评！</p><p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/88f2f73d-91a9-4be4-492d-e7be6fb33800/width=525/88f2f73d-91a9-4be4-492d-e7be6fb33800\" /></p><h3 id=\"heading-27\">Instructions for v2 version</h3><p>Now Colorwater has undergone various enhancements and has a try on realistic style!</p><p>Recommended configuration</p><ul><li><p>Anime-like models: CFG&lt;6, weight 0.85-1</p></li><li><p>Realistic-like models: CFG&lt;5, weight 0.5-0.7</p></li></ul><p>At present, the style of the character's face is still the maximum to retain the original style of the model, v3 version will try to improve this part, the pursuit of realistic style.If things go well, there will be two diff versions by the time they are completed for everyone to try.</p><p>Thank you all for your kind comments!</p><p></p><p></p><p></p><p></p><h3 id=\"heading-28\">v1 使用说明：</h3><ul><li><p>水彩的风格会根据CFG的值变化，建议体验从2~6的不同变化，更高值的使用请注意是否能与你的模型匹配。总的来说，CFG的高低和水彩的浓淡正相关。</p></li></ul><p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c647e2d1-1e6b-48d8-53a6-ffa0098e6400/width=525/c647e2d1-1e6b-48d8-53a6-ffa0098e6400\" /></p><ul><li><p>权重推荐使用0.85-1，如与其他lora搭配请自行判断。</p></li><li><p>由于一些原因，数据集特意排除了人脸相关的数据，所以大部分主模型在人物面部的表现都还是自己原本的特色，请根据需要自己调整即可。</p></li></ul><p></p><h3 id=\"heading-29\">Instructions for v1 version</h3><ul><li><p>The style of watercolor will change according to the value of CFG, it is recommended to experience different variations from 2~6. For higher values, please pay attention to whether it can match your model. In general, the high CFG is positively related to the intensity of the watercolor.</p></li><li><p>The weights are recommended to use 0.85-1, please use your own judgment if matching with other lora.</p></li><li><p>For some reasons, the dataset deliberately excludes face-related data, so most of the main models in the character face are still their own original features, please just adjust yourself as needed.</p><p></p></li></ul>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 37174,
                        "favoriteCount": 0,
                        "thumbsUpCount": 6898,
                        "thumbsDownCount": 1,
                        "commentCount": 31,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 2
                    },
                    "creator": {
                        "username": "AlchemistW",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6192f367-0fdf-46ca-ed08-c61d64b90a00/width=96/AlchemistW.jpeg"
                    },
                    "tags": [
                        "anime",
                        "watercolor",
                        "chinese",
                        "style",
                        "art style",
                        "paintings",
                        "artstyle",
                        "styles"
                    ],
                    "modelVersions": [
                        {
                            "id": 21173,
                            "name": "v4",
                            "index": 0,
                            "modelId": 16055,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>v4 版本在适配多个模型的能力上有了极大改进，请参考sample图片。</p><p>推荐设置：权重=0.8-1，CFG=3-6</p><p>The v4 version has greatly improved the ability to adapt to multiple models, please refer to the sample image.</p><p>Recommended settings: weight=0.8-1, CFG=3-6</p>",
                            "publishedAt": "2023-03-10T14:31:52.376",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 31237,
                                "ratingCount": 5153,
                                "rating": 5,
                                "thumbsUpCount": 5874,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 17638,
                                    "sizeKB": 147569.447265625,
                                    "name": "Colorwater_v4.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-10T14:36:04.270Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "5AE754B3",
                                        "AutoV2": "1B175706FF",
                                        "SHA256": "1B175706FF313111F5C5C750E18F13056868801CCDE0E75F73F327A8E4F57A05",
                                        "CRC32": "0D7B99A1",
                                        "BLAKE3": "35FA1DC2BBDD35F95ABA6E8CB18A7672E84CB7292D0362FE51314A9949002637",
                                        "AutoV3": "91184B428AD3"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/21173",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 224275,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/188ef085-0410-4859-5a19-98e215f95000/width=450/224275.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBKUQL9|.m}@00RPE2tQKjRPxDkCyst7$fIU",
                                    "type": "image"
                                },
                                {
                                    "id": 224276,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a1e6fdb8-a28e-4255-f453-792b8d9af000/width=450/224276.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIJ[3S00t-~Wxb-;%Nxut.-;%1M{EQMxD%Nb",
                                    "type": "image"
                                },
                                {
                                    "id": 224274,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f11996b8-30ae-4c18-e1d1-53aaa64e1300/width=450/224274.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKL4Z=%L%f%24T?vn%Mx_N-:RjEMx]E1jYWB",
                                    "type": "image"
                                },
                                {
                                    "id": 224272,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a67dcdca-f21f-4bae-795e-b9432c519a00/width=450/224272.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UQIq}+~q%$9F_NxuR+of58IURP%2-=aexFoJ",
                                    "type": "image"
                                },
                                {
                                    "id": 224501,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/32326f50-151b-4cc2-37c3-c41f19259000/width=450/224501.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UFF$O$~qR%9F_3_39FIU-;a}IUM{%gxuxtj[",
                                    "type": "image"
                                },
                                {
                                    "id": 224271,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4b810ab0-b63c-4017-2b85-6f597a31f300/width=450/224271.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEGbky-W00EK?t~WwhNF?^x^%2Vs.S%gRjaJ",
                                    "type": "image"
                                },
                                {
                                    "id": 224270,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/042c03f0-67aa-4ad6-990d-85023d7fa900/width=450/224270.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UaKUfv?ZM_Nd~VXUX9t5?cnis:of-;n$jFtR",
                                    "type": "image"
                                },
                                {
                                    "id": 224315,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/82e5fee6-d113-441f-7f52-e53b770d1d00/width=450/224315.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UQM7Z6VaD$--NX-px]o{_NwJxas;-ot8i^IU",
                                    "type": "image"
                                },
                                {
                                    "id": 224269,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3a4554ad-9f59-47f8-0dee-5f26811a7800/width=450/224269.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "ULH{1G?uNbxaW*WbR*n#~W%2ouIV-oozD+IV",
                                    "type": "image"
                                },
                                {
                                    "id": 224314,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c3a0cc25-0657-4a64-242a-d15874eca100/width=450/224314.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "USM@Gy^+Rj-;t6xtWBIU_NkDxuM{-;M|t7t7",
                                    "type": "image"
                                },
                                {
                                    "id": 224500,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f8d15278-f15e-49e0-542b-a8bf8bd3cf00/width=450/224500.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UcMj?nR+~q-;xuofRjRk-;RjRja}xuazIVay",
                                    "type": "image"
                                },
                                {
                                    "id": 224499,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/66932733-efd9-449e-8894-fc1be74a2a00/width=450/224499.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UWKBgvxu?bt7xvRjRjoz~qWBIVj[t7tQayWB",
                                    "type": "image"
                                },
                                {
                                    "id": 224268,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e204e3c-cf79-4fa3-b33b-f809401c2000/width=450/224268.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UUP6{mxv_4%M?coeM_Rk?vxuxbM{~qjZIUWV",
                                    "type": "image"
                                },
                                {
                                    "id": 224313,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/79b90d8c-a1e5-40d2-cab5-9ed3a5819300/width=450/224313.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UPOWvj?H_4x]_4ofM_Rj_4t7xuIU_3j[M{WB",
                                    "type": "image"
                                },
                                {
                                    "id": 224312,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/26debbbb-c504-434b-e76c-0a58b46acd00/width=450/224312.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UdO|Orog_N%LM}ogt6WB%#ayn~t7WBWBt7WV",
                                    "type": "image"
                                },
                                {
                                    "id": 224311,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/08b7cc18-89dc-47af-ea7e-ba71da015400/width=450/224311.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UWP%Ioxa.8o|%fxuaeM{_NRiRjxbM{V@ozWB",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/21173"
                        },
                        {
                            "id": 20343,
                            "name": "v3",
                            "index": 1,
                            "modelId": 16055,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>全面强化！</p><ul><li><p>通用的模型推荐配置：CFG&lt;7，权重0.65-0.75，CFG与色彩浓淡完全挂钩，但请注意，根据模型不同，有些在7左右就会出现过拟合的现象。但有一些三次元模型会在7之上有比较复古的重水彩表现。</p></li></ul><p>和其他LoRA配合使用时请注意避免加权和过高的情况，一般来说，加权总值不超过1.2比较合适，如果需要水彩风格较多的显现，则需要保持沁彩的权重为最高的那个。</p><p></p><p>Power Enhanced!</p><ul><li><p>Generic model recommended configuration: CFG&lt;7, weight 0.65-0.75, CFG is fully linked to color intensity, but please note that depending on the model, some overfitting will occur at around 7.But there are some realistic models will have a more vintage heavy watercolor performance on top of 7.</p></li><li><p>When using with other LoRA, please pay attention to avoid weighting and too high, generally speaking, the total weighted value is not more than 1.2 is more appropriate, if you need more watercolor style to appear, you need to keep the weight of the QIN color as the highest one.</p></li></ul><p></p>",
                            "publishedAt": "2023-03-08T16:29:40.28",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1810,
                                "ratingCount": 276,
                                "rating": 5,
                                "thumbsUpCount": 278,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16954,
                                    "sizeKB": 147572.5888671875,
                                    "name": "Colorwater_v3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-08T16:31:09.999Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "FE2C8820",
                                        "AutoV2": "82128060EE",
                                        "SHA256": "82128060EE5C013F3505C4321F67DFC08B261973E998BA13F4840EC0F8B3F9E7",
                                        "CRC32": "CC25B71D",
                                        "BLAKE3": "666C3AF4E644757346D056A5D7699855651279DB112DCC5F22D96B1F1E951062",
                                        "AutoV3": "F00E1C5D6AD3"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/20343",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 215291,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad3e030e-de2b-475b-fa60-7c9d952dc500/width=450/215291.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UxNdH@xu~qt7jst7ofM{-;RjaeofM{j[t7of",
                                    "type": "image"
                                },
                                {
                                    "id": 215288,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eccf2a1b-09f9-493a-676e-905a183f4d00/width=450/215288.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UWNwcqxt_Nt8xbj@oza#?bayWAt7oyWBWBof",
                                    "type": "image"
                                },
                                {
                                    "id": 215287,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4570ba3e-39d0-4104-9741-dd6dc3908200/width=450/215287.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UJMH0?E0EhNGtmE1ITof?w-;%1t7xF%3tSWB",
                                    "type": "image"
                                },
                                {
                                    "id": 215285,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1bca1a7-875e-4172-00c9-29a98faedd00/width=450/215285.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U#MQx3xu~qt7t7V@ofWXxuRjjZxukCofofs:",
                                    "type": "image"
                                },
                                {
                                    "id": 215284,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/429a5ad6-f6b8-4a8a-ae7a-e3ca2bc10000/width=450/215284.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTLg-9.8~p_3-;kCofWB~qRPR*NGjEoLa|kC",
                                    "type": "image"
                                },
                                {
                                    "id": 215283,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5c85846d-0e92-49bb-ce63-be5eb637ff00/width=450/215283.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UXN^by?b~qIU-;oMM{Rj?bV@IUt8WBR%xut7",
                                    "type": "image"
                                },
                                {
                                    "id": 215289,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a05d3fe9-4ced-44ea-a0d3-225351839600/width=450/215289.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "URNT][xa_NyDM{t7t7R%_4flaKs:?baeRkt7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/20343"
                        },
                        {
                            "id": 19476,
                            "name": "v2",
                            "index": 2,
                            "modelId": 16055,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 19,
                            "description": "<p>现在的沁彩进行了各种强化，有了一定的写实能力！</p><ul><li><p>二次元类模型推荐配置：CFG&lt;6，权重0.85-1</p></li></ul><ul><li><p>三次元类模型推荐配置：CFG&lt;5，权重0.5-0.7</p></li></ul><p>目前对于人物面部的风格还是最大限度保留了模型的原始风格，v3版会对这部分尝试进行改进，追求写实风格，到时候会将二、三次元分开版本供大家尝试。</p><p></p><p>Now Colorwater has undergone various enhancements and has a try on realistic style!</p><p>Recommended configuration</p><ul><li><p>Anime-like models: CFG&lt;6, weight 0.85-1</p></li><li><p>Realistic-like models: CFG&lt;5, weight 0.5-0.7</p></li></ul><p>At present, the style of the character's face is still the maximum to retain the original style of the model, v3 version will try to improve this part, the pursuit of realistic style.If things go well, there will be two diff versions by the time they are completed for everyone to try.</p>",
                            "publishedAt": "2023-03-06T16:16:16.714",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1846,
                                "ratingCount": 334,
                                "rating": 5,
                                "thumbsUpCount": 334,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16255,
                                    "sizeKB": 147571.3525390625,
                                    "name": "Colorwater_v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-06T16:21:13.180Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "C98AFC32",
                                        "AutoV2": "656D3DC973",
                                        "SHA256": "656D3DC973E6AD6A2899903D272BF357DF3248A5BF675803D982E27F968BEAFB",
                                        "CRC32": "35CCBDA2",
                                        "BLAKE3": "210401EBFE61F9D73A10AD0F9D8051DE74CAD0413A23C49F61657C6B19C77D3A",
                                        "AutoV3": "0AA067F666A9"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/19476",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 206368,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71ef3293-2ac6-40e1-f1a5-4f24bb387f00/width=450/206368.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UfL}84xb~qWBxut7RjM{?bofIUj[t6R*ozxa",
                                    "type": "image"
                                },
                                {
                                    "id": 204409,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dbef05af-4fce-46fa-3dc5-1412167ea100/width=450/204409.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "URKw|PD%_3?a~qt7xvt7o}axofs:ozofn%R%",
                                    "type": "image"
                                },
                                {
                                    "id": 204406,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/440c45f8-880f-4c46-ed41-9c9b613c7800/width=450/204406.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UZMtaN_NM{o0~XNajGjb%MWBaes:adV[kDoe",
                                    "type": "image"
                                },
                                {
                                    "id": 204410,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a83df5d7-a498-40e6-98b1-c2197ccd4100/width=450/204410.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UiMQ*It7~qoft7xua{M{_3t7IokBWBRjj[of",
                                    "type": "image"
                                },
                                {
                                    "id": 204408,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4fb28d81-ab05-4612-d671-811f3a685400/width=450/204408.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UML52aSh~W%Lu5IoV@Rj.SRkIAo0M|kCxZxa",
                                    "type": "image"
                                },
                                {
                                    "id": 204407,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/96bc4de7-cdb0-4fa6-73a7-bbe8cbfd0400/width=450/204407.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDIiaXoa00tl0Jx?jJM|_NxtIVWF4mM{4pxt",
                                    "type": "image"
                                },
                                {
                                    "id": 204405,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b50aaf13-7896-4a8d-55b6-a8880e7b7100/width=450/204405.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDJlZwJ~0JTCB^t5WCxa?KnA9ZVy-o%34.In",
                                    "type": "image"
                                },
                                {
                                    "id": 206367,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4076a3aa-b4bd-4fd8-a1c4-26985e211700/width=450/206367.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "USKA~J9a_N%M?^WBM{WVtmWBi^ofxGxtayjZ",
                                    "type": "image"
                                },
                                {
                                    "id": 206366,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1114e37c-240e-4133-0c44-18568d8f4e00/width=450/206366.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "UQJ7~}WB.TI@OtIVV?bv%gIU%2t7%gWXM{sA",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/19476"
                        },
                        {
                            "id": 18952,
                            "name": "v1 (the original)",
                            "index": 3,
                            "modelId": 16055,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<ul><li><p>水彩的风格会根据CFG的值变化，建议体验从2~6的不同变化，更高值的使用请注意是否能与你的模型匹配。总的来说，CFG的高低和水彩的浓淡正相关。</p></li></ul><ul><li><p>权重推荐使用0.85-1，如与其他lora搭配请自行判断。</p></li><li><p>由于一些原因，数据集特意排除了人脸相关的数据，所以大部分主模型在人物面部的表现都还是自己原本的特色，请根据需要自己调整即可。</p></li></ul><p></p><ul><li><p>The style of watercolor will change according to the value of CFG, it is recommended to experience different variations from 2~6. For higher values, please pay attention to whether it can match your model. In general, the high CFG is positively related to the intensity of the watercolor.</p></li><li><p>The weights are recommended to use 0.85-1, please use your own judgment if matching with other lora.</p></li><li><p>For some reasons, the dataset deliberately excludes face-related data, so most of the main models in the character face are still their own original features, please just adjust yourself as needed.</p></li></ul><p></p>",
                            "publishedAt": "2023-03-05T14:49:42.458",
                            "availability": "Public",
                            "trainedWords": [
                                "colorwater"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2281,
                                "ratingCount": 420,
                                "rating": 5,
                                "thumbsUpCount": 423,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 15864,
                                    "sizeKB": 147570.84765625,
                                    "name": "Colorwater.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-05T14:50:55.910Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "18C204BC",
                                        "AutoV2": "C175427F7D",
                                        "SHA256": "C175427F7DBFF068E2BCA093877FDAC147DA6A1609664BF9E70936AF84C30EA3",
                                        "CRC32": "A80D274E",
                                        "BLAKE3": "2A74F12AB158A621F30F6B9512D2C9838042E7F30215FE0B05925E2857876CCF",
                                        "AutoV3": "878049A38F90"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/18952",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 197808,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/de61b585-8d01-43b0-7318-39bdcc84a000/width=450/197808.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UiQvj@xu_NozWCogt7Rj%hjsadayWBWBofoy",
                                    "type": "image"
                                },
                                {
                                    "id": 197816,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c6a719b0-ec92-47ba-1b10-6b46cdd04000/width=450/197816.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "U*L=5%xtt5t7?dj?aeaew[WWj?fjj[WBazfR",
                                    "type": "image"
                                },
                                {
                                    "id": 197815,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cd028f38-d249-4793-51a4-67980b6d3a00/width=450/197815.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "ULN,;%x]00RO_MMxM_W:D%%MIUR*xYbIW;oI",
                                    "type": "image"
                                },
                                {
                                    "id": 197814,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dddd8f8d-9a6a-42e7-0113-1a8ac360da00/width=450/197814.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UUKnu6.TIpRO.8OGNH%2%hS%R%s.o$IWM{s-",
                                    "type": "image"
                                },
                                {
                                    "id": 197813,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f63a06d7-9a07-4504-7eff-9a1c7c53b800/width=450/197813.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UKPGBKDi~Cv#?^RPbaS5TJM{E1t7^jX84UaK",
                                    "type": "image"
                                },
                                {
                                    "id": 197812,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/35f6038a-58d3-4bea-8881-b8297feb5800/width=450/197812.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U8O:,]_MP0D$TuRQ00ovP9D%00xs00-=tQM{",
                                    "type": "image"
                                },
                                {
                                    "id": 197811,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/16d5cb88-7e42-433f-c919-442f81e66c00/width=450/197811.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UwM@fbxu_NNGfkR%kBWBM{RiWBj[M{WAofof",
                                    "type": "image"
                                },
                                {
                                    "id": 197810,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bc171441-3e11-4c78-0f8f-493d2d3ea600/width=450/197810.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1280,
                                    "hash": "ULIO;Cw?Y5n+%%%d-q^%x_-:?FD%%h%GD%jD",
                                    "type": "image"
                                },
                                {
                                    "id": 197809,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5396617c-ab74-4ef7-8472-fc699c6b8200/width=450/197809.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTM7#.o|InIU%%V_g2oy%gxtxb%3XBn~xbog",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/18952"
                        }
                    ]
                },
                {
                    "id": 264290,
                    "name": "Styles for Pony Diffusion V6 XL (Not Artists styles)",
                    "description": "<p><span style=\"color:rgb(21, 170, 191)\">This asset is designed to work best with the </span><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/257749/pony-diffusion-v6-xl\"><u><span style=\"color:rgb(21, 170, 191)\">Pony Diffusion XL</span></u></a><span style=\"color:rgb(21, 170, 191)\"> model, it will work with other SDXL models but may not look as intended.</span></p><p></p><p><strong><span style=\"color:rgb(34, 139, 230)\">CLIP SKIP in ComfyUI</span></strong></p><p><span style=\"color:rgb(34, 139, 230)\">-1 gray picture with noise and spots</span></p><p><span style=\"color:rgb(34, 139, 230)\">-2 picture looks the same as in the preview</span></p><p><span style=\"color:rgb(34, 139, 230)\">If you do not add the </span><strong><span style=\"color:rgb(34, 139, 230)\">CLIP Set Last Layer</span></strong><span style=\"color:rgb(34, 139, 230)\"> node, the result will be exactly the same as -2.</span></p><p></p><p></p><p><strong>(It will not work correctly with other SDXL checkpoints.)</strong></p><p><strong><u>Does not work with any other models!</u></strong></p><p><strong>except Pony Diffusion V6 XL or models with Pony Diffusion V6 XL in the merge!</strong></p><p><s>You can of course use with other models you no one forbids it, but I do not guarantee a good result!</s></p><p></p><p>LoRAs without Trigger Words! but there are words used in training! (<strong>Some models have Trigger Words</strong>)</p><p><strong>Tokens that can enhance the style or change it!</strong></p><p><strong>Summer Night</strong> - dark theme, low light,</p><p><strong>Cold Oil/Cold Oil Gothic</strong> - oil painting, traditional media, realistic,</p><p><strong>Cold Night</strong> - dark theme, low light,</p><p><strong>Digital Art</strong> - digital art, realistic,</p><p><strong>Concept Art/Concept Art Twilight</strong> - concept art, realistic, &amp; concept art, horror (theme), monochrome, fog, realistic,</p><p><strong>Oil Gothic</strong> - painting (medium), traditional media, realistic,</p><p><strong>Gothic Art</strong> - painting (medium), traditional media, realistic,</p><p><strong>Line Art</strong> - lineart, monochrome, greyscale,</p><p><strong>Oil Painting</strong> - traditional media, realistic,</p><p><strong>Photo/Photo 2</strong> - RAW, photo, realistic,</p><p></p><p><u>The previews were made without using ADetailer</u></p><p></p><p><strong>TRAINED</strong></p><p>Smooth, Anime, Ink, Oil Painting, Photo, Line Art, Summer Days, Gothic Art, Concept Art ,Smooth 2, Anime 2, Digital Art, Rainbow, Photo 2, Cold Night, <span style=\"color:rgb(193, 194, 197)\">Cold Oil, Summer Days 2, Summer Night, Smooth Night, Gothic Art 2, Oil Painting Sharp, Impressionism Oil, Palette Knife</span></p><p><strong>MERGE</strong></p><p><strong>Smooth Anime</strong> - Smooth + Anime <strong>50/50</strong></p><p><strong>Smooth Anime 2</strong> - Smooth 2 + Anime 2 <strong>50/50</strong></p><p><strong>Smooth Anime Night</strong> - Smooth Night + Cold Night <strong>50/50</strong></p><p><strong>Oil Gothic</strong> - Oil Painting + Gothic Art <strong>50/50</strong></p><p><strong>Concept Art Twilight</strong> - Concept Art + Concept Art Dark (Unpublished) + Concept Art Negative (Unpublished) <strong>35/35/30</strong></p><p><strong>Concept Art Eclipse</strong> - Concept Art + Concept Art Dark 2 (Unpublished) + Concept Art Negative 2 (Unpublished) <strong>35/35/30</strong></p><p><strong>Cold Oil Gothic</strong> - Cold Oil + Gothic Art Sharp (Unpublished) <strong>50/50</strong></p><p><strong>Eldritch Oil </strong>- Oil Painting Sharp + Impressionism Oil Painting + Palette Knife Painting<strong> 35/35/30</strong></p><p><strong>Styles are based partially or entirely on images created by the AI</strong></p><p></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "RentCivit",
                        "Rent",
                        "Image"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 3,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 224684,
                        "favoriteCount": 0,
                        "thumbsUpCount": 6571,
                        "thumbsDownCount": 5,
                        "commentCount": 95,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 21602
                    },
                    "creator": {
                        "username": "prgfrg23",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b78d22bc-2763-4cf0-a54c-d1997c124379/width=96/prgfrg23.jpeg"
                    },
                    "tags": [
                        "anime",
                        "female",
                        "bara",
                        "digital art",
                        "western art",
                        "style",
                        "yaoi",
                        "male",
                        "ponyxl"
                    ],
                    "modelVersions": [
                        {
                            "id": 450029,
                            "name": "LineArt Mono",
                            "index": 0,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 5,
                            "description": "<p>Repeats: 20</p><p>Epoch: 20</p><p>Image Count: 22</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 1</p><p>Clip skip: 1</p><p>Training steps: 3200</p><p>Resolution: 640x1024</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>Captioning: WD14 Captioning (SmilingWolf/wd-v1-4-convnextv2-tagger-v2)</p><p>Trigger Words: flat color, &amp; lineart, monochrome, greyscale,</p><p>Recommended LoRA Strength: 0.7-1</p>",
                            "publishedAt": "2024-04-16T09:42:27.97",
                            "availability": "Public",
                            "trainedWords": [
                                "flat color,",
                                "lineart, monochrome, greyscale,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 7560,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 452,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 369776,
                                    "sizeKB": 223097.69140625,
                                    "name": "LineArt Mono Style LoRA_Pony XL v6.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-04-16T09:45:53.843Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "B0230BE7",
                                        "AutoV2": "EEE189AAA2",
                                        "SHA256": "EEE189AAA273310DD24EF7D9AD57A357BFDCBE1F7FD989B32E575C3C8E72E33B",
                                        "CRC32": "3A36F4C7",
                                        "BLAKE3": "FA36C2C662A54F92B45DCA27B34B9B8301BD8A01183FD95A2F51E6C85A956B71",
                                        "AutoV3": "0B6E1DEC0628"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/450029",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 10004308,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/98d78294-5017-4897-8caf-47a07f0d8f13/width=450/10004308.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U2BWi9E100Rl00D%xxt800_3~q?bD$a#s*00",
                                    "type": "image"
                                },
                                {
                                    "id": 10004312,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3728ec30-e2d0-437c-a99b-b15cb30e06c5/width=450/10004312.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDGIWEIVJ~-:E3xutlt7Ent7%gRj.TRjaLWC",
                                    "type": "image"
                                },
                                {
                                    "id": 10004309,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8c66556d-187f-41b5-bd49-6a38b9d6a84e/width=450/10004309.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8ATTfIS5P$,_NadM_V=%$s:xZRi-=obRORl",
                                    "type": "image"
                                },
                                {
                                    "id": 10004310,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/35741495-1b8b-4b8a-93a1-4c0f1766aa2c/width=450/10004310.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGDl$hNHkV%2?wxbRjR*ElRkRjs:OGae-pIV",
                                    "type": "image"
                                },
                                {
                                    "id": 10004705,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c28df1d4-318f-461e-8d6e-c9a5a7f69d97/width=450/10004705.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U0Amo600009F00kC-;%M00~qRj9F?b00_44n",
                                    "type": "image"
                                },
                                {
                                    "id": 10004707,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1ab22be9-c8ec-41f7-94f6-e9d95227ac82/width=450/10004707.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U2C6$0%MM{%M?b%M_3xut8RjWWRj~qWB9Fof",
                                    "type": "image"
                                },
                                {
                                    "id": 10004706,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/81208327-9ce4-446d-8692-b3ab10128909/width=450/10004706.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U1Ad4XE100^+00_3M{of4n-;?bIU00D%M{-;",
                                    "type": "image"
                                },
                                {
                                    "id": 10004751,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/383c3d89-2234-4218-ae0f-b102e40d30b5/width=450/10004751.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U5Ci{$xuxuof~qj[M{WBDiIU9Ft7-pWB^+Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 10004762,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1435e28e-5bcf-4d78-9113-b50f0d115065/width=450/10004762.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U4B3.]4m00D%00ozN2-=4T?bt5IU?dR*%JIU",
                                    "type": "image"
                                },
                                {
                                    "id": 10004772,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a72d0d30-0529-46a2-9f0e-30262f4fae48/width=450/10004772.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UBGl0DD*Kh?H9hxbyExa5bxtx^NGyZWBVsW;",
                                    "type": "image"
                                },
                                {
                                    "id": 10004763,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a334b8c-cf65-4937-b92f-0a881c73d3f4/width=450/10004763.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8AmSmM]0x$-_Nn#ROr;cF$k-UV?%4s8VqR:",
                                    "type": "image"
                                },
                                {
                                    "id": 10004761,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/59756312-3632-4f31-abf5-a0cba4b9fd3a/width=450/10004761.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGDcH:M}bvxu?wxaRjR*ElR+RjxaS%oK-:Ip",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/450029"
                        },
                        {
                            "id": 446346,
                            "name": "Concept Art DarkSide",
                            "index": 1,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 5,
                            "description": "<p>Concept Art DarkSide is a merge of 3 models</p><p>0.30 - Concept Art Dark</p><p>0.35 - Concept Art Night (Unpublished)</p><p>0.35 - Concept Art Night Not Edited (Unpublished)</p><p>Recommended LoRA Strength: 0.7-1</p><p>For one reason or another, I don't publish some styles. I don't always manage to create a good style the first time, sometimes I have to merge several models to get the style I want.</p><p>kohya_ss does not allow to merge models with different Network Dimension (Rank). That's why I don't change the LoRA training settings.</p>",
                            "publishedAt": "2024-04-14T12:03:13.366",
                            "availability": "Public",
                            "trainedWords": [
                                "concept art, realistic, dark theme, low light,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3680,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 273,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 366344,
                                    "sizeKB": 223093.85546875,
                                    "name": "Concept Art DarkSide Style LoRA_Pony XL v6.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-04-14T12:05:51.318Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "AB865A3B",
                                        "AutoV2": "F1353BCCC9",
                                        "SHA256": "F1353BCCC975D11DAD08649F5E74E8F2ED275528A5F2A0AA0ADD66C3DC409D4F",
                                        "CRC32": "C95DB469",
                                        "BLAKE3": "ADA67C11F53E926EEC0485AEDE096662C4729E6D8CCCA4807DDF4B1D23E54AA4",
                                        "AutoV3": "7D78542BDEDF"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/446346",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 9864647,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a465c050-84b1-4357-a2c5-8a7a5f2f87ae/width=450/9864647.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U04Ln5b|4o?]ivenH=I900.T?^DiDN8wDN.T",
                                    "type": "image"
                                },
                                {
                                    "id": 9864648,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/83692d7f-31b0-4c15-8b4a-fc72aed9c012/width=450/9864648.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U055C3~q0000v%RPX.%g00R%_3tSF|g4rqMw",
                                    "type": "image"
                                },
                                {
                                    "id": 9864646,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0c67111f-d94d-4c09-b818-4121265e80fc/width=450/9864646.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U24LXlRkIToz_4ozM_kBtRt7V@aetSfkROjb",
                                    "type": "image"
                                },
                                {
                                    "id": 9864645,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1df5774e-7f5c-4884-b49a-1bea6cda813f/width=450/9864645.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U24xi9x^9FRO?wx]E0MxNakCoJf5Ioof%Mog",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/446346"
                        },
                        {
                            "id": 418782,
                            "name": "Concept Art Ultimatum",
                            "index": 2,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Concept Art Mixture + Concept Art Mixture Brush 50/50 = Concept Art Ultimatum</p><p>Concept Art Twilight + Concept Art Eclipse 50/50 = Concept Art Mixture (Unpublished)</p><p>Concept Art Mixture Brush (Unpublished)</p><p>Same data set as Concept Art Brush but trained on a mix of Twilight and Eclipse</p><p>Recommended LoRA Strength: 0.7-1</p>",
                            "publishedAt": "2024-03-30T08:51:00.969",
                            "availability": "Public",
                            "trainedWords": [
                                "concept art, digital art, realistic,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 12036,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 783,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 340628,
                                    "sizeKB": 223093.80078125,
                                    "name": "Concept Art Ultimatum Style LoRA_Pony XL v6.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-30T08:45:44.157Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "A5440537",
                                        "AutoV2": "AF6820BBF7",
                                        "SHA256": "AF6820BBF7C9F00B4ED3EAA40A95C064E1AA0F822B3796C7946D7025DBF8FFB1",
                                        "CRC32": "5F0F497A",
                                        "BLAKE3": "E82EEE9C2A42E5A14B2027E898A464661401F0C9B14BD68A40C261A9379D4DEF",
                                        "AutoV3": "DB9D0EA00DE3"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/418782",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 8821307,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/82c0925d-427b-4ff9-8bae-c01e0021bcb7/width=450/8821307.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U78ESdIU8|%2t,xvMxRP9a%LMcRk*0IUVXt7",
                                    "type": "image"
                                },
                                {
                                    "id": 8821305,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6fa5a4f0-ca67-4869-94a5-510ed7b194d3/width=450/8821305.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U68#7?E19H%Lo~x]MyMx0MxuH=V[*0IBZ#xt",
                                    "type": "image"
                                },
                                {
                                    "id": 8821308,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b0c298fc-0a97-4bbf-98f9-f80ef198f58e/width=450/8821308.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDH2AuE1E1~Wby%g?w%10.t7x^IVT0xZI9Sh",
                                    "type": "image"
                                },
                                {
                                    "id": 8821306,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c7b9faf6-7b73-4383-bd9f-aa8d3559890c/width=450/8821306.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEIEa}02XM~VtSo#.SoJBYs-ksIoTKxDIUtQ",
                                    "type": "image"
                                },
                                {
                                    "id": 8821304,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2533c03e-8f59-4c00-8ae8-9357bf30fc11/width=450/8821304.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UC9aEft79sRm_Nt7D%V[S}j]aKRibFogRPRj",
                                    "type": "image"
                                },
                                {
                                    "id": 8821311,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7758dc3d-938c-4a4b-bccf-070eced4203f/width=450/8821311.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UE9@VKt7E0WY_Nt7ITWBXSfkVsRiofofM{Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 8821309,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/67853e8b-35b9-43d7-947f-9c223d3e823d/width=450/8821309.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U9EVvhWV0e?a?^xu00Io0Lt7MdV@jEj@-pM{",
                                    "type": "image"
                                },
                                {
                                    "id": 8821310,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/76ff3f3a-2e4b-4c49-a21c-a1cdafca3201/width=450/8821310.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UHFiDLM|tj-;_NoMROIp4:R,MwaKIVRj$%M{",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/418782"
                        },
                        {
                            "id": 418769,
                            "name": "Concept Art Brush",
                            "index": 3,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Repeats: 20</p><p>Epoch: 2</p><p>Image Count: 70</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 1</p><p>Clip skip: 1</p><p>Training steps: 2800</p><p>Resolution: 1024x1024</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>Captioning: WD14 Captioning (SmilingWolf/wd-v1-4-moat-tagger-v2)</p><p>Trigger Words: concept art, digital art, realistic,</p><p>Recommended LoRA Strength: 0.7-1</p><p>LoRA is trained on images created by me using ideogram.ai</p>",
                            "publishedAt": "2024-03-30T08:33:15.805",
                            "availability": "Public",
                            "trainedWords": [
                                "concept art, digital art, realistic,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 2900,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 141,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 340620,
                                    "sizeKB": 223100.54296875,
                                    "name": "Concept Art Brush Style LoRA_Pony XL v6.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-30T08:35:50.638Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "6E3AFC14",
                                        "AutoV2": "5A8B4C2EEC",
                                        "SHA256": "5A8B4C2EECC138AE594A6CA16309B1BF888D8A1FBC2FE4788D56BFDF915926B0",
                                        "CRC32": "7F2BEC6B",
                                        "BLAKE3": "A9C8D6A0B058F6FA45B0FEB8865B47BF3EF493C8736244A216549D6224EE7AB9",
                                        "AutoV3": "07A77577A87B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/418769",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 8820857,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/778f7bf4-c5f0-435d-9d5d-74d0e3c25bac/width=450/8820857.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U58;c49u02wa_NtS8{ni5p-:HrM{O@ROr=Iq",
                                    "type": "image"
                                },
                                {
                                    "id": 8820859,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b04b91a5-d27e-4280-9f84-9c53b6aa5b4c/width=450/8820859.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U49Qpv9a00#j.TtR8_oM1O-;D4IVY6R4$fIp",
                                    "type": "image"
                                },
                                {
                                    "id": 8820854,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6de5042e-20f9-4032-9484-f43c15f7aa13/width=450/8820854.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAKANK5UL}^*vKT0~q%00-%1FzIo-psnD*kC",
                                    "type": "image"
                                },
                                {
                                    "id": 8820858,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f14dfb6f-0c70-4527-b8e6-87fc3d6ce130/width=450/8820858.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEKTe=0hIS?HwcNe~ps.F}xZOZRj%gsnIUkC",
                                    "type": "image"
                                },
                                {
                                    "id": 8820856,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0df43862-f8a0-42ec-a72d-ab088bc05a98/width=450/8820856.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U98zx{kU4:RQ_NxuD%M{cCxuMxIU%MxbIUIo",
                                    "type": "image"
                                },
                                {
                                    "id": 8820867,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4f83ce45-3d9d-4f78-b69e-8e39656bd973/width=450/8820867.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UA8|;XWT4.Rl_NofITV@kpxbR5NF%Mt7IAM{",
                                    "type": "image"
                                },
                                {
                                    "id": 8820864,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8b4ddaa6-71ed-4bb3-a62e-e6370ed7c619/width=450/8820864.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U6FYS:R+_1~B?b%L00NG00t7D*M|MdRj?GRj",
                                    "type": "image"
                                },
                                {
                                    "id": 8820865,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9f9c75ff-8b01-482f-8c76-cdc07aa63270/width=450/8820865.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U9GRhy9b^#?a~qNH4.NH00flDjNGM_Rk^jIp",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/418769"
                        },
                        {
                            "id": 398292,
                            "name": "Concept Art Eclipse",
                            "index": 4,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Concept Art Eclipse is a merge of 3 models</p><p>0.30 - Concept Art 2</p><p>0.35 - Concept Art Dark 2 (Unpublished)</p><p>0.35 - Concept Art Negative 2 (Unpublished)</p><p>LoRA Weight: [0.8-1]</p>",
                            "publishedAt": "2024-03-18T11:39:14.32",
                            "availability": "Public",
                            "trainedWords": [
                                "concept art, realistic,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 9627,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 677,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 321168,
                                    "sizeKB": 223093.83203125,
                                    "name": "Concept Art Eclipse Style LoRA_Pony XL v6.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-18T11:40:40.253Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "5B6F5AFE",
                                        "AutoV2": "7D82C67370",
                                        "SHA256": "7D82C6737082F8C0FC6C3FFA0C7E44A98A85821D5B605B52DFDFC31005FEA406",
                                        "CRC32": "701E1B78",
                                        "BLAKE3": "8693BFD5499D3274ED68284CB2A610430CECC1C60190F72FE30E0C4297C65919",
                                        "AutoV3": "3452A682132C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/398292",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 8153270,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/db5d6575-e745-4455-9a8d-53e1c6222a63/width=450/8153270.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U17K#h0WXn^GOv%34;-;00~UE88_QkD%$xpL",
                                    "type": "image"
                                },
                                {
                                    "id": 8153271,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0bf3c8c2-9d0c-4faf-82b7-782fe147daba/width=450/8153271.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U58EG8D*4o%fIAogkYV@00%MaKRP.TMxR4%M",
                                    "type": "image"
                                },
                                {
                                    "id": 8153269,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f9c283a5-6bd5-4499-8fe8-8c838ef5b31f/width=450/8153269.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UADvWdD*X.~WS8xuyExD0L%MRPIUNxe:Z~Nb",
                                    "type": "image"
                                },
                                {
                                    "id": 8153272,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/305669f5-6081-43d7-a7a8-90a9add9600d/width=450/8153272.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCF~Kz4nu4~CJGj?t.xC5B-:V@ShT0xaivJB",
                                    "type": "image"
                                },
                                {
                                    "id": 8153276,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/56f9cf7b-dc9c-490a-99cb-3e7634769ae8/width=450/8153276.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDA0]|MxR*x]_4t7Rjt7W;xuaeRjo#j]RiWB",
                                    "type": "image"
                                },
                                {
                                    "id": 8153275,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e0568be-5a3a-43b4-8065-bc0116788ad5/width=450/8153275.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UHA,:}MxW-x]_4k9RjtRbbt7RPaexvWBRiae",
                                    "type": "image"
                                },
                                {
                                    "id": 8153273,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b06258be-5218-4ea4-a55e-688a2dec7c4a/width=450/8153273.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCBzC8%hXm?H?wt8M{ozI[RkWAofEMWBxtR-",
                                    "type": "image"
                                },
                                {
                                    "id": 8153274,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4227db29-0fb4-4d03-83e0-e7e82186a6ce/width=450/8153274.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UID]h^pJXS%L.Tx^M{f+I[M}V?ofSiIU%LR+",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/398292"
                        },
                        {
                            "id": 398283,
                            "name": "Concept Art 2",
                            "index": 5,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 7,
                            "description": "<p>Repeats: 20</p><p>Epoch: 20</p><p>Image Count: 14</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 2800</p><p>Resolution: 1024x1024</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>Captioning: WD14 Captioning (SmilingWolf/wd-v1-4-moat-tagger-v2)</p><p>Trigger Words: concept art, realistic,</p><p>LoRA Weight: [0.7-1]</p><p>Same dataset as Concept Art but edited, more detail in the lights and a little more texture.</p>",
                            "publishedAt": "2024-03-18T11:27:40.178",
                            "availability": "Public",
                            "trainedWords": [
                                "concept art, realistic,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3300,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 181,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 321158,
                                    "sizeKB": 223098.54296875,
                                    "name": "Concept Art 2 Style LoRA_Pony XL v6.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-18T11:30:50.039Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "D8903E90",
                                        "AutoV2": "EE5EECCE1A",
                                        "SHA256": "EE5EECCE1AB4D7F100731E9BFA46EAEA15A3F81CECF64514E1B66129BC230976",
                                        "CRC32": "46A286C0",
                                        "BLAKE3": "4DB4DE43400940321E90A2B8205D994FB7EBCC385E671A50A9ECCF272CEBE689",
                                        "AutoV3": "09E057C225A3"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/398283",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 8152900,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f37569b3-8946-4965-b47d-f8565e01b9b8/width=450/8152900.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UHBzd?RQT0tR?^bIf,x[x]f+xvoft6a#MxWB",
                                    "type": "image"
                                },
                                {
                                    "id": 8152894,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0369d0bb-8e7f-4d17-a27a-0b12d1823426/width=450/8152894.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U7A1U}RP4ptRy?XSa%kD8_.7pIMy-;t88waK",
                                    "type": "image"
                                },
                                {
                                    "id": 8152895,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aca24857-4470-4d28-9cb4-42f139b85d22/width=450/8152895.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UBEyVs_2TeMd.TogtmxCK6%gaKM{O@R-xaoe",
                                    "type": "image"
                                },
                                {
                                    "id": 8152902,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6cbade59-5a50-45df-a17e-804e21906b5e/width=450/8152902.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAHLVZ~pLfQ,xxkpca~B69?]VsazLMkW%2WV",
                                    "type": "image"
                                },
                                {
                                    "id": 8152898,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5c157b4e-02d6-4567-a546-d730b4b82398/width=450/8152898.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UXE:G8IU%M%g_Nozt7x]oytQofo1t7aejZWB",
                                    "type": "image"
                                },
                                {
                                    "id": 8152906,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f045764-e67d-490a-8d08-af77a3520c7e/width=450/8152906.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UfGI}:IAtkx]_NbbtQx[X5oyt6s.tRV@V@ae",
                                    "type": "image"
                                },
                                {
                                    "id": 8152904,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9344b3f6-da50-4bdb-8397-c732f35f9d1e/width=450/8152904.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UOF$b8x].8ae_NRQNGV[pIkCNGt7X8V[soWX",
                                    "type": "image"
                                },
                                {
                                    "id": 8152910,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e4693045-4442-4933-b54f-2d2aee93f833/width=450/8152910.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UWG]5F%fyDVt_MjFRjV@pIWXV[ofbvoes:kV",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/398283"
                        },
                        {
                            "id": 396157,
                            "name": "Eldritch Oil",
                            "index": 6,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Eldritch Oil is a merge of 3 models</p><p>0.35 - Oil Painting Sharp</p><p>0.35 - Impressionism Oil Painting</p><p>0.30 - Palette Knife Painting</p>",
                            "publishedAt": "2024-03-17T05:08:52.822",
                            "availability": "Public",
                            "trainedWords": [
                                "oil painting, traditional media, realistic,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3768,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 205,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 319170,
                                    "sizeKB": 223093.83203125,
                                    "name": "Eldritch Oil Style LoRA_Pony XL v6.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-17T05:13:03.089Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "79DE9B94",
                                        "AutoV2": "F8CF0A571F",
                                        "SHA256": "F8CF0A571F9F99DC1124BC4B1BA308B85E7C5C7B95951D50D2DBFFB495196125",
                                        "CRC32": "CDDA5505",
                                        "BLAKE3": "08E0579CDB30C2945193F273ACE22C2052D62F40DFF5FAFF9E879D271F3811BA",
                                        "AutoV3": "0A242520CCB6"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/396157",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 8083062,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9be24265-1051-4091-b6c2-07b1f3b82f73/width=450/8083062.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U7Amo2bv0f?GNLbx9cr;00ae-oRO.mRjMctR",
                                    "type": "image"
                                },
                                {
                                    "id": 8083061,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/350a5b6e-6a63-4910-9aaf-d3e2bd4d53f2/width=450/8083061.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U68|@a9H0N^%adozE2nh4o?GR4Iq.mD*n4%L",
                                    "type": "image"
                                },
                                {
                                    "id": 8083057,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d5547703-db0f-4f0d-8cf8-5e3cc623b424/width=450/8083057.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UBHeRV^l0eNe?JRm?wx[G0x[%hR-O[E1xD%L",
                                    "type": "image"
                                },
                                {
                                    "id": 8083058,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6dee92f1-55c3-49d7-bca3-7ec2135c3cee/width=450/8083058.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "ULHU,u~o9@tSRQ-=yEozE7o$tSWFx[R-oMR.",
                                    "type": "image"
                                },
                                {
                                    "id": 8083060,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b3ee981a-bcc9-4d9c-9b34-b15e6990ed08/width=450/8083060.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEB3{LIAIoyD_NoyIAtRS1o#RPV@tRWBjEn$",
                                    "type": "image"
                                },
                                {
                                    "id": 8083081,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e93bfc1-83e2-4d0b-ba4c-683416a2c6e3/width=450/8083081.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UIBWrcDiNayD_Nf5IUx]NatRRijEkXWCjFn$",
                                    "type": "image"
                                },
                                {
                                    "id": 8083083,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9f60c14e-11f5-467e-bf23-3110468ab0bd/width=450/8083083.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UMEyGAp0%gR+~qx]bvRkE2ogf+R+M{R*t7WC",
                                    "type": "image"
                                },
                                {
                                    "id": 8083075,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6c26d20d-8588-4307-87e6-faba40924733/width=450/8083075.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEF=p*k@yD^+_N-?OYX99bkYjIIVXSIo?HE2",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/396157"
                        },
                        {
                            "id": 396148,
                            "name": "Palette Knife",
                            "index": 7,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Repeats: 20</p><p>Epoch: 10</p><p>Image Count: 20</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 2000</p><p>Resolution: 704x1024, 792x1024</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>Captioning: WD14 Captioning + Edit (SmilingWolf/wd-v1-4-moat-tagger-v2)</p><p>Trigger Words: oil painting, traditional media, realistic,</p><p>LoRA Weight: [0.7-1]</p><p>This Style is trained on the images created by this LoRA</p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/336656/eldritch-palette-knife-painting-oil-painting-style\">https://civitai.com/models/336656/eldritch-palette-knife-painting-oil-painting-style</a></p>",
                            "publishedAt": "2024-03-17T04:59:18.028",
                            "availability": "Public",
                            "trainedWords": [
                                "oil painting, traditional media, realistic,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 2022,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 87,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 319158,
                                    "sizeKB": 223099.12109375,
                                    "name": "Palette Knife Painting Style LoRA_Pony XL v6.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-17T05:00:57.592Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "4A1E09A6",
                                        "AutoV2": "D58F8F8E82",
                                        "SHA256": "D58F8F8E8257F5B775C6339073CCB6FF838E80A8E53D8ADE7BEBA13EDFC10444",
                                        "CRC32": "506DBEB4",
                                        "BLAKE3": "E7D1BCEAFEF7C1136684E0C7E87656471EA4E71EC26234B3EC28760686412839",
                                        "AutoV3": "C34C3B156D24"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/396148",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 8082792,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/412e88cf-0155-4d61-a5ca-230aa6392878/width=450/8082792.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8A,H_.7XA=^_L?FRQV@IrxZIUIVt8M~$yM|",
                                    "type": "image"
                                },
                                {
                                    "id": 8082794,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/38df7247-804f-4136-95cc-b7bf111dcd27/width=450/8082794.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U48|;H2w0p~9%~xu03$f0M$fHrM|%#Iq^gE3",
                                    "type": "image"
                                },
                                {
                                    "id": 8082795,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1511bc03-a825-48ea-b4e9-7f5424c64d2b/width=450/8082795.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UIF~KjWAFw-S_Nt6kqrrIrt7%MWB-:s:jroy",
                                    "type": "image"
                                },
                                {
                                    "id": 8082793,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f909d1e-3029-4e05-8865-30f0a605a459/width=450/8082793.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UJH_rSELF?^j?wxtpJr?EAxa%hIp_NRjoJoz",
                                    "type": "image"
                                },
                                {
                                    "id": 8082791,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/637d4d6c-b577-4102-9750-0fc88a1a0819/width=450/8082791.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8BMY*R-0~?G_MbbD%%1J-WW#QIo~BWBI:WB",
                                    "type": "image"
                                },
                                {
                                    "id": 8082800,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e0b0e69b-6f6f-48ab-857d-72edfc7a5e20/width=450/8082800.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UABfqjM|0~%g_No}RPx[NHXSwHIU%2RjIoRP",
                                    "type": "image"
                                },
                                {
                                    "id": 8082801,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/810594ff-ce92-48ed-9c1d-c4c9533d7693/width=450/8082801.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGF5Nn?FRO-U~pxtMdM}FyWCR5E3?GoKnhoe",
                                    "type": "image"
                                },
                                {
                                    "id": 8082802,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d7df342c-5957-463f-82d1-e49c8412c42c/width=450/8082802.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAG8Afs,AU~U.7-o$eRl01n$-89a$%V@-UIo",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/396148"
                        },
                        {
                            "id": 396134,
                            "name": "Impressionism Oil",
                            "index": 8,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Repeats: 20</p><p>Epoch: 5</p><p>Image Count: 58</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 2900</p><p>Resolution: 704x1024, 792x1024, 1024x792</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>Captioning: WD14 Captioning + Edit (SmilingWolf/wd-v1-4-moat-tagger-v2)</p><p>Trigger Words: oil painting, traditional media, realistic,</p><p>LoRA Weight: [0.8-1]</p><p>This Style is trained on the images created by this LoRA</p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/312341/eldritch-impressionism-oil-painting\">https://civitai.com/models/312341/eldritch-impressionism-oil-painting</a></p>",
                            "publishedAt": "2024-03-17T04:49:12.116",
                            "availability": "Public",
                            "trainedWords": [
                                "oil painting, traditional media, realistic,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 2004,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 84,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 319146,
                                    "sizeKB": 223102.34765625,
                                    "name": "Impressionism Oil Painting Style LoRA_Pony XL v6.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-17T04:50:59.443Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "03695AE9",
                                        "AutoV2": "40C66A2A38",
                                        "SHA256": "40C66A2A38DA252D3C6043AA056016B1E2A0755E8196424F5849581843C11E93",
                                        "CRC32": "2982584D",
                                        "BLAKE3": "FDAC4AC430986BA0C5ACA1FDE230E3CCD8B553D281B60F403947BAA99F5BAA86",
                                        "AutoV3": "027D37AFF49C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/396134",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 8082554,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/abc2d49c-22bc-44be-8eda-743891e7495b/width=450/8082554.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U6AwSGtk01slyYoLDji^4;jE#QaK?]n#Mcb_",
                                    "type": "image"
                                },
                                {
                                    "id": 8082550,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e97bdda-9915-4fce-aa2d-3fcd6716eac1/width=450/8082550.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U89@nyE4ES-:NznOM}s.EQn3R4M|ysIp%LkW",
                                    "type": "image"
                                },
                                {
                                    "id": 8082552,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9b649ada-d27b-43d4-a3d3-a5b69ba8700a/width=450/8082552.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8HU^B#*g%T2%iRjyZSi5q%hI:R*AEIpR4xZ",
                                    "type": "image"
                                },
                                {
                                    "id": 8082553,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/83c19bda-9e4d-4e84-9588-f2941e957919/width=450/8082553.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDIE^P-TO@R:?cae.TkCTLtltRW=TJNHV=fk",
                                    "type": "image"
                                },
                                {
                                    "id": 8082551,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f2b83e39-65fd-4433-9220-486a121d0237/width=450/8082551.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDB|gAR6F3yD_Nt7D%tlIobcVsi^xuWBe.sl",
                                    "type": "image"
                                },
                                {
                                    "id": 8082556,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ee034672-389a-47c7-9f14-a07fe5a5e72e/width=450/8082556.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UJCGx,MdOYyD_NoyIUtlNGo#ROn$tRRkjEsm",
                                    "type": "image"
                                },
                                {
                                    "id": 8082555,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a14f6d16-24ee-4cb4-b11c-3812d32b8b71/width=450/8082555.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCDcBjIq%eM{~pxtIoM{4:t6oJR*D*R*%1t7",
                                    "type": "image"
                                },
                                {
                                    "id": 8082557,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f38972b-baee-4482-9b55-b82976ff947a/width=450/8082557.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAEfQSxu?uxZ~pxaW-WC4oWBjGWV9GbH-pRj",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/396134"
                        },
                        {
                            "id": 396121,
                            "name": "Oil Painting Sharp",
                            "index": 9,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 19,
                            "description": "<p>Repeats: 20</p><p>Epoch: 5</p><p>Image Count: 56</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 2800</p><p>Resolution: 704x1024</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>Captioning: WD14 Captioning + Edit (SmilingWolf/wd-v1-4-moat-tagger-v2)</p><p>Trigger Words: oil painting, traditional media, realistic,</p><p>LoRA Weight: [0.8-1]</p><p>This Style is trained on the images created by this LoRA</p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/127139/classipeintxl-oil-paint-oil-painting-style\">https://civitai.com/models/127139/classipeintxl-oil-paint-oil-painting-style</a></p>",
                            "publishedAt": "2024-03-17T04:38:01.068",
                            "availability": "Public",
                            "trainedWords": [
                                "oil painting, traditional media, realistic,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 2862,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 126,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 319134,
                                    "sizeKB": 223101.18359375,
                                    "name": "Oil Painting Sharp Style LoRA_Pony XL v6.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-17T04:40:50.459Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "23716249",
                                        "AutoV2": "97068E9045",
                                        "SHA256": "97068E90451C0554043C95FF593D9CAB45B3F50437364D91AC9DC79437247B2C",
                                        "CRC32": "B09D3F18",
                                        "BLAKE3": "9197FBE031829DECA414F046418C33492A9AC7D04EE8C4D51C4ED3998D88CF04",
                                        "AutoV3": "1002C788271B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/396121",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 8082111,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5aecd268-44e5-4e8e-b43c-97242372b647/width=450/8082111.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UB9@S3t659tRMwWENIs89EMxV?t6?^i^RQS4",
                                    "type": "image"
                                },
                                {
                                    "id": 8082113,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5be4c49d-7d1a-4d0a-9c30-1a8f1a7a4cf9/width=450/8082113.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U48z=I4T0o$wvy%#4Ux]0L.8Q,IVPq8w_NM_",
                                    "type": "image"
                                },
                                {
                                    "id": 8082114,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bb51cd9a-7f23-46d8-92e7-f140da7782c0/width=450/8082114.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UBHeE@?H01Io.9bc%#aKYRtQ%hVt.SoMxubb",
                                    "type": "image"
                                },
                                {
                                    "id": 8082112,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/63c24489-0c92-4a5e-8ec9-a5c048c972a3/width=450/8082112.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UKIO2m~WEdozsE-;yDtR9#%gtTogXmbdxuj]",
                                    "type": "image"
                                },
                                {
                                    "id": 8082110,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/854d6943-1a44-4bd3-a011-fb9137bc96ba/width=450/8082110.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UJBM=K9EW;%N_4M{RjtRX7ofoJRikXRjoJo0",
                                    "type": "image"
                                },
                                {
                                    "id": 8082115,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5d23abfa-df6e-4d58-8aed-798b7cf4e70f/width=450/8082115.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UJA,wp8_W;%g_4RPNGxvbbj?oeV[kXRjs-n*",
                                    "type": "image"
                                },
                                {
                                    "id": 8082116,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/df952237-2edc-432b-b418-afdaa99c4b35/width=450/8082116.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UHFh@eE3_1s7~p%0bvM{I=nNX9aeofE1xus:",
                                    "type": "image"
                                },
                                {
                                    "id": 8082117,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/55e16dfe-523f-4ac2-ba7f-59a45efd1214/width=450/8082117.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "URG8=kS6t6oL_N%NM{Rkb_t8RjaytlRkt6ay",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/396121"
                        },
                        {
                            "id": 382235,
                            "name": "Gothic Art 2",
                            "index": 10,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 7,
                            "description": "<p>Repeats: 20</p><p>Epoch: 10</p><p>Image Count: 24</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 2400</p><p>Resolution: 768x1024</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>Captioning: WD14 Captioning + Edit (SmilingWolf/wd-v1-4-moat-tagger-v2)</p><p>Trigger Words: gothic art, oil painting, traditional media, realistic,</p><p>LoRA Weight: [0.7-1]</p>",
                            "publishedAt": "2024-03-09T05:33:59.876",
                            "availability": "Public",
                            "trainedWords": [
                                "gothic art, oil painting, traditional media, realistic,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 5405,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 402,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 306674,
                                    "sizeKB": 223099.53515625,
                                    "name": "Gothic Art 2 Style SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-09T05:35:57.638Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "6BDA1999",
                                        "AutoV2": "025E4799ED",
                                        "SHA256": "025E4799ED08603421AAC324C70C4ABEF0B2F697EF8824D4FC9B9C4F8DBF91A7",
                                        "CRC32": "A63ED846",
                                        "BLAKE3": "64F2553DCCA53780A5BBE783FB22C6224EAB1A4C373BDFC3359FD021CF077DEE",
                                        "AutoV3": "AEBD32C215DA"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/382235",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 7661577,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0247c99d-cf2c-4ba8-b41f-5daee806d63e/width=450/7661577.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U2BpLW~qyYNa0g4n}tV]00IUAH^*PC~V0Kt4",
                                    "type": "image"
                                },
                                {
                                    "id": 7661579,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/49bb6796-3276-4865-a63e-fbed26d7b589/width=450/7661579.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U59%ef~U0MR-0MENR.M|4pIV%Lxt%f%0nNxt",
                                    "type": "image"
                                },
                                {
                                    "id": 7661578,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/30a610cd-2ca6-4ac1-ad31-2760c083ea9b/width=450/7661578.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAEyJJxt4.RjF#NG~ptRyEoyNIogbvbI$$of",
                                    "type": "image"
                                },
                                {
                                    "id": 7661576,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bbc5a763-fad5-4d99-a551-7deb776d01fb/width=450/7661576.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEGIWGxuNZtQO]R*~qxuktt6E2R+R-oejEWB",
                                    "type": "image"
                                },
                                {
                                    "id": 7661580,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bff58e88-c92d-4366-bcec-66c280ab520a/width=450/7661580.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U3Bf-2kS#N^%PC9F4o.8~9D$E3_3yY9Fr:kD",
                                    "type": "image"
                                },
                                {
                                    "id": 7661581,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/439648a6-5c73-43bd-bbc9-2a8a9e691220/width=450/7661581.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U4Bpa@o}iZ-n_ND*IA.8n34o4p?v?wMxrVWZ",
                                    "type": "image"
                                },
                                {
                                    "id": 7661583,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8ef7f386-a115-4468-9bd0-5781371685d3/width=450/7661583.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U3C~^:_2t-01K7Ip4:slD*V@IU%24:-o~9W=",
                                    "type": "image"
                                },
                                {
                                    "id": 7661582,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ab7a31e2-979c-4ddd-9c35-efc574f4fc1b/width=450/7661582.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDEL]E~px]az.8xuIps.t7t7s.xakCxaoJR+",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/382235"
                        },
                        {
                            "id": 379218,
                            "name": "Smooth Anime Night",
                            "index": 11,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 7,
                            "description": "<p>Smooth Night + Cold Night = Smooth Anime Night</p>",
                            "publishedAt": "2024-03-07T12:31:35.871",
                            "availability": "Public",
                            "trainedWords": [
                                "dark theme, low light,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 5151,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 311,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 304046,
                                    "sizeKB": 223093.82421875,
                                    "name": "Smooth Anime Night Style SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-07T12:37:19.051Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "7003C421",
                                        "AutoV2": "F6A5637005",
                                        "SHA256": "F6A5637005CE527AF588322BA9F1AC42FC886BD574CE38890222ED2478E2F428",
                                        "CRC32": "FCA4924F",
                                        "BLAKE3": "6E469BF711E349218B09CCEF8EA9D2D2916AC4C695D43073F1F9B14F9F8F8BE1",
                                        "AutoV3": "D2350BC23E81"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/379218",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 7573822,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/187ca12c-150c-4da4-b4d7-7738499b2036/width=450/7573822.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U23vXJL}HstnyGWEXCp0D4t-pJafR:tlQRkC",
                                    "type": "image"
                                },
                                {
                                    "id": 7573820,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a3196059-acd3-4d3a-b218-8b9da988191e/width=450/7573820.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U24VzbHq8xs=tVWFXWtU8wyYtma$kZpHL#o~",
                                    "type": "image"
                                },
                                {
                                    "id": 7573821,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/92c8af93-345a-4a72-832b-bd20a13236cc/width=450/7573821.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UH98JgMwI;%hbyad%%M_RoV?ogWAWoWAV?j?",
                                    "type": "image"
                                },
                                {
                                    "id": 7573823,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71dbe855-f593-42c0-88e0-5335be5db4b2/width=450/7573823.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UHAdpAMwEK%hN3jE.AM{IYadV^RiR$f4RNod",
                                    "type": "image"
                                },
                                {
                                    "id": 7573819,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fdda2e21-7bdf-4b55-93f9-b37c1ce6608d/width=450/7573819.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UB3S-aadVqo$t:adVrkXo$adVqkDbEaxaIfl",
                                    "type": "image"
                                },
                                {
                                    "id": 7573825,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5951eb91-73b4-47ba-9133-913d0bb4613c/width=450/7573825.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U95=-4R5McyE.TV@Mwo~tRj]MbkDkCWAVra#",
                                    "type": "image"
                                },
                                {
                                    "id": 7573824,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/91c20aaf-7799-437f-98a9-c1a3a919562a/width=450/7573824.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UI6[zRo#Wsog%%tTRjkDo~o#aeaytnj]oLWB",
                                    "type": "image"
                                },
                                {
                                    "id": 7573826,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f2de57ea-890d-45f9-9417-e95c16adbdca/width=450/7573826.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDAm-+_3.9%g_4?wt7xvkDxuj?axxuRjofWA",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/379218"
                        },
                        {
                            "id": 379209,
                            "name": "Smooth Night",
                            "index": 12,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 7,
                            "description": "<p>Repeats: 20</p><p>Epoch: 20</p><p>Image Count: 12</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 2400</p><p>Resolution: 576x832</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning: SmilingWolf/wd-v1-4-moat-tagger-v2</p><p>Trigger Words: dark theme, low light,</p><p>LoRA Weight: [0.8-1]</p>",
                            "publishedAt": "2024-03-07T12:23:44.441",
                            "availability": "Public",
                            "trainedWords": [
                                "dark theme, low light,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 2675,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 124,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 304034,
                                    "sizeKB": 223098.43359375,
                                    "name": "Smooth Night Style SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-07T12:26:41.015Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "0FAC6035",
                                        "AutoV2": "265DD27138",
                                        "SHA256": "265DD27138332C365EE858144E56DAC0966AB078DBA18BB432870A6BC22D5BCE",
                                        "CRC32": "77AC4DC6",
                                        "BLAKE3": "0B5330A366CF9F4BCD47005D065F18E2172DFC59568B82636676A0623F744388",
                                        "AutoV3": "B732B80BA312"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/379209",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 7573624,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c052c7f9-bfeb-4700-ab5b-be3002f5699c/width=450/7573624.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "US3^2CazkZkDt:aykYkDkYfPf5j]aej[acf6",
                                    "type": "image"
                                },
                                {
                                    "id": 7573625,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d69766a0-ccd0-450b-8021-3b53ce8aa2c8/width=450/7573625.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UM3mIyf8kFj^pMe.kEkDkYaxaxj]kDkCadf5",
                                    "type": "image"
                                },
                                {
                                    "id": 7573622,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/53ac4c66-9e1e-4bb3-9dd3-a763f538c1db/width=450/7573622.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UG5PX;VrpMo%toadp0aeRMf5acaxWEkDaekD",
                                    "type": "image"
                                },
                                {
                                    "id": 7573621,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5f81f767-7cb1-44b2-bba9-106e86bea24f/width=450/7573621.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UC7V1YMwcHx_tpaLtoRiITaJs;V?Mwj[V=j@",
                                    "type": "image"
                                },
                                {
                                    "id": 7573623,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6991c594-ebf5-4cf2-8d32-96102d7817d3/width=450/7573623.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U92shYkDVpj]pMf5Z}kCkXadVpkCkYflaJf5",
                                    "type": "image"
                                },
                                {
                                    "id": 7573628,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e7764559-6ad8-4936-a69f-eef4af59abff/width=450/7573628.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U84yWbV?Q,tm*0V?Q,o~tjV@MbkXtlf8Vra~",
                                    "type": "image"
                                },
                                {
                                    "id": 7573626,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8eb7681e-8741-48e4-9e80-25fdce2f68c7/width=450/7573626.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UN7VDxV@tnae%%WBkDaxyEa#WAfQtRaeV?j[",
                                    "type": "image"
                                },
                                {
                                    "id": 7573627,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a53c1948-7c94-4613-9271-dad4a2f987c9/width=450/7573627.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UUAUK^j]x_f5.TazWDj?yEWCRjj[tRWBV@oe",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/379209"
                        },
                        {
                            "id": 374041,
                            "name": "Summer Night",
                            "index": 13,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 5,
                            "description": "<p>Repeats: 20</p><p>Epoch: 20</p><p>Image Count: 16</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 3200</p><p>Resolution: 960x1024</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning: SmilingWolf/wd-v1-4-moat-tagger-v2</p><p>Trigger Words: dark theme, low light,</p><p>LoRA Weight: [0.8-1]</p><p>With the use of Trigger Words the image becomes darker and more like night, same with Cold Night</p>",
                            "publishedAt": "2024-03-04T15:40:54.579",
                            "availability": "Public",
                            "trainedWords": [
                                "dark theme, low light,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 5519,
                                "ratingCount": 109,
                                "rating": 4.98,
                                "thumbsUpCount": 466,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 299662,
                                    "sizeKB": 223099.68359375,
                                    "name": "Anime Summer Night Style SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-04T15:40:51.868Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "25CB2A0B",
                                        "AutoV2": "12ADF1A067",
                                        "SHA256": "12ADF1A0676F4DA8959DDCD32806AA566680F5E803A5D919B7261EC3EA756B0A",
                                        "CRC32": "588AB10B",
                                        "BLAKE3": "5FECFAC8ACF1EF049B504BB83E70D0AC007D6C6DB9F3116ACB0800B03E979031",
                                        "AutoV3": "B86F759E5613"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/374041",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 7441533,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e7ece518-6460-4643-85fa-d5c6ddb29b75/width=450/7441533.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U02?He#NMH.9S$S+8_IpHX%%yZiuWAo~xsQ*",
                                    "type": "image"
                                },
                                {
                                    "id": 7441534,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9b97c704-2f6b-41e4-bb73-20152419662f/width=450/7441534.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U23SVAR3kT%iR3o$fgRPRPRPkFVrWGkBeoo~",
                                    "type": "image"
                                },
                                {
                                    "id": 7441532,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7d7abe3e-ebce-4943-a8e3-67766f55b045/width=450/7441532.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U12Y@YR4MbtnyFWAROo#yFaeMbo#o~flVrfl",
                                    "type": "image"
                                },
                                {
                                    "id": 7441531,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eca84904-f1be-415f-b0f2-5ef4e3ed4f27/width=450/7441531.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U12r~$yFITRO%$tTI9RiaKR4McRPVqROVrax",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/374041"
                        },
                        {
                            "id": 372898,
                            "name": "Summer Days 2",
                            "index": 14,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Repeats: 20</p><p>Epoch: 20</p><p>Image Count: 16</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 3200</p><p>Resolution: 960x1024</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning: SmilingWolf/wd-v1-4-moat-tagger-v2</p><p>LoRA Weight: [0.8-1]</p><p>Same dataset only with reduced contrast, a little more detail in the highlights and shadows and more Training steps</p>",
                            "publishedAt": "2024-03-03T23:10:10.504",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 6389,
                                "ratingCount": 55,
                                "rating": 5,
                                "thumbsUpCount": 410,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 298708,
                                    "sizeKB": 223102.33203125,
                                    "name": "Anime Summer Days 2 Style SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-03T23:11:02.673Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "C1782D26",
                                        "AutoV2": "1611FBB3D5",
                                        "SHA256": "1611FBB3D53EB5B0527D1168834E02F42C0A363825C216F095657B5880AC7474",
                                        "CRC32": "4EB10AC0",
                                        "BLAKE3": "80507134115AA309D57CFE6C239D0CC46170F5DA3BA526253144C6E591C11008",
                                        "AutoV3": "C5D19A0BC3AC"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/372898",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 7414969,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/70c9e35f-d264-4930-b26a-fa5705a9945a/width=450/7414969.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U5CPO#0.v}}lX.BC9xRj01t,S#ENGc~Awav}",
                                    "type": "image"
                                },
                                {
                                    "id": 7414971,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5d74aafc-fd25-48b8-a245-b0dbb54f9226/width=450/7414971.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UBFhx50#?D?HYRNL.8I[0QM{f-NH%MIUaJoJ",
                                    "type": "image"
                                },
                                {
                                    "id": 7414968,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2817e3cd-c901-45cb-9721-21913a54dcfb/width=450/7414968.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDDSw9IWNGRk_MM{RPX9jEWA9Gt7S1xtRPIp",
                                    "type": "image"
                                },
                                {
                                    "id": 7414970,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c4a72096-b359-4279-86c1-afcef1472d5f/width=450/7414970.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U5EoVy=rtQD*02%L0LI;4;9b00%M02R+~V%1",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/372898"
                        },
                        {
                            "id": 365402,
                            "name": "Cold Oil Gothic",
                            "index": 15,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Cold Oil + Gothic Art Sharp = Cold Oil Gothic</p><p>Gothic Art Sharp is the same as Gothic Art only sharper, even too sharper for this reason and not published</p>",
                            "publishedAt": "2024-02-28T15:02:05.58",
                            "availability": "Public",
                            "trainedWords": [
                                "oil painting, traditional media, realistic,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 5100,
                                "ratingCount": 180,
                                "rating": 5,
                                "thumbsUpCount": 409,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 292112,
                                    "sizeKB": 223093.81640625,
                                    "name": "Cold Oil Gothic Style SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-28T15:06:23.513Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "C4E52DB6",
                                        "AutoV2": "542E751DF5",
                                        "SHA256": "542E751DF516CEA4691EC86680F8BB818D10EC7B5CC3C0CEEF9A1A533CA65DFB",
                                        "CRC32": "B1AFF48B",
                                        "BLAKE3": "05D3085583D3FB88EB1F052E4D16AEDFFBDC85EFD9631746BFD3680910FDB5FF",
                                        "AutoV3": "51B5F639C752"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/365402",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 7220983,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a5cdf611-7c7b-4319-a6d9-ff8e27560b4c/width=450/7220983.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U4ATZa_N02IVElnh9#Iq008_xu-otTSiv|xs",
                                    "type": "image"
                                },
                                {
                                    "id": 7220985,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c8465573-655d-46c8-8c2c-42017dc8023b/width=450/7220985.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U59ju{_N0gM|gO%MI]I[008{tRt6IVIVm+$y",
                                    "type": "image"
                                },
                                {
                                    "id": 7220982,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d21e26cc-dee3-4e71-b8bb-d2b3002e8e78/width=450/7220982.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UIHV0Pxu4.M{JERk_NWVI_kCx^ofE2WBaxt7",
                                    "type": "image"
                                },
                                {
                                    "id": 7220981,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/58707f1d-ff8a-4847-aa40-b0a7eddf585c/width=450/7220981.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UMHxvhs,I.NGI^IU_NxuNhWBNLRkWWofRij[",
                                    "type": "image"
                                },
                                {
                                    "id": 7220984,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/13f598d9-e59f-4529-adbc-7eca18f1b198/width=450/7220984.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCCP*4M|ngxu_MjFMxtRocayD*tRNGRjRPbI",
                                    "type": "image"
                                },
                                {
                                    "id": 7220986,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a70f2786-9db9-433f-a491-62b8b545aee3/width=450/7220986.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UHCZb3M{WA%L_MRjRPxut6WBIUt7R%WBRPWC",
                                    "type": "image"
                                },
                                {
                                    "id": 7220988,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5aa2983a-017e-408d-b38b-297fc2b5b1b2/width=450/7220988.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCDJ3A~qEga{_3%NI@%LItt7kCbcNGRj%1t7",
                                    "type": "image"
                                },
                                {
                                    "id": 7220987,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7afcfb85-4f99-408d-9b32-017e0beea204/width=450/7220987.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UNFFHO~px[%M-;%MS4%LM}WCa#xaRjjss.WB",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/365402"
                        },
                        {
                            "id": 365387,
                            "name": "Cold Oil",
                            "index": 16,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Repeats: 20</p><p>Epoch: 5</p><p>Image Count: 56</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 2800</p><p>Resolution: 704x1024</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>Captioning: WD14 Captioning + Edit (SmilingWolf/wd-v1-4-moat-tagger-v2)</p><p>Trigger Words: oil painting, traditional media, realistic,</p><p>LoRA Weight: [0.8-1]</p><p>Cold Oil is whiter cooler less yellow unlike Oil Painting and not much more contrast in the shadows</p><p>Without Trigger Words the style isn't as strong it still looks good but with Trigger Words it looks like real Oil Painting</p><p>Cold Oil does not create low light images LoRA is in no way related to Cold Night other than Cold in the name</p><p>This Style is trained on the images created by this LoRA And the editing by me</p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/127139/classipeintxl-oil-paint-oil-painting-style\">https://civitai.com/models/127139/classipeintxl-oil-paint-oil-painting-style</a></p>",
                            "publishedAt": "2024-02-28T14:47:39.084",
                            "availability": "Public",
                            "trainedWords": [
                                "oil painting, traditional media, realistic,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3159,
                                "ratingCount": 6,
                                "rating": 5,
                                "thumbsUpCount": 78,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 292095,
                                    "sizeKB": 223101.19140625,
                                    "name": "Cold Oil Style SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-28T14:51:03.330Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "E4265093",
                                        "AutoV2": "DA6251695C",
                                        "SHA256": "DA6251695C5E216AD33D15BC544625C63B553EC44CF14146F03A74497352D5F8",
                                        "CRC32": "AF411B50",
                                        "BLAKE3": "9CF583DC75ED80C2A0A0E6C826E63EC40F27D81F0EB274CF97B766939B4FC2F0",
                                        "AutoV3": "7AA38D6C41C2"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/365387",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 7220581,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9e9646b4-4ecf-412b-a0c4-3e8e96a9e005/width=450/7220581.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8AJ.r~p58M}-naK4:IV4o9FIAt7tm%M-:xZ",
                                    "type": "image"
                                },
                                {
                                    "id": 7220586,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7c77110b-504d-431c-ad7b-a0d1c9200db7/width=450/7220586.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U68XLP?^0gIq?axb9xNG4UDiR4jDOuX8rpad",
                                    "type": "image"
                                },
                                {
                                    "id": 7220582,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2cd29d7b-4622-4b5f-82c6-a4edae2e7979/width=450/7220582.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGFiPtRQNYtR.SM{_Nxu%$Rjo#kDNyWBoJWB",
                                    "type": "image"
                                },
                                {
                                    "id": 7220585,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/297d5df4-6a2e-4204-906a-2f9dd4682b66/width=450/7220585.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UFGlI%9FO8kp?vIA_NR+x_M_jdWrIoR%xZV[",
                                    "type": "image"
                                },
                                {
                                    "id": 7220584,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dd8aedaf-be8e-4820-804e-d28fdb61b908/width=450/7220584.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UHCP#3IUx[xu~qRjWBt7-pWBIUoftRRjV[WV",
                                    "type": "image"
                                },
                                {
                                    "id": 7220588,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/47bc3f88-1bee-4e01-a2cf-dc433d56bbb7/width=450/7220588.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UHBz8[IUxt%M_NWAaetR%2WBIUt7ofRjWBj]",
                                    "type": "image"
                                },
                                {
                                    "id": 7220587,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/532a37da-705e-41c4-86de-445dcccad9e5/width=450/7220587.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEEf7#?bIn%0~Vt7Sg-:9ZaeoLkCIoWBs:x]",
                                    "type": "image"
                                },
                                {
                                    "id": 7220589,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/33c08889-3c1c-40aa-a5dd-67af6c6feaa3/width=450/7220589.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UNFrhV~qx]-:?a%MNb%MM{jZt7ofRjaejYWX",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/365387"
                        },
                        {
                            "id": 363874,
                            "name": "Cold Night",
                            "index": 17,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Repeats: 20</p><p>Epoch: 3</p><p>Image Count: 100</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 3000</p><p>Resolution: 768x1024</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning SmilingWolf/wd-v1-4-moat-tagger-v2</p><p>Trigger Words: dark theme, low light,</p><p>LoRA Weight: [0.8-1]</p><p>This is Night Version of Anime Style</p><p>Without using Trigger Words, the image is a bit lighter and almost no different, but I still recommend using Trigger Words</p>",
                            "publishedAt": "2024-02-27T11:36:31.126",
                            "availability": "Public",
                            "trainedWords": [
                                "dark theme, low light,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3272,
                                "ratingCount": 60,
                                "rating": 5,
                                "thumbsUpCount": 189,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 290818,
                                    "sizeKB": 223109.44921875,
                                    "name": "Anime Cold Night Style SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-27T11:41:04.646Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "50187DAD",
                                        "AutoV2": "1BB4922FB7",
                                        "SHA256": "1BB4922FB73A80970A96B4EB1E8C489AE60B149A529553EFE5EED68857AC6890",
                                        "CRC32": "08822745",
                                        "BLAKE3": "F1C26A3A5CEBA5691CC21C1876E45BFA4698DD1F9054FD268B2299EC433183B3",
                                        "AutoV3": "C5BE68B8F4C8"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/363874",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 7180329,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1dcd50f5-b104-43f8-a44c-d9f01cf4bfcb/width=450/7180329.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U64M6YMIWHtSyGR5tnV@Vuaxo#aekYV?VXo}",
                                    "type": "image"
                                },
                                {
                                    "id": 7180331,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bb938cec-fcae-405c-a11c-03da6cc8e5c9/width=450/7180331.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U95$fCMvI8x^WHaJt:V?RpadtSV@WYjEjEWB",
                                    "type": "image"
                                },
                                {
                                    "id": 7180330,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dc5ee8dd-83c3-48d7-b27c-8b29e562b0fe/width=450/7180330.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U33cR,V@MIt-ysahVYkCo?aeVYaxRgj@a1V@",
                                    "type": "image"
                                },
                                {
                                    "id": 7180328,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bb3a9a50-96b8-4fa6-95a4-972970572d18/width=450/7180328.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UF4o~Qo$V[adt:kDV?aykYj[ayado$juf6ad",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/363874"
                        },
                        {
                            "id": 363388,
                            "name": "Photo 2",
                            "index": 18,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 7,
                            "description": "<p>Repeats: 5</p><p>Epoch: 4</p><p>Image Count: 300</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 3000</p><p>Resolution: 768x1024</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>Captioning: WD14 Captioning + Edit (SmilingWolf/wd-v1-4-moat-tagger-v2)</p><p>Trigger Words: raw, photo, realistic,</p><p>LoRA Weight: [0.8-1]</p><p>Without the tokens raw, photo, realistic, the model will generate 2.5D-3D and sometimes 2D styles, these tokens should be at the beginning after the score, if you can't get a realistic style, you're doing something wrong try to change the prompt</p><p>The preview should show that the first image is with Trigger Words and the second image is just with LoRA</p><p>Score, Trigger Words, Prompt</p>",
                            "publishedAt": "2024-02-27T03:04:54.535",
                            "availability": "Public",
                            "trainedWords": [
                                "raw, photo, realistic,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 10642,
                                "ratingCount": 28,
                                "rating": 4.86,
                                "thumbsUpCount": 369,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 290398,
                                    "sizeKB": 223113.94921875,
                                    "name": "Photo 2 Style SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-27T03:06:01.577Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "62E6B8F1",
                                        "AutoV2": "979CBE2EC4",
                                        "SHA256": "979CBE2EC41F4870D5B27B2BADBD25D994C907A93C4AE74C177287289DE7DAFA",
                                        "CRC32": "22703107",
                                        "BLAKE3": "9ED37FD103FF038D8CB30E51F292026C561D52BE56ED04E4B95D222323CD1EA3",
                                        "AutoV3": "19F2FC550F8D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/363388",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 7165344,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aa8cbf10-7ead-4e49-bad1-286f7242e112/width=450/7165344.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U39Qmi0102^NwK%M0O%L00.8%L9bB@ob]}IV",
                                    "type": "image"
                                },
                                {
                                    "id": 7165341,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/02b73587-9106-432d-aa95-559282541a63/width=450/7165341.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U39jy30101^d-.ae0.-n00_MxZ9zF$.7mjNf",
                                    "type": "image"
                                },
                                {
                                    "id": 7165342,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/173d3f42-c1a3-425d-98ff-a8791e74e5b5/width=450/7165342.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "USH_=5xaITM{RkMx_NozI[M{ogjut7t7oIV@",
                                    "type": "image"
                                },
                                {
                                    "id": 7165343,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2dece6f5-e9d3-4621-a21a-30340bc69ef2/width=450/7165343.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UKH_-|xCteScXBD%?wof9gRiItIVIUWU%0s.",
                                    "type": "image"
                                },
                                {
                                    "id": 7165345,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e4d64dc2-7a68-4095-be59-72c206e2e04d/width=450/7165345.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEAwVINFR%x[_NRjRPt7xuWVMyoftQWVRQWB",
                                    "type": "image"
                                },
                                {
                                    "id": 7165347,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f2bfacb-75c7-4800-bce8-3eae2578fb97/width=450/7165347.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "ULB|g0M{X4xu_NR*Rjt7xtf+MyofbEayRPRj",
                                    "type": "image"
                                },
                                {
                                    "id": 7165348,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5a922f55-0ef6-4aa2-a56c-b41869f0e692/width=450/7165348.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UVG[+i_3tl%L~q%go#s:M|Rkjbt7NFRjadtQ",
                                    "type": "image"
                                },
                                {
                                    "id": 7165349,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1b573e51-652c-4b3e-9d50-2830f2853b7d/width=450/7165349.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UUHB#f~ptl?H^+-;NIs;RnWEs;xuayRjs-xt",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/363388"
                        },
                        {
                            "id": 354355,
                            "name": "Rainbow",
                            "index": 19,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Repeats: 20</p><p>Epoch: 12</p><p>Image Count: 20</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 2400</p><p>Resolution: 768x1024</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning</p><p>SmilingWolf/wd-v1-4-moat-tagger-v2</p><p>LoRA Weight: [0.8-1]</p>",
                            "publishedAt": "2024-02-21T16:25:30.716",
                            "availability": "Public",
                            "trainedWords": [
                                "rainbow style, vibrant colors, vivid colors,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3729,
                                "ratingCount": 164,
                                "rating": 4.99,
                                "thumbsUpCount": 364,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 282551,
                                    "sizeKB": 223099.26953125,
                                    "name": "Rainbow Style SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-21T16:25:57.822Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "0FCEFF7C",
                                        "AutoV2": "3967A20A16",
                                        "SHA256": "3967A20A16FA7B73D830C4DCB1090050F133C2A2CB8C374AA9CE5BB19F320E96",
                                        "CRC32": "64452D0A",
                                        "BLAKE3": "5963014AD76F4D5E7363AB7EF1A20E7583586944D14B80AF6255B35CE8865483",
                                        "AutoV3": "7579E96560DF"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/354355",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 6927414,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1babc55f-f853-4ea5-a1fa-6c1148f0d66f/width=450/6927414.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8HK6HB=M%|?1TbceDKO16+~2uR8peb[ROt7",
                                    "type": "image"
                                },
                                {
                                    "id": 6927419,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f19b3be4-98bb-4563-96ba-d4fcdcbb8337/width=450/6927419.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U6Dl7.Vy4r}=Wb%10-Nz0MS7J~Ip3GTJv|V@",
                                    "type": "image"
                                },
                                {
                                    "id": 6927425,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5d777310-7bd1-4ae6-8e10-f44bef4bb6e5/width=450/6927425.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCJQvU}@%VAsF}=zuO9]1PaMs.X3-nM}=qWB",
                                    "type": "image"
                                },
                                {
                                    "id": 6927415,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e18ae3c9-1d72-41e1-9f20-1e0c1f5d2cc7/width=450/6927415.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UFJj*uE2KG-.1QRj?^NK13R-R.IqS0WB=roL",
                                    "type": "image"
                                },
                                {
                                    "id": 6927416,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/db74d121-0f25-4898-b9bd-e7f2dfa0edb3/width=450/6927416.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UFHw+CM|jBtS.mrtD,kq-hS$IVjcXLxVv#NK",
                                    "type": "image"
                                },
                                {
                                    "id": 6927417,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e113d99c-19a8-4fa8-905b-de3c8ec4fa90/width=450/6927417.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UIHBJBE2$ex]?]sBM|o|-PX8D*kDR$o0VtNH",
                                    "type": "image"
                                },
                                {
                                    "id": 6927424,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/69d1a0cc-1acf-41d8-a98b-6fb2b7d4c57c/width=450/6927424.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U7I;3T+a:F~BWd=^9bD%-DnOyBvhHCrpY2-:",
                                    "type": "image"
                                },
                                {
                                    "id": 6927418,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/58762dba-b377-4afa-b1e2-9e78d0568765/width=450/6927418.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGIgo@~V.8~B?w-;AHIVI^9bRPr?ozIprq=_",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/354355"
                        },
                        {
                            "id": 341131,
                            "name": "Digital Art",
                            "index": 20,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 7,
                            "description": "<p>Repeats: 20</p><p>Epoch: 6</p><p>Image Count: 24</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 1440</p><p>Resolution: 832x1024+1024x768</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning</p><p>SmilingWolf/wd-v1-4-moat-tagger-v2</p><p>LoRA Weight: [0.7-1]</p><p>This Style is trained on the images created by this LoRA</p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/303233/eldritch-digital-art\">https://civitai.com/models/303233/eldritch-digital-art</a></p>",
                            "publishedAt": "2024-02-13T04:06:24.799",
                            "availability": "Public",
                            "trainedWords": [
                                "read description"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 6823,
                                "ratingCount": 239,
                                "rating": 5,
                                "thumbsUpCount": 469,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 271098,
                                    "sizeKB": 223101.93359375,
                                    "name": "Digital Art Style SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-13T04:07:35.574Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "2828CD82",
                                        "AutoV2": "191DBC9CCF",
                                        "SHA256": "191DBC9CCFE6F8F13F84C2C75697BBE946A794C7D01FBB9E1B49345500075734",
                                        "CRC32": "AB198A3C",
                                        "BLAKE3": "AE282FE8F1B86C4609787C6F146DE5D7C7EF13D5CAF8390B1A8D4FCE6D637AC5",
                                        "AutoV3": "0CF042B134DA"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/341131",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 6577990,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e4fbe288-a06d-442f-9541-1f438b3c3b60/width=450/6577990.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UD9aX2%0xanNlVozIWRjIVW?e-kCs8f,r;t6",
                                    "type": "image"
                                },
                                {
                                    "id": 6577987,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/625fdf0c-1f1d-463d-a2e0-9e5aff5f5ab5/width=450/6577987.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCB3]7yBr?$ePXtRE4M|4;ogxtR-xAR+wax[",
                                    "type": "image"
                                },
                                {
                                    "id": 6577986,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e495025-3d4d-4484-8577-d7dc9f8cd562/width=450/6577986.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UUEfc-V@.7xu_4oKxvofR.t7aeRkWUofn#WB",
                                    "type": "image"
                                },
                                {
                                    "id": 6577988,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/15a9fb38-e25b-497e-ade8-4f38609ceb5f/width=450/6577988.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UVFiPtRP.7%M_4aex]ozR:oye:WBocofn#WB",
                                    "type": "image"
                                },
                                {
                                    "id": 6577989,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a2f25303-5d45-40c2-8b1b-dee644e40d9d/width=450/6577989.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEC74wf+M|s;?^oIMykDxrRjD*fkxoj[aLM{",
                                    "type": "image"
                                },
                                {
                                    "id": 6577991,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1f400135-4541-449d-8c87-8371a09764ac/width=450/6577991.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UHD]#TtQNG%L_Nt5MykD%KRjD*Rjo[oMn$M{",
                                    "type": "image"
                                },
                                {
                                    "id": 6577992,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c2120b91-bbf4-428d-a334-e7db77363b66/width=450/6577992.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UKE3F-_NNaMx%NxuNGR*axV?D%IUaKRjofof",
                                    "type": "image"
                                },
                                {
                                    "id": 6577993,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/28cc444a-bf57-4517-abfe-75c422e94fde/width=450/6577993.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UWFFmT_NtRae%Nt8R*WBWAV?IUM{RjWBt7s:",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/341131"
                        },
                        {
                            "id": 333607,
                            "name": "Smooth Anime 2",
                            "index": 21,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 5,
                            "description": "<p>Smooth 2 + Anime 2 = Smooth Anime 2</p>",
                            "publishedAt": "2024-02-07T22:19:01.239",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 14921,
                                "ratingCount": 171,
                                "rating": 4.99,
                                "thumbsUpCount": 939,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 264526,
                                    "sizeKB": 223093.80859375,
                                    "name": "Smooth Anime 2 Style SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-07T22:21:56.671Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "C386D0B3",
                                        "AutoV2": "0A83E3D6A9",
                                        "SHA256": "0A83E3D6A93E494D44FB55AC87461502D5A705489CA5CD6B048988152AAEB6BA",
                                        "CRC32": "8C54BB6D",
                                        "BLAKE3": "6170C2972C7534718E6F81D3DC690BBA4D6722C169428A937AF15645051D0067",
                                        "AutoV3": "92E0B50D2A64"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/333607",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 6381068,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80f0aa6d-ec41-4d96-8bb9-623e17e22eb5/width=450/6381068.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U4A,zp0003Z$x_NKK8-V00~pt6ofA1^+4Tjv",
                                    "type": "image"
                                },
                                {
                                    "id": 6381073,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aad80bd1-10ee-42d0-894b-95996f1672e3/width=450/6381073.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UOI#u:nhcBg3XpIU?wtR5GWBIvR*oxxaV?WB",
                                    "type": "image"
                                },
                                {
                                    "id": 6381070,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e1cc5125-2e57-4e9c-b3a8-1dbf05250438/width=450/6381070.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGGS439a9a?G~UM|M{-p${tQ01xu.7oJRjIV",
                                    "type": "image"
                                },
                                {
                                    "id": 6381071,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/64cd56a7-3c53-43e2-86ca-de8f1833a066/width=450/6381071.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "URG[TY~px]%2-;-;S4%2R-ofofj]t7aes:Rk",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/333607"
                        },
                        {
                            "id": 333590,
                            "name": "Anime 2",
                            "index": 22,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 5,
                            "description": "<p>Repeats: 20</p><p>Epoch: 3</p><p>Image Count: 100</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 3000</p><p>Resolution: 768x1024</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning</p><p>SmilingWolf/wd-v1-4-moat-tagger-v2</p><p>LoRA Weight: [0.7-0.8]</p>",
                            "publishedAt": "2024-02-07T22:07:24.098",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 6198,
                                "ratingCount": 16,
                                "rating": 5,
                                "thumbsUpCount": 172,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 264511,
                                    "sizeKB": 223110.48046875,
                                    "name": "Anime Style 2 SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-07T22:10:47.388Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "4AA8EFF8",
                                        "AutoV2": "FA51B1E297",
                                        "SHA256": "FA51B1E29716B9CAC1F8D9E9C9A08FEEFC9ABD7239748E8DDC757D3F1EB4649E",
                                        "CRC32": "D886AFA3",
                                        "BLAKE3": "8DDCC83FF81286D7BD9AAA366ADDB77F9C084096411922B4B9C6DD1CF3A61256",
                                        "AutoV3": "8CF932758D69"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/333590",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 6380688,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0cbb97bc-4f0e-4967-8304-99652bcd888b/width=450/6380688.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8CPnpXoVy~A^joLajxZ00RPE2D+ALNH0LNI",
                                    "type": "image"
                                },
                                {
                                    "id": 6380689,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7b07dde3-7e40-4524-a75e-cdf92785f06e/width=450/6380689.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UII#lg~AX_OlT3D*?vx[0WShIcNdS%xUWAbY",
                                    "type": "image"
                                },
                                {
                                    "id": 6380686,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3c223e9e-b5c7-4a7e-8929-6bdd7dbb05f0/width=450/6380686.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UFFiSgNG0L-:~oR%IUxuD$WE9GxtNas:e.M{",
                                    "type": "image"
                                },
                                {
                                    "id": 6380687,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e6b7b71b-d1fb-4efd-a85a-203a1600d080/width=450/6380687.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UWIN:O~Wxvt7?b%fNw%LM}ofbGf6xtt6oeM|",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/333590"
                        },
                        {
                            "id": 333587,
                            "name": "Smooth 2",
                            "index": 23,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Repeats: 20</p><p>Epoch: 20</p><p>Image Count: 12</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 2400</p><p>Resolution: 576x832</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning</p><p>SmilingWolf/wd-v1-4-moat-tagger-v2</p><p>LoRA Weight: [0.7-0.8]</p>",
                            "publishedAt": "2024-02-07T22:00:19.538",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 9482,
                                "ratingCount": 48,
                                "rating": 4.96,
                                "thumbsUpCount": 470,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 264503,
                                    "sizeKB": 223099.23828125,
                                    "name": "Smooth Style 2 SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-07T22:00:49.335Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "E77A6394",
                                        "AutoV2": "5A39036209",
                                        "SHA256": "5A39036209F575759C2A570C5116DD314E636F6B6EACE6039473627344F456BC",
                                        "CRC32": "3F3B8E85",
                                        "BLAKE3": "D702730F8671C4C4F243C7904D7F552164487CB7F2982089E7CA73C0D9E53FB9",
                                        "AutoV3": "93DF3FD8FEDC"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/333587",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 6380494,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b0763c93-ba92-40c6-9823-7e027160a984/width=450/6380494.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U38;Mw0K02~C-XXnKlrV0N?GD$s:PBxDQ,Xo",
                                    "type": "image"
                                },
                                {
                                    "id": 6380492,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/15e8302b-4de9-4070-8c3d-274e9d5e449e/width=450/6380492.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UWHLxmNays%MgjRjtnWXD*V?V?WBSis:xYW=",
                                    "type": "image"
                                },
                                {
                                    "id": 6380496,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a30529e1-c556-4dee-b23d-712d85a7d867/width=450/6380496.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UBCZFakW58xa~pNGD*xu~VR*0KxatRoeaLf6",
                                    "type": "image"
                                },
                                {
                                    "id": 6380493,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/27a608d3-7b98-40fa-b3a0-a1edb8cfca07/width=450/6380493.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UbHxgCtR%hoL_4t8NdWB-=R*t7ae%MRjWAo0",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/333587"
                        },
                        {
                            "id": 330475,
                            "name": "Concept Art Twilight",
                            "index": 24,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 7,
                            "description": "<p>Repeats: 20</p><p>Epoch: 10</p><p>Image Count: 14</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 1400</p><p>Resolution: 1024x1024</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning</p><p>SmilingWolf/wd-v1-4-moat-tagger-v2</p><p>LoRA Weight: [0.8-1]</p>",
                            "publishedAt": "2024-02-05T20:33:33.934",
                            "availability": "Public",
                            "trainedWords": [
                                "read description"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 17789,
                                "ratingCount": 80,
                                "rating": 4.97,
                                "thumbsUpCount": 1403,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 261934,
                                    "sizeKB": 223093.87890625,
                                    "name": "Concept Art Twilight Style SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-05T20:36:22.069Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "7571A4DD",
                                        "AutoV2": "2D9EE3FC65",
                                        "SHA256": "2D9EE3FC659E073EAC18EC2F1055F156465A0B5E4F7BFBA835EDB9464044A7AE",
                                        "CRC32": "8ED6C5D1",
                                        "BLAKE3": "8BE1F9B253B0CB5DA0AB3963A2E73619B970F5F8F44369E42195101966049088",
                                        "AutoV3": "558EF32DD91B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/330475",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 6300154,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fef829a4-9e92-4541-91f9-d6395adef9fa/width=450/6300154.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U77BWX%gS%M{%%tSX9WYIUW?fkoJMxRjV=nh",
                                    "type": "image"
                                },
                                {
                                    "id": 6300155,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/960d77c3-c806-4370-958f-8b4e9f71096b/width=450/6300155.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U67_D|?w9bM}yFx^T1NK4TMxtSxtD%IUVqs+",
                                    "type": "image"
                                },
                                {
                                    "id": 6300156,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8ea2e0ff-4724-4cda-91fa-3def4fe45502/width=450/6300156.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEDJhuRPTJS4OHIU?wo#D%WAIUM{D%t7ROad",
                                    "type": "image"
                                },
                                {
                                    "id": 6300159,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1b2f8527-340c-498b-b7d4-4769b510e1c2/width=450/6300159.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGFPT-D%KP-;I^V??wIU9ZROMxRPNFjYaJoM",
                                    "type": "image"
                                },
                                {
                                    "id": 6300157,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f935e4e-0175-4e62-8a7a-d1bc2eaa69ed/width=450/6300157.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UG9*AOkCkCx]?^axRPozxuayIARjt7j[ROV@",
                                    "type": "image"
                                },
                                {
                                    "id": 6300158,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b550124b-4f10-4fa2-a9f5-bd68b71c7afe/width=450/6300158.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UIBDygRjt7tR?^jZadt7x]t7D$WBo#WBMxRj",
                                    "type": "image"
                                },
                                {
                                    "id": 6300160,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ac29f9de-3e23-4ebc-8f50-c4d92cb5c6ef/width=450/6300160.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UFCjCS%g.9ay.AxaX9kCXUnhRPayo#xun~n~",
                                    "type": "image"
                                },
                                {
                                    "id": 6300161,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d1cbec5e-30c2-4cf7-be3f-9819192225a3/width=450/6300161.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UOFFme%L.8t6?w%MR,s:yEoeayoJtSWBsmjY",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/330475"
                        },
                        {
                            "id": 329446,
                            "name": "Concept Art",
                            "index": 25,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 7,
                            "description": "<p>Repeats: 20</p><p>Epoch: 10</p><p>Image Count: 14</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 1400</p><p>Resolution: 1024x1024</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning</p><p>SmilingWolf/wd-v1-4-moat-tagger-v2</p><p>LoRA Weight: [0.8-1]</p>",
                            "publishedAt": "2024-02-05T04:19:27.236",
                            "availability": "Public",
                            "trainedWords": [
                                "read description"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 5330,
                                "ratingCount": 27,
                                "rating": 5,
                                "thumbsUpCount": 193,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 261083,
                                    "sizeKB": 223098.56640625,
                                    "name": "Concept Art Style SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-05T04:20:53.033Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "13C4F1AC",
                                        "AutoV2": "BC7A0121E0",
                                        "SHA256": "BC7A0121E00FD192A5467FAF041D123786C3D68F5CAA613D92617C766938A4AB",
                                        "CRC32": "7B88CAE4",
                                        "BLAKE3": "A8DE8339B50C5FE6EEB5C39EE4EB85F10395832CB9CAAA2C011A95DAF5720AC7",
                                        "AutoV3": "644990F2166C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/329446",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 6273443,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d4edd15-ef73-489f-82c5-8abfd7573fd1/width=450/6273443.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UcEpG}WA%gRk_NoLt7ofxut7jut7WCofRjae",
                                    "type": "image"
                                },
                                {
                                    "id": 6273445,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/de10edd3-59e6-4ade-b414-319208e23954/width=450/6273445.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGBW_C%fTLM|.TtRg4bcD*bcjGt7H@RjR5n$",
                                    "type": "image"
                                },
                                {
                                    "id": 6273442,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aa429a91-8557-432d-be10-2f5b84dd783f/width=450/6273442.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UJHezkM{.Tx^%hM{~qWBD%M{MxWBS~WBs.WC",
                                    "type": "image"
                                },
                                {
                                    "id": 6273441,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/707fb8e3-87e5-4596-9496-e47e94135586/width=450/6273441.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UJIF0lIopw-;tmM{_NM|IoIURPNGkqWBxZt7",
                                    "type": "image"
                                },
                                {
                                    "id": 6273444,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f994bee2-2428-4068-8220-1d1333515430/width=450/6273444.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UWG9KmRk-;xu_Nf7j@oexuofD%RjozayM{V@",
                                    "type": "image"
                                },
                                {
                                    "id": 6273448,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2f08d7f7-5c51-4313-9d51-5ec188e976b4/width=450/6273448.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UWGlYFRj.7%L_NbIt7t6xtkCD%Rjoff5M{Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 6273447,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/635b8dac-4c39-429b-b2c9-9108c4a1437b/width=450/6273447.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UcHVC+%M.8V@~qt7WXt7-;t7j?V@%MWBaeWB",
                                    "type": "image"
                                },
                                {
                                    "id": 6273446,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/741035ea-1c8e-4892-ac57-706ba8fea06b/width=450/6273446.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UhH.Thxu%hjY~qs:bbj@-;jsj@RjxuWBjFWB",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/329446"
                        },
                        {
                            "id": 327859,
                            "name": "Oil Gothic",
                            "index": 26,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Oil Painting + Gothic Art</p><p>LoRA Weight: [0.8-1]</p>",
                            "publishedAt": "2024-02-04T04:21:36.082",
                            "availability": "Public",
                            "trainedWords": [
                                "read description"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3977,
                                "ratingCount": 46,
                                "rating": 4.98,
                                "thumbsUpCount": 133,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 259719,
                                    "sizeKB": 223093.83984375,
                                    "name": "Oil Gothic Painting Style SDXL_LoRA_Pony Diffusion V6.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-04T04:25:39.108Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "7F3A670E",
                                        "AutoV2": "E308C23706",
                                        "SHA256": "E308C23706E563CFF663E2C93673FDFDA00D6E53A2FFC900B92D43BE8204FD5F",
                                        "CRC32": "5C9170AE",
                                        "BLAKE3": "263CA14A44CC9997E8B497E70B79C081991FA51A9941ABAADD982592C8209E07",
                                        "AutoV3": "7EE8A07888C8"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/327859",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 6235023,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8c3cdcc2-809c-4964-af28-cb457ff00f7f/width=450/6235023.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U4Aw0M~o0Ns9F4IV5YIV00Dj%1-oI]x]#6%L",
                                    "type": "image"
                                },
                                {
                                    "id": 6235024,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d5baf97b-60f5-406b-964f-fea41cfc4b86/width=450/6235024.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U59%q^_N58ogX.xuETEO009FXTxXX9NH#j${",
                                    "type": "image"
                                },
                                {
                                    "id": 6235026,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e2a16b32-565e-4c0d-85ea-3afffac29c0b/width=450/6235026.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UJHB-zxa9uR*J=Rk_NkCETkCt8j?NGofRPf6",
                                    "type": "image"
                                },
                                {
                                    "id": 6235027,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/15509e9c-54bf-45e0-a710-1e3891bfc9f0/width=450/6235027.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UKH.D~t6I.I;XVIV_Nx[NhWVRoRjR*kCRiWB",
                                    "type": "image"
                                },
                                {
                                    "id": 6235025,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bc4bf2e8-f415-49ed-84de-1dfb933443e6/width=450/6235025.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEC$[oM|oHt6_MaeM{ozs+WBD*t7SNV@Vsbb",
                                    "type": "image"
                                },
                                {
                                    "id": 6235028,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/61063f18-1e80-40b8-9800-9c8034e023de/width=450/6235028.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGCZRzRjWTt7~pWBM{ozt6RkIUt7bHRjM{WX",
                                    "type": "image"
                                },
                                {
                                    "id": 6235029,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/774f7044-ba7a-43c6-82b2-658654d00d80/width=450/6235029.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UME{X#.8XSxu?w%MW?W=kYM{WBs.kWIVjEf5",
                                    "type": "image"
                                },
                                {
                                    "id": 6235030,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/510fe874-808a-40c1-ae82-6d3d806091de/width=450/6235030.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UPFh*D~p%f%M?a%Mbc%MRkWBWCt7RjjYs.ay",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/327859"
                        },
                        {
                            "id": 324652,
                            "name": "Gothic Art",
                            "index": 27,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Repeats: 20</p><p>Epoch: 12</p><p>Image Count: 10</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 1200</p><p>Resolution: 768x768</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning</p><p>SmilingWolf/wd-v1-4-moat-tagger-v2</p><p>LoRA Weight: [0.8-1]</p>",
                            "publishedAt": "2024-02-02T02:41:49.979",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3315,
                                "ratingCount": 50,
                                "rating": 4.98,
                                "thumbsUpCount": 122,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 257026,
                                    "sizeKB": 223097.26171875,
                                    "name": "Gothic Art  Style SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-02T02:45:39.778Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "A049D332",
                                        "AutoV2": "A9BE292D7D",
                                        "SHA256": "A9BE292D7DE57CB4FA62CC7F05D64B1C6DDA71D4B6F692215787C244F9173567",
                                        "CRC32": "F3616E92",
                                        "BLAKE3": "8C7914FEAE91E0D1761A56486D453826A20FCF9A82457E7FED44B20373994F96",
                                        "AutoV3": "8E6403D4BD3D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/324652",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 6162157,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/684529c1-c3d7-4ce3-961c-eeaa69e352dd/width=450/6162157.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U3A^E:t.5SH?0qRQ9k$|00%K?u%M.ko~+E9a",
                                    "type": "image"
                                },
                                {
                                    "id": 6162158,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8ca269b9-443a-4599-9531-fb75912f4d8c/width=450/6162158.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UPH-*.kC-os:~V%LIURj-:oeIVf6%MM|R-t7",
                                    "type": "image"
                                },
                                {
                                    "id": 6162160,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/922fa7ce-75a1-4a86-a4c3-e769bc273a5c/width=450/6162160.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGG8[o%g4T#Q_M%0ozS%%$o#rrxtTzo}Mwnh",
                                    "type": "image"
                                },
                                {
                                    "id": 6162156,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e76c11e1-3ab7-4c9b-998e-4efe73b0584a/width=450/6162156.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDI439^jHsIV|?o}8_MyE+S3_2V@Q.n5IU-p",
                                    "type": "image"
                                },
                                {
                                    "id": 6162161,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0ecfb4b5-43b6-42e2-a5b3-e57676a0cd58/width=450/6162161.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAKS;Q$*00IV03-p57oe_MjFoJM|4VNG~Bxt",
                                    "type": "image"
                                },
                                {
                                    "id": 6162159,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8b1c0ee5-95f3-4e51-9190-75b72868d45f/width=450/6162159.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDFr*B_2^+xt~q9Fxuxa-:IUt7t7NG%Mt7xt",
                                    "type": "image"
                                },
                                {
                                    "id": 6162163,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/10684d12-eb04-4d58-b0bf-4ddb41eca03b/width=450/6162163.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAE.@E}qcsBWIWaex[R+.RBV58;_58WV-SxG",
                                    "type": "image"
                                },
                                {
                                    "id": 6162164,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e6bffe86-70f5-4a0d-b16a-b32325646375/width=450/6162164.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UHHnmN?wloT14=xHo~S%q@WCjEadRiIo4oRk",
                                    "type": "image"
                                },
                                {
                                    "id": 6162391,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/110caa43-d733-42ac-ba0f-d7f73427b7d8/width=450/6162391.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8HBMP~p00wH000fs%Rj?vxa+]X8In?F?aI:",
                                    "type": "image"
                                },
                                {
                                    "id": 6162390,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71db5969-c619-46ec-b7e5-59eee74f552d/width=450/6162390.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U9GH-p~U00E2004:%K-U^jt7?FxtXg={-oIq",
                                    "type": "image"
                                },
                                {
                                    "id": 6163336,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2ae5ab9f-d8ba-4ef2-abd0-d205016be602/width=450/6163336.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U5Ac-t~o0i%L4;9b9$Vs0LIU-O--yY%M$eW=",
                                    "type": "image"
                                },
                                {
                                    "id": 6163337,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e54c1e6d-1caa-4fdb-924c-0289fa4ef248/width=450/6163337.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U797bB4o5Y,-IBxuI[xt4o%fwtIrpyRP$%R*",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/324652"
                        },
                        {
                            "id": 323081,
                            "name": "Summer Days",
                            "index": 28,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 5,
                            "description": "<p>Repeats: 20</p><p>Epoch: 10</p><p>Image Count: 16</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 1600</p><p>Resolution: 960x1024</p><p>Train Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning</p><p>SmilingWolf/wd-v1-4-moat-tagger-v2</p><p>LoRA Weight: [0.8-1]</p>",
                            "publishedAt": "2024-02-01T01:07:39.953",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 6034,
                                "ratingCount": 58,
                                "rating": 4.98,
                                "thumbsUpCount": 240,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 255701,
                                    "sizeKB": 223102.32421875,
                                    "name": "Anime Summer Days Style SDXL_LoRA_Pony Diffusion V6 XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-01T01:10:53.848Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "A3548D98",
                                        "AutoV2": "1F42C3E91C",
                                        "SHA256": "1F42C3E91CE1F826D97EB8DF98742A101A9F0BF8B0CB2527D3CE2F6E54EA7875",
                                        "CRC32": "17197F84",
                                        "BLAKE3": "38A946A0A786EB763DF1F03D9CD3E099168FAD2D5DB337D1DAE203C93585FFB7",
                                        "AutoV3": "AC07904B9F20"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/323081",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 6120674,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/38530fc4-d5c9-4588-87bb-8f8e393688bf/width=450/6120674.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCCi?jIs~Wt6RkNxIpbIRP?Go}s.K7niskV@",
                                    "type": "image"
                                },
                                {
                                    "id": 6120671,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1393a14-d7a5-4b59-8f4f-90d98f62145d/width=450/6120671.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UKE{5^SO-;s:~V-;WBWBS5%2R*Rk-:Io-pRk",
                                    "type": "image"
                                },
                                {
                                    "id": 6120675,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c8545017-d283-419b-9bf7-0a069bdfbdad/width=450/6120675.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "ULE:0f%NI9oe?w%fD*Myo~NKnNnhgjt6V?xv",
                                    "type": "image"
                                },
                                {
                                    "id": 6120673,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/149a1d10-59c8-4a51-89f4-35072d821fab/width=450/6120673.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U7GQtqE^000M=Fui0e-V0e*yyXVY9F0z0f^k",
                                    "type": "image"
                                },
                                {
                                    "id": 6120676,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/07dcb869-01f8-46d4-89d0-c092b948ea32/width=450/6120676.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCI:zj9Z0K=|tR-oNGRkkpj?xGIpJ5EL~BE1",
                                    "type": "image"
                                },
                                {
                                    "id": 6120677,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8641b2f7-746b-41af-be7e-edd32c58a3cd/width=450/6120677.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UFDJFrWB%M-;~pIV9F%M^+M{j]t7axofj[t7",
                                    "type": "image"
                                },
                                {
                                    "id": 6120679,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d0a39fc4-c861-4e9c-a224-bf2d6f2529f9/width=450/6120679.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDE.61^i^+TK~Bs.xvo#5AE2wH#k4oIBwbrW",
                                    "type": "image"
                                },
                                {
                                    "id": 6120678,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/25955846-ab6b-4c01-98c4-37880655b0dc/width=450/6120678.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UKFYcJ9u_N-Vo}-;XnRPQnNaR6xuvzM{ae%2",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/323081"
                        },
                        {
                            "id": 302106,
                            "name": "Line Art",
                            "index": 29,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Repeats: 20</p><p>Epoch: 20</p><p>Image Count: 8</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 1600</p><p>Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning</p><p>SmilingWolf/wd-v1-4-convnextv2-tagger-v2</p><p>LoRA Weight: [0.6-0.8]</p>",
                            "publishedAt": "2024-01-17T09:22:45.989",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 8469,
                                "ratingCount": 130,
                                "rating": 4.99,
                                "thumbsUpCount": 431,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 238329,
                                    "sizeKB": 223097.69921875,
                                    "name": "Line Art Style LoRA XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-01-17T09:25:46.970Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "8D474945",
                                        "AutoV2": "D6A4F87236",
                                        "SHA256": "D6A4F872361418B1AF5BFB7EFED4F1EA9465D9ED2427971AD1BE14C4EC03E3F7",
                                        "CRC32": "5825C842",
                                        "BLAKE3": "43B7631CFE5B9609FC3650510D52CEE24C27CCFFAAD1D9E265D9F26A5DA2311D",
                                        "AutoV3": "A4EACAE3D10D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/302106",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 5583605,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/636805a1-e244-401c-8eb2-08b8d0553441/width=450/5583605.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8FYcJ04YR%1KT-:%i-:4n-PWBM_?Z%grnD+",
                                    "type": "image"
                                },
                                {
                                    "id": 5583603,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e0af2c47-578d-487e-aee0-8b41c0299a3d/width=450/5583603.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UYKdb+IVtQ?G~qxaIUR*?bofM{t7%NWBWCof",
                                    "type": "image"
                                },
                                {
                                    "id": 5583604,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/25498aff-2940-46f8-81a8-28fc972d4ab2/width=450/5583604.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UVI=JdX99Es8.7slSJS2b{X7wgjI%jxuVYR+",
                                    "type": "image"
                                },
                                {
                                    "id": 5583602,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1a01d8c4-28b6-441c-b17c-c4ccbbcfc96d/width=450/5583602.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "ULK,aGbv009E}[xuDi-;0KRPuONaRPx]JRD%",
                                    "type": "image"
                                },
                                {
                                    "id": 5583601,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/701a23b5-b1de-4835-83e0-1f13545436a7/width=450/5583601.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEM$=4DP00-;00-pXOxt-;%M^kIo0KD*~W$*",
                                    "type": "image"
                                },
                                {
                                    "id": 5583606,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3098ecc7-10b0-448d-9a73-e06ac669f560/width=450/5583606.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UKJRdV_3_3M{_39F9Ft7~qWB-;M{9Ft7Rjxu",
                                    "type": "image"
                                },
                                {
                                    "id": 5583607,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d626fc6e-28d2-4416-8462-aea956676945/width=450/5583607.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "ULHnvwoy9a_3yZtRxaogJ;OZtRMwIpRjnhnh",
                                    "type": "image"
                                },
                                {
                                    "id": 5583608,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ab83e8d2-586b-4db2-8b33-4bfe75ce24c5/width=450/5583608.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UMKwa_4.UH?G0L?aK6IAeVaJVZOFH=WAxsyD",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/302106"
                        },
                        {
                            "id": 300686,
                            "name": "Photo",
                            "index": 30,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Repeats: 20</p><p>Epoch: 10</p><p>Image Count: 22</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 2200</p><p>Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning</p><p>SmilingWolf/wd-v1-4-convnextv2-tagger-v2</p><p>LoRA Weight: [0.8-0.1]</p>",
                            "publishedAt": "2024-01-16T06:53:30.273",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 8507,
                                "ratingCount": 34,
                                "rating": 4.94,
                                "thumbsUpCount": 180,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 237153,
                                    "sizeKB": 223098.12890625,
                                    "name": "Photo Style LoRA XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-01-16T06:56:09.349Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "ABD90462",
                                        "AutoV2": "BD9A91AA94",
                                        "SHA256": "BD9A91AA94241890C5C086383A62A82478A0E1511FA99383A20802838D285119",
                                        "CRC32": "8B08475A",
                                        "BLAKE3": "A0AF1857D28FA8B8A199604344D3D565E59128FA76627EFD884BDAD3A96203B5",
                                        "AutoV3": "E84DB89DF11F"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/300686",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 5546351,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1aa46f41-579f-42f6-a66f-751bcb08f5f6/width=450/5546351.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U7BWlA1Om,~BN#-pICa000}@b^NGt2IT$~yD",
                                    "type": "image"
                                },
                                {
                                    "id": 5546352,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a5556a9-9bf3-4e42-bac0-32fe2aa2195c/width=450/5546352.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UKGlCmX9.8-:?G%MRioJIVxtV?xu~qkC%Mt7",
                                    "type": "image"
                                },
                                {
                                    "id": 5546355,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04bff59b-c9a2-48fb-b5eb-ab55a3e74793/width=450/5546355.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UHGIZJ_2IS?G_3_3JCD%E4-=xw9G_N%Li^tR",
                                    "type": "image"
                                },
                                {
                                    "id": 5546354,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/985fc486-2be1-4727-8875-4f026465af67/width=450/5546354.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAD9SE~W014nI9xuIAIU5qNG_2%LRkM{IUt7",
                                    "type": "image"
                                },
                                {
                                    "id": 5546353,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cbd24d87-95e9-4ace-8d09-613c8e593cf0/width=450/5546353.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCJGvW0001n%w4xuInwIIV~VD%t7Q-S5=|R*",
                                    "type": "image"
                                },
                                {
                                    "id": 5546356,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9e4cb569-8b11-4acd-892b-9acd6051a706/width=450/5546356.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEDl~B%2t7%M~qRjIUxuIUIUIUxuIU%Mt7%M",
                                    "type": "image"
                                },
                                {
                                    "id": 5546358,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/74df42d6-9ed3-4bd9-b228-446eb9811570/width=450/5546358.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDGR*aOt~p^+wf-:9aVst-bb-o9aIUtRtRV@",
                                    "type": "image"
                                },
                                {
                                    "id": 5546359,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/10f986c8-27a3-4dfb-b8e1-997e24989220/width=450/5546359.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UBHBVp?b*0.8MIH?xH%M00yEI=8_=|x^9FM{",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/300686"
                        },
                        {
                            "id": 298243,
                            "name": "Oil Painting",
                            "index": 31,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Repeats: 20</p><p>Epoch: 5</p><p>Image Count: 56</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 2800</p><p>Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning</p><p>SmilingWolf/wd-v1-4-convnextv2-tagger-v2</p><p>LoRA Weight: [0.8-1]</p><p>This Style is trained on the images created by this LoRA</p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/127139/classipeintxl-oil-paint-oil-painting-style\">https://civitai.com/models/127139/classipeintxl-oil-paint-oil-painting-style</a></p>",
                            "publishedAt": "2024-01-14T09:25:59.952",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 4568,
                                "ratingCount": 21,
                                "rating": 5,
                                "thumbsUpCount": 97,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 235035,
                                    "sizeKB": 223101.17578125,
                                    "name": "Oil Painting Style XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-01-14T09:30:54.736Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "FCD7EC35",
                                        "AutoV2": "E6F4BDB342",
                                        "SHA256": "E6F4BDB3424CEE9D3E3159277B59F93FE983C0CEC4CC48FD16FD7B6E63072411",
                                        "CRC32": "4F9C2DD4",
                                        "BLAKE3": "037955056A055E7C5C35DC01012CDA6AD3F9DB60F4875850DCE4C1D6B9C2E097",
                                        "AutoV3": "6FB3CEA745F5"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/298243",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 5479380,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/07a8ebc1-d926-47b3-b25c-b4fb8fc587f9/width=450/5479380.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "URLD.Ex]?bD%~V%Mx]-;%2IVNGRP~qaeIUM{",
                                    "type": "image"
                                },
                                {
                                    "id": 5479381,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1aadeaa1-c9e3-4702-ba15-a9d6fcbf2219/width=450/5479381.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "URHe5lIVO=s:~pM{OFoepcRQoMoz%}jGrqS$",
                                    "type": "image"
                                },
                                {
                                    "id": 5479379,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9ef424a4-13d8-4cab-8191-307f2e98a178/width=450/5479379.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UHH-_RI=_M^*~pkX9a%0K7bcMxM{TLRk%0a$",
                                    "type": "image"
                                },
                                {
                                    "id": 5479378,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4f434855-ec6a-4dc1-bd30-a9627611a8db/width=450/5479378.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UNIqf9_NTJxW?v?ubvM|%LX9E2M|ESS#oer=",
                                    "type": "image"
                                },
                                {
                                    "id": 5479386,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c2442bb6-89ed-4663-928a-3cd07500c55f/width=450/5479386.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UPF$CFV[t6t7~pt6RjoLt6ofD*j@t6WCM|WB",
                                    "type": "image"
                                },
                                {
                                    "id": 5479384,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e67d1d8-b8df-4044-b156-fe60a53c43f3/width=450/5479384.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UPHLL}?t.6Mw~qbdRlIUNexvV@xuR*%Mi_xu",
                                    "type": "image"
                                },
                                {
                                    "id": 5479382,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/55fbe102-fd6b-4b6f-9a7b-f1dae0ef9862/width=450/5479382.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UQHLYGt6aKjEy8f6D+s.~TxsIqR.M{WAkCRm",
                                    "type": "image"
                                },
                                {
                                    "id": 5479385,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a019e7a2-a612-44bb-ae20-29e315023aa4/width=450/5479385.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGDvN3IU?^r?_Ms:tksmoyozslRj%Mt6V[Rk",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/298243"
                        },
                        {
                            "id": 298242,
                            "name": "Ink",
                            "index": 32,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Repeats: 20</p><p>Epoch: 10</p><p>Image Count: 14</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 1400</p><p>Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning</p><p>SmilingWolf/wd-v1-4-convnextv2-tagger-v2</p><p>LoRA Weight: [0.7-0.8]</p>",
                            "publishedAt": "2024-01-14T09:23:07.912",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3457,
                                "ratingCount": 3,
                                "rating": 4.67,
                                "thumbsUpCount": 68,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 235032,
                                    "sizeKB": 223098.58984375,
                                    "name": "Ink Style LoRA XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-01-14T09:25:50.461Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "1B3C8FD5",
                                        "AutoV2": "C5B0765CF0",
                                        "SHA256": "C5B0765CF06DF3561EEA5A57B4D9F0E41C85F3FDC37B8BFE4C0E68005368593F",
                                        "CRC32": "FB192435",
                                        "BLAKE3": "8CE6B937DF9FDE8967CA77EA7B0D7254E201D0459A56EFF6317BA4E0369390EA",
                                        "AutoV3": "FF24E192A187"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/298242",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 5479321,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7596286a-32f5-4aa9-bce8-428d22d5ad6d/width=450/5479321.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UcLNPt%g-;E1~Wt7%M%2xuR*X8RP?vjtRjMx",
                                    "type": "image"
                                },
                                {
                                    "id": 5479319,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4aa80658-eed6-487b-87e3-8b52092003a5/width=450/5479319.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UPI}Cp*0tR-p^lTeNKs:EONGxZsRKRRQrXni",
                                    "type": "image"
                                },
                                {
                                    "id": 5479317,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3060e7d1-d24b-4a38-b484-1253eb7ebd2c/width=450/5479317.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "URGI=y?a~q$z.At6N{jEE2IpIVkCESNKslWX",
                                    "type": "image"
                                },
                                {
                                    "id": 5479320,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/88507420-e94d-4e3e-8d35-af73964c81f9/width=450/5479320.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UWIE-7~qozxu%hx^t7e.I[fkM|j@9ZIpt7%1",
                                    "type": "image"
                                },
                                {
                                    "id": 5479318,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/670ec397-4d1a-476b-a60b-964e77f30bc6/width=450/5479318.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UNGIGr-pxuM{~pxaRjRj%1of4.RjxuofM{RP",
                                    "type": "image"
                                },
                                {
                                    "id": 5479322,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/30b80a7b-a2cb-4eb3-9169-bff3c2f2f636/width=450/5479322.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UPH24ao|t7Mx~pE1IVM{E1jFRjx[IUt8aKx]",
                                    "type": "image"
                                },
                                {
                                    "id": 5479324,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cc07903e-39f3-4e3c-92cb-1fd0880ea689/width=450/5479324.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UYJRa8Rjn$aeyBNGIV%2~VxaIVM|IUWUWXWV",
                                    "type": "image"
                                },
                                {
                                    "id": 5479323,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/34f9ce8d-3a87-465b-aead-2fa1c2e1efee/width=450/5479323.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UHFP1.M|lor@_MR-%gnN9]xaxZogTKs9soR+",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/298242"
                        },
                        {
                            "id": 298238,
                            "name": "Smooth Anime",
                            "index": 33,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Smooth Style + Anime Style 50/50</p>",
                            "publishedAt": "2024-01-14T09:20:09.606",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 13810,
                                "ratingCount": 32,
                                "rating": 4.94,
                                "thumbsUpCount": 1278,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 235030,
                                    "sizeKB": 223093.81640625,
                                    "name": "Smooth Anime Style LoRA XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-01-14T09:20:46.779Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "54A5CCBE",
                                        "AutoV2": "CB65A31C8B",
                                        "SHA256": "CB65A31C8B4A741CEE298D4291FF0FF8F4DBED933B2B503629EE4287A8E631D5",
                                        "CRC32": "4542C90C",
                                        "BLAKE3": "A194033BB35F47840D3BDE677CC11E862815623322B88D851D3AFBECF62C60AC",
                                        "AutoV3": "3F96AEF48B5A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/298238",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 5479264,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0fc58db4-9ec5-4c69-bbc6-0add18475454/width=450/5479264.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UaLp~=XS.8Mx~W%ftR%2tRM|bbRP.8RjM|Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 5479266,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/af0224a7-4556-4437-bdf7-682aeaf1caf1/width=450/5479266.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UcI#ZDSjg#xu.AkDbxt6E,RjsoWVpJMyr;WV",
                                    "type": "image"
                                },
                                {
                                    "id": 5479265,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3955d43f-1b5d-44d8-af23-456fbbb04dab/width=450/5479265.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UVIEeLM}~V%2Oa%0IpWBI@jFV@WBENbbw]of",
                                    "type": "image"
                                },
                                {
                                    "id": 5479268,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/882d81da-07c8-4c43-980a-a7d2fc2842d5/width=450/5479268.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGHU^2~opXR#9}S7E2IV9dt9N3-W02ko-pxs",
                                    "type": "image"
                                },
                                {
                                    "id": 5479267,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6ae9d880-ee7e-4798-9cd3-dde70262c284/width=450/5479267.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UOGb*Dt6o}xt_Mt6M{RkVrof8{M|t7ayM{a|",
                                    "type": "image"
                                },
                                {
                                    "id": 5479270,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/249c0b19-cf8d-4f7e-8e08-c4ac29b0901b/width=450/5479270.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UWHLk}.8ghR5_NtSx]V@9ZV[VYtRInt7Mxt7",
                                    "type": "image"
                                },
                                {
                                    "id": 5479269,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b9df337c-6c29-413e-ac75-b316b86c3e91/width=450/5479269.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UWIYE_f,Mys,y9RjD*xt~UxtM|RkIAWBM|WD",
                                    "type": "image"
                                },
                                {
                                    "id": 5479271,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/217c08bf-7af9-4a55-b9ef-8d4fdd3255fc/width=450/5479271.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "USHU@6ofy?kX?vM{%gt7ELrrnOR*tSx[aet7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/298238"
                        },
                        {
                            "id": 298005,
                            "name": "Anime",
                            "index": 34,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Repeats: 20</p><p>Epoch: 20</p><p>Image Count: 8</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 1600</p><p>Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning</p><p>SmilingWolf/wd-v1-4-convnextv2-tagger-v2</p><p>LoRA Weight: [0.5-0.7]</p>",
                            "publishedAt": "2024-01-14T03:46:06.049",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 4980,
                                "ratingCount": 16,
                                "rating": 4.94,
                                "thumbsUpCount": 161,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 234841,
                                    "sizeKB": 223098.37109375,
                                    "name": "Anime Style LoRA XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-01-14T03:45:56.556Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "C7C66BD7",
                                        "AutoV2": "234B2E7897",
                                        "SHA256": "234B2E78972E39FD3557C270C9980CDBF222D9F0D40FBD83B506F97192B78203",
                                        "CRC32": "29CD03E9",
                                        "BLAKE3": "CB8A4D65BC903AFEB5A440C4ECC7AFFA073E0AA7D7E09B3015AC1BE3B0B6274F",
                                        "AutoV3": "71A6A3849C70"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/298005",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 5471490,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b5689e0e-fcfb-486e-b8ac-2c051a3e7f80/width=450/5471490.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UmLNGT?H-;IV~Vx[ozofkWNGW;V@%gj@oeV[",
                                    "type": "image"
                                },
                                {
                                    "id": 5471493,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a9fea8dd-3565-4cfb-9af5-312f98e3073b/width=450/5471493.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UQJj^]9b%}x[yZNHItbv11NHwbRkF2RPwIni",
                                    "type": "image"
                                },
                                {
                                    "id": 5471491,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/93d0a36c-db4e-4da4-a6aa-fcc70d816a43/width=450/5471491.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UWI#V|M~~p-o9$%0E2NGEMjZa0oc9ujZxCWE",
                                    "type": "image"
                                },
                                {
                                    "id": 5471492,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e5dfbf6d-386b-4782-8d0a-b76e4b348454/width=450/5471492.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UfK1jk~o.5tQ%fW?W=t7o~xvRpjv9bX9oNRj",
                                    "type": "image"
                                },
                                {
                                    "id": 5471494,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b1f49fcf-fdba-4667-8e51-0f982e8f65d3/width=450/5471494.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UNHxp5-.tQIo~pxtM{NGk7oL4ofQx[xtIVM{",
                                    "type": "image"
                                },
                                {
                                    "id": 5471495,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/769b6c4a-2b5a-4370-879d-1ff566354d7f/width=450/5471495.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UVHxpL~p?]XS?caLt8bI9Zfis,%LE1%gaKj[",
                                    "type": "image"
                                },
                                {
                                    "id": 5471496,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/43f596fc-dc5e-495b-a124-4c6f8c82377c/width=450/5471496.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UbI#uk-ot6V@.5xtIooe~U%LNHWVMxxZR+ay",
                                    "type": "image"
                                },
                                {
                                    "id": 5471498,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aae7e7c7-ae13-4d40-9d75-ed7bade663c7/width=450/5471498.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UQH_#*M|yspI_MIot7%LozRPi_kCtRx]RPof",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/298005"
                        },
                        {
                            "id": 297988,
                            "name": "Smooth",
                            "index": 35,
                            "modelId": 264290,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>Repeats: 20</p><p>Epoch: 20</p><p>Image Count: 8</p><p>Network Rank: 32</p><p>Network Alpha: 16</p><p>Batch size: 2</p><p>Clip skip: 1</p><p>Training steps: 1600</p><p>Resolution: 1024x1024</p><p>Model: ponyDiffusionV6XL_v6</p><p>WD14 Captioning</p><p>SmilingWolf/wd-v1-4-convnextv2-tagger-v2</p><p>LoRA Weight: [0.6-0.7]</p>",
                            "publishedAt": "2024-01-14T03:27:54.518",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 6224,
                                "ratingCount": 11,
                                "rating": 4.82,
                                "thumbsUpCount": 305,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 234831,
                                    "sizeKB": 223098.09765625,
                                    "name": "Smooth Style LoRA XL.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-01-14T03:30:54.617Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "4BC9F19B",
                                        "AutoV2": "01B141E29C",
                                        "SHA256": "01B141E29C481C65754141FF1FC99E8C5E7B0C91797C20827086EBD15777E5DB",
                                        "CRC32": "4408D6B7",
                                        "BLAKE3": "27A4058A35CE8B68BD9CCCADF9E22FB6F56415CCA41CB2EFE3D9A66B9E41846B",
                                        "AutoV3": "D3FFBD6136E2"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/297988",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 5470988,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/231cf3ab-ab87-4060-a2a4-ee95e8449829/width=450/5470988.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UUKnC~tR?^IA~W%gx^-p?bIUIoIU%#aKRjbI",
                                    "type": "image"
                                },
                                {
                                    "id": 5470990,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3402e136-0f85-45dc-8670-115eb9051f23/width=450/5470990.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UqG[.]X9TKxa?wkCbvoLk?oLs,WqpJWBnhbH",
                                    "type": "image"
                                },
                                {
                                    "id": 5470992,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7101c3f5-96d7-494f-b23f-744e7750f209/width=450/5470992.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UWF~aaWZ?wn+tnjuI[WBS*M|Rit7Irt7nhkB",
                                    "type": "image"
                                },
                                {
                                    "id": 5470989,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b0cd30d0-810c-451d-ad23-93e06893016c/width=450/5470989.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UQGbxJ%MJQay*0bIMxae.8j[I9oK9ua}nMax",
                                    "type": "image"
                                },
                                {
                                    "id": 5470991,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bfe5c370-5e85-4cd7-bc6b-622b52a49308/width=450/5470991.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UKFPE6xtS~oy~pofIVWBVsoe4oM|o}t7IVM{",
                                    "type": "image"
                                },
                                {
                                    "id": 5470995,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e5a58f0-1ae0-478c-8ee6-557813044dac/width=450/5470995.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UaF$eOx^yCRO_No#x[V@ELWBROt7NGofMxs:",
                                    "type": "image"
                                },
                                {
                                    "id": 5470993,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aa01770f-e4f8-4918-abce-4f7df4f72317/width=450/5470993.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UUI5h_xuD*adtdM{D*xt~VxaE2NGIAWBWYa#",
                                    "type": "image"
                                },
                                {
                                    "id": 5470994,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/239f6f13-3a63-4857-b2ed-29e1b67a3a1a/width=450/5470994.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UeH2Zjxu?^WW.8Rj%gt7RjV@V?R*tRx[s:oz",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/297988"
                        }
                    ]
                },
                {
                    "id": 11722,
                    "name": "IU",
                    "description": null,
                    "poi": true,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": false,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 61412,
                        "favoriteCount": 0,
                        "thumbsUpCount": 6535,
                        "thumbsDownCount": 0,
                        "commentCount": 48,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 170
                    },
                    "creator": {
                        "username": "Ithlinni",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/494378ce-ce65-488a-f1ba-5520836fa200/width=96/Ithlinni.jpeg"
                    },
                    "tags": [
                        "girl",
                        "photorealistic",
                        "female",
                        "asian",
                        "woman",
                        "celebrity",
                        "korean",
                        "realistic"
                    ],
                    "modelVersions": [
                        {
                            "id": 18576,
                            "name": "IU V3.5",
                            "index": 0,
                            "modelId": 11722,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Merged V3.0 and V2.0 as adviced.</p>",
                            "publishedAt": "2023-03-04T17:42:42.365",
                            "availability": "Public",
                            "trainedWords": [
                                "iu1"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 51066,
                                "ratingCount": 4951,
                                "rating": 5,
                                "thumbsUpCount": 5469,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 15565,
                                    "sizeKB": 295024.1767578125,
                                    "name": "iu_v35.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-04T17:46:09.542Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "A62E54EB",
                                        "AutoV2": "C9598BA347",
                                        "SHA256": "C9598BA3470C9529BA2BB386A0BF74BCDCAC5E6C4EFCFDE70067755F3B76316A",
                                        "CRC32": "52218C1F",
                                        "BLAKE3": "5DA6BBC1EB1630BB558DBCAECE68703C39006A490E41B6CF347CE6D713A8628C",
                                        "AutoV3": "1818D7F2C01A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/18576",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 192323,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/17ae24a7-8ce4-44fb-ac2c-a2dccfa54c00/width=450/192323.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U7EM8+-=00?b04IVyENH05t6+@i^~ptR-4V?",
                                    "type": "image"
                                },
                                {
                                    "id": 192324,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/100bdccd-afd5-4aef-0045-126ae8260b00/width=450/192324.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UNI#M$~W9]4.K7Rj-;t6KRt8r=%L-=RjD*WB",
                                    "type": "image"
                                },
                                {
                                    "id": 192322,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8e9d7acc-2a7d-406e-3d8d-0e942575dc00/width=450/192322.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UBMGn;0000P9Dz0K_2E2T_tR?ct,}a=|m+t,",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/18576"
                        },
                        {
                            "id": 17930,
                            "name": "IU V3.0",
                            "index": 1,
                            "modelId": 11722,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-03-03T10:05:43.614",
                            "availability": "Public",
                            "trainedWords": [
                                "iu1"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2376,
                                "ratingCount": 151,
                                "rating": 4.99,
                                "thumbsUpCount": 151,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 15003,
                                    "sizeKB": 73838.544921875,
                                    "name": "iu_v3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-03T10:10:33.763Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "9399A5E8",
                                        "AutoV2": "8AD0A61885",
                                        "SHA256": "8AD0A61885B866EA5160EC78B15EEBA795FC63C75A205C667180C0CBF64306F2",
                                        "CRC32": "565A1313",
                                        "BLAKE3": "560F4FF0DE6694DE5ADC69A8AAC8C85392E4A6A8F1A6ED053857AC2BCC56D2B0",
                                        "AutoV3": "3FB6A28B1509"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/17930",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 183566,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4c0e5a1b-672e-4eb6-3b21-117d002f4600/width=450/183566.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UKLgkU?EaI_N~9_3pJV@0LRP?aD%-SWCR+%L",
                                    "type": "image"
                                },
                                {
                                    "id": 183565,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ab73cd36-6cf5-44ca-8193-11117d06c400/width=450/183565.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDNcj7EML3%gE+zo_4xZ9{Io$%My%~0$9ZE*",
                                    "type": "image"
                                },
                                {
                                    "id": 183564,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7a86e9f6-dc97-4af2-e8a2-c4e0d7061d00/width=450/183564.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UHMs{0=^Ot$~0LRO.Sx[?^-:rBoIWU-pxuM{",
                                    "type": "image"
                                },
                                {
                                    "id": 183563,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b28c1658-d0e8-453c-648e-c2da4d2cb100/width=450/183563.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UMJ*k+VsM^IV~T9Gb_xusqIVkD-:TL%LxBtR",
                                    "type": "image"
                                },
                                {
                                    "id": 183562,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/98c27484-4fba-420b-8058-0db34342c900/width=450/183562.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UMLqLeIqIm9G=p9Fo~ad0Ls,?a%g~oogIAIo",
                                    "type": "image"
                                },
                                {
                                    "id": 183561,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b7240bef-ad82-435b-9305-f06e26614400/width=450/183561.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UPK_2l5B%g%M~8xCslx]#jROS4$%O[%ga0V@",
                                    "type": "image"
                                },
                                {
                                    "id": 183560,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/20dffd1b-952b-44de-c677-91023b20c000/width=450/183560.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UVK1RL-q~q-;^$%LIoV@?G9Fj[RkaJae%1Io",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/17930"
                        },
                        {
                            "id": 15770,
                            "name": "IU V2.0",
                            "index": 2,
                            "modelId": 11722,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-02-26T15:25:17.316",
                            "availability": "Public",
                            "trainedWords": [
                                "iu1"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4190,
                                "ratingCount": 421,
                                "rating": 5,
                                "thumbsUpCount": 421,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 13458,
                                    "sizeKB": 147573.1533203125,
                                    "name": "iu__v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-26T15:27:44.876Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "57A234DD",
                                        "AutoV2": "EADAD14576",
                                        "SHA256": "EADAD145767948140AE5C9E4E3E7F40801A583ACE335C19C11781650D578FAE9",
                                        "CRC32": "8FC04E5E",
                                        "BLAKE3": "E0CC56899989B829647D9E65528C9DF37936A873934461DAE39CD38371CACABA",
                                        "AutoV3": "E7059E0CEB37"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/15770",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 158045,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/33e9576d-d6da-4468-560a-ae5b61feee00/width=450/158045.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UALD}g00kq0Kp{9F~WZ~+Z-;9aVt00Rj?vI;",
                                    "type": "image"
                                },
                                {
                                    "id": 158044,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/262c9674-7351-4359-2ae8-2346760b0100/width=450/158044.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UOKdoE?w%g$*I@xaxuR+_MI9Ioj[MwIUIoxt",
                                    "type": "image"
                                },
                                {
                                    "id": 158043,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bba17033-2869-4dfe-9741-ab3245e30100/width=450/158043.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UEI;u6E59=~WIn?G4oE1%xNG9bIU56jDI:tQ",
                                    "type": "image"
                                },
                                {
                                    "id": 158042,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b679f95f-0c01-49bf-06d1-d288365a1a00/width=450/158042.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UDI;k%IU00fm0LITb_%3.7MxV}od?wj:t7Vt",
                                    "type": "image"
                                },
                                {
                                    "id": 158041,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8be633e8-0fad-4921-324a-dbe0a6a6e300/width=450/158041.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "USHB;}Iu-:bDb_~qo#M|^+%gIpxvp0g3xtRj",
                                    "type": "image"
                                },
                                {
                                    "id": 158040,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/209d75c9-b41a-4ca0-852e-408f2bfc0c00/width=450/158040.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "USEV~fM|?dM{o%s:E2WYRkxun#xvb_t8xuog",
                                    "type": "image"
                                },
                                {
                                    "id": 158039,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71a0895a-6029-401c-ac38-c31ab5827100/width=450/158039.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UFK1RC~D00?H000Kx[NHtkxtwMV[tk-p%2E1",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/15770"
                        },
                        {
                            "id": 13849,
                            "name": "IU V1",
                            "index": 3,
                            "modelId": 11722,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>It's a little bit difficult to generate perfect result but I don't know why. Just try it.</p>",
                            "publishedAt": "2023-02-22T13:37:53.379",
                            "availability": "Public",
                            "trainedWords": [
                                "iu1"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3780,
                                "ratingCount": 497,
                                "rating": 5,
                                "thumbsUpCount": 499,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 12175,
                                    "sizeKB": 147572.3994140625,
                                    "name": "iuv2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-22T13:41:25.526Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "0379BD7A",
                                        "AutoV2": "15ED4EAA6F",
                                        "SHA256": "15ED4EAA6F89E74D722760B4E4B4B7B67A69D11293C5B4963D696BB11319439E",
                                        "CRC32": "AF892143",
                                        "BLAKE3": "3D23D8DDE77D065C9339E22A1D938ED8E6B8366ED0C4ADA20D896D30416B5926",
                                        "AutoV3": "593134CB420D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/13849",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 134292,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b99a6ca4-503b-40c6-7b22-ee783279d500/width=450/134292.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UQE{INw@-:s:~WwaIoxt_3xBxaR,ozs9V@R+",
                                    "type": "image"
                                },
                                {
                                    "id": 134298,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4e941c6a-ec3d-4284-151a-f043a12b9700/width=450/134298.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UNEfc-0Ltlxu~qM{R%n$%hRj%MIUx]t7M{oz",
                                    "type": "image"
                                },
                                {
                                    "id": 134297,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ba3d3714-fb55-4d2b-e964-396af2b6c300/width=450/134297.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "U9K^mN00Xg-:4m9G%1?G?GxB~q~W00j[?HR*",
                                    "type": "image"
                                },
                                {
                                    "id": 134296,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6ad94127-8ad7-45ff-ff4a-09dbec0f9d00/width=450/134296.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "URGu,nyE0LNGS$M{?Ha~_4bcxuof.8R*RjWB",
                                    "type": "image"
                                },
                                {
                                    "id": 134295,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/64510424-8c91-46fb-8207-403c4900ca00/width=450/134295.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "URJa$V9Z56xG_ND*?HIotRIoxuRjxuWBV@xa",
                                    "type": "image"
                                },
                                {
                                    "id": 134294,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f0cba38a-e94e-4563-718b-b185efe8c200/width=450/134294.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UTLNrf~q0Jxt_3-;?bogt8Rl%Nj]ozROMxof",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/13849"
                        }
                    ]
                },
                {
                    "id": 5477,
                    "name": "Lucy (Cyberpunk Edgerunners) LoRA",
                    "description": "<h2>Lucy (Cyberpunk Edgerunners) LoRA</h2><p><strong>Making models can be expensive. Do you like what I do? Consider supporting me on </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/Lykon275\"><strong>Patreon</strong></a><strong> 🅿️ or feel free to </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://snipfeed.co/lykon\"><strong>buy me a coffee</strong></a><strong> ☕</strong></p><p>Another hard LoRA for another great character design. Both version (35 and 42) are flexible enough. I'd say that 35 is a bit better with her normal outfit, but 42 is a bit more precise with her naked (but it still needs some help with triggers like <code>(robot joints:0.5)</code> and <code>mechanical parts</code>). None of them seem to get her back pattern perfectly, as the dataset was not very consistent, but the 42 epoch version is a little bit more precise on that. Trigger is <code>lucy \\(cyberpunk\\)</code>, weight should be <strong>around 1 for the offset version (0.65 for the old ones) </strong>on AnyLoRA ckpt<strong>. </strong> <br /><br />The as a LoRA this is flexible enough to allow you to change her hairstyle, clothes, have just pieces of her outfit or all of it. But if you type <code>jacket</code> you get her jacket, if you type <code>shorts</code> you get her shorts, etc. <br /><br /><strong>How to use LoRA's in auto1111:</strong></p><ul><li><p>Update webui (use <code>git pull</code> <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/embed/mn8fMF10XN4?start=31&amp;end=60\">like here</a> or redownload it)</p></li><li><p>Copy the file to <code>stable-diffusion-webui/models/lora</code></p></li><li><p>Select your LoRA like in <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/watch?v=-bMeyXOZwN0\">this video</a></p></li><li><p><strong>Make sure to change the weight</strong> (by default it's <code>:1</code> which is usually too high)</p></li></ul><p></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 4,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 49197,
                        "favoriteCount": 0,
                        "thumbsUpCount": 6476,
                        "thumbsDownCount": 1,
                        "commentCount": 16,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 12
                    },
                    "creator": {
                        "username": "Lykon",
                        "image": "https://cdn.discordapp.com/avatars/180327464155742208/59254be18ccd627daf138d053327485d.png"
                    },
                    "tags": [
                        "anime",
                        "character",
                        "girl",
                        "sexy",
                        "cyberpunk",
                        "naked",
                        "lucy",
                        "cyberpunk edgerunners",
                        "woman",
                        "girls"
                    ],
                    "modelVersions": [
                        {
                            "id": 6370,
                            "name": "offset",
                            "index": 1,
                            "modelId": 5477,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2023-01-28T00:53:28.586",
                            "availability": "Public",
                            "trainedWords": [
                                "lucy \\(cyberpunk\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 45682,
                                "ratingCount": 142,
                                "rating": 4.92,
                                "thumbsUpCount": 211,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 47993,
                                    "sizeKB": 147567.2177734375,
                                    "name": "lucy_offset.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-12T08:31:20.425Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "B24243A9",
                                        "AutoV2": "2BB7EFC809",
                                        "SHA256": "2BB7EFC80951480576CB1EA28486A9473106732CA5B45E316D7764EC2CEA76D5",
                                        "CRC32": "4E4AD7E8",
                                        "BLAKE3": "1E97B19F31E44B31AEEE88874DE9F148A91F43CED3DFEA12AF26F3766610B189",
                                        "AutoV3": "F7A664103D28"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/6370",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 6523817,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f7932c5-dfd2-4676-aff6-6c4ac715cd64/width=450/6523817.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQF$O].9cDIp_4-;IUIUoc-pIAM{^+t79Zag",
                                    "type": "image"
                                },
                                {
                                    "id": 117724,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/19a6bfab-3b46-4634-d61e-95983ea1f800/width=450/117724.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 864,
                                    "height": 1304,
                                    "hash": "UeHxW+9aM{RP~WD%oLWB-oMyWVxax]ofRjae",
                                    "type": "image"
                                },
                                {
                                    "id": 364196,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/69116f6e-344f-4dc7-7f8c-4da23bf91400/width=450/364196.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UGGuj*$g-1~U9h_3004nSi4=D*01t9?FoutQ",
                                    "type": "image"
                                },
                                {
                                    "id": 6523818,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5cdc0be2-309e-4b69-ad35-74a089c5e7a5/width=450/6523818.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCJHUV~qON4m0-X700-q^%MyXkxD01%g={57",
                                    "type": "image"
                                },
                                {
                                    "id": 56930,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/94ed7afe-d492-4a41-0fb3-6b575b3ae500/width=450/56930.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UAF~adbz00xv~EkYrAi~00nh8wRjEdwtERTI",
                                    "type": "image"
                                },
                                {
                                    "id": 6523656,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3c20953a-f8d6-4925-a1ab-76fc0c5ccc45/width=450/6523656.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEJacsx[G7xIlAtQ00RP~ExtkpNI00Rj=^Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 56936,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fa691f6a-40b3-43a3-ead4-764634715a00/width=450/56936.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UIFrkq%04,9F~VE1E0s;IWE29Go#-;tTIUE2",
                                    "type": "image"
                                },
                                {
                                    "id": 56932,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/982215a7-f7c8-43c7-b1c3-a2f1836bfc00/width=450/56932.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UCHn?MIU?uIo00WBIUM{_N-;s,?HE1M|_3Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 56917,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5f52b11b-251b-4615-f99b-533b54623c00/width=450/56917.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "U9IEX_5_wC0000$]00%2~Vn3o|^+wgXSIAWA",
                                    "type": "image"
                                },
                                {
                                    "id": 56935,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/19909d1b-41c7-485b-74b6-7890ffd40900/width=450/56935.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UDGIJ}?H9Ya%K%Io0KIU00x^^+%MMxTJ~Wxs",
                                    "type": "image"
                                },
                                {
                                    "id": 56934,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a8a83485-a4dd-4ed1-4e3b-b52de0001d00/width=450/56934.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UBH_Pr00MaI;04~U0100tKvz-;wGt2S*9XMz",
                                    "type": "image"
                                },
                                {
                                    "id": 56933,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c89bd7de-3ca8-4b57-eaa7-632c3158ca00/width=450/56933.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UeJRR0.7oXE2%%-pIUs:N2${tRxB%bbwxtM|",
                                    "type": "image"
                                },
                                {
                                    "id": 56928,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/58ede5d5-4482-4382-b8fa-e1404e685c00/width=450/56928.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UKGI$U~q4ms:x^o}DhRO0K9FnNX7D%aKxtf+",
                                    "type": "image"
                                },
                                {
                                    "id": 56927,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fa8927f4-1094-4c5a-c39b-1684d59dda00/width=450/56927.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "U6HLPg;p000K00%MI-5600TH^*xU:i.9}Gv|",
                                    "type": "image"
                                },
                                {
                                    "id": 56926,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e625a9ab-1b16-4a93-0b73-c151ef7ba800/width=450/56926.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UFHL0n9b00E000~C9F0eIWxv%Lsln$9Z?Hoz",
                                    "type": "image"
                                },
                                {
                                    "id": 56924,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2a393641-dd57-4124-5df9-82422dca7000/width=450/56924.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UNF?9LOZxn9a00V?M|%14o-pjHRi_Nbcozjv",
                                    "type": "image"
                                },
                                {
                                    "id": 56923,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e51a38ce-7d03-43a5-bfc1-ab9c86238800/width=450/56923.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UaG0IdX89ss;mRjFROWB-qofITWB~qWBNGf6",
                                    "type": "image"
                                },
                                {
                                    "id": 56919,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/23ec93eb-df4d-496a-b29f-d5a301f32900/width=450/56919.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "U6G92K=j00.900obI-W900Ns?bM{Im_N^Q4m",
                                    "type": "image"
                                },
                                {
                                    "id": 56918,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0dea7107-8856-4335-8e43-17914da20900/width=450/56918.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UKG+%e.8y9I[008_IAtQ4:-:Mxsp?wRjtmxv",
                                    "type": "image"
                                },
                                {
                                    "id": 56921,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2cb55e85-91d2-46cc-c65c-b3680982fc00/width=450/56921.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "U2C@T#0700El8w%{8yrWE1DO0ztP8w%g^*IU",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/6370"
                        },
                        {
                            "id": 68629,
                            "name": "35 epochs",
                            "index": 2,
                            "modelId": 5477,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 4,
                            "description": null,
                            "publishedAt": "2023-05-12T08:28:33.501",
                            "availability": "Public",
                            "trainedWords": [
                                "lucy \\(cyberpunk\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1114,
                                "ratingCount": 1364,
                                "rating": 5,
                                "thumbsUpCount": 2098,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 47991,
                                    "sizeKB": 147533.748046875,
                                    "name": "lucy-000035.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-12T08:26:00.782Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "597AC243",
                                        "AutoV2": "58B8B4ED7E",
                                        "SHA256": "58B8B4ED7E7B0BE0FDE43501341190A4C46AC4A4B70E13759A0EAA59DDDACF8D",
                                        "CRC32": "05C869EC",
                                        "BLAKE3": "0997BD9DF6640F6DBF43999F59383FE724D12296682A58AF3F13AF1257891DD6",
                                        "AutoV3": "28D922482DD5"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/68629",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 764786,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c22c9377-874b-4328-a7e8-0adc9d913fb5/width=450/764786.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1840,
                                    "height": 1598,
                                    "hash": "UjIE-Aofayt7~qWBayRj%Na#ayWC-;t7ayxu",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/68629"
                        },
                        {
                            "id": 6371,
                            "name": "42 epochs",
                            "index": 3,
                            "modelId": 5477,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 13,
                            "description": "<p>Better for nudes, aid using <code>(robot joints:0.5)</code> and <code>mechanical parts</code>.</p>",
                            "publishedAt": "2023-01-28T00:56:12.926",
                            "availability": "Public",
                            "trainedWords": [
                                "lucy \\(cyberpunk\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2401,
                                "ratingCount": 4216,
                                "rating": 5,
                                "thumbsUpCount": 4216,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 6613,
                                    "sizeKB": 147533.7490234375,
                                    "name": "lucy-000042.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-01-28T01:01:13.873Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "62E1D862",
                                        "AutoV2": "C9C8507635",
                                        "SHA256": "C9C8507635D9A5F8D558B5E01FC6BBF654C25B90A41378249E2355955E85D2B2",
                                        "CRC32": "F003FE98",
                                        "BLAKE3": "B65756C1B3F109E0904D2E671D97FA9C81C7EC6FF1DB7A4ECA17AC8B2A29E9FE",
                                        "AutoV3": "72FAD2BA7671"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/6371",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 56953,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9f4d555c-e024-40c7-b96c-5baff8bf0200/width=450/56953.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UIFrkq%04,9F~VE1E0s;IWE29Go#-;tTIUE2",
                                    "type": "image"
                                },
                                {
                                    "id": 56957,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e29812e6-77a2-4bae-96d4-b214c31b7c00/width=450/56957.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UNGS1G009[~CWtIUbcxaIAx[9FxubYX4s+tR",
                                    "type": "image"
                                },
                                {
                                    "id": 56947,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/73ee4cc9-d5fc-4321-8836-fb6a39edec00/width=450/56947.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UAF~adbz00xv~EkYrAi~00nh8wRjEdwtERTI",
                                    "type": "image"
                                },
                                {
                                    "id": 56954,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8263a17d-5f41-44bf-fe2d-1ca77ba03000/width=450/56954.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "U9IEX_5_wC0000$]00%2~Vn3o|^+wgXSIAWA",
                                    "type": "image"
                                },
                                {
                                    "id": 56952,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/72cefc5e-d2f2-4a1c-29e4-5a67a55bdb00/width=450/56952.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UDGIJ}?H9Ya%K%Io0KIU00x^^+%MMxTJ~Wxs",
                                    "type": "image"
                                },
                                {
                                    "id": 56951,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/052f10fd-8c49-4a89-d385-d91681cc3400/width=450/56951.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UBH_Pr00MaI;04~U0100tKvz-;wGt2S*9XMz",
                                    "type": "image"
                                },
                                {
                                    "id": 56950,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a8ed936c-f65b-4f47-4acd-949aceeadf00/width=450/56950.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UeJRR0.7oXE2%%-pIUs:N2${tRxB%bbwxtM|",
                                    "type": "image"
                                },
                                {
                                    "id": 56949,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e8019677-f8e0-492a-fb24-6b55257cc500/width=450/56949.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UCHn?MIU?uIo00WBIUM{_N-;s,?HE1M|_3Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 56948,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/25c19d13-0ec5-4791-f614-6f76804d2500/width=450/56948.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UeJHgq~pIoM|-=WVNF%2oMf6oet6NGf6s:WV",
                                    "type": "image"
                                },
                                {
                                    "id": 56959,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b4ca2c2c-bb73-452b-c0d2-1f4458c16400/width=450/56959.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UgIqfi~AD$VsxZVrng-:s+s.R%ozW=t7t6t6",
                                    "type": "image"
                                },
                                {
                                    "id": 56942,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1c0290a8-c203-458a-b6e4-502b3ad4c100/width=450/56942.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UKGI$U~q4ms:x^o}DhRO0K9FnNX7D%aKxtf+",
                                    "type": "image"
                                },
                                {
                                    "id": 56941,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/29745a67-c3e1-4555-df73-453325c16100/width=450/56941.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "U6HLPg;p000K00%MI-5600TH^*xU:i.9}Gv|",
                                    "type": "image"
                                },
                                {
                                    "id": 56958,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/47882352-a641-40a2-8efc-800d8b334100/width=450/56958.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UFHL0n9b00E000~C9F0eIWxv%Lsln$9Z?Hoz",
                                    "type": "image"
                                },
                                {
                                    "id": 56939,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/476e8314-adad-4e6f-7588-c29ba51e8200/width=450/56939.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UNF?9LOZxn9a00V?M|%14o-pjHRi_Nbcozjv",
                                    "type": "image"
                                },
                                {
                                    "id": 56946,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/99a6af19-58fe-4bfc-b909-3aa5ae646c00/width=450/56946.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UaG0IdX89ss;mRjFROWB-qofITWB~qWBNGf6",
                                    "type": "image"
                                },
                                {
                                    "id": 56940,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e717a47-24a7-4122-92be-3ca425809200/width=450/56940.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UKGI=wXT9YofHXjG4mRi-;o0IURj_NW=ELt7",
                                    "type": "image"
                                },
                                {
                                    "id": 56956,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ed1356ab-09f3-4087-0135-5e5475f75700/width=450/56956.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "U6G92K=j00.900obI-W900Ns?bM{Im_N^Q4m",
                                    "type": "image"
                                },
                                {
                                    "id": 56938,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ec43d1f3-31d5-4224-9571-a72204d1e700/width=450/56938.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UKG+%e.8y9I[008_IAtQ4:-:Mxsp?wRjtmxv",
                                    "type": "image"
                                },
                                {
                                    "id": 56945,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f4a97813-beac-4c06-4356-317201e3e200/width=450/56945.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "U2C@T#0700El8w%{8yrWE1DO0ztP8w%g^*IU",
                                    "type": "image"
                                },
                                {
                                    "id": 56955,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e62d07b-507e-4ea2-274e-eda0af69a300/width=450/56955.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UZJt#p~qx[E1=~bIo{tRNH?HMxRjMyt7s,WU",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/6371"
                        }
                    ]
                },
                {
                    "id": 8029,
                    "name": "Elegant hanfu ruqun style",
                    "description": "<p>The training set is mainly about the illustrations of Hanfu works of many artists,which style is pure,fresh,quiet and elegant.</p><p>The lora weight I recommend is 0.8 to 1.0.</p><p>ENJOY IT WWW</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 26553,
                        "favoriteCount": 0,
                        "thumbsUpCount": 6318,
                        "thumbsDownCount": 1,
                        "commentCount": 20,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 10
                    },
                    "creator": {
                        "username": "L_A_X",
                        "image": "https://cdn.discordapp.com/avatars/1046319534790942850/a6d5fd6a7c4c7f1e0af299bc3a0d4fab.png"
                    },
                    "tags": [
                        "anime",
                        "style",
                        "ruqun",
                        "hanfu"
                    ],
                    "modelVersions": [
                        {
                            "id": 9470,
                            "name": "V1.0",
                            "index": 0,
                            "modelId": 8029,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p></p>",
                            "publishedAt": "2023-02-11T13:02:01.878",
                            "availability": "Public",
                            "trainedWords": [
                                "ru_qun"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 26553,
                                "ratingCount": 6091,
                                "rating": 5,
                                "thumbsUpCount": 6318,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 9169,
                                    "sizeKB": 73839.2958984375,
                                    "name": "Elegant hanfu ruqun style.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-11T13:05:59.182Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "A494919E",
                                        "AutoV2": "495901D34F",
                                        "SHA256": "495901D34F3D9EB992E4154C51306B51A6184147979A51FFDAF4BAB0DC028D9A",
                                        "CRC32": "9A888F0C",
                                        "BLAKE3": "E4F3131220C06B71CB4906EDFC608A92ACB69EA5DD687E4E29C4AA0AD09027D4",
                                        "AutoV3": "18E059AE584A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/9470",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 92713,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b11f7a1a-c998-4444-f866-4c01fcbeb300/width=450/92713.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UhI5PQM{ab%2~VM|WpxuoJIoR+R.ofRjRjWC",
                                    "type": "image"
                                },
                                {
                                    "id": 91067,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/51c44132-df1b-46b7-8c8f-c74c06179300/width=450/91067.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 720,
                                    "height": 960,
                                    "hash": "UZKTi9?a9Z9G~p%LMxV@9aV[WCkCsmj[ogWC",
                                    "type": "image"
                                },
                                {
                                    "id": 92712,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/447f6119-c54b-4d4e-ea02-dd2271667300/width=450/92712.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UaIq[a~WRP9Z-:%LNGaetR%MR+oJS1M{ogax",
                                    "type": "image"
                                },
                                {
                                    "id": 92707,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/08c64f41-6d69-4632-fdb7-2456c08b4100/width=450/92707.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIHxf}_20J4o~pbbWB%LT0%1MykCxv%1WBRP",
                                    "type": "image"
                                },
                                {
                                    "id": 92698,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1dcf696e-6cc9-4a73-1f8b-d4dbbe46b800/width=450/92698.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFH.7y02Q,rr~p4.4:-:Ri01-;J7x^ng$+%M",
                                    "type": "image"
                                },
                                {
                                    "id": 91075,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4ee5227a-ac9d-4bd4-9919-35948608fa00/width=450/91075.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 720,
                                    "height": 960,
                                    "hash": "UWKwU+?b_Nx]_No#xaxHRPM{R*IoNGt7xaxa",
                                    "type": "image"
                                },
                                {
                                    "id": 91074,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f0c034c-ab21-4e0d-ad07-4133547d6700/width=450/91074.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 720,
                                    "height": 960,
                                    "hash": "UlIYFDD%XQkq.madRPX9s;X7WBxGxvM{s:oM",
                                    "type": "image"
                                },
                                {
                                    "id": 91073,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6625b790-dec5-44f6-114e-74c8ce109700/width=450/91073.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 720,
                                    "height": 960,
                                    "hash": "UGH_Pv~p00D*Mb-q.8tR%gRkxu-p9FM{s9%L",
                                    "type": "image"
                                },
                                {
                                    "id": 91072,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f27bb576-696c-42ae-f114-8be01dcdb700/width=450/91072.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 720,
                                    "height": 960,
                                    "hash": "UIHUk4?tN:4.9qJ4.6^*Om~UovxW9Zs.xGoe",
                                    "type": "image"
                                },
                                {
                                    "id": 91071,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0472496b-ee16-423d-36de-492ea070ae00/width=450/91071.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 720,
                                    "height": 960,
                                    "hash": "UHG8.tE29Z?H~p9G9G?abv%LRjt8NKs:xat7",
                                    "type": "image"
                                },
                                {
                                    "id": 91070,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f4a9eb45-4465-4a49-6e91-6d663d07a600/width=450/91070.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 720,
                                    "height": 960,
                                    "hash": "UDKATq^*00ss~B?b0z00.8tN9tMyNcNGs:xH",
                                    "type": "image"
                                },
                                {
                                    "id": 91069,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a5123e28-661e-457b-281d-d7bfd0384d00/width=450/91069.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 720,
                                    "height": 960,
                                    "hash": "UMJto2_MEdxt9sNdt7jEW-?FNFxtNdt6WqRj",
                                    "type": "image"
                                },
                                {
                                    "id": 92706,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c436fe76-a729-40d7-8e99-5509724c1c00/width=450/92706.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UfJHaK~oE1WE%Kx[tR$+M{t7t7NGIpWBoJR*",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/9470"
                        }
                    ]
                },
                {
                    "id": 7094,
                    "name": "Arcane Style LoRA",
                    "description": "<h2>Arcane Style LoRA</h2><p><strong>Making models can be expensive. Do you like what I do? Consider supporting me on </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/Lykon275\"><strong>Patreon</strong></a><strong> 🅿️ or feel free to </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://snipfeed.co/lykon\"><strong>buy me a coffee</strong></a><strong> ☕</strong></p><p>Greatest show of 2021, time to bring this style to 2023 Stable Diffusion with LoRA.</p><p>This should be used with <strong>AnyLoRA</strong> (that's neutral enough) at <strong>around 1 weight for the offset version, 0.65 weight for the original one</strong> (with highres fix R-ESRGAN 0.4 denoise for better results). Trigger is <code>arcane style</code> but I noticed this often works even without it.</p><p>Allow me to remind <strong>this is not a character LoRA </strong>(I didn't tag characters in the dataset). Still ,as you can see, it can get pretty close to the original characters with accurate prompting. This should also work with most of my character LoRA's (used Ahri and Lucy to test).</p><p>Please enjoy.</p><p><br /><strong>How to use LoRA's in auto1111:</strong></p><ul><li><p>Update webui (use <code>git pull</code> <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/embed/mn8fMF10XN4?start=31&amp;end=60\">like here</a> or redownload it)</p></li><li><p>Copy the file to <code>stable-diffusion-webui/models/lora</code></p></li><li><p>Select your LoRA like in <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/watch?v=-bMeyXOZwN0\">this video</a></p></li><li><p><strong>Make sure to change the weight if needed</strong> (by default it's <code>:1</code>)</p></li></ul><p><br /></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 45798,
                        "favoriteCount": 0,
                        "thumbsUpCount": 6240,
                        "thumbsDownCount": 1,
                        "commentCount": 43,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 222
                    },
                    "creator": {
                        "username": "Lykon",
                        "image": "https://cdn.discordapp.com/avatars/180327464155742208/59254be18ccd627daf138d053327485d.png"
                    },
                    "tags": [
                        "anime",
                        "arcane",
                        "league of legends",
                        "girl",
                        "sexy",
                        "tv show",
                        "style",
                        "art style",
                        "artstyle",
                        "girls",
                        "video game"
                    ],
                    "modelVersions": [
                        {
                            "id": 8339,
                            "name": "offset",
                            "index": 0,
                            "modelId": 7094,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-02-06T22:54:01.231",
                            "availability": "Public",
                            "trainedWords": [
                                "arcane style"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 44151,
                                "ratingCount": 425,
                                "rating": 4.98,
                                "thumbsUpCount": 506,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 10270,
                                    "sizeKB": 295023.6611328125,
                                    "name": "arcane_offset.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-15T18:41:23.828Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {},
                                    "downloadUrl": "https://civitai.com/api/download/models/8339",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 79106,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/93e74bc8-97ce-4826-e142-594cdd134d00/width=450/79106.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UDGa^ERP4:~p00E0RP-px[nPM_JT00NG^*M{",
                                    "type": "image"
                                },
                                {
                                    "id": 79024,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e04ffbd-8e4d-4ead-77e2-33f33b596500/width=450/79024.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UdHK,_~V_2?aWUt6j[WBE1M{RPM{-oWBoeof",
                                    "type": "image"
                                },
                                {
                                    "id": 79037,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aa5ce4d1-09f4-4db5-450d-3bdfca8fb600/width=450/79037.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UQGRk@~W?HNts:%2S4%Lj?IUM|xtkD-;%2n$",
                                    "type": "image"
                                },
                                {
                                    "id": 79036,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d8d21378-d54b-4f1f-5be6-48f5feaf1100/width=450/79036.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UYEoMd?Hx[t8~V-:tRtRbFxtozxuNIxaofWX",
                                    "type": "image"
                                },
                                {
                                    "id": 79057,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d8edb43f-0798-4af1-6dbf-8f6816e37600/width=450/79057.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UFELZ]01S{~C~U4:EL%2SzIV-ot7?HM{=|bH",
                                    "type": "image"
                                },
                                {
                                    "id": 79030,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5ad7b32e-346f-4be5-9d45-b6c4fb6ec600/width=450/79030.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "USHdy;%LOX^*~W-:S1V@?bIoMxxto}s.a0oy",
                                    "type": "image"
                                },
                                {
                                    "id": 79033,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9907aac6-cb81-4a3d-e3c0-980ea3cd8f00/width=450/79033.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UfJasJ?c?bMy~qRP%MRjtljFxuWCtSWXjYaz",
                                    "type": "image"
                                },
                                {
                                    "id": 651045,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/430d1914-7347-4148-8046-980ec15d7b00/width=450/651045.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UKH^|x?bx[S1~q%MWBRP57-pjGM{xa%Lxus:",
                                    "type": "image"
                                },
                                {
                                    "id": 321303,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a224dc09-5fea-442a-2a12-71cd31cde300/width=450/321303.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "ULELv$E0IU~W?cRiRit79us.NGIUNIs:ofM{",
                                    "type": "image"
                                },
                                {
                                    "id": 79035,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c7c54057-b5e6-4765-4318-a1a12797bf00/width=450/79035.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UCFE[z0100s+OuIoVr$%5Rw_xaxt0f~BoJ9a",
                                    "type": "image"
                                },
                                {
                                    "id": 79031,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/94ad7363-96f8-488e-b396-7ead8a7ba600/width=450/79031.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UlKwqbNG_N-;?bIUozs:aeRiR*s:Rjoft6bH",
                                    "type": "image"
                                },
                                {
                                    "id": 79032,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1716dac-6969-4858-6b8e-44c915f8b500/width=450/79032.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UCD+rZ~B0JoxK6sk-n-;55ad-U-;RPxu%19G",
                                    "type": "image"
                                },
                                {
                                    "id": 79034,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ed194d55-30ed-4e72-67e7-ac7300531100/width=450/79034.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UjMQCmbZ_N%2$+yDoz$*%3M{kWV[D%RjxaRP",
                                    "type": "image"
                                },
                                {
                                    "id": 79029,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f6f421ed-00af-4693-9860-5554b5323b00/width=450/79029.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UTIEUzIVMyxt~UV]IVW-4.xa$+R%IVt6s:Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 79028,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ac4fe5ee-287e-4a5a-2300-15ed9f9f8500/width=450/79028.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UGJkJ;.A00-2pJto4:-40ftn_2xU_NRlM{%K",
                                    "type": "image"
                                },
                                {
                                    "id": 79027,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5f2ac7c8-816e-4f63-a44f-146b8ef33000/width=450/79027.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UfGk?^#*j?NG~WxZV@NGxs%MM{Rjg3x[M{oL",
                                    "type": "image"
                                },
                                {
                                    "id": 79026,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/47688fc3-efaf-43b7-7927-2c0da45e7e00/width=450/79026.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UDFPHN00?8~p04~T02WbRNEQxtR5wENa%Mt5",
                                    "type": "image"
                                },
                                {
                                    "id": 79025,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a4012109-e56a-4338-74a9-63e2cf271200/width=450/79025.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UnJbmM-pMzxtPEXlbHt6V*WFWUofx@WXahs:",
                                    "type": "image"
                                },
                                {
                                    "id": 651046,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/610a4e92-7729-4997-08e5-c17a240b6b00/width=450/651046.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "USHd]W?H_3?H~q%Lo}%Lbb%2ofIpE2xuxuoL",
                                    "type": "image"
                                },
                                {
                                    "id": 651044,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/53d4044d-a750-447c-ca1d-f5fbd76e6400/width=450/651044.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UTH_DH00.7Vt~qMwWCxaXTRiV[t7?aM|Rjof",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/8339"
                        },
                        {
                            "id": 68672,
                            "name": "offset 64 dim",
                            "index": 1,
                            "modelId": 7094,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 2,
                            "description": null,
                            "publishedAt": "2023-05-12T10:05:54.416",
                            "availability": "Public",
                            "trainedWords": [
                                "arcane style"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 611,
                                "ratingCount": 1471,
                                "rating": 5,
                                "thumbsUpCount": 2300,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 48027,
                                    "sizeKB": 72137.21875,
                                    "name": "arcane_offset64dim.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-12T09:41:02.800Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "8BA58FC7",
                                        "AutoV2": "F5E2C4A6C9",
                                        "SHA256": "F5E2C4A6C92C96BDB9DD41C738882CE24DBAA1EEBA7E8F677CD69062EADF26DD",
                                        "CRC32": "9D1025B4",
                                        "BLAKE3": "D14D50BE26125AC426E9ECA143981C0050FA634E30016EACFE33F8A508F29708",
                                        "AutoV3": "A1309984CDF2"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/68672",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 765611,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ea8d0841-d43e-4d76-990b-95be699acbfc/width=450/765611.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1840,
                                    "height": 1587,
                                    "hash": "USHUzzad%2Io.TR*WBoe~qofRj%2_3R*s:kC",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/68672"
                        },
                        {
                            "id": 10912,
                            "name": "original",
                            "index": 2,
                            "modelId": 7094,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 6,
                            "description": null,
                            "publishedAt": "2023-02-15T18:44:12.637",
                            "availability": "Public",
                            "trainedWords": [
                                "arcane style"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1036,
                                "ratingCount": 3470,
                                "rating": 5,
                                "thumbsUpCount": 3470,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 10271,
                                    "sizeKB": 295025.2099609375,
                                    "name": "arcane.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-15T18:46:04.985Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "73DF21AD",
                                        "AutoV2": "F15429D21C",
                                        "SHA256": "F15429D21C6B54B32577BE32DFEEBA7F7FF13CB4585432E59FE20D88D83C1C51",
                                        "CRC32": "2A9F7BB3",
                                        "BLAKE3": "1442D9BE485C7145089EDAAD0A2A30548C2FD1A7EAD6B08D93C9AA3FC2FAC693",
                                        "AutoV3": "98DF018DB34C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/10912",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 105505,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8579ecaf-a8b3-4b16-9244-49c6091f3e00/width=450/105505.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 887,
                                    "hash": "UVIXjhV@ofRPt-WVWCax~qoMoes:?bkCj?oz",
                                    "type": "image"
                                },
                                {
                                    "id": 105504,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1fc103a3-da5a-4f61-95f0-5b419cd0a200/width=450/105504.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 887,
                                    "hash": "UVIXjiV@oeMyt-fjWVfk~qj]WBs:?vbFofoz",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/10912"
                        }
                    ]
                },
                {
                    "id": 16997,
                    "name": "Standing Full Body with Background Style LoRA (带背景立绘/背景付き立ち絵)",
                    "description": "<p>Trined on tachi-e (standing full body) with background from multiple mobile games. This LoRA is suited for both portrait &amp; landscape orientation images.</p><p>Usage:</p><ul><li><p>Trigger words:</p><ul><li><p><code>white background, full body</code>: tachi-e with background (separately described), try using <code>(white background:1.5)</code> if it's not working; the higher the strength of <code>white background</code>, the larger the white area</p></li><li><p><code>simple background, full body</code>: tachi-e w/o background (no describe, portrait orientation)</p></li><li><p><code>white background, full body, border, outside border</code>: tachi-e w/ background and border cut-out</p></li><li><p><code>white background, no human</code>: scenery tachi-e w/o characters</p></li></ul></li><li><p>Elements:</p><ul><li><p>Clothes: <a target=\"_blank\" rel=\"ugc\" href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Aattire\">https://danbooru.donmai.us/wiki_pages/tag_group%3Aattire</a> (I'd emphasize for defeated tachi-e, use <code>torn clothes, torn legwear, torn shirt, torn dress</code>, also try adding <code>nsfw</code> and you'll see what happens)</p></li><li><p>Basic elements: <code>fire/flame/water/ice/snow/lightning/electricity/clouds/wind/fog</code> ... etc.</p></li><li><p>Color: <code>{color} theme</code>, use <code>{color} background, white background</code> and you'll get a two-tone background, also you can use <code>colorful</code></p></li><li><p>Plants: <code>tree/flower/floral background/meadow</code> ... etc.</p></li><li><p>Animals: <code>cat/dog/rabbit</code> ... etc. and you can add monsters like <code>ghost/zombie/dragon</code> .. etc. See: <a target=\"_blank\" rel=\"ugc\" href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Alegendary_creatures\">https://danbooru.donmai.us/wiki_pages/tag_group%3Alegendary_creatures</a></p></li><li><p>Architecture: gothic architecture/east asian architecture/cityscape/architecture/skyscraper/bridge/door ... etc.</p></li><li><p>Theme: <code>fantasy/steampunk/cyberpunk</code> ... etc. See: <a target=\"_blank\" rel=\"ugc\" href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Atechnology\">https://danbooru.donmai.us/wiki_pages/tag_group%3Atechnology</a></p></li><li><p>Others:</p><ul><li><p>Symbols: <code>magic circle/hexagram</code> ... etc. See: <a target=\"_blank\" rel=\"ugc\" href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Asymbols\">https://danbooru.donmai.us/wiki_pages/tag_group%3Asymbols</a></p></li><li><p>Ornaments: <code>book/chair/gem</code> ... etc.</p></li><li><p>Expressions, postures &amp; gestures: <a target=\"_blank\" rel=\"ugc\" href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Aface_tags\">https://danbooru.donmai.us/wiki_pages/tag_group%3Aface_tags</a> / <a target=\"_blank\" rel=\"ugc\" href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Aposture\">https://danbooru.donmai.us/wiki_pages/tag_group%3Aposture</a> / <a target=\"_blank\" rel=\"ugc\" href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Agestures\">https://danbooru.donmai.us/wiki_pages/tag_group%3Agestures</a></p></li><li><p>Image composition: <code>dutch angle/from above/fisheye</code> ... etc. See: <a target=\"_blank\" rel=\"ugc\" href=\"https://danbooru.donmai.us/wiki_pages/tag_group%3Aimage_composition\">https://danbooru.donmai.us/wiki_pages/tag_group%3Aimage_composition</a></p></li><li><p>All other things you can imagine</p></li></ul></li></ul></li><li><p>Use with other LoRAs: characters, poses, concepts etc.</p></li></ul><p></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 11,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 28995,
                        "favoriteCount": 0,
                        "thumbsUpCount": 6163,
                        "thumbsDownCount": 0,
                        "commentCount": 16,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 10
                    },
                    "creator": {
                        "username": "CyberAIchemist",
                        "image": "https://lh3.googleusercontent.com/a/AEdFTp7wdMG_twkGoSPl9QFSRrBhaXvnEmP_l69xiJbH6g=s96-c"
                    },
                    "tags": [
                        "anime",
                        "landscapes",
                        "girl",
                        "female",
                        "standing",
                        "full body",
                        "style",
                        "art style",
                        "illustration",
                        "artstyle",
                        "digital illustration",
                        "fantasy",
                        "girls",
                        "video game",
                        "simple background"
                    ],
                    "modelVersions": [
                        {
                            "id": 20072,
                            "name": "v1.0 offset",
                            "index": 0,
                            "modelId": 16997,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 11,
                            "description": "<p>Trained with offset noise</p>",
                            "publishedAt": "2023-03-08T04:04:34.924",
                            "availability": "Public",
                            "trainedWords": [
                                "white background, full body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 28995,
                                "ratingCount": 5517,
                                "rating": 5,
                                "thumbsUpCount": 6163,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16757,
                                    "sizeKB": 36973.80078125,
                                    "name": "tachi-e.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-08T04:06:32.754Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "4A9A0C5F",
                                        "AutoV2": "9AAA4A57A1",
                                        "SHA256": "9AAA4A57A1EBDDD28B3DCCF262970B07C72C24C5622DC842BFAA5FFD793BED5C",
                                        "CRC32": "2C261D03",
                                        "BLAKE3": "21DDF941859E86633D14D41E642C2A1EA57F9525AEF906A75CCF3C152D881BE9",
                                        "AutoV3": "15C1B061D1CB"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/20072",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 212087,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7eb7730f-7b3e-4db3-50f5-f792f4e19000/width=450/212087.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UKNmmB9a.8^+~pWBNdtQ_NWB.8tR-VMxMxxv",
                                    "type": "image"
                                },
                                {
                                    "id": 212100,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/863e9514-e7fc-4370-1b8b-ce666fa5c200/width=450/212100.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UHJRBfRn?w^+tTt6bbNG_Nofozt7xUoMRjWB",
                                    "type": "image"
                                },
                                {
                                    "id": 212099,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f25bccc0-71dd-449a-97d9-7c03e36a2300/width=450/212099.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "URJ*-m4n~q-;xtD%%Mt7RiWBRjt7-=WBR*%2",
                                    "type": "image"
                                },
                                {
                                    "id": 212098,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/055099be-f1fb-417b-7be3-7bd32aa66000/width=450/212098.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UaK_F1%M_3?bIUofIUoz~qxuM{R*t7%MaeRj",
                                    "type": "image"
                                },
                                {
                                    "id": 212095,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1a728c90-0334-4e86-3c61-c860a4b32800/width=450/212095.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UKIhgNM|_Nod?cNG.9xax@V@$$%M^+adWUoz",
                                    "type": "image"
                                },
                                {
                                    "id": 212097,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1310fd7-d0df-4825-155c-6f77905b2c00/width=450/212097.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UaNwp4xu-;tRxZWWWDoL~qR*xat7R-jZoyR+",
                                    "type": "image"
                                },
                                {
                                    "id": 212096,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b184b7fe-3fb3-422b-d876-5e8a6ce10600/width=450/212096.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UPNAF,t7.SX8?GR%Na%2~qoy9ZRk9Ht7kCay",
                                    "type": "image"
                                },
                                {
                                    "id": 212094,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f744597a-ee46-4594-f25e-441337702900/width=450/212094.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UdL|[mof~q%M%MRjaet7_3RjM{j[-;t6RjWB",
                                    "type": "image"
                                },
                                {
                                    "id": 212093,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4c0964b3-a61e-433e-443d-34fd646c6400/width=450/212093.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UlNAn{og~qxu%hofRif8?bWBM{j[?Hoet7j[",
                                    "type": "image"
                                },
                                {
                                    "id": 212092,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/514335ab-20c0-44d9-9185-0c573147ef00/width=450/212092.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UVIE|kkX9axu~WNHIos.krWA%2WB-VjES2NG",
                                    "type": "image"
                                },
                                {
                                    "id": 212089,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/55b0bd0c-63d0-4d43-27ca-1da995319d00/width=450/212089.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UfM7fbxu%Mxu~qWBNFRk?uoL%2ofxtoftRt7",
                                    "type": "image"
                                },
                                {
                                    "id": 212091,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ee152486-8a04-4cab-830d-109cb7a6a000/width=450/212091.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "ULO3nXV?pJ-;^5oft7oz?^t7RPkCofs:W=xu",
                                    "type": "image"
                                },
                                {
                                    "id": 212090,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3194f4cb-e675-4d5a-e4de-0723608b6f00/width=450/212090.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UQK1aq_39YIU?wtR~p%Lo#%1%2Rj4nIAs.bI",
                                    "type": "image"
                                },
                                {
                                    "id": 212088,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6dce8e9f-069f-4cb7-57e9-52ce4b011300/width=450/212088.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UPMjO4%M.mxvyDxu%fs:RjIUM{t7%gxtD%R*",
                                    "type": "image"
                                },
                                {
                                    "id": 214818,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b4c56ea6-f944-453d-94d8-4df312d60300/width=450/214818.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 4000,
                                    "height": 535,
                                    "hash": "U$M*8Pa}Rjof~qofj[WV^+jZs:WB%MfPayoL",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/20072"
                        }
                    ]
                },
                {
                    "id": 53601,
                    "name": "娜乌斯嘉nwsj_realistic",
                    "description": "<p>我的社交平台，抖音和B站同名都叫娜乌斯嘉！也可以加入我的qq群一起交流!</p><p>一群:321159940</p><p>二群:554810562</p><p>V1版本：权重推荐0.6-0.7</p><p>V1.1版本：权重推荐0.8</p><p>V2.0版本：触发词PerfectNwsjMajic，之所以用这个名字是因为我为了排除原生发型中分刘海的干扰，生成了一批光头图，果然很好的规避了这个缺陷。现在娜娜可以完美的适配各种发型的关键字了！Majic的后缀是为了提醒大家这个模型用Majic系列模型更容易还原娜娜的脸型！,切记切记！权重一定不可高于0.8，不然百分百生成光头娜娜=0=，推荐权重0.7！</p><p>V3.0版本：推荐权重0.7-0.8，在KW小姐姐的指导下使用了1024的素材进行训练，生成的脸部会清晰很多，光头和痣多的问题也已经解决！直出和放在AD插件里使用都OK！</p><p>感谢大家的支持，娜娜这就给磕一个，记得关注我哟！拜拜！</p><p></p><p>hi everyone</p><p>我是娜乌斯嘉，名字来源于宫崎骏的动画片风之谷的娜乌斯嘉</p><p>这是一个我自己的真人脸型</p><p>配方是原生的真人lora权重0.8+majicrealV4底模+fashiongirl权重0.2+shojovibe权重0.2</p><p>生成了新的一批图片训练而成</p><p>我称之为娜乌斯嘉realistic</p><p>在小范围公布Lora之后收到了很多美丽的图片，当然也有nsfw的图片</p><p>作为一个学美术的艺术生我是不在意这些的</p><p>请不要吝啬去尝试这个脸型吧，期待看到大家的艺术品！</p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [],
                    "allowDerivatives": false,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 56919,
                        "favoriteCount": 0,
                        "thumbsUpCount": 6125,
                        "thumbsDownCount": 3,
                        "commentCount": 163,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 110
                    },
                    "creator": {
                        "username": "nawusijia",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/13620aeb-6a71-4f0c-0c39-7887b0e07a00/width=96/nawusijia.jpeg"
                    },
                    "tags": [
                        "character",
                        "photorealistic",
                        "woman"
                    ],
                    "modelVersions": [
                        {
                            "id": 89527,
                            "name": "vHD_Nwsj_Majic3.0",
                            "index": 0,
                            "modelId": 53601,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>推荐权重0.7-0.8之间，使用1024像素训练，脸部高清耐得起放大~</p>",
                            "publishedAt": "2023-06-05T03:57:12.475",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 28429,
                                "ratingCount": 2145,
                                "rating": 4.99,
                                "thumbsUpCount": 2590,
                                "thumbsDownCount": 2
                            },
                            "files": [
                                {
                                    "id": 61538,
                                    "sizeKB": 73841.5263671875,
                                    "name": "BeautyNwsjMajic2-01.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-05T04:00:42.401Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "8A76CED5",
                                        "AutoV2": "C932413949",
                                        "SHA256": "C932413949A815FC64378FFA6EC34944597C5FF57CD98541347C4107106FD5D5",
                                        "CRC32": "7DD9B487",
                                        "BLAKE3": "0D0911742B4745498C444FEE235E91BE0667C8AFB25748F2324E6FE2DBB42CA8",
                                        "AutoV3": "8850F307E415"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/89527",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1035574,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b4a2d05f-1ed7-49d7-a0d5-02d1229653a5/width=450/1035574.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFFiDR~p9t.800InI@4o%gWAi^nh.S%M-U%2",
                                    "type": "image"
                                },
                                {
                                    "id": 1035542,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1805b489-20a2-4f86-8112-237a11a291bb/width=450/1035542.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 614,
                                    "height": 922,
                                    "hash": "UDGu8k?Gxt4.02jYx]tRXmofM{-:~VxuD%9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 1035547,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dce16c83-17c2-4fd2-ae47-b09d03d31cd9/width=450/1035547.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEGI4I00$e%14T^*JBxt9aI;s9NH~pE1Vs%1",
                                    "type": "image"
                                },
                                {
                                    "id": 1116035,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/379c9acc-d5ec-4ecf-a7c7-804959848948/width=450/1116035.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1920,
                                    "height": 1280,
                                    "hash": "UGE{X,j]4n01x[og9ZM{~q%2D%RPD%t7Iooz",
                                    "type": "image"
                                },
                                {
                                    "id": 1116046,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/98cf1e4b-4e21-485f-8f70-19448ca37ef0/width=450/1116046.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1920,
                                    "height": 1280,
                                    "hash": "URE.|SIUJ5%MtQs:E1Rk~pE1oHogx]t6M{t8",
                                    "type": "image"
                                },
                                {
                                    "id": 1116049,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a9c20d73-81d4-4730-9971-d93d5f59e6ae/width=450/1116049.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1920,
                                    "height": 1280,
                                    "hash": "UCDvv2_3PQ4o?^xv%LIUNJInIB$*.6%KRiM{",
                                    "type": "image"
                                },
                                {
                                    "id": 1116055,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e75f0deb-12f9-4251-901b-89b6c669aef1/width=450/1116055.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1920,
                                    "height": 1280,
                                    "hash": "UGG+K;00yD~pyCsAD%tS.94mIAM|W9s;V@xt",
                                    "type": "image"
                                },
                                {
                                    "id": 1116057,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2342afa7-055b-4c9d-98ab-b1c8f7a61edb/width=450/1116057.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UQF=%KDitlaK_ND%RjRjtSWAM{kC-pWBM{xa",
                                    "type": "image"
                                },
                                {
                                    "id": 1116181,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2f88c513-a65c-40ec-b687-99cc9b3c8574/width=450/1116181.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1920,
                                    "height": 1280,
                                    "hash": "UGE{X,j]4n01x[og9ZM{~q%2D%RPD%t7Iooz",
                                    "type": "image"
                                },
                                {
                                    "id": 1116215,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ae647d20-14cc-4d61-8846-c14ee79ed7b5/width=450/1116215.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1920,
                                    "height": 1280,
                                    "hash": "U48qB80M~UE3Y7I[xvE202^*D%-pIo~U9Z^*",
                                    "type": "image"
                                },
                                {
                                    "id": 1116231,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8201714f-575d-49f0-b7d3-2a8ac4a91d04/width=450/1116231.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1920,
                                    "height": 1280,
                                    "hash": "UMEVyntR0K-o?Ht8NeoL_4xuM_of-=oMRPt8",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/89527"
                        },
                        {
                            "id": 69646,
                            "name": "PerfectNwsjMajic_2.0",
                            "index": 1,
                            "modelId": 53601,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>此版本排除了刘海的干扰，可以随意替换发型，权重推荐0.7。不可高于0.8！否则会出现光头！为了排除发型干扰，此模型的数据集全部都是光头造型。</p>",
                            "publishedAt": "2023-05-13T13:49:43.071",
                            "availability": "Public",
                            "trainedWords": [
                                "PerfectNwsjMajic"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 15349,
                                "ratingCount": 1517,
                                "rating": 5,
                                "thumbsUpCount": 1518,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 48638,
                                    "sizeKB": 36975.8583984375,
                                    "name": "PerfectNwsjMajic_4.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-13T13:46:03.377Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "18676487",
                                        "AutoV2": "553D256661",
                                        "SHA256": "553D256661AB98DB3D2DFF3E1520F2E27288E7AB06359C99ED7B730ED5AF9D9C",
                                        "CRC32": "F3414C2A",
                                        "BLAKE3": "80FCF3CA362AD6F455226010DF3AFA061F6F0EAC55BE44D7330F71CC5058267A",
                                        "AutoV3": "6DC9CD1B779A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/69646",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 777471,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/469ab139-2838-4871-850d-4e689a79120a/width=450/777471.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 803,
                                    "height": 1204,
                                    "hash": "UTKBE;~CyDV[-;buOYa#%hNZIAafo}s:wdni",
                                    "type": "image"
                                },
                                {
                                    "id": 777472,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9268c941-dcca-492a-99a1-978d0ff47d1d/width=450/777472.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAHx?84p~Wx^FEIU9v-pA1S#Hr$%t+%2bqxu",
                                    "type": "image"
                                },
                                {
                                    "id": 777474,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6b695b44-331f-416f-803a-dfb07f4bae3d/width=450/777474.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJJ8hfH[xv?b.m9]x]xatSXlskIoyDwMMxWC",
                                    "type": "image"
                                },
                                {
                                    "id": 777477,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/92ee5584-05a5-48d1-a210-6e3d5ea77832/width=450/777477.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 893,
                                    "height": 1340,
                                    "hash": "UDIFJM00Kk_3Bpxuxb%1X:t7$fD*ysE1D%ou",
                                    "type": "image"
                                },
                                {
                                    "id": 777479,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ba5a7d2b-8208-4bf3-bd3c-6b1618512c9e/width=450/777479.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1664,
                                    "height": 1024,
                                    "hash": "U9Hx+{008{?uB.ix4T}]xdgMDNtlm+w{EKE1",
                                    "type": "image"
                                },
                                {
                                    "id": 777487,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f6f76c63-3982-4cc4-8f0d-99ed7d08fa56/width=450/777487.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1664,
                                    "height": 1024,
                                    "hash": "UIJu4RYP4.%f_N:-4nOTd[MxE1NZ%NM{9ZtR",
                                    "type": "image"
                                },
                                {
                                    "id": 777488,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1ba28bc5-7bd7-4a3c-a2b6-ef7568e389d5/width=450/777488.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1664,
                                    "height": 1024,
                                    "hash": "UJIYCE02o~~W.8$PIUrqOF9Zn3Ino|IoS}f5",
                                    "type": "image"
                                },
                                {
                                    "id": 777492,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f1e3748-6fa2-4d16-a625-7b5a80e4dc2e/width=450/777492.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1664,
                                    "height": 1024,
                                    "hash": "UPI=DYEjJC~CMy,HI:sAXSVsxZIVxZxatRRj",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/69646"
                        },
                        {
                            "id": 63730,
                            "name": "nawsjmajic_v1.1",
                            "index": 2,
                            "modelId": 53601,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>有朋友反馈模型过拟合的问题，因为我只训练了脸型所以我一直是用局部重绘的，不直出，并且这里提供一个训练步数较少的版本，权重依然在0.6-0.8之间最好用</p>",
                            "publishedAt": "2023-05-06T07:41:56.024",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 7753,
                                "ratingCount": 1156,
                                "rating": 5,
                                "thumbsUpCount": 1158,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 44855,
                                    "sizeKB": 18544.32421875,
                                    "name": "nwsjmajic-05.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-06T07:40:42.818Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "71FAFA91E1",
                                        "SHA256": "71FAFA91E10D1B961D82CC24127882BA9674511F6F67A10E61DA4D624304698A",
                                        "CRC32": "C9103754",
                                        "BLAKE3": "F66FFB052FC1D81ECC37B768BD96798D341BEC652337941FF3D481A4FBD4437C",
                                        "AutoV3": "B3CAF879B886"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/63730",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 703176,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/10be7471-32c7-43c9-ac7d-1f0739975a82/width=450/703176.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFF5{d~pTX^*00k7WVR%.A-pwcNHD%fmtRIU",
                                    "type": "image"
                                },
                                {
                                    "id": 703210,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f64a38fc-1262-4e36-b4f0-fff9fb899e8a/width=450/703210.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHEyA0~q?c%M^*x]RjR,k?x]-VNG?b-;-:%M",
                                    "type": "image"
                                },
                                {
                                    "id": 703212,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7169920f-56f5-4244-8230-193c50f4e01d/width=450/703212.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UNG[$kW9XT4.9Doc%MMx_NX9w]s;xYRjxbR.",
                                    "type": "image"
                                },
                                {
                                    "id": 703215,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d69a8e1c-49c1-48d0-bb59-64a6a38b8f08/width=450/703215.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFF5%60K_M^kZz-;E1-oTe8_adI[?bM{t7M{",
                                    "type": "image"
                                },
                                {
                                    "id": 703243,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0618157f-f5ae-4ce6-bf50-6f958735abc7/width=450/703243.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMC6=SxuxuR*_Nt7ozfl-;Rjofof.8aes.t7",
                                    "type": "image"
                                },
                                {
                                    "id": 703241,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9c62b223-e8c2-4838-a968-372a030f7036/width=450/703241.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UACP#8?v~qx[4nIU4p9Z$%D%%NM{%N%L?b?a",
                                    "type": "image"
                                },
                                {
                                    "id": 703242,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/11ef8f5f-711e-4406-b05a-2b984f7124d2/width=450/703242.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8Aw9wx^WZ~WwIS6tm?H9Z-:t7M{K4g3InEL",
                                    "type": "image"
                                },
                                {
                                    "id": 703244,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/43a78108-e311-4902-bc88-9705578bfb84/width=450/703244.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8B:pixtxt_29FIU9aNG-;4-V[x]?wITVsxu",
                                    "type": "image"
                                },
                                {
                                    "id": 722267,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/91b23c82-50f5-4a0c-a645-6dd289e30777/width=450/722267.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U9J%qZWU$x~pKk%M%2JBRQIonNX9^+rrITt8",
                                    "type": "image"
                                },
                                {
                                    "id": 722270,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e291729b-4367-4025-8f0e-4a272a4c839f/width=450/722270.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U9KwFMO?OD$*YRrXRi$L$dr;r;%0%NRlWGNH",
                                    "type": "image"
                                },
                                {
                                    "id": 722268,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7721bb27-e97e-41f5-b141-c96c59e52cc2/width=450/722268.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UBLM#B~ps%aL*0x]RijE%LXTkDV@?Fn$RjX8",
                                    "type": "image"
                                },
                                {
                                    "id": 722269,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2fa4252a-ba43-4fda-805d-a98082798e3a/width=450/722269.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U5J7dq0Lxk~C*0xF-oSL%2Di-;RPNIj]D%Rk",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/63730"
                        },
                        {
                            "id": 57952,
                            "name": "nwsjmajic_v1.0",
                            "index": 3,
                            "modelId": 53601,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 23,
                            "description": "<p>推荐权重0.6-0.8，推荐模型<strong>majicMIX realistic V4</strong></p>",
                            "publishedAt": "2023-04-29T08:05:42.961",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5388,
                                "ratingCount": 893,
                                "rating": 5,
                                "thumbsUpCount": 894,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 41265,
                                    "sizeKB": 18544.3251953125,
                                    "name": "nwsjmajic-10.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-29T08:00:49.511Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "2530739B33",
                                        "SHA256": "2530739B33F6D090B2066EC5935D229B296D4AB7516ED624D3E72078A0DA2E97",
                                        "CRC32": "9CBBAE96",
                                        "BLAKE3": "FB19EE77307B0398BF415CA3FC9CDE71B878664F8C169659B8F3DD4F5782D4FA",
                                        "AutoV3": "8D717648086F"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/57952",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 630137,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f3ec3384-431c-41bc-7644-7fae4011fc00/width=450/630137.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEFO=Z~p01s.000Kt7s:?vxu%1%LE1-;-;IV",
                                    "type": "image"
                                },
                                {
                                    "id": 630151,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0abb7009-2ee9-4a69-690e-aaaf32c33e00/width=450/630151.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGDvNA_N0ftR9u-;^+M|x^x]xas:x]kDRjs.",
                                    "type": "image"
                                },
                                {
                                    "id": 630157,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/75126eca-4b24-4ff8-cae1-e7392bdc4000/width=450/630157.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDG8yKRR565700f8?bR+_4R-?G%1tRM{IV?H",
                                    "type": "image"
                                },
                                {
                                    "id": 630163,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d15b575a-b3c4-4da0-1146-1356d7034900/width=450/630163.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEGl3M00tl~W?bVsxGIoWooMRPxu_4D%tQjY",
                                    "type": "image"
                                },
                                {
                                    "id": 630169,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71abce83-8c60-4e10-9aca-5196ba07b900/width=450/630169.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNK-IC_N?v?b-;o#xu%Mx]?Hx]oz%MSgn%%2",
                                    "type": "image"
                                },
                                {
                                    "id": 667316,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5ff3dcd8-9886-45f4-ab56-56f478dfade8/width=450/667316.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UUEB]NjuE2s:~Bs:E2WC%La{9aay-:WBM|oe",
                                    "type": "image"
                                },
                                {
                                    "id": 667314,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6ef5d939-f0f6-4715-a7dc-5924627469db/width=450/667314.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDB{onS202Rk^*t64:WBt7M|M|%K~UWC4:xa",
                                    "type": "image"
                                },
                                {
                                    "id": 667320,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/01a5f87f-7688-4f48-b69a-2d463ef49e55/width=450/667320.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHF5,8~p0K9F009G%L%MIpoMxujb4:Rji{s;",
                                    "type": "image"
                                },
                                {
                                    "id": 667313,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/685ea0eb-3106-4237-ac77-c93497d47585/width=450/667313.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCEoSr~o01so4.E1Rkofbb?axa9t9Z4oD%%1",
                                    "type": "image"
                                },
                                {
                                    "id": 667312,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7559d6b1-1454-4329-ad54-99325ca5901a/width=450/667312.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCFq%W.7%L~Ax[^%NH?G-5={^%xt0LRj-UoM",
                                    "type": "image"
                                },
                                {
                                    "id": 667321,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d73538b8-bd34-4c8c-91b2-b178bbf67ab4/width=450/667321.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFFF86-p01NF$c9aW??GxUIps;%1~VV[Rjt7",
                                    "type": "image"
                                },
                                {
                                    "id": 667318,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/189fca7a-9ab8-481e-8574-b00f7afdb4f3/width=450/667318.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEEo3?tR01D*Md9u-p={~Vbbi_WAtO%1ofIp",
                                    "type": "image"
                                },
                                {
                                    "id": 667323,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dbbcead4-b989-40db-946b-120679bf1720/width=450/667323.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UVH2At-:E2M|~payWqae%fRjt7xt_2xaE1WB",
                                    "type": "image"
                                },
                                {
                                    "id": 667311,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8bc1a264-6c84-4161-aaef-b22769cca26e/width=450/667311.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJC~@zof01Wq~Bay9Zj[IAazkCV@%LofbIaz",
                                    "type": "image"
                                },
                                {
                                    "id": 667322,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/abdf0ef7-33f5-4305-9870-d0dbc65f3ee8/width=450/667322.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBC~VY^*0gIU~AxaozkB9EM{j?%2^jxa9ZV@",
                                    "type": "image"
                                },
                                {
                                    "id": 667324,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80af3d2e-9902-4b42-b757-624331c8ad28/width=450/667324.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UkGb9jazx]t7~VoLtRof-ooLWBj@?Ha|Rkay",
                                    "type": "image"
                                },
                                {
                                    "id": 667315,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/25a3c8fa-478c-4f59-a46c-512e183da3fe/width=450/667315.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIE.%[~W019Z00D*%2t6-:n,xa%LD%R*xuRj",
                                    "type": "image"
                                },
                                {
                                    "id": 667317,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a134d42f-15ee-4286-9dad-46cd6967b665/width=450/667317.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULEy0t~VI:R*nhE1IUWB9GE1%2xu%MWUaf%1",
                                    "type": "image"
                                },
                                {
                                    "id": 667319,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b260cbe1-7703-48cc-a253-8eddbee952ea/width=450/667319.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFG[Zr0#Xl-:EM~q?bxt.S_2M|oeI.-;?GIU",
                                    "type": "image"
                                },
                                {
                                    "id": 670514,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/87cb119c-a1a0-4a3f-b576-8001aa09f4b5/width=450/670514.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKEVNT~VELIp?F%Lt7Rk4.IVspjZM|M|Ios:",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/57952"
                        }
                    ]
                },
                {
                    "id": 124347,
                    "name": "xl_more_art-full / xl_real / Enhancer",
                    "description": "<h3 id=\"heading-39\">All Sample image are made Base <strong>SDXL_1.0</strong> with<strong> Hi-res fix</strong> only - (<strong><span style=\"color:rgb(121, 80, 242)\">No refiner</span></strong>)</h3><p>This LoRas enhance/improve image to get more aesthetic<strong>/</strong>artistic/creative<strong>, </strong>detailled.</p><p></p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/124347?modelVersionId=152309\"><span style=\"color:rgb(64, 192, 87)\">xl_more_art-full_v1</span></a> this version is little more photorealistic than betas but you can also do anime/illustrations.</p><p>Weight 0.8-1 is recommended but you ca push more than 1 on less detailled render. ^^</p><p>This LoRa also contains a training for aerial photos (use \"Aerial\" keywords), more details here : <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/articles/2030/how-to-create-realistic-aerial-land-art\">https://civitai.com/articles/2030/how-to-create-realistic-aerial-land-art</a></p><p></p><h3 id=\"heading-16\"><strong><span style=\"color:rgb(190, 75, 219)\">Please help me :</span></strong></h3><h3 id=\"heading-2\"><span style=\"color:rgb(253, 126, 20)\">Add to your </span><strong><span style=\"color:rgb(230, 73, 128)\">collection </span></strong><span style=\"color:rgb(253, 126, 20)\">and </span><span style=\"color:rgb(230, 73, 128)\">share</span><span style=\"color:rgb(253, 126, 20)\"> your </span><span style=\"color:rgb(230, 73, 128)\">creations </span><span style=\"color:rgb(253, 126, 20)\">here !</span></h3><p></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": false,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 3,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 76908,
                        "favoriteCount": 0,
                        "thumbsUpCount": 6046,
                        "thumbsDownCount": 6,
                        "commentCount": 30,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 3110
                    },
                    "creator": {
                        "username": "ledadu",
                        "image": "https://lh3.googleusercontent.com/a/AEdFTp7Zm-q8sfTBuBzBa1nuk2b4pej55mgtap0L74NbtQ=s96-c"
                    },
                    "tags": [
                        "anime",
                        "animals",
                        "art",
                        "realism",
                        "detailed armor",
                        "style",
                        "illustration",
                        "detailed",
                        "photorealism",
                        "realistic",
                        "landscape",
                        "detail",
                        "enhancer",
                        "creative",
                        "detailed texture",
                        "detailer",
                        "3d character",
                        "refiner",
                        "photorealisic"
                    ],
                    "modelVersions": [
                        {
                            "id": 152309,
                            "name": "xl_more_art-full-v1",
                            "index": 0,
                            "modelId": 124347,
                            "baseModel": "SDXL 1.0",
                            "nsfwLevel": 3,
                            "description": "<p>The V1 is OUT !!</p><p>Incredible good !!!!</p>",
                            "publishedAt": "2023-08-31T06:54:44.399",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 66136,
                                "ratingCount": 1157,
                                "rating": 4.95,
                                "thumbsUpCount": 2560,
                                "thumbsDownCount": 6
                            },
                            "files": [
                                {
                                    "id": 113467,
                                    "sizeKB": 702168.71875,
                                    "name": "xl_more_art-full_v1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-28T02:00:49.305Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "C3149766",
                                        "AutoV2": "15E31FE2B6",
                                        "SHA256": "15E31FE2B6AE2E77EE47A3CCDF27BD14F7B54CE27C6A58502875FDAD26F34460",
                                        "CRC32": "1B3B9470",
                                        "BLAKE3": "3CA25696AB1B233B8DD613FAB04E9ED9026E50AE53D638191FD19BD538627EDF",
                                        "AutoV3": "09DFEDDA537C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/152309",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2287991,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/321764d7-8265-4050-bbcd-d6c0a5da556c/width=450/2287991.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "U9BNZDx^4T8|~nD-4WMyDPRjNz%e4Wx:yD.6",
                                    "type": "image"
                                },
                                {
                                    "id": 2443509,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/31bc873b-6fd5-4645-a72c-e61c3c91ae9f/width=450/2443509.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 4800,
                                    "height": 3709,
                                    "hash": "UDDvZk{c:j+uT_k=kWS#vLS%OYSOtT+G#7v}",
                                    "type": "image"
                                },
                                {
                                    "id": 2287990,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0dda8569-33b7-47cb-a405-eadfcc806bc2/width=450/2287990.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1376,
                                    "height": 1376,
                                    "hash": "UGE|h|-900BqM{TKXnicDOOF~9wb#5wHO@Fz",
                                    "type": "image"
                                },
                                {
                                    "id": 2287986,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/df8952e5-e439-4949-888f-f53f97245295/width=450/2287986.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "URIg}.%MyEV[~qRjRQV@={V@E1oJ^+xu%Nfk",
                                    "type": "image"
                                },
                                {
                                    "id": 2287988,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5ce8a631-8a5b-4543-996b-020fbf2c7f94/width=450/2287988.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U6AmrE}j001SyYt7n2Mx015B~A~84To~%$IT",
                                    "type": "image"
                                },
                                {
                                    "id": 2287981,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/58a1b7d0-151f-426b-b9ab-80eaa94115ee/width=450/2287981.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "U6DcN~0000M{00~Wt8xaXl+Z~CR-0f9w-VV?",
                                    "type": "image"
                                },
                                {
                                    "id": 2288027,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/480ef8ae-b55c-4933-9521-807f822464f6/width=450/2288027.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "UKHL0UEL15Iq00~qbbRkGI9F%0tR56kY-VR%",
                                    "type": "image"
                                },
                                {
                                    "id": 2287978,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d14dc7dd-ff0a-4f3c-bb29-1746378e2338/width=450/2287978.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UbG^OdyDuPRkl9S6M}t6o~nMM|bbXnahahoI",
                                    "type": "image"
                                },
                                {
                                    "id": 2288132,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5ed4b819-3d5e-4ae3-b983-e4f11f295a78/width=450/2288132.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U9B}Qv8~,8_H00bc4_Sc0N?SvoTJ?uE5v~D,",
                                    "type": "image"
                                },
                                {
                                    "id": 2287980,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a725027c-c05e-4628-abb2-72380158aaa6/width=450/2287980.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UDHT?0tQ03-S~Us:M|WC0gjZN_R+VsoJS#j]",
                                    "type": "image"
                                },
                                {
                                    "id": 2287985,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0c0e6a7a-b345-48ce-9375-b02009c1a484/width=450/2287985.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "UICs,Spd00=spexaeRI[NKRislW?_NWBDis8",
                                    "type": "image"
                                },
                                {
                                    "id": 2288131,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/878e7c24-30d7-4bbf-92a8-465b35394738/width=450/2288131.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U9F5dPmPVC_N00PCJ:IA.Sm*t-yE0NoLVtM{",
                                    "type": "image"
                                },
                                {
                                    "id": 2288025,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ff25f79e-4e72-44a2-b0b6-2c2b81a3e1f6/width=450/2288025.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "ULFh2[Ip^1%1~9V@$#OEM|bb9_jF#SX8EOni",
                                    "type": "image"
                                },
                                {
                                    "id": 2287987,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1b52062a-feed-4878-9381-56144282dbe3/width=450/2287987.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U6Cr.lIA00tR}?a09upJWB?G9GD*Na~Vw^D*",
                                    "type": "image"
                                },
                                {
                                    "id": 2288158,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c98849ca-5d76-477d-a047-0bbd0eee2a4e/width=450/2288158.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UkMHh@x@%i%2%fNJMys:%jNM$zxZN2oMe-xb",
                                    "type": "image"
                                },
                                {
                                    "id": 2288211,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04ec6e8d-8c75-4567-8713-3671adaff685/width=450/2288211.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UAGS130200~VOas;$xRPx]az^jM|4;ax-:oz",
                                    "type": "image"
                                },
                                {
                                    "id": 2288216,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3ae39b45-b986-4967-8346-d95b3f1b8910/width=450/2288216.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UVHoUh?H$yt7h2ogS$t7kXxtRjRk%MofV@oe",
                                    "type": "image"
                                },
                                {
                                    "id": 2288303,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/568f1c24-b72e-4b94-9fb3-646e5cbcfddc/width=450/2288303.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "ULKnh^u59$-4yG$~xvN|KPnMIUaeT04oelaK",
                                    "type": "image"
                                },
                                {
                                    "id": 2288301,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a2ecadb7-7206-44e8-9875-2b4c94df36d6/width=450/2288301.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "ULHp6Kt7P;bxCmW=mkxZGanhQ,NHPBoI%gW=",
                                    "type": "image"
                                },
                                {
                                    "id": 2296412,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7689207a-7a45-4d56-82c5-c12fb103b11a/width=450/2296412.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "ULGbYU^+4oWB~q?HRkS5%1xtt6t7WYxuIUof",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/152309"
                        },
                        {
                            "id": 169002,
                            "name": "fractal-art.v1",
                            "index": 1,
                            "modelId": 124347,
                            "baseModel": "SDXL 1.0",
                            "nsfwLevel": 3,
                            "description": "<p>This is version of xl_more_art-full_v1 with finetuned image of Natural fractal</p><p>This model is a little too reactive to certain words like fractal, flower, leaf, tree...</p><p>It tends to flatten the images.</p><p>Reactive words :</p><p>intricate flower wallpaper leaves arafed inspired plant leaf beautiful vibrant skin water flowers pattern veins fractal carline coral spiral macro trees inside palm forest art fractals organic composition droplets lit microscopic symmetrical eye carapic abstract colorful structure fibonacci angle liquid tree covered eyes hyperdetailed symmetry glass bubbles wavy lush explosion energy kolkoutine dome marble grain” broccoli reptile sun ice circle fantasy symmetric river corals atmospheric crown cosmic beeple teal bird staircase deep jan growing space cone metal feathers hurufiyya buds degrees sand jungle ancient tropical wings maze-like winning canvas calatrava grass volumetric waves branches lot salvia cactus neon spines pine lotus iris arbor powerful shell hole cracked floating fern lava fluid frozen bone aster sunlight ocean rosette curvaceous natural honeycomb portal dress circular atmospheric” crystal muted rays post-processing fungus simulacrum bleda petals intricacy various swirl bubble splashes spider hexagonal leather structures cacti extraterrestial brock podedworna farm destiny web ruffles weavers snake effect sunny vnuk drain terracotta hofer spike molecular gloomy brain feather grid jewels horns mathematical shape ivory tesselation coxcomb patterned symmetrically hasselblad oil wood sunrise ink desert worm frill munford curve stalagtites stone sunflower twisting spiralling carnival galactic pineapples angled redwood shore multidimensional scruffy star juice crater overlayed leafy shishk alien oni dragon vine eggs flocks kidney hexagons reef ecosystem horne octan krasovskiy jaegwan sprouts tundra quarter fossilized three spirals cast particles carvings clouds fawcett ribcage heim coin radial gelon curvatures anemones vault line profile furry hastur interlocking caspar blocking seashell painted pretty peppermint motif flora-lush-crater biomechanical cathedral tcolor behance whie brushed candy worms minn velleneuve loosely jewelry meadows adobe gothic carnation shattered quaint snow crypto soap lights krūmiņš mustard abstractions wisconsin hug kavisky lettuce lake mandelbrot cascade sponge hillside hemlocks baer heart slabs botanical pearls twilight seeds dandelion skeleton carapace lavander antennae amazon rainforest glowing resembling stars rust needles kiwi rock</p>",
                            "publishedAt": "2023-09-24T22:24:25.706",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 2634,
                                "ratingCount": 1711,
                                "rating": 5,
                                "thumbsUpCount": 3521,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 128375,
                                    "sizeKB": 192465.4609375,
                                    "name": "fractal-art.v1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-28T02:00:48.196Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "7A3C6BA1",
                                        "AutoV2": "69DEF87817",
                                        "SHA256": "69DEF87817769C6E89AFB75F0D14A7771DA29D9F94E8AC43895FF01BE23C79E2",
                                        "CRC32": "2CF463A9",
                                        "BLAKE3": "4957C9A7BC3CE19677149793B578E858AB7CFEDB6AF4D99658BAF62481FCA9A0",
                                        "AutoV3": "05CF0518BAD0"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/169002",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2655409,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/db0cdfab-6f72-4de2-8ace-c8d041ab048a/width=450/2655409.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U78EhzRPIRMh~pR59HRWQ,nNEANLx-xt%eM{",
                                    "type": "image"
                                },
                                {
                                    "id": 2655406,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9de90fd7-07ae-4326-a3c2-7d3f5bd86e8b/width=450/2655406.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "U9BD$S8{00?u_Lx[4VWEM_xbM#Dj$+t6D+s.",
                                    "type": "image"
                                },
                                {
                                    "id": 2655349,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9a175d03-583f-451c-a0fa-af70440b1ee2/width=450/2655349.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UCJjk-?a$}%g={-:^%9F$}9awbZ~~9jEI[S5",
                                    "type": "image"
                                },
                                {
                                    "id": 2655330,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0a472b2e-ab24-4a82-978c-443c0e76db15/width=450/2655330.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U7CGPiO]0000~X?u4n8_00n,?G%L9D4o?c_3",
                                    "type": "image"
                                },
                                {
                                    "id": 2655379,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a6444833-2b79-46ba-97d8-0bbef3449749/width=450/2655379.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UBEVx@0MIV%2.4V_Ef%1lHt7R*s+~nNFoexs",
                                    "type": "image"
                                },
                                {
                                    "id": 2655325,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ba320a22-8e87-4636-ab7a-4e0fabbd4223/width=450/2655325.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UJ9RwQRk02t5GKox$KRjO[afxWnh%gaeM|jF",
                                    "type": "image"
                                },
                                {
                                    "id": 2655369,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bbcc15d3-30ea-4f3e-869a-bca513930bde/width=450/2655369.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U59tGdQ}Mla]X,Riw@E2#9V}v~J8}g9drY^w",
                                    "type": "image"
                                },
                                {
                                    "id": 2655398,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/86c09ae3-02d1-43f3-a0a2-58f2f21d0a14/width=450/2655398.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U7C~q:0-0g%MTKs7Rkxu0$ox~BS%x]xtiws+",
                                    "type": "image"
                                },
                                {
                                    "id": 2655314,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9c0606f4-5be1-4a7d-a07b-0b75fd7cc485/width=450/2655314.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UEAm#,55w?NG?dM_Mws,DgW8M{%NMwNG%MbI",
                                    "type": "image"
                                },
                                {
                                    "id": 2655346,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/215a162f-c8c2-4e09-83ab-e3b4ff9f2152/width=450/2655346.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UBC?r]xu%MM{M{j[j[t7M{ofD%Rj~qRjWBj[",
                                    "type": "image"
                                },
                                {
                                    "id": 2655370,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dac2d0c4-c50d-4450-82eb-bf747dad0e69/width=450/2655370.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UBELEW0#yr~WpxXoEl~VTcXAWF-p^4D$^kRk",
                                    "type": "image"
                                },
                                {
                                    "id": 2655241,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0eb66e20-e4e2-4298-b3d7-401e553edf19/width=450/2655241.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UVIE^Vj[4nRj~qofD%azM{ayRjj[M|ayIoWB",
                                    "type": "image"
                                },
                                {
                                    "id": 2655343,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4377b229-d73a-4794-b8c0-e5ec2e0fe25d/width=450/2655343.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UAA^s_01DP_M.RMyrWoy9u-pMfDj.6x[4p-.",
                                    "type": "image"
                                },
                                {
                                    "id": 2655710,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/89a2e787-bad0-40e3-97b0-432dd63c9032/width=450/2655710.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U27-c?,I00bw:?xF5NE1IWt:I,M^Int9$-xZ",
                                    "type": "image"
                                },
                                {
                                    "id": 2654942,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/47ecd57d-ff11-4030-b06d-8be32de4046b/width=450/2654942.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U6D0Gn_34n9F-;t7D%9F~qRjM{IUt7WBt7M{",
                                    "type": "image"
                                },
                                {
                                    "id": 2655312,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dd86e9b6-8794-4535-a615-e2a5d11d5f19/width=450/2655312.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UPJjFp4=};%1?b-5-PxZ?GxVE3WYS%WBEMs:",
                                    "type": "image"
                                },
                                {
                                    "id": 2655501,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e1927ffb-814e-426e-ab3f-857eefd6d74b/width=450/2655501.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UJDJVIDOGGr=~XZ$E*smt-n4EMafp{ivNaWE",
                                    "type": "image"
                                },
                                {
                                    "id": 2655543,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/46c4d5bf-e324-4e6a-a9ee-a61544678f57/width=450/2655543.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UF7VJ.o}H=WAt-kCf%a{Hqay*0ozMwf7X9bH",
                                    "type": "image"
                                },
                                {
                                    "id": 2655592,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8b3123d9-1a64-4e2f-b544-4db9e15157b0/width=450/2655592.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UXJG[:j[_3t6$ifRWCay_Mj[w^kBTJj@xZa|",
                                    "type": "image"
                                },
                                {
                                    "id": 2655712,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9a423c91-6ef2-4562-846a-3ac90ae19200/width=450/2655712.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U7AL9Goy00kX_3WE8wV@00jY=vVsI;jYysoz",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/169002"
                        },
                        {
                            "id": 148870,
                            "name": "xl_more_art-full-beta2",
                            "index": 2,
                            "modelId": 124347,
                            "baseModel": "SDXL 1.0",
                            "nsfwLevel": 3,
                            "description": "<p>New version (more accurate, more textures)</p><p>Work good on anime/illustration/character/paint and also Photorealism</p><p>Adjusted weight =&gt; 0.7-1.0 are good value</p><p>I trained <strong>aerial</strong> photo and merge in the beta1</p>",
                            "publishedAt": "2023-08-26T17:29:56.102",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3544,
                                "ratingCount": 64,
                                "rating": 5,
                                "thumbsUpCount": 94,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 110498,
                                    "sizeKB": 702168.0078125,
                                    "name": "xl_more_art-full-beta2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-28T02:00:48.434Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "F8B1A14D",
                                        "AutoV2": "D8B578170E",
                                        "SHA256": "D8B578170E18136226B45E4DEA8CD1C7C4D25474BBDA72F8FB6D5ABEDD8D44F1",
                                        "CRC32": "9D85D96C",
                                        "BLAKE3": "A3830979F6DAE1C3FC0CB89FB15E403E4D8F6E625DBA43F776ED6FAF7D9D1ADC",
                                        "AutoV3": "B73ADDA671BF"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/148870",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2283115,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8c1e8e27-0099-4913-b86f-05d9579d8189/width=450/2283115.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "ULIqy3ROyExF_NnOM{V@?HaKM{kC.8Rj-;xa",
                                    "type": "image"
                                },
                                {
                                    "id": 2214647,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a1d115a3-a420-4a27-a197-d17c72222ca0/width=450/2214647.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UoNwM$kDx{xu%La#IUj].Ajrs*WDt7jrWAt6",
                                    "type": "image"
                                },
                                {
                                    "id": 2214575,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/afc8cb26-9b8a-490b-a851-752c1f782ba2/width=450/2214575.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U7B55m-6-%_F4mFxNPb]4}?mD5DSnLIbWGM#",
                                    "type": "image"
                                },
                                {
                                    "id": 2214863,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/87e93d62-2df4-45ad-8970-6b6b1537b293/width=450/2214863.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UbGRSF?Hs,s.~V-:bHj[%1%2t7R*E2s:xaWB",
                                    "type": "image"
                                },
                                {
                                    "id": 2214592,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a6e8d583-b441-472a-808f-fdb20b4a495e/width=450/2214592.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "U3BWY[%h00I=yYo~4TR5D}IUvf-o_3n34Tb_",
                                    "type": "image"
                                },
                                {
                                    "id": 2215748,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e992622-5381-4a78-a28f-0b2fb815096a/width=450/2215748.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U5G*c%-;_O$z%0S5t.%1%Nxu9^Ne?GkW9Zxu",
                                    "type": "image"
                                },
                                {
                                    "id": 2214583,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d7dc0ec7-cf3b-4246-bfbe-2bcfd0a68ed0/width=450/2214583.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UDG*D~?woyE214odoys.9axso~xus79a$Lay",
                                    "type": "image"
                                },
                                {
                                    "id": 2214643,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3729da8a-2cd7-4205-aefb-9a384466a487/width=450/2214643.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UJLqkR_MOu^i?Ix^kX^%AEoZITTLGcE2WCR*",
                                    "type": "image"
                                },
                                {
                                    "id": 2214580,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e59cf3cb-282f-41bb-a2c3-910c6649b988/width=450/2214580.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U.OzGJjs_Nxu%NofV@azt8j[aej?RiWBogaz",
                                    "type": "image"
                                },
                                {
                                    "id": 2214637,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f538aa76-6e1b-4920-96ea-9209a4b60ce7/width=450/2214637.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U9FP4.0200~V%hkDngRkxuof?GIVIqkC?af,",
                                    "type": "image"
                                },
                                {
                                    "id": 2214645,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/691bce08-34a9-460e-a44c-4856498c56fd/width=450/2214645.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UYGu{*NIJUxs}_X8OYn%?IRlM|j[=JNKjcRl",
                                    "type": "image"
                                },
                                {
                                    "id": 2214653,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eaca0e09-8f55-4025-8d78-f46c9a61a1ea/width=450/2214653.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UWDTIupdx[-:*Jk?I;o}lno~i_X9l9X7V?bb",
                                    "type": "image"
                                },
                                {
                                    "id": 2214630,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/72de0172-21a3-4a6f-a2b9-b78f76f3e0df/width=450/2214630.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1376,
                                    "height": 1376,
                                    "hash": "UCEEGWIr1j?a-aWT00s;StRliHt60.%0rWWD",
                                    "type": "image"
                                },
                                {
                                    "id": 2214633,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b7bf41d2-f413-4611-931f-2b703f3e373d/width=450/2214633.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1376,
                                    "height": 1376,
                                    "hash": "U5E4ickq00?w@xNG00nim*Rkn2w]0P%2;2Na",
                                    "type": "image"
                                },
                                {
                                    "id": 2215007,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/197a532d-740b-485b-a376-e2b4365c9a52/width=450/2215007.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UfLEH2M}_3%1~q%1%2t7^+RkRjs:IpWBWBa#",
                                    "type": "image"
                                },
                                {
                                    "id": 2215126,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8b377552-3a13-4363-af02-8b6f872ba937/width=450/2215126.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "U8C$K8-=0#66,0[o9Y0}Emw0AWjpmlBW}?^J",
                                    "type": "image"
                                },
                                {
                                    "id": 2214594,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/77e45f4f-0f40-4a97-b084-0c6a83a34e20/width=450/2214594.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UhIhc]s:E1ax_MozE2WUWBoMM{WBaxWXV@jF",
                                    "type": "image"
                                },
                                {
                                    "id": 2220057,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bfa1b2d8-3ed0-4466-b48b-96515c8fb759/width=450/2220057.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "U8AweRY58wMJ~oD;4pa0H@RPJpx@8{t2tm-:",
                                    "type": "image"
                                },
                                {
                                    "id": 2220656,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f91dab5f-f376-4258-bb9b-c8bff74279e7/width=450/2220656.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "U8EoA3%#iuZg_Nwu%1X9PB58^iX8t8D*%ME3",
                                    "type": "image"
                                },
                                {
                                    "id": 2220787,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/43cba313-b81c-43f3-8ec7-cd25530a88b6/width=450/2220787.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "USL3lLOZ.Sja~8NxE2NdIAEhD+S4x]bv-oSO",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/148870"
                        },
                        {
                            "id": 141133,
                            "name": "xl_real_beta1",
                            "index": 3,
                            "modelId": 124347,
                            "baseModel": "SDXL 1.0",
                            "nsfwLevel": 1,
                            "description": "<p>Get images more photorealistic, add details</p><p>This Lora make images more <strong>creative, aesthetic, detailled</strong>.</p><ul><li><p>weight 0.7 is a good value for cfg scale &gt;= 7</p></li><li><p>weight 0.8-1.0 are a good values for cfg scale 5.5-7.0</p></li><li><p>weight 0.1-0.3 is a good value for small changes</p></li><li><p>Trained with 9 epochs on 6k steps</p></li></ul><p>I use realistic images to train this lora</p>",
                            "publishedAt": "2023-08-15T10:01:26.012",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3565,
                                "ratingCount": 87,
                                "rating": 5,
                                "thumbsUpCount": 129,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 103697,
                                    "sizeKB": 702172.875,
                                    "name": "xl_real_beta1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-28T02:00:48.017Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "AB0FB1E7",
                                        "AutoV2": "13AB89CBD8",
                                        "SHA256": "13AB89CBD83EA5D4164AC9673042B95A609C7AF51EAB2E34F227396511927B64",
                                        "CRC32": "1AC3EBA6",
                                        "BLAKE3": "00D3AD7A15557CD1E27F20B0E7119A9CCAFBEDA30688C412B44EAF63351CB77E",
                                        "AutoV3": "50E8FA8FF75C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/141133",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2090138,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e08c78e-2c85-4fc2-a2c2-ac43d2a4cb5b/width=450/2090138.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "UdLg95t6~VayOGWBNGWBo}RkIVofNIt6WCWB",
                                    "type": "image"
                                },
                                {
                                    "id": 2087702,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4af621fc-4f04-4247-bbc0-9379847cd7e6/width=450/2087702.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "U5FF4*}?0K-q5z$k^l^Q0{kq^7ROo~-V+u0y",
                                    "type": "image"
                                },
                                {
                                    "id": 2039930,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a89087b6-54ce-47c8-b99c-c9c294f79351/width=450/2039930.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U67,_V9^0M~B-ToI57xZn$aKV@M{ShtR%2Sh",
                                    "type": "image"
                                },
                                {
                                    "id": 2039913,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d6f2d5b4-a098-498f-87dd-f5b0b0637f41/width=450/2039913.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U87Uq,?Z?uWG_M%M.8t8x]kE%NxuRntR%Lxt",
                                    "type": "image"
                                },
                                {
                                    "id": 2040524,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ca176749-91f1-4b22-850a-c31a9cbbde50/width=450/2040524.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 12672,
                                    "height": 1721,
                                    "hash": "UfD9hvofj[of~qj[aykC_3j[f6fk_3j[fQj[",
                                    "type": "image"
                                },
                                {
                                    "id": 2039909,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7a3ada6a-58f1-45cf-a2ea-11b2b9dad60a/width=450/2039909.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 12672,
                                    "height": 1721,
                                    "hash": "UhC%HYocazj[~qoLazj[_3oejtj[_3offij]",
                                    "type": "image"
                                },
                                {
                                    "id": 2041455,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f09b5411-100c-4337-8447-1b71d0834924/width=450/2041455.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "U9En@*4oOUIoAhEKxZf600^*M}xa}=aifPWC",
                                    "type": "image"
                                },
                                {
                                    "id": 2041411,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/313a3fa9-9e71-4af1-96ff-81b4aac27c68/width=450/2041411.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "UCE_q2My0eI;JaE0oeNH4m$|IqbF}@xa9Zxt",
                                    "type": "image"
                                },
                                {
                                    "id": 2040110,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/20a6acc4-3a6d-4e1b-aa1e-e42bb3eb5e0c/width=450/2040110.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UEAmr34:4;^P_MMxIVtRT0nirrOYxuR+nOsA",
                                    "type": "image"
                                },
                                {
                                    "id": 2040155,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/44c1c5c4-491e-4975-bdfb-e51431b23fb5/width=450/2040155.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 12672,
                                    "height": 1721,
                                    "hash": "UxG+Et%Laeay~pt6WBj[-=WBWVkC?baya|fR",
                                    "type": "image"
                                },
                                {
                                    "id": 2047688,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4bfb0759-cbdd-4761-bf9c-477c1de2773d/width=450/2047688.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UBEe[I~V000L4;D+kB-p4osC~W-pInSKxuM{",
                                    "type": "image"
                                },
                                {
                                    "id": 2048149,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e581108-571c-4950-875d-54003fcff935/width=450/2048149.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UBEe[I~V000L4;D+kB-p4osC~W-pInSKxuM{",
                                    "type": "image"
                                },
                                {
                                    "id": 2048209,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/17740386-7b6e-4f4d-bd89-ec90cbadee07/width=450/2048209.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "ULBgJGof-:IV?wbHxtNGXARkoeRj9GWCM{WB",
                                    "type": "image"
                                },
                                {
                                    "id": 2048548,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c220b44a-47a2-48eb-ae10-d980e5a0025e/width=450/2048548.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "UFB3$vt5_4bJp0s8%MjaD*ofD*s,Irx]M|oz",
                                    "type": "image"
                                },
                                {
                                    "id": 2048724,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6ee4e702-aa68-47ec-ad8c-39b4840d4795/width=450/2048724.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "U8BM[FxvE18^_NxY%L00-lDix]tR?GDi_3W=",
                                    "type": "image"
                                },
                                {
                                    "id": 2048795,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b8aafb8d-600c-4de7-b5d8-72f5e6bc7a26/width=450/2048795.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "UBE2Oa0~-p={9aJ.?br=E2oJ0#s:}@RjEO$%",
                                    "type": "image"
                                },
                                {
                                    "id": 2048862,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e611de3a-95e9-4d89-bc66-b4d4f5256cdf/width=450/2048862.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UOBz8@Mx%2R-~WM{xZR-t6RjoIWXJBNGNGoe",
                                    "type": "image"
                                },
                                {
                                    "id": 2054437,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3ccfbe1a-9da2-4887-8821-0030f50a743e/width=450/2054437.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1344,
                                    "height": 1344,
                                    "hash": "UEEV7zR*02bt~UWUD*t70#s:-mR*9uWB?GV[",
                                    "type": "image"
                                },
                                {
                                    "id": 2054344,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c46fe48b-a0e9-4a5b-a518-7dd15f5cc31f/width=450/2054344.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UBB|D#oy02oe?FkBR*of02ay}@oe5QjbxGR*",
                                    "type": "image"
                                },
                                {
                                    "id": 2054472,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e6f4b7e5-7b03-49b0-99a1-4ad7ee87c7a2/width=450/2054472.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1344,
                                    "height": 1344,
                                    "hash": "UGFF7|~W?H-:-UWUIVxt^jxuNaIo^*%Mxunj",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/141133"
                        },
                        {
                            "id": 135755,
                            "name": "xl_more_art-full-beta1",
                            "index": 4,
                            "modelId": 124347,
                            "baseModel": "SDXL 1.0",
                            "nsfwLevel": 3,
                            "description": "<p>This Lora make images more <strong>creative, aesthetic, detailled</strong>.</p><ul><li><p>weight 0.7 is a good value for cfg scale &gt;= 7</p></li><li><p>weight 0.8-1.0 are a good values for cfg scale 5.5-7.0</p></li><li><p>weight 0.1-0.3 is a good value for small changes</p></li></ul><p>Trained with 8 epochs on 14k steps</p><p>Artistic image are used to train this lora</p>",
                            "publishedAt": "2023-08-09T01:29:18.338",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1029,
                                "ratingCount": 55,
                                "rating": 5,
                                "thumbsUpCount": 81,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 100086,
                                    "sizeKB": 702172.734375,
                                    "name": "xl_more_art-full-beta1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-28T02:00:48.760Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "6347B7A1",
                                        "AutoV2": "1334B6962C",
                                        "SHA256": "1334B6962C870C013FFD447F635599C31A885032797E8E053EB6CAEDAAF56DCB",
                                        "CRC32": "545BC480",
                                        "BLAKE3": "E6DAB1EA91927FF30DC3B9CB170813759C1DCCD60741E8741F680A4B6F9EE8F3",
                                        "AutoV3": "DC1E16ED65A7"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/135755",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1949598,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1f1de96-58d6-4fce-8d32-e86c4fe8856a/width=450/1949598.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2400,
                                    "height": 1823,
                                    "hash": "UKFscC?b%%n3#unUR4WFHXZ~xBM|;J-AbKNH",
                                    "type": "image"
                                },
                                {
                                    "id": 1937269,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ecb5e6ad-1698-4183-8285-d5c3df80f45b/width=450/1937269.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UHD9IzR5%L-o~Voet5t70gt7RjRkE4jaMyt7",
                                    "type": "image"
                                },
                                {
                                    "id": 1949459,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5357e664-1bd5-41b0-b0cf-00eb77ff02cb/width=450/1949459.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2496,
                                    "height": 1865,
                                    "hash": "U9CiEiv#NIIV}sr=xF-U01-U$%-ow0xZWCNG",
                                    "type": "image"
                                },
                                {
                                    "id": 1971850,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1b2be050-1227-4fd7-9ca6-c894e4fde03d/width=450/1971850.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UQFh-SxvE2Rj~p%MI=WX%Ls:xuS5Ris,NGog",
                                    "type": "image"
                                },
                                {
                                    "id": 1949463,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f0daf1c2-5fc2-4084-b16a-07f3dacbb7b5/width=450/1949463.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2496,
                                    "height": 1865,
                                    "hash": "UFF#?s?bMxRP~Br=RPIUMIaKxunh4Ti{oznh",
                                    "type": "image"
                                },
                                {
                                    "id": 1937309,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7b173d75-f69e-4c67-b308-3be8facb31eb/width=450/1937309.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UgFsSgM}NL%1%%M}ozt6pJe.M{niSxWBnhRQ",
                                    "type": "image"
                                },
                                {
                                    "id": 1949458,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/99bbb940-9c41-4a3a-9101-01b1b825c22d/width=450/1949458.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2496,
                                    "height": 1865,
                                    "hash": "UNE:bpkqjXi^-@r@slRjIBjYV@slHqr?jvWB",
                                    "type": "image"
                                },
                                {
                                    "id": 1937437,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/10659fc8-b1c1-4e0f-aca8-a4c4bc6f394b/width=450/1937437.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UaF~EqO[cZ-p.TxvOrozTzaLNINHO[a0jFRj",
                                    "type": "image"
                                },
                                {
                                    "id": 1949468,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/337cf7d2-74b1-4b2b-9a24-b6169a60162c/width=450/1949468.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3600,
                                    "height": 3709,
                                    "hash": "UBF5v^I^VrJWcuV[n4t7HqVrRkn+_NS#r?bc",
                                    "type": "image"
                                },
                                {
                                    "id": 1937277,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cc390dbe-3219-43d6-8672-4cc3ac5f4e96/width=450/1937277.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1536,
                                    "hash": "UeI=0sWCEKni~payEMoykDbaIVX8r=flV@a#",
                                    "type": "image"
                                },
                                {
                                    "id": 1949456,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/676668f2-2def-4bfb-8112-d815e8ffadc9/width=450/1949456.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2496,
                                    "height": 1865,
                                    "hash": "ULIEOg#VIoX8~CnNV@s:4UaKsBxtH?t8t6WB",
                                    "type": "image"
                                },
                                {
                                    "id": 1969478,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d78ed30a-af47-43b5-aead-6fc7021695c7/width=450/1969478.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1536,
                                    "height": 1152,
                                    "hash": "UCByjat600%gSutlkYM{JBxu={Vt~qt7D%t7",
                                    "type": "image"
                                },
                                {
                                    "id": 1949460,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bf0cf99e-3405-42b8-baca-a13439dfb630/width=450/1949460.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3600,
                                    "height": 1856,
                                    "hash": "U9A1FrjKo#Rn:j-AS2of}V$iRjjFy@%2R.oz",
                                    "type": "image"
                                },
                                {
                                    "id": 1949454,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3647422d-a45d-47e7-a966-1082f77298e2/width=450/1949454.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 3600,
                                    "height": 1865,
                                    "hash": "UHH1ux-;9aE28xMy$%$$4Tog=^xC}:WCennj",
                                    "type": "image"
                                },
                                {
                                    "id": 1949462,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0438040d-3be1-4b94-9547-5e98952e1bf8/width=450/1949462.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3600,
                                    "height": 1856,
                                    "hash": "UEF5y{s=$zMx~CxaR*WC^QxHWBogD4wcSit7",
                                    "type": "image"
                                },
                                {
                                    "id": 1949457,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/21e4c798-d5a1-4ed9-9d13-9749b8a5eb7a/width=450/1949457.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2496,
                                    "height": 1865,
                                    "hash": "UCFrhe~X4p4.vf%1xEV@VE%1xXi_H?Rjt8of",
                                    "type": "image"
                                },
                                {
                                    "id": 1949467,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6ebde98e-a922-4120-a09d-78984ad3ad3c/width=450/1949467.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3200,
                                    "height": 1473,
                                    "hash": "UFFYu^~qIUxGDNIToe$*4TM|t8V@rqt7ays9",
                                    "type": "image"
                                },
                                {
                                    "id": 1967126,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c8d4c944-68cd-405e-9dcb-5a533db146e7/width=450/1967126.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3600,
                                    "height": 3709,
                                    "hash": "U6E2]}.QNHI9.SKN-pV@}IEMV[xa.9x^w^M{",
                                    "type": "image"
                                },
                                {
                                    "id": 1949758,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d2cf8525-04ee-4b65-9dd2-eafe5e7dfc49/width=450/1949758.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2496,
                                    "height": 1865,
                                    "hash": "UFF#?s?bMxRP~Br=RPIUMIaKxunh4Ti{oznh",
                                    "type": "image"
                                },
                                {
                                    "id": 1949769,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b8aa7a96-222b-4405-b5fc-de062bf5c8c8/width=450/1949769.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2400,
                                    "height": 1823,
                                    "hash": "UKFscC?b%%n3#unUR4WFHXZ~xBM|;J-AbKNH",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/135755"
                        }
                    ]
                },
                {
                    "id": 54233,
                    "name": "GHIBLI_Background",
                    "description": "<p><strong>（（Please download the </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/4468?modelVersionId=7425\"><strong><em>counterfeitv2.5</em></strong></a><strong> model and </strong><a rel=\"ugc\" href=\"https://civitai.com/models/22354\"><strong>clearVAE</strong></a><strong> before using it ）） ！！！</strong></p><p><strong><em>If you are interested in the field of AIGC design, please join my channel to discuss it</em></strong></p><p><strong><em>Discord</em></strong><a target=\"_blank\" rel=\"ugc\" href=\"https://discord.gg/rX3UwAkQN2\"><strong><em>https://discord.gg/rX3UwAkQN2</em></strong></a></p><p><strong><em>QQ群607134175</em></strong></p><p><strong>The site preview image will compress the image quality, please double-click to view the original HD image</strong></p><p><strong>The beautiful Ghibli scene has a powerful expression for both architecture and landscape</strong></p><p><strong>v5.0 update</strong></p><p><strong>Updated more training sample set parameters, wider generalization, optimize the performance of the built environment，this is the <em><u>best Ghibli style</u></em> model you have ever used, beautiful watercolor style</strong></p><p><strong>if you like my model, please pay attention or give feedback below, I will continue to update</strong></p><p><strong><em><u>The model prohibits commercial use, handling, and any blending, and the author retains ownership of the model</u></em></strong></p><p>该模型禁止商用，搬运，以及任何融合行为，作者保留模型所有权</p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [],
                    "allowDerivatives": false,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 48525,
                        "favoriteCount": 0,
                        "thumbsUpCount": 5997,
                        "thumbsDownCount": 0,
                        "commentCount": 31,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 501
                    },
                    "creator": {
                        "username": "Mccc",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5ad1c575-f329-45f4-be51-4cff071e584a/width=96/Mccc.jpeg"
                    },
                    "tags": [
                        "ghibli",
                        "scenery",
                        "background"
                    ],
                    "modelVersions": [
                        {
                            "id": 125985,
                            "name": "END",
                            "index": 0,
                            "modelId": 54233,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-07-26T01:22:16.029",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 21186,
                                "ratingCount": 1032,
                                "rating": 5,
                                "thumbsUpCount": 2235,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 91019,
                                    "sizeKB": 147567.8203125,
                                    "name": "Ghibli_v6.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-26T01:25:42.374Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "C5E99DBF",
                                        "AutoV2": "58549CC3D3",
                                        "SHA256": "58549CC3D34F8AD1092120BFF02A8C66B374A9AC31EB2C30B247C8C72F11B019",
                                        "CRC32": "2C010167",
                                        "BLAKE3": "666F60E52DF125836FF298D004A54EED5845FBA5FCD4F9D7D386632D2D216F05",
                                        "AutoV3": "A2031B1564BA"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/125985",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1724526,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b6c570a7-86fb-4b77-9837-922f52750c0b/width=450/1724526.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UDALmr%E$fofUW8~aQIC*FWAyAIUxcMMxuoJ",
                                    "type": "video"
                                },
                                {
                                    "id": 1724528,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b6bffd36-c56c-4b06-86a1-30f7b3247063/width=450/1724528.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "U769mutODTRnSvoLt5Rk.hoeMzbHN2RRtQth",
                                    "type": "image"
                                },
                                {
                                    "id": 1724531,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/66bb8c45-529c-412c-8849-10ca01f67bd9/width=450/1724531.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UAA0@7EJvdF{%jnjohS1AW$lTLwzO=t7Sx$,",
                                    "type": "image"
                                },
                                {
                                    "id": 1724532,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ea4b530a-ab61-485f-b99d-00315661b899/width=450/1724532.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UMDcje4VR*Ip%$rpNKR*?wsPNIIWObs7t7M|",
                                    "type": "image"
                                },
                                {
                                    "id": 1724530,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2620f87a-45b6-4f7e-bce4-f4d6cf8d5616/width=450/1724530.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UOGvhn_NV@EQKlIVjER+x^RiMxxu%NjFRPt7",
                                    "type": "image"
                                },
                                {
                                    "id": 1724529,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4f2ea7c3-a9ea-48af-ae2a-c885d5dcb80e/width=450/1724529.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UeEp4UNdNdf5~EI[Nej?^+S5W=ay.7a$j]a|",
                                    "type": "image"
                                },
                                {
                                    "id": 1724536,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4e89d084-1b57-4515-aaec-328443811b98/width=450/1724536.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UYFjKVn3U]x]2|NFs8jYY7oztlV?R6s;XTRk",
                                    "type": "image"
                                },
                                {
                                    "id": 1724535,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/540af8c3-fdbc-438a-b961-4e99ddcee46c/width=450/1724535.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "U83^8do%H;XAIeWBxtt9VnaIkEoz.AngMwRi",
                                    "type": "image"
                                },
                                {
                                    "id": 1724533,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/70c253a2-d435-4f01-bbee-f65d1d3e0747/width=450/1724533.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UDALpy%E$fofUW8~aQIC*FawyAIVxcMMxuoJ",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/125985"
                        },
                        {
                            "id": 102828,
                            "name": "v5.0",
                            "index": 1,
                            "modelId": 54233,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>The model training samples are added to optimize the generalization</p>",
                            "publishedAt": "2023-06-24T10:01:24.654",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 13274,
                                "ratingCount": 1009,
                                "rating": 5,
                                "thumbsUpCount": 1556,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 72103,
                                    "sizeKB": 147567.21875,
                                    "name": "Pyramid lora_Ghibli_n3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-24T09:55:53.740Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "8A36F83E",
                                        "AutoV2": "84A3C2CB0C",
                                        "SHA256": "84A3C2CB0CFCAF0553512CA3C0E0B01CF420ACAAF763388851749B3FB6A287D3",
                                        "CRC32": "554F6BE4",
                                        "BLAKE3": "3AB2305E3D77777701F509C0996D12436F8DF6EEC45C6AA35753624E548E644A",
                                        "AutoV3": "48556A006D2C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/102828",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1678498,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a0285e71-24e3-401d-af9c-b623ccb80812/width=450/1678498.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UfFjf]o|IUW=2gW=agj]$,n%f+RkDhobt6WB",
                                    "type": "video"
                                },
                                {
                                    "id": 1678454,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5db40525-1f7f-4c80-9ec9-2f065a634ec0/width=450/1678454.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UgFjc.o|IVW=2NW=WXj]$,n%f+RkDhoIt6WB",
                                    "type": "image"
                                },
                                {
                                    "id": 1678451,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a131ad28-1953-451b-baa9-9e5d960f526c/width=450/1678451.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "Ub4|QFWAR5t8yGWARPo#o#a#WAoeZ~kDkCad",
                                    "type": "image"
                                },
                                {
                                    "id": 1678457,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aee1e23b-d4bb-4a36-8e88-412b8d397b0d/width=450/1678457.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UzJRvjXSNLt6?1f,WXjvt-azs-oeTcoInjWE",
                                    "type": "image"
                                },
                                {
                                    "id": 1678455,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d11df854-3df2-4442-9b9c-02c3e4239db7/width=450/1678455.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UiIFoPofnioJXoM{ofof_4xuxuogxFxuIUWC",
                                    "type": "image"
                                },
                                {
                                    "id": 1678458,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c69094c7-2e36-4c5c-b174-a92e095f78f2/width=450/1678458.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UPHM4d-=t6M{yYE1ofs:~qIUWBxuxZt7t6WB",
                                    "type": "image"
                                },
                                {
                                    "id": 1678461,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/31d909de-60b4-491e-8076-d9e84f622e59/width=450/1678461.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UwDet;tRSiR+x|oNozRktnoIjGWUg4adfjbI",
                                    "type": "image"
                                },
                                {
                                    "id": 1678462,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/94d04cf1-1d9c-4b2b-ae80-29448c6f8ce6/width=450/1678462.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "URDv[kMwE0%gyYMwbV%g_NM_E1xvxvIoW:t7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/102828"
                        },
                        {
                            "id": 93438,
                            "name": "v4.0",
                            "index": 2,
                            "modelId": 54233,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-06-11T00:41:30.9",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2405,
                                "ratingCount": 274,
                                "rating": 5,
                                "thumbsUpCount": 288,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 64547,
                                    "sizeKB": 147567.21875,
                                    "name": "Pyramid lora_Ghibli_n.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-11T00:41:36.067Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "3F46641E",
                                        "AutoV2": "A897C53205",
                                        "SHA256": "A897C53205739782A2C53AA616199FAA9108A4D487DD60C3A026372089ECF01A",
                                        "CRC32": "B3454AC7",
                                        "BLAKE3": "FF57269C52FE94E9804C5F616FC1E4E210710D17EB17C9C18553B290FC0BA7CE",
                                        "AutoV3": "5AA0A0088D79"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/93438",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1102723,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/630ccc4f-c401-4e31-a1cd-f36ba713398d/width=450/1102723.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UNC@j6nOW9KKBaM{sVs,.8M{SzofTMogRknj",
                                    "type": "image"
                                },
                                {
                                    "id": 1102717,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e8fb25e-d8c5-4e54-b244-cc678262f0e8/width=450/1102717.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UgFjN2M{RNWY%%InRijbx^R%bIWUxvahozRk",
                                    "type": "image"
                                },
                                {
                                    "id": 1102722,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b230f459-2263-4d5f-a75d-ffbd3f07fe71/width=450/1102722.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UGCtL98|Dix]?^ngIAbcOu%JMwoz.7M}Rit7",
                                    "type": "image"
                                },
                                {
                                    "id": 1102719,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c63b9ebe-bf83-4f51-a718-7477e958cb95/width=450/1102719.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UbENX*E2kCbc_4M{WCoz%OfNWBj[%goxR%n+",
                                    "type": "image"
                                },
                                {
                                    "id": 1102718,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/75ad11dc-b5e2-4e97-a60f-d98e17513dae/width=450/1102718.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UhF7FqD$ELs+tpMxjFxGtmozNFs:NbtRS3of",
                                    "type": "image"
                                },
                                {
                                    "id": 1102720,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d1212687-a9fd-44c6-b960-47afabf09987/width=450/1102720.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UQFi-$JA00tQ~Cb]E1M{xwoyRPIWtRRnt6XQ",
                                    "type": "image"
                                },
                                {
                                    "id": 1102721,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/03342c62-c84d-4cfe-86e5-168f9fc2ebb0/width=450/1102721.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UFDT]|9}Djxc%z.6NFouyGN2IU%e~n9dMyi$",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/93438"
                        },
                        {
                            "id": 86765,
                            "name": "v3.0",
                            "index": 3,
                            "modelId": 54233,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-06-01T07:11:07.571",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5232,
                                "ratingCount": 783,
                                "rating": 5,
                                "thumbsUpCount": 785,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 59374,
                                    "sizeKB": 147567.21875,
                                    "name": "P_GHIBLI_V3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-01T07:11:32.911Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "AA9B6F38",
                                        "AutoV2": "7ED965267E",
                                        "SHA256": "7ED965267E71EA7997603352345A3C3CFDB0E20F4182E1FB9F18C8202F488995",
                                        "CRC32": "64B45F23",
                                        "BLAKE3": "F3F26C441CE41A2453BE4CB3CB35E55FBDB3269FD7C8E77D279C69DA578D6F5B",
                                        "AutoV3": "A44B533FF739"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/86765",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 989845,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2cc58875-d4c5-42f6-bd2a-ec72110a67f0/width=450/989845.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UB4|A%t:MbRNT4V?xvtTneZ|V@bJoekDV?aI",
                                    "type": "video"
                                },
                                {
                                    "id": 989847,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e49be2a0-e223-44bc-a390-ac1c933ea50c/width=450/989847.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UC56lItpMbRNS-V?tStTnfZ}V@bIocj]V?aI",
                                    "type": "image"
                                },
                                {
                                    "id": 989848,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/38ff2b21-8164-4885-b53b-d31ae649363c/width=450/989848.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "U25sJ%M14TyCy:a2Vuo|t3ayRQjFX9odoLV[",
                                    "type": "image"
                                },
                                {
                                    "id": 989850,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e23e896-5a50-4fe0-a4d6-aeaf3aefd5df/width=450/989850.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UFBzRY4;MI%L5uxZm*kC_NNHn2WCI^j@sjaM",
                                    "type": "image"
                                },
                                {
                                    "id": 989846,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1ecc4eab-a5f6-40b0-9635-00fe85743e0e/width=450/989846.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UQG9aK?vROxu?wD*Rit6-;Rkbct7xaayxuR*",
                                    "type": "image"
                                },
                                {
                                    "id": 989851,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c0f1ed82-dff8-4e4d-886e-ea5f5c44bc2a/width=450/989851.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UVDA}u4:R-xaY8xYWBbIVutRt6NH-;NHoJoe",
                                    "type": "image"
                                },
                                {
                                    "id": 989849,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9ca2959c-22d6-483e-9671-20ca9a3a7f1d/width=450/989849.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UVFYV]tRwuoJ.TxuNGRkpKozWBf6%Mozs.oJ",
                                    "type": "image"
                                },
                                {
                                    "id": 989852,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/228f8687-8d4a-4ae4-a761-f9deb3db3e28/width=450/989852.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UYHv%{$$I=WD}qazoeoe=^R,n%jt%0odsmaz",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/86765"
                        },
                        {
                            "id": 75526,
                            "name": "v2.0",
                            "index": 4,
                            "modelId": 54233,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p><strong>Using the latest pyramid noise offset technology for lora training</strong></p><p><strong>the picture has reached the level of wallpaper</strong></p><p><strong>this is the best Ghibli style model you have ever used</strong></p><p><strong>beautiful watercolor style</strong></p><p><strong>for secondary creation and modification has a great experience</strong></p><p><strong>if you like 2 my model, please pay attention or give feedback below, I will continue to update</strong></p>",
                            "publishedAt": "2023-05-20T03:07:02.905",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3750,
                                "ratingCount": 599,
                                "rating": 5,
                                "thumbsUpCount": 601,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 52147,
                                    "sizeKB": 147567.21875,
                                    "name": "Pyramid lora_Ghibli_v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-20T03:06:15.150Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "74CEAF2F",
                                        "AutoV2": "DB000D363E",
                                        "SHA256": "DB000D363E554FB97C34FCC7D459A95CE70F10986904DAF80E55564BC36F9855",
                                        "CRC32": "513B4035",
                                        "BLAKE3": "43BD7EA0E1942EEC072DFC10CD48223B26ABC12C52BB72D13BA1388B239BE81B",
                                        "AutoV3": "64D487281AAE"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/75526",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 848923,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a270ccf7-d48a-4933-834a-c947b8cbf962/width=450/848923.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1216,
                                    "height": 608,
                                    "hash": "UdD^#=I9IoRktWi]RjbXtSjZRiaxtRt6Rjae",
                                    "type": "video"
                                },
                                {
                                    "id": 844777,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/582f95d2-afc3-4178-b5fe-84fc1d27e5e1/width=450/844777.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1216,
                                    "height": 608,
                                    "hash": "UdD^#;I9IoRktpi]RjbXtSjZRiaxtQt6Rjae",
                                    "type": "image"
                                },
                                {
                                    "id": 844778,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ac62e435-29b5-42a4-ad37-41cf06f8deb2/width=450/844778.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1216,
                                    "height": 608,
                                    "hash": "UQI3gc#:R+t6^jEObbt6~99_Nxt6=_aMofkC",
                                    "type": "image"
                                },
                                {
                                    "id": 844779,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f6ca891f-e679-4121-967e-cd92052d0c7b/width=450/844779.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1216,
                                    "height": 608,
                                    "hash": "UJH_=D4nM{-;IUa{WVof~qM{M_WBM{RPf6WB",
                                    "type": "image"
                                },
                                {
                                    "id": 844780,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a4cd22b3-47ae-4e78-a2de-337fd7aae35b/width=450/844780.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1216,
                                    "height": 608,
                                    "hash": "UTFPw2NHE3bH~qS7NLkC0$xUxVaf0ps:%0jZ",
                                    "type": "image"
                                },
                                {
                                    "id": 844781,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/637621ba-d35f-4f39-818f-b4490797b5a2/width=450/844781.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1216,
                                    "height": 608,
                                    "hash": "UwG^8_ogoft7tWWVoLofIWRkoej?a]s.kBWV",
                                    "type": "image"
                                },
                                {
                                    "id": 844783,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f3759e59-5bc7-4a80-85f3-262eba493faa/width=450/844783.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1216,
                                    "height": 608,
                                    "hash": "UrIE;ExtE4a~.TxajYofERR+xWs.s.RkWDa}",
                                    "type": "image"
                                },
                                {
                                    "id": 871095,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f137a927-0ba5-447a-9be9-c3390d81155c/width=450/871095.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1216,
                                    "height": 816,
                                    "hash": "UZDnCF%%R.iut:kXt7ngIoMxozWBx[adWYWB",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/75526"
                        },
                        {
                            "id": 58596,
                            "name": "v1.0",
                            "index": 5,
                            "modelId": 54233,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-04-30T03:49:31.469",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2678,
                                "ratingCount": 555,
                                "rating": 5,
                                "thumbsUpCount": 557,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 41643,
                                    "sizeKB": 73838.03515625,
                                    "name": "Ghibli_v4.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-30T03:50:42.223Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "6806EE29",
                                        "AutoV2": "DF7098D16D",
                                        "SHA256": "DF7098D16DF3533F3F8E49377146BE132EB81AB494544CBE7C26444CB0A8C99A",
                                        "CRC32": "98E8475A",
                                        "BLAKE3": "D3577BCFBEB8EC717A1504C1E6B060620706555028890045D2D9FD8629712431",
                                        "AutoV3": "667C7E946BAC"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/58596",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 638284,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2de63efb-8604-46c1-acb4-ef8a75b3eb00/width=450/638284.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1168,
                                    "height": 800,
                                    "hash": "UGFiPV}@8{jKTMnhrpx@.8M|D$%2kZodRNRk",
                                    "type": "image"
                                },
                                {
                                    "id": 638285,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b994c8db-02ff-4198-cda3-65054bed5400/width=450/638285.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1168,
                                    "height": 800,
                                    "hash": "UUIF6%Z~D%adyZMxxCRi_Nf4IUjYxabHWCxa",
                                    "type": "image"
                                },
                                {
                                    "id": 638286,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4d106057-d2a5-4f38-193e-30ef5202ae00/width=450/638286.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1168,
                                    "height": 800,
                                    "hash": "UTH-yBs,9atR~qxCMyoz?vt6V[ofb_oJxaWC",
                                    "type": "image"
                                },
                                {
                                    "id": 638288,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3f62644b-a3d6-4ae7-6f3b-46cd82f87d00/width=450/638288.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1168,
                                    "height": 800,
                                    "hash": "UMEfJ}I[R4xsK-NKMxWX%hxVV?kD~UNGIpog",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/58596"
                        }
                    ]
                },
                {
                    "id": 9997,
                    "name": "Liyuu LoRA",
                    "description": "<p>你鲤鱼姐当然有LoRA啦！</p><p></p><p>QQ交流群：548362937</p><p></p><p>本人原则上不支持使用此模型生成任何成人内容。用户在使用本模型时，请务必遵守当地法律法规，勿侵犯他人的名誉权、隐私权或肖像权。</p><p>I generally do not support the use of this model to generate any adult content. When using this model, users should abide by local laws and regulations and shall not violate any other's right to reputation, privacy or portrait.</p><p>私は一般的に、このモデルを使用して成人コンテンツを生成することをサポートしません。 このモデルを使用する場合は、ユーザーは当地の法律や規制を守り、他人の名誉権、プライバシー権または肖像権を侵害しないようにしなければなりません。</p>",
                    "poi": true,
                    "allowNoCredit": false,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 50033,
                        "favoriteCount": 0,
                        "thumbsUpCount": 5789,
                        "thumbsDownCount": 1,
                        "commentCount": 43,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 100
                    },
                    "creator": {
                        "username": "Skald",
                        "image": "https://lh3.googleusercontent.com/a/AEdFTp6RsSYSIIDxp9Vn90MK0LG_S56O2UNYPTzXSCB5=s96-c"
                    },
                    "tags": [
                        "girl",
                        "photorealistic",
                        "portraits",
                        "real person"
                    ],
                    "modelVersions": [
                        {
                            "id": 11885,
                            "name": "Liyuu_v1",
                            "index": 0,
                            "modelId": 9997,
                            "baseModel": "Other",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-02-17T23:31:22.718",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 50033,
                                "ratingCount": 5644,
                                "rating": 5,
                                "thumbsUpCount": 5789,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 10943,
                                    "sizeKB": 147577.51953125,
                                    "name": "Liyuu.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-17T23:35:55.697Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "8BCF9171",
                                        "AutoV2": "A9BCA5DDC5",
                                        "SHA256": "A9BCA5DDC53D614A81BA475624526277EA3F2D320424FD7B465BE490B5A2F10C",
                                        "CRC32": "E273915D",
                                        "BLAKE3": "6B94C967019BE474A335F0CFC6B599A827A05366CE1099CB9A023E58C2723853",
                                        "AutoV3": "1830F4B31E7D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/11885",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 113602,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/277a0735-cbd9-486f-7a0d-0d4acd365700/width=450/113602.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UDJI6I%fKi;k00W9X-og5PEKM_9ZYkj=ZfIW",
                                    "type": "image"
                                },
                                {
                                    "id": 113598,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b6f9bd66-a8d5-4d99-8653-43f513e05500/width=450/113598.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UGJ[F*-n~SNMl:$%.8NFn1oz-oxVyE?F-7Iq",
                                    "type": "image"
                                },
                                {
                                    "id": 113601,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/17e5261c-3e35-4f5a-3b90-b94455115100/width=450/113601.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UFHx+[-=_NSi4nIURjo}^+M_4n%Mx]S5wGRj",
                                    "type": "image"
                                },
                                {
                                    "id": 113600,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b9799575-3e23-47de-7c39-4285cfd5dc00/width=450/113600.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "UCL|u|m6Dg=|00kF%g={]f%h?axV~V9Zw0Z~",
                                    "type": "image"
                                },
                                {
                                    "id": 113599,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f189c2e7-d9ac-45bd-d297-09256c2d0600/width=450/113599.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "U9Hodw?K5ym-00NHFwa2QmIn?Js:.SxcwHn+",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/11885"
                        }
                    ]
                },
                {
                    "id": 14605,
                    "name": "Howls Moving Castle , Interior / Scenery LoRA ( Ghibli Style ) v3",
                    "description": "<p><strong>v3 -</strong> Updated methods, accuracy, captions and a bunch of other work over a few days. Though similar results, I feel this version prompts better now; Examples are with the preview images but<strong> it tends to work well even just written as: &lt;loraname:1&gt; or: in the style of &lt;loraname:1&gt;,</strong> It can be tricky to get night scenes ( especially indoors ) this is something I might improve in the future but for now try adding <strong>night, dark</strong>, to prompts. </p><p><strong>FOR v2 USERS:</strong> you no longer need howlsbgs as a trigger word on v3.</p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/nucleardiffusion\"><strong>https://www.patreon.com/nucleardiffusion</strong></a></p><p>or please consider an easy one off donation here: <a target=\"_blank\" rel=\"ugc\" href=\"https://ko-fi.com/nucleardiffusion\">https://ko-fi.com/nucleardiffusion</a></p><p><br /><strong>Trained from the brilliant Ghibli movie Howls Moving Castle only</strong>, this LoRA is capable of creating different interiors and landscapes in the style from the film.</p><p><strong>Notice:</strong> This free work is intended for art and illustration purposes of emergent technology and not intended nor' trained for making illicit images, as the author I've taken care to not use any private data in the training process or designed it for such purposes. <strong>By downloading this model you are agreeing with the aforementioned intent and that you will not use my work to create / share images of a potentially immoral and / or illegal nature.</strong></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 29344,
                        "favoriteCount": 0,
                        "thumbsUpCount": 5682,
                        "thumbsDownCount": 0,
                        "commentCount": 5,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 51
                    },
                    "creator": {
                        "username": "nucleardiffusion",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/27747377-128b-489c-b265-4ed4d72db360/width=96/nucleardiffusion.jpeg"
                    },
                    "tags": [
                        "anime",
                        "landscapes",
                        "studio ghibli",
                        "ghibli",
                        "scenery",
                        "style",
                        "art style",
                        "artstyle"
                    ],
                    "modelVersions": [
                        {
                            "id": 19998,
                            "name": "v3",
                            "index": 0,
                            "modelId": 14605,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>trigger word \"howlsbgs\" no longer needed in the prompt, refined my training technique.</p>",
                            "publishedAt": "2023-03-07T23:47:14.887",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 26892,
                                "ratingCount": 4652,
                                "rating": 5,
                                "thumbsUpCount": 5172,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16693,
                                    "sizeKB": 147570.080078125,
                                    "name": "howlbgsv3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-07T23:51:59.835Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "8392BB80",
                                        "AutoV2": "3F9B3E7F43",
                                        "SHA256": "3F9B3E7F43E42253622A53BD0AEBA0F3942D13C4FC6ED90282B93D0112544F57",
                                        "CRC32": "699247B5",
                                        "BLAKE3": "23E686D24D80E7F451C4E21BF183B326B53A565B5A82B8623389C80963027FDA",
                                        "AutoV3": "4A82B9C07983"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/19998",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 211327,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d872791e-02de-4806-1e9d-441704d29000/width=450/211327.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 960,
                                    "height": 640,
                                    "hash": "UXE|elRoM_t6.AoJkBbbx_t7jIf6gNoJogof",
                                    "type": "image"
                                },
                                {
                                    "id": 211288,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d7d0c24b-e603-49e2-130d-f4a8da066200/width=450/211288.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 960,
                                    "height": 640,
                                    "hash": "UCE_v%M_Ot010N02~UbX$x~U9a%200XTIU?a",
                                    "type": "image"
                                },
                                {
                                    "id": 211287,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a20470b6-b56a-4f56-16ba-5e3698b34000/width=450/211287.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 880,
                                    "height": 584,
                                    "hash": "UKD0TENfE4s:x|kDkCbI00xD%0R+8^jsf6oJ",
                                    "type": "image"
                                },
                                {
                                    "id": 211289,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a5abed6c-515b-42b9-081f-533091a1c200/width=450/211289.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 960,
                                    "height": 640,
                                    "hash": "UDDu_Y9Z8ws915-P$JtSCAwHRNWB-pI:D*kY",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/19998"
                        },
                        {
                            "id": 17507,
                            "name": "v2",
                            "index": 1,
                            "modelId": 14605,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>This version understands better dark interior and towns, seems to be better detailed ( reuploaded v2 with a fix )</p>",
                            "publishedAt": "2023-03-02T10:45:21.328",
                            "availability": "Public",
                            "trainedWords": [
                                "howlbgs"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1592,
                                "ratingCount": 326,
                                "rating": 5,
                                "thumbsUpCount": 326,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 14713,
                                    "sizeKB": 147570.3388671875,
                                    "name": "howlbgs.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-02T12:01:29.063Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "6ACD8F80",
                                        "AutoV2": "4ABAD66F8C",
                                        "SHA256": "4ABAD66F8C7F886D0DA6A2C889D216E962CF3AED0596BED98DADBC9B95294863",
                                        "CRC32": "26A192F6",
                                        "BLAKE3": "15D93D62A6534A07C82B890A42F2EFF8F2CE55A0EE43E19DDF5B60BF29A3A42D",
                                        "AutoV3": "B5296CDD46CB"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/17507",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 178702,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c35133a5-a145-42ae-5d68-b4882d1df700/width=450/178702.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 880,
                                    "height": 584,
                                    "hash": "UZE;JsRojZbb^-X5kVj[_Na$bHWVtUj@V@kB",
                                    "type": "image"
                                },
                                {
                                    "id": 178372,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2ebb11f8-d26b-4512-0015-96ed045d8c00/width=450/178372.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 880,
                                    "height": 584,
                                    "hash": "U5CidO-p4;00~p?G?F020Mxu9uxa00?ZxYE3",
                                    "type": "image"
                                },
                                {
                                    "id": 178691,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9fc97dd5-2f3c-42b0-fe52-6fde1dacb900/width=450/178691.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 880,
                                    "height": 584,
                                    "hash": "UREyMCIu%Lj]N1~oogWDWYWFxt%LIWIV%Lj]",
                                    "type": "image"
                                },
                                {
                                    "id": 178690,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a30224d9-d1ad-4ad8-12cf-13c789c87500/width=450/178690.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 880,
                                    "height": 584,
                                    "hash": "U9A0tBOY~At60MocIqNHS6RjM|xa-Poes:Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 178706,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7c486aa5-9000-44e8-a9c8-6422e94b9a00/width=450/178706.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 880,
                                    "height": 584,
                                    "hash": "ULF?UvxujIW:-=%Lt6WBK0xuRjoe_NkBaxWC",
                                    "type": "image"
                                },
                                {
                                    "id": 178373,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/708163dc-cfb1-4460-b6f0-0bb228da7800/width=450/178373.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 880,
                                    "height": 584,
                                    "hash": "UBFse?Vt9YIpb~IvDjs:-htRs;xa-pngtmba",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/17507"
                        },
                        {
                            "id": 17201,
                            "name": "v1",
                            "index": 2,
                            "modelId": 14605,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-03-01T16:50:21.411",
                            "availability": "Public",
                            "trainedWords": [
                                "howlbgs"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 860,
                                "ratingCount": 191,
                                "rating": 5,
                                "thumbsUpCount": 191,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 14473,
                                    "sizeKB": 147570.1767578125,
                                    "name": "howlbgs.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-01T16:51:27.835Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "85D822EB",
                                        "AutoV2": "07645D116A",
                                        "SHA256": "07645D116AD3A4652C299BA20E163289336DD20874C8605A79DA6EC14A166F92",
                                        "CRC32": "29F9AFFA",
                                        "BLAKE3": "012CB0D32EB7C20C29545790457197546C21D70E727905663519D6DCD465C749",
                                        "AutoV3": "168D5DABBCF3"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/17201",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 174581,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1d6125a3-a44d-4d24-1639-e416286c1700/width=450/174581.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 880,
                                    "height": 584,
                                    "hash": "ULGT1b?ZE0NZ4_XA$*WT-CnUWXRi?[M{X8a#",
                                    "type": "image"
                                },
                                {
                                    "id": 174580,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/294b5bc5-0058-4dfc-8bdb-dee117f0e800/width=450/174580.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 880,
                                    "height": 584,
                                    "hash": "UIF6IAyGWCt201t9_3kE$|D*9FRj9FV=xqRl",
                                    "type": "image"
                                },
                                {
                                    "id": 174598,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7e9a49e0-d075-4074-2e8a-85eab33dfe00/width=450/174598.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 512,
                                    "hash": "UOHU|I=r?Hs+~q9F%MV?9v9as:D*f6ofxaM|",
                                    "type": "image"
                                },
                                {
                                    "id": 174577,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/439e0d61-b8d8-4e39-360b-10e478d14600/width=450/174577.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 880,
                                    "height": 584,
                                    "hash": "U8He|EV@01IVlUITs.xa00%LIAD*_NDi?H-:",
                                    "type": "image"
                                },
                                {
                                    "id": 174579,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/96910f1a-c7d5-4957-5fb9-608204d81e00/width=450/174579.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 880,
                                    "height": 584,
                                    "hash": "U8I=3|4n?wDi010Kxs.8009F9F8_?Hxu.7t6",
                                    "type": "image"
                                },
                                {
                                    "id": 174576,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e5018bc4-b42b-48bd-bd36-46ee5a874800/width=450/174576.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 880,
                                    "height": 584,
                                    "hash": "UBFse?Vt9YIpb~IvDjs:-htRs;xa-pngtmba",
                                    "type": "image"
                                },
                                {
                                    "id": 174578,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d2fdbf95-765b-4401-746e-af0ec932c900/width=450/174578.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 880,
                                    "height": 584,
                                    "hash": "UOF6F6IVX9t6?^odt7t6Tes.xZNIXnRkoyoL",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/17201"
                        }
                    ]
                },
                {
                    "id": 60724,
                    "name": "KIDS ILLUSTRATION",
                    "description": "<p>This LoRa try to mimic the simple illustration style from kids book.</p><h2 id=\"heading-2\">!!!!!!!!! PLEASE DON'T POST LEWD IMAGES IN GALLERY, THIS IS A LORA FOR KIDS ILLUSTRATION !!!!!!!!!</h2><h3 id=\"heading-117\">Training LoRa necessitate a lot of coffee. If you think that what I do is useful and want to help me keep doing this you can buy me a coffe here: <a target=\"_blank\" rel=\"ugc\" href=\"https://ko-fi.com/clumsy_trainer\">https://ko-fi.com/clumsy_trainer</a></h3>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit"
                    ],
                    "allowDerivatives": false,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 40250,
                        "favoriteCount": 0,
                        "thumbsUpCount": 5608,
                        "thumbsDownCount": 1,
                        "commentCount": 53,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 133
                    },
                    "creator": {
                        "username": "Clumsy_Trainer",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/636771ff-1f59-4e27-9b54-0a881ed4c6be/width=96/Clumsy_Trainer.jpeg"
                    },
                    "tags": [
                        "simple",
                        "style",
                        "illustration",
                        "cartoon",
                        "books",
                        "kids"
                    ],
                    "modelVersions": [
                        {
                            "id": 67980,
                            "name": "COOLKIDS V2",
                            "index": 0,
                            "modelId": 60724,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Re-trained from scracth. Results may be different 'cause I lost the first dataset. The shading and overall prompt coherence should be better, tho</p>",
                            "publishedAt": "2023-05-11T13:48:54.988",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 37536,
                                "ratingCount": 4135,
                                "rating": 5,
                                "thumbsUpCount": 5189,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 47560,
                                    "sizeKB": 147567.21875,
                                    "name": "COOLKIDS_MERGE_V2.5.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-11T13:46:06.544Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "26A36BC4",
                                        "AutoV2": "461A1DC302",
                                        "SHA256": "461A1DC302A1BD5E25FCE75644E50EC589AC4F65573238709FB415B7AAF1EB36",
                                        "CRC32": "1E8CCB5E",
                                        "BLAKE3": "A75E5021F4B97CC1BE613FEF7922D3F88FAA461BC35D06128265D78ADAD5EF3A",
                                        "AutoV3": "7F2175533EA5"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/67980",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 757211,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e11904bc-ba48-41e7-b4db-a1ae00211918/width=450/757211.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 512,
                                    "hash": "UIN+b3=x9Fv#uh-;EfEfL0x]NZXkV}wJxZ-6",
                                    "type": "image"
                                },
                                {
                                    "id": 757212,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b3a95c43-9372-437e-9ba6-4950952e8f8e/width=450/757212.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UNHMolEhNf-U?^NtH?xuE0nzD4j_WFM_Vtt8",
                                    "type": "image"
                                },
                                {
                                    "id": 757214,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6986bcb0-02c2-4da7-b844-6369db93943a/width=450/757214.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UTIE]_V@ITM|*0ICR5sBY5rrICt7n6R$t5b^",
                                    "type": "image"
                                },
                                {
                                    "id": 757215,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4d4dde8d-4958-4d7d-8e0b-a0b7aabba9d3/width=450/757215.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UaI}twobITo#*JRjMeog9GRjaMogDNi^tRWq",
                                    "type": "image"
                                },
                                {
                                    "id": 757216,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/65f88f1b-e707-4b10-b229-690e2185b5d2/width=450/757216.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "USH2xt%K9GM|~ooM8}RkbpbXIDoMnNV[oxoy",
                                    "type": "image"
                                },
                                {
                                    "id": 757217,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/05e40e88-2bf6-438e-b0af-f372fa2a11ac/width=450/757217.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UcM7GGxGABnP?^IsnNogR6R6Vst8ITIUV@kX",
                                    "type": "image"
                                },
                                {
                                    "id": 757218,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/af2219e4-96db-483b-a75b-f862769d3f43/width=450/757218.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UYH2cSE4IU-R?^RlnNob%gbbM|s:oLj]RkX9",
                                    "type": "image"
                                },
                                {
                                    "id": 757219,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e4b21b44-5831-44e0-98ef-0cfc21d3dad7/width=450/757219.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UoIYg@I=R$%1?wI;VsoeRPV@RPWARhaKr=WB",
                                    "type": "image"
                                },
                                {
                                    "id": 757221,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0ca5ce33-ac0a-4fc5-94b9-6bbc33f5c44f/width=450/757221.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "ULHMS=wH8wKP=|i_M~S%cbniMdozu6WAsjo}",
                                    "type": "image"
                                },
                                {
                                    "id": 757224,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/756f80e5-5dea-4c69-bb2c-57e985cbf729/width=450/757224.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDG]7%VF00tT_NDk8{?aImMyJq-:]{NIpvxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 757223,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9747e738-18c7-47a8-a48e-7e798438fd51/width=450/757223.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UOHen38{I:%1_N4o$|%2,-D*M|o}?aRjVsWr",
                                    "type": "image"
                                },
                                {
                                    "id": 757222,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/37aeeed8-95b5-4e1d-89f0-c42e4f1b437b/width=450/757222.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UeG[_]D*IVx[_ND*i{t7oLIUkDWVr=Rjt7WA",
                                    "type": "image"
                                },
                                {
                                    "id": 757226,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/85f97717-831e-4248-8fbe-b962e6f4c0bd/width=450/757226.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UbJ8639ZD*%L_ND*nhofIoM{t7WWM_Rit7kW",
                                    "type": "image"
                                },
                                {
                                    "id": 757225,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7d1709e1-3cad-48e2-9d4d-a17200b06775/width=450/757225.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UoIYg@I=R$%1?wI;VsoeRPV@RPWARhaKr=WB",
                                    "type": "image"
                                },
                                {
                                    "id": 757227,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2313db1e-d060-4e2e-8cdd-578cbef8c259/width=450/757227.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UWIhc?8{e,%Lys9Hr=oyM{M}WYRj$wR+s;R+",
                                    "type": "image"
                                },
                                {
                                    "id": 757228,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fcfdb1de-ec44-4883-b4f0-30636a6ba9d5/width=450/757228.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCFq{]~9KNNK}]n$t5oy020g9axZ1HIpM{WE",
                                    "type": "image"
                                },
                                {
                                    "id": 757231,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/36fe675a-1954-436c-9bf6-6635d8e2b59c/width=450/757231.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UPDAZ2%f8xIUUH%MrWMx$yxtXTRk$fs,tRX9",
                                    "type": "image"
                                },
                                {
                                    "id": 757229,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/81c88078-da5d-4390-8e01-a67ed82be331/width=450/757229.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "USIEqb9a9Z%1?^D*iv%19ZjYM|f+Mw%1RkWV",
                                    "type": "image"
                                },
                                {
                                    "id": 757230,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4beda60e-8e38-43fa-9d51-3a579ad96ecd/width=450/757230.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "USEWEoD*DP%L?^D*rpxtIVM|xuR+Mds.x]NH",
                                    "type": "image"
                                },
                                {
                                    "id": 757232,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4589c75f-01fe-4fdd-a448-9f257be4a54b/width=450/757232.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UYHLYXrq0LEM_Mr=D*NaI;M|Rj%2t2IVWB%L",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/67980"
                        },
                        {
                            "id": 65213,
                            "name": "COOLKIDS",
                            "index": 1,
                            "modelId": 60724,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>First version, already working on a second version</p>",
                            "publishedAt": "2023-05-07T23:04:55.774",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2714,
                                "ratingCount": 426,
                                "rating": 5,
                                "thumbsUpCount": 430,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 45765,
                                    "sizeKB": 147567.2177734375,
                                    "name": "COOLKIDS.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-07T23:05:44.041Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "63A07CAB",
                                        "AutoV2": "3F4F757010",
                                        "SHA256": "3F4F757010811A1ED43D97B896B8B74A5ACA618C26688AB51A5D2B1F5CB32166",
                                        "CRC32": "0595ADC0",
                                        "BLAKE3": "F8A83CE097C7DFC0B8DEEA41A49F09F25EF4A0FB384EC5522583FBB2B57655A9",
                                        "AutoV3": "513A731C348D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/65213",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 721765,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/21b1e3b4-f0c6-4acc-b10b-8c42163002cb/width=450/721765.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UHI|UQ_1RQtk}TSwR5kU?vM|rq$%4:sofl$*",
                                    "type": "image"
                                },
                                {
                                    "id": 721769,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/50594c92-14d3-4820-9fe8-86c254547250/width=450/721769.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UAPMK@-o?_Uw4UjF_LXn}cahW8s8[9n%TLt7",
                                    "type": "image"
                                },
                                {
                                    "id": 721766,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4b35f0c7-0fbc-47b8-a589-ffaf166b0502/width=450/721766.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UxJ+A4ocAnaK.TjZRjj?$ga$V?bbabayi]j]",
                                    "type": "image"
                                },
                                {
                                    "id": 721768,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/11515fbd-f20a-4d5a-af4a-cc865bfd6ef3/width=450/721768.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UACPV8$d4nRR6XM{r:xZyYRi0fOFKQsl-PS1",
                                    "type": "image"
                                },
                                {
                                    "id": 721767,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ace7c331-aabf-474e-9a78-887659baec91/width=450/721767.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U6H2*]+Y00T#^{krmTnK9;EBmL-L?cD7Z6%O",
                                    "type": "image"
                                },
                                {
                                    "id": 721770,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/68472d35-7d03-4fa2-8df7-9b5f1528e585/width=450/721770.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UhFs0yIoIUs:?^M|ROofIqe.i_ofDij?WBof",
                                    "type": "image"
                                },
                                {
                                    "id": 721772,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7dcce8d0-6f74-4d9d-af31-64527eefc017/width=450/721772.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UtL;WfT1ENxZ_LOGt7s.S0NKozaxS0RkaeR*",
                                    "type": "image"
                                },
                                {
                                    "id": 721771,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aadf3b60-be7e-4862-8203-cae32b99bf2b/width=450/721771.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UmLzg1tSD+s+~Vo#aeoc-oWYx@of%LR-t7W=",
                                    "type": "image"
                                },
                                {
                                    "id": 721773,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/223dfa21-2208-4f0b-86f6-cb1d97b1a233/width=450/721773.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UwJ*IrNMx[ju~pS6ozbHtlbvR+oftRofWBxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 721774,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/168b90f5-2af3-4049-b33d-92a09c51561e/width=450/721774.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UeIFSd9HTejFcuSP%MWBIpOGrptlxaE2r;WY",
                                    "type": "image"
                                },
                                {
                                    "id": 721775,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1ca15072-f59d-4051-85f9-6ceaa9bf21ea/width=450/721775.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UdL3[Prr?GxZ?^s9%2oeF{bII;j[%KSht3s.",
                                    "type": "image"
                                },
                                {
                                    "id": 721777,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f6814394-1a33-4784-bf69-10539151ec15/width=450/721777.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UsI=3~r;OXRkyZs7xZRkRoRiM{R*IUV@RPWC",
                                    "type": "image"
                                },
                                {
                                    "id": 721778,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04524b3b-a0d8-4abd-9816-39e099d2054c/width=450/721778.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UMFr9FxG}@-:_MR*-VxtT0WBt7eoVYIpR%RP",
                                    "type": "image"
                                },
                                {
                                    "id": 721776,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b2321549-c38c-44ae-8e9d-a1025a0a4dd7/width=450/721776.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UpIq[fxtM{s:~qt7fkoe-;t7W;oex]kCWBof",
                                    "type": "image"
                                },
                                {
                                    "id": 721779,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fd721275-3731-4209-8d52-943a98fe95f7/width=450/721779.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UoHxWvV@M{n%~qRjRPWB?bRjM|WBx^WBoKae",
                                    "type": "image"
                                },
                                {
                                    "id": 721780,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6467ff62-5f5d-4e0d-9841-c4cfa8105b99/width=450/721780.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "USF??S-m0MRj~mxaDlk7w=tPRCV[xTn$buWX",
                                    "type": "image"
                                },
                                {
                                    "id": 721783,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2b3ad250-c322-4e86-a3ae-947d632ce60e/width=450/721783.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UfH.Z1.6tQVv~nxbt7xZt3j]aiofoux?oMR,",
                                    "type": "image"
                                },
                                {
                                    "id": 721781,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b520a71d-ccec-4339-82d8-0133211ee486/width=450/721781.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UUI;YF00yD%2~p9Fb^S2-NI^xB$%J%RowINy",
                                    "type": "image"
                                },
                                {
                                    "id": 721782,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/085b7d2c-11f7-4cd2-b626-3d92db99db19/width=450/721782.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UjM7GYsoyXo#Y8oeXVkCGEs.R+WByFWErrWY",
                                    "type": "image"
                                },
                                {
                                    "id": 721784,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/24450832-656f-4884-8df7-879ea63f34c8/width=450/721784.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U7G[_kVF00D~Y6Nu00KI02NL{V$k2nyErAx-",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/65213"
                        }
                    ]
                },
                {
                    "id": 37343,
                    "name": "POV Facesitting",
                    "description": "<p>For those who appreciate the \"imminent facesitting\" low-angle shot, this is for you. At weaker settings, and in between ideal outputs, it will generate other nice low angles.</p><p></p><p>Trained on NAI from 91 custom images, generated from a small number of photo sources.</p><p>Sweet spot is around 0.7-0.8, consistency may be improved by the \"from below\" tag.</p><p></p><p>Known Issues: Often causes distortion of the nose. Inpainting works as a fix, but I am investigating if this can be avoided in a v1.1</p><p></p><p>Please post your best work, or share it with me, and I may include the best stuff in a future revision to improve this model's versatility and range. As of right now, it's reasonably flexible, but there's always room for improvement.</p><p></p><p>---------------</p><p></p><p>推荐给那些欣赏 \"当面 \"低角度拍摄的人。它在理想的输出之间或在较弱的设置下产生其他不错的低角度。</p><p>NAI由91张自定义图像训练而成，并由少量照片来源生成。</p><p>甜点在0.7-0.8左右，一致性可以通过 \"from below \"的标签来提高。</p><p></p><p>已知问题：经常出现鼻子失真。 可以通过内画来纠正，但正在调查V1.1版中是否有解决的办法。</p><p></p><p>为了提高这个模型的通用性和范围，请张贴或与我分享你最好的作品，因为我可能会在未来的修订中包括最好的作品。 目前，它是相当灵活的，但总是有改进的余地。<br /></p><p>---------------</p><p></p><p>イマドキの顔出し」ローアングル撮影を評価する方におすすめです。理想的な出力の合間や、弱めの設定で、他の素敵なローアングルを生成してくれます。</p><p>91枚のカスタム画像からNAIをトレーニングし、少数の写真ソースから生成。</p><p>スウィートスポットは0.7-0.8程度で、「from below」タグによって一貫性が改善されるかもしれません。</p><p></p><p>既知の問題点： 鼻の歪みが発生することが多い。インペイントで修正できるが、v1.1で回避できるか調査中。</p><p></p><p>このモデルの汎用性と範囲を向上させるために、将来の改訂にベストなものを含めるかもしれませんので、あなたのベスト作品を投稿するか、私と共有してください。今のところ、それなりに柔軟性はありますが、常に改善の余地があります。</p><p></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 5,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 47453,
                        "favoriteCount": 0,
                        "thumbsUpCount": 5594,
                        "thumbsDownCount": 0,
                        "commentCount": 20,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 10
                    },
                    "creator": {
                        "username": "NeuralEros",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4b6d8f2b-258a-4056-1b24-254900d2b000/width=96/NeuralEros.jpeg"
                    },
                    "tags": [
                        "sexy",
                        "concept",
                        "pose",
                        "camera angle"
                    ],
                    "modelVersions": [
                        {
                            "id": 43354,
                            "name": "v1.0",
                            "index": 0,
                            "modelId": 37343,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": null,
                            "publishedAt": "2023-04-12T06:13:04.486",
                            "availability": "Public",
                            "trainedWords": [
                                "from below"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 47453,
                                "ratingCount": 4382,
                                "rating": 5,
                                "thumbsUpCount": 5594,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 33014,
                                    "sizeKB": 106068.9404296875,
                                    "name": "povFacesitting.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-12T06:15:44.986Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "29224A19",
                                        "AutoV2": "5529F4327F",
                                        "SHA256": "5529F4327FCC2D29C24D00D8459DC7794A4C3F240DC2099A49BEC6E0FAEA46CE",
                                        "CRC32": "3782D54F",
                                        "BLAKE3": "8087BC6538AB0C62D996D8957B831311E8B926AD62CE4ED36DC551BB6A86E26D",
                                        "AutoV3": "BB32E9D14681"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/43354",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 475034,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/350ecf85-a958-4733-d7f7-c842a128e300/width=450/475034.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPFO=Z%gWBM{~qx]-;R+tmtRRiNGIVkCjFs:",
                                    "type": "image"
                                },
                                {
                                    "id": 475036,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/56b3b557-8738-4ba6-86d5-492a57a5f900/width=450/475036.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "UHHxjM-Q?wkDyZrq_4o~0ioz4okD-VxubI?b",
                                    "type": "image"
                                },
                                {
                                    "id": 475039,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b20fc431-9fe2-4a22-95fe-25def88fc400/width=450/475039.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USGIAf4:tQ%0~WITt7V@%Ms:W=t6IrxZxaNG",
                                    "type": "image"
                                },
                                {
                                    "id": 475037,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5ffc80db-d8aa-41df-ebb8-6b96f9369900/width=450/475037.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "UNJt6l={~VD*-;-oR+4o?HI:Ip$%s:~VxaR*",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/43354"
                        }
                    ]
                },
                {
                    "id": 23337,
                    "name": "Urban Samurai | v0.14 | Clothing LoRA",
                    "description": "<p>😉 If you got some beautiful image by using UrbanSamurai, plz share them on Review or Comment! Thx!</p><p>如果你使用城市武士Lora生成了漂亮的圖，歡迎在評價中展示！感謝！</p><p></p><h3><strong>NEW V0.14</strong></h3><p>!!</p><p><strong><em><u>Key prompt: urbansamurai, techwear</u></em></strong></p><p><strong><em><u>Negative prompt: ((mask))</u></em></strong></p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/94cb45a2-acb7-4069-f730-636e6385e400/width=525/94cb45a2-acb7-4069-f730-636e6385e400.jpeg\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c8008ece-1087-4be4-88c9-bf2dd3de2b00/width=525/c8008ece-1087-4be4-88c9-bf2dd3de2b00.jpeg\" /><p>（v0.14）</p><h2><strong>DESCRIPTION</strong></h2><p>This LoRA can dress characters in \"Techwear\" style clothing, and works well on most 2D, 2.5D, and live-action models. Suitable for full body figure.</p><p><strong>LoRA:</strong></p><p>&lt;lora:urbansamurai_v0.3:1&gt;</p><p><strong>Tag:</strong></p><ul><li><p><em>techwear jacket</em></p></li><li><p><em>with buckle and tape</em></p></li><li><p><em>black cap and mask</em></p></li><li><p><em>black gloves</em></p></li><li><p><em>tactical vest</em></p></li><li><p><em>*holding a katana (the effect is not good, it will be improved in subsequent versions)</em></p></li></ul><h2><strong>Practices</strong></h2><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f47762e-8325-45c1-4064-5da3867e6600/width=525/6f47762e-8325-45c1-4064-5da3867e6600\" /><p>(v0.2)</p><p><strong>Key Prompt:</strong></p><ul><li><p>fullbody</p></li><li><p>black techwear jacket and orange trousers with buckle and tape</p></li><li><p>&lt;lora:urbansamurai_v0.3:0.8&gt;</p></li></ul><p></p><h2><strong>MORE</strong></h2><p><strong><em>歡迎朋友們加我微信交流：artist3yehe</em></strong></p><p>Reach me on Twitter if you wish to contribute to improving this mod, Thx!</p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://twitter.com/Artist3YeHe\">https://twitter.com/Artist3YeHe</a></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 32303,
                        "favoriteCount": 0,
                        "thumbsUpCount": 5532,
                        "thumbsDownCount": 0,
                        "commentCount": 22,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 10
                    },
                    "creator": {
                        "username": "YeHeAI",
                        "image": "https://cdn.discordapp.com/avatars/1062281176015982682/7a49dd24cff7bebe77b35b0e0d9e648f.png"
                    },
                    "tags": [
                        "clothing",
                        "techwear"
                    ],
                    "modelVersions": [
                        {
                            "id": 27871,
                            "name": "urbansamurai_v0.3",
                            "index": 0,
                            "modelId": 23337,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>a nice version</p>",
                            "publishedAt": "2023-03-23T13:56:18.644",
                            "availability": "Public",
                            "trainedWords": [
                                "techwear jacket",
                                "black gloves",
                                "tactical vest",
                                "with buckle and tape"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 28087,
                                "ratingCount": 666,
                                "rating": 5,
                                "thumbsUpCount": 723,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 23023,
                                    "sizeKB": 147573.255859375,
                                    "name": "urbansamurai_v0.3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-23T14:00:53.539Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "3AFF94DC",
                                        "AutoV2": "3631B6DA02",
                                        "SHA256": "3631B6DA02C410EF44781FB202182D5E378C898D08E8E2B7C0A8645CF46F0EC3",
                                        "CRC32": "1B5545E8",
                                        "BLAKE3": "5B13864246BAE2448F0B40C4AA6755BAC7256A73DEF53A176A6C5A20421B5241",
                                        "AutoV3": "1B65794D9BA7"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/27871",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 313048,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e29e5b22-3eb9-4807-c664-63ad605a5100/width=450/313048.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 2176,
                                    "hash": "UiH^k-o~=yn3}sT0$*RPwcS#NaWB-UozM{of",
                                    "type": "image"
                                },
                                {
                                    "id": 317034,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a39c454c-212d-41de-a60f-e33095c31a00/width=450/317034.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 2176,
                                    "hash": "UEI=P.@ZQ8:+rr%Mx]sp00uiPATe9FRj%gtl",
                                    "type": "image"
                                },
                                {
                                    "id": 313052,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fdc09b72-e426-4676-781f-e4985ba77900/width=450/313052.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 2176,
                                    "hash": "UUHJ%O]*t7R,|qn%sTaf^OWqRkWq-VI;OYS3",
                                    "type": "image"
                                },
                                {
                                    "id": 313051,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/976c028d-6efe-431e-897d-d5aa20d34900/width=450/313051.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 2176,
                                    "hash": "UNF#dv%fs*Rj}@K5xawcQ,E#RjxaD4ELNxs.",
                                    "type": "image"
                                },
                                {
                                    "id": 313049,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aa4b6599-0990-437b-6b71-96127b5d3100/width=450/313049.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 2176,
                                    "hash": "USH1ofi^o}x^}ss;tSWBvLxbIpRPL~jE9tkW",
                                    "type": "image"
                                },
                                {
                                    "id": 317035,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ce3a88e2-a411-463a-e9c4-0af78a860a00/width=450/317035.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 2176,
                                    "hash": "ULHotc_3?w?c?boexuRP-;RkRiV@?cWAMxtR",
                                    "type": "image"
                                },
                                {
                                    "id": 317033,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d84f72f3-71b1-45c3-2142-3d68988da900/width=450/317033.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 2176,
                                    "hash": "UaJIq#t7?wxuRiWBWAfPkXj?DiRjIUj?M_ay",
                                    "type": "image"
                                },
                                {
                                    "id": 685315,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f30dec11-642f-43ac-92a3-6da096ec4b10/width=450/685315.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2048,
                                    "height": 1216,
                                    "hash": "UADJVI~q?bMx009Ej[9F4n%MRj%MIUD%IU%M",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/27871"
                        },
                        {
                            "id": 55962,
                            "name": "v0.14",
                            "index": 1,
                            "modelId": 23337,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>Greatly improved the adaptability to different models!</p>",
                            "publishedAt": "2023-04-26T15:38:56.025",
                            "availability": "Public",
                            "trainedWords": [
                                "urbansamurai",
                                "techwear"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3413,
                                "ratingCount": 3290,
                                "rating": 5,
                                "thumbsUpCount": 3294,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 40141,
                                    "sizeKB": 147569.26171875,
                                    "name": "urbansamuraiv0.14-000002.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-26T14:46:18.586Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "8E39E1D9",
                                        "AutoV2": "C7150AD13F",
                                        "SHA256": "C7150AD13F9FBA82168BB22C9B396C2EFF7477D596CE7FDC5DA3CB26A0025E66",
                                        "CRC32": "2F675099",
                                        "BLAKE3": "8022D9C13C34C289AAD49A71EB1F5B0063AE77ECAE0B9399883EE7AF76EFFA9F",
                                        "AutoV3": "247CB2C8D799"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/55962",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 606780,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8d928898-de6a-4ed2-8604-8565f07bd400/width=450/606780.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1632,
                                    "hash": "UUHLl3xvxu%N~qofoLxu%gkCIUWB%Mt7Rjf6",
                                    "type": "image"
                                },
                                {
                                    "id": 606783,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/56ec78ef-b15b-487d-1bfd-b7b74a221900/width=450/606783.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1632,
                                    "hash": "UJFrx09F~qM_9FD%M{9Ys:kCE1NG-pxuR*R*",
                                    "type": "image"
                                },
                                {
                                    "id": 606790,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aa021b32-73a6-4ccb-1e74-9f917db8e800/width=450/606790.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1736,
                                    "hash": "UOEofD~qx^x^-p%MozWqt-tSt7xZEztS-pxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 606789,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/88e7b6ea-3ca6-48b1-97e1-4eff82127600/width=450/606789.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 816,
                                    "height": 1736,
                                    "hash": "UQCGlS_N-=xcW,xuxvt8%3t8WBWTxcxbxuxt",
                                    "type": "image"
                                },
                                {
                                    "id": 606792,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad64f97a-d838-47e1-3bca-f49a2f9cdb00/width=450/606792.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1736,
                                    "hash": "UNG8o}~W?v%#^k-px]x].8%Mnis:AtXS$*$*",
                                    "type": "image"
                                },
                                {
                                    "id": 606782,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4a1c9b2e-4005-4805-efd8-3345d1ba9f00/width=450/606782.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1632,
                                    "hash": "ULGb-j?b%M-=_3ax-;%M-;s:t7xu_N%MITRj",
                                    "type": "image"
                                },
                                {
                                    "id": 606788,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c70d841b-857e-44b5-2b1d-46e6e5926b00/width=450/606788.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1736,
                                    "hash": "UODvvO_4%g%M%N-;oft7tQofWAj[t7xuxuWB",
                                    "type": "image"
                                },
                                {
                                    "id": 606791,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8f3d9fe3-0010-42a8-5bba-70c3bb601900/width=450/606791.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1736,
                                    "hash": "UHHK;E-=*0pw?voz-p%MLMxu#l-U.9xaRjxa",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/55962"
                        },
                        {
                            "id": 31314,
                            "name": "*urbansamurai_fashion",
                            "index": 2,
                            "modelId": 23337,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>Even more restrained, there is no excessive iconic visual structure, but highlighting the feeling of British martial arts, making the overall line of the character.</p><p>The same training data set, different training parameters.</p>",
                            "publishedAt": "2023-03-29T14:27:04.866",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 803,
                                "ratingCount": 1547,
                                "rating": 5,
                                "thumbsUpCount": 1549,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 25836,
                                    "sizeKB": 9326.0380859375,
                                    "name": "UrbanSamurai_fashion.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-29T14:31:23.933Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "7AD8353D",
                                        "AutoV2": "14F08495E4",
                                        "SHA256": "14F08495E4BB0B3EDB85E9EC2A848EACA06BA694A8D387F4BDF16BA90549EBB7",
                                        "CRC32": "7ECBD972",
                                        "BLAKE3": "B79AFC85426B260BC7D7ACF2A8F0E1BC9A04584913F10A46830562B36036BB1B",
                                        "AutoV3": "0A61684CFBFC"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/31314",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 356295,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a3632ca0-e3f7-4b87-fcca-09ef48e9c700/width=450/356295.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 2176,
                                    "hash": "ULGSDdIA4n?v00x]%fM_~po1WXt6.7E1ITt7",
                                    "type": "image"
                                },
                                {
                                    "id": 356294,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/47457d21-ec2b-4798-f79e-5be699131500/width=450/356294.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1152,
                                    "height": 2176,
                                    "hash": "UZHLe%.9o{M{.8%gX7V@_4tRogRkIpWExaxu",
                                    "type": "image"
                                },
                                {
                                    "id": 356293,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d7ea3137-c2a4-4d63-b708-fe254868e700/width=450/356293.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1152,
                                    "height": 2176,
                                    "hash": "UDFFW}^h~p_NRio}4:IUs$tRxXRj%$Vrjd?b",
                                    "type": "image"
                                },
                                {
                                    "id": 356291,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b37c3798-9c0e-41ec-43d7-58314e046500/width=450/356291.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1152,
                                    "height": 2176,
                                    "hash": "UAIX{lIb?9~q4U%Lo}9G00IA%OaK9bR-IU-p",
                                    "type": "image"
                                },
                                {
                                    "id": 356290,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b79aadde-e1a4-46e6-0bce-8ff7a23a6e00/width=450/356290.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 2176,
                                    "hash": "UOH.KD~p4m9FMaRNtQM{xujX%MtR?b-;MxM_",
                                    "type": "image"
                                },
                                {
                                    "id": 356289,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d4fa5902-099a-48f3-42a9-b2e075004700/width=450/356289.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 2048,
                                    "hash": "UDHeOU-=?]JW01ofIUX900s,IB-n-ORjR+Z~",
                                    "type": "image"
                                },
                                {
                                    "id": 356288,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/19ca6c42-d0f7-486f-8fe5-bc1379aa1e00/width=450/356288.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 2048,
                                    "hash": "UFI}hg00P:_N-;00o}oz5kRjvgVsRP?HMxIo",
                                    "type": "image"
                                },
                                {
                                    "id": 356287,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c395cdde-4553-4f06-05b4-415bdcbc6000/width=450/356287.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 2176,
                                    "hash": "UYHCG-t7_NM{--Rjt5fls%M{ITozt2ofRiM{",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/31314"
                        }
                    ]
                },
                {
                    "id": 7984,
                    "name": "Figma Anime Figures",
                    "description": "<p><strong>Note</strong>: I did not train these LoRA models myself. Original source: <a target=\"_blank\" rel=\"ugc\" href=\"https://huggingface.co/stma/lora-dump\">https://huggingface.co/stma/lora-dump</a></p><h2><strong>Recommended settings</strong></h2><p><strong>Quick start</strong></p><ul><li><p>Model: <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/4437/abyssorangemix2-sfw\">AbyssOrangeMix2</a></p></li><li><p>LoRA weight: 0.6 (UNet: 0.6, TEnc: 0.25)</p></li><li><p><code>[realistic], [3d], (3dcg), ((octane render)), [fisheye]</code> in positive prompt for realism</p></li><li><p><code>simple background, grey background</code> in negative prompt</p></li><li><p>CLIP skip: 2</p></li><li><p>Sampler: DPM++ SDE Karras (Euler a recommended for other models)</p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://huggingface.co/datasets/gsdf/EasyNegative\">EasyNegative </a>in negative prompt</p></li></ul><p><strong>Usable</strong></p><ul><li><p>LoRA weight range: 0.2 - 1.15 (UNet: 0.35 - 1.15 TEnc: 0.2 - 1.0)</p></li></ul><p>UNet is required for the style. UNet over 0.65 will look like an anime figure product. Too high UNet weight will melt details.</p><p>Lower TEnc weight will improve generalization. High TEnc will affect composition to look more like an anime figure product photo. Too high will fry the details.</p><p>Start with lower weight and increase as necessary. Requires more weight when mixed with TI embeddings and other LoRAs.</p><h2><strong>Figma</strong></h2><p>Trained on 5,746 images scraped from GoodSmile's international catalogue, including the discontinued products. All images were tagged with <code>figma</code> first and the product name with <code>figma</code> stripped out second, so an image from a product named \"figma Hatsune Miku\" would be tagged <code>figma, hatsune miku</code>. All other tags came from the WD1.4 tagger. <code>3d</code> and <code>realistic</code> tags seem to work well with it.</p><p>The alpha16 version is better at generalizing, while the 7e-5 version is better at capturing the figure-with-transparent-stand look.</p><h2><strong>Example images</strong></h2><h3>Model</h3><ul><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://huggingface.co/gsdf/Counterfeit-V2.5\">Counterfeit-V2.5 </a>(TODO: update example images to <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/4437/abyssorangemix2-sfw\">AbyssOrangeMix2</a>)</p></li></ul><h3>Textual inversion</h3><ul><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/4972/roxy-migurdia-ti\">Roxy Migurdia</a> (character) <code>roxy-migurdia</code></p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/5537/megumin-ti\">Megumin</a> (character) <code>megumin_1000</code></p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/3036/charturner-character-turnaround-helper\">Char Turner </a>(composition) <code>chartuner</code></p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://huggingface.co/datasets/gsdf/EasyNegative\">EasyNegative </a><code>EasyNegative</code></p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://huggingface.co/datasets/Nerfgun3/bad_prompt\">Bad Prompt </a><code>bad_prompt</code></p></li></ul><h3>Additional LoRA</h3><ul><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/4831/yelan-lora-collection-of-trauters\">Yelan</a> (charater) <code>yelan \\(genshin impact\\)</code></p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/5126/torino-aqua-style-lora\">Torino Aqua</a> (style) <code>torino aqua</code></p></li></ul>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 3,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 27079,
                        "favoriteCount": 0,
                        "thumbsUpCount": 5423,
                        "thumbsDownCount": 0,
                        "commentCount": 12,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 0
                    },
                    "creator": {
                        "username": "robowaifudev",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b5178af9-4692-4099-5271-89d711b99a00/width=96/robowaifudev.jpeg"
                    },
                    "tags": [
                        "anime",
                        "concept",
                        "figurines",
                        "action figure",
                        "figma"
                    ],
                    "modelVersions": [
                        {
                            "id": 9413,
                            "name": "figma",
                            "index": 0,
                            "modelId": 7984,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>This version works better for artistic effect but is less good at details and less compatible with other LoRAs.</p>",
                            "publishedAt": "2023-02-11T07:55:58.459",
                            "availability": "Public",
                            "trainedWords": [
                                "figma"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 25962,
                                "ratingCount": 1902,
                                "rating": 5,
                                "thumbsUpCount": 1975,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 9128,
                                    "sizeKB": 151494.275390625,
                                    "name": "figma.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-11T08:01:10.521Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "0F2E3571",
                                        "AutoV2": "6F6D687FE0",
                                        "SHA256": "6F6D687FE041FCDC0FE55B9CD90AE7634DC50EBC9DA849DC869B232A8DF60F9D",
                                        "CRC32": "4DF210A6",
                                        "BLAKE3": "243A3408E98185303BA787ECBAD232FDD39F5B40EA3CC3D1AADB96F609D9B53D",
                                        "AutoV3": "DC746A5A4DA9"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/9413",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 90635,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ed907efe-71df-4bfb-f7da-fc97420a8a00/width=450/90635.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UWGSrw.Snm$*THozsoM{~C$*xaozU_MxSfkB",
                                    "type": "image"
                                },
                                {
                                    "id": 90636,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1541e722-b857-4892-6960-13bba4c9a800/width=450/90636.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UNH-[Qs.~pD*%MR+x]xuIpx]IVWBt7-pIURj",
                                    "type": "image"
                                },
                                {
                                    "id": 90943,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/83a32549-85bb-4757-b46f-71ea6a59ff00/width=450/90943.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 856,
                                    "hash": "USI#Je~n?Y-oxZxtads+4=XAWXR%-qwdIVD+",
                                    "type": "image"
                                },
                                {
                                    "id": 90710,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e19d7c34-42a9-4d2b-3300-34926e44ca00/width=450/90710.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UOI#GW0K.7%f_NIUX8tR~XIn%2s;%Ms,Rlt7",
                                    "type": "image"
                                },
                                {
                                    "id": 90491,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5902f97c-ab43-4f06-45c3-cb4f20868000/width=450/90491.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 560,
                                    "height": 896,
                                    "hash": "UHDl$i9aIon$~pRjs,R*s.j?-pWX^+kCM|t6",
                                    "type": "image"
                                },
                                {
                                    "id": 90485,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e48dde6-a171-4f67-f959-3ad5ebf50700/width=450/90485.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 560,
                                    "height": 896,
                                    "hash": "U6G9T_DO2b~q00s98wx]m7.8{e9azUo~?HR*",
                                    "type": "image"
                                },
                                {
                                    "id": 90492,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2393c09a-c9e1-447e-0b3d-b4f93a64a600/width=450/90492.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAGbP2Rj9uwK00~pR*n$.Ssm$%OD_2s9nitl",
                                    "type": "image"
                                },
                                {
                                    "id": 90490,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7c9e1e51-3470-43a6-6092-c6c01b18cb00/width=450/90490.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 560,
                                    "height": 896,
                                    "hash": "UNE.-34nnhxu?w9Fjuoz~WITt7ofM}M{WDay",
                                    "type": "image"
                                },
                                {
                                    "id": 90489,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bde6bcbd-9b18-4562-6c29-c594e2188300/width=450/90489.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 560,
                                    "height": 896,
                                    "hash": "UMGR|^%NRNWY~VxZNFRlnMV?NMkD-:xaR:oz",
                                    "type": "image"
                                },
                                {
                                    "id": 90488,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1c4fb76f-076d-476d-bce1-7c7d1f6efa00/width=450/90488.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 560,
                                    "height": 896,
                                    "hash": "U8GIDh00.6${0i~U%L%2~8I[IV%L00_N01R+",
                                    "type": "image"
                                },
                                {
                                    "id": 90487,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dfb97732-8b7e-420e-ded6-c5cde64e3500/width=450/90487.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UNJ7wG0KnN?a00x]xuM|?GD%S3xu_N4:WAoI",
                                    "type": "image"
                                },
                                {
                                    "id": 90486,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3b88afe7-df31-4768-5dd4-3c930c687500/width=450/90486.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 512,
                                    "hash": "UBGlYQE2DiXS00WBjEWYbcjEkWoz~Bs:S2oL",
                                    "type": "image"
                                },
                                {
                                    "id": 91076,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/74b4c889-ce8e-442c-3faf-ebbdc8b1a300/width=450/91076.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 856,
                                    "hash": "UBINT]9b00f$02xu4:of01Rj~WRk4mtR%ge.",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/9413"
                        },
                        {
                            "id": 9414,
                            "name": "figma [alpha16]",
                            "index": 1,
                            "modelId": 7984,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>The alpha16 version has a stronger anime figure look and is better at generalizing and has better details.</p>",
                            "publishedAt": "2023-02-11T07:55:58.459",
                            "availability": "Public",
                            "trainedWords": [
                                "figma"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 611,
                                "ratingCount": 1576,
                                "rating": 5,
                                "thumbsUpCount": 1682,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 9129,
                                    "sizeKB": 151388.5537109375,
                                    "name": "figma [alpha16].safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-11T08:01:01.933Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "249E12EF",
                                        "AutoV2": "74CA2D92AD",
                                        "SHA256": "74CA2D92AD92185085A73B58128AB1BFEF4FBC5316DF6194D609E6B261913613",
                                        "CRC32": "15B167D8",
                                        "BLAKE3": "170580F5CE602AC0ABEE20920001949AD270090882D119004D02D0E31C223445",
                                        "AutoV3": "0307B2D8C1A7"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/9414",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 90745,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c135c971-2600-4467-0fa8-ddad86b2e900/width=450/90745.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFFOAZR*0z~BNaNGM_SOD*0eNFxG~C?HR+%1",
                                    "type": "image"
                                },
                                {
                                    "id": 90744,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8b5b2952-8a22-41a5-0ee1-255559a4de00/width=450/90744.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 856,
                                    "hash": "UBE{nX4TK+ibYR%#xbRODiTzIVS$?c00IpX9",
                                    "type": "image"
                                },
                                {
                                    "id": 90501,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1beaaebc-4528-4495-38b9-1aff8d39b400/width=450/90501.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 560,
                                    "height": 896,
                                    "hash": "UHIXERIV~9xED%~VVsNG_1E2I;j[%MIpt6WB",
                                    "type": "image"
                                },
                                {
                                    "id": 90500,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/99560e2b-35e7-4818-5484-63d32a867100/width=450/90500.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 560,
                                    "height": 896,
                                    "hash": "UQHK^J~Wx]e.tm%gxuWC-oxts:WCt7RjRjRj",
                                    "type": "image"
                                },
                                {
                                    "id": 90499,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f80226df-22fe-433f-bc3a-f0aa9f83e700/width=450/90499.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 560,
                                    "height": 896,
                                    "hash": "UHG*~B~A-gjWb0t7s+t68^tSNIxuxG%2kDM{",
                                    "type": "image"
                                },
                                {
                                    "id": 90498,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c83b82fa-b84e-456b-f83e-2cb70dc7b600/width=450/90498.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 560,
                                    "height": 896,
                                    "hash": "U7EW2k4;yXxu00?aivo~MbMyQ-IU~BS#t7$%",
                                    "type": "image"
                                },
                                {
                                    "id": 90497,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0ded5210-13ab-4402-1dd8-287f08ad6200/width=450/90497.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 560,
                                    "height": 896,
                                    "hash": "UEHw4D0z~AENdB]-xuxE~Cb^xas:^Re.ogba",
                                    "type": "image"
                                },
                                {
                                    "id": 90496,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f97a8542-0099-475a-9367-abeeaab4e200/width=450/90496.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 560,
                                    "height": 896,
                                    "hash": "UMF}.r~C-TxY-;%2xY%24nkWt7%2WqofbwR*",
                                    "type": "image"
                                },
                                {
                                    "id": 90495,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d096e8be-8baf-4f25-f475-f047969e9600/width=450/90495.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 560,
                                    "height": 896,
                                    "hash": "UJHB0l01=YtR_ND*wIof~C9ZRksoK5Ri9u%1",
                                    "type": "image"
                                },
                                {
                                    "id": 90494,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/358e4360-90ed-45da-910d-3172986d1900/width=450/90494.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 560,
                                    "height": 896,
                                    "hash": "UAHxTtrXGu*000j]R*bHAttR#RR5IVt6f+Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 90493,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8b48b339-8e12-4bff-2aba-feb917169800/width=450/90493.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 640,
                                    "height": 640,
                                    "hash": "U6IEbB~WQmWY009Z$%of1NV@cEt60}%gOsn$",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/9414"
                        },
                        {
                            "id": 9415,
                            "name": "figma [7e-5]",
                            "index": 2,
                            "modelId": 7984,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>The 7e-5 version is better at capturing the figure-with-transparent-stand look and has more variety in backgrounds but they look plastic.</p>",
                            "publishedAt": "2023-02-11T07:55:58.459",
                            "availability": "Public",
                            "trainedWords": [
                                "figma"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 506,
                                "ratingCount": 1679,
                                "rating": 5,
                                "thumbsUpCount": 1825,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 9130,
                                    "sizeKB": 151431.6650390625,
                                    "name": "figma [7e-5].safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-11T08:00:57.553Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "61E8AA0F",
                                        "AutoV2": "B16BFAB3A6",
                                        "SHA256": "B16BFAB3A6049098E2CB606A925D37E552F460F0064427CDFC147DD84EA25231",
                                        "CRC32": "380FAEC8",
                                        "BLAKE3": "90D0CD89B7B23DC54E0D86E360A642555ACC08E73D29F635A9B588D8E8852334",
                                        "AutoV3": "88B55A4041A7"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/9415",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 90796,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/10afaf60-e3a3-4edb-f7c5-70c68a89f600/width=450/90796.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 856,
                                    "hash": "UCF=%X~D.T0#1Q.7XA%3Y+-V4:Na9]krV_-V",
                                    "type": "image"
                                },
                                {
                                    "id": 90795,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5eb5ed3a-44a5-435a-1b61-f0f3317e4c00/width=450/90795.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 856,
                                    "hash": "UPGIZED*D$xvNv%LRPWX~pM|M{t7I=WCIVbH",
                                    "type": "image"
                                },
                                {
                                    "id": 90794,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a93ce27f-048d-4bd4-a8fe-e415ed9e9400/width=450/90794.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 856,
                                    "hash": "UFG+dopK~otRF~XA9E_3AJ9ZMwE1x_IUr;nO",
                                    "type": "image"
                                },
                                {
                                    "id": 90512,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/61ee6a2f-9410-469e-a9bb-ed60d6a50000/width=450/90512.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCHU5+D*4.M{_NELxZRj-nIoeox]a$%2E2Sh",
                                    "type": "image"
                                },
                                {
                                    "id": 90511,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b605ce64-ce9e-4bea-98a6-c61302aa1500/width=450/90511.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFE_:NE1]~S~~B-UV?xZ}mNb-pM|xDE2g3xF",
                                    "type": "image"
                                },
                                {
                                    "id": 90510,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71f9971c-2716-474b-06f6-249c3afc8600/width=450/90510.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U6F6B?8_NTEL%W-qk8-p?p~o^+ITVs~oE2WU",
                                    "type": "image"
                                },
                                {
                                    "id": 90509,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aa34df2f-a5b0-461e-8543-83f7c1fa9800/width=450/90509.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBE{FL0Kl9niE84:?aah~no#$yxv00o#M_t8",
                                    "type": "image"
                                },
                                {
                                    "id": 90508,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4430a59c-0695-49c5-4684-3a72cb189500/width=450/90508.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEHLuX9F_N~qMx%NIUj?Iot7MxIUIVV?oeRj",
                                    "type": "image"
                                },
                                {
                                    "id": 90507,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bb3ce54d-9700-4551-8887-d223076bb400/width=450/90507.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U7HK;7005Q~C?^8{D%%#*J00I9.SVaSvIoxb",
                                    "type": "image"
                                },
                                {
                                    "id": 90506,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e57d426e-afc7-4c99-e4f0-5c4f5eaf1800/width=450/90506.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "ULGb9j^*rpt7tkxGi^RkwHn$oMkC~B?atloz",
                                    "type": "image"
                                },
                                {
                                    "id": 90505,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e46508ba-6c2c-4cde-bfff-6a18a69a6100/width=450/90505.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDHULU0K9YXT%i01^*j]~BD%?aV@spVrEMIU",
                                    "type": "image"
                                },
                                {
                                    "id": 90504,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aeb48810-9ded-459e-fef3-19859c47f500/width=450/90504.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UMGuRU-U%gI=?wNHtRt7-;ogRPRj^,-qs+ay",
                                    "type": "image"
                                },
                                {
                                    "id": 90503,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/841852c9-a125-406b-7a04-5473e3bfb400/width=450/90503.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UYG[m2~q$%x[.8-psoozNGV@E2RjxtoyWBM{",
                                    "type": "image"
                                },
                                {
                                    "id": 90502,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/62eed0b6-f1d2-4e27-00cc-6cf3eb826400/width=450/90502.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEDlK5M_~9xGs8-pn$oL0LWWIqxtWUNGt7NG",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/9415"
                        }
                    ]
                },
                {
                    "id": 11701,
                    "name": "Yoneyama Mai Style",
                    "description": "<h1><strong><em>本模型仅供学习参考使用，禁止商用</em></strong></h1><h1><strong>Yoneyama Mai Style</strong></h1><h3><strong>Trained by YozoraAru</strong></h3><p>This model is absolutely insane and stunning. It's from <strong>Maiyama</strong> and it'll give you some incredibly complex visual results. It has a unique and personal style that really shines through in the model. I recommend using it in specific situations and playing around with <strong>weights</strong> between <strong>0.3~0.7</strong> for the best effect. Have fun with it!</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent",
                        "Sell"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 3,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 23971,
                        "favoriteCount": 0,
                        "thumbsUpCount": 5371,
                        "thumbsDownCount": 1,
                        "commentCount": 12,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 10
                    },
                    "creator": {
                        "username": "YozoRaAru",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5a9e24d8-7739-4418-f313-18f97dc32b00/width=96/YozoRaAru.jpeg"
                    },
                    "tags": [
                        "style",
                        "art style"
                    ],
                    "modelVersions": [
                        {
                            "id": 26660,
                            "name": "Yoneyama Mai_V2 (LoCon)",
                            "index": 0,
                            "modelId": 11701,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p><strong>Trained by Locon,please install Locon extension</strong></p><p><strong>使用了Locon训练，需要安装Locon插件</strong></p><ul><li><p>Fixed the issue of poor image control</p></li><li><p>修复了对于画面不好控制的问题</p></li><li><p>Optimized file size</p></li><li><p>优化了文件大小</p></li><li><p>Increased the model's generalization ability</p></li><li><p>增加了模型的泛化性</p></li><li><p>It is recommended to use <strong>weights </strong>between <strong>0.5-0.7</strong>.</p></li><li><p>建议使用<strong>权重</strong>在<strong>0.5-0.7</strong></p></li></ul>",
                            "publishedAt": "2023-03-21T10:36:16.659",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 16017,
                                "ratingCount": 3345,
                                "rating": 5,
                                "thumbsUpCount": 3745,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 22082,
                                    "sizeKB": 10859.4599609375,
                                    "name": "msw_locon-t2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-21T10:41:23.826Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "B24AE189",
                                        "AutoV2": "5C71D2370F",
                                        "SHA256": "5C71D2370FD8E246D51934E77B3477C0AA41BD66DDBADCAB04C424BC16E57304",
                                        "CRC32": "34CCDDB3",
                                        "BLAKE3": "DD8486C5EE24B8E7B5269268136779676B4ED87232671F9DFA80DD18A6080020",
                                        "AutoV3": "4C1704D2CDEB"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/26660",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 295352,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9738a944-8bb8-43c8-41d7-c0c2ddabcd00/width=450/295352.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1280,
                                    "hash": "UZJu4Kjb_4oz~qIUWVNG?bWVM{t7kDt7aext",
                                    "type": "image"
                                },
                                {
                                    "id": 293765,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cbdb24db-c123-4c08-bfe2-b6660e5a0900/width=450/293765.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1280,
                                    "hash": "UjKmto={%KNG~qkBxvxatlSit7WY%Ms:V@Wq",
                                    "type": "image"
                                },
                                {
                                    "id": 293818,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/45fc17ad-6bc0-4037-2d8b-b221ed989f00/width=450/293818.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1280,
                                    "hash": "UwIhdORk%NWG~qR*o~WCs,bHj[j@t7oejEkC",
                                    "type": "image"
                                },
                                {
                                    "id": 295346,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/08a24460-050e-42f8-1cb8-65d8a3dfb500/width=450/295346.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1280,
                                    "hash": "ULG+XU~q00IU?bofD%t7%Mt7M{t8IUt7%Mt7",
                                    "type": "image"
                                },
                                {
                                    "id": 293770,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f6b85dae-33ef-4fd6-1b40-d7662dad5400/width=450/293770.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1280,
                                    "hash": "UZHeC4RkH=xu%hjZNGWBAHoeNKNG~WR*R4xa",
                                    "type": "image"
                                },
                                {
                                    "id": 293767,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/204ee8f1-3c9d-4b4d-41e6-0ef565446b00/width=450/293767.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1280,
                                    "hash": "UnI}n#aeofae~qjtNGRjtkt7ofWB-;kCoLj[",
                                    "type": "image"
                                },
                                {
                                    "id": 293768,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/12edf13f-6773-499f-5ec2-779ae41f9600/width=450/293768.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1280,
                                    "hash": "U4Hxy$00pu_N00_30000^~?v-3D$00000MWF",
                                    "type": "image"
                                },
                                {
                                    "id": 293764,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/baf3c1e6-343e-4032-234d-a2bf9169f900/width=450/293764.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 768,
                                    "hash": "UAG+XV00Di00t7RjDiIU00~q-;IoM{9Fxuof",
                                    "type": "image"
                                },
                                {
                                    "id": 293763,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9052f31e-6ed2-445a-c57b-24ef78984e00/width=450/293763.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 768,
                                    "hash": "UXO3@RRQxvMy~qDkIUt8oy-;M|My%NRiRjox",
                                    "type": "image"
                                },
                                {
                                    "id": 293762,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bc3f1a8a-7470-49b5-8217-087168f2d300/width=450/293762.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 768,
                                    "hash": "UPHeUsM_4.?v~qjYRj%L%Nn$aetR-;t7IUNG",
                                    "type": "image"
                                },
                                {
                                    "id": 293761,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5679b487-b05e-4731-e5b8-521c9753dd00/width=450/293761.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 768,
                                    "hash": "UGELph~X4.00ozRoV@IUx[xvM}IVx@RkM{RP",
                                    "type": "image"
                                },
                                {
                                    "id": 295350,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e8dfc72-c51d-42ca-8e35-e88f7854a100/width=450/295350.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 768,
                                    "hash": "UBHK,{Dh5qxa4,t700%2.TNI^jj[IUE29GX9",
                                    "type": "image"
                                },
                                {
                                    "id": 295349,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/917e8f4f-c25d-49a1-5e0b-130477cd5400/width=450/295349.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 768,
                                    "hash": "UXJbN=RjE1ju~qs:D%of?bt7ozRj?bV@t8t6",
                                    "type": "image"
                                },
                                {
                                    "id": 295348,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4603ed8c-24d3-4e47-bfd6-2dda9ca44400/width=450/295348.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 768,
                                    "hash": "USM*2B00_3_M_3IUDit6~pxvt8s:-;t7t8tR",
                                    "type": "image"
                                },
                                {
                                    "id": 295347,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cb66f997-92fa-48c4-74ec-9d049dddfe00/width=450/295347.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 768,
                                    "hash": "UoNTXk%L_NWB%Loc%MbcD$xtR+M{tRtRbIad",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/26660"
                        },
                        {
                            "id": 13827,
                            "name": "Yoneyama Mai_V1 (LoRA)",
                            "index": 1,
                            "modelId": 11701,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": null,
                            "publishedAt": "2023-02-22T12:42:26.63",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 7954,
                                "ratingCount": 1633,
                                "rating": 5,
                                "thumbsUpCount": 1636,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 12164,
                                    "sizeKB": 147568.4814453125,
                                    "name": "Yoneyama Mai_v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-22T13:01:31.812Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "CDEC17F9",
                                        "AutoV2": "2BB4840FA4",
                                        "SHA256": "2BB4840FA42CA871E378D81CABE33020E6E61A19F5C0326A25FCD10F0DFCEF30",
                                        "CRC32": "6A45AA91",
                                        "BLAKE3": "070B41F9D345579A87A9193FBF2045A469751070D7AFD02B95C9DC831F80D717",
                                        "AutoV3": "26B97F2B8CCE"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/13827",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 134045,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/27b7d68f-5b45-4052-45e8-b844d9ddfd00/width=450/134045.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1280,
                                    "height": 768,
                                    "hash": "UJHwr[yD00o0E2rWoy~WwHtR?Hn%D%IonhEL",
                                    "type": "image"
                                },
                                {
                                    "id": 134052,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/680d9ffd-4fa0-4d88-db27-5c4a63e0a300/width=450/134052.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "U9KweC%z0{0y}F_39FS^RQ^+E1IoXm004n-o",
                                    "type": "image"
                                },
                                {
                                    "id": 134054,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d7e9e7b-a7bb-4c01-a663-70d934757200/width=450/134054.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 768,
                                    "hash": "UHFZ,4n#F#bv?^RiIAoHVrR4MxW9.9oZMzNF",
                                    "type": "image"
                                },
                                {
                                    "id": 134053,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d538061a-3244-4fd8-aaf9-a850abafba00/width=450/134053.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "UHIEL^-78^01R:_NRN9ZE0E0E0a1$*IpNFNF",
                                    "type": "image"
                                },
                                {
                                    "id": 134050,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a787897b-6810-4519-2e79-539cf3b1fd00/width=450/134050.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 768,
                                    "hash": "UNM7v400_M?H~qNe-o%2V?%1V@bE%MRjt8xv",
                                    "type": "image"
                                },
                                {
                                    "id": 134048,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cb102e5c-776a-4940-d888-1af2b4830c00/width=450/134048.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "U9I}9i}s0K00$3.SMxDiS}xu?b?cRks:D%M|",
                                    "type": "image"
                                },
                                {
                                    "id": 134105,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ea39ae1a-5818-4e1b-dc5c-a2f8be704700/width=450/134105.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1536,
                                    "hash": "UQM@Azix_Mxt^+-:X9wf?GMxD%RQxss:%3e.",
                                    "type": "image"
                                },
                                {
                                    "id": 134046,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/96ad78ad-345a-45b5-fdf9-165cbd0cb100/width=450/134046.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 768,
                                    "hash": "UfM@7nsENc?v~WMxx]WUs.ITW.WB-p%MjZR*",
                                    "type": "image"
                                },
                                {
                                    "id": 134049,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2ea15a17-5389-4d3e-b763-28ab8f625c00/width=450/134049.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "UDGl6t~W4m00?d%L4nM_IT%3WEjrx@M{xa9E",
                                    "type": "image"
                                },
                                {
                                    "id": 134047,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e08bc585-c042-455f-f5cc-57b33d330d00/width=450/134047.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "UOL|[:s,_NNu?I%NIVx[IUIUIVS1?bWBWBR-",
                                    "type": "image"
                                },
                                {
                                    "id": 134051,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ca74b944-2711-44a4-d89c-95db5e2c4e00/width=450/134051.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "U7I#WV~B000KM|^+4:IW9Z.8IT?G?atR4.IT",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/13827"
                        }
                    ]
                },
                {
                    "id": 11367,
                    "name": "Tifa_meenow",
                    "description": "<h3><strong>Other Final Fantasy VII Remake version:</strong></h3><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/12035/aerithmeenow\"><strong>Aerith_meenow</strong></a></p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/12671/realisticaerithmeenow\"><strong>Realistic_Aerith_meenow</strong></a></p><h3></h3><h3>About tifa_ v2</h3><p>This training increased the training set, optimized the tag, and Tifa became more \"flexible\" and easier to use with other Lora.</p><p>1. The recommended weight is around 0.75</p><p>2. This version of tifa is easy to be naked. Please adjust the tag appropriately.</p><h3><strong>关于tifa_v2</strong></h3><p>此次训练加大了训练集，优化了Tag，Tifa也变得更加\"灵活\"，更容易和其他Lora搭配使用。</p><p>1.建议权重 0.75附近</p><p>2.这个版本tifa比较容易裸体，请适当调整tag。</p><p></p><p></p><p>About v1:</p><h3><strong>If you also like Final Fantasy VII Remake</strong></h3><h3><strong>I believe this model will not disappoint you.</strong></h3><p>This is a Lora model about Tifa. It adopts the method of mixed training of real people and Tifa games. There are still many imperfections as a version for the time being. At the same time, I hope you can give full play to your creativity and provide further ideas for my creation.</p><p></p><p><strong>Model related issues:</strong></p><p>1. It is recommended to use <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/6424/chilloutmix\">Chilout Mix output</a></p><p>3. The triggering weight of Lora model is 0.9, and the effect is good</p><p>3. The model is still powerless to generate images of huge model size</p><p>4. The model is mainly good at facial modeling, and may match better with other models in terms of movement?</p><p></p><p>Thank you very much for preferring this model=)</p><p></p><p>关于V1：</p><h3>如果你也很喜欢Final Fantasy VII Remake</h3><h3>相信这个模型不会另你失望。</h3><p>这是一个关于Tifa的Lora模型，采用真人和Tifa游戏混合训练的方法，暂时作为一版本还有很多未完善的，同时我也很希望大家发挥自己创造力，提供我创作的进一步思路。</p><p></p><p>模型相关问题：</p><p>1.推荐使用<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/6424/chilloutmix\"><strong>ChilloutMix 输出</strong></a></p><p>3.Lora模型触发权重0.9效果附近较好</p><p>3.模型对于生成巨大型号尺寸的图片暂时还很无能为力</p><p>4.模型主要擅长面部塑造，动作方面可能和其他模型搭配起来更好？</p><p></p><p>最后非常感谢大家喜欢这个模型 =)</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 0,
                    "mode": "TakenDown",
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 37894,
                        "favoriteCount": 0,
                        "thumbsUpCount": 5311,
                        "thumbsDownCount": 0,
                        "commentCount": 20,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 3
                    },
                    "creator": {
                        "username": "Meenow",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f2583cc5-fa66-41b6-f5e2-9ffc17186000/width=96/Meenow.jpeg"
                    },
                    "tags": [
                        "final fantasy",
                        "tifa lockhart",
                        "tifa",
                        "final fantasy vii remake"
                    ],
                    "modelVersions": [
                        {
                            "id": 16793,
                            "name": "tifa_v2",
                            "index": 0,
                            "modelId": 11367,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>See the introduction for details.</p>",
                            "publishedAt": "2023-04-17T17:25:51.422",
                            "availability": "Public",
                            "trainedWords": [
                                "tifa lockhart",
                                "red_eyes",
                                "black hair",
                                "long hair"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 33600,
                                "ratingCount": 5046,
                                "rating": 5,
                                "thumbsUpCount": 5285,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 14145,
                                    "sizeKB": 147582.0078125,
                                    "name": "tifa_v2.3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-28T18:21:16.548Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "DD4420EA",
                                        "AutoV2": "2CE8DDF032",
                                        "SHA256": "2CE8DDF0325154BE2D599AB1F9199C8B0F90BB94B52F822ECE555481E6B9DE49",
                                        "CRC32": "4255F049",
                                        "BLAKE3": "A9B106BC5D5A755E7CD15F4C02623D73051914E09EA794FB4CB1CA112B412E25",
                                        "AutoV3": "5BF0B0CC76CA"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/16793",
                                    "primary": true
                                }
                            ],
                            "images": [],
                            "downloadUrl": "https://civitai.com/api/download/models/16793"
                        }
                    ]
                },
                {
                    "id": 11896,
                    "name": "Raiden Shogun | Realistic Genshin LORA",
                    "description": "<p>samples in: https://youtu.be/Md31qYa78yk</p><p>Training without any <strong>real person's face</strong> in dataset.</p><ul><li><p><strong><em>Update 23/03/07:</em></strong><em> The problem about hands and extra fingers is fixed......a little bit?</em></p></li></ul><p><em>For everyone: I am not using the official lora loader, so you should use the</em><strong><em> additional-network </em></strong><em>webui plugin to use my lora setting.</em><br />Recommended weights for txt2img - 0.55-0.75, higher weights may cause some issue.</p><p><em>Thank you for downloading!<br />Please leave a image with comment if you like it, I would love to see.</em></p><p><strong>If you see anyone selling images that generated by this model on pixiv or other platform please message me on twitter.</strong></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 36669,
                        "favoriteCount": 0,
                        "thumbsUpCount": 5197,
                        "thumbsDownCount": 0,
                        "commentCount": 5,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 100
                    },
                    "creator": {
                        "username": "Cy1zu_",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e20eb40c-bf3d-4e9e-730d-b2e9661ee100/width=96/Cy1zu_.jpeg"
                    },
                    "tags": [
                        "anime",
                        "character",
                        "girl",
                        "photorealistic",
                        "genshin impact",
                        "game character",
                        "video game",
                        "raiden shogun"
                    ],
                    "modelVersions": [
                        {
                            "id": 19827,
                            "name": "RaidenShogun-HandsFix",
                            "index": 0,
                            "modelId": 11896,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>Maybe fixed some hands problem?</p>",
                            "publishedAt": "2023-03-07T13:08:14.401",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 25647,
                                "ratingCount": 3071,
                                "rating": 5,
                                "thumbsUpCount": 3355,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16542,
                                    "sizeKB": 159061.2744140625,
                                    "name": "RaidenShogun-HandsFix.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-07T13:11:53.034Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "A24B81BE",
                                        "AutoV2": "B688E3DD62",
                                        "SHA256": "B688E3DD62F1E12261887FD70A89E262C0E54FF509C6B22189BDBBE20D2677C7",
                                        "CRC32": "C9496F73",
                                        "BLAKE3": "FCA6FE7A62D56A935CF8DD4C28E2B0316D31196365643DE8F1BBC9DB1674C982",
                                        "AutoV3": "41B380802849"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/19827",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1241191,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/abbfe4d7-d72f-4783-860e-cd970efc0a7a/width=450/1241191.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCF5I2%%00FNVWb{-EEK009r?HkStQNGROs%",
                                    "type": "image"
                                },
                                {
                                    "id": 208805,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/329a2af6-6902-44a2-aeb2-4f1545487c00/width=450/208805.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 811,
                                    "height": 1080,
                                    "hash": "UBC$yr_400E2%O-;^,NMImkD?H-;orxvR%IS",
                                    "type": "image"
                                },
                                {
                                    "id": 208804,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bf03e8da-2961-45c9-e6ab-794377390a00/width=450/208804.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2880,
                                    "height": 1033,
                                    "hash": "UnHB+3RiayNE~qjuayog?uofayt7?aj[ayof",
                                    "type": "image"
                                },
                                {
                                    "id": 208803,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6055f3a3-73f7-450d-221f-070494924100/width=450/208803.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2880,
                                    "height": 1033,
                                    "hash": "UjH27.e-a#n#~oofayt7_Na~aybI_4WBfRWU",
                                    "type": "image"
                                },
                                {
                                    "id": 208802,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8fafb114-0ad8-40a8-1cee-3f3a5eaf0900/width=450/208802.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2880,
                                    "height": 1033,
                                    "hash": "UjHeFVogayt9_MaxayjY_3WUf7WT~Xj]ayoz",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/19827"
                        },
                        {
                            "id": 14059,
                            "name": "RaidenShogun",
                            "index": 1,
                            "modelId": 11896,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-02-23T00:52:20.102",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 11022,
                                "ratingCount": 1851,
                                "rating": 5,
                                "thumbsUpCount": 1851,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 12323,
                                    "sizeKB": 159064.2919921875,
                                    "name": "RaidenShogun.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-23T00:56:16.133Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "A2E2E4A5",
                                        "AutoV2": "9940DAB5B5",
                                        "SHA256": "9940DAB5B56E13B9FFB0D6468410D1AEC1E9FE97DF82D221959D85C45A84F3F6",
                                        "CRC32": "14060BD1",
                                        "BLAKE3": "59D38F5CEDFA7C22388C4D1730AC03E6607D5779F7AC53490440E92C9AD056A0",
                                        "AutoV3": "5161807A98BF"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/14059",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 173382,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ebe33058-77e5-48d3-3123-3a92da08b700/width=450/173382.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1080,
                                    "height": 1440,
                                    "hash": "UBC~*]_400D+%P-;^,NMImog?H-=oqxvR$Mv",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/14059"
                        }
                    ]
                },
                {
                    "id": 42903,
                    "name": "Doll Likeness - by EDG",
                    "description": "<p>If you'd like to support me and do more:<br /><a target=\"_blank\" rel=\"ugc\" href=\"https://ko-fi.com/edgonkofi\">https://ko-fi.com/edgonkofi</a> - commissions open!<br />If you're looking for a <a target=\"_blank\" rel=\"ugc\" href=\"https://ko-fi.com/post/EDGs-tutorials-P5P6KT5MT\">&gt;&gt;LoRA Making Tutorial&lt;&lt;</a></p><h3 id=\"heading-50\"><strong><span style=\"color:rgb(64, 192, 87)\">Want SDXL or Pony dolls? Click here: </span></strong><br /><strong><span style=\"color:rgb(64, 192, 87)\">&gt;</span></strong><a target=\"_blank\" rel=\"ugc\" href=\"https://ko-fi.com/edgonkofi/shop/sdxldolls\">edg XL dolls</a><br /><span style=\"color:#40c057\">&gt;</span><a rel=\"ugc\" href=\"https://ko-fi.com/edgonkofi/shop/ponydolls\"><span style=\"color:#4c6ef5\">edg Pony dolls</span></a><strong><span style=\"color:rgb(64, 192, 87)\"><br />I have started training and uploading them on my ko-fi shop. </span></strong><br /><strong><span style=\"color:rgb(64, 192, 87)\">XL dolls available to date: French, Colombian, Argentinian, Polish, Egyptian, Philippina, Greek, Canadian, Blonde Bimbo and more!</span></strong></h3><p><strong><span style=\"color:rgb(64, 192, 87)\">Pony dolls undergoing training.</span></strong></p><h3 id=\"heading-784\"><span style=\"color:rgb(250, 82, 82)\">The 1.5 dolls are now available on the civitai generation service. Remember that this means that you are allowed to sell the images that you get from the civitai generation but prohibits you from uploading this resource to another generation site.</span></h3><p></p><h1 id=\"heading-785\">Doll Likeness - By EDG</h1><p>Don't mind me, just jumping on the bandwagon!</p><p>On this model page you will find many many different dolls to play with.</p><p>Have fun!</p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [
                        "RentCivit"
                    ],
                    "allowDerivatives": false,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 202223,
                        "favoriteCount": 0,
                        "thumbsUpCount": 5191,
                        "thumbsDownCount": 2,
                        "commentCount": 66,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 3377
                    },
                    "creator": {
                        "username": "EDG",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5b118e95-4ef4-471f-a2e8-bb3f754e4a00/width=96/EDG.jpeg"
                    },
                    "tags": [
                        "sexy",
                        "woman",
                        "clothing",
                        "face",
                        "doll",
                        "beautiful face"
                    ],
                    "modelVersions": [
                        {
                            "id": 455957,
                            "name": "Moldovan Doll Likeness",
                            "index": 0,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2024-04-20T13:00:00",
                            "availability": "Public",
                            "trainedWords": [
                                "edgMLD_woman,edgMLD_face,edgMLD_body,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 723,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 62,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 375405,
                                    "sizeKB": 18541.3203125,
                                    "name": "edgMoldovanDollLikenessv1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-04-19T17:41:43.022Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "5B3373AE8E",
                                        "SHA256": "5B3373AE8E692F65A0287679B767DDEDC282ED3C7A1882F8B88B3AE63B08DABC",
                                        "CRC32": "817796F2",
                                        "BLAKE3": "A947FB6716F135C7B0B4BC8045C548C11EE31BF7505FA82E0C45DF8428C6AFA0",
                                        "AutoV3": "24CEB9493D70"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/455957",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 10260365,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/17bea213-6b3b-4450-8849-237eda0b15f2/width=450/10260365.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHJZ*;^k8cS~2@OYz=#,0fja%1M{-Cn%NtS3",
                                    "type": "image"
                                },
                                {
                                    "id": 10262176,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4dda979b-37e7-4e2a-a330-13f26f9fafaa/width=450/10262176.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIID]}xuI:-p~Wxuayt64;t7skInR%Rjs,oI",
                                    "type": "image"
                                },
                                {
                                    "id": 10262976,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e8c1a00-5e6b-4950-babc-9fbbb280d992/width=450/10262976.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEID~-S6ct9a?^?b-;s:OsM|?Gw]%1IoMxae",
                                    "type": "image"
                                },
                                {
                                    "id": 10261383,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e26ed58-440d-4b01-a4a7-f2e70818bcf1/width=450/10261383.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6F}ZdD*0K-o01-piwof00nhElD%ozof~B-p",
                                    "type": "image"
                                },
                                {
                                    "id": 10260540,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1d155f57-d956-460a-9ca4-8916bca117b3/width=450/10260540.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEF$CLt800NF$vM|58M|00IV~pxu.6NI-oWA",
                                    "type": "image"
                                },
                                {
                                    "id": 10261308,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e6b2daf-b135-4ce9-92b0-cba68bd918f1/width=450/10261308.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6G@Y;M{0g=x00^*9FX95702$*MyEMX8^*~B",
                                    "type": "image"
                                },
                                {
                                    "id": 10260424,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/537a9348-94a2-47a8-a52e-cc70135c9dc4/width=450/10260424.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAGu5mr;00~Wvw^*x_nN0g-o={E1Rjof-nRj",
                                    "type": "image"
                                },
                                {
                                    "id": 10262585,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d6cbb841-36e6-4258-9fb8-754692a5e52c/width=450/10262585.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIIXT{S4ys^*g%ayM|xuIpxtxCIpRkbbt7jY",
                                    "type": "image"
                                },
                                {
                                    "id": 10263153,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/34113292-4338-4e29-84c0-3aecbd6e51ac/width=450/10263153.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7G@x+tQ00~D72-Wacbq01ozE24:9axG-oNF",
                                    "type": "image"
                                },
                                {
                                    "id": 10260662,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/96f603b2-16be-48d6-ae70-3db70bedba8a/width=450/10260662.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFDuf4xaADS2~pNaVtn%IpRjaKoLMyoKoykC",
                                    "type": "image"
                                },
                                {
                                    "id": 10260790,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7cefbd96-264a-481f-8577-03faa26afb95/width=450/10260790.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UOJtey_N%#tR?w%gpJ-UpdNHa$Io_3RjV@9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 10262565,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4059b025-bd35-4664-8011-5ab22c59f3f7/width=450/10262565.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UOI;kvxt*0%MTKs:jZX9NekD%1t6ogRkayxa",
                                    "type": "image"
                                },
                                {
                                    "id": 10262445,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad3129fb-ba4d-4cbc-82c4-fa4f4a353daf/width=450/10262445.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBD9SC~V000K0eE2V@%2I9Ioo}t7s+j[IpWB",
                                    "type": "image"
                                },
                                {
                                    "id": 10263315,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ca5abbd9-38fb-4a98-b81e-1c58d12ef6e0/width=450/10263315.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5ATWX5?000fiw-T58R500#Q9|_3q[9^~qS4",
                                    "type": "image"
                                },
                                {
                                    "id": 10260841,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/31b174fc-1cd5-45f6-b867-348cff8268be/width=450/10260841.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDD]6$%1ys%NxtRjD*S49tkWn4V@NGR*R*s.",
                                    "type": "image"
                                },
                                {
                                    "id": 10260964,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/35f4cb70-33ed-4949-aa2a-225ac7ae03f1/width=450/10260964.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9IhQ%00t1bc~T0000-;8wo#%$o}xsWC?IM{",
                                    "type": "image"
                                },
                                {
                                    "id": 10261627,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/24b38c69-e38c-4860-8b36-432dd4a78dac/width=450/10261627.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8EeuyE103~W_4%2~WX9Tfng?G57?bR*og-:",
                                    "type": "image"
                                },
                                {
                                    "id": 10262047,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/33310db0-9d27-450c-984f-997729dfe44c/width=450/10262047.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHF=dd4otL%M_2?bE1NG~obIIpn#?bE1ahn#",
                                    "type": "image"
                                },
                                {
                                    "id": 10262049,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b208e03b-c3fe-46b6-a3d5-60a1c8a28f46/width=450/10262049.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USG+Bxof-Ojs~VaxI;Rkm*bbXUV@t8kDjYWA",
                                    "type": "image"
                                },
                                {
                                    "id": 10261894,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e24a0538-8994-446a-957c-20828e005d47/width=450/10261894.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGGuXI%M00^%ER-=^*W.?vxwM}NH~oxv-:Rj",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/455957"
                        },
                        {
                            "id": 422885,
                            "name": "Estonian Doll Likeness",
                            "index": 1,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 23,
                            "description": null,
                            "publishedAt": "2024-04-04T16:00:00",
                            "availability": "Public",
                            "trainedWords": [
                                "edgEst_woman,edgEst_face,edgEst_body,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 948,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 60,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 344422,
                                    "sizeKB": 18541.3203125,
                                    "name": "edgEstonianDollLikenessv1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-04-01T18:30:43.894Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "92047565AC",
                                        "SHA256": "92047565AC927FF2AADDFF23EF35A163586385246FF2835E36BD17CB63F7B04E",
                                        "CRC32": "042C87DC",
                                        "BLAKE3": "E3515DDB755A1100DBC3130D1FD8C32BB6097EEF039721F000A52856BB41BD25",
                                        "AutoV3": "6E42C47E6DBF"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/422885",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 8972589,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/de15ced4-8943-401c-a6b3-68391567d8c9/width=450/8972589.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEKU4kf800^+00%M.Tog4otRxuIAXUadi]t8",
                                    "type": "image"
                                },
                                {
                                    "id": 8973119,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/25fa5eae-6187-43b8-ba97-238f8f733613/width=450/8973119.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1424,
                                    "hash": "UNHBe.4oX,8x~pM{R:D$T0ozIoRj%LxaV@NG",
                                    "type": "image"
                                },
                                {
                                    "id": 8977238,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/de850b1a-bb3b-4817-a35b-f16f08a41397/width=450/8977238.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIJ7~}?a00E100Rj%ga}4:t8ofM{?wWBIAay",
                                    "type": "image"
                                },
                                {
                                    "id": 8972891,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a260e94c-ed56-4360-b407-d7954b50ce63/width=450/8972891.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULKl^2.5Bg~D%n?HRVNsCZ-W$kkVvEJ6InIC",
                                    "type": "image"
                                },
                                {
                                    "id": 8972584,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7e4ec89a-cc71-42c3-9e2e-d3d827d401f6/width=450/8972584.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UOD04Ms*-iof~7xubcjYROj[NLRjItadWCWY",
                                    "type": "image"
                                },
                                {
                                    "id": 8972587,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1624e224-cba9-4ced-89a5-df24f2d4437a/width=450/8972587.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBI#Ac9EK+x]~k%3lA%hERt7MxI;-?ofeSRP",
                                    "type": "image"
                                },
                                {
                                    "id": 8972586,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/27b807e5-cbef-44fd-9a01-d0720590c945/width=450/8972586.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJHU%%8{00_49DtSX.IT0fW;bJoJRmso?Gs:",
                                    "type": "image"
                                },
                                {
                                    "id": 8973347,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5903e6f2-0e23-468d-aad6-33192492e9a5/width=450/8973347.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFJHs~E10fr;00NGo$s,01Mx%1x]_4ozD$of",
                                    "type": "image"
                                },
                                {
                                    "id": 8972915,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d6826590-1b21-4649-b79d-f6a13fc567b4/width=450/8972915.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UOJkK9x]?[nN-eRoIw${%Dxrs9IbEWV?nMXA",
                                    "type": "image"
                                },
                                {
                                    "id": 8972838,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/009117d2-1d8c-41d4-9a98-9bbdf3c93401/width=450/8972838.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMJ7gx~WPA.9tj_Mx]afo~%M%NtR9uRjV?WV",
                                    "type": "image"
                                },
                                {
                                    "id": 8972590,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/92b13e12-84d2-43b5-99fa-75a427317094/width=450/8972590.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEFYT3=V8w.8?_i,1U$0I.-A%2M}K7=r]}TJ",
                                    "type": "image"
                                },
                                {
                                    "id": 8972643,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d1a1381b-a98f-4035-8c7b-f9c22e4ada5a/width=450/8972643.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNK1OLv|+DQ-}iaKBrtRI[adNHT0BXS$#6rq",
                                    "type": "image"
                                },
                                {
                                    "id": 8972674,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/64c0c4bd-a965-4037-ad12-411c287a1461/width=450/8972674.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UWG8.mV@RO-o}SslShkXFzaKj]S5NcR*w]s:",
                                    "type": "image"
                                },
                                {
                                    "id": 8972890,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ea6dcc4a-733d-411e-a693-e4c78790af6b/width=450/8972890.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDJQTZ00HCS6xAE100^j3pO?}sV[DPoLtRsW",
                                    "type": "image"
                                },
                                {
                                    "id": 8972944,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e3f4469f-7529-4c02-98d3-f72ca8a9f4c7/width=450/8972944.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNKA]3xuys-;={ayJ.j[tSofE2RjNeWVsmkC",
                                    "type": "image"
                                },
                                {
                                    "id": 8973147,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/108c495a-6ec0-4f79-8236-ca2ed95b3e72/width=450/8973147.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIJjxct6Pq.8K+s,RjNGtSo#M{V[S%RknNt7",
                                    "type": "image"
                                },
                                {
                                    "id": 8973181,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/65ffad01-e1f2-429d-9092-5b5ec2a04c3d/width=450/8973181.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULLM;VM{yq~V~qof%hWX9Zt6IVIWDibFMdjE",
                                    "type": "image"
                                },
                                {
                                    "id": 8973216,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f1f54152-d4be-47ae-b058-33fc1ef2b863/width=450/8973216.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQK,:Cog_N~qXnRiIpt8IUWAD*ayNaWAxDf6",
                                    "type": "image"
                                },
                                {
                                    "id": 8973242,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d2a30b7c-65d2-4655-b147-66497321cc40/width=450/8973242.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMKTVx9Fcs?Gy?$jtlX9tlXnV[xuoMxaWBWB",
                                    "type": "image"
                                },
                                {
                                    "id": 8973271,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d46e2ddb-6543-43c8-a46e-0ff9d8d3b316/width=450/8973271.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPJ7t9VXLNOZ-=jZV[R*XTozS5jYElNHslxZ",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/422885"
                        },
                        {
                            "id": 398803,
                            "name": "Malaysian Doll Likeness",
                            "index": 2,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2024-03-22T16:30:00",
                            "availability": "Public",
                            "trainedWords": [
                                "edgMal_woman,edgMal_face,edgMal_body,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 802,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 58,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 321624,
                                    "sizeKB": 18541.3203125,
                                    "name": "edgMalaysianDollLikenessv1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-18T17:36:27.805Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "BF861C0B03",
                                        "SHA256": "BF861C0B036CA178A768D8EB72E6357FAD3B763791CC313409A1DEDBBE1C50A4",
                                        "CRC32": "EC77B7BA",
                                        "BLAKE3": "ED45F661123E46B50F2D91031780A2BCC58A770F986354BBBF8A779A3EE4E9CD",
                                        "AutoV3": "6DF72F6F3849"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/398803",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 8168623,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/102d300f-601d-47d5-9696-a7194d5a47a3/width=450/8168623.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFFYfUR.01^+?bkBNe%200%2~qIo%gxuM{M{",
                                    "type": "image"
                                },
                                {
                                    "id": 8169148,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/76173053-a180-4881-8b38-544df836caf2/width=450/8169148.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHG*va~V?wa$%$ozt7E2?HRjNGslXTNGs.xt",
                                    "type": "image"
                                },
                                {
                                    "id": 8168804,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2018f251-6ce9-47e6-afb7-5b6ee80abe4e/width=450/8168804.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U79Gm*In9uxa~qay9at6-pt7V?WB0ft7slNG",
                                    "type": "image"
                                },
                                {
                                    "id": 8168803,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c2b16eb4-de11-4d8e-8a9d-555b3d2c9f1a/width=450/8168803.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7A,F7E1k=-p~BxuEMRj9]Rk9aogX9s:IoR*",
                                    "type": "image"
                                },
                                {
                                    "id": 8168627,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/443fbdc3-69dd-4268-b3f6-3c5486e6202f/width=450/8168627.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPJHs@Kj*JI:0L-WH?xCOG-qe-t6.StSt7NG",
                                    "type": "image"
                                },
                                {
                                    "id": 8168693,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/25fd1ac1-8c32-4946-a35c-86a75308d14a/width=450/8168693.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCE_~+~WO[tS?^Ri%gtSxuIU9ZW;-;%M-ot7",
                                    "type": "image"
                                },
                                {
                                    "id": 8168697,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f77320e8-0e77-408f-b9cd-434f07f3542c/width=450/8168697.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJEyA5M{_4t7_3%MSiNHo#xZNHs.%MRjaxxa",
                                    "type": "image"
                                },
                                {
                                    "id": 8168871,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ef9281dd-d5a1-490b-8e76-b9e451050b72/width=450/8168871.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8GH*f4p0f-:FzkW~B%10g%1NHR%^jRjD*oL",
                                    "type": "image"
                                },
                                {
                                    "id": 8168963,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/50a6bf14-5854-4468-bf47-f6b7c1e5283a/width=450/8168963.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAH1**?H00?H0057%1-V%g?G~WX9IU%L4.D%",
                                    "type": "image"
                                },
                                {
                                    "id": 8168987,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fe8cba25-7555-4d3e-a326-6fe5b065b2c2/width=450/8168987.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5C5^$~A009u0MIp={s-RQIp9u-o9uxa^j57",
                                    "type": "image"
                                },
                                {
                                    "id": 8169036,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dd9b8f50-5e6d-4047-97c5-dc6e8da2da6b/width=450/8169036.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U384lJ4n00~qz.%M0LITH=ofTJkW9ZxvxDIU",
                                    "type": "image"
                                },
                                {
                                    "id": 8169067,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ddb79a1f-37d0-4542-877f-44ea1aa1225e/width=450/8169067.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8A]$:~V0L4:9aNGE1Rk0KIV-pxaS2ayenof",
                                    "type": "image"
                                },
                                {
                                    "id": 8169120,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/93c19068-b9b0-4d2e-a5dd-2146abf469ea/width=450/8169120.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBF=dp00UH~A_2%LWGxvNE%2D+NGEUxu?EIo",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/398803"
                        },
                        {
                            "id": 352749,
                            "name": "Latvian Doll Likeness",
                            "index": 3,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2024-02-20T16:33:40.877",
                            "availability": "Public",
                            "trainedWords": [
                                "edgLatv_woman,edgLatv_face,edgLatv_body, blonde"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 2413,
                                "ratingCount": 132,
                                "rating": 5,
                                "thumbsUpCount": 169,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 281083,
                                    "sizeKB": 18541.3203125,
                                    "name": "edgLatvianDollLikeness1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-20T16:20:44.790Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "14A3668B55",
                                        "SHA256": "14A3668B55D5DCE2307CBA4ACE38940939D593C5F41A39EF42E4A157C87FFA96",
                                        "CRC32": "459D9124",
                                        "BLAKE3": "8BD15AC5F33A2976BFFD6E2F7252BD0F741F19C250DD639C8E4D5FDB23FE841F",
                                        "AutoV3": "030B0AF4DB94"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/352749",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 6881291,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d1e4d431-3189-4fce-9574-6d4ba79a3a00/width=450/6881291.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5G9Ed00-I5Z_L4m5s?b=_00yG.9DQMH4o%h",
                                    "type": "image"
                                },
                                {
                                    "id": 6880950,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a97a86f2-22dc-4e20-9427-51a4968ca177/width=450/6880950.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIJ?pdOmlm}sT_Z#0MJR2vR4rEI:wPt2Xmi|",
                                    "type": "image"
                                },
                                {
                                    "id": 6881062,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c0675707-0b0d-4fe6-ba2e-9e95bd2fcace/width=450/6881062.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHJQH3001#ELUZInIBRQ,sxtVsV[pwxGV@X8",
                                    "type": "image"
                                },
                                {
                                    "id": 6880999,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8e70713c-d638-430e-a9b0-c6dd2b7c43bb/width=450/6880999.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTI4*6_45q%Mx^?H-;X8kBs:xuof9ZMxRPRj",
                                    "type": "image"
                                },
                                {
                                    "id": 6880949,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/90d262ae-2d50-4654-bdd0-cea90a3ee3ef/width=450/6880949.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBF#jz?v7$~VyCs:4;W;9[t7rrIo9cWV?G$*",
                                    "type": "image"
                                },
                                {
                                    "id": 6880951,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ea546fc0-cecd-4e4d-9ae2-606360da7e93/width=450/6880951.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "URJj#a-;_M?a_1xuE2kBNGs-RPRjV@oeSgWB",
                                    "type": "image"
                                },
                                {
                                    "id": 6880947,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e4b5e312-90b3-426a-843b-af726569081c/width=450/6880947.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDI:,,000z_N0Jt-IB8wUGU^vMY54T.8b]tR",
                                    "type": "image"
                                },
                                {
                                    "id": 6880948,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8f971f92-4fa2-400d-a34f-c6a49c30ab84/width=450/6880948.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UcLf{@IU*0%2.mtRnQxuRQadIUNGtRjuofWB",
                                    "type": "image"
                                },
                                {
                                    "id": 6880952,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4c1a0b39-3806-4883-b35c-7efd438a35a5/width=450/6880952.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKJ@nBMxUH%gyD%La1tRNtozrraKMxWBSxS2",
                                    "type": "image"
                                },
                                {
                                    "id": 6880954,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/32bf5129-f337-4005-b0b9-db52289bf094/width=450/6880954.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UcMjULD*y?x]L3kCRpW=x]ofrrni$*aya_of",
                                    "type": "image"
                                },
                                {
                                    "id": 6880996,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f8bf175e-596f-4f70-97f6-bd2d1029f661/width=450/6880996.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGFFdP0LDg9G{tM|9~$$xq%1R.OZ5@NK#R-5",
                                    "type": "image"
                                },
                                {
                                    "id": 6881020,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1659f909-dd69-4a69-9ef7-52aee6d13ad8/width=450/6881020.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKIEU[%M00~U00t6tmIpE0Myf9IpE1NGs;NG",
                                    "type": "image"
                                },
                                {
                                    "id": 6881041,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/457b1717-bb7d-4e52-9c89-e5694e204d10/width=450/6881041.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7HKnVRQ00-n00-p-rWU9a4:~V-qEOxasRxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 6881109,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/843be80d-2956-49c0-a4af-df5b90534a10/width=450/6881109.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U4ID]n003VH@tk00x].800~p00~V%#%2D*9u",
                                    "type": "image"
                                },
                                {
                                    "id": 6881132,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/148a0278-ec95-4dfe-931a-d23d8c2a5740/width=450/6881132.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8JHEm004mS%0J4o.8t95trWTLOs?]4:rB~U",
                                    "type": "image"
                                },
                                {
                                    "id": 6881242,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b822974a-5eec-4d34-9bff-b628710666a7/width=450/6881242.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UgKA~NM|*0xupdWYOFkB%Mt7juRk%NR*$%t7",
                                    "type": "image"
                                },
                                {
                                    "id": 6881259,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/728cf70d-f172-46ca-abf2-7ba64b52e994/width=450/6881259.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UYKnG3IUyZoc%%X.O@n3?Iw]RoS1%NIpxCxu",
                                    "type": "image"
                                },
                                {
                                    "id": 6881280,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a8e7c531-c783-4b13-9b7c-41206b83551f/width=450/6881280.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMGIr@x]JkS|PpyDX8t6_NyERkxDItbx%2of",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/352749"
                        },
                        {
                            "id": 329784,
                            "name": "Porcelain Doll Likeness",
                            "index": 4,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2024-02-05T19:20:12.483",
                            "availability": "Public",
                            "trainedWords": [
                                "edgCG_woman,edgCG_face,edgCG_body,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 2030,
                                "ratingCount": 64,
                                "rating": 5,
                                "thumbsUpCount": 171,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 261357,
                                    "sizeKB": 36973.8046875,
                                    "name": "edgPorcelainDollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-05T10:40:39.876Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "FDD0F60A",
                                        "AutoV2": "85DB590EA8",
                                        "SHA256": "85DB590EA8D2074D484ED10540F2C776D3F463083B101552F1D6055FEEC8EF7B",
                                        "CRC32": "B9829D04",
                                        "BLAKE3": "505B98A4B444B4CEA12D66AF1E6B8A623F66FC522FC99890B4EE564E11A88969",
                                        "AutoV3": "1C3E65DB2B4A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/329784",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 6285168,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d404c3f9-ed06-4a57-bc75-9af3e638a7e2/width=450/6285168.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFID:et,?tn5_MIp=yt7IoRPELX7kV%2M|E1",
                                    "type": "image"
                                },
                                {
                                    "id": 6283142,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/359cf331-b739-4904-873b-561617ad1015/width=450/6283142.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USJQ~3?H~WtQ?vV@ozWW?bRjNGkCkXf6aej[",
                                    "type": "image"
                                },
                                {
                                    "id": 6283143,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d51c863a-07b5-4961-bce5-8aaab123e34a/width=450/6283143.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9H_fAXnpJrq00Mx_N%#DOW=00nNE1t7DiM{",
                                    "type": "image"
                                },
                                {
                                    "id": 6283133,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2de129f8-f3d0-445f-96c1-102e1c461db5/width=450/6283133.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGHL3ft6GG%L0dR$4-s+WT%K-n%0~WobNeg3",
                                    "type": "image"
                                },
                                {
                                    "id": 6284419,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/af5486d4-7cbc-43c6-a5c0-3ea93ab90c50/width=450/6284419.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAIqx?%100S#9rxu^jE1xvWB~VRPj?IUIUo}",
                                    "type": "image"
                                },
                                {
                                    "id": 6284418,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/66da9c80-63ec-421e-8db0-3914ba0512f1/width=450/6284418.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKMs+g~q4n^j.8W?MxMxNft7V@M{%gxuITRi",
                                    "type": "image"
                                },
                                {
                                    "id": 6284722,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f667bfc0-18cc-415b-8531-d43812493678/width=450/6284722.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UILNAB^+*0_3Aa?bnN%NSh9F%1ae?HRjIU%L",
                                    "type": "image"
                                },
                                {
                                    "id": 6284773,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/99e5a1fb-027f-44ae-9d6e-a385ebf6f9e3/width=450/6284773.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGKATho3Aos:Y4?E=_Io5R~p-p^+^%NG%1Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 6284810,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b172d5b2-f0e4-46c6-b66a-cc7524c53518/width=450/6284810.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEG[Wk_4~V?H~q%2D*IUwHIU9Zt7IUNGof%M",
                                    "type": "image"
                                },
                                {
                                    "id": 6284860,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a9ca7c4d-d7c7-4360-91cb-c46bbe3f7d42/width=450/6284860.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9F#,bT0~qWU~A%L9aE1%1IoE1-p%0WCWBR*",
                                    "type": "image"
                                },
                                {
                                    "id": 6284917,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9ec88c7a-b317-4c59-8903-5f6280162e00/width=450/6284917.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGGkUnTdUH-V00rX4TS1Vqt7?HbvnSNGTKnO",
                                    "type": "image"
                                },
                                {
                                    "id": 6284919,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/70581792-3aa0-4207-ac5a-73efedcfbadf/width=450/6284919.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAIXEf.S00rWRO8w-;_NOS%fxtNZ00kCJPVX",
                                    "type": "image"
                                },
                                {
                                    "id": 6284951,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/33c6228a-b23d-4776-a9c3-54f0e2022a64/width=450/6284951.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UoJQ[@tStRxZ_Nxvt7WVtSt7o0WBaeaxWAWB",
                                    "type": "image"
                                },
                                {
                                    "id": 6284988,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fe075567-1878-436b-b837-5d28ff4ce615/width=450/6284988.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIHL6xxu~q_3-:IUE1V@ELoe-pD%Mxt7M_j]",
                                    "type": "image"
                                },
                                {
                                    "id": 6284989,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1879fce-051a-47ff-97f8-24797c8c389c/width=450/6284989.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UWKdb@Mv_NjE.9ozNGRPogWBIUofShWBsmkC",
                                    "type": "image"
                                },
                                {
                                    "id": 6285004,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/78a5dea6-aa00-4b69-b313-7aff1f043490/width=450/6285004.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U3E2a?0000$fPA$i9ZV[00t8~WI:00X9?G=|",
                                    "type": "image"
                                },
                                {
                                    "id": 6285049,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f2e01754-41f3-421b-aa86-1b30172d7130/width=450/6285049.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBEn|t~B00D%#P%1^k%ME2n$tRR+aJoLNeof",
                                    "type": "image"
                                },
                                {
                                    "id": 6285051,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/11e3a840-ff46-494f-ba1e-0c8d92670b5f/width=450/6285051.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5FF1@~W009FWTM{M{s;4nt7?aM{00IoK7.8",
                                    "type": "image"
                                },
                                {
                                    "id": 6285067,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d138b27d-9134-4c01-8c9d-ee990e109ff3/width=450/6285067.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCE2a?WBO=%2~Wa{xuof01a#xHRj9toLRQR*",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/329784"
                        },
                        {
                            "id": 308491,
                            "name": "Tomboy Doll Likeness",
                            "index": 5,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2024-01-26T17:24:27.525",
                            "availability": "Public",
                            "trainedWords": [
                                "edgtb_woman,edgtb_face,edgtb_body,",
                                " messy haircut"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3139,
                                "ratingCount": 111,
                                "rating": 5,
                                "thumbsUpCount": 296,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 243889,
                                    "sizeKB": 18541.3203125,
                                    "name": "edgTomboyDollLikenessv1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-01-22T15:30:52.315Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "D43D4D0436",
                                        "SHA256": "D43D4D043616B85DB020C1F492C504771D2B15041DC6E5C4A3D5EB1B85B06793",
                                        "CRC32": "B4B25263",
                                        "BLAKE3": "C63D47946410CAA35902F1D025EF6295809516C2EAE7D27FC2996B8BC017DF4F",
                                        "AutoV3": "97DD1DCFCF75"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/308491",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 5764060,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dff1c774-b3d8-420b-8c84-c18449995d51/width=450/5764060.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDGR9u0eTy4:7LIV^*D%57s.#lI:~BRjIUs,",
                                    "type": "image"
                                },
                                {
                                    "id": 5763904,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/41eae858-7156-4cab-8daa-5f587f3f7910/width=450/5763904.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKKAQW4.p{InGIR5%LROJBM{-pM{-mNcnhof",
                                    "type": "image"
                                },
                                {
                                    "id": 5763907,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b367e8e9-9431-40aa-aec5-644be492e93a/width=450/5763907.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USHU;2?b%#^j~q%hS$xa9u%M-pM|j=s,-Ua_",
                                    "type": "image"
                                },
                                {
                                    "id": 5763901,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d4195813-9380-41e8-8cdb-faad012811f1/width=450/5763901.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U4ATN8?GDzD*}4M|BYWB-?R*4m%2E0s.-pWB",
                                    "type": "image"
                                },
                                {
                                    "id": 5763898,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c0b872fe-d829-4cad-997f-48bc2d8541d6/width=450/5763898.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7AJKGEL8w-q]|Rj0%%0.TR*4.xaw[WBs:j[",
                                    "type": "image"
                                },
                                {
                                    "id": 5763896,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/651c9d18-fc0a-478b-bfc4-927aacbb3493/width=450/5763896.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDK1E*_3MvR5MINF~VRjyXRj,nxuoyRPMxf+",
                                    "type": "image"
                                },
                                {
                                    "id": 5763899,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9de2d1f8-8bbd-4b84-a997-f0b866630289/width=450/5763899.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULJH{]-:0KRlIoRjWAofE2V@t7bI_Nj@VrWB",
                                    "type": "image"
                                },
                                {
                                    "id": 5763908,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/06851141-a0e4-4ce4-a6da-ce635455b68a/width=450/5763908.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPKKZrVsJ:xtDjozRjWBE2o#?GjF~qaeMxof",
                                    "type": "image"
                                },
                                {
                                    "id": 5763909,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/241e6902-616b-419d-b12e-f84050992fb2/width=450/5763909.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKKA]4#P15IoFPDi~pkV9^NG?Hjt_N={aLs:",
                                    "type": "image"
                                },
                                {
                                    "id": 5763897,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5a3c317e-a41d-4261-8e28-672f35603654/width=450/5763897.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UVFiP+-oR%-:*0tSbGkDTKWB%Maetlj[M_j?",
                                    "type": "image"
                                },
                                {
                                    "id": 5763902,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7ed8292a-61e6-4bf8-9c07-d31d863c50d2/width=450/5763902.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UED]PNI;Y6^+~q-px]NH^+%Mbvs:-pRkSO%M",
                                    "type": "image"
                                },
                                {
                                    "id": 5763913,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/88480eeb-3634-4cf2-832d-fbad49843cea/width=450/5763913.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNLDx?xb?w%M~qWBNHxa0KWB?Gofw[ayR*WV",
                                    "type": "image"
                                },
                                {
                                    "id": 5763903,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dee90462-57c8-4e69-ba4a-643b14cd6dde/width=450/5763903.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQGk]~XTtmMw~qozWXIU%gV@%Ms.?bxuShoe",
                                    "type": "image"
                                },
                                {
                                    "id": 5763906,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/69185f6b-904a-4594-bb60-9af4ab3daa0f/width=450/5763906.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCG7xh9a0J%M}mt7%3nh0#xZ={X8Dioz%MM{",
                                    "type": "image"
                                },
                                {
                                    "id": 5763905,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/18280a73-3303-49ae-a93d-fe2444904df1/width=450/5763905.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UeJ8CSx]UHX9Te%3fkozs9bw$Msm%MaeozoJ",
                                    "type": "image"
                                },
                                {
                                    "id": 5763910,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dd7320b7-268d-4378-8ab3-a0e7db110540/width=450/5763910.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGIqr+Q-2[9|3G9X;2%g1Q*^OlogPDr:=|Nx",
                                    "type": "image"
                                },
                                {
                                    "id": 5764026,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d1688dba-65d9-42df-bc86-ffc3d686c00d/width=450/5764026.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBEVc{00*09FyD9FtlD%00xuwctR%#j?-pof",
                                    "type": "image"
                                },
                                {
                                    "id": 5764075,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d6e95edf-6081-418c-9cdd-737c084a89a9/width=450/5764075.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8F4[$$mH@#+Ipnj}URj02bu-:bbAuOB02WY",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/308491"
                        },
                        {
                            "id": 293992,
                            "name": "Venezuelan Doll Likeness",
                            "index": 6,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 23,
                            "description": null,
                            "publishedAt": "2024-01-12T19:33:03.311",
                            "availability": "Public",
                            "trainedWords": [
                                "edgVenz_woman,edgVenz_face,edgVenz_body, "
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 2956,
                                "ratingCount": 43,
                                "rating": 5,
                                "thumbsUpCount": 163,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 231372,
                                    "sizeKB": 18541.3203125,
                                    "name": "edgVenezuelanDollLikenessv1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-01-10T21:05:45.574Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "C209D2CEBD",
                                        "SHA256": "C209D2CEBDBE5FA6D32762C30268EB41D6153EA063D45F6935C47C0049C5D3ED",
                                        "CRC32": "CF83CF6B",
                                        "BLAKE3": "0E9C0AB8D88EA6A02016A68D3B2918273D462CDEF043A32FB93130E31BAC6C46",
                                        "AutoV3": "D062AD62C68B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/293992",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 5361668,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a7c6c8f9-8042-4013-b4a3-46527e5024ea/width=450/5361668.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFH^6RIA7FNt*H9twcw|o},G,@OX$jJ7Syja",
                                    "type": "image"
                                },
                                {
                                    "id": 5361684,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/66d560b2-2c12-436d-8a8a-c653e49b00c7/width=450/5361684.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHJ@8zWrJOx]y?R,-U%25rs-MeEgozt8MxRP",
                                    "type": "image"
                                },
                                {
                                    "id": 5361675,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/896a7754-8fb9-4549-b693-08a9768f566d/width=450/5361675.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9IgAcxv*G0hYN?H^6bc57E2M|={%09anOxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 5361674,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cfdbef6a-2b90-4a3b-95bf-7ad4748046c4/width=450/5361674.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFKcIc~C8_IBz;Rj~V-p57RkIps.s:R*IoxF",
                                    "type": "image"
                                },
                                {
                                    "id": 5361670,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9bb3ed32-b564-4894-ac6d-d07f72e96bd5/width=450/5361670.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1349,
                                    "hash": "UMM6@$9Z?^^+p_IArrR,4n4n9FbI-VIUM{%M",
                                    "type": "image"
                                },
                                {
                                    "id": 5361666,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6eeb07f1-c28e-49b5-b189-1d5fa0e0889a/width=450/5361666.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNKTxs_4PqI[Tz%MaJt6yDNG-Uni-;f6s:t7",
                                    "type": "image"
                                },
                                {
                                    "id": 5361669,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8cc3cf14-fb08-45a7-9a72-3a1f3fa2f651/width=450/5361669.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEJkce^NCPTJ03M{E0I.#kNY+ErWL4ro$dw[",
                                    "type": "image"
                                },
                                {
                                    "id": 5361665,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/291d0c6f-1fed-485e-8857-1fa636977211/width=450/5361665.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAB{fY$*00og.mWU9FNc~Wae4otRtlR*a0%1",
                                    "type": "image"
                                },
                                {
                                    "id": 5361671,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad9d3137-d817-40ac-a833-e38054383cf7/width=450/5361671.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBG7b]xu4Trr~Wt7DiV@;4s.}ts:rqsm$kj]",
                                    "type": "image"
                                },
                                {
                                    "id": 5361667,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/353968b3-e1e2-4171-a543-e370cc2123d6/width=450/5361667.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5D+J0#?00031G-Vv~NLv~AA$m~BFZ-nMzIW",
                                    "type": "image"
                                },
                                {
                                    "id": 5361717,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a72ba82f-ee52-4ead-b854-da758ba6312e/width=450/5361717.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8C$l:^*rAxa|B$%yZR*_4R+9EE2xBM{EM%L",
                                    "type": "image"
                                },
                                {
                                    "id": 5361672,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/83692ff0-10e2-4be2-94fe-260cc8f083cd/width=450/5361672.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCHeLB00Q59F0wSOVaIo~Js?Nt-:EgITaL-:",
                                    "type": "image"
                                },
                                {
                                    "id": 5361673,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/26c5bbff-9579-42e3-9a39-6313f1ea8232/width=450/5361673.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8Fg?|so00g30Ls:^*i{0zRk}tkW?]bb56oL",
                                    "type": "image"
                                },
                                {
                                    "id": 5361676,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/845ed326-082a-4cda-b82c-3a5a97e14dba/width=450/5361676.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6E-s}-p00o|0hxa^PM|0fEL=xxa~Uoe57V[",
                                    "type": "image"
                                },
                                {
                                    "id": 5361678,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f6f3a45d-ec3d-4ee7-989a-f18464ef58e5/width=450/5361678.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAFqj,xaW9~AELEM57%20LIp-ot6%2-UxEIp",
                                    "type": "image"
                                },
                                {
                                    "id": 5361679,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f70afd2e-fd30-40d5-9cd8-342c884367d3/width=450/5361679.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U3EBso00009u~B01E2?G00^P~C-oR5-o%10z",
                                    "type": "image"
                                },
                                {
                                    "id": 5361681,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5c66950d-6daa-49c4-9fa4-f4c03da7b18c/width=450/5361681.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9EeGZxG9tRQ~AV[0fR*tPaxxabb%1fP=|sC",
                                    "type": "image"
                                },
                                {
                                    "id": 5361682,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b6db4c5d-42f6-4c3c-8ae0-a90b42f3046a/width=450/5361682.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1024,
                                    "height": 1441,
                                    "hash": "UJGt~S00~p4.?aD%OZM{JAadt7R*NFbbsoxa",
                                    "type": "image"
                                },
                                {
                                    "id": 5361680,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/306fb657-f6a6-4097-9a34-4259133ed1be/width=450/5361680.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U2BewIwJ0c^53UI.9EOsQS$j}bjF00XTTfRi",
                                    "type": "image"
                                },
                                {
                                    "id": 5361683,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/efd216ff-41c6-4577-af5a-9bcfa37ec484/width=450/5361683.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNJaZb_4.m_3r:IUxFRPozD%r?IURit7R*s.",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/293992"
                        },
                        {
                            "id": 268175,
                            "name": "Greek Doll Likeness",
                            "index": 7,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-12-29T13:00:00",
                            "availability": "Public",
                            "trainedWords": [
                                "edgGrk_woman,edgGrk_face,edgGrk_body,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 4242,
                                "ratingCount": 122,
                                "rating": 5,
                                "thumbsUpCount": 331,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 209145,
                                    "sizeKB": 18541.3203125,
                                    "name": "edgGreekDollLikenessv1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-12-19T20:55:48.588Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "DDDBF1DBCE",
                                        "SHA256": "DDDBF1DBCEC10A1F1CD924769F3B51F1878F8B411B0B3324DE73777F36AC7D38",
                                        "CRC32": "0702161A",
                                        "BLAKE3": "EE47D07F7841E8FCA98828CEB08D201F63F623B7D9B9F7DB97AB4EB1D8B13E35",
                                        "AutoV3": "A8DFB4D4BD42"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/268175",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 4721449,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c2b46aca-2447-4365-b020-33598e5233c1/width=450/4721449.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQHK@9Mw%ME1~BRjNxRkEME1-oxtozM|$%t6",
                                    "type": "image"
                                },
                                {
                                    "id": 4721454,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad8c2a1e-27d5-4773-a784-8595067c0fdf/width=450/4721454.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UbHTs}NE7KxGYkrq$jS#X.Rj$Qa#R:bbR*ae",
                                    "type": "image"
                                },
                                {
                                    "id": 4721453,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/902d02fe-16bd-4a1b-b49c-91ad80fabfb3/width=450/4721453.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U45}UA9~J8-UlC%29uoyo|RjxDI;IToaW.sm",
                                    "type": "image"
                                },
                                {
                                    "id": 4721450,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9d8c5b3c-156e-42f2-9eca-b2785d370c37/width=450/4721450.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJHT~o~V0yOrX9o|s;ag9uxakCR+NHs:xZe.",
                                    "type": "image"
                                },
                                {
                                    "id": 4721452,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5a10faf3-19c9-445f-8cd0-d1152c7e6e5a/width=450/4721452.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UfL47}%$t-wHLNJ:S%RO-qrqt7Vs=_$eV@a#",
                                    "type": "image"
                                },
                                {
                                    "id": 4721456,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d9ce56d9-9956-4607-bfcf-5da0f9720626/width=450/4721456.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UYMP{|.8?^-;?^R+tRWXtmt7smn%ozt7aKWB",
                                    "type": "image"
                                },
                                {
                                    "id": 4721455,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/94c711a5-5f29-4973-9f74-5db1eb4aeeeb/width=450/4721455.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U584b@Di00~q^kbb0zxD00t7?HIU57o0^jR-",
                                    "type": "image"
                                },
                                {
                                    "id": 4721459,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4e1d803c-dc50-42f0-bcc7-be6661808370/width=450/4721459.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMG@[V?H0KR%?^tR4.ae?Hoe$kt7Ioaeaeof",
                                    "type": "image"
                                },
                                {
                                    "id": 4721457,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0fe8ce89-bffd-4b07-88e9-09364f0f857a/width=450/4721457.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UfPPr$t7.A-:xvj[ogofW@f5s*kCkCofs:ae",
                                    "type": "image"
                                },
                                {
                                    "id": 4721461,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c761f54e-0e53-462c-ba47-fd6a02d03af7/width=450/4721461.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UaMPtXD%?b?u~qIVWB-;M{t7xaRQwO%M%1ax",
                                    "type": "image"
                                },
                                {
                                    "id": 4721460,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d701d7b-a29d-4ac3-ad7d-093871326deb/width=450/4721460.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UENJgzWXpf?G%3xuV@%10PIU$^kC8^xaWBR,",
                                    "type": "image"
                                },
                                {
                                    "id": 4721462,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7805c6b2-f921-4a87-ac8e-31091c343347/width=450/4721462.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UOKwLV_3%~S5_Nxut7R+K5tRi^V@-pX8RjxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 4721463,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5fdaf271-09ec-4f8d-9077-b754d796b132/width=450/4721463.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "URKv{ns:Kixu_Moe%1RkSLxaa0M{-pW=R*t6",
                                    "type": "image"
                                },
                                {
                                    "id": 4721465,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e8a3cd21-16cb-4ba6-b458-b479683572d9/width=450/4721465.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UA8}rhbH4TozH=ofO@WBDhj[v}adc[WB#7j[",
                                    "type": "image"
                                },
                                {
                                    "id": 4721464,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c456c989-379c-4f87-a635-7aa0d53a005f/width=450/4721464.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1485,
                                    "hash": "U7EK+NSN00+^8{-U~BVt0yM{x]%MpIWB57J-",
                                    "type": "image"
                                },
                                {
                                    "id": 4721467,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ae3b40ea-cbca-44cd-95a7-e414bb5ac345/width=450/4721467.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJA1^xk78wo$MIaeSwkDNqa%Q,adlVof,:fj",
                                    "type": "image"
                                },
                                {
                                    "id": 4721466,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0b887581-d6cb-4b6e-bbcb-712852a9d623/width=450/4721466.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8I;9qTJ3r^k3=nN[;S~0}t7}@Rk^+NwMKxa",
                                    "type": "image"
                                },
                                {
                                    "id": 4721469,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f965c9b7-d9c4-4fc6-9f72-b25b15dc6e13/width=450/4721469.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAHUnMTJEk?H?HIV.8-;IUnNEMt7~p-oIB9a",
                                    "type": "image"
                                },
                                {
                                    "id": 4721468,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/170f8542-0819-45f7-810a-40108133badb/width=450/4721468.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USJ89J~pVsD%~VoftRRjD*IVbuoJyCRjMxjY",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/268175"
                        },
                        {
                            "id": 47576,
                            "name": "French Doll Likeness",
                            "index": 8,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2023-04-17T00:36:17.469",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful frd_woman, perfect frd_face, perfect frd_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 7917,
                                "ratingCount": 120,
                                "rating": 4.99,
                                "thumbsUpCount": 138,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 35341,
                                    "sizeKB": 147590.0712890625,
                                    "name": "frd.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-17T00:30:54.194Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "0448A646",
                                        "AutoV2": "28E26785B0",
                                        "SHA256": "28E26785B0A8991C78E581D5DFE94AEA9AF2E60DCE472DCCDEB67AB81A3BDEBF",
                                        "CRC32": "77CE933A",
                                        "BLAKE3": "BFFD343C86F3312628095F505D1A8819DAE1A21C340B6924C8F9E44FE1294AB6",
                                        "AutoV3": "9AD30E274C08"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/47576",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 512718,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bbb18d62-6155-4d3a-a4a6-9cd51c90cb00/width=450/512718.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U6Fq,hFx004VSb^,M~0000D%^*?b9GD$-:~W",
                                    "type": "image"
                                },
                                {
                                    "id": 512717,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bc254574-a71a-499c-b81a-907ee39e7f00/width=450/512717.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UAF5me00?]0L01%MM{V@EhM{?H%1r=xtM{9u",
                                    "type": "image"
                                },
                                {
                                    "id": 512722,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/07fdf830-7bf8-46d2-6bbe-a5f4d8bfd500/width=450/512722.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UMEVKN9G4o~W-UaeNxt757ae%1WBNGWqxGni",
                                    "type": "image"
                                },
                                {
                                    "id": 512725,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e056ec1e-3a98-4588-925f-2fee5c6feb00/width=450/512725.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UNINv=kCkX~VD*~Uxs%2Inxt-oM|^*V@WBR+",
                                    "type": "image"
                                },
                                {
                                    "id": 512720,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/76947279-aec3-43da-42bd-beaf757fcd00/width=450/512720.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UFF=5W5700~WtR9ZM_?H9t?H-pD*IUIoNx%2",
                                    "type": "image"
                                },
                                {
                                    "id": 512716,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b9d702de-b21a-4b55-a340-47c4c631de00/width=450/512716.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U5DIwQ00ui00r^RiPBMJ01%Lv~^*4.xt=yt6",
                                    "type": "image"
                                },
                                {
                                    "id": 512715,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8b33b978-1a16-4a74-8d3b-487a85495000/width=450/512715.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1049,
                                    "hash": "UEF5mh_4+?5S0f9uF2x]1Q?GM{-p%gtS-Vwv",
                                    "type": "image"
                                },
                                {
                                    "id": 512733,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d20685f4-4257-4c0f-c627-68ba4ee1ca00/width=450/512733.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UCHT{l}@00_2009t9tE2.8?G^QE200oztSNG",
                                    "type": "image"
                                },
                                {
                                    "id": 512721,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1755f80a-6360-4279-d6df-ec4af2da0300/width=450/512721.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UAFq{[t0o[~B?Z^ixuEL$*IpIo-o0MIVr@Sf",
                                    "type": "image"
                                },
                                {
                                    "id": 512724,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/470f4ec2-1cf5-44c9-b003-19abf7805000/width=450/512724.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDIqo*003GT002%LyE-pER%KMyMx~UEQVr?b",
                                    "type": "image"
                                },
                                {
                                    "id": 512732,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/793f1ca3-2a15-45b6-1fb7-2a9484797200/width=450/512732.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UTH.7*_2_N~W?I-;-;xuOsxaw]M{-;ocWVof",
                                    "type": "image"
                                },
                                {
                                    "id": 512727,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4a604a09-9bd9-40e5-cc41-c51231728000/width=450/512727.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UPIqfWNGE1?HD$~V?HxaXSxZ$$E1xZIVjZR+",
                                    "type": "image"
                                },
                                {
                                    "id": 512726,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bc5335dd-b674-4161-9904-3aba4b1e8000/width=450/512726.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UNG*.-~p57?H?G_3-;IU9uRj$%NbM{Rjofxa",
                                    "type": "image"
                                },
                                {
                                    "id": 512758,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3f25a689-1f1f-4401-ca4d-2d487153f800/width=450/512758.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 660,
                                    "height": 1296,
                                    "hash": "UYJZ@{~VTKxuJBS4xas.57ni%1e.ofWBWCR+",
                                    "type": "image"
                                },
                                {
                                    "id": 512719,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8d189de9-a834-494f-313b-3b85a0a3bc00/width=450/512719.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UNELscMy9FbH}?E2tlaebvE2={NGS#IV-oof",
                                    "type": "image"
                                },
                                {
                                    "id": 1450331,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e52a26f-3d1c-4d40-a801-651e5cb2eaae/width=450/1450331.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9B3mMXS0#~Wz-%g9ujE0hnO^PI;11V?~Vbb",
                                    "type": "image"
                                },
                                {
                                    "id": 1450332,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/800db454-24c1-40fe-b920-764739d8be03/width=450/1450332.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U48;A94:0f-n~W?H0fI;nOxuo}WB4oof?HRk",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/47576"
                        },
                        {
                            "id": 222732,
                            "name": "BlondeBimbo Doll Likeness",
                            "index": 9,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 14,
                            "description": null,
                            "publishedAt": "2023-11-12T17:07:42.279",
                            "availability": "Public",
                            "trainedWords": [
                                "blonde hair,edgBB_woman,edgBB_face,edgBB_body,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3556,
                                "ratingCount": 78,
                                "rating": 4.97,
                                "thumbsUpCount": 146,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 171729,
                                    "sizeKB": 18541.3203125,
                                    "name": "edgBlondeBimboDollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-11-12T16:55:55.190Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "2C3A6C8DBC",
                                        "SHA256": "2C3A6C8DBCC46C7FE6631592D29620AF1F822B9A256AD34C9F5FABBC1F695CCF",
                                        "CRC32": "722A9D1D",
                                        "BLAKE3": "4011F8B6154E5DFD3920BEB473848ABE8F84B7D4CD43636D67B3142272FBF1F5",
                                        "AutoV3": "48C538F1F09E"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/222732",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3573957,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3a8f5cb2-e57e-4b2c-b87c-5204f8ccd8eb/width=450/3573957.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U38pcQA;0|+w6L=K02Ef~VR+WCX8DjN[xtwy",
                                    "type": "image"
                                },
                                {
                                    "id": 3573812,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c2327356-2ec5-4fbd-a0ef-32d101c908fd/width=450/3573812.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPHd{eR.YPMx1H9aVZIo~V%2R*awV[ShS#r?",
                                    "type": "image"
                                },
                                {
                                    "id": 3573730,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8a8832e3-94c4-4c0f-8af1-9f6c728d2d51/width=450/3573730.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFC?1BogE2={~UNHMx-n?Ha#R%WUtRoLxDoI",
                                    "type": "image"
                                },
                                {
                                    "id": 3573685,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/26c1b164-b12f-488a-9d53-9eb8eae56dd4/width=450/3573685.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5CY]#yY00UuE3nh%ONa0ixa?GW90hnh}mt8",
                                    "type": "image"
                                },
                                {
                                    "id": 3573740,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/753e810d-c9ff-4e83-b470-ea978f51aae8/width=450/3573740.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6D[^IM}0Mx]ngE2009ZbuIV~BD*0M%L~BE2",
                                    "type": "image"
                                },
                                {
                                    "id": 3573752,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/996ba623-8fb1-4403-8737-a26bdd1593fd/width=450/3573752.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "UBEx*2K7TK-p~Bx]0Mt7%MIVRj9a~U%1=_-U",
                                    "type": "image"
                                },
                                {
                                    "id": 3573817,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/58342ed1-89c4-4726-8de7-21787283be21/width=450/3573817.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJG*~W02-{nf0*w[5EWB~nR$NNs=pdR5%Lac",
                                    "type": "image"
                                },
                                {
                                    "id": 3573858,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/68d59c40-068a-4395-89ad-dd2e25164893/width=450/3573858.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UaKUA#9Z_Nx]Mx%MX9IUR*f5t7e:ofjss:WW",
                                    "type": "image"
                                },
                                {
                                    "id": 3573924,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4a45c5bf-1dc4-4111-bfd1-6e4bb99c4694/width=450/3573924.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U47TqUM{9F-V_MNG0yt7%3oJRPkCEkxF$%n*",
                                    "type": "image"
                                },
                                {
                                    "id": 3573882,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/388a389d-0abb-4834-82b8-d8882a146721/width=450/3573882.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U27mjJ5k00b^~p=K01$%:+XSNLNZR6WB^*Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 3573896,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a850853e-e91b-47c4-b2cc-a92b7b31b957/width=450/3573896.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPF5gV?HE#-;_NNwIA$*-pV@IUoet7xaX7X8",
                                    "type": "image"
                                },
                                {
                                    "id": 3573902,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/17a51b3b-ecaf-4c22-8a5d-1aaea142f694/width=450/3573902.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9CO|0^Q0|9[*IE}DiMeM{xaxaWW8{V@yCXS",
                                    "type": "image"
                                },
                                {
                                    "id": 3573970,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bd8d753c-dc04-498b-b970-849080694b1c/width=450/3573970.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMFsShzWQ7#ri{GXDPM{-DVsMxOT%~wfo}sA",
                                    "type": "image"
                                },
                                {
                                    "id": 3574031,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1bb32b67-13a0-4ad9-8eb3-43daa293ded9/width=450/3574031.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9G+UEG[2]%~DN00[UiIdByXERx]v2xZNeRQ",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/222732"
                        },
                        {
                            "id": 178663,
                            "name": "Argentinian Doll Likeness",
                            "index": 10,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-10-08T21:46:16.166",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful edgArg_woman,edgArg_body,edgArg_face"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 4790,
                                "ratingCount": 116,
                                "rating": 4.99,
                                "thumbsUpCount": 192,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 136689,
                                    "sizeKB": 18546.21875,
                                    "name": "edgArgentina_Doll_Likeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-10-08T21:35:45.203Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "9947B45E5E",
                                        "SHA256": "9947B45E5E4155E2EF6B86E3B84A85C03ECEF4147A1609E7B60EDF80C6B91C42",
                                        "CRC32": "F539301E",
                                        "BLAKE3": "BA4953ADFD1DCFB330F32F569AE7A7B7FC0127064A02D2AAFFB573D45A65762C",
                                        "AutoV3": "E32282CC784B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/178663",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2857378,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/05117873-920a-4835-ae02-c889eb469b93/width=450/2857378.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U77^_Pr=0LJ9_4aKI:WWEkR+?GsS00kW?HVs",
                                    "type": "image"
                                },
                                {
                                    "id": 2857371,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a0f5ba10-2afc-4c8a-9193-9368911a9750/width=450/2857371.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U38zoo00T0t6Di.800~Vwbxu9tV@%gIUsn%M",
                                    "type": "image"
                                },
                                {
                                    "id": 2857370,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/20b05dca-7ab7-4136-aab9-c8116566cc8d/width=450/2857370.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UME2@800_N8_x^9FtRxZxtoJkCt7kXM{t7WV",
                                    "type": "image"
                                },
                                {
                                    "id": 2857373,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e5de22cd-9036-4de7-9089-ab29db77174f/width=450/2857373.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U77A*txZ4.%2~Bs:9Zs:xZNHE2R+NHNGM|R+",
                                    "type": "image"
                                },
                                {
                                    "id": 2857443,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/60f9c03c-8e76-409a-88c8-a8e0438df7b6/width=450/2857443.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U27nXf~B00XoV?t74T009FNyIpMx9tWB^+$$",
                                    "type": "image"
                                },
                                {
                                    "id": 2857445,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b78e05d7-69ba-4a74-9792-0be374607710/width=450/2857445.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UdK0]MXS?v-;.mxas;x]-;ogRjt7xuoyRjR*",
                                    "type": "image"
                                },
                                {
                                    "id": 2857451,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7e39dfbf-b647-412f-b565-48c1f84ee799/width=450/2857451.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJHBYzM{_Mxa_Maex]ofx^axo3WB%hM{RnM{",
                                    "type": "image"
                                },
                                {
                                    "id": 2857464,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a2108673-10d3-46ed-bcde-b1e2a943f12d/width=450/2857464.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEJt@[~V0eR,4oNfE2RjKkNG4Tad?badjFe.",
                                    "type": "image"
                                },
                                {
                                    "id": 2857493,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/85e62f44-1999-417d-9e34-bd8e628a0c10/width=450/2857493.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UYJkG#ay_N?byDa#xuR+%MRjM|t7-;RjM|t7",
                                    "type": "image"
                                },
                                {
                                    "id": 2857494,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e3ac13f-ddc1-44dc-bc50-625175c4c01a/width=450/2857494.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCHB#p?uNXnz_N_MM|D%-;?ctmIU00-;xuIU",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/178663"
                        },
                        {
                            "id": 130236,
                            "name": "Australian Doll Likeness",
                            "index": 11,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-07-31T13:09:01.272",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful blonde edgAus_woman"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4838,
                                "ratingCount": 94,
                                "rating": 5,
                                "thumbsUpCount": 145,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 94435,
                                    "sizeKB": 18547.7890625,
                                    "name": "edgAustralianDoll.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-31T13:05:43.933Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "6B1888FFB0",
                                        "SHA256": "6B1888FFB026DFB5A7A0FDA2B7C2328A2D3E5FF1B59C1545E1C1822B8555D269",
                                        "CRC32": "6293D8C7",
                                        "BLAKE3": "1EE4B14D371B12446E24504725EE8B8BAE22E4E99D54E1FC17C3CE66F608ABBD",
                                        "AutoV3": "9485055382FB"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/130236",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1807577,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/78a941d7-2a07-485e-b6dc-a81eb9d10af7/width=450/1807577.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "UaK1By_NJCxZE.T1R+t7p0kDw[aKNIV@RPof",
                                    "type": "image"
                                },
                                {
                                    "id": 1807584,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c6960c8b-8866-492c-aa82-4c0a510a9cbe/width=450/1807584.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "UDLNMfQl009G03H=k?i_5AI9*0%MA1Z}WFj[",
                                    "type": "image"
                                },
                                {
                                    "id": 1807605,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/92606655-08a4-4572-b106-ea62b65b56bf/width=450/1807605.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UQJ@tLxaEgE20hx]IpR*?wx]$zxZx^tSRPV@",
                                    "type": "image"
                                },
                                {
                                    "id": 1807571,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5a103cd3-d9e3-4b19-b4ba-2aa84f57b8f3/width=450/1807571.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UKK,{ZM}0gXTE1xZE2oz~qWX^jIpp0NGE2W=",
                                    "type": "image"
                                },
                                {
                                    "id": 1807581,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d3648842-8c78-47a1-8e1b-02e8cc30b9b3/width=450/1807581.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UaJtYe~qE2JCS6kro~S4x^tlkXn%IpM}WDs:",
                                    "type": "image"
                                },
                                {
                                    "id": 1807567,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8f8d2916-4c44-4d6b-88cc-f68780d286b1/width=450/1807567.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "URD]C,_2fkaz~V?ao#t7-p%Mx]xuo#tRtRkC",
                                    "type": "image"
                                },
                                {
                                    "id": 1807565,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5c11c2b2-d2d5-4b1f-b37b-08fa21fe8853/width=450/1807565.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U8B3QY0g0Lad~9Io9uofIoNH^*Ip58xZxYM|",
                                    "type": "image"
                                },
                                {
                                    "id": 1807568,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9eb77370-19ff-4f4c-ba71-64edb985ae47/width=450/1807568.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9C6cA0100_3}?I;57xZIANHtln$M|R+%2Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 1807569,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/94b844a4-37de-42f5-a9e0-66b7c1db2518/width=450/1807569.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "URHK^LRnPBWr_NIqWXRj_3Ip%1ni.TR,%2bI",
                                    "type": "image"
                                },
                                {
                                    "id": 1807570,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/309aff33-5e43-42d8-b2bf-0bf47d6dd2ef/width=450/1807570.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U4D8wT-;015T}:9b02020h9v~V%M0157^i=_",
                                    "type": "image"
                                },
                                {
                                    "id": 1807574,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c9f981d9-3a4d-4e28-8e11-8051c98f3eec/width=450/1807574.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJD*^O^j9uWE~AxZ9uIqI=oct6ofNd%0-n%1",
                                    "type": "image"
                                },
                                {
                                    "id": 1807578,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3965543a-e78d-4770-8cfc-aac523872d6c/width=450/1807578.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UxI}Is.TpJT1JDOZXnozM|jFaejYRkayoJae",
                                    "type": "image"
                                },
                                {
                                    "id": 1807576,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b7e9d480-dacc-4470-ac92-cb3d8422876e/width=450/1807576.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULG7#kGI9^Vs~US%%1E2%h%MxuIoOttR%2sB",
                                    "type": "image"
                                },
                                {
                                    "id": 1807621,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3203a06d-9224-491f-9ff9-e7d8600b8b9b/width=450/1807621.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFEeGW~p64^jyC?GxaR+9^9b9bS54;EMbII;",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/130236"
                        },
                        {
                            "id": 263470,
                            "name": "Pinay Doll Likeness",
                            "index": 12,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-12-15T15:00:54.304",
                            "availability": "Public",
                            "trainedWords": [
                                "edgPinay_woman,edgPinay_face,edgPinay_body, "
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 2475,
                                "ratingCount": 30,
                                "rating": 5,
                                "thumbsUpCount": 67,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 204978,
                                    "sizeKB": 36973.8046875,
                                    "name": "edgPinayDollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-12-15T15:00:50.291Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "87A59EF8",
                                        "AutoV2": "FAD9AFC523",
                                        "SHA256": "FAD9AFC52363B9798951248649E5DFA27091FEDD1C57262E58BAD13D7237C2BE",
                                        "CRC32": "FC5F4D76",
                                        "BLAKE3": "98079B01BE13011358127305DF20450DBAF0DAD43AF6E3C651344446195C5914",
                                        "AutoV3": "C89B9E5C17BB"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/263470",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 4606468,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/557d37c3-55da-44d0-9f39-7c51077877fc/width=450/4606468.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDF4.j=qM]-o}hEm-p$yEmxC=]NekWbFxZoI",
                                    "type": "image"
                                },
                                {
                                    "id": 4606463,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/586e524f-16e5-4d48-88f0-a017e79309b2/width=450/4606463.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7EeJmI;00~B?3R-Rjov05={tS9v0PWrV{IV",
                                    "type": "image"
                                },
                                {
                                    "id": 4606466,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/969f7278-2389-45fd-8fb7-39e73c504bf9/width=450/4606466.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBDk*?V[00X7_MWCIAoL%gX6n4jGtSsoNFNa",
                                    "type": "image"
                                },
                                {
                                    "id": 4606447,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eabdf23b-d810-45a2-af2a-1aec2079f53b/width=450/4606447.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIC~3TWV0Mfj~Af69aj[%1bGM|jakCoLNHWV",
                                    "type": "image"
                                },
                                {
                                    "id": 4606450,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1aca0d5e-45b8-4c4f-b7dd-854213eb8a8b/width=450/4606450.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UWG@=4xaRiWB~pbHM{WCbwWBM|kCo}ayslof",
                                    "type": "image"
                                },
                                {
                                    "id": 4606448,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/31cac7af-6dc0-4804-84e9-67ec47b9d046/width=450/4606448.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEJ%tft900E0DzNG~XWA=^E0^+?H^+xaNGxu",
                                    "type": "image"
                                },
                                {
                                    "id": 4606452,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e7a23608-a180-4853-a2e8-bbdb942744db/width=450/4606452.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UYGIr=%L-;ww_4jYbcNGT2WqX8WqyDbHxGs:",
                                    "type": "image"
                                },
                                {
                                    "id": 4606451,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d314255c-a765-4abc-a6bd-d5e9b0895ca5/width=450/4606451.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UADRvXt69ts9_Ks:02R*^%oeR+j[#moLNIoM",
                                    "type": "image"
                                },
                                {
                                    "id": 4606455,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/199069a2-8618-4b8a-b900-5dff2aee5fa6/width=450/4606455.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPIh54?b.Tx]?aE1xaxuXmo2RPoz-nxuIoRk",
                                    "type": "image"
                                },
                                {
                                    "id": 4606454,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/384322aa-0a43-4830-98c3-afde761f36e5/width=450/4606454.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQGkqLnhKjo}_4aK%2krXoW;aJt7tSofNGof",
                                    "type": "image"
                                },
                                {
                                    "id": 4606459,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/70f333fd-33c4-40f7-9d8d-69f6bdd4b2e9/width=450/4606459.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UqM?@{RP_4-;-=R*oftRj]xaaeR*%2fkWqWB",
                                    "type": "image"
                                },
                                {
                                    "id": 4606456,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cae49a7d-d53b-424b-8201-19926e6d9380/width=450/4606456.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJIp-$R.K7^kD4r=I9-A=zrqn3NI~CkX%#so",
                                    "type": "image"
                                },
                                {
                                    "id": 4606458,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ba8bd486-7e6e-4a5f-b9b5-df3f52f5dd9e/width=450/4606458.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1468,
                                    "hash": "UIDSd^xuW5bE~8xu4.R%?As:ETWANLazkDWB",
                                    "type": "image"
                                },
                                {
                                    "id": 4606464,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/deb7c377-9b5e-483f-a3db-e81c5a9c761f/width=450/4606464.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNHKhPNgQ*~S_2s:9uxt%J%0RpIun#k9kWWE",
                                    "type": "image"
                                },
                                {
                                    "id": 4606462,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/abbeccd8-48e7-499e-a3fd-718b6217c2e2/width=450/4606462.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 708,
                                    "height": 1536,
                                    "hash": "UKJ61%t758-C}]t7=|-o,r%2-:ni#pa#xt$%",
                                    "type": "image"
                                },
                                {
                                    "id": 4606460,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a02648d7-5141-44ba-8177-d394da88208c/width=450/4606460.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKKHIOJ8zWxa^*oM9[bGOEs:GDR*}ZjZR%t6",
                                    "type": "image"
                                },
                                {
                                    "id": 4606449,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4c51e018-65e1-4932-ac47-72fc22926f24/width=450/4606449.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USLpaG~V_MIp.8oyt7M{tRkWt6V@tRRkxZjZ",
                                    "type": "image"
                                },
                                {
                                    "id": 4606446,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dac60e9f-3012-4a5c-963a-8013fb622f7a/width=450/4606446.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBJQA:%31*-UYRIq?H%1XAxC%LM{?HxaIpIp",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/263470"
                        },
                        {
                            "id": 245999,
                            "name": "Influencer Doll Likeness",
                            "index": 13,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-12-01T16:38:23.344",
                            "availability": "Public",
                            "trainedWords": [
                                "blonde,edgInf_woman,edgInf_face,edgInf_body,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3621,
                                "ratingCount": 85,
                                "rating": 5,
                                "thumbsUpCount": 204,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 190455,
                                    "sizeKB": 18541.3203125,
                                    "name": "edgInfluencerDollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-12-01T16:40:44.926Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "DB16EC5BD4",
                                        "SHA256": "DB16EC5BD4FA38F93E7D065F7C1646EB96B436CE31BC48115D5917434571845E",
                                        "CRC32": "75BABD17",
                                        "BLAKE3": "515F14DACBCBB9C03B3C84030FC22BD8DDC35B0042DD28589552FFFC8AEF30BA",
                                        "AutoV3": "7575CF50F268"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/245999",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 4085206,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a54a8b06-fa04-4c09-865f-f06e56ed64e8/width=450/4085206.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "URIz6p}s0ebb8_spTJIo+cnOb]%Mo|S}O=SM",
                                    "type": "image"
                                },
                                {
                                    "id": 4085207,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ec4492ca-53bb-46e3-9c02-215699098b4b/width=450/4085207.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UED9YX0L00~WDh%MIVn$9unh-pW?IVxus8E1",
                                    "type": "image"
                                },
                                {
                                    "id": 4085193,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e57892fb-40f5-4a5e-ab1b-04bd9ec9fe0a/width=450/4085193.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHFOZJ9Y0Ms+~pIUIpof4;j[xXogaextRkNH",
                                    "type": "image"
                                },
                                {
                                    "id": 4085197,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ab02da86-8a8e-425f-84ea-8da735fc9e03/width=450/4085197.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UgL2@=%2qus.}EaKicfQRjR%NHWXtRkCXSof",
                                    "type": "image"
                                },
                                {
                                    "id": 4085198,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/67ee1cb4-4957-4718-9d8b-92bf5ec701f3/width=450/4085198.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMG[NK0L9[?G~oaeNet79Gt8%2oe9at7xajZ",
                                    "type": "image"
                                },
                                {
                                    "id": 4085196,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/24f1816a-2d0d-4da3-827b-e46ca57858dd/width=450/4085196.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFI;n;}ju4D*%~4.ElEM4;xv#*={OEShi_s;",
                                    "type": "image"
                                },
                                {
                                    "id": 4085200,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/378b6281-61f4-4d29-8257-b44614cd7d5b/width=450/4085200.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIDlsJ9FpJxZ~Wa{9txtRjxtM{R*Iqj@xZWC",
                                    "type": "image"
                                },
                                {
                                    "id": 4085205,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ee2cac5e-0fb7-4fbf-a065-c01245385cfa/width=450/4085205.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UdI}L:%MTyM|*0NbtmV@tmxatRsmxvbIs:Wq",
                                    "type": "image"
                                },
                                {
                                    "id": 4085194,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/76af516c-c3c2-4660-9548-6199d7a05d6e/width=450/4085194.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGHK|f00*000pbMxI=XTNaNGr?%LS5WVR*Wq",
                                    "type": "image"
                                },
                                {
                                    "id": 4085203,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d02a3b16-044c-4aa0-ad4b-ce011c234882/width=450/4085203.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UYI5GItR*0-pX.RjkWIoMd$gi^ofR5WBn4oz",
                                    "type": "image"
                                },
                                {
                                    "id": 4085204,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f42be663-f95f-4a38-bf1d-218b348d31f7/width=450/4085204.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAF#wH9t00-o=,-;9#~A0#kSNHWZ0MIU^iE1",
                                    "type": "image"
                                },
                                {
                                    "id": 4085209,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d3898b6-4963-4239-bb43-445d17b55f1e/width=450/4085209.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UZHB-@%LlVbIESWXE3RkNHbcnhaeWCfkM|ad",
                                    "type": "image"
                                },
                                {
                                    "id": 4085210,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2b61a0ba-cc37-46d2-88d3-f690c5004ba6/width=450/4085210.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNIELk={o|Ip~pWAIoRQ9aD*M|IpbIE1oLsA",
                                    "type": "image"
                                },
                                {
                                    "id": 4085212,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/297900bb-ca63-48f7-830a-7010bc91de39/width=450/4085212.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGJRK+?GlVMy~qkX%N-;4nD*MwjX4-xt$gIU",
                                    "type": "image"
                                },
                                {
                                    "id": 4085211,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9f1ce399-787d-4dff-b6ae-25cc7fa9bd51/width=450/4085211.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8E-?]0J00~q7k=ON4t701EdX3IT00-:-Oni",
                                    "type": "image"
                                },
                                {
                                    "id": 4085208,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/162ceb59-f7c3-46cb-bd8f-0d728fbf6e9b/width=450/4085208.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFE:9{Nb00~qH?D$R+M_8wkWtRa0ys%g-px]",
                                    "type": "image"
                                },
                                {
                                    "id": 4085215,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e1853d5a-5083-49b1-aea9-986ba1a4b47f/width=450/4085215.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPG@ln~BEfJBLHTIWGn%MeRPRjWFD*M|R%NF",
                                    "type": "image"
                                },
                                {
                                    "id": 4085213,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c253441f-73e0-4056-bede-e1906cfd95f5/width=450/4085213.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8C?=i9t00~WZ#R5tSIo4TnitlnjCRtl={oy",
                                    "type": "image"
                                },
                                {
                                    "id": 4085214,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/68dbfb45-7467-4ee6-97e9-b309d710caf8/width=450/4085214.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9GkOJ%200?G9[I:#S?GDjDk}[wc$*-AnOIV",
                                    "type": "image"
                                },
                                {
                                    "id": 4085216,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f84958ac-c616-47ac-bea7-dc5913f8db4a/width=450/4085216.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9Kc@T~V00?H1oNZ6^ix4@Mz}vs;8{$+IpVa",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/245999"
                        },
                        {
                            "id": 232848,
                            "name": "Mrs Olympia Doll Likeness",
                            "index": 14,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-11-20T18:15:24.683",
                            "availability": "Public",
                            "trainedWords": [
                                "edgOlympia_woman,edgOlympia_face,edgOlympia_body,",
                                "a woman posing for a picture"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 2888,
                                "ratingCount": 107,
                                "rating": 5,
                                "thumbsUpCount": 218,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 179700,
                                    "sizeKB": 18541.3203125,
                                    "name": "edgOlympiaDollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-11-20T18:10:44.660Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "5457C36D58",
                                        "SHA256": "5457C36D58EECF53DE1CF2BA9B2D8ACC41064C8CA00201C93810C28C9772AB2B",
                                        "CRC32": "4F3BEF7D",
                                        "BLAKE3": "FB6E99025D8DC6292C1A2405F7B1706C2764D8802B62933E18B99B35D7D7B40F",
                                        "AutoV3": "43A7BB24C4D3"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/232848",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3781160,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3ff83382-5dbc-4997-9ed6-7674014de0f0/width=450/3781160.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5C5;#4.0f}tK}-UMz9]5QI:xE-V5R$+$kEd",
                                    "type": "image"
                                },
                                {
                                    "id": 3781033,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ddd6a35e-2d4d-4119-bd1c-70de9a248a3a/width=450/3781033.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9D+b*00yX01xU%L9aNd00~q9Go#bwxa$*E1",
                                    "type": "image"
                                },
                                {
                                    "id": 3781037,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a5e02a40-09b3-475e-8d39-901925c23fd6/width=450/3781037.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAAva_$g0J%1D~R-Ivbb0MR*~Bs:t7ayWAoM",
                                    "type": "image"
                                },
                                {
                                    "id": 3781049,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2d822140-8f84-4de7-8be8-a513fc49a99b/width=450/3781049.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKHnQr_3Fw8_9taK00In~q^*-p9ZEMNHnOi_",
                                    "type": "image"
                                },
                                {
                                    "id": 3781057,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e34425e5-f5c3-443f-a2da-57f965a238ed/width=450/3781057.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMG[Tn8^%%Dz?wR4kWxYb^WCadxutTfis8W-",
                                    "type": "image"
                                },
                                {
                                    "id": 3781058,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/55ae4391-5b61-4fe7-85fe-bd383676d7ed/width=450/3781058.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEE-]x4:w0-p0xM|5mRPxHNF~AE3X9jIxZNH",
                                    "type": "image"
                                },
                                {
                                    "id": 3781066,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/11f1f2c9-c583-4011-a8b0-c62677a9d067/width=450/3781066.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGFheo%DOQ?cxP~W%0ITxcawxbNGIoIVE3R:",
                                    "type": "image"
                                },
                                {
                                    "id": 3781062,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/99b5f357-0ca4-43b2-8e0f-6f2832f1e0ac/width=450/3781062.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKHUUl%L~n%0$wafr;W.4:RjIWV]I[WXxboe",
                                    "type": "image"
                                },
                                {
                                    "id": 3781128,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b2d3caf4-a355-4794-8fda-56ca6a4d2599/width=450/3781128.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U3AvRk~C00IpT}-;#RE10L9^AI-6D%RjENR%",
                                    "type": "image"
                                },
                                {
                                    "id": 3781174,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/15a9c1b2-593e-4a88-b0fa-f1242aeb0630/width=450/3781174.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULG[A;0LInMx~p9Gt8IV?HRikXbIXSe:%0Ri",
                                    "type": "image"
                                },
                                {
                                    "id": 3781178,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d297643e-f0af-4de0-a363-79e0bd4d009c/width=450/3781178.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDG7;|~W0LwHG^-=rqIo%g%LxDwcNbIoE1oy",
                                    "type": "image"
                                },
                                {
                                    "id": 3781179,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4d2ee14a-5c71-4bed-bca9-fe047523c622/width=450/3781179.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHGQ^LRj01bcYR-T#7JBu4s+IU$*pINGIUoz",
                                    "type": "image"
                                },
                                {
                                    "id": 3781180,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8b7bd876-8efd-4162-a9bc-2911be82f6f8/width=450/3781180.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7DIayH=5ti_1PT04.I=I9~WVXfS.8E1s+s:",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/232848"
                        },
                        {
                            "id": 363822,
                            "name": "LOTR Elf Doll Likeness",
                            "index": 15,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2024-03-07T17:00:00",
                            "availability": "Public",
                            "trainedWords": [
                                "edgelf_woman,edgelf_face,edgelf_body,pointy ears"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 869,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 70,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 290761,
                                    "sizeKB": 18541.3203125,
                                    "name": "edgLOTRelfDollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-27T10:51:00.838Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "20520AB8BF",
                                        "SHA256": "20520AB8BF9F542C3764920931963F90927843F1C6469D86BEEC95C068136BD1",
                                        "CRC32": "D07C938B",
                                        "BLAKE3": "E6681F70798CD6875A900CBDDFF6D95AFD427AE40015D3C0B4E2A3CC2BB6E4FE",
                                        "AutoV3": "145D4BCD7F18"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/363822",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 7179169,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/41498f3c-c042-4cff-8015-da56c0f7826c/width=450/7179169.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8Ey3*~p0J=|D4Me%3o}9YX8IUMxE*t7r=oz",
                                    "type": "image"
                                },
                                {
                                    "id": 7179131,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3dc7ea19-9024-41e5-af5c-8853c5e9c4e7/width=450/7179131.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6EylP%Kkt8_004T00o}00NK.7~WyD-=VsMw",
                                    "type": "image"
                                },
                                {
                                    "id": 7179130,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ff6513d8-3fb5-4cbe-84b9-5c317148feb7/width=450/7179130.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7Bf*7IoKR~Wr:oM01R%%ME0Io%24:%MwIIp",
                                    "type": "image"
                                },
                                {
                                    "id": 7179129,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/93134504-c9a1-4655-b663-204410888d81/width=450/7179129.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTIq}*9a_3?H~qogtlRj-nxuxDM{?bjZsmRj",
                                    "type": "image"
                                },
                                {
                                    "id": 7179127,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/771cd301-f29f-48f1-97be-29ad7facaf82/width=450/7179127.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDCsXKRj_Nt7-pt79ZR*xDWBIVs:R*j[V@ay",
                                    "type": "image"
                                },
                                {
                                    "id": 7179133,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5cb5ba07-0fa2-4ef1-a680-e1e847be3d41/width=450/7179133.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U2B:v=00?^00Dg%200Iq00tRXDajMc?b9ZIo",
                                    "type": "image"
                                },
                                {
                                    "id": 7179132,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b4b86e68-4fad-4735-b4b5-f4c421cb2c63/width=450/7179132.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U3E2qU000156~CE2.8-n00-;vcIsIRIT8{?d",
                                    "type": "image"
                                },
                                {
                                    "id": 7179224,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ca8c5d35-5625-4a58-bae8-a62a0f1a7637/width=450/7179224.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEH_utIBb[?b-pRO01WB4TMx~qxZ-;NHxuWX",
                                    "type": "image"
                                },
                                {
                                    "id": 7179254,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6259dd4c-dc40-4ef5-8bb0-a66a5bdd9d56/width=450/7179254.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U3D9;OMx1V?]00-.9ioY00tM-HV?5uax=_t8",
                                    "type": "image"
                                },
                                {
                                    "id": 7179442,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2c3ee8f8-d88c-4d40-a8c1-2fe4d6acc55c/width=450/7179442.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIC6S%Rjr;of~UNGM{ofM{s:Nat7ELofWCj?",
                                    "type": "image"
                                },
                                {
                                    "id": 7179294,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/60df6b29-5726-4655-bd30-d9af9179bb24/width=450/7179294.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBI|{;sjBqRi0C9ZjERP9FNHwH%2~V-pV{oz",
                                    "type": "image"
                                },
                                {
                                    "id": 7179499,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f2b0c91-63f8-4586-ba78-08ccb5904a82/width=450/7179499.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U4BM}M0KN74T{L0000x@4Y.9.i^,I,R#Q-8{",
                                    "type": "image"
                                },
                                {
                                    "id": 7179538,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/623a74fb-019c-4dfc-b96b-d6bbe4b745db/width=450/7179538.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8CF-U~90f-8=fnNI.~Voat7s8t7TIxv={RP",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/363822"
                        },
                        {
                            "id": 214671,
                            "name": "Guyanese Doll Likeness",
                            "index": 16,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-11-06T10:02:42.856",
                            "availability": "Public",
                            "trainedWords": [
                                "edgGUY_woman,edgGUY_face,edgGUY_body,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 1802,
                                "ratingCount": 37,
                                "rating": 5,
                                "thumbsUpCount": 70,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 165190,
                                    "sizeKB": 18541.3203125,
                                    "name": "edgGuyaneseDollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-11-06T09:50:45.327Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "5BF8CE6E0E",
                                        "SHA256": "5BF8CE6E0E0097235E06614EDEA32DC0DF9066BAD550B6145C19C2B373D78D99",
                                        "CRC32": "86FB5F93",
                                        "BLAKE3": "AB56341B32AC7772764E470217EF490489EC6BFFB07FE3E2B2B6DBBD855A153B",
                                        "AutoV3": "FE793D251813"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/214671",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3428874,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/89b2ab95-a8a8-4f8b-9cdb-e933cfb75911/width=450/3428874.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USIhNx4n.TMw$Kx]-;-p*0xu$2xt-oslt8E2",
                                    "type": "image"
                                },
                                {
                                    "id": 3428766,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/16716979-3ba0-40cd-8ac7-8332a7bf7f76/width=450/3428766.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "URIEeB~qu3E1%g?b9ZIU%gxv%2M{%3bJxujr",
                                    "type": "image"
                                },
                                {
                                    "id": 3428768,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/97ea1855-3c3d-412b-90e0-6e912e9473a3/width=450/3428768.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "UeIXmm-p_NxvtmRkozbINGoei_s:-;t7WXWr",
                                    "type": "image"
                                },
                                {
                                    "id": 3428781,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e48b853-5f9f-43ea-bd40-40afa28b2a60/width=450/3428781.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEG6|pmS0f~B71w]v$jc0}xsxZJAtRRkr=S$",
                                    "type": "image"
                                },
                                {
                                    "id": 3428875,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e121cb3-98ee-49c1-89bc-077e8ef57adb/width=450/3428875.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGF#UM^j0NE1S}IoozM{0g9u$f%1~C-pM{bI",
                                    "type": "image"
                                },
                                {
                                    "id": 3428924,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f154046e-c84b-47d2-b1aa-0af2b13009e6/width=450/3428924.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "UWGRh.?w?v_3-:%2S$jZoJWYs.V@Ipsln$NH",
                                    "type": "image"
                                },
                                {
                                    "id": 3429028,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0e8a7429-3bc6-49d1-a803-895180f5c47c/width=450/3429028.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "UiHV3lkD_Nt7-oRjbFRjE2RjM{RjkWkDV?j[",
                                    "type": "image"
                                },
                                {
                                    "id": 3429033,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/24daf70a-9d37-4832-bf19-790fd7945637/width=450/3429033.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UIGR-y~XAHE24T#jD%Ip*0IUI9E1.7.8%gI:",
                                    "type": "image"
                                },
                                {
                                    "id": 3429029,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5110d643-5a6d-40fa-accc-0b4adaa1d86f/width=450/3429029.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "UJIh21}[T0%g%fMw?a.8G^I:H?xtgO9vNIad",
                                    "type": "image"
                                },
                                {
                                    "id": 3429034,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a3c9268c-6aab-4af9-a34d-0e97e95d9018/width=450/3429034.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U8GktT~nx^MbiF9Z01~q1+0100o|V?00Mf%N",
                                    "type": "image"
                                },
                                {
                                    "id": 3429035,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/67044184-89df-4793-8580-8456451404af/width=450/3429035.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UMGRYu~q%h$+J%ogoz%M00D%RPR%bIV@IUV[",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/214671"
                        },
                        {
                            "id": 205207,
                            "name": "PuertoRican Doll Likeness",
                            "index": 17,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-10-30T11:01:50.677",
                            "availability": "Public",
                            "trainedWords": [
                                "tanned brunette,edgPR_woman,edgPR_face,edgPR_body,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3726,
                                "ratingCount": 64,
                                "rating": 5,
                                "thumbsUpCount": 125,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 157380,
                                    "sizeKB": 9328.75,
                                    "name": "edgPuertoRicanDollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-10-30T10:50:42.560Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "38B1FF91",
                                        "AutoV2": "08B05894B5",
                                        "SHA256": "08B05894B52571DC00DF1C83E1F58C30D07D9808364BDF93857A2D840F9F026C",
                                        "CRC32": "DFC8A53C",
                                        "BLAKE3": "E5EDE9FC67297210D86BB12D2F23E6F7E01F552D46312DCF0830F8FFAC36D113",
                                        "AutoV3": "9CCEF547CCF9"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/205207",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3263200,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ba789215-2898-4b36-851a-d7bae8d7c37d/width=450/3263200.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBE2OgoJ009aKbs:^RRj~CbHE1%1~WR*E1xa",
                                    "type": "image"
                                },
                                {
                                    "id": 3263078,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a1a4afa0-f02d-4505-a932-318cf2db2838/width=450/3263078.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULHxKX~B?v%34TtSE1xaPC-;%3xu-oMx=|Ri",
                                    "type": "image"
                                },
                                {
                                    "id": 3263077,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/db0ec1fd-059d-4540-8c38-8f2ce9b46fa1/width=450/3263077.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJIX?V004-V|n24-_4bc.TM^xInM_3D%RO.9",
                                    "type": "image"
                                },
                                {
                                    "id": 3263097,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/56452983-81c0-4aaf-9eb4-faf31dd8a04a/width=450/3263097.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIE2IL~BIU4:9]EMIqV]9HaLW.?GNZxZxaa#",
                                    "type": "image"
                                },
                                {
                                    "id": 3263080,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0852a69b-295f-4297-9fbf-ead944bb7874/width=450/3263080.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFF5,C~V4-56-Qa1%Nx]9Hs.xw%2_Nxt9FMx",
                                    "type": "image"
                                },
                                {
                                    "id": 3263079,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c6f3e66a-20c9-4ca2-8fe5-ede450fec777/width=450/3263079.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNI};g.TPWrq-AxZ~XNG.8R5rqNdo~X8Mxe.",
                                    "type": "image"
                                },
                                {
                                    "id": 3263124,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/933863f5-9750-4ecd-9a70-9ef7f8fcb60d/width=450/3263124.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNIEkSDi?v8{?uM_ni9F~pRiIpofNwafMxS#",
                                    "type": "image"
                                },
                                {
                                    "id": 3263127,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/939291b3-7ad1-4c5f-a490-9f8bc04ffb02/width=450/3263127.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAE_s*R+0z^*01NG4oRkx[jF~V%LM|WVD*xt",
                                    "type": "image"
                                },
                                {
                                    "id": 3263156,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad19970e-c8f0-4501-b26f-17ba89d66f3e/width=450/3263156.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHJa1F00k:Ne?u$y-oWXOYj[WV%2~q9FbI-:",
                                    "type": "image"
                                },
                                {
                                    "id": 3263158,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bd161672-98ce-4b38-9189-93bc62cd50c7/width=450/3263158.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIH_urkq55~V4m-n%M%MyXM{s;9u9vn,MJe:",
                                    "type": "image"
                                },
                                {
                                    "id": 3263157,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1c8ac6dd-03fb-47d9-acbd-533e7aec0efd/width=450/3263157.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCI;^$0000IoHX01?^%NE1%$^jDh?bIU$yIU",
                                    "type": "image"
                                },
                                {
                                    "id": 3263174,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4c24453c-73a8-4376-847d-8a5cf06e5de2/width=450/3263174.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTKd0,DO.Tic%}Rj,b$Q^+t7OnS~FvWB$jNG",
                                    "type": "image"
                                },
                                {
                                    "id": 3263173,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4469fedf-96ec-4882-a371-ac399a1a69aa/width=450/3263173.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UVJH8kFt_4k=-qtlxbX7JBR%aKt7x]s;j?xb",
                                    "type": "image"
                                },
                                {
                                    "id": 3263196,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/91de7336-1f5e-46d0-ae1f-527c47930f02/width=450/3263196.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDFXxT,.005=C6ROrDXn5TM{Vs~D_4R*9EkC",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/205207"
                        },
                        {
                            "id": 194058,
                            "name": "Colombian Doll Likeness",
                            "index": 18,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-10-22T13:12:04.766",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful edgCol_woman,edgCol_face,edgCol_body,"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3414,
                                "ratingCount": 67,
                                "rating": 5,
                                "thumbsUpCount": 126,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 148393,
                                    "sizeKB": 18546.2265625,
                                    "name": "edgColombianDollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-10-22T13:00:49.418Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "80BBB84207",
                                        "SHA256": "80BBB8420735FD701E047E5D52AFDEFBBCB765EA4347110497BAA2CB35BB56D8",
                                        "CRC32": "6677468A",
                                        "BLAKE3": "1DA32336A8A08F5000E32A8635B3B1CF156636C42A8A9644CAD88C1BA626644E",
                                        "AutoV3": "FA1C2F97B44D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/194058",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3097099,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4424d060-eee3-40d1-bee0-42f5a79eb445/width=450/3097099.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9BM#=^k4nEN0hI?9FRj~pxunNo00gIo%0xa",
                                    "type": "image"
                                },
                                {
                                    "id": 3097109,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/499e5295-a794-49ca-98d2-b8e8f5ea3f96/width=450/3097109.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6CF*T~q024pS_-o58JB0058?H-p-.awnhad",
                                    "type": "image"
                                },
                                {
                                    "id": 3097092,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ee7c1cff-9ce2-4484-936f-efa70f6fe136/width=450/3097092.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8ECRf~CEh01?]tQ4:S0.8M|%2Myt-M_xb%M",
                                    "type": "image"
                                },
                                {
                                    "id": 3097108,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/93563ce6-850f-408c-89eb-f4c1b1712d82/width=450/3097108.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGD+#n~W9a9aiHMy57R+S0baM|M{-:WBxb%2",
                                    "type": "image"
                                },
                                {
                                    "id": 3097126,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2f3ea675-2423-4c60-9e0f-c1a76fb3ba5c/width=450/3097126.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9DI{|~V0001D%IV0zI;4.R*^k-VM{NGRltQ",
                                    "type": "image"
                                },
                                {
                                    "id": 3097136,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0ce04ff2-4e02-4e26-9af0-441452a62996/width=450/3097136.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDDb{7~p0#0eEOE3MxIU%g-:^*xu00D%NKxu",
                                    "type": "image"
                                },
                                {
                                    "id": 3097162,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cab466dd-a609-40be-9772-cff62c7ca0c5/width=450/3097162.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEFE_t},0N4:9tI]xuxW0fNL${%2%Ns-RiNI",
                                    "type": "image"
                                },
                                {
                                    "id": 3097217,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e3aa40c8-8939-40be-8bac-167a585e9f7a/width=450/3097217.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UVGuXX~qkr?a?G-pR-M}I=R-RkaekBa#xat6",
                                    "type": "image"
                                },
                                {
                                    "id": 3097292,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1356ecd7-62d8-47d8-b139-39f86c6e441b/width=450/3097292.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTGkLD~VGGXmpckqr]$*tS%MxvOEXmtSj^of",
                                    "type": "image"
                                },
                                {
                                    "id": 3097214,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0f341687-f14f-42cd-aaf4-85b593a19a94/width=450/3097214.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6BWD4~W0000SzkW014:t5s.-;xtM{NH9axa",
                                    "type": "image"
                                },
                                {
                                    "id": 3097216,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fb1e0ba0-97a6-44c9-b500-5b170dcafc47/width=450/3097216.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJDb]1~V4.Mx-n-o-ot7xt%2t7RkaxayWBs:",
                                    "type": "image"
                                },
                                {
                                    "id": 3097218,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b98800fa-4b45-4e97-97a4-8f0ebf82a877/width=450/3097218.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBEyGK9FPB~q00xu00IUNFso-SNG~qR+T0t6",
                                    "type": "image"
                                },
                                {
                                    "id": 3097215,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/23bcd83e-008f-43cf-9e26-da2d0612d8de/width=450/3097215.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULGuao9FJU?b~qE1Rj-p0Ks.4nS2tRRjD%xu",
                                    "type": "image"
                                },
                                {
                                    "id": 3097219,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a1f5dde6-2b2e-480c-ba35-b45e45f10ce9/width=450/3097219.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UiGR#Z~Wt5xv%Mxuo1ayNGWoWqR*kCkCRjae",
                                    "type": "image"
                                },
                                {
                                    "id": 3097223,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3196bc08-6297-49f9-8c52-8fb1f5834d3d/width=450/3097223.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U:FsV~R-tnt7pfoMkXbIS%s.V?R*t8R+ngoe",
                                    "type": "image"
                                },
                                {
                                    "id": 3097265,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c8f955c9-82fd-4061-893c-cf7de6256352/width=450/3097265.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFHLG3000K^+.74n~XD%00S2%hM{Iq%MRiNG",
                                    "type": "image"
                                },
                                {
                                    "id": 3097284,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/35823d2b-e930-4b67-97b4-7f3e1ce60310/width=450/3097284.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPF;[=~V5+ACO:ozi|soozofxuoz-:-pt7oy",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/194058"
                        },
                        {
                            "id": 182327,
                            "name": "Mexican Doll Likeness",
                            "index": 19,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-10-14T12:10:57.77",
                            "availability": "Public",
                            "trainedWords": [
                                "tanned,edgMex_woman,edgMex_face,edgMex_body"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3309,
                                "ratingCount": 46,
                                "rating": 5,
                                "thumbsUpCount": 96,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 139944,
                                    "sizeKB": 36973.8046875,
                                    "name": "edgMexicanDollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-10-14T11:40:45.413Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "33E3FB10",
                                        "AutoV2": "655EDCAF62",
                                        "SHA256": "655EDCAF6257475E0348A88520C239AD81EF88208AED3D138F5FEA14F35ABE85",
                                        "CRC32": "95DB7440",
                                        "BLAKE3": "ABF72EB3A57C0E16A57A6E96E286930F7C743EE87EC1228463CF6FB57E925C4B",
                                        "AutoV3": "EF608DED3C45"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/182327",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2942410,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0c3191fd-e8fd-48ce-937d-6e4b62b93920/width=450/2942410.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHEoS%4TLgIU00x]H?wcIot7i_?a.8j[xuIp",
                                    "type": "image"
                                },
                                {
                                    "id": 2942500,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4604bd07-d6af-4948-a18c-4b3eb9d887ce/width=450/2942500.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6Dk*=E100%30M-U^5R*9G5R-;~B0fo2xtS1",
                                    "type": "image"
                                },
                                {
                                    "id": 2942481,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/83c2af06-8378-4ff6-90ab-3550784cf6b3/width=450/2942481.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8H1b[003D8y8t00~om.%~D%={T1^8NfD*%f",
                                    "type": "image"
                                },
                                {
                                    "id": 2942411,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d9d68fc3-1598-4dee-b5d1-aabe40d4bb5a/width=450/2942411.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UaIqr;%gB;nhyXM{-;bb_Nt7xZMxt7IVxZof",
                                    "type": "image"
                                },
                                {
                                    "id": 2942409,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5ed4d6fd-d318-4539-a7a6-4059274fdbf6/width=450/2942409.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCFqj]7i?w.T00d:00#60~^j={I@?GFL=|o}",
                                    "type": "image"
                                },
                                {
                                    "id": 2942408,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/98fd3021-9bd5-4c20-b94e-bd33051e2f56/width=450/2942408.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKKKZsH=LMH=IST0~BMcGIxZMcW;x]VYtS9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 2942407,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/feb2fcd9-c489-4890-b396-3bc960ff7baa/width=450/2942407.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UUI;u2~Wgi-p9ZI;.8t7pcg4VsR*xYs9xGn%",
                                    "type": "image"
                                },
                                {
                                    "id": 2942406,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1cbed58-6fe8-4f66-b7ec-bee1c2b3d99a/width=450/2942406.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBIN~+00UH?w0#}?Si57%hTeU]$fGHD%=|~B",
                                    "type": "image"
                                },
                                {
                                    "id": 2942462,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5c088d24-7903-4436-8570-a6597562105e/width=450/2942462.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDIqcVx^0f^O4T0LO@~B?a9Zaf?G.9?H$gIo",
                                    "type": "image"
                                },
                                {
                                    "id": 2942603,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/db08865b-4793-4346-b90f-e6677a6715f2/width=450/2942603.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGJ*F;x^0J^j004n?b?Gys9F$ko}PV?cwcEj",
                                    "type": "image"
                                },
                                {
                                    "id": 2942647,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7a33f13c-58b1-40dc-b5de-7d81263310d4/width=450/2942647.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USJ%nUwOy?TKUFIA-;%N?wRp-W%LpHOWNt-p",
                                    "type": "image"
                                },
                                {
                                    "id": 2942648,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b1c436e3-ea96-4f7a-bf47-ed025b21e206/width=450/2942648.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNGRSVK6%gMx.m-pXTv}%hRjwIIUr?WBm+9a",
                                    "type": "image"
                                },
                                {
                                    "id": 2942677,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e3e9c9ca-c989-44f1-882b-ce8874d45904/width=450/2942677.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UOGt?9E1.TNGcYx]-;$%Ipx]$%jF=|r?NGEL",
                                    "type": "image"
                                },
                                {
                                    "id": 2942687,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9321a0b6-e671-4473-9a5b-5380780f3e6e/width=450/2942687.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEHnEK%gHD?HqF-:^*S#X.Ris9RQ~VV@MdjF",
                                    "type": "image"
                                },
                                {
                                    "id": 2942811,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dfa5a6d8-f1e1-479a-b9dc-e399663b8852/width=450/2942811.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7BMxss:00o#:zjE9at7pxay~Wso00t7%1M{",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/182327"
                        },
                        {
                            "id": 170981,
                            "name": "Brazilian Doll Likeness",
                            "index": 20,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 6,
                            "description": null,
                            "publishedAt": "2023-09-30T14:17:10.826",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful edgBr_woman,edgBr_face,edgBr_body, "
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3191,
                                "ratingCount": 113,
                                "rating": 5,
                                "thumbsUpCount": 194,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 130048,
                                    "sizeKB": 9324.0234375,
                                    "name": "edgBrazilian_Doll_Likeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-09-27T15:05:38.568Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "ED281A8A",
                                        "AutoV2": "537A2B7129",
                                        "SHA256": "537A2B71294AB184B2B8627ACB182F3B4F593B1F00BEAD1D22A22C030E1C9C38",
                                        "CRC32": "17DE0610",
                                        "BLAKE3": "AA1B52190AE5E5AC81B275F20464F4E9C9BC01FBDC708E0B060E17953EB8B113",
                                        "AutoV3": "E4D49FC1B314"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/170981",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2690702,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0ea5369d-c8c5-43c1-8fb5-bd4971cecfd3/width=450/2690702.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "UDBV^z~EIo-U?b=|w@f5E1bE$wNGJFW?t4t6",
                                    "type": "image"
                                },
                                {
                                    "id": 2690608,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9acc9dec-109b-4ece-8fc6-ff8fa5ac3434/width=450/2690608.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFF;]A00uO00%%rCXnR50~-9X8%0-DaKOAR+",
                                    "type": "image"
                                },
                                {
                                    "id": 2690722,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d44b648-4754-4a8e-afe2-4cf1caa0381d/width=450/2690722.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U6FzaOGa3t841o}Y:L[3Dg0K{C9?0O,@GOjG",
                                    "type": "image"
                                },
                                {
                                    "id": 2690606,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5a20bff7-82e0-43ee-88c8-9437a64c4013/width=450/2690606.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7EnktDi3p%e3V9t}tv$0Kw{;|J74n-;R4EM",
                                    "type": "image"
                                },
                                {
                                    "id": 2690773,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fdd9e1b7-52f4-44f3-afd7-c04d52b48388/width=450/2690773.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USHUkK~CIUNH4.Ip-=%LE0NHWAaekBoKWANG",
                                    "type": "image"
                                },
                                {
                                    "id": 2690797,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ebd4152d-0aca-4d87-859c-3a3edb6bc357/width=450/2690797.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGJk4XI:6._N1Pad-:%h0KxaZ}M_H=oMjZV?",
                                    "type": "image"
                                },
                                {
                                    "id": 2690807,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3b8df301-eba3-439f-b805-68f967e6e1c4/width=450/2690807.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNI=7G~UGwyZysOX.8-;4nNeVrZ~x^s:jHR-",
                                    "type": "image"
                                },
                                {
                                    "id": 2690729,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1df697cc-9863-4183-b34c-033735f40d8b/width=450/2690729.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UTG9T__NveiuJ?J;EfR4$l$je,t2X.bvnNM|",
                                    "type": "image"
                                },
                                {
                                    "id": 2690744,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0f307444-0c88-4271-9abf-9696b7e69cbf/width=450/2690744.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGD,P}?w8x.Qrc%#csmnDkrvtQE1EKV?+vs9",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/170981"
                        },
                        {
                            "id": 168997,
                            "name": "Canadian Doll Likeness",
                            "index": 21,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-09-24T21:36:42.86",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful edgCN_woman,edgCN_face,edgCN_body, "
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 4598,
                                "ratingCount": 91,
                                "rating": 5,
                                "thumbsUpCount": 139,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 128371,
                                    "sizeKB": 9328.7734375,
                                    "name": "edgCanadian_Doll_Likeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-09-24T21:15:54.721Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "57EFED5A",
                                        "AutoV2": "C333CE418A",
                                        "SHA256": "C333CE418A111A4976FCA662D8D5DDC97314780484359B23A654029DCF17AE80",
                                        "CRC32": "CA755286",
                                        "BLAKE3": "2BE1B490C71A9EDE875EC7045187476593AEECB2F0DED4DD1557553F6F3DEB54",
                                        "AutoV3": "B739B4E4FADD"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/168997",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2654906,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/429164c6-ec7c-4dfb-95da-2ed47e7589f9/width=450/2654906.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8C$M}={019u0LX8IVoL9aoL~Vf6RjIpD*xt",
                                    "type": "image"
                                },
                                {
                                    "id": 2654873,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e7b5d6f-6081-47ed-b0d2-94c3492fdab0/width=450/2654873.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHGI7b_Nu5^*.TtRRjRP-WRPM{R*I=s.slR+",
                                    "type": "image"
                                },
                                {
                                    "id": 2654914,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e09f5d5a-2668-447a-8a29-736e344be8d9/width=450/2654914.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEJQ{8~q0eIU0J?b#msCxs$%D%9Z~WxaM{IU",
                                    "type": "image"
                                },
                                {
                                    "id": 2654916,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/baf7d1ca-44b1-4bfb-80e8-e8b84ba4babf/width=450/2654916.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9Gu2qPD000J5O%LD*?HFrE1In#+?K?H8_M|",
                                    "type": "image"
                                },
                                {
                                    "id": 2654927,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/de479e07-39d8-4f98-9c3f-4b9bcbca6c6e/width=450/2654927.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKHw+J$K0y~qyq$~H=X4Iox]?bIADibwNGRQ",
                                    "type": "image"
                                },
                                {
                                    "id": 2654928,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e5a4451d-8ea9-4727-acc8-73cb2e6d5f9e/width=450/2654928.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGI56{0000_3~p4n%L%gD%E1-;of_3IAt7R-",
                                    "type": "image"
                                },
                                {
                                    "id": 2654939,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7ba8794c-3a6d-4fee-82e1-f21264b2fe39/width=450/2654939.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNGIQ5~pI=R.xZM{IpWA0KIV-pxtS2oLxaWB",
                                    "type": "image"
                                },
                                {
                                    "id": 2654943,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/47d05cec-119b-4cac-8b6f-ecb6dc0bd161/width=450/2654943.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULHLVc?v4.~p-p_2-;R*00xu-;D%.8E1D%NG",
                                    "type": "image"
                                },
                                {
                                    "id": 2654960,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a37e2b96-d659-4424-b886-27327ba90a1e/width=450/2654960.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHFrt[_3?u~W$e%MIA9F~BVrD%IV%M%2nOs:",
                                    "type": "image"
                                },
                                {
                                    "id": 2654967,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/93a41dba-6918-4233-86f5-c4366b282dc5/width=450/2654967.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJIOOoX9xuRjvykC9FIV?Gj]-:4._N%MRPR*",
                                    "type": "image"
                                },
                                {
                                    "id": 2654966,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cf44d491-577b-411d-b2f8-84d60f419793/width=450/2654966.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKFiAIWX%gs,MwaeE1t7~BogD%s:tRbbR5V@",
                                    "type": "image"
                                },
                                {
                                    "id": 2654974,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/92692c72-8a71-45e1-bb21-ac48e27ce5b3/width=450/2654974.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIF=s}%2~p-;MJxa4njFt5t7ofs:?GRj-;js",
                                    "type": "image"
                                },
                                {
                                    "id": 2654978,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8b05e620-3a2d-40d4-b721-f3f4e7e854cb/width=450/2654978.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULHUOm~WYjyD?t?bQ-wd~W%1xGnN-p-;X9S$",
                                    "type": "image"
                                },
                                {
                                    "id": 2654997,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6239e17f-dd39-402a-b8e1-09e459f39c26/width=450/2654997.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7B:Hb0g00}n00~USi9v.QQ-O@gNDkpIRPwH",
                                    "type": "image"
                                },
                                {
                                    "id": 2654996,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3ee4ed37-1d47-42cd-957d-cc5402bff9e5/width=450/2654996.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGCPL.}[vLv#9FRjxb%2xUX5K6NeIVRkads,",
                                    "type": "image"
                                },
                                {
                                    "id": 2655006,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6eea88f7-4389-4fb5-b24a-b4bf4d3ed849/width=450/2655006.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULF=my4TTJ-:^i9Zoex]?bIUxGbv~CR4tRR*",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/168997"
                        },
                        {
                            "id": 161930,
                            "name": "Mama Люба Doll Likeness",
                            "index": 22,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2023-09-18T09:21:56.618",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful edgML_woman,edgML_face,edgML_body"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3566,
                                "ratingCount": 88,
                                "rating": 5,
                                "thumbsUpCount": 168,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 122053,
                                    "sizeKB": 9329.3359375,
                                    "name": "edgMamaLuba_DollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-09-14T19:00:53.148Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "CA261E58",
                                        "AutoV2": "3E0F1C7ADC",
                                        "SHA256": "3E0F1C7ADC9DDDA1083151FC470DE78FCFCCA26E9170A9F7DD3C6920CB52B1C2",
                                        "CRC32": "5641789F",
                                        "BLAKE3": "D5ADF676DF87534D22067E4DDB2E654ADE9FEAC99B539B85377FBFF749A8D90D",
                                        "AutoV3": "14A1F510D21D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/161930",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2501680,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eada01bc-bc05-45f9-ae24-285eeace008a/width=450/2501680.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNG*={Dg~q9F^+9FE2Rk^+xtt7xuoJV?n%NH",
                                    "type": "image"
                                },
                                {
                                    "id": 2501309,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f250f205-761f-4f52-a0a5-b3fe9c100102/width=450/2501309.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBD+PbRP0zIp?ut7RQWX4oxuxVae0fM{~Bxa",
                                    "type": "image"
                                },
                                {
                                    "id": 2501308,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/596436e6-c1bf-474f-80fe-5cdee5141f8b/width=450/2501308.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKG8f+_317~q?8-=^%?HEmae$$Rioge.RoNG",
                                    "type": "image"
                                },
                                {
                                    "id": 2501305,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/592b8bc2-aae6-458e-a2af-97f04a1f38a6/width=450/2501305.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6GR0d0000J:00Iq4-^*-n={_49Y0J^,E20d",
                                    "type": "image"
                                },
                                {
                                    "id": 2501304,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/feda07bf-a944-4b3b-a8b2-30edd009e43b/width=450/2501304.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UXG+OO%M%hR-~3V@%Ma{ObRjeTRjIqj]xaxu",
                                    "type": "image"
                                },
                                {
                                    "id": 2501306,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d94651bf-07e6-4c3f-ad45-702dc3a89879/width=450/2501306.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8DbmF^*004:NEM{M|tQ019Z~U^*_2%2IBV[",
                                    "type": "image"
                                },
                                {
                                    "id": 2501307,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/19a455e9-ece4-4f3e-af1d-098e51cf59bb/width=450/2501307.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDE_?cRO$+IA~pRjEfRj00ozr=xuxZX8aeWB",
                                    "type": "image"
                                },
                                {
                                    "id": 2501324,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c53759f0-e416-4831-92fd-d3c9558c2b61/width=450/2501324.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQHUkI%2-p-p~qRjozWV.8M{WXM{_3xu-pj[",
                                    "type": "image"
                                },
                                {
                                    "id": 2501367,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dc331302-1c89-4edb-97b5-a16323e35074/width=450/2501367.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMK^:8nh_N-;%MD%?c-;JVM|r=%Loy%LRPIo",
                                    "type": "image"
                                },
                                {
                                    "id": 2501368,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f73362b4-7ab8-4c17-9781-3302ec0d3c8a/width=450/2501368.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHG@}a4nE%0L9uD%x]wJ?aE1~C9Z0Kt7%2Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 2501378,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a234afce-9be9-4482-9290-a62ad7bd5c38/width=450/2501378.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDH-Z5mS%3-p=e4TMeIBcFRPNd%gB:5Q~p%g",
                                    "type": "image"
                                },
                                {
                                    "id": 2501395,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b9ca13d0-423d-4ca5-94bf-ad916612824f/width=450/2501395.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHE.CN-:E2?ayD^+%ft70L%M~BjF?GE1Rj%L",
                                    "type": "image"
                                },
                                {
                                    "id": 2501422,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/729de331-091f-4585-8372-0496f1d2bf48/width=450/2501422.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKG*+$xu5R9EO@^+s9D%58WW%0NG~WM{M|RP",
                                    "type": "image"
                                },
                                {
                                    "id": 2501431,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4aeb72e8-c609-4395-a768-a98b437e73dc/width=450/2501431.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBGa%z_N0z%g2[$*tRR54U0K={%M?uM{-V%2",
                                    "type": "image"
                                },
                                {
                                    "id": 2501456,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5dd17a1b-5c7d-4c78-ba0f-357857e2e34e/width=450/2501456.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQI;#KS5?^%MkX-px^WBRPo}%LV@WB?bt7ay",
                                    "type": "image"
                                },
                                {
                                    "id": 2501483,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cc356f23-45dc-4404-b06a-eea0c377f884/width=450/2501483.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7DIg[8w9a00OWS~Fa9[00-;n~?H={R5}t-B",
                                    "type": "image"
                                },
                                {
                                    "id": 2501535,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fd115557-01f9-4530-8182-5195877dbd6f/width=450/2501535.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULI5oRD*LycG8wyD-ES#tS-?$jv#j_xuM}xH",
                                    "type": "image"
                                },
                                {
                                    "id": 2501577,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3c277346-b401-4445-9d1a-17be7b936f01/width=450/2501577.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBHdNx*K@{hg2[7J1H5k0fl8F_Ef|];P]Q-V",
                                    "type": "image"
                                },
                                {
                                    "id": 2501602,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cdcc7703-6941-40e0-8b90-e9015d44402c/width=450/2501602.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPJj-s$*qF?aEzW=s9xZD*j?VsW;t7xuWBIo",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/161930"
                        },
                        {
                            "id": 159094,
                            "name": "Polish Doll Likeness",
                            "index": 23,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-09-11T09:27:46.935",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful edgPL_woman,edgPL_face,edgPL_body"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 5109,
                                "ratingCount": 134,
                                "rating": 5,
                                "thumbsUpCount": 150,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 119540,
                                    "sizeKB": 9328.71875,
                                    "name": "edgPolishDollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-09-10T17:40:50.099Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "824824DE",
                                        "AutoV2": "A5C099CD93",
                                        "SHA256": "A5C099CD9378F695E0E35B075EBE8903CCE5BFD17E392461F998A6B5740A6817",
                                        "CRC32": "8BFBF43E",
                                        "BLAKE3": "87EA5CB968A4257D057E045380C008467D8C03140D646DD2BBFDB35AEF1E0E58",
                                        "AutoV3": "46F50BA5879F"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/159094",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2439699,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1a365dc6-68b0-42f0-a632-7c3eb40103e1/width=450/2439699.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9GatPt6000101-pMyS457RP~US2EMt7D*%2",
                                    "type": "image"
                                },
                                {
                                    "id": 2439772,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/62c2448b-638d-4acb-8f5c-ca756aab721a/width=450/2439772.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCF5p}xS#fx_:zI{0p-M03$_I^WFo~nM~99%",
                                    "type": "image"
                                },
                                {
                                    "id": 2439717,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/426c735e-9908-46e0-9cdd-13ddc741b92d/width=450/2439717.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAEU_a~U00010gEMM{xZ0Lso^joyjGRkR*bH",
                                    "type": "image"
                                },
                                {
                                    "id": 2439733,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/411a3f10-10fb-4915-b7bc-3a36b21b2845/width=450/2439733.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 862,
                                    "height": 1447,
                                    "hash": "UbK^ES?w*0t7yXfls;Mxb_t7WBn~WYV@o0Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 2439747,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2a16a1e6-7ef2-4e4a-9944-5bc0ac5ef7ba/width=450/2439747.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGDIds4;02~UNaWVM|WVE1%1s:of57%1s.Ip",
                                    "type": "image"
                                },
                                {
                                    "id": 2439739,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9e9b7e41-8c94-4f0e-8842-e04925bcf86a/width=450/2439739.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UYHnHF~UEMoJX8W.E2E2NaIpIVRj-oj]V[xZ",
                                    "type": "image"
                                },
                                {
                                    "id": 2439644,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/10b8c1f3-3e8b-4edd-ba43-763c7d5ee3d1/width=450/2439644.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCGa,u~V0f9t0g-VIon$0LM|-VNH$~s.%2f8",
                                    "type": "image"
                                },
                                {
                                    "id": 2439645,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/931662b6-f12a-4722-9478-2433a1e475d5/width=450/2439645.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9H1Sh0LE0={_1-p00%10z?G9ao#%K9a}[nP",
                                    "type": "image"
                                },
                                {
                                    "id": 2439643,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/65a5887f-1404-4618-8bdf-c1f4cd42fab5/width=450/2439643.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCKdb#={00,@00V@00aLk?ENIXI:01tQ~Wba",
                                    "type": "image"
                                },
                                {
                                    "id": 2439650,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/282ba345-ae9f-40fd-8c98-55e7a8b4aea6/width=450/2439650.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFI}Ip~pK+9aO?IoE4n$9tNIDPVs={o0t8xt",
                                    "type": "image"
                                },
                                {
                                    "id": 2439652,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/650db322-7410-4580-a571-2c714ea376a1/width=450/2439652.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAGa?^V?00~U02Ip$%Ip0e?H-pNH0LIp~VxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 2439653,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5f0e04e7-8bdc-4725-8af8-33a1e2e4de06/width=450/2439653.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAHU2v%100~B00Io9uI;~AbH=_%101-p?a9a",
                                    "type": "image"
                                },
                                {
                                    "id": 2439665,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/77ee6a42-9150-4f17-90d4-22689d26fb28/width=450/2439665.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBHK;0xtK+-puPozK6tR0Mjs,:RkV?fQ$faz",
                                    "type": "image"
                                },
                                {
                                    "id": 2439794,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6bd970d9-87e0-4034-9b17-5968a25c30ea/width=450/2439794.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9Kc;H0100~Cl9$*_4XTL0M{01?H9sbb?HH?",
                                    "type": "image"
                                },
                                {
                                    "id": 2439805,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/17e97263-0e9e-4505-b359-4dff7e295165/width=450/2439805.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCH_JWxG00of?uay4pof00R*=yRk~Wt7D*IV",
                                    "type": "image"
                                },
                                {
                                    "id": 2439817,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f2b3abc4-5058-4a7d-af50-25f7a6e956c5/width=450/2439817.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBD]3gID00s%${0LJU~p5T-:wcIU00-o~VIq",
                                    "type": "image"
                                },
                                {
                                    "id": 2439833,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/936e4fe3-3600-479f-b3b5-1b2f2e9f8e1a/width=450/2439833.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEFOZD~V0L4:kBj?NGoJ01%2%1WB~VxtxaWE",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/159094"
                        },
                        {
                            "id": 156633,
                            "name": "Rubicon Doll Likeness",
                            "index": 24,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 23,
                            "description": null,
                            "publishedAt": "2023-09-06T22:18:26.417",
                            "availability": "Public",
                            "trainedWords": [
                                "edgAyre",
                                " red hair,red eyes"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3892,
                                "ratingCount": 56,
                                "rating": 5,
                                "thumbsUpCount": 100,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 117389,
                                    "sizeKB": 36973.8046875,
                                    "name": "edgAyre_AC6.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-09-06T22:10:47.722Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "725D2BC2",
                                        "AutoV2": "FFE2CA5C91",
                                        "SHA256": "FFE2CA5C9125F6972992FC8F367D8117853D99E9F2383C606287A096D50085FC",
                                        "CRC32": "158031BD",
                                        "BLAKE3": "6A9A070F9719F2CB10928A551DE30ECB3437F2A5D2FBFA33D5203AB0C5EF3CAE",
                                        "AutoV3": "7CB920ABD347"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/156633",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2385572,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/53e962bf-9e18-452b-99cf-b352925a72a4/width=450/2385572.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1427,
                                    "hash": "U5GIJ=000000=|00ysD%00~q_3NF9a_3DN%g",
                                    "type": "image"
                                },
                                {
                                    "id": 2385462,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d1b3eaaf-c28f-4ae3-80d4-4ba39606ea0c/width=450/2385462.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U4Du3=0100}t3:s:D5FvHX%LyCH@00=|~p9u",
                                    "type": "image"
                                },
                                {
                                    "id": 2385444,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e9cd3465-863b-48a6-92cc-8bdb4d291b7a/width=450/2385444.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UID+A2~WPp.8tlx]aKniROIT9ZIoenWVXSWq",
                                    "type": "image"
                                },
                                {
                                    "id": 2385445,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6aba49de-9d94-486f-9941-cdf1f40e4b6e/width=450/2385445.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCF;{C567#^k00xZ0KbH00tQ?aIU~Wt7t7t7",
                                    "type": "image"
                                },
                                {
                                    "id": 2385446,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6c78e6d1-7ab6-4053-852f-0f5b131462a0/width=450/2385446.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7EB$}tl00S300M{-;M|oy%2?Gxa00IU~V%L",
                                    "type": "image"
                                },
                                {
                                    "id": 2385453,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7b6b2941-2253-478e-b487-249ec7003e61/width=450/2385453.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAEeV}%gp{nP?^ITtRMx004nD%E0VZWBWCIo",
                                    "type": "image"
                                },
                                {
                                    "id": 2385481,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/770ffacc-b23e-4247-8fad-bd51fbd9efdc/width=450/2385481.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHE18ZK41H}s2@,@i{FwMxI;$*RkRQn%oyw{",
                                    "type": "image"
                                },
                                {
                                    "id": 2385511,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/30e4ec5d-21e8-40c9-85a2-a80edbe3f2bc/width=450/2385511.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQJQNEoek;01~pE2NaIUS#WCWBayMxWBg3xa",
                                    "type": "image"
                                },
                                {
                                    "id": 2385516,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/44b9cc54-56ef-4fa5-a495-1b0b20253008/width=450/2385516.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U59iSjBm0{|{C6,@iwJ,56r@$+JRvNJ,O=,E",
                                    "type": "image"
                                },
                                {
                                    "id": 2385522,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f2961b1d-3415-4c8d-ac1c-cd2e1621e89d/width=450/2385522.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U26j:?560J-p~UIo9vxa9r$%xcNG9J%2XMIo",
                                    "type": "image"
                                },
                                {
                                    "id": 2385536,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04b914a4-5859-41c7-8e50-a65ac4f573cf/width=450/2385536.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UICP#7~q?v?b?H_3tR%MIAIUofM{9ZNGRiWB",
                                    "type": "image"
                                },
                                {
                                    "id": 2385601,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e9e9683-1f0f-49f0-8a79-99cbaa6ba995/width=450/2385601.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9C6Jsxa0K~W01ELD%rq$*MxM{oftR^+-;E2",
                                    "type": "image"
                                },
                                {
                                    "id": 2385604,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a4065f49-c028-4a84-9b5c-ef8c073b6672/width=450/2385604.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8Iq1F0002VY0gIo?uR6~W-:-UkW0fRP?aWU",
                                    "type": "image"
                                },
                                {
                                    "id": 2385542,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a0904e55-8225-4c01-8972-e06b4e97d5fb/width=450/2385542.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQGa%,9EXms,?^D$EgjF=|Ioj]aetljZ%2R*",
                                    "type": "image"
                                },
                                {
                                    "id": 2385605,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/12056c26-e61f-4f37-b3eb-87ba41f5a922/width=450/2385605.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UiG*+*xu.8xu~Wj[x]oLofM{WBRjS2azs:of",
                                    "type": "image"
                                },
                                {
                                    "id": 2385608,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2eea3cb5-54a8-40d9-be84-dce1c4aa93b3/width=450/2385608.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMGuRRDi.S4T~WNGEgD%rrNHELx]wfw{R*n%",
                                    "type": "image"
                                },
                                {
                                    "id": 2385623,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d1f63c47-2507-4b0b-989d-1a582785096b/width=450/2385623.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKE_s[00~qVE%2M{I;NGRPtRIooznOo0Rjwd",
                                    "type": "image"
                                },
                                {
                                    "id": 2385632,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0dce37de-7816-452c-bf9f-3191e91d4e76/width=450/2385632.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNIXpx00_Nxu_3NaxuIUI;jFD*t7RjniIojZ",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/156633"
                        },
                        {
                            "id": 152467,
                            "name": "Bulgarian Doll Likeness",
                            "index": 25,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-08-31T12:37:20.576",
                            "availability": "Public",
                            "trainedWords": [
                                "edgBulgr_woman, edgBulgr_face,edgBulgr_body"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 4288,
                                "ratingCount": 64,
                                "rating": 5,
                                "thumbsUpCount": 126,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 113591,
                                    "sizeKB": 9329.1484375,
                                    "name": "edgBulgarian_Doll_Likeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-08-31T12:35:55.643Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "BA1AD2C3",
                                        "AutoV2": "7AB3BABF13",
                                        "SHA256": "7AB3BABF13EF85EEC84612E459D7516154CD8E2CACC6F9149803CCE06CD8EC7D",
                                        "CRC32": "425ADD6F",
                                        "BLAKE3": "A5725D9B47579C2D001FC21413C680DE0E1F8BAA847B5D0B0F72FB2F961C4F8E",
                                        "AutoV3": "008458D11BF8"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/152467",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2291258,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1d68a991-b7d6-482e-9b4d-f8f933329453/width=450/2291258.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFD9C$005Q%h_ND$WB%g%gI:RP$+E1tQocxa",
                                    "type": "image"
                                },
                                {
                                    "id": 2291261,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f12ca1d0-09db-4fbe-a6d2-9a514013b54f/width=450/2291261.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCB{ZP4.Ee^+~WRiM|%3l9IUR6-p5QsTRjNu",
                                    "type": "image"
                                },
                                {
                                    "id": 2291263,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/572372c1-3d8a-4fad-b98b-ea349b22edbe/width=450/2291263.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7A0RP~C0L0eS}I:IUM{4oa#={-pWCt7oyIo",
                                    "type": "image"
                                },
                                {
                                    "id": 2291297,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2bbb6299-de43-4c90-a88e-4ce599d30e12/width=450/2291297.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAF=Bj~W0f00NcM|E1WB4.?HRjxuEMRj?GE1",
                                    "type": "image"
                                },
                                {
                                    "id": 2291277,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a0e80fc7-cacf-4555-93f2-30d0c4c367fe/width=450/2291277.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEFE[w%MwtxBEKM{0f0156M|s9?HD%a_~C%M",
                                    "type": "image"
                                },
                                {
                                    "id": 2291298,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/16411abd-ae11-4bdb-bb4f-fe366ee48056/width=450/2291298.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8Eeof~V00ax01D%E1?H00%2~C4:E19tE1WC",
                                    "type": "image"
                                },
                                {
                                    "id": 2291276,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5b80a3a0-d249-4254-afd4-751b1800a3e2/width=450/2291276.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDCiUNTIAA~D9?$*n6b]9FRjtQr@tRs:sC9a",
                                    "type": "image"
                                },
                                {
                                    "id": 2291299,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5b283ebd-73b4-4ad5-a188-5ef651281fc6/width=450/2291299.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6E2a=~B0L00K64.4:ni00ShxC-;oM-p?Gxu",
                                    "type": "image"
                                },
                                {
                                    "id": 2291300,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6be0f996-5701-4f6a-9965-115f2a95a4d2/width=450/2291300.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U2E_,NM{00SML3}q_2I:000000?H01JWRi00",
                                    "type": "image"
                                },
                                {
                                    "id": 2291278,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c0db3400-8116-4696-98a9-43a2d3884a87/width=450/2291278.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBD]6y%200?GNZ%LIns-IVWXt69G~Wt7E1-o",
                                    "type": "image"
                                },
                                {
                                    "id": 2291280,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2cd8a6d9-e9d3-4c88-a5e5-150e5d992032/width=450/2291280.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBD9CyS}00t7J6aLE1xu00%2~V9F%NtQniIo",
                                    "type": "image"
                                },
                                {
                                    "id": 2291282,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9f9f78c0-782b-4734-bf68-a4c7605588ce/width=450/2291282.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBExnq000KRQ4n?G57%1IVbH^*Ip00f6~WRj",
                                    "type": "image"
                                },
                                {
                                    "id": 2291281,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eb7663cc-2524-4112-a49a-34609d396d01/width=450/2291281.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAG8ft00S001~V00%zt7MxRj?H?HSO_3IA0K",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/152467"
                        },
                        {
                            "id": 145479,
                            "name": "Indonesian Doll Likeness",
                            "index": 26,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 23,
                            "description": null,
                            "publishedAt": "2023-08-21T14:16:59.267",
                            "availability": "Public",
                            "trainedWords": [
                                "edgIndo_woman,edgIndo_face,edgIndo_body,  "
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 4997,
                                "ratingCount": 181,
                                "rating": 5,
                                "thumbsUpCount": 277,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 107682,
                                    "sizeKB": 9328.4921875,
                                    "name": "edgIndonesianDollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-08-21T14:16:05.781Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "1E7EE2E4",
                                        "AutoV2": "73FE71868D",
                                        "SHA256": "73FE71868DDAECF4A8997B506B0B65C693EEB1210BABDA1E1967AE16A7F49CE1",
                                        "CRC32": "9FE52836",
                                        "BLAKE3": "09969DB2F243EE1F685B5356D3870F274C4F27D23163B5C1478DD025B1F6BBCB",
                                        "AutoV3": "11AD0C358278"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/145479",
                                    "primary": true
                                },
                                {
                                    "id": 107684,
                                    "sizeKB": 9328.4921875,
                                    "name": "edgIndonesianDollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-08-21T14:21:00.451Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "1E7EE2E4",
                                        "AutoV2": "73FE71868D",
                                        "SHA256": "73FE71868DDAECF4A8997B506B0B65C693EEB1210BABDA1E1967AE16A7F49CE1",
                                        "CRC32": "9FE52836",
                                        "BLAKE3": "09969DB2F243EE1F685B5356D3870F274C4F27D23163B5C1478DD025B1F6BBCB",
                                        "AutoV3": "11AD0C358278"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/145479?type=Model&format=SafeTensor"
                                }
                            ],
                            "images": [
                                {
                                    "id": 2138609,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a109ef75-ba0e-411e-b4be-b2b2f75d035f/width=450/2138609.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UZJ@?]WB?^j[%g%MoLayNGRjRjWB%2f6R*og",
                                    "type": "image"
                                },
                                {
                                    "id": 2138607,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2a8582bd-23a3-42e2-8b60-26840b725c51/width=450/2138607.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPE2LXE19a~BELNHf+ofE2%1$*E2oeoKfkt6",
                                    "type": "image"
                                },
                                {
                                    "id": 2138594,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2c84456b-fe9a-44c7-abd5-aee784ca8d2b/width=450/2138594.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKE2:]8_XSyD~qIUNa-;xH%LjGWF9aShxZ$%",
                                    "type": "image"
                                },
                                {
                                    "id": 2138592,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/20c51d43-8ede-4ceb-94ed-05ed0f502425/width=450/2138592.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDE.R$.T%h?b_3~qyD?H0f-p=|Ioo}V@IVs.",
                                    "type": "image"
                                },
                                {
                                    "id": 2138596,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/696e21e0-5437-4c76-b305-906333ded37e/width=450/2138596.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULJG.+~q-:_39]kCt6-:Jo-o-UI=S4-o-UM{",
                                    "type": "image"
                                },
                                {
                                    "id": 2138593,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bbf799d9-e733-49f9-8506-9a01636139fa/width=450/2138593.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJIgv300Nxaz?^8_x]Ip9}Vs-oxu~VNGM{^*",
                                    "type": "image"
                                },
                                {
                                    "id": 2138595,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/34f4da0e-e9a6-43a3-9f10-73bffc7df14f/width=450/2138595.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEI4Y5~V00vLX.%MIn0eEkEO4.Io?H%1v}E1",
                                    "type": "image"
                                },
                                {
                                    "id": 2138600,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e43620a3-5b6a-407a-af60-dc554dc07836/width=450/2138600.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBJ%^K4T3C4T490K~XD4vg~DafM_DO-;9F9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 2138598,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4328f97a-70f1-4c72-9017-9cd4d2e060e5/width=450/2138598.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "URFFQz_N?b-;~W%NtRt7WUbIRkM{R*t7o0M{",
                                    "type": "image"
                                },
                                {
                                    "id": 2138597,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e03ed745-0b3f-4d79-8c82-32f5ec899d7e/width=450/2138597.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQJHgl~UIT-p00%2-;xt^+n$kCoL%LoJM{of",
                                    "type": "image"
                                },
                                {
                                    "id": 2138601,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/040ed3e3-c7e7-4f3c-a321-3086a2771b4f/width=450/2138601.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNHeUk_NWY?bRS.St,M{K5WBwcM{^+s:n$IU",
                                    "type": "image"
                                },
                                {
                                    "id": 2138604,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9e44125f-612b-45ad-85b9-c62fa7f39f88/width=450/2138604.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UXHe5$?G^*~V_3oebw%MR+j@s:jbX9s:xDWB",
                                    "type": "image"
                                },
                                {
                                    "id": 2138602,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/de4d92a4-b2eb-4bb4-be69-02174f7470cf/width=450/2138602.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "URK1Xb.7Sc%MS~xu?uX8DjxHx]e.?^IVVZae",
                                    "type": "image"
                                },
                                {
                                    "id": 2138599,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/03825173-acc9-4f0d-91c7-13d9616d032a/width=450/2138599.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U4DlG|004nEj00?G0fR*00%MOs^i9uxt}sEM",
                                    "type": "image"
                                },
                                {
                                    "id": 2138603,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/232ee21f-840f-4d6d-9882-d556246c4cf4/width=450/2138603.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNHnsja0_NIo%gIUt7%ME2NGM{og-pofM|WB",
                                    "type": "image"
                                },
                                {
                                    "id": 2138605,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f957559e-af35-4f85-9ed9-471a3ee9a076/width=450/2138605.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHDu}O~VkVbG?bozWWxFIpM|NGE1IoWBxZoe",
                                    "type": "image"
                                },
                                {
                                    "id": 2138606,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3d8d3ad1-2d2d-4a90-bdd7-0fab577b79ee/width=450/2138606.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDC~h$~VV?%2?Gxtt6Ip4.V?RkE19uR*NGt7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/145479"
                        },
                        {
                            "id": 141169,
                            "name": "ShiroGal Doll Likeness",
                            "index": 27,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-08-15T11:34:39.266",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful edgShg_woman,perfect edgShg_face,edgShg_body"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3971,
                                "ratingCount": 78,
                                "rating": 5,
                                "thumbsUpCount": 129,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 103735,
                                    "sizeKB": 18547.25,
                                    "name": "edgShiroGal_DollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-08-15T11:25:45.108Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "04C2343721",
                                        "SHA256": "04C23437214487E8BB05E9FD5CFDAD3D13544B7A559ADA1FE25DE0750C6210AE",
                                        "CRC32": "6D21DF6E",
                                        "BLAKE3": "85A04D9A16CC763B286416B0937A0840AE675203BF91904D7B2D3F90CE852B1E",
                                        "AutoV3": "DA039EF02C41"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/141169",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2041062,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bd1caf47-cc66-4b64-8f91-094bb687c4c9/width=450/2041062.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCE2;3t-01~WIT9Ynisn00Dir=IUx^_3x]M{",
                                    "type": "image"
                                },
                                {
                                    "id": 2041061,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ecec57fb-1fe9-4b96-a22c-e95261483d47/width=450/2041061.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8Ee[S0000?v^i0zxZ-p01^*D%D$0L~BE2Md",
                                    "type": "image"
                                },
                                {
                                    "id": 2041058,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e3f25957-f310-4841-ab9f-1cdee527e73d/width=450/2041058.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UVIO90RPS5?a~Woexut7tRt6RjbIozt7s:f6",
                                    "type": "image"
                                },
                                {
                                    "id": 2040888,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/671c7dc5-f3e7-418a-8e04-a6d6edf56698/width=450/2040888.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9Hny=~WuO02Qk4.4TxU=CIU9%9bO]-;_2~U",
                                    "type": "image"
                                },
                                {
                                    "id": 2040886,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3a56d6e0-5e3f-4248-b24c-1f309c0fedd8/width=450/2040886.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "URKwtf_2.TSQ?vkX-ps+=@MxkERjJ;ofjEW=",
                                    "type": "image"
                                },
                                {
                                    "id": 2040887,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/acf07dd7-e50e-41a2-9a51-6180471ef8e4/width=450/2040887.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEKKA}DlqC^RK]-;-=ad9XD*-=Vs?c8^jED%",
                                    "type": "image"
                                },
                                {
                                    "id": 2040889,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/feeef0b7-2075-4e8e-a3e6-8de42df404ca/width=450/2040889.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDJkJ:^+0cD%=:8_.TbJ00IVkC%L_N%MMx%2",
                                    "type": "image"
                                },
                                {
                                    "id": 2040890,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/913228bc-bffe-443d-959f-4122641f05b1/width=450/2040890.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCE_%XER00~Q5fnMA3S+rBo#R=IANZn%t5xt",
                                    "type": "image"
                                },
                                {
                                    "id": 2040891,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9c2534ed-7b5a-4db7-856f-d22a500c532c/width=450/2040891.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHKAsZ?w.8%M*JbvM|X8oLniIAjE%$o}%LRk",
                                    "type": "image"
                                },
                                {
                                    "id": 2040896,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eb854a41-8de8-4341-94c8-5a82b18d59be/width=450/2040896.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UtM7S}s:?wt7%hjXo}WVbwkWadoftRWCaes.",
                                    "type": "image"
                                },
                                {
                                    "id": 2040916,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3dd36863-c03b-4195-9717-1eab02bf4c0d/width=450/2040916.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UUJHp{%3y9WV=_t6RQoN?wt7tSt8%hxtxZxu",
                                    "type": "image"
                                },
                                {
                                    "id": 2040919,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a8a05283-e154-47fc-b41b-8467cbe426d2/width=450/2040919.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNM7DdD%?^?b-.x]xvWURPkCRjf6tQjFRjNG",
                                    "type": "image"
                                },
                                {
                                    "id": 2040973,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5f7345d8-a2fe-443a-9b67-35077b68a1ff/width=450/2040973.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIH1}Mt8F0~V4nVs01NH~Vaz?bxu9aWCRjfl",
                                    "type": "image"
                                },
                                {
                                    "id": 2041023,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/93bf61cd-2d0b-4342-8b7c-85797f8d8ccd/width=450/2041023.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDG*]300OF-6_N01E1Di?bivM|D%%gtl%N%M",
                                    "type": "image"
                                },
                                {
                                    "id": 2041051,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6b6ec8f7-50de-4687-9c3d-d95e43102c97/width=450/2041051.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCCs27xZ01NH~At70fM|IoWBj@fPIVWC-poe",
                                    "type": "image"
                                },
                                {
                                    "id": 2041054,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/32fe846e-9f4c-4d8f-a5ea-41d7fa0e8b09/width=450/2041054.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIEVZ.sR9ZI?~WRkIo%LaKofM|WUE1R+-ps.",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/141169"
                        },
                        {
                            "id": 135703,
                            "name": "Dutch Doll Likeness",
                            "index": 28,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-08-08T10:00:00",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful edgND_woman,perfect edgND_face,perfect edgND_body,"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4074,
                                "ratingCount": 70,
                                "rating": 5,
                                "thumbsUpCount": 103,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 99136,
                                    "sizeKB": 18546.4453125,
                                    "name": "edgDutchDollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-08-07T10:45:43.713Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "674A294F9E",
                                        "SHA256": "674A294F9E5BA642717C57F75C16375CC8C1057D4E4B1AF05C18B10101A3F06D",
                                        "CRC32": "FA2DB5A3",
                                        "BLAKE3": "1EFF05A1F7739ADABF68B8A3C890725547ECEBD6F60160333B87106FBA17A9EC",
                                        "AutoV3": "F4CA7FE5B081"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/135703",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1913997,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bcbc4824-cf4d-477f-9706-dbba6f7f2f7e/width=450/1913997.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "UEI;YOIV%~xu#jD%8^oLD*M{XoM{~BtSx^Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 1915090,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1187ceec-8418-4bde-a1b2-6c3eaf32d0db/width=450/1915090.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "UNLq5~~V9Fa#8wozXTt7o~t7%N%2%#WXVrkB",
                                    "type": "image"
                                },
                                {
                                    "id": 1915062,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6125c462-57b8-4fdf-b5dd-49ae456a0c00/width=450/1915062.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "UDKKWm4mHq?vHX4;OtI:8_RO.9jX*0%Lw[tR",
                                    "type": "image"
                                },
                                {
                                    "id": 1913956,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/344e48f1-c198-420a-b21c-61fdd49e00cc/width=450/1913956.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UtLXDBt7%gs:_4ofbcaeM|oKj@flNHRjRPof",
                                    "type": "image"
                                },
                                {
                                    "id": 1913996,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8152b281-fc35-40df-a61b-75e227c87682/width=450/1913996.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCJ??J}^0dIB00X35ZtR5GxZ-nIoKQxv,:xZ",
                                    "type": "image"
                                },
                                {
                                    "id": 1913959,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4946e1fa-7d1f-4bfa-bfa0-63da0d76d894/width=450/1913959.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UaJtr8%L?vW=_NkCR.WC?caxogs.%#WBxas.",
                                    "type": "image"
                                },
                                {
                                    "id": 1913954,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/91c36726-0131-4b9d-b9cb-44158f378133/width=450/1913954.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPI53,xu?w?a?bM{M{WVM{xtM{M|t7R*WBjs",
                                    "type": "image"
                                },
                                {
                                    "id": 1913963,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/404c7f3a-121e-449b-a4e3-2a0634d28aa9/width=450/1913963.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCHdvz^k01NH00V@9ZWA*0NeMy%2#jIU$gt6",
                                    "type": "image"
                                },
                                {
                                    "id": 1913961,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/daa9bc26-90fb-42fa-bb4a-701203b2ab8d/width=450/1913961.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQELvst74-NH~UkDM{M{-:bbRPM{^+bHE1kC",
                                    "type": "image"
                                },
                                {
                                    "id": 1913966,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e43a3603-645e-4ba2-a056-82cefa8771e1/width=450/1913966.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIFYS=xW_NE2IU9F9aD%I;%Mxa%MRi%MWBt7",
                                    "type": "image"
                                },
                                {
                                    "id": 1913953,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d964d7f1-a3f1-4946-bc1b-a17d1e75a143/width=450/1913953.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBFF50IU*04n%gwHxvNH0fNH$z-;^+kBRjR*",
                                    "type": "image"
                                },
                                {
                                    "id": 1913955,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8e886196-ef84-4309-b2ec-b574335116eb/width=450/1913955.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEJk4L-o?GDjenIV_3~Vb{%20KRl%hR*xBE2",
                                    "type": "image"
                                },
                                {
                                    "id": 1913965,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/97e5e1ff-aa9a-48b2-b970-3edd42fb810f/width=450/1913965.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHGu2Z~pM{M|9ZV@4:E1t,t6D*RPS}%M=|Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 1913960,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e44e0046-4173-4d33-bf62-fc263ad3cca0/width=450/1913960.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJJ*SFNbEL~qm*-;?vWA4.IUnOD*.89FIAIU",
                                    "type": "image"
                                },
                                {
                                    "id": 1913952,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8ab7e0c9-87b2-4e54-b00a-e6a4fefb0baf/width=450/1913952.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQKA.@~p-n%g#Pbcf+a{4nNJ%hax?wtRM{M{",
                                    "type": "image"
                                },
                                {
                                    "id": 1913957,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a4632f62-3236-4a96-9bb0-6290536f926b/width=450/1913957.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKF5:J00tlxu~qivE2xt-;MxkCM|x]E1s:WX",
                                    "type": "image"
                                },
                                {
                                    "id": 1913958,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a9133188-63ed-4c71-bf81-8ba484277630/width=450/1913958.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9Gtym0f00~V0157Si?G-o-UVuR%0ejv~Bsl",
                                    "type": "image"
                                },
                                {
                                    "id": 1913962,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a6e26dc7-7261-49e3-bbce-e7160ea4ac80/width=450/1913962.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U%M@Q7of_N%2%Mf5M|j[t7ozRkRibbbHaeof",
                                    "type": "image"
                                },
                                {
                                    "id": 1915194,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9ea34d24-5682-434c-b8ec-7f99f970061b/width=450/1915194.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDDl+xx]00xa~9R*K7%L?ba#Mdxt9}ogaKf6",
                                    "type": "image"
                                },
                                {
                                    "id": 1915260,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/307afb51-965e-4ade-aaf8-f358d24c85d6/width=450/1915260.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDHKCI~D0zxG0JW+560fRo-ow{xH-oWG?G-U",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/135703"
                        },
                        {
                            "id": 68863,
                            "name": "Maghreb Doll Likeness",
                            "index": 29,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-05-12T14:58:26.853",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful dark haired mod_woman",
                                "perfect mod_face, perfect mod_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 6988,
                                "ratingCount": 79,
                                "rating": 5,
                                "thumbsUpCount": 90,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 48155,
                                    "sizeKB": 73844.595703125,
                                    "name": "mod.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-12T14:51:35.308Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "F420E2F6",
                                        "AutoV2": "F07D19139C",
                                        "SHA256": "F07D19139CDB47875B108BECE682774E6653BE706B911D10C2CDEC9275F0032F",
                                        "CRC32": "9D2A0AFE",
                                        "BLAKE3": "4F4937EE77A961A4FC790E0C5F4F26972440AF7A025EED7550601B2B0E1BBE32",
                                        "AutoV3": "D716A2F7A0DD"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/68863",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 767967,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f1bcb3f5-d191-44d2-bc13-24a80d9f1f57/width=450/767967.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U7D90NElq@00}4%20hEQrq$dJpJDM{xZI[Iq",
                                    "type": "image"
                                },
                                {
                                    "id": 767963,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/18a4fd05-5dde-4543-a0af-7ec9a150334d/width=450/767963.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "ULC$WL~UoyX9xFogf*ofM{M|NHayNHoJ%1s:",
                                    "type": "image"
                                },
                                {
                                    "id": 767835,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b2ae5e8c-3bfc-4d35-ab03-2a45b1f8dc6e/width=450/767835.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UHH_GR.8?s~B-z-mE8NH?DxW-oR-x^tR$x%0",
                                    "type": "image"
                                },
                                {
                                    "id": 767836,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d3970323-2461-4fab-9c97-cf6f894a3b61/width=450/767836.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UUHBYu.StQxu.mu4T0ba%hbyn-sCS*sDi_R-",
                                    "type": "image"
                                },
                                {
                                    "id": 767837,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/75720a43-f9cc-4c3f-aead-34b4c08d932f/width=450/767837.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UGELpYu6%MNF~WKlE,xBo#bwt7nhJCaerqIp",
                                    "type": "image"
                                },
                                {
                                    "id": 767834,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9888d76c-0cdc-40f1-b240-fec86d044d9b/width=450/767834.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UGEoY]4n?w00~po|E2H?kWtRM{VsNxjZ$fR*",
                                    "type": "image"
                                },
                                {
                                    "id": 767838,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a274b65c-ba85-46b0-8b65-1961170c3fbc/width=450/767838.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UKHea-VDyY?D~ovxXANL-OroRkI]-oR.xuoc",
                                    "type": "image"
                                },
                                {
                                    "id": 767840,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80ba5513-d310-40ca-90e9-6b9566ce614e/width=450/767840.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UcHVF_t+obnO~oXnt7V?$|R;V?fOxuWVoIoe",
                                    "type": "image"
                                },
                                {
                                    "id": 767905,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cc39a2da-35de-4d4a-beaa-0262014fe7bc/width=450/767905.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UHH^@Y00?^rp.SMx-;M{4:$*-TIpwbNdIBbb",
                                    "type": "image"
                                },
                                {
                                    "id": 767906,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5ae20a43-1036-42b3-b241-61b1af7df620/width=450/767906.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U7Ga??00ui01_1AcZ#fmAa$*^ir?x]4:s:9F",
                                    "type": "image"
                                },
                                {
                                    "id": 767903,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/28f334d4-f7f5-47b8-90a9-b10e73ab39a3/width=450/767903.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UKHng5?^?]x[?wXoXTa#Emj^xGs:xua|adbE",
                                    "type": "image"
                                },
                                {
                                    "id": 767907,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1ccb8cc7-8fee-418d-b02d-4a635bcb0196/width=450/767907.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UAF=Q{~A^J^*_2ogDi~VozxaDiW?X:IUi_D*",
                                    "type": "image"
                                },
                                {
                                    "id": 767904,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d86babb9-52f8-4bb1-9d0a-f9143003e2ae/width=450/767904.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UGGb3P8^?H0L}l-;IU9u=ExtMyIqxunhsoRk",
                                    "type": "image"
                                },
                                {
                                    "id": 767951,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e294986f-291e-44d2-a3a4-b44c5f438366/width=450/767951.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UJH1GA~UtKt7^%t7IB9ZM|RjIoIpIpR*t6s.",
                                    "type": "image"
                                },
                                {
                                    "id": 767953,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/93786a6f-3739-4d4a-bf95-3822f2e891d4/width=450/767953.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9EBvt-402Si}+XAa_R%NIWB$*jE9|s*={9w",
                                    "type": "image"
                                },
                                {
                                    "id": 1450256,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8ec23f85-2347-4172-af32-26a7e3e8d109/width=450/1450256.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFB{opofIpoL~V%2Ipxa?H%2t7s:-o%L%1oe",
                                    "type": "image"
                                },
                                {
                                    "id": 1450258,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/95d68f26-76be-4875-93cf-af245103d3f8/width=450/1450258.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UNE.to.9%fn$~qNyNHIU-;S5Rjs9xvx]ogxu",
                                    "type": "image"
                                },
                                {
                                    "id": 1432731,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/17fc8e5f-c6ba-4db7-8c8a-391f0051fa2a/width=450/1432731.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U7C$TB0M-o={={~VE1%2Na?G%KE2XR9a~BM|",
                                    "type": "image"
                                },
                                {
                                    "id": 1432725,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a8ca2c4e-2948-4c94-a59f-12d347699fba/width=450/1432725.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UHEC2k?bo~~W^*-;bvtRR*RjRjWBWBaee:Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 1432723,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/919da39d-867a-4f49-bdcf-2353d2071196/width=450/1432723.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDC~hu9ZtPIq~VRkxtIoafxaRkWBM{oeD*t7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/68863"
                        },
                        {
                            "id": 48453,
                            "name": "Italian Doll Likeness",
                            "index": 30,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2023-04-17T21:25:48.426",
                            "availability": "Public",
                            "trainedWords": [
                                " beautiful itd_woman, perfect itd_face, perfect itd_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4838,
                                "ratingCount": 43,
                                "rating": 5,
                                "thumbsUpCount": 56,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 35800,
                                    "sizeKB": 147571.15625,
                                    "name": "itd1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-17T21:25:58.825Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "3D8C9592",
                                        "AutoV2": "35985FEBFF",
                                        "SHA256": "35985FEBFF2F01A08721DB94A295F6F8BB0398011E3092AD62FF6DAD41DFDDA2",
                                        "CRC32": "6D3FBFBA",
                                        "BLAKE3": "92896FA9F69E6C97759E4AE252C5347FDA419016EE6D0AB7F2932B6F919CE830",
                                        "AutoV3": "2575265F1BD3"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/48453",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 520644,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3bb33658-5ee5-4f97-2143-9502ebb65900/width=450/520644.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "ULGkH}-oKi5R~VR*?GV@K5WU-UadS$WVxus:",
                                    "type": "image"
                                },
                                {
                                    "id": 520329,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7cbb7b83-222e-41c1-128f-eb0b647dce00/width=450/520329.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U7ELEF~BBTx[15xa02oM-oE2}snj0zxt^%xt",
                                    "type": "image"
                                },
                                {
                                    "id": 520324,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4decf9e9-afc1-4ef3-0f6c-e3080aefab00/width=450/520324.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UGEL$;%2?^oL9ZIoMxS4yEfiR6t7V?WBV@t7",
                                    "type": "image"
                                },
                                {
                                    "id": 520327,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/90ef490a-e799-4754-6164-096147213400/width=450/520327.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9E_U700lTbI0i^N4.R*J6Ejw]-p729F~CsS",
                                    "type": "image"
                                },
                                {
                                    "id": 520341,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1b243a81-4619-4f42-2ee9-2bf6242cc200/width=450/520341.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UMFq]-x]cYxuyD~VkX%2o~%M^jNGJUbIxan%",
                                    "type": "image"
                                },
                                {
                                    "id": 520335,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c0faef95-d425-440e-cdd1-4e4c9b8e9b00/width=450/520335.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFGRr6xt?^~V?vD%?GIo9aM{E1IoE2n$M{R+",
                                    "type": "image"
                                },
                                {
                                    "id": 520331,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5625496a-1e93-458a-49ef-d06ab16e4500/width=450/520331.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDGa,#?GPB%hB;$%xaS$?G4:9GV@.7EL^j~C",
                                    "type": "image"
                                },
                                {
                                    "id": 520333,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/38e020b2-82e8-4c49-e56c-682bb6814b00/width=450/520333.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDC~VU~VFe-p029a9aVs%2WBxakWIo%1-VIo",
                                    "type": "image"
                                },
                                {
                                    "id": 520332,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d943d8ad-31d9-4948-9458-a0004ee5f500/width=450/520332.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UBF4}=~U?axt0MWB57IoNdE2wJIo5S%2%2-o",
                                    "type": "image"
                                },
                                {
                                    "id": 520336,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/718b7816-86ed-43f8-951b-2c43ee807700/width=450/520336.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "ULGtyqyDx]?Gtm~V-pxG-;xtRjE2kVSO-oM{",
                                    "type": "image"
                                },
                                {
                                    "id": 520340,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/06c02d06-6c67-4496-b70f-9fd4d0bf8700/width=450/520340.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UEF}TO0gFx~B0f^*S#Rj-pWB9aoeSgEL~AbI",
                                    "type": "image"
                                },
                                {
                                    "id": 520337,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8eef2eaf-3845-45d6-303c-b72ac2b8b500/width=450/520337.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFFEr[E2FxS~Fy~BtRS#xt-;s9?Gx[E2?G$*",
                                    "type": "image"
                                },
                                {
                                    "id": 520330,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3482c3c8-0031-4b2b-0c75-368dd61f5c00/width=450/520330.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UTELZ.~Vx]-p-:?G-:xuJ8t7xZoe%Ls:snjZ",
                                    "type": "image"
                                },
                                {
                                    "id": 520328,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f23a6f9e-e224-4edb-b2cb-5bbd639c9700/width=450/520328.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UPEn^jkqJ8~Bofofofa#NwaeIoEMELxtxtoJ",
                                    "type": "image"
                                },
                                {
                                    "id": 520325,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2a40e403-87bf-4660-daf9-cfc3ace55400/width=450/520325.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UAD[;500yX0L_N00?GV[tQ%1Mxxt9[R*w^oz",
                                    "type": "image"
                                },
                                {
                                    "id": 520339,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1cab09f6-3e8f-4f13-98d7-9d74cf756a00/width=450/520339.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UEELmR%2.Sbc%#01%1Iq_NxG={W=tRM_n$X9",
                                    "type": "image"
                                },
                                {
                                    "id": 520334,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/76c2ba58-0089-4f72-b966-b12e3f4c1400/width=450/520334.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDE_mo%f%f~B9^s;I=n+ozRjIUI;oyRj={%1",
                                    "type": "image"
                                },
                                {
                                    "id": 520338,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/761949c4-c209-4192-b3b7-5842d9485500/width=450/520338.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UNF~Kz?G_MIop{9akrni.8-oR5f6D*M|IAkC",
                                    "type": "image"
                                },
                                {
                                    "id": 1450390,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/567081da-23f9-4e1c-9aa2-1c8f976386d0/width=450/1450390.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UHFO+IRj570Lav9Z%1t6caW=$LRP~Vxa9aIp",
                                    "type": "image"
                                },
                                {
                                    "id": 1450408,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8832ecb3-1af3-45d0-b5d5-a0f946964e7b/width=450/1450408.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFF5y,~BIo0f=ra0-;%M02Nbw{$%OYbcRPi_",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/48453"
                        },
                        {
                            "id": 112124,
                            "name": "Persian Doll Likeness",
                            "index": 31,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2023-07-07T08:22:29.212",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful edgPersian_woman, perfect edgPersian_face, perfect edgPersian_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4392,
                                "ratingCount": 75,
                                "rating": 5,
                                "thumbsUpCount": 108,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 79442,
                                    "sizeKB": 18545.52734375,
                                    "name": "edgPersian.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-07T08:25:44.225Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "C6F1BC14A9",
                                        "SHA256": "C6F1BC14A9BA4052E659A78BBC2192580EA76B64628F708DA03E67E0100A1D11",
                                        "CRC32": "B2C74031",
                                        "BLAKE3": "3C4B24CBC4C55DA056FE9E30CFD7A307DB5E14DA59D07FAE37CBC862BB92E40E",
                                        "AutoV3": "A13B346508F6"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/112124",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1444990,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/55e6c4d1-1f0a-405e-9ab6-d5bb20afeea3/width=450/1444990.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UACrl=~B0M57OsWXxa-nNaae={Nb%Ls.R+xF",
                                    "type": "image"
                                },
                                {
                                    "id": 1444991,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0932c9f9-ef95-472c-a103-3736572b6779/width=450/1444991.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UKE-:U={9u={57NGoy%2~B%1s.s.9u-n^jR*",
                                    "type": "image"
                                },
                                {
                                    "id": 1444987,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c3243594-7044-417b-ad13-a8d0fb6b4bb7/width=450/1444987.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U6Ci2D9u01~B02Na%1aK02-A$kNd~B%19aj=",
                                    "type": "image"
                                },
                                {
                                    "id": 1444989,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6c7c946d-9ca1-4b5e-b175-0d22509d5104/width=450/1444989.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9En-JS501~V02I=?G-o?aRQ-UX8^%t8bcIp",
                                    "type": "image"
                                },
                                {
                                    "id": 1445005,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f567f504-b074-4522-aae4-815f1809c916/width=450/1445005.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDD+Vf?Gxt?Gw[%1R*xa~pxtNHt701WVRjRj",
                                    "type": "image"
                                },
                                {
                                    "id": 1445007,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b705319e-8803-4bf4-be49-8f80ced67fc4/width=450/1445007.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8E.5[%L_2%Lvyn~01M{^+W=~VbbELWCs:Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 1445006,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/28d519ee-347f-49a3-840f-dea4fdd92c33/width=450/1445006.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBHe8%t7I;?wDhD%9a0Ktlt78{?b_2x^?a-p",
                                    "type": "image"
                                },
                                {
                                    "id": 1444988,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2c3ccbcd-cd9c-4730-81b6-a93465a07e9c/width=450/1444988.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFFEZI~U0#%g0$t7^%^jIpxa^PNG9axZbbD+",
                                    "type": "image"
                                },
                                {
                                    "id": 1444994,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/659980e5-7686-469f-b7d5-05d005384ead/width=450/1444994.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDE-{sEN0LD*9aRk%L%20Mad={f*~U?G9aM|",
                                    "type": "image"
                                },
                                {
                                    "id": 1444992,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4a098a9d-c00b-4cc2-8267-4e248010196e/width=450/1444992.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDIp|?00~9H@KhIVX.02F3Djxaae~UIU~Bni",
                                    "type": "image"
                                },
                                {
                                    "id": 1445003,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bafd7f81-dd97-4f52-b83e-f73c0a289480/width=450/1445003.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGBD7*t79ubH~pogIoa{NHazaej?9GWCM|WB",
                                    "type": "image"
                                },
                                {
                                    "id": 1444993,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f488cb39-e597-436e-82c4-0296360d41a9/width=450/1444993.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UIGa^09G0e9ZE10M_2Ip~pE2n3azV?WC-:xa",
                                    "type": "image"
                                },
                                {
                                    "id": 1444996,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/229026da-bf88-4939-9ab7-0406d7f54125/width=450/1444996.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UECigbR:t70L~oIp%LM{^*R+M|NGoeWA%1Ip",
                                    "type": "image"
                                },
                                {
                                    "id": 1444995,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/32a27d91-bf45-4a90-9895-c1a354d13f37/width=450/1444995.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UJC$r|~V?u-;RPMx9ZIUM|IVw]NGOEoz%2%L",
                                    "type": "image"
                                },
                                {
                                    "id": 1445000,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2eac8cf4-448d-4c04-a5a0-74b0af9fb40c/width=450/1445000.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFEC8,?F0f9{_3IU%L?aTKE1$$?H~Ws.9ZWY",
                                    "type": "image"
                                },
                                {
                                    "id": 1444999,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dc0c6dae-75a3-4f00-b83d-b71f5169d12a/width=450/1444999.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UCD]ME9Z_Nsm?FofkXRjEkxtr;IU?GRjIot7",
                                    "type": "image"
                                },
                                {
                                    "id": 1445001,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/03359e65-99df-4314-b38b-96bee247ae0a/width=450/1445001.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UBC5^xD*0L~B57-o={9aIVxtxuRjWqM|M|xa",
                                    "type": "image"
                                },
                                {
                                    "id": 1444998,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4cc7b460-f7c2-4906-b383-1215425aa318/width=450/1444998.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UCFhkp~WJ70fx[9t?G^*4:xDRPxZ%g?GD%D*",
                                    "type": "image"
                                },
                                {
                                    "id": 1445002,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d9b598ed-177d-4c31-8763-b11010b391d5/width=450/1445002.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UKDR~M4:j[~BNGs:Ipof9a?G$*E2ozV@NGX8",
                                    "type": "image"
                                },
                                {
                                    "id": 1450215,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6798d2b1-7f2c-414d-9130-cde3a75530c1/width=450/1450215.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDA]{R~qIp4n~B-:NHE10KIAxF%M0LD%%1-p",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/112124"
                        },
                        {
                            "id": 121908,
                            "name": "Egyptian Doll Likeness",
                            "index": 32,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-07-21T16:22:39.723",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful dark haired edgEgyptian_woman,perfect edgEgyptian_face, perfect edgEgyptian_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3419,
                                "ratingCount": 85,
                                "rating": 4.99,
                                "thumbsUpCount": 138,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 87692,
                                    "sizeKB": 18546.1796875,
                                    "name": "edgEgyptian_Doll.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-20T15:16:47.125Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "6906760218",
                                        "SHA256": "6906760218385358907CEE8853B6619321991CB000EFD107E45BA75E2C5CEE73",
                                        "CRC32": "9E9C982C",
                                        "BLAKE3": "247113B8DE4160693E08E681C42691126AEC88E2A5568BE931518F9FC83B036B",
                                        "AutoV3": "35E94DB3BD74"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/121908",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1642579,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/126e6e40-a8db-41ad-b35f-333b21e097e8/width=450/1642579.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPLNA5xZpJI@Tze.?bbvtnNGxu%M_Na|tR-p",
                                    "type": "image"
                                },
                                {
                                    "id": 1642639,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8345252e-280b-44fb-9b0d-43ec70f9e051/width=450/1642639.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBH_St?b00Q-00IT?w%g9F~p.7D%.8%MMd9a",
                                    "type": "image"
                                },
                                {
                                    "id": 1642580,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b54f08a6-f676-461f-abd8-e785690fe29b/width=450/1642580.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8E25;$$00K5}?WB9ukCu2x[w0MxTIWBDjxa",
                                    "type": "image"
                                },
                                {
                                    "id": 1642636,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/21a2d129-462b-4850-adda-f210f296e817/width=450/1642636.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBFOx}~W00$$004.o}?HD*?a~VE1?vR+9ZNH",
                                    "type": "image"
                                },
                                {
                                    "id": 1642576,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8181e4cb-1d6f-4bee-9c27-29f6edc5b944/width=450/1642576.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEHA|YoI0gaft,I;rpD%tl$$r=D*~V-UIUIp",
                                    "type": "image"
                                },
                                {
                                    "id": 1642570,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b3e62bdc-3d01-4b52-977e-2e2ebc58e909/width=450/1642570.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGH-#_S$D#vx^b$x_4%g8_~VkDtRE1?aMxj]",
                                    "type": "image"
                                },
                                {
                                    "id": 1642571,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fd6dd7b0-e10f-4a91-a47e-580281f28376/width=450/1642571.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8FhR~~V00$%58-oxZ$%?HWV-UE2^*-pof9a",
                                    "type": "image"
                                },
                                {
                                    "id": 1642574,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/658f9e80-dfed-4d06-a440-f8f8e68fe8c6/width=450/1642574.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UOH^@bXkI:=w9ZXSS2WX_N%1sT9tE1kDRlWB",
                                    "type": "image"
                                },
                                {
                                    "id": 1642573,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1a8e7d0a-4dc6-4298-a5f5-0635ced1ad91/width=450/1642573.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "U9Gt{B~DbUIA00M|S~9^E2NGtRS0-pxtD*%0",
                                    "type": "image"
                                },
                                {
                                    "id": 1642575,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c425623d-13cb-4783-bec0-89df89a6b7a9/width=450/1642575.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8A]QjpI0L9G}rNd9usls+aeI=xa0#i_xZxa",
                                    "type": "image"
                                },
                                {
                                    "id": 1642577,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/52904ed0-1d24-4da7-ba23-7f9a7f1093ae/width=450/1642577.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8F}$VrW00-p0mI99a%f_NRO%M-pTfD*4oxu",
                                    "type": "image"
                                },
                                {
                                    "id": 1642578,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b5809349-062c-45d8-992d-fe4942db73e9/width=450/1642578.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UZIO2:={%MxukrRPWCRk~pn~%2xtS%s,WBof",
                                    "type": "image"
                                },
                                {
                                    "id": 1642637,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f9ccd38e-707e-4746-904c-8234a308bac3/width=450/1642637.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTIEb0bD9s-:x]D%tP%g_MV?ROtR%g%1RPRj",
                                    "type": "image"
                                },
                                {
                                    "id": 1642572,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/392a0526-8f2b-468b-a9d2-e7e06ec015cc/width=450/1642572.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGGanC~qFf^OGu_3-;Eg-;-;xuE2%fXS%1s9",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/121908"
                        },
                        {
                            "id": 121408,
                            "name": "Swedish Doll Likeness",
                            "index": 33,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-07-20T10:50:00",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful edgSwedish_woman,perfect edgSwedish_face, perfect edgSwedish_body,"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4281,
                                "ratingCount": 28,
                                "rating": 4.93,
                                "thumbsUpCount": 46,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 87278,
                                    "sizeKB": 18550.03125,
                                    "name": "edgSwedishDoll.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-19T20:31:05.655Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "56FEC5D39D",
                                        "SHA256": "56FEC5D39DA7019724DC757B95B0C62C8A03E36C48BD7B964EF3B5D137BFE446",
                                        "CRC32": "213838B4",
                                        "BLAKE3": "5AB1A709917D6555138B416A26B67CD47EE034E6C375C68B37FAD2E8B401E177",
                                        "AutoV3": "BE7DFB5B6797"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/121408",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1632197,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/67e29166-bc08-479a-90b3-09d56ef9dc94/width=450/1632197.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8C?P{~q019Z00019]jayDRkRP?aK5?b^+Mx",
                                    "type": "image"
                                },
                                {
                                    "id": 1632201,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/05b7c53d-26eb-4f69-a7c6-a1b4360c6889/width=450/1632201.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UME.Rx~V9aIpR5Io9uIo%LRkIVso-:%Mt7V[",
                                    "type": "image"
                                },
                                {
                                    "id": 1632198,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/01f97148-50a6-481b-9a47-cbc10fb63420/width=450/1632198.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFFrbHn$9u9a00M{ozIV_NIo$*xuD*ofs:xa",
                                    "type": "image"
                                },
                                {
                                    "id": 1632196,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5bac1e48-8b78-4483-93d6-acc37ec16e47/width=450/1632196.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "UMI4|l~q9ED%4n9FE1E29Y%1x^R*-oxutlt7",
                                    "type": "image"
                                },
                                {
                                    "id": 1632195,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/39003876-e791-4143-bc32-41064b53240d/width=450/1632195.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "UPP6v?t8?^?boa%MogxujE%MR*IU%1s:Naoz",
                                    "type": "image"
                                },
                                {
                                    "id": 1632194,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/47a0eabd-16ad-4ae0-9eb0-172d7b1952c3/width=450/1632194.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "UCHnyzDi00~X00E2tS%100?b.9MwS%WBn4a{",
                                    "type": "image"
                                },
                                {
                                    "id": 1632199,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bf818938-d42b-4c79-82fc-2f0ee82a752e/width=450/1632199.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 2048,
                                    "hash": "UPGtpY~C0yE155M{RlS4WZW:oyR*NZWpWCaz",
                                    "type": "image"
                                },
                                {
                                    "id": 1632200,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0e6ea145-1e30-48f8-b515-7c826eb33e57/width=450/1632200.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULE_,K~VI:R*={Rj0LE1%fW=M|ae-:t7niV@",
                                    "type": "image"
                                },
                                {
                                    "id": 1632202,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/374876f3-44e4-4f15-ab55-c5f58c310843/width=450/1632202.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UOE{5_%29tRj~WoeE2NGtRNHIo%1o}j]n%a{",
                                    "type": "image"
                                },
                                {
                                    "id": 1632446,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8512e616-1bf7-4308-be73-d877609e63b0/width=450/1632446.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCCP9Q0M$_9H~AE2S#E29GxuI@%1E2%2R*xZ",
                                    "type": "image"
                                },
                                {
                                    "id": 1632470,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0ce990e0-0028-4f1a-8cf3-e5dded2771ac/width=450/1632470.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8BV;IDi_2E1~V9a9v574.f,00bJM|?anN-p",
                                    "type": "image"
                                },
                                {
                                    "id": 1632489,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bc31cdc6-4c37-41d9-b34e-0a1fa370777a/width=450/1632489.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEGuL6kQ?]4.00IV01Nf00%MXS%2?b?H-pM{",
                                    "type": "image"
                                },
                                {
                                    "id": 1632505,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b0f54f07-144a-4dd9-92db-d57d26a8d99a/width=450/1632505.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UADIE=-o0eIp0$NH0iRk~9WVxD%1ELRkbIxa",
                                    "type": "image"
                                },
                                {
                                    "id": 1632509,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e8228055-3f7f-442c-9bf0-d3880c8d9713/width=450/1632509.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEFOJt4:AE~A0KSh0L%1%1e.s;s.%LxaxuWB",
                                    "type": "image"
                                },
                                {
                                    "id": 1632521,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6034b768-c7bd-4c55-bb17-0904fc2219ed/width=450/1632521.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UUJaN1~VNabI9FRj9aIVE2n$WXWBxuW=s:fP",
                                    "type": "image"
                                },
                                {
                                    "id": 1632540,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ca6bf41c-4b14-4bc3-be51-dc3e6f8ceb1c/width=450/1632540.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1023,
                                    "height": 1307,
                                    "hash": "UEE_{p~V009G01V[%MX99ZbH-pNGbbayaKni",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/121408"
                        },
                        {
                            "id": 116643,
                            "name": "Hapa Doll Likeness",
                            "index": 34,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 23,
                            "description": null,
                            "publishedAt": "2023-07-13T10:52:29.383",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful edgHapa_woman",
                                " pretty edgHapa_face, perfect edgHapa_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4075,
                                "ratingCount": 102,
                                "rating": 5,
                                "thumbsUpCount": 143,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 83269,
                                    "sizeKB": 18546.3515625,
                                    "name": "edgHapaDollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-13T10:55:25.227Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "BCD6ACDC8C",
                                        "SHA256": "BCD6ACDC8CFDDA0A6B5E8EA4AE07637A73AAA73D4E76F150044E422B359A649F",
                                        "CRC32": "68CDACFF",
                                        "BLAKE3": "FB514773A5E8F6329DDADFD606E427F754D418695698B3AECAB0DE29B492EE44",
                                        "AutoV3": "55FF0B17ADDF"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/116643",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1536635,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bf6c63fe-aeaa-4a27-8dfe-efce3e43692c/width=450/1536635.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8F#abR500tS00-:O?E10KM{~CIpELW=oJt7",
                                    "type": "image"
                                },
                                {
                                    "id": 1536633,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5835e15b-058d-4a5a-9fab-141908d938aa/width=450/1536633.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKG*A_~B9u4.Y6NtR+IUa%IVf5sS_2%LenV@",
                                    "type": "image"
                                },
                                {
                                    "id": 1536630,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/88b0d126-696b-4e17-80fc-9bd4df271e0c/width=450/1536630.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDKl,Q6u*xFz{]u2MJIC00IB.mrs=zcEkVt6",
                                    "type": "image"
                                },
                                {
                                    "id": 1536631,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bf196b2c-284d-44ad-955c-b71f2eb663a3/width=450/1536631.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7Iz^,0000OF5S};00_3$H9G.A.9_39uVs_3",
                                    "type": "image"
                                },
                                {
                                    "id": 1536636,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d084530-0712-403a-a704-9a90284c4b54/width=450/1536636.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9I49Nbw004n00IU5Rba9ZR+?aNGoMM|~BIp",
                                    "type": "image"
                                },
                                {
                                    "id": 1536638,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/22a0fd1d-a4d4-4115-b347-892b4fd8075c/width=450/1536638.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9INaFR600~U00oy-VoeDixZ^*kDXTbbM|V@",
                                    "type": "image"
                                },
                                {
                                    "id": 1536639,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9f5f35e8-a0e0-47af-bf15-77e8dfe5da83/width=450/1536639.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9LWY2-=4TZ$00R4xw%M00XmIBD*xtRP~UaJ",
                                    "type": "image"
                                },
                                {
                                    "id": 1536640,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fe7fc228-df10-49bb-b512-50a304369c43/width=450/1536640.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQLg63og8^xY-NoJRoxtawWBxZog~qozV?Ri",
                                    "type": "image"
                                },
                                {
                                    "id": 1536642,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/27721354-f9db-4b2d-922a-aed8fd9b960a/width=450/1536642.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UUJa7fH?^iVX.TxYI:Ri%$RjNGRj?bRPs.Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 1536643,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1a524137-43c1-4974-ba9e-b7aabd68be6f/width=450/1536643.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UWJ@ONt7~q?ao~bJgOW=R*%LWAt7X8Rjo0WB",
                                    "type": "image"
                                },
                                {
                                    "id": 1536641,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c4a57a87-10ae-4361-87fd-445a8db5cb67/width=450/1536641.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTMP?*.8.T_NF3RjX8jEEMV@V@NGx]t7oLR+",
                                    "type": "image"
                                },
                                {
                                    "id": 1536644,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/60613970-d5e4-438f-a753-fd814a3f8fe1/width=450/1536644.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHJQsC^*~V%g~q%hT0Iq4mt7S5$%D*4oNHWA",
                                    "type": "image"
                                },
                                {
                                    "id": 1536645,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cac7d824-c378-41ea-960f-7eea6f252deb/width=450/1536645.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMDSE._3-;kC~p?b%MozxvxukWkCkCR-WXRk",
                                    "type": "image"
                                },
                                {
                                    "id": 1536648,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bb075371-a5fd-4dbe-a1cc-333181c9d7e5/width=450/1536648.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULGRxNi_~W%M~pRjozoyV?j[IVWBIAofM{fj",
                                    "type": "image"
                                },
                                {
                                    "id": 1536649,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d21c7c3c-50a5-4faa-8697-d91c7876c67c/width=450/1536649.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJI}09yD%zRj_N?a%gnh%g-pyDE1_2tR%2R*",
                                    "type": "image"
                                },
                                {
                                    "id": 1536650,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d2609e85-e022-410a-8a07-3bedfe25e670/width=450/1536650.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJIg},~q_2~WbwoztRj[9F%2Osn$%Mt7V@IV",
                                    "type": "image"
                                },
                                {
                                    "id": 1536647,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/184cb49a-551c-462a-be1f-83963f1ddc7c/width=450/1536647.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1024,
                                    "height": 1162,
                                    "hash": "U4FE$300HVL~yr00GG8_%40J?d-MyX8_x]#S",
                                    "type": "image"
                                },
                                {
                                    "id": 1536658,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/93b3ba38-45f0-4f20-99eb-64fc7b1c5920/width=450/1536658.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9Duua~C0055%}E24.%09vNGRQxa-p-p%1Io",
                                    "type": "image"
                                },
                                {
                                    "id": 1536659,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a56f6866-8e76-4af7-97b6-eec04c2f8260/width=450/1536659.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9CrvEIW0K9t_MD*nhs,%gRPV@%1.7aeIVIp",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/116643"
                        },
                        {
                            "id": 60081,
                            "name": "Mid-East doll Likeness",
                            "index": 35,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-05-01T21:14:21.226",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful m3d_woman,perfect m3d_body, perfact m3d_face"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4421,
                                "ratingCount": 56,
                                "rating": 5,
                                "thumbsUpCount": 66,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 42586,
                                    "sizeKB": 73842.587890625,
                                    "name": "m3d.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-01T21:15:34.697Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "275D5B59",
                                        "AutoV2": "2679F0EFA4",
                                        "SHA256": "2679F0EFA4FBE9681DCB3FBD60AD08B4E39F2ABEC938A6A26822E952FDA89D84",
                                        "CRC32": "3366A40F",
                                        "BLAKE3": "15829D3D886D6E6E39374A5B59F08C9AB7C410798B4DDACF5143211458006C72",
                                        "AutoV3": "D607C37FAA26"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/60081",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 655987,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/20d0e920-052d-4dc4-da7f-0f7987dbf900/width=450/655987.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U8JG[]xG00OsRf-;},s8X:^k^*bb%0ROxCI;",
                                    "type": "image"
                                },
                                {
                                    "id": 655990,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/30ffdf93-4ac3-40ab-5d18-b2e12a52b700/width=450/655990.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UcGb0H~p?b-;?Ho}tRxuD*M{V@jFNGoKjYM|",
                                    "type": "image"
                                },
                                {
                                    "id": 655984,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/520e062f-3a1c-4ac0-179b-6e0eae86e600/width=450/655984.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UQJQ[@?b9ZRPD$E1NIWB?w%MI9M|R%RkITIV",
                                    "type": "image"
                                },
                                {
                                    "id": 655993,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0bf63889-2895-4b3e-8a8a-d92f03476800/width=450/655993.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UMJ7aZkr_M_3%M$$%L57oID%slRjNHIo-V?G",
                                    "type": "image"
                                },
                                {
                                    "id": 655986,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cff293dc-d58b-4d0a-faca-b077aa64c300/width=450/655986.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UBI4Y2njyq00.S~BK3E1WAtk,@M|01.7xG-:",
                                    "type": "image"
                                },
                                {
                                    "id": 655992,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8b6be74b-a6fd-493b-0439-236e83f7a400/width=450/655992.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDF5He_3Xm9b%M~B9tE1ELI:^jV[0zxZ%1s,",
                                    "type": "image"
                                },
                                {
                                    "id": 655989,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/230ee219-c458-449b-a66c-e39dcb1cda00/width=450/655989.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UEFOZE~qpw_3oL={M|579uEL^j={57oz?G?G",
                                    "type": "image"
                                },
                                {
                                    "id": 655985,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5fd4de7e-68cf-4b35-86ae-65b64201da00/width=450/655985.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UAHnvnEM~VkCIA9GxZIA%LIUE2?bMwM{M{R-",
                                    "type": "image"
                                },
                                {
                                    "id": 655988,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/db79c6e0-12cb-4252-e460-b44338ba0100/width=450/655988.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9FrO-tm~o00~Bt74.IUITD%-;-;nNnh%Mxu",
                                    "type": "image"
                                },
                                {
                                    "id": 655991,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/392075da-0eb4-418a-00aa-1e487d504000/width=450/655991.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDGQ|F?H%LS~~AaLs.NG57Naxa~AbaNakB-o",
                                    "type": "image"
                                },
                                {
                                    "id": 655997,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/989f55f0-ca62-4774-9d01-dbc60eca1100/width=450/655997.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U7C=SU}@0057k:I;57Ip0fso}@of0fNH^j%1",
                                    "type": "image"
                                },
                                {
                                    "id": 655998,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/338ad79f-a0fd-46f5-9407-bf5a4ef3b600/width=450/655998.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "ULGkH~~oTcxu%LV@WCEL57R*={xZNHWWxa-o",
                                    "type": "image"
                                },
                                {
                                    "id": 1450643,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a18361ad-205f-433e-ade2-44a109060ce1/width=450/1450643.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U7Cis}D*00-V+DNGlUwH00NG~B?b1j%L+s9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 1450644,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eebe3a08-8b29-4d7c-8fa6-2ca7b09bd9e3/width=450/1450644.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UACGGc000K_N-gRPIpow8wtmp0Rj01-:?FMy",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/60081"
                        },
                        {
                            "id": 74089,
                            "name": "Viet Doll Likeness",
                            "index": 36,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-05-18T13:56:50.731",
                            "availability": "Public",
                            "trainedWords": [
                                "edgVietd_woman",
                                "perfect edgVietd_face, perfect edgVietd_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3495,
                                "ratingCount": 54,
                                "rating": 5,
                                "thumbsUpCount": 62,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 51245,
                                    "sizeKB": 41587.2880859375,
                                    "name": "Doll_LikenessbyEDG_edgVietd.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-18T13:58:00.820Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "1315B3A8",
                                        "AutoV2": "3413BFC071",
                                        "SHA256": "3413BFC0712EE6D37828B35A9167E4C291B624A36931B805C76B7E40714D5C48",
                                        "CRC32": "B4BA26B0",
                                        "BLAKE3": "A35DB753AFE6094BE3A0F125EF5C54F522F46EB917961D44777369B5BAC1EA84",
                                        "AutoV3": "1025724D9DA8"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/74089",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 827895,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b662fa30-3cfd-4554-af54-637d68b7f5d8/width=450/827895.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1018,
                                    "height": 1138,
                                    "hash": "UUMaV87t?^Gte7I:tT%LIpkVt7xbyFj]ius:",
                                    "type": "image"
                                },
                                {
                                    "id": 827896,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/97e1f062-0b02-4986-a1c5-2a3c992b7428/width=450/827896.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDLNrpEA.P_200R2~p9Fr9xsFix^K8x_v_-m",
                                    "type": "image"
                                },
                                {
                                    "id": 827894,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/14a6eb90-428c-4003-bd00-8ab0c84e027f/width=450/827894.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U8K1zb9G7*D600I1?]-?00nq=hD*00?N04D|",
                                    "type": "image"
                                },
                                {
                                    "id": 827897,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/12cb557b-b8b6-4b11-9720-46568fd0a61f/width=450/827897.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UPL;Q*ITyC^$VBR-?aS%bCS5slkCpyxCR5-n",
                                    "type": "image"
                                },
                                {
                                    "id": 827899,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/37276195-f7f7-4ce8-b59b-8b8a50888f41/width=450/827899.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UEJs:@IA$_0NI90N^J?Zxpx[59}=9aR-xu9b",
                                    "type": "image"
                                },
                                {
                                    "id": 827901,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/46d8ac3d-3d26-4d78-99e7-4ceaafbc3f88/width=450/827901.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UYL|Dk9a.RS~HWWnTxJ-1fI:S5W=xur?V@t7",
                                    "type": "image"
                                },
                                {
                                    "id": 827902,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c892b4c9-9411-423e-a460-351ccf7ebc7e/width=450/827902.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UTMGYRs=_NE33rJQKjkp5=i_RRrsTdRjScxs",
                                    "type": "image"
                                },
                                {
                                    "id": 827903,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4f071caa-bf9a-41bf-8b9f-338d6c734d70/width=450/827903.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UPM6@#In?t*02_D+OaX-7Kw[s-OTFhxXs9IW",
                                    "type": "image"
                                },
                                {
                                    "id": 827900,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/90b7e1ec-32d2-455c-800f-74dd6d626907/width=450/827900.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UQMaCb~q%~bbL}nN%hbbpKIU?GNH.8oeoLRk",
                                    "type": "image"
                                },
                                {
                                    "id": 1450448,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6c0ee77b-5801-45a2-aaea-b6cb492edca6/width=450/1450448.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFGbk;t800xu00xa.9Io00E1%hxZ?wxtV=bb",
                                    "type": "image"
                                },
                                {
                                    "id": 1450450,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e6002357-a765-42fe-a721-4c915b50e451/width=450/1450450.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UZJar|M{?ZM|~pf6WUt6-TWVozt6ofj[RkWC",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/74089"
                        },
                        {
                            "id": 78147,
                            "name": "Latina Doll Likeness",
                            "index": 37,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2023-05-22T19:35:21.521",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful Lnd_woman",
                                "perfect Lnd_face, perfect Lnd_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4270,
                                "ratingCount": 69,
                                "rating": 5,
                                "thumbsUpCount": 81,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 53768,
                                    "sizeKB": 25458.173828125,
                                    "name": "edg_LatinaDollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-22T19:36:14.288Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "947FFB32",
                                        "AutoV2": "700478729F",
                                        "SHA256": "700478729FF4E386C69942288C5DF4084397B0B05F190A2DDA7D3486043B58D6",
                                        "CRC32": "29D460BB",
                                        "BLAKE3": "FDE1FCA6E2CC3E2AD9174B6D268D1A3A09FD73B7C86C25C5C13B84ED57AD861F",
                                        "AutoV3": "D276A8E074F8"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/78147",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 876437,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e197c0a8-af16-44b9-ab64-ce7b40caef66/width=450/876437.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UIH-rfR*%L0g~AIptlj[SPNHxC-of-bI%0xa",
                                    "type": "image"
                                },
                                {
                                    "id": 876425,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d6dc536-8424-4a95-bca0-0a571395e27c/width=450/876425.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDF}+b4n0e~VB#axrrW=9Xx]%3M|tlVsRjMy",
                                    "type": "image"
                                },
                                {
                                    "id": 876440,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0b3e4944-b67f-4de6-9b29-06e101af33a8/width=450/876440.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "USHBfMsnpfS%-5S4v}s8#AslEnNHyZofNfae",
                                    "type": "image"
                                },
                                {
                                    "id": 876424,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5c51faff-d8cd-43f5-95d1-21dd0448db50/width=450/876424.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UNMGbZ9ZC6^+*Jnh?HIoR+flVsWA%gWXRPxa",
                                    "type": "image"
                                },
                                {
                                    "id": 876436,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/64fa09c3-8f24-4a4a-8055-391c6f98528c/width=450/876436.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UGC=@-IqDi^i{{fOK4xaO?s9RkOEE2tRxaIU",
                                    "type": "image"
                                },
                                {
                                    "id": 876434,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9e891214-8cab-475e-9d51-ab3b5e25a9a9/width=450/876434.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFH24g?v?t~U~W4:yDNHt7E1-oE1?wEMRO-o",
                                    "type": "image"
                                },
                                {
                                    "id": 876438,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/82357305-f6d2-4587-bddc-d2286b9eec76/width=450/876438.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UAEL85AU7Z^6Ka?GE1NG1Z-TVYI:}@o|Svrs",
                                    "type": "image"
                                },
                                {
                                    "id": 876441,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/da3b70b2-9c0a-4337-922a-50e246feedd6/width=450/876441.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UHI4ko;LG^Ip2cI??btR0gNxRjs:^,n#4:ni",
                                    "type": "image"
                                },
                                {
                                    "id": 876439,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f0134fd0-1a06-478c-983a-3e867a45153a/width=450/876439.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UJFXr89ZRhM^}OS6ozxv%hR*s8$zNFRixvs.",
                                    "type": "image"
                                },
                                {
                                    "id": 876423,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6eed178f-8a21-4e1d-bf76-2bb3a05efebb/width=450/876423.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UJF6h9t-QRQ,{tMwOtozeRoKgio~KRkCi^R*",
                                    "type": "image"
                                },
                                {
                                    "id": 876422,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/86ad3a0f-0a41-4fe2-b271-f47fb56b5ba6/width=450/876422.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UPIqMz~pYOyXF1IVsA%MNbRjs9%L%Mj?WBtR",
                                    "type": "image"
                                },
                                {
                                    "id": 876426,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6caff85c-27d3-4b63-91af-12b28bd29681/width=450/876426.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U7Ew{?^61NM{~Ab^5PSx9[s;MxEL%NRlkrMe",
                                    "type": "image"
                                },
                                {
                                    "id": 876428,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/87579501-6553-47d3-9787-889282e5f4f9/width=450/876428.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UtM~;Db{p{-VTyozxbofS$r=aKSgogjFf5WC",
                                    "type": "image"
                                },
                                {
                                    "id": 876433,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8b45d01e-c78d-4a30-9702-f7bfc0bdcc16/width=450/876433.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UeI;#UwI.TtRAfS$Sk%1I]tQadR*o$s,r;ae",
                                    "type": "image"
                                },
                                {
                                    "id": 876429,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/398cf56e-0dfa-47ef-b8de-fdc9a5e7b8aa/width=450/876429.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFGaayTJYM}@R$xEwHIU9_$PM{SgwIR*W.s;",
                                    "type": "image"
                                },
                                {
                                    "id": 876431,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f15a8c90-7723-4a42-bf19-957d7e69eb5d/width=450/876431.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1006,
                                    "hash": "UMCZhqx72|NgEINNi]xsMbMyZ~$x#l%Ke.Iq",
                                    "type": "image"
                                },
                                {
                                    "id": 876430,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/113da72e-534b-4e4c-b803-2750e4eab3ff/width=450/876430.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UEE.9G9$0M~W?9NFIUxos6Iut7xY0-ae=ySi",
                                    "type": "image"
                                },
                                {
                                    "id": 876432,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a5d796aa-0e59-4c33-8058-242ef0518594/width=450/876432.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 852,
                                    "hash": "UAGuE{_LyZ5P?bx@o5rU0#$+RNn--*=z9YEU",
                                    "type": "image"
                                },
                                {
                                    "id": 876435,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/133fca4e-128c-4e39-86f7-2c77d84211d7/width=450/876435.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UGFhVF~VlT?b9[4:E2IW%yNFRP%1nOjExtbc",
                                    "type": "image"
                                },
                                {
                                    "id": 1450482,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e6f84ebd-3ae6-436c-a04d-5c893cc49c2c/width=450/1450482.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UED]0bMwxu%L~p01I;S4Eg9G-ps9tQ$i%2Mx",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/78147"
                        },
                        {
                            "id": 49006,
                            "name": "Spanish Doll Likeness",
                            "index": 38,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-04-18T13:46:40.292",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful esd_woman,perfect esd_face, perfect esd_body,"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4394,
                                "ratingCount": 30,
                                "rating": 5,
                                "thumbsUpCount": 39,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 36108,
                                    "sizeKB": 147571.8291015625,
                                    "name": "esd.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-18T13:46:09.610Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DBBE991F",
                                        "AutoV2": "8277285FB6",
                                        "SHA256": "8277285FB6E90123E004C667ACA01BF62EDF5C801D0B42DE34EE2855ED90910C",
                                        "CRC32": "DD2F8ECA",
                                        "BLAKE3": "AB030C162337A4B06238C04B9CC531CB2E5FBFF25C35D131E4B6AB66E5414A8E",
                                        "AutoV3": "891AF392CD1C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/49006",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 526434,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/99fc0fc6-6e72-4c20-f126-683d7aa94100/width=450/526434.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U8CrZd02At0f.7n4tl4:TJ0f~B$gOr0f~B={",
                                    "type": "image"
                                },
                                {
                                    "id": 526436,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a09ee94e-ae32-4119-c4bc-48d66717b300/width=450/526436.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UeG8Gw~V-;o}ofWC%1xZWBayaeayt7t7ofs:",
                                    "type": "image"
                                },
                                {
                                    "id": 526424,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/447eb190-45ac-466a-5404-d91590afd600/width=450/526424.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UHD9CtT0?b~VxuxZt7M|9ZIVRPIo4:V@jFNG",
                                    "type": "image"
                                },
                                {
                                    "id": 526432,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8624d08d-1263-49d2-8a9a-eb2539af7c00/width=450/526432.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UEDu_AK6?u~V-:~Vozx[$yRjnNxC^%D*$%xW",
                                    "type": "image"
                                },
                                {
                                    "id": 526431,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e28bb3af-ac26-4a42-d5dc-ba746abcb300/width=450/526431.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UEE2tb00XnxZ_MQ,JAs:XnRjwIx]~p9Gae-;",
                                    "type": "image"
                                },
                                {
                                    "id": 526426,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/abce6f38-8e73-4846-e199-bf75b9d02c00/width=450/526426.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFDu}O00?vMx~pDi?H4.tRR*oLxZSLRjxZof",
                                    "type": "image"
                                },
                                {
                                    "id": 526429,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5166240d-232c-4e5b-2479-836be177f500/width=450/526429.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UEGt$ybw~q0M_3^i.8Io~VIp?GM|57M{=|^j",
                                    "type": "image"
                                },
                                {
                                    "id": 526425,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2ce16f30-a006-4adf-7fe1-d067ede45700/width=450/526425.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UECPY6~Vx[=|~V^*xuNHS#xt-pIpxt?H-poy",
                                    "type": "image"
                                },
                                {
                                    "id": 526433,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/370a80b5-e0a1-4063-20ae-1179d4237400/width=450/526433.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UGC~k:OsX9-pX9?GNHRP57-psmD*~VIpR+oz",
                                    "type": "image"
                                },
                                {
                                    "id": 526430,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ef02d773-75f3-458f-db0e-c052659d5d00/width=450/526430.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "ULDb=?~V.7?a~V^*%2%LI;t6niIoxtWBa#Ip",
                                    "type": "image"
                                },
                                {
                                    "id": 526435,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/99029dfa-b0b1-4f55-4c78-07b569d42000/width=450/526435.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UREL+{~VkqOsxu-;xuxCxvWBsmxa%2xuxtNG",
                                    "type": "image"
                                },
                                {
                                    "id": 526427,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e546b75e-11e6-4654-af27-719a2da32800/width=450/526427.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UMBV|f~Vx[Rj?G-p-oof%L%Lt6Rjt6t6j[s.",
                                    "type": "image"
                                },
                                {
                                    "id": 526448,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad049c39-b8f1-4687-ed12-71790e79c200/width=450/526448.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDCiaQNHKP~VE3?Gxt0fIUR-jFxFo|M{xF?a",
                                    "type": "image"
                                },
                                {
                                    "id": 526447,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ea342d11-79fb-4c8f-99b9-7b5160245900/width=450/526447.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "ULECB]4:~pV[XT%1Neoe9tt6V@t7I:n%t6R+",
                                    "type": "image"
                                },
                                {
                                    "id": 1450505,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/becca756-53ca-4135-99d2-15056b76ead2/width=450/1450505.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UGF=:c~pD%M|00V?I:WADiM{%MxvyEo#s:V@",
                                    "type": "image"
                                },
                                {
                                    "id": 1450513,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/acada71d-eec8-4f74-9a93-c5a55393d21d/width=450/1450513.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "USGuq6D%9Z-:~WV?E0WXxujEt7R+_3M{s:t7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/49006"
                        },
                        {
                            "id": 49212,
                            "name": "Russian Doll Likeness",
                            "index": 39,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": null,
                            "publishedAt": "2023-04-18T18:16:18.123",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful rud_woman, perfect rud_face, perfect rud_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5892,
                                "ratingCount": 50,
                                "rating": 5,
                                "thumbsUpCount": 64,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 36246,
                                    "sizeKB": 147571.3671875,
                                    "name": "rud.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-18T18:15:58.668Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "45C90383",
                                        "AutoV2": "724BF8EDCD",
                                        "SHA256": "724BF8EDCDF283EE6B9600D42981C5AEF9A6FF90CDA9CB39920A4E71A8DF928A",
                                        "CRC32": "AE469F49",
                                        "BLAKE3": "6B624CBF052771D1C1D8E276DC7EC35F3247CD7FA2DD8D0570AC073E3D0E2D5D",
                                        "AutoV3": "2D44FF4C732B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/49212",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 528966,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/049e6021-861a-45f0-65a1-b84503bb9300/width=450/528966.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UIJjo3-n014p009w9FWBM{xG~W%1JA9aV[WV",
                                    "type": "image"
                                },
                                {
                                    "id": 528967,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a9bdd807-8080-4a55-c327-354196fdd400/width=450/528967.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UUJ%wb~V0L9G4.IoIVNGIpoM?HtQE2Rji^ae",
                                    "type": "image"
                                },
                                {
                                    "id": 528959,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/20a1a34c-5724-4127-0772-bee5629a6100/width=450/528959.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "USH^kft60LM|~BNHIVt7k9WBn+ozW=ayIpoJ",
                                    "type": "image"
                                },
                                {
                                    "id": 528960,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8cf1218f-e21a-408b-96df-927fed745400/width=450/528960.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UGKAA:}:005AbpEgxuNG00NyxuIVNHRkrsxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 528895,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1a86e385-78f3-4d60-4b9d-1dd070025200/width=450/528895.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9LDfG0L3;E1OX9F~pnN0PeS4T-n4To$VYxu",
                                    "type": "image"
                                },
                                {
                                    "id": 528961,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c27ef6d4-617f-4ee8-1cfb-6ff0cb854400/width=450/528961.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "URH^t%~A0157WUs-RjM|t6W=WqR*57EMWCxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 528896,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5812be1e-00dc-41b1-75cc-a6f755c8f900/width=450/528896.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UdM7W2?GUHX9E+jYIqofJBWBRlWBtSbcWCRk",
                                    "type": "image"
                                },
                                {
                                    "id": 528958,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/89f77752-5a76-4f9c-c912-40428b054f00/width=450/528958.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UJHdNi}=0e?Z^*%0xZoyEMW=-pWC%1RkbIxu",
                                    "type": "image"
                                },
                                {
                                    "id": 528897,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5c0a071b-b569-499f-685d-b3f09b942300/width=450/528897.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UBJt3X0M00xs00of57$*?^%L8_xuIAIp-oof",
                                    "type": "image"
                                },
                                {
                                    "id": 528894,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6692f87f-02a0-4e35-7ce6-6eef8d2f5300/width=450/528894.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "ULL3_a~V72kqK+ogbwI:5UWBIBIo%1xF%2f6",
                                    "type": "image"
                                },
                                {
                                    "id": 528898,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/08cc9c23-ca74-452a-ec8b-e122f1a80900/width=450/528898.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFLpjjEL015U4m9GFyU]cuxt4nX9=_IoxuX8",
                                    "type": "image"
                                },
                                {
                                    "id": 528904,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0250f9f1-7831-4bcf-9a2e-c14576acaf00/width=450/528904.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UEKA+*4T0f_2Gw,-9a0et.IUxGShAHE2^*w]",
                                    "type": "image"
                                },
                                {
                                    "id": 528900,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/730d9161-c646-4421-c267-32bfc20ec700/width=450/528900.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UQMi~JD*%#-:*0aetm%19~WV9GozohWDV[kC",
                                    "type": "image"
                                },
                                {
                                    "id": 528905,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ba377195-4462-4574-0c1b-77d89ed48e00/width=450/528905.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UHLpT}~q0LRi00%M9a9F9uDi-Aoc0Kf,?H%g",
                                    "type": "image"
                                },
                                {
                                    "id": 528901,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/840d0150-7cf4-4709-d7a3-10cb4931ef00/width=450/528901.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UAL3x;t,00$d00xa4;IA0gxa=wM{4nE2~Wxu",
                                    "type": "image"
                                },
                                {
                                    "id": 528899,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/89697a11-e435-495d-f261-385e9c966400/width=450/528899.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UPL4KO0zYk?H%$M|krtRp0R-wJM|OXRPtRtR",
                                    "type": "image"
                                },
                                {
                                    "id": 528902,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/affb318b-c99b-465d-3ecc-71d7a1dcae00/width=450/528902.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U5MsK001Q48w05t,0M9G00OGL#9Z00#k_2^k",
                                    "type": "image"
                                },
                                {
                                    "id": 528964,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bc68fb95-f510-47d5-09e6-db0451902200/width=450/528964.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UlKmhA~UEgNGNaofa}R+IURkV@M|o}WBaJoL",
                                    "type": "image"
                                },
                                {
                                    "id": 529920,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fac7ba16-61e8-4b6c-d4cf-fea5e1e28600/width=450/529920.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UPIX%5%14m~qE2%L.8Rjk?Ioi_xtxut7RPjY",
                                    "type": "image"
                                },
                                {
                                    "id": 530006,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9c8efd39-8224-44ec-b3d7-480919c83700/width=450/530006.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UGI:|6%2000M5lbI#RM{01Ip~VS4E2NHNG-o",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/49212"
                        },
                        {
                            "id": 49876,
                            "name": "Tanned Doll Likeness",
                            "index": 40,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-04-19T13:28:43.397",
                            "availability": "Public",
                            "trainedWords": [
                                " ((tan skin)), beautiful tad_woman, perfect tad_body, perfect tad_face,"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3758,
                                "ratingCount": 30,
                                "rating": 5,
                                "thumbsUpCount": 39,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 36662,
                                    "sizeKB": 73842.173828125,
                                    "name": "tad.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-19T13:31:17.302Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "9C068C4B",
                                        "AutoV2": "DC501C0B90",
                                        "SHA256": "DC501C0B90D163DBB61E24C7D89DE71B3F52EC8D56AB9150EB89845DE99724DB",
                                        "CRC32": "40EAEC66",
                                        "BLAKE3": "B0EB6FFB07D561419CD5F5B069D7C93C74A03E6890440FAB3E739D4EB2DD966A",
                                        "AutoV3": "71A8A0E6C52D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/49876",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 536263,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8753e641-cf89-4525-a83e-6846f56d2800/width=450/536263.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UFIpr35S00%L^jw]E19u57={kW$*~Aoe57oJ",
                                    "type": "image"
                                },
                                {
                                    "id": 536272,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/75b08853-f899-4ee3-b11f-1b1a66135e00/width=450/536272.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "ULF=zA?GD%NbobNH~qxa?bR+M{f6_3s:E1bH",
                                    "type": "image"
                                },
                                {
                                    "id": 536267,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fc60e04d-b942-4738-abde-ada7592c1500/width=450/536267.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UPIXpq*0?^-pIoXo.8g4.8IVIAIo0Kxst6j=",
                                    "type": "image"
                                },
                                {
                                    "id": 536266,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/292c0c7b-c4c7-46db-edbb-757a58b9ab00/width=450/536266.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UBGuXc00%zMd00^+b{_20$~W8wM{4nnO_N9G",
                                    "type": "image"
                                },
                                {
                                    "id": 536265,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ee7fa834-169e-420f-364b-591795ec8500/width=450/536265.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UNHn?E0LE0%L4ms._NRj?vRkVrs:xuRjxtxt",
                                    "type": "image"
                                },
                                {
                                    "id": 536270,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/962ecc41-7ba5-40b2-c53e-100c41eddd00/width=450/536270.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UCGbCv560L~V00%L%#RPENV@8wIpngWC~WtR",
                                    "type": "image"
                                },
                                {
                                    "id": 536262,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80fc6c79-9f5a-4616-1c2d-7affe48c5900/width=450/536262.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UNI}CZ5S~U%1r;V@~qxZ0$ae9Ga{RkbcR*NI",
                                    "type": "image"
                                },
                                {
                                    "id": 536269,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c10f2699-e2e6-4bb7-e403-9eefba613000/width=450/536269.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UED]C;R.0eIUD%9t?b-U_N$%H?IqE2xu%M9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 536268,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3f284037-e3c1-44be-86c4-d771f4461500/width=450/536268.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UEG8ZVMwt+xu]|?c_2IU.TMw#kkC00xv%LM|",
                                    "type": "image"
                                },
                                {
                                    "id": 536264,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/426652ff-bb02-464d-cc52-9dfa9ade4f00/width=450/536264.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "ULGHxT02AI~UIo-pjZxa%gWC-:xuIpt7ofs.",
                                    "type": "image"
                                },
                                {
                                    "id": 536271,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9e454229-b208-4c01-60ea-82d1755ed500/width=450/536271.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UHEVHC?bpI~B-TIpS2RPt,?G%1NG4:E2IoIU",
                                    "type": "image"
                                },
                                {
                                    "id": 536300,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3b2a5763-5493-4e6c-3127-c1337d480900/width=450/536300.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "USEVA^o}Or$z~V%LWWn$Jn%LwvE2X9xto0Io",
                                    "type": "image"
                                },
                                {
                                    "id": 536309,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/32d0834f-a624-46d9-77d0-c4c251915900/width=450/536309.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UOD+Vh9Z~VR5~BWA%MaKNJaxNGM|xuRjt6E2",
                                    "type": "image"
                                },
                                {
                                    "id": 536303,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/29d670e6-52bc-4c0f-a19c-f10ebb570900/width=450/536303.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UDD]I}00?[R9_1Dkt1t9k=Mx-oNy~X9F-;R%",
                                    "type": "image"
                                },
                                {
                                    "id": 536308,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/53f53493-a9a8-4a17-6522-3a64f4e5da00/width=450/536308.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UGCYm*5RTJ~A^*R+xu%10z%1xE9uIpoJo0M|",
                                    "type": "image"
                                },
                                {
                                    "id": 536302,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e64f336-5a04-413a-09e0-7d4bc7ab9e00/width=450/536302.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UBD+Vhr=C7NG~pIUkrs858RPMyskaIM_VsM{",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/49876"
                        },
                        {
                            "id": 50182,
                            "name": "African Doll Likeness",
                            "index": 41,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2023-04-19T21:20:43.734",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful abd_woman, abd_body, perfect abd_face"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3983,
                                "ratingCount": 36,
                                "rating": 5,
                                "thumbsUpCount": 48,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 36840,
                                    "sizeKB": 73841.73046875,
                                    "name": "abd.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-19T21:16:23.683Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "2CBB3CC8",
                                        "AutoV2": "19C4B6737D",
                                        "SHA256": "19C4B6737D3A03AAAB0D05DC61EB3C325B016F7DA94E6E094E139CCBF8AEC7F1",
                                        "CRC32": "8698914A",
                                        "BLAKE3": "BC26AE177F23827A10A60015AEEB6DC4260448EE6C5F02CEBA0A68EC06252BA2",
                                        "AutoV3": "96CA4F35E60D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/50182",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 539805,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3373d68a-a8c0-49ef-c3db-cb230abda500/width=450/539805.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U5AI*;~A0#5R^i={S49vELxENHEM-BNHIpNH",
                                    "type": "image"
                                },
                                {
                                    "id": 539811,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/911a41c2-256c-4010-924d-c8375d9a6c00/width=450/539811.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9CF#A^j00xCI,RibwNwR2%0~qg3.7Ip9GIo",
                                    "type": "image"
                                },
                                {
                                    "id": 539812,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/af12e893-0452-496b-01e1-3d4c2e9edc00/width=450/539812.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UPHLST~W_2M{xtt7-;t7IpRkIUaeRjWBt7t7",
                                    "type": "image"
                                },
                                {
                                    "id": 539803,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ef2081d5-71b1-4c23-9957-fd42e071f700/width=450/539803.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UKHU@3_N_1M{AwyDEOjE9Zxtt7V@~WaKaJxu",
                                    "type": "image"
                                },
                                {
                                    "id": 539808,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f8d2f03f-25bf-4b3b-41b8-f5f9c91f0600/width=450/539808.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "URGudr~qxst79GRPt7bI4TaJ$*s.%2WBM{Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 539823,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/df17dae1-ec2d-42ef-7a41-e00feabb1d00/width=450/539823.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 882,
                                    "hash": "U8A+mV~A5l5Rt3-TNH9]jGRkNHI;I;NbR-WC",
                                    "type": "image"
                                },
                                {
                                    "id": 539813,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1054888b-88ed-402e-0f57-305d7b1cae00/width=450/539813.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "ULIrNk8w_Mr;K+IVo~EMVsX8={Rk?wxGDiWU",
                                    "type": "image"
                                },
                                {
                                    "id": 539809,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/51733fec-e81f-43ba-7b95-b0ffd9bb8800/width=450/539809.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UAEx^T?u.S~WNW_28|i{_LJAtmE355%1ICe=",
                                    "type": "image"
                                },
                                {
                                    "id": 539806,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a693721c-20e3-48cd-6771-0fbd89806700/width=450/539806.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UHFrqx-:.R%Myr%fIotR~qoz%MW;JCX9NHof",
                                    "type": "image"
                                },
                                {
                                    "id": 539807,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7a726c0d-8868-46c4-1d80-5242ad767c00/width=450/539807.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1019,
                                    "height": 1253,
                                    "hash": "UOE:3mRp?^I=nhx]VYxu.8?bkW%2%#NG%MxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 539810,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d8cba3b0-fcf1-492a-ef3d-f6deab262900/width=450/539810.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDDIt8obcV-nD%xZD%NGI;s;IBM|~WaMWaIq",
                                    "type": "image"
                                },
                                {
                                    "id": 539822,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3fd4ef3c-143f-4093-cc47-f665d9012400/width=450/539822.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UIFFTv00?Zj_.7IWt3%3I^%HICxt~XD$WFt7",
                                    "type": "image"
                                },
                                {
                                    "id": 539838,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b60cfedf-bfc7-40b3-a426-e49e4b0f0f00/width=450/539838.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UZDvl@WV_NW=tmNGx]WVE2oLIBWBaykCs.j[",
                                    "type": "image"
                                },
                                {
                                    "id": 539844,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e16c33a2-80bb-4535-4cd3-e30b4e357700/width=450/539844.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UHFYS^00V?%1_ND%%MkC0L$%x^WrkXs:IAt7",
                                    "type": "image"
                                },
                                {
                                    "id": 539852,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/370448cb-befa-4a95-057a-19dbf1d7d400/width=450/539852.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U8C$l-pcMaNw0h^kEQWC00D*_4WVVX9ZRP%1",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/50182"
                        },
                        {
                            "id": 51035,
                            "name": "Highlands Doll Likeness",
                            "index": 42,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-04-20T21:24:01.955",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful hld_woman, perfect hld_face, perfect hld_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4276,
                                "ratingCount": 131,
                                "rating": 5,
                                "thumbsUpCount": 142,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 37334,
                                    "sizeKB": 73841.943359375,
                                    "name": "hld.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-20T21:21:24.045Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "37D04FA6",
                                        "AutoV2": "67C8B932F6",
                                        "SHA256": "67C8B932F64BFD8D8B3DCC4173DFD50A9579AFA57A4CC0BDD5D823EC47D363A4",
                                        "CRC32": "FD2445D4",
                                        "BLAKE3": "0C0C18CD63FDBDCD051961AC2A41C02B2ACACD4372704BA8FCD49F895D6ECF67",
                                        "AutoV3": "9ADA5FF2B376"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/51035",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 549315,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ea2adaa1-10f8-4dbe-4604-9e8c91198a00/width=450/549315.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UCHBSi0e004n^+D$~pD*9FjF?vRP8_R+?b%L",
                                    "type": "image"
                                },
                                {
                                    "id": 549308,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/08497c56-0e07-4dea-0616-4dd951d7dc00/width=450/549308.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDFht}Ad00^+?C01D$-o%K%N_Njb8^IAx[Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 549307,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/02ef65f1-807d-4220-e124-ebf3c001c100/width=450/549307.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UEFY4C^O00D%M_%2ofE#00IV_NxtM{oft6o#",
                                    "type": "image"
                                },
                                {
                                    "id": 549310,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f10b85c1-c42f-4df2-8dd4-ffeb3183a700/width=450/549310.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UjH-[N~pbqxB%N-;t7RjoLoM%3R-t7xuogof",
                                    "type": "image"
                                },
                                {
                                    "id": 549311,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1deeeca7-43c7-4dae-3dad-d19fe8bb6d00/width=450/549311.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UBFhS3IW01t8r;01EfRQ$z-:_NNGDiIBIoIU",
                                    "type": "image"
                                },
                                {
                                    "id": 549320,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eaa99f80-608c-4d2d-2c19-f69397769b00/width=450/549320.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "ULE_v~~W0e9Z9FDjIUX9-;%ftlNHDiRPt8kW",
                                    "type": "image"
                                },
                                {
                                    "id": 549312,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e7724b1b-7cf5-4f36-6956-5dd13204ec00/width=450/549312.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UCFq%f~V0K~W+a4n0dW=oc?v.SE24TMxNbIU",
                                    "type": "image"
                                },
                                {
                                    "id": 549306,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/74a0cc09-63ca-450c-3095-c0ccf2c80e00/width=450/549306.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UQGa%v~B-:j=?Hxv%LOFx]M{-=t7W;R+f*t7",
                                    "type": "image"
                                },
                                {
                                    "id": 549324,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2b23edb3-792c-487f-f141-6c6fa4f1c900/width=450/549324.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFFXxC~B0xS2xnRjE1E2R*xu?cXT4:NGaLnO",
                                    "type": "image"
                                },
                                {
                                    "id": 549318,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6c972c07-6518-4f25-cae2-e8a23463a600/width=450/549318.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UPE_?Z~p574.9FIAR*t7%Lx[-;ozIURPR+t7",
                                    "type": "image"
                                },
                                {
                                    "id": 549316,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cf19eb15-1bc1-40b9-bfe6-2a52a43ed400/width=450/549316.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFGR3gK%OTrW^*~pJ7~AX--U?vofRP%g-pOY",
                                    "type": "image"
                                },
                                {
                                    "id": 549309,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5ee50c5b-a71d-4ecc-7486-a1a2c6d57f00/width=450/549309.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UWFr3G~V4:9FIUjFxtW;D%IotRx]R*R*R*kC",
                                    "type": "image"
                                },
                                {
                                    "id": 549322,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/00c4063d-dac9-4bce-722c-55239ff15100/width=450/549322.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFFY12000K9GIT%ND$?H0zn3_4R54Tx]xabw",
                                    "type": "image"
                                },
                                {
                                    "id": 549313,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fdb04ee8-0e27-4d92-2849-41dca19a0400/width=450/549313.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UAFE=j9]0000MdNa0K~V~pRP%#Di00Io?v-p",
                                    "type": "image"
                                },
                                {
                                    "id": 549325,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bca1c229-be76-4b89-f998-d8f2788c4f00/width=450/549325.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U6F55BY60000VX=|0K$$]$D%.mXTD4sm5S%z",
                                    "type": "image"
                                },
                                {
                                    "id": 549317,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f99c7de-ab22-44b1-65de-6cce2a526800/width=450/549317.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UaG[7y~WELM{Mxent7kW-;%Mxvo}Mxn%xubc",
                                    "type": "image"
                                },
                                {
                                    "id": 549321,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f72d9b9c-bb20-4d8c-1284-2536be679500/width=450/549321.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UMG*TfcEELv~^*RjtQ-o~Vxt?bWX-.aK%1oz",
                                    "type": "image"
                                },
                                {
                                    "id": 549323,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4e6c83f3-017f-4e85-f129-5cea79649500/width=450/549323.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UIFE=l~C0000DhaJE2Xm=|s.%gNH8^aKXStS",
                                    "type": "image"
                                },
                                {
                                    "id": 549319,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2d3bbde0-0fd0-4e85-fee5-7aa93f6b8300/width=450/549319.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UjIEb0~VtQofM{tRbcS5%gbIafRjxZxuxut7",
                                    "type": "image"
                                },
                                {
                                    "id": 1450587,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/70f7430a-90ed-4dee-858b-68a4e5f92141/width=450/1450587.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UAHU,;OZpZ~B0000S$^%?vE2sq4:JUkD%MI9",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/51035"
                        },
                        {
                            "id": 58102,
                            "name": "Heavy Metal Doll Likeness",
                            "index": 43,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>Special thanks to Angela and Alissa</p>",
                            "publishedAt": "2023-04-29T13:05:15.645",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful heavymetal_doll, perfect heavymetal_doll face,dressed in heavymetal_doll_clothing"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3293,
                                "ratingCount": 12,
                                "rating": 5,
                                "thumbsUpCount": 23,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 41358,
                                    "sizeKB": 73842.755859375,
                                    "name": "heavymetal_doll.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-29T13:05:37.042Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "3D5B9E5B",
                                        "AutoV2": "F84F2C0F6B",
                                        "SHA256": "F84F2C0F6BC5D209081FC8C71DE4FD7131527DBF98171D829E47BA20754D7AA2",
                                        "CRC32": "5AF319C4",
                                        "BLAKE3": "F2E4EFC87F1F28C218C45BA9EB78D7D14E1727C185CD7288B4F7725535EDED75",
                                        "AutoV3": "494FB9163B15"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/58102",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 632063,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/36f2a9ce-6191-4b72-7591-7a8e4e5a0400/width=450/632063.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UOFFKb~VtlR*IoNGR*V[0LE1nit7%2s:NGRk",
                                    "type": "image"
                                },
                                {
                                    "id": 631940,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9a4ec98d-0d41-4686-49e7-4053c45fe800/width=450/631940.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U6AmxR00X.t7xtxa9Zs:00~qDit7ENM{_2M|",
                                    "type": "image"
                                },
                                {
                                    "id": 632093,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/17117382-5ae4-4457-bf7c-a5064944e500/width=450/632093.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFGlR{00%J4p?aE2NFxZEKxbH?%g~oD*M{Nb",
                                    "type": "image"
                                },
                                {
                                    "id": 631939,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fabdbca2-fc2e-4e93-1724-f3de5fb2c000/width=450/631939.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UCCGPr~q9Z0KM{RkIUoK9ZRj%2j]4oIo%L-p",
                                    "type": "image"
                                },
                                {
                                    "id": 631931,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/73a62499-d27c-48aa-a894-da35f7ce3200/width=450/631931.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDDcwA009~$#_NIUD%sn4U_3DhD%9Z?HIAM{",
                                    "type": "image"
                                },
                                {
                                    "id": 631933,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8a8b0c8d-9557-435b-46ed-3dbeedcb3f00/width=450/631933.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U7AJ.u4.00~W4:kCs:xts9t7WBWBNIxtR*E2",
                                    "type": "image"
                                },
                                {
                                    "id": 631936,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/48df0d16-8248-49d2-5dd7-a0070bed7400/width=450/631936.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U3A,%m~q000zpy-p8w0K4T4oIn^P9FoHrrVt",
                                    "type": "image"
                                },
                                {
                                    "id": 631930,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6ab698d6-a5a1-4d65-c5f2-cc859bb59000/width=450/631930.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UMCGY~~qyD-;9FD%D%RjIUIUIURj-;%MkCt7",
                                    "type": "image"
                                },
                                {
                                    "id": 631937,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/57eea0b3-bbbe-4c2b-55d6-d3b6a5813500/width=450/631937.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U3BpkGBX02yWET-700xF00Z#$1N{tiXn~Coz",
                                    "type": "image"
                                },
                                {
                                    "id": 631935,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/68e7aadf-84aa-4491-14eb-99d35a147300/width=450/631935.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UEE.qg.8TL~pEONIX9xuE2S5M{t5?H?b%MM|",
                                    "type": "image"
                                },
                                {
                                    "id": 631932,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cc300dfd-3186-4a83-23af-b2d598e42400/width=450/631932.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UADcj#E0GGMxDjWF4nni00s+~AjXE3WE-=b_",
                                    "type": "image"
                                },
                                {
                                    "id": 631934,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0271694b-153b-4426-3e15-b13e32a59a00/width=450/631934.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U6DlN6010Nn3^%D%5Tx^0f~W00bw4nozn$x[",
                                    "type": "image"
                                },
                                {
                                    "id": 632092,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e9e1bb26-512a-4f49-94c9-fa18d2fc3100/width=450/632092.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1019,
                                    "height": 1162,
                                    "hash": "UDE{qV00w??wxp4p%0D*JUDjw]XT%2ozxaRj",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/58102"
                        },
                        {
                            "id": 58267,
                            "name": "German Doll Likeness",
                            "index": 44,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2023-04-29T16:10:12.261",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful grd_woman,perfect grd_face, perfect grd_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4602,
                                "ratingCount": 26,
                                "rating": 5,
                                "thumbsUpCount": 39,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 41450,
                                    "sizeKB": 73842.8369140625,
                                    "name": "grd.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-29T16:05:36.132Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "883058D2",
                                        "AutoV2": "A2EA7A4373",
                                        "SHA256": "A2EA7A437371B21435BB07A52FE748BA85FE2B2535A85111153A34C12AEED892",
                                        "CRC32": "A7F49901",
                                        "BLAKE3": "AFA9ACF2BC7E395CD49A8B0BBE721B098CE723D0DC71863B0359F71DD7B57DB0",
                                        "AutoV3": "BFE439E0B173"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/58267",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 633838,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2f63b366-e5c5-4976-575e-76b93bd05200/width=450/633838.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDGa%l9a9t~U%0?G0foy57R+NGkCIpIp-oM{",
                                    "type": "image"
                                },
                                {
                                    "id": 633825,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/490a56b6-f56a-444b-41d1-cddfe9f98600/width=450/633825.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U8Iz|,k?u3S6Acx]5S~Wxa$*MxRP57Rj^kM{",
                                    "type": "image"
                                },
                                {
                                    "id": 633841,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e57361ec-bc0b-4203-553e-a8f19a8c9200/width=450/633841.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UTHUd;~Vx]XS~Vt7NHWW9aM|V@RjNHof$*of",
                                    "type": "image"
                                },
                                {
                                    "id": 633837,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e0fb71f-ec4d-40df-c3b4-f2db9fc6c400/width=450/633837.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UCFE+F4;57~V~BayE2W;0fbZs:s:R*oexZof",
                                    "type": "image"
                                },
                                {
                                    "id": 633824,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f5b3abde-d28d-480e-e8fa-aa0124201100/width=450/633824.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U5DuGF~V00001IV[R%smDP-o^jI;019a?G~B",
                                    "type": "image"
                                },
                                {
                                    "id": 633829,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d51727fb-16ee-4b85-916a-a644da74b700/width=450/633829.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UCH-x:9a00?G00%LO[%L_NRk-VNGE2%1$zWV",
                                    "type": "image"
                                },
                                {
                                    "id": 633830,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/511f9430-dfb2-428e-3e95-f6fde8c8d700/width=450/633830.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UIE{LX%10fE2t7IAIoNGXnD*xaxa_NobM{oL",
                                    "type": "image"
                                },
                                {
                                    "id": 633832,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a08099e9-c99d-4dbb-2f01-91af2f35f800/width=450/633832.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UCFFEM010MxYD%i^EMnh4.Rj?HRj_4RiogRj",
                                    "type": "image"
                                },
                                {
                                    "id": 633822,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/66114913-8e30-4d87-1a17-7b362c4b6300/width=450/633822.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UQHV0X$%TJIu.TV?JDI;ETX5$+t7%ix]s:xu",
                                    "type": "image"
                                },
                                {
                                    "id": 633826,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/637f4054-94b4-4cfb-f8bc-68791207d700/width=450/633826.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDF=dR?H0LkXs6My0fIo0d9a$%xY~qt8s:?G",
                                    "type": "image"
                                },
                                {
                                    "id": 633827,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e48f8bba-8e0c-45fc-0035-227c68eb2200/width=450/633827.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UBEx@Q~p0L0KpI%gENVs01N1%3RitlIUrqof",
                                    "type": "image"
                                },
                                {
                                    "id": 633823,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/08f31a7c-3bf6-42b9-6534-0494499fe300/width=450/633823.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9H_D9~W0fEK0M-VNH4ot69ZxFxa0Kay%M-p",
                                    "type": "image"
                                },
                                {
                                    "id": 633861,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ec1fc4eb-3507-4cd6-eb4a-21cfc2295a00/width=450/633861.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UMKn0eIpEf~pROV@%Nt6JCt6IANGjYWBs:WB",
                                    "type": "image"
                                },
                                {
                                    "id": 633862,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f1340320-5169-47cc-116d-ef9d6e124900/width=450/633862.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U8HBPT0000_20e~W00E29vD%^+IV4-o#%2-o",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/58267"
                        },
                        {
                            "id": 58453,
                            "name": "Petite Doll Likeness",
                            "index": 45,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>This is a model trained on petite women like Alizée.</p>",
                            "publishedAt": "2023-04-29T21:53:06.825",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful petite_doll",
                                "perfect petite_doll face, perfect petite_doll body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4687,
                                "ratingCount": 29,
                                "rating": 5,
                                "thumbsUpCount": 39,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 41552,
                                    "sizeKB": 73842.5146484375,
                                    "name": "petite_doll.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-29T21:56:01.472Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "50BD1511",
                                        "AutoV2": "7D9CC4988D",
                                        "SHA256": "7D9CC4988D2081896008601F04530F15E856C9994542B93BB409FAA42C757689",
                                        "CRC32": "4E7E8841",
                                        "BLAKE3": "60FF3C51B0A7739AE6F01CB4FA7E5327B3529439116F06667AEB76491249C233",
                                        "AutoV3": "82868CB5E449"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/58453",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 636352,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1a6b26c9-e008-4e4d-8907-aca6c7ff0e00/width=450/636352.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UHHn.$Z+0zt89a%f_2t7cCkD%Loz_Mf+xa%2",
                                    "type": "image"
                                },
                                {
                                    "id": 636343,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a5eedcc7-f269-4aa7-22df-8303f6de0f00/width=450/636343.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UGFh|$_3_NozIpIUxut7^*s:9ZNGNbWWxZs:",
                                    "type": "image"
                                },
                                {
                                    "id": 636342,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9785e4b4-11f2-4683-9f6d-d348d36db800/width=450/636342.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UMJ@?^4nT0t700-;?bV@.Txu-TM{t7aexutR",
                                    "type": "image"
                                },
                                {
                                    "id": 636344,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cb63699e-53c9-458d-c9cf-bbb4b50a9e00/width=450/636344.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9C$s0S#0NIp?H?H0fRk01t8=^NG0fs:~VnO",
                                    "type": "image"
                                },
                                {
                                    "id": 636348,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/02ed0fda-61b7-482f-684f-544d3fc9ac00/width=450/636348.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UQL;T?-=Rhx]H=%M_NM{Ipays9WB?vRjVsoe",
                                    "type": "image"
                                },
                                {
                                    "id": 636351,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2fadbdc5-bfba-48a8-ef9d-8b4c4cee5b00/width=450/636351.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UCDSgyemt-EM~W-oNbENJAIp%1?G58R+-o%1",
                                    "type": "image"
                                },
                                {
                                    "id": 636341,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c9d1440a-20f1-4738-1f8d-f7303b45c300/width=450/636341.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UVFO[hRj?cM{~Wt7ozayX9t7xZWCX9j[xaWB",
                                    "type": "image"
                                },
                                {
                                    "id": 636350,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bbdd7940-dd8b-456e-c6ed-b802494b5900/width=450/636350.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDFrYK%3?w-;%OD%x]E2?HNGnh?H01Wr^kof",
                                    "type": "image"
                                },
                                {
                                    "id": 636354,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7a141342-b935-4339-0c79-add51a140300/width=450/636354.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UBEol0O%00}^TU-.i}9HM_-:xv9FOpay$*Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 636353,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3a72a9dc-b82a-4dbc-abbe-16ce80837100/width=450/636353.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9HLYQD*00?HLsVs=e-;M^xtN3Efy?I.8w-D",
                                    "type": "image"
                                },
                                {
                                    "id": 636346,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/917d3fd0-e4e3-4901-4e49-7d6177a7ca00/width=450/636346.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 954,
                                    "height": 1041,
                                    "hash": "ULE.?$?aOmJg_K-:R*IU%ftRxaaLtlt8j0Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 636347,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/feb29375-a997-42c5-ff6d-c634c9a50500/width=450/636347.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UIE.?=029vV@_LMys:IVIoWE-oR*9ZxuW;xt",
                                    "type": "image"
                                },
                                {
                                    "id": 636349,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dd36e22d-91f9-40d2-f437-315a4cf6b300/width=450/636349.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UOKU4i~qX.V@IVV??aNItRM{xZoK?bNGV@xZ",
                                    "type": "image"
                                },
                                {
                                    "id": 636345,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0254f356-b567-4138-8753-8e4712099900/width=450/636345.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UEHnpc-pystRpcRk~pxt9ZRk^jxu_3of%Mbb",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/58453"
                        },
                        {
                            "id": 58743,
                            "name": "Irish Doll Likeness",
                            "index": 46,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-04-30T08:30:48.565",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful ird_woman",
                                " perfect ird_face, perfect ird_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3921,
                                "ratingCount": 32,
                                "rating": 5,
                                "thumbsUpCount": 44,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 41741,
                                    "sizeKB": 73842.125,
                                    "name": "ird.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-30T08:25:51.238Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "0A953B08",
                                        "AutoV2": "B2F2F35889",
                                        "SHA256": "B2F2F35889BA01278BDC6790704427161877A07257A6F08130A92FDE5D3E8DB6",
                                        "CRC32": "38A4848E",
                                        "BLAKE3": "78EFA7D1B9A12F7F972B5D426BB5413D9AD3C4E00362A4B2C2D674F93E83BBE4",
                                        "AutoV3": "3C9372DC5358"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/58743",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 639960,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8a86a7a5-8894-498c-5938-3261ae358900/width=450/639960.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UGHKd}~B0xxu1FIVNF9[^iXSt,-o$%r=iwk9",
                                    "type": "image"
                                },
                                {
                                    "id": 639961,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1bbc768-8aa8-4f5d-0514-de024c42c700/width=450/639961.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UMH,*L}Z56nOpbnPEL57#SWBWVsm$%-ns:kW",
                                    "type": "image"
                                },
                                {
                                    "id": 639958,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f12a963d-8153-4ff1-53e2-4523751a0200/width=450/639958.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UAIDv}%M000LX+ouKN?G00-,_N~V9ZNaaLIV",
                                    "type": "image"
                                },
                                {
                                    "id": 639959,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d6410021-71aa-440f-8403-39fa28119c00/width=450/639959.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UKIzxB4oI.}@RPQ-f+VY~WMdx^s+tRs,XTI:",
                                    "type": "image"
                                },
                                {
                                    "id": 639962,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/538d9f03-dc66-4813-71bd-f3626c3e0b00/width=450/639962.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U7GkwH%F0000E1~A55_19Fs7=}~p_2?I-UE1",
                                    "type": "image"
                                },
                                {
                                    "id": 639963,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/32e14472-d2a9-4e66-f1da-fe8767d7d600/width=450/639963.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U7HUXq0000RQQ8xYt7=td?~CD+oIWQrq?I58",
                                    "type": "image"
                                },
                                {
                                    "id": 639995,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1bb11d0b-68e0-47be-98a3-a70d87bc0c00/width=450/639995.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UZIXEa_2xt~paet7X7WBxuRjR*xuIoxt%2Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 639992,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0b0cbf7e-4c5f-4d22-97dd-87a5034ce000/width=450/639992.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UTH_6|~VE1D%D%%2tQxuozWBs:R*IURj%Lxu",
                                    "type": "image"
                                },
                                {
                                    "id": 639993,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3883a5dd-2db7-4423-ff6b-f62bf4b30a00/width=450/639993.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UIHx4%EK0dxs00?GXmM{Ioxb9aIV~WIUWFo#",
                                    "type": "image"
                                },
                                {
                                    "id": 639991,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e9ba33f2-c8ef-4682-4186-f6635ef44300/width=450/639991.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UBGRPAAx0000DN9b_4%1Fw#79a^+NEsVtRX8",
                                    "type": "image"
                                },
                                {
                                    "id": 639994,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/651fc5f2-2c64-4c81-3a2a-d78f03ed0f00/width=450/639994.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UEH1lF~oMv004T%1tP-p?vxaIpVs4.D%o~SP",
                                    "type": "image"
                                },
                                {
                                    "id": 640004,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b38a1015-7f73-4f7c-4403-67611378ba00/width=450/640004.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U8H1So002pQ--:D*0LEM00.R?]v~00Vt-Vo}",
                                    "type": "image"
                                },
                                {
                                    "id": 640005,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/91da3e81-c3cf-4608-73c2-666b543bf800/width=450/640005.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UUGkm?D*JO-:~VNFE1tR_1Rkk8X8xujsWAWY",
                                    "type": "image"
                                },
                                {
                                    "id": 640007,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/19d7bcd9-812c-4ab5-b040-de939c6cb600/width=450/640007.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UHHK@B00_Lm-~VIB9uw~xrM{xt%L-=9F-;V@",
                                    "type": "image"
                                },
                                {
                                    "id": 640006,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c5603db2-d962-40b2-091c-f917d2cba600/width=450/640006.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UBKd0q0000$+Ka00_NxW-:WB.SDhD%E1NbIU",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/58743"
                        },
                        {
                            "id": 59131,
                            "name": "Catallena Doll Likeness",
                            "index": 47,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>JUTTI MERI, OYE OYE OY! :D</p>",
                            "publishedAt": "2023-04-30T18:41:02.778",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful ctd_woman",
                                "perfect ctd_body, perfect ctd_face,"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3101,
                                "ratingCount": 11,
                                "rating": 5,
                                "thumbsUpCount": 17,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 41966,
                                    "sizeKB": 73842.525390625,
                                    "name": "ctd.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-30T18:40:55.507Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE3AA43A",
                                        "AutoV2": "FAB2FF7112",
                                        "SHA256": "FAB2FF711276CB5356EB508A124DE9580C1C58156F2575E8820A142A1E6158CD",
                                        "CRC32": "6136862D",
                                        "BLAKE3": "A38310D5624F8B922E642AB3BF1BCD672F388D6512D8575EBB62656C6FEE7363",
                                        "AutoV3": "A43672A20014"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/59131",
                                    "primary": true
                                },
                                {
                                    "id": 41965,
                                    "sizeKB": 73842.525390625,
                                    "name": "ctd.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-30T18:40:51.565Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE3AA43A",
                                        "AutoV2": "FAB2FF7112",
                                        "SHA256": "FAB2FF711276CB5356EB508A124DE9580C1C58156F2575E8820A142A1E6158CD",
                                        "CRC32": "6136862D",
                                        "BLAKE3": "A38310D5624F8B922E642AB3BF1BCD672F388D6512D8575EBB62656C6FEE7363",
                                        "AutoV3": "A43672A20014"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/59131?type=Model&format=SafeTensor"
                                }
                            ],
                            "images": [
                                {
                                    "id": 644642,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d0bb1853-ad27-4900-2850-3e33197ebc00/width=450/644642.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9GI=n00EGE1+DJZAdEL0M-UY8D%R}tm},9v",
                                    "type": "image"
                                },
                                {
                                    "id": 644639,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cf8df2fc-3600-4fc7-3460-8ccbf9851500/width=450/644639.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UIHLML009a-n00xV-=My_ND%-pWV%hIUxYxu",
                                    "type": "image"
                                },
                                {
                                    "id": 644643,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a9d85ceb-1409-45c0-0ed6-51cae1ae5900/width=450/644643.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UGGj]SJj9v-p54sp9ZIoIXW;~VWEW-axIps+",
                                    "type": "image"
                                },
                                {
                                    "id": 644640,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2d3f5378-f144-45ea-ce9d-115d875e2c00/width=450/644640.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UBI4qv00YP~Wx]^jpJ9t%$4.$+^*OFD%$%%g",
                                    "type": "image"
                                },
                                {
                                    "id": 644636,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6917791d-62c3-4b81-2ba0-354e9993a100/width=450/644636.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDGRn}9a01~p00-o.80L%MxtD%Rk%MD*n%?H",
                                    "type": "image"
                                },
                                {
                                    "id": 644637,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6e90d3d8-3989-4e71-64e3-14102e179200/width=450/644637.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UHH1xr~BPBo}9uIVo~E2-;%2nOt79ZS4t7V@",
                                    "type": "image"
                                },
                                {
                                    "id": 644644,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b982b9eb-a790-4bfd-89de-260434f23b00/width=450/644644.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UCF#]-00JP^*00_458Vr.TIU^*RjIpIUxDx]",
                                    "type": "image"
                                },
                                {
                                    "id": 644646,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a28c215e-3191-48f7-b4eb-0db839d8e500/width=450/644646.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UGF5aFWAPC%2~qWX%Naz0fxa?GE1xuniWBWB",
                                    "type": "image"
                                },
                                {
                                    "id": 644645,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/00f7fb2d-f0ab-4e1a-f9fc-7db9d544f700/width=450/644645.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDD]0f4.0g$%x^IA?bD%0LV?~VD%NGofxuxa",
                                    "type": "image"
                                },
                                {
                                    "id": 644635,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/402423aa-5665-47a8-bdd9-af8f5ac17100/width=450/644635.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9F=m+,.0gjF00-;-;E1Pq00?HkW00-;s.?H",
                                    "type": "image"
                                },
                                {
                                    "id": 644647,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/224fc2c6-4544-4318-9ebc-83b1fd22fb00/width=450/644647.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UIEefGM{%M9G~BS4X8E29F-:$%-pNF-:-o%L",
                                    "type": "image"
                                },
                                {
                                    "id": 644641,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/282305f1-8bfb-4ca2-27e5-bb9713d76a00/width=450/644641.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U4ByaB9}%#~Bv1IA00=wO@-;_3oz0e9Z~Vn~",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/59131"
                        },
                        {
                            "id": 59216,
                            "name": "Turkish Dolls",
                            "index": 48,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-04-30T21:35:58.448",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful tkd_woman",
                                "perfect tkd_face, perfect tkd_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3784,
                                "ratingCount": 51,
                                "rating": 5,
                                "thumbsUpCount": 57,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 42037,
                                    "sizeKB": 36978.35546875,
                                    "name": "tkd.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-30T21:35:45.744Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "11197EB5",
                                        "AutoV2": "7C677C2D6C",
                                        "SHA256": "7C677C2D6CE02C96A40A8B22FB2D806C409BCF49C018AB4C490E369A8EBA23B9",
                                        "CRC32": "75012B10",
                                        "BLAKE3": "42CB014197A874509C53B6A8BEF27D7B748EB88951F9F25F791D35B9597465D5",
                                        "AutoV3": "9FC46D9B1C6C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/59216",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 645841,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/73ed53b8-9cf0-4eb7-12fa-5820d455cc00/width=450/645841.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1110,
                                    "hash": "ULFqm?~UI:xa^%-oI;NH^%%1t7xaS#-o-VNb",
                                    "type": "image"
                                },
                                {
                                    "id": 645816,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/140cba0e-18fa-4ff1-ed6d-9cdb3e150900/width=450/645816.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UCF}r]040KJ6^6NanPba01Sw}]%KxDafJ7s:",
                                    "type": "image"
                                },
                                {
                                    "id": 645814,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ded44753-91c0-495f-5286-c5af50f02400/width=450/645814.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UAGkK_E4I-0gr]0L9a=|9a^ij0S15Qxu~BM{",
                                    "type": "image"
                                },
                                {
                                    "id": 645821,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b10322e4-b506-4ecd-a8c6-bed07f7cc900/width=450/645821.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDFX;N.PE0-9}GV]Ior?0MRk-WWCEet6-VRk",
                                    "type": "image"
                                },
                                {
                                    "id": 645813,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6ab8d488-243a-49bc-eb5d-2b77df029100/width=450/645813.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDDbNN^i55=_IpWBIpWC01a#~BNGniWB%1xt",
                                    "type": "image"
                                },
                                {
                                    "id": 645818,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3bd0839c-0543-47d8-0a8b-3f9942933000/width=450/645818.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UAGuBv01$]4.~URO%L-:00D*-=?GIUIVs;t7",
                                    "type": "image"
                                },
                                {
                                    "id": 645820,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b3b10167-09b5-44b5-97f9-3ae3f1a5c400/width=450/645820.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UEGR3c0N00I[9Eod~AIpElxZaixa0Kof~BIp",
                                    "type": "image"
                                },
                                {
                                    "id": 645811,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/05c41dc9-029f-4932-0d59-c46fd3120b00/width=450/645811.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFG92H$t%f-n00Ma0:bE1R9E$+s+~CxVK7jZ",
                                    "type": "image"
                                },
                                {
                                    "id": 645817,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/35589c47-9a29-4e54-fa10-d9050c32c700/width=450/645817.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UHEL:CD%9Y9F4.S6tSM_S$R-slkD}?EMI@of",
                                    "type": "image"
                                },
                                {
                                    "id": 645819,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/752c4512-40b5-4a8a-dd03-0da91ee80100/width=450/645819.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UXJQ+k~W4.xC8^RitSogyDR*aKayNGxuxZM{",
                                    "type": "image"
                                },
                                {
                                    "id": 645812,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/85535856-00b1-46ed-6378-c7a58949f500/width=450/645812.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UOJ@g:~VS#?G4T?a-:xutRt7s:IUtRIURjxu",
                                    "type": "image"
                                },
                                {
                                    "id": 645815,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/415693a8-e687-4643-2c51-7558ebb36400/width=450/645815.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UCHBC~?w4.VX0000S$tmL3?b=|M_0Kr=w^NG",
                                    "type": "image"
                                },
                                {
                                    "id": 1450672,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dd1e5edd-327b-486b-8889-2a230640c623/width=450/1450672.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UAAJZm?GOAsm-Q?Gofxu^M%KXS%2S~%2~Bxa",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/59216"
                        },
                        {
                            "id": 60848,
                            "name": "NativeAm Doll Likeness",
                            "index": 49,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-05-02T19:56:25.247",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful qcd_woman",
                                "perfect qcd_face, perfect qcd_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3232,
                                "ratingCount": 94,
                                "rating": 5,
                                "thumbsUpCount": 106,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 43062,
                                    "sizeKB": 73841.68359375,
                                    "name": "qcd.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-02T19:58:08.125Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "B75DD5DC",
                                        "AutoV2": "FC930B1278",
                                        "SHA256": "FC930B12787694930170ED598D9C8119BA827A88DCFC086AD3723389C04FCC84",
                                        "CRC32": "0C8F4321",
                                        "BLAKE3": "99C63614BF98AB3A2DEF9B781E5BE0B63E838564A719D4856A66720F14CD8F30",
                                        "AutoV3": "75B3675FB89A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/60848",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 666344,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/070a1b1b-32ba-4a03-8dad-f1010d32afe8/width=450/666344.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UUH1uZ^j%MNH~Vt6%1RjkWWAxZoKN_Rkf,t7",
                                    "type": "image"
                                },
                                {
                                    "id": 666345,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e21a1060-7eac-4f0a-a0e0-fc44b4f85128/width=450/666345.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UfJ*SFwHo~xa_NWBflxa%g-pw]R+tlt6oIWW",
                                    "type": "image"
                                },
                                {
                                    "id": 666348,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/91c0202b-f6e0-4724-b377-870de72f35eb/width=450/666348.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "USI#AKE3Szwu~V9FM{xu%hxbw]NGS#M{o0Ip",
                                    "type": "image"
                                },
                                {
                                    "id": 666351,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/95b875fb-eab9-4ac4-a440-16b77ea0420a/width=450/666351.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UIGRer~V5S-oozRQ9ZkDEgxu^iX902IAxDE1",
                                    "type": "image"
                                },
                                {
                                    "id": 666347,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fce15e89-c4b5-43b6-829d-b5fa4c6fff77/width=450/666347.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U7E_:E_LFWE1?a?G0fnN0MIrRRW.Rn0M-Tt7",
                                    "type": "image"
                                },
                                {
                                    "id": 666346,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9e8b1ed5-e8b9-47f6-bf3e-b2edc51a8621/width=450/666346.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UMH_V-Nf.TT0~XENI@X8#$IpR4s.-.R.xCoz",
                                    "type": "image"
                                },
                                {
                                    "id": 666354,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d9ee5ee9-bfea-42f5-b325-58a742dd8dda/width=450/666354.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "ULHBMK9F?c$e~V9bV@XA-PS5V?xu%MV@t6Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 666349,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a398c7e4-3651-4064-a661-ab0c1c8c1c96/width=450/666349.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UQF~8W-o.Tt6^,WqNfWYMwbcIAof-St6xCR*",
                                    "type": "image"
                                },
                                {
                                    "id": 666350,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad7c9145-a5d2-4f0b-8396-b3a7568003e3/width=450/666350.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UhI}#ADi?wxa?wa}S4xubbkCRPV@ogoeRjWA",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/60848"
                        },
                        {
                            "id": 63849,
                            "name": "Busty Japanese Doll",
                            "index": 50,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-05-06T11:17:05.016",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful jpd_woman",
                                "perfect jpd_face,perfect jpd_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3954,
                                "ratingCount": 10,
                                "rating": 5,
                                "thumbsUpCount": 19,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 44916,
                                    "sizeKB": 73845.2314453125,
                                    "name": "jpd.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-06T11:15:44.428Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "AC4E35FF",
                                        "AutoV2": "7C5F88B69F",
                                        "SHA256": "7C5F88B69F8DA2D1A6187E2F10450F6BCDCCEC802AD35F59C510FEE742A709FC",
                                        "CRC32": "4974FA43",
                                        "BLAKE3": "E2FFDC4E011E6E0ACCB8E9C6C0EC957F3B3F1A344AA04529EBACE08AD9DFD038",
                                        "AutoV3": "215BC25900EE"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/63849",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 704722,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cad48fc1-8cc1-4181-a350-3d8f8add4ecc/width=450/704722.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFI;VJ0f0K^+9[_N?GRP-:?b%NIU?w%M-oE2",
                                    "type": "image"
                                },
                                {
                                    "id": 704724,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/febba185-863b-440a-b89a-45e88c3947c8/width=450/704724.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UmHKX[~W%gXTXSX9t7s;IVRjs9oLjZodNaWB",
                                    "type": "image"
                                },
                                {
                                    "id": 704723,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/acfdb552-e304-4c98-bb48-bdf5ad695769/width=450/704723.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UJJ@wZOa9YH?rAIn~qD%D$r;s,xu%$%MMxI[",
                                    "type": "image"
                                },
                                {
                                    "id": 704726,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/92e6acd1-417f-4bea-b7f9-b5730b19c13e/width=450/704726.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UKKA4@0OMv%N~n$c$L-;=;-4a#%gTLIV-U%M",
                                    "type": "image"
                                },
                                {
                                    "id": 704725,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a54e8f5e-8dbc-4082-a54f-3a6c572a81ca/width=450/704725.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UHIWo[FYS]$QS^9a~C%M~o=xX5D*9tIpkCS2",
                                    "type": "image"
                                },
                                {
                                    "id": 704730,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4ecd62c8-08ae-4446-86f7-366bb4810714/width=450/704730.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDGaOctl1I^R~qR*RktRTZ-U$jozI9R-jEWA",
                                    "type": "image"
                                },
                                {
                                    "id": 704727,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/da834ac0-ec35-481b-9c89-d9b3ca320ef3/width=450/704727.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UCH,^y00%|EMug0L$i^+00_3D%-:4o?aShIA",
                                    "type": "image"
                                },
                                {
                                    "id": 704728,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/27fd8259-4f68-479c-9e67-fb63dca8a46d/width=450/704728.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UZJQ+u~BH=i_U[oJx^ozNwbIofaxpJf6nhof",
                                    "type": "image"
                                },
                                {
                                    "id": 704731,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e6169712-5a41-4268-b7d6-f457ab033d82/width=450/704731.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UJIXw400MuE4UuR*X:IU8^xto$s8.AM}s+s8",
                                    "type": "image"
                                },
                                {
                                    "id": 704729,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6168f904-df02-47f4-bf52-6fdec63108ca/width=450/704729.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UjK1Xo_2i^%NwZS4o~tRr:ogt8oe.AkXs,xu",
                                    "type": "image"
                                },
                                {
                                    "id": 704739,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bfcea80d-151f-4f60-8f53-1569f6fd5ebc/width=450/704739.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "ULLD[ajFVpV[D4ad?vaeS5kCs;ae%%azwuof",
                                    "type": "image"
                                },
                                {
                                    "id": 704740,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d3deec78-3664-4890-a7fd-f2d247379b2e/width=450/704740.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UCKKc:4TK6?H00RO?brWF|yZU]^+0N-on,oz",
                                    "type": "image"
                                },
                                {
                                    "id": 704743,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dd7f0200-9ef0-4ec0-8068-527cf2ff1dae/width=450/704743.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UgKdMc-:xrNH~UtS%hRjf3xDxuM|o~R*ROR+",
                                    "type": "image"
                                },
                                {
                                    "id": 704744,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ab1488a0-d823-4615-9777-5189135629dd/width=450/704744.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UJLNPzRjAB-o00oytQ?GE2IWMxRjyZE2?GM|",
                                    "type": "image"
                                },
                                {
                                    "id": 704745,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/28253f1d-2d44-49b9-8999-c712b7b08cb7/width=450/704745.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UQMGxJ8_%eMx~9R+.9VrERWUV@xZ_NV[ROoz",
                                    "type": "image"
                                },
                                {
                                    "id": 704750,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/99934906-7668-468b-a9b2-a438759d8ef9/width=450/704750.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9Lfp[~B=.=p02Ov008w0K56IpJ:4n#*?v59",
                                    "type": "image"
                                },
                                {
                                    "id": 704748,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/beca08b3-12bb-45fc-82ce-e94f031b7965/width=450/704748.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UGJ6$v0L.l=yPAxt$3xZ00%fDjJBDjS3I:sm",
                                    "type": "image"
                                },
                                {
                                    "id": 704749,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/39753fb5-544a-483a-80af-8e719792ef80/width=450/704749.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UZI|n2~BngWC9aa#%1V@xn%1R.xW9bRlR.og",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/63849"
                        },
                        {
                            "id": 63894,
                            "name": "Norwegian Doll Likeness",
                            "index": 51,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-05-06T12:25:13.457",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful nod_woman",
                                "perfect nod_body,perfect nod_face"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4463,
                                "ratingCount": 90,
                                "rating": 5,
                                "thumbsUpCount": 99,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 44943,
                                    "sizeKB": 73842.8623046875,
                                    "name": "nod.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-06T12:25:57.460Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "37118E37",
                                        "AutoV2": "3CD056F438",
                                        "SHA256": "3CD056F4383AEDE754793BB2004914D1B61C2895CB8783A5329FE3E3D5D683A0",
                                        "CRC32": "AA1270D8",
                                        "BLAKE3": "B8ED4F3914E4D9FCF5C1285F5C4478A144F70098BFE3E720B40124AF95190A34",
                                        "AutoV3": "FAA2D9110C13"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/63894",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 705255,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2ca6b807-79d2-4a83-899d-dc4388846c6a/width=450/705255.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U7G*1k-600~B-WE201E3K5W;9G-oFaxZ=yj?",
                                    "type": "image"
                                },
                                {
                                    "id": 705260,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f45f4431-5464-4c46-be93-9019d13c888d/width=450/705260.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UHJZ*mM_02xF}-xZI@Sh0gofe-s:-=RPspR+",
                                    "type": "image"
                                },
                                {
                                    "id": 705271,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/68f13e42-1466-418f-9d82-cfb2c7d27d9c/width=450/705271.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UBMiTI~m00-U0#~B039HEL9a-qIp4.oft8%K",
                                    "type": "image"
                                },
                                {
                                    "id": 705259,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5ac62efc-b7b2-421e-a266-ced54ba29b9f/width=450/705259.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UAHdQu030{EM}[Rj01~AKixZwMt65kM|-BkC",
                                    "type": "image"
                                },
                                {
                                    "id": 705258,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/76862bb4-809d-4ce1-8957-34e9447aeeda/width=450/705258.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UCEx9HxF02%K}@s:0zI;58ofxGNHEfoJ-Vxa",
                                    "type": "image"
                                },
                                {
                                    "id": 705257,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f3198f1-a966-4834-9b5d-3f626991d820/width=450/705257.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UILDPjt79Fog}OV@.RV@FgW?xBt6s8oIIWWE",
                                    "type": "image"
                                },
                                {
                                    "id": 705256,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/491b5a25-8d70-458e-9ead-47e6b3c52e3e/width=450/705256.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UDKJufE200.80057I]xBTL}@jDxu57RjWWxY",
                                    "type": "image"
                                },
                                {
                                    "id": 705261,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6663b75e-97a5-469e-bb0f-608ad92e6de3/width=450/705261.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UFIOLn6X3YG1:NXM9t,,1nI9+ZVrmiROxFIo",
                                    "type": "image"
                                },
                                {
                                    "id": 705263,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b35393a1-0b5f-40dd-8d55-9ab186545ad0/width=450/705263.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UTK1LL:N2|oZt6xnRPxtGbS#s;tnogs8RjWE",
                                    "type": "image"
                                },
                                {
                                    "id": 705264,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4085c84f-511b-477f-a92a-18235d69cbbc/width=450/705264.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "USGu|ACTny+sTK-4Q,xCGGv~v|I:ivaJIqkr",
                                    "type": "image"
                                },
                                {
                                    "id": 705270,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/93fe1401-a273-4241-b389-924713ae114f/width=450/705270.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UbMGYOpJLM?bYRs;S7t7cZROspbEcFR*S$R*",
                                    "type": "image"
                                },
                                {
                                    "id": 1450612,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/afd72878-4af8-4c94-9987-5ec8d0470aa4/width=450/1450612.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9F}yZwc1P^+L#xZ0KE103%N+[0f5;IA~W-p",
                                    "type": "image"
                                },
                                {
                                    "id": 1450618,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c3914015-1ee5-4830-ba23-024b30b8c093/width=450/1450618.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UBG[TW~VP:0f00D%IAM{uiIp^Q-pIAxu-:xu",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/63894"
                        },
                        {
                            "id": 65807,
                            "name": "Bollywood Doll Likeness",
                            "index": 52,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-05-08T17:27:53.344",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful ind_woman,perfect ind_face, perfect ind_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3377,
                                "ratingCount": 110,
                                "rating": 5,
                                "thumbsUpCount": 119,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 46108,
                                    "sizeKB": 73842.056640625,
                                    "name": "ind.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-08T17:31:12.181Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "FA06F002",
                                        "AutoV2": "0AB64C4522",
                                        "SHA256": "0AB64C4522180F75BD56B2B775C158B4FC9EAB874B69C392457FF403DF0CE5F5",
                                        "CRC32": "6107E60E",
                                        "BLAKE3": "7C88156F84FCD238B984F79DDEBF5D81377DB129696C8864AA36B045C1B9A167",
                                        "AutoV3": "67F8831F9AEE"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/65807",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 729512,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/66dc3ec6-96d2-486e-a33d-8f73fdda4e13/width=450/729512.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UKK]+NZytB},.9}+-?rpAKRl={EN%2kXS6R:",
                                    "type": "image"
                                },
                                {
                                    "id": 729511,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1742bab2-590e-40be-90ba-6f536d061a65/width=450/729511.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9I;39000Lv,%xxv^i4qQ,Y4}rt9}XBhrFOX",
                                    "type": "image"
                                },
                                {
                                    "id": 729510,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d51bf035-6fc0-4e48-b3f3-c57ca167bb15/width=450/729510.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UGK9=NY25HT2?Jx]~V^kRltk$y-WNINLof~B",
                                    "type": "image"
                                },
                                {
                                    "id": 729513,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aa37359a-f27a-47b4-9a0d-8a5e23a5f718/width=450/729513.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UIJ%][~q0z~S00s%$e9vWFMyxFM{gOJDV]n$",
                                    "type": "image"
                                },
                                {
                                    "id": 729509,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8c163e7e-9fa8-4516-a4bd-57ef2c94119b/width=450/729509.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UBK^7=VYMc03rn9btl=^%#t6}--;x[Io?b^J",
                                    "type": "image"
                                },
                                {
                                    "id": 729514,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8d029f0f-46db-437f-9ac9-0788b56a54f8/width=450/729514.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UGL|Ge9ZpxOtyX%L~pZ#5qRi#,?axtbb-oM{",
                                    "type": "image"
                                },
                                {
                                    "id": 729520,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/712fa9e1-8e62-4852-869b-7f66e34bf2a9/width=450/729520.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "ULJ@O2-U5QD+0f4:IUoK?Zs+-o-n58of~UNG",
                                    "type": "image"
                                },
                                {
                                    "id": 729516,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/949b04ca-df70-41dd-9ee0-c91f499c0777/width=450/729516.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UHKckFWY01^*Ip%2~AIo?ZWBwc$%NwIp%2?G",
                                    "type": "image"
                                },
                                {
                                    "id": 729515,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6055979a-4467-40fc-b2a8-9f9044bcd6df/width=450/729515.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UAIW[h0M02E202NH~AE2w]-oxD-ob[9ur^en",
                                    "type": "image"
                                },
                                {
                                    "id": 729517,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4ce55207-df3d-4e79-b63d-5e2f27588705/width=450/729517.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "U9I|w60003rq01Rk?E-o=y~BM{EQ.54;^k4:",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/65807"
                        },
                        {
                            "id": 82778,
                            "name": "Denise Doll Likeness",
                            "index": 53,
                            "modelId": 42903,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-05-27T14:17:02.09",
                            "availability": "Public",
                            "trainedWords": [
                                "beautiful edgDenise_woman",
                                "perfect edgDenise_face, perfect edgDenise_body"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3183,
                                "ratingCount": 286,
                                "rating": 5,
                                "thumbsUpCount": 294,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 56640,
                                    "sizeKB": 18546.572265625,
                                    "name": "edgDenise_DollLikeness.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-27T14:11:34.013Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "8E61CFD297",
                                        "SHA256": "8E61CFD297CA622BA266297EDFEE3FA9FAD89661A0204AE5A81F15A60D8132E4",
                                        "CRC32": "0FCC74F4",
                                        "BLAKE3": "7F466F173F9A2AC908C9CDD9B87218F58F50D74EC512D9D7027E04DAC22F7DD5",
                                        "AutoV3": "C0E563B8409D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/82778",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 932270,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6c42bd96-79ba-44a6-8a14-e033848c8a58/width=450/932270.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJI|B$0z01}@Sc$*$QX70LIpb^%2IqOXRjM{",
                                    "type": "image"
                                },
                                {
                                    "id": 932239,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d47f5c15-070a-4341-bc72-d8caa19f8606/width=450/932239.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UTQ@JBmS}J,@IVXl%2s;QTkqs:o|-qo}IAnO",
                                    "type": "image"
                                },
                                {
                                    "id": 932240,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/53a50738-5a78-4d58-abdb-ab8fd84f4561/width=450/932240.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UKJr%N^k0}|2~q}t=K%2KPJ8$%kp$kay9tM{",
                                    "type": "image"
                                },
                                {
                                    "id": 932241,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/28b90fdb-5c1f-4f02-91b8-1cc6db4586c4/width=450/932241.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1296,
                                    "hash": "UQN9a--WsE~W9a=|xv%2T0s98_I;m+i_M{M{",
                                    "type": "image"
                                },
                                {
                                    "id": 932242,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/03002c2e-cc1c-4808-be9a-eff86e5fa1e0/width=450/932242.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9K^Z}vi5Q~qGb#rizn$El^,004:~qOE8_9F",
                                    "type": "image"
                                },
                                {
                                    "id": 932244,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/58eb9e4c-e0e5-4b68-890a-9853ddd1c4df/width=450/932244.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UbI=Z5pJL3wu6;o~WGaKOvRP$*oe^+rqIUX7",
                                    "type": "image"
                                },
                                {
                                    "id": 932248,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5c22c381-36ad-4bc8-a56c-c1cc6ab5897c/width=450/932248.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UQJRT~9EHWXT0;#6S*OY5Brr-BXA.So}M{o~",
                                    "type": "image"
                                },
                                {
                                    "id": 932245,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6b2a3f67-7ab4-471b-bf86-22d713cdf76a/width=450/932245.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UILL?^?bpy$+K%?H-VNH0fV@rqbFRQM{RPRk",
                                    "type": "image"
                                },
                                {
                                    "id": 932247,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5b6d16a7-1c70-4224-89eb-2a532a930f5e/width=450/932247.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFIykE8{}[rWxvIoo}RPD*Ip^jE2Ef-oRjtR",
                                    "type": "image"
                                },
                                {
                                    "id": 932262,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/898b37c1-605c-4b50-8e1c-0955ae3ed8b2/width=450/932262.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDIWvD^O00~AIT~B^kIA589t%1%2Xo9a9GS$",
                                    "type": "image"
                                },
                                {
                                    "id": 932263,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/017c1cf8-9087-46ef-bd01-2710c9652a35/width=450/932263.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFL37GE100~B$v=|^js+02RiNetR0hs:9uE2",
                                    "type": "image"
                                },
                                {
                                    "id": 932264,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/48a0c927-8f70-413a-a58e-ef28b9f0ae82/width=450/932264.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAJ?jJ00CP:*?[IB}[Io00g39a%38xENs,WE",
                                    "type": "image"
                                },
                                {
                                    "id": 932285,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/25460a16-34d5-4786-a92d-93f6bda1cfb7/width=450/932285.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UXIz}3s:*0xvrUaxRijYOZofRjWCR+n$ofa}",
                                    "type": "image"
                                },
                                {
                                    "id": 932305,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8463692e-0afe-463a-a970-9a7d447e65f3/width=450/932305.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UbPY0g?w-Xf6v~V@%2t7VuRjkVn$t7ofRjbb",
                                    "type": "image"
                                },
                                {
                                    "id": 932315,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1786707b-4d0e-44e9-961e-545191d8c0c1/width=450/932315.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFLpdZkW0z+]0Kxu~qS}D*tRrrMdWBMx%2o}",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/82778"
                        }
                    ]
                },
                {
                    "id": 7706,
                    "name": "Shirt Tug Pose (LORA)",
                    "description": "<p>LORA model for shirt tug pose, suggested LORA weights: 0.5 ~ 1.5, default weight 1 should be good enough.</p><p>If the pose doesn't show up for some checkpoints, try greater weights.</p><p>Trigger words: shirt, naked shirt, shirt tug</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 3,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 35380,
                        "favoriteCount": 0,
                        "thumbsUpCount": 5146,
                        "thumbsDownCount": 1,
                        "commentCount": 3,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 0
                    },
                    "creator": {
                        "username": "Akii",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cb83d777-82e1-4821-80f7-138a32e57114/width=96/Akii.jpeg"
                    },
                    "tags": [
                        "poses"
                    ],
                    "modelVersions": [
                        {
                            "id": 9048,
                            "name": "shirt_tug",
                            "index": 0,
                            "modelId": 7706,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-02-09T19:53:49.884",
                            "availability": "Public",
                            "trainedWords": [
                                "shirt",
                                "naked shirt",
                                "shirt tug"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 35380,
                                "ratingCount": 5089,
                                "rating": 5,
                                "thumbsUpCount": 5146,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 8831,
                                    "sizeKB": 147577.712890625,
                                    "name": "shirt_tug.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-09T19:56:59.887Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "B9087FE2",
                                        "AutoV2": "A1C6BB7F6F",
                                        "SHA256": "A1C6BB7F6FDA0C7500E7F019087FF3DA5EB5B186258206903D8324DA5FFBE68C",
                                        "CRC32": "26D7B001",
                                        "BLAKE3": "F76F0EDE64F73C720E25A4BC88014E3AA88ECB27677827D05A3C92DA35338F51",
                                        "AutoV3": "D4F75A12B3E9"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/9048",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 86755,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/81c123d7-db99-4ca7-7ea2-a67a25606200/width=450/86755.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGGk|200YNi__M9F?baKMdM{t8jZELspoKRk",
                                    "type": "image"
                                },
                                {
                                    "id": 86764,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/efed6c05-ca7d-40a6-8169-c38b59512200/width=450/86764.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGI}VB9bNN~V@rt6=ZkCl:axS#WE^*bbxYNH",
                                    "type": "image"
                                },
                                {
                                    "id": 86762,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c7aae424-0548-49be-711f-3fe6c7594700/width=450/86762.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UXIqcR~V4.so-:?HtRIoMxofo}R*aeWBoft7",
                                    "type": "image"
                                },
                                {
                                    "id": 86761,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c73a5095-a4a9-4e36-0493-ec0496a0f100/width=450/86761.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UKHL0d%2D$01yEtRNHRO~AR*tmMxkWs:WWIp",
                                    "type": "image"
                                },
                                {
                                    "id": 86760,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/62cf88d4-d586-462d-fb85-9f471fb25700/width=450/86760.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEI4%{M_~o01.QIB~V-:=x=|D*R*NZX8sTRR",
                                    "type": "image"
                                },
                                {
                                    "id": 86756,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f57695a8-eb73-4bb7-0386-f71b76731400/width=450/86756.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFG8}*j^Ub$$~pkD4@t7~TbcbwxZ.8kDrWsm",
                                    "type": "image"
                                },
                                {
                                    "id": 86758,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/544faa3b-5b01-4a41-0d19-63a0e1461300/width=450/86758.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UMGIZS01.Tt7E+%gxujF%2xaE1%2S5oJs:Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 86757,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/58388539-a96a-40ca-8f81-5952ea1a5b00/width=450/86757.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U8GIZL9bO;Rk?^t700My_3%200V[Ost6wKRj",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/9048"
                        }
                    ]
                },
                {
                    "id": 6779,
                    "name": "Arknights-Texas the Omertosa",
                    "description": "<p>Role of <em>Arknights</em></p><p><em>weight0.7-0.85 can achieve good effect.</em></p><p><em>You can use head or Omertosa to trigger different effects。</em></p><p><strong><em>TEXAS!</em></strong></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 3,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 27311,
                        "favoriteCount": 0,
                        "thumbsUpCount": 5123,
                        "thumbsDownCount": 0,
                        "commentCount": 8,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 10
                    },
                    "creator": {
                        "username": "L_A_X",
                        "image": "https://cdn.discordapp.com/avatars/1046319534790942850/a6d5fd6a7c4c7f1e0af299bc3a0d4fab.png"
                    },
                    "tags": [
                        "anime",
                        "character",
                        "arknights",
                        "game character"
                    ],
                    "modelVersions": [
                        {
                            "id": 7974,
                            "name": "v1.0",
                            "index": 0,
                            "modelId": 6779,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-02-05T10:51:17.829",
                            "availability": "Public",
                            "trainedWords": [
                                "head",
                                "omertosa "
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 27311,
                                "ratingCount": 4865,
                                "rating": 5,
                                "thumbsUpCount": 5123,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 7950,
                                    "sizeKB": 73839.3642578125,
                                    "name": "Arknights-Texas the Omertosa.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-05T10:56:08.186Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "77830DC1",
                                        "AutoV2": "0B86FE247C",
                                        "SHA256": "0B86FE247C1A02D781E236ABD356B2B7180F4250F1F7C2633EDE7BAC2CD40272",
                                        "CRC32": "B5DAE033",
                                        "BLAKE3": "79108D257851CAE1997A6AF95210BB8963684EC3F0CBC64FD442A5ABB90F8D91",
                                        "AutoV3": "5C4D035B5519"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/7974",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 323361,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/429b6b9b-c1b3-4e54-74d1-dc51e5c23100/width=450/323361.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNG*~M_2~Ao}f-9a4oIp~VNIwuoc?a%1xF%L",
                                    "type": "image"
                                },
                                {
                                    "id": 148892,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/28c6d5aa-e12b-458d-312f-8f4c669b1e00/width=450/148892.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2048,
                                    "height": 2039,
                                    "hash": "UtJH?raf?bkC~qofoft7%MWBM{j[t7j]RjWB",
                                    "type": "image"
                                },
                                {
                                    "id": 75141,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/87c88df9-2e11-4b76-4eab-6f37a914f000/width=450/75141.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "USFiV}D%-;-:?^r=R*xa%#WB%MRjJVt6WBRj",
                                    "type": "image"
                                },
                                {
                                    "id": 75145,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b41a960e-2d34-4f97-6e0b-d395be344800/width=450/75145.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UmKUWe-;-;%M~qWB%MayxuIUt7ofxuM{IUxu",
                                    "type": "image"
                                },
                                {
                                    "id": 75144,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/44a710d4-6954-401f-e18d-50203e95ec00/width=450/75144.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UGEyDD~qD%Di4nRj4:R+D%D*-pS2E1%1ni%2",
                                    "type": "image"
                                },
                                {
                                    "id": 75143,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c680fb86-0ceb-4bb7-b47c-ca32e6436700/width=450/75143.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UcJ@]~^+?vWX_NNG%MRjx]M|Mxe.?HozIoju",
                                    "type": "image"
                                },
                                {
                                    "id": 75168,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d99ddaaf-feaa-4883-2acd-d3a4988e2700/width=450/75168.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UlG9Hs%1%L%h?wRjoftRx^jYRjj[NHj?V[M{",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/7974"
                        }
                    ]
                },
                {
                    "id": 6213,
                    "name": "Dark Magician Girl LoRA",
                    "description": "<h2>Dark Magician Girl LoRA</h2><h3><u>Turn on visibility to see all the examples</u></h3><p><strong>Making models can be expensive. Do you like what I do? Consider supporting me on </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/Lykon275\"><strong>Patreon</strong></a><strong> 🅿️ or feel free to </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://snipfeed.co/lykon\"><strong>buy me a coffee</strong></a><strong> ☕</strong></p><p>Great character design from a great franchise. Should work on most anime models at 1 weight (0.6-0.7 for the old one). Triggers with <code>dark magician girl</code> plus her outfit description so she can be <em>customized </em>like you want. For the first pic I also used dpep2 LoRA to give it some style.</p><p>Thanks to <strong>@plsdontultme </strong>for some of the examples.<br /></p><p><strong>How to use LoRA's in auto1111:</strong></p><ul><li><p>Update webui (use <code>git pull</code> <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/embed/mn8fMF10XN4?start=31&amp;end=60\">like here</a> or redownload it)</p></li><li><p>Copy the file to <code>stable-diffusion-webui/models/lora</code></p></li><li><p>Select your LoRA like in <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/watch?v=-bMeyXOZwN0\">this video</a></p></li><li><p><strong>Make sure to change the weight</strong> (by default it's <code>:1</code> which is usually too high)</p></li></ul>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 29396,
                        "favoriteCount": 0,
                        "thumbsUpCount": 4995,
                        "thumbsDownCount": 0,
                        "commentCount": 14,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 50
                    },
                    "creator": {
                        "username": "Lykon",
                        "image": "https://cdn.discordapp.com/avatars/180327464155742208/59254be18ccd627daf138d053327485d.png"
                    },
                    "tags": [
                        "anime",
                        "character",
                        "girl",
                        "sexy",
                        "female",
                        "manga",
                        "consistent character",
                        "games",
                        "tcg",
                        "yu-gi-oh!",
                        "dark magician girl",
                        "game character",
                        "girls"
                    ],
                    "modelVersions": [
                        {
                            "id": 7287,
                            "name": "offset",
                            "index": 0,
                            "modelId": 6213,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-04-19T08:33:26.918",
                            "availability": "Public",
                            "trainedWords": [
                                "dark magician girl"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 28672,
                                "ratingCount": 3149,
                                "rating": 5,
                                "thumbsUpCount": 3210,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 48017,
                                    "sizeKB": 147567.2177734375,
                                    "name": "dark_magician_girl_offset.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-12T09:31:11.436Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "9499320C",
                                        "AutoV2": "092EB916AA",
                                        "SHA256": "092EB916AA39394702B4C92F7F95B13A2CB3EA00FF0F1519933614A69193400A",
                                        "CRC32": "33577C8F",
                                        "BLAKE3": "3782FA2830D6D41679D97CC6545F86C65690A156690F7665479029A3320B0D61",
                                        "AutoV3": "8D794D78422A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/7287",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 67367,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fe65402b-c874-46cd-d03d-3c6b7ca75500/width=450/67367.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "U9J%@F^,00010c~qE2I80w4;%#5Q00-?ESM|",
                                    "type": "image"
                                },
                                {
                                    "id": 765354,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/96c83a06-8ffe-4105-adbb-f96564f140cc/width=450/765354.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UAHx1:Q.00bE00IU~q-o?XELE7fiE8tRMwR+",
                                    "type": "image"
                                },
                                {
                                    "id": 117719,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/abbfb63b-c3b3-49ee-3bfc-6dfb27139500/width=450/117719.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1920,
                                    "height": 2944,
                                    "hash": "UGHUY0KR00^*0x~VOuJ;8_S5?anNMxD%V@tR",
                                    "type": "image"
                                },
                                {
                                    "id": 67375,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c28808b0-3aad-4d08-1ba8-9874e553d100/width=450/67375.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UOMt2S,s_NoLt6ozV?M|?bIVT0bvR=ID^*xZ",
                                    "type": "image"
                                },
                                {
                                    "id": 359055,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b892bf5e-f5d4-49d0-4dfc-36c83fd0bc00/width=450/359055.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UII#S{000z~W9Et79^$*5[j;-VjIxvD%?FM{",
                                    "type": "image"
                                },
                                {
                                    "id": 359054,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/90f142e5-631f-4047-d345-ad4b425a2a00/width=450/359054.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBHd:M00KMNfEgw@E3oyx]ITENJ7Kk4;~BWE",
                                    "type": "image"
                                },
                                {
                                    "id": 67373,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6665d5e8-2fca-41a9-aae4-afd5ce471600/width=450/67373.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UHK,?V%}55rpyE%M9FH?~B-;XTX903RiozNF",
                                    "type": "image"
                                },
                                {
                                    "id": 67372,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/31854738-05d0-4286-3cd3-7efabfbbf900/width=450/67372.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "ULJ@g~-U00IX%19Z%1~W4.bE9us:9coHxaRj",
                                    "type": "image"
                                },
                                {
                                    "id": 67370,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4ca9d041-04eb-47cd-d374-03536baf9100/width=450/67370.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UMK1B?.54m%L_M_2xVIptJ~BJB$+xvNG%1xu",
                                    "type": "image"
                                },
                                {
                                    "id": 67368,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5ae19e59-8aed-47fd-b329-d43dcaa35500/width=450/67368.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UWLzU7-;xu%2_Nt7RPD%tRxBV?RPtm-TsoR*",
                                    "type": "image"
                                },
                                {
                                    "id": 67374,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7bd988e6-c458-4952-ce66-cbdbd47dd400/width=450/67374.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "URKKHG_3kp.8~Bf,EMkC9Z%L-:%2Nhk9RPoI",
                                    "type": "image"
                                },
                                {
                                    "id": 359056,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fd227f5b-167c-4b09-17b0-4f1238399800/width=450/359056.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9IEIaDO00?v5;D$~V?bExELj^%2A0S$I9RQ",
                                    "type": "image"
                                },
                                {
                                    "id": 67371,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5eb59a23-5d0b-46a9-6317-34a45d099500/width=450/67371.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UQLNPzIu-no~_2S5NF%1ERSi~p%2F$$~s*Rn",
                                    "type": "image"
                                },
                                {
                                    "id": 67369,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/58f4be61-da07-4390-4bab-b2b3d4b3a900/width=450/67369.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UIMZ%h?H?bRQ?wIU?Gx]tS-Sf%E3tnNaVr$%",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/7287"
                        },
                        {
                            "id": 68656,
                            "name": "v1",
                            "index": 1,
                            "modelId": 6213,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-05-12T09:25:47.727",
                            "availability": "Public",
                            "trainedWords": [
                                "dark magician girl"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 724,
                                "ratingCount": 1234,
                                "rating": 5,
                                "thumbsUpCount": 1804,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 48013,
                                    "sizeKB": 147569.0966796875,
                                    "name": "dark_magician_girl.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-12T09:31:09.124Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "BF114FE4",
                                        "AutoV2": "A652EB19BD",
                                        "SHA256": "A652EB19BDA179DDA992541B6E509C1F601E8406F86E0DC4364DDAB97D8C064D",
                                        "CRC32": "3F1C76C0",
                                        "BLAKE3": "89B3229BD208C92BE2A6B1496A66EEFBDAA013E2C66D8E0862433B20373B8F1F",
                                        "AutoV3": "37DA6A4E6D88"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/68656",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 765277,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/de78564f-9d8d-4f5b-9103-eb0af0c229a2/width=450/765277.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UAH-iZv#00kD00IU~q%2?XELE8ofESkWM_R,",
                                    "type": "image"
                                },
                                {
                                    "id": 765342,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a7b1b0c2-0840-4d02-accb-2729d6113906/width=450/765342.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1840,
                                    "height": 1599,
                                    "hash": "UaJto8aeaye.%#WVayWB~qbHaybH.8ofayt7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/68656"
                        }
                    ]
                },
                {
                    "id": 11096,
                    "name": "Irene",
                    "description": "<p>Bae Joo-hyun a.k.a. Irene, Korean Singer. Please do not share NSFW images in gallery, they will be removed!</p><p></p>",
                    "poi": true,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": false,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 3,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 42163,
                        "favoriteCount": 0,
                        "thumbsUpCount": 4914,
                        "thumbsDownCount": 1,
                        "commentCount": 58,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 201
                    },
                    "creator": {
                        "username": "Ithlinni",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/494378ce-ce65-488a-f1ba-5520836fa200/width=96/Ithlinni.jpeg"
                    },
                    "tags": [
                        "girl",
                        "photorealistic",
                        "asian",
                        "woman",
                        "beautiful",
                        "celebrity",
                        "korean",
                        "portraits",
                        "realistic",
                        "real person",
                        "bae joo-hyun"
                    ],
                    "modelVersions": [
                        {
                            "id": 20090,
                            "name": "irene V7.0",
                            "index": 0,
                            "modelId": 11096,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-08-13T22:59:41.217",
                            "availability": "Public",
                            "trainedWords": [
                                "irene1"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 30166,
                                "ratingCount": 3512,
                                "rating": 5,
                                "thumbsUpCount": 3717,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 16775,
                                    "sizeKB": 147567.2177734375,
                                    "name": "irene_v70.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-08T05:11:33.716Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "BA183C3F",
                                        "AutoV2": "2F3CF44E63",
                                        "SHA256": "2F3CF44E63737A9109768999D10D2D9E2B4E914382BDE46D3367E7AD18EFFF18",
                                        "CRC32": "1203D64F",
                                        "BLAKE3": "DEDC06BA20B9E65172EAA2B12C06CA5428D35CDAEAE71856E292AD4A2B28D506",
                                        "AutoV3": "636D7E321EBE"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/20090",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 212371,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b2e17b74-aa55-498a-b506-5016b4b6d400/width=450/212371.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UHLNY[I900p000kr?w$}00-otRs:%hxuM{IV",
                                    "type": "image"
                                },
                                {
                                    "id": 212368,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8a029e11-1816-4b20-1c8d-306f8a06a600/width=450/212368.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UIHCG~ro0Kks@;T1kVxDs*Sii_aJ.TslVrM|",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/20090"
                        },
                        {
                            "id": 16468,
                            "name": "Irene 6.0",
                            "index": 1,
                            "modelId": 11096,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-08-13T22:59:41.217",
                            "availability": "Public",
                            "trainedWords": [
                                "irene1"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4550,
                                "ratingCount": 535,
                                "rating": 5,
                                "thumbsUpCount": 537,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 13919,
                                    "sizeKB": 147575.509765625,
                                    "name": "irene__v6.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-28T03:46:14.202Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "3BF0CFE5",
                                        "AutoV2": "5CB9985FE2",
                                        "SHA256": "5CB9985FE2B5D5F58346720E31E3DF0C6B6C64A8A662951FC8D6117CBB2ADCAE",
                                        "CRC32": "5E4E9088",
                                        "BLAKE3": "3B7A5F187FCDA15F4DBCC7080C015E0F6C60EDA320DE8A13A15378B69D7ED666",
                                        "AutoV3": "3DD44996C38A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/16468",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 169385,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/58f1fd70-14a7-4b39-ace4-b5ae3df3de00/width=450/169385.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UmMZ:j_NJUn%O[%Nxuj]s:V?s9RktlRjaeV@",
                                    "type": "image"
                                },
                                {
                                    "id": 169358,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f43d5760-a87a-4458-a6dc-0c993b63e700/width=450/169358.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UYK,:C~qXn-;K5-;%M%2E1M{r=RjxuoKofNG",
                                    "type": "image"
                                },
                                {
                                    "id": 166153,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d9edf47e-e0ba-4356-8280-72a015c88a00/width=450/166153.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UII;n$?H01-o0?tS~AxsFz9vRUV@.8NfM_Ri",
                                    "type": "image"
                                },
                                {
                                    "id": 166155,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/31b8689a-ce4b-43a2-c6c8-9892a575db00/width=450/166155.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UCJsX-}i1G020-0fMz-U5Q%E-B,]58-XsREL",
                                    "type": "image"
                                },
                                {
                                    "id": 166154,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/32eadba2-c8c0-452c-b5e7-e8f1e5eb0600/width=450/166154.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UEFrIxyY^*~C5To}9as8S%E2D%D%58oe^P9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 166151,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/32db49dc-6269-49c9-5494-af7d58237400/width=450/166151.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "USL;EUs=Y4-:7$Io%hIr%%Ncr=S4TLNII9t7",
                                    "type": "image"
                                },
                                {
                                    "id": 166149,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2b5a1aec-16dc-485b-305f-d725a12b6500/width=450/166149.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UWIr8MTdIo%2},tl-;WCaeoItRaK.9W.M{s:",
                                    "type": "image"
                                },
                                {
                                    "id": 169384,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/89d3ca94-6af3-4b47-3463-660728c54200/width=450/169384.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UNL:.Xxv~7-U^Y-:R5n$_NRjQ,jD=tR+9cjY",
                                    "type": "image"
                                },
                                {
                                    "id": 173419,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4ba3955a-849b-4d0f-6b50-0e797e645200/width=450/173419.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UNK,:F#9?v}[xuVtbas:tl%M%1s:R+RP%MM{",
                                    "type": "image"
                                },
                                {
                                    "id": 173418,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9f70ea66-7011-4ac3-61f4-047f129c5800/width=450/173418.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UKKwa=xa%$~V~WxG?aM|E2jFi^M{tRju^+Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 173417,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/994f41f1-7652-4fed-06a5-e95d91479300/width=450/173417.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UPKde^^+yY?a_NjE?bIUJBMx-pRPx]of%M%2",
                                    "type": "image"
                                },
                                {
                                    "id": 173416,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e650ce5c-c02a-44d9-cfeb-ab04eb034e00/width=450/173416.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "URLN3^01.T~CNd$*t7V[tmxa-p%1IpWAxbM{",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/16468"
                        },
                        {
                            "id": 15263,
                            "name": "Irene V5.0",
                            "index": 2,
                            "modelId": 11096,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>This version is good.</p>",
                            "publishedAt": "2023-08-13T22:59:41.217",
                            "availability": "Public",
                            "trainedWords": [
                                "irene1"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1724,
                                "ratingCount": 139,
                                "rating": 4.97,
                                "thumbsUpCount": 139,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 13089,
                                    "sizeKB": 147572.94921875,
                                    "name": "irene__v5.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-25T14:11:17.978Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "FEED6422",
                                        "AutoV2": "0F8D61F034",
                                        "SHA256": "0F8D61F0349C6646B68F6CEC22D20AAF8D01A40E7D0E85E141C717D96DD2BB28",
                                        "CRC32": "171CE175",
                                        "BLAKE3": "CA17FA9148D3FF458FE55073103D10508FA1422FA15089721C04EBB97939B5DB",
                                        "AutoV3": "3A4E3264D371"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/15263",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 150702,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6335b098-1c87-41dc-0bf7-45afabee1300/width=450/150702.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UHJ%|G00Vqen$yW=yEIUkq%Mxu9G~WxuIAxt",
                                    "type": "image"
                                },
                                {
                                    "id": 150701,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/120f6524-7307-4c3e-3855-e88b5e8bb600/width=450/150701.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UXJHdlI;T{={LNxunnNF%3oL%0Rjx^V@RPkC",
                                    "type": "image"
                                },
                                {
                                    "id": 150699,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4ac5e396-b36a-4661-ae7a-fa1a6a931200/width=450/150699.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UVHC7lXT?w-U_4xuozIA%ht8j]Rj%MM{WAt7",
                                    "type": "image"
                                },
                                {
                                    "id": 150698,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c80e13ca-c6ce-4430-4b74-07c64617e400/width=450/150698.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "ULJ8nvM|0L^+9aM{?wRPbxog-pRj_NxuIANF",
                                    "type": "image"
                                },
                                {
                                    "id": 150697,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f3da2a03-0d53-4878-345b-d38419312300/width=450/150697.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UCLWeJ00^#N1-3-:%#Md4;^*xt0L~VD%D%-;",
                                    "type": "image"
                                },
                                {
                                    "id": 150696,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/be02bf53-009e-438c-c150-0049d6929b00/width=450/150696.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UMIhQuIAKu?uTzW9IBE2?wIU?Hs;?cM{Rjxu",
                                    "type": "image"
                                },
                                {
                                    "id": 150695,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d05b0b52-7eb8-4add-ee86-8ba723f11900/width=450/150695.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "ULJuAZRQO;?bu6s;XUIq%NWBM}WB9ZozMvRi",
                                    "type": "image"
                                },
                                {
                                    "id": 150694,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ded09f50-2441-4751-1bc3-560ddaf88c00/width=450/150694.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UaL;QwWr9r-pXVtRx^R%?wWBnmRj%gNGM_of",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/15263"
                        },
                        {
                            "id": 14886,
                            "name": "Irene V4.0",
                            "index": 3,
                            "modelId": 11096,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>Small upgrade (maybe). Try avoid \"1girl\" in the prompts when using it.</p>",
                            "publishedAt": "2023-08-13T22:59:41.217",
                            "availability": "Public",
                            "trainedWords": [
                                "irene1"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1565,
                                "ratingCount": 135,
                                "rating": 5,
                                "thumbsUpCount": 135,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 12802,
                                    "sizeKB": 147574.6142578125,
                                    "name": "irene__v4.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-24T14:41:17.573Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "6FDF93AB",
                                        "AutoV2": "1387BB11A6",
                                        "SHA256": "1387BB11A65986BB5540D0FD5A96B647DB5EDB3E47300119A12E562489687764",
                                        "CRC32": "33B6CC73",
                                        "BLAKE3": "1B79BF8CBA6F765D13353D7CE51F66AF76E485103C552F13919C98107530A92C",
                                        "AutoV3": "D0271879BCAB"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/14886",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 145617,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6e5b40aa-79e4-443e-9318-8e396b68e300/width=450/145617.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UJJH,g~V0fQl0NRP-ow[PDNf-o%hpKbvtSNy",
                                    "type": "image"
                                },
                                {
                                    "id": 145615,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/376b7f0d-8ddb-4f5f-8e4b-c7d000b11200/width=450/145615.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UQKdubV?s-Vr?H-;kXs:E2%M?bNG~qo}IUbI",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/14886"
                        },
                        {
                            "id": 14295,
                            "name": "Irene V3.0",
                            "index": 4,
                            "modelId": 11096,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>Added trigger word \"Irene1\" , and should get more accurate results base on your prompt.</p>",
                            "publishedAt": "2023-08-13T22:59:41.217",
                            "availability": "Public",
                            "trainedWords": [
                                "irene1"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1390,
                                "ratingCount": 111,
                                "rating": 5,
                                "thumbsUpCount": 111,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 12440,
                                    "sizeKB": 147574.5361328125,
                                    "name": "irene_v3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-23T12:25:54.670Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "705F3767",
                                        "AutoV2": "F853D580CB",
                                        "SHA256": "F853D580CB44FC7FAF0330B2CD1EE713574C8D9B3358FB4DE0332555FAB93050",
                                        "CRC32": "B067EAF6",
                                        "BLAKE3": "E3866026F76DC125F8A841C800D0BF4986353D6310AD1D4F8215023B761562E7",
                                        "AutoV3": "B461CA9AB4BB"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/14295",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 142878,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dfc42b3f-7b48-4edb-0538-9e73ba355900/width=450/142878.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UPIX{mR+F|%L0g%N%hae~qxu~WM{yXWq-=fk",
                                    "type": "image"
                                },
                                {
                                    "id": 139212,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f49caea4-c047-4372-bd1d-550e88267700/width=450/139212.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UJI#+E9GOtMd?wR+S$M{E3%M~qj]?wIUIAxu",
                                    "type": "image"
                                },
                                {
                                    "id": 139211,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0161e096-03cb-472b-e34f-266a789d4600/width=450/139211.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UMGu?:D*yDsl_Nt6Y7s:?vkB%NRjJWRj={sl",
                                    "type": "image"
                                },
                                {
                                    "id": 139209,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/85273d17-7db0-4c77-9347-9dfd44d61500/width=450/139209.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "U7C?r~_N0000K6RP8wjY_No#RQxu.ToeDOD%",
                                    "type": "image"
                                },
                                {
                                    "id": 139207,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/14743ef8-6b2b-463a-0010-0a03e9b28300/width=450/139207.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UJFi12?c0ME10=Rk-:NGThX9a~%2FiNen+j]",
                                    "type": "image"
                                },
                                {
                                    "id": 139206,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b98c7322-401c-4058-fe98-c100a2667300/width=450/139206.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UDH24r0016~W04oM?G$*%3xu$K9Z5AxaD$I:",
                                    "type": "image"
                                },
                                {
                                    "id": 139205,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/497bbc14-93c9-477d-d007-d58700513600/width=450/139205.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UCIhT]=q00?c0=I8lCI]t.9Fxvxu%hJW_3-;",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/14295"
                        },
                        {
                            "id": 13495,
                            "name": "Irene V2.0 ",
                            "index": 5,
                            "modelId": 11096,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>just added a little more pictures to train the lora</p>",
                            "publishedAt": "2023-08-13T22:59:41.217",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1911,
                                "ratingCount": 195,
                                "rating": 5,
                                "thumbsUpCount": 196,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 11941,
                                    "sizeKB": 147569.77734375,
                                    "name": "ireneV2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-21T11:17:10.153Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "592758D6",
                                        "AutoV2": "0C1208401F",
                                        "SHA256": "0C1208401F6C0134F51521496800B0ADBC1559035BECA96A239D87A99E64428B",
                                        "CRC32": "A28BD3E8",
                                        "BLAKE3": "60148AFB51E3E7E3ECFC0E530A537A3A71A5AFA8092D8312A6F3D0129964F6DC",
                                        "AutoV3": "3C2887DF873F"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/13495",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 130459,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8e7f4348-f0b8-40f9-ce67-0911c296aa00/width=450/130459.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UQHwoir=^j$$^*IUxuIp~BxaNbWCxuxtWBNH",
                                    "type": "image"
                                },
                                {
                                    "id": 130458,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/27033cd2-7ae4-4a9f-6b79-5bd6c0209900/width=450/130458.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UEEyoMx]00M{00R,?^WBT1xuofM{.8WBrqof",
                                    "type": "image"
                                },
                                {
                                    "id": 130457,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c161af64-569b-4ac2-2bef-074fc686b900/width=450/130457.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 768,
                                    "hash": "UgG[=?j@.8tR_NWBozbH.8Rkxuay%Mofoeof",
                                    "type": "image"
                                },
                                {
                                    "id": 130456,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/91513936-3af5-4d01-ba9c-68386a388200/width=450/130456.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UCG*{A%g004nE2xu~qE2-=?bIAxtXTS5xu-;",
                                    "type": "image"
                                },
                                {
                                    "id": 130455,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2ce5c662-2d12-41f6-a787-6f90ec68eb00/width=450/130455.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UUJRQ~%MS$%M_Nx]%gj[kXae%2Rj?cRjIAWB",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/13495"
                        },
                        {
                            "id": 13143,
                            "name": "Irene V1.0",
                            "index": 6,
                            "modelId": 11096,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-08-13T22:59:41.217",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 857,
                                "ratingCount": 85,
                                "rating": 5,
                                "thumbsUpCount": 85,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 11716,
                                    "sizeKB": 147569.7255859375,
                                    "name": "irene2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-20T15:46:22.499Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "8CCCA499",
                                        "AutoV2": "B3B7FA39E6",
                                        "SHA256": "B3B7FA39E64808356DC00D79848249B4A9341ECD85272A24845C4B7CD785ABDC",
                                        "CRC32": "32355BD8",
                                        "BLAKE3": "AFDA305024C593E8CC85DB7D0F8338D95508AEE83BB4BDBFDD435C545896922E",
                                        "AutoV3": "69115A403031"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/13143",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 127024,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8f5a43c2-0a95-4056-c4d6-b2611deed400/width=450/127024.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UCGj]E=y9u0202%1~BIo-:0fn%?G0LWVkC%1",
                                    "type": "image"
                                },
                                {
                                    "id": 127023,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d99ed12-39b5-4df3-1cfd-a4639a340000/width=450/127023.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UHIf}0IBNa0fEgIV~ARj_2E2Rj=_IpR*EMxa",
                                    "type": "image"
                                },
                                {
                                    "id": 127022,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/367ccad6-e0ae-4196-cb2b-a36cf4069800/width=450/127022.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UJGt]9%M-U=_~qRjD%9a%g$$IVIp%2E1R*xu",
                                    "type": "image"
                                },
                                {
                                    "id": 127021,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/88e5975b-a87c-42e6-51e0-ff541b3fb600/width=450/127021.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UHHARt=xE20fS4NG~ANHxt57Rk?FM|WBt6%1",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/13143"
                        }
                    ]
                },
                {
                    "id": 76937,
                    "name": "Hairstyles Collection",
                    "description": "<p><strong>Patreon</strong></p><p>Get early access to build and test build, be able to try all epochs and test them by yourself on <a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/betterCuteAsians\"><strong>Patreon </strong></a>or contact me for support on Discord</p><p></p><p><strong>Recommended settings</strong></p><ul><li><p>Make sure you are aware on the usage instructions of LORA</p></li><li><p>Sampler: DPM++ SDE Karras (Recommended for best quality, you may try other samplers)</p></li><li><p>CFG Scale : 5 to 10</p></li><li><p>LORA weight for txt2img: reccomended 0.2-0.5.</p></li></ul><p></p><p><strong>Insutrctions</strong></p><p>My advice is to start with posted images prompts then change them, in any case you will find different keywords for each model (wich should be used with a weight of 1.2-1.3).</p><p></p><p>Also in version description on the right you will find more details about each hairstyle model.</p><p></p><p>Enjoy!</p><p></p><p><strong><u>If you'd like to support my efforts and have access to early and bleeding edge builds</u></strong>, please think about joining my Patreon: <a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/betterCuteAsians\"><strong>https://www.patreon.com/betterCuteAsians</strong></a></p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [
                        "Image"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 22,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 159619,
                        "favoriteCount": 0,
                        "thumbsUpCount": 4898,
                        "thumbsDownCount": 0,
                        "commentCount": 51,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 20
                    },
                    "creator": {
                        "username": "antonio_riolo2610",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/41ffdf0b-a439-4be8-6394-aea3514d6300/width=96/antonio_riolo2610.jpeg"
                    },
                    "tags": [
                        "photorealistic",
                        "sexy",
                        "female",
                        "style",
                        "woman",
                        "girls",
                        "realistic"
                    ],
                    "modelVersions": [
                        {
                            "id": 103767,
                            "name": "Short Dreads",
                            "index": 0,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>Very simple to use, just use the keyword with proper weight.</p><p>Work with both males and females.</p>",
                            "publishedAt": "2023-06-25T13:16:00.827",
                            "availability": "Public",
                            "trainedWords": [
                                "short_dreads_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 7890,
                                "ratingCount": 1027,
                                "rating": 5,
                                "thumbsUpCount": 1794,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 72827,
                                    "sizeKB": 147571.287109375,
                                    "name": "short_dreads_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-25T13:16:10.919Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "274A64DF",
                                        "AutoV2": "9AD55BD84D",
                                        "SHA256": "9AD55BD84DEF90FAA9A6DEC71F441698F1F9951593914E575D166DC5B9ACBB00",
                                        "CRC32": "89E23BD5",
                                        "BLAKE3": "AA5647F0176363BAB887C3A736AFA0FCB44BDC786768EF015B5A7478EB592009",
                                        "AutoV3": "637B6075BCAD"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/103767",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1283886,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/525bcf1f-dfbc-4935-bc60-a928af10ae28/width=450/1283886.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDHw[X,o00u40L5S%M+tI[kD?Fnh.m$$DOJA",
                                    "type": "image"
                                },
                                {
                                    "id": 1283891,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dea3eefd-b4f2-4ecd-b60e-dfea2bc3716e/width=450/1283891.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFDu-]s:D%-oB;NH9GM|GH$%wIt6~WI:Mxf6",
                                    "type": "image"
                                },
                                {
                                    "id": 1283885,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2c60d744-1d24-4029-b0d6-8772496293f4/width=450/1283885.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UdI4^j.8EN%M?w%MRkofTe%2$%WV-pbbNGWX",
                                    "type": "image"
                                },
                                {
                                    "id": 1283884,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/99911d32-877a-44db-807c-0c3dfac25b91/width=450/1283884.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFIXs%4m00~p00WYO[M|CSrp$gxZ?vs:rCW=",
                                    "type": "image"
                                },
                                {
                                    "id": 1283882,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e726bd8-72db-41c0-8bd5-b347d9a17d30/width=450/1283882.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHI;^#%~00_3Ty_3_N%2ys^+wING_3kWR4tR",
                                    "type": "image"
                                },
                                {
                                    "id": 1283883,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ab8af0e8-7394-4c90-9aaa-3eb3509151a4/width=450/1283883.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFHx4,D*00-:0hoertRj16oK?aWB~pM|s9s:",
                                    "type": "image"
                                },
                                {
                                    "id": 1283881,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b978d132-f958-4930-ae0a-b6b99cc494e9/width=450/1283881.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UaHe8?%gEN?G?^?HNHkW-;xuxZofNxbHslWV",
                                    "type": "image"
                                },
                                {
                                    "id": 1283887,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/74cfdaba-f033-4872-ba5e-a06a458c4257/width=450/1283887.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHIq}y.T00-;pd_3_NxtbJ?Gs:E1cFWAvyW?",
                                    "type": "image"
                                },
                                {
                                    "id": 1283889,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/77073363-a9b5-4ebc-97c6-2a4290582651/width=450/1283889.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UNJaWT%#01-:*0?H-p%1tm-osmENxuRjV?oz",
                                    "type": "image"
                                },
                                {
                                    "id": 1283888,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/099a3c39-6063-4b27-9e9e-de411049156b/width=450/1283888.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGI|~x0003~n0@vy~2Rp0p$^tQRRt,a0M|x@",
                                    "type": "image"
                                },
                                {
                                    "id": 1283890,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/49347f82-ce1a-4d6e-aafb-27d1ea3c3f22/width=450/1283890.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UZKS|XbvM{f6~V-pM{s:o}X9-Tj?~Vt7a{of",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/103767"
                        },
                        {
                            "id": 103000,
                            "name": "Dreads",
                            "index": 1,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>Very simple to use, just use the keyword with a proper weight, like 1.3.</p><p>works with both females and males.</p>",
                            "publishedAt": "2023-06-24T14:45:31.235",
                            "availability": "Public",
                            "trainedWords": [
                                "dreads_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3007,
                                "ratingCount": 70,
                                "rating": 4.97,
                                "thumbsUpCount": 78,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 72241,
                                    "sizeKB": 147571.38671875,
                                    "name": "dreads_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-24T14:45:42.272Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "1EB1A7FF",
                                        "AutoV2": "AFC82529F9",
                                        "SHA256": "AFC82529F9F1457DA46B66D93FC28326B4B964D52AB22578682385440C928FEF",
                                        "CRC32": "C2B69567",
                                        "BLAKE3": "A21661C7CEC20EEC6219F3EEE8C32ABF470F420BE93A1EC736EBF4194DA1115F",
                                        "AutoV3": "D5B7AB40B0B6"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/103000",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1272233,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bc7df5f3-85c3-4929-8b45-443e7e3c5393/width=450/1272233.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHJF.6E1Pl}@.5RQ+btPNFI:wJnO~ANG^*={",
                                    "type": "image"
                                },
                                {
                                    "id": 1272246,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8211fd03-cbdd-425d-a6a6-9fb1261e7e34/width=450/1272246.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIGI+W*000?HMx%M?w-=00%2%MRiMIRjW;M{",
                                    "type": "image"
                                },
                                {
                                    "id": 1272236,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/501873c6-5cdc-46a1-89a8-36e1fdc5d1a6/width=450/1272236.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGG[4t~pV:#,--t8EN0L=q-okrRiI;jE-QI@",
                                    "type": "image"
                                },
                                {
                                    "id": 1272238,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4132f641-cadb-4ddd-a5d9-313d6c47d1cc/width=450/1272238.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "ULJjR_M|04%1IxWB~RV[^$w{?Fj=?GRks-W.",
                                    "type": "image"
                                },
                                {
                                    "id": 1272240,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e1e44ba-7b76-45f6-88b0-f3c2ece5bdf0/width=450/1272240.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UMIW=H^%06Rq0T%2~S-on#oL%1t3bEn$RQNH",
                                    "type": "image"
                                },
                                {
                                    "id": 1272234,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e00809ba-b871-4470-ade0-cddb05900b20/width=450/1272234.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIJao|JC00I9VWX9~qD%%fWY.8IVs9ogkDWB",
                                    "type": "image"
                                },
                                {
                                    "id": 1272239,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2fe6144a-fb6c-4844-83c1-3492fe0cc12f/width=450/1272239.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UWF={:?w0e%1IU%N?vxuNes:xaozs.oLWBay",
                                    "type": "image"
                                },
                                {
                                    "id": 1272235,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/263f974e-a14b-4263-a7bd-6c85d4e5caa0/width=450/1272235.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFFYJu?G^c$*=?-:9w9b}=XANenNw[IpR*oM",
                                    "type": "image"
                                },
                                {
                                    "id": 1272237,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d1d0d7f3-adfe-4296-973b-713f176af989/width=450/1272237.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UMB::N.TtM-;%1tSR:slM_%1krWVVsjFWXbI",
                                    "type": "image"
                                },
                                {
                                    "id": 1272241,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b110419d-4d6c-46cb-8a1d-c819ba7e6a16/width=450/1272241.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFJZ*K0N04~Sssaw~6IX=]=_.5xZ=xIq-jRj",
                                    "type": "image"
                                },
                                {
                                    "id": 1272244,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3fa36410-2d23-4f67-a755-11dc9ff3c8b2/width=450/1272244.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEJ86G0000-=8wI=_ND*VD.8$%D*RPXT%hn$",
                                    "type": "image"
                                },
                                {
                                    "id": 1272243,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a43dc808-4dbf-4260-9e9b-82cc041438b8/width=450/1272243.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCH0kj013U+]T^0L,I9t5lxZ}[M{9HxtNui_",
                                    "type": "image"
                                },
                                {
                                    "id": 1272245,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/27563754-9714-479c-b261-0e4814d32c4f/width=450/1272245.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBGQX[?]0y;21JD+D54.yY~W=x4.9HEMt2#l",
                                    "type": "image"
                                },
                                {
                                    "id": 1272248,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0446bb35-2565-467c-aaf5-0131836a6dd9/width=450/1272248.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBJ64-Jz8s|^1Z^j*|pH0M0fNLIo020#9bsp",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/103000"
                        },
                        {
                            "id": 97794,
                            "name": "Middle Parting",
                            "index": 2,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 22,
                            "description": "<p>I really like to post particular hairstyles, but since someone hasked for this one i made it!</p><p>To make it a little particular i added the possibility to use optional keyword \"(middle_jewelry over head:1.3)\" this will most likely generate jewelry over middle parting hairstyle, this keyword works better with 512x512 images but with a lucky seed you might get a good result also for 512x768</p><p>Always adviced 1.3 at keywords weight and 0.5 at model weight.</p>",
                            "publishedAt": "2023-06-17T09:06:01.598",
                            "availability": "Public",
                            "trainedWords": [
                                "middle_parting_hairstyle",
                                "middle_jewelry over head"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4908,
                                "ratingCount": 122,
                                "rating": 5,
                                "thumbsUpCount": 131,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 68038,
                                    "sizeKB": 147571.2548828125,
                                    "name": "middle_parting_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-17T09:06:14.912Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "7A509858",
                                        "AutoV2": "77F08EBA0B",
                                        "SHA256": "77F08EBA0B49AE0A9E963BADCA8C055E15BAC067323F7CA59EF1F251A66A8FFA",
                                        "CRC32": "2609AE5B",
                                        "BLAKE3": "6FB920BECA08E293F0E16397502E311E1D002D470C525C536B2834A8CB5E78D8",
                                        "AutoV3": "574417F82F05"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/97794",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1176442,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a3418bb1-ce58-46c6-842a-84a45ff3b32a/width=450/1176442.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIDlm8-=0LM_pxtmxZr=~q%NS$V?Tex]$%Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 1176449,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/61c498d4-0ec7-45a7-b660-37b0480b04ca/width=450/1176449.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UJH24n-p02x]uPOYIqRjIUxuvzR5rp$%Di9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 1176431,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ff744745-b9fe-4773-a2d1-68155f907ff2/width=450/1176431.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UUEVvt?It-M{*0tl-;r=?H%MNGWBIof+nNs:",
                                    "type": "image"
                                },
                                {
                                    "id": 1176444,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b1a03b86-e61e-4676-ab44-acfdeeaac9ee/width=450/1176444.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UQFYlp%h0gxG?w-;V[M{KQt7xFNGtRIoMxxa",
                                    "type": "image"
                                },
                                {
                                    "id": 1176432,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a7f6bfff-225a-4850-993e-1237546ca0f5/width=450/1176432.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDE.z.5S9G~B5?s,D*wc}]%1Ei9aK*n%-7XS",
                                    "type": "image"
                                },
                                {
                                    "id": 1176434,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f7b977b9-a5c4-44b6-a468-571ddd9ac3b8/width=450/1176434.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UICG*]R*_4xZ,[t7OYnjDOV@EKtRIUf7axkC",
                                    "type": "image"
                                },
                                {
                                    "id": 1176433,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e9d7bae6-103d-4f8e-b9df-e46ec2dbc496/width=450/1176433.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDCsq2%2p{WUInS1%3spL}V@4=%20eWZ#*xV",
                                    "type": "image"
                                },
                                {
                                    "id": 1176446,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e1c8d45d-38a5-4dbb-87ba-77aaf8373118/width=450/1176446.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UFF5y~Ip00-oPqt7MwM{%$xZQ-I;~qM|Dit7",
                                    "type": "image"
                                },
                                {
                                    "id": 1176435,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/af66f823-5e62-4071-93aa-5b430b7a89f3/width=450/1176435.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UJD]iB?bOQxv.T%h_3nh^G%NK7RO9uj[n3WB",
                                    "type": "image"
                                },
                                {
                                    "id": 1176436,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5deafe66-8070-41c6-964a-cc617a5196d7/width=450/1176436.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UTD]oG-;pdad*0x]?baJ?HxuNGjYI:kBnOf5",
                                    "type": "image"
                                },
                                {
                                    "id": 1176437,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/14008d97-2e80-48b6-a57b-01c8fbd036ae/width=450/1176437.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UPI5JX?H00M|B=T0%3xuTL-;-;S5.Tx]VrI:",
                                    "type": "image"
                                },
                                {
                                    "id": 1176440,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/afba437e-c38b-459e-824c-425a9fb6a25f/width=450/1176440.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UOHB*,-=0zD%Y6%N~qIUV@o#-;s.o~t7Q-s.",
                                    "type": "image"
                                },
                                {
                                    "id": 1176439,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7c6b1041-37cf-4728-992c-6f4be01de7cb/width=450/1176439.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UNHBGH560f~B5=Vr$ijsJBf5-oNHx^aeaKof",
                                    "type": "image"
                                },
                                {
                                    "id": 1176441,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b14d2f91-4843-4abb-8485-f661d8b9f650/width=450/1176441.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGG[E7?c009ZGvtm^R$kTz?b-oEM?w-=MwE1",
                                    "type": "image"
                                },
                                {
                                    "id": 1176443,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e0e8382d-0759-4b96-a846-22b6b63dc9b5/width=450/1176443.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDEex|rV0fE,-n9ujv~BMvsp$eI:FfVXxZIo",
                                    "type": "image"
                                },
                                {
                                    "id": 1176447,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b74c8e28-a2c8-4aba-aa61-40b8aad81b29/width=450/1176447.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UKGuRU~q0#9wD$IUxF$2H?IAt6x]KPtR%1M|",
                                    "type": "image"
                                },
                                {
                                    "id": 1176445,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2804e342-305b-42c9-bf06-bfc60de6ff33/width=450/1176445.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAE{FW007zU]L2H?~DMd4T_N0Lov01f*=wtS",
                                    "type": "image"
                                },
                                {
                                    "id": 1176448,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9b889b28-29a9-4f75-a63b-d9fab089ceb5/width=450/1176448.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIHUUhkV03e@24S5^zxCF$xH-TX5%fs,R6EN",
                                    "type": "image"
                                },
                                {
                                    "id": 1176450,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e39df26-52dc-4a27-a748-abacc357886d/width=450/1176450.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGGkRL-p04NH0g0#xW~A03-U^#EOM^-mxbD,",
                                    "type": "image"
                                },
                                {
                                    "id": 1176451,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/30c903f3-1233-41e5-8b4a-7930b79498b3/width=450/1176451.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UKEfHH-;PBVrystS?bnN~C%NI=t79ttR$%t7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/97794"
                        },
                        {
                            "id": 93108,
                            "name": "Hi Top Fade",
                            "index": 3,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 20,
                            "description": null,
                            "publishedAt": "2023-06-10T15:02:38.645",
                            "availability": "Public",
                            "trainedWords": [
                                "hi_top_fade_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5488,
                                "ratingCount": 145,
                                "rating": 5,
                                "thumbsUpCount": 157,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 64275,
                                    "sizeKB": 147571.3310546875,
                                    "name": "hi_top_fade_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-10T15:01:24.207Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "1D07B041",
                                        "AutoV2": "4756A49FC6",
                                        "SHA256": "4756A49FC63A1CA46AFD82F3A2797DA07467CF7B7C4C8A223259EAE9C9E1B71E",
                                        "CRC32": "BBFEC804",
                                        "BLAKE3": "DA9BB48DEF1BC18319368B5B05239BA4EDA058F453C3B6F5F83A28501FCBF0AE",
                                        "AutoV3": "BB62E3B4FFCD"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/93108",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1097368,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/15989f80-4961-4e3c-82d6-8b802b97ef33/width=450/1097368.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHD0+dbw9sxuuPtS%2RQ-3-;NLNe9z%g$#x]",
                                    "type": "image"
                                },
                                {
                                    "id": 1097365,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e7a9eb29-73b7-4d6d-8c54-bc37bf155222/width=450/1097365.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBD,J]=X4q5rT#$~xu%Nv*9uJ5oz56-;wboz",
                                    "type": "image"
                                },
                                {
                                    "id": 1097370,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/335ad4ee-890c-49ab-afb3-415c8f8a447b/width=450/1097370.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UNF=q5IU1O%2L4sl%2M{9_bbrqbHE2ogs+oz",
                                    "type": "image"
                                },
                                {
                                    "id": 1097362,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8361926f-b641-41ee-8941-51454889baba/width=450/1097362.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UZI5AB?wPB_3TeX8xGxZ9aw]s:IpR+t7t7kC",
                                    "type": "image"
                                },
                                {
                                    "id": 1097363,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7820d8ce-cc74-4ed4-a08b-b207416ea2e9/width=450/1097363.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIEMd-NH5E-VY8%MxvIpD*t8Svay4:Rj$NkC",
                                    "type": "image"
                                },
                                {
                                    "id": 1097364,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/60c7330b-7f27-4f31-8cf9-87cdbf97d975/width=450/1097364.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UVG+XX_NOt-=E+IpadxFM|s9RjM{S$t6r?Ip",
                                    "type": "image"
                                },
                                {
                                    "id": 1097369,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1c5baca6-6a36-4020-8fd1-1dd3df421805/width=450/1097369.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "USF?Fg?vk=?wS4WVIqx]57M{%2V?xZt8s.bc",
                                    "type": "image"
                                },
                                {
                                    "id": 1097373,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a1b5ea33-a547-456f-a00f-d54e813ab71e/width=450/1097373.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UUH2j2i^0KXU.mR-V@tQ%KR.Iu%LK7s+xCR-",
                                    "type": "image"
                                },
                                {
                                    "id": 1097367,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ea71df9c-1dae-4496-a6d2-4fdf39f79a5e/width=450/1097367.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGDc,+,:0cF$GEMv$ltPr9bbD,j?G1Oa$w%N",
                                    "type": "image"
                                },
                                {
                                    "id": 1097366,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/31684674-dd05-474d-9e6e-0c39e48e8797/width=450/1097366.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UQEfmNE1Aw%2u6WB%3R*M|tRRibH9uoew]t7",
                                    "type": "image"
                                },
                                {
                                    "id": 1097371,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/11eaa4d3-fd12-4a33-aa7f-4ba9fbe2172d/width=450/1097371.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UdG+akxt9uR,.Ts:t6f+%MR+NGxaI=ofxZWA",
                                    "type": "image"
                                },
                                {
                                    "id": 1097372,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e6c4c12-6207-4b14-ae00-59964e49d99c/width=450/1097372.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UaJ*3XM}5a-p?wj[W?NIW=Iq$%$zS$WDRkW;",
                                    "type": "image"
                                },
                                {
                                    "id": 1097376,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/154a9451-89b2-452f-bda7-5738394b241c/width=450/1097376.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UVH24i-40OEoK-Rk-TkBESM|xWxZbvaxWCj]",
                                    "type": "image"
                                },
                                {
                                    "id": 1097374,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bee25546-8c3f-4c30-8d0d-8c42c0db6210/width=450/1097374.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9HxmVDi00?w00AI$eVX8_%L~W9Gpy-ox^E,",
                                    "type": "image"
                                },
                                {
                                    "id": 1097377,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eda4dece-264c-48f6-8993-8215a623ea0b/width=450/1097377.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "ULHL;_n$0#bw*0NG_3%2D$xaxuMxOuxZkDNI",
                                    "type": "image"
                                },
                                {
                                    "id": 1097375,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ba099637-90b2-4ebf-985a-bbccca67e9fb/width=450/1097375.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UeIY5~%10g%g*0xu%gj]JDj?xvWBI[RjaKW=",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/93108"
                        },
                        {
                            "id": 87689,
                            "name": "Princess Leia",
                            "index": 4,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 22,
                            "description": "<p>Very easy to use, just prompt the keyword with 1.3 or less weight.</p><p>Model weight adviced: 0.5</p>",
                            "publishedAt": "2023-06-02T13:58:51.695",
                            "availability": "Public",
                            "trainedWords": [
                                "side_buns_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5200,
                                "ratingCount": 601,
                                "rating": 5,
                                "thumbsUpCount": 608,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 60074,
                                    "sizeKB": 147571.599609375,
                                    "name": "side_buns_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-02T14:01:22.820Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "768B5E38",
                                        "AutoV2": "C910A3CDD4",
                                        "SHA256": "C910A3CDD4B1FBCC0B3D1EF6098CD9A082A0428DA93FE8EBB310673442B61D86",
                                        "CRC32": "1B998607",
                                        "BLAKE3": "8017F865700361F96E0746AD8DE2213D556D1FA8E07DED9E19042C789D86CB4F",
                                        "AutoV3": "C0DC3C196123"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/87689",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1005376,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c3ec3d77-f6db-4a1b-bba7-e57adee58ee0/width=450/1005376.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEJ7].VC00Oa7$4.?b%L9ws-^+M{~qR.I9oJ",
                                    "type": "image"
                                },
                                {
                                    "id": 1005380,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/26eee03f-abb4-458d-866d-6aa39603acfe/width=450/1005380.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGI50$~p004o0:S%?v?F0$o#^*ofx^xuxCWB",
                                    "type": "image"
                                },
                                {
                                    "id": 1005370,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/45064357-1474-4546-9754-d759c3c23897/width=450/1005370.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBDc2YDh}?^*0:e.0%9Z={t8t6%1IpogRjWC",
                                    "type": "image"
                                },
                                {
                                    "id": 1005375,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/205dd279-504c-4d45-b616-23776b6953c1/width=450/1005375.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCHeRh-O000f0L9u%g^+01xF~Vf*Axt6rWWD",
                                    "type": "image"
                                },
                                {
                                    "id": 1005372,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/17606620-a3e4-47fd-8117-97382ba6fb4c/width=450/1005372.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9E3C.BqCT-5Em.801E100M{Rj$%0znM?HT0",
                                    "type": "image"
                                },
                                {
                                    "id": 1005386,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a1b49930-87b6-4f42-9c18-23b021316e59/width=450/1005386.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9Db~L000e~p1QD$%LNd^jr;9vWB0Nsm={t8",
                                    "type": "image"
                                },
                                {
                                    "id": 1005371,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8b25623a-6ddc-4d99-a4ab-09e82f865c41/width=450/1005371.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UMF=N~E1I=%2lCjEEmWX5Ys:-:Ipo~M|-oxa",
                                    "type": "image"
                                },
                                {
                                    "id": 1005368,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/39b169df-3ae7-405f-bb7b-5672ea9a7ebe/width=450/1005368.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFEyGN4.YRI=I]%ME2NG4n?HVrWUEkIp-o%1",
                                    "type": "image"
                                },
                                {
                                    "id": 1005369,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/96d37752-67c1-4549-8088-873234e41435/width=450/1005369.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHF}m8SM0~v~GwofxHs,10xa$*M{o#NG%1s:",
                                    "type": "image"
                                },
                                {
                                    "id": 1005377,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1f70908c-8bef-41d6-8468-4353526288cc/width=450/1005377.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UII46P},5,t7P;v|xHIpESEL^*wy%hrsIokp",
                                    "type": "image"
                                },
                                {
                                    "id": 1005381,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e998ea9-29d5-4439-ab4b-ffeb82a28d85/width=450/1005381.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBGHuaZ}0nIV14NH-q%2EKkDMd%24=E0~VSh",
                                    "type": "image"
                                },
                                {
                                    "id": 1005383,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e8d9f74d-e962-4d65-8b6b-92307a78c7eb/width=450/1005383.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9Fhkx.AD$MHBs~XRj00w5R:01${01Rj$%t6",
                                    "type": "image"
                                },
                                {
                                    "id": 1005387,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/345a77ee-cb97-4459-b9f1-dbfc9d53da6d/width=450/1005387.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHHUa[E40i~V0gxYMxWB01NG?Gs9kqR*rqEN",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/87689"
                        },
                        {
                            "id": 93763,
                            "name": "Afro",
                            "index": 5,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 22,
                            "description": "<p>Very simple to use, just use the keyword, you will probably generate a black woman since training images are of black women </p>",
                            "publishedAt": "2023-06-11T12:17:15.123",
                            "availability": "Public",
                            "trainedWords": [
                                "afro_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3808,
                                "ratingCount": 294,
                                "rating": 5,
                                "thumbsUpCount": 299,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 64809,
                                    "sizeKB": 147571.162109375,
                                    "name": "afro_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-11T12:16:28.229Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "C1AC7DE7",
                                        "AutoV2": "8D76371C4E",
                                        "SHA256": "8D76371C4EA463406815531E51A36FDBC74741C79E10810697610A5238BBB0FC",
                                        "CRC32": "56081A50",
                                        "BLAKE3": "A538C798CC0320FB6249AC0BFDF83D972C0C73FD593CFA56428B8D878FE7EBD5",
                                        "AutoV3": "BE173FF3DA5C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/93763",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1108555,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1cf7f155-1a69-4c4b-b0cf-2a4861f19323/width=450/1108555.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U7EVH900wgE0IB9ul9MeqZ~pv{-=0ft7#Sx]",
                                    "type": "image"
                                },
                                {
                                    "id": 1108547,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/634bc4c9-62c4-4e5f-9a6f-6751e79cef7d/width=450/1108547.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAG81RDiP;Vt0,57$RM{4.~Wm+-;4:W=RPWB",
                                    "type": "image"
                                },
                                {
                                    "id": 1108546,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cf45b3f8-3be4-4c0f-98d1-51be6dfaea41/width=450/1108546.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UMF}pK-UGbtSPXNGoht8AckC-UNdE2WXskni",
                                    "type": "image"
                                },
                                {
                                    "id": 1108548,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/665ddd6f-5000-40f9-b38a-6a8b88244e45/width=450/1108548.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCH^q;,+0pSi?[InMz-:-gxHv|T0s;R+RjIp",
                                    "type": "image"
                                },
                                {
                                    "id": 1108544,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c275e66a-58da-4445-9772-420fa4fd13d0/width=450/1108544.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UWF=?.M{Tdr;Y8aeo~RPNIozR.k9E4j[wHog",
                                    "type": "image"
                                },
                                {
                                    "id": 1108545,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a6e9853f-155a-4e3f-ba7e-d6bf68d2d9b6/width=450/1108545.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UACi,uISGET37jIUXrr;%Ke--=V?0O%1#%NI",
                                    "type": "image"
                                },
                                {
                                    "id": 1108550,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f282888b-9e00-4dad-a53d-cbdc22382de2/width=450/1108550.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAD]6[HqP19e0eE2S-i[00_4iu?H0NNHw?XA",
                                    "type": "image"
                                },
                                {
                                    "id": 1108549,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1fd66af7-594b-4c94-9913-aaf030a54c4a/width=450/1108549.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UPFF:AM{p1r;T#WVbcROtAj[buaf9vRjaJkW",
                                    "type": "image"
                                },
                                {
                                    "id": 1108551,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b1b68339-321f-4ff2-9ade-1996b7fd220e/width=450/1108551.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEDl_~V?5akVG1Ri%Nxa,wt5THIq0exa$2oz",
                                    "type": "image"
                                },
                                {
                                    "id": 1108552,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8bb330cf-26ab-4eed-b291-132e500e76dd/width=450/1108552.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UNF~U3NH0M-o?wxuIoRj?boeWARkOrWBn4oz",
                                    "type": "image"
                                },
                                {
                                    "id": 1108553,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d13d159f-055b-40c4-b81c-86ca4f382b71/width=450/1108553.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UMF5:VkC0*%2*0xvRkRj?Ht7M_R*T0V@emWV",
                                    "type": "image"
                                },
                                {
                                    "id": 1108554,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2b0aafe8-2498-42f4-bff8-31f6dd041044/width=450/1108554.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEGI1S~B000$02EQ%i$~01s:?axtJ9V?Mws.",
                                    "type": "image"
                                },
                                {
                                    "id": 1108556,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/abf73718-876c-4403-9a68-d890ad375f33/width=450/1108556.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UJG[Wvbw02xu0Qxv_4xu58R+%0IVNHWBMdWV",
                                    "type": "image"
                                },
                                {
                                    "id": 1108557,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/87ca1a92-028a-4c0b-be4e-9d007a87feaf/width=450/1108557.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHG[pIMw00%gPXWT%3iwO[t7%29Y?caJR5kX",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/93763"
                        },
                        {
                            "id": 87048,
                            "name": "Long Braid",
                            "index": 6,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>I'm quite happy about this model, gives good results in most cases. </p><p>It has been trained mostly on indian women but it seem capable to generate anything.</p><p>It works very good with inside_church and wedding dresses models, not because they are necessary but they give a little of environment to this kind of hairstyle.</p>",
                            "publishedAt": "2023-06-01T14:46:31.1",
                            "availability": "Public",
                            "trainedWords": [
                                "long_braid_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 6127,
                                "ratingCount": 134,
                                "rating": 5,
                                "thumbsUpCount": 140,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 59564,
                                    "sizeKB": 147571.658203125,
                                    "name": "long_braid_hairstyle-10.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-01T14:46:19.135Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "200E149B",
                                        "AutoV2": "34E85D7B48",
                                        "SHA256": "34E85D7B484915A36E7E698BFC3E3A8F8961738168F61E84C84FCBCD11DE0FB9",
                                        "CRC32": "062DF03A",
                                        "BLAKE3": "68C6DE9C8F596E534B2C5F5F18A3B9924B9145967547C7F10E1F5377B2BD1479",
                                        "AutoV3": "362841CF3CF4"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/87048",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 993912,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cf607027-8a45-4c10-947a-0dcdd948ab97/width=450/993912.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBJZ;,WF00VXE2b_~AIA12f*4ox]0g%2Vs4:",
                                    "type": "image"
                                },
                                {
                                    "id": 993909,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/13895025-824b-4549-aad9-08840e7e9559/width=450/993909.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIKANKD%0L%MMxbc~WD%J7xtM{Rk9ZozV@af",
                                    "type": "image"
                                },
                                {
                                    "id": 993911,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b17b64aa-d201-4c68-8568-734f5125c4ca/width=450/993911.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UKIz*Q={00~V00-o~pnh%LxFs8NGM|xZofbc",
                                    "type": "image"
                                },
                                {
                                    "id": 993910,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7b2df79c-b84a-4095-bcc4-9c93dbed28f0/width=450/993910.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U7H-Sw]h00yD00~V?uD%~V4:?G%202kWRQo}",
                                    "type": "image"
                                },
                                {
                                    "id": 993907,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b8fd2d55-adc7-41f2-98f9-9fe41d50303d/width=450/993907.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UQKKG~~q01%fE+.8?uIoXn-;-padE2a}e.n%",
                                    "type": "image"
                                },
                                {
                                    "id": 993908,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/82161c64-f79f-4631-a2dc-d81215c89c86/width=450/993908.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCJs|K-?00E0009Z_29G0*t6ks_N0LxtE2D%",
                                    "type": "image"
                                },
                                {
                                    "id": 993915,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/75252ab0-c0d6-4521-84eb-a0192f92da8b/width=450/993915.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFKchGo}00-P00Iq~pV@69-:rqD*02R*IqS#",
                                    "type": "image"
                                },
                                {
                                    "id": 993918,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6327ee95-5e5e-4aa8-ab95-5b13f613ef69/width=450/993918.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDJs^B$+005P00tS^%IUPqNGI9^j0jt8D%M{",
                                    "type": "image"
                                },
                                {
                                    "id": 993913,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3398641f-3bcd-49e4-8be2-d5c0c74d97fa/width=450/993913.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEIzVIxa00,.9EIU~WxbE19w-:9atQof%1IV",
                                    "type": "image"
                                },
                                {
                                    "id": 993916,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e14b42ea-013c-440e-80e4-5871cc105a47/width=450/993916.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBHm7MX83k}?2@-AU|Oq${9]=xMy9a%1NxE2",
                                    "type": "image"
                                },
                                {
                                    "id": 993917,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d43a7561-72f8-45cf-a200-04760d3cb7a8/width=450/993917.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U8J%OIv#00.8000M^*M{rC-:~U-VIn0f-oIU",
                                    "type": "image"
                                },
                                {
                                    "id": 993919,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/96eb0768-a2a6-4cf0-957c-4df9df060fa5/width=450/993919.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UOJ?Z,^jAa~AO?-nr?NbM|NGs,V@E1xaNHax",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/87048"
                        },
                        {
                            "id": 86255,
                            "name": "Space Buns",
                            "index": 7,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 23,
                            "description": "<p>Works also with anime.</p>",
                            "publishedAt": "2023-05-31T12:59:25.15",
                            "availability": "Public",
                            "trainedWords": [
                                "space_buns_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5684,
                                "ratingCount": 132,
                                "rating": 5,
                                "thumbsUpCount": 142,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 58940,
                                    "sizeKB": 147571.212890625,
                                    "name": "space_buns_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-31T13:00:42.045Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "1A1869F8",
                                        "AutoV2": "99B54C80D5",
                                        "SHA256": "99B54C80D547CBAD4D718B274BC51F78B8A0F9F94E09FB2645A448F9D47F38E4",
                                        "CRC32": "C9A8768F",
                                        "BLAKE3": "3FA4EE542CEBEC09F4828DD631F57AB483EF1312BEB13BF3EC144DB7B564E22D",
                                        "AutoV3": "C25E2A462603"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/86255",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 980899,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/264d9558-b0d9-4e7f-afaf-766975a2cdca/width=450/980899.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UfI4-Ls70+RjL4oI%0V?J;kDxVV@jXS4j]j@",
                                    "type": "image"
                                },
                                {
                                    "id": 980891,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/18dd8b89-4e89-48f7-b2a4-24ae470e5592/width=450/980891.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDFhL[Ip0K^*9tofozIo00I:-oRk~BWBVsoz",
                                    "type": "image"
                                },
                                {
                                    "id": 980895,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3b324139-7618-47c3-b911-720f433de7a6/width=450/980895.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UUIg.YMx~Vt7r?W;9axa%LNGozRjo}xGt7oL",
                                    "type": "image"
                                },
                                {
                                    "id": 980898,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d18713f0-9e39-4b5b-823c-e1ad1fb3a34a/width=450/980898.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U6H1Y-9w00.R00NG?v~V00tk=v00vzNG^PMy",
                                    "type": "image"
                                },
                                {
                                    "id": 980885,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cdd04961-00ec-4b6b-8f7e-04cf4d4a92c6/width=450/980885.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9H1=AIX00?t02tQVZV{01oen5RQ}?E1~V-o",
                                    "type": "image"
                                },
                                {
                                    "id": 980894,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f9a29083-2ce7-4bed-9f26-dd1d88bb0ca2/width=450/980894.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "URIg$J-o~V%1ivX89Zxts.aexuIpEgV@xGWB",
                                    "type": "image"
                                },
                                {
                                    "id": 980886,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6c8771e6-08ce-4345-9bb6-8f8640a57b7f/width=450/980886.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U6Jtl00000?b4TIU%%0L01Io%OD*KQIqa0-n",
                                    "type": "image"
                                },
                                {
                                    "id": 980896,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0d63e1cf-152d-49de-9f86-b7d108854e00/width=450/980896.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHH1um9F0i-T24M{={M{Iv$*-pRko~bwRjtR",
                                    "type": "image"
                                },
                                {
                                    "id": 980897,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4f79d9a8-fc95-481d-a681-5224cc7c4e40/width=450/980897.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UdKmqa%M~V-p%K%LNGR*%1s:t7RjE1WBWBf6",
                                    "type": "image"
                                },
                                {
                                    "id": 980887,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9eee187d-0e2d-483f-bf5f-15ecdead62b5/width=450/980887.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBHL3u00_N00%#02-;V]0LM{ELM{4-xZ^*NG",
                                    "type": "image"
                                },
                                {
                                    "id": 980901,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/37ea5f3b-012d-4bae-9349-c01e7e261cc1/width=450/980901.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UZK0]Jsl9txZAJof%1R+?wt6RjR*yEofX8s:",
                                    "type": "image"
                                },
                                {
                                    "id": 980900,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dbbc7bb5-bf57-46a9-9db0-dc6ea3a208bf/width=450/980900.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UOG[NQ~V~V-pyEM{E1NGJCE1M{R*F2xaR*oL",
                                    "type": "image"
                                },
                                {
                                    "id": 980890,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/788c791b-6af7-48ef-bca1-0eb0b584af17/width=450/980890.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBJaZj9b00~W00V?9aae0$xunOIoITW-rqof",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/86255"
                        },
                        {
                            "id": 85517,
                            "name": "Knotless Braid",
                            "index": 8,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 22,
                            "description": "<p>This model has a big bias on generating black girls since it has been trained on black women images (most of the people using this haircut is black) </p><p>My advice is to use it with 0.3-0.5 weight on the model and some weight on the keyword.</p><p>While using a character model to generate you might see a transofrmation of that character in a black one or almost black, if that's not what you want try to lower the weight of the model but you risk to lose the haircut.</p>",
                            "publishedAt": "2023-05-30T13:41:22.858",
                            "availability": "Public",
                            "trainedWords": [
                                "knotless_braid_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4143,
                                "ratingCount": 131,
                                "rating": 4.99,
                                "thumbsUpCount": 137,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 58405,
                                    "sizeKB": 147571.1484375,
                                    "name": "knotless_braid_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-30T13:40:55.766Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "3DB54543",
                                        "AutoV2": "23B535D96F",
                                        "SHA256": "23B535D96F3911066A0E16C64D6577E3E52E7181B4B9E23378750F0E019950BC",
                                        "CRC32": "F4E4A8DF",
                                        "BLAKE3": "41718E22FF63FA46A9F6F6402F740CA20A75DF07208B32BD961BE9028D601E2C",
                                        "AutoV3": "E6BB59EDF614"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/85517",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 968572,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04393b5d-7a31-423d-80c6-862f129c0164/width=450/968572.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAJ@8ux]00Vs00E1_N-:9}?H$x%1j=$e9a~A",
                                    "type": "image"
                                },
                                {
                                    "id": 968569,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/acf9e606-cc1f-4877-9baf-f5b8647befcf/width=450/968569.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UUIzbd-;X.~BEk%LofkDI:oejZs:flRj-oM|",
                                    "type": "image"
                                },
                                {
                                    "id": 968561,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dd3f9d10-5ae7-460f-83f6-1e5bb2ad9e71/width=450/968561.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDHU5+570z={?bWX-;jFxG$%E39a4:9a~BsA",
                                    "type": "image"
                                },
                                {
                                    "id": 968562,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80652180-3911-4e26-9e5b-eb4fc03372c4/width=450/968562.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U8HdBJ0M0z=|7IIW9H9v9Z-U~V564:NH~BD*",
                                    "type": "image"
                                },
                                {
                                    "id": 968566,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/12222470-01d2-4603-aa03-d555fe27bf32/width=450/968566.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U7Gt$x5r0MKQ_2XAx]^+00s+S20L009Z~AMx",
                                    "type": "image"
                                },
                                {
                                    "id": 968563,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f1273de7-246b-4d48-b62e-3417ddc0e9df/width=450/968563.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDG@xu~B0L?H?a-o-o^*0L-:%L9aE1offRM|",
                                    "type": "image"
                                },
                                {
                                    "id": 968564,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/519e841a-f204-4e80-99dc-d4f94cdbc03c/width=450/968564.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHJ%OO9G00~C9ZRQ?GM|0LWDtRenNxRk%MxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 968565,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e545e48b-5aa4-49e6-b801-d7d2cee6de2c/width=450/968565.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAJGl}~A00^%0f5R$%%MDi%M?a9ZDiI;tR4:",
                                    "type": "image"
                                },
                                {
                                    "id": 968567,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5710aca4-17d8-4eee-9d18-9e2409d75166/width=450/968567.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U8IgT5%2000fyB4o^j_201E24;D*00bw~VIC",
                                    "type": "image"
                                },
                                {
                                    "id": 968568,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/76741150-78db-40fe-a473-9541b8f3d916/width=450/968568.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UNIW+SIByC^P~U9aW=IpWUofs:xa9uae%1Ip",
                                    "type": "image"
                                },
                                {
                                    "id": 968570,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/47f44664-0b34-49eb-b11f-27702ac1ea4f/width=450/968570.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UPK9}TtS~AWXS~j]E3sp0MNH9uxZOEt6-oWB",
                                    "type": "image"
                                },
                                {
                                    "id": 968571,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3418414b-31db-4ffe-853d-4190304dd7b3/width=450/968571.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U8I3]$0:0g?adA.9^+9v0zJB%29b000f~Ar?",
                                    "type": "image"
                                },
                                {
                                    "id": 968574,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/41260de1-1dc2-4158-a792-571fc4bec4f5/width=450/968574.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UKIDHz570z}@puRknSgME2Ip%LIpxGNG%1rs",
                                    "type": "image"
                                },
                                {
                                    "id": 968573,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fe9ef1f7-362a-436f-8f2b-456d7c9e13af/width=450/968573.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U8KTVtt-00#k00DN~p^*9Z%h.801AI0fwHVs",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/85517"
                        },
                        {
                            "id": 83658,
                            "name": "Bridal",
                            "index": 9,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>This hairstyle model doesn't always work in frontal view, you need a lucky seed. </p><p>But gives good result for side and back view. Because of the training images, mostly from side and back cause of the hairstyle type.</p><p>For frontal view you might want to raise the weight of model/keyword but you might get artifacts at some point. For side view you might wont to lower it.</p><p>Works also with anime, look at examples.</p>",
                            "publishedAt": "2023-05-28T12:24:57.933",
                            "availability": "Public",
                            "trainedWords": [
                                "bridal_hairstyle",
                                "back view",
                                "side view"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 6770,
                                "ratingCount": 169,
                                "rating": 5,
                                "thumbsUpCount": 175,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 57196,
                                    "sizeKB": 147571.6572265625,
                                    "name": "bridal_hairstyle-10.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-28T12:26:39.844Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "A8B88FA5",
                                        "AutoV2": "42CE589444",
                                        "SHA256": "42CE589444CABC72A8E8CCA274C25A298819439EE960B8AEB2E4E23CDD0B24C0",
                                        "CRC32": "D610AFBC",
                                        "BLAKE3": "CB609D64F5DE1C61C34155D1F5EDABD779D5F93727456C718BDA7452BA513E3D",
                                        "AutoV3": "408F7D0492FC"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/83658",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 943855,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/295a1160-0ae9-4e29-bc8b-c6b282f67f85/width=450/943855.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBJaApE10z?G02?a~p%1T}xX#,-o9cD*s9E2",
                                    "type": "image"
                                },
                                {
                                    "id": 943851,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/79ee5973-b770-4634-831c-d14bb2611b5f/width=450/943851.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEMi=,IB00NF00^+NF-;.T={^OtQogXm=_Di",
                                    "type": "image"
                                },
                                {
                                    "id": 943852,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/91c4854a-bbba-4d70-8338-e112c1bc78d8/width=450/943852.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFKmkM-:0f0L03nh.8tQ*0xu#l?F%gaKt8R*",
                                    "type": "image"
                                },
                                {
                                    "id": 943845,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/86020924-cfee-40a1-833a-fe55a806ce07/width=450/943845.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDKv:EIA00x]00~V_3n3X-?Gwa-;%0^*j]Sf",
                                    "type": "image"
                                },
                                {
                                    "id": 943849,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/60a1c889-161c-47f6-9fef-b105a7b76883/width=450/943849.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UMKJ}Y_N579u0eo}?vo~.9ENxF%LVYxaogof",
                                    "type": "image"
                                },
                                {
                                    "id": 943847,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c18f99a7-5872-4778-b1bc-f09caafd0eff/width=450/943847.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHL3rx?w0LDhTex^~WM|yD?a-oD*?bNeV@$%",
                                    "type": "image"
                                },
                                {
                                    "id": 943846,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0b10dfce-2633-48c6-9f3f-ba71467cd7f2/width=450/943846.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "USJG+lM{0K~B9Zxt-:NHIo%1t6Ip?axar=R*",
                                    "type": "image"
                                },
                                {
                                    "id": 943850,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/92d4435a-ec96-4f8c-bb68-e9db700d9a26/width=450/943850.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEJjrK%N000LE04:Sjog0LxZIVxu~V-qxuM{",
                                    "type": "image"
                                },
                                {
                                    "id": 943848,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0012202b-5f8e-4c7a-a1fc-9f4a3dbf3ba2/width=450/943848.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCKK1k~q00wd000LS6=|58?H%2-;00xa4:9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 943853,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ca6e620a-c3d3-4fc8-a57e-6e16a7e5f708/width=450/943853.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGLpaJ~V00r?4,jENLof0L%1RPR%xtWVkDi^",
                                    "type": "image"
                                },
                                {
                                    "id": 943854,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f5c326a4-2120-4f8e-9756-62e8c5fa06f6/width=450/943854.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHIER#?ak?IVAeNI9^oe%%%1?bX859Rj-A-U",
                                    "type": "image"
                                },
                                {
                                    "id": 943856,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fdfaabbe-3d2c-47eb-b562-7b15a85a7b77/width=450/943856.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 512,
                                    "hash": "UFL47^%g4.~p00E2M_IV0~%1n4IVOtxY?GR*",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/83658"
                        },
                        {
                            "id": 98713,
                            "name": "Baldie",
                            "index": 10,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>Since someone requested an hairstyles for men, i decided to pubblish an hairstyle that would work great for both male and females. </p>",
                            "publishedAt": "2023-06-18T12:59:02.09",
                            "availability": "Public",
                            "trainedWords": [
                                "baldie_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3323,
                                "ratingCount": 526,
                                "rating": 5,
                                "thumbsUpCount": 541,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 68780,
                                    "sizeKB": 147570.859375,
                                    "name": "baldie_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-18T13:01:19.272Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "5CFC9B0D",
                                        "AutoV2": "4055C4224D",
                                        "SHA256": "4055C4224D49CFF23C8574C338F9396BE5B1FF3DDFBB2787C718973296E4DD7A",
                                        "CRC32": "3B830CD2",
                                        "BLAKE3": "783638514B748E37F37148EBB6200E4C4317BF3267BF2A3D84D7A256C7D7A8F0",
                                        "AutoV3": "76E023057984"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/98713",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1193246,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/795f422c-0b12-4089-9449-2e7cb2f333e0/width=450/1193246.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHFP1.-V000K?uW=9ZM{KQx]VY%2~q-pDiRk",
                                    "type": "image"
                                },
                                {
                                    "id": 1193250,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6dfd41d0-3214-4710-a5db-38985fdacbe4/width=450/1193250.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDE2th?v00$%I.g4kroz9v%M~Cxu^iNaEj-;",
                                    "type": "image"
                                },
                                {
                                    "id": 1193242,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/58a7e96e-6635-4d55-ace4-db14f0115808/width=450/1193242.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHEoV?9a00~VEKRPI;NGH=jYJXxFNexv-o%L",
                                    "type": "image"
                                },
                                {
                                    "id": 1193239,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/da3060dd-d6f3-4e5d-9af2-b3153c42a8ad/width=450/1193239.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U69aaOpe00?HY+aJ0%Rj;KM{9Y$erBROu6tm",
                                    "type": "image"
                                },
                                {
                                    "id": 1193238,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2b05f27d-bcd1-46ea-b56a-5330d873f5cb/width=450/1193238.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBH,3bDi0z~V3os9MKxt0fOr-B+vVZV[I:KO",
                                    "type": "image"
                                },
                                {
                                    "id": 1193249,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/adcd7151-b2f9-45c4-87f2-5a58fd6ee562/width=450/1193249.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBA^RZ~q4,obMbIo9~R+tRn$VrNG#6WBJWs:",
                                    "type": "image"
                                },
                                {
                                    "id": 1193236,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0475d9a0-1de6-4f31-80bd-9e783fc37ed0/width=450/1193236.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGIOFMD%00?a4Txu?^RO01M{?H-pIqRjMx?G",
                                    "type": "image"
                                },
                                {
                                    "id": 1193241,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/daca0223-5400-4f86-9d2d-6651573efd1d/width=450/1193241.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U6C7g2nh9?.8+?xu0MRP0hWX00NG^fM|~qWV",
                                    "type": "image"
                                },
                                {
                                    "id": 1193240,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9859c715-4801-45cf-9e0c-86de6340bd54/width=450/1193240.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEJQ=y-U00$%00EgT}xuMxIU~A^k4;IVNc-p",
                                    "type": "image"
                                },
                                {
                                    "id": 1193245,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9fb3428f-4737-48c2-9fca-9ab7ede5d88c/width=450/1193245.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U68z}u~q0JAHqG%2GH9t-qMc4T0eQljbOZIU",
                                    "type": "image"
                                },
                                {
                                    "id": 1193237,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/56492d37-90a5-43ea-a8c4-8670e4047b84/width=450/1193237.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEIgig9H00~V03%1ExM}01EM?G%1-oWBE1s:",
                                    "type": "image"
                                },
                                {
                                    "id": 1193243,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/95b57f0a-9b8f-44aa-a136-252b9e10a6f7/width=450/1193243.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U79*1700O:JB9Y%00$xCWFNeVX-V}?V[JWW.",
                                    "type": "image"
                                },
                                {
                                    "id": 1193244,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b2ca86d6-8c6b-455b-b1a1-748a0ef9b401/width=450/1193244.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UMHxvn~q00008wM{%gbc0fbHxuWXNHt7i^Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 1193247,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f0170536-929c-472a-b8c8-4436fc69161f/width=450/1193247.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEG*pD~V009t59NGxWIp01oLtPE1R%t7%3xa",
                                    "type": "image"
                                },
                                {
                                    "id": 1193248,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/77a9423c-84a1-42ff-83d5-70d1f9878168/width=450/1193248.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHHURh~V00a~R60e01xax]Rj-U-o%M%2afNG",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/98713"
                        },
                        {
                            "id": 82605,
                            "name": "Short Pigtail",
                            "index": 11,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 6,
                            "description": "<p>Very simple to use, just use the keyword, works with very low weights.maybe with 1.3 weight on the keyword and 0.5 on the model.</p><p>I uploaded epoch 5 out of 10 because epoch 10 was overfitted for realistic images, but epoch 10 seems to work better for anime, come in my patreon to see and download all epochs <a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/betterCuteAsians\">https://www.patreon.com/betterCuteAsians</a></p>",
                            "publishedAt": "2023-05-27T09:57:05.002",
                            "availability": "Public",
                            "trainedWords": [
                                "short_pigtail_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5826,
                                "ratingCount": 236,
                                "rating": 5,
                                "thumbsUpCount": 244,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 56543,
                                    "sizeKB": 147570.8427734375,
                                    "name": "short_pigtail_hairstyle05.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-27T09:56:39.015Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "267B032A",
                                        "AutoV2": "A54F0A5397",
                                        "SHA256": "A54F0A53975623106372FBA044F831D8075A33B11A9100A2AB43D9447BA9BF1C",
                                        "CRC32": "83DEC7A6",
                                        "BLAKE3": "BC726DC89D1044F69C3E0AD60F33644614DA090563EE6CEF4959BDDAC267F783",
                                        "AutoV3": "1C3E76705D6E"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/82605",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 929789,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/459e507a-bb3a-414f-bf2c-19993c26692c/width=450/929789.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAFh*G~V00^+yB~V~VN@01IoOrRj00D%=yV@",
                                    "type": "image"
                                },
                                {
                                    "id": 929786,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/787391d6-513f-46dc-ac97-ae4c10853d1d/width=450/929786.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UXI4*ExuEM.8_Nt7NH%gO[a#M{x]%MWCoJxu",
                                    "type": "image"
                                },
                                {
                                    "id": 929781,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/956c6eb1-2550-44cd-b138-0fe74f57aec0/width=450/929781.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UWIg=nE2KktR?^R+xvt7%gWD%2kCo~Rj?Ha}",
                                    "type": "image"
                                },
                                {
                                    "id": 929782,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f91ff57d-3164-4aad-8930-af39f7e370a5/width=450/929782.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFH1f6xa4.IoInxa9aNG00R*V[Na~BkB?HoL",
                                    "type": "image"
                                },
                                {
                                    "id": 929783,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4a709824-c93e-4d9e-a559-37cfe7092590/width=450/929783.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UOF=aanMAvo#.TRix]t7E3t6bcs:0foy%1oL",
                                    "type": "image"
                                },
                                {
                                    "id": 929784,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e51f1070-131a-4fa4-9898-80fc777241f8/width=450/929784.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDFE}|?FK8NfO@I@9]t601s;RjNG4;In}[%M",
                                    "type": "image"
                                },
                                {
                                    "id": 929780,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ccfdf578-63af-41b3-a0bd-79fa37cd4130/width=450/929780.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UOI;n+~V?v?G?b-:%MM|VskCM{M|9aNG%1xG",
                                    "type": "image"
                                },
                                {
                                    "id": 929787,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/83594fbe-9d74-40a0-8f18-a880cae0243f/width=450/929787.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCF5T~9Y9sEj${%20gs,0g?G~BR*OsE1-UV[",
                                    "type": "image"
                                },
                                {
                                    "id": 929785,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ba6a34ff-610c-4c78-b1af-80bcfd04afa4/width=450/929785.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U7FYS@-V00k=GvxG~WS~00NG56IU00RP=aad",
                                    "type": "image"
                                },
                                {
                                    "id": 929788,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/75c1efbf-6832-42a3-b594-d12e52919084/width=450/929788.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9JZuM0103$*0M0M%Jae0NIp~9NHDk^%={NI",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/82605"
                        },
                        {
                            "id": 84609,
                            "name": "Updo",
                            "index": 12,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>Very easy to use and works also with anime.</p>",
                            "publishedAt": "2023-05-29T13:04:47.034",
                            "availability": "Public",
                            "trainedWords": [
                                "updo_hairstyle",
                                "back_view",
                                "side_view"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 7554,
                                "ratingCount": 229,
                                "rating": 5,
                                "thumbsUpCount": 238,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 57795,
                                    "sizeKB": 147571.1943359375,
                                    "name": "updo_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-29T13:05:33.223Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "C22617FF",
                                        "AutoV2": "A3C94D3846",
                                        "SHA256": "A3C94D384676BCBC5B678ED06D7E537A7D107E5BF29CADFA69CAA0E3E2C9F170",
                                        "CRC32": "1749F348",
                                        "BLAKE3": "280941F144A1FBA8849227D00BFCE912109FB13BBC278B6C81754D493672AF80",
                                        "AutoV3": "A24121398124"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/84609",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 955983,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d6649fc7-ff99-4dfd-b36e-2d26eb91e65d/width=450/955983.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UhJR8U-;Sh%M_N%Mf,x]XTofRjWVNajs$*sn",
                                    "type": "image"
                                },
                                {
                                    "id": 955991,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/85a81318-f19c-48ea-8e7d-076ec164097c/width=450/955991.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9H-3_%201I:6QsA4o9a00ju4:NH}@%2?bxa",
                                    "type": "image"
                                },
                                {
                                    "id": 955984,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f61f26de-a407-4467-aaf1-710419b62a14/width=450/955984.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UKJje$?v0f-;0e-:~WEN9ZRP$fjF^%n~aKWU",
                                    "type": "image"
                                },
                                {
                                    "id": 955982,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7e1ae845-df29-403c-b4a5-cc8ac6d3b2d3/width=450/955982.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UJNT5h-:*J9FyrtR~paK57oer?NG~VoJnPM{",
                                    "type": "image"
                                },
                                {
                                    "id": 955986,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3d71ae98-6f66-404c-abd1-3f14c9fb9d8f/width=450/955986.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9Kd9[~A~o00~TTK?c^O00s,-UNI^*-U=x01",
                                    "type": "image"
                                },
                                {
                                    "id": 955985,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ff2fd4e6-ec11-4f5f-ba39-319006cd3fa5/width=450/955985.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U8HU2x00EM56^*^*02R+00_3}rD%4:JU=w%1",
                                    "type": "image"
                                },
                                {
                                    "id": 955989,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d28a046a-ab78-4a55-a9f2-13336ea22eaf/width=450/955989.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFJH5SE200?b.ms:n3kr5SNb4:kD01jY^j-o",
                                    "type": "image"
                                },
                                {
                                    "id": 955988,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b8c9ca0f-7dae-4663-be09-9c2302e1b845/width=450/955988.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UNKJ-^-pS~nh%gxt?GM{kW-:sm56~VofIV=|",
                                    "type": "image"
                                },
                                {
                                    "id": 955987,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c535d705-32c9-4f73-9927-71ed44350396/width=450/955987.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHIEFR?b0#NG5lIp-;xu01%2~BE2=_R*4o$%",
                                    "type": "image"
                                },
                                {
                                    "id": 955990,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7fdda454-7be5-4f1e-a020-b7b081a0e81e/width=450/955990.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIKA4p%1EM%2~UxaNHt7~Bt6-oxa=|Rj-pof",
                                    "type": "image"
                                },
                                {
                                    "id": 955992,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8cdba1f3-eb8b-4371-a7f6-66663266b01c/width=450/955992.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "ULJQl@4:0eofIoNG~VD%E1oeozM{^*oMRj%M",
                                    "type": "image"
                                },
                                {
                                    "id": 955993,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b6cc2515-871b-4e16-b6a8-d0d4bc890295/width=450/955993.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UXI;YMxYRiRPbXxaxtbI4.xt?HkC~VxuRjt6",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/84609"
                        },
                        {
                            "id": 81751,
                            "name": "Pixie",
                            "index": 13,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 6,
                            "description": "<p>Very simple to use, just use the keyword, i used 1.3 on the keyword in my posted images.</p><p>It doesn't always work, many times it generate long hair while pixie hairstyle is a short haircut. If that's the case try with higher weight on model/keyword or just hope for a lucky seed.</p><p>I used some of my controlnet poses packs that you can find in my page to generate many of the images posted.</p><p>Works also with anime.</p>",
                            "publishedAt": "2023-05-26T11:49:20.706",
                            "availability": "Public",
                            "trainedWords": [
                                "pixie_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 6354,
                                "ratingCount": 7,
                                "rating": 4.86,
                                "thumbsUpCount": 17,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55982,
                                    "sizeKB": 147572.666015625,
                                    "name": "pixie_hairstyle-05.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T11:51:30.672Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "BD8B8A62",
                                        "AutoV2": "AFB08EDB15",
                                        "SHA256": "AFB08EDB15B3E5AD3A142B402040B0A7D9EB32C937E4237A5FFB0DAC5F3DDCBC",
                                        "CRC32": "3E02E561",
                                        "BLAKE3": "26F149EBB49737B321307EA8520E093097D916A6714103528BBC6FE95ADF12CA",
                                        "AutoV3": "50722E6C1B45"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81751",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 918335,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f156c3d4-b536-431e-8f32-002c6fa93c34/width=450/918335.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBINKun300~W00OE~VMx0K%2~BxFl9i_rWtl",
                                    "type": "image"
                                },
                                {
                                    "id": 918336,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/749ef1ad-9bd1-43f7-a5a0-f4ced6d11a4a/width=450/918336.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGJGTU={9u}?0$j[$$xD0#V[xZR*XTWBIpI:",
                                    "type": "image"
                                },
                                {
                                    "id": 918337,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5b750413-49d8-4177-9b94-68de99d85f7a/width=450/918337.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGKc%|?w0#]$0=F}W?ROu6-;o#Mx-=NHw^ad",
                                    "type": "image"
                                },
                                {
                                    "id": 918339,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fae9b6a5-fbb0-453a-89b0-7325aabd532a/width=450/918339.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDI4X?.901D*17~W-pIU5ZOt^k-TXnXAnjs:",
                                    "type": "image"
                                },
                                {
                                    "id": 918338,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ffb19875-44fc-41b9-8284-bcd045444c48/width=450/918338.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAI;9Y0L00yD03~B.8NG0O^k^*9u%~57#l-V",
                                    "type": "image"
                                },
                                {
                                    "id": 918340,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a51638f7-3c04-443d-a632-18c54b9b997e/width=450/918340.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEGH@.xuAq-=K--oSjOY0jNa-Vjv0LRk$yRP",
                                    "type": "image"
                                },
                                {
                                    "id": 918342,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f5f8228f-648a-4a84-b4c6-660442bdcf93/width=450/918342.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEGI7Zt-1R~V00ITVDM{?bxZ^*bvI@tRo2M{",
                                    "type": "image"
                                },
                                {
                                    "id": 918341,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/15bc0308-a034-4728-8159-fdb15e8e32df/width=450/918341.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFG*ya^*574:F~ELEk-ok@az-pae%hWB~Uxa",
                                    "type": "image"
                                },
                                {
                                    "id": 918343,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b47984ff-3f74-4665-88c9-c64486d93191/width=450/918343.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBHKqaZfl99G5Z-402JByYsj~BIp5SD*#,WC",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81751"
                        },
                        {
                            "id": 81741,
                            "name": "Colored Buzzcut",
                            "index": 14,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 28,
                            "description": "<p>Very simple to use, just use the keyword, i used 1.3 on the keyword in my posted images.</p><p>I used some of my controlnet poses packs that you can find in my page to generate many of the images posted.</p><p>Doesn't seem to work with anime.</p>",
                            "publishedAt": "2023-05-26T11:44:26.118",
                            "availability": "Public",
                            "trainedWords": [
                                "colored_buzzcut_hairstyle",
                                "shaved"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3063,
                                "ratingCount": 2,
                                "rating": 5,
                                "thumbsUpCount": 3,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55978,
                                    "sizeKB": 147571.6826171875,
                                    "name": "colored_buzzcut_hairstyle-10.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T11:46:32.035Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "9B88406E",
                                        "AutoV2": "07B3491265",
                                        "SHA256": "07B34912654A0748F2016F2F3D7DBB068DB85E40AA8B62F73CD30690C9B1A234",
                                        "CRC32": "6BD60234",
                                        "BLAKE3": "8696C6B9D152AE2FB99379DA0CE93714028625FAEAF0A716C0A0CD7BE1577C4A",
                                        "AutoV3": "FB11E4BB26C4"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81741",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 918273,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7136b9d8-5cea-41db-aacf-14ef3a91a6cd/width=450/918273.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDINQ{~BjEE101E1^*xu02ogIV$*In%2tRE2",
                                    "type": "image"
                                },
                                {
                                    "id": 918272,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/22699327-1fd3-4c81-9a09-854960eba2a0/width=450/918272.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBIzYY9b00?H00EMMyaKSeW;~Vs:oyIpt7WV",
                                    "type": "image"
                                },
                                {
                                    "id": 918270,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80e44257-dd87-4423-8ba7-ad4e153a8dd5/width=450/918270.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UOIg.V~U139u01%2vzNHK6EL%f%1rqWCr=xa",
                                    "type": "image"
                                },
                                {
                                    "id": 918271,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/59490629-6876-499b-95d3-9bfe0731c32e/width=450/918271.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHGt{L-;01~V01D%nOWB5QNuo}t8-o$fnN%1",
                                    "type": "image"
                                },
                                {
                                    "id": 918269,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cad73ccd-dc13-49ab-9aaa-a19c79676b55/width=450/918269.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9Fhx8-:009ZLgxt^OIV0iI:-UjFKjX8w]%2",
                                    "type": "image"
                                },
                                {
                                    "id": 918274,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/90b396a3-1ce8-4f0d-a7ef-feb5ccd9d1dd/width=450/918274.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCHKhE0L00x]0L~BrqIo0g^*?a0f9v57#+^j",
                                    "type": "image"
                                },
                                {
                                    "id": 918280,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4f419c20-9e1b-45f9-8153-e7683414b661/width=450/918280.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAGk5toe00JT0M-V9a9aF_5Q}Z-oWD~BWB0f",
                                    "type": "image"
                                },
                                {
                                    "id": 918276,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b716e767-af3f-4886-b0e4-afd4d76c7f10/width=450/918276.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "USJ7zOE29u%112E1I;of~qWE$$WBR*nixaWq",
                                    "type": "image"
                                },
                                {
                                    "id": 918275,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/719f2117-aa0f-4117-b7ce-a4b7a143827d/width=450/918275.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAIECL000}~p00Ab0L^O.S-A-p-;00={=|E1",
                                    "type": "image"
                                },
                                {
                                    "id": 918278,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/58dd6ec9-0ff2-4402-b96f-843bd304352a/width=450/918278.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCGa%qx]0f5603xW4:kD02xY~Bof%K58%1M{",
                                    "type": "image"
                                },
                                {
                                    "id": 918277,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/da11cd33-ab03-4f26-8a81-7cdb12f7fd7f/width=450/918277.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDH-lWEM020f00-o4:odyY-:~At7D$9a-:D%",
                                    "type": "image"
                                },
                                {
                                    "id": 918281,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3c10b666-7020-470d-acc7-01ab0b280810/width=450/918281.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCIW_,EM~B^*AaWX9uIo0LxGE2M|0LI:xtIV",
                                    "type": "image"
                                },
                                {
                                    "id": 918279,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ef31dfb9-bd62-438e-9c61-87fe524be4be/width=450/918279.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEHnHR-:9aIp00M{~Cxa5l%2D*xZ4.Nb-:NH",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81741"
                        },
                        {
                            "id": 81736,
                            "name": "Long Hime Cut",
                            "index": 15,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 6,
                            "description": "<p>As you can see many of my images have a perfect hime cut hairstyle not showing the fronthead, in those images i used my model in inpaint, first i generated the images as i wanted, then i sent to inpaint, masked the fronthead, checked fill checkbox and wrote in the prompt only this: \"(long_hime_cut_hairstyle:1.3),&lt;lora:long_hime_cut_hairstyle:0.5&gt;\" and then generated to have a perfect hime cut hairstyle.</p><p>I didn't do that for all the images, some of them are just generated, but they are not perfect hime cuts. So, remeber to inpaint if the generations is not how you want it.</p><p>Remember if you are inpainting an image after the other that before sending to inpaint your image you have to close the last image from img2img or in the new generation it will remember the old masked part other then the masked part of your new image, doing a mess.</p><p>Also many of the images are generated using controlnet poses packs that you can find in my page.</p><p>Works also with anime.</p>",
                            "publishedAt": "2023-05-26T11:39:03.198",
                            "availability": "Public",
                            "trainedWords": [
                                "long_hime_cut_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 6425,
                                "ratingCount": 4,
                                "rating": 5,
                                "thumbsUpCount": 11,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55971,
                                    "sizeKB": 147570.9814453125,
                                    "name": "long_hime_cut_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T11:41:25.541Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "61259D3F",
                                        "AutoV2": "BF9AF6A07C",
                                        "SHA256": "BF9AF6A07C36A337FE6702971809B6B017B4C3DEAC85125EA0C308ADFC9AEBD5",
                                        "CRC32": "916F93D3",
                                        "BLAKE3": "41D9422D5E5587315DC04A75DFEC2775640DB287CF47BE52568E4E3AC6F1862E",
                                        "AutoV3": "99C9890BDCAE"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81736",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 918157,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e6eed3d-cb15-4767-8dc8-879df51eb917/width=450/918157.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEG8Ao9Z0LI;-p-oI:xt00-p~BIoI;IpV@sn",
                                    "type": "image"
                                },
                                {
                                    "id": 918158,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/783a10d4-bd93-47de-91b9-3cb4eb842967/width=450/918158.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "ULJGybIVBB?G?^oLjJxutlR+xZxaRjofV@Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 918155,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d2b294ff-b3dd-41dd-ac39-c3918471c6c6/width=450/918155.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCJjM8~BNa^*Io^*%L%10fNH9aj?9GE1-VV@",
                                    "type": "image"
                                },
                                {
                                    "id": 918152,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/be7622dd-ace1-40d2-bad5-fb48aebcc8ef/width=450/918152.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UOJZ}CWV-.=|~pxtxuayV@RjM|j[9ZRP$*Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 918156,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2882f2c4-d74f-4ae0-b28f-d33082bb63b1/width=450/918156.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UKJtPD~U01ae4:fk?bt7M{WVxuIUE1M{aKay",
                                    "type": "image"
                                },
                                {
                                    "id": 918154,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1bf1e63d-16ab-486a-907a-633d83cacf75/width=450/918154.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U8Hmu^5700ae00Io%2?Gxsxu^P56Djni~V%2",
                                    "type": "image"
                                },
                                {
                                    "id": 918153,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/30968219-86e1-4505-b518-cbbdc03b23b6/width=450/918153.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEIzq^M{~Vni?Gxt9aIp57WV^jR*?GNGsm-o",
                                    "type": "image"
                                },
                                {
                                    "id": 918159,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/725a7022-ad11-4dc5-8066-400e0a1a3352/width=450/918159.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9FF1[oL00-p~qxt9GIo?bNGs9-pOst7IBIV",
                                    "type": "image"
                                },
                                {
                                    "id": 918160,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/86e54f57-ae27-4722-821a-10564e2474ce/width=450/918160.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDI|5i9a_1jE_LMyn$s-00NHM|W;D*ozxaWC",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81736"
                        },
                        {
                            "id": 81752,
                            "name": "Pigtail",
                            "index": 16,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 23,
                            "description": "<p>Very simple to use, just use the keyword, i used 1.3 on the keyword in my posted images.</p><p>I used some of my controlnet poses packs that you can find in my page to generate many of the images posted.</p><p>Works also with anime.</p>",
                            "publishedAt": "2023-05-26T11:50:49.969",
                            "availability": "Public",
                            "trainedWords": [
                                "pigtail_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 6904,
                                "ratingCount": 4,
                                "rating": 5,
                                "thumbsUpCount": 13,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55983,
                                    "sizeKB": 147571.646484375,
                                    "name": "pigtail_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T11:51:28.485Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "375BDFF8",
                                        "AutoV2": "AA2A8C63C9",
                                        "SHA256": "AA2A8C63C9E0ACAC9FCEFCBCD0D13E173F0CBD8EB61D93127FA73779CC8ED2DD",
                                        "CRC32": "B9ECB927",
                                        "BLAKE3": "9342B9D9EBB70480FCB80335B4AD0B856B03C62E6893588182F92F861B2C0B0B",
                                        "AutoV3": "BF6489E727A5"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81752",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 918352,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d3748892-8c19-49b2-b24a-adf98832aabb/width=450/918352.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCH,^n?aXk~U-ojEI:xZi^xtnhIVTIE2~BIo",
                                    "type": "image"
                                },
                                {
                                    "id": 918348,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/053e6c6d-eb62-4bdd-9fb2-2b6af8035d40/width=450/918348.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDGbCt^*000KE1M{~W-pEjIo-o-oKkt7Z$E1",
                                    "type": "image"
                                },
                                {
                                    "id": 918349,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2d4e869d-199f-4027-b2b2-3ff23cde4913/width=450/918349.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9Hdpi0L9u01?HIoNHIo01E1o#={~VxDNHxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 918350,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/55490f8c-f1d6-4b8a-975a-565a8f1efc37/width=450/918350.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDINpyIoTK0f~q9aNeIp0gIoXT?G~VVstRs,",
                                    "type": "image"
                                },
                                {
                                    "id": 918347,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0b8cf82d-643f-46d9-9fa5-07e1612a14d5/width=450/918347.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAJ%OUX5Rk~B01NHozNb00sDWB9a9uj]X8IV",
                                    "type": "image"
                                },
                                {
                                    "id": 918353,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cd88556d-2c2b-4a3f-bb38-3e284bbc0705/width=450/918353.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U6G*Zy?v-;%N7OTL%M-;00%gIV?H_N%MENE2",
                                    "type": "image"
                                },
                                {
                                    "id": 918356,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c99935f8-6eb0-412f-86ca-ec3c0d5f1ff7/width=450/918356.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9IEU_0f00~V00%L?bIV0eRj.8t7%g%2xCa0",
                                    "type": "image"
                                },
                                {
                                    "id": 918355,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6ab57355-4a76-4739-8a15-464b39096689/width=450/918355.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U4K,,50000^*00Fv_NXS00KPo#010}8{E1xC",
                                    "type": "image"
                                },
                                {
                                    "id": 918354,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7d6866b9-3608-4457-843b-c71bdd6d9382/width=450/918354.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGI#13~V00^*0f56E1InSi-;s.Mx_3xus9Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 918360,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/778a1378-04c4-4dfd-91a9-0b75a0a065c4/width=450/918360.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UQLDfO~W0f$gyEW=ozM{Xno|xuIU_2of%2ae",
                                    "type": "image"
                                },
                                {
                                    "id": 918361,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bf7e4085-4306-4a39-863b-d2df7af7f7b5/width=450/918361.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UULMt+Ip~V={^*%1t7NaWXoeR*t7%fM{-os:",
                                    "type": "image"
                                },
                                {
                                    "id": 918362,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/57118f44-6e95-4ca3-b5bc-65efbf9e0ab6/width=450/918362.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UILf%JM~0KIAwGMy~WXTE1xtMyxu.7IpMxM_",
                                    "type": "image"
                                },
                                {
                                    "id": 918363,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/32680023-1831-499e-9430-985dfd06f033/width=450/918363.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDJ78iI:00I:0e=|?GoMad%2?G56%f56$%~C",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81752"
                        },
                        {
                            "id": 81758,
                            "name": "Bun",
                            "index": 17,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>Very simple to use, just use the keyword, works with very low weights.</p><p>Works also with anime.</p>",
                            "publishedAt": "2023-05-26T11:53:54.669",
                            "availability": "Public",
                            "trainedWords": [
                                "bun_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 6061,
                                "ratingCount": 299,
                                "rating": 5,
                                "thumbsUpCount": 306,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55988,
                                    "sizeKB": 18545.1259765625,
                                    "name": "bun_hairstyle-10.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T11:56:24.956Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "0726662EA6",
                                        "SHA256": "0726662EA629F15EEAEDA78CF3C506ED7379FE8A9E71AE0BE2AD8D85E9FF7F4B",
                                        "CRC32": "8567B9C1",
                                        "BLAKE3": "AD50FC36CA566D1E0FBCF841EF5C51ECD1A2881B7CA99A6C861357FFBBEE64ED",
                                        "AutoV3": "6E6C9D99C949"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81758",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 918393,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c378282a-c7b6-461d-b523-43922b36f4e3/width=450/918393.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UKJi@CkC57ozJ*?Gt7Rj-;xa-U%2~ANwofRj",
                                    "type": "image"
                                },
                                {
                                    "id": 918392,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b65a4087-1381-49e1-ba37-f8f6f7c7645d/width=450/918392.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UPJ%qPxt0Lae00IVSh%ME2n$n%Na~Vt6%2oL",
                                    "type": "image"
                                },
                                {
                                    "id": 918390,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f57cd405-f035-4185-bf03-a2c7eca7ff74/width=450/918390.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIIqP{${00t700jFtmxakV%0~BS4%ME1E2M{",
                                    "type": "image"
                                },
                                {
                                    "id": 918394,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3ee13f7d-cf73-40de-8de7-32651c3df248/width=450/918394.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFHx4]?w01bt01R5-Wsq00E1=wr=K*.8%LNw",
                                    "type": "image"
                                },
                                {
                                    "id": 918391,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5802bc9e-6f60-4e20-84d5-6bd387f77540/width=450/918391.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIM6ek00ACxZ_2Mx~VRjENt7xFWVtRWBslof",
                                    "type": "image"
                                },
                                {
                                    "id": 918395,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0a71564c-19e6-49ba-b589-c44bcb129270/width=450/918395.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U7LV,W0101GH5pnV_NM}l9w}}@NG?^58R5-U",
                                    "type": "image"
                                },
                                {
                                    "id": 918396,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b2f96e04-4093-4f5e-b447-bbbbe3262fca/width=450/918396.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UYLMbH~p5R%M.7?H-pxuEgkWt7ofS$oKRQWB",
                                    "type": "image"
                                },
                                {
                                    "id": 918400,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/66981d29-1e14-4c7d-8088-5b92de4d9c1c/width=450/918400.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBKS*4^k0z~C00E3={0Lu4OFX7JB^%E2WBxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 918397,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8fb398b4-1667-4e20-862f-55e15170e748/width=450/918397.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9JZe=-;D*-p00RPtlRj0gae4:E1~BoftR-:",
                                    "type": "image"
                                },
                                {
                                    "id": 918398,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b6642b7f-494a-4e93-901d-2021416aa2cf/width=450/918398.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "ULK+=d%2IoR+56WCj[oLXmoJE1WA~BxaX8bb",
                                    "type": "image"
                                },
                                {
                                    "id": 918401,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/05d027b4-e8b2-44ca-85f2-e806dfeb0873/width=450/918401.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDJ6=^~C01^k0zOYt8Nb56e-%1WB-U-TrXs9",
                                    "type": "image"
                                },
                                {
                                    "id": 918399,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f763d9f1-df62-42fd-af6c-be21ed5f057c/width=450/918399.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEJG=;~pGH9]Cm-opI^+1OxC^1S#^*I:Mdi_",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81758"
                        },
                        {
                            "id": 81748,
                            "name": "Curls",
                            "index": 18,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>Very simple to use, just use the keyword, i used 1.3 on the keyword in my posted images.</p><p>I used some of my controlnet poses packs that you can find in my page to generate many of the images posted.</p><p>With higher weight then 0.3 on the model you might see curls also on the dress, i don't advice that, it's not pretty, use low weights, it will work only for hairstyle.</p><p>Works also with anime.</p>",
                            "publishedAt": "2023-05-26T11:47:57.132",
                            "availability": "Public",
                            "trainedWords": [
                                "curls_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 6498,
                                "ratingCount": 3,
                                "rating": 5,
                                "thumbsUpCount": 7,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55980,
                                    "sizeKB": 147572.509765625,
                                    "name": "curls_hairstyle-10.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T11:51:28.003Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "D74AB8C6",
                                        "AutoV2": "9EBC70F84A",
                                        "SHA256": "9EBC70F84AD2ADB162FE077B5309781BEA6BC594AA6B18E6CB88C0D9E612597C",
                                        "CRC32": "E6C74CB5",
                                        "BLAKE3": "70680F938E36F1F21B711B674693706314AB34B4AE66BD62CD5F5CDFD647A41F",
                                        "AutoV3": "647135557816"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81748",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 918323,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/445be4ee-44e0-4447-ab5d-602947cba021/width=450/918323.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9GRSP_N1%5?P;ozOF-p0iwb}nM{?G9uIAD*",
                                    "type": "image"
                                },
                                {
                                    "id": 918325,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8ae0668b-e7c8-4c1a-80f9-b3f02313fd38/width=450/918325.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAIDjf$fOl^%%K?GM|s:~UE2?GbHxsof=_%1",
                                    "type": "image"
                                },
                                {
                                    "id": 918324,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3a7b1c39-3cdd-46b0-a014-9370ac3b04cf/width=450/918324.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCI|K|~A5R^i0gx[xZ?aSfn$-oRk={n%-U%1",
                                    "type": "image"
                                },
                                {
                                    "id": 918322,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0271ceed-761e-4044-86cd-5c7ebdb313b2/width=450/918322.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9Jj6o570z1000RjwIE102%LtR~A-pbb5R%1",
                                    "type": "image"
                                },
                                {
                                    "id": 918329,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/122916e4-cf0f-4d23-9d24-b9e5a7bb3f54/width=450/918329.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UOINBUt5%LR*%LkBbGof9]R*NH%1~Boet6oL",
                                    "type": "image"
                                },
                                {
                                    "id": 918328,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c9f36915-1c58-4d43-9e22-ad3006f015b1/width=450/918328.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCI;hq^j009w7ME2~Vs:Kkn$?Gt8%hxuRPR*",
                                    "type": "image"
                                },
                                {
                                    "id": 918326,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a65eaa1c-3737-4557-85e9-6760cb00582b/width=450/918326.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAID{*s:000f00^*={ad01-p~VNcS20fV@-o",
                                    "type": "image"
                                },
                                {
                                    "id": 918327,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/230e19bc-9f90-40c8-b0fe-b83fce1f0e78/width=450/918327.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEL:ik~WOr?a00$*VsNGNyi_xuI:%1I:IA-U",
                                    "type": "image"
                                },
                                {
                                    "id": 918332,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4f12caf7-55a2-4bc3-ab5e-3d051687cc28/width=450/918332.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCH10n-pxt~B-o?G9uxaSzoe^%EM0fRjV@ae",
                                    "type": "image"
                                },
                                {
                                    "id": 918330,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f22f2483-5b46-4b18-b4b2-93e841cdbd1f/width=450/918330.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UJK+x_^%Ip$%Kj%2NGt6~AWVi{R*n+V[Rjxt",
                                    "type": "image"
                                },
                                {
                                    "id": 918331,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3af3dfed-abad-4a1d-b21e-2180686dcfd2/width=450/918331.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEJGK1x]-o^OOX~VM|9uniOsNb$f_1ni%LbF",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81748"
                        },
                        {
                            "id": 81743,
                            "name": "Buzzcut",
                            "index": 19,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 12,
                            "description": "<p>Very simple to use, just use the keyword, i used 1.3 on the keyword in my posted images.</p><p>I used some of my controlnet poses packs that you can find in my page to generate many of the images posted.</p><p>It doesn't always work, try to use both keywords togheter like \"(buzzcut_hairstyle, shaved:1.3)\". Also you might want to raise the model weight or the keyword weight or wait for a lucky seed or just inpaint the hairs.</p><p>Might work also with anime.</p>",
                            "publishedAt": "2023-05-26T11:46:07.422",
                            "availability": "Public",
                            "trainedWords": [
                                "buzzcut_hairstyle",
                                "shaved"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3711,
                                "ratingCount": 4,
                                "rating": 5,
                                "thumbsUpCount": 8,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55979,
                                    "sizeKB": 147571.029296875,
                                    "name": "buzzcut_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T11:46:34.268Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "33FE95C2",
                                        "AutoV2": "1E3AEBBBB2",
                                        "SHA256": "1E3AEBBBB225ECC37E6C2633BC37E1EA129479C670DF8709A7D589FD338F4202",
                                        "CRC32": "C93B362C",
                                        "BLAKE3": "F12E5C8EBB4C657372587B1E47869F8D09251B061FC6187CE507D1FACAFA9FA3",
                                        "AutoV3": "26E04AF1D338"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81743",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 918294,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/16c2f10a-8f49-4cbd-af12-a21b4c5f862b/width=450/918294.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UOJ7%V_35mtSysxuV@bv5TkCr=RjtSoznhnh",
                                    "type": "image"
                                },
                                {
                                    "id": 918289,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9ef7552c-5cfa-4b4d-96c6-6052a3005766/width=450/918289.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCINaJVt00E200xtt7Na01xZ~Bof%LSh?GIB",
                                    "type": "image"
                                },
                                {
                                    "id": 918288,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4ef727aa-6a59-44dd-a313-4ff56451c2fc/width=450/918288.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDIDs{}@00^j02%L^*Io0157n$EgIoM{R*xa",
                                    "type": "image"
                                },
                                {
                                    "id": 918292,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b9c195a3-b375-47ae-8700-c19ce9ff2bf1/width=450/918292.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIH^#8%101~B0M9aIo%29uNajZs:%2%1%2xa",
                                    "type": "image"
                                },
                                {
                                    "id": 918290,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/edebefeb-e790-4730-a04b-5e2c0a1f3ffc/width=450/918290.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEIqJr~V00n|?aWB$%ogR-WEIo4:-,R%=|?G",
                                    "type": "image"
                                },
                                {
                                    "id": 918287,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0c68e135-dc1f-4db1-9104-929f275faa37/width=450/918287.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9E-]vMw00~BAvt757EL0eIp=|%256WU~B-o",
                                    "type": "image"
                                },
                                {
                                    "id": 918291,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/46009eb4-10ad-4ac4-b4ff-410aea4ed018/width=450/918291.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGGt{LpI5pI=%%~B9^tRAI%L^jNdFfS#s:M|",
                                    "type": "image"
                                },
                                {
                                    "id": 918293,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/089f5b61-243d-4092-9507-914855543eda/width=450/918293.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAFE=i~C000L9uay^*s:0ME1^*^*5Rxtwc9a",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81743"
                        },
                        {
                            "id": 81728,
                            "name": "Ponytail Weave",
                            "index": 20,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 6,
                            "description": "<p>Very simple to use, just use the keyword, maybe with a 1.3 weight.</p><p>As you can see many of my images have a perfect hime cut hairstyle not showing the fronthead, in those images i used my model Long Hime Cut Hairstyle in inpaint, first i generated the images as i wanted with ponytail weave model, then i sent to inpaint, masked the fronthead, checked fill checkbox and wrote in the prompt only this: \"(long_hime_cut_hairstyle:1.3),&lt;lora:long_hime_cut_hairstyle:0.5&gt;\" and then generated to have a perfect hime cut hairstyle.</p><p>Remember if you are inpainting an image after the other that before sending to inpaint your image you have to close the last image from img2img or in the new generation it will remember the old masked part other then the masked part of your new image, doing a mess.</p><p>Also many of the images are generated using controlnet poses packs that you can find in my page.</p><p>Works also with anime.</p>",
                            "publishedAt": "2023-05-26T11:34:14.915",
                            "availability": "Public",
                            "trainedWords": [
                                "ponytail_weave_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5397,
                                "ratingCount": 2,
                                "rating": 5,
                                "thumbsUpCount": 9,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55969,
                                    "sizeKB": 147571.06640625,
                                    "name": "ponytail_weave_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T11:36:27.151Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "F88044CD",
                                        "AutoV2": "1949B00F66",
                                        "SHA256": "1949B00F661D8231B77895377566D2E6E2FD5C0B3DF82819A41ABA39801EFCB0",
                                        "CRC32": "E3F8E409",
                                        "BLAKE3": "39A4D8F3224F04BEBBACE4A0565A148DB6DFF9EDEE63993A294F1820496E1E1F",
                                        "AutoV3": "AC270380415D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81728",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 918110,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/466db052-13bc-450e-b62f-0647c1eac314/width=450/918110.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEGRPB~UEh9bAJ$$NdEhE3J8WBxGJBxu?G-U",
                                    "type": "image"
                                },
                                {
                                    "id": 918103,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f116160c-ed90-4811-a64c-2664305c8238/width=450/918103.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDHnNfkX5S~B04M|ENxu.9nh-TE3ETs+-oEM",
                                    "type": "image"
                                },
                                {
                                    "id": 918109,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/38567650-63b3-4879-8f98-bb519511b050/width=450/918109.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9H-Mh5800.700J8_N$j5Ro#^jVs5rnhR5x[",
                                    "type": "image"
                                },
                                {
                                    "id": 918102,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/af98ded7-41e1-4394-845d-eadccb8bb103/width=450/918102.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIHKz%0hyD$i*0NLoI9vAetSrqxuOaxvn4xu",
                                    "type": "image"
                                },
                                {
                                    "id": 918101,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/86f0c51e-3452-46f9-96ae-5e86088bf852/width=450/918101.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFIE5}I?*IwJ04sp03NbFhxt^kRkXTIo^jsT",
                                    "type": "image"
                                },
                                {
                                    "id": 918105,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c37738d0-4ffc-431d-89cc-085f7746afde/width=450/918105.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U8J7Ey~B=Y020nE2rW~B0nRj9Fr=yE^*Eg0g",
                                    "type": "image"
                                },
                                {
                                    "id": 918106,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1b8fe2c2-dc32-4527-8742-9f69fb112921/width=450/918106.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UNKKA,01?uNH~q4;JC%MEMWB%2-ptQn%%LIp",
                                    "type": "image"
                                },
                                {
                                    "id": 918108,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/24b33056-86cb-45c5-b0e2-1c2008defab6/width=450/918108.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIH1xn0h%g$iysNLs,9vAetSrqxuOtxva0xu",
                                    "type": "image"
                                },
                                {
                                    "id": 918107,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6427f274-cbad-4b0f-902f-0e737a5b3396/width=450/918107.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCHdy-o#5S~C04M|Egxu.Anh=wE2A0s+-oEM",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81728"
                        },
                        {
                            "id": 81738,
                            "name": "Egyptian Bob",
                            "index": 21,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 4,
                            "description": "<p>Very simple to use, just use the keyword, i used 1.3 on the keyword in my posted images.</p><p>I used some of my controlnet poses packs that you can find in my page to generate many of the images posted.</p><p>My advice is to use \"hime_cut_hairstyle\" keyword, and if it doesn't work with a weight 1.3 or lower, then try to add the 2nd keyword egyptian_bob_hairstyle. It should give a stronger effect but you might encounte egyptian stuff in your generated images.</p><p>Should works also with anime.</p>",
                            "publishedAt": "2023-05-26T11:41:09.769",
                            "availability": "Public",
                            "trainedWords": [
                                "hime_cut_hairstyle",
                                "egyptian_bob_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 6485,
                                "ratingCount": 4,
                                "rating": 5,
                                "thumbsUpCount": 13,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55975,
                                    "sizeKB": 147571.2490234375,
                                    "name": "egyptian_bob_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T11:41:24.674Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "8019A715",
                                        "AutoV2": "F4CE6E733F",
                                        "SHA256": "F4CE6E733FDCD80FFD6852AE4E73A42842815C287BBFB0D63594DBEEFDFE40BD",
                                        "CRC32": "6C6EC131",
                                        "BLAKE3": "B10160D49D68639E0A67C34A8A4ED50E720055CA412CA0A1D9074657D1BBB6B9",
                                        "AutoV3": "17CC7CDAE8E0"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81738",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 918214,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5135c1a0-7da5-4dd5-87e2-1e30f58c793a/width=450/918214.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UKMrxb~V9YrW0L-Txuo}i^M|?GWCXSt7nOoJ",
                                    "type": "image"
                                },
                                {
                                    "id": 918212,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9da7cbb2-3782-4fda-8418-7db3fd2a636f/width=450/918212.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFHKqdxt0O?F0kIpxbIV9^kV~AxFEMxFr?W;",
                                    "type": "image"
                                },
                                {
                                    "id": 918213,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8174334e-d808-4ef2-b84e-82e25d8fdaaa/width=450/918213.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFHw[P~U00s9IT^%~po}NF%L~U%1J.-o-TNH",
                                    "type": "image"
                                },
                                {
                                    "id": 918216,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ea3824b6-7560-4398-88f4-4293dda37929/width=450/918216.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9Hdy.xCX.%N03t6029aPAj[Rjoe~ANH}?-U",
                                    "type": "image"
                                },
                                {
                                    "id": 918217,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7b8c13c8-32fe-44e7-94be-78b5a44fa37e/width=450/918217.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAFh*Q-V019]JBs:0fNa3sX8$ext,DM|~B-o",
                                    "type": "image"
                                },
                                {
                                    "id": 918215,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/72c79ec5-adab-46bd-bc9b-d1e2e413d79b/width=450/918215.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDIy,w%10Ls.%fs.IpW.01NH-os:}?WV^ixG",
                                    "type": "image"
                                },
                                {
                                    "id": 918219,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eff70845-74dc-4530-b71e-e6cc74e67cba/width=450/918219.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEG*HA?G0L~B020fM{ad9^-pt7R+-Unh$ioK",
                                    "type": "image"
                                },
                                {
                                    "id": 918221,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c81a0f2c-3c35-4e95-aa20-ec170317756e/width=450/918221.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBHwrzJC0g5700%2S~xa0fRP}=xu^%kCw]D%",
                                    "type": "image"
                                },
                                {
                                    "id": 918218,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dd37fda6-6373-4ecb-a6a1-aecc87d34456/width=450/918218.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAHB3y0L00kX03~BD%E1K+M{=X-:~qIpi^D*",
                                    "type": "image"
                                },
                                {
                                    "id": 918222,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/808c94d7-a2e6-4119-a7ce-444bded4cdbf/width=450/918222.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBGkqA?H00t,E,kq~V?G7Nxa~VS$E+of$NIV",
                                    "type": "image"
                                },
                                {
                                    "id": 918220,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9efab7d5-6d5f-45c6-8c51-04f4b5229bcc/width=450/918220.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEGRxMwc01XnFhS4#-xFLNoL^*bvF}s:%MR,",
                                    "type": "image"
                                },
                                {
                                    "id": 918223,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/25ab8dd5-ad52-40b6-a989-72b6b03e5ccb/width=450/918223.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCHB3s0f00tR02~Aw_E20g^*^j57O@57rq={",
                                    "type": "image"
                                },
                                {
                                    "id": 918226,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7b94f10f-3bc9-4635-b159-da807122f936/width=450/918226.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCHnNi0f02%g01}@$*EM0#^*^*9uK656#R^P",
                                    "type": "image"
                                },
                                {
                                    "id": 918225,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4ed1530d-60bb-4f39-8972-2a9d0d29decb/width=450/918225.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIJj0TNG~T^jDj%14:M|-UR*-os:Eys.^jW:",
                                    "type": "image"
                                },
                                {
                                    "id": 918224,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/87c5f3df-879e-447c-8e08-1d46b56cad16/width=450/918224.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIH2TR~q0h9b00s.-Vo#E2M|%0%0pybc-oof",
                                    "type": "image"
                                },
                                {
                                    "id": 918227,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dbbba0f6-c345-4bf0-b846-90bc70e0c6ae/width=450/918227.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCN[,9$y.44o00={#RO@S]xt^*RQ_LIonORQ",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81738"
                        },
                        {
                            "id": 81755,
                            "name": "A Line",
                            "index": 22,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 22,
                            "description": "<p>Very simple to use, just use the keyword, i used 1.3 on the keyword in my posted images.</p><p>I used some of my controlnet poses packs that you can find in my page to generate many of the images posted.</p><p>Works also with anime.</p>",
                            "publishedAt": "2023-05-26T11:52:29.056",
                            "availability": "Public",
                            "trainedWords": [
                                "a_line_haircut"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5841,
                                "ratingCount": 1,
                                "rating": 5,
                                "thumbsUpCount": 12,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55984,
                                    "sizeKB": 147571.15625,
                                    "name": "a_line_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T11:56:29.445Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "A1D316F0",
                                        "AutoV2": "F35DF0ED27",
                                        "SHA256": "F35DF0ED27A2F26D8B511031BD0BF9ED99968CD6F7438E55DCC6E466458FAB8E",
                                        "CRC32": "7FFE94C2",
                                        "BLAKE3": "EDE1A95188C3D49EE3E8120DCEFB07B757C2EBE0B5F6A96D565A448E7C12596C",
                                        "AutoV3": "6372796015CC"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81755",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 918367,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/41bd3898-f652-46c1-9b11-8a92b501f712/width=450/918367.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDF;=,E29tsl~VNGxtRj?HoJozxagNjG^jWB",
                                    "type": "image"
                                },
                                {
                                    "id": 918369,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ab9f1e20-2431-487b-a43a-d0421ffcebaf/width=450/918369.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCHnNf5800-U01$%_3X84:I;~URPXmxZR4R+",
                                    "type": "image"
                                },
                                {
                                    "id": 918368,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5e554f3b-aadc-4cc6-8f66-b72958e4acca/width=450/918368.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBJacl4n00t7K+-V?w%MyD~V?G4;_N9ai_?G",
                                    "type": "image"
                                },
                                {
                                    "id": 918366,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/51e10c1a-30c8-47d9-815e-94f5fce99631/width=450/918366.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEK0H8-;0fni9axaw|R+-:~V^*^j%LE3-obH",
                                    "type": "image"
                                },
                                {
                                    "id": 918365,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/70279e39-f73a-46b2-8ccf-b9b16a3f5e5d/width=450/918365.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHJjMC~B56^*00IV-pD*AHShayNbkAE1Rjxt",
                                    "type": "image"
                                },
                                {
                                    "id": 918370,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c4466501-d587-440b-9c0f-92fcb4d94175/width=450/918370.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEJGcv-UE1={OXR*xaIp0#E2t6Ip~UIVIo%2",
                                    "type": "image"
                                },
                                {
                                    "id": 918373,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c8e3921f-5188-4ffd-a2c2-71aa62b4f5c5/width=450/918373.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCIglyEi56IpKjt7%1=|01RjIUoK~Wsm9ZE1",
                                    "type": "image"
                                },
                                {
                                    "id": 918374,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/59aae4bb-cdc2-44c7-bcb2-7899a619a8a7/width=450/918374.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UJJjVaW;-oNG~VbbNGxt57WBS4%2^jWB%1Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 918371,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b3ecc86c-e9be-4af9-ab3d-e2115ba3bb61/width=450/918371.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U8HdjP~B00Ip0Mt7?HxFIqM|slxuOYR*n%M{",
                                    "type": "image"
                                },
                                {
                                    "id": 918372,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d1a04d6d-d9cb-42cb-9840-8687b3557ea1/width=450/918372.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBGH@:$j00Md00Nw^+XT56My~Vxa0f-:e9xF",
                                    "type": "image"
                                },
                                {
                                    "id": 918375,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1320379b-4d24-4452-9377-62d19d4874c1/width=450/918375.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UXG*{GjZAIkC?wj[tSofbwofxZbIIpoM%1j[",
                                    "type": "image"
                                },
                                {
                                    "id": 918377,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/170f3099-d93c-423b-b6d0-5e2fdf84d073/width=450/918377.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBIXQ.-p00E1-nNG~W%LoIs:^+kC_2of?Gn$",
                                    "type": "image"
                                },
                                {
                                    "id": 918376,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0cad2b02-bb9c-4a93-b211-ad318c1132e5/width=450/918376.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UUHBoOxa0LWX_4WVogoftSf6t7ofEMay-pj[",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81755"
                        },
                        {
                            "id": 81725,
                            "name": "Side Swept",
                            "index": 24,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 14,
                            "description": "<p>My advice is to use the keyword with 1.3 weight</p><p>I'm uploading epoch 5 because epoch 10, the lats one, seems overfitted for realistic images but epoch 5 doesn't seem to work with anime while epoch 10 does work with anime and it's not an overfit for them. But since i make mostly realistic models i'm uploading epoch 5, if you want to try all other epochs come in my patreon.</p>",
                            "publishedAt": "2023-05-26T11:30:35.801",
                            "availability": "Public",
                            "trainedWords": [
                                "side_swept_hair",
                                "ponytail"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5172,
                                "ratingCount": 1,
                                "rating": 5,
                                "thumbsUpCount": 5,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55966,
                                    "sizeKB": 147571.6806640625,
                                    "name": "side_swept_hair-05.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T11:31:57.660Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "9CAE86CF",
                                        "AutoV2": "0CAECA2AE4",
                                        "SHA256": "0CAECA2AE4DF8F1265BB0D0ABED4224BAD43AE10DC2741367141291B64F0F77B",
                                        "CRC32": "B7F3F2DC",
                                        "BLAKE3": "FA4143AF4673315EE613CA34499661E46043F5A2020E335398A87B1600074602",
                                        "AutoV3": "194152C6D633"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81725",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 918057,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b25ca45f-0d41-4fda-aa4e-2c9472487c4a/width=450/918057.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBKI|h0300PUwFIr^jozvd9x?G$L~URQE2o}",
                                    "type": "image"
                                },
                                {
                                    "id": 918053,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c11ef65a-4990-429f-b612-c4093a96bf30/width=450/918053.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDKJSn%1FZ={OUsA={s.0LIpE2EM~Us:%0NG",
                                    "type": "image"
                                },
                                {
                                    "id": 918052,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d1914c44-d6c0-411a-95c4-dc4ac41547cd/width=450/918052.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGI}9YMx5R~V00%fV?n$9vM|-pE2SOE1s-NH",
                                    "type": "image"
                                },
                                {
                                    "id": 918054,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6578afc1-1d9a-459d-9e0e-ff829b66ffa7/width=450/918054.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIL{@$0hGZogPBkq?cxvS%%2s;R-~VM|s9jF",
                                    "type": "image"
                                },
                                {
                                    "id": 918055,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0db1e0cb-64e8-48af-b203-68a1ca7dcbd6/width=450/918055.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UOI3,P?GSdSexZ={J7oeEh?F~Axa-oozbGs.",
                                    "type": "image"
                                },
                                {
                                    "id": 918051,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/103fdc2a-86e5-41c6-93a5-6384d622cbae/width=450/918051.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UKJsUfxZ0L~Vx]$%-T?G9ujZxZR+M|RkM|Io",
                                    "type": "image"
                                },
                                {
                                    "id": 918056,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/12ee2e15-fcf6-48d9-9b03-8b561c2b18dc/width=450/918056.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "ULJ6fykq%L-o}?%Lbcoy0fkBRkn$9aWBr=sS",
                                    "type": "image"
                                },
                                {
                                    "id": 918059,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d964869-0c66-4f26-bd3b-54680956a75c/width=450/918059.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBI;3G=F?YS$0h};9HS~0g.6~Bv#tlE2?F$%",
                                    "type": "image"
                                },
                                {
                                    "id": 918058,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f5e01110-5790-4338-b924-4813c3726a22/width=450/918058.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDH-S#_2FZ_NX:4.01XTX.slV@%MyXIU=wx^",
                                    "type": "image"
                                },
                                {
                                    "id": 918060,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/61c19717-b3dc-42e8-84ba-6fb169972d2b/width=450/918060.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIH^t.~9g#^%0#r=E2IU9~D*RmNGXnx]?Gxa",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81725"
                        },
                        {
                            "id": 81722,
                            "name": "Half Ponytail",
                            "index": 25,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 4,
                            "description": "<p>Half Ponytail Hairstyle model has been requested to me, it should be a ponytail that doesn't contain all hairs, but just a part of them, the rest should be free.</p><p>It works most of the times for realistic images, using 1.3 as weight on the keyword.</p><p>Most of the images are made with Controlnet using my poses packs that you can find in my page.</p>",
                            "publishedAt": "2023-05-26T11:28:45.023",
                            "availability": "Public",
                            "trainedWords": [
                                "half_ponytail_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5276,
                                "ratingCount": 1,
                                "rating": 5,
                                "thumbsUpCount": 7,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55964,
                                    "sizeKB": 147571.6904296875,
                                    "name": "half_ponytail_hairstyle-10.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T11:31:34.555Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "BB82064B",
                                        "AutoV2": "460795F24F",
                                        "SHA256": "460795F24FDDC43EDF0960907882C0D13CCC7BDA00F556B4D55F7373EB5FE2F6",
                                        "CRC32": "D8706F8A",
                                        "BLAKE3": "9ED5A30C2F85F33C8CE5FAF6FE4F2F82E3DA370666908B32674A378CAFCE46F3",
                                        "AutoV3": "3FABB6A52EC4"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81722",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 918029,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cd3cdbb2-fab7-486b-a983-25967b2388e4/width=450/918029.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U7F}sA_32]~V0N4o9aI=5=-;^*E200s:=xbH",
                                    "type": "image"
                                },
                                {
                                    "id": 918031,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/db1c8312-3087-4a79-8037-3e47af2a3e68/width=450/918031.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDIDs]f,01xEAH%L~BxZ0fNH-oxa0#WBE29t",
                                    "type": "image"
                                },
                                {
                                    "id": 918026,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71b6e685-78e8-47b3-b3f6-92b59d53202f/width=450/918026.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAHU8{IU00-;15e:~VOE0O%L=|Rl4=RjnOWB",
                                    "type": "image"
                                },
                                {
                                    "id": 918027,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1aef09c3-8940-4f0d-ba30-1e95a7e04d1d/width=450/918027.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAI4Ii0L01?G02}@-pIp01^k$*0fKP57nO-o",
                                    "type": "image"
                                },
                                {
                                    "id": 918028,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/af2d92cc-4d55-4a43-b1f7-50b400ab0202/width=450/918028.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHI;kyNH01%2K7%2~XM|01M|kD-p9ZR+a0WA",
                                    "type": "image"
                                },
                                {
                                    "id": 918030,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6e493ddd-6bf9-4228-9e34-ba0efe6dcffc/width=450/918030.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCGRPDx]%#%L*0-VF39u02IoD+$*9ukB=ws9",
                                    "type": "image"
                                },
                                {
                                    "id": 918032,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a989ec86-4e44-4936-9d88-7fed719a35d1/width=450/918032.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDHnEIXT01~C02WCxuE200s--TjEx[jZxCWB",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81722"
                        },
                        {
                            "id": 81730,
                            "name": "Very Long",
                            "index": 26,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 6,
                            "description": "<p>Very simple to use, just use the keyword, maybe with a weight of 1.3.</p><p>Many of the images are generated using controlnet poses packs that you can find in my page.</p><p>Works also with anime.</p>",
                            "publishedAt": "2023-05-26T11:37:10.249",
                            "availability": "Public",
                            "trainedWords": [
                                "very_long_hair"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5488,
                                "ratingCount": 4,
                                "rating": 5,
                                "thumbsUpCount": 10,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55970,
                                    "sizeKB": 147572.0146484375,
                                    "name": "very_long_hair-10.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T11:36:33.737Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "A04D846F",
                                        "AutoV2": "F20C500B76",
                                        "SHA256": "F20C500B7648F7786257506F3E4703517819BD6AA8616F01893DF981EFECE474",
                                        "CRC32": "CD60C5EF",
                                        "BLAKE3": "B8AB1C5A4BB7363F7B888E1147158045DE71E6CF45AB61A8558A45A0EB3C7437",
                                        "AutoV3": "9AFEB2EEEE1C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81730",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 918126,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cf097307-5c52-483d-b854-7a34a22dd8d6/width=450/918126.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBF521~qAaxZpKx^EkR*0%T0NeE2x^T0%L$%",
                                    "type": "image"
                                },
                                {
                                    "id": 918129,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/38702f8e-74f8-44ec-bff6-5b7b7623cfd2/width=450/918129.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHGaqOxD9^tRK7s:JBg40gWXM|Nd~BbIn%NH",
                                    "type": "image"
                                },
                                {
                                    "id": 918128,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a3c0737b-c07e-4759-bdea-1ffc4320d974/width=450/918128.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UKGuROrq0MOFYRVs?HOFO[E2t6-V.8I;Vs$z",
                                    "type": "image"
                                },
                                {
                                    "id": 918127,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e31d2678-8147-4fad-bf93-fc0f5c1ecad0/width=450/918127.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCD[|Yxa0MI;*0R+t8oMAIsnnPofEMRk$%xa",
                                    "type": "image"
                                },
                                {
                                    "id": 918131,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/72ff4aee-a710-4c4e-a094-a3a9d677ed30/width=450/918131.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "ULJQcp_N01%2yY-=%g%gcF%MwcNe%gt7a0sT",
                                    "type": "image"
                                },
                                {
                                    "id": 918130,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a6111b63-c3b3-4c7c-89af-3bd2be301fa5/width=450/918130.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDJjoHEo00xu0fR:_NI@4oIV-;IpSh4:$en~",
                                    "type": "image"
                                },
                                {
                                    "id": 918134,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/00996e02-321c-4e57-a69f-00a963c10929/width=450/918134.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFHU5}-p0z9GAcELIq?G57WWD*WC-TWC~URk",
                                    "type": "image"
                                },
                                {
                                    "id": 918133,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/679068a0-dc10-46a5-9615-f88df6ff430b/width=450/918133.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGID~;^%0#~U0hMxs;Rj01-:-pI;XSIpVsIo",
                                    "type": "image"
                                },
                                {
                                    "id": 918135,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7e9bb0a7-81fb-49b3-b1ba-be38bb1eaedf/width=450/918135.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCHA-A,-Pp-oK6^iRlof9FxEVYIpX,NG~Ui_",
                                    "type": "image"
                                },
                                {
                                    "id": 918132,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d5570352-38e0-4a97-be7d-e0c047de9e96/width=450/918132.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDFYP%%f00NGC8%2?aNwPobbM|bI~qR*IUkW",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81730"
                        },
                        {
                            "id": 81740,
                            "name": "Half Buzzcut",
                            "index": 28,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 12,
                            "description": "<p>Very simple to use, just use the keyword, i used 1.3 on the keyword in my posted images.</p><p>I used some of my controlnet poses packs that you can find in my page to generate many of the images posted.</p><p>It doesn't always work, might need to try more generations.</p><p>Works also with anime, just with higher weights on model/keyword.</p>",
                            "publishedAt": "2023-05-26T11:42:41.75",
                            "availability": "Public",
                            "trainedWords": [
                                "half_buzzcut_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5343,
                                "ratingCount": 3,
                                "rating": 5,
                                "thumbsUpCount": 7,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55976,
                                    "sizeKB": 147571.1806640625,
                                    "name": "half_buzzcut_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T11:46:29.632Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "B2374C5C",
                                        "AutoV2": "8C016C0027",
                                        "SHA256": "8C016C0027C68D44D2D1364141386A9BE5DE24DB782C82EAC54FD02FEA1C28BD",
                                        "CRC32": "ED7DCD90",
                                        "BLAKE3": "9D9AC7F8D18C52617C10CEEDD4464478CB0531242E02C326142B0B265FFA1172",
                                        "AutoV3": "6944CAF9A71D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81740",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 918247,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/39179c41-9150-49f9-b2e2-d7e86e20272c/width=450/918247.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U8JGvP5602-:00}@MyEN4p}?^*0MPAKi=s}?",
                                    "type": "image"
                                },
                                {
                                    "id": 918248,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7eda06e1-372b-4bbe-8318-686422dc0d14/width=450/918248.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UOJkM|?cGa?v.ms.%1%g5RS4RPM{TJofs9M{",
                                    "type": "image"
                                },
                                {
                                    "id": 918240,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/13da6c76-feae-4888-a89f-1f46333f2832/width=450/918240.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGKA$#D%7i?H7%Rj%NRj02$#MxWYM{M{%2tR",
                                    "type": "image"
                                },
                                {
                                    "id": 918241,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bd8d70b3-e077-49da-8bcc-87385b621b85/width=450/918241.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGLCw{IT0gxa_MMy~B%0IWax%2n,NHn+IpNb",
                                    "type": "image"
                                },
                                {
                                    "id": 918242,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/02c39a3a-88a8-4564-bc84-fd11e379175c/width=450/918242.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEGb0KM{AZ-o~q$$I;EL_2k9%L?Gkrae?Ga}",
                                    "type": "image"
                                },
                                {
                                    "id": 918244,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8a154cea-852d-4c72-a529-f896e9778764/width=450/918244.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U7IWl.Io^j~B0zxa57EM01%157Ip0LE2xtM|",
                                    "type": "image"
                                },
                                {
                                    "id": 918243,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0088d39c-6ff3-465a-b9a8-5847846ad9b1/width=450/918243.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEKS*4R*NH~B0gWVM|Ip00smWWE2NGjZNbRj",
                                    "type": "image"
                                },
                                {
                                    "id": 918245,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4117e967-6d4c-412f-b41a-caf3b0e19796/width=450/918245.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UJINdVxY~A5R15S4EL-U0hj[j[%05pR*NGE2",
                                    "type": "image"
                                },
                                {
                                    "id": 918249,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0e9354cd-9db7-497a-a67a-d732afbff482/width=450/918249.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UKJ%Uj~90z?GyD-n?Gt7E1I:nhM|n#s:V?Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 918246,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/18600338-ef80-4cc9-9f3a-c6f5b4ce9357/width=450/918246.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U9IX8J,.01}m2_0LtSnM14IokCR5~qwb~Bnh",
                                    "type": "image"
                                },
                                {
                                    "id": 918250,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f9815d5-3a7b-4003-95ab-c61c88b8a765/width=450/918250.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U8KmFKRj1Q570458yE0M03s.-=~B%Mxa0L-U",
                                    "type": "image"
                                },
                                {
                                    "id": 918251,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b6e999cb-be25-4af2-9e55-bf0661b3a37b/width=450/918251.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCExt;-T0N9uT}tR0fIp03S$,.sm^+WX={$$",
                                    "type": "image"
                                },
                                {
                                    "id": 918253,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/400b3c54-0635-43c5-af78-84b497aeeffd/width=450/918253.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBGkLG$f0gOsLNsS9ZOZ0NWCE1S$^+t7^PkD",
                                    "type": "image"
                                },
                                {
                                    "id": 918252,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/91d1db86-3398-4e23-a00b-e52e9b1802b4/width=450/918252.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U8H1f0so0MpJG^rr56F20NWB9ZOY?cxu~Bt7",
                                    "type": "image"
                                },
                                {
                                    "id": 918254,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3925e0bc-f085-4098-97d0-940239dbf056/width=450/918254.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBKAA@IV00-n00NeoNaf-nM{~W-p56ofMxRj",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81740"
                        },
                        {
                            "id": 81727,
                            "name": "Long Ponytail",
                            "index": 29,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 12,
                            "description": "<p>Very simple to use, just use the keyword, maybe with a weight of 1.3.</p><p>Many of the images are generated using controlnet poses packs that you can find in my page.</p><p>Works also with anime.</p>",
                            "publishedAt": "2023-05-26T11:32:17.588",
                            "availability": "Public",
                            "trainedWords": [
                                "long_ponytail_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5437,
                                "ratingCount": 2,
                                "rating": 5,
                                "thumbsUpCount": 8,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55968,
                                    "sizeKB": 147571.2158203125,
                                    "name": "long_ponytail_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T11:36:26.076Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "63A104D2",
                                        "AutoV2": "1E54EB6D8E",
                                        "SHA256": "1E54EB6D8E147D7374A268C4AAB0C6DF0BD47152C5C0E8BEEC34E0A9F81D8BA4",
                                        "CRC32": "B93A0B95",
                                        "BLAKE3": "40D8B46C258BD451471C1769129A12F1479A99CD14C6D93B022859BD027504DA",
                                        "AutoV3": "E2C43C9DC71E"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81727",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 918086,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bc39c21d-f052-4de3-9a70-0ff787bd9c3c/width=450/918086.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UJJ7adT15RxC8JI@9tRj%$WB^Ps.?br=wIkC",
                                    "type": "image"
                                },
                                {
                                    "id": 918079,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1da92663-c005-4e5d-9eff-e6e6a2b2ef61/width=450/918079.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHIglv~UFwwJF3-o4;0L%goxt7WC58Ip-Us:",
                                    "type": "image"
                                },
                                {
                                    "id": 918082,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/db251c25-010b-415d-bf36-12cedadfbcd3/width=450/918082.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UUJQfu~BE0WA9t-n-:XS9a9aod%2ozofV@xZ",
                                    "type": "image"
                                },
                                {
                                    "id": 918081,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7a0eab00-cb99-425a-9ba8-c86eeb168a7e/width=450/918081.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "USI#48V@FyW=?wM|Ipof?vNG$*%1X-NI$%f7",
                                    "type": "image"
                                },
                                {
                                    "id": 918080,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c534ab8f-fe66-47ed-bc9e-b78b282b6940/width=450/918080.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHHKa]~B000L57NH-p%29ZM{%2-pIps:%1Io",
                                    "type": "image"
                                },
                                {
                                    "id": 918083,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/06fa74fb-e92d-4bac-8893-db44f2822ac7/width=450/918083.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UNIDp%~Vo|-p%L-Vxat79ZM|oLRk57RjxaxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 918084,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d1d8b5d5-9828-49dc-b106-b1b3f0f748c1/width=450/918084.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHKJ}Z~Bo|o}0L^*xa-o01R*%1V[D%E2?HNG",
                                    "type": "image"
                                },
                                {
                                    "id": 918087,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/db225f63-4ecd-4288-b388-fc3b20b89376/width=450/918087.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UKK0]AVs00ShM_Io-;RkRjM|tRWB~VIV%1xu",
                                    "type": "image"
                                },
                                {
                                    "id": 918085,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3618ba43-dc34-462a-b994-cbb3e0b36dd1/width=450/918085.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UMKAf@WB0K~W?a-:_2IVRjkC%LjYtRa#%2WW",
                                    "type": "image"
                                },
                                {
                                    "id": 918088,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d4539e3f-9d91-4c8b-900d-cc066cbaa197/width=450/918088.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHJ7O0~V00I99F-U?HOE00Rj%g%M?uxu-TVs",
                                    "type": "image"
                                },
                                {
                                    "id": 918089,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a14b11bc-a2c4-4a85-b109-4a1b4d355c8d/width=450/918089.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDGan8%10z~V9ZM|4:57xDS5tRxa5RIp~BjY",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81727"
                        },
                        {
                            "id": 81720,
                            "name": "Emo",
                            "index": 30,
                            "modelId": 76937,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 6,
                            "description": "<p>Very easy to use, just use the keyword, maybe with 1.3 weight.</p><p>Emo hairstyle is kinda messy hairstyle.</p><p>It has been trained with hair of any color, so you can just add \"red hair\" or \"blue hair\" etc to have the color you want.</p><p>To fix only the hair color and don't make also everything else of that color i advice to use cutoff extension and fix color keyword to the hair and only hair.</p><p>Should work with both short and long hair keyword.</p><p>Doesn't work very well with anime.</p>",
                            "publishedAt": "2023-05-26T11:26:57.278",
                            "availability": "Public",
                            "trainedWords": [
                                "emo_hairstyle"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 6436,
                                "ratingCount": 3,
                                "rating": 5,
                                "thumbsUpCount": 14,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55963,
                                    "sizeKB": 147571.240234375,
                                    "name": "emo_hairstyle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T11:31:34.247Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "5A50A076",
                                        "AutoV2": "28F0B5EE29",
                                        "SHA256": "28F0B5EE2959105F8A4080F8CF84F627DEFD9F7E454070BA1A639B6D98B6C577",
                                        "CRC32": "63CCD511",
                                        "BLAKE3": "469B5EA6DCA27E3E1D56BF68217AF7919E8F420B89AA7C3AFD0CAF1D54268C67",
                                        "AutoV3": "3EB95F1283DC"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81720",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 918014,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0d775196-9014-4b6f-b4ae-c52f6cbcc783/width=450/918014.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDH-P,000z~B16Di^+IVcF$e-p9ZwfbFo|Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 918021,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1d26aded-1f3a-4dde-a458-7bfb51ce4cb1/width=450/918021.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGHT~yEL1H~B0OozNfIB57NG%2sTIp%2xto0",
                                    "type": "image"
                                },
                                {
                                    "id": 918018,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80522989-c667-4a89-8788-b6dbf229b9cd/width=450/918018.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHF#]*ELEk~V01xaM{D*4nR*sls:tl%1?HWW",
                                    "type": "image"
                                },
                                {
                                    "id": 918015,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/adf4b85c-cc2d-47e5-92ab-294e063f4761/width=450/918015.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UZHeh2NGyExa?wofx]RkE2Rkj[e.9aofxajZ",
                                    "type": "image"
                                },
                                {
                                    "id": 918013,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f6fdb248-6ad1-413e-8dd4-340f937616f2/width=450/918013.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHHw}u9ZPTxG~qV?-p9GtlX7-pV@IpNHaeae",
                                    "type": "image"
                                },
                                {
                                    "id": 918016,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c107a65c-fb63-4b48-a984-d93b6beec557/width=450/918016.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDIqT7001#-A*JV@_MIUIVNG$jWq0LofxtV@",
                                    "type": "image"
                                },
                                {
                                    "id": 918017,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1422a64-bcc2-4892-a7c8-d7924aaa32b9/width=450/918017.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UCE{U@S~00~X56kD%Nxu00wJMyIU01R5#jNI",
                                    "type": "image"
                                },
                                {
                                    "id": 918019,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9b3f0b1a-9dc2-4b0d-b710-f73f35e02468/width=450/918019.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGGu,w4nuP=|TM-ot89F00xu9FjEK7Ip?Gxa",
                                    "type": "image"
                                },
                                {
                                    "id": 918022,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/63a87da1-051a-42d2-ad17-f228668e2b6f/width=450/918022.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIGk?yX80L~V?axZ=|NGocoK%LE1SeR*xt%2",
                                    "type": "image"
                                },
                                {
                                    "id": 918020,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c95fa8f5-37e0-4225-b09c-0555f9b2fe4d/width=450/918020.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UJJ7j.Ac6TrrlVo~?cIAt8bv-VRP-:s:awE2",
                                    "type": "image"
                                },
                                {
                                    "id": 918023,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/09defc4e-6651-45b3-baca-793019c281f7/width=450/918023.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U7INjs0K00~q02R5?wE10N%K~pwwITM|IUox",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81720"
                        }
                    ]
                },
                {
                    "id": 11463,
                    "name": "Saika Kawakita",
                    "description": null,
                    "poi": true,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": false,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 35446,
                        "favoriteCount": 0,
                        "thumbsUpCount": 4889,
                        "thumbsDownCount": 0,
                        "commentCount": 27,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 20
                    },
                    "creator": {
                        "username": "Ithlinni",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/494378ce-ce65-488a-f1ba-5520836fa200/width=96/Ithlinni.jpeg"
                    },
                    "tags": [
                        "girl",
                        "photorealistic",
                        "sexy",
                        "female",
                        "asian",
                        "woman",
                        "celebrity",
                        "japanese",
                        "realistic"
                    ],
                    "modelVersions": [
                        {
                            "id": 21867,
                            "name": "Saika V3.0",
                            "index": 0,
                            "modelId": 11463,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-03-12T02:10:54.832",
                            "availability": "Public",
                            "trainedWords": [
                                "saika1"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 25085,
                                "ratingCount": 3229,
                                "rating": 5,
                                "thumbsUpCount": 3239,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 18231,
                                    "sizeKB": 73838.544921875,
                                    "name": "saika___v3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-12T02:16:40.221Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "59781E87",
                                        "AutoV2": "A323E7B1B6",
                                        "SHA256": "A323E7B1B6671DCF040092B92E32E751E7CC09E2AF4C7F99CE7E2612B7404669",
                                        "CRC32": "90451DE9",
                                        "BLAKE3": "3ED9876397FDC0D225077E095E6DC8901F80DB239EE642FCD9BDD00031841A1F",
                                        "AutoV3": "2BE9DDF6A812"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/21867",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 233656,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04c1ac4e-1c57-42ca-6070-860b55073d00/width=450/233656.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UMDl.;%N0L_4Djo#tT9Z9FM_t6RjxukCj[%M",
                                    "type": "image"
                                },
                                {
                                    "id": 233659,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/97b1fe1b-fb83-4203-a046-3ba79c480600/width=450/233659.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UMHBG80K.mRQ$~RPNcRjELw_jcE1IUj[jZIp",
                                    "type": "image"
                                },
                                {
                                    "id": 233658,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/608ced00-f61b-4694-8707-f276b3183100/width=450/233658.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEI|~_DQC4~D03P7V?oM4,w~?ZIC_N9Fr;EL",
                                    "type": "image"
                                },
                                {
                                    "id": 233657,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e471838a-6665-46a2-9a90-ad514fcb9000/width=450/233657.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U89%M1~W5=56v}M_56oz9ZM{nOjFu4-;^jM{",
                                    "type": "image"
                                },
                                {
                                    "id": 233655,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aaf15a38-e056-44cd-7bee-e562cdd4d200/width=450/233655.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAC613Mx4-9]}@9tX99trWS5x^V?F2R*RO~C",
                                    "type": "image"
                                },
                                {
                                    "id": 233729,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ff33be32-63e4-4153-2ca9-aee46486b000/width=450/233729.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UYHoRW%3.mRk-=tQ%hRitRtRt8V@%MbIr;M{",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/21867"
                        },
                        {
                            "id": 15623,
                            "name": "Saika V2.0",
                            "index": 1,
                            "modelId": 11463,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-02-26T09:52:27.197",
                            "availability": "Public",
                            "trainedWords": [
                                "saika1"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 8186,
                                "ratingCount": 1349,
                                "rating": 5,
                                "thumbsUpCount": 1349,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 13366,
                                    "sizeKB": 147573.7216796875,
                                    "name": "saika__v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-26T09:56:33.909Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "F02E7F6D",
                                        "AutoV2": "09E3351008",
                                        "SHA256": "09E335100855118B6ED6D860CB055E84C410E63BFC33FE8F0DE182D6E9C98631",
                                        "CRC32": "A64BCECC",
                                        "BLAKE3": "906F37D3C4AA103981AF947C318AF318AC701D75A5F09E88EF4E8FE097141A4A",
                                        "AutoV3": "BF5C7D2F6A5C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/15623",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 156031,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eb84847a-c3e4-4fe5-0f92-285840a3f200/width=450/156031.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UCJQi_0NE+^*009Z~pM{NGRS-m9a9^xt0LNI",
                                    "type": "image"
                                },
                                {
                                    "id": 156030,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/db77b0b5-3cc0-456b-61c4-2fb98bc00c00/width=450/156030.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UEGRr9_40z-=00D%X99a00ROogjYxuX8xZ-o",
                                    "type": "image"
                                },
                                {
                                    "id": 156029,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ff6ebace-7352-44ce-1b6a-1d9fb31eec00/width=450/156029.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UDLp%48^GsaJ1j00?bIV^+R#~Vr?.St7nm9u",
                                    "type": "image"
                                },
                                {
                                    "id": 156028,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c2845328-5370-4d15-9829-49031d58b300/width=450/156028.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UXLza8IVY5x]yZM|?bxu?IbZ?It8tRWYM{R*",
                                    "type": "image"
                                },
                                {
                                    "id": 156027,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5aedb188-0aee-4d1d-4c72-d676ac6bd400/width=450/156027.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "U9H-ZE4n0zH?2exH~Cs8A3-U^%ELyE9@Dkxv",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/15623"
                        },
                        {
                            "id": 13571,
                            "name": "Kawakita V1",
                            "index": 2,
                            "modelId": 11463,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-02-21T16:06:03.888",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2175,
                                "ratingCount": 304,
                                "rating": 5,
                                "thumbsUpCount": 305,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 12001,
                                    "sizeKB": 147569.703125,
                                    "name": "kawakita.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-21T16:11:22.578Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "C9745787",
                                        "AutoV2": "7E7EFDF1A4",
                                        "SHA256": "7E7EFDF1A4C75B766786ACC4683227A0B7FA651DF6D5A20349FA49CFE25FF4AF",
                                        "CRC32": "C50E9B96",
                                        "BLAKE3": "93C7E07F2E95C780408B67AFD58F49C92881799DC603A5DCBCD577C6B1F07B06",
                                        "AutoV3": "17EA0AB76A89"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/13571",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 131239,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e6a1a485-625b-40f3-5c74-1ba372ef8400/width=450/131239.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UdIhy:_4?wxux]V@xuoKfRt7f5bHt7t7WAWB",
                                    "type": "image"
                                },
                                {
                                    "id": 131244,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cac9420b-1552-4c4a-4d28-1619e8ff4700/width=450/131244.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UuIF6,Ri_Nxt-;WVkCozt7j[V@WBt8j]kCj]",
                                    "type": "image"
                                },
                                {
                                    "id": 131243,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1533185-9f18-46b3-4bd4-aac34bbeeb00/width=450/131243.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UVHoB[4T_N%N.9IUxuogxtt8ofRit8a#ofs:",
                                    "type": "image"
                                },
                                {
                                    "id": 131242,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/01dd406d-11bc-407d-dd47-305542dcb500/width=450/131242.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UwJ*n[V@_Nxu-;t7t7azs:fQaeRjt8WBofof",
                                    "type": "image"
                                },
                                {
                                    "id": 131241,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/98679a38-93b3-4728-77e8-a8b4d0ef7f00/width=450/131241.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UhJ*YZkC?^adyDt7%LM{ogkCV@RP%MogaeRk",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/13571"
                        }
                    ]
                },
                {
                    "id": 23167,
                    "name": "Pony Character Concept Art XL & 1.5 by creativehotia",
                    "description": "<h3 id=\"heading-9\"><span style=\"color:rgb(213, 223, 232)\"> Lora xl with dpo technology experimental natural language:</span></h3><p><span style=\"color:rgb(199, 136, 18)\">Experiment with the scores to get the desired details with the promt:</span></p><p><span style=\"color:rgb(199, 136, 18)\">score_9, score_8_up, score_7_up, score_6_up, score_5_up, score_4_up,</span></p><p><span style=\"color:rgb(230, 73, 128)\">READ: works with specific models with dpo technology, do not try them with other xl models because it will not work:</span></p><p>Best models:</p><ul><li><p><span style=\"color:rgb(75, 173, 88)\">Pony Diffusion XL V6</span></p></li></ul><ul><li><p><strong><span style=\"color:rgb(75, 173, 88)\">Pony Diffusion for Anime</span></strong></p></li><li><p><strong><span style=\"color:rgb(75, 173, 88)\">AutismMix SDXL</span></strong></p></li></ul><h3 id=\"heading-10\">Triggers words: conceptart,multiple views,white background,simple background</h3><h3 id=\"heading-46\">Weight: 1</h3><h3 id=\"heading-61\">Comisions on <a target=\"_blank\" rel=\"ugc\" href=\"https://www.fiverr.com/creativehotia/create-loras-of-your-favorite-character-in-stable-diffusion\"><span style=\"color:rgb(250, 176, 5)\">Fiverr </span></a><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/CreativeHot\"><span style=\"color:rgb(253, 126, 20)\">Patreon </span></a><a target=\"_blank\" rel=\"ugc\" href=\"https://twitter.com/Creativehotia\"><strong><span style=\"color:rgb(64, 192, 87)\">Twitter</span></strong></a></h3><p><img src=\"https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3aca9f7e-bfb8-435c-879a-3a78e2c00800/width=525/3aca9f7e-bfb8-435c-879a-3a78e2c00800.jpeg\" /></p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit"
                    ],
                    "allowDerivatives": false,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 5,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 22027,
                        "favoriteCount": 0,
                        "thumbsUpCount": 4775,
                        "thumbsDownCount": 1,
                        "commentCount": 9,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 70
                    },
                    "creator": {
                        "username": "Creativehotia",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/207fe312-0371-404e-ae7c-f1b84a9dfe90/width=96/Creativehotia.jpeg"
                    },
                    "tags": [
                        "anime",
                        "landscapes",
                        "sprites",
                        "3d",
                        "person",
                        "sexy",
                        "female",
                        "digital art",
                        "consistent character",
                        "highly detailed",
                        "concept art",
                        "model",
                        "style",
                        "art style",
                        "video game character",
                        "illustration",
                        "2d",
                        "artist",
                        "artstyle",
                        "beautiful",
                        "digital illustration",
                        "game character",
                        "man",
                        "portraits",
                        "video game",
                        "conceptual",
                        "2d art",
                        "2d sprite"
                    ],
                    "modelVersions": [
                        {
                            "id": 361175,
                            "name": "Pony Xl concept V1",
                            "index": 0,
                            "modelId": 23167,
                            "baseModel": "Pony",
                            "nsfwLevel": 5,
                            "description": "<p>xl pony version</p>",
                            "publishedAt": "2024-02-26T01:32:11.844",
                            "availability": "Public",
                            "trainedWords": [
                                "conceptart,multiple views,white background,simple background"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 5311,
                                "ratingCount": 99,
                                "rating": 4.98,
                                "thumbsUpCount": 637,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 288482,
                                    "sizeKB": 56078.35546875,
                                    "name": "concept-10.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-26T01:20:47.681Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "0CBA5960",
                                        "AutoV2": "88F8CAA6FF",
                                        "SHA256": "88F8CAA6FFC303684B2605ECAC9AAD35706B7759F61175FFBBBA755AAA5B1F67",
                                        "CRC32": "8E1FD359",
                                        "BLAKE3": "350B7C3344B40404857D883CD49669BE7D99CF2A123ABEFF685829CF7942F3B6",
                                        "AutoV3": "EB609E85D608"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/361175",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 7120986,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a64e79e9-490e-4561-9232-76fc435cc788/width=450/7120986.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 832,
                                    "height": 1216,
                                    "hash": "UGIEtzAb?c~Bw^x]X8jZ~W-pM|D%#mkqt7sn",
                                    "type": "image"
                                },
                                {
                                    "id": 7120979,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/950f589b-cb30-4a69-820b-850c3403c200/width=450/7120979.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 832,
                                    "height": 1216,
                                    "hash": "U$PP[nt7_Nt7oLayozof-;ayM{t7ofWBj@of",
                                    "type": "image"
                                },
                                {
                                    "id": 7120981,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b6b9c084-9906-426a-b91e-bf976935e4c3/width=450/7120981.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 832,
                                    "height": 1216,
                                    "hash": "UBEourtR~qV?VrM{xuxu?v%MxvWWW=tRxun$",
                                    "type": "image"
                                },
                                {
                                    "id": 7120985,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80b084ea-8539-4585-b760-ca96cee10bdb/width=450/7120985.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 832,
                                    "height": 1216,
                                    "hash": "UZIORrR*-;-;~pxuRkRj_3ofofWB_3M{WAay",
                                    "type": "image"
                                },
                                {
                                    "id": 7120988,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80939050-e9e5-4d4e-9327-535fe6cd94fc/width=450/7120988.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 832,
                                    "height": 1216,
                                    "hash": "U7C?v3o~xu-:00WYodaz~q?bM{M{DhDiR*kC",
                                    "type": "image"
                                },
                                {
                                    "id": 7120989,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/96ee3201-3b82-4405-a193-e21133803a26/width=450/7120989.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 832,
                                    "height": 1216,
                                    "hash": "UEJu1E?b%fRO4nRjWBt7~qt7WBWXkBoet7M{",
                                    "type": "image"
                                },
                                {
                                    "id": 7120992,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c92e5831-26eb-4d43-b127-1398a60ac312/width=450/7120992.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 832,
                                    "height": 1216,
                                    "hash": "UMG8=tDi~WD%afof%MxZ~qIns:s:ozjZRjS2",
                                    "type": "image"
                                },
                                {
                                    "id": 7120983,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/13c16388-efb2-45d2-8c71-18dabf47d99b/width=450/7120983.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 832,
                                    "height": 1216,
                                    "hash": "UBJkWODi_Nkq%400t7ad-=4._39Ft99FDi_2",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/361175"
                        },
                        {
                            "id": 115612,
                            "name": "v1.0 new version",
                            "index": 1,
                            "modelId": 23167,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-07-11T22:25:11.102",
                            "availability": "Public",
                            "trainedWords": [
                                "2dcharacter,simple background,multiple views,reference sheet,white background"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4649,
                                "ratingCount": 343,
                                "rating": 5,
                                "thumbsUpCount": 674,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 82400,
                                    "sizeKB": 36991.6767578125,
                                    "name": "2dcharacter.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-11T22:20:43.659Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "2F8B2607",
                                        "AutoV2": "94C7E71262",
                                        "SHA256": "94C7E71262C53CE0818BF4844289F158FCD65325D25385A4664F76FFB73547F8",
                                        "CRC32": "B1062A6B",
                                        "BLAKE3": "4D9AC35EB9C04B52E905C64877DD97E3EDFEA772DFF507B5CB4F9C01FAFFDDB7",
                                        "AutoV3": "E49A857E08F2"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/115612",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1515367,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b22ae7e6-7d7c-4c10-8dee-a1829a40597d/width=450/1515367.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UPJH{%x]t8Vs-;RPRPtR~q?bjZWB%MayxuRj",
                                    "type": "image"
                                },
                                {
                                    "id": 1515384,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9399afdb-4faf-4018-a631-683983861bc2/width=450/1515384.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UUJkTExu~q%g%1t7t7j[tRt8Ioays9kCayj@",
                                    "type": "image"
                                },
                                {
                                    "id": 1515370,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bc5b14c6-d03b-4a3e-a77c-fffccbd796c5/width=450/1515370.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UQFi79oL-=RO~WWBozV@?Hoft7M{xuoLaf%M",
                                    "type": "image"
                                },
                                {
                                    "id": 1515366,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/66b5627a-a01b-4c85-9e83-d0fdbf7d39a4/width=450/1515366.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIHeXz%gtRRj-qIUMxx[.8?btRoz_N.8$*xF",
                                    "type": "image"
                                },
                                {
                                    "id": 1515371,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ec42fd59-a5a3-4f1f-8264-258b4b9f252c/width=450/1515371.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UbKnbx.8xa?bfkWAWBWV~qxuRjRjof%Mayt7",
                                    "type": "image"
                                },
                                {
                                    "id": 1515374,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5c032932-41ce-4b3f-b6fd-681f80c110c9/width=450/1515374.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UaJ*Yb-=_N-;%2D$IVS5M|IURi%M%gtRt7xG",
                                    "type": "image"
                                },
                                {
                                    "id": 1515368,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/097562ea-d121-4c87-8332-c5d93d90a043/width=450/1515368.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UKJas4x]oMNH%hoytRRiMxaexuRj_4j]xuad",
                                    "type": "image"
                                },
                                {
                                    "id": 1515377,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f7d4c79-aed3-4596-9d12-7159b8f7adfb/width=450/1515377.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UJL4pSV@~qtRRj-;WBIU-pRjM{?H?HM{ozV@",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/115612"
                        },
                        {
                            "id": 29226,
                            "name": "old version",
                            "index": 2,
                            "modelId": 23167,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": "<p>Space theme was added to assets and weapons, it may be limited but it works well, the conceptual art of characters was improved, weapon improvements and new designs</p><p>recommendation to use controlnet and hirex fix for better quality I hope you enjoy it</p>",
                            "publishedAt": "2023-03-26T01:36:26.811",
                            "availability": "Public",
                            "trainedWords": [
                                "2dsprite assets",
                                "2dsprite character",
                                "2dsprite armor",
                                "2dsprite weapons"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 12067,
                                "ratingCount": 3485,
                                "rating": 5,
                                "thumbsUpCount": 3533,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 24157,
                                    "sizeKB": 36976.1103515625,
                                    "name": "2DspriteV2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-26T01:40:50.742Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "D0B8E343",
                                        "AutoV2": "9EB90869FC",
                                        "SHA256": "9EB90869FC933E9E23718D4764FB534EC5037920A6FD116CAA3C4EDBE8BBA137",
                                        "CRC32": "084EA8E3",
                                        "BLAKE3": "568DA2C921098D51CAF50F67E68881A9074A74F321F39A43DCF2E98AE2C49FA9",
                                        "AutoV3": "029529578F83"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/29226",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 330270,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0a93ad68-6798-4798-544e-18fe4df7ef00/width=450/330270.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "U6Hn?9Md~WtR^Poz9a%gyD%#E2_M?vIo-;%2",
                                    "type": "image"
                                },
                                {
                                    "id": 330269,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/693c6157-0a90-41c5-4147-f1e35877db00/width=450/330269.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UBG8ZU}r%L}?0LEME2M{4UEjjY-p4;EMn%Ip",
                                    "type": "image"
                                },
                                {
                                    "id": 330268,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b5b594fd-3725-41cc-ef1d-9ffe3bffa200/width=450/330268.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "U4D9eX4;DiKjD*Di^OX98_9H^jaeIV~UfjxE",
                                    "type": "image"
                                },
                                {
                                    "id": 330267,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ce018051-583c-4f1f-0da9-47f7d45ff600/width=450/330267.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "U5C%8Dwd00k=^j_NXn8x019GMd%gH?4:4:VY",
                                    "type": "image"
                                },
                                {
                                    "id": 330266,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e8337e5e-0694-4a37-ae35-9ea1904eb200/width=450/330266.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UAFFQrt84UM_kWD*tR-os:9Gxt~V^ii^xE%f",
                                    "type": "image"
                                },
                                {
                                    "id": 330265,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e23d0f1-ce11-42f9-68af-f737b3bd6b00/width=450/330265.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UDGle5V{%hxsRjIUtOah?wRiDibI.6n$xIV[",
                                    "type": "image"
                                },
                                {
                                    "id": 330264,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/be2affe1-697b-4208-1af5-d4f685b77800/width=450/330264.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "U5F5_~?%G@JERsE8rW$f01smMz=08y?EOXE#",
                                    "type": "image"
                                },
                                {
                                    "id": 330263,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8a9c17d2-4198-4754-ae89-54a1e3d6c700/width=450/330263.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UBIEk89H%M%2%OoeRQS5_Nx?RQ%0.5%Mt3$$",
                                    "type": "image"
                                },
                                {
                                    "id": 330262,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7bf0d342-7e83-4e9e-571f-b34d7ab50800/width=450/330262.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UNKBO6_3M{?b~qIUITt7tR9FWBae?bae%Mt7",
                                    "type": "image"
                                },
                                {
                                    "id": 330261,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/94842d78-7b70-4e4f-9ac8-14b5bca5ff00/width=450/330261.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UDG9HcIVofR+%1tRx]of_NM{IAV@x]adMxWC",
                                    "type": "image"
                                },
                                {
                                    "id": 330260,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5b42f570-b18e-481c-4b15-49dd2471d800/width=450/330260.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "U5Fr*A?uo~00~UozE2%101Dj9F_M?uIURPSO",
                                    "type": "image"
                                },
                                {
                                    "id": 330259,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ab452fc1-4e38-4da8-7ade-4851bbc8fd00/width=450/330259.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UCGleUsm_M%gxtt6M|oft6xta#R+%LaxM{j[",
                                    "type": "image"
                                },
                                {
                                    "id": 330258,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80d0452e-54cb-479c-fa17-b67248e1da00/width=450/330258.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "U7H2r~x]_MR5?GVsIUt7jYWEozRP-;M{ayx[",
                                    "type": "image"
                                },
                                {
                                    "id": 330257,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cd82db90-1a81-483c-34d5-374dcd3ecc00/width=450/330257.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "U5Hy8j_N00t700RP%LV?00IAR,RjIAkBRjW=",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/29226"
                        }
                    ]
                },
                {
                    "id": 5529,
                    "name": "Eye - LoRa",
                    "description": "<h1>Eyes</h1><p>Token: <strong>loraeyes</strong></p><p>Weight:<strong> 0.8 [Change according to your usage]</strong></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent",
                        "Sell"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 41259,
                        "favoriteCount": 0,
                        "thumbsUpCount": 4754,
                        "thumbsDownCount": 2,
                        "commentCount": 12,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 30
                    },
                    "creator": {
                        "username": "Kokoboy",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/691c6b90-336e-4f84-80b0-e3b4359d3800/width=96/Kokoboy.jpeg"
                    },
                    "tags": [
                        "anime",
                        "eyes",
                        "reflection"
                    ],
                    "modelVersions": [
                        {
                            "id": 6433,
                            "name": "Eyes_V1.0",
                            "index": 0,
                            "modelId": 5529,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Dataset Image: 110<br />Image Sources: Pixiv &amp; Pinterest</p>",
                            "publishedAt": "2023-01-28T12:24:52.066",
                            "availability": "Public",
                            "trainedWords": [
                                "loraeyes"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 41259,
                                "ratingCount": 3998,
                                "rating": 5,
                                "thumbsUpCount": 4754,
                                "thumbsDownCount": 2
                            },
                            "files": [
                                {
                                    "id": 6800,
                                    "sizeKB": 31286.2744140625,
                                    "name": "Eyes.zip",
                                    "type": "Training Data",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-01-29T08:10:48.286Z",
                                    "metadata": {
                                        "format": "Other"
                                    },
                                    "hashes": {
                                        "AutoV1": "09F5537C",
                                        "AutoV2": "1206312F35",
                                        "SHA256": "1206312F35D777C1A4912FCAE9425306C69491B09B5E33F7B47C679DE7FD1967",
                                        "CRC32": "631A44A0",
                                        "BLAKE3": "DC28E7B969177783EA56CC43B01720C16BA02A7EE11DBD7EFEECF56756A0A038"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/6433?type=Training%20Data"
                                },
                                {
                                    "id": 6665,
                                    "sizeKB": 147533.8095703125,
                                    "name": "Loraeyes_V1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-01-28T12:26:25.570Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "171FCBB8",
                                        "AutoV2": "9E1907C7D8",
                                        "SHA256": "9E1907C7D8AAA662BB624D11C569C4AD8E8BBA83F04C67A58EB9318AC6CD04D8",
                                        "CRC32": "952490D0",
                                        "BLAKE3": "5E61D6A8C05C7AD0F604C92A7CEF271F175D316420F51C88A72CF2F78B404FD2",
                                        "AutoV3": "DA8286D2AB99"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/6433",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 59640,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/85f9b688-0356-499d-dd41-e8a4e6250a00/width=450/59640.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "U%LD+7~VX-ozM{jFogt6r=RjJ.ofXmoyv}r?",
                                    "type": "image"
                                },
                                {
                                    "id": 57784,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/73e83197-2e3b-4e17-9d00-831d125d8800/width=450/57784.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UENlGh00#*D,00uN%2Rj{0Ki0NP8=#OTIAX8",
                                    "type": "image"
                                },
                                {
                                    "id": 57790,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80249fea-181b-4d40-bfc5-7ff32b20b000/width=450/57790.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "U9G@x-Ub00kW02PV9uZ$OX={rC-p~CVsE3S$",
                                    "type": "image"
                                },
                                {
                                    "id": 57789,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/69274ed8-d65e-41be-8806-0ec11cd0ab00/width=450/57789.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UCJHjx00J7Fs00~9~BxGRD$w0x%M_3icD%NK",
                                    "type": "image"
                                },
                                {
                                    "id": 59639,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4819913c-3f1e-4aab-efbd-2633fb411700/width=450/59639.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UjKU[;~BO=V@0zRjsVS~%0s+RkofozkVwIr?",
                                    "type": "image"
                                },
                                {
                                    "id": 57780,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3c7b14a4-c411-497d-068c-dee5b71fdf00/width=450/57780.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2048,
                                    "height": 671,
                                    "hash": "UhMa9Gxbxut7?wR*WBaz~XkCoLay_3ofR*fk",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/6433"
                        }
                    ]
                },
                {
                    "id": 7252,
                    "name": "CharTurnerBeta - Lora (EXPERIMENTAL)",
                    "description": "<h2>This thing is EXPERIMENTAL.</h2><p>It 100% will try to take over your style and character.</p><p>Please use caution. Also, weight it down to .2-.4</p><p></p><p>Mixes well with <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/3036/charturner-character-turnaround-helper\">charTurnerV2</a></p><p> and is being released EARLY and BEFORE IT'S READY because a few prompts in charTurnerV2 mention it.</p><p></p><p>I know it has problems. I KNOW IT DOES. It's a <em>beta</em>.  :D</p><p> </p><p>Use at your own risk. :3  </p><p> - mouse</p><p> </p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 31265,
                        "favoriteCount": 0,
                        "thumbsUpCount": 4738,
                        "thumbsDownCount": 0,
                        "commentCount": 27,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 0
                    },
                    "creator": {
                        "username": "mousewrites",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bdfe115f-4430-4ee7-31bc-eff38f86c500/width=96/mousewrites.jpeg"
                    },
                    "tags": [
                        "consistent character",
                        "utility",
                        "tool"
                    ],
                    "modelVersions": [
                        {
                            "id": 8527,
                            "name": "CharTurnBetaLora",
                            "index": 0,
                            "modelId": 7252,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>beta, use at your own risk.</p><p>Small grids: lora strength 0-1 over three seeds in different models.</p><p> Large grids: Lora strength 0-1 vertical, CharTurnerv2 strength 0-1 horizontal, in different models.</p><p>(uploading error, will upload soon) Clip Skip: I use both 1 and 2. There's a protogen grid showing both clip 1 and clip 2</p>",
                            "publishedAt": "2023-02-07T19:40:35.173",
                            "availability": "Public",
                            "trainedWords": [
                                "charturnbetalora"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 31265,
                                "ratingCount": 4189,
                                "rating": 5,
                                "thumbsUpCount": 4738,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 8406,
                                    "sizeKB": 147570.646484375,
                                    "name": "charTurnBetaLora.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-07T19:45:57.707Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "6755E849",
                                        "AutoV2": "1128414775",
                                        "SHA256": "11284147758D894F6E99807661A669D252BF9D8406384DCF5ED61160F69E3E10",
                                        "CRC32": "0A5C7E2B",
                                        "BLAKE3": "89BABAD6E284778409021F3F3DA3C6116CDFDD1EAE2AAEBB350A6BD561C6C420",
                                        "AutoV3": "3EA4D28A604F"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/8527",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 84069,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b378b1b4-2fa3-4229-c57c-791eac4b8400/width=450/84069.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1056,
                                    "height": 768,
                                    "hash": "U29jQ0baEKbF00NHIpM|~qI:NHR+00%1-U%1",
                                    "type": "image"
                                },
                                {
                                    "id": 81049,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/755abdb3-5800-46c4-8fe3-15b182e2d000/width=450/81049.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1852,
                                    "height": 1324,
                                    "hash": "U06akt~35Yxa}=R-9$WX5GNdR-oK~NR-ERR-",
                                    "type": "image"
                                },
                                {
                                    "id": 84087,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/825e680b-e62d-4a68-cd4e-fa0579616400/width=450/84087.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2160,
                                    "height": 2510,
                                    "hash": "UOF$Y7~q_3_3%2ofoLofM_RjRjR*-;kCa{oL",
                                    "type": "image"
                                },
                                {
                                    "id": 84088,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ff375b9a-479f-4790-c665-347584f5f500/width=450/84088.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2171,
                                    "height": 2532,
                                    "hash": "UKGbu8~q_3_4xbt7j[j[D%RjRjRj?boMj[of",
                                    "type": "image"
                                },
                                {
                                    "id": 84075,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/15454e10-1277-4d79-89ab-5e25176bf300/width=450/84075.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1836,
                                    "height": 1824,
                                    "hash": "UVHB}K_N?b_3WBRjWBWBV@RjRkRjRjWAWBWB",
                                    "type": "image"
                                },
                                {
                                    "id": 84074,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6639e349-ac64-4254-4c4b-0819e8ab0b00/width=450/84074.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1836,
                                    "height": 1808,
                                    "hash": "USHB;_~q_3_3V?RjWBWBWBRjRkRjRjWBWAWA",
                                    "type": "image"
                                },
                                {
                                    "id": 84073,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad533fe8-5dee-4bfe-a9ba-027225520f00/width=450/84073.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1836,
                                    "height": 1791,
                                    "hash": "UQG[$k~q_N_NnhRjR*R*kBRjRjV@R,RjWBWB",
                                    "type": "image"
                                },
                                {
                                    "id": 84072,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7faf15c1-faca-4747-6ef7-928c647d8400/width=450/84072.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1836,
                                    "height": 1806,
                                    "hash": "UQHed@_N_3_NRjRjWBWBRjV@RkV@RjWBR*WB",
                                    "type": "image"
                                },
                                {
                                    "id": 84071,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e3a9374-bb4b-457e-29b5-3728fe46e200/width=450/84071.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1836,
                                    "height": 1835,
                                    "hash": "UUG8.h_N_3_3jFRjWBRkR*RjRjR*RkWBRkWA",
                                    "type": "image"
                                },
                                {
                                    "id": 84070,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bb8cc181-0e14-4361-4d82-0e8e787f0f00/width=450/84070.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1836,
                                    "height": 1824,
                                    "hash": "URG[vT_N_4_3V?RjRjRjR*RjRjRjNHV@WAWB",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/8527"
                        }
                    ]
                },
                {
                    "id": 120096,
                    "name": "Pixel Art XL",
                    "description": "<h1 id=\"heading-63\">Pixel Art XL</h1><p>Consider supporting further research on <a target=\"_blank\" rel=\"ugc\" href=\"https://ko-fi.com/nerijs\">Ko-Fi</a> or <a target=\"_blank\" rel=\"ugc\" href=\"https://twitter.com/nerijs\">Twitter</a><br />If you have a request, you can do it via Ko-Fi<br /><br /><a target=\"_blank\" rel=\"ugc\" href=\"https://astropulse.gumroad.com/l/RetroDiffusion\">Checkout my other models at RetroDiffusion<br /><img src=\"https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c4c4d3a2-b85f-40c1-a232-6212771987f9/width=525/c4c4d3a2-b85f-40c1-a232-6212771987f9.jpeg\" /><br /></a><br />Best used in conjunction with: <a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/Astropulse/pixeldetector\"><strong>Astropulse PixelDetector</strong></a></p><p></p><p>Downscale 8 times to get pixel perfect images (use Nearest Neighbors)</p><p></p><h3 id=\"heading-7\"><strong>Use a fixed VAE to avoid artifacts (0.9 or fp16 fix)</strong></h3><h3 id=\"heading-8\"><strong><br />Best results without using, pixel art in the prompt</strong></h3><p></p><h2 id=\"heading-1982\">Tips:</h2><ul><li><p>Don't use refiner</p></li><li><p>Works great with only 1 text encoder</p></li><li><p>No style prompt required</p></li><li><p>No trigger keyword require</p></li><li><p>Works great with isometric and non-isometric</p></li><li><p>Works with 0.9 and 1.0</p></li></ul><p></p><h2 id=\"heading-1983\">Changelog</h2><ul><li><p>v1: Initial release</p></li></ul>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [],
                    "allowDerivatives": false,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 52718,
                        "favoriteCount": 0,
                        "thumbsUpCount": 4663,
                        "thumbsDownCount": 4,
                        "commentCount": 78,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 1915
                    },
                    "creator": {
                        "username": "NeriJS",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/825fb90e-671f-4399-be5c-18a2fe35b75e/width=96/NeriJS.jpeg"
                    },
                    "tags": [
                        "pixel art",
                        "style",
                        "pixelart"
                    ],
                    "modelVersions": [
                        {
                            "id": 135931,
                            "name": "v1.1",
                            "index": 0,
                            "modelId": 120096,
                            "baseModel": "SDXL 1.0",
                            "nsfwLevel": 1,
                            "description": "<p>Update compatibility with AUTOMATIC1111<br />Better coherence<br />More flexible</p>",
                            "publishedAt": "2023-08-07T16:02:34.409",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 45362,
                                "ratingCount": 1980,
                                "rating": 4.99,
                                "thumbsUpCount": 3488,
                                "thumbsDownCount": 4
                            },
                            "files": [
                                {
                                    "id": 99321,
                                    "sizeKB": 166545.94921875,
                                    "name": "pixel-art-xl-v1.1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-08-07T16:00:42.028Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "1643DE9F",
                                        "AutoV2": "BBF3D8DEFB",
                                        "SHA256": "BBF3D8DEFBFB3FB71331545225C0CF50C74A748D2525F7C19EBB8F74445DE274",
                                        "CRC32": "B8AF58B7",
                                        "BLAKE3": "E90959513C166BDF9A33D14E20DB4C003559C98C8F16C1F90FAF6F60089D3435",
                                        "AutoV3": "DBE5CDF5F8F4"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/135931",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1918193,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0770e5fc-4260-4e3c-a0ee-bf2253028e9f/width=450/1918193.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UBM8E0x[4Sx]%Laff+of1cWV^6s;-Uj[NIWC",
                                    "type": "image"
                                },
                                {
                                    "id": 1918242,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/684efffb-c290-4e5b-b0be-90b3e7234a89/width=450/1918242.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U5OWQY?H?^?a^*ayR.og%~a|H?oL-=ofskRP",
                                    "type": "image"
                                },
                                {
                                    "id": 1918331,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6c54e73b-ee6f-4ca4-b683-f6aa619894c1/width=450/1918331.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UYPPZG9E10R+_3M{?wo}%#-;iwxa.8xvnij]",
                                    "type": "image"
                                },
                                {
                                    "id": 1918359,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/21af48d8-0538-4065-bba2-385e4b189d90/width=450/1918359.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U7M70^%L0}%Mw@j[tmay0ej[~Cay?wayDhoe",
                                    "type": "image"
                                },
                                {
                                    "id": 1918636,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fc960370-d609-44ec-9f2d-ab0d32217f58/width=450/1918636.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UFHu14jKAG-C|6r^F?ja0]s9%1I:B-Nr[csA",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/135931"
                        },
                        {
                            "id": 130580,
                            "name": "v1.0",
                            "index": 1,
                            "modelId": 120096,
                            "baseModel": "SDXL 1.0",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-07-31T22:04:04.651",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 7356,
                                "ratingCount": 940,
                                "rating": 5,
                                "thumbsUpCount": 1188,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 94718,
                                    "sizeKB": 166545.94921875,
                                    "name": "pixel-art-xl.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-31T22:05:48.203Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "BA61190A",
                                        "AutoV2": "4234637CB8",
                                        "SHA256": "4234637CB80C998F41E348E6A6CB6BC20D8D038B2B0F256B6129B3B5E353EEF7",
                                        "CRC32": "03A0729F",
                                        "BLAKE3": "8A5F8DD0CABDDE860D74925682EAB182BE4607EA0981219C051BC37FCFF8FB06",
                                        "AutoV3": "E764D20C687C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/130580",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1814841,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9baa0b1f-1439-45bc-9716-2137c2b865f6/width=450/1814841.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UBJ8-8-;3Y9ZxurWbITe1PRO}T%h$gTdS#vL",
                                    "type": "image"
                                },
                                {
                                    "id": 1814896,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1aa2aea6-acc9-4802-a8cf-6a486fb3b453/width=450/1814896.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 960,
                                    "height": 960,
                                    "hash": "UCPPGYn3D2?vXLoz%gW-Y5kWQmaJ_Mj=IVRk",
                                    "type": "image"
                                },
                                {
                                    "id": 1814842,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b62cbc88-5e5e-41e6-aeb6-7b82b6b30047/width=450/1814842.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U5Eec8OW0v-om,sp.Tni%Es9*_Na0vW.+FX4",
                                    "type": "image"
                                },
                                {
                                    "id": 1814894,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4bc295c6-314e-4970-b554-a02bb997db56/width=450/1814894.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 960,
                                    "height": 960,
                                    "hash": "UVO{?Xt7Nxxa?^WVRkWC=tjYjEay%1j[IokB",
                                    "type": "image"
                                },
                                {
                                    "id": 1814897,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c16bc58a-4c91-46e7-b32c-56e9d841a2bf/width=450/1814897.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 960,
                                    "height": 960,
                                    "hash": "UDHeXpbvCk$*$irrOXS~D3w_zpN^K%O?#m#8",
                                    "type": "image"
                                },
                                {
                                    "id": 1814843,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5b936081-6fc1-4983-a3a0-9be0129f7f44/width=450/1814843.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UBBOgJt7CmTIcEjXnibJKQWV#*spv}j^S~X3",
                                    "type": "image"
                                },
                                {
                                    "id": 1814891,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f390725-93e0-44e5-a45c-8cddec284d22/width=450/1814891.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 960,
                                    "height": 960,
                                    "hash": "U3LzHKv#~A-V}sxF,pSh#89bJVV@^*rDS$$z",
                                    "type": "image"
                                },
                                {
                                    "id": 1814895,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aa381da3-63c8-4df3-a63c-2847ffb29380/width=450/1814895.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 960,
                                    "height": 960,
                                    "hash": "UAFXq|+Z?a:%CAv}J:#k%~W;xsS#8JslbbWB",
                                    "type": "image"
                                },
                                {
                                    "id": 1814893,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a96df9b7-fbc3-4471-a4a3-81fdfb87afcf/width=450/1814893.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 960,
                                    "height": 960,
                                    "hash": "ULJiz+O@%1t7wIbcoLoe}RsmR+WVaLV@WVWX",
                                    "type": "image"
                                },
                                {
                                    "id": 1814892,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e624f01-e7f4-4cbd-bf84-0393dc441058/width=450/1814892.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 960,
                                    "height": 960,
                                    "hash": "U5I?KH=XLN%2~S+YOaOt%|%xkpMy%#Seroi_",
                                    "type": "image"
                                },
                                {
                                    "id": 1818851,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d2cf9094-87ce-4c6c-ba5e-eb7482fe7e30/width=450/1818851.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UAKnYxxvpyxu-obHNKj@yZf6VDbHyFj?rVWX",
                                    "type": "image"
                                },
                                {
                                    "id": 1818875,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fc4142a0-d963-492f-9a6a-b73c72b4e04b/width=450/1818875.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1920,
                                    "height": 1024,
                                    "hash": "UVF#:o?c~q?b-;t7ofj[%gWBRjRj-;f6WBWB",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/130580"
                        }
                    ]
                },
                {
                    "id": 21722,
                    "name": "Vivid Impactful Style (Yoneyama Mai [米山 舞]  Style Likeness) - LoRA/LoCon",
                    "description": "<h1>Vivid Impactful Style</h1><h3>An Artstyle Lora With High Compatibility</h3><p><strong>Important: Now, <u>LoCon</u> version is out!</strong></p><ul><li><p>Recommeneded prompts: Please check sample pictures.</p></li><li><p>Trigger word: vvi\\(artstyle\\), vvi\\(face\\),vvi\\(eyes\\),vvi\\(oa\\)</p><p>Note: You can use vvi\\(artstyle\\) to trigger the artsyle lora. If you want to generate portriats, I would recommand you use vvi\\(face\\),vvi\\(eyes\\) thses two trigger words to get a better performance. You can use vvi\\(oa\\) to trigger the offcial_art like style.</p></li><li><p>Recommeneded Weight: 0.6-1 (You can adjust it by your perference.)</p></li><li><p>CFG scale: 5.5-7</p></li><li><p>Check Point/Base Model recommendation: Anything V4.5, Dan Mix</p></li><li><p>Special thanks:</p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/26417/artoria-caster-lycoris\"><strong>Artoria Caster (アルトリア・キャスター) - Lycoris</strong></a></p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/21333/atelier-shallie-shallotte-elminus-lora\"><strong>Atelier Shallie - Shallotte Elminus LoRA</strong></a></p><p>(Lora usage in sample)</p></li><li><p><s>I am planning to release a LoHA version next week. </s> No significant difference between LoCon and LoHa version. I will release a new version if I can get a larger training set.</p></li><li><p>How to use LoCon/LyCORIS? Please read instruction of <a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/KohakuBlueleaf/a1111-sd-webui-locon\">a1111-sd-webui-locon</a>.</p><p></p><p>What's the different between v4g-lora and v4h-locon? Since I did not change the training set, I anticipate that they will have the same impact on your generated images. After hours of testing, I couldn't find any significant difference between these two models. The v4h-locon may be slightly superior to the v4g-lora.</p><p>So, why am I still releasing this Locon? Because this v4h-locon has a file size advantage. It uses 100 mb less hard drive space,but still works great flawlessly.</p><p>v4g-lora和v4h-locon有什么不同？由于我没有改变训练集，我预计它们对您生成的图像将具有相同的影响。经过几个小时的测试，我无法找到这两个模型之间的任何显着差异。v4h-locon可能略优于v4g-lora。</p><p>那么，为什么我仍然要发布这个Locon模型呢？因为v4h-locon具有文件大小优势。Locon 模型比Lora模型小100 mb，但仍能完美无缺地运行。</p><p></p><p>Comparison (对比): All samples were generated with Anything V4.5 or Dan Mix V2.3 （底模：Anything V4.5/Dan Mix V2.3）</p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d4f2abd7-1740-4524-13ac-a315c61bce00/width=525/d4f2abd7-1740-4524-13ac-a315c61bce00\" /><p>vvi\\(artstyle\\), 1girl,solo,long hair, blonde hair, city lights, cityscape, bandages, city, night, jacket, railing, outdoors, wind, black jacket, building, shirt, cigarette, floating hair, sky, brown hair,upper body, arms behind back, &lt;lora:Vivid_Impactful_Style_locon_v4h:0.7&gt;<br />Negative prompt: EasyNegative<br />Steps: 20, Sampler: DPM++ SDE Karras, CFG scale: 5.5, Seed: 2308100336, Size: 512x1024, Model hash: 79846849a1, Clip skip: 2, ENSD: 31337</p><p></p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4e8928c1-725e-43fd-7d10-d001a2206900/width=525/4e8928c1-725e-43fd-7d10-d001a2206900\" /><p>vvi\\(artstyle\\), 1girl, solo, blue eyes, parted lips, brown hair, flower, looking at viewer, bangs, portrait, lying, blue flower, long hair, colorful, long sleeves, grass, close-up, liquid hair,&lt;lora:Vivid_Impactful_Style_locon_v4h:0.7&gt;<br />Negative prompt: EasyNegative<br />Steps: 20, Sampler: DPM++ SDE Karras, CFG scale: 5.5, Seed: 872925101, Size: 512x768, Model hash: 79846849a1, Clip skip: 2, ENSD: 31337</p><p></p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/89dac257-f72c-48b9-65a7-0b2da2c17400/width=525/89dac257-f72c-48b9-65a7-0b2da2c17400\" /><p>vvi\\(artstyle\\), 1girl, solo, flower, long hair, green eyes, looking at viewer, black background, smile, white flower, hair between eyes, floating hair, closed mouth, portrait, bangs, bare shoulders, grey hair, lily (flower), simple background, eyelashes, white hair, yellow eyes, eyes visible through hair, upper body,&lt;lora:Vivid_Impactful_Style_locon_v4h:0.7&gt;<br />Negative prompt: EasyNegative<br />Steps: 20, Sampler: DPM++ SDE Karras, CFG scale: 5.5, Seed: 1147334132, Size: 768x768, Model hash: 79846849a1, Clip skip: 2, ENSD: 31337</p><p></p><p></p><p><strong>If you like my work,please give me a like &lt;3.</strong></p><p><strong>如果你喜欢我的模型请给我一个赞 &lt;3.</strong></p><p><strong>もし、私のモデルが気に入ったら、「いいね！」をクリックしてください&lt;3。</strong></p><p></p><p></p><p></p></li></ul>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [],
                    "allowDerivatives": false,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 11,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 20831,
                        "favoriteCount": 0,
                        "thumbsUpCount": 4321,
                        "thumbsDownCount": 0,
                        "commentCount": 4,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 10
                    },
                    "creator": {
                        "username": "James991116",
                        "image": "https://avatars.githubusercontent.com/u/103013280?v=4"
                    },
                    "tags": [
                        "anime",
                        "girl",
                        "style",
                        "art style",
                        "illustration",
                        "artstyle",
                        "yoneyama mai",
                        "yoneyama mai style"
                    ],
                    "modelVersions": [
                        {
                            "id": 33016,
                            "name": "v4.0h-LoCon",
                            "index": 0,
                            "modelId": 21722,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": "<ul><li><p>Please install the <a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/KohakuBlueleaf/a1111-sd-webui-locon\">Locon extension</a> before using!！</p></li><li><p>Using LoCon training method.</p></li><li><p>100 mb less in file sizes than v4.0g-lora.</p></li><li><p>Same/slightly better than v4.0g-lora.</p></li><li><p>请在使用前安装 <a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/KohakuBlueleaf/a1111-sd-webui-locon\">Locon extension</a>插件！</p></li><li><p>使用LoCon训练方法。</p></li><li><p>比v4.0g-lora文件大小少100 MB。</p></li><li><p>效果与v4.0g-lora相同或略有改善。</p></li></ul>",
                            "publishedAt": "2023-04-01T07:50:27.026",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 13686,
                                "ratingCount": 2723,
                                "rating": 5,
                                "thumbsUpCount": 3113,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 27194,
                                    "sizeKB": 43869.8173828125,
                                    "name": "Vivid_Impactful_Style_locon_v4h.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-01T07:51:11.585Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "17B246FF",
                                        "AutoV2": "2F3E83DD93",
                                        "SHA256": "2F3E83DD93E70DFEF9D6A4176D22CB74E6041BCCA41D1F6947B8DF8F83651FB9",
                                        "CRC32": "F7C59618",
                                        "BLAKE3": "E403C2FDF8867DB9921816C63CFF6D9DEB3AE59470C65F69B3A9644BBE9881DD",
                                        "AutoV3": "07F4F0D3877D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/33016",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 376140,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/26c33489-d453-4e64-914b-fc536e3d7100/width=450/376140.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UQJ*-uv~AY%g.S9[o|xu?bxunOIU_NxZIoXS",
                                    "type": "image"
                                },
                                {
                                    "id": 376146,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3674b31e-593d-40cf-b36c-700876200c00/width=450/376146.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UGKn0q~U.l%Lv#My58WXIU.8Sdoyxsov%LD$",
                                    "type": "image"
                                },
                                {
                                    "id": 376145,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6cbc2fbe-ec79-49a8-7451-bc7730789600/width=450/376145.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UYJ@@3E2_2xu~Cxux]xtnhxutRRjtSoft7of",
                                    "type": "image"
                                },
                                {
                                    "id": 376144,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dfac9f3c-b62c-43d8-f4b1-7a20c25b4900/width=450/376144.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UfJ83MkC~W%M~qWVR%oLxufRaeRjx]t7t6ay",
                                    "type": "image"
                                },
                                {
                                    "id": 376143,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b87c7170-2a6a-4caf-b5b1-12dbbd984b00/width=450/376143.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UeMjzIoK~q%MxuWBWBof_3kCM{j[M_oes:V@",
                                    "type": "image"
                                },
                                {
                                    "id": 376142,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/655ecf61-dfa4-4c14-8118-d858516bb700/width=450/376142.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UZHxZ|_2o}IA_N%gbcM{r?oeIoxuD%s:oMxa",
                                    "type": "image"
                                },
                                {
                                    "id": 376141,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f762b1e8-2505-47c3-79cf-710a6a7d7700/width=450/376141.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UMJGpP~WACi{$+WA0doeRkNFIokAxCRkxssW",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/33016"
                        },
                        {
                            "id": 30521,
                            "name": "v4.0g-LoRa",
                            "index": 1,
                            "modelId": 21722,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": "<ul><li><p>Fixed some issues in v3.0ab.</p></li><li><p>Bigger training set.</p></li><li><p>More expressive style.</p><p></p><p></p></li></ul>",
                            "publishedAt": "2023-03-28T06:48:42.207",
                            "availability": "Public",
                            "trainedWords": [
                                "vvi\\(artstyle\\)",
                                "vvi\\(face\\)",
                                "vvi\\(eyes\\)",
                                "vvi\\(oa\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3317,
                                "ratingCount": 300,
                                "rating": 5,
                                "thumbsUpCount": 302,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 25195,
                                    "sizeKB": 147609.037109375,
                                    "name": "Vivid_Impactful_Style_4g.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-28T06:51:38.766Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "15F65CFF",
                                        "AutoV2": "287A72E1DC",
                                        "SHA256": "287A72E1DC399D4D50EC444AA6CA222B8AED983901ADA2612B1D72F394876C14",
                                        "CRC32": "7B2F860D",
                                        "BLAKE3": "6970700BBF9772ED509A1D64C12FC11501AC031CA19E91DE0E42390F4CBFC7C1",
                                        "AutoV3": "BCC16997B8B6"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/30521",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 346591,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dfce1c98-40e1-4b97-b892-167accc43900/width=450/346591.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UUK0jD~WEzRON2Rk9tRiIUf+xubcofNHNGM{",
                                    "type": "image"
                                },
                                {
                                    "id": 346590,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b71db924-acb4-4272-9a43-ee85c8756f00/width=450/346590.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UfJ7?yIA%fxu~VWBRit7t7adkBaeNGt6xaae",
                                    "type": "image"
                                },
                                {
                                    "id": 346589,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/51a05c9e-8765-40a7-61ab-37a6b0151f00/width=450/346589.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UCHeIMJX00eR4T9E~q%300R4-;xb~Xt6r;xu",
                                    "type": "image"
                                },
                                {
                                    "id": 346588,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/32440991-69f8-4ac4-8e8a-4e5edd2ebc00/width=450/346588.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UBIXv_0K00^+qs%g.T9Z4ox]-;oIX99Fxu_3",
                                    "type": "image"
                                },
                                {
                                    "id": 346587,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/12aaf9ac-d81e-43e4-8da6-b92d973c7b00/width=450/346587.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UEKKKHt7%~Rk%#WB~V-pD*xa%2E1M{NG9G%M",
                                    "type": "image"
                                },
                                {
                                    "id": 346586,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ed72870a-0194-4b65-e262-5cd95f059000/width=450/346586.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "U6J@8=002^_3L*.700-=0J0K*J8_,wo~w?-3",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/30521"
                        },
                        {
                            "id": 27115,
                            "name": "v3.0ab",
                            "index": 2,
                            "modelId": 21722,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 11,
                            "description": "<ul><li><p>Changed trigger wrod from vvi\\(profile\\) to vvi\\(oa\\) for offcial_art like style.</p></li><li><p>Better training set made the LoRa model better.</p></li></ul>",
                            "publishedAt": "2023-03-22T05:18:20.455",
                            "availability": "Public",
                            "trainedWords": [
                                "vvi\\(artstyle\\)",
                                "vvi\\(face\\)",
                                "vvi\\(eyes\\)",
                                "vvi\\(oa\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2161,
                                "ratingCount": 564,
                                "rating": 5,
                                "thumbsUpCount": 564,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 22463,
                                    "sizeKB": 147607.1728515625,
                                    "name": "Vivid_Impactful_Style_3ab.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-22T05:21:41.773Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "F9EA6BB5",
                                        "AutoV2": "8991B6EBF6",
                                        "SHA256": "8991B6EBF67EA013AA1350A598227CC3A47BB01CBD8AAD0445849622D77420F8",
                                        "CRC32": "4B5483A5",
                                        "BLAKE3": "7E699EC4F6BFF959C83B63E1AB7157B98DC7C93B3E54DEFAEB6516536E2BC216",
                                        "AutoV3": "583ACB493F37"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/27115",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 330723,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/455a6cf3-582b-4121-009c-a5a8a940a100/width=450/330723.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UdLNog_3_3Rk_NozkCoeNGM{xZt7ofogxtkC",
                                    "type": "image"
                                },
                                {
                                    "id": 298725,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/abfd2e7f-932a-4c1b-83eb-665592836300/width=450/298725.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UCJRH-0J00~UK3%4Mb?v4.s;-mR%DgIU?ce=",
                                    "type": "image"
                                },
                                {
                                    "id": 298724,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/030b0bf5-f22e-4ae9-56ae-46926a9e1600/width=450/298724.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UUJk[s_NpdRP?t%2IB%MIoae-Cs.x]t8-pIV",
                                    "type": "image"
                                },
                                {
                                    "id": 298723,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d6519f6c-c884-4cd5-cf87-ee487c670f00/width=450/298723.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UCJbKt00009ZHWIpidM{?vE1]k$h5lM{WBt,",
                                    "type": "image"
                                },
                                {
                                    "id": 298722,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/96f61a38-4444-4a4f-309b-abd026e21e00/width=450/298722.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UMI}q.%Mxu^+~qNG%M%MofRjM{R*RjRjt7xu",
                                    "type": "image"
                                },
                                {
                                    "id": 298721,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/09e72d72-de28-4dca-9c99-e9eee82dae00/width=450/298721.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1280,
                                    "hash": "UAG8}}t700of^,%MRjIUofWB-;WB~qIUD%%M",
                                    "type": "image"
                                },
                                {
                                    "id": 298720,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d845828b-3cfc-4d80-b8ac-55e2a4d41400/width=450/298720.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UQJkG@9Z?w?Ix]bIo#Io01t7M{oM%2Rjs:-p",
                                    "type": "image"
                                },
                                {
                                    "id": 298719,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d931dbc3-2cea-464d-506c-11847612ec00/width=450/298719.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "U9IhdO00W*~q%N-;D%%M01WB%e%M4ot7_3D%",
                                    "type": "image"
                                },
                                {
                                    "id": 298718,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d82788c6-71a1-4c30-1083-d64e5684a800/width=450/298718.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 768,
                                    "hash": "UPL|yD4n.T-=%LNF%Mt7xuV[x]xu%Ms:tQt7",
                                    "type": "image"
                                },
                                {
                                    "id": 330540,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3568c13b-33ef-4fd1-fdd3-3f5efbb06200/width=450/330540.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "USJt-v~p9sE1.8xuadxu9aWBjENGM_t7V?M{",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/27115"
                        },
                        {
                            "id": 26057,
                            "name": "v2.0",
                            "index": 3,
                            "modelId": 21722,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 9,
                            "description": "<p>Now you can use vvi\\(profile\\) to trigger the offcial_art like style.</p>",
                            "publishedAt": "2023-03-20T08:26:14.467",
                            "availability": "Public",
                            "trainedWords": [
                                "vvi\\(artstyle\\)",
                                "vvi\\(face\\)",
                                "vvi\\(eyes\\)",
                                "vvi\\(profile\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1111,
                                "ratingCount": 253,
                                "rating": 5,
                                "thumbsUpCount": 254,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 21615,
                                    "sizeKB": 147608.365234375,
                                    "name": "Vivid_Impactful_Style_2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-20T08:31:43.319Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "2C3E19AC",
                                        "AutoV2": "61EBD24659",
                                        "SHA256": "61EBD246599DDBA2FD025153575747D9C90529ABB360BA1C7E3EBD6D198EC94E",
                                        "CRC32": "46643854",
                                        "BLAKE3": "8C6965359703B645FE2D41E26BBEFE20F2B220687EB7104ADC048F5E1D6304D0",
                                        "AutoV3": "D3FFCCC128F6"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/26057",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 286649,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d1780452-f246-4898-5a06-f6de7f758600/width=450/286649.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 832,
                                    "hash": "UHI}YS009Z~W9INZtRkCSzWX?GoNIV-;%Nf6",
                                    "type": "image"
                                },
                                {
                                    "id": 286648,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f7b05143-6be0-4911-66a7-6b016c5fb900/width=450/286648.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UKJI00oz-mM{D$xtD%WBt7IUM{Rl~q-p?bxt",
                                    "type": "image"
                                },
                                {
                                    "id": 286647,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fb1c78e4-024f-4593-cff3-4560dcd14300/width=450/286647.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "UbLNx*%M~qxu^+t7ozM{?bt7M_RjR%M{ogxu",
                                    "type": "image"
                                },
                                {
                                    "id": 286693,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/189e15e1-90d7-40d8-ecf8-e84850bd5e00/width=450/286693.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 768,
                                    "hash": "UBL4Qr9a00~W.900VX$*xti^E157Si?b9Ft7",
                                    "type": "image"
                                },
                                {
                                    "id": 286646,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9159fb51-ca62-4fed-a792-adcddc8be600/width=450/286646.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 768,
                                    "hash": "UHIX{vIUIU-;~qt7D%RjD%-;xuRjogayt7R*",
                                    "type": "image"
                                },
                                {
                                    "id": 286645,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3f3cba9d-0246-4099-dc4f-b65962b3c900/width=450/286645.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UMGIvG%L4mbI~UWF4mRjbuoZIoWBRqj^RjRk",
                                    "type": "image"
                                },
                                {
                                    "id": 286644,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6ccbd543-506d-4a83-69bc-f9b69e576800/width=450/286644.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 768,
                                    "hash": "UAJb2B_25RzT009GJC^j.T%#VsxFI?aJMwI9",
                                    "type": "image"
                                },
                                {
                                    "id": 286692,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/038b18c9-6b23-449a-f741-eb5731a29d00/width=450/286692.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 768,
                                    "hash": "UAIrBE9F00?b?bxu~qRjxu?b%MD%00-;?b9F",
                                    "type": "image"
                                },
                                {
                                    "id": 286691,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04e50f4a-a94c-43ed-db79-156978670300/width=450/286691.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "ULHn?Goz?HRk~qa}NIWXf,jZ9boLkDt7M_Io",
                                    "type": "image"
                                },
                                {
                                    "id": 286690,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7c9ce80c-3161-4f9f-603a-09fef292c000/width=450/286690.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UEGbho?E004p~Rw[D*OGK6OFw{$fVXkDXTM{",
                                    "type": "image"
                                },
                                {
                                    "id": 286689,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/19a4213f-753f-4dff-3db2-e67fa6ec6500/width=450/286689.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UBIr500000_3-;-;9Ft700D%~qxu00-;IUxu",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/26057"
                        },
                        {
                            "id": 25922,
                            "name": "v1.0",
                            "index": 4,
                            "modelId": 21722,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 11,
                            "description": "<p>This is the first version. More updates will comming soon.</p>",
                            "publishedAt": "2023-03-20T01:03:18.576",
                            "availability": "Public",
                            "trainedWords": [
                                "vvi\\(artstyle\\)",
                                "vvi\\(face\\)",
                                "vvi\\(eyes\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 556,
                                "ratingCount": 102,
                                "rating": 5,
                                "thumbsUpCount": 102,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 21519,
                                    "sizeKB": 147598.3271484375,
                                    "name": "Vivid_Impactful_Style_1-0.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-20T01:06:29.844Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "8232E315",
                                        "AutoV2": "0D61EF1760",
                                        "SHA256": "0D61EF17602038E7098B08A606A969CB0DB6611DD626FB58B1AA4DD3D4CC7F3D",
                                        "CRC32": "200DCB3B",
                                        "BLAKE3": "82765F722999973BC655C9F7ACD5D5D05FC34063FC08696DF9D222DDCCDA0491",
                                        "AutoV3": "413B6A81D0CB"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/25922",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 285082,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e2f43b8-e744-462d-97d8-d92b6bf77e00/width=450/285082.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UQMtHyoM_N.7%#xuWARj_3xuaeRj.8R%RjW=",
                                    "type": "image"
                                },
                                {
                                    "id": 285091,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d7f26d4c-095c-4a36-3270-a7911b187200/width=450/285091.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 768,
                                    "hash": "UCGR}KE-02~V0MXB_3IAxAMyM_Di9X_4s*WZ",
                                    "type": "image"
                                },
                                {
                                    "id": 285090,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f276cc37-dc70-4e77-6f38-55122a9cf900/width=450/285090.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "ULHn?Goz?HRk~qa}NIWXf,jZ9boLkDt7M_Io",
                                    "type": "image"
                                },
                                {
                                    "id": 285089,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e325d3dc-cb56-4437-f343-097cf1417500/width=450/285089.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UEGbho?E004p~Rw[D*OGK6OFw{$fVXkDXTM{",
                                    "type": "image"
                                },
                                {
                                    "id": 285088,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/07d39ef7-8153-4b41-7fea-ca4fa1d8b800/width=450/285088.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1280,
                                    "hash": "UGJ8R]xu00M{~q-;00of_3%MIUM{xuofM{Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 285087,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/13b540e7-2b61-4fd8-0313-4c3c9fd4d500/width=450/285087.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UNJt@^Di01_49t-;WVx]xtoz%Lxa9ZRi%LM{",
                                    "type": "image"
                                },
                                {
                                    "id": 285086,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0b984d06-2fba-4892-f02c-321779050200/width=450/285086.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UFIOY3_300?w?Jxax]o#00M{-V^+p0.8^+oz",
                                    "type": "image"
                                },
                                {
                                    "id": 285085,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8407b5e4-e628-49a0-72ce-6cfb6be9d400/width=450/285085.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UMIqly~q0K4oVYIoo#V@9aIU-;%MIUM{ozkW",
                                    "type": "image"
                                },
                                {
                                    "id": 285084,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dee5f673-f928-42cc-bf1a-512d26cc5300/width=450/285084.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UCLq374.00}[B,n+xuRkv#D*^5?a{U$k-WnS",
                                    "type": "image"
                                },
                                {
                                    "id": 285083,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7b60e61e-a441-4b00-0172-6e8ab72a9800/width=450/285083.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 768,
                                    "hash": "UKI=Aat-Y7-RIo~qxvV=~VxYt6E1.9xW%1Ri",
                                    "type": "image"
                                },
                                {
                                    "id": 286650,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c40a4096-1564-4e9f-631e-9d4ba230f600/width=450/286650.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 1024,
                                    "hash": "USL4jL~q_3M{D*%3oyayIAM{t7%M%Moft7j@",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/25922"
                        }
                    ]
                },
                {
                    "id": 131864,
                    "name": "breast size slider",
                    "description": "<p>breast size slider trained on no data using <a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/ostris/ai-toolkit\">https://github.com/ostris/ai-toolkit</a></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 62239,
                        "favoriteCount": 0,
                        "thumbsUpCount": 4252,
                        "thumbsDownCount": 3,
                        "commentCount": 51,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 269
                    },
                    "creator": {
                        "username": "CptPancakes",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8ee2aedd-8cc2-486f-9e95-5b8981f5a900/width=96/CptPancakes.jpeg"
                    },
                    "tags": [
                        "breasts",
                        "tool",
                        "nsfw",
                        "slider"
                    ],
                    "modelVersions": [
                        {
                            "id": 146600,
                            "name": "offset",
                            "index": 0,
                            "modelId": 131864,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>inverted the direction and changed the scale to be from -1 to 1 instead of 5 to make it easier to use the keyboard shortcuts in a1111 </p>",
                            "publishedAt": "2023-08-23T09:15:10.182",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 58113,
                                "ratingCount": 2056,
                                "rating": 4.99,
                                "thumbsUpCount": 3964,
                                "thumbsDownCount": 3
                            },
                            "files": [
                                {
                                    "id": 108578,
                                    "sizeKB": 6704.578125,
                                    "name": "breastsizeslideroffset.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-08-23T09:10:41.695Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "29849421",
                                        "AutoV2": "1D5A77D6B1",
                                        "SHA256": "1D5A77D6B141CC78D0BA21E91130BC3567C8B9575AA61D58CC1D225112EE9298",
                                        "CRC32": "1730C8B8",
                                        "BLAKE3": "C011A6FB7380FEA09B7D072D86698D0E970E7273AE5B8FF570EBB87B3D4FB6BB",
                                        "AutoV3": "CA4F2F9FBA92"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/146600",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2164413,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fb49ddc5-ac0c-4795-83af-80045f5b22a4/width=450/2164413.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 780,
                                    "height": 768,
                                    "hash": "UA9G:hOts:IU}nMxoeX9IUi_WBof74%gR*r=",
                                    "type": "image"
                                },
                                {
                                    "id": 2164416,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/46c782db-0772-4917-bbd2-75107ba6287e/width=450/2164416.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2944,
                                    "height": 1625,
                                    "hash": "UcIqr;_N?v?b%NWBf6j?yDaejFWB%hjsaeay",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/146600"
                        },
                        {
                            "id": 144993,
                            "name": "v1.0",
                            "index": 1,
                            "modelId": 131864,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 11,
                            "description": null,
                            "publishedAt": "2023-08-20T18:04:19.219",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 4126,
                                "ratingCount": 258,
                                "rating": 5,
                                "thumbsUpCount": 305,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 107277,
                                    "sizeKB": 6704.828125,
                                    "name": "breastsizeslider.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-08-20T17:50:54.663Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "AAC250F2",
                                        "AutoV2": "EC37DA9287",
                                        "SHA256": "EC37DA9287EE6067939DDF189C55207A06C9977788636646357BAB87CF0EC75E",
                                        "CRC32": "E97C5D34",
                                        "BLAKE3": "8F188CC7072B13B66C21B978CA2D0A498D694D9B86874D1D40ED65FC47C07DCB",
                                        "AutoV3": "3B4E8027B5A8"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/144993",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2127563,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bcc1628a-9bcf-412d-a075-f8d0fc949bc6/width=450/2127563.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 780,
                                    "height": 768,
                                    "hash": "UA9G:hOts:IU}nMxoeX9IVi_WBof74%gR*r=",
                                    "type": "image"
                                },
                                {
                                    "id": 2127564,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a782719f-de0f-4c97-937a-01a364dd26f3/width=450/2127564.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2560,
                                    "height": 857,
                                    "hash": "UYCZO+oKkCj[~pofayj[_3j]jtj[?waej[j[",
                                    "type": "image"
                                },
                                {
                                    "id": 2127580,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f81bb1ee-2b94-4403-93e4-04bc2b4ed817/width=450/2127580.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 2560,
                                    "height": 857,
                                    "hash": "UdG*=]xaofkCyEWXayj[?bjsayj[~qjsj[az",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/144993"
                        }
                    ]
                },
                {
                    "id": 4830,
                    "name": "Shenhe - LoRA Collection of Trauter's",
                    "description": "<p><a target=\"_blank\" rel=\"ugc\" href=\"https://huggingface.co/YoungMasterFromSect/Trauter_LoRAs\">https://huggingface.co/YoungMasterFromSect/Trauter_LoRAs</a> collection of Anime LoRAs that include characters from various series.<br />Every day I try atleast to add 1 LoRA to the collection.<br />It has guide on what LoRAs are, and how to use them.<br />I also included images with metadata and sample prompts.<br />Those are my personal LoRAs made with my usecase in mind. I don't guarantee that they will produce results that you are searching for.</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 26596,
                        "favoriteCount": 0,
                        "thumbsUpCount": 4251,
                        "thumbsDownCount": 2,
                        "commentCount": 12,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 2
                    },
                    "creator": {
                        "username": "Trauter",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d9a2b7d-daec-4a19-a174-18489b342f01/width=96/Trauter.jpeg"
                    },
                    "tags": [
                        "anime",
                        "character",
                        "3d",
                        "genshin impact",
                        "2d"
                    ],
                    "modelVersions": [
                        {
                            "id": 5545,
                            "name": "Shenhe Hard",
                            "index": 0,
                            "modelId": 4830,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-01-19T18:10:44.338",
                            "availability": "Public",
                            "trainedWords": [
                                "character \\(series\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 24951,
                                "ratingCount": 1357,
                                "rating": 4.99,
                                "thumbsUpCount": 1485,
                                "thumbsDownCount": 2
                            },
                            "files": [
                                {
                                    "id": 5718,
                                    "sizeKB": 147532.8759765625,
                                    "name": "Shenhe_Hard.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-01-19T18:20:52.791Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "DA4F232D",
                                        "AutoV2": "E091210D3E",
                                        "SHA256": "E091210D3E46C5AF2FACA47932F725784156FDBF09E8942BC08731C60BE1E3E3",
                                        "CRC32": "1F5B1848",
                                        "BLAKE3": "6A7511E0672CEFC3D2E04373F73A5EC3CB95DA4B61A6713376B4BB30A5683761",
                                        "AutoV3": "DC19AEE5E7E3"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/5545",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 44166,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a8220f45-7295-4587-dd85-a8bd3b9bfd00/width=450/44166.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 533,
                                    "height": 799,
                                    "hash": "UPGb@#%2?^Nd?d%MIoWBx_WBs:xuM{%MxZjZ",
                                    "type": "image"
                                },
                                {
                                    "id": 44169,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a4ba951-0e6f-4065-74bc-8128c2f5f500/width=450/44169.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 533,
                                    "height": 799,
                                    "hash": "UjMQx6IU~q-;_4t8M{fP?bj[WBs:IUofRjM{",
                                    "type": "image"
                                },
                                {
                                    "id": 44168,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7c221873-1d2b-45d5-fe47-816c478ccf00/width=450/44168.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 533,
                                    "height": 799,
                                    "hash": "USLW;XD*9Z?H9a9FRiWB_NIUjFRjxvn~xubI",
                                    "type": "image"
                                },
                                {
                                    "id": 44167,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5be09989-5d45-47b6-d1e6-a4e4cb39f300/width=450/44167.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 533,
                                    "height": 799,
                                    "hash": "UFGuq7xax[9F_4IU9ZIU0Kt6D%M{00M{xa-;",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/5545"
                        },
                        {
                            "id": 5546,
                            "name": "shenhe medium",
                            "index": 1,
                            "modelId": 4830,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-01-19T18:10:44.338",
                            "availability": "Public",
                            "trainedWords": [
                                "character \\(series\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1050,
                                "ratingCount": 1250,
                                "rating": 5,
                                "thumbsUpCount": 1336,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 5719,
                                    "sizeKB": 147532.8759765625,
                                    "name": "Shenhe_Hard.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-01-19T18:23:24.851Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "DA4F232D",
                                        "AutoV2": "E091210D3E",
                                        "SHA256": "E091210D3E46C5AF2FACA47932F725784156FDBF09E8942BC08731C60BE1E3E3",
                                        "CRC32": "1F5B1848",
                                        "BLAKE3": "6A7511E0672CEFC3D2E04373F73A5EC3CB95DA4B61A6713376B4BB30A5683761",
                                        "AutoV3": "DC19AEE5E7E3"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/5546",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 44173,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/05d35dd3-8e82-464a-2b68-3937c2b20e00/width=450/44173.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 533,
                                    "height": 799,
                                    "hash": "UPGb@#%2?^Nd?d%MIoWBx_WBs:xuM{%MxZjZ",
                                    "type": "image"
                                },
                                {
                                    "id": 44172,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e0037cf9-68f6-4098-378c-8c39a9acb000/width=450/44172.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 533,
                                    "height": 799,
                                    "hash": "UjMQx6IU~q-;_4t8M{fP?bj[WBs:IUofRjM{",
                                    "type": "image"
                                },
                                {
                                    "id": 44171,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/168caedc-bf84-4dd7-24f0-218a05b88500/width=450/44171.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 533,
                                    "height": 799,
                                    "hash": "USLW;XD*9Z?H9a9FRiWB_NIUjFRjxvn~xubI",
                                    "type": "image"
                                },
                                {
                                    "id": 44170,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7b79958c-f92d-4060-f3b5-71b30b4aa500/width=450/44170.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 533,
                                    "height": 799,
                                    "hash": "UFGuq7xax[9F_4IU9ZIU0Kt6D%M{00M{xa-;",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/5546"
                        },
                        {
                            "id": 5547,
                            "name": "Shenhe soft",
                            "index": 2,
                            "modelId": 4830,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-01-19T18:10:44.338",
                            "availability": "Public",
                            "trainedWords": [
                                "character \\(series\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 595,
                                "ratingCount": 1367,
                                "rating": 5,
                                "thumbsUpCount": 1476,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 5720,
                                    "sizeKB": 147532.8759765625,
                                    "name": "Shenhe_Soft.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-01-19T18:26:01.627Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "29497688",
                                        "AutoV2": "8D51B251D0",
                                        "SHA256": "8D51B251D04E93510A52E85CFDCF1274DFE4351362731549DC2317C03852CAF4",
                                        "CRC32": "73C51E49",
                                        "BLAKE3": "51A69010FCB48F9CC15E608885753E59E89486086DD831ED1BBF8DA916476FA3",
                                        "AutoV3": "6E0318661389"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/5547",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 44177,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d1ffd424-0aae-4613-8820-59b1a9e0f900/width=450/44177.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 533,
                                    "height": 799,
                                    "hash": "UPGb@#%2?^Nd?d%MIoWBx_WBs:xuM{%MxZjZ",
                                    "type": "image"
                                },
                                {
                                    "id": 44176,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3c7e6464-4daa-4e19-f675-8e3587089600/width=450/44176.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 533,
                                    "height": 799,
                                    "hash": "UjMQx6IU~q-;_4t8M{fP?bj[WBs:IUofRjM{",
                                    "type": "image"
                                },
                                {
                                    "id": 44175,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8d612f5e-7997-4a78-3eeb-543355601900/width=450/44175.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 533,
                                    "height": 799,
                                    "hash": "USLW;XD*9Z?H9a9FRiWB_NIUjFRjxvn~xubI",
                                    "type": "image"
                                },
                                {
                                    "id": 44174,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7ebf3b7e-0538-430b-eba2-dccc5076c600/width=450/44174.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 533,
                                    "height": 799,
                                    "hash": "UFGuq7xax[9F_4IU9ZIU0Kt6D%M{00M{xa-;",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/5547"
                        }
                    ]
                },
                {
                    "id": 10679,
                    "name": "Stylized 3D Model LoRA",
                    "description": "<p><strong><u>(日本語は後半にあります)</u></strong></p><p></p><h2>Stylized 3D Model LoRA</h2><p>This is a LoRA trained on stylized 3D model images.</p><p>It can provide a figure-like material and a distinctive silhouette.</p><p></p><h2>Changes in 3.0</h2><ul><li><p>Increased the training resolution (ver.2: 768, ver.3: 896)</p></li><li><p>Revised the tagging</p><ul><li><p>Removed the trigger word as well</p></li></ul></li><li><p>Reviewed the training parameters</p></li></ul><p></p><h2>Improvements in 3.0</h2><ul><li><p>It can reproduce a more stereoscopic effect than ver.2</p></li><li><p>LoRA can be applied without a trigger word</p></li><li><p>The effect of LoRA can be adjusted by adding the <code>3d</code> tag to either Positive or Negative Prompt</p></li></ul><p></p><h2>Precautions</h2><p>Depending on the base model, the face may become overly deformed.</p><p>If it doesn't work well, consider using the following models, which are used for verification:</p><ul><li><p><a rel=\"ugc\" href=\"https://civitai.com/models/7152\">Facebomb Mix</a></p></li><li><p><a rel=\"ugc\" href=\"https://civitai.com/models/38606/alstroemeria-mix\">Alstroemeria Mix</a></p></li></ul><p></p><p></p><p></p><h2>Stylized 3D Model LoRA</h2><p>スタイライズドされた 3D モデル画像を学習した LoRA です。</p><p>フィギュアのような質感と特徴的なシルエットを与えることができます。</p><p></p><h2>3.0 での変更点</h2><ul><li><p>学習解像度を向上しました (ver.2: 768, ver.3: 896)</p></li><li><p>タグ付けを見直しました</p><ul><li><p>トリガーワードも削除しました</p></li></ul></li><li><p>学習パラメータを見直しました</p></li></ul><p></p><h2>3.0 での改善点</h2><ul><li><p>ver.2 よりも 3D 的な立体感が再現できます</p></li><li><p>トリガーワードなしで LoRA を適用することが可能です</p></li><li><p><code>3d</code> タグを Positive または Negative Prompt に入れることで LoRA の効果の調整が可能です</p></li></ul><p></p><h2>注意点</h2><p>ベースモデルによっては顔が変形しすぎる場合があるかもしれません。</p><p>動作確認には以下のモデルを使用しているので、うまくいかない場合はこれらの使用をご検討ください。</p><ul><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7152\">Facebomb Mix</a></p></li><li><p><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/38606/alstroemeria-mix\">Alstroemeria Mix</a></p></li></ul>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [
                        "Image"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 26834,
                        "favoriteCount": 0,
                        "thumbsUpCount": 4246,
                        "thumbsDownCount": 1,
                        "commentCount": 17,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 0
                    },
                    "creator": {
                        "username": "NeoClassicalRibbon",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9ec3588e-bd6c-4dcd-46da-a3592e592300/width=96/NeoClassicalRibbon.jpeg"
                    },
                    "tags": [
                        "girl",
                        "colorful",
                        "vibrant colors",
                        "style",
                        "fantasy"
                    ],
                    "modelVersions": [
                        {
                            "id": 44570,
                            "name": "v3.0",
                            "index": 0,
                            "modelId": 10679,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<ul><li><p>Increased the training resolution (ver.2: 768, ver.3: 896)</p></li><li><p>Revised the tagging</p><ul><li><p>Removed the trigger word as well</p></li></ul></li><li><p>Reviewed the training parameters</p></li></ul>",
                            "publishedAt": "2023-04-13T10:22:27.887",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 20952,
                                "ratingCount": 2591,
                                "rating": 5,
                                "thumbsUpCount": 2926,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 33581,
                                    "sizeKB": 73861.2177734375,
                                    "name": "stylized_3dcg_v4-epoch-000012.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-13T10:26:42.405Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "366E59FB",
                                        "AutoV2": "B29183A863",
                                        "SHA256": "B29183A86392C6AA972AA33F6AF3C18F5B1B9F0A734FDE35DD2CAE2DDA763363",
                                        "CRC32": "17D3F565",
                                        "BLAKE3": "4CEDCDED59E61502190E60FBAAEB14777B2350AF077C34C300081F1EA05B6D01",
                                        "AutoV3": "2AEFEC9B31EE"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/44570",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 485405,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4d6bf635-dc2e-4dd7-5329-197bc6281300/width=450/485405.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1344,
                                    "hash": "UFGa|K9ZR4o}o|RjRioz}=E2XTjYNfIoxGoe",
                                    "type": "image"
                                },
                                {
                                    "id": 485406,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e9a8293c-eb32-416b-186c-af9e99cc0200/width=450/485406.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1344,
                                    "hash": "UHGkUg}?xZx]M{-ps:kCM{xvof%L9u9uS$Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 485407,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f61d920a-b9cf-4153-4834-d1d8eecc4d00/width=450/485407.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UNF5aE~VS1IVx]%M-pbHRjofI;ayayoJjus:",
                                    "type": "image"
                                },
                                {
                                    "id": 485410,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/160b9999-e705-43ab-4f2a-33c2567fd900/width=450/485410.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGFFX0-o~q_3D%s,9aIU?G4nofIo%N$zxttR",
                                    "type": "image"
                                },
                                {
                                    "id": 485411,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2319f417-c986-4fd2-7421-936071f16100/width=450/485411.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGE{97IV~pxu?H%2R*xus,aeR+WC%MWBo0R*",
                                    "type": "image"
                                },
                                {
                                    "id": 485408,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ee1d7c7d-d444-4343-6aa3-6f0a95e76600/width=450/485408.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UJI4|lEN%g-;~U%1E2fP9FaeNIR*R*Rkn%WB",
                                    "type": "image"
                                },
                                {
                                    "id": 485412,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f8f1c13a-63c5-4250-7ff6-eeba63988400/width=450/485412.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCDKxW_1P9T{L9RiRQng00Ee8xHs?]%gH@%N",
                                    "type": "image"
                                },
                                {
                                    "id": 485409,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4fb69d18-d5da-4c52-22f3-18c951b9ce00/width=450/485409.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UEDm?g^hI:0$~C-VRPIo00o#Z#v#4.tlsmem",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/44570"
                        },
                        {
                            "id": 12667,
                            "name": "v1.0",
                            "index": 1,
                            "modelId": 10679,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2023-02-19T16:06:47.137",
                            "availability": "Public",
                            "trainedWords": [
                                "scg"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1046,
                                "ratingCount": 144,
                                "rating": 5,
                                "thumbsUpCount": 145,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 11436,
                                    "sizeKB": 147580.2294921875,
                                    "name": "stylized-3d-model-lora-v10.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-19T16:11:19.399Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "ACB66610",
                                        "AutoV2": "BECB7B3A83",
                                        "SHA256": "BECB7B3A83E39A1F11A960A43F70E4E8E3320CE3E985F19BB926D5B97C7CE487",
                                        "CRC32": "704ACEE3",
                                        "BLAKE3": "DD2F8E6FF9DE275BEA4E9157BA3D84C2F093F85DE950372BD99428EC6C19AE58",
                                        "AutoV3": "DD253EDFF00D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/12667",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 122345,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6c74c58d-9dfd-42c5-e8c8-0cc76f355a00/width=450/122345.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U6CF-lIp00ET?tE2M{%L00IU~W?H5G=_nN9_",
                                    "type": "image"
                                },
                                {
                                    "id": 122336,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e0aeaaa-684b-4012-a0f3-91b913f12f00/width=450/122336.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 768,
                                    "hash": "UAJ7H-E%~oR40y9v01aK0iRkOa0M$f~AMw9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 122347,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c0fa8388-2ee6-40b5-6c32-12f0c4ecda00/width=450/122347.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1344,
                                    "hash": "UWKAmH-p%Mb_.8kAx]tR~WslWFNGkCW=oLe.",
                                    "type": "image"
                                },
                                {
                                    "id": 122346,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a0876c8-8650-41e5-45b5-a40407b62200/width=450/122346.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UNJHp*WA_4xaM_t7D%RjyXoft8WVV?M|R-xa",
                                    "type": "image"
                                },
                                {
                                    "id": 122344,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c85dd727-9c61-4071-e2e9-57beec7e2d00/width=450/122344.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "ULF$O{4TF_rr_NE0XQr?9sSzsRWB.8spniR%",
                                    "type": "image"
                                },
                                {
                                    "id": 122343,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6b7f9bc9-1628-4251-9384-71a7e57a7300/width=450/122343.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U7IW$S00_L4o0o~UMx%3005X0L?aEjo09a9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 122342,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c4481470-369d-4a2e-ea36-e3817ddd7500/width=450/122342.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1344,
                                    "hash": "UCF}i%oz_M-prtt7-ot75jM|Z~aKIoxZs.t6",
                                    "type": "image"
                                },
                                {
                                    "id": 122341,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3bf2486a-aaf0-41ef-103b-dfcea5f7e500/width=450/122341.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1344,
                                    "hash": "U9G]2b#8.AXoFv4noz-:MzM|00E0t7Rjv~-o",
                                    "type": "image"
                                },
                                {
                                    "id": 122340,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e4bf889b-465c-4bb0-c733-2a90d2d40000/width=450/122340.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UKH2N8tR*J$*r=RkE2fk_2s.M{R+oJj[NHWB",
                                    "type": "image"
                                },
                                {
                                    "id": 122339,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3c7e473c-3fc1-4aaa-7ba6-500eb86eea00/width=450/122339.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UNFX*R~Voyoz^*-pX9%2I:xaogS4E2of%2bI",
                                    "type": "image"
                                },
                                {
                                    "id": 122338,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/670833b2-5629-419f-b189-e044eb604400/width=450/122338.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UfJ7j%IUtQ%M~pWBt6tRt6oyR*WBNGofNGV[",
                                    "type": "image"
                                },
                                {
                                    "id": 122337,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7e2bf085-db2d-4620-9e50-a96d741bf400/width=450/122337.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDH0w]}=4.$*0pM|NFI[%ENZEN-V9GxF^Pbb",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/12667"
                        },
                        {
                            "id": 13152,
                            "name": "v2.0",
                            "index": 2,
                            "modelId": 10679,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>Trained with resolution at 768px.</p><p>This will give more solid 3D effect with higher weight.</p><p></p><p>解像度 768 px で再学習しました。</p><p>強度を上げることでより 3D 感を強調することができます。</p>",
                            "publishedAt": "2023-02-20T16:10:05.455",
                            "availability": "Public",
                            "trainedWords": [
                                "scg"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4836,
                                "ratingCount": 1181,
                                "rating": 5,
                                "thumbsUpCount": 1182,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 11720,
                                    "sizeKB": 147579.9853515625,
                                    "name": "stylized3DModelLora_v20.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-20T16:11:08.692Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "961E781B",
                                        "AutoV2": "B0979474DD",
                                        "SHA256": "B0979474DD458A3CD1A134CE6665B00241E293BF3BD82E49B0206C29326A6398",
                                        "CRC32": "6D02E1E9",
                                        "BLAKE3": "FEC295D8AE9E78EE096AD0985E37412A96FA2F4FF7C69C690379A1861ECCD116",
                                        "AutoV3": "A915E36AC3C7"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/13152",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 127168,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f40011aa-5f6d-4f09-3fff-5a25792fbc00/width=450/127168.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UHCjCCDk9@oL_LDlt4WDRiMzozWX-.RkR*j=",
                                    "type": "image"
                                },
                                {
                                    "id": 127167,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d821b428-5a26-45bd-b0b9-0b36c19a0300/width=450/127167.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "ULI|{,-6E1%04.~VIpt3M_9axvR%$}xtE2Si",
                                    "type": "image"
                                },
                                {
                                    "id": 127166,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0b233ddd-3a73-4df6-0043-873c0ca1ce00/width=450/127166.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UJID?r~A=ws:?aoJi_bHeSM|Rjxas:WBaKbb",
                                    "type": "image"
                                },
                                {
                                    "id": 127165,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6c179c76-51be-4377-3699-e94c85307500/width=450/127165.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1344,
                                    "height": 896,
                                    "hash": "UNGjgCR*EKR+}@WBE2kB-nW;EMe.t7j[i_j?",
                                    "type": "image"
                                },
                                {
                                    "id": 127164,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/85eac6a0-42bc-4fe0-4ff8-64559a0b4700/width=450/127164.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 768,
                                    "hash": "UIF~Kot6TCWV~UazEMj@-,a#IqoLRnoeR+ju",
                                    "type": "image"
                                },
                                {
                                    "id": 127163,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4c9aa4af-d9b2-4c17-224e-96eafd0dfc00/width=450/127163.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U3FE_yAJ00~V;[EN00n$00nhA1xDT2-5GI-p",
                                    "type": "image"
                                },
                                {
                                    "id": 127162,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2d1786da-63c6-4677-042d-b8a2bfcc9500/width=450/127162.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UJE2qRX9E1I:~AR,IojZemNbOYxZaKWCS$bb",
                                    "type": "image"
                                },
                                {
                                    "id": 127161,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d4ecfb0-896a-4586-b294-c6d4e8764500/width=450/127161.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 768,
                                    "hash": "URF=2L?GRiI:~VofRiRjxuS2oLoL%1juIoof",
                                    "type": "image"
                                },
                                {
                                    "id": 127160,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e2a9bf1c-aae2-47df-65fe-5c1d11fbaf00/width=450/127160.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UFEx*1Nb0et7~Uof9aj?0LaeR:bHD*WDozR*",
                                    "type": "image"
                                },
                                {
                                    "id": 127159,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8cab8c19-bc86-4248-6bd3-867bd6110900/width=450/127159.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UKEMdvRj9E%2yZoeVsagM{ozVssl9EoLRiWY",
                                    "type": "image"
                                },
                                {
                                    "id": 127158,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/31d07cef-067d-4a84-f661-8c23e50d2300/width=450/127158.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1344,
                                    "height": 896,
                                    "hash": "UJG7uc}mI8R+OZnhM{xa0$E2Sio#SjI=oJkD",
                                    "type": "image"
                                },
                                {
                                    "id": 127157,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/23d15641-03d2-4bd2-0f6b-d49e05171300/width=450/127157.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1344,
                                    "height": 896,
                                    "hash": "UMGRxC*{xAx[-.xaVY-:f*X8IpoI~UjFn$r=",
                                    "type": "image"
                                },
                                {
                                    "id": 127156,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5380c797-fa69-41c6-2940-3102ff82ec00/width=450/127156.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGF}=q4:IoIp~pIVV@jZE2SNnixGD+%1f6NH",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/13152"
                        }
                    ]
                },
                {
                    "id": 65423,
                    "name": "NijiMecha - Artstyle LORA",
                    "description": "<p>Trained on NAI with 138 pictures from nijijourney default and expressive.<br />Best result with weight between : 0.8-1.<br /><br />Prompt activator : None<br />But I recommend to use mecha related prompts like :<br />mecha, robot, armor, bodysuit, mechanical arms, science fiction, no humans</p><p></p><p>Commissioned by realitylvn on <a target=\"_blank\" rel=\"ugc\" href=\"https://fiverr.com/konanai/create-lora-model-for-you\"><strong>fiverr</strong></a></p><p>Reviews are really appreciated, i love to see the community use my work, that's why I share it.<br />If you like my work, you can tip me <a target=\"_blank\" rel=\"ugc\" href=\"https://ko-fi.com/konan49773\"><strong>here.</strong></a></p><p>Got a specific request ? I'm open for commission on my <a target=\"_blank\" rel=\"ugc\" href=\"https://ko-fi.com/konan49773/commissions\"><strong>kofi</strong></a> or<strong> </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://www.fiverr.com/konanai/create-lora-model-for-you\"><strong>fiverr gig</strong></a> *! If you provide enough data, OCs are accepted</p><p><img src=\"https://statics.teams.cdn.office.net/evergreen-assets/personal-expressions/v2/assets/emoticons/smile/default/30_f.png?v=v81\" alt=\"🙂\" /></p><p><em>*Any paid request will not be presented on this page, unless you give me permission to.</em></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 5,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 26495,
                        "favoriteCount": 0,
                        "thumbsUpCount": 4206,
                        "thumbsDownCount": 1,
                        "commentCount": 2,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 209
                    },
                    "creator": {
                        "username": "Konan",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7cd552a1-60fe-4baf-a0e4-f7d5d5381711/width=96/Konan.jpeg"
                    },
                    "tags": [
                        "anime",
                        "mecha",
                        "style",
                        "robot",
                        "mechanical"
                    ],
                    "modelVersions": [
                        {
                            "id": 70067,
                            "name": "v1.0",
                            "index": 0,
                            "modelId": 65423,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": null,
                            "publishedAt": "2023-05-14T00:52:26.236",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 26495,
                                "ratingCount": 3526,
                                "rating": 5,
                                "thumbsUpCount": 4206,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 48894,
                                    "sizeKB": 147573.6259765625,
                                    "name": "nijiMecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-14T00:55:58.833Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "F94FF9EC",
                                        "AutoV2": "A42CEDDE8D",
                                        "SHA256": "A42CEDDE8DF09A0CA50230AC9B5AC3CF7FFE2D8A407A9E108D54312181EEDCF3",
                                        "CRC32": "1ADF7311",
                                        "BLAKE3": "EC8F785205B7F990F54A743304793C1575AD174156AC4D703A0B3A2E3F6F8C73",
                                        "AutoV3": "492D6878F85A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/70067",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 782613,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/20536dea-f626-44ca-a7d3-3f575ef92299/width=450/782613.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCFYW7JT57,?8^Rk4njE~qi|kqo}I9M{M{%M",
                                    "type": "image"
                                },
                                {
                                    "id": 782607,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/097255e2-a55b-419f-86bd-60f88141cb55/width=450/782607.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBEVHPOs7L=|8^R*9GIo?^t7i_bb4.axXSwJ",
                                    "type": "image"
                                },
                                {
                                    "id": 782610,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4dcc730d-46fe-47f7-b959-9f5695e72ff4/width=450/782610.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAAT1LIr57nR~ANI9uaKn+NHNa$%VtRkR*%1",
                                    "type": "image"
                                },
                                {
                                    "id": 782606,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/380a7178-766e-42bf-afb0-cb15c068b31a/width=450/782606.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIFYDNae0LI;_2%19aNH~Uj[RkM|S2%1-oIp",
                                    "type": "image"
                                },
                                {
                                    "id": 782614,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3a74a629-e0a4-4c39-bd6a-5120e54872af/width=450/782614.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "U4Ac9?-iQk^k165SEL={-4^O~AIq0LNKXTI:",
                                    "type": "image"
                                },
                                {
                                    "id": 782609,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/05c1cdde-a0eb-428d-bcf9-86eb677c07fd/width=450/782609.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNGH;.S$#5f9.AozaIIVTzxaE1NG?bNx,-Nd",
                                    "type": "image"
                                },
                                {
                                    "id": 782615,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/50d9fcc4-b3b0-4b0d-9276-73af8bd3f090/width=450/782615.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULIOe9x]~q%1x]xuIUM{tlRPaex]NHV@RPW;",
                                    "type": "image"
                                },
                                {
                                    "id": 782611,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9603f84d-49fb-413a-ad86-d16c72412564/width=450/782611.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIGS7Woz%gxu00WVRjRj~qt7Rja|D%WBofay",
                                    "type": "image"
                                },
                                {
                                    "id": 782608,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f0955a82-71a6-4f79-86d5-ed4567683d9c/width=450/782608.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAF5gM~VD*~B~pX94:57^*0L01%L~W4:V?^*",
                                    "type": "image"
                                },
                                {
                                    "id": 782612,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/176f4786-365b-493e-bcef-55e5f6ea3add/width=450/782612.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFCG73W=NIt88^RjE2V@~qRjShxu9FWCR*xa",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/70067"
                        }
                    ]
                },
                {
                    "id": 28600,
                    "name": "Esthetic 90s style",
                    "description": "<h3 id=\"heading-41\">Esthetic 90s style (and a little 80s)</h3><p></p><h3 id=\"heading-8\">completely redesigned lora, based on the \"<a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/posts/era-esthetic-v5-89814199\">ERA v5.0</a>\" model</h3><p></p><p>version <a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/posts/esthetic-90s-3-93872973?utm_medium=clipboard_copy&amp;utm_source=copyLink&amp;utm_campaign=postshare_creator&amp;utm_content=join_link\">3.0R</a> (Lora, based on the version 7.6V model (it is not even on patreon yet), the most detailed and complete version of Lora, is much better than version 2.0R and with a greatly enlarged dataset)</p><p><img src=\"https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a12f879a-a92b-48e7-b8a6-232ddd5ea5f5/width=525/a12f879a-a92b-48e7-b8a6-232ddd5ea5f5.jpeg\" /></p><p>P.P.S. new model <a target=\"_blank\" rel=\"ugc\" href=\"https://boosty.to/girlsai/posts/dc80cb13-c35b-4671-bacc-9156c6fe6599?share=post_link\">ogipote (2.5D)</a> and <a target=\"_blank\" rel=\"ugc\" href=\"https://boosty.to/girlsai/posts/dc80cb13-c35b-4671-bacc-9156c6fe6599?share=post_link\">ogipote (2.5D)_v2.0</a> on <a target=\"_blank\" rel=\"ugc\" href=\"https://boosty.to/girlsai\">Boosty</a></p><p><img src=\"https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aee4fc1c-103b-4e8b-88ea-a1bad7c13fef/width=525/aee4fc1c-103b-4e8b-88ea-a1bad7c13fef.jpeg\" /></p><p></p><p><strong>I made a </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://drive.google.com/file/d/1lR7dKvFoKK9mCwKU4hVcR8jwYnYXoZgE/view?usp=share_link\"><strong>video</strong></a><strong> on how to achieve the same quality or just repeat my art</strong></p><p></p><p><strong>A small version comparison:</strong></p><p><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/569c3b49-7017-43ad-38cc-44b4c142c300/width=525/569c3b49-7017-43ad-38cc-44b4c142c300\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2f850e22-54f4-4668-3374-bdc292079100/width=525/2f850e22-54f4-4668-3374-bdc292079100\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/957bd6f1-0a90-4c3e-b088-2ebe20e57700/width=525/957bd6f1-0a90-4c3e-b088-2ebe20e57700\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c42530ef-f861-4e27-ad9d-62b8e1e9b700/width=525/c42530ef-f861-4e27-ad9d-62b8e1e9b700\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9ff69cd6-0ea8-4891-a80c-5d9813cacc00/width=525/9ff69cd6-0ea8-4891-a80c-5d9813cacc00\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/75aa71d4-7ce9-413a-7be8-a07eb138a500/width=525/75aa71d4-7ce9-413a-7be8-a07eb138a500\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fc015531-c349-4e3f-815a-3142669f4100/width=525/fc015531-c349-4e3f-815a-3142669f4100\" /><img src=\"https://imagecache.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c17f3bdf-3954-4f3d-0dc3-697453fd2300/width=525/c17f3bdf-3954-4f3d-0dc3-697453fd2300\" /></p><p></p><p></p><p>when I release version 1.3, versions 1.2 and 1.2R will be released to the public</p><p></p><p>Hands finally reached the style of the 90s. There were many difficulties, dozens of versions, but I found a golden mean, from which I will continue to build on future updates.</p><p><br /><strong><u>just use hires fix as much as your video card is capable of, so as not to give an error, with 8gb of video memory it is 512x768 with hires fix 2, upscaler Latent (nearest-exact), the picture will be much more detailed. If you want a style close to the original but with more detail, don't use Denoising strength above 0.55, but to avoid artifacts, do not use too low a value, optimally 0.5</u></strong><br /><br /><strong>LORA weight</strong> 0.6<br /><br /><strong>CFG Scale</strong> - 7</p><p></p><p><strong>Eta noise seed delta</strong> 31337</p><p><br /><br />Use <strong>Abyssorangemix3aom3_aom3a3.safetensors </strong>With these negative prompts:<br /><strong>(worst quality, low quality, extra digits:1.4)</strong></p><p><br /><strong>Trigger Words: </strong>First, depending on what you need, trigger words are not required at all, read:</p><p><strong>1990s \\(style\\)</strong> - most often makes enlarged eyes and detailed pupils, as in anime Slayers or Sailor Moon for example.</p><p><strong>1980s \\(style\\)</strong> - there are some 80s arts, when used together with <strong>1990s \\(style\\)</strong> sometimes very interesting results are obtained</p><p>retro artstyle - additional optional trigger<br /><br /><strong><u>Combined with my other </u></strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/user/OneRing\"><strong><u>LORA</u></strong></a><br /><br /><strong>How to use LoRA's in auto1111:</strong></p><ul><li><p>Update webui (use <code>git pull</code> <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/embed/mn8fMF10XN4?start=31&amp;end=60\">like here</a> or redownload it)</p></li><li><p>Copy the file to <code>stable-diffusion-webui/models/lora</code></p></li><li><p>Select your LoRA like in <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/watch?v=-bMeyXOZwN0\">this video</a></p></li><li><p><strong>Make sure to change the weight</strong> (by default it's <code>:1</code> which is usually too high)<br /><br />*Information taken from <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/user/Lykon\">Lykon</a><br /><br /><strong>Please post your work with or without comments, it will help me improve. Thanks!</strong><br /><br /><strong>If you like my work, click on the heart above, I will be pleased :3</strong></p></li></ul>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [],
                    "allowDerivatives": false,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 15,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 29671,
                        "favoriteCount": 0,
                        "thumbsUpCount": 4182,
                        "thumbsDownCount": 0,
                        "commentCount": 18,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 20
                    },
                    "creator": {
                        "username": "OneRing",
                        "image": "https://lh3.googleusercontent.com/a/AEdFTp5jp2mctZvnQnEwhgqBAKUyZXGV0NCQrodXW3vY2g=s96-c"
                    },
                    "tags": [
                        "anime",
                        "vintage",
                        "retro",
                        "aesthetic",
                        "80s",
                        "retro artstyle",
                        "style",
                        "anime character",
                        "1990s",
                        "90s",
                        "esthetic",
                        "retro anime",
                        "90's",
                        "anime style",
                        "retro style",
                        "90s style"
                    ],
                    "modelVersions": [
                        {
                            "id": 180882,
                            "name": "v2.0R",
                            "index": 0,
                            "modelId": 28600,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>completely redesigned lora, based on the \"ERA v5.0\" model</p>",
                            "publishedAt": "2023-10-12T10:59:51.502",
                            "availability": "Public",
                            "trainedWords": [
                                "1990s (style)",
                                "retro artstyle",
                                "1980s (style)"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 6083,
                                "ratingCount": 291,
                                "rating": 5,
                                "thumbsUpCount": 359,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 138653,
                                    "sizeKB": 147610.484375,
                                    "name": "90sv2.0R.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-10-12T10:15:49.718Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "C6C3ADDB",
                                        "AutoV2": "1DAB950E1B",
                                        "SHA256": "1DAB950E1BA3C01922F926B0B0EA8B82690023FCFCBA8B0AC3F82A0392EBA805",
                                        "CRC32": "080D154D",
                                        "BLAKE3": "DF9852604C72856BE4CFD5902CF145F37C2944D91C7C700EFA9E00D6176AED0F",
                                        "AutoV3": "6BA890DC968B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/180882",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2912979,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aa80361b-f82b-4eaf-a13d-15211ed0626f/width=450/2912979.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UBHUtavy0#9u0fIo01D%%$4m~V%10Laf?GRP",
                                    "type": "image"
                                },
                                {
                                    "id": 2912978,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/918fa857-c091-4399-9c92-f2d68dbdf027/width=450/2912978.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "U9Hnvp0100~V00t7x^_2D%ozt7IUMwofx]NG",
                                    "type": "image"
                                },
                                {
                                    "id": 2912949,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1132566b-0fa5-4e48-bd16-aaf078bf8e0e/width=450/2912949.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UNJ%|L000#kXROR.xtaeE1D%~VRP%2oMxaWX",
                                    "type": "image"
                                },
                                {
                                    "id": 2912935,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/65a81802-0691-4a49-947d-ad1c176cc998/width=450/2912935.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UNJjuKM{0zn$IUM|~BxZ4.t7nht7NHt7Vsj[",
                                    "type": "image"
                                },
                                {
                                    "id": 2912967,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fc2ff52e-2b6f-4afb-bb60-3960a04bf3ab/width=450/2912967.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UNGuRM~pOXIU_4NGIUIAXS9FMxaLo}IAoK%g",
                                    "type": "image"
                                },
                                {
                                    "id": 2912928,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3ae60e68-e6a5-4acc-95d3-796549be1ef0/width=450/2912928.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UDH^n$~B1s9sDi9Z58w054NZp0-;9v?a9[I;",
                                    "type": "image"
                                },
                                {
                                    "id": 2912944,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/33193e7e-e87c-4a5c-9f40-fb5327b02c85/width=450/2912944.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UDHx4r4.Pk^$3X=?%EOXIv--}+WY?[Mf-nRl",
                                    "type": "image"
                                },
                                {
                                    "id": 2912933,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ebb67e04-9a2b-4822-b614-7419b62319a4/width=450/2912933.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UVJj|]?bNG--~qxu9bIpJCRkoNogOYfkxbxu",
                                    "type": "image"
                                },
                                {
                                    "id": 2912977,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ea9f07df-d099-4d68-8047-2d48d17ff17f/width=450/2912977.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UCF5sjRjAU57tmV{xuNG_MSv$*-os:j[-oRk",
                                    "type": "image"
                                },
                                {
                                    "id": 2912976,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad8c9af2-816a-4091-8c04-d9867242186c/width=450/2912976.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UBFr|Z~p01IU$p.80M4U*IJ6VuaJ%4xu^*xY",
                                    "type": "image"
                                },
                                {
                                    "id": 2912929,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9446f15f-ce75-4eac-957e-dcb6c201485f/width=450/2912929.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UIELv-~XlBNG5[NLRkRj9ZNGrVt7oMRiD%Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 2912975,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a7f5d0cc-d877-48bf-bf2f-42307654a59a/width=450/2912975.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UDJ7dj?HY4Se57niw[Ip00SgM|IV~BE1?G={",
                                    "type": "image"
                                },
                                {
                                    "id": 2912994,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6ac2bde7-1ff3-4cec-9b6e-905dc9eef976/width=450/2912994.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UZJ%|H~WEhtRofj[bcX8t6jZxut7M{WVNGM|",
                                    "type": "image"
                                },
                                {
                                    "id": 2912993,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/70bdb7b3-416c-4555-be71-a3094c7e62ac/width=450/2912993.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UIJao~t7tm?vb^t7_NMy00bHIAoL_N%M-pxa",
                                    "type": "image"
                                },
                                {
                                    "id": 2912990,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/519c5ade-764f-4f98-84a7-d9e0020ea0e3/width=450/2912990.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UIKwwl.m0K=|y?$jR5xuELIAMdRk9GaK-;E1",
                                    "type": "image"
                                },
                                {
                                    "id": 2912991,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a655abc4-b6af-4332-912e-75029e6783a2/width=450/2912991.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UTJQ[{_Nu4a$kE?aE1tRJVn%-pfR-ptRxuxt",
                                    "type": "image"
                                },
                                {
                                    "id": 2912992,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b48d71d6-87ab-4219-9b99-08f0b8d419ae/width=450/2912992.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "ULI}3B_201IAElIpxZWX9voL-ooz~VtRIVD$",
                                    "type": "image"
                                },
                                {
                                    "id": 2912995,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e7ce2ebd-f2bc-4c04-9a54-0aed0f868de9/width=450/2912995.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UTJ7RKjGOsM{~CM|OsIp4.IA%MV@xuIoNGof",
                                    "type": "image"
                                },
                                {
                                    "id": 2913004,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71c98d4f-b9f3-4c17-8e82-03d64f308e23/width=450/2913004.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1152,
                                    "height": 1792,
                                    "hash": "UDGutMNe00?G#l9EM|$$4;t7_N%2IUNK%h-p",
                                    "type": "image"
                                },
                                {
                                    "id": 2913127,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f4d5edbb-69d9-4a63-908a-d1953508137c/width=450/2913127.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UIG87g~qD%8{9tM_E2S$5kM{NGxt+~OEa0Mw",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/180882"
                        },
                        {
                            "id": 246837,
                            "name": "v1.7R",
                            "index": 1,
                            "modelId": 28600,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 31,
                            "description": "<p><strong>the best version on old data</strong></p>",
                            "publishedAt": "2023-12-02T09:42:44.609",
                            "availability": "Public",
                            "trainedWords": [
                                "1990s (style)",
                                "retro artstyle"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 246,
                                "ratingCount": 158,
                                "rating": 5,
                                "thumbsUpCount": 329,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 191102,
                                    "sizeKB": 147574.666015625,
                                    "name": "90sv1.7R.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-12-02T09:40:44.327Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "14A32129",
                                        "AutoV2": "90E752256D",
                                        "SHA256": "90E752256D07710EB90BC22D8AC848203953C011E622551D45EFE845DD01DD7D",
                                        "CRC32": "30033638",
                                        "BLAKE3": "5C0431F3935F70277095E29BD1624C8120E1C1BEFA969FD560C341B0C20540CE",
                                        "AutoV3": "91FD9E2768B4"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/246837",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 4106460,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f79ad8a0-d43d-419a-94a0-59367c5cd94a/width=450/4106460.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UHK,{f%M-6xu~9nhV?0J?]x[%#-;MwD*-AIU",
                                    "type": "image"
                                },
                                {
                                    "id": 4106456,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1ba84402-7221-49e6-a460-db19511cd8ce/width=450/4106456.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UOJt@z4T9~XA~1D%-:IU^vRiIVR-NyxU%3Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 4106461,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0bc60023-5786-4799-8a92-b6e6c781474b/width=450/4106461.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UKGIWH?c~q_2~qx]X9%M9GNGIUD%D%RPRPRj",
                                    "type": "image"
                                },
                                {
                                    "id": 4106459,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0097ea8d-ff7f-48db-84da-f74abec0d921/width=450/4106459.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UOH_cV^kF89i0yO?#-%18~MyMwwvIUsCRhS#",
                                    "type": "image"
                                },
                                {
                                    "id": 4106454,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e7ecc18f-d41e-4a3f-9fbe-3b55d3c7b61c/width=450/4106454.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "U6I5DV003r01005RGG^RX:00?^~W00^%-=00",
                                    "type": "image"
                                },
                                {
                                    "id": 4106457,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9a5742c4-dd71-448f-9a88-485b0b20f419/width=450/4106457.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UBG+2Y4T10F}00D*oMm+00~q^it7TJtRMd-;",
                                    "type": "image"
                                },
                                {
                                    "id": 4106452,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dc72ebdb-e3ea-4a88-9e1a-541ea6ae00a8/width=450/4106452.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "U6J@OQ0000?^00%29dE0%#S|m.4o00~q9Y-=",
                                    "type": "image"
                                },
                                {
                                    "id": 4106446,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1191d7ab-4caf-4b27-8af1-e53943d09a17/width=450/4106446.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UJHUz%D*02b^02_N?vD*EMJVac_2-;a}kWax",
                                    "type": "image"
                                },
                                {
                                    "id": 4106444,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f40ec83b-8dcb-476b-9dea-0792897ae251/width=450/4106444.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UAI;hz009[_L00M_0L4o00?d~V~V00kC?v9G",
                                    "type": "image"
                                },
                                {
                                    "id": 4106447,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fb73adca-972b-46b7-9e0d-29855b1ea919/width=450/4106447.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UJHeRl0000=|_44n_3IUXOVu-qNZpIt7xCR*",
                                    "type": "image"
                                },
                                {
                                    "id": 4106443,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e627d236-8499-4545-8c2c-1e5f523f89c8/width=450/4106443.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UcIXpz-=SwRk~q%3%1R+RknhMys:E1ROIUt7",
                                    "type": "image"
                                },
                                {
                                    "id": 4106449,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a7998584-9056-4b0b-9b43-2aefa18713d6/width=450/4106449.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UmMjUI-;9]~qNxW;xFe.s9s:tRW=-;%Mxuo0",
                                    "type": "image"
                                },
                                {
                                    "id": 4106450,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6eaffa13-8391-49af-8f9f-2d136366ced9/width=450/4106450.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UXH-=W-;E1xuPAWUIoxv~CR%aexuE0oKNGoz",
                                    "type": "image"
                                },
                                {
                                    "id": 4106445,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/411c0a1e-76cd-47ac-a134-11323cb03b52/width=450/4106445.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "U9GS1E004.V?_3t70Kt7^*?b00?bx]R%4n_N",
                                    "type": "image"
                                },
                                {
                                    "id": 4106451,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8ff572a3-8b67-4ae8-ae4f-eb02d02b43b6/width=450/4106451.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UEM60z-:0G9bu_9J}^?Z4X^z~VIW$SNZs:WG",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/246837"
                        },
                        {
                            "id": 96797,
                            "name": "v1.3RW",
                            "index": 2,
                            "modelId": 28600,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 31,
                            "description": "<p><strong>the best quality version in my opinion and by voting</strong></p>",
                            "publishedAt": "2023-06-15T19:47:07.487",
                            "availability": "Public",
                            "trainedWords": [
                                "1990s \\(style\\)",
                                "1980s \\(style\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 10787,
                                "ratingCount": 771,
                                "rating": 5,
                                "thumbsUpCount": 1137,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 67246,
                                    "sizeKB": 147569.5234375,
                                    "name": "90sv1.3RW.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-15T19:16:21.982Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "17E81D39",
                                        "AutoV2": "4B145EA48F",
                                        "SHA256": "4B145EA48F5A48474F1C580A688F2973F76A5D7ADEB0B67B12854421C61D0553",
                                        "CRC32": "120FC541",
                                        "BLAKE3": "B3A856BC56A518670AD2B2321E1A8DBFA790C36AD459AC5368431414E9D49FD8",
                                        "AutoV3": "6D8997DBB2D8"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/96797",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1158400,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/72a9fccd-9d0f-4ca0-8b0f-d682042a77bc/width=450/1158400.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UYI=Jn-=00WC~q%M9FWAD%IUbIIo-pRj9FbH",
                                    "type": "image"
                                },
                                {
                                    "id": 1158220,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/864887b5-712b-4271-ad82-54cfcbff52d7/width=450/1158220.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UUHee5tm.AozWGNx$*oz9F9ZIUaf_3E1?Hxa",
                                    "type": "image"
                                },
                                {
                                    "id": 1158261,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/efdc3d77-02db-42dd-99d8-e19962760cb5/width=450/1158261.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1072,
                                    "height": 1608,
                                    "hash": "UAHxHP~VBVaJ004;ERM}00%NZ,-:;0#+x@t5",
                                    "type": "image"
                                },
                                {
                                    "id": 1158131,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7693e9c3-a13d-4063-84de-995c26b31914/width=450/1158131.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1760,
                                    "height": 984,
                                    "hash": "UXJQD?ADIn?aoNpIRQIUMyT0bbIA}[n+I;SN",
                                    "type": "image"
                                },
                                {
                                    "id": 1158286,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6fa4895f-21fb-4a9a-a123-b04ea552d8b6/width=450/1158286.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGG+5dt601~W_2%Mx]4nx]8_RPkqIB4.E2t6",
                                    "type": "image"
                                },
                                {
                                    "id": 1158287,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ea0c7307-7616-476a-bb99-1bce1e1cbfc8/width=450/1158287.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UeHnpjR*t7-p_4a_f7kDI^ofRjIoWYNHRkae",
                                    "type": "image"
                                },
                                {
                                    "id": 1158288,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/70552781-e79e-4966-a093-bee6d18b10ce/width=450/1158288.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UWI4@e%N?bV@_N-pxuM_%NxtM{V@xukXMxRj",
                                    "type": "image"
                                },
                                {
                                    "id": 1158297,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/191dbfc0-2167-4a18-8fea-9f1f60b83aae/width=450/1158297.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFJ%nMPp2_-XL4D*?v%g0%vL-p5m%20JE1IU",
                                    "type": "image"
                                },
                                {
                                    "id": 1158300,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7b7ffe30-2591-45d7-9f3e-9b7539168a58/width=450/1158300.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USG+ap~XF}g4u5yDs,Mx%gMysmxtxHi_IoR%",
                                    "type": "image"
                                },
                                {
                                    "id": 1158304,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b99479e9-580b-4d06-bd6b-83a8c519ddb2/width=450/1158304.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULF}.%=yY6-p~qrX%2oz%g$g^Pf*?InNXTM{",
                                    "type": "image"
                                },
                                {
                                    "id": 1158306,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/97ce72ce-3fae-4c96-8724-1a0c1e045031/width=450/1158306.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "URJaDn^dV=~VEd_1-niv9aX9-;NFOGIpIoxu",
                                    "type": "image"
                                },
                                {
                                    "id": 1158308,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1139ff7d-4525-4a4e-8dc9-29f9445b80f5/width=450/1158308.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UVG8J^VDX.xu?wI9-:R,TKD*xaRPxCIqn%rq",
                                    "type": "image"
                                },
                                {
                                    "id": 1158439,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fe5c68bd-1a5e-442a-a23f-cba303f2f4c4/width=450/1158439.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1072,
                                    "height": 1608,
                                    "hash": "UUIhjc4m?wt8R.D%Rjoz%N-=s-af0Kn~t7of",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/96797"
                        },
                        {
                            "id": 54221,
                            "name": "90sv1.6R",
                            "index": 3,
                            "modelId": 28600,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p><strong>more characters, better prompts, more styles</strong></p><p>1.7R on <a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/OneRing\"><strong>Patreon</strong></a></p>",
                            "publishedAt": "2023-04-24T15:56:02.902",
                            "availability": "Public",
                            "trainedWords": [
                                "1990s \\(style\\)",
                                "1980s \\(style\\"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 6265,
                                "ratingCount": 1103,
                                "rating": 5,
                                "thumbsUpCount": 1105,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 39221,
                                    "sizeKB": 147590.884765625,
                                    "name": "90sv1.6R.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-24T15:11:44.247Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "27C19C2A",
                                        "AutoV2": "E65E718B0E",
                                        "SHA256": "E65E718B0E0B5A3503E237E46F8C19FB74C71AF6ADB25D71587B6A393F6052D3",
                                        "CRC32": "65AD3EEE",
                                        "BLAKE3": "990C941AA1F4F22064F150F000F277D40B3A9CBB20C03FF0F188230116E281EB",
                                        "AutoV3": "D40D74EA180B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/54221",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 586329,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7963754a-6381-450c-c3a4-23a5437fab00/width=450/586329.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UOHwQ8{v03s7vg+^=|ogR%S3bbWYXUNFkCxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 586033,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6b5daf42-efcf-4657-a918-c655f1181500/width=450/586033.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UWHTjx+bDOj[}tv~V@o#vMt8o#t6V@XSNGjF",
                                    "type": "image"
                                },
                                {
                                    "id": 586269,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/484b67e5-7195-414a-aaaf-26bbfd45d500/width=450/586269.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UAHTw5Dk00?a0htkXPE100oJ~VRk=^M{V@%L",
                                    "type": "image"
                                },
                                {
                                    "id": 586671,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b06b65b4-6d41-410b-79fa-d6d4910f8800/width=450/586671.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UaI4qw~WEMM{rsV[oz%Logt7ogRkozozxaay",
                                    "type": "image"
                                },
                                {
                                    "id": 586623,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ef3d3994-5ad5-405e-4e43-04b4c818fc00/width=450/586623.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UPHng7~W9aM|0fSNRPM|I=D*MxM|={xar?%1",
                                    "type": "image"
                                },
                                {
                                    "id": 586268,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f5e1db80-3238-46b8-f34a-afacb6d7d500/width=450/586268.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "U7FF{bx[00b_019Es,-:0NWY-4X9~C_2o~ES",
                                    "type": "image"
                                },
                                {
                                    "id": 586731,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1e4a423c-4e3e-4232-50da-f4d260029100/width=450/586731.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UFEo_h-q1PAI01aeXAM|%%R+rp-p00NG%2xY",
                                    "type": "image"
                                },
                                {
                                    "id": 586303,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7d3180ea-cace-4c54-1e72-bc165a105000/width=450/586303.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UGHnmW9u%#R%~XoI?axa?u-p?HoypJ%M-;-;",
                                    "type": "image"
                                },
                                {
                                    "id": 586032,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/08f9306f-5165-4ee4-e79c-16063d582600/width=450/586032.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UGHLrQs.004nO^WY^,xu%1xa4n%M.TRi%1Ri",
                                    "type": "image"
                                },
                                {
                                    "id": 586267,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/64089ee8-f39a-40b1-c68f-bedfe5ccad00/width=450/586267.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UGL2;$J7*0J*^l~qkX-:^+_3-pOF_4V?~B8{",
                                    "type": "image"
                                },
                                {
                                    "id": 586270,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/15d06f3d-17df-48c3-ca01-5a1520e52100/width=450/586270.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UdKwz+xa_3xv~WV@tRozW=WBofofozt7RPs:",
                                    "type": "image"
                                },
                                {
                                    "id": 586341,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/16d6ab28-f8f0-4b88-fc5f-fa937db88300/width=450/586341.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UiKAsYo#f5RjRi9axujE~qn%x]-p%MxabHo0",
                                    "type": "image"
                                },
                                {
                                    "id": 586423,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6e2f5f5e-7099-4003-bdd7-c96d35e82c00/width=450/586423.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UDG8cn9biZ~U00xs0MIV?uIs-=oa01^*^#IU",
                                    "type": "image"
                                },
                                {
                                    "id": 586503,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/024702f6-6a45-4eb3-4f3f-29ffe5972200/width=450/586503.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UeHx1r~p-.jYxuxuIpRjIUIVRka}IURiaykC",
                                    "type": "image"
                                },
                                {
                                    "id": 586530,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eabc235d-ad8c-481d-c4aa-fcd86da01e00/width=450/586530.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UEIXBg~q0fxG0KDin4NaPUtPH?kYv}n$I9IV",
                                    "type": "image"
                                },
                                {
                                    "id": 586592,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/af03f1a7-12f4-4635-7d71-97333926b700/width=450/586592.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "U9F$VD.S0f%48^Rj4nD%C9=}~WW,m*xvWEog",
                                    "type": "image"
                                },
                                {
                                    "id": 586035,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71ac9c92-a8bd-4bcf-2ef9-ba048c9e4100/width=450/586035.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1096,
                                    "height": 1648,
                                    "hash": "UKI4w=9Gg%-o.mxt^j%M0N?GvzXT^hsp9ZWC",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/54221"
                        },
                        {
                            "id": 39946,
                            "name": "v1.2R",
                            "index": 4,
                            "modelId": 28600,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p><strong>new versions</strong> 1.3RW, 1.4RW, 1.5RW, 1.6R on <a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/OneRing\"><strong>Patreon</strong></a><br /><br /><strong>A fixed version</strong>, on the basis of which this lora will expand</p>",
                            "publishedAt": "2023-04-08T12:22:37.269",
                            "availability": "Public",
                            "trainedWords": [
                                "1990s \\(style\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3552,
                                "ratingCount": 778,
                                "rating": 5,
                                "thumbsUpCount": 780,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 31009,
                                    "sizeKB": 147569.42578125,
                                    "name": "90sv1.2R.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-08T12:16:47.566Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "2B9AA6ED",
                                        "AutoV2": "FD0BE37737",
                                        "SHA256": "FD0BE37737DA146EB7E410921D50C83B857E9648D1CAF429802740A5E4C4FC37",
                                        "CRC32": "4C1226CF",
                                        "BLAKE3": "CC689A6D97D8834014264A7F384DA07CA1FE088BA6EE6FA0EAD7B4AD012D9518",
                                        "AutoV3": "59176D646AFC"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/39946",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 442387,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/585f8caf-5694-40c6-f7d1-82bee4b6c000/width=450/442387.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDEMX-?b5T-;9YoJ%NXT00S*.9WV~AtlD%?H",
                                    "type": "image"
                                },
                                {
                                    "id": 442348,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a7845afc-57e9-4efa-e1ce-2d037610d300/width=450/442348.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFGR^}_NPD~WS$WB^*xX9GxV%LE1I9-;M|NG",
                                    "type": "image"
                                },
                                {
                                    "id": 442294,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d52d95f8-5bfe-4d26-3958-cb83c1358f00/width=450/442294.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UWKJ.LMwoc.8G^={pcs:-;xF#nS$%M9uRinN",
                                    "type": "image"
                                },
                                {
                                    "id": 442297,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/42327a8b-954e-43eb-c8aa-d69b288a8f00/width=450/442297.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USH^xO4.7#$jpHMcr;EgEeRk$Msp.TjFpJt6",
                                    "type": "image"
                                },
                                {
                                    "id": 442304,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6cd62fd5-78c4-470f-7840-2ed5278cb100/width=450/442304.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKDcH_IT-;nO?wadX9IU%ht7%MIU.8%MWXRj",
                                    "type": "image"
                                },
                                {
                                    "id": 442314,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ea3a7cda-a0a9-4af9-32ba-49810076e700/width=450/442314.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBHo5s005?s7004m?v9ZEL?bMw~W9a?Gn$xu",
                                    "type": "image"
                                },
                                {
                                    "id": 442329,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a95edc92-7e93-4edb-cb20-46eb90337900/width=450/442329.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UrG+akIUNG-;_4xaj[bb?Ha}ofod%LWVaejF",
                                    "type": "image"
                                },
                                {
                                    "id": 442332,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e741d4f8-2c4a-4d35-a6f4-4e93a990d300/width=450/442332.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPH_oh_N?wtRR%MwWrIV%1E1%MWU4:t6?Hxu",
                                    "type": "image"
                                },
                                {
                                    "id": 442339,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1fb934c6-3319-4bdd-bafa-a5b85bca2a00/width=450/442339.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UVI}bd4m?w-=56fiRjx]s:t7M_M{IAkCoyV@",
                                    "type": "image"
                                },
                                {
                                    "id": 442358,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e78c1cf0-5029-44e5-3e00-436b02285800/width=450/442358.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJHC1d-P9*$x~7s7?bMxm%D*%LV=fmE3M^oL",
                                    "type": "image"
                                },
                                {
                                    "id": 442360,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ceeb41a6-5f61-49be-d7f3-8fb2a4246100/width=450/442360.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKI#r*J5?v%%xa%Mo~?GgL-;RkD%tR%1MxE2",
                                    "type": "image"
                                },
                                {
                                    "id": 442390,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5b7a3b85-2440-4c02-fe1b-84dee6edb400/width=450/442390.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UtG]BpxuWBWB_Nx]WBfkbHt7Rij]D%j]Rjay",
                                    "type": "image"
                                },
                                {
                                    "id": 442393,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/15489adc-daad-488f-5e5b-268a0f8ef200/width=450/442393.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UcGa]+xtj[oL~Ubbn%NH^%RkV[RktQayoej[",
                                    "type": "image"
                                },
                                {
                                    "id": 442399,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/de2de8c0-8f23-4e92-9ecd-b9a929047d00/width=450/442399.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UnHU,,jr9F-p_NjYITtQJCj[RiNHIVbIj?Rk",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/39946"
                        },
                        {
                            "id": 39931,
                            "name": "v1.2",
                            "index": 5,
                            "modelId": 28600,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 11,
                            "description": "<p><strong>intermediate version</strong>, maximum accuracy, but low quality.</p>",
                            "publishedAt": "2023-04-08T12:09:06.62",
                            "availability": "Public",
                            "trainedWords": [
                                "1990s \\(style\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 480,
                                "ratingCount": 1,
                                "rating": 5,
                                "thumbsUpCount": 2,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 31000,
                                    "sizeKB": 147569.4248046875,
                                    "name": "90sv1.2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-08T12:07:49.468Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "8EF437A7",
                                        "AutoV2": "0E6F7A4D64",
                                        "SHA256": "0E6F7A4D64199EF375C0AB9E332ABEF4B5BFC4015309C679B5DC1B8CA8D05A31",
                                        "CRC32": "D1FDA6E5",
                                        "BLAKE3": "7C1739ABE5FAA169A423C86E0CA9EA5550202BC4E60285883295D8052E139C87",
                                        "AutoV3": "A1B272BB0860"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/39931",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 442231,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c82cddc1-cb77-44a3-3a32-82e78c059400/width=450/442231.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMGSAZGdR%4ntmRPn29Gx@-lNIM{S1f+kYs.",
                                    "type": "image"
                                },
                                {
                                    "id": 442226,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d9838e04-2811-4e65-85ea-24f0760b5400/width=450/442226.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UeJHRD-;.SR5~WbvyDni~ps:%2NG%hn$xbWo",
                                    "type": "image"
                                },
                                {
                                    "id": 442228,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b8823cf1-495f-4dbe-eb40-4f5960d71800/width=450/442228.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNHB9?59%et7QR0gxrRQUH9dxtnO=V$fXRkU",
                                    "type": "image"
                                },
                                {
                                    "id": 442209,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3b167949-71c2-4390-cb22-c87e28a9da00/width=450/442209.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3840,
                                    "height": 1795,
                                    "hash": "UZLz:O~q_N_2%gt6ofRj_3V[M{of?bRjRje.",
                                    "type": "image"
                                },
                                {
                                    "id": 442206,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8ff78823-8995-4eae-5b8d-21a5c132d100/width=450/442206.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1408,
                                    "height": 897,
                                    "hash": "UfMtR0_M~q?b.9ROs-ae?bRjRjayxat8RjNF",
                                    "type": "image"
                                },
                                {
                                    "id": 442213,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0bad21bf-9cfa-4b68-ed40-8fee8b007b00/width=450/442213.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 3840,
                                    "height": 1795,
                                    "hash": "UjL;W|~q?v.8?bRjWCjb%gWBaKWB-;WBWAWB",
                                    "type": "image"
                                },
                                {
                                    "id": 442218,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1db40101-221c-488b-e51b-4daa69e31400/width=450/442218.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3840,
                                    "height": 1795,
                                    "hash": "UeKni1~q_M?b?FRkbcWB?vRjWAWB%gV[jFbI",
                                    "type": "image"
                                },
                                {
                                    "id": 442235,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c29713b8-fd87-477c-df7e-0ce2999c6e00/width=450/442235.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UUJ@zo*0t.IpElE4kEae16aLWBNJ9Goe?Gs,",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/39931"
                        },
                        {
                            "id": 34306,
                            "name": "90sv1",
                            "index": 6,
                            "modelId": 28600,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>the first version does not understand character names well because of my mistake, in version 1.2R on <a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/OneRing\"><strong>Patreon</strong></a> everything is fixed, the style of the 90s is improved, new art and \"understanding\" of names are added, this lora will be updated many, many times with the addition of new characters and will be based on version 1.2R<br /><br />Be patient, this lora will be updated regularly and other versions will be in the public domain</p>",
                            "publishedAt": "2023-04-03T09:33:28.258",
                            "availability": "Public",
                            "trainedWords": [
                                "1990s \\(style\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2258,
                                "ratingCount": 502,
                                "rating": 5,
                                "thumbsUpCount": 505,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 28205,
                                    "sizeKB": 147583.513671875,
                                    "name": "90sv1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-03T09:36:13.001Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "7D34357A",
                                        "AutoV2": "2F67CC73C9",
                                        "SHA256": "2F67CC73C98A2DD6870C090C1D72904C6E5942969E4B53FA0739BB3420CA2B31",
                                        "CRC32": "9B118F6E",
                                        "BLAKE3": "DE13864B7AA89C1BE93D65458FC89C417F3CF338789A71D01F0F080A5E487BE1",
                                        "AutoV3": "2322C3D7F1DE"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/34306",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 391803,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ca48ca35-84e2-488c-c0d8-6c622d2fbe00/width=450/391803.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "URL3[l.lKP]4.T?v-:i_4?RlEk-VK7n3rqJU",
                                    "type": "image"
                                },
                                {
                                    "id": 391816,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6dde5556-fa88-4b3c-d913-0c478a312900/width=450/391816.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCF6FUv}000MHX4T.7tl?HWV?wS$8wog%MIU",
                                    "type": "image"
                                },
                                {
                                    "id": 391815,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8e9a7873-b36e-4aa3-8747-6e7209948800/width=450/391815.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UeG*ym-:yDbb~qkDx]WV~pt7-poL?bWBozj@",
                                    "type": "image"
                                },
                                {
                                    "id": 391814,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/15637422-2cab-4c65-866e-2555057bab00/width=450/391814.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "URNA3e-p_4SgH?xuxbE0yYRjt7s:M|Z$tQM{",
                                    "type": "image"
                                },
                                {
                                    "id": 391813,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a89951e3-c0c9-456c-61cc-0a0573249300/width=450/391813.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USJH,Y~pE0wb9Fx[adIA-:NFofog-:t69aNH",
                                    "type": "image"
                                },
                                {
                                    "id": 391812,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a7dba5a1-6db8-4894-4a78-6ef3b4c3d300/width=450/391812.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UjJaySWq?vV@~VW=tRjFRifiIVs:s:oLW;fk",
                                    "type": "image"
                                },
                                {
                                    "id": 391811,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3109c665-b0a7-48ae-075a-1279b5e91e00/width=450/391811.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJKdV#4T0w_N00M|rt%MKzxu-qV@00xu9ZIo",
                                    "type": "image"
                                },
                                {
                                    "id": 391810,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/21bc574f-78ff-41fe-39da-1a1ddd6b2100/width=450/391810.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDIX:PwH~VR?^*OYpJ~ppaVtoNIUyD={H?9G",
                                    "type": "image"
                                },
                                {
                                    "id": 391809,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9d3e5a5a-91af-448d-606d-1ed5b42f3000/width=450/391809.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNJHwCt7OtD*00IAx]IU_NIURPR*SO%M?bxt",
                                    "type": "image"
                                },
                                {
                                    "id": 391808,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b059edd2-6201-4cd3-66a0-81e747f4e200/width=450/391808.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UVJ7]$xu.8-p02rrRjNx~UxtjYE1R5D%I;oe",
                                    "type": "image"
                                },
                                {
                                    "id": 391807,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2a05749c-7853-40cf-ad9e-57e735f2d900/width=450/391807.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UeI59}~TDg$*os%L-;xubvo#kDRkt7oMjFj[",
                                    "type": "image"
                                },
                                {
                                    "id": 391806,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5df91ba6-11db-4946-1788-5aca4e974c00/width=450/391806.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKI4*7009]xG-:9Fozs:_2My%ME1~VniNHsm",
                                    "type": "image"
                                },
                                {
                                    "id": 391805,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6b5b702a-4711-4e4e-84b9-99d8d0759e00/width=450/391805.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDH^-f.800IB8wE2.8%29GM{^kt7}=R*9ss,",
                                    "type": "image"
                                },
                                {
                                    "id": 391804,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/23d83402-b546-4b4d-f2ce-17fe1d683c00/width=450/391804.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UVGkE_-:~AxZ9%IWE3NGo{%0R%bGs.IpxEs:",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/34306"
                        }
                    ]
                },
                {
                    "id": 38551,
                    "name": "Squeezer - Experimental",
                    "description": "<p>It changes the character's body shape without destroying the model's characteristics, as shown in the example image. <strong>(Doesn't work for realistic models)</strong></p><p>The strength of the effect can vary depending on the model and the LoRAs mixed in, etc.</p><p>Stable for most models up to ±1.5(max 2.0), beyond that, there may be issues</p><p>It can act as a secondary to some of the functionality of the <a rel=\"ugc\" href=\"https://civitai.com/models/65214?modelVersionId=69898\">Age slider</a>, and can still be useful when building models. </p><p></p><p>////////////////////////////////////////////////////////////////////////////////////</p><p>Do you like my work? check out my profile and see what else!</p><p>And <a target=\"_blank\" rel=\"ugc\" href=\"https://ko-fi.com/bradcatt\"><strong>A cup of coffee would be nice! 😉</strong></a></p><p>////////////////////////////////////////////////////////////////////////////////////</p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 30468,
                        "favoriteCount": 0,
                        "thumbsUpCount": 4074,
                        "thumbsDownCount": 0,
                        "commentCount": 45,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 700
                    },
                    "creator": {
                        "username": "Bradcatt",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/abb3676c-fefb-4624-7118-5c762fc86200/width=96/Bradcatt.jpeg"
                    },
                    "tags": [
                        "anime",
                        "character"
                    ],
                    "modelVersions": [
                        {
                            "id": 54302,
                            "name": "💩",
                            "index": 0,
                            "modelId": 38551,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-04-24T16:45:56.378",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 25066,
                                "ratingCount": 2683,
                                "rating": 5,
                                "thumbsUpCount": 3370,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 39265,
                                    "sizeKB": 147567.224609375,
                                    "name": "Squeezer2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-24T16:46:34.752Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "CB0427FA",
                                        "AutoV2": "518AB90C3C",
                                        "SHA256": "518AB90C3CA517FDE1CB3F4E8D03B28F7E1C23675DFD81796CB1869F105F7AB5",
                                        "CRC32": "1084F299",
                                        "BLAKE3": "6819B2E317AEDC4BE0D7519C8F88A9428D24A0FC8E1D2604385A8B0F4FCA98A3",
                                        "AutoV3": "990210F35558"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/54302",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 587193,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a78fae20-7e1e-4c8e-c737-5ceb6dd02b00/width=450/587193.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 450,
                                    "height": 356,
                                    "hash": "UCK^Kf00R%%g]Nt7WUR%*IIVWYnl%#IpWXog",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/54302"
                        },
                        {
                            "id": 44493,
                            "name": "😺",
                            "index": 1,
                            "modelId": 38551,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-04-18T10:00:16.714",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5402,
                                "ratingCount": 710,
                                "rating": 5,
                                "thumbsUpCount": 718,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 33538,
                                    "sizeKB": 147567.224609375,
                                    "name": "Squeezer.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-13T08:46:31.289Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "CB0427FA",
                                        "AutoV2": "F034CD3E52",
                                        "SHA256": "F034CD3E521CC3E6B32B47083A34FD32797139A3F057E1D450D596110B6FCB4E",
                                        "CRC32": "08FC4D5D",
                                        "BLAKE3": "F143BC9B80475285E10A215E8EE515357B2CFC683241F93A2C7C8B1881381B51",
                                        "AutoV3": "6BADE872DC7E"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/44493",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 484683,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6b8267f8-c0ae-46ea-0b74-82793d335100/width=450/484683.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1456,
                                    "height": 1152,
                                    "hash": "UCK^Kf00R%%g]gt7WBR%*IIVWrjIyXIpWXog",
                                    "type": "image"
                                },
                                {
                                    "id": 484699,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f629e387-6498-439d-aaea-f8f77ba85300/width=450/484699.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U9IE2~-:49rX}RR*F{-UUGI=HtxtPUSiDkNG",
                                    "type": "image"
                                },
                                {
                                    "id": 484684,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b54fc285-67dc-45af-cc68-1ca7a2fd4800/width=450/484684.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAIg$M-:3?v~}RS1KQ-AUGI[H@xDTxNf9Had",
                                    "type": "image"
                                },
                                {
                                    "id": 484686,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b5c0129e-9c39-4d36-5e7f-73c65c6fd100/width=450/484686.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCJQl}oz3=^P}SWVFf$gLLNKQ.o{csNeDkov",
                                    "type": "image"
                                },
                                {
                                    "id": 484687,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7072382f-4252-40ff-2cda-7192c689b000/width=450/484687.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "URN9%$tRys$h#kbHT0ni%zaKMekp%fa#RQof",
                                    "type": "image"
                                },
                                {
                                    "id": 486216,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/432465d6-3667-4cd9-b28e-6444da598300/width=450/486216.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8IVb}$j00w{~Aoe9bRkocWVM|s.wJayIpoL",
                                    "type": "image"
                                },
                                {
                                    "id": 486215,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2cf0dc06-7260-4583-fee3-ce979ca11d00/width=450/486215.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U6Iet*$jD4,;}=jZEQX7+aaeA[of}[oe0fWB",
                                    "type": "image"
                                },
                                {
                                    "id": 491470,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3300bf72-f36c-42c2-219f-094095a46400/width=450/491470.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDKApO$*O@%g-9V@Xmo}00V@WCR,~VtR0LRP",
                                    "type": "image"
                                },
                                {
                                    "id": 491463,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ab2ea1fa-45c9-465b-ba9a-4189d38bca00/width=450/491463.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8KT##-p10?H}@jZK6kC00V@%2I;-oay9Goy",
                                    "type": "image"
                                },
                                {
                                    "id": 491464,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/08e8f357-7e7b-4938-4a61-80e92cbc9e00/width=450/491464.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDK,{f%L5R-:Dij[tla}0KaeE2NG~Wju4.bF",
                                    "type": "image"
                                },
                                {
                                    "id": 491550,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fcd9afbf-6c9a-4f43-8cc8-a1d19816e900/width=450/491550.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3826,
                                    "height": 1152,
                                    "hash": "UCKT_LS$%LxZ}@bIoJsl~Ws-t7t6~qnit7WV",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/44493"
                        }
                    ]
                },
                {
                    "id": 8949,
                    "name": "Jim Lee (DC Comics / Marvel) Style LoRA",
                    "description": "<h2>Jim Lee (DC Comics / Marvel) style LoRA</h2><p><strong>Making models can be expensive. Do you like what I do? Consider supporting me on </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/Lykon275\"><strong>Patreon</strong></a><strong> 🅿️ or feel free to </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://snipfeed.co/lykon\"><strong>buy me a coffee</strong></a><strong> ☕</strong></p><p>Been wanting to try this for a long time now. I think this came out pretty nicely and captures the style of Jim Lee quite well. I tested it on AnyLoRA and AbyssOrangeMix2 with my negative embeddings and it's pretty convincing <strong>at weight=1 for the offset version and 0.65 for the original (check \"original\" tab for a comparison)</strong>. Use the prompt <code>jim lee</code> for better accuracy.</p><p>Keep in mind that, while this can make Superman, Batman and Wonder Woman pretty well, this is not a character LoRa but a Style LoRA. Have fun making your own superheroes!</p><p><strong>NOTE: </strong>I used ControlNet on some of the examples. Check the full generation data.</p><p>2nd pic courtesy of <strong>sadxzero </strong>from the reviews.</p><p></p><p><strong>How to use LoRA's in auto1111:</strong></p><ul><li><p>Update webui (use <code>git pull</code> <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/embed/mn8fMF10XN4?start=31&amp;end=60\">like here</a> or redownload it)</p></li><li><p>Copy the file to <code>stable-diffusion-webui/models/lora</code></p></li><li><p>Select your LoRA like in <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/watch?v=-bMeyXOZwN0\">this video</a></p></li><li><p><strong>Make sure to change the weight</strong> <strong>according to the instructions of the model </strong>(by default it's <code>:1</code>)</p></li></ul>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 5,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 28804,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3983,
                        "thumbsDownCount": 0,
                        "commentCount": 52,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 0
                    },
                    "creator": {
                        "username": "Lykon",
                        "image": "https://cdn.discordapp.com/avatars/180327464155742208/59254be18ccd627daf138d053327485d.png"
                    },
                    "tags": [
                        "batman",
                        "superhero",
                        "marvel",
                        "dc comics",
                        "comics",
                        "style",
                        "art style",
                        "wonder woman",
                        "superman",
                        "jim lee",
                        "artstyle"
                    ],
                    "modelVersions": [
                        {
                            "id": 10580,
                            "name": "offset",
                            "index": 0,
                            "modelId": 8949,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": null,
                            "publishedAt": "2023-02-15T01:34:39.201",
                            "availability": "Public",
                            "trainedWords": [
                                "jim lee"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 27904,
                                "ratingCount": 91,
                                "rating": 5,
                                "thumbsUpCount": 140,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 10220,
                                    "sizeKB": 147567.2177734375,
                                    "name": "jim_lee_offset_right_filesize.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-15T15:51:04.889Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "F7E84A73",
                                        "AutoV2": "3CB37EF4FD",
                                        "SHA256": "3CB37EF4FD9AE4D5F154CC53079FC89DC91C26475958378CF6086D228353CC04",
                                        "CRC32": "A2AF7091",
                                        "BLAKE3": "0FB88E573510581A774050FEB9FD4B0B3EAE0C84C5AE50CC912C653E9DE44E9C",
                                        "AutoV3": "A549961DAAFF"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/10580",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 102779,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/671dc47e-cace-49e6-4bb4-7a0997b10100/width=450/102779.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UfMG#NR*_NtStRR+R*WV.8V[%LV@xvWBoLs:",
                                    "type": "image"
                                },
                                {
                                    "id": 103823,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c5d6b7e8-b036-4f17-1aab-87446e078500/width=450/103823.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 960,
                                    "height": 1344,
                                    "hash": "U9Eff^.T,ANy0LD%xCxaDi=_58e-03IUXnNd",
                                    "type": "image"
                                },
                                {
                                    "id": 102795,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/db1107bc-2493-4354-84d4-82a83cc3b600/width=450/102795.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UjIhN--;%Mt7~VNFo#NG?Cs-xDWAI[a~s+t7",
                                    "type": "image"
                                },
                                {
                                    "id": 102794,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/30ab31cf-2332-460b-0ec4-8871541a4d00/width=450/102794.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UJIN,GNa00=x}m%M9ZIV9aE1yD-;8{9b%g^i",
                                    "type": "image"
                                },
                                {
                                    "id": 102793,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/067462e5-f222-4b82-9dcc-f4708cc78900/width=450/102793.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1304,
                                    "hash": "UoLp2LM|kAsA~BogfkR*M}xaV[R+s:RkWVt6",
                                    "type": "image"
                                },
                                {
                                    "id": 102792,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d82a004d-4d41-4100-ffc9-beb43093e200/width=450/102792.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "URLgO%%$T2I^u6MxE,M}?vt24;t69$s=IU$d",
                                    "type": "image"
                                },
                                {
                                    "id": 102791,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/88914b63-c107-4f84-ff8a-1169aea55b00/width=450/102791.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UMHx4.~VE0Rjk8xt-ot7$d-SI[-o9ut7xbob",
                                    "type": "image"
                                },
                                {
                                    "id": 102790,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/36f4672f-bce9-4adc-e746-24c7f3210000/width=450/102790.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UBJH]z00lo?HPC8w.9xZG0-;Vrx]~V%h0gSh",
                                    "type": "image"
                                },
                                {
                                    "id": 102789,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5fb01590-4b58-49c5-d394-35e2004b1600/width=450/102789.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UJHnpX%h~VM{4oxZxsS4E2oIE1obxZxsRkIo",
                                    "type": "image"
                                },
                                {
                                    "id": 102788,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/41a408f4-038c-4d0f-a573-3f1ec7e3ae00/width=450/102788.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 864,
                                    "height": 1304,
                                    "hash": "UTL3+G==%3a0K,RPS*x[?^%KJWtQTKofi_M|",
                                    "type": "image"
                                },
                                {
                                    "id": 102787,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/032036cf-fd48-44ec-a53d-2434342aab00/width=450/102787.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1304,
                                    "hash": "UJFZ7}9v.8.T9~%2MxWV?GD%$$Mx4oxux]t6",
                                    "type": "image"
                                },
                                {
                                    "id": 102786,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f067ff20-40d2-4fae-1b60-0b3df4252d00/width=450/102786.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1344,
                                    "height": 896,
                                    "hash": "UcKTlRRPvzVs~B-U58RPt3xCS~I@NHkWo}oz",
                                    "type": "image"
                                },
                                {
                                    "id": 102785,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/337bab8f-02d6-48ae-7f6b-e3dd8520a400/width=450/102785.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1304,
                                    "hash": "UbJHXXT0X.IU~pn3-pV@%gae-pxa?ao#x]kW",
                                    "type": "image"
                                },
                                {
                                    "id": 102784,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/043e8588-37b5-45a6-e7ee-385d8b0f3e00/width=450/102784.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 864,
                                    "height": 1304,
                                    "hash": "UXL3rx-:tS^j~UIojFt7xubGWBWBt7t7WXaf",
                                    "type": "image"
                                },
                                {
                                    "id": 102783,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2d2543ab-2667-4382-d6d2-e090f8cd3500/width=450/102783.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "URMP:t~W-:-n.8%MxaNH?uIpRjR%?bIpxaM|",
                                    "type": "image"
                                },
                                {
                                    "id": 102782,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a430ec74-af0c-4cd1-9aa9-836a3bd2a500/width=450/102782.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UeIWo$xa$zoJ~9s-n+WW]}jFI=a#$eoJR+s.",
                                    "type": "image"
                                },
                                {
                                    "id": 102781,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1b146406-1679-4fb6-18ba-c7ee73fbe200/width=450/102781.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIGIo_s:?bs:_NkU?cWCngRO-;oz?vMxxaM{",
                                    "type": "image"
                                },
                                {
                                    "id": 102780,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d776100c-0502-48cb-c27f-3c5d591db800/width=450/102780.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHJjh@s=%0M{-oNaIqE3NLWYn5sl~9RixYNG",
                                    "type": "image"
                                },
                                {
                                    "id": 105538,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bcac99cf-70ce-4d7f-a522-89d344fb9b00/width=450/105538.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UDKK.c-B3ht+8wR6*GRk9ExZ-XNdu5xZyCI=",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/10580"
                        },
                        {
                            "id": 10754,
                            "name": "original",
                            "index": 1,
                            "modelId": 8949,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": null,
                            "publishedAt": "2023-02-15T11:19:26.156",
                            "availability": "Public",
                            "trainedWords": [
                                "jim lee"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 900,
                                "ratingCount": 3385,
                                "rating": 5,
                                "thumbsUpCount": 3869,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 10113,
                                    "sizeKB": 147569.169921875,
                                    "name": "jim_lee.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-15T11:21:02.425Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "47E2055B",
                                        "AutoV2": "C7A7E0C99E",
                                        "SHA256": "C7A7E0C99E496762A8404EF076F86E611D6C5149CEB2FEB8363123AF6A1D4CE6",
                                        "CRC32": "CA8F6762",
                                        "BLAKE3": "EF078E928E415A1E9E56F60D0FF4AE5D94AC6F94191D788BA7EAB17B66D371D1",
                                        "AutoV3": "4F2B18F2C3F2"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/10754",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 104946,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bc39aa5e-75ca-4cf8-f5a8-4c6614134b00/width=450/104946.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 895,
                                    "hash": "UaFGC8t7aytR?ZWBayV@~pjsayjY~Wogayt8",
                                    "type": "image"
                                },
                                {
                                    "id": 104945,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4b688d25-51d3-4bed-52ee-66ca7fcf3600/width=450/104945.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 895,
                                    "hash": "UmM6;ot6j[t6~qR*ayNG%hoLays:x^ofays:",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/10754"
                        }
                    ]
                },
                {
                    "id": 6433,
                    "name": "[LORA]Flat_Color",
                    "description": "<p>When an image is colored in solid blocks of color, without shadows, highlights, or gradients. The image is \"flat\" in that there are little to no indications of depth.</p><p>This model  works better on<strong><em> scenery</em></strong> than character,if you want a image with a well sketched girl , I wont recommend you to try this lora. </p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 19864,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3942,
                        "thumbsDownCount": 1,
                        "commentCount": 9,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 1
                    },
                    "creator": {
                        "username": "Ekitai_192",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b589447c-350c-4cd7-ede2-0c3ae9a26400/width=96/Ekitai_192.jpeg"
                    },
                    "tags": [
                        "style"
                    ],
                    "modelVersions": [
                        {
                            "id": 7555,
                            "name": "flat_color",
                            "index": 0,
                            "modelId": 6433,
                            "baseModel": "Other",
                            "nsfwLevel": 1,
                            "description": "<p><strong>parameters</strong></p><p>as109<strong>,</strong>(Highest picture quality), (Master's work), (Detailed eye description), (8K wallpaper),(Detailed face description),(flat color:1.3),(ligne claire:1.3),(beautiful_detalied_oange_sky:1.2),(cloudy sky:1.2),pale_color,reflective_water,(1girl:1.3),sunset,twilight,flying_fishes,standing_on_liquid,looking at viewer,outdoors,(full_body),holding_shoes ,wide shot,(((masterpiece))),(best quality),beautiful detailed bright aqua eyes,(beautiful detailed shiny pink_hair:1.2),very long hair,(smile), (white_shirt),barefoot,bare legs,bus stop, street, fence,road_sign,ripples,utility_pole<br />Negative prompt: nsfw,tiger,deformed,lowers,bad anatomy,bad hands,bad feet,text,error,missing fingers,extra digt,fewer digt,cropped,worst quality,low quality,normal quality,blurry ,mosaic_censoring,mosaic,extra legs,extra fingers,extra tongues,extra navels,extra feet,extra hands,multiple legs,multiple fingers,multiple tongues,multiple navels,multiple feet,multiple hands,helmt, lowres, bad anatomy, bad hands, text, error, missing fingers, extra digit, fewer digits, cropped, worst quality, low quality, normal quality, jpeg artifacts, signature, username, blurry<br />Steps: 30, Sampler: DPM++ 2S a Karras, CFG scale: 4.5, Seed: 1080477712, Size: 640x1024, Model hash: 5db7b92a37, Batch size: 3, Batch pos: 0, ENSD: 31337, AddNet Enabled: True, AddNet Module 1: LoRA, AddNet Model 1: flat_color(a89a33de), AddNet Weight 1: 0.55</p>",
                            "publishedAt": "2023-02-03T12:54:49.642",
                            "availability": "Public",
                            "trainedWords": [
                                "flat_color,ligne_claire"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 19864,
                                "ratingCount": 3497,
                                "rating": 5,
                                "thumbsUpCount": 3942,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 7625,
                                    "sizeKB": 74063.5791015625,
                                    "name": "flat_color.pt",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-03T12:56:10.311Z",
                                    "metadata": {
                                        "format": "PickleTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "A89A33DE",
                                        "AutoV2": "E91F4A5285",
                                        "SHA256": "E91F4A528578921540A1DBCD802BB5CA8F7F51CB30309CCADAE6E20B802080BC",
                                        "CRC32": "D74F521B",
                                        "BLAKE3": "5E90307564E5EA41506B27FFA0D85FF9B48FBFB319CBEE361BB24A3E1F5A78D6"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/7555",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 70779,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ba7af3e7-f55b-42dc-be79-384740f72a00/width=450/70779.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 2048,
                                    "hash": "U7FP:D0|8wDi1PyE}?x^Yhog,GGG?JiHOsAt",
                                    "type": "image"
                                },
                                {
                                    "id": 70778,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/15708976-86fd-46a4-24b6-a1068b9dae00/width=450/70778.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 2048,
                                    "hash": "ULGSfjMwMw%g_Mt8^Qxa,_J6%2X8wGFeM}jb",
                                    "type": "image"
                                },
                                {
                                    "id": 70777,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9b1600be-9bba-45a1-433a-c63997721c00/width=450/70777.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 2048,
                                    "hash": "UWKBatyrO?tR~COWtRkW-;RPkBofIAVsNGj[",
                                    "type": "image"
                                },
                                {
                                    "id": 70776,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6247682a-ffa7-4721-aef4-0f6edee7dd00/width=450/70776.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 2048,
                                    "hash": "UUKw;1^*E0o|~V?axrR*E0-o%MRQ={t7ofNG",
                                    "type": "image"
                                },
                                {
                                    "id": 70775,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e75d39c6-159a-4931-e888-07d94e00c000/width=450/70775.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 2048,
                                    "hash": "UEGl-*?c02tRyZ%MjXoKG0Xn-;ogOBtl%3NH",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/7555"
                        }
                    ]
                },
                {
                    "id": 5891,
                    "name": "Crazy Expressions",
                    "description": "<p>A lora born of my irritation with the lack of the AI's ability to output truly insane or traumatized looking characters. I recommend for most use cases you refer to the \"constricted pupils\" tag followed by a facial expression. Check out \"About This Version\" for more details.</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 15,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 30013,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3927,
                        "thumbsDownCount": 1,
                        "commentCount": 24,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 2
                    },
                    "creator": {
                        "username": "Annawn",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/746e2dbd-30e0-43a8-891e-721f4134af2c/width=96/Annawn.jpeg"
                    },
                    "tags": [
                        "character",
                        "constricted pupils",
                        "yandere",
                        "crazy",
                        "faces"
                    ],
                    "modelVersions": [
                        {
                            "id": 91871,
                            "name": "Constricted Pupils V3",
                            "index": 0,
                            "modelId": 5891,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>Entirely retrained on 100 images. Version notes are as follows:</p><ul><li><p>No longer generates random mask parts and stuff. Should work better when blended with other LORAs now. I think.</p></li><li><p>May have a tendency to lower detail in the overall image, try to use mid to high weights.</p></li><li><p>Inpaint tested, need only highlight the eyes now.</p></li><li><p>With this version, there are only two trigger token: <strong><em>\"constricted pupils, small pupils\"</em></strong></p></li></ul><p>If you experience any issues with this version, I recommend downgrading or you can also try <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/48579/yameroyandere\">https://civitai.com/models/48579/yameroyandere</a></p>",
                            "publishedAt": "2023-06-08T20:45:37.105",
                            "availability": "Public",
                            "trainedWords": [
                                "\"constricted pupils, small pupils\""
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 14455,
                                "ratingCount": 1020,
                                "rating": 5,
                                "thumbsUpCount": 1645,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 63858,
                                    "sizeKB": 30282.5927734375,
                                    "name": "Constricted PupilsV3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-09T18:11:15.810Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "E91E4761",
                                        "AutoV2": "8C03E82738",
                                        "SHA256": "8C03E827386D4B4A2AE93E4B9EB66BB7D50541436DB992788535B8BF4E2C876A",
                                        "CRC32": "F059DA30",
                                        "BLAKE3": "4B81626E7A4CD2024C318CF19F405461936049B4D140742D3148423B0F0C8D8C",
                                        "AutoV3": "2389E3EFBF4A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/91871",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1077403,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a91c58e7-9415-4d9a-8d55-d4f0c61086f9/width=450/1077403.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1248,
                                    "hash": "UAJHae%2?wE2$y^+NwE1000KIVNHM}^,01s,",
                                    "type": "image"
                                },
                                {
                                    "id": 1075209,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/03d5ba32-15df-465b-9565-a7d021866527/width=450/1075209.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1424,
                                    "hash": "UBL4Tx-T00_2Y7D$~W~WIpRQ%Mbvk=s:$%9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 1075210,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fe401cc9-867d-4c99-9b62-34c631431d43/width=450/1075210.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1424,
                                    "hash": "UDIz-cxa00%1_LR*-Ut6O;t7=|oKS$a{nhR*",
                                    "type": "image"
                                },
                                {
                                    "id": 1075216,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/459e4648-6b23-4dd3-bc21-96ee65353fa5/width=450/1075216.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1072,
                                    "height": 1232,
                                    "hash": "UPH2m4?wpcIn.8o}^+WAE1S4t7xaE0kCxuxt",
                                    "type": "image"
                                },
                                {
                                    "id": 1075212,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1c7d0ca-78df-40c7-ad2d-fe536fef083d/width=450/1075212.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1424,
                                    "hash": "UIB3vk.9~p_3WDt6R*s:00Mw9GD%%2IpaeWA",
                                    "type": "image"
                                },
                                {
                                    "id": 1075214,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b0419ecb-521e-4b38-9eee-6860c85a69ac/width=450/1075214.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1424,
                                    "hash": "UIEf7*yD%2-;.T?a57tR-oNGRPM|57ayWCRQ",
                                    "type": "image"
                                },
                                {
                                    "id": 1075246,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3c3cdb19-5a38-4965-9a12-0c43418a9d71/width=450/1075246.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1424,
                                    "hash": "UUMsvFWB};-oXjxuIVM{0Kj[kDR+xZn~M}WU",
                                    "type": "image"
                                },
                                {
                                    "id": 1075211,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fbeb5fee-e89d-44a5-bb03-79ecc6eb00cd/width=450/1075211.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1424,
                                    "hash": "UdK12kof~qs:?bj[S4j[X-f6-Vofx]a|NGj[",
                                    "type": "image"
                                },
                                {
                                    "id": 1075213,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8863b7e8-afeb-4be3-9e78-b7a6320c1d7f/width=450/1075213.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1424,
                                    "hash": "UhHxA{of9FjtSQoLD*WB~VayM{j[NHoLRkay",
                                    "type": "image"
                                },
                                {
                                    "id": 1075218,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/50b5e0e6-7372-43e5-a05a-3371045f2858/width=450/1075218.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1424,
                                    "hash": "UjEyoaIpI[%1pfWBS5WDWaRjxCs.RPn#Rjfk",
                                    "type": "image"
                                },
                                {
                                    "id": 1075217,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ff1cb8fa-14d3-4009-bd34-7fbed5f8b77b/width=450/1075217.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1424,
                                    "hash": "ULI}#JX-8Jr?22XnD*xZyEDiDi$$%#r?S1%M",
                                    "type": "image"
                                },
                                {
                                    "id": 1075215,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b73e8f76-e6ca-475c-a15f-bd853cf948d9/width=450/1075215.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1424,
                                    "hash": "URHK^cMw~pwf-n-;u4xC4:x[EKtQtQ9Z%MW=",
                                    "type": "image"
                                },
                                {
                                    "id": 1075207,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d154c2b8-d1b3-4e59-a87c-1c5448b801d0/width=450/1075207.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1424,
                                    "hash": "UQLWbK~W0K$*9bsDt2I:DjIoS1sC%1aexaof",
                                    "type": "image"
                                },
                                {
                                    "id": 1075208,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/986f4b36-8d68-49c4-9d2e-dd185c7db309/width=450/1075208.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "USNAuFvqxgU~THX8=|Rj56xt$*NZFxR*njt6",
                                    "type": "image"
                                },
                                {
                                    "id": 1075307,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f333ccdc-8293-4eae-bc3e-22158d9537b7/width=450/1075307.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1424,
                                    "hash": "UHFreX019ZI:~U9G-=D%5PM|^kM{x^niaJNu",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/91871"
                        },
                        {
                            "id": 6860,
                            "name": "Crazy Expressions",
                            "index": 1,
                            "modelId": 5891,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Trained on a self-curated dataset of 82 images. I recommend for most use cases you refer to the \"constricted pupils\" tag followed by a facial expression. You may also notice that the pupils glow sometimes, which is probably a side effect of the training, but it actually works in it’s favor.</p><p>Inpaint testing was tried. Only when I inpainted the whole face did it work.</p>",
                            "publishedAt": "2023-01-30T20:37:02.858",
                            "availability": "Public",
                            "trainedWords": [
                                "crazy face",
                                "crazy eyes",
                                "crazy smile",
                                "shocked",
                                "horrified",
                                "scared",
                                "small pupils",
                                "constricted pupils"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 15558,
                                "ratingCount": 2291,
                                "rating": 5,
                                "thumbsUpCount": 2304,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 6993,
                                    "sizeKB": 147532.8759765625,
                                    "name": "Crazy_ExpressionsV2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-01-30T20:41:01.834Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "55039043",
                                        "AutoV2": "9A8C01632F",
                                        "SHA256": "9A8C01632F6E7D10CC4980C07699FCE0A69A181566565A75C3C129523A9D81A2",
                                        "CRC32": "4512FE47",
                                        "BLAKE3": "27AB0A177F586CCC84AD75C5C6DE3236E8742B744EDE2BB259839627A25A126C",
                                        "AutoV3": "3837E43B4976"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/6860",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 62690,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e7c7be1-7593-4ebc-6bbb-0d557ed82600/width=450/62690.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1184,
                                    "hash": "UEE{kS$*PAtm_3xuDiM_E3%hqt$M.TjFk;j[",
                                    "type": "image"
                                },
                                {
                                    "id": 62709,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a17db86b-b8f6-4488-a87a-5b0963e46200/width=450/62709.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 744,
                                    "hash": "UFHek0_1o%ER_LIp^,^*NaobsqIptRt7-pNG",
                                    "type": "image"
                                },
                                {
                                    "id": 62708,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/23126391-de77-4a56-a5a6-5f5530f58e00/width=450/62708.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1184,
                                    "hash": "UnH{E1M_%M-;_Nof%ftRS4j[jEozo#RiV?oz",
                                    "type": "image"
                                },
                                {
                                    "id": 62707,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a3998c78-6b40-4435-7fd1-b83b5d27a200/width=450/62707.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 744,
                                    "hash": "UBE:6,00H[~q00-;D*ox4;WB-VM{jbNFxt%3",
                                    "type": "image"
                                },
                                {
                                    "id": 62706,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/41223c26-89e0-4208-21ba-3e0b4ec97c00/width=450/62706.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 744,
                                    "hash": "UGJGvRt-Io-={]IUI@0L#kIUD%i_SwxZx^=|",
                                    "type": "image"
                                },
                                {
                                    "id": 62705,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d71ce470-62e6-4ba0-5595-4325285d0900/width=450/62705.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 744,
                                    "hash": "UCHe8}-VE19t00?H000K9t-;o}IU_ND*~V-;",
                                    "type": "image"
                                },
                                {
                                    "id": 62704,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d692df82-a691-4f78-9cb7-b341970c8100/width=450/62704.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1184,
                                    "hash": "U6ECOQx]5=4T^*E20L9Z00^+^4%L?vM{~WIV",
                                    "type": "image"
                                },
                                {
                                    "id": 62703,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/74d1475c-176e-4657-61d3-5adec1dbca00/width=450/62703.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1184,
                                    "hash": "UlIOkKt6?Ixb~qt7x]t6RjRjWBWAR*WAn+Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 62702,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b582d37b-23e9-47ee-25a7-2f69036d2500/width=450/62702.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1184,
                                    "hash": "UTD^7i_NRNMxITRPI:RjT0t7nNn~o~t7$#V?",
                                    "type": "image"
                                },
                                {
                                    "id": 62701,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3347d3b0-5c65-4aca-d097-eab52c8d5700/width=450/62701.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 744,
                                    "hash": "ULFFjR~q02M|0J9FIBWXS$bc%3s:Io%M?IWr",
                                    "type": "image"
                                },
                                {
                                    "id": 62700,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04a2a930-177a-4d76-1a62-f7ba952b6700/width=450/62700.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1176,
                                    "height": 960,
                                    "hash": "UWH0;L~U,-v}5RIVE2M|5SI?xaX8$|xsxts:",
                                    "type": "image"
                                },
                                {
                                    "id": 62699,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/db33e8d1-641d-482c-33f4-b2ae7979c100/width=450/62699.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1184,
                                    "hash": "UYIOLR_1xwbJ_L%2%Nt8tkt8agWBR:ogsVWV",
                                    "type": "image"
                                },
                                {
                                    "id": 62698,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/abef062c-41ff-46b4-7e1d-886b3dd98400/width=450/62698.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1184,
                                    "hash": "UTGbo3~pM^M~M{xvxt-nxwWAjXM|NIxus,M|",
                                    "type": "image"
                                },
                                {
                                    "id": 62697,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/54c2c9e0-c2d8-415f-0ad3-b090b59a1b00/width=450/62697.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1184,
                                    "hash": "UQIgGm~A~TE*={JBS$wu${%KNKM|IuM{aJNL",
                                    "type": "image"
                                },
                                {
                                    "id": 62696,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7b3753be-5411-4cb1-5e78-8ceffc128d00/width=450/62696.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1184,
                                    "hash": "U5Eo}N0Jz=00#3DS0Xk@00~qHq~UKT%d+]Mz",
                                    "type": "image"
                                },
                                {
                                    "id": 62695,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/74b4ab94-e666-4957-a052-aacc059a7800/width=450/62695.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1176,
                                    "height": 960,
                                    "hash": "UDF;TS0#iI4;FG^%0hD+6{}XR-9w-7NHogxt",
                                    "type": "image"
                                },
                                {
                                    "id": 62694,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a7451c7f-b907-4675-1317-df6c0a1b2b00/width=450/62694.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1176,
                                    "height": 960,
                                    "hash": "UFEeY~0h{v5l9]xaD%X9XTE2bH$jIo%1xZNH",
                                    "type": "image"
                                },
                                {
                                    "id": 62693,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d91ec83e-af01-44a6-1749-3c27ba445800/width=450/62693.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1008,
                                    "height": 896,
                                    "hash": "UHHUXxIV01s.~oWB4:bH^*ofIVWCxubH9Goe",
                                    "type": "image"
                                },
                                {
                                    "id": 62692,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/30aa3783-d457-4258-6fe3-e087a1b34800/width=450/62692.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1008,
                                    "height": 896,
                                    "hash": "UOHxKTIUXlD%~WRjI.oLxabHIos:NGt7s.Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 62691,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9e28e53b-2206-48fc-01a6-d6ce17885700/width=450/62691.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1176,
                                    "height": 960,
                                    "hash": "UCGk5%4mD#TN9G%H$d~CIo-o?G#ktK-V%2E1",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/6860"
                        }
                    ]
                },
                {
                    "id": 65283,
                    "name": "[Realistic] Modern Victorian fashion dress | 洛丽塔裙子 | ロリータ ドレス Vol.1",
                    "description": "<p><em>I found a new AI tool Shakker, a best image to image tool. You can try it via </em><a target=\"_blank\" rel=\"ugc\" href=\"https://www.shakker.ai\"><em>https://www.shakker.ai</em></a></p><hr /><p>更多款式可以来这里查看：<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/112070\">洛丽塔裙子vol2</a> / <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/286328\">洛丽塔裙子vol3</a></p><p>You can find more style here: <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/112070\">Modern Victorian fashion dress vol2</a></p><p>/ <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/286328\">Modern Victorian fashion dress vol3</a></p><hr /><p>触发关键词：请参考版本说明</p><p>Trigger word: <span style=\"color:rgb(193, 194, 197)\">Please refer to instructions for each version</span></p><p>トリガーキーワード：バージョンの説明を参照</p><p>训练素材采用真实系图片训练，模型在动漫模型中出图可能效果不佳</p><p>Realistic style images were used for training this LORA, so this LORA may not perform well when generating images by anime checkpoint.</p><p>トレーニング資料は実際の画像を使用してトレーニングされているため、モデルはアニメーション モデルでは適切に機能しない可能性があります。</p><hr /><p>** 请使用<a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/Bing-su/adetailer\">adetailer</a>/<a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/ototadana/sd-face-editor\">sd-face-editor</a>来修缮脸部</p><p>** Please use <a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/Bing-su/adetailer\">adetailer</a>/<a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/ototadana/sd-face-editor\">sd-face-editor</a> to fix the face</p><p>** <a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/Bing-su/adetailer\">adetailer</a>/<a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/ototadana/sd-face-editor\">sd-face-editor</a>を使って顔の修正をお願いします</p><hr /><p>推荐LORA权重：您可以先尝试0.7。如果感觉有污染到其他元素请酌情降低权重。不建议超过0.85。</p><p>Recommend LORA weight : You can try 0.7 first. If you feel that other elements are polluted, please reduce the weight as appropriate. It is not recommended to exceed 0.85.</p><p>おすすめのLORAのウェイト: 最初に0.7を試してもいいです。他の要素で汚染されていると感じた場合は、必要に応じてウェイトを下げてください。0.85を超えなかったほうがいいです。</p><hr /><p>诚挚邀请您尝试此LORA，作者很希望能得到您的反馈和建议。如果您能分享您生成的美图就更好了。感谢~</p><p>Sincerely invite you to try this Lora. I am eager for your feedback and comment. It would be great if you can share the beautiful images generated by this lora. Thanks~</p><p>今回のLORAを試すように心から招待されています。著者はそのフィードバックや提案を得たいと思っています。生成した美しい写真を共有できれば良いです。ありがとうございます。</p><p></p><p>该LORA的训练期望仅仅包含衣服，不包括人脸和背景等其他元素。您可以搭配其他lora或底模元素来生成完整图片。如果污染到其他元素请评论告知，我会尽量尝试修复。</p><p>The training expectation of this LORA only contains the clothing, not including other elements such as faces and backgrounds. You can mix this LORA with elements (for example : face) of other lora or checkpoint to create a complete picture. If this LORA pollutes other elements, pls let me know by comment. I will try to fix it.</p><p>LORAトレーニングの要望は衣服のみで、顔や背景などの他の要素は含まれていません。 他のLoraまたはベースモールドの要素と組み合わせて、完全な写真を生成できます。他の元素で汚染されている場合は、コメントでお知らせください。できるだけ修復してみますから。</p><p></p><p>抱歉我暂时没有找到很好的办法将很多不同款式的服装集合到一个lora里面，目前我只能将几个不同款式的lora分别上传。如果您喜欢这个风格的服装，还麻烦您先选择您喜欢的款式LORA下载尝试。如果您了解如何能把多套不同款式的服装集合到一个lora文件里里面，我很希望能联系您和向您学习了解这方面的知识。感谢</p><p>Sorry, I haven't found a good way to train different styles of costume into one lora. Currently I can only upload them on by one. If you like this type of costume, please choose your favorite style LORA to download and try. If you know how to train different styles of costume into one lora, I would love to contact you and learn from you about this. Thanks~</p><p>申し訳ありません。多くの異なるスタイルの服を1つのLORAに整える方法を見つけられませんでした。今は、LORAのいくつかの異なるスタイルを個別にアップロードすることしかできません。このスタイルの服が気に入ったら、お気に入りのスタイルのLORAをダウンロードして、試してみてください。複数の異なるスタイルの服を1つのLoraファイルに整える方法を知っているなら、連絡させていただきます。そして、関連知識を教えてください。誠にありがとうございます。</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent",
                        "Sell"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 3,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 47819,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3914,
                        "thumbsDownCount": 1,
                        "commentCount": 25,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 40
                    },
                    "creator": {
                        "username": "cyberAngel_",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/87bde8b6-b11b-4537-ac0a-f5ecd0bf019d/width=96/cyberAngel_.jpeg"
                    },
                    "tags": [
                        "dress",
                        "clothing",
                        "victorian dress"
                    ],
                    "modelVersions": [
                        {
                            "id": 189837,
                            "name": "Classic style 4",
                            "index": 0,
                            "modelId": 65283,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>触发词/Trigger words:</p><p>lo dress, layered dress, long dress, lace-trimmed dress, frills, puffy sleeves, wide sleeves, bow, jewelry, long sleeves, hat</p><p>可自定义裙子颜色/Customizable dress color：</p><p>pink dress/green dress/yellow dress/orange dress ( 等 ,etc. )</p>",
                            "publishedAt": "2023-10-20T02:00:00",
                            "availability": "Public",
                            "trainedWords": [
                                "lo dress, layered dress, long dress, lace-trimmed dress, frills, puffy sleeves, wide sleeves, bow, jewelry, long sleeves, hat",
                                "pink dress",
                                "green dress",
                                "yellow dress",
                                "orange dress"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 3767,
                                "ratingCount": 191,
                                "rating": 4.99,
                                "thumbsUpCount": 452,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 145167,
                                    "sizeKB": 147573.3515625,
                                    "name": "lo_dress_classic_style4_v1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-10-19T12:56:18.337Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "298049CC",
                                        "AutoV2": "4185A2AF76",
                                        "SHA256": "4185A2AF76E8C3B4821190018983A78D114AF95DD7A05D4B642AB849E8901835",
                                        "CRC32": "E28D4490",
                                        "BLAKE3": "75E6CB6C0BEAFE585B27ADE56D1D4B124EBC22F63976258A060BA56A983B369E",
                                        "AutoV3": "80EE8CF8BA6B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/189837",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3038414,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9aed5e9b-48c0-447b-9b69-8c25d38c241d/width=450/3038414.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDBW3]E000^+Ioofofj?00%2~WE1=}RjWBjt",
                                    "type": "image"
                                },
                                {
                                    "id": 3038415,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ec744b22-38d1-41ce-8ad3-9f6a290c2044/width=450/3038415.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBAm}Axu00IUI9RPoztR00a~_Nt7kCj?aeRj",
                                    "type": "image"
                                },
                                {
                                    "id": 3038416,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5f537a5d-119c-454e-a1b4-d7e32366140e/width=450/3038416.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8BzkL_400D*00IAW=adI9kC.Txu4oM{s+tR",
                                    "type": "image"
                                },
                                {
                                    "id": 3038418,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/219081d5-be95-47c0-82ae-cca9e8fb9306/width=450/3038418.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGGIM@xv0dWB~q?uoMIU9[T0^laK~Xx]t8xa",
                                    "type": "image"
                                },
                                {
                                    "id": 3038425,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7bc6253d-06c4-46ad-9dca-4fe390576d0c/width=450/3038425.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDFPZ+~o8^M|01R;IqIUMaNFXVe.%#%M?Gx[",
                                    "type": "image"
                                },
                                {
                                    "id": 3038433,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/555825bc-df19-437c-a47b-531938d512dc/width=450/3038433.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6H.1q9F00oN~U.8Dh8_~T-=0f9E0oVs00.8",
                                    "type": "image"
                                },
                                {
                                    "id": 3038419,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f9859ca9-3796-486f-9c74-2b5771fcc5e4/width=450/3038419.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCAKK.Rj00xuVsozR*WB00t7_NM{tlRPs:tR",
                                    "type": "image"
                                },
                                {
                                    "id": 3038420,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e226aa62-4942-4891-8205-5869fd1ce362/width=450/3038420.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCHLYj_40JNEAG_3xHD$cYNMnTng~q-=%gxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 3038421,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/73b0a73e-e755-4d8f-bcff-801c2b2a2588/width=450/3038421.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U4FP1%si009i0x?Hs*E30000=h~X?E^ixr-:",
                                    "type": "image"
                                },
                                {
                                    "id": 3038426,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/31f5128c-3330-4dea-8e82-9edf232a6277/width=450/3038426.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFHC7b9DI9~q0LD$NGxv-;D$o~Ro_ND$-pRk",
                                    "type": "image"
                                },
                                {
                                    "id": 3038424,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/822af2b9-19ce-4bc9-ad41-5ea368bd980c/width=450/3038424.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCEy6?9v00-p-T9un~sS00E2~qjE?HIUR*-;",
                                    "type": "image"
                                },
                                {
                                    "id": 3038417,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/52fdf35a-3095-4b1b-88a9-06baa724c4ac/width=450/3038417.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEBy]lxt00E1M_V@WCjs00R+~Wxus9ofaxWV",
                                    "type": "image"
                                },
                                {
                                    "id": 3038423,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/140a25d8-d180-4812-ad1f-aded7f693d08/width=450/3038423.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEBg0pIU00-;RjogWBWA00xu~qIU%MM{oexu",
                                    "type": "image"
                                },
                                {
                                    "id": 3038429,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/75abfbf4-6ae2-4563-90c1-7e4d988506c1/width=450/3038429.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UWH2G[Z~4ntS~qRPRPxuNINGxts,kDWARkWY",
                                    "type": "image"
                                },
                                {
                                    "id": 3038428,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/edc968c4-f134-4ccb-a787-9dbf96879580/width=450/3038428.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDC6.I?a004.9FM|xuxa00IU~q-:?vxtM{NG",
                                    "type": "image"
                                },
                                {
                                    "id": 3038432,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/03cd3ce5-6f56-4f1f-a687-e63ba36e8f08/width=450/3038432.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEFE[q?H00IUtQWBD*Io00R*-qbb~CaxIos:",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/189837"
                        },
                        {
                            "id": 116611,
                            "name": "Classic Style 3",
                            "index": 1,
                            "modelId": 65283,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-07-13T09:38:54.348",
                            "availability": "Public",
                            "trainedWords": [
                                "lodress"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 7527,
                                "ratingCount": 460,
                                "rating": 5,
                                "thumbsUpCount": 788,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 83241,
                                    "sizeKB": 73838.03125,
                                    "name": "lo_dress_classic_style3_v1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-13T09:37:56.360Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "7B7CBB5E",
                                        "AutoV2": "1E87E475BA",
                                        "SHA256": "1E87E475BAF9DF1639E13817C8528763B390DF409F304996F7A6ECD44014314F",
                                        "CRC32": "7DBABEA9",
                                        "BLAKE3": "C0C584C406C4669585EB1A3CC2B5EF4BB0E7DE61D5A55BE786A769AB3199FDE2",
                                        "AutoV3": "6F7B8C0FF86C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/116611",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1536005,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/650abc88-f076-4e19-ba33-4e157b788439/width=450/1536005.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UGEfEB_30JIo~q.8kCIo0Jf+%NjZRloMWWxu",
                                    "type": "image"
                                },
                                {
                                    "id": 1536011,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3d4d5939-f408-4652-8154-a0c13ff85fdc/width=450/1536011.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UDDSzb00E1jE_3oMWBo#9Fae~XE1xvNG%NV?",
                                    "type": "image"
                                },
                                {
                                    "id": 1536008,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ca659fa9-6fd5-45bb-8719-432959771980/width=450/1536008.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UFDlyk009Y%N~p4.x]of9FV@?IM{E1s:t8WA",
                                    "type": "image"
                                },
                                {
                                    "id": 1536010,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ab4a8f7a-85ee-45bf-a12b-43cb33cb8c17/width=450/1536010.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UJEM5xD$9ZtR~q9FM{t7tlM{xuxut8M{t7xu",
                                    "type": "image"
                                },
                                {
                                    "id": 1536009,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4e2b4d5f-b382-445c-8cfb-1c73e44652da/width=450/1536009.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UID]e]4n00s:_NIUWBM{NZn%oLNFxvM{Rjt8",
                                    "type": "image"
                                },
                                {
                                    "id": 1536007,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/56903d15-c6a3-4987-b57a-0ce8bb79accd/width=450/1536007.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UBC~}9004-%M?bD%%MWB00n$~XE0E1%LRjNG",
                                    "type": "image"
                                },
                                {
                                    "id": 1536012,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c4704257-d8d1-48fa-8417-e3bcf36e22a9/width=450/1536012.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UBEo.9_40L~q_N.8?bxu00ay~WIUxakCIURj",
                                    "type": "image"
                                },
                                {
                                    "id": 1536006,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d0cea100-8465-42d4-8018-6c5e796637b3/width=450/1536006.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UDDl$q0000_4_3IAWC-p4-Mx^,x]M|WBj[M{",
                                    "type": "image"
                                },
                                {
                                    "id": 1536344,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0dd20102-133f-4b55-a85c-c3552d2e6031/width=450/1536344.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "U8FP570000~X-pWGozxt9sxa-q9GNGxta$M{",
                                    "type": "image"
                                },
                                {
                                    "id": 1536346,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3a76d9a7-757d-4502-bc42-3a424ec5b096/width=450/1536346.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "U9FFX500E0?a~W9Zxu%29Y4o~Xj[-=M{M{oz",
                                    "type": "image"
                                },
                                {
                                    "id": 1536343,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a44536ce-77b1-45ad-a49a-d80e15095ee8/width=450/1536343.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "U7EVgC%M00E1?b^,^,?b0K-;_3?b9FD%%g~X",
                                    "type": "image"
                                },
                                {
                                    "id": 1536347,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ec259dd0-f4c1-4a78-843e-31b18a1bbcdb/width=450/1536347.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UAEM5*0000%N~qD%ogs.4-oL-qWX9Z-pM{NH",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/116611"
                        },
                        {
                            "id": 105062,
                            "name": "Classic style 2",
                            "index": 2,
                            "modelId": 65283,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>触发词/Trigger words:</p><p>lo dress, layered dress, lace-trimmed dress, long sleeves, puffy sleeves, wide sleeves, see-through sleeves, jewelry, frills, long dress, lace</p><p>可选/Optional:</p><p>veil,  hair ornament, hair flower</p>",
                            "publishedAt": "2023-06-29T05:58:49.247",
                            "availability": "Public",
                            "trainedWords": [
                                "lo dress, layered dress, lace-trimmed dress, long sleeves, puffy sleeves, wide sleeves, see-through sleeves, jewelry, frills, long dress, lace",
                                "veil,  hair ornament, hair flower"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3499,
                                "ratingCount": 187,
                                "rating": 5,
                                "thumbsUpCount": 275,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 146115,
                                    "sizeKB": 147573.0703125,
                                    "name": "lo_dress_classic_style2_v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-10-20T10:50:48.819Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "7D3E0CFB",
                                        "AutoV2": "B7CD3504A9",
                                        "SHA256": "B7CD3504A99BF0568CFA7786F50803670415A17CF2D0E67FFA6EF6C9B63E2A4E",
                                        "CRC32": "B20F3C95",
                                        "BLAKE3": "3FECD819537A0F9B803FB6EEE2C3BE4CBAB5605BA8029FC0FB3BA5F1E1DCB53D",
                                        "AutoV3": "32523321CECC"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/105062",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3053828,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/08c37bfe-bd9a-4621-9d6b-99a9a2e92980/width=450/3053828.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCC?fgIU00-;00t7-;Rj00t7_2M|~qWBIAof",
                                    "type": "image"
                                },
                                {
                                    "id": 3053836,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f8ce847a-f326-40c0-912d-64f4ab0c9a6f/width=450/3053836.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEGIlyx[0JR-00x].8IU9Z?H%2%2_N-;t7%g",
                                    "type": "image"
                                },
                                {
                                    "id": 3053830,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/877f69dd-838b-457c-a929-95612f6e90fc/width=450/3053830.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9HVCz~V00S$00nN_3XS0000M{x].SIoIU%2",
                                    "type": "image"
                                },
                                {
                                    "id": 3053839,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2d42ad37-44b6-415c-8ee7-1dde18b4065c/width=450/3053839.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9Gl0GNF00M|00og_4M|00%2~WV@_4R*D$Io",
                                    "type": "image"
                                },
                                {
                                    "id": 3053834,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b5a5d6e7-5c0e-438b-bdc0-92fabcf03262/width=450/3053834.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAF={z-o00Na00Rk_NRQ01-p?a-pbxD*Dioz",
                                    "type": "image"
                                },
                                {
                                    "id": 3053829,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f962f9cd-7172-47eb-b447-cbe74a3f151a/width=450/3053829.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBI}kj-p00~qV?_3_3t6t8t7M{j[%Mt7IAIU",
                                    "type": "image"
                                },
                                {
                                    "id": 3053837,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f5252b4-80cf-48c6-bf7f-1b48d8dc706a/width=450/3053837.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9G+di0000_M4n4T_Nx]9#4n-=Rn?wIARPog",
                                    "type": "image"
                                },
                                {
                                    "id": 3053838,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c8e5e076-8cea-4492-a5b2-c9ea0ff73b34/width=450/3053838.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDG98J~q00E100-;?cRjbb%M-;og.8%MjFM|",
                                    "type": "image"
                                },
                                {
                                    "id": 3053827,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e63e682a-bd4c-457a-bb35-80c587348fe5/width=450/3053827.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBC?fjIT00%M00xvxuWA00WA~qRk?bofD$WV",
                                    "type": "image"
                                },
                                {
                                    "id": 3053825,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e11f545-f177-4e11-8067-7d6a4de9f6c7/width=450/3053825.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULHB;?~p4.NG9ZIUofj[M{Rj%Mt7WCWBMxj[",
                                    "type": "image"
                                },
                                {
                                    "id": 3053826,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c9efd1e6-712c-4eed-ab6b-25df1cbd4526/width=450/3053826.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFEo=C~q01IU4nD%WVa}9GR*^+xuxuWBD%of",
                                    "type": "image"
                                },
                                {
                                    "id": 3053833,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/745db55b-00db-4087-9f04-0d866e9c9332/width=450/3053833.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8EM5t-:00E200oz_ND%4:IA%M-;IoxaV?%2",
                                    "type": "image"
                                },
                                {
                                    "id": 3053831,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f345d760-9c3c-44cf-a65a-e655a03252a0/width=450/3053831.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U2FP1.Mc000000^*?v_400tR%2oc000L^jIU",
                                    "type": "image"
                                },
                                {
                                    "id": 3053832,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/94bbe25f-56b1-4454-9cf0-b81cb5136c80/width=450/3053832.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8G[vTrp00of00-p_Nn#9GV@M_xv9GWXMwR+",
                                    "type": "image"
                                },
                                {
                                    "id": 3053835,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e60083f2-2206-433b-be1f-f3c1b6639e34/width=450/3053835.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UOHx.{~qD%M{x]_3.8aeE2%g%Mt7%NofRjWC",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/105062"
                        },
                        {
                            "id": 94970,
                            "name": "Classic Style 1",
                            "index": 3,
                            "modelId": 65283,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>触发词/Trigger words:</p><p>lo dress, layered dress, wrist cuffs, frills, detached sleeves, bow, necklace, jewelry,</p>",
                            "publishedAt": "2023-06-29T08:56:05.858",
                            "availability": "Public",
                            "trainedWords": [
                                "lo dress, layered dress, wrist cuffs, frills, detached sleeves, bow, necklace, jewelry"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 6377,
                                "ratingCount": 562,
                                "rating": 5,
                                "thumbsUpCount": 611,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 149432,
                                    "sizeKB": 147572.7734375,
                                    "name": "lo_dress_classic_style1_v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-10-23T09:45:48.891Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "86FDFEDF",
                                        "AutoV2": "6D9EA8AB32",
                                        "SHA256": "6D9EA8AB325B3E7A7C2824DFA677D17252894B333479C478CD5E4AADBB316E5F",
                                        "CRC32": "EECE661C",
                                        "BLAKE3": "7234B9ED9602F969DB26BB2910A3A3ECE27E0E0F1FEE1A4CEBF0779CFF7281A7",
                                        "AutoV3": "25583B613B29"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/94970",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3115213,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/85162f58-34a0-499b-9f32-d87fdb2ac7f7/width=450/3115213.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7GbYb0100~V00-:S$-o00jY%gIpo#WYxYWV",
                                    "type": "image"
                                },
                                {
                                    "id": 3115224,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/798e0200-5ec3-45d7-9251-a9b8a0de7b21/width=450/3115224.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U4G8_t0000~p00^$Nzt500Ie?KI.01_0IBt8",
                                    "type": "image"
                                },
                                {
                                    "id": 3115219,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c83bae7c-37a5-4d2e-a586-b87435c15034/width=450/3115219.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBFiDH_200IT4-%gt8t7EJ%L^,of~q?bMyM{",
                                    "type": "image"
                                },
                                {
                                    "id": 3115221,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/db47e450-a685-422d-97aa-65e94123d9e1/width=450/3115221.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCI#W3%gyX~W0K%MS4ja4:IUV@IU.7ofIUWV",
                                    "type": "image"
                                },
                                {
                                    "id": 3115223,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/26f0500a-b371-4a6e-9b72-308632055a3d/width=450/3115223.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBHLVVD+9r~V9YM_It%J004p%2IUyE-nM|xt",
                                    "type": "image"
                                },
                                {
                                    "id": 3115218,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/633a42f0-dc12-48fd-99c9-607f49ecf3fa/width=450/3115218.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6Gl9kVW00Ne009F-pV?0LW?~W%MQ,xukCS$",
                                    "type": "image"
                                },
                                {
                                    "id": 3115220,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a27439e1-9db5-437c-91b0-a0513c6ec9f8/width=450/3115220.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7F$Ic.6004otZ_Mo#9H009Z-rS7E0?aM{NH",
                                    "type": "image"
                                },
                                {
                                    "id": 3115225,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d80e3b71-a34c-476d-8e0c-15bd029c0720/width=450/3115225.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAE.z_Mx00^+9E%MWVV@00M{~qRjNGfks:R*",
                                    "type": "image"
                                },
                                {
                                    "id": 3115222,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ef66fd42-5b68-4203-bcf4-bf25bdd7ca37/width=450/3115222.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMHB*v~qIVM|D%xaRkRPITbF%MxuX9xut8of",
                                    "type": "image"
                                },
                                {
                                    "id": 3115216,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ee4f74a7-4c12-4a6d-8278-0b425a7e1628/width=450/3115216.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9F5?aV[00_3D$-;t8oe00oc~qIUD%ogt6M{",
                                    "type": "image"
                                },
                                {
                                    "id": 3115217,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/73f84010-1d76-4a69-93f1-3ea770d6eefe/width=450/3115217.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8HLSaIA00^+00?b%gt700of~qIU_Ns:rqIo",
                                    "type": "image"
                                },
                                {
                                    "id": 3115214,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e3359bb7-5e70-4fd4-9a19-e5481f8f810e/width=450/3115214.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBEori-;00RP00D%%M%200oe~qof?cxuM_Io",
                                    "type": "image"
                                },
                                {
                                    "id": 3115215,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/97b5c93b-fefb-41f7-ac8a-9ef46f1a8e03/width=450/3115215.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAFYib-p009F009FtRxu00og~Xt8_3xuniRj",
                                    "type": "image"
                                },
                                {
                                    "id": 3115226,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/444dfb8d-9852-49c5-abad-698111c3e94e/width=450/3115226.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UADvNDx]00RP4mD%E1s:4.xu~qxu00M{%MfP",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/94970"
                        },
                        {
                            "id": 81923,
                            "name": "Gothic style 2",
                            "index": 4,
                            "modelId": 65283,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>触发词/Trigger words:</p><p>lo dress, layered dress, long dress, long sleeves, wide sleeves, frills, choker</p>",
                            "publishedAt": "2023-06-29T08:56:13.923",
                            "availability": "Public",
                            "trainedWords": [
                                "lo dress, layered dress, long dress, long sleeves, wide sleeves, frills, choker"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5854,
                                "ratingCount": 358,
                                "rating": 5,
                                "thumbsUpCount": 360,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 160488,
                                    "sizeKB": 147572.7265625,
                                    "name": "lo_dress_gothic_style2_v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-11-02T08:30:52.854Z",
                                    "metadata": {
                                        "format": "SafeTensor"
                                    },
                                    "hashes": {
                                        "AutoV1": "399395A3",
                                        "AutoV2": "C14D4FD5D5",
                                        "SHA256": "C14D4FD5D5C4E4D2668AB5C27C2D109B1739C31BBDDDB4598C4E785E52B2DFB1",
                                        "CRC32": "B7E216B9",
                                        "BLAKE3": "B7068AB66EB26A7A819DBC8DDE47B4674C19FA9739AF67100D3EAD82B2EC55EB",
                                        "AutoV3": "1E67DBC30A0C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81923",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3330902,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/25e399e2-f99b-458b-ba34-f0fd4d66ff7e/width=450/3330902.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U13ucpWB0exa^+of9ZbHxtofIoR*RjWVfjae",
                                    "type": "image"
                                },
                                {
                                    "id": 3330901,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9006a2b9-64f2-41f1-80a0-18e99d9138e7/width=450/3330901.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U355FH%MOZxb.At8NKof4nIoM_WC8_M{xBRj",
                                    "type": "image"
                                },
                                {
                                    "id": 3330897,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9080f505-3496-4d89-98e3-38beb3b37787/width=450/3330897.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U14eNOoy0Lt7~Vt70fj@nORjIojZ9aae?GbG",
                                    "type": "image"
                                },
                                {
                                    "id": 3330904,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/65c2a4b6-e609-49f2-9d25-27c8ac09bace/width=450/3330904.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U14U.|EM0exu_4og9tadI[xaM_WB0Jt7xCWB",
                                    "type": "image"
                                },
                                {
                                    "id": 3330895,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c08c29ac-d44f-4362-86a1-c528f09a403e/width=450/3330895.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U14n[JRP56-qwH%N9ZoJ_4MxIUR*4mtSR%WA",
                                    "type": "image"
                                },
                                {
                                    "id": 3330896,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7b788e4b-5b68-4806-8904-3c1abef83d78/width=450/3330896.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U15}dSD$9uNG~o%M4.NG?bs;D*of00WBxtn%",
                                    "type": "image"
                                },
                                {
                                    "id": 3330898,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/43e6c9ef-cbbd-42f3-956c-b4880a0d31d1/width=450/3330898.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U24xY:Si0K?H?dog9Zt79aa{-oIo0Ks:^*IU",
                                    "type": "image"
                                },
                                {
                                    "id": 3330899,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/20f612e1-d0a3-4c0d-8219-d8b41211501f/width=450/3330899.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U2552yRj0e-p~pof56xajFofM|WB9ZfP%MRj",
                                    "type": "image"
                                },
                                {
                                    "id": 3330903,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/61d30317-9949-43b8-9388-90ee3aded26e/width=450/3330903.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U14n*[EM4.M|~Wxa4.RjE2-pE2xZ9ZI;%Lxa",
                                    "type": "image"
                                },
                                {
                                    "id": 3330894,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9a641333-59f5-4dcb-9d8d-8103e8dca590/width=450/3330894.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U24-^VR%00xu~Wju4:t6RPbHs:js4:j[?HR*",
                                    "type": "image"
                                },
                                {
                                    "id": 3330900,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/01ef98e6-03ab-4948-8e79-d6b5f90502ea/width=450/3330900.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U24-;Goz0KM|-;xa56M{D%Rjxut64.Rj~C%L",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81923"
                        },
                        {
                            "id": 75024,
                            "name": "Gothic style 1",
                            "index": 5,
                            "modelId": 65283,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>触发词/Trigger words:</p><p> lo dress, gothic, detached sleeves, long sleeves, wide sleeves,</p>",
                            "publishedAt": "2023-06-29T08:56:17.354",
                            "availability": "Public",
                            "trainedWords": [
                                " lo dress, gothic, detached sleeves, long sleeves, wide sleeves"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 5056,
                                "ratingCount": 382,
                                "rating": 4.99,
                                "thumbsUpCount": 382,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 160289,
                                    "sizeKB": 147572.2109375,
                                    "name": "lo_dress_gothic_style1_v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-11-02T03:30:55.780Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "EE1A3485",
                                        "AutoV2": "F30B9056BC",
                                        "SHA256": "F30B9056BCD4DD15C4B08C7B92641D0814AA7798BA79F4681AF0F29CCD75D8A1",
                                        "CRC32": "6743F473",
                                        "BLAKE3": "C391C9FACE842D49366F9071DA13FA33194C647E0C5BA227FC255345273A5234",
                                        "AutoV3": "06B7C3BC5338"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/75024",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3326655,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5516b443-f2f8-4db3-bc92-d5cf72e15774/width=450/3326655.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDA,tW-;xufk4nIURjjs~qxuR*ay9EM{M{of",
                                    "type": "image"
                                },
                                {
                                    "id": 3326659,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/da2423b9-2b05-49e0-bd37-52e8747fe655/width=450/3326659.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U254{i57E1xt~WE2Iot6o#oLNGs;57%2WVWC",
                                    "type": "image"
                                },
                                {
                                    "id": 3326654,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0b8f183d-7fb3-4da2-bfb7-5c748484f2d5/width=450/3326654.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U15hGWIo00?H~ps:0eWW00t7^*Io00R*~Vso",
                                    "type": "image"
                                },
                                {
                                    "id": 3326656,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a2f52dee-dbc3-42af-b442-89e0e3f069b5/width=450/3326656.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UG9@P0-qogoz00D%RjWB~q%Mayof9EM{WBWB",
                                    "type": "image"
                                },
                                {
                                    "id": 3326657,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e585455a-8d12-4c3c-9db5-8780dfb62e93/width=450/3326657.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U25X$2-nEKIo~qxaNHM{NfWXRjs;00E3n%%2",
                                    "type": "image"
                                },
                                {
                                    "id": 3326658,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/47f1974c-422e-430f-b5f2-b9b0e7d09895/width=450/3326658.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U88NkN-;kWt74nE0NGWB~q%MR*j[4nIURjWB",
                                    "type": "image"
                                },
                                {
                                    "id": 3326660,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/28d05d0d-9b6e-4e89-a154-a2878b0e266c/width=450/3326660.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U35#LuIU0fRj~VIVELoL4.bH%2oM00%M-oS2",
                                    "type": "image"
                                },
                                {
                                    "id": 3326653,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b8247c81-6a2e-4422-94c9-d8949cb60ef9/width=450/3326653.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UA9tDh-;tRof4nD%NGj[~q%MNGay0JM{WAay",
                                    "type": "image"
                                },
                                {
                                    "id": 3326661,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2fcd3ee0-9732-4042-b955-c134e7745634/width=450/3326661.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U25}Q_9t00IU~WIU9t%20Le.~C%257ja~V9a",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/75024"
                        },
                        {
                            "id": 86185,
                            "name": "Floral style 3",
                            "index": 6,
                            "modelId": 65283,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>触发词/Trigger words:</p><p>lo dress, layered dress, detached sleeves, wide sleeves, see-through</p><p>可选/Optional:</p><p>veil, hat, hair ornament, bonnet, jewelry,</p>",
                            "publishedAt": "2023-06-29T08:56:09.485",
                            "availability": "Public",
                            "trainedWords": [
                                "lo dress, layered dress, detached sleeves, wide sleeves, see-through",
                                "veil, hat, hair ornament, bonnet, jewelry, "
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 7328,
                                "ratingCount": 555,
                                "rating": 5,
                                "thumbsUpCount": 559,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 149655,
                                    "sizeKB": 147572.0625,
                                    "name": "lo_dress_floral_style3_v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-10-23T14:51:35.249Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "41C35289",
                                        "AutoV2": "7117F346AA",
                                        "SHA256": "7117F346AA6E06477833B7667826EC8DAE23C976981E1FBE1E53265ED99AC52A",
                                        "CRC32": "94118A1B",
                                        "BLAKE3": "E3F5E39DC140A02AB48D3B377BA509F07F0947A466CCADF9982CC37ECB6B2E8E",
                                        "AutoV3": "891CAA784AA4"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/86185",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3119547,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/545cf8e3-3ca1-4df5-9ea4-e837425839c3/width=450/3119547.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6C~;v_2009G009ZtRM{00Rj~V?b_3-;s.M|",
                                    "type": "image"
                                },
                                {
                                    "id": 3119541,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fc36ccfd-d69c-4527-95d3-f3702c5fa141/width=450/3119541.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDE{La?v01NH0LS4oyNG4:xa-pxu_N-;xbWC",
                                    "type": "image"
                                },
                                {
                                    "id": 3119546,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7a64f817-fa54-459e-87e5-dbbb54f29494/width=450/3119546.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDH_x$4:u6-oER?bt8WBD$M_ROWVtRRjWBt7",
                                    "type": "image"
                                },
                                {
                                    "id": 3119540,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1bea7b22-e781-446d-a970-0c686e7eee0e/width=450/3119540.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIFi0=~q0KD%T0x^xuIUNexv%Mxa%hxvWBRj",
                                    "type": "image"
                                },
                                {
                                    "id": 3119543,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/31d17a12-5788-4fae-9f0d-8b5a6b6999c9/width=450/3119543.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5F=mzR30000n$9F_3t700NH-n~q%g-;D$IU",
                                    "type": "image"
                                },
                                {
                                    "id": 3119544,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1cdba4fb-5cca-486e-bebd-3d08af221e77/width=450/3119544.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UADvN8_300RiXoOGV@RO0gx^?HRP_4t8Mx%L",
                                    "type": "image"
                                },
                                {
                                    "id": 3119548,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/02fdf1e4-780e-45f2-9a14-59533e5c4a24/width=450/3119548.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEI5Pj4oyZ?bJC-;t7RkM{M_MwRjbct7V@of",
                                    "type": "image"
                                },
                                {
                                    "id": 3119542,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c3ac25c6-0c8b-47fc-91ea-5eeaf2242c0e/width=450/3119542.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8DlsE~W009Z4:IUj=R%4.xt_2%M^+s+M{%M",
                                    "type": "image"
                                },
                                {
                                    "id": 3119539,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/befcae81-ed87-4b19-8a1d-6104f65e070c/width=450/3119539.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8DvJ{~p009ZbrR*xtah00aw_2of-oxVM{x]",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/86185"
                        },
                        {
                            "id": 72984,
                            "name": "Floral style 2",
                            "index": 7,
                            "modelId": 65283,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-06-29T08:56:20.017",
                            "availability": "Public",
                            "trainedWords": [
                                "lo_dress"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4195,
                                "ratingCount": 209,
                                "rating": 5,
                                "thumbsUpCount": 210,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 76566,
                                    "sizeKB": 73838.03125,
                                    "name": "lo_dress_floral_style2_v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-02T10:05:43.360Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "3A8976E3",
                                        "AutoV2": "E940944BC7",
                                        "SHA256": "E940944BC78F4795EE3212CE27C0950B7E9B7B1B6B084E2BEF48BA6AA7DCA66A",
                                        "CRC32": "182F3BF9",
                                        "BLAKE3": "4DD3A3FF028DE5E068AAF3ADB8747330574F0B9D9038696223546B476DD5E988",
                                        "AutoV3": "86D4D68EACCE"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/72984",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1371181,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cae7920c-c50e-446d-969c-c0b6ac53658c/width=450/1371181.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1072,
                                    "height": 1608,
                                    "hash": "UEF~Bmxv00j]_4RkRiWA-NIUxwog_3RPV^og",
                                    "type": "image"
                                },
                                {
                                    "id": 1371184,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4960882b-c9f1-4dd4-961f-f6f1978092f4/width=450/1371184.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UOHU-89E9D%3^%RRo5n$?wIUxGRi?bM{M_j[",
                                    "type": "image"
                                },
                                {
                                    "id": 1371179,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/50b28004-53f2-427c-a5b2-059ebfd77854/width=450/1371179.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1072,
                                    "height": 1608,
                                    "hash": "U6F$6LD;00os*0My9Yx?iF4m%j?c~T4:s?-;",
                                    "type": "image"
                                },
                                {
                                    "id": 1371190,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/41b4c819-9387-4a78-9b55-aab16c8a8294/width=450/1371190.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UPI5AF_NM^xZx9ocM|Mx.8%Maht7_4%NV@of",
                                    "type": "image"
                                },
                                {
                                    "id": 1371182,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/acccd987-d96f-43c8-9163-fec196da9f89/width=450/1371182.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UDIXjvrr4m_4Q*-q9HoM?w%3xvIU?wxbMwIo",
                                    "type": "image"
                                },
                                {
                                    "id": 1371180,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c30fa2ab-dda1-41a7-aa28-770e9e7b7213/width=450/1371180.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UAHxBO^j00xZHXRSo%xb_4_3xaof^-ROk7IT",
                                    "type": "image"
                                },
                                {
                                    "id": 1371183,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d66cae17-693a-4057-9172-ac92f945df73/width=450/1371183.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UEIEL,009X%gz.~Xj0NF%2Rj-;WB?cMxInxu",
                                    "type": "image"
                                },
                                {
                                    "id": 1371185,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b5b89311-98b5-46d6-ba05-53071d62a133/width=450/1371185.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UNHns%D%9ExurU%NM}e:?IR%s;Mx~Xa#V?xu",
                                    "type": "image"
                                },
                                {
                                    "id": 1371186,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ce057ca1-bb5c-4ec6-8385-0eba0a1fef36/width=450/1371186.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UIJQ{F?bD$tRVBIBV_WA?v%3xv%M_4ogM_of",
                                    "type": "image"
                                },
                                {
                                    "id": 1371187,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/65062d80-debd-4fa6-9792-6d3bbde8f9fd/width=450/1371187.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UDHeLc4T00_300_4NLWVoas:?cIU%iIUoHxv",
                                    "type": "image"
                                },
                                {
                                    "id": 1371188,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/98f2c80a-33d5-4662-b9c2-cf2e0c9ebfe8/width=450/1371188.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "URI}bh?bIS-p^h%gIWs:_Nx[s;WE?vtRROj?",
                                    "type": "image"
                                },
                                {
                                    "id": 1371189,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ea2baae0-03e1-4cbc-9425-ca051096ef06/width=450/1371189.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "ULIEeX%N9Ea$$cMxIWRi_4%NsWt6_3oMIUWC",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/72984"
                        },
                        {
                            "id": 69920,
                            "name": "Floral style 1",
                            "index": 8,
                            "modelId": 65283,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-06-29T08:56:23.055",
                            "availability": "Public",
                            "trainedWords": [
                                "lo_dress"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4216,
                                "ratingCount": 311,
                                "rating": 5,
                                "thumbsUpCount": 314,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 76564,
                                    "sizeKB": 73838.03125,
                                    "name": "lo_dress_floral_style1_v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-02T10:05:47.356Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "52E1C657",
                                        "AutoV2": "1AED3C80EB",
                                        "SHA256": "1AED3C80EB8E3470BB1FC5C131490B4BFFAB57E1FEF542072B532DE5AF39E5A0",
                                        "CRC32": "880BB79A",
                                        "BLAKE3": "443A534F244254D46C1EBD7D57F36FC78F617AFE2D98BD9FF0AAE1EA8AB6FB65",
                                        "AutoV3": "770537D73A57"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/69920",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1371124,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c95c535d-907e-408c-9939-d8771e9cc63c/width=450/1371124.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UMI#fQ-:0Kt8XSo}xuoM_N?b%Lof_4xvIURj",
                                    "type": "image"
                                },
                                {
                                    "id": 1371132,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5ca5545a-d0bb-4a89-9ef5-e73355c93308/width=450/1371132.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UFHn?Ai^009t9ENG-pt6-:%L%1?H~pWVM|t7",
                                    "type": "image"
                                },
                                {
                                    "id": 1371125,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2ffefad1-f77e-46ba-bf28-8153d7b8adbf/width=450/1371125.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "U8HLF}4.00%300xu~WE1-=%1?H9Z%Kxb4ot7",
                                    "type": "image"
                                },
                                {
                                    "id": 1371126,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5c7348b4-98a3-421c-95ff-e34eab01fa17/width=450/1371126.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "ULHBoG%M0KR+InE1t7V@Rlxa-ps:~WxtE1Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 1371122,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0a9376b2-a72c-44bd-bfc1-3ac2dde1c55b/width=450/1371122.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UIHeRc$%0LR-E0D*kBad9Z-p?axt~WjsM{WE",
                                    "type": "image"
                                },
                                {
                                    "id": 1371123,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c40727e2-7f61-41ed-9f5d-897f30bc3adb/width=450/1371123.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UEHen8=}00IoDz9ba#t2D$oz?I%1~pxt9GM{",
                                    "type": "image"
                                },
                                {
                                    "id": 1371128,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3a947f69-d0c0-4e46-9158-b239b5a45639/width=450/1371128.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UJHB;]D*00-oNzWA%2V@%hV@-pM__NM{IURj",
                                    "type": "image"
                                },
                                {
                                    "id": 1371129,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/03ad1107-c73e-45d1-bbd1-6f515b4242f1/width=450/1371129.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UKGbVJ%100ogD$oLozxta#ofxbof~WxaE1Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 1371131,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a014c43d-e9fa-4c89-8279-5c028f4291f3/width=450/1371131.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UMHo5l?H00IpkW%N-pxZ^,%N%2o0~q%MM|WB",
                                    "type": "image"
                                },
                                {
                                    "id": 1371130,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9916407a-29f9-409d-8398-3583f9e1b0d0/width=450/1371130.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UIHen6Ip00ohSJWFsm%2~pM{ngWV~pROD$fk",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/69920"
                        }
                    ]
                },
                {
                    "id": 5693,
                    "name": "beautiful detailed eyes,",
                    "description": "<h1 id=\"heading-2\"><strong>beautiful detailed eyes,</strong></h1>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 42683,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3904,
                        "thumbsDownCount": 2,
                        "commentCount": 25,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 20
                    },
                    "creator": {
                        "username": "Xiao_Ye_Youli",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/02893237-31f4-4505-da71-bf34d27f9d00/width=96/Xiao_Ye_Youli.jpeg"
                    },
                    "tags": [
                        "beautiful anime eyes",
                        "eyes",
                        "beautiful detailed eyes"
                    ],
                    "modelVersions": [
                        {
                            "id": 6626,
                            "name": "v1.0",
                            "index": 0,
                            "modelId": 5693,
                            "baseModel": "Other",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-06-27T23:15:38.334",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 42683,
                                "ratingCount": 3121,
                                "rating": 5,
                                "thumbsUpCount": 3904,
                                "thumbsDownCount": 2
                            },
                            "files": [
                                {
                                    "id": 6836,
                                    "sizeKB": 36940.6279296875,
                                    "name": "眼睛双.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-01-29T15:41:04.509Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "511D6E1F",
                                        "AutoV2": "5264FFF928",
                                        "SHA256": "5264FFF92841B0E433E3AAD39A96DF293F5E37496534F90D51937120CCFC2892",
                                        "CRC32": "91A365FE",
                                        "BLAKE3": "21F729488C645ECBC5CBFB058A58379AD6746F9F664165B70594DC960C82C622",
                                        "AutoV3": "3013F7BD7B29"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/6626",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 60376,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b08a8ee1-e3f3-403f-22b3-7586100a5600/width=450/60376.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 512,
                                    "hash": "UTKmhWxZMxX9?HVs4:ofNsnif9t5~WRkV@jE",
                                    "type": "image"
                                },
                                {
                                    "id": 60231,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/35f087f1-6065-45f6-ec36-75b267e8e800/width=450/60231.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 512,
                                    "hash": "UXLCuF~9M]%LQ-%L%fWTOGNaNIt3IpRPxa%2",
                                    "type": "image"
                                },
                                {
                                    "id": 60232,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d1136229-cf74-4b76-4034-548dfb8a2e00/width=450/60232.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 512,
                                    "hash": "UHLoyj0O5PtliG4:GZou_LMfOr?b.8R69Zk=",
                                    "type": "image"
                                },
                                {
                                    "id": 60228,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/64ff4372-2de7-473f-ae2b-18c4a443fa00/width=450/60228.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2400,
                                    "height": 1370,
                                    "hash": "UgMGuA_N?v?b%MbIayjsbvayn%WC%3j[R*ay",
                                    "type": "image"
                                },
                                {
                                    "id": 60375,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/da64c373-c841-46a3-75fd-ab5085707000/width=450/60375.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 512,
                                    "hash": "URIO:t~SGgoIrD?W=gxrT-xX%Ho3?HtPIpIp",
                                    "type": "image"
                                },
                                {
                                    "id": 60233,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4a4b9ec6-cbd1-4bdd-1f79-d24aea10a300/width=450/60233.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 640,
                                    "hash": "UHJaD;~pJm?HDOxaI.?HEK-;~WEgFw$gNGkD",
                                    "type": "image"
                                },
                                {
                                    "id": 60374,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7fa5846a-4c52-4df9-d6e5-db46ae24bd00/width=450/60374.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 640,
                                    "hash": "UdI}n_~Wx[S4V_%2t4xaxn%M%MWBT0bIozR*",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/6626"
                        }
                    ]
                },
                {
                    "id": 100435,
                    "name": "Character Design Sheet (HELPER) (3-PERSPECTIVES)+(COLOR PALETTE) -SD 1.5 | XL PONY- by YeiyeiArt",
                    "description": "<p><strong><u><span style=\"color:rgb(130, 201, 30)\">REMEMBER to follow the social networks and ask for your own model. </span></u></strong></p><p><strong><span style=\"color:#fab005\">New version</span> of the character creation tool by <span style=\"color:#15aabf\">YeiyeiArt</span>. Now available for the<span style=\"color:#82c91e\"> XL Pony</span> version. Enjoy it. <u>Please read the version notes for better use of the model and to create incredible character designs</u>.</strong></p><p><em><span style=\"color:rgb(209, 213, 219)\">Hello, guys! Today I bring you something special for all those who enjoy </span></em><strong><em><span style=\"color:rgb(209, 213, 219)\">creating characters</span></em></strong><em><span style=\"color:rgb(209, 213, 219)\"> for their own projects. This model will allow you to create aesthetic perspectives to design your character in </span></em><strong><em><span style=\"color:rgb(209, 213, 219)\">multiple views.</span></em></strong><em><span style=\"color:rgb(209, 213, 219)\"> Use the </span></em><strong><em><span style=\"color:rgb(209, 213, 219)\">keyword </span></em></strong><em><span style=\"color:rgb(209, 213, 219)\">to invoke the model: \"</span></em><strong><em><span style=\"color:rgb(34, 139, 230)\">CharacterSheet</span></em></strong><em><span style=\"color:rgb(209, 213, 219)\">\" for more precise results. Use the</span></em><strong><em><span style=\"color:rgb(209, 213, 219)\"> following words</span></em></strong><em><span style=\"color:rgb(209, 213, 219)\"> for better outcomes: \"(</span></em><strong><em><span style=\"color:rgb(64, 192, 87)\">multiple views, full body, upper body, reference sheet</span></em></strong><em><span style=\"color:rgb(209, 213, 219)\">:1)\". As an additional </span></em><strong><em><span style=\"color:rgb(250, 176, 5)\">tip</span></em></strong><em><span style=\"color:rgb(209, 213, 219)\">, the model works best with a resolution of </span><u><span style=\"color:rgb(250, 176, 5)\">512 x 512 </span>And the best weight </u></em><strong><em><u>\"&lt;0.5 - 0.8&gt;\"</u><span style=\"color:rgb(209, 213, 219)\">.</span></em></strong><em><span style=\"color:rgb(209, 213, 219)\"> </span><u><span style=\"color:rgb(209, 213, 219)\">Have fun and don't forget to share your images and leave a review ;DD</span></u></em></p><p><em>⬇️⬇️⬇️⬇️⬇️⬇️⬇️⬇️</em></p><p><strong>Don’t forget to check out my other Disney Series Loras on my profile. Currently </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/39104/rapunzel-disney-princess-tangled-by-yeiyeiart\"><strong>Rapunzel</strong></a><strong>, </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/39091/snow-white-disney-princess-by-yeiyeiart\"><strong>Snow White</strong></a><strong>, </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/39097/merida-brave-disney-princess-by-yeiyeiart\"><strong>Merida</strong></a><strong>, </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/40796/cinderella-disney-princess-by-yeiyeiart\"><strong>Cinderella</strong></a><strong>, </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/41879/pocahontas-disney-princess-by-yeiyeiart\"><strong>Pocahontas</strong></a><strong>, </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/41901/fa-mulan-disney-princess-by-yeiyeiart\"><strong>Fa Mulan</strong></a><strong>, </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/42668/elsa-frozen-disney-princess-by-yeiyeiart\"><strong>Elsa</strong></a><strong>, </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/42675/anna-frozen-disney-princess-by-yeiyeiart\"><strong>Anna, </strong></a><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/43727/tiana-the-princess-and-the-frog-disney-princess-by-yeiyeiart\"><strong>Tiana</strong></a><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/42675/anna-frozen-disney-princess-by-yeiyeiart\"><strong> </strong></a><strong>and </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/35930/alice-in-wonderland-disney-by-yeiyeiart\"><strong>Alice in Wonderland</strong></a><strong>, </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/46315/ariel-the-little-mermaid-princess-disney-by-yeiyeiart\"><strong>Ariel</strong></a><strong>, </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/47226/aurora-sleeping-beauty-disney-princess-by-yeiyeiart\"><strong>Aurora</strong></a><strong>, </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/49860/(single%20braid),%20(hat,%20shirt,%20animal%20print%20pants,%20boots,%20belt)\"><strong>Jasmine</strong></a><strong> From the Princess Series ;D” Also u have The Bonus Series with: </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/44524/nani-pelekai-lilo-and-stitch-disney-by-yeiyeiart\"><strong>Nani Pelekai</strong></a><strong>, </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/44530/lifeguard-lilo-and-stitch-disney-by-yeiyeiart\"><strong>Lifeguard </strong></a><strong>(lilo &amp; stitch). And </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/44638/tinker-bell-peter-pan-disney-by-yeiyeiart\"><strong>Tinker bell</strong></a><strong>, </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/45382/jane-porter-tarzan-disney-by-yeiyeiart\"><strong>Jane Porter (Tarzan)</strong></a><strong>, </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/59739/kida-nedakh-atlantis-disney-by-yeiyeiart\"><strong>Kida (atlantis)</strong></a><strong>, </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/61382/chel-the-road-to-el-dorado-dreamworks-by-yeiyeiart\"><strong>Chel</strong></a><strong>, </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/90316/jessica-rabbit-disney-by-yeiyeiart\"><strong>Jessica Rabbit</strong></a><strong>.</strong></p><p><strong><em>Restaurant Series: </em></strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/55631/ronald-mcdonald-chan-characteroutfit-by-yeiyeiart-restaurant-series\"><strong><em>Ronald </em>McDonald</strong></a><strong><em>, </em></strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/28337/wendys-restaurant-series\"><strong><em>Wendys</em></strong></a></p><p><strong>Don’t forget to check out my other Disney Series Loras on my profile. </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/user/YeiYeiArt/models\"><strong>YeiYeiArt</strong></a><strong>.</strong></p><p><strong>Or</strong></p><p><strong>THE NEW !! Villain Collection: </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/51612/maleficentmalefica-disney-by-yeiyeiart\"><strong>Maleficent</strong></a><strong>, </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/52350/ursula-the-little-mermaid-disney-by-yeiyeiart\"><strong>Ursula</strong></a><strong>.</strong></p><p>⬇️⬇️⬇️⬇️⬇️⬇️⬇️⬇️</p><p><strong><em><u><span style=\"color:rgb(250, 176, 5)\">ADVICE</span></u></em></strong><em><u>!! </u></em><u>“If you want a <span style=\"color:rgb(250, 176, 5)\">commission </span>of something in particular, whether it’s a style or a character on request, contact me via <span style=\"color:rgb(250, 176, 5)\">email</span>: </u><a target=\"_blank\" rel=\"ugc\" href=\"mailto:jeanc.romero.ib@gmail.com\"><u>jeanc.romero.ib@gmail.com</u></a><u> </u><strong><u>or</u></strong><u> write me by <span style=\"color:rgb(76, 110, 245)\">Discord </span>--&gt; </u><strong><em><u><span style=\"color:rgb(76, 110, 245)\">jeangcr</span></u></em></strong><u>”</u></p><p><strong><em><u>Check my comissions!!:</u></em></strong></p><p><img src=\"https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/74b3521e-0a4f-4467-8e11-9930be2ec4f5/width=525/74b3521e-0a4f-4467-8e11-9930be2ec4f5.jpeg\" /></p><p><img src=\"https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/17d33afe-648f-47a9-be05-b89c01524d05/width=525/17d33afe-648f-47a9-be05-b89c01524d05.jpeg\" /></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent",
                        "Sell"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 3,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 26424,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3897,
                        "thumbsDownCount": 0,
                        "commentCount": 9,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 150
                    },
                    "creator": {
                        "username": "YeiYeiArt",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/705eab24-8252-493b-9bb6-c6c9e8e6f9ee/width=96/YeiYeiArt.jpeg"
                    },
                    "tags": [
                        "anime",
                        "sexy",
                        "female",
                        "design",
                        "style",
                        "art style",
                        "woman",
                        "game character",
                        "girls",
                        "video game",
                        "characters",
                        "lora"
                    ],
                    "modelVersions": [
                        {
                            "id": 416030,
                            "name": "-PONY XL-",
                            "index": 0,
                            "modelId": 100435,
                            "baseModel": "Pony",
                            "nsfwLevel": 3,
                            "description": "<p>New better version of the Original Model to XL PONY. Now with better resolution and results! ENJOY<br />Dont forget to use the Trigger Words.<br /><br />Recommended resolutions:<br /><br />768 - 1024<br />1024 - 768<br />1024 - 1024<br /><br />try with white background or black background.<br /><br /></p>",
                            "publishedAt": "2024-03-28T19:05:36.448",
                            "availability": "Public",
                            "trainedWords": [
                                "CharacterDesignXL ",
                                "(CharacterSheet:1)",
                                "reference sheet, (full body, from side, front:1.1), upper body, cartoon,",
                                "simple white background"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 4126,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 497,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 337994,
                                    "sizeKB": 56086.00390625,
                                    "name": "XLPCharacterDesign_Concept-10V2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-03-28T18:55:41.685Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "1F09CECE",
                                        "AutoV2": "7A0D56284F",
                                        "SHA256": "7A0D56284FC1FDABD17ED6AA5403F59C8DA7A63A79FFCBA52718A057516B1BFA",
                                        "CRC32": "AD427CAE",
                                        "BLAKE3": "FCDB9F01B1B36265B622475F7347B03A688EA1E0BCA230E36DAB399CDFE48F46",
                                        "AutoV3": "F3E4204FFD95"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/416030",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 8729252,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5586b089-ed9d-4a0c-8dbf-25ed35b9310a/width=450/8729252.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UQKw,@JU_N-o~WWCW=M{_3%MV?IoxtIoRjae",
                                    "type": "video"
                                },
                                {
                                    "id": 8729278,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dbcc5afb-2428-4f77-8b6c-d6b62d0ecf2c/width=450/8729278.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UGP~yZ.S.m#7%1D%RikW?]o}S1tQ^j?bOC9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 8729288,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b2ea6d8f-20b5-45e5-be95-76bebeede354/width=450/8729288.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UXM@J@S$?v^j%2o#o0M{~q%2RjNdIUWCR+M{",
                                    "type": "image"
                                },
                                {
                                    "id": 8729279,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0504576c-3208-4440-a368-0024a860cbdf/width=450/8729279.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "USLXJVNH_N-p~W%gM{IU?vRPM{R+IAxtbIWC",
                                    "type": "image"
                                },
                                {
                                    "id": 8729280,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a48e95f6-3721-418c-a284-0eba47b0821b/width=450/8729280.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UQO:kctS.SwIxZR+oft6_N%LjZoz-oxuM{9G",
                                    "type": "image"
                                },
                                {
                                    "id": 8729259,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8c70723f-013f-4937-9914-aa0bc1372a1f/width=450/8729259.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UKNAezMJ%MpI_NsnxvRQ_Mk=NHwJM{R*t7R*",
                                    "type": "image"
                                },
                                {
                                    "id": 8729258,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1d74f081-c70c-474d-9ea8-f572187cbf88/width=450/8729258.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UQNmm6t8tR%M~qf5n$WB%gx^xuV@%2WBRjRj",
                                    "type": "image"
                                },
                                {
                                    "id": 8729261,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8f6e72d0-166c-48e0-90c5-fb6854921003/width=450/8729261.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UAOzDE_3-;00IUIA%Mni?^tRR+t7t6%1N_9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 8729263,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/abd6307e-8903-4247-a049-4d2be3173488/width=450/8729263.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UQOW1:kW$*I9%grrayba_NtkV@M{t6o}fkt7",
                                    "type": "image"
                                },
                                {
                                    "id": 8729265,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ed35221e-d4d0-454a-88ef-adf5b079368a/width=450/8729265.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UNP~=,^,?^%Lni%1V[NG%~X8VswJOF%MxGMd",
                                    "type": "image"
                                },
                                {
                                    "id": 8729304,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8e057eb8-c3f2-4713-98a1-03790d85236a/width=450/8729304.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UNJ%X%xu9YIAD%VYxFxv63OYr?$g*JS~RQRP",
                                    "type": "image"
                                },
                                {
                                    "id": 8729310,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b90cd852-52d1-4834-833d-0fc77ef25d8c/width=450/8729310.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UJN,*#^Q=a^iDiE1o~tm?^%MNG9Z^jrq$iR5",
                                    "type": "image"
                                },
                                {
                                    "id": 8729264,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/67de34f1-602b-47d2-8296-6688dddce53c/width=450/8729264.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 768,
                                    "hash": "UYN0_1S%aeMw^+SiV@oJ~q%1RjXAD%jEt7WX",
                                    "type": "image"
                                },
                                {
                                    "id": 8729298,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ebc32093-a480-4f6d-9053-bf38cd2a3056/width=450/8729298.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 768,
                                    "hash": "UKLNiNIVkW%1~qXRRPoe_3?GOWIV%fE2jZxH",
                                    "type": "image"
                                },
                                {
                                    "id": 8729303,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f7836e9c-abda-4934-bc07-59f718a081b6/width=450/8729303.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UPO3e1tm.7tR%Lf7WBj[.Tt,WBiwR4RkaeS#",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/416030"
                        },
                        {
                            "id": 107502,
                            "name": "1.5 Standard",
                            "index": 1,
                            "modelId": 100435,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>best results at &lt;0.5 - 0.8&gt;</p>",
                            "publishedAt": "2023-06-30T20:00:03.298",
                            "availability": "Public",
                            "trainedWords": [
                                "(CharacterSheet:1)",
                                "(multiple views, full body, upper body, reference sheet:1)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 22298,
                                "ratingCount": 2171,
                                "rating": 5,
                                "thumbsUpCount": 3536,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 75727,
                                    "sizeKB": 73850.341796875,
                                    "name": "CharacterDesign_Concept-10.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-30T19:50:50.340Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "7C637646",
                                        "AutoV2": "503553D6B7",
                                        "SHA256": "503553D6B795F7946B1F6E5AE99C1EFA26CE2776DF1213F0F3E2DAD145E18145",
                                        "CRC32": "20A12D4D",
                                        "BLAKE3": "5818343E716BACCB192B7046CD0F02649B49126CA79911D9D02E5F49B32536CC",
                                        "AutoV3": "6F65857A23AD"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/107502",
                                    "primary": true
                                },
                                {
                                    "id": 75726,
                                    "sizeKB": 73850.341796875,
                                    "name": "CharacterDesign_Concept-10.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-06-30T19:50:44.728Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "7C637646",
                                        "AutoV2": "503553D6B7",
                                        "SHA256": "503553D6B795F7946B1F6E5AE99C1EFA26CE2776DF1213F0F3E2DAD145E18145",
                                        "CRC32": "20A12D4D",
                                        "BLAKE3": "5818343E716BACCB192B7046CD0F02649B49126CA79911D9D02E5F49B32536CC",
                                        "AutoV3": "6F65857A23AD"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/107502?type=Model&format=SafeTensor"
                                }
                            ],
                            "images": [
                                {
                                    "id": 1350779,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c804a825-f0ee-4683-bdc1-ef2d4e4779bc/width=450/1350779.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UHL;T+x]_N^jrqM|-;tR?b-;xuNH^*xuIUV?",
                                    "type": "image"
                                },
                                {
                                    "id": 1350761,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aad5f6bd-8350-48d4-8317-1153b804e344/width=450/1350761.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UWO3wqx]_NoIs+NGWXf5.8tRWBof?at8jFRP",
                                    "type": "image"
                                },
                                {
                                    "id": 1350763,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dd866093-f219-45ee-97ac-bb92923d4fbc/width=450/1350763.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1382,
                                    "height": 1382,
                                    "hash": "UAMZt7Q.u6b{caY5x[%3t.xwv{aH#Fi]RlMz",
                                    "type": "image"
                                },
                                {
                                    "id": 1350766,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/29c80064-4f3c-42ab-9162-9453725be8c1/width=450/1350766.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1382,
                                    "height": 1382,
                                    "hash": "UOKo7Ysp~W-;?Fs:E2XT-;o#oMM{%2x]oejF",
                                    "type": "image"
                                },
                                {
                                    "id": 1350769,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d6fc9bcf-0675-4347-a3a8-74e1d77cfbd7/width=450/1350769.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UTN^G4Sh_N^+_3xubHM{_3xuM{IoxaM{WBni",
                                    "type": "image"
                                },
                                {
                                    "id": 1350784,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/051a65e8-e447-43af-a241-cb439a734453/width=450/1350784.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UXNAk:%M~q%fM{M{xuxu?bxuRjRj%Lt7NGRj",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/107502"
                        }
                    ]
                },
                {
                    "id": 4982,
                    "name": "Anime Screencap Style LoRA",
                    "description": "<h2>Anime Screencap Style LoRA</h2><p><strong>Making models can be expensive. Do you like what I do? Consider supporting me on </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/Lykon275\"><strong>Patreon</strong></a><strong> 🅿️ or feel free to </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://snipfeed.co/lykon\"><strong>buy me a coffee</strong></a><strong> ☕</strong><br /></p><p><strong>UPDATE: v3 is here!</strong></p><ul><li><p>v3 should be used at around weight 1 on AnyLoRA ckpt or similar style neutral models.</p></li><li><p>v3 is trained from ALL my anime screencap datasets, the same I used for all my specific anime models. It should retain \"some\" styles if you use the trigger words from those, but it's never gonna be accurate to one specific style.</p></li><li><p>v2 is more \"magazine\" style and should be used at around <strong>0.3 weight</strong>. Trigger keyword is <code>anime screencap</code>.</p></li></ul><p><br /><strong>How to use LoRA's in auto1111:</strong></p><ul><li><p>Update webui (use <code>git pull</code> <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/embed/mn8fMF10XN4?start=31&amp;end=60\">like here</a> or redownload it)</p></li><li><p>Copy the file to <code>stable-diffusion-webui/models/lora</code></p></li><li><p>Select your LoRA like in <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/watch?v=-bMeyXOZwN0\">this video</a></p></li><li><p><strong>Make sure to change the weight</strong> (by default it's <code>:1</code> which is usually too high)</p></li></ul>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 5,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 39464,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3865,
                        "thumbsDownCount": 0,
                        "commentCount": 14,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 27
                    },
                    "creator": {
                        "username": "Lykon",
                        "image": "https://cdn.discordapp.com/avatars/180327464155742208/59254be18ccd627daf138d053327485d.png"
                    },
                    "tags": [
                        "anime",
                        "anime screencap",
                        "style",
                        "art style",
                        "artstyle"
                    ],
                    "modelVersions": [
                        {
                            "id": 60568,
                            "name": "v3 offset",
                            "index": 0,
                            "modelId": 4982,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": "<p>Use at weight 1 on AnyLoRA</p>",
                            "publishedAt": "2023-05-02T13:17:12.893",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 26433,
                                "ratingCount": 1332,
                                "rating": 5,
                                "thumbsUpCount": 1987,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 42887,
                                    "sizeKB": 147567.2177734375,
                                    "name": "animemix_v3_offset.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-02T13:16:18.696Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "0B1D3C64",
                                        "AutoV2": "8A5B858E95",
                                        "SHA256": "8A5B858E956CB2D79D44D3728510A2A9AE6053FCF15D75ABB71CA8EFC19A7DDC",
                                        "CRC32": "858F2D1F",
                                        "BLAKE3": "D18132BDCC78342CF6AEAF27395C07ECDEF867D5798237A2A15F1BC45E377ACA",
                                        "AutoV3": "B8CFB98B6C79"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/60568",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 662267,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ce5b19dc-94d0-477e-df4a-d8eef4364a00/width=450/662267.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1840,
                                    "height": 2528,
                                    "hash": "UuH{iuIUobbbXYRjV[a$%xt7RjoeWHt7aeae",
                                    "type": "image"
                                },
                                {
                                    "id": 662266,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/006d2575-fc9a-475b-b313-4ba51ba49a00/width=450/662266.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UQPY;sRnP;t58wnhI;R*4TV@IUS#MwagXSfk",
                                    "type": "image"
                                },
                                {
                                    "id": 662268,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f46bc02-47ef-4656-66e4-24e193462800/width=450/662268.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UdK^jN%1_NtQ?btRs.oL9ZbIofRjoMj[xuWU",
                                    "type": "image"
                                },
                                {
                                    "id": 662264,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/448218dc-da75-40c5-0728-8772d1f0a900/width=450/662264.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UII=DU00?]VYMwxr?wIU00IUH?IU9tD*MwM|",
                                    "type": "image"
                                },
                                {
                                    "id": 662263,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0924256d-a52a-4a56-d4da-70010ab1a500/width=450/662263.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UYK^jRROKi%M~qMx%3kWD*Io%1oe#:kCInRP",
                                    "type": "image"
                                },
                                {
                                    "id": 662261,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/34d7f112-a73b-4573-bb60-b09f21460400/width=450/662261.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UHO:L7~T*Fs+0oX9^~bb00V[?HxZ%Ybb%MjE",
                                    "type": "image"
                                },
                                {
                                    "id": 662262,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3938696c-d5de-4376-63cf-0c5a52f70000/width=450/662262.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UFJHK:0000~VmjEfk@niIoIoxbxZ-:M{9Zs+",
                                    "type": "image"
                                },
                                {
                                    "id": 662415,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f9848364-e3f8-4e8c-20cf-c4fcdd821000/width=450/662415.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UXMQO.#i^,xp~pxWogt6D%tRIUWVbcV@-pRj",
                                    "type": "image"
                                },
                                {
                                    "id": 662265,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/03e44f73-35ba-4669-7f64-8ba70b026b00/width=450/662265.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UALzHaDk00Mx534;0357TJ9t~qM|00$j-pxb",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/60568"
                        },
                        {
                            "id": 5744,
                            "name": "v2-35epochs",
                            "index": 1,
                            "modelId": 4982,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": null,
                            "publishedAt": "2023-01-21T22:16:22.317",
                            "availability": "Public",
                            "trainedWords": [
                                "anime screencap"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1057,
                                "ratingCount": 1879,
                                "rating": 5,
                                "thumbsUpCount": 1881,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 5952,
                                    "sizeKB": 294990.0458984375,
                                    "name": "anime_screencap_v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-01-21T22:23:40.126Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "640E0A2A",
                                        "AutoV2": "B889046675",
                                        "SHA256": "B8890466755B673821A2FA0500430931D4F079B1FFD3776C9F229260FA51AB91",
                                        "CRC32": "2DE0B266",
                                        "BLAKE3": "5CE07CB7B4FFCFDAC694ED268FCB205FB4D039258C987BCD09FA6EE80058825B",
                                        "AutoV3": "EF57717827BA"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/5744",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 47259,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a8d274b1-b9c7-4fed-efdc-1a17507c2300/width=450/47259.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UlJkJ=VrS#o#~qROtSt8IUWBxut6M{ogM_WA",
                                    "type": "image"
                                },
                                {
                                    "id": 47258,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ccec8132-e8f3-4bd9-11c1-2eaa5eb4da00/width=450/47258.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UKKeDt?uISoZ00.8E0E000Iq~qnj?v-=RPWB",
                                    "type": "image"
                                },
                                {
                                    "id": 47257,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2c959bb5-954a-4fed-ccc1-cc8445fa2b00/width=450/47257.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UJKAsS?a%}%g_NbI^*t7tRIoE1s:oMj[xtf6",
                                    "type": "image"
                                },
                                {
                                    "id": 47256,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ae258d60-a561-4ab5-38ca-f5dbb2570200/width=450/47256.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "USNT5q?]nfQ-5Z$cwGn,ofxpoLNyXnS#NeNJ",
                                    "type": "image"
                                },
                                {
                                    "id": 47255,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/67d18156-ac9c-4313-c9a7-a539729ad200/width=450/47255.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDJu#jt*0Vbd0HI;}~t29Fxu?0Ipk|wb-AWU",
                                    "type": "image"
                                },
                                {
                                    "id": 47254,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/170d09ce-74db-4de5-cd72-f4279a1c3e00/width=450/47254.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UYJRBb_N$%xv~pX9MyNH-:t7xut7%Lofxat7",
                                    "type": "image"
                                },
                                {
                                    "id": 47253,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5913d1e9-c968-4461-2dbd-54b688fa3b00/width=450/47253.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UNL:l+E100?GQ*bbAcIp9Zj^R-xr?^rq%3tR",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/5744"
                        },
                        {
                            "id": 5742,
                            "name": "v2-30epochs",
                            "index": 2,
                            "modelId": 4982,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": null,
                            "publishedAt": "2023-01-21T22:09:07.325",
                            "availability": "Public",
                            "trainedWords": [
                                "anime screencap"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 11974,
                                "ratingCount": 12,
                                "rating": 5,
                                "thumbsUpCount": 14,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 5950,
                                    "sizeKB": 294990.0458984375,
                                    "name": "anime_screencap_v2-000030.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-01-21T22:13:35.309Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "53056863",
                                        "AutoV2": "42B131A8E7",
                                        "SHA256": "42B131A8E7CA237C7160EF6673AE25DC9C1D06B6256C71C5D93DD2C5A03D7FA8",
                                        "CRC32": "D99A2A09",
                                        "BLAKE3": "7B9212AC677E7426DBB4FCDFBA1803B28DCAF429859AEC168B9C243105203E76",
                                        "AutoV3": "854ADB307093"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/5742",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 47232,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b20dc71d-41ac-40e3-03a3-860d387c3900/width=450/47232.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UlJkJ=VrS#o#~qROtSt8IUWBxut6M{ogM_WA",
                                    "type": "image"
                                },
                                {
                                    "id": 47238,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c2e944ea-a2cf-4c7d-d24a-6fa7455a3a00/width=450/47238.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UKKeDt?uISoZ00.8E0E000Iq~qnj?v-=RPWB",
                                    "type": "image"
                                },
                                {
                                    "id": 47237,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b2c0bdee-489b-4e7d-088f-d9ceec125b00/width=450/47237.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UJKAsS?a%}%g_NbI^*t7tRIoE1s:oMj[xtf6",
                                    "type": "image"
                                },
                                {
                                    "id": 47234,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/224c351d-9ab0-4ca8-f949-8656c0769000/width=450/47234.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UYJRBb_N$%xv~pX9MyNH-:t7xut7%Lofxat7",
                                    "type": "image"
                                },
                                {
                                    "id": 47235,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/898a435a-56fc-4cf5-3add-8b53f965ec00/width=450/47235.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDJu#jt*0Vbd0HI;}~t29Fxu?0Ipk|wb-AWU",
                                    "type": "image"
                                },
                                {
                                    "id": 47233,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71fe73b5-dec4-4156-a1ff-074e9ba34400/width=450/47233.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UNMGL}E300^*mPWCBDMx9tnPNIXl_Ns9-Vtk",
                                    "type": "image"
                                },
                                {
                                    "id": 47236,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/de72547b-9c56-4372-0682-f681d3557200/width=450/47236.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "USNT5q?]nfQ-5Z$cwGn,ofxpoLNyXnS#NeNJ",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/5742"
                        }
                    ]
                },
                {
                    "id": 11814,
                    "name": "Ganyu (Genshin Impact) - Realistic + Anime - LoRA",
                    "description": "<h2>Ganyu (Genshin Impact) - Realistic + Anime - LoRA</h2><p><strong>Making models can be expensive. Do you like what I do? Consider supporting me on </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/Lykon275\"><strong>Patreon</strong></a><strong> 🅿️ or feel free to </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://snipfeed.co/lykon\"><strong>buy me a coffee</strong></a><strong> ☕</strong></p><p>I know that there are already many Ganyu LoRA's, however I wanted to test a new technique using <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/10028\"><strong>NeverEnding Dream (NED)</strong></a> as a base for training to basically turn an anime character into a real one. This is not trained on cosplay images but just on about 300 Ganyu fanarts.</p><p>It's flexible enough to make her in any style (realistic or anime, with a bit of help from style loras for a more dramatic effect) and any outfit and hairstyle. <strong>Please check the examples</strong>.</p><p>Triggers with <code>ganyu \\(genshin impact\\)</code> usually at weight <code>1</code> but might require tuning based on the model you're using it on (sometimes I used <code>1.2</code>, sometimes <code>0.65</code>). Works great on NeverEnding Dream and with Korean/Japanese likeness loras, or on any anime model out there.</p><p>Please enjoy and consider supporting me. <br /></p><p><strong>How to use LoRA's in auto1111:</strong></p><ul><li><p>Update webui (use <code>git pull</code> <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/embed/mn8fMF10XN4?start=31&amp;end=60\">like here</a> or redownload it)</p></li><li><p>Copy the file to <code>stable-diffusion-webui/models/lora</code></p></li><li><p>Select your LoRA like in <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/watch?v=-bMeyXOZwN0\">this video</a></p></li><li><p><strong>Make sure to change the weight according to the instructions </strong>(by default it's <code>:1</code>)</p></li></ul>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 26493,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3838,
                        "thumbsDownCount": 0,
                        "commentCount": 14,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 31
                    },
                    "creator": {
                        "username": "Lykon",
                        "image": "https://cdn.discordapp.com/avatars/180327464155742208/59254be18ccd627daf138d053327485d.png"
                    },
                    "tags": [
                        "anime",
                        "character",
                        "girl",
                        "person",
                        "photorealistic",
                        "sexy",
                        "female",
                        "genshin impact",
                        "ganyu",
                        "woman",
                        "beautiful",
                        "game character",
                        "realistic",
                        "semi-realistic",
                        "video game"
                    ],
                    "modelVersions": [
                        {
                            "id": 13958,
                            "name": "offset",
                            "index": 0,
                            "modelId": 11814,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-02-22T18:02:13.352",
                            "availability": "Public",
                            "trainedWords": [
                                "ganyu \\(genshin impact\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 26493,
                                "ratingCount": 3579,
                                "rating": 5,
                                "thumbsUpCount": 3838,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 12241,
                                    "sizeKB": 147567.2177734375,
                                    "name": "ganyu_ned2_offset.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-22T18:06:21.084Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {},
                                    "downloadUrl": "https://civitai.com/api/download/models/13958",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 173908,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aad7058f-2158-414d-c3a7-8faa69d50900/width=450/173908.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UBF=%S0000~W00IUMw-=XU-;RjIA00s+-q?b",
                                    "type": "image"
                                },
                                {
                                    "id": 135521,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/026e65b7-b5ce-451b-100b-c759657f2400/width=450/135521.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "U7HLVs005P0001t94m9Z4T?wMHD$EL_3aj-l",
                                    "type": "image"
                                },
                                {
                                    "id": 135520,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/66f92de6-2cbf-4250-c5e8-f25a2c9db500/width=450/135520.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "U6HBb^0000={pM4=00N_5E^*M{n30LtRxZ~V",
                                    "type": "image"
                                },
                                {
                                    "id": 135519,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ebc433da-5d1c-4ab5-1a80-97cf7c5e2900/width=450/135519.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1344,
                                    "hash": "UAGbh.010JxVMxf,00%L?wM{~W%14;?b-p9F",
                                    "type": "image"
                                },
                                {
                                    "id": 135518,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9c5c6a4c-578f-495b-b639-afaaeea90300/width=450/135518.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "U8F5?a0100~W8^M_D$_257_3IU4nET8_xv_3",
                                    "type": "image"
                                },
                                {
                                    "id": 135517,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/099923f4-888f-4530-0642-a896db818700/width=450/135517.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1008,
                                    "height": 1344,
                                    "hash": "UXJRO4%Lf3bH_4IUs*oKNF%3-pxt-;%2M|xu",
                                    "type": "image"
                                },
                                {
                                    "id": 135516,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fbe5e3ef-02cd-4747-8fc7-eb40ec8d6000/width=450/135516.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1008,
                                    "height": 1344,
                                    "hash": "UUFiS^f-R%Ri_4adV@NGxuayoMM{.8t7a}f6",
                                    "type": "image"
                                },
                                {
                                    "id": 135531,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/28b8b99c-1544-4c38-1537-26258df9ea00/width=450/135531.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UDIOX%o$IQ~U4mRj9ZIT%gIwD%DiRlIn?Z_2",
                                    "type": "image"
                                },
                                {
                                    "id": 135514,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/37f0a43d-0b09-423b-59f8-50095609eb00/width=450/135514.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UBFh|=-=00Di0K9F4:~qI^f5-URj9v~V=|IT",
                                    "type": "image"
                                },
                                {
                                    "id": 135513,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4026f89c-4759-41bb-379f-f5bf35818b00/width=450/135513.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "U8F=zL0000-=00IoM^?IXo^*IU9Z00%1?H~W",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/13958"
                        }
                    ]
                },
                {
                    "id": 24833,
                    "name": "Minimalist Anime Style",
                    "description": "<p>Gives more detail when using negative weight. (Thanks for this information @superBlast)</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 20305,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3830,
                        "thumbsDownCount": 0,
                        "commentCount": 7,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 120
                    },
                    "creator": {
                        "username": "hortacreator",
                        "image": "https://lh3.googleusercontent.com/a/AGNmyxaJbOghN3mJlvRyU_fmnk3YvciokAQjvQbQnoM=s96-c"
                    },
                    "tags": [
                        "anime",
                        "minimalist",
                        "style",
                        "artstyle"
                    ],
                    "modelVersions": [
                        {
                            "id": 29709,
                            "name": "v1.0",
                            "index": 0,
                            "modelId": 24833,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-03-26T18:40:05.921",
                            "availability": "Public",
                            "trainedWords": [
                                "anime minimalist"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 20305,
                                "ratingCount": 3076,
                                "rating": 5,
                                "thumbsUpCount": 3830,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 24556,
                                    "sizeKB": 147571.849609375,
                                    "name": "anime_minimalist_v1-000020.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-26T18:45:39.163Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "CD6A7810",
                                        "AutoV2": "F16F6504EF",
                                        "SHA256": "F16F6504EF57EAC0D0ABE857D9A4665681E935438FE3315F6045337F4FCEFD71",
                                        "CRC32": "C677A2B7",
                                        "BLAKE3": "CE8DC1093EB15F703ADEDABF6CDFF680181BA1815065CE12665D4FC75286ED29",
                                        "AutoV3": "DF6E467C4E38"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/29709",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 336272,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3dc34bb7-c730-4f14-556d-b9dd36493400/width=450/336272.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 768,
                                    "hash": "UfM7lexu~Tt3x]WEV@s,$wa#%2ay?GoIIpR.",
                                    "type": "image"
                                },
                                {
                                    "id": 336271,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cc16fa99-8afb-40ef-2a59-b37d75036600/width=450/336271.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UOGtskV@HY%L~payD%bH%gWBIUt7M{a|xaoL",
                                    "type": "image"
                                },
                                {
                                    "id": 336274,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/85f78fe2-403a-48ec-068e-c3cae0740000/width=450/336274.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UNIX~$%L~7WC^ds-_Mt7t6WYxtRPE3Rjn~t7",
                                    "type": "image"
                                },
                                {
                                    "id": 336273,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ef69ed48-237e-46c2-a404-89011420f500/width=450/336273.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 768,
                                    "hash": "UjL}W^g3}@oz-:ofrrxGRjRjkWja-pjabFjs",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/29709"
                        }
                    ]
                },
                {
                    "id": 5200,
                    "name": "2B (NieR:Automata) LoRA / YorHA edition",
                    "description": "<h2>2B (NieR:Automata) LoRA</h2><p><strong>Making models can be expensive. Do you like what I do? Consider supporting me on </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/Lykon275\"><strong>Patreon</strong></a><strong> 🅿️ or feel free to </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://snipfeed.co/lykon\"><strong>buy me a coffee</strong></a><strong> ☕</strong></p><p>Another character LoRA. Trigger is with <code>yorha no. 2 type b</code> and other 2b descriptive tags (this is a LoRA, not an embedding, after all, <strong>see the examples</strong>). Weight <strong>around 0.5</strong> seems to be good, but may vary. May be able to do other Nier Automata characters and stuff that ended up in the dataset, plus outfit variations. Have fun!<br /><br />NOTE: the mole position is hard for diffusion models, just inpaint it. <br /></p><p><strong>How to use LoRA's in auto1111:</strong></p><ul><li><p>Update webui (use <code>git pull</code> <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/embed/mn8fMF10XN4?start=31&amp;end=60\">like here</a> or redownload it)</p></li><li><p>Copy the file to <code>stable-diffusion-webui/models/lora</code></p></li><li><p>Select your LoRA like in <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/watch?v=-bMeyXOZwN0\">this video</a></p></li><li><p><strong>Make sure to change the weight</strong> (by default it's <code>:1</code> which is usually too high)</p></li></ul>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 27958,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3811,
                        "thumbsDownCount": 0,
                        "commentCount": 43,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 30
                    },
                    "creator": {
                        "username": "Lykon",
                        "image": "https://cdn.discordapp.com/avatars/180327464155742208/59254be18ccd627daf138d053327485d.png"
                    },
                    "tags": [
                        "anime",
                        "character",
                        "girl",
                        "nier automata",
                        "sexy",
                        "yorha no. 2 type b",
                        "2b",
                        "nier",
                        "woman",
                        "girls",
                        "video game"
                    ],
                    "modelVersions": [
                        {
                            "id": 6031,
                            "name": "v2b",
                            "index": 0,
                            "modelId": 5200,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-01-25T00:35:34.921",
                            "availability": "Public",
                            "trainedWords": [
                                "yorha no. 2 type b"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 27958,
                                "ratingCount": 3453,
                                "rating": 5,
                                "thumbsUpCount": 3811,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 6291,
                                    "sizeKB": 147533.7490234375,
                                    "name": "yorha_noDOT_2_type_b.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-01-25T00:41:47.477Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "83F41602",
                                        "AutoV2": "3FB6A3C0B0",
                                        "SHA256": "3FB6A3C0B0B93190D802A27CD1A67C1787C0D50E41BAE0E4DA73BAF1F67D9E79",
                                        "CRC32": "A9441758",
                                        "BLAKE3": "9825CE5ECECADB7FCCDA1A527AE351B6FDA0F28539C3BC1C7400B96A4429C123",
                                        "AutoV3": "DDE83CF76FD3"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/6031",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 51748,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b19587ae-4fe3-4b74-449d-29143241a200/width=450/51748.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UgHVSVtRt6%M.Aofxuofo~M{adWCo#RjRjWC",
                                    "type": "image"
                                },
                                {
                                    "id": 117732,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a236c803-40e3-4995-dab0-6c6d88cddc00/width=450/117732.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1304,
                                    "hash": "UdHo8tE1J$s.~qIUNGRj%gRjxZoeW@RjVtoy",
                                    "type": "image"
                                },
                                {
                                    "id": 51738,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/493a43b1-72f4-4a56-5966-82ffce457200/width=450/51738.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UeKUG-^*.6X6~pR,R%RkE0M{RPt6RPxtV[R%",
                                    "type": "image"
                                },
                                {
                                    "id": 51743,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9fd066cb-8426-4148-a705-9fdd6cdf2700/width=450/51743.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UaGb;pIUyDo#_4IVtma~x]R*RjjuRQRje.of",
                                    "type": "image"
                                },
                                {
                                    "id": 55195,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6b83cac4-5d55-43d6-e7db-ac9817034300/width=450/55195.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UPF=:Y_2tkf,~qofIUM{D*M|RQV[D*WBoLt7",
                                    "type": "image"
                                },
                                {
                                    "id": 51746,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7a61645a-2aad-40a4-83a6-74f767ae7e00/width=450/51746.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 864,
                                    "height": 1304,
                                    "hash": "UWIq}y%NS}-:_N?bt7oz_3ogx]og?HIUIU-p",
                                    "type": "image"
                                },
                                {
                                    "id": 51745,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e6a7df38-fb66-4d6f-d76c-0e04002b6900/width=450/51745.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UjM@TBIU.8xu?bt6ayogxukCayj[~qoeRjkC",
                                    "type": "image"
                                },
                                {
                                    "id": 51747,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/95661238-8dc9-46ba-5662-277cbe8afe00/width=450/51747.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UjKdPg$*_NjG?btRt7WC9Zx]t7ofIAMxs:WB",
                                    "type": "image"
                                },
                                {
                                    "id": 51744,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/12cb4d7f-f17f-4f38-5fd6-5e3b1fe14500/width=450/51744.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UYH.Z#9Gact7.Axqxuxukqx]jEayIqx]RQRj",
                                    "type": "image"
                                },
                                {
                                    "id": 117731,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/82572b7d-2e0c-4a99-e1ca-5a6a82cbba00/width=450/117731.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 864,
                                    "height": 1304,
                                    "hash": "UgHoaw_3%L-:.Axuj]xux]RiM{bIt7RiRjWB",
                                    "type": "image"
                                },
                                {
                                    "id": 51742,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f1bbe9d3-d271-4ffb-9548-9573cef2b000/width=450/51742.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UuJ*k:xa.8Rk~qayofjZ%MofRiWVx]ofofj[",
                                    "type": "image"
                                },
                                {
                                    "id": 51741,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a0de96a1-bcad-4ed5-9361-a285d70afb00/width=450/51741.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UcJ[0IM|NG?b~q?boyM{?bM{t7f6tRIUofRj",
                                    "type": "image"
                                },
                                {
                                    "id": 51740,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a3f65d77-d0e1-4bdd-3fc9-0b67fa668700/width=450/51740.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UhIhW@%1NrR*~qbGWAofR*RjjYoLMyxaagRj",
                                    "type": "image"
                                },
                                {
                                    "id": 55194,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a57e1134-4269-47ca-32db-bbc4d1d0a000/width=450/55194.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UVI#llD%_Nxuxv%M9F%M9GWBRjM{D%IUs:oL",
                                    "type": "image"
                                },
                                {
                                    "id": 51739,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a3b112dc-3772-4416-6dee-474f9f3d6400/width=450/51739.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UrKnSXxutRkC~qRjRjoft8ayWBRjM{t7oLof",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/6031"
                        }
                    ]
                },
                {
                    "id": 5042,
                    "name": "WLOP Style LoRA",
                    "description": "<h2>WLOP style LoRA</h2><p><strong>Making models can be expensive. Do you like what I do? Consider supporting me on </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/Lykon275\"><strong>Patreon</strong></a><strong> 🅿️ or feel free to </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://snipfeed.co/lykon\"><strong>buy me a coffee</strong></a><strong> ☕</strong></p><p><br />There is already a <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/2968/wlop\">model checkpoint for wlop</a> that you should definitely check out. However LoRA's are becoming the new way to basically mix models on the go and add artstyle and characters also combining multiple ones with many different pre-existing models. Wlop style is already used a lot in prompts, especially on Midjourney, so I made this. <br /><br />For the preview pics I used AnyLoRA and Abyss Orange Mix V2 and a <strong>weight of 1 for the offset version (0.6 for the old one)</strong>. Trigger word is of course <code>wlop</code>. Works well with <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/4384/dreamshaper\">DreamShaper</a> too but you won't get the perfect style on it (it's trained on anime models). I also used CLIP skip 2. <br /><br /><strong>How to use LoRA's in auto1111:</strong></p><ul><li><p>Update webui (use <code>git pull</code> <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/embed/mn8fMF10XN4?start=31&amp;end=60\">like here</a> or redownload it)</p></li><li><p>Copy the file to <code>stable-diffusion-webui/models/lora</code></p></li><li><p>Select your LoRA like in <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/watch?v=-bMeyXOZwN0\">this video</a></p></li><li><p><strong>Make sure to change the weight</strong> (by default it's <code>:1</code> which is usually too high)</p></li></ul>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 22796,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3799,
                        "thumbsDownCount": 0,
                        "commentCount": 22,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 11
                    },
                    "creator": {
                        "username": "Lykon",
                        "image": "https://cdn.discordapp.com/avatars/180327464155742208/59254be18ccd627daf138d053327485d.png"
                    },
                    "tags": [
                        "anime",
                        "girl",
                        "portaits",
                        "sexy",
                        "female",
                        "digital art",
                        "character art",
                        "highly detailed",
                        "wlop",
                        "style",
                        "art style",
                        "woman",
                        "artist",
                        "artstyle",
                        "digital illustration",
                        "fantasy",
                        "girls",
                        "portraits"
                    ],
                    "modelVersions": [
                        {
                            "id": 68639,
                            "name": "offset",
                            "index": 0,
                            "modelId": 5042,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-05-12T09:00:22.716",
                            "availability": "Public",
                            "trainedWords": [
                                "wlop"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 8219,
                                "ratingCount": 821,
                                "rating": 5,
                                "thumbsUpCount": 1104,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 48001,
                                    "sizeKB": 295023.6611328125,
                                    "name": "wlop_offset.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-12T08:51:14.005Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "A8B173FA",
                                        "AutoV2": "1CCDAE3CFF",
                                        "SHA256": "1CCDAE3CFF8CEDBDAED71E59E08147FA7C72128E7C6D395832F5D618DE56C81E",
                                        "CRC32": "3D4624F3",
                                        "BLAKE3": "FE78D7FF6BE1C15CB457507652547F5CF4C69CC9B7C919096407CC8970A7C7EF",
                                        "AutoV3": "C13F2D07A028"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/68639",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 765072,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f9ae154c-8b8c-4f62-b8b1-0f957f8a4d45/width=450/765072.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UJHeUk~V569u_2%Mx]E2-;%M%2Rk_3%LRks:",
                                    "type": "image"
                                },
                                {
                                    "id": 765083,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f88dec2f-2597-4875-af7c-e7be1c043813/width=450/765083.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UlJkcR~AEgIoK8N|M{M|xtf5Rks-N|V@slW=",
                                    "type": "image"
                                },
                                {
                                    "id": 765073,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b1037a57-e426-4f90-bae0-b76d990c6dbb/width=450/765073.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UWH_GN?b~VR*4oMx9GWBOFofozRkD*t6WB%L",
                                    "type": "image"
                                },
                                {
                                    "id": 765170,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f9d4d978-b032-4ad2-a804-701968ea1342/width=450/765170.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UuJkJ@Io~qxu^+R*tRs:xuxabbs:xuo1ofRj",
                                    "type": "image"
                                },
                                {
                                    "id": 765186,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b3d26cf9-5c5d-4c72-ac42-eba10c60048d/width=450/765186.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UOD]Vg00xta#~W4.xaofxaE1%Lt7axRkxuM{",
                                    "type": "image"
                                },
                                {
                                    "id": 765209,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b6951d77-e253-47a7-b874-6ba9f7b5cad7/width=450/765209.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UEHe5z00xtt8~W9G-:of01-:?Hax%MxaE1s:",
                                    "type": "image"
                                },
                                {
                                    "id": 765231,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cb7bb35a-5db2-4f1b-9b99-1a4e581d0ccd/width=450/765231.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UCF=%H~p569Z?v^+M_M{004.IUxa0KIU-p%M",
                                    "type": "image"
                                },
                                {
                                    "id": 765106,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/56779017-2de5-48de-b43c-5f09436f2932/width=450/765106.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UUK_8oIAGI?ZvfxZ+sRQ~8S*M|WA.8xYNLXA",
                                    "type": "image"
                                },
                                {
                                    "id": 765023,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/09afbdb4-aa11-4440-accc-961deb69348a/width=450/765023.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1792,
                                    "height": 1561,
                                    "hash": "UgJkWIxaj[%L~qj]j[of?cj[j[of?bayj[WB",
                                    "type": "image"
                                },
                                {
                                    "id": 765036,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6c54bc6e-30fd-4425-a1d9-5ac9a6ea74d9/width=450/765036.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1792,
                                    "height": 1561,
                                    "hash": "UbJ*F+xuj[-:x^Rjj[RP_Nj]j[j]?bj[j[a{",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/68639"
                        },
                        {
                            "id": 5835,
                            "name": "v1",
                            "index": 1,
                            "modelId": 5042,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-04-29T21:56:51.032",
                            "availability": "Public",
                            "trainedWords": [
                                "wlop"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 14577,
                                "ratingCount": 2697,
                                "rating": 5,
                                "thumbsUpCount": 2699,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 6092,
                                    "sizeKB": 294990.0439453125,
                                    "name": "wlop-000030.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-01-22T19:19:29.583Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "FB8FD82C",
                                        "AutoV2": "52F58AAEB7",
                                        "SHA256": "52F58AAEB76CE1E63E03BAA9A9796AE6AB14F093749099E937E696DDF718BB94",
                                        "CRC32": "D6C92D43",
                                        "BLAKE3": "17CD9B22BC9903CEBA17532FDBC5B68B832882056E035B002DFE58A9C2036346",
                                        "AutoV3": "D1FB49DC5E4B"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/5835",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 48752,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b1e40d0f-2aa2-4b42-ae1f-ee75f0e42c00/width=450/48752.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UJHLSV~V569u_2%Mx]E2-;%M%1V[_2%LRks:",
                                    "type": "image"
                                },
                                {
                                    "id": 48756,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/950bed00-cba8-4c0a-736a-39c2f3c75600/width=450/48756.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1632,
                                    "height": 2448,
                                    "hash": "UVI4w=?b~VR*4oMx9GWBOFogozRkD*xZWB%2",
                                    "type": "image"
                                },
                                {
                                    "id": 48778,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ce545948-70db-4f54-e5c5-48ecad089d00/width=450/48778.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UZJj}6~W?b-p_2%2s:t6S2oejZR+xaWVM|t6",
                                    "type": "image"
                                },
                                {
                                    "id": 48755,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/79d6ba86-4869-4f65-06af-3ae009453c00/width=450/48755.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "U;LXGOxu_NkC-ps:NGof%MaykBjtS3RjRjjZ",
                                    "type": "image"
                                },
                                {
                                    "id": 48753,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/736842e2-3ffb-4215-13e7-d1c184d06100/width=450/48753.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1120,
                                    "height": 840,
                                    "hash": "UFC%1}_N004T-=xuMwIAX.s:IBNHIqWBM}NK",
                                    "type": "image"
                                },
                                {
                                    "id": 48754,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cfa7d1be-7aab-4341-32fe-fc6c667f1200/width=450/48754.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1632,
                                    "height": 2448,
                                    "hash": "UIGIWI~q%LIAkr%MIVoe57IVxtWYNGbHM{tR",
                                    "type": "image"
                                },
                                {
                                    "id": 55192,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f8538f50-4d8d-4d2b-b22e-37d391beaa00/width=450/55192.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UPF=:Y_2tkf,~qofIUM{D*M|RQV[D*WBoLt7",
                                    "type": "image"
                                },
                                {
                                    "id": 48795,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f0b98048-2a4f-40a1-b297-084fb1c28700/width=450/48795.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UmIO?_-nUHE3KkT0%exsNHn3njRQpIR.Rnof",
                                    "type": "image"
                                },
                                {
                                    "id": 55196,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5665edb8-0765-4bb5-dc7f-d2f412f36e00/width=450/55196.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 816,
                                    "height": 1224,
                                    "hash": "UVI#llD%_Nxuxv%M9F%M9GWBRjM{D%IUs:oL",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/5835"
                        }
                    ]
                },
                {
                    "id": 22470,
                    "name": "Gundam RX78-2 outfit style 高达RX78-2外观风格",
                    "description": "<h1 id=\"heading-280\">Latest update: SDXL version 2.0 released</h1><p><strong>2023/12/09</strong></p><p>Improved TE training, Great common use ability now.</p><p>Can perform really good with SDXL base 1.0, White Base, please make a try</p><p>take the prompt from my images.</p><p>use the weight from 0.5-0.8</p><p>it is very like SD1.5 time, it's a Gundam cloth for Girl!</p><p>make your Gundam Girl now!</p><p></p><p>again:</p><h2 id=\"heading-289\"><strong><span style=\"color:rgb(250, 82, 82)\">Face editor Plugin is highly recommended</span></strong></h2><p></p><p></p><h1 id=\"heading-280\">Latest update: SDXL version released</h1><p>Instruction: please notice SDXL version is a Lycoris not Lora, but same way to use</p><p>This is the updated version for SDXL, if you wish to try SDXL, you can download this one, and it is a Lycoris version, for some reason, SDXL base model has a strange weight for Gundam, once you have the girl face, it will not likely to show full body, please use high weight to trigger it, or adding more prompts which related to the leg, foot, such as, long leg, shoes, it will help to full body prompt to realize.</p><p>if you find your output is likely to only have underwear, please use prompt bodysuit, it will significantly help to put the cloth on.</p><p>finally, please take a try and discover more!</p><p>注意：SDXL版本实际上是Lycoris版本，而不是Lora版本，但使用方法相同。</p><p>这是SDXL的更新版本。如果您想尝试SDXL，可以下载这个版本，它是Lycoris版本。由于某种原因，SDXL基础模型对Gundam的权重有些奇怪，一旦您得到女孩的脸部，它不太可能显示全身，请使用高权重来触发它，或者添加更多与腿、脚相关的提示，例如，长腿、鞋子，这将有助于全身提示的实现。</p><p>如果您发现您的输出只有内衣，请使用提示词“bodysuit”，它将显著地帮助添加衣物。</p><p>最后，请尝试并发现更多！</p><p></p><h2 id=\"heading-289\"><strong><span style=\"color:rgb(250, 82, 82)\">Face editor Plugin is highly recommended</span></strong></h2><hr /><p></p><hr /><p></p><hr /><p>欢迎查看我的其他模型：<a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/user/ttplanet\">ttplanet Creator Profile | Civitai</a></p><p>这是一个非常平衡的lora, 可以恰如其分的展现高达的特征，但是却又可以比较好的控制权重，使用gundam\\(rx78\\)作为主触发词放在prompt的第一个，然后根据你使用的模型适当的调节权重从0.1-1都可以。</p><p>你可以让真人穿上高达风格的衣服，也可以通过mecha armor触发关键词直接穿上盔甲，这取决于你需要什么风格。</p><h3 id=\"heading-281\"><u>这个lora可以很好的和各种模型匹配，不管是真人的还是动画的！而且可以和各种其他人物lora混用！</u></h3><p>建议使用方法是先正常的生成一个人物，调整到你喜欢的衣服和动作，调整你喜欢的场景，然后加载Lora， 如果你使用的是系统lora插件，那就直接选用添加权重，如果你不使用插件，那么就用&lt;lora:gundamRX782OutfitStyle_v10.safetensors:1&gt;进行触发，调整权重。</p><p>请查看我的范例图，里面是一些想法，你们可以自己玩的更high。</p><p>lora使用512*512采样生成，理论上768以下的解析度都能较好支持，建议使用hiresfix进行高清修复。想到什么再更新吧，希望能得到你们的支持。</p><p>推荐使用底模recommend SD model：</p><p>chilloutmix</p><p>Daceflopainting</p><p>AOM系列</p><p>Anything系列</p><p>以上模型都可以涩涩，如果你喜欢机甲瑟瑟的话。</p><p></p><p>This is a very balanced Lora that can perfectly showcase the features of Gundam while also allowing for good control over the weighting, use gundam\\(rx78\\) as the priority prompt, ranging from 0.1 to 1 depending on the model you're using.</p><p>You can have a real person wear Gundam-style clothing, or trigger keywords to directly wear mecha armor, depending on the style you prefer.</p><h3 id=\"heading-282\"><strong>It fit will most SD model no matter it is for real person or animation.</strong></h3><p>The recommended method is to first generate a character normally, adjust their clothing and movements to your liking, adjust the scene to your liking, and then load Lora. If you're using the system Lora plugin, you can directly add weighting. If you're not using the plugin, you can trigger it with &lt;lora:gundamRX782OutfitStyle_v10.safetensors:1&gt; and adjust the weighting.</p><p>Please refer to my sample images for some ideas, and feel free to explore on your own.</p><p>Lora is generated at 512*512 resolution, and can support resolutions below 768 fairly well. We recommend using hiresfix for high-definition restoration. We'll update as more ideas come up, and I hope to have your support.</p><p></p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": false,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 31,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 18930,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3734,
                        "thumbsDownCount": 0,
                        "commentCount": 14,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 0
                    },
                    "creator": {
                        "username": "ttplanet",
                        "image": null
                    },
                    "tags": [
                        "anime",
                        "gundam",
                        "style"
                    ],
                    "modelVersions": [
                        {
                            "id": 26830,
                            "name": "SD1.5 V1.0",
                            "index": 0,
                            "modelId": 22470,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>This is for SD1.5 Lora</p>",
                            "publishedAt": "2023-03-21T16:13:08.472",
                            "availability": "Public",
                            "trainedWords": [
                                "gundam\\(rx78\\)",
                                "mecha",
                                "robot",
                                "science fiction"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 16067,
                                "ratingCount": 3300,
                                "rating": 5,
                                "thumbsUpCount": 3436,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 22220,
                                    "sizeKB": 73841.6162109375,
                                    "name": "RX78_V1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-21T16:15:38.699Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "E7655602",
                                        "AutoV2": "1225A60F0A",
                                        "SHA256": "1225A60F0A65D98DE64C640D32506FD06AC67D298C7A28BE0C2D36BC4B818BB0",
                                        "CRC32": "57A7B021",
                                        "BLAKE3": "B1E1B6B43AD02C39EA3015349B79F0629F1FD73C9BF5EB7AC64DFF252E047FF4",
                                        "AutoV3": "C477CE14DE20"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/26830",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 430354,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80b679e2-a314-48a7-62fe-aba669aca500/width=450/430354.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 2304,
                                    "hash": "U4D9bm0000_4~qM{4TRQ00?b^+t700-p4TyD",
                                    "type": "image"
                                },
                                {
                                    "id": 295589,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/580b5fea-14fe-4f4e-b185-f61ee61e3600/width=450/295589.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UOG*$*~WADNb4.E1M|$%yDkWxZ?GenRkt7V@",
                                    "type": "image"
                                },
                                {
                                    "id": 295574,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/236f7823-ad8d-4df1-7eff-32eaade01000/width=450/295574.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "U6CiqBtTnn~X+s9s-X$%8_9Z=|={MyJPV?xa",
                                    "type": "image"
                                },
                                {
                                    "id": 298561,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f98493c4-9fa2-4bc7-78da-1c8b62014200/width=450/298561.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMF=2d~COSR*IArrn*$%9[jZ#T$g.8xu=|aK",
                                    "type": "image"
                                },
                                {
                                    "id": 295573,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/01b98ed3-8605-49e1-aeea-06fdd7429b00/width=450/295573.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UUHUqi~WJ8IpIpWWNHof-;kB%1xa%M-:s;V@",
                                    "type": "image"
                                },
                                {
                                    "id": 295572,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2efbfc2b-aa70-49a2-f834-b0792dc3a600/width=450/295572.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7D9M29Z0eIq^*0L~B4.9v0f^%9a0Jo#_3E3",
                                    "type": "image"
                                },
                                {
                                    "id": 296196,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/29871140-284f-44c7-6665-7772dfcf5600/width=450/296196.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1536,
                                    "hash": "UWGbboxakBkC-;D%s:oe~qozogxa-=D%Rjt8",
                                    "type": "image"
                                },
                                {
                                    "id": 296195,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7da7b179-fc53-44f1-cc9e-e0a5d9645800/width=450/296195.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1536,
                                    "hash": "UCDvNL~V9YNex^D%?H%M-:Ioxaog-p9ZIo-;",
                                    "type": "image"
                                },
                                {
                                    "id": 295571,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d133bf19-b302-4b6d-78ae-4fbd8d43d000/width=450/295571.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UUM%$dog~q%M_4t7f,WC%2RjD%RjtSRjNGtR",
                                    "type": "image"
                                },
                                {
                                    "id": 295570,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/47877303-910d-425a-b366-faed8636aa00/width=450/295570.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UgM7lmxuXN%ME1awk9of?cRjs;WU_NaixaWC",
                                    "type": "image"
                                },
                                {
                                    "id": 295569,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c01d8d97-72e0-465b-7d82-ed56c6912100/width=450/295569.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "URK-Xv_4EJtPJ6-=o{RjtRtQahRj_3j^sDs;",
                                    "type": "image"
                                },
                                {
                                    "id": 295568,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f9137561-a882-461e-a4e5-3c38e583aa00/width=450/295568.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5A,d[xt009Z$*NG9ZxtDhM|~q-;00WB=|s:",
                                    "type": "image"
                                },
                                {
                                    "id": 295567,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c6ee9c7f-71dd-4a49-8f7d-2d8272f86000/width=450/295567.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTJa~8M|ScxvT2n%ofbI?dt6xvbJ_4W9xaRj",
                                    "type": "image"
                                },
                                {
                                    "id": 295566,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/859fd39f-835c-437c-7f98-70f948b17900/width=450/295566.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8ECRf000KxZ009ZD%-p}=%M.9f,00-;-qIo",
                                    "type": "image"
                                },
                                {
                                    "id": 295565,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a6a5b1c-4563-44c0-7a00-f6a8db813200/width=450/295565.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDIqca~XyD~qv_IpVsxW.RMxaK-otm^jpIxv",
                                    "type": "image"
                                },
                                {
                                    "id": 295564,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6db6f0de-f3d9-4026-dded-8028f8779300/width=450/295564.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8BpY0%49E~XkrRjSP%N0LR:?cX9V@xuxujY",
                                    "type": "image"
                                },
                                {
                                    "id": 295563,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/105f443e-a6fa-4662-6a7e-7f8d4d661d00/width=450/295563.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2304,
                                    "height": 1536,
                                    "hash": "UOIhKm01Ri-:~p?a9Z?a~UD*W?-otRE1j]E2",
                                    "type": "image"
                                },
                                {
                                    "id": 296657,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/abeff94b-36d5-4a04-68ba-3975cbe6b300/width=450/296657.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "UHD]Yv4-XSD%00WAE1jF~Wayx]tR0KM{s:Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 296664,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fb373c29-ec5a-41b7-e4f8-71f18b188200/width=450/296664.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 2304,
                                    "hash": "UEJHzP-=~q.800jsIUIUx]9FR,Mx_3t5WBs:",
                                    "type": "image"
                                },
                                {
                                    "id": 430377,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/986a95dc-4750-41bd-3739-85b095b6cf00/width=450/430377.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 2304,
                                    "hash": "U7D+#v0L00~W-poM%2Iot8xu?Hxa00r=nj?b",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/26830"
                        },
                        {
                            "id": 255349,
                            "name": "SDXL v2.0",
                            "index": 1,
                            "modelId": 22470,
                            "baseModel": "SDXL 1.0",
                            "nsfwLevel": 31,
                            "description": "<p>updated with TE trained, great common use ablity</p>",
                            "publishedAt": "2023-12-08T17:15:14.974",
                            "availability": "Public",
                            "trainedWords": [
                                "Gundam\\(rx78\\)",
                                "armor"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 982,
                                "ratingCount": 51,
                                "rating": 5,
                                "thumbsUpCount": 141,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 198079,
                                    "sizeKB": 1833743.921875,
                                    "name": "RX78_SDXL_v3_loha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-12-08T17:12:02.627Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "92B83DFE",
                                        "AutoV2": "BDC191A2A3",
                                        "SHA256": "BDC191A2A3309D97693CBD0D3A7E5B486B009A54A680B4EB6A88F5C73F42900D",
                                        "CRC32": "DFAE6A7A",
                                        "BLAKE3": "072B15CEE49D81950F366292732998C09CEC5C11AF9E9075A7EAC52470122956",
                                        "AutoV3": "9C6B42573A5C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/255349",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 4324015,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c89670fa-418a-4850-977b-5d0ab16b62fa/width=450/4324015.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1536,
                                    "height": 2560,
                                    "hash": "UDF=O9AH00v#h}EM~pMyR4EM%Ln+=|EgInr?",
                                    "type": "image"
                                },
                                {
                                    "id": 4324022,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7a14e5cd-2db8-434d-acb7-43ebb2660eb3/width=450/4324022.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1536,
                                    "height": 2560,
                                    "hash": "UHFOr_n39]AGKQ9t-TxF%MR*M{oJ~WxFb_tS",
                                    "type": "image"
                                },
                                {
                                    "id": 4324007,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/58a80e46-aa1c-4556-85f7-00f4045b1140/width=450/4324007.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1536,
                                    "height": 2560,
                                    "hash": "U9E{Ol9Z00Mz00_3I=Wq~qR*?aIU0yELRN$,",
                                    "type": "image"
                                },
                                {
                                    "id": 4324008,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/24ddd88e-5e69-410a-ae75-0625e1906a51/width=450/4324008.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 1536,
                                    "hash": "UEKdPi70=FFsRM8wS1i^P;;NyXVs-=O;MJXS",
                                    "type": "image"
                                },
                                {
                                    "id": 4324016,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ff541957-4e26-42f2-8924-07386de695e9/width=450/4324016.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 2560,
                                    "hash": "UAEe_e0g4n~p#PxvxuD%?aIUOFs;9@IV_MD*",
                                    "type": "image"
                                },
                                {
                                    "id": 4324009,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3bdcbe59-fef3-4a25-b7cd-2fada69abfb5/width=450/4324009.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 2560,
                                    "hash": "UFFO[pbx9D^kxtNG~qaKW7xCtnNGo#MxEMbv",
                                    "type": "image"
                                },
                                {
                                    "id": 4324013,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f014eb61-d12d-4746-ab9c-2fe5e86c0f38/width=450/4324013.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 2560,
                                    "height": 1536,
                                    "hash": "UIFrkwrn.8~A4ojGM{V?Ee?b-Utlx^-o%LIU",
                                    "type": "image"
                                },
                                {
                                    "id": 4324012,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d82d0631-f86f-4e91-99cd-da387d2dc066/width=450/4324012.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1536,
                                    "height": 2560,
                                    "hash": "UBF=t3?c00%L0Lxb4o9F0Jo#%29F~q-;_3r;",
                                    "type": "image"
                                },
                                {
                                    "id": 4324017,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8df497f6-8d8c-4f71-b9eb-1a073632e961/width=450/4324017.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 2560,
                                    "hash": "UIHVC@nLS~M_S+%M%M%1~q%g%LxuOtWTIUs,",
                                    "type": "image"
                                },
                                {
                                    "id": 4324019,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/28507ade-f1dc-4504-b2f8-3e158440b8e4/width=450/4324019.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1536,
                                    "height": 2560,
                                    "hash": "UDGu8+-OE39aD%00Io-o0ziv~WnOOrs-.8M{",
                                    "type": "image"
                                },
                                {
                                    "id": 4324018,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7dfd914d-3782-4386-9598-d93443d263ce/width=450/4324018.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 2560,
                                    "hash": "ULHn?J%$O??HO7x[XToz~V?HX4tkNHXA-;%2",
                                    "type": "image"
                                },
                                {
                                    "id": 4324021,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f44b3e16-c38b-4f09-86b7-18365eabd7df/width=450/4324021.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 2560,
                                    "height": 1536,
                                    "hash": "UBC$yUD*0KV@8_In.8V@IT_49aRinj-=IU%L",
                                    "type": "image"
                                },
                                {
                                    "id": 4324025,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bc9b6e22-007d-43f5-8ac3-6d332c0ddd75/width=450/4324025.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 1536,
                                    "hash": "UIIER]?vGaS7tm_3%hOD~X$*xvI;}]xEkqNF",
                                    "type": "image"
                                },
                                {
                                    "id": 4324030,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c8dbaba7-890d-444f-8efe-f066daa74abf/width=450/4324030.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 2560,
                                    "hash": "UVFY$Mt89sba9aWYRiWB_4t7t7aeNfM{nhWB",
                                    "type": "image"
                                },
                                {
                                    "id": 4324026,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ed02cd72-9118-46a2-8120-597a34e0907b/width=450/4324026.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 2560,
                                    "hash": "UBE2kN0f00%y]#EM.9g4M_krwhM{_4SiD*xu",
                                    "type": "image"
                                },
                                {
                                    "id": 4324475,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/674f2fef-361b-411d-8705-26c54fd8e924/width=450/4324475.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 2560,
                                    "hash": "UDF=wG0000%ztS0K~BJCauRP$wV{?tIV9Zen",
                                    "type": "image"
                                },
                                {
                                    "id": 4324492,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7794ae24-9da0-4b0c-930a-aa2e95af55ea/width=450/4324492.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 2560,
                                    "hash": "U9FO+OKl9DIpx_R+I;%M-=-o?w^+~q%KR.s;",
                                    "type": "image"
                                },
                                {
                                    "id": 4324499,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/962b3308-c25f-49a2-835c-caeb35fbcbd7/width=450/4324499.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 1536,
                                    "hash": "U8ECOdH?00x[}^v#~X9v~WDi^,R*yZE1%1S$",
                                    "type": "image"
                                },
                                {
                                    "id": 4324141,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1fad32f8-bc49-44bb-afca-04042d1abcca/width=450/4324141.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1536,
                                    "height": 2560,
                                    "hash": "U7Frq=MH00_49f01~pDpyV4o-.^kO$57^+={",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/255349"
                        },
                        {
                            "id": 159294,
                            "name": "SDXL v1.0",
                            "index": 2,
                            "modelId": 22470,
                            "baseModel": "SDXL 1.0",
                            "nsfwLevel": 15,
                            "description": "<p><strong>Instruction: please notice SDXL version is a Lycoris not Lora, but same way to use</strong></p><p>This is the updated version for SDXL, if you wish to try SDXL, you can download this one, and it is a Lycoris version, for some reason, SDXL base model has a strange weight for Gundam, once you have the girl face, it will not likely to show full body, please use high weight to trigger it, or adding more prompts which related to the leg, foot, such as, long leg, shoes, it will help to full body prompt to realize.</p><p>if you find your output is likely to only have underwear, please use prompt bodysuit, it will significantly help to put the cloth on.</p><p>finally, please take a try and discover more!</p>",
                            "publishedAt": "2023-09-11T13:15:53.647",
                            "availability": "Public",
                            "trainedWords": [
                                "gundam\\(rx78\\)",
                                "mobile suit",
                                "mecha armor",
                                "body suit"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 1881,
                                "ratingCount": 89,
                                "rating": 4.99,
                                "thumbsUpCount": 170,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 119940,
                                    "sizeKB": 691056.390625,
                                    "name": "sdxl_loha_RX78_v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-09-11T13:10:48.355Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "2237C167",
                                        "AutoV2": "930567806F",
                                        "SHA256": "930567806FB4F0DA7C6B811E8194C04B11A931E0973F7E0EFD0A68972F7B843E",
                                        "CRC32": "3209E0D8",
                                        "BLAKE3": "CB16167F1C67F8418029F5313DDE743935F50CCCCB221BB8FCF8F9CB8DB85119",
                                        "AutoV3": "81B7ACAC6027"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/159294",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2451745,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a683f2f5-6a9b-424c-93bc-8fa7ca4f9db7/width=450/2451745.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 3072,
                                    "hash": "U9EVgC_39[IVNgM|?cIpyDRP_N-;4.XSw|w{",
                                    "type": "image"
                                },
                                {
                                    "id": 2451919,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8ac9907b-9327-4bf3-8bdc-5e1d66911312/width=450/2451919.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1408,
                                    "height": 2048,
                                    "hash": "UCG[QlqZ%LMcR;~B-;V=lROXR.Sx0LSe-6g2",
                                    "type": "image"
                                },
                                {
                                    "id": 2451909,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f938773d-ff24-4324-9dcb-2a902d96b735/width=450/2451909.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1536,
                                    "height": 2432,
                                    "hash": "URKd;}~q?H%LOaSitR-p-;bcaxad?cxvROM{",
                                    "type": "image"
                                },
                                {
                                    "id": 2451686,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04f05d54-329d-4b4f-af95-e797dd371202/width=450/2451686.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 2304,
                                    "hash": "UHI#r.?v_3~qJDo#o#%g-;IVNGW;.8WsRnIA",
                                    "type": "image"
                                },
                                {
                                    "id": 2452366,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/052e27d4-b543-435f-a503-8d7ac917be41/width=450/2452366.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 2048,
                                    "height": 1536,
                                    "hash": "UAJ7]--=-:NK^+jF?G_NDhR+00W;={NG00ai",
                                    "type": "image"
                                },
                                {
                                    "id": 2451743,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9416c09e-e884-44f5-803d-1ced7b689f25/width=450/2451743.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1536,
                                    "height": 2432,
                                    "hash": "UGFFX5~q-:~p-;xu?a?ayDRjxvaeR%s:NdRj",
                                    "type": "image"
                                },
                                {
                                    "id": 2451921,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6bdf9bb4-7b56-40d6-83bd-3d853c9631a7/width=450/2451921.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1056,
                                    "height": 1536,
                                    "hash": "U9HxHU+u~UJB1R+Zt7R5?v%zEM8{t8~pi{kr",
                                    "type": "image"
                                },
                                {
                                    "id": 2451820,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bcaa57eb-7b10-4881-b211-bb9c42470aef/width=450/2451820.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 2304,
                                    "height": 1536,
                                    "hash": "UGF$Ft0L9vD%S*D%s,xCS~Mx%2xa~XRjt24:",
                                    "type": "image"
                                },
                                {
                                    "id": 2451818,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2b8884a3-5120-4bff-9c1d-627419754893/width=450/2451818.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1536,
                                    "height": 2304,
                                    "hash": "UQGkzs~V9tIp-;aeo#S5ELE1%Ms:tSafxGM|",
                                    "type": "image"
                                },
                                {
                                    "id": 2452027,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d67ca710-46e6-4b7e-87c0-11f837a2a776/width=450/2452027.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2048,
                                    "height": 1536,
                                    "hash": "UII;|=~q?axu?GaJ-oRj-onhE4NGx]a#IUxC",
                                    "type": "image"
                                },
                                {
                                    "id": 2451672,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f756e310-ad6b-4048-a8fa-88dc6055df29/width=450/2451672.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 2304,
                                    "hash": "UGG8.v~9D$%LksIUt7?aW90Ko~%Mx[M_D*kC",
                                    "type": "image"
                                },
                                {
                                    "id": 2451682,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c06c24d5-7f3a-4ca7-9ca1-5424957c9650/width=450/2451682.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 2304,
                                    "hash": "U9F~aT4nJ8%g4oov-q-:~p^*-=%1J8%Mx_-p",
                                    "type": "image"
                                },
                                {
                                    "id": 2451840,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2f877a33-b449-43e6-8e0d-f971096b14fa/width=450/2451840.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 2304,
                                    "height": 1536,
                                    "hash": "UMG[yh~qyDo#01XAtSS5D$D*t7n$-pV?V@xa",
                                    "type": "image"
                                },
                                {
                                    "id": 2451918,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/127c1b03-7570-470a-a000-3e5069ec73d7/width=450/2451918.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1408,
                                    "height": 2048,
                                    "hash": "UGIh8T?wo|TKA0_3b{bwyX%NWCjF%LENe9aK",
                                    "type": "image"
                                },
                                {
                                    "id": 2451935,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/812ca885-c9e5-4820-a2a1-20b387c98583/width=450/2451935.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1056,
                                    "height": 1536,
                                    "hash": "U7Gbn}~XYkX.yF-pt6t6?E-=H=vz0M?w%3xG",
                                    "type": "image"
                                },
                                {
                                    "id": 2451965,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d5ccb36b-119a-4b66-adb7-829ba946a337/width=450/2451965.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1056,
                                    "height": 1536,
                                    "hash": "UEHLYt-pyB~qO]D+XAIq%1xub{x]_N%gs:t7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/159294"
                        }
                    ]
                },
                {
                    "id": 8429,
                    "name": "Helltaker LoRA",
                    "description": "<p>Helltaker LoRA</p><p><br />If you want to reproduce the original Helltaker-like character, enter the trigger word 'Helltaker'.</p><p></p><p>Alternatively, I recommend that you apply weights between 0.5 and 0.6 without applying trigger words.</p><p></p><p>Or If you apply a weight of 0.3~0.4, It will emphasize the outline.</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 20724,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3729,
                        "thumbsDownCount": 1,
                        "commentCount": 10,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 10
                    },
                    "creator": {
                        "username": "EPEG1234",
                        "image": "https://cdn.discordapp.com/embed/avatars/3.png"
                    },
                    "tags": [
                        "anime",
                        "style",
                        "helltaker"
                    ],
                    "modelVersions": [
                        {
                            "id": 9942,
                            "name": "1.0",
                            "index": 0,
                            "modelId": 8429,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-02-13T05:35:27.971",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 20724,
                                "ratingCount": 3282,
                                "rating": 5,
                                "thumbsUpCount": 3729,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 9576,
                                    "sizeKB": 147569.697265625,
                                    "name": "Helltaker.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-13T05:41:04.975Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "97EA1570",
                                        "AutoV2": "856E67AF85",
                                        "SHA256": "856E67AF8548A092CB69446016129868A2E0E203F21687EEFBEC6CFBE47F910B",
                                        "CRC32": "1E9F70E4",
                                        "BLAKE3": "58BD6A265724C3C5BBD7D18013327BDE1B9B94C26F05755615C6B02BD28DF510",
                                        "AutoV3": "303DC55D153F"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/9942",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 143007,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e8ea892a-556d-484f-d93f-f7be102d4900/width=450/143007.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UrO3|Ut7~qxuxuayofof.7V@j[t7xafQWqkC",
                                    "type": "image"
                                },
                                {
                                    "id": 96804,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/73eac4f7-e468-42c2-9c72-d048df0c4800/width=450/96804.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTI}x7oz_3%2~qofD%RjtlV@V@WVM{t7t7f6",
                                    "type": "image"
                                },
                                {
                                    "id": 143006,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/65e5420d-6c0f-4492-b07a-dcc04456c400/width=450/143006.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USG[$l9F-.D%~qD*s+RjozNID*NGIVRjxus-",
                                    "type": "image"
                                },
                                {
                                    "id": 96802,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3d3afe11-365c-4e1f-7693-1be127409300/width=450/96802.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEGv0BIA*0-;E1oLxuRP00kCRPIADOIU0K-;",
                                    "type": "image"
                                },
                                {
                                    "id": 96801,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d6c9f738-80c4-4482-ed46-f5a32684f000/width=450/96801.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFHe@5~qFy?bnO^%s+Os00Rj-UoM=YtRxuoL",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/9942"
                        }
                    ]
                },
                {
                    "id": 24062,
                    "name": "[LoRA]地雷系/量産型ファッション | landmine girl fashion | 地雷系量产系妹子",
                    "description": "<h3 id=\"heading-41\">you can use 日本語 | 中文 | English to feedback</h3><p></p><h3 id=\"heading-42\"><a rel=\"ugc\" href=\"https://twitter.com/TakoSuikaRider\"><strong>ツイッター</strong></a><strong>に投稿する際、</strong> #SuikaMix か @TakoSuikaRider　をしてください。</h3><h3 id=\"heading-43\">use #SuikaMix or @TakoSuikaRider if you post on <a rel=\"ugc\" href=\"https://twitter.com/TakoSuikaRider\">twitter</a> :)</h3><p></p><p></p><p></p><p>jirai fashion/landmine girl is a fashion style in japan, it's different from lolita fashion and main color is pink and black,</p><p></p><p></p><p></p><p></p><p>v2: trained with 288 images (including the 94 images used in v1) in 1024x1024, based on SD1.5, 19200 steps,</p><p>v1: trained with 94 images in 1024x1024, based on SD1.5, 5400steps,</p><p>you can choise the one you like :)</p><p></p><p></p><p></p><p></p><h3 id=\"heading-44\">main word <strong>jirai fashion ,</strong> you can see the sample image's prompts to find out how to specify colors and clothes, and hair</h3><p></p><p></p><p></p><p></p><p>SuikaMix<strong> </strong>is a model I mixed ,you can download <a rel=\"ugc\" href=\"https://www.picpic.ai/modelinfo/060e3c23eaa84c948f4d2e4d79fde7bb\">here</a></p><p><u>RealSuikaMix is not pulished yet,</u></p><h3 id=\"heading-45\"><strong>weight 0.6-0.8 is recommended</strong></h3><p>looking forward to see your images :)</p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [],
                    "allowDerivatives": false,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 27614,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3671,
                        "thumbsDownCount": 0,
                        "commentCount": 12,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 4
                    },
                    "creator": {
                        "username": "takosuika",
                        "image": "https://lh3.googleusercontent.com/a/AGNmyxaL8SIfJ_EZFVBLwKTI9APaaqu8WBPbCx46iqdd=s96-c"
                    },
                    "tags": [
                        "fashion",
                        "outfit",
                        "clothing",
                        "japanese girl",
                        "jirai",
                        "地雷",
                        "量産型"
                    ],
                    "modelVersions": [
                        {
                            "id": 33010,
                            "name": "v2.0",
                            "index": 0,
                            "modelId": 24062,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>trained with 288 images (including the 94 images used in v1) in 1024x1024, based on SD1.5, 19200 steps,</p>",
                            "publishedAt": "2023-04-01T07:33:57.026",
                            "availability": "Public",
                            "trainedWords": [
                                "jirai fashion"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 24621,
                                "ratingCount": 2467,
                                "rating": 5,
                                "thumbsUpCount": 3039,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 27189,
                                    "sizeKB": 9324.7919921875,
                                    "name": "jirai_v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-01T07:36:29.188Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "B551F98F",
                                        "AutoV2": "4149FB2B4C",
                                        "SHA256": "4149FB2B4CD59A5104DAF304E53411FDFA7371934161782BF60F448C9C9B8150",
                                        "CRC32": "D2C39D3C",
                                        "BLAKE3": "808595FDF891F59FA8D872DD382E31B3514CBFAA8C4EA64B893F0C2D29AA7E83",
                                        "AutoV3": "360487F810E8"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/33010",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 376057,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/caf36a4a-b235-457a-d1cd-12c93a636a00/width=450/376057.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "UAH_Szxa00-;Iq4oM{bc_2Iq%29G~p%M9ZIU",
                                    "type": "image"
                                },
                                {
                                    "id": 376040,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/df1a028c-49a0-411a-3dc5-0b9a0305b900/width=450/376040.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "UCGH}J0L5kNyY8RjtT-o0,o~%hM{5[?bnlR*",
                                    "type": "image"
                                },
                                {
                                    "id": 376051,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f295a03d-c7a5-4e00-0058-0df587007500/width=450/376051.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "U8GuOD00XO9FW-00~W-pEd01%2~W-;-pM{In",
                                    "type": "image"
                                },
                                {
                                    "id": 376055,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/02039bb6-58a1-4166-8afe-1f28964d1000/width=450/376055.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "UCHBSa9u^h-:0Mxu~VNb%L^*Nead0Lt7t7t7",
                                    "type": "image"
                                },
                                {
                                    "id": 376053,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f0af30a7-bf8d-4bcb-168d-185489dc0000/width=450/376053.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "U7F}_?%L^h-o~V~V~V0L^*?GS5xuE0?aIp^k",
                                    "type": "image"
                                },
                                {
                                    "id": 376049,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bd62108c-d645-4ea6-3de8-7a5244168b00/width=450/376049.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "U6F=aT00%Fj0~V4:-:8{00R._3010K9af+?b",
                                    "type": "image"
                                },
                                {
                                    "id": 376047,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d748704d-8dc1-435e-b038-dacee2293f00/width=450/376047.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "U9Gkzd4.--00~V%M%1xu00R*-;.8NZRjxu9G",
                                    "type": "image"
                                },
                                {
                                    "id": 376048,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cab8ee5b-0bb9-4727-2946-74d98e8d7f00/width=450/376048.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "UBFYP-0K$yD*?b4:9aRj009u~pxZE2t6x]M{",
                                    "type": "image"
                                },
                                {
                                    "id": 376045,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/66893ad3-9e6f-4756-685f-567d02480800/width=450/376045.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "UBEy9~?G=_%N~V?a^*NGDh-;%NRi9axZR*bv",
                                    "type": "image"
                                },
                                {
                                    "id": 376046,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1059c8ae-41ba-425f-27f8-98f308dce000/width=450/376046.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "UCGk%n?Z00NG0JRiS59Z00sm~q-;%gSiRORP",
                                    "type": "image"
                                },
                                {
                                    "id": 376043,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ac2a1eef-a3d4-42e6-1c53-e37a73db2b00/width=450/376043.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "UCFFBH~VxV^%E2?H%LWB%M?GIqX901j[%MNH",
                                    "type": "image"
                                },
                                {
                                    "id": 376041,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/880ee93a-84d0-4ead-22e3-ef36687cbb00/width=450/376041.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "UFF5sy%2aI~V%LWYoLM|D%t7ozD%RQoIWUof",
                                    "type": "image"
                                },
                                {
                                    "id": 376042,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7d131f67-1b29-4bab-f1fc-662ab9677f00/width=450/376042.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "UAI4;TyZx]AKNz0NOF%M00%ip0D%yEtSi{%M",
                                    "type": "image"
                                },
                                {
                                    "id": 376039,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7dfe8b90-8388-40f7-9c71-2f0e3824a000/width=450/376039.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "ULHUh1-;W=%29G4:RkRj~VIpE2Rjt6xtofxa",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/33010"
                        },
                        {
                            "id": 28745,
                            "name": "v1.0",
                            "index": 1,
                            "modelId": 24062,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>trained with 94 images in 1024x1024, based on SD1.5, 5400steps,</p>",
                            "publishedAt": "2023-03-25T06:36:42.783",
                            "availability": "Public",
                            "trainedWords": [
                                "jirai fashion"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2993,
                                "ratingCount": 635,
                                "rating": 5,
                                "thumbsUpCount": 637,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 23751,
                                    "sizeKB": 9326.9560546875,
                                    "name": "jirai.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-25T06:41:57.487Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "0F931243",
                                        "AutoV2": "5D8F605E11",
                                        "SHA256": "5D8F605E11FC257FB0750F0007DEDCB8296CE517F71E5AD7FF676D5418E5F58A",
                                        "CRC32": "5602D2D1",
                                        "BLAKE3": "6175EC1D1C9668DBEA9E2015DFDF3B6DF67C86BB56BF63531BCB18EE481FF2F6",
                                        "AutoV3": "A6261F3BA817"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/28745",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 331080,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4d61060d-76de-49d8-d2ef-0c2e0255cb00/width=450/331080.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "UAF#]*%#-.-q~VR-^*IVpGxa-p9ZWA?Gxuoy",
                                    "type": "image"
                                },
                                {
                                    "id": 324212,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/19c35b36-34f7-4c44-6d82-66a366e0d200/width=450/324212.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "UDD+}IkCS1_3_N-p%Mt7D%t7IUM{NHWBIUM{",
                                    "type": "image"
                                },
                                {
                                    "id": 324211,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/daa48e67-b528-4c78-563e-23ff0db59500/width=450/324211.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9G*[{9~?t4._4?b01M{T1_2IVIU?uIps;sA",
                                    "type": "image"
                                },
                                {
                                    "id": 325274,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d1e13bd3-3fea-4748-fd68-e0cbbddda500/width=450/325274.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "UIGH@@~p~U?G?HxuE2WAxts:RkRks,j?xat7",
                                    "type": "image"
                                },
                                {
                                    "id": 324208,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/466ffda3-9db7-4266-0011-99a05e9ea800/width=450/324208.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1496,
                                    "height": 920,
                                    "hash": "U8GIT3^*9t4.E201_2Io~WIos:-p0LxaWCD*",
                                    "type": "image"
                                },
                                {
                                    "id": 325273,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ef21af3a-41ff-4c7b-6de6-4bcb5c207c00/width=450/325273.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "UQHUC0E1=Yxt~BaeNGkCJARkI=IpxYWBxaR*",
                                    "type": "image"
                                },
                                {
                                    "id": 324210,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0500c92a-7d3a-4156-8687-55afdc6d2400/width=450/324210.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "UHHUwljv9Z~W-;^+WB%MX5Io-;t7-paeE1WB",
                                    "type": "image"
                                },
                                {
                                    "id": 324209,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/259eb299-eda7-4f9a-6c7c-50969adefd00/width=450/324209.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1568,
                                    "hash": "U6Fh|y00k#~WDoS0%4RQ~UWB?HWA00IW~VE1",
                                    "type": "image"
                                },
                                {
                                    "id": 325167,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d4ed4723-013f-4d72-c518-888c105f1700/width=450/325167.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3483,
                                    "height": 4000,
                                    "hash": "U3FFNnogt8~UxtM|IpRis+R%Io~pE1tR9GIo",
                                    "type": "image"
                                },
                                {
                                    "id": 325166,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fe190346-1db4-42d0-7b32-ae3bc3e30800/width=450/325166.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3483,
                                    "height": 4000,
                                    "hash": "U4FFKiS2-o^*~VjI%2%M-oIoRioy?HxuE1%L",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/28745"
                        }
                    ]
                },
                {
                    "id": 76693,
                    "name": "Mecha",
                    "description": "<h1 id=\"heading-274\"><span style=\"color:rgb(250, 82, 82)\">Choose the one u like best</span></h1><p></p><h1 id=\"heading-15\"><span style=\"color:#4c6ef5\">First generation</span></h1><p><img src=\"https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/46e34082-dfa3-4d0a-b772-4c0975632988/width=525/46e34082-dfa3-4d0a-b772-4c0975632988.jpeg\" /></p><h1 id=\"heading-4\"><span style=\"color:rgb(76, 110, 245)\">Second generation</span></h1><p><img src=\"https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cc25be1c-5599-4a4e-be1c-2a865c0d2ff3/width=525/cc25be1c-5599-4a4e-be1c-2a865c0d2ff3.jpeg\" /></p><p></p><h1 id=\"heading-3\"><span style=\"color:rgb(130, 201, 30)\">Recommend Model: </span><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/23900/anylora-checkpoint\"><strong><span style=\"color:rgb(130, 201, 30)\">anyloraCheckpoint_bakedvaeFtmseFp16NOT</span></strong></a><span style=\"color:rgb(130, 201, 30)\">,</span></h1><p></p><h3 id=\"heading-272\">Extract from MechaMix</h3><p></p><p><span style=\"color:rgb(190, 75, 219)\">Negative prompt: hair, (worst quality, low quality:1.4), (bad_prompt_version2:0.8), EasyNegative, badhandv4, text, name, letters, watermark</span></p><p><span style=\"color:rgb(190, 75, 219)\"><br />Steps: 20,</span></p><p><span style=\"color:rgb(190, 75, 219)\">Sampler: DPM++ 2S a Karras,</span></p><p><span style=\"color:rgb(190, 75, 219)\">CFG scale: 7,</span></p><p></p><p><span style=\"color:rgb(190, 75, 219)\">Denoising strength: 0.5,</span></p><p><span style=\"color:rgb(190, 75, 219)\">Hires upscale: 2,</span></p><p><span style=\"color:rgb(190, 75, 219)\">Hires steps: 20,</span></p><p><span style=\"color:rgb(190, 75, 219)\">Hires upscaler: R-ESRGAN 4x+ Anime6B</span></p><p></p><p><span style=\"color:rgb(190, 75, 219)\">Clip skip: 2,</span></p><p><span style=\"color:rgb(190, 75, 219)\">VAE: </span><a target=\"_blank\" rel=\"ugc\" href=\"http://kl-f8-anime2.vae.pt\"><span style=\"color:rgb(190, 75, 219)\">kl-f8-anime2.vae.pt</span></a></p><p></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent",
                        "Sell"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 42440,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3652,
                        "thumbsDownCount": 0,
                        "commentCount": 25,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 110
                    },
                    "creator": {
                        "username": "Cinsdia",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/413ee08a-0537-47b8-a230-df633466fecd/width=96/Cinsdia.jpeg"
                    },
                    "tags": [
                        "mecha",
                        "cool",
                        "style",
                        "robot"
                    ],
                    "modelVersions": [
                        {
                            "id": 150907,
                            "name": "StealthMecha",
                            "index": 0,
                            "modelId": 76693,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p><strong>又发现个跟我师出同门的老哥，狠狠的NTR</strong></p>",
                            "publishedAt": "2023-08-29T09:28:53.022",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 6553,
                                "ratingCount": 309,
                                "rating": 4.99,
                                "thumbsUpCount": 759,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 112221,
                                    "sizeKB": 147572.390625,
                                    "name": "StealthMecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-08-29T09:05:47.287Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "671FDB87",
                                        "AutoV2": "E4E72FA640",
                                        "SHA256": "E4E72FA640A61794316DC25174A4D72D8E00C8E46BC002D93DBA6DD8C1C3C55D",
                                        "CRC32": "982426C0",
                                        "BLAKE3": "302A2BBDB6500EFAE4CF47A4CAF7FB7E250698026559D0D3AC90A606EFC238FE",
                                        "AutoV3": "44131EA44044"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/150907",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2257212,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f51b96eb-5a05-47e1-b777-764ed2471a2c/width=450/2257212.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNEfQb.8NF0K~q-;fkD%X8-;f7Ri-;.8RjM{",
                                    "type": "image"
                                },
                                {
                                    "id": 2257177,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/90cfaec1-7551-4722-8a3e-c9e46f22db12/width=450/2257177.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDDvZlE2IUS4.9Rj%LNG-;MxIAtR~qD%%2Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 2257176,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/da988356-1ff0-4343-a0ea-4d8153e370a2/width=450/2257176.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEE.^W.TxY%MtmENM{D%8_9Z8_IT~p-:Di%L",
                                    "type": "image"
                                },
                                {
                                    "id": 2257178,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d0d959a2-6b30-4a75-9c4b-a41b8efc9ba5/width=450/2257178.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USEV~TbbRj%L_Nt8oJxa%gt7IU%2?bM{M{xt",
                                    "type": "image"
                                },
                                {
                                    "id": 2257181,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/244687be-b8dd-4de8-9bb9-c61cfc7ed961/width=450/2257181.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNE3J0IUWURk_NV@%MRjx]xZWAt7?bxtD%t7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/150907"
                        },
                        {
                            "id": 138522,
                            "name": "AstralMecha",
                            "index": 1,
                            "modelId": 76693,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>赶紧把第三代填填满</p>",
                            "publishedAt": "2023-08-11T07:54:34.61",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 4027,
                                "ratingCount": 246,
                                "rating": 5,
                                "thumbsUpCount": 468,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 101545,
                                    "sizeKB": 147567.224609375,
                                    "name": "AstralMecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-08-11T07:55:34.470Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "903DCD7E",
                                        "AutoV2": "A10AE74127",
                                        "SHA256": "A10AE741278436F98C17828DFFA71659F647311DCE12EB1D5648DF287BB6DC5F",
                                        "CRC32": "04AD4EDA",
                                        "BLAKE3": "D35C9153C99FC34A63A645F9799E3157EA6A6A34E08F92DBB9D44C4B0795FFFF",
                                        "AutoV3": "9B9EF9913373"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/138522",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1975268,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9829c1d2-6c99-40a6-b882-057209a86bee/width=450/1975268.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCAd4PIWIoM|~pWYIVM|E2%LD*f5E2xZIVxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 1975269,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b0a2b5f6-d969-49ba-b5e5-2e2a422809b7/width=450/1975269.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDC$.e?b8{9G~p%2M{Ip.8%1D%RjTdxuD*M{",
                                    "type": "image"
                                },
                                {
                                    "id": 1975266,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f1ef9bac-fee6-4c9c-be50-27db170f94c2/width=450/1975266.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U3C6V^0M009u_3%f0MNG00%fIB^%Bp01}?%2",
                                    "type": "image"
                                },
                                {
                                    "id": 1975267,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5055c759-740f-45e4-9b33-c5c8f9de34be/width=450/1975267.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHFO[h-pM_9G?w?HV@Iojx-:D%R*?aM|RPR*",
                                    "type": "image"
                                },
                                {
                                    "id": 1975265,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/82bc4ca0-ca79-4913-ad57-7866e02b996a/width=450/1975265.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFCsT_IpMxoJ~pR+IVRktRxaIVs,%MRkM{oe",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/138522"
                        },
                        {
                            "id": 138510,
                            "name": "LavaMecha（熔岩）",
                            "index": 2,
                            "modelId": 76693,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Merged with Lava by <strong>myself</strong></p><p><strong>黑红真是怎么配都好看</strong></p>",
                            "publishedAt": "2023-08-11T07:15:23.208",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 882,
                                "ratingCount": 3,
                                "rating": 5,
                                "thumbsUpCount": 9,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 101534,
                                    "sizeKB": 147567.224609375,
                                    "name": "LavaMecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-08-11T07:05:37.501Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "D153CD34",
                                        "AutoV2": "2809CB6908",
                                        "SHA256": "2809CB6908608439ECF0648768DB8EACA1DCE6269F33E1FAD68D22AF8785C41E",
                                        "CRC32": "8D72A202",
                                        "BLAKE3": "310C0DFD3A8DCB89C4A9CADFD5EEE2740E4B48D328D82C8A92DB16A11AC1A72A",
                                        "AutoV3": "B3E35D891CCB"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/138510",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1974911,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1c787bc4-e358-4446-afcc-44e0e2ccd8a4/width=450/1974911.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6Ace;pI9uV[.m?GR%jF^k-:ofayE2xu%1%2",
                                    "type": "image"
                                },
                                {
                                    "id": 1974900,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f21a3bae-c58a-45d5-ac08-a9a3a1b5a0c3/width=450/1974900.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U49?ap0g9axZ?]E2a0NHk;NHn%E2FeRj={Ip",
                                    "type": "image"
                                },
                                {
                                    "id": 1974902,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bcb9c929-7450-46dd-ae87-304b44f27197/width=450/1974902.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8BMY;xZ4.I=_NI;E2s.-;S2xa%1R+NGs:-p",
                                    "type": "image"
                                },
                                {
                                    "id": 1974901,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/38f65beb-5855-43de-b858-22fdb5807421/width=450/1974901.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9AcoC%MD%NG_NtRE2EL%Mxus:NGtQ%0s.$%",
                                    "type": "image"
                                },
                                {
                                    "id": 1974910,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71c5c9cd-a4f4-48c1-ad3b-120c2922e597/width=450/1974910.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U4A,8+EkEL^j?^NdNG-nw[ENt7sl02IVnN-o",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/138510"
                        },
                        {
                            "id": 127741,
                            "name": "InkMecha(水墨)",
                            "index": 3,
                            "modelId": 76693,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p><strong>我亲爱的SSR没有让我失望</strong></p>",
                            "publishedAt": "2023-07-28T10:03:00.313",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3821,
                                "ratingCount": 230,
                                "rating": 5,
                                "thumbsUpCount": 398,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 92411,
                                    "sizeKB": 147567.224609375,
                                    "name": "InkMecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-28T10:01:39.707Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "927B70CA",
                                        "AutoV2": "8CA11AC15B",
                                        "SHA256": "8CA11AC15B1DDBC1E008C69F417D8BC1E2745DAFB2D954F642B1446CF0CC2868",
                                        "CRC32": "6E72AC3E",
                                        "BLAKE3": "E12F10E489D95690AB45054A2FB0AA312F9A807990B19F8345E9267685D93138",
                                        "AutoV3": "18756B70642D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/127741",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1757804,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/13887acf-1967-4e90-9302-8d0dea3c3287/width=450/1757804.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UVI=Mot8IUE1~qofM{D%jY9FIUD%-;j]D%%M",
                                    "type": "image"
                                },
                                {
                                    "id": 1757805,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b6a5bef2-d269-42dd-b00f-a10debd81c5d/width=450/1757805.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UeI#x^ozWAt7~qayWBRkV@RjD*WB?bofIUj[",
                                    "type": "image"
                                },
                                {
                                    "id": 1757802,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4ed8d67e-6107-4f4d-8e13-61e9c78d2ff2/width=450/1757802.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UZG+UJtRRPt7~qWBRPWBRjj[IUIU%Mt7IUt7",
                                    "type": "image"
                                },
                                {
                                    "id": 1757806,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/477af13b-7f7f-4fa2-8877-c9b719e9cc11/width=450/1757806.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UgJ*YaMyNFNG~qIUt7WVODozaeof%M%MIUoL",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/127741"
                        },
                        {
                            "id": 120924,
                            "name": "SharpieMecha",
                            "index": 4,
                            "modelId": 76693,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Merged with MinimalVector by <strong>myself</strong></p>",
                            "publishedAt": "2023-07-19T07:24:15.179",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2473,
                                "ratingCount": 283,
                                "rating": 5,
                                "thumbsUpCount": 288,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 86877,
                                    "sizeKB": 147567.224609375,
                                    "name": "SharpieMecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-19T07:42:05.522Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "310FFE15",
                                        "AutoV2": "5DC8810EDF",
                                        "SHA256": "5DC8810EDF8D0D58B9E9AA99C8B83B22F4676B6112BBAE258ADBA761DA91A397",
                                        "CRC32": "9AA8538D",
                                        "BLAKE3": "3DB5CF6B2AD1BECEF26B682B4469F505BAFF1DC9140B54ED8991B83E3F6CEE55",
                                        "AutoV3": "CCA94D822040"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/120924",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1623940,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2b9d3301-a8c4-47ea-bc15-a38093bd7eda/width=450/1623940.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGIDzG%g%~-oDjE2ELnh5;M|57NG~V-pOY%M",
                                    "type": "image"
                                },
                                {
                                    "id": 1623939,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1c69884f-120b-429c-b657-8b3ade96ec92/width=450/1623939.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCGH#i=FK%tlui?F~Bxu02KOj]%M;kWq0LTJ",
                                    "type": "image"
                                },
                                {
                                    "id": 1623938,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/763d1f89-7362-4d82-a37e-cbf44a767071/width=450/1623938.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCFOr.TJ-;xuK7NeXSe.00t74:ae~V={nNbv",
                                    "type": "image"
                                },
                                {
                                    "id": 1623937,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/42024705-9d46-40e2-a467-bb46ef8f731a/width=450/1623937.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFIEO#?wyrxu-W~VI[9Z00s+4nIU?uR+M{9u",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/120924"
                        },
                        {
                            "id": 119297,
                            "name": "MinimalVectorMecha",
                            "index": 5,
                            "modelId": 76693,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Merged with MinimalVector by <strong>myself</strong></p><p><strong>中文想不出来就不写了</strong></p>",
                            "publishedAt": "2023-07-17T02:07:38.48",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 985,
                                "ratingCount": 48,
                                "rating": 5,
                                "thumbsUpCount": 67,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 85475,
                                    "sizeKB": 147567.224609375,
                                    "name": "MinimalVectorMecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-17T03:23:16.704Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "D63708E6",
                                        "AutoV2": "55ABA0E959",
                                        "SHA256": "55ABA0E959CCC224BFC15E1AFE2DAC9C77E295199D34E768B5144C94B12818B6",
                                        "CRC32": "F22BCA5C",
                                        "BLAKE3": "09CF1749F3F5D28B1835EEA1CD65B412C4757A48F1A3812B11E9D916E000E9E5",
                                        "AutoV3": "FFB995C46FD2"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/119297",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1591990,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5f27817c-325b-4d85-869c-b22a1468f56c/width=450/1591990.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDDlp9oznNs:~pNGxuM{IoRjt7WB%MRjRjt7",
                                    "type": "image"
                                },
                                {
                                    "id": 1591991,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b6337dd9-8bcf-419b-b351-b3030abb1720/width=450/1591991.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCC?T79^M_?a~BEL%1-:M{tRxb%LIURPR*%L",
                                    "type": "image"
                                },
                                {
                                    "id": 1591984,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ee463c49-d356-4a38-b62c-26e21d143439/width=450/1591984.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFE{Uyx^E1?a~qI@a|xaIUD*D*M{?FD*9GxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 1591989,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/751e56c3-05ce-443a-9a89-7d3edfd14af0/width=450/1591989.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5Ee=AEN-P00*04:~U4.?vD*%#IpD%V[?vRj",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/119297"
                        },
                        {
                            "id": 117200,
                            "name": "BokehMecha（闪耀）",
                            "index": 6,
                            "modelId": 76693,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Merged with Hologram by <strong>myself</strong></p>",
                            "publishedAt": "2023-07-14T03:47:45.13",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1837,
                                "ratingCount": 74,
                                "rating": 5,
                                "thumbsUpCount": 92,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 83757,
                                    "sizeKB": 147567.224609375,
                                    "name": "BokehMecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-14T04:02:19.826Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "0B957AD5",
                                        "AutoV2": "6D79D0DD49",
                                        "SHA256": "6D79D0DD492346360AE0E5B618015A93AFC6F49DDBB7BCD628B4B2FF4902F652",
                                        "CRC32": "5F91EA70",
                                        "BLAKE3": "B9F0799FD98530B70EA87C0F6681D29A0A1FB504D39A15F5C733CBD3AB2BD80B",
                                        "AutoV3": "972339D4A351"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/117200",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1547018,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f616f2e-de9f-4177-a943-08c9e604c7f2/width=450/1547018.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPIELd~A^NNetmWq$#NI0LWW57t7xBs,W=%1",
                                    "type": "image"
                                },
                                {
                                    "id": 1547020,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a3ac7a7a-8b91-4705-886f-d24a9bb960bb/width=450/1547020.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGHw_U=v^$9a~W%1aJM|00S$02xt9ZIpR,%2",
                                    "type": "image"
                                },
                                {
                                    "id": 1547019,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/694fd4fc-7e60-4693-8204-8a7e55bf73ba/width=450/1547019.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UYG[N9RQD*o}XUaeIoofR*WBNGt7~9RkRlt7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/117200"
                        },
                        {
                            "id": 116511,
                            "name": "HologramMecha（解离）",
                            "index": 7,
                            "modelId": 76693,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Merged with Hologram by <strong>myself</strong></p>",
                            "publishedAt": "2023-07-13T06:36:23.313",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1457,
                                "ratingCount": 54,
                                "rating": 5,
                                "thumbsUpCount": 71,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 83170,
                                    "sizeKB": 147567.224609375,
                                    "name": "HologramMecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-13T06:32:22.506Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "A34A0338",
                                        "AutoV2": "5BD8D6339D",
                                        "SHA256": "5BD8D6339D4E5E693E6723EC50A703E6BC48F5193A69B736635B7F1134EF4A46",
                                        "CRC32": "EAB8DC63",
                                        "BLAKE3": "FFD76160428012A599592AF344F02576C875EF5BDB6F777E00B3A89A03F2F09C",
                                        "AutoV3": "DBFB248C6CAE"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/116511",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1533997,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/72d5edc4-f823-40cc-860d-107b51cdeb8a/width=450/1533997.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULDA1IkWITr?_4M_IUjYx]ITIUozxuMwnjoz",
                                    "type": "image"
                                },
                                {
                                    "id": 1534015,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4ce5e9a5-f142-46c1-bcc6-d61c111ad642/width=450/1534015.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U45sD:yED4MJDhR4o~tR%iozysbvHXf+yDnN",
                                    "type": "image"
                                },
                                {
                                    "id": 1534025,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/befc48e7-6e41-41fc-9c82-41eb8eca9a48/width=450/1534025.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5A^8-K%.R?wo|MxD%wcMvsoxaxY%3I;-=kD",
                                    "type": "image"
                                },
                                {
                                    "id": 1534028,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a22e505a-bed7-4a23-9454-cfb477c68d5f/width=450/1534028.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U58}0;pI9ER;~WWVIUIo4mD*bJ%29ZMxkX%M",
                                    "type": "image"
                                },
                                {
                                    "id": 1534026,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ff27b3f8-2ff6-4d35-8ec2-4984976e26d4/width=450/1534026.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCB4H|S$8^Dj?^t68_M{W9eTMxozE2RP%1-;",
                                    "type": "image"
                                },
                                {
                                    "id": 1534027,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0e1e3435-10a2-4262-ac8a-e72f96d79f5a/width=450/1534027.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEAwC;EkM^Rk_3E2M{M{~VIVV@WBWTRPRkt8",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/116511"
                        },
                        {
                            "id": 115859,
                            "name": "GlassSteelMecha（蓝钢）",
                            "index": 8,
                            "modelId": 76693,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Merged with GlassSteel by <strong>konyconi</strong></p>",
                            "publishedAt": "2023-07-12T07:42:08.078",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1565,
                                "ratingCount": 56,
                                "rating": 5,
                                "thumbsUpCount": 70,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 82617,
                                    "sizeKB": 147567.224609375,
                                    "name": "GlassSteelMecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-12T07:46:26.999Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "CAF3BAC8",
                                        "AutoV2": "2A8389F815",
                                        "SHA256": "2A8389F815716CD1DEEB0C8716AE00388E072E1FE31076B8280E0D02A9E378BE",
                                        "CRC32": "9DDE3998",
                                        "BLAKE3": "3F9664FD3B15226D1032A48FE5BFF37B0E7E1D77AF48BFC2EAE24C02B927A60C",
                                        "AutoV3": "6C3921D98F82"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/115859",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1520228,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6ee1cf4e-b871-4ec0-8b41-b05a5f11c479/width=450/1520228.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCA^wPOFxBRP_NozxZtR01-:M{%g9GaxIVx]",
                                    "type": "image"
                                },
                                {
                                    "id": 1520231,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/61b07140-9691-4b84-8ee8-99a43dfff69e/width=450/1520231.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7B|jI_N==r;%hM|MxM_00D%8_Ri_N?aad%M",
                                    "type": "image"
                                },
                                {
                                    "id": 1520232,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b66c623d-d9fd-445b-b326-af91c0682036/width=450/1520232.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBCQJU_N00D%_3og009F_3tR9FIU-;%2Ipt6",
                                    "type": "image"
                                },
                                {
                                    "id": 1520233,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/64ed8997-f77d-462f-b424-3cd28f20e415/width=450/1520233.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFB45dIUozM{~pRjbbRjIUxuRjt7MyWBRQ%L",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/115859"
                        },
                        {
                            "id": 113502,
                            "name": "TalDarimMecha（末世）",
                            "index": 9,
                            "modelId": 76693,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Merged with TalDarim by <strong>konyconi</strong></p>",
                            "publishedAt": "2023-07-09T07:16:20.312",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2065,
                                "ratingCount": 125,
                                "rating": 5,
                                "thumbsUpCount": 159,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 80630,
                                    "sizeKB": 147567.224609375,
                                    "name": "TalDarimMecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-09T07:16:14.825Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "BEA49A2B",
                                        "AutoV2": "722D6D7D6A",
                                        "SHA256": "722D6D7D6AD627EED8B6F0322BB5F02DBB487F7C74EE756099851D3FEF304A6F",
                                        "CRC32": "99FA9880",
                                        "BLAKE3": "39FCF1FC3B3E542A2E61EB5B563E9F16E828A36AC4D14AFE4D97552ECB480331",
                                        "AutoV3": "8A5273B2D037"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/113502",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1473093,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d3e46cd4-a67f-4943-877e-53b6e8bb2899/width=450/1473093.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAA,k6NI4nM{_Ns:DiIVx^xF9ZM{x]V@MxkC",
                                    "type": "image"
                                },
                                {
                                    "id": 1473108,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d4426715-8ff3-4941-9d02-b78bf19a9c25/width=450/1473108.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U28gQ#~W00D%%$t8Z#IVF|Ip#ltRMyE1kW$*",
                                    "type": "image"
                                },
                                {
                                    "id": 1473094,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e1c63317-94ae-46cd-8454-497ab6cc1f10/width=450/1473094.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U38zu.J:4.t6?^tRxa9ayES5r=IUKjNGxEIU",
                                    "type": "image"
                                },
                                {
                                    "id": 1473104,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5d130286-4284-427b-b751-138577aac0d7/width=450/1473104.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBB3jCXT4ni__Nt7D%V@_3j[D%Rj.8smD*oL",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/113502"
                        },
                        {
                            "id": 112651,
                            "name": "EbonyGoldMecha（黑金）",
                            "index": 10,
                            "modelId": 76693,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Merged with EbonyGold by <strong>konyconi</strong></p>",
                            "publishedAt": "2023-07-08T03:37:51.557",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1741,
                                "ratingCount": 62,
                                "rating": 5,
                                "thumbsUpCount": 78,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 79896,
                                    "sizeKB": 147567.224609375,
                                    "name": "EbonyGoldMecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-08T03:45:11.077Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "E435C98B",
                                        "AutoV2": "E62E48C517",
                                        "SHA256": "E62E48C5178CD0A5402DF1EECC1A62584C117FA400B0E3EAE5F75C557B224855",
                                        "CRC32": "91B416D1",
                                        "BLAKE3": "46D722654CD6D75BC8D15E2946A3FE4FE0EAC6750D53F9EE2C4065849295D1C8",
                                        "AutoV3": "90803C86A292"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/112651",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1456035,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c2f9599a-3dc9-48ee-8223-e8dec6e44871/width=450/1456035.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9C~|?M{9G~p^%M|9Gt7n,IV00-:.8M|Rj?H",
                                    "type": "image"
                                },
                                {
                                    "id": 1456034,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2ff51eae-17a7-4270-8441-4b287a4d8fc0/width=450/1456034.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCC6Z3~V-oR+-o-pozxaxatQf5xa-:?H?Hxu",
                                    "type": "image"
                                },
                                {
                                    "id": 1456026,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2716c443-97d7-43ff-b850-831a8fc2b6b6/width=450/1456026.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5BpOg_N%202?a_3a~4:?b-:9F9GkXE1-oIo",
                                    "type": "image"
                                },
                                {
                                    "id": 1456027,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/00d255e2-0e56-49c5-8779-6537d1d6a542/width=450/1456027.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UADS%X-=_2IU_N-;x]M{01t74oIUxbM{MxIV",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/112651"
                        },
                        {
                            "id": 112042,
                            "name": "KhalaiMecha（圣堂）",
                            "index": 11,
                            "modelId": 76693,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p><strong>圣堂武士，亮出光刃！</strong></p><p>Merged with Chronomancy by <strong>konyconi</strong></p>",
                            "publishedAt": "2023-07-07T05:48:37.804",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1471,
                                "ratingCount": 55,
                                "rating": 5,
                                "thumbsUpCount": 66,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 79372,
                                    "sizeKB": 147567.224609375,
                                    "name": "KhalaiMecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-07T05:40:45.908Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "1CF88D98",
                                        "AutoV2": "3BE67705C7",
                                        "SHA256": "3BE67705C70653A535BFF4E5223A3FFF1111565DFAEE622F028EC6A6A72C96E6",
                                        "CRC32": "7CFC79CB",
                                        "BLAKE3": "33E052320CF4A41320F262A9478E3B5FD0B4ED25C8278F821909C4C891F8BDCA",
                                        "AutoV3": "B0ACBF9E83AC"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/112042",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1443866,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c9dbd1e8-017e-4f23-95aa-d34694924a7c/width=450/1443866.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U38|^j?F4oI]?^^*tRMyaJozs+?GiHIpjI%2",
                                    "type": "image"
                                },
                                {
                                    "id": 1443913,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c84c9c43-f4f3-4389-81af-8727de0d087e/width=450/1443913.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAB|KYRP9an$_Nt7D*s.H?tR9F%2R.IU9FtR",
                                    "type": "image"
                                },
                                {
                                    "id": 1443911,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/72b2a63c-77a6-46f5-b64c-cf8f76b91152/width=450/1443911.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U3Aw9pE,tmD*.m0L$%4o00IArWjGxWIA?a_M",
                                    "type": "image"
                                },
                                {
                                    "id": 1443912,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/34bc7ba0-2ebe-4d95-8793-0c502b1fb7ff/width=450/1443912.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U79G~:~Bo}M}~p-o%LxZIUt7-:-oIUt7%MxZ",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/112042"
                        },
                        {
                            "id": 111313,
                            "name": "ChronomancyMecha（占星）",
                            "index": 12,
                            "modelId": 76693,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Merged with Chronomancy by <strong>konyconi</strong></p>",
                            "publishedAt": "2023-07-06T05:41:23.496",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1669,
                                "ratingCount": 70,
                                "rating": 5,
                                "thumbsUpCount": 84,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 78791,
                                    "sizeKB": 147567.224609375,
                                    "name": "ChronomancyMecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-06T05:42:45.205Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "7923B43F",
                                        "AutoV2": "B66CA57EE8",
                                        "SHA256": "B66CA57EE86B679DAB7E174DB3295695B76ECD6D65377BAD6B50EEAE2E06144D",
                                        "CRC32": "FF835E6F",
                                        "BLAKE3": "E1F8F8DEDE4C73EACEFCD6937B954D5DF2AF23332A537620B1E6150ED387DDE0",
                                        "AutoV3": "19E9A923F6D8"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/111313",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1428376,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9432bd0b-cca7-48c7-b42b-a289b3b6246f/width=450/1428376.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UABzOWI;MyRj_N9ZxtMx?GM{RjMxxuD*xttR",
                                    "type": "image"
                                },
                                {
                                    "id": 1428378,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ffc8822c-ac0b-4135-958a-70f2e3955d9b/width=450/1428378.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UABpth_2H?nN_N-;MxIAD%x]9ZIUE19ZWBx]",
                                    "type": "image"
                                },
                                {
                                    "id": 1428375,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e5ba05ee-9bb2-4c9f-afb6-f686dccd8285/width=450/1428375.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9Am-rTfD*%L_NS$og%MMw%LRji_nhaeM|-;",
                                    "type": "image"
                                },
                                {
                                    "id": 1428377,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fb5de819-379d-47e4-8e71-7ca2c74576f4/width=450/1428377.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5B|Qj?vxu.S~pIVw^RP8w%18xDis+Ipxt~p",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/111313"
                        },
                        {
                            "id": 110880,
                            "name": "AngelicMecha （天使）",
                            "index": 13,
                            "modelId": 76693,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Merged with Angelic by <strong>konyconi</strong></p>",
                            "publishedAt": "2023-07-05T13:21:10.458",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1719,
                                "ratingCount": 77,
                                "rating": 5,
                                "thumbsUpCount": 87,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 78428,
                                    "sizeKB": 147567.224609375,
                                    "name": "AngelicMecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-05T13:20:27.028Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "A272A47B",
                                        "AutoV2": "0EC538C331",
                                        "SHA256": "0EC538C33195016EA4322FB95DB0D376342FAA7F6DB5D3658873038815744794",
                                        "CRC32": "E97BD600",
                                        "BLAKE3": "C0CBB712D4D05F10703B83DDE70B763FDFA40E1457DD088880656680A987CE86",
                                        "AutoV3": "D796AE3254CD"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/110880",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1418644,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3419c03c-2990-4d98-aee1-a9183448f84a/width=450/1418644.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8Dl=$.70KIo~q%M9aIU00V[D%D%_2oJMxof",
                                    "type": "image"
                                },
                                {
                                    "id": 1418643,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/06a68853-1af6-4ba6-8225-e848c94da146/width=450/1418643.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UADvN4M{00E2OFozE1M{4n-pa#jE~pD*xWtR",
                                    "type": "image"
                                },
                                {
                                    "id": 1418657,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a78e1642-35a0-43d7-8885-1008f4ec1de4/width=450/1418657.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIE.@CWB00M{~pRk9GWBM|xtM|xt-:s.M{s.",
                                    "type": "image"
                                },
                                {
                                    "id": 1418659,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/40316645-4f26-49c5-9d11-8e050b602915/width=450/1418659.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULFFset6Dixu~pRQ9Gog9GWB9aayxaxtV@WB",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/110880"
                        },
                        {
                            "id": 110735,
                            "name": "CircuitBoardMecha（遗迹）",
                            "index": 14,
                            "modelId": 76693,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Merged with CircuitBoard by <strong>konyconi</strong></p>",
                            "publishedAt": "2023-07-05T08:26:47.005",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1459,
                                "ratingCount": 27,
                                "rating": 4.96,
                                "thumbsUpCount": 36,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 78309,
                                    "sizeKB": 147567.224609375,
                                    "name": "CircuitBoardMecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-05T08:19:41.962Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "2A699E2C",
                                        "AutoV2": "50AF495D7B",
                                        "SHA256": "50AF495D7BBD3DBD28290460BAC39A278F769416EBE2A9DE710BFAAC3E4E3680",
                                        "CRC32": "8A42A76C",
                                        "BLAKE3": "757E00509129065C682CB3AD605E04E52F22F0C5268B5758C277D5EECE941D8F",
                                        "AutoV3": "826BBB6FA2FF"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/110735",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1416027,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/005f2b2c-0968-4720-868f-8bf48e9267f9/width=450/1416027.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7Ef1dt,4:9F~pNG0fM{01M{00_1_2=|4n^j",
                                    "type": "image"
                                },
                                {
                                    "id": 1416028,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/03e889fc-a1e8-4143-9e60-7b3cfd9d6cef/width=450/1416028.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJCPtz~V-p-:~V-:%M%LW=t7xtbIR+xaayNG",
                                    "type": "image"
                                },
                                {
                                    "id": 1416029,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e0dd090-babc-4f23-a8bc-63901219b23a/width=450/1416029.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U4CPqsOZ9F9a0Mx[bcV@01s,9GoK~VIWrqtQ",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/110735"
                        },
                        {
                            "id": 81465,
                            "name": "OriginMecha（起源）",
                            "index": 15,
                            "modelId": 76693,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-05-26T06:40:18.341",
                            "availability": "Public",
                            "trainedWords": [
                                "Mecha"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 8716,
                                "ratingCount": 1001,
                                "rating": 5,
                                "thumbsUpCount": 1056,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 55818,
                                    "sizeKB": 147567.396484375,
                                    "name": "Mecha.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-26T06:41:27.476Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "D0C53462",
                                        "AutoV2": "7D30B14A04",
                                        "SHA256": "7D30B14A04451C7D74F9B6287C5F6A78CCD36D71D81C855EA6154D0FBD1A60F2",
                                        "CRC32": "E2122765",
                                        "BLAKE3": "78EFDA5E11C1F38A4D10D663C5D1B3934C1D6E77A0BB9B8B764EA04439B9CC4F",
                                        "AutoV3": "7028056B9FEE"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/81465",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 915439,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/74cd198a-c52f-47db-b035-82b7ab43bb2d/width=450/915439.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULFrkqIp%gV[_4X8%MM{9ut7VtR%XSM{Rjoz",
                                    "type": "image"
                                },
                                {
                                    "id": 915446,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b4ae76c4-cb14-4be0-bd98-d4b17e42c648/width=450/915446.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKFYrwx]IV^*~qbwWXxaM|IVE1WCxu9GIBxu",
                                    "type": "image"
                                },
                                {
                                    "id": 915447,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9a5b1e86-002a-4595-8326-42197540a145/width=450/915447.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USF$bE.8Rk-p_Nt8R*aekDM{IVRP%MIVM|xt",
                                    "type": "image"
                                },
                                {
                                    "id": 915448,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a7f1da2e-2b2e-460b-8e93-c086643ce2df/width=450/915448.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UOFFvwIokBay_NNHoKodogkCWBxt%MIVoJxu",
                                    "type": "image"
                                },
                                {
                                    "id": 915449,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a82f83d-86dc-4021-ba7b-41828c4b974e/width=450/915449.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGF~Q}NGoeIp_4%L-:IUIV-;jZs.tloLs9xu",
                                    "type": "image"
                                },
                                {
                                    "id": 915450,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/45e31ac8-4b4a-42fc-860e-0da6475d8f81/width=450/915450.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UVG[[[M{ofR*_NsmoeR*NI%1RjkC-:xtM{WW",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/81465"
                        }
                    ]
                },
                {
                    "id": 15271,
                    "name": "20D黑丝",
                    "description": "<p>20D stand for 20DEN black pantyhose （20d黑丝）</p><h3>please at least read <strong><em><u>How to use</u></em></strong> part!</h3><ul><li><p>Because the Tights/pantyhose tags are not working well, so i made this lora which is aimed in creating <strong>wonderful 20 DEN Black Tights legs</strong>.</p></li><li><p>my Example Images were generated by <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/6424/chilloutmix\"><strong><em>chilloutmix</em></strong></a> and my other lora <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/14171/cutegirlmix4\"><strong><em>MIX4</em></strong></a></p></li></ul><h2><strong>How to use:</strong></h2><h3><strong><u>txtToimg:</u></strong></h3><ol><li><p>&lt;lora:20d:(0.4-0.7 recommended)&gt;, and add \"<strong>20d</strong>\" to your parameter, you <strong>dont</strong> have to add semilar words like \"pantyhose\" or \"tight\".</p></li><li><p>Set the Aspect Ratio to 1:2 can get the standing full_body image, <strong>if you set a square ratio, or set the weight of this lora above 0.7, you'll very likely receive photos of only legs and ass.</strong></p></li><li><p>recommend adding \"high_heels\" tag.</p></li></ol><h3><strong><u>imgToimg:</u></strong></h3><p>use inpaint function, and only paint the leg area. you can wear 20D pantyhose for girls.</p><p></p><p>Any other issue or your findings of this lora, pls comment. Let's made a greater lora for leg fetish!!</p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent",
                        "Sell"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 22993,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3639,
                        "thumbsDownCount": 0,
                        "commentCount": 45,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 0
                    },
                    "creator": {
                        "username": "mpmp",
                        "image": "https://avatars.githubusercontent.com/u/69283412?v=4"
                    },
                    "tags": [
                        "girl",
                        "sexy",
                        "panty and stocking",
                        "pantyhose",
                        "realistic",
                        "tights"
                    ],
                    "modelVersions": [
                        {
                            "id": 17988,
                            "name": "v1.0",
                            "index": 0,
                            "modelId": 15271,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p></p>",
                            "publishedAt": "2023-03-03T13:35:26.41",
                            "availability": "Public",
                            "trainedWords": [
                                "20d"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 22993,
                                "ratingCount": 3407,
                                "rating": 5,
                                "thumbsUpCount": 3639,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 18447,
                                    "sizeKB": 73845.0869140625,
                                    "name": "20d_new.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-12T14:36:14.114Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "1D05EA22",
                                        "AutoV2": "713ED435D7",
                                        "SHA256": "713ED435D73B702BB6A21B2DFC6BADC12FD214BD691ABFB85ECEE066DD4B6D0A",
                                        "CRC32": "5501C9F9",
                                        "BLAKE3": "17AF90C4D19B78644E3F3D91BB62A305125C484CBD404C582EDD040F9B2FE0E7",
                                        "AutoV3": "9F4A6B3E2CDD"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/17988",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 237229,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2efdc236-01e3-45b6-a6d9-9b1a614bc400/width=450/237229.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 614,
                                    "height": 1228,
                                    "hash": "UAHn:3~V0000004n9F9F?G?G_4?b00t7_N-=",
                                    "type": "image"
                                },
                                {
                                    "id": 185355,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/05353326-2840-4175-5e8d-9cbb57fcf400/width=450/185355.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1862,
                                    "height": 1350,
                                    "hash": "UaKnoAs;ae-;~qs:aeoffBRjfPNF9FWBjZa~",
                                    "type": "image"
                                },
                                {
                                    "id": 237347,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a82f129f-0ea3-4429-bc96-45006062f600/width=450/237347.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 614,
                                    "height": 1228,
                                    "hash": "UFHK%-$xD~~WbdIoE1%2?aWY^kxa4--o^+$%",
                                    "type": "image"
                                },
                                {
                                    "id": 237348,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/444d21ee-191a-4ecd-86d8-83a114e91800/width=450/237348.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 614,
                                    "height": 1228,
                                    "hash": "UBGu8m#%ws-n05_39E9F~p?vD%IT_N4oE1Io",
                                    "type": "image"
                                },
                                {
                                    "id": 237227,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4c348488-f43a-40a5-69b5-27913a9b2400/width=450/237227.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 614,
                                    "height": 1228,
                                    "hash": "ULGbYT?a4nMySz-:IoM|~Vt6RjRQ9FWAbIM{",
                                    "type": "image"
                                },
                                {
                                    "id": 237226,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/43e15456-8632-4315-78ca-c7cdb6b87a00/width=450/237226.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 614,
                                    "height": 1228,
                                    "hash": "UCH1[7ROO@^+v|oJ4.s:00?GR4WBTLV@~WM{",
                                    "type": "image"
                                },
                                {
                                    "id": 237345,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f97c3662-0e37-425d-c9d7-771af5be6d00/width=450/237345.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 614,
                                    "height": 1228,
                                    "hash": "UDIXpp00xV?apdV?4.kWo~~VD%xuITE2ozW;",
                                    "type": "image"
                                },
                                {
                                    "id": 237346,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c4bdc398-55cb-46f5-8b79-415ae5ce3100/width=450/237346.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 614,
                                    "height": 1228,
                                    "hash": "ULF$6BM{bYxtRjoIoeRj~qxaoeay%Lt7NHWB",
                                    "type": "image"
                                },
                                {
                                    "id": 237228,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3a990083-12de-4b73-23b1-3f37cf7cc100/width=450/237228.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 614,
                                    "height": 1228,
                                    "hash": "UCIh4~004n?v_3xt9FE3~B~VWCD*xtD*bcn#",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/17988"
                        }
                    ]
                },
                {
                    "id": 13910,
                    "name": "Thicker Lines Anime Style LoRA Mix",
                    "description": "<p>This LoRA tries to improve the outlines performance, most of the popular anime models (e.g. Anything V4.5, Counter Feit, AbyssOrangeMix, etc.) have some sort of pastel-like feeling and rather thin outlines.</p><p>This LoRA is trained on stylized images and then merged with several LoRA models I trained previously (most of them are already published on Civitai, you can check my homepage).</p><p>The example images are generated with Anything V4.5 + orange mix VAE, but this LoRA is capable of multiple models (also including NSFW), along with different character LoRA.</p><p>For strength, I'd say 1.0 is good enough.</p><p>I've also attached a checkpoint version, merged with Anything V4.5. It's for more sophisticated use (e.g. using another style LoRA).</p><p>中文：</p><p>本LoRA模型是为解决多数动漫风格模型过于柔和导致描线较弱的问题而训练的。基于风格化的图片训练，并与我此前训练的多个LoRA模型进行了融合而成。</p><p>示例图片为Anything V4.5 + orange mix VAE生成，但本LoRA并不限定基础模型的种类（包括NSFW类），并可兼容多数人物LoRA。</p><p>推荐强度为1.0。</p><p>附带的Checkpoint版本是和Anything V4.5融合的版本，用于一些更复杂的场景（如使用其他的画风LoRA）。</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 23,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 29798,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3634,
                        "thumbsDownCount": 0,
                        "commentCount": 13,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 200
                    },
                    "creator": {
                        "username": "CyberAIchemist",
                        "image": "https://lh3.googleusercontent.com/a/AEdFTp7wdMG_twkGoSPl9QFSRrBhaXvnEmP_l69xiJbH6g=s96-c"
                    },
                    "tags": [
                        "anime",
                        "girl",
                        "digital art",
                        "mix",
                        "style",
                        "art style",
                        "illustration",
                        "beautiful",
                        "girls"
                    ],
                    "modelVersions": [
                        {
                            "id": 16368,
                            "name": "LoRA version",
                            "index": 0,
                            "modelId": 13910,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 23,
                            "description": "<p></p>",
                            "publishedAt": "2023-02-27T21:00:47.304",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 28719,
                                "ratingCount": 40,
                                "rating": 5,
                                "thumbsUpCount": 108,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 13865,
                                    "sizeKB": 147567.2177734375,
                                    "name": "thickline_fp16.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-27T21:36:11.979Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "6A0C42FF",
                                        "AutoV2": "759D6FDF53",
                                        "SHA256": "759D6FDF539F44F6991EFD27EF1767C7779AC8884DEFC71DD909E5808B5EA74B",
                                        "CRC32": "8B03F799",
                                        "BLAKE3": "6A3A5CE228E8B401972AC836564C33B00BF104F218A0376971AC90051FC15A67",
                                        "AutoV3": "58C5F51B2B68"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/16368",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 165044,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e0a6f8b-222c-4393-38ae-440e5768c300/width=450/165044.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UMGlPGDO?b~X?d9F9Yt7Ki9Z9ZS2k;rqxZkC",
                                    "type": "image"
                                },
                                {
                                    "id": 165051,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7eecac65-1340-4423-3732-ad0448eddc00/width=450/165051.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U8KwIq8$00?c@1In=|Dk00.PEfx]0cbW~At5",
                                    "type": "image"
                                },
                                {
                                    "id": 165052,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0d827595-7999-4407-6078-f84913d49f00/width=450/165052.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 5632,
                                    "height": 2100,
                                    "hash": "UfN^C{x]R*xv_NRjj@WB?bRjj[WB.8jZayWB",
                                    "type": "image"
                                },
                                {
                                    "id": 165149,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/30282aee-3f78-425f-1f7f-cc2cd0c15e00/width=450/165149.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 5632,
                                    "height": 2100,
                                    "hash": "UjNKF#x]Wp%L~qRjoLWB?HWAayWB.7ayayWB",
                                    "type": "image"
                                },
                                {
                                    "id": 165050,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a473989e-59cc-41c4-6dfa-d9993671db00/width=450/165050.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UXH_+3_Ng3$f?vN|9b%1%NbwIpt69aNINIWV",
                                    "type": "image"
                                },
                                {
                                    "id": 165148,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f60af4f1-7fd0-417c-985a-6db909ae8500/width=450/165148.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U4EL:9?bc,=W-@^+#Rxs00020M^*00?Z0M56",
                                    "type": "image"
                                },
                                {
                                    "id": 165049,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/03f6f39a-0373-4587-cceb-3ad40372b400/width=450/165049.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U9HCD;0LVtRU*HI,00DPnj56wK$%57^Q=G?H",
                                    "type": "image"
                                },
                                {
                                    "id": 165048,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e95272ae-ad79-49d4-12e5-b058bbbfc600/width=450/165048.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UIH.Tw02$kD*}?DiX9kq?^VZH?xt?vIq%fIV",
                                    "type": "image"
                                },
                                {
                                    "id": 165047,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b8158566-a8f6-4902-bf4d-006eb7882300/width=450/165047.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UWIqv3xv0JRjofaxxsog4.t6%0WA~VocRjof",
                                    "type": "image"
                                },
                                {
                                    "id": 165046,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/61c832f5-5f2a-45a3-1a73-8d2a6b7c6400/width=450/165046.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UAH-[]NC009a_K?0ECM~00NEJBITA0=|%D9Y",
                                    "type": "image"
                                },
                                {
                                    "id": 165336,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2dd23fa8-edcf-444d-c695-87b17ec1d300/width=450/165336.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U7Hewr4n%~4m^,019sob0000004T4-nQ~WRh",
                                    "type": "image"
                                },
                                {
                                    "id": 165335,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c4ce4ec4-4738-485d-1201-474d5105ae00/width=450/165335.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UJKdSu~V56o49[%2%gof0L%LNJM{024.RQ-p",
                                    "type": "image"
                                },
                                {
                                    "id": 165045,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3f77b60c-217c-46df-45e6-9489f9a0da00/width=450/165045.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UEKdSpM|00E200IUIpkW00%L^k?H~W0LNI%L",
                                    "type": "image"
                                },
                                {
                                    "id": 165113,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3864157d-138b-482e-cfd5-11fe1bb47f00/width=450/165113.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U4KmeSk?00OZ8x?GKz0K00bb?[D%00In00sk",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/16368"
                        },
                        {
                            "id": 16379,
                            "name": "Checkpoint Version",
                            "index": 1,
                            "modelId": 13910,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Base model: Anything V4.5</p><p>Recommend VAE: orangemix or kl-f8-anime2</p>",
                            "publishedAt": "2023-02-27T21:42:18.622",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1079,
                                "ratingCount": 3020,
                                "rating": 5,
                                "thumbsUpCount": 3551,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 13867,
                                    "sizeKB": 2082642.022460938,
                                    "name": "thicklinemix.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-27T21:53:16.041Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "8ECD9616",
                                        "AutoV2": "DC21BF1781",
                                        "SHA256": "DC21BF17812B83C0E1353EB30EFD23570D06C06B9FDAC254C7481ED0BC1AE812",
                                        "CRC32": "3877B170",
                                        "BLAKE3": "1062BB9BA6DE1EDC358336DD82C745F788806612E4C92AEBB5FDC890426EC16B",
                                        "AutoV3": "C0C12149CB22"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/16379",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 165179,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/530884be-d593-463b-4353-bb34700b0600/width=450/165179.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 970,
                                    "hash": "UhK-a^t7kYof?vR*f5WB~pn~jYae_3ofaxt6",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/16379"
                        }
                    ]
                },
                {
                    "id": 78605,
                    "name": "Ink scenery | 水墨山水",
                    "description": "<p>先使用咒语“white background, scenery, ink, mountains, water, trees. Modify”。出了效果之后再更改、添加。</p><p>Start with white background, scenery, ink, mountains, water, trees. Modify after you successfully get the effect.</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent",
                        "Sell"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 31933,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3599,
                        "thumbsDownCount": 2,
                        "commentCount": 16,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 229
                    },
                    "creator": {
                        "username": "silvermoong",
                        "image": "https://lh3.googleusercontent.com/a/AEdFTp6hjv-geDSynTd9QNXn-WGlxnkzBUMLoQRYjBNc=s96-c"
                    },
                    "tags": [
                        "water",
                        "ink",
                        "scenery",
                        "background",
                        "tree",
                        "mountain"
                    ],
                    "modelVersions": [
                        {
                            "id": 83390,
                            "name": "v1.0",
                            "index": 0,
                            "modelId": 78605,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-05-28T06:28:50.938",
                            "availability": "Public",
                            "trainedWords": [
                                "white background, scenery, ink, mountains, water, trees"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 31933,
                                "ratingCount": 2574,
                                "rating": 5,
                                "thumbsUpCount": 3599,
                                "thumbsDownCount": 2
                            },
                            "files": [
                                {
                                    "id": 57029,
                                    "sizeKB": 147571.7880859375,
                                    "name": "Ink scenery.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-28T06:26:32.604Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "FFEE28FB",
                                        "AutoV2": "9581B6265F",
                                        "SHA256": "9581B6265F384B64D13FD8805665614ABE9B9C0EC6488838FDFAD7E4C05F4122",
                                        "CRC32": "FD108A37",
                                        "BLAKE3": "56C1E1D34B4B988A35112D4FA9F70504AAED0181DECDBE63DB12714A10DED37D",
                                        "AutoV3": "26343A3A36A0"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/83390",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 940385,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d875eaca-d51d-4f74-9e4c-a942ee10cc69/width=450/940385.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UXK^]Et7%goL-;WBs:t6~pjZWBofIpofxYNH",
                                    "type": "image"
                                },
                                {
                                    "id": 940390,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/37e00a1e-7cde-4dc6-a665-301b5c91a987/width=450/940390.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNIhQlkC02s:~VRkRjxt?Gxa9uM|4pkCWVV[",
                                    "type": "image"
                                },
                                {
                                    "id": 940382,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f224a114-966d-47eb-9999-b3960b688528/width=450/940382.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UULW|extWCofxuM|M{xu~WWBt6ofV@WC%Lof",
                                    "type": "image"
                                },
                                {
                                    "id": 940381,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a93daf34-aee2-453a-8170-2bccebd50669/width=450/940381.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UyM%[%fkxut7t7ofayRj~qoLR*ofxuWBWBof",
                                    "type": "image"
                                },
                                {
                                    "id": 940383,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/94591c1c-b2c1-442b-916f-788580084638/width=450/940383.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UuLXJJWBt7xtxuoLj[R*~pofj[j[oLj@WBkC",
                                    "type": "image"
                                },
                                {
                                    "id": 940384,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/22c1b231-809a-4945-a965-c8f30effdea5/width=450/940384.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAG+Hr9H00-:D+IV~V?Znjt64:NH00-p-pD*",
                                    "type": "image"
                                },
                                {
                                    "id": 940387,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/14239303-dd05-407a-a083-8138d67fc619/width=450/940387.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTK1dbM|%L%2-:oft6WV~VxtoyRkD*s:%2Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 940388,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/94230793-cb98-4b13-b73e-d69f7ce3da0c/width=450/940388.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UqLNi8t7t7az%Mj[j@of~WoeR*kBRjWVWBWB",
                                    "type": "image"
                                },
                                {
                                    "id": 940391,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a6165204-360a-4c92-8174-c13302e1116c/width=450/940391.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UZI=3?oyIUay~pM{xuof%MRjWCWCnhayRjNG",
                                    "type": "image"
                                },
                                {
                                    "id": 940389,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/77e43107-093a-4cc2-a604-141f1d10aaaa/width=450/940389.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UTKK+i9Z^+ayE1IU?bs:~pRj%Mof01%Lxuaf",
                                    "type": "image"
                                },
                                {
                                    "id": 940392,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0e77ced1-cc2d-4d33-b54e-b2cc4a161f75/width=450/940392.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UaK-I3xuIoV[?aRjayt7~ps:RkR*IUj[j[Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 940397,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a7d43e0-f2e7-4c82-aecc-dc77338900a3/width=450/940397.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UPJR8FIp~C-:%2R*%Ls:~Vt6oyNG9axZoeWV",
                                    "type": "image"
                                },
                                {
                                    "id": 940422,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/14cee7b8-acbd-452c-bb5b-e517786e3b52/width=450/940422.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UcJkDYRkIp%L^*aybHoL~Vt6IpRjNGayWBj[",
                                    "type": "image"
                                },
                                {
                                    "id": 940423,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/822e9024-c21c-404b-bc29-c3cdda1905df/width=450/940423.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UDIEd^0$00=__2RkM{t6~pxC57I;9axZ-:R,",
                                    "type": "image"
                                },
                                {
                                    "id": 940426,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f2be451-3102-4e20-9b0c-e6d5ee2f9f36/width=450/940426.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UTKK+i9Z^+ayE1IU?bs:~pRj%Mof01%Lxuaf",
                                    "type": "image"
                                },
                                {
                                    "id": 940410,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8f84e190-0499-4ce5-94ff-f6dea09cce3b/width=450/940410.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2048,
                                    "height": 1024,
                                    "hash": "UHJa.YD%00~W_2E2xtIU?a9GIVoL~VNG?H-:",
                                    "type": "image"
                                },
                                {
                                    "id": 940400,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5d03c84e-2fd7-43be-a54d-78dca3bd411a/width=450/940400.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2048,
                                    "height": 1024,
                                    "hash": "UrKwtQj[IVWB%LoLt7j[~Vj[ofWCs:WCRjs:",
                                    "type": "image"
                                },
                                {
                                    "id": 940421,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7884bc73-5930-4dd5-979a-c41a5c380825/width=450/940421.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UmKU4Sj[s.j@%LNGxt%2~VWBt7xaM{j[WBay",
                                    "type": "image"
                                },
                                {
                                    "id": 940414,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2f7c80db-395e-40b2-abdd-bcdc8faeb2e1/width=450/940414.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2048,
                                    "height": 1024,
                                    "hash": "ULIr4,-:wc9GMxM|D*t7~pV[s:ofIURjIot7",
                                    "type": "image"
                                },
                                {
                                    "id": 941598,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/90363d2f-646d-4dbd-9d10-ff6ae307bc62/width=450/941598.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UoM7Mpofxtt7%LWCR*s:~Wt6WVWBsma}WWWC",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/83390"
                        }
                    ]
                },
                {
                    "id": 21458,
                    "name": "Anime Kisses",
                    "description": "<p>I see a lot of people creating kiss pictures and getting very few decent results, dealing with a lot of randomness, with people that seem to bump into each other more than kissing. The purpose of this LoRA is provide help to create such pictures in a better and more stable way.</p><p>Seems to work better at lower CFG scales.</p><p>Pictures are done with EasyNegative, kl-f8-anime2 VAE and various models.</p><p>NOTE: see the <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/23455/anime-kisses-locon-version\">LoCon version</a> for the update.</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent",
                        "Sell"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 23,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 25603,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3596,
                        "thumbsDownCount": 0,
                        "commentCount": 3,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 0
                    },
                    "creator": {
                        "username": "JollyIm",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/25c709d4-d8f7-4e57-90cd-209dd6121c00/width=96/JollyIm.jpeg"
                    },
                    "tags": [
                        "anime",
                        "concept",
                        "love",
                        "yaoi",
                        "multi-character",
                        "kiss",
                        "yuri"
                    ],
                    "modelVersions": [
                        {
                            "id": 25591,
                            "name": "v1",
                            "index": 0,
                            "modelId": 21458,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 23,
                            "description": null,
                            "publishedAt": "2023-03-19T11:11:35.854",
                            "availability": "Public",
                            "trainedWords": [
                                "kiss",
                                "tongue kiss",
                                "kissing"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 25603,
                                "ratingCount": 3539,
                                "rating": 5,
                                "thumbsUpCount": 3596,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 21245,
                                    "sizeKB": 9327.9873046875,
                                    "name": "AnimeKiss.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-19T11:16:32.264Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "C5015469",
                                        "AutoV2": "B2C28B6AAD",
                                        "SHA256": "B2C28B6AADE2615A2FAECD401089AECB91A09C29266269D53AA3DEDF7EFFD67E",
                                        "CRC32": "4CD9342D",
                                        "BLAKE3": "1DC85314CCBE9672569C87F5837987F6DE4937CCAB97DAAF715B2F0195712483",
                                        "AutoV3": "494310EE0291"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/25591",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1662237,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f1498f82-b2e6-46d2-9e2e-1899fb473a83/width=450/1662237.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 985,
                                    "height": 1200,
                                    "hash": "URJQNFSz4.wJIpODoL%2%1t7e.xa_Nn%wING",
                                    "type": "video"
                                },
                                {
                                    "id": 291039,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0a2ab922-decf-47ee-c597-146e9f075800/width=450/291039.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1392,
                                    "height": 1400,
                                    "hash": "UKI;L=wbI:-:_24:-p^*0fxF~BX8aKxaIpEL",
                                    "type": "image"
                                },
                                {
                                    "id": 281173,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eef36302-5e39-42ce-3590-9839742ad900/width=450/281173.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1248,
                                    "hash": "UXI}YK-q.Tx]_NRj%Nof?HIoIobbXSxuxaad",
                                    "type": "image"
                                },
                                {
                                    "id": 281172,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/29c415db-cffc-4eae-73be-5e9bd05ade00/width=450/281172.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1376,
                                    "hash": "UKIN?o?cNFrr%gkWE2IUV=%g%2Vs_4%N$%nO",
                                    "type": "image"
                                },
                                {
                                    "id": 281171,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/26709708-d0d9-4db6-f3eb-430a847d8300/width=450/281171.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UZH-44~BNFR+ELoyozWBJCI:xYxbM|IpWDs:",
                                    "type": "image"
                                },
                                {
                                    "id": 281170,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bcbade0b-6f3c-4171-c3a6-41b29ef81700/width=450/281170.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1248,
                                    "hash": "UDKd#x_401.80N9u9~My00xt_3M{_3%gHqr;",
                                    "type": "image"
                                },
                                {
                                    "id": 281169,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7b3fa307-2458-42e7-7ba5-f1a1e5cea600/width=450/281169.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UaMPF0_40#E2BW%MS2jrTeT0$%M{tRxZa0aK",
                                    "type": "image"
                                },
                                {
                                    "id": 281168,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c9b75a16-761f-4c6b-749a-3e548be7c200/width=450/281168.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1248,
                                    "hash": "UcL{}C~V.To|.Sbb%MM{t+Nd-oM{yDx[aeRQ",
                                    "type": "image"
                                },
                                {
                                    "id": 281167,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6479bb83-0041-428b-e035-99ffac58ea00/width=450/281167.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1368,
                                    "height": 1360,
                                    "hash": "UXN98.}?pbEL0f-osAR*%L9a%2afbbD*V]Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 281166,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7a365096-5c71-4e33-01e1-07f1654ff900/width=450/281166.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1312,
                                    "hash": "UXI#Db?HIUo#?wNGIoNH%hNGs8of~qt7Mxs:",
                                    "type": "image"
                                },
                                {
                                    "id": 281175,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2ff6c8c4-521b-4887-0240-ad05fd96e400/width=450/281175.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1248,
                                    "hash": "UWIhNyo#?b-:~qIVx]bckVt8x]s+xaofn$Io",
                                    "type": "image"
                                },
                                {
                                    "id": 281165,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2fb02b0a-b1e1-4ad4-f67f-0b626265f200/width=450/281165.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1248,
                                    "hash": "ULH1SsH?56o}?ur=R%kWtRs.xZR+_NE1MxRl",
                                    "type": "image"
                                },
                                {
                                    "id": 281164,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2293bd9e-f628-420d-f1e1-61ae47c5db00/width=450/281164.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 968,
                                    "height": 1264,
                                    "hash": "UKLCt_?H6i%1.lJBNHOE0$s,RPoz.8n$nOkW",
                                    "type": "image"
                                },
                                {
                                    "id": 281163,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d96a4ce5-88be-46db-6388-ca4a66b9d400/width=450/281163.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1248,
                                    "hash": "UGJa1S_N0L-T~qxuD*IUX.%MRPoLpdoLrWIp",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/25591"
                        }
                    ]
                },
                {
                    "id": 15699,
                    "name": "Keqing | Genshin Impact | 3in1 LoRA & LoCon",
                    "description": "<h2>A LoRA Model of Keqing from Genshin Impact<strong>.</strong></h2><p></p><p><strong>This LoRA includes <em>three </em>official costumes.</strong></p><p><strong>There are <em>three </em>sets of trigger words:</strong></p><p></p><p>For triggering <strong>Piercing Thunderbolt(<em>Default Costumes</em>):</strong></p><p><code>keqing (piercing thunderbolt) (genshin impact), keqing (genshin impact), pantyhose, hair bun, purple hair, gloves, twintails, long hair, purple eyes, diamond-shaped pupils, bare shoulders, hair ornament, black pantyhose, cone hair bun, detached sleeves,dress, jewelry, medium breasts, earrings, bangs, frills, purple dress, black gloves, braid, skirt,</code></p><p></p><p>For triggering <strong>Opulent Splendor</strong>:</p><p><code>keqing (opulent splendor) (genshin impact), keqing (genshin impact), official alternate costume, dress, cone hair bun, night, strapless dress, looking at viewer, long hair, cleavage, black dress, hair bun, strapless, bare shoulders, purple hair, bangs, bow, detached collar, purple eyes, diamond-shaped pupils, ribbon, double bun, twintails, two-tone dress, medium breasts, hair ornament, black bow, hair ribbon, blue dress, bowtie, hair between eyes,</code></p><p></p><p>For triggering <strong>Lantern Rite:</strong></p><p><code>keqing (lantern rite) (genshin impact), keqing (genshin impact), hair bun, skirt, scarf, purple sweater, white skirt, purple hair, sweater, twintails, purple eyes, diamond-shaped pupils, hair ornament, bare shoulders, smile, breasts, cone hair bun, long hair, belt, double bun, long sleeves, bangs, bow, hair flower, hair bow,ribbon, hair ribbon, braid, plaid scarf, plaid, off shoulder</code></p><p></p><p><em>bonus</em>: For trigger <em>Any </em><strong>Custom Outfit:</strong></p><p><code>keqing (genshin impact), hair bun, purple hair, twintails, purple eyes, diamond-shaped pupils, hair ornament, cone hair bun, long hair, double bun, bangs, bow, hair flower, hair bow, hair ribbon, [Explain in detail what clouthes you would like to trigger......]</code></p><p></p><p>Recommend <strong>0.85-1</strong> Strength for triggering any official costume.</p><p>For changing custom clothes, I suggest <strong>0.7-0.85 </strong>Weight</p><p></p><p>The preview images were generated by the AbyssOrangeMix series Model.</p><p>In some instances applied ControlNet.</p><p></p><p>I am using the NAI model [e6e8e1fc] to train.</p><p>Able to work with all <strong>mixed </strong>models based on NAI(i.e. AbyssOrangeMix, Anything v3)</p><p></p><p>If you like this LORA, please comment and give it a like.❤️</p><p>Any suggestions are welcome to comment here.</p><p>And also welcome to share your creations.</p><p>Enjoy it!</p><p></p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": false,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 3,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 25632,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3545,
                        "thumbsDownCount": 1,
                        "commentCount": 3,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 115
                    },
                    "creator": {
                        "username": "myive",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/32579d15-4328-4429-ca41-0f3b25d49100/width=96/myive.jpeg"
                    },
                    "tags": [
                        "anime",
                        "character",
                        "girl",
                        "genshin impact",
                        "keqing",
                        "video game",
                        "locon"
                    ],
                    "modelVersions": [
                        {
                            "id": 18521,
                            "name": "v1.0",
                            "index": 0,
                            "modelId": 15699,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>initial commit</p>",
                            "publishedAt": "2023-03-04T15:53:50.598",
                            "availability": "Public",
                            "trainedWords": [
                                "keqing (genshin impact)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 24713,
                                "ratingCount": 65,
                                "rating": 4.95,
                                "thumbsUpCount": 103,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 15511,
                                    "sizeKB": 147580.5419921875,
                                    "name": "keqing_lion_optimizer_dim64_loraModel_5e-3noise_token1_4-3-2023.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-04T15:56:22.455Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "6A4F40E2",
                                        "AutoV2": "EB31251D67",
                                        "SHA256": "EB31251D674CC2CA087A43ED1FEEF444EA3715107A6FF000FB8075E5A057A2A8",
                                        "CRC32": "10891C89",
                                        "BLAKE3": "27B94485FB6CAF80BBAF6FBFA8501C9DC8A2900A7B0D45B78A3C4160E838FED1",
                                        "AutoV3": "62893A579DB7"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/18521",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 191572,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a6a8cca6-5672-466e-ea5a-5fc7ce16c400/width=450/191572.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIGRxW~W019ZE1NG9YNH0KIV?Ht7xst6s;ae",
                                    "type": "image"
                                },
                                {
                                    "id": 191719,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5f46044d-9a0a-4f44-54b9-57dc9bb7db00/width=450/191719.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "URJ[0O?atMM{~WofkqR%M|RjRiV@Iojsxtog",
                                    "type": "image"
                                },
                                {
                                    "id": 191716,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b86f29f3-ded8-4f7c-8093-d6fda1cd3b00/width=450/191716.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBIEO*~X0001wHE2NE9Z%hM}01NH4oae?aR+",
                                    "type": "image"
                                },
                                {
                                    "id": 191718,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5b5b2816-7598-49b0-cf1f-3b4aab641100/width=450/191718.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBF=p^_200MxI9%10KIU0Ks-~U-p-nt6%M?G",
                                    "type": "image"
                                },
                                {
                                    "id": 191720,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c7b18d69-e788-456b-cc36-c283fabd1300/width=450/191720.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UdL4mR?bxuae~qt8t8M|-;xat7RjR.RkoJR*",
                                    "type": "image"
                                },
                                {
                                    "id": 191717,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b9686d74-f2f7-4872-b501-692856cd5300/width=450/191717.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCF5y~ER0J4n4mD+?FIp4,4;~W-q$~E2kBV[",
                                    "type": "image"
                                },
                                {
                                    "id": 191762,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7157ef9c-712d-4baa-24c3-a7bc2df37700/width=450/191762.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTL4HL_2%IRk~Wxt%Log%NxtD%WBD*Rjxu%L",
                                    "type": "image"
                                },
                                {
                                    "id": 191738,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/66db1be3-0e76-47f6-795b-643444f27f00/width=450/191738.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6HLG300Rw?EMdo#00E4miM|D$xu0OngE2~p",
                                    "type": "image"
                                },
                                {
                                    "id": 191739,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c79cc1a1-1839-46f8-a0bd-af4d970f2400/width=450/191739.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UdK1n3-:.7oL~Wt6xuRjxaxtt7R*bbRjs:WA",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/18521"
                        },
                        {
                            "id": 18531,
                            "name": "V1.0_LoCon",
                            "index": 1,
                            "modelId": 15699,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>The experimental <strong>LoCon</strong> model may provide better detail than <strong>LoRA.</strong></p><p><strong>Warning: </strong>This is not a <strong>LoRA </strong>model; this is a <strong>LoCon</strong> model.</p><p>It will <strong>not work</strong> without the following extensions:</p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/KohakuBlueleaf/a1111-sd-webui-locon\">GitHub - KohakuBlueleaf/a1111-sd-webui-locon: A extension for loading locon model in sd-webui</a></p>",
                            "publishedAt": "2023-03-04T16:16:29.801",
                            "availability": "Public",
                            "trainedWords": [
                                "keqing (genshin impact)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 919,
                                "ratingCount": 3097,
                                "rating": 5,
                                "thumbsUpCount": 3470,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 15522,
                                    "sizeKB": 304332.9541015625,
                                    "name": "keqing_lion_optimizer_dim64_loconModel_5e-3noise_token1_4-3-2023.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-04T16:21:44.858Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "7EAF1701",
                                        "AutoV2": "8BD53FD523",
                                        "SHA256": "8BD53FD52361CEA68338D3EF3A4CCAE8C0CC3D3F8953B63185974EB1A8A15847",
                                        "CRC32": "B2E1E76F",
                                        "BLAKE3": "3472ED1B1ED31753F68FDD766DD78BDF65642F86DC8981BDF657A7E0F903ED18",
                                        "AutoV3": "FABF25C1589C"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/18531",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 191715,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/32408bd9-256a-40d5-2b1a-6ddb85d6a200/width=450/191715.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJGkzi~p0KD%9aM|9FIo0KM{?G%Mk8xtxuRj",
                                    "type": "image"
                                },
                                {
                                    "id": 191711,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7e01f85e-7eac-47b0-89e9-8df03c1fe400/width=450/191711.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTJ*M0~W-ntR^*t7%MkDV?xaWCtQ9aa#t7f,",
                                    "type": "image"
                                },
                                {
                                    "id": 191712,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0e2d985d-23fd-46af-245d-2441ccd49f00/width=450/191712.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "URKwkF~pV=-;%MogWBM|?btRM{IVIpIot7-:",
                                    "type": "image"
                                },
                                {
                                    "id": 191714,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/12f92673-5662-44da-7e99-52a51fe1e400/width=450/191714.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDHeF201ND-;-O4;4.xtD$Ip~VNG$wIqxvaf",
                                    "type": "image"
                                },
                                {
                                    "id": 191710,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4395619d-1a46-4e8c-3158-f697659a9200/width=450/191710.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5H-+200?5Q,}j0M9X0e4TtR0ek800.7^ixa",
                                    "type": "image"
                                },
                                {
                                    "id": 191713,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04dbcdab-7144-441e-f05b-8b89f1766600/width=450/191713.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USHUd_~VRhM_IUjEWBR*W=ozIVM{4.IU%M%2",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/18531"
                        }
                    ]
                },
                {
                    "id": 16335,
                    "name": "Beautifuleyeslikeness_水汪汪的大眼睛2.5D",
                    "description": "<p>汉服国风人脸2.5D</p><p>第一二版权重给高了确实会影响头饰</p><p>只有上半身</p><p>主要个人喜欢这个脸</p><p>第一版权重建议0.6，高了容易出来两个人</p><p>第三版只有人脸</p><p>Hanfu Guofeng Face 2.5D</p><p>If the weight of the first and second editions is too high, it will affect the headwear</p><p>Only the upper body</p><p>The main person likes this face</p><p>The weight recommendation in the first version is 0.6, which is too high for two people</p><p>The third edition only has faces</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent",
                        "Sell"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 25349,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3519,
                        "thumbsDownCount": 0,
                        "commentCount": 17,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 0
                    },
                    "creator": {
                        "username": "705516186562",
                        "image": null
                    },
                    "tags": [
                        "anime",
                        "girl",
                        "female",
                        "beautiful",
                        "girls"
                    ],
                    "modelVersions": [
                        {
                            "id": 20817,
                            "name": "half body",
                            "index": 0,
                            "modelId": 16335,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": "<p>上半身加衣服</p>",
                            "publishedAt": "2023-03-09T18:10:26.294",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 19096,
                                "ratingCount": 2900,
                                "rating": 5,
                                "thumbsUpCount": 3114,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 17351,
                                    "sizeKB": 36977.609375,
                                    "name": "yuantu.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-09T18:15:59.236Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "804AF85D",
                                        "AutoV2": "84211E4B40",
                                        "SHA256": "84211E4B4045B4D9E80B679CA7D9C408879A523FAE5E26D1E92A41C9AEED2732",
                                        "CRC32": "A176712A",
                                        "BLAKE3": "6F40F1C30D9AE0412FCE31B77D5983F4B3BFC24A23B12EEF276DA01854934697",
                                        "AutoV3": "AE6140ECD5E4"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/20817",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 220496,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/732b0aa7-2000-4b30-84d9-8c98d84b8300/width=450/220496.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 1024,
                                    "hash": "UFJZ**?G00~VEOt6^%xu00%2?HoJ56-o%Mj[",
                                    "type": "image"
                                },
                                {
                                    "id": 220495,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5aeae873-0f44-4106-710a-8a0a907f2c00/width=450/220495.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 1024,
                                    "hash": "UFJ7UX~W00-;#+$%-oI;00-V-pMxIAs.x[%M",
                                    "type": "image"
                                },
                                {
                                    "id": 220494,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4717c85b-d405-49db-0205-63a18cff1c00/width=450/220494.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U5F}=;kr56~BrBROtSt7M{IU%2Rk5Q?bngMy",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/20817"
                        },
                        {
                            "id": 19483,
                            "name": "purefacelikeness",
                            "index": 1,
                            "modelId": 16335,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": "<p>只训练的脸部</p><p>Only trained face</p>",
                            "publishedAt": "2023-03-06T16:33:42.363",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3494,
                                "ratingCount": 220,
                                "rating": 5,
                                "thumbsUpCount": 223,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16260,
                                    "sizeKB": 36976.3056640625,
                                    "name": "lianbu1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-06T16:35:55.921Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "66F0F22B",
                                        "AutoV2": "AE09C523D9",
                                        "SHA256": "AE09C523D9BC868B7D14143E64E18A320216A727D77BD860A570D54DE96BCD52",
                                        "CRC32": "FA8DEF00",
                                        "BLAKE3": "8732603ED41A2A69BA9B96FD30EDB762FF36C8EC7A3F5768493EB4F69BF8EDCB",
                                        "AutoV3": "3E39EC1735CC"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/19483",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 204822,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f9fa2de-e4f9-4fc4-8534-074a5d267200/width=450/204822.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 1024,
                                    "hash": "UNK,mm~C00M|bHbHsAsm00RjNGIoWAoLSga}",
                                    "type": "image"
                                },
                                {
                                    "id": 204532,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0fcc4e65-0c5d-4da1-a7f9-573c7d258500/width=450/204532.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 576,
                                    "height": 1024,
                                    "hash": "UFD]6+Nx0K~Wib9aOE%2t7WXV@WAtR$*niNG",
                                    "type": "image"
                                },
                                {
                                    "id": 204530,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7b3ff7e7-9a25-45b1-ef21-6afc61f93700/width=450/204530.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 576,
                                    "height": 1024,
                                    "hash": "U8G[KMxwx@~WD4?H5QER0#s.01$~_3R*xwbw",
                                    "type": "image"
                                },
                                {
                                    "id": 204529,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4b07c264-3e24-459c-70de-9f25c4768400/width=450/204529.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 576,
                                    "height": 1024,
                                    "hash": "U9FrCq0000={0J9Z~WVs00-pkBV@~qRlIBxu",
                                    "type": "image"
                                },
                                {
                                    "id": 204821,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/05720b38-c287-4d01-0072-5c73e2b3c500/width=450/204821.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 1024,
                                    "hash": "UBK0vwoi00xt4pE1~V-p0dNaV]RQ00WBEzbu",
                                    "type": "image"
                                },
                                {
                                    "id": 204527,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5874c206-de2d-412c-ae9d-3a3db308ce00/width=450/204527.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 1024,
                                    "hash": "UOFE+Z~Boyt7IUIo56IoNGR*%2bHW-%2%2Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 204820,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2327296f-4365-4d8a-e031-5c632ba83000/width=450/204820.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 1024,
                                    "hash": "UDLWIy9H00~WIpNG-ps:00IoEL%Loz-VS#$*",
                                    "type": "image"
                                },
                                {
                                    "id": 204819,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/99ea8a87-7b71-4cef-6c3d-7d70009b4b00/width=450/204819.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 576,
                                    "height": 1024,
                                    "hash": "UIJ7RM}[0KIVnhX8IU=|0KM_-;ELROxufhE1",
                                    "type": "image"
                                },
                                {
                                    "id": 343758,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a3e921be-a7b8-48f8-6ae1-d2d732230400/width=450/343758.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1280,
                                    "height": 960,
                                    "hash": "U3Hx8303^*0000_2_3~V_2bw-p4:00-oM|ad",
                                    "type": "image"
                                },
                                {
                                    "id": 343757,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ba46a3b2-a360-4cdf-dcd8-7ae77144ae00/width=450/343757.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UMJR2A?aEJ^,%e-;xtD*~q_3?bM{IqbJM}j[",
                                    "type": "image"
                                },
                                {
                                    "id": 343756,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b2c150f8-422d-4f96-c076-62287c335700/width=450/343756.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U7Iqv50M?]0LYQD$Iq?IAv9F-pEN.8%3%M9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 343755,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/398a894e-0f83-4450-d78b-cebb6e527f00/width=450/343755.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCHxW:5900={00IT0e_30fNb~W9Fx^t6Mw%g",
                                    "type": "image"
                                },
                                {
                                    "id": 343754,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/51a11a27-f4fe-483f-33dd-e0a95f0e1f00/width=450/343754.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "UCIEqf~U0JNX00t8%2x[D+9Z%4IVE2WFIBai",
                                    "type": "image"
                                },
                                {
                                    "id": 343753,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7c2325bb-6e5d-4914-711d-54058b5a3200/width=450/343753.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "U6He2*4:00TJ00-VJBEM?v01~W?a00M{t3s;",
                                    "type": "image"
                                },
                                {
                                    "id": 343752,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/38c42d93-9e87-4e93-7f4c-2c7c14efa100/width=450/343752.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UBIg}+sk00S_Exxt~qot.64mn$xu00NbIU9F",
                                    "type": "image"
                                },
                                {
                                    "id": 343751,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6cb57e87-040b-45e3-e9c5-d31716af2b00/width=450/343751.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1280,
                                    "height": 1280,
                                    "hash": "U7IXv~009XSAu3^,Dj4nl800~VIU0#RN%L-;",
                                    "type": "image"
                                },
                                {
                                    "id": 343750,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/50628387-fac4-4c3e-3348-cbf8e7f2f100/width=450/343750.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U8J*9v00o[E3AssjMyD%1P4.IVx]58WU~V%M",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/19483"
                        },
                        {
                            "id": 19285,
                            "name": "hanfuguofengkeaimeiziV2",
                            "index": 2,
                            "modelId": 16335,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>V1</p>",
                            "publishedAt": "2023-03-06T07:17:12.492",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1855,
                                "ratingCount": 101,
                                "rating": 4.99,
                                "thumbsUpCount": 103,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16122,
                                    "sizeKB": 36978.86328125,
                                    "name": "kawayiV2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-06T07:21:05.832Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "BD0ED3E6",
                                        "AutoV2": "072EDFFD76",
                                        "SHA256": "072EDFFD76B4FD1621E9601430A327DE72B426CD5A86AF7C9D1E743BA628DB37",
                                        "CRC32": "EE4A17D1",
                                        "BLAKE3": "5B374B9EF65A548D6E9565EB31D74A2951A8A8ADD47AD2BF86815153C6941EDD",
                                        "AutoV3": "1D82C691CEEF"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/19285",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 202106,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/87be4218-82bd-4288-dccc-245f24ecee00/width=450/202106.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UDGRST~U000f9tof^*jX01s.^,%2i_M{bwxu",
                                    "type": "image"
                                },
                                {
                                    "id": 202105,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/975c12e2-33ae-45c9-073f-79f413d22100/width=450/202105.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UJE_?i~V004:RjoJ%2xZ9tkC=}ofRPWBX9WV",
                                    "type": "image"
                                },
                                {
                                    "id": 202104,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2ffb4630-4904-417b-7d6b-dfee70617b00/width=450/202104.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "ULEoMm0L0d~W%KIUxa%LEKV@$%WARPt7X9V[",
                                    "type": "image"
                                },
                                {
                                    "id": 202103,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3094ba0a-be1f-44e0-6139-f31450c0e700/width=450/202103.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UDDb$u9b00-oIUs:smjE0Kjs~Dofr]j?Io%L",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/19285"
                        },
                        {
                            "id": 19286,
                            "name": "hanfuguofengkeaimeiziV1",
                            "index": 3,
                            "modelId": 16335,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>V2</p>",
                            "publishedAt": "2023-03-06T07:17:12.492",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 904,
                                "ratingCount": 89,
                                "rating": 5,
                                "thumbsUpCount": 89,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16123,
                                    "sizeKB": 36979.0087890625,
                                    "name": "kawayi.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-06T07:21:06.014Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "0A6FA57A",
                                        "AutoV2": "DB1BFF044A",
                                        "SHA256": "DB1BFF044A416AA8A24BE11DF1E7793152C0AE761421339F2453C639C970B122",
                                        "CRC32": "EFBAE84B",
                                        "BLAKE3": "438AD0937B390719382A7622D2C2523E93E26A9D490F34ABB166F2BBD6C4DF17",
                                        "AutoV3": "72F15979524D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/19286",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 202110,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/495779d2-f106-4922-14aa-617f2001da00/width=450/202110.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U9GuRSxa_2?G00xu0KRj0fE1~qtlDP^jwHIU",
                                    "type": "image"
                                },
                                {
                                    "id": 202109,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f46fd9fd-12f6-4b44-f9e4-453a088c9800/width=450/202109.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UDGH}DxA00xv00%N?GD%F2WA~CNG00NLtRt7",
                                    "type": "image"
                                },
                                {
                                    "id": 202108,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bfaf4f5a-8946-4e3f-6f00-6bde3dd79200/width=450/202108.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U7EVB5^*000g00o#~B0L5l%0^l?G00E1tk-;",
                                    "type": "image"
                                },
                                {
                                    "id": 202107,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/18b2e3dc-1f97-4665-4c7b-c40db7702600/width=450/202107.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UBF}$d4.00^,IU-p^k0K00xF~CxtIAo#Na$*",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/19286"
                        }
                    ]
                },
                {
                    "id": 21388,
                    "name": "Incoming hug/kiss",
                    "description": "<p>v1.1 View from above has been added [request : ash0080618]<br />v1.2 Added incoming kiss [request : monkeyman007]</p><ul><li><p>make an image related to the hand still distorted, use Nagative : EasyNegative, bad-hands-5</p></li><li><p>Due to increasing Alpha = 16, this LoRA is greatly strengthened. It is recommended to reduce Str if using other characters or increase Str LoRA instead.</p></li><li><p>P.S. Sometimes it makes the characters look younger in anime style.</p></li><li><p>The failed rate hand was still 50%.</p></li></ul><p><strong>Training Data v.1.2</strong></p><ul><li><p>587 image 5-8 repeats 2 epochs</p></li><li><p>Powershell ISE run script <strong>kohya-ss</strong></p></li><li><p>module = Networks.LoRA</p></li><li><p>cosine_with_restarts 3</p></li><li><p>16 DIM / 16 Alpha</p></li><li><p>U-net 1e-4</p></li><li><p>Loss ??</p></li></ul>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 2,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 22412,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3418,
                        "thumbsDownCount": 0,
                        "commentCount": 10,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 100
                    },
                    "creator": {
                        "username": "Gtonero",
                        "image": "https://cdn.discordapp.com/avatars/282355902479204353/fe1f230bc9ada4d83cae8ecfe4f7d6bd.png"
                    },
                    "tags": [
                        "anime",
                        "concept"
                    ],
                    "modelVersions": [
                        {
                            "id": 27867,
                            "name": "v1.2",
                            "index": 0,
                            "modelId": 21388,
                            "baseModel": "Other",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-03-23T13:38:56.83",
                            "availability": "Public",
                            "trainedWords": [
                                "incoming hug",
                                "incoming kiss"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 18786,
                                "ratingCount": 2297,
                                "rating": 5,
                                "thumbsUpCount": 2753,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 23020,
                                    "sizeKB": 18541.53125,
                                    "name": "incominghugAlpha16.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-23T13:40:48.406Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "F13959A223",
                                        "SHA256": "F13959A22344FA601FCE83F78A60BC8B227FA6DF45C1E1498C3678E75135C28E",
                                        "CRC32": "AD4095FC",
                                        "BLAKE3": "CE8AC09640BF72652837E73120976811DA4F5F84DF0546843B604D86A5AE0F10",
                                        "AutoV3": "9FDA4CAC7A21"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/27867",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 312965,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f990edff-41aa-4f4e-fdf7-f2adec2c9800/width=450/312965.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 760,
                                    "height": 920,
                                    "hash": "UKKKZz010J?b~W4.%Kay5RD%I9Ri~qbbrstR",
                                    "type": "image"
                                },
                                {
                                    "id": 312964,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/16870ba7-350d-4b97-44e4-368d2d5b6000/width=450/312964.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 760,
                                    "height": 920,
                                    "hash": "UNL;Ec0fI.?b~pM{%MRQJUMxM{ayS6M{r?X8",
                                    "type": "image"
                                },
                                {
                                    "id": 312963,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c6f55b5d-ce1b-4b9d-3b3c-bf1e4fbe4400/width=450/312963.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 760,
                                    "height": 920,
                                    "hash": "UGL;X6IB00_3y?kDm*xYBqRkMIn$-6of-:t7",
                                    "type": "image"
                                },
                                {
                                    "id": 312962,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/af088cb1-a16f-4607-379e-56a1cbe1a500/width=450/312962.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 760,
                                    "height": 920,
                                    "hash": "UUL|v5-p9EjG_Nxus8WC5RozROWq-5Rjxuay",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/27867"
                        },
                        {
                            "id": 26127,
                            "name": "v1.1",
                            "index": 1,
                            "modelId": 21388,
                            "baseModel": "Other",
                            "nsfwLevel": 3,
                            "description": "<p>In 1.1, hand distortion is at 50%.</p>",
                            "publishedAt": "2023-03-20T10:54:46.645",
                            "availability": "Public",
                            "trainedWords": [
                                "incoming hug"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2339,
                                "ratingCount": 405,
                                "rating": 5,
                                "thumbsUpCount": 406,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 21663,
                                    "sizeKB": 18541.5302734375,
                                    "name": "incominghug.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-20T10:56:23.802Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "DE2F2560",
                                        "AutoV2": "9E63580137",
                                        "SHA256": "9E635801372952DE8BECA470874AFE9F7E17FF446FF120BE7BEF5CD7CFCEF9E8",
                                        "CRC32": "6D586E09",
                                        "BLAKE3": "D703413D58681E220EA9B7FCFB2D96C26B062DC49A86707B16082450047B3945",
                                        "AutoV3": "A140F2A4B73F"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/26127",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 287368,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a98dfd2c-71e0-467f-4b04-213bef188600/width=450/287368.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 760,
                                    "height": 920,
                                    "hash": "UZL;20%g%$jb~ARjE2adJ8xaNIjEEhRks;oe",
                                    "type": "image"
                                },
                                {
                                    "id": 287369,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bdf0edd9-f544-4564-1d9f-686518cda400/width=450/287369.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 760,
                                    "height": 920,
                                    "hash": "UVMQ6PEOyE-:~9t8IsxtKPRPNLt6ERbbs.Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 287367,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f5145e3e-b6e2-4482-8d3a-8b1ecae35700/width=450/287367.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 760,
                                    "height": 920,
                                    "hash": "UcLXDFWC~qxu-;t7o#s:9ZRjt7j[?bofniof",
                                    "type": "image"
                                },
                                {
                                    "id": 287366,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9c8a8c06-6c2e-40c9-2bbe-2506f0be5a00/width=450/287366.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 760,
                                    "height": 920,
                                    "hash": "UfJ*M6S4_N%1-;t7ozt6ELRjt7V@t8ogozof",
                                    "type": "image"
                                },
                                {
                                    "id": 287365,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3c2b90b5-82da-44b3-6844-979bc83f8600/width=450/287365.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 760,
                                    "height": 920,
                                    "hash": "UBOWBA?b02n44TE1PC.7.TsmE8V[%$bv-;Mx",
                                    "type": "image"
                                },
                                {
                                    "id": 287364,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad014c2a-b585-488e-acf3-d73821868f00/width=450/287364.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 760,
                                    "height": 920,
                                    "hash": "UKM%l^9GF}~p#j%Mo~NGt,IVIpx]EjjYWBfl",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/26127"
                        },
                        {
                            "id": 25497,
                            "name": "v1.0",
                            "index": 2,
                            "modelId": 21388,
                            "baseModel": "Other",
                            "nsfwLevel": 2,
                            "description": null,
                            "publishedAt": "2023-03-19T06:31:47.691",
                            "availability": "Public",
                            "trainedWords": [
                                "incoming hug"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1287,
                                "ratingCount": 264,
                                "rating": 5,
                                "thumbsUpCount": 264,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 21161,
                                    "sizeKB": 9324.2275390625,
                                    "name": "incominghug.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-19T06:36:23.126Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "2D449DFD",
                                        "AutoV2": "695A17ED39",
                                        "SHA256": "695A17ED39AE8C9403C8887493F8D7E5621BEDFBD0F0CA6797927F5117471DC2",
                                        "CRC32": "B2889A3D",
                                        "BLAKE3": "6487B66C0EDFB5B844E8870A2B259FD9D230CB2FB1E6FE416A761CA7EBDA1C6E",
                                        "AutoV3": "E5EEC39C8858"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/25497",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 279871,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d79b2978-845d-42c1-37b7-dce9e903cb00/width=450/279871.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 760,
                                    "height": 960,
                                    "hash": "UEMG*bI=L2xa~BtS_3?GH?M{5St6g4IpWVnh",
                                    "type": "image"
                                },
                                {
                                    "id": 279946,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f2a7164-32ce-4033-c739-b19623a14a00/width=450/279946.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 760,
                                    "height": 960,
                                    "hash": "UgLD_fo}~qsn?HRjW;xuIoM{bct7x]t7xuRP",
                                    "type": "image"
                                },
                                {
                                    "id": 279839,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/69321dff-483c-4c5a-f548-f8578b0a9400/width=450/279839.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 760,
                                    "height": 960,
                                    "hash": "UHMa05tSg%r?wI%M_NnO0faeE1VspKSO%fjY",
                                    "type": "image"
                                },
                                {
                                    "id": 279838,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/77565989-f542-4235-9d93-fffae9e93b00/width=450/279838.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 760,
                                    "height": 960,
                                    "hash": "UELghYJC?^rq^gbv~q^kxZxaJ:MdEgI;_4%M",
                                    "type": "image"
                                },
                                {
                                    "id": 279945,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e28e3e84-cebf-4a8d-427b-bbc9fff3da00/width=450/279945.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 760,
                                    "height": 960,
                                    "hash": "UTMGhsWXtnn$~VXTIr-o5QjFS%M{T1NHV?xt",
                                    "type": "image"
                                },
                                {
                                    "id": 279870,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/98e9c392-056c-4f6f-8517-3c5bcd8c3200/width=450/279870.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 760,
                                    "height": 960,
                                    "hash": "UPMQCl9b*0^*~pkXnjM{M{IoOs$%t-s.s9Nx",
                                    "type": "image"
                                },
                                {
                                    "id": 279944,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/26590e80-9f66-4330-01f3-36bda8aa9300/width=450/279944.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 760,
                                    "height": 960,
                                    "hash": "UXMs~Coz?^oz-pWWNHxtIpjYX9R*Wrof$*of",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/25497"
                        }
                    ]
                },
                {
                    "id": 10626,
                    "name": "Makoto Shinkai (Your Name + substyles) Style LoRA",
                    "description": "<h2>Makoto Shinkai style LoRA</h2><h3>Includes substyles for Your Name, Weathering With You and The Garden of Words.</h3><p><strong>Making models can be expensive. Do you like what I do? Consider supporting me on </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/Lykon275\"><strong>Patreon</strong></a><strong> 🅿️ or feel free to </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://snipfeed.co/lykon\"><strong>buy me a coffee</strong></a><strong> ☕</strong></p><p>Requested on Discord, this was trained on my hand selected and tagged dataset of anime screencaps. Trigger word is <code>shinkai makoto</code> and contains substyles that are each triggered with <code>kimi no na wa.</code> (mind the dot), <code>tenki no ko</code>, and <code>kotonoha no niwa</code> respectively. See the example images and final comparison. Keep in mind this is not a character lora. While it obviously overfitted on the main cast, it won't get characters accurately 100% of the time without a character specific LoRA/TI.</p><p>It works most accurately on AnyLoRA and I've offset it so that it works at 1 weight. Should actually work on most anime models and on <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/10028/neverending-dream\">NeverEnding Dream</a>.</p><p>Clip skip 2 should be better, but careful as some of the examples are using Clip skip 1 because I forgot the setting from another test I was making. Pic 3 and 10 are generated with clip skip 1 and upscaled with clip skip 2.</p><p><br /></p><p><strong>How to use LoRA's in auto1111:</strong></p><ul><li><p>Update webui (use <code>git pull</code> <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/embed/mn8fMF10XN4?start=31&amp;end=60\">like here</a> or redownload it)</p></li><li><p>Copy the file to <code>stable-diffusion-webui/models/lora</code></p></li><li><p>Select your LoRA like in <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/watch?v=-bMeyXOZwN0\">this video</a></p></li><li><p><strong>Make sure to change the weight according to the instructions </strong>(by default it's <code>:1</code>)</p></li></ul>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 3,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 19309,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3416,
                        "thumbsDownCount": 0,
                        "commentCount": 11,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 10
                    },
                    "creator": {
                        "username": "Lykon",
                        "image": "https://cdn.discordapp.com/avatars/180327464155742208/59254be18ccd627daf138d053327485d.png"
                    },
                    "tags": [
                        "anime",
                        "girl",
                        "movie",
                        "female",
                        "highly detailed",
                        "makoto shinkai",
                        "style",
                        "art style",
                        "woman",
                        "illustration",
                        "artist",
                        "artstyle",
                        "cute",
                        "digital illustration",
                        "girls",
                        "male"
                    ],
                    "modelVersions": [
                        {
                            "id": 12610,
                            "name": "offset",
                            "index": 0,
                            "modelId": 10626,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 3,
                            "description": null,
                            "publishedAt": "2023-02-19T13:42:49.147",
                            "availability": "Public",
                            "trainedWords": [
                                "shinkai makoto",
                                "kimi no na wa.",
                                "tenki no ko",
                                "kotonoha no niwa"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 19309,
                                "ratingCount": 3105,
                                "rating": 5,
                                "thumbsUpCount": 3416,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 11397,
                                    "sizeKB": 147567.2177734375,
                                    "name": "shinkai_makoto_offset.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-19T13:46:25.212Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "574DEB23",
                                        "AutoV2": "EF6BA90E34",
                                        "SHA256": "EF6BA90E343502F6A8BF6DA0D9F8F4E2571D0248D11D14AA577B7DDC490BBD48",
                                        "CRC32": "E60DAA91",
                                        "BLAKE3": "CEB6E5FC896FFEDEB83F7E8E5ACC6199AD5FDB76E5DC533AC1CC95E5D0848DBB",
                                        "AutoV3": "CA429A1460F9"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/12610",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 122175,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8a74bbda-3a1b-49f4-86e3-b9ff52334a00/width=450/122175.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UmKK]3%MpyM}K8R:%gWUIAM|V@oyxtWVsmRk",
                                    "type": "image"
                                },
                                {
                                    "id": 122173,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9ac7d408-a700-4419-cf5a-868778784300/width=450/122173.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UMHUz+~Wto-pI_M_tnI;^+kDsWNH00xa?Gfk",
                                    "type": "image"
                                },
                                {
                                    "id": 122216,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3d371d90-f250-4469-4683-d383620f1100/width=450/122216.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 3680,
                                    "height": 1417,
                                    "hash": "UbLN_Tt8s:ax.AWYW;bE$%WAaeWC~pj=kBa#",
                                    "type": "image"
                                },
                                {
                                    "id": 122512,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0a38624e-352e-47bf-3bff-01bbf9ea0900/width=450/122512.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UKH1-^Fu=t~U,:58I=oL4o9bM|RlS5n$xGoL",
                                    "type": "image"
                                },
                                {
                                    "id": 122174,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a71d69b4-2211-4e71-b99f-3978afce1400/width=450/122174.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UMH2H8.9yGsSHq8^MxI[%fEjV?s:E1Ip^*%L",
                                    "type": "image"
                                },
                                {
                                    "id": 121645,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3bf80076-8396-4207-95f5-964679ec7500/width=450/121645.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1264,
                                    "height": 920,
                                    "hash": "UACry$5kt2n#1mRmNFRj00}=slkW:*5RR-sp",
                                    "type": "image"
                                },
                                {
                                    "id": 122376,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/20087d55-6bea-46e0-3a25-b770ad846400/width=450/122376.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UcNTg-~q?vayI:oI%Mt7?bM|sSoy-;WBRjRi",
                                    "type": "image"
                                },
                                {
                                    "id": 122375,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e1f5d68c-f2a5-4e0a-9c8d-2dbc14484f00/width=450/122375.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "USNTRQ^+?w9ZT1agxZ-;^,t7-oRj_NM{MxMx",
                                    "type": "image"
                                },
                                {
                                    "id": 122511,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2c4b71be-f091-460a-096e-9c2695374100/width=450/122511.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1264,
                                    "height": 920,
                                    "hash": "URLENQR5_M?bTOwI-=WV9aDjfi%MX2-p%Lf+",
                                    "type": "image"
                                },
                                {
                                    "id": 122510,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/12e7fb3e-748f-4ae0-d239-9d0598772400/width=450/122510.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UjKLXYH?Gwpe4=S0i{IVRRad$fofXSs9Nbxu",
                                    "type": "image"
                                },
                                {
                                    "id": 122509,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d42fae62-a101-4908-e5ec-1824e7a3b700/width=450/122509.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UWK-8{$*E1IV_4M{kXt6tn%1tlxuo$f$afRj",
                                    "type": "image"
                                },
                                {
                                    "id": 122377,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9085f6a6-1ab4-4e2b-aacf-429278848200/width=450/122377.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UEI4t:0N00~VD$0$~CE200IV-6IVxt-U?Hox",
                                    "type": "image"
                                },
                                {
                                    "id": 122172,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bdcca90f-1252-4280-1b20-4751fca52100/width=450/122172.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UIIh8a%iV=00AO4:4n^%Z##QSw-=+^EM.8bu",
                                    "type": "image"
                                },
                                {
                                    "id": 121642,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e282367-a197-4215-4925-523777036600/width=450/121642.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UhKA~Rx]yD^*_4xt?aM{?bRjM{M{%Mofoes:",
                                    "type": "image"
                                },
                                {
                                    "id": 122171,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/84c7dc8f-570e-44c7-304e-0e3749af3600/width=450/122171.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UJHd%AAd58=_02^kxvjE_N=|nM9s8_S$?GM{",
                                    "type": "image"
                                },
                                {
                                    "id": 122374,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dedd9a99-133c-4aec-708b-4a25313e3a00/width=450/122374.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1264,
                                    "hash": "UmJHp|xu*0ShE8jEj^ayIoxZspxakrbbodWC",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/12610"
                        }
                    ]
                },
                {
                    "id": 62760,
                    "name": "Asian girls face",
                    "description": "<p><strong>Recommended settings:</strong></p><ul><li><p>Make sure you are aware on the usage instructions of LORA</p></li><li><p>VAE: vae-ft-mse-840000-ema-pruned (For realistic models)</p></li><li><p>Sampler: DPM++ 2M alt Karras (Recommended for best quality, you may try other samplers)</p></li><li><p>Steps: 20 to 40</p></li><li><p>Clipskip: 1 or 2</p></li><li><p>Upscaler : 4x-UltraSharp</p></li><li><p>CFG Scale : 5 to 9</p></li><li><p>LORA weight for txt2img: anywhere between 0.2 to 0.7 are recommended</p></li><li><p>Denoise strength for img2img: 0.3 to 0.7</p></li></ul><p></p><p><strong>Disclaimer</strong></p><p>Creation of SFW and NSFW images is user's decision, user has complete control over to generate NSFW content whether or not.</p><p></p><p>This is a model that has been taken down, I found a lot of people looking for it, so I share it,I am not the original author of lora, the source of the sample picture: a blogger in bilibili.</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 5,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 31855,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3400,
                        "thumbsDownCount": 0,
                        "commentCount": 19,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 20
                    },
                    "creator": {
                        "username": "CNvtuber",
                        "image": "https://lh3.googleusercontent.com/a/AGNmyxbt6J5-p_i2GwQ36eypcK1LOSpq3QtguDp2nYdjkA=s96-c"
                    },
                    "tags": [
                        "photorealistic",
                        "asian",
                        "style",
                        "woman",
                        "girls",
                        "face"
                    ],
                    "modelVersions": [
                        {
                            "id": 67325,
                            "name": "v1.0",
                            "index": 0,
                            "modelId": 62760,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": null,
                            "publishedAt": "2023-05-10T16:37:08.363",
                            "availability": "Public",
                            "trainedWords": [
                                "FACE"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 31855,
                                "ratingCount": 2647,
                                "rating": 5,
                                "thumbsUpCount": 3400,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 47107,
                                    "sizeKB": 147567.2177734375,
                                    "name": "asianGirlsFace_v1.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-10T16:36:26.101Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "5A265D61",
                                        "AutoV2": "55D9FC2445",
                                        "SHA256": "55D9FC24456DAC3A8B47C993241574F61C456E222990E17999539F8475FB69F6",
                                        "CRC32": "36646214",
                                        "BLAKE3": "065B927EFC541A1731BEACD0E5777A7F82F4DCBDEB4D88F0F30A29F62904CAA0",
                                        "AutoV3": "53040ED45427"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/67325",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 747945,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/031e4408-3098-4f4a-9a05-d499cedf513a/width=450/747945.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 4096,
                                    "height": 6144,
                                    "hash": "UGE{b2~W8^%M004.krRPt.kWxYxuR%%1%1Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 747943,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a49700fa-ee2a-4d2c-932e-48c76f339bee/width=450/747943.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 4096,
                                    "height": 6144,
                                    "hash": "UVFiGZ~qo}%g00RP%MfkkXRjV@oJs.fPRkWB",
                                    "type": "image"
                                },
                                {
                                    "id": 753237,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/17976ec0-9e02-4d9d-a38f-b2e9c59c22a4/width=450/753237.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 5120,
                                    "height": 7680,
                                    "hash": "U9D+}IyE9Z~p00Di_4%N0Ms;r=D*xv-;IUE1",
                                    "type": "image"
                                },
                                {
                                    "id": 760012,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b49187c6-1fd6-41db-aaf5-c23b2ad8fe0b/width=450/760012.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UIECd=jF00NH4.M{-;t70KIVxuxt~qs:M_s:",
                                    "type": "image"
                                },
                                {
                                    "id": 764568,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/72440c9e-1949-4cd9-b17a-9ddefe4e60b5/width=450/764568.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U8D9n=029F^+QkD%_Nj^tRxaD%M{9ur=xB56",
                                    "type": "image"
                                },
                                {
                                    "id": 764795,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/edf50d58-e953-4f21-b442-3d4235ab0da0/width=450/764795.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UGFi76OZaI~Vq@NG%gxax]s:V[R%-=n$D%t6",
                                    "type": "image"
                                },
                                {
                                    "id": 764908,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4a7c0c4f-99f1-44c2-8525-e932401d7b0b/width=450/764908.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UFEMB,~WiuWY,mxu.9NHEMM{Mxs,9Z9FD%Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 774556,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e15952bf-d871-40fe-8dbd-d65469002a58/width=450/774556.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 2560,
                                    "height": 3840,
                                    "hash": "U7E2|L004n0L~VIVOE%M00-p.8-pJCa#r=Ri",
                                    "type": "image"
                                },
                                {
                                    "id": 774564,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fd46ab55-978b-48a4-b3e4-ec9f1506dd47/width=450/774564.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U8Dl$h^+00x]_Nbc-;?H00xa_3D%E0kCxaIp",
                                    "type": "image"
                                },
                                {
                                    "id": 775236,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/221e229e-1494-454e-8126-860c7161e4dd/width=450/775236.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UDEff[.9DhRi-h?cyExu.T.8^+oMyY?bD%IV",
                                    "type": "image"
                                },
                                {
                                    "id": 775805,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d91aa5e7-d100-4e1b-821f-5d63b7db4b81/width=450/775805.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U9C~*f00}?^Q}?R5IU$jH@={xHNG9vk8%2I.",
                                    "type": "image"
                                },
                                {
                                    "id": 776420,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/706514b4-7049-4281-b43b-5d58db124b41/width=450/776420.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UADJL[0N00n3H;9Z_NOZ4TNe_NWBIUofxZM{",
                                    "type": "image"
                                },
                                {
                                    "id": 776934,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/095092a9-26a8-4138-b0e3-7d3ef286a6de/width=450/776934.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U9Eo*^8_000LMI01_N-:xt4.-:-p_39Z%1s.",
                                    "type": "image"
                                },
                                {
                                    "id": 778191,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e0632818-67dc-4da4-81a1-788d9bc1a9e5/width=450/778191.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "UKDvfx~qM{NG?a%Mx]xaD%RjxuW;XSNGV?jF",
                                    "type": "image"
                                },
                                {
                                    "id": 778188,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ac944020-db82-4da5-b200-dddeacf9f28e/width=450/778188.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U7A,?_D%00~qHrozk?M{00^+?bIUo}IpnNR+",
                                    "type": "image"
                                },
                                {
                                    "id": 778190,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/49451862-093a-445c-a6e2-30f6c67c61db/width=450/778190.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1280,
                                    "height": 1920,
                                    "hash": "U5A,g[~p0fRjI.oz-;WXE2IU4oRjE2bH~B%2",
                                    "type": "image"
                                },
                                {
                                    "id": 934031,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e855c542-d747-43ec-a214-d2236acb5d77/width=450/934031.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 960,
                                    "hash": "U48;Je?b%f9F~VbH_2xt00M_MwxuDiRPE2o#",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/67325"
                        }
                    ]
                },
                {
                    "id": 13239,
                    "name": "Light and Shadow",
                    "description": "<p>这个画风lora，可以让你的画面出现绚丽的光影效果，同时兼容其他角色lora，建议使用Anything和高分辨率修复</p><p>推荐权重0.6-0.8</p><p>可以配合我的其他画风lora使用</p><p>经过噪声偏移训练的版本与未经过的版本效果完全不同</p><p>两个lora都很棒，且各有特色，所以我觉得自己应该把这两个lora分开发布</p><p></p><p>推荐一个可以免费生图的模型网站</p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://tusi.art/\">吐司 </a><a target=\"_blank\" rel=\"ugc\" href=\"http://Tusi.Art\">Tusi.Art</a><a target=\"_blank\" rel=\"ugc\" href=\"https://tusi.art/\"> - 可在线生图的模型分享社区，还是免费的！</a></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent",
                        "Sell"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 21682,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3394,
                        "thumbsDownCount": 0,
                        "commentCount": 5,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 0
                    },
                    "creator": {
                        "username": "Eisthol",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eeeb212f-cd4e-4a41-5829-ac679df07800/width=96/Eisthol.jpeg"
                    },
                    "tags": [
                        "anime",
                        "girl",
                        "female",
                        "style",
                        "art style",
                        "fantasy"
                    ],
                    "modelVersions": [
                        {
                            "id": 15603,
                            "name": "v1.0",
                            "index": 0,
                            "modelId": 13239,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-02-26T08:59:56.482",
                            "availability": "Public",
                            "trainedWords": [
                                "starry,strry light,night,colorful,cloud,star \\(sky\\),"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 21682,
                                "ratingCount": 3144,
                                "rating": 5,
                                "thumbsUpCount": 3394,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 13353,
                                    "sizeKB": 147568.478515625,
                                    "name": "Light and Shadow.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-26T09:01:29.973Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "9FB86D6C",
                                        "AutoV2": "15A630AB22",
                                        "SHA256": "15A630AB2255460B2E99B1E5A6765A1CEDCD210E2FFCA32474BD02DF24232624",
                                        "CRC32": "4F241205",
                                        "BLAKE3": "5EF0476E921450AB8E58CCFF3213AC4B46B4681A68AF0BA78434CC73B0729F8A",
                                        "AutoV3": "B2DEFA67DC5D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/15603",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 155703,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0508932a-40a4-4460-c1a0-08313c923700/width=450/155703.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBECa{9F00?c_MMw00%M01Mw-px^XUNF%L.8",
                                    "type": "image"
                                },
                                {
                                    "id": 155715,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/be512508-ee9a-4651-777f-be9b12def200/width=450/155715.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEFi=fD$EK.8%hITW+?b?w%1ox4n9GIAxux^",
                                    "type": "image"
                                },
                                {
                                    "id": 155714,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c1cf44b4-8541-42d1-57b1-ffd918867e00/width=450/155714.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTGS$R_4RPWY.9o#kDWYtSx^j[DiW?WARjx]",
                                    "type": "image"
                                },
                                {
                                    "id": 155713,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0b8ffbb5-9008-42b8-3755-b293497ff300/width=450/155713.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USH2{ADi.9R,pyxvMxx^D*xaDiozoIWCROS4",
                                    "type": "image"
                                },
                                {
                                    "id": 155711,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1346d8f9-9fb4-4f6d-3591-2fbd862d0000/width=450/155711.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCEy#@?J9~9aKB.TNMx]Djt-D%p0_Nt8?at8",
                                    "type": "image"
                                },
                                {
                                    "id": 155710,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/08d880a9-53a9-4d5c-06f7-a59b74b7bb00/width=450/155710.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCG*BB~p004:J:xuJ7V@RPIoNuxaD%IVkWW:",
                                    "type": "image"
                                },
                                {
                                    "id": 155709,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f795ae00-377b-4dab-f6fb-e12b43b98a00/width=450/155709.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7ID%a~V00?HNH~W=z00Dg4nx[%f0K9Z57Z$",
                                    "type": "image"
                                },
                                {
                                    "id": 155708,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1bf16aa8-c40c-40c9-8c7a-9952b458b600/width=450/155708.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULF5X2~VIoxZ?ZozIpNH$eWAs.t6xsNGj@%2",
                                    "type": "image"
                                },
                                {
                                    "id": 155707,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2ec125e4-0aee-4cbe-1086-56e55d0c0900/width=450/155707.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9F6U[%h0[.Ah}%#00R=MHD,Ne%f8^IA9Y9F",
                                    "type": "image"
                                },
                                {
                                    "id": 155706,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8a2018a7-24f9-4381-5f62-7f8133f73000/width=450/155706.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "U8I#ANw700Fyx9000M#R0MxC=|~A5q~q8{J6",
                                    "type": "image"
                                },
                                {
                                    "id": 155705,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1ef0067f-5668-4672-63f6-36f682488200/width=450/155705.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UA9ti:Djx{o%?dOso2IU00.7oyD*4T-?RU%O",
                                    "type": "image"
                                },
                                {
                                    "id": 155704,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cc6bf7ad-3b32-4742-d40e-079085a90000/width=450/155704.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U67U_Eq[8^Tfx]MwMw%%00JMx]%5Me.Rn3DO",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/15603"
                        }
                    ]
                },
                {
                    "id": 7505,
                    "name": "Hu Tao | Genshin Impact",
                    "description": "<p>If you like my work then drop a 5 review and hit the heart icon</p><h2 id=\"heading-20\"><span style=\"color:rgb(253, 126, 20)\">Character commission is open</span> on <a target=\"_blank\" rel=\"ugc\" href=\"https://patreon.com/goofyai\">Patreon</a></h2><h3 id=\"heading-3\">Join my New <a target=\"_blank\" rel=\"ugc\" href=\"https://discord.gg/M8yAsU9ZhC\"><strong>Discord Server</strong></a></h3><p><strong>This model is available on </strong><a rel=\"ugc\" href=\"https://dazzleai.network/generate\"><strong>Dazzleai </strong></a><strong>for free to generate</strong></p><p>This is a lora for the charecter Hu Tao from Genshin impact .</p><p>this model is trained on novelai model but can also work well with anything-v4 or AOM2.</p><p>use weight at 0.6-0.8 or experiment as you like.</p><p>if you want to get the photo with her ghost use the tag \" boo tao \"</p><p></p><p></p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [],
                    "allowDerivatives": false,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 15,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 28331,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3347,
                        "thumbsDownCount": 0,
                        "commentCount": 13,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 10
                    },
                    "creator": {
                        "username": "Goofy_Ai",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/50b47d84-29da-4be4-b4f1-e397c6e49679/width=96/Goofy_Ai.jpeg"
                    },
                    "tags": [
                        "anime",
                        "character",
                        "girl",
                        "person",
                        "female",
                        "genshin impact",
                        "woman",
                        "illustration",
                        "cartoon",
                        "fantasy",
                        "game character",
                        "girls",
                        "portraits",
                        "video game"
                    ],
                    "modelVersions": [
                        {
                            "id": 14479,
                            "name": "v2",
                            "index": 0,
                            "modelId": 7505,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2023-02-23T19:17:24.766",
                            "availability": "Public",
                            "trainedWords": [
                                "hu tao(genshin impact)",
                                "boo tao",
                                "symbol shaped pupils"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 25612,
                                "ratingCount": 2947,
                                "rating": 5,
                                "thumbsUpCount": 2978,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 12545,
                                    "sizeKB": 147579.794921875,
                                    "name": "hutao_v2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-23T19:20:56.522Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "820C8516",
                                        "AutoV2": "D2806A3251",
                                        "SHA256": "D2806A3251F10AC8E44FAC08611AC16236152DCC8AA9DEA531E0758A65186BD8",
                                        "CRC32": "D4FA0339",
                                        "BLAKE3": "3BD4D69EC88C03B427F5A8D4551666ADF5F5103F180B3A2F91BEE22124B3BE9F",
                                        "AutoV3": "A8E1C9089A12"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/14479",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 385577,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f7b258c2-251a-452f-94b0-3786457fcd00/width=450/385577.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTK15n^*.8D%_NNukBMxM{V@sSM{x]R*Rjs:",
                                    "type": "image"
                                },
                                {
                                    "id": 385578,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/10c3ecd5-3533-41fe-a168-e68d91d66b00/width=450/385578.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 680,
                                    "hash": "UOJHUH_3~qtRx]%MtRjYR%%g?HozxuWDkDRj",
                                    "type": "image"
                                },
                                {
                                    "id": 141445,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d01b8934-69ce-46d9-bc52-cf7ddf809000/width=450/141445.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UWKKc$Io~qt8?HWX-pRk~WoLozxaShxtxuxa",
                                    "type": "image"
                                },
                                {
                                    "id": 141444,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/81f384e7-016e-432f-8354-ffae5c44f400/width=450/141444.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UdK-Rhx[_Nof?bof-;kC-;WBj]aeIoWBs:j[",
                                    "type": "image"
                                },
                                {
                                    "id": 141443,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a6475a40-e913-40d8-4224-0a8f2a177600/width=450/141443.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UVKKf[WV_3xu?bxa^+tR~qIokWt7I:Rjxuj[",
                                    "type": "image"
                                },
                                {
                                    "id": 141442,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/025545f5-1492-4356-5aad-9d40756f1300/width=450/141442.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "USMjjw%M_3xu?boz~qWC%1Rj%Mt7xvfkD%n$",
                                    "type": "image"
                                },
                                {
                                    "id": 141441,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71967a7f-bdf7-4623-793d-2eb733484900/width=450/141441.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UaKdxmx]_Nt7_3t6-;NH-;R*x]t7W=ayoJae",
                                    "type": "image"
                                },
                                {
                                    "id": 141440,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2b8f26a0-9b52-48d7-0a69-4943a0eb9400/width=450/141440.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGIX,A-;BgoeYN%M%FIT_M%M~VxtEMxb^*jF",
                                    "type": "image"
                                },
                                {
                                    "id": 141439,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/561d09eb-923e-49ea-9437-397eb0a34300/width=450/141439.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U8JkDom]3NDOUXm[~UDjp]x_~Vrr0LtSR%t3",
                                    "type": "image"
                                },
                                {
                                    "id": 141438,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e5edeca1-9049-48f8-c9fe-66cdcbda4d00/width=450/141438.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFJHgi-;0dNFTuxu%KW,Ee%M~Wk8IT%2Iot6",
                                    "type": "image"
                                },
                                {
                                    "id": 141437,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0a6c7a88-79f0-4403-1101-a7df24976200/width=450/141437.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UULzga%M_NIU.Sof_3oz_3WB-;-;D%M{jFNG",
                                    "type": "image"
                                },
                                {
                                    "id": 141436,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/55ea46f3-9fc7-4288-a0ea-c6e64edbad00/width=450/141436.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UTJ8YH?v.TobyEo#tlMxxutR%2t6X9V@WBoz",
                                    "type": "image"
                                },
                                {
                                    "id": 141435,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/333dd9df-25fd-42e1-8ea2-6dd061c38100/width=450/141435.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UVODFC_3?^Iox^x]?bIA-;WBxaoLt7RjWVR*",
                                    "type": "image"
                                },
                                {
                                    "id": 141434,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e7c314ce-0aae-490b-1f31-cd6acf39c200/width=450/141434.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UFI;^y-?%#aePC?cSi%L?wXUkXIoS~bwg2t7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/14479"
                        },
                        {
                            "id": 8813,
                            "name": "v1",
                            "index": 1,
                            "modelId": 7505,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2023-02-08T20:35:57.747",
                            "availability": "Public",
                            "trainedWords": [
                                "hu tao(genshin impact)",
                                "symbol shaped pupils",
                                "hat",
                                "flower",
                                "boo tao"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 2719,
                                "ratingCount": 371,
                                "rating": 4.99,
                                "thumbsUpCount": 371,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 8639,
                                    "sizeKB": 147570.3046875,
                                    "name": "hutao_nai.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-08T20:41:24.675Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "07045D0A",
                                        "AutoV2": "ED58CC0739",
                                        "SHA256": "ED58CC0739B7CB80CD491D6F14F3C16F84510D96594750DC56AB462BF9EEAA17",
                                        "CRC32": "C1503238",
                                        "BLAKE3": "D1CD279E298093F947A8E3940317E445D4DFDBE5C583F93EF7CBFF4EDBA626D7",
                                        "AutoV3": "02066C34D0C7"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/8813",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 84159,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e403598f-a85f-42af-e759-16df8876ed00/width=450/84159.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "UYIhKp_4?wo~%gx]T0W?E1X8xua}RjWB%2WB",
                                    "type": "image"
                                },
                                {
                                    "id": 84151,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b82d7535-12d6-4121-386f-307a9167ce00/width=450/84151.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2048,
                                    "height": 2560,
                                    "hash": "UoLghSs:_Nj]-;WBtRWVR+NGxut7xtt7WCR*",
                                    "type": "image"
                                },
                                {
                                    "id": 84158,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ea9320e9-70ea-46ae-0cf3-7a36a0a18500/width=450/84158.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "UQL4Z[~pK%Ri0dj:%hNF55RNr;WT%0t6Mws;",
                                    "type": "image"
                                },
                                {
                                    "id": 84157,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c9ad6526-4dc9-4f38-0ead-ff2e15905900/width=450/84157.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 728,
                                    "hash": "UbK^,3tR*0xut,kC-;aeI:aes9RjxGbHt7of",
                                    "type": "image"
                                },
                                {
                                    "id": 84156,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/538a2c4a-0272-4439-c1ba-4da5bce32300/width=450/84156.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 728,
                                    "hash": "UPJ*I]-;_3.8~VNK-p?b-oRlM{xuR+xFt7Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 84155,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0603c586-922d-4e10-0903-801e2592ad00/width=450/84155.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UVKwa[~qkqRislRjt5RjW.xbV@WB9ZRQ-pof",
                                    "type": "image"
                                },
                                {
                                    "id": 84154,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80990d2f-eb10-43b2-2242-9e79893b5200/width=450/84154.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U6G*ykx?Ec~p00s+xp9F^i0%-VI=0102~WD+",
                                    "type": "image"
                                },
                                {
                                    "id": 84153,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/652a7f4e-2457-49ee-6dbb-1640edf29c00/width=450/84153.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1456,
                                    "hash": "UXK^a3~WOYt6X--;^+t69axutRR*?bkCM{Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 84152,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bea5f606-2b74-4e38-a8c0-548644248400/width=450/84152.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1456,
                                    "hash": "UhK-2$~WyD%2J-xu?Hs:NaWCaeoJ%Mt7V@Rj",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/8813"
                        }
                    ]
                },
                {
                    "id": 17704,
                    "name": "Goth Girl LoRA",
                    "description": "<p>This is my Goth Girl LoRA. This LoRA is trained on NovelAI, <em>so it will not do particularly well with realistic models. It was also trained with a heavily NSFW dataset.</em><br /><br />The keyword is 'gothgirl', but other tags that describe the look and style of goth culture work well too. <br /><br />The strength is good from 0.6 to 0.8, but I use 0.75 strength. All images are generated are generated with Hires Fix and the Orangemix VAE. All pictures were made with the blends available on my profile.<br /><br />If you like the model, join the <a target=\"_blank\" rel=\"ugc\" href=\"https://discord.gg/UqxdnbAQp5\">discord</a>.</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": true,
                    "nsfwLevel": 28,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 24585,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3340,
                        "thumbsDownCount": 0,
                        "commentCount": 24,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 71
                    },
                    "tags": [
                        "anime",
                        "sexy",
                        "female",
                        "porn",
                        "gothic",
                        "boobs",
                        "naked",
                        "nudes",
                        "gothicgirl",
                        "style",
                        "woman",
                        "sex",
                        "breasts",
                        "beautiful",
                        "cute",
                        "girls",
                        "hentai",
                        "women"
                    ],
                    "modelVersions": [
                        {
                            "id": 75355,
                            "name": "v2.0",
                            "index": 0,
                            "modelId": 17704,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2023-05-19T22:52:39.476",
                            "availability": "Public",
                            "trainedWords": [
                                "gothgirl"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 13849,
                                "ratingCount": 1174,
                                "rating": 4.99,
                                "thumbsUpCount": 1738,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 52039,
                                    "sizeKB": 36988.3486328125,
                                    "name": "gothgirl.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-19T22:11:15.997Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "3671E9D8",
                                        "AutoV2": "FEFC1E66E9",
                                        "SHA256": "FEFC1E66E9298AB0B393268EDF069C02C55A0DDDD2E684C3C7CB0592CC697D29",
                                        "CRC32": "7B5E4B37",
                                        "BLAKE3": "637B850ECE5BFBB539EEC57A53725D787BF3ECCD59088BA1995D7DC5E85213B5",
                                        "AutoV3": "80704C3A4BA4"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/75355",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1379279,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8f0b2e92-c2f7-4b7f-9d20-b38e37c018fb/width=450/1379279.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8G*~L4.p{~W_200$f%M00?vDit6#Q%g4nD$",
                                    "type": "image"
                                },
                                {
                                    "id": 843036,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6cd6967f-ef7b-4aa0-9bef-8b30ef6cec2c/width=450/843036.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIB3Tu-p9ZNGE2oM%2R+4:M|%2xa~VxaE2oL",
                                    "type": "image"
                                },
                                {
                                    "id": 843040,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/978446cc-db16-4ee0-8aa5-954faffd2c9a/width=450/843040.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9EVg4q^0|%N01yDQ-S%9wNI~Cs;B:RPOr%2",
                                    "type": "image"
                                },
                                {
                                    "id": 1277781,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/198e8488-3fa4-48d1-845b-cf7ba751d921/width=450/1277781.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMIEnk8^x[RP.T4o%NbI9FWA-:t7r?j[IUjY",
                                    "type": "image"
                                },
                                {
                                    "id": 1379280,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/66aefb82-c1ba-49f7-a7b9-c05391482fe2/width=450/1379280.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIGR;w_4?v%g_N?b?b-;IV?bRQIUWAWBIoMx",
                                    "type": "image"
                                },
                                {
                                    "id": 843037,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f78c98da-7d66-4f27-9605-5a4b56a6bd9e/width=450/843037.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UOEolR^+~V^+pK-pR+R,%gR*xaoeEMWCIoRj",
                                    "type": "image"
                                },
                                {
                                    "id": 1204215,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3fd88fca-3416-489a-9ea6-63a5ab522572/width=450/1204215.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "UDEf1l_2M^M{~Vt69ZRj4.k8IoNGO9xtRPWB",
                                    "type": "image"
                                },
                                {
                                    "id": 1154924,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4b4303b3-0c9f-4e71-9903-ac9fd6311282/width=450/1154924.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 4480,
                                    "height": 6080,
                                    "hash": "UGGa?|^*01jZ0KM{oJIp01R*?HWW~Woe9ZWB",
                                    "type": "image"
                                },
                                {
                                    "id": 1590548,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fd93f0f2-d95c-4c99-824f-509267ba71ad/width=450/1590548.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U58|@gKkD$O@_N$%4n$*4mR4IAVrRjR,%1Io",
                                    "type": "image"
                                },
                                {
                                    "id": 903643,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1083f818-01db-4c5a-85a6-09b7d9c1c935/width=450/903643.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1152,
                                    "height": 1664,
                                    "hash": "USLD[rE3~V~Wu5NI9uW.#URQmlwd%1%2w[-9",
                                    "type": "image"
                                },
                                {
                                    "id": 9238581,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/85b1b49e-4dec-4815-80b3-7bcfa68c1b2d/width=450/9238581.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBF5:P_3ysIo.9NG?wsnNdWX4mjF9Zt7~Vxu",
                                    "type": "image"
                                },
                                {
                                    "id": 1095299,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2a870adb-e571-40a4-a938-63e9753d5f81/width=450/1095299.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1984,
                                    "height": 3200,
                                    "hash": "U98h,eax0zIB^jZ%8wk;LySz=LxGC4V@+JtR",
                                    "type": "image"
                                },
                                {
                                    "id": 3750560,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/94c7fe8c-44f3-4274-925d-12f415b606fc/width=450/3750560.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 2048,
                                    "height": 3072,
                                    "hash": "UBFhht58Oa~B4:oKs+oM9axa%1E2-obHIpad",
                                    "type": "image"
                                },
                                {
                                    "id": 843035,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f2789b09-c8eb-4c07-bca7-e50cce05524a/width=450/843035.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UvODFCjY_NxutlfkxZof%MRjRjxtxut7WBWC",
                                    "type": "image"
                                },
                                {
                                    "id": 843041,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c8e4ade7-709e-43c2-9226-39a1f1000521/width=450/843041.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U4B{fd^k000L0gM{~C~C02o#^k9Z-=bvM|E1",
                                    "type": "image"
                                },
                                {
                                    "id": 843039,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c7e41622-50fa-488a-8e27-645b5f6a573f/width=450/843039.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UhIE-D-q_4t8_Nf+%MWAtRRjM{WBtSWBWBt7",
                                    "type": "image"
                                },
                                {
                                    "id": 875530,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c143831b-3821-45be-8fc7-b7718842c0ac/width=450/875530.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6BpFL00FG-p9_-74.xZ%gD%^+NGRO9a~VIo",
                                    "type": "image"
                                },
                                {
                                    "id": 888604,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/11962569-79ab-4249-9c19-46c0557676b9/width=450/888604.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 2048,
                                    "height": 3264,
                                    "hash": "UHE.kQ?a009ZJBS#WBV@00xa~pkCjFM|R+xu",
                                    "type": "image"
                                },
                                {
                                    "id": 843034,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c5de427f-718a-4c21-b044-9a9a0d4260c2/width=450/843034.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAE.Owt7.6D*~ps;t7569FNF0K?H8^jFR5%M",
                                    "type": "image"
                                },
                                {
                                    "id": 916058,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/61b5f02d-6dde-462e-83bf-2ed50677a984/width=450/916058.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHD9n?~V4o9a_2oJ9GNG9ZIVo2%1D*Rk%2xt",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/75355"
                        },
                        {
                            "id": 20930,
                            "name": "v1.0",
                            "index": 1,
                            "modelId": 17704,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 31,
                            "description": null,
                            "publishedAt": "2023-05-19T22:07:00.747",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 10736,
                                "ratingCount": 1613,
                                "rating": 5,
                                "thumbsUpCount": 1614,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 17441,
                                    "sizeKB": 36989.2724609375,
                                    "name": "Goth LoRA.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-10T02:21:11.453Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "DE3A010A",
                                        "AutoV2": "90E4260AF3",
                                        "SHA256": "90E4260AF3D174D1AD283D2B741336F97BB26446EB148CCD5A273A310B9EE0B9",
                                        "CRC32": "A6A6029E",
                                        "BLAKE3": "7A9A93BFE5F0438471BBEEF1AFBEEB991919531C9EB1EEAF86B4092838B10432",
                                        "AutoV3": "6D0802D3C76A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/20930",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 222042,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/580a6873-2955-45a5-f86c-0e5da80f7900/width=450/222042.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U7CFbd^Q0Kw|9u={^jxZ0K$j}[$%}[$*$fxG",
                                    "type": "image"
                                },
                                {
                                    "id": 222050,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a369c478-5263-4dd0-0cf5-27486b03ec00/width=450/222050.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UGH-cG9a00Na01=|^kt79aE2xa=|~VE1WBt7",
                                    "type": "image"
                                },
                                {
                                    "id": 473863,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1fab90ec-61c5-4bf3-7979-c4ae3ca02100/width=450/473863.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKG*pIM{5Sxu_2Io?H%2-;R*%2%2~Wae?Ha}",
                                    "type": "image"
                                },
                                {
                                    "id": 796571,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e984a42b-e8e3-4661-8a5a-0c55ca48299f/width=450/796571.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 4096,
                                    "height": 4096,
                                    "hash": "U9E2IS9u00a#01s,%2t70K%2-;NG~CNHRjae",
                                    "type": "image"
                                },
                                {
                                    "id": 434350,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d2f00feb-4dde-4a65-f941-254885e41000/width=450/434350.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1080,
                                    "height": 1920,
                                    "hash": "ULF5v[-;IVjZ~qxaD%Rjtm%MV@Io?bxuniM|",
                                    "type": "image"
                                },
                                {
                                    "id": 222046,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/90fcfb13-d219-4143-c13a-ff4dbab24e00/width=450/222046.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UZL|TAM{_N?aS%ofsmt7t8Rjaxoft8WCozs:",
                                    "type": "image"
                                },
                                {
                                    "id": 222048,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2684991c-c06b-4144-b533-bb6d34d45300/width=450/222048.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDG*=^IB0Le.caRi-qRj0LWC^+V[~pxa4.WV",
                                    "type": "image"
                                },
                                {
                                    "id": 1366548,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a3add177-8a68-4395-8fd9-2e9b7c90ce22/width=450/1366548.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGBfCP~CI:R*bIxa-o-oIoaes:R*M{NGRkNG",
                                    "type": "image"
                                },
                                {
                                    "id": 490877,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ec219cf0-0be4-4543-4985-5aee56851f00/width=450/490877.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 2560,
                                    "height": 1920,
                                    "hash": "U7C$QD~XKP^+?v-ps:e-?^%go3n$yDozjGM{",
                                    "type": "image"
                                },
                                {
                                    "id": 222047,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/04bbf656-e8b9-4994-6738-987a48e7c500/width=450/222047.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UQI#W4Rj?w-;NeaeRjRkRjWBRPxuWVa}oej[",
                                    "type": "image"
                                },
                                {
                                    "id": 222140,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/37f9026e-7b58-4c6f-114e-2b57d4997400/width=450/222140.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UCCG7D4.00~WJ*My-pkBIojF%LE1-poLNGRj",
                                    "type": "image"
                                },
                                {
                                    "id": 257045,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b4dd5b85-2052-4abc-25cf-9ffc28ddd000/width=450/257045.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHGt$*^*-UkC}sV@E2I:$gaeXSSh={WBIpt6",
                                    "type": "image"
                                },
                                {
                                    "id": 223358,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b4572f04-3366-47e3-3640-ff6b1cea0800/width=450/223358.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "U8C=rK4;01~Bx^oIE1Sh0L?Fof9tITW=%LRQ",
                                    "type": "image"
                                },
                                {
                                    "id": 2370978,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c04c60bd-cbee-41c3-9641-1908e6f3bcf1/width=450/2370978.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 768,
                                    "height": 1056,
                                    "hash": "U6DI%xo#02O@u*Mx8w$%80OG_3?b^%v~00M|",
                                    "type": "image"
                                },
                                {
                                    "id": 223363,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad2291c4-9867-4bee-822d-5bb8842baf00/width=450/223363.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAI4U~}@o]%g00?G~Ug4:~^O^%W9jc^jF2OT",
                                    "type": "image"
                                },
                                {
                                    "id": 522342,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8aa7e66c-b300-4948-1191-80e84e95d200/width=450/522342.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1280,
                                    "hash": "ULFqwVE20L%M0Ln%-pso0Kt7xuIo~CoLE1Wq",
                                    "type": "image"
                                },
                                {
                                    "id": 3212618,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3840b4df-f0e1-41e4-9f0e-220362809cb4/width=450/3212618.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "U3CZ66a11Y~o.QtR-URk01%LR6E2IoE2%1f6",
                                    "type": "image"
                                },
                                {
                                    "id": 2961062,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/412a9175-41de-49f9-bcff-9b984cf03732/width=450/2961062.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "U9E2h89Z00~WxsNGE3n$00a#NHRP?H%2M_%2",
                                    "type": "image"
                                },
                                {
                                    "id": 796562,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/20c39165-16c2-455b-81f5-59852e110601/width=450/796562.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 4096,
                                    "height": 4096,
                                    "hash": "U5ExL$}F000000-p^P-o0eWV%Mxu=|9ZNZ-p",
                                    "type": "image"
                                },
                                {
                                    "id": 1366552,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9fee1800-476b-4528-becf-17bd921afdc2/width=450/1366552.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U57U0b-;0J4.%4ofImIUELX8Wmxa_N-;D$D$",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/20930"
                        }
                    ]
                },
                {
                    "id": 47909,
                    "name": "NijiExpressive_v2",
                    "description": "<h3 id=\"heading-28\">I found a new AI tool Shakker, a best image to image tool. You can try it via <a target=\"_blank\" rel=\"ugc\" href=\"https://www.shakker.ai\">https://www.shakker.ai</a> ,it can help you:</h3><p>-Remix: Upload a picture. Just switch the prompts, and you can create stunning images in the same style.</p><p>-Style Transfer: Shakker not only extracts the style,but also switches among various styles.</p><p>Besides, Shakker also offers Object Control,Composition Control,Collage Redrawing etc.</p><h2 id=\"heading-91\">Niji-Expressive V2 launch!!</h2><h3 id=\"heading-92\">灵动优雅，张力尽显</h3><p>本次升级<strong><em>泛用性</em></strong>，能在更多模型和采样方式上适用</p><p>选取500+优质且风格统一的<strong><em>Nijijourney</em></strong>图片，进行更高精度训练</p><p>推荐关键词：<strong><em>letterboxed, illustration,</em></strong></p><p>目前仍然存在手部和肢体的bug（甚至更严重）</p><p>十分推荐使用“<strong><em>bad promt，easynegative，badhand</em></strong>”等负面embedding</p><p>======================</p><h3 id=\"heading-93\"><strong>Vivid and elegant, full of tension</strong></h3><p>This upgrade is generalized and can be applied to more models and sampling methods</p><p>500+ Nijijourney pictures with high quality and uniform style were selected for higher precision training</p><p>Recommended keywords: letterboxed, illustration,</p><p>- There are still hand and limb bugs (even worse)</p><p>It is highly recommended to employ \"bad promt, easynegative, badhand\" and other negative embedding</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 19578,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3315,
                        "thumbsDownCount": 0,
                        "commentCount": 8,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 0
                    },
                    "creator": {
                        "username": "Terry9993",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e7cd7bab-0a5e-426d-7ad2-ed173d85fd00/width=96/Terry9993.jpeg"
                    },
                    "tags": [
                        "anime",
                        "niji",
                        "style",
                        "illustration"
                    ],
                    "modelVersions": [
                        {
                            "id": 52506,
                            "name": "v2.0",
                            "index": 0,
                            "modelId": 47909,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-04-22T15:48:29.73",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 19578,
                                "ratingCount": 2778,
                                "rating": 5,
                                "thumbsUpCount": 3315,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 38220,
                                    "sizeKB": 147587.6611328125,
                                    "name": "NijiExpressV2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-22T15:46:33.118Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "E0E4AD26",
                                        "AutoV2": "693F1AF8DF",
                                        "SHA256": "693F1AF8DFBDD70FD60F2AED969B69A247BAF310DFFD5B24B657D83E149E1AC5",
                                        "CRC32": "1A0D2394",
                                        "BLAKE3": "7E906770A622CB17188057AC2F0A0498F585646AD8045DCC3335DB291E615ADD",
                                        "AutoV3": "F7F33E287CC6"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/52506",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 571939,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/071f96a7-5c2e-4482-53f9-d9aaaddade00/width=450/571939.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 328,
                                    "height": 512,
                                    "hash": "UQI}^r-:~q_39at7e-IU%M%LNGIUxtM{tR-;",
                                    "type": "video"
                                },
                                {
                                    "id": 566002,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a05acea3-0ca3-426f-8d3c-59aac316ae00/width=450/566002.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1312,
                                    "height": 1712,
                                    "hash": "UBAT_;?v0000?wx]DiDiI9RjxuocjDkCkWWB",
                                    "type": "image"
                                },
                                {
                                    "id": 565987,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/52a26a95-29cf-41bd-bcf4-0771cbbe6400/width=450/565987.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1168,
                                    "height": 1824,
                                    "hash": "U56l#Q0e.3UC.lL,mtakNunOynTDynR%ifML",
                                    "type": "image"
                                },
                                {
                                    "id": 565998,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/84af3dd4-e8d6-4e9d-ccf6-1b53cecbd400/width=450/565998.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1168,
                                    "height": 1824,
                                    "hash": "UMIh,A_2~q~p4:oMobM{t7xuIoD%xaM{t8.8",
                                    "type": "image"
                                },
                                {
                                    "id": 566003,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e19d6615-fa65-480c-b438-dda3e0fede00/width=450/566003.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1168,
                                    "height": 1824,
                                    "hash": "UWHVh-?^Rks-R:S5RjV@S5NIS5ozxBjFRPWW",
                                    "type": "image"
                                },
                                {
                                    "id": 565993,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6a4083c4-5ea9-4b3f-d527-7c79288bad00/width=450/565993.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1312,
                                    "height": 1712,
                                    "hash": "UMDmHj_M8_8_?v-:VsIUxus.adofskt5t7WC",
                                    "type": "image"
                                },
                                {
                                    "id": 565992,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/29bb646d-d8d8-4ac8-d8ca-611745980f00/width=450/565992.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1088,
                                    "height": 1712,
                                    "hash": "UTF=gX?Z~VtR?F-:t6kCNKWEoKxaRlRka}t6",
                                    "type": "image"
                                },
                                {
                                    "id": 565988,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b9d8e17c-c855-444f-80c0-45acacbfe000/width=450/565988.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1168,
                                    "height": 1824,
                                    "hash": "U9HnHQ~p_29wDi0foyaeIBXSMx9GR5OW-B~V",
                                    "type": "image"
                                },
                                {
                                    "id": 565997,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/da7f5686-3116-4a42-8350-69e5dd98aa00/width=450/565997.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1168,
                                    "height": 1824,
                                    "hash": "UUI4;S_N?HxvcE$*R*M{$*EMIURj9Znixaa{",
                                    "type": "image"
                                },
                                {
                                    "id": 565995,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/95fc3cc1-ac3d-4607-9e9a-6472cd637b00/width=450/565995.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1168,
                                    "height": 1824,
                                    "hash": "URI5Jg~q.7-;WCM|a%jZRoozawM{%NbEV[a$",
                                    "type": "image"
                                },
                                {
                                    "id": 565996,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/34519dfd-508e-49e4-6864-5363827e8c00/width=450/565996.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1312,
                                    "height": 1936,
                                    "hash": "U8B42lW;00s;?wax9Dafw@j]tTfik@axaIkC",
                                    "type": "image"
                                },
                                {
                                    "id": 565990,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a4ac61f1-cbed-4885-215f-14b568958400/width=450/565990.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1584,
                                    "hash": "UHIg_k_1R4$+009GNHkV~U-oogt7E1Ioafr?",
                                    "type": "image"
                                },
                                {
                                    "id": 565985,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/72514f26-982e-49bf-8826-36a2f670a200/width=450/565985.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1312,
                                    "height": 1936,
                                    "hash": "UcIX%B~VR$WY%gWBRkV@E1R*s.t6WCaejYay",
                                    "type": "image"
                                },
                                {
                                    "id": 565984,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/afd989bd-e909-4dfa-cec7-28dbcebfaf00/width=450/565984.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1168,
                                    "height": 1824,
                                    "hash": "UNHnvw~q%K-:J-%2xux]-pSNXS%MMxWUMxNG",
                                    "type": "image"
                                },
                                {
                                    "id": 566001,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1d1629a0-3e5b-442a-f075-803f14321a00/width=450/566001.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1168,
                                    "height": 1824,
                                    "hash": "UMKd@|~p_3~p-;-:E1%M-;M{IUt701t7%Mn%",
                                    "type": "image"
                                },
                                {
                                    "id": 566000,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0ce0668f-f2d5-4d25-5989-a19933f64c00/width=450/566000.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1168,
                                    "height": 1824,
                                    "hash": "UQD9|-.9$%xC_Nx^smsStlW=RPs.bbWBRQkC",
                                    "type": "image"
                                },
                                {
                                    "id": 565999,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f8300ee3-8cb8-44a2-5866-8dfb38b9b100/width=450/565999.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1168,
                                    "height": 1824,
                                    "hash": "ULDSm:NGV@Io~VM|V[RjRnIVozs.M|M|xZxt",
                                    "type": "image"
                                },
                                {
                                    "id": 565983,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bd16a31d-f906-4801-75bc-f54c3dbb4100/width=450/565983.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1168,
                                    "height": 1824,
                                    "hash": "UxMQt+NG~q-;x]t7ShRkWCjtWBjsRQWBoejZ",
                                    "type": "image"
                                },
                                {
                                    "id": 565986,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ed449b2f-384d-41f6-5487-7667c9ee1600/width=450/565986.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1168,
                                    "height": 1824,
                                    "hash": "UKGu:pM{skRj?]s9nhRPEgD%s8M|I@r=IUx[",
                                    "type": "image"
                                },
                                {
                                    "id": 587846,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e41d1fae-a6c7-4347-ef0f-909bac4e6c00/width=450/587846.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJGQ|oD%IU^l}]%3EKbFJ6s:Inoz9@ogbFR%",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/52506"
                        }
                    ]
                },
                {
                    "id": 15431,
                    "name": "Nami (One Piece) Pre and Post Timeskip LoRA",
                    "description": "<h2>Nami (One Piece) LoRA (pre and post timeskip)</h2><h3><u>CHECK BOTH VERSIONS</u></h3><p><strong>Pre Timeskip: </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/15431?modelVersionId=18188\">https://civitai.com/models/15431?modelVersionId=18188</a><br /><strong>Post Timeskip:</strong> <a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/15431?modelVersionId=18189\">https://civitai.com/models/15431?modelVersionId=18189</a></p><p><strong><u>Also check your filters to see all the examples</u></strong></p><p><strong>Making models can be expensive. Do you like what I do? Consider supporting me on </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/Lykon275\"><strong>Patreon</strong></a><strong> 🅿️ or feel free to </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://snipfeed.co/lykon\"><strong>buy me a coffee</strong></a><strong> ☕</strong></p><p>Well, this wasn't easy to get right. One version of Nami alone is already pretty hard to make: she has a very specific tattoo, asymmetrical, she has exactly 2 rings per side on her jeans (or on her skirt before timeskip) and she wears tons and tons of different official outfits. Plus her artworks tend to be inconsistent, so I had to clean the dataset a lot. Not to mention the timeskip problem: she is basically 2 different characters, both very hard.</p><p>At the end of the day I had to accept some compromise. First of all I had to make TWO LoRA's and not one. Second I needed to focus on getting her main outfit right and, most importantly, the tattoo. Everything else came second.</p><p>I think I managed somehow. I made 2 LoRA's, one for pre timeskip Nami and one for post timeskip Nami, both of them can do both versions, but they focus on their respective ones.</p><p>Main outfits are always kind of right, but exactly right about 1/4th of the time. Tattoo is almost always right. Secondary outfits are almost right about 1/4th of the time, depending on how rare they are in artworks.</p><p>The model is not overfitted and can be used on most booru based models. I mostly tried it with AnyLoRA and NeverEnding Dream for realistic shots. <strong>Weight should be around 1 for post timeskip and around 1.2 for pre timeskip for better accuracy</strong>. I suggest using weight 1 if you need just her face and tattoo on non-official outfits.</p><p>Triggers with <code>nami \\(one piece\\)</code> for better accuracy. Also use <code>short hair</code> in pre timeskip version. One of the examples is also using my Wano Style LoRA.</p><p>Please enjoy.</p><p></p><p><strong>How to use LoRA's in auto1111:</strong></p><ul><li><p>Update webui (use <code>git pull</code> <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/embed/mn8fMF10XN4?start=31&amp;end=60\">like here</a> or redownload it)</p></li><li><p>Copy the file to <code>stable-diffusion-webui/models/lora</code></p></li><li><p>Select your LoRA like in <a target=\"_blank\" rel=\"ugc\" href=\"https://www.youtube.com/watch?v=-bMeyXOZwN0\">this video</a></p></li><li><p><strong>Make sure to change the weight according to the instructions</strong> (by default it's <code>:1</code>)</p></li></ul><p></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 5,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 31338,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3310,
                        "thumbsDownCount": 1,
                        "commentCount": 10,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 120
                    },
                    "creator": {
                        "username": "Lykon",
                        "image": "https://cdn.discordapp.com/avatars/180327464155742208/59254be18ccd627daf138d053327485d.png"
                    },
                    "tags": [
                        "anime",
                        "character",
                        "girl",
                        "photorealistic",
                        "sexy",
                        "female",
                        "one piece",
                        "woman",
                        "beautiful",
                        "cute",
                        "girls",
                        "portraits",
                        "realistic",
                        "women",
                        "nami"
                    ],
                    "modelVersions": [
                        {
                            "id": 18189,
                            "name": "post timeskip",
                            "index": 1,
                            "modelId": 15431,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": null,
                            "publishedAt": "2023-04-19T08:31:59.853",
                            "availability": "Public",
                            "trainedWords": [
                                "nami \\(one piece\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 27888,
                                "ratingCount": 3262,
                                "rating": 5,
                                "thumbsUpCount": 3302,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 15210,
                                    "sizeKB": 147567.2177734375,
                                    "name": "nami_final_offset.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-03T21:56:48.656Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "2649A274",
                                        "AutoV2": "3D98234D54",
                                        "SHA256": "3D98234D5442EB4EB8C552397EE880ABD4859592A7DBBD7DA10D56C207791319",
                                        "CRC32": "E47D1DD4",
                                        "BLAKE3": "DB830DB8640AB59CB61D43DFEE08BE96F320A2906E05522AB3075DE6FBCD4A5D",
                                        "AutoV3": "D5A11D4F80FC"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/18189",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 366074,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/08dafdeb-e171-4e2a-534d-a194c6b48000/width=450/366074.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UHJbBjNM2|u6ZOx^4;af05I9?bnhyF$JtRJC",
                                    "type": "image"
                                },
                                {
                                    "id": 187077,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/afb0ff27-2bb5-491d-6f16-8632f7061000/width=450/187077.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UWI5AEI9EMbc?wIUo#X7WBxaa$NdRm%1RPSQ",
                                    "type": "image"
                                },
                                {
                                    "id": 187076,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e147d008-06cb-4f3b-52c7-995b67d6cc00/width=450/187076.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UVLMqw9HRhRk~UE1tQNHVrNaI[s.9Zoz-oRk",
                                    "type": "image"
                                },
                                {
                                    "id": 187075,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1dd3fd2f-b45d-447a-34b0-80419528db00/width=450/187075.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UMLNif191TNz+sK+ETIVRQx[?Coe~o-NOZEl",
                                    "type": "image"
                                },
                                {
                                    "id": 187074,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e70d8cfb-a96b-4fe0-9598-8aee2f0ff900/width=450/187074.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UXJt9+9FabIp~Ar;9uR.RPxFt7WXxbWBxZWC",
                                    "type": "image"
                                },
                                {
                                    "id": 187073,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b5023f86-97c7-4a5e-0833-50fc2a50b300/width=450/187073.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UaI}YTH=PCxv.AV@Ott7A0xb%Mf,NfsoNHWC",
                                    "type": "image"
                                },
                                {
                                    "id": 187078,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2495c9dc-1014-45b7-dbfe-fa08d525ba00/width=450/187078.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1344,
                                    "hash": "UIKUTi00CA-n-rsp5s$y0pxu?v$gT2nOo~t6",
                                    "type": "image"
                                },
                                {
                                    "id": 187072,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9c1b08e6-565f-47c6-cfd0-8c998d84f100/width=450/187072.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UWKw;5.7PXxZIw$ys;$z%MtRkCoI9~tmXTn~",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/18189"
                        },
                        {
                            "id": 18188,
                            "name": "pre timeskip",
                            "index": 2,
                            "modelId": 15431,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>use at around 1-1.3 weight</p>",
                            "publishedAt": "2023-04-29T17:38:39.714",
                            "availability": "Public",
                            "trainedWords": [
                                "nami \\(one piece\\)"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3450,
                                "ratingCount": 12,
                                "rating": 4.92,
                                "thumbsUpCount": 20,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 15209,
                                    "sizeKB": 147567.2177734375,
                                    "name": "nami_pre_timeskip_offset.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-03T21:56:40.411Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "338B734D",
                                        "AutoV2": "95C0EA0FD7",
                                        "SHA256": "95C0EA0FD7EA6403289111F13454D7922BA9B6CEC93E87C8C3E54E836EFBEF0B",
                                        "CRC32": "2DB93779",
                                        "BLAKE3": "031BC3AAE9655DE62BE1C49B8BD61ABD1B9B8E8425C68136048A7E82934FD4FC",
                                        "AutoV3": "E616AF6650C4"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/18188",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 366077,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f289ceb1-c156-46a2-192d-394fddeff800/width=450/366077.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UPK^z2?E7joc9H#OohacqGV=Sj$d5Fn$slNG",
                                    "type": "image"
                                },
                                {
                                    "id": 187055,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d68d3e0a-647a-445e-ba61-40a1b41ee100/width=450/187055.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UMMtKw?G69NGpJxAx?S$?Gxutnx_BaaJ%hEN",
                                    "type": "image"
                                },
                                {
                                    "id": 187058,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/241f67c9-6cdb-435f-945a-5fd8fa1a8b00/width=450/187058.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UBJ*9d000c?c0h4oW.-;vNoaOeM^F~Rf_1WE",
                                    "type": "image"
                                },
                                {
                                    "id": 187057,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0ba67f15-ece5-4539-49fa-894204708b00/width=450/187057.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USLzBc~UyBx[^*x]X9%L4oxujFD*-QM{t8R*",
                                    "type": "image"
                                },
                                {
                                    "id": 187056,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0802b077-b644-4379-1e1b-6551316f5c00/width=450/187056.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UaHpYm9IYRO]I0nRM{IVs;I[ngad4;r=o#j^",
                                    "type": "image"
                                },
                                {
                                    "id": 366076,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/82c57bec-411a-444d-0dd1-fa881ca3be00/width=450/366076.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UNKdiEE33Ex]K-V]t.JCqZIslCRk8_t8$eNH",
                                    "type": "image"
                                },
                                {
                                    "id": 366075,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cc50e724-aabb-4e8e-7ed7-0256e1006200/width=450/366075.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 920,
                                    "height": 1376,
                                    "hash": "UKKnJX-S7%o}8~:~V}IU*dVqIx-ODPW?XBIU",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/18188"
                        }
                    ]
                },
                {
                    "id": 165876,
                    "name": "2D Pixel Toolkit (2D像素工具包)",
                    "description": "<p><strong><span style=\"color:rgb(250, 82, 82)\">QQ交流群753289747，群内会不时发布内测模型</span></strong></p><h1 id=\"heading-9\"><strong><span style=\"color:rgb(250, 82, 82)\">SDXL版本</span></strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/352841/sdxl2d-pixel-toolkit-2d\">【SDXL】2D Pixel Toolkit （2D像素工具包） - Sprites_128 | Stable Diffusion LoRA | Civitai</a></h1><p>好用的话麻烦给个五星好评哈哈哈</p><p>If it's useful, could you please give it a five-star review? Hahaha</p><p><strong><span style=\"color:rgb(250, 82, 82)\">九个不同的Lora，角色和序列帧动画，冷兵器，枪械，植物，动物，书籍，药水瓶和等距建筑</span></strong></p><p><span style=\"color:#fa5252\">Nine distinct Lora fonts, character and frame-by-frame animation, cold weapons, firearms, plants, animals, books, potion bottles, and isometric architecture.</span></p><p>专门为独游开发训练的模型，花费了半个多月的心血，原本是打算自用不公开的，但后来想到独游事业的发展，还是公开吧，希望能够帮助到大家，游戏上线了评论里说下我可能会去玩哈哈</p><h3 id=\"heading-96\">直出的像素图是<strong><span style=\"color:rgb(250, 82, 82)\">真·像素图</span></strong>，不是对不齐格子的伪·像素图，并且边缘清晰，不会模糊，也没有污染，对其他Lora的兼容性也都OK，可同时使用其他人物Lora，<strong><span style=\"color:rgb(250, 82, 82)\">强烈推荐配合插件palettize使用，可以直出像素图↓↓↓</span></strong></h3><h3 id=\"heading-97\"><a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/Astropulse/sd-palettize\"><strong>GitHub - Astropulse/sd-palettize：Automatic1111 扩展，用于对生成的图像进行调色</strong></a></h3><p><strong>大模型推荐 <span style=\"color:rgb(250, 82, 82)\">anything4.5</span>，<span style=\"color:rgb(250, 82, 82)\">anylora</span>，还有<span style=\"color:rgb(250, 82, 82)\">ReV Animated</span></strong></p><p><strong>如果<span style=\"color:rgb(250, 82, 82)\">只是想出像素图</span>，关键词是 <span style=\"color:rgb(250, 82, 82)\">pixel,pixel art,pixelart,xiangsu,xiang su</span></strong></p><p><strong>如果想出<span style=\"color:rgb(250, 82, 82)\">横版2D的像素人物</span>，请务必在上面的关键词后面再加上 <span style=\"color:rgb(250, 82, 82)\">((Side view)),full body,solid background</span></strong></p><p>Originally, I intended to use it for myself and not make it public, but later I realized that the development of the indie game industry needs it, so I made it public, hoping it can be helpful to you.The game has been launched and the comments say that I may go to play haha.</p><p>The pixel image produced is a true pixel image, not a pseudo-pixel image that is not aligned with the grid. The edges are clear, not blurry, and there is no contamination. It is also compatible with other Lora models and can be used simultaneously with other character Loras. </p><h3 id=\"heading-98\">The straight out pixel image is a <span style=\"color:rgb(250, 82, 82)\">true pixel image</span>, not a fake pixel image with uneven grids. The edges are clear, not blurry, and not contaminated. It is also compatible with other Loras and can be used with other Loras simultaneously.<span style=\"color:rgb(250, 82, 82)\"> It is strongly recommended to use the palettize plugin to directly generate true pixel images ↓↓↓</span></h3><h3 id=\"heading-18\"><a target=\"_blank\" rel=\"ugc\" href=\"https://github.com/Astropulse/sd-palettize\"><strong>GitHub - Astropulse/sd-palettize：Automatic1111 扩展，用于对生成的图像进行调色</strong></a></h3><p><strong><span style=\"color:rgb(193, 194, 197)\">Model recommendation </span><span style=\"color:rgb(250, 82, 82)\">anything4.5</span>,<span style=\"color:rgb(250, 82, 82)\">anylora </span>or<span style=\"color:rgb(250, 82, 82)\"> ReV Animated</span><br />If you only want to create pixel images, the keywords are <span style=\"color:rgb(250, 82, 82)\">pixel, pixel art, pixelart, xiangsu, xiang su</span><br />If you want to create a side view, full body, solid background pixel character, be sure to add <span style=\"color:rgb(250, 82, 82)\">((Side view)), full body, solid background</span> after the above keywords.</strong></p><p></p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": false,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 20682,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3271,
                        "thumbsDownCount": 0,
                        "commentCount": 38,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 2706
                    },
                    "creator": {
                        "username": "SYK006",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b1e41930-9b33-4975-bb70-69797b20fcea/width=96/SYK006.jpeg"
                    },
                    "tags": [
                        "asset",
                        "game asset",
                        "pixel",
                        "tools",
                        "2d",
                        "game",
                        "assets",
                        "gamedev"
                    ],
                    "modelVersions": [
                        {
                            "id": 186677,
                            "name": "Sprites_64",
                            "index": 0,
                            "modelId": 165876,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-10-17T16:29:28.245",
                            "availability": "Public",
                            "trainedWords": [
                                "pixel,pixel art,pixelart,xiangsu,xiang su"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 14712,
                                "ratingCount": 399,
                                "rating": 5,
                                "thumbsUpCount": 1048,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 180411,
                                    "sizeKB": 295024.3671875,
                                    "name": "pixel sprites.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-11-21T12:20:49.194Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "8D3F362D",
                                        "AutoV2": "96D2011E9E",
                                        "SHA256": "96D2011E9EC40C442ADBAB8004E9C972055F153046A22FA49679007C4FBED125",
                                        "CRC32": "85327BD0",
                                        "BLAKE3": "32D01E0FD1ED054DDCCFE2C1B1CD65EBA5262302AAA712F24BDC903026681B92",
                                        "AutoV3": "C1C30E7EAC72"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/186677",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3615077,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/847ea402-0a39-46f4-82a5-fa6c66941cb2/width=450/3615077.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1417,
                                    "height": 2841,
                                    "hash": "U47n8x%MW:bI~TWAj[oe0gRkjZj?5UoJWBay",
                                    "type": "image"
                                },
                                {
                                    "id": 3001293,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3ea27016-4007-4343-8873-89f1a8884c86/width=450/3001293.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1450,
                                    "height": 2236,
                                    "hash": "U39Z[oxb$c?G0Wj@IrIqD4oInOW9~ns:t4oz",
                                    "type": "image"
                                },
                                {
                                    "id": 3615075,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1307e2e7-92f9-4b86-bafd-c22af5517e03/width=450/3615075.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1600,
                                    "height": 512,
                                    "hash": "UJI|~?s:s.xZ~oWXo0s.rWWWoKay~9oebHoL",
                                    "type": "image"
                                },
                                {
                                    "id": 3615076,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b83007a4-47cf-4361-b90a-2a8951e85cbd/width=450/3615076.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1417,
                                    "height": 567,
                                    "hash": "U38zuwt6azofT#j[WWbI#PoLj?WB5aWXj@j?",
                                    "type": "image"
                                },
                                {
                                    "id": 3615078,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad079395-326b-4993-bd10-487b929cb4f4/width=450/3615078.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1420,
                                    "height": 568,
                                    "hash": "U00,FsboR7nT$xkWV[a1L#nmo|SfEBnOtLTb",
                                    "type": "image"
                                },
                                {
                                    "id": 3000368,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0797aa27-345a-40bf-a43f-107e0990101a/width=450/3000368.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U6KAZo01?GIq%LNeIqM}oIIps:%0~9RPNG-:",
                                    "type": "image"
                                },
                                {
                                    "id": 3000542,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2d898352-40ad-4390-a9f7-96e22ed8eccc/width=450/3000542.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 640,
                                    "hash": "URK,$,M|~T?G-noeNHWV=_t6NIR*t7R*n$s:",
                                    "type": "image"
                                },
                                {
                                    "id": 3000541,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8277c75a-052b-4e3f-9245-0d0c3b20eb08/width=450/3000541.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 640,
                                    "hash": "UML3[NIp~U^%%2xaj?Rj%KayNGR*%KWBWXt7",
                                    "type": "image"
                                },
                                {
                                    "id": 3000577,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/41497c84-9641-46b3-8321-cf57ae95ea0e/width=450/3000577.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U49aBH=x015rL,wd%dNbInS3ohxC0-OW}=$P",
                                    "type": "image"
                                },
                                {
                                    "id": 3000578,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bb666979-ea21-43c9-920e-52261ab7fd28/width=450/3000578.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UILM*6xa~UkW-UobNaWF%IWVM}smWYR:t6s*",
                                    "type": "image"
                                },
                                {
                                    "id": 3000615,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9bb0ca91-8c85-45cc-bd18-3507ece8463f/width=450/3000615.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UYLN6.M}~V-oxbays,j[^*xZM|RkbDofNHR*",
                                    "type": "image"
                                },
                                {
                                    "id": 3000624,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b3423150-b4fc-46bc-890a-07c1688534c7/width=450/3000624.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UfLgIMR+~V%1xaj@k9f8~BoeRkfQxtazRkbF",
                                    "type": "image"
                                },
                                {
                                    "id": 3000744,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/939a2400-f5b6-4def-8a1e-8eb905e44762/width=450/3000744.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 512,
                                    "hash": "UTIDz1RkxZt6^hoe$$oL~9oesnn%S5oJENaz",
                                    "type": "image"
                                },
                                {
                                    "id": 3000748,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f0a55cee-bfb0-44ce-892f-7e4bf36b2494/width=450/3000748.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 512,
                                    "hash": "UQG[WfkCb_jZ0qWXozWC~Vj[t6azIqayRjj[",
                                    "type": "image"
                                },
                                {
                                    "id": 3000750,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/88ab0f9e-e261-4303-8138-638e50326bdc/width=450/3000750.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 512,
                                    "hash": "UaJ*6IV]~Uxs9bjb-nt6^*s:nij[IWWBt7WE",
                                    "type": "image"
                                },
                                {
                                    "id": 3000911,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b3be16d3-c8e3-46f0-999a-88930e4a7882/width=450/3000911.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UAEU439c03~A4;%0-oIp0Nxs?XE3^kIpI.%2",
                                    "type": "image"
                                },
                                {
                                    "id": 3000913,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f17f4f97-afd9-4fd9-97e7-57eb7479ba0e/width=450/3000913.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UOK0D}-UV@Ip}?Rk~9xab^W=j@sm=@s,JCWr",
                                    "type": "image"
                                },
                                {
                                    "id": 3000944,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5dfc0cb0-88bb-4916-b207-4876b5ba329c/width=450/3000944.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U9Fg]wMx9#4?0n0N~AxoRP^MxHD+0is:t6R*",
                                    "type": "image"
                                },
                                {
                                    "id": 3000965,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/563dbe1f-1254-422a-8691-cd754e5c3f8c/width=450/3000965.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U3Ed;Q#n01}?14oy%1$g00^hAu0$7f589ZS}",
                                    "type": "image"
                                },
                                {
                                    "id": 3000967,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f6696b4-c958-41e9-80cc-d4d967dfeb68/width=450/3000967.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U8Fqp@01JDpJ14I;~AV[00~UIVnhZ}?HIpR%",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/186677"
                        },
                        {
                            "id": 265506,
                            "name": "Sprites_32",
                            "index": 1,
                            "modelId": 165876,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-12-17T12:45:36.037",
                            "availability": "Public",
                            "trainedWords": [
                                "pixel,pixel art,pixelart,xiangsu,xiang su"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 815,
                                "ratingCount": 972,
                                "rating": 5,
                                "thumbsUpCount": 981,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 206748,
                                    "sizeKB": 36974.6640625,
                                    "name": "pixel_sprites_32.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-12-18T12:45:38.912Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "51340B17",
                                        "AutoV2": "D1C7D1D470",
                                        "SHA256": "D1C7D1D4702E0FCBC2CB054276574F402AAF1F5D4DDBF7D9EECEB5682B15098C",
                                        "CRC32": "19B1DD3A",
                                        "BLAKE3": "4FF17E2778411D666A8EBC15C5F022283D8FFDD0D57BD4F8A24767139AA95051",
                                        "AutoV3": "C07827AC824E"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/265506",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 4656940,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4540ddb1-66a6-4054-ace2-70242e7d1ad8/width=450/4656940.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UaL|lm-;~Vxu?uof%MozNHM{xuWB_2aeM{WB",
                                    "type": "image"
                                },
                                {
                                    "id": 4657381,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/80130116-5a53-4538-8071-0ae14ee77607/width=450/4657381.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UIKK1R4o}?M|02t7RQxu};xuIpxtD+M{%MRj",
                                    "type": "image"
                                },
                                {
                                    "id": 4656938,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1eccc61b-8cc2-4d9a-bf94-c3effdbbb22f/width=450/4656938.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UYK_2qxu?vxaF3of-Tt6~W-o-:Ip%2WCW=M{",
                                    "type": "image"
                                },
                                {
                                    "id": 4657023,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/38a6e887-d66e-4334-9f7b-664e28cdb2da/width=450/4657023.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UDKdC.${~TRQ00E8D,WXISV=jGj=x^WZM|%L",
                                    "type": "image"
                                },
                                {
                                    "id": 4657049,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dbe8c3f6-5d1f-4a0f-bdf3-a590dbdb63e1/width=450/4657049.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U*Oy*8t7_NbIRkWBofofx^j[jZof%1oeofj]",
                                    "type": "image"
                                },
                                {
                                    "id": 4657374,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1acdc6fa-d39c-4013-9e9d-0c7dc0af04c4/width=450/4657374.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UIJtS94:4;02~U-oxGM{~VD*M|xtoyIpM|js",
                                    "type": "image"
                                },
                                {
                                    "id": 4656991,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1efe045c-ed80-48d0-8115-2766080d5643/width=450/4656991.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UsQ+yrof?^t7o2ofkCV@%gj[RPj[xuayRjbH",
                                    "type": "image"
                                },
                                {
                                    "id": 4657034,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/787d2c84-bf76-4cf4-a6a0-5fd320559ef2/width=450/4657034.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UsLqC2tQJPRQ_4ofoMRjx^WBxakC-:aeoeoz",
                                    "type": "image"
                                },
                                {
                                    "id": 4657012,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d2271542-8459-4cad-a863-b3f859e0d9a8/width=450/4657012.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U$PPikRj?w%Ls.bbWEnh-;ofRjWBxun$baR+",
                                    "type": "image"
                                },
                                {
                                    "id": 4657051,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e42e75ed-99d2-415a-9caa-67a41c23b511/width=450/4657051.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UuQ9vDV@_4%MW:ofs:WB%hozROWAs:Rjbbt7",
                                    "type": "image"
                                },
                                {
                                    "id": 4657033,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e459397f-2bab-4545-8057-ef6f5ce9dd3a/width=450/4657033.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UrQSk^of?^t7NFfkspae%Mj[M{ae%3j[R*WV",
                                    "type": "image"
                                },
                                {
                                    "id": 4657042,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/211d7c79-03a1-45ce-8090-c865d28daa45/width=450/4657042.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UjR..JoL?^x]Rjj[xuWByDkCVYaKx]WBVst7",
                                    "type": "image"
                                },
                                {
                                    "id": 4657043,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/01cf5c97-7c5c-42e2-8b55-b712ef70ee0d/width=450/4657043.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UzP?UKs:_NogR%aes:ofx]WBadt7xbkCbHj?",
                                    "type": "image"
                                },
                                {
                                    "id": 4657376,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/65c13b82-dcb3-4c07-808f-93a54a17623a/width=450/4657376.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UQI4tj%L~UM|x[ofWBoLR*WC%1xtWBoft6of",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/265506"
                        },
                        {
                            "id": 365383,
                            "name": "Animal",
                            "index": 2,
                            "modelId": 165876,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2024-02-28T14:53:49.634",
                            "availability": "Public",
                            "trainedWords": [
                                "animal,pixel,pixel art,pixelart,xiangsu,xiang su"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 391,
                                "ratingCount": 109,
                                "rating": 5,
                                "thumbsUpCount": 200,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 292100,
                                    "sizeKB": 295024.375,
                                    "name": "PixelAnimal.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-02-28T14:56:34.438Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "4E98BBD6",
                                        "AutoV2": "F6C47CE309",
                                        "SHA256": "F6C47CE309CB71BD9CA5C801AD3E5600E66668EBBD0AC528F2A94056CAE66AAE",
                                        "CRC32": "76BD226A",
                                        "BLAKE3": "012AE10FC2A7D8D1BADAB32209EB32C660B2D45ED423698A28111CEA352036A0",
                                        "AutoV3": "9A1084E32FA6"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/365383",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 7221164,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/34b73d5d-e860-428b-85f7-80962910cb60/width=450/7221164.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 5121,
                                    "height": 1183,
                                    "hash": "UiF$O*WWsmR*~qofR+bH~Wj]j[of_No0oeaf",
                                    "type": "image"
                                },
                                {
                                    "id": 7220954,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/33aa1a8c-d7b8-4847-bc18-ec9581bac545/width=450/7220954.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UTF$9JyF9}tRX=x^j?oL0%S5=sM{IvNyXRWB",
                                    "type": "image"
                                },
                                {
                                    "id": 7220942,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c8630184-0c1e-4f43-bcea-0f2c0ddf71a7/width=450/7220942.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "ULBCPzoe0zayt6j[R*ay0gWV}?j[IpWVxaoL",
                                    "type": "image"
                                },
                                {
                                    "id": 7221305,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1d5d23ef-25d5-4f37-bd34-9ca7b05a3bf2/width=450/7221305.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UHH27pNc?w-o-ooLIpWV%$xZMdNHEkW;-Tn%",
                                    "type": "image"
                                },
                                {
                                    "id": 7221306,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/02c098af-44df-4034-b717-8b22e4e371c3/width=450/7221306.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UbE{nWxC-os,7jWBR+W;x_R-V?ogXAozn$WC",
                                    "type": "image"
                                },
                                {
                                    "id": 7221307,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4f062ea5-b66f-4553-ae93-75871b72308f/width=450/7221307.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UeBhWJkqyDjYLNjsbbbbW@VsVYkCJ;kDV@jF",
                                    "type": "image"
                                },
                                {
                                    "id": 7221693,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a5c02476-29a5-4284-83b4-8bef0ef2f8e9/width=450/7221693.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UlN0k{S3.T%1t9juW.Wq*0s:rqNbSdbFxYoL",
                                    "type": "image"
                                },
                                {
                                    "id": 7221696,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fd2de556-57ea-4126-bb8c-f59090ec8be7/width=450/7221696.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U37w1xR*1O-T,?9^Nx-90mJA}An*5:=_,:Ej",
                                    "type": "image"
                                },
                                {
                                    "id": 7221692,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a4c2b719-5842-4106-93e9-80b42ab618e6/width=450/7221692.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UIFFNmxt^+IpNxoJs.bI~VRjRj%LkCbHofjY",
                                    "type": "image"
                                },
                                {
                                    "id": 7221701,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f8a769fa-448d-4fd7-b900-5f0892913a89/width=450/7221701.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UHB2Y[NI0%-S$gj@NdWW0%xF}qIrI[WV$fso",
                                    "type": "image"
                                },
                                {
                                    "id": 7221690,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/37ecc66a-de67-46cf-b3ca-9fab67d1f72c/width=450/7221690.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UCBL#5$%0NAFV@WXbvoJ0#J8}?,;bujZniW=",
                                    "type": "image"
                                },
                                {
                                    "id": 7221702,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/168a0eb9-da10-447c-88fe-293cec672451/width=450/7221702.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UOGRq^t7~VWCo#f6jFj[~AaeaKt6NbazxYoL",
                                    "type": "image"
                                },
                                {
                                    "id": 7221691,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d0ab2211-c639-4c39-9854-efb149bb8020/width=450/7221691.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U8DR=|s,03Nd4UbHtia{5YWV~As.FafP#RjZ",
                                    "type": "image"
                                },
                                {
                                    "id": 7221697,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d966a1d1-d9e1-4c20-be21-3bf0046bc760/width=450/7221697.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U7BMVzof00WX0Njt^%bH0MWV~Boe?Gj[D*ay",
                                    "type": "image"
                                },
                                {
                                    "id": 7221694,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/16760b22-42bc-435c-ad63-084f4d96f397/width=450/7221694.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U7DuJ8}?0104IVM}tQ-n0#Ip^O?F%exsMzE3",
                                    "type": "image"
                                },
                                {
                                    "id": 7221695,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a8c259ca-10e2-4cb8-9738-ed6690e87097/width=450/7221695.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UJEfsPtM~pj{W{aej:f,.AV_R5ovx+oznmaJ",
                                    "type": "image"
                                },
                                {
                                    "id": 7221698,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e94beff1-8eaf-4302-9aa4-2932757ccda0/width=450/7221698.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U8AJ1ZM}0P^ir=WXNdsm0+oy};Ip0%s-^MNI",
                                    "type": "image"
                                },
                                {
                                    "id": 7221703,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/caab75ab-e41d-481b-b9d2-6e080f30d28b/width=450/7221703.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UMFOu^E-Bp%g7%wJs,bwETVr#QIp5sOEwJnN",
                                    "type": "image"
                                },
                                {
                                    "id": 7221700,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bf9ae4a9-e998-4c63-87e6-439a68d97402/width=450/7221700.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U79i#YEO0j};$$s-I=I?0%$$}q9x9_R,=w$h",
                                    "type": "image"
                                },
                                {
                                    "id": 7221704,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/782ef19b-409e-4f7e-b2eb-fb21450545d4/width=450/7221704.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U77^ujof00R*?Gj@E2az01WV~Vof4;ay?GoK",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/365383"
                        },
                        {
                            "id": 230962,
                            "name": "Cold weapon",
                            "index": 3,
                            "modelId": 165876,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-11-19T04:52:32.793",
                            "availability": "Public",
                            "trainedWords": [
                                "weapon,no humans,pixel,pixel art ,pixelart",
                                "axe",
                                "sword",
                                "bow"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 1063,
                                "ratingCount": 81,
                                "rating": 5,
                                "thumbsUpCount": 110,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 178226,
                                    "sizeKB": 295024.3671875,
                                    "name": "pixel sword.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-11-19T06:05:49.244Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "77CD5EA2",
                                        "AutoV2": "D35F5770DA",
                                        "SHA256": "D35F5770DA510E8AB87BE9D1A88B2FBE4EBDA946C1E7F8F69EFD79245C8AD7D9",
                                        "CRC32": "71A8F683",
                                        "BLAKE3": "FD8626E2BCACF42E784265DB1FBA0613ED1ED70F511831232C75885991A3D65E",
                                        "AutoV3": "F6A6AABFFF70"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/230962",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3740009,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4c65ac51-d1ed-457b-90a1-d385c5e0c825/width=450/3740009.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2688,
                                    "height": 1536,
                                    "hash": "U~KK.*~q%MIUofoffka|j@fRa|jtofofj[f6",
                                    "type": "image"
                                },
                                {
                                    "id": 3739975,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d433dd85-17a9-4e2e-a30a-da8a8e356a3f/width=450/3739975.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U55X[toz00RO-=kDI9V?aEa#b$oJrqaeT0oz",
                                    "type": "image"
                                },
                                {
                                    "id": 3739976,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e1e04e47-0937-4119-9166-13dbe9e0dc86/width=450/3739976.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UA7,[LIp0L?F};NH5W-US~jui_f%9as:%2Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 3739978,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b8935faf-db24-426c-b7f2-672cc7747a49/width=450/3739978.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U17K9t%2009a-:oeIVRkR39uKR~AM{RktQxt",
                                    "type": "image"
                                },
                                {
                                    "id": 3739985,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/807f01d2-1090-42d6-bed1-1177e162ce78/width=450/3739985.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U74LRtj[9DWDtSj?ROa$RKaytWj]aIa#kYj=",
                                    "type": "image"
                                },
                                {
                                    "id": 3739977,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4f7bd147-3c8b-40e9-aac0-e38f21b045de/width=450/3739977.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U65}XGNH00-V}@R-5R$$%LWXIVslRNoLkZWB",
                                    "type": "image"
                                },
                                {
                                    "id": 3739981,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e2dfcd42-232b-40e6-8d11-af6127bf8b43/width=450/3739981.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U267[u%200D*xtoeNHRkjB9ZIw~qR*R*j[xt",
                                    "type": "image"
                                },
                                {
                                    "id": 3739979,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2dfd87ff-ed4a-4444-afd2-0ccd32bb1498/width=450/3739979.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U66*5YIp00?G~9R*58%0JPs:whI.57xZ={EL",
                                    "type": "image"
                                },
                                {
                                    "id": 3739983,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/15b4ac4f-b4ad-4995-b172-ffb9b117de7c/width=450/3739983.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U87AiGNG0J-p}[Rk5Q%1xojcN1k7Eas:xLNG",
                                    "type": "image"
                                },
                                {
                                    "id": 3739984,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6978905a-88c0-4359-9aa9-1f2fa1cd8770/width=450/3739984.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U76%~SIp0J?G~ANH58%1t0oMRpSJD~xZxdIo",
                                    "type": "image"
                                },
                                {
                                    "id": 3739982,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/36ea542b-1ec6-4615-aa5b-34d604c05d15/width=450/3739982.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U97wZ.Io0K?H~7NG9h-otRWBRixa9tof%2WA",
                                    "type": "image"
                                },
                                {
                                    "id": 3739986,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7893e4c1-c7b1-4e04-afc5-580310a9ea43/width=450/3739986.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UC8gBLIp0K={~9NH59%2kWoLaKS1E1s:%3I;",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/230962"
                        },
                        {
                            "id": 230453,
                            "name": "Gun",
                            "index": 4,
                            "modelId": 165876,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-11-18T19:39:43.094",
                            "availability": "Public",
                            "trainedWords": [
                                "gun,no humans,pixel,pixel art ,pixelart"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 950,
                                "ratingCount": 53,
                                "rating": 5,
                                "thumbsUpCount": 73,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 180340,
                                    "sizeKB": 295024.3671875,
                                    "name": "pixel gun.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-11-21T10:30:43.290Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "67AEDC76",
                                        "AutoV2": "9EACB93CB9",
                                        "SHA256": "9EACB93CB9E90662E9F1FB7795B13EC60D7A654C1F57F6C58B08D3E2AACDDC79",
                                        "CRC32": "4FD4E2E0",
                                        "BLAKE3": "8E47CCEDF3ABF78F48E6D68FE31F8361EFCBF7CF628EC1F6DD69219827B567DB",
                                        "AutoV3": "DE033B4C1EBB"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/230453",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3728605,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6e6c32bc-c495-418c-be27-6fc3a2fee1e6/width=450/3728605.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UIIEU{-n-mbd4VRjjYj]~7NHIqs+-PxukDn#",
                                    "type": "image"
                                },
                                {
                                    "id": 3728537,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ebcea0c3-3176-4a79-b776-a01427a6c3dc/width=450/3728537.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U2B{$9OHwb^i~CV[Rj$%Bl$yERNd0xS}xuEg",
                                    "type": "image"
                                },
                                {
                                    "id": 3728395,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2669d6bc-6981-41b7-ac56-1edee198be01/width=450/3728395.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U8E2,]=^aIJE00adkBkD~oI]RpxA0KNfs;ng",
                                    "type": "image"
                                },
                                {
                                    "id": 3728385,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c204137e-5e59-47d3-8893-a5b2bc55f4c8/width=450/3728385.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U5D+[7}k]{tS-=V?nMoz^sA1EnniD$pJTMRO",
                                    "type": "image"
                                },
                                {
                                    "id": 3728396,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f4188f88-3135-4932-9018-382dee4e6cc6/width=450/3728396.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U3A]mR0g0g%M0K-U9vxt0~fl-oaK02Se~AIV",
                                    "type": "image"
                                },
                                {
                                    "id": 3728514,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/83f57150-3a63-4854-9a08-88fc82d81e73/width=450/3728514.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U4EoY_~7S$9*%Mn#W?S6~9E8jY=?nhSjs7xA",
                                    "type": "image"
                                },
                                {
                                    "id": 3728567,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/529c9908-647a-470f-9a95-5bd694b967ab/width=450/3728567.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U29GK?0}0e-p?Z$j9v%100Iu~As700R*^jRj",
                                    "type": "image"
                                },
                                {
                                    "id": 3728579,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3f0c4326-b56c-4b6c-a3d9-fc625d96c154/width=450/3728579.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U6E{FO%h=@#P%MV[s+nN~oV?9wXooatQNyXo",
                                    "type": "image"
                                },
                                {
                                    "id": 3728604,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d9103161-48f3-484a-8970-1e619e39d444/width=450/3728604.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U1E2Xy9%03$}00R5x]NH1*$^acJD0OBC}lnh",
                                    "type": "image"
                                },
                                {
                                    "id": 3728606,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e40971b-f71f-45d3-a36f-962cb1308981/width=450/3728606.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UBG*pIs,%1WBE29aW=t7~Tt7IVt79b%LxWRP",
                                    "type": "image"
                                },
                                {
                                    "id": 3728607,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8d7dcf2e-a7bd-46a5-b40f-153f3ce4958e/width=450/3728607.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U5E.qq}*k7FO^*M}nhbH-$Eni~=p9w%Lbdr=",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/230453"
                        },
                        {
                            "id": 232251,
                            "name": "Plant growth",
                            "index": 5,
                            "modelId": 165876,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-11-20T06:36:10.892",
                            "availability": "Public",
                            "trainedWords": [
                                "plant growth process, reference table, no people, flower, gray background, simple background, growth stage, five stages, from young bud to luxuriant, still life, plant, leaf, soil,pixel,pixel art,pixelart,xiangsu,xiang su,no humans"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 965,
                                "ratingCount": 214,
                                "rating": 5,
                                "thumbsUpCount": 310,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 179231,
                                    "sizeKB": 295024.375,
                                    "name": "pixel plant growth.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-11-20T06:26:03.698Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "D8342F33",
                                        "AutoV2": "8EF4E85D83",
                                        "SHA256": "8EF4E85D83FAE537A6E2BF6AAFEED07572E78DB6332D78EADC725C8D5968891B",
                                        "CRC32": "DD470105",
                                        "BLAKE3": "4678F8DD76F2AF3032361A8153459D4A27D50F956E740E7C985E3CD13B33127D",
                                        "AutoV3": "788C48503786"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/232251",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3768258,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/52efd9ab-c0a4-470d-859d-b4dea955571e/width=450/3768258.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "UBG929?DxnkF?doHM|f,-yIWWIt5$^R;tQjD",
                                    "type": "image"
                                },
                                {
                                    "id": 3768363,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1eeba198-92c9-4574-be60-2dc1039b727a/width=450/3768363.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "UMI#okWE00WA~qR*IUaxr{Rif$tR0Kocxuoz",
                                    "type": "image"
                                },
                                {
                                    "id": 3768394,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7839617f-6320-49a2-88bc-83970570706d/width=450/3768394.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "U7IEkPtj=#of56R*D%WB}_Vv5Oxt00of?axa",
                                    "type": "image"
                                },
                                {
                                    "id": 3768349,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/54c1be86-2c36-45e2-8806-67a06b34df9a/width=450/3768349.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "UIH.D_WrIXad~pR*E1oJM,e.NFxu01s--:og",
                                    "type": "image"
                                },
                                {
                                    "id": 3768405,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fa05ed19-5b9e-48a0-8e6d-c3e73c2b7af2/width=450/3768405.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "UPHLh+t8%3fO~qfRRjoei+WAR$ogWBoct7WE",
                                    "type": "image"
                                },
                                {
                                    "id": 3768277,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5fe56e5a-7439-406a-bb27-6c525973417b/width=450/3768277.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "U4HV0S%h?0waIdMx0Joz04aII,kY00x^~XeT",
                                    "type": "image"
                                },
                                {
                                    "id": 3768302,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2acf31aa-b577-458e-9db5-66bfd555c92d/width=450/3768302.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "UAG]BU-E,{b;*H#ZVtOl|RM{KGtP+kKGgL#Z",
                                    "type": "image"
                                },
                                {
                                    "id": 3768272,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/47ea3ae6-7dad-4e75-9fd4-bb37e6c2327c/width=450/3768272.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "U7G98A-Y-YXe~qV_M{f}#1O7SuxJRUtLxui*",
                                    "type": "image"
                                },
                                {
                                    "id": 3768271,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/270f117f-a62d-4943-815a-1bbecc1f433c/width=450/3768271.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "U4Gbq_0100o]OqRQD%x@00-:ths=00ti~qa6",
                                    "type": "image"
                                },
                                {
                                    "id": 3768273,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3bf9dae8-3989-454b-ac59-e5b5b9c3cc0b/width=450/3768273.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 512,
                                    "hash": "UBI#rt%N-You~qagM{bF=jRiO7s=MxkUtRnm",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/232251"
                        },
                        {
                            "id": 240692,
                            "name": "Book",
                            "index": 6,
                            "modelId": 165876,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-11-27T07:51:44.099",
                            "availability": "Public",
                            "trainedWords": [
                                "boox,pixel,pixel art,pixelart,xiangsu,xiang su"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 815,
                                "ratingCount": 548,
                                "rating": 5,
                                "thumbsUpCount": 558,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 186208,
                                    "sizeKB": 295024.3671875,
                                    "name": "pixel book.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-11-27T07:10:57.014Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "6F0C6292",
                                        "AutoV2": "2666BDF520",
                                        "SHA256": "2666BDF520C266CDE131F028C0B1FAC3CA460A803158F000B519641B5CCC4461",
                                        "CRC32": "81E2CA0A",
                                        "BLAKE3": "6A07297AD5D28AC5BEB4758B124935103CA17A6E842F56DAC356A02B12327BAE",
                                        "AutoV3": "7512A1684C60"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/240692",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3959974,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b27c6261-405b-4e04-af86-d5e9f3845b29/width=450/3959974.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2688,
                                    "height": 2560,
                                    "hash": "U~Lgkb~q%MMxoMkBbHjZj]aya{jtbboLj[ay",
                                    "type": "image"
                                },
                                {
                                    "id": 3960111,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/174a8ccd-410d-462e-ad67-f2f1f572999f/width=450/3960111.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U5CEg@EN02oytQ^59vM|0MxF^iae9b1I}?%0",
                                    "type": "image"
                                },
                                {
                                    "id": 3960093,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4198d6f1-fc64-41c5-9b1f-35fdc0f8c9ae/width=450/3960093.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2688,
                                    "height": 2560,
                                    "hash": "U~LNlY~q%MM{ogkAfkayflaxjtjsX9n$jta|",
                                    "type": "image"
                                },
                                {
                                    "id": 3960125,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cdb87744-75f8-499d-8dfe-f44989c411ff/width=450/3960125.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U5E]rp0$0M=x5S}YSdr?0z$%^6sm$_0~-oba",
                                    "type": "image"
                                },
                                {
                                    "id": 3960132,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f331aae7-51f3-43e7-9321-0ad92e137e3e/width=450/3960132.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U6A]N?1P00#S05-V%fTK4,s:bw-6?@9szorp",
                                    "type": "image"
                                },
                                {
                                    "id": 3960141,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e2f8fa06-fa40-4ca0-9ae4-e410bad682ef/width=450/3960141.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U3B-[50:0K$k0q}s-h$g5zxDN4^0s$5R]*N_",
                                    "type": "image"
                                },
                                {
                                    "id": 3960143,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/62a306b2-7436-4f34-af0e-d87a8bb3ba7a/width=450/3960143.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U5B3AZ0607^g06^g^fJ74el1SdjJ_F4@M*ba",
                                    "type": "image"
                                },
                                {
                                    "id": 3960144,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b095afa0-1f3b-48de-bd47-710b115ead11/width=450/3960144.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UBFC^{Rn0coH5@=d#$$fIQS1B@$k;GADGJS#",
                                    "type": "image"
                                },
                                {
                                    "id": 3960145,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/57f18e73-092a-4b65-bd2c-7d78f2635782/width=450/3960145.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U8D8IV#p00J*GI^5+Yr?0cbHcZ=c*w5lLNNw",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/240692"
                        },
                        {
                            "id": 237466,
                            "name": "Bottle",
                            "index": 7,
                            "modelId": 165876,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-11-24T15:53:13.954",
                            "availability": "Public",
                            "trainedWords": [
                                "bottle,pixel,pixel art,pixelart,xiangsu,xiang su,simple background"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 859,
                                "ratingCount": 84,
                                "rating": 5,
                                "thumbsUpCount": 130,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 183667,
                                    "sizeKB": 295024.3671875,
                                    "name": "Pixel bottle.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-11-24T18:36:23.612Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "881D6BFF",
                                        "AutoV2": "F2E3DB788C",
                                        "SHA256": "F2E3DB788C9892F7A9B6406634B45CC6FD70BF730266B0F70AF3157340BF3FA5",
                                        "CRC32": "814F5A74",
                                        "BLAKE3": "8A2A7B01F9C2AAB0A502D7756ADAC5BAC169786164265D563A4C93C9D04A1556",
                                        "AutoV3": "30F4B22F26CE"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/237466",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 3887988,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e2ae1fa-9c8a-4959-aef2-91a3b882ede4/width=450/3887988.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 640,
                                    "hash": "U59amJM{03V|rORjtway4XRk?rx??+oyMnV[",
                                    "type": "image"
                                },
                                {
                                    "id": 3892739,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d7812754-6b37-4493-b651-700f00bf1a2b/width=450/3892739.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U5G*=|a#y=?H_MxtMeRk-:R*9GWVMxoe.7f7",
                                    "type": "image"
                                },
                                {
                                    "id": 3892785,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d2ca2692-15ce-40e6-9982-0c7fcbbff4df/width=450/3892785.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U77^=YoN00NZI7WnbixaR3fktmV?S.aesgkW",
                                    "type": "image"
                                },
                                {
                                    "id": 3892779,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5abeb316-4234-46e8-96e2-fab0ef4182c0/width=450/3892779.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U9Ac.8NZ00=#4,sAj~ELRNxvtSIT%7NFM[-W",
                                    "type": "image"
                                },
                                {
                                    "id": 3892750,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bf1cc9fe-7323-4756-8c66-2333812a2d89/width=450/3892750.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U9HeC0M|.m?G?vxuVsR*.7jtIBa|Q.M|Xmso",
                                    "type": "image"
                                },
                                {
                                    "id": 3892743,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e53c3090-b9cc-4df6-96e8-6e3fe1a6504f/width=450/3892743.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U1Am#VNx00~V:{t7GNRj00Rk*Ft2.DR*Mq%1",
                                    "type": "image"
                                },
                                {
                                    "id": 3892781,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/76b6aa63-96e1-4f1f-9d65-6897db24b210/width=450/3892781.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UA9G,lbd00ngEHoI$-NKMHaxyFogxzWCV.xZ",
                                    "type": "image"
                                },
                                {
                                    "id": 3892756,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ad479dda-bba0-44d7-9ad6-67c5f606ea16/width=450/3892756.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U4Bo]itR00%00Mt5]$9b0LWB^*Rk|:M}B;^j",
                                    "type": "image"
                                },
                                {
                                    "id": 3892796,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d2be3783-2b64-41a7-8154-cadebc3d96a0/width=450/3892796.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U59jQBk900noI*s;stIo00f9~WbDnrNFx+=}",
                                    "type": "image"
                                },
                                {
                                    "id": 3892740,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/96251d74-98e4-44da-8cd7-7ef1a9793fda/width=450/3892740.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U397nUR.00%HDZs.%rNK4UbE?unn~mR+4rxY",
                                    "type": "image"
                                },
                                {
                                    "id": 3892788,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0f766fbc-e8b3-40dc-a2d7-8cbed195af4c/width=450/3892788.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UEFFaK%MNp%200M_D,Ip~Vt7x^od9Jj[%Kt7",
                                    "type": "image"
                                },
                                {
                                    "id": 3892784,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4cf0d26f-1a45-4928-a8da-c1d5e653b2c0/width=450/3892784.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U5BpR*-400A20vW@?Js5QkSOT#w[cIi]+rp1",
                                    "type": "image"
                                },
                                {
                                    "id": 3892760,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/885877c0-56dc-4841-bbde-2a3e9e898ccf/width=450/3892760.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U59jDps;00Ri0et6}[E3D%NGtR-o$jRkXS%1",
                                    "type": "image"
                                },
                                {
                                    "id": 3892762,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/55ffc799-6ac2-460c-8aa3-1db46bdb4cf6/width=450/3892762.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U2A0g:I]00~85{xs,N9c02s:^%I:mnIp%z?G",
                                    "type": "image"
                                },
                                {
                                    "id": 3892777,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fc3515bc-d663-41b8-bd22-5a779876106d/width=450/3892777.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UFJkTQt7_Is:9WWB9IWVISWCRqocIKj?-+oN",
                                    "type": "image"
                                },
                                {
                                    "id": 3892778,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0189dc69-13b2-484e-a2f5-41865c81e0e7/width=450/3892778.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "URJ*xZof~ntR00j[D+RjI9a#E2aeWIWB-noz",
                                    "type": "image"
                                },
                                {
                                    "id": 3892780,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e42b1ec0-e257-434f-ba8f-a6f6dd537155/width=450/3892780.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U59jDps;00Ri0et6}[E3D%NGtR-o$jRkXS%1",
                                    "type": "image"
                                },
                                {
                                    "id": 3892797,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5b9f7029-52a9-4d2f-b460-744bec48a989/width=450/3892797.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U597L.j^00s*NTt6s^IpISayxwofW3NHxi-o",
                                    "type": "image"
                                },
                                {
                                    "id": 3892799,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ed5b1c34-ea8c-423e-96e9-6b0c42cb32ed/width=450/3892799.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U4B{fctB00^X00oG^09g4-nz~DEn]~NMBW~R",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/237466"
                        },
                        {
                            "id": 448478,
                            "name": "Isometry build",
                            "index": 8,
                            "modelId": 165876,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2024-04-15T13:49:30.389",
                            "availability": "Public",
                            "trainedWords": [
                                "((Isometry)),pixel,pixel art,solo"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 112,
                                "ratingCount": 0,
                                "rating": 0,
                                "thumbsUpCount": 11,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 368322,
                                    "sizeKB": 336478.5,
                                    "name": "Pixel_Building2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2024-04-15T13:45:50.479Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "31958B49",
                                        "AutoV2": "0578139D34",
                                        "SHA256": "0578139D34B6FDCC8DFBF26BFB3B7163DC43C44BF516BAFA7A25EF436389DF78",
                                        "CRC32": "BFBB850C",
                                        "BLAKE3": "DC6FBA4DADD07089B6D18D5AF4B82D4F612F728922509A2C379635D4D89BEE87",
                                        "AutoV3": "E2524D79E6FF"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/448478",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 9939121,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9f84f1b2-e12f-480e-ac72-a183025010a5/width=450/9939121.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UpIEb8NGM{M|~VRkj?oJt5WBt7t7xZs-WYWX",
                                    "type": "image"
                                },
                                {
                                    "id": 9939159,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3d22d141-1a30-4cde-99ee-c464150c6849/width=450/9939159.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UePZS[kC_Nxt~qoeIUWXtQj[RPWVD%WVozj?",
                                    "type": "image"
                                },
                                {
                                    "id": 9939067,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/00618574-9685-4191-b4ba-a7d583e8f6bf/width=450/9939067.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UlODh1of?at7^+j@M|fR~VoeNHfR9aa}oJWU",
                                    "type": "image"
                                },
                                {
                                    "id": 9939125,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2d0c3064-cae7-4a30-94ee-792c988cf999/width=450/9939125.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UhK,{bD%%MNG~pxZWBR*?uWARjt7xuNGRjxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 9939158,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8b98f782-c394-4961-b29a-c894b438c015/width=450/9939158.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UYNv}Uof?wxtETof9aNH9bWCoxfkRnWBxtt7",
                                    "type": "image"
                                },
                                {
                                    "id": 9939122,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5d56c90d-fedd-41ab-8138-c9af8c48c904/width=450/9939122.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UuOy|nWC.8t7%2s:WUR*_NofenayWUR*Rjs:",
                                    "type": "image"
                                },
                                {
                                    "id": 9939076,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ca92e398-ede5-45b7-a0b7-b4977f3377be/width=450/9939076.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UOKm@DNH~q-o?Hs.D*R+bvs:M{Rk4oWCR*js",
                                    "type": "image"
                                },
                                {
                                    "id": 9939060,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9196c345-c51e-4203-bbd5-5b5504960aed/width=450/9939060.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UtLNfBM|-ps:~pt6ayj[-:a}Rja#Ioj[RjWB",
                                    "type": "image"
                                },
                                {
                                    "id": 9939156,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/feb17e54-c141-446f-8fec-1ec3e7db6336/width=450/9939156.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UyLD0%M|W?s.~Un$jufRb^ocn~WEofayaejs",
                                    "type": "image"
                                },
                                {
                                    "id": 9939092,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5f6c3e3c-865b-4c9e-be44-9ff7f48910b6/width=450/9939092.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "U9JRQ[IY$+~V0C%K0JIpn9tPxwM|00IWV|NF",
                                    "type": "image"
                                },
                                {
                                    "id": 9939094,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c8f3faea-3408-4173-86b0-7e0df86005ae/width=450/9939094.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UTJar|M}-;-o~Wt6ocofoNt6V@NHInWDIoWB",
                                    "type": "image"
                                },
                                {
                                    "id": 9939103,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/35d0a91e-b869-490f-82bd-49f5a691fd30/width=450/9939103.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UsNdH?j]?bt7~qofRjaz_3j[WBj[D%WCIUay",
                                    "type": "image"
                                },
                                {
                                    "id": 9939113,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1c7f2e2f-afc9-449f-a3d5-44968cecb47a/width=450/9939113.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UCHK,[^*o~Nx00IV9ZWB_MNd$NxF00t3xbM|",
                                    "type": "image"
                                },
                                {
                                    "id": 9939147,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/28004f44-6239-4f5b-92ba-f7de59a35fa8/width=450/9939147.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 512,
                                    "hash": "UDFEu?D*04%K01xaxuay03tQ^MIW~WWBe,oL",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/448478"
                        }
                    ]
                },
                {
                    "id": 8072,
                    "name": "Covering eyes Pose LORA",
                    "description": "<p>LORA for danbooru tag <em>covering_own_eyes</em> using hand. Directly using the tag could not give promising results so I made this LORA. Some examples are using character LORA from other creators. Thanks for sharing the work!</p><p></p><p>Default weight=1 should be enough for plug and play.</p><p>Trigger words: <em>covering eyes</em></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent",
                        "Sell"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 5,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 19059,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3261,
                        "thumbsDownCount": 0,
                        "commentCount": 7,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 0
                    },
                    "creator": {
                        "username": "Akii",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cb83d777-82e1-4821-80f7-138a32e57114/width=96/Akii.jpeg"
                    },
                    "tags": [
                        "anime",
                        "poses",
                        "erotic pose"
                    ],
                    "modelVersions": [
                        {
                            "id": 9521,
                            "name": "covering_eyes",
                            "index": 0,
                            "modelId": 8072,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 5,
                            "description": null,
                            "publishedAt": "2023-02-11T18:03:21.333",
                            "availability": "Public",
                            "trainedWords": [
                                "covering eyes"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 19059,
                                "ratingCount": 3212,
                                "rating": 5,
                                "thumbsUpCount": 3261,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 9218,
                                    "sizeKB": 147584.7900390625,
                                    "name": "covering_eyes.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-11T18:06:05.576Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "1F5A6E7A",
                                        "AutoV2": "A7508476E4",
                                        "SHA256": "A7508476E4DCCE02C24FB53C144DED3121EFC2A867157AA9EE73FAB1DFEA7720",
                                        "CRC32": "2006E79F",
                                        "BLAKE3": "556E226EB041615EB818837DF196C82A879FB925458342294D0158CF170AF1C1",
                                        "AutoV3": "2DFE2DC67C5A"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/9521",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 91762,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f44aae0-d14d-4efa-6ec4-adbf00806d00/width=450/91762.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UGH_Y[xu5RIo~qIo^+_3?HW:E1xGOYRP_2WB",
                                    "type": "image"
                                },
                                {
                                    "id": 91764,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1cb50557-9463-43f6-843d-acb1f7eee900/width=450/91764.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UIIN~#01?Z00~q%2E14n-;IoE1E19t9a-Vxu",
                                    "type": "image"
                                },
                                {
                                    "id": 91799,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d0db319d-b3df-453a-6be4-69e4ff5a0500/width=450/91799.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UNH.1q?H0KE1~nxoI?o#I9ozWZRPk?%Nn3M^",
                                    "type": "image"
                                },
                                {
                                    "id": 91763,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/945646cf-f1cf-49c1-f5c8-0292dc50fc00/width=450/91763.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UYIg=g~VtQoz_2xuxt%LofozozkCE2e.xGWV",
                                    "type": "image"
                                },
                                {
                                    "id": 91798,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f8ad1bd8-e597-4bab-3878-a69a6d08c100/width=450/91798.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHI|g==}Q6.TJjIV^+-W.Rj[#9D*IpM{-;o}",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/9521"
                        }
                    ]
                },
                {
                    "id": 118533,
                    "name": "MengX girl_Mix",
                    "description": "<p>这是一个亚洲女性脸模，无需分层使用。此lora在大部分情况下可以使人物皮肤变得更加白嫩，一定程度上改善图片发黄的问题，代价是牺牲一定的皮肤质感。</p><p>--这个模型不太适合欧美风格比较鲜明的模型，建议使用亚洲模型。</p><p>--我还是建议你们下载到本地进行使用，我发现很多在线生成的效果，只能说一言难尽。</p><p>--This is an Asian women's face model that does not need to be layered. This lora can make the character's skin whiter and tenderer in most cases, and improve the yellowing problem of the picture to a certain extent, at the cost of sacrificing a certain skin texture.</p><p>--This model is not suitable for models with distinctive European and American styles. It is recommended to use Asian models.</p><p>--I still recommend that you download it locally and use it. I found that many online generation results are not good.</p><hr /><p>V40--</p><p>降低了V30的柔光效果，脸型相比V30略微改变，我个人认为V40更加可爱一些。</p><p>权重0.9似乎更加好看。推荐权重0.7-1.0。</p><p>请务必打开<strong>ADetailer</strong>插件使用，且在插件提示词中加入lora，这样才能完美还原脸型，</p><p>我比较常用face_yolov8m这个模型，重绘幅度建议根据景别以及人物大小来调整，范围大概在0.2-0.4之间。</p><p>可以尝试在提示词中增加blush，或许能让脸更加可爱，少女。</p><p>貌似在其他模型上传图片无法链接到我的lora，所以希望能在此页面进行返图~</p><p>The soft light effect of the V30 has been reduced, and the face shape has changed slightly compared to the V30. I personally think the V40 is cuter.</p><p>A weight of 0.9 seems to look better. Recommended weight 0.7-1.0.</p><p>Please be sure to open the ADetailer plug-in to use, and add lora to the plug-in prompt word, so as to perfectly restore the face shape.</p><p>I usually use the face_yolov8m model. It is recommended to adjust the redrawing range according to the scene and the size of the characters. The range is about 0.2-0.4</p><p>You can try to add blush to the prompt word, maybe it can make the face more cute, girly.</p><p>It seems that uploading pictures on other models cannot be linked to my lora, so I hope to return pictures on this page~</p><p></p><hr /><p></p><p>这是一个亚洲女性脸模，无需分层使用。此lora在大部分情况下可以使人物皮肤变得更加白嫩，一定程度上改善图片发黄的问题，代价是牺牲一定的皮肤质感。特定情况，自带柔光效果。</p><p>权重在1.0或1.0以下都可以，再往上我没有进行测试。</p><p>此lora可以让你非常轻松的获得一个面部表情变现力不错的亚洲女性。</p><p>建议打开<strong><span style=\"color:rgb(255, 255, 255)\">ADetailer</span></strong>插件使用。</p><p>如果你觉得不错，请在此分享你觉得不错的图片，谢谢。</p><p></p><p>This is an Asian women's face model that does not need to be layered. This lora can make the character's skin whiter and tenderer in most cases, and improve the yellowing problem of the picture to a certain extent, at the cost of sacrificing a certain skin texture. In certain cases, it has a soft light effect.</p><p>Weights at or below 1.0 are fine, I haven't tested anything higher than that.</p><p>This lora allows you to easily obtain an Asian woman with good facial expressions.</p><p>It is recommended to use the ADetailer plug-in.</p><p>If you think it is good, please share the pictures you think are good here, thank you.</p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit"
                    ],
                    "allowDerivatives": false,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 26005,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3250,
                        "thumbsDownCount": 0,
                        "commentCount": 14,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 50
                    },
                    "creator": {
                        "username": "MengX",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1b629dc2-cb3c-4a55-a8d1-48c4bb8ebc1a/width=96/MengX.jpeg"
                    },
                    "tags": [
                        "character",
                        "person",
                        "photorealistic",
                        "female",
                        "woman",
                        "girls",
                        "portraits",
                        "realistic"
                    ],
                    "modelVersions": [
                        {
                            "id": 137910,
                            "name": "V40",
                            "index": 0,
                            "modelId": 118533,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>降低了V30的柔光效果，脸型相比V30略微改变，我个人认为V40更加可爱一些。</p><p>权重0.9似乎更加好看。总体来说，各有优点，总体区别不是特别大，看你个人爱好了。</p><p>请务必打开<strong>ADetailer</strong>插件使用，且在插件提示词中加入lora，这样才能完美还原脸型。</p><p>The soft light effect of the V30 has been reduced, and the face shape has changed slightly compared to the V30. I personally think the V40 is cuter.</p><p>A weight of 0.9 seems to look better. Generally speaking, each has its own advantages, and the overall difference is not particularly big, depending on your personal preferences.</p><p>Please be sure to open the ADetailer plug-in to use, and add lora to the plug-in prompt word, so as to perfectly restore the face shape.</p>",
                            "publishedAt": "2023-08-10T11:29:48.824",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 22786,
                                "ratingCount": 1524,
                                "rating": 5,
                                "thumbsUpCount": 2912,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 102560,
                                    "sizeKB": 295024.359375,
                                    "name": "MengX girl_Mix_V40.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-08-13T06:21:39.357Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "8FF29E88",
                                        "AutoV2": "E413AEDA21",
                                        "SHA256": "E413AEDA21F41FC09439B3027D5C623D18FA7A97CB5AE5E51C9918621F6464EB",
                                        "CRC32": "0B0DCC72",
                                        "BLAKE3": "483D5F3A316F12FD984645BE682FD04C52FF282EE8015021F300C1831EDB8963",
                                        "AutoV3": "A49D39CFFD13"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/137910",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2123086,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/14f3bd31-16a7-4268-bb84-281f72c566b3/width=450/2123086.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 3840,
                                    "hash": "UbG[_{~qI;WV01M{%LogNHM{aKjZxuofM{oJ",
                                    "type": "image"
                                },
                                {
                                    "id": 5090912,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cb289125-bdd7-4921-a647-dc375a6346ef/width=450/5090912.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJG9R3YR0.-700Z#xXo~I9skwaRjkrRPxCM{",
                                    "type": "image"
                                },
                                {
                                    "id": 4054283,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/97e8dd56-c11e-45a1-85f0-3e53c5788be2/width=450/4054283.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UB7U3Y?aE24:~W?HIo9G-;-:n$ITx^%Ms,M_",
                                    "type": "image"
                                },
                                {
                                    "id": 4054095,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/24fd2436-ba84-4f36-8412-6b05de02c34d/width=450/4054095.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGBp5;-:_1~p%MWXkCxu00IV4:4o9FxDV@IB",
                                    "type": "image"
                                },
                                {
                                    "id": 4054119,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cfb02552-157e-44c2-bdf3-3b38a4bbdd27/width=450/4054119.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCBC#+579Fxu~VjZD*WY0N={WXNG0LbI%Ms+",
                                    "type": "image"
                                },
                                {
                                    "id": 4054092,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5675049d-345f-4cdc-9625-d75e53bf28f9/width=450/4054092.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U96*H#9GNI?H~V9ZR--:%MIUs:%2X8Rjxafk",
                                    "type": "image"
                                },
                                {
                                    "id": 4054097,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8caf18e1-f319-499a-b850-8fe8353f2e12/width=450/4054097.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UJBp5[wv^%M|~pWA-oM|O@NGIpWBOGWVE2oe",
                                    "type": "image"
                                },
                                {
                                    "id": 4054093,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4fbcb20e-a570-4711-88fc-1c0ce7a26b90/width=450/4054093.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UD97Ie~p%g_2~V?a-;?aIpt6=|t7IpbIxaRk",
                                    "type": "image"
                                },
                                {
                                    "id": 4054094,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ebb0374f-264e-4ef4-81b9-67edfc41f44f/width=450/4054094.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U88f=S0OX7=_0i};ENNH%KE3=^X80$=_NHjF",
                                    "type": "image"
                                },
                                {
                                    "id": 5091031,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/90424c3a-38ef-449c-91c3-ad143edfe009/width=450/5091031.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1365,
                                    "height": 2048,
                                    "hash": "UOLgFdLM~p^+00ITxu-;IVxI%3NG.8%gw{af",
                                    "type": "image"
                                },
                                {
                                    "id": 1961582,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/577044a0-6f96-447e-9bfc-088f3e0a6370/width=450/1961582.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5BDA^xZ9EJV_4?G4:xu0KtRITRj4.E2^*V@",
                                    "type": "image"
                                },
                                {
                                    "id": 1961342,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/efcc83ea-0561-48af-aadd-d85469c1e5e2/width=450/1961342.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2560,
                                    "height": 3840,
                                    "hash": "U5D+rPxvB:~V_NxvIBjY00o#VXIo-;xu%2t7",
                                    "type": "image"
                                },
                                {
                                    "id": 1961298,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d8a46efc-5006-40d3-a96c-21bc98def38c/width=450/1961298.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6Dbm1nM4nI=0j02-Vxa=V%f~pIU00NfOFE2",
                                    "type": "image"
                                },
                                {
                                    "id": 1961299,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/818a4bb6-bfe5-4095-a274-3a11686a6463/width=450/1961299.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHEex#_N%Mxu_2?b^+xuD*t6%Mo#IpWBE1of",
                                    "type": "image"
                                },
                                {
                                    "id": 1961300,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/905a8e43-f6c3-4a04-b24b-46917a3d7209/width=450/1961300.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UfFY=TRORiWB?wROM{ayNeRjaKWARj%2jFV@",
                                    "type": "image"
                                },
                                {
                                    "id": 1961288,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/df48322f-4525-4a6f-8d9e-ec523c169dd9/width=450/1961288.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5F~EZ~X004m0w02]%^%Kv$*H@kR2=9a0L?Z",
                                    "type": "image"
                                },
                                {
                                    "id": 1961666,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e5099248-73e2-4597-a3a9-9e2bd3cd7e46/width=450/1961666.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UfK-8,jY~pM{%hkDxus.9aofM{R+-:V@oejs",
                                    "type": "image"
                                },
                                {
                                    "id": 1961712,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/90df37b7-52db-434d-ab29-2e0d145b6b1b/width=450/1961712.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UNHw_Z4n-;xu~pR5-:S59us,-:WBn#R*kBWB",
                                    "type": "image"
                                },
                                {
                                    "id": 1961569,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/31829746-f099-4562-a430-47be9de35ef6/width=450/1961569.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCE_:a?E01EQ0g%2~Coy0NRj%MxZ%hRkIAxa",
                                    "type": "image"
                                },
                                {
                                    "id": 1963207,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/cbdf4481-5931-4371-a849-bc3ddb02450c/width=450/1963207.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U4C~o3017#^j00Ip00o}00XT?HM{uPMd~qoJ",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/137910"
                        },
                        {
                            "id": 128601,
                            "name": "v30",
                            "index": 1,
                            "modelId": 118533,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-07-30T00:16:13.628",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3219,
                                "ratingCount": 274,
                                "rating": 5,
                                "thumbsUpCount": 346,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 93438,
                                    "sizeKB": 147567.21875,
                                    "name": "MengX girl_Mix_v30.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-29T23:00:41.218Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "D435AC03",
                                        "AutoV2": "9A1588B097",
                                        "SHA256": "9A1588B097F7310EB32089EA3BCC23430638BB95101604DE8256018448BA49C6",
                                        "CRC32": "E63760B5",
                                        "BLAKE3": "3E756FBB3B231BAB3D3E7DF544B58E22BCC913364A8F27A78CE99AD02A376A44",
                                        "AutoV3": "565A167A240D"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/128601",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1783111,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e64e18b4-596b-49fd-b2b7-6f8f379e84d9/width=450/1783111.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UFDu[D4.0K~C00%2-oNGS6Ip%2j]-:WBM{xa",
                                    "type": "image"
                                },
                                {
                                    "id": 1782917,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a17a9b10-a858-46f1-ba63-690c007904e4/width=450/1782917.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U6Eeol0M00%200={^,of01-p~WNF?H57Mws;",
                                    "type": "image"
                                },
                                {
                                    "id": 1782908,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2cf285ac-6f14-4075-ab04-9aec7db42828/width=450/1782908.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 2560,
                                    "height": 3840,
                                    "hash": "UKECh0~qNFIT?wxvM{RP?v-=s:RktRxujYM|",
                                    "type": "image"
                                },
                                {
                                    "id": 1782924,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6f521a52-55db-46e1-b703-ca7672512fd8/width=450/1782924.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEBgD68^4:~q~pM{4T_3?cR*9F%M?wMxRjn$",
                                    "type": "image"
                                },
                                {
                                    "id": 1783221,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/37627d2f-4f1b-479a-846f-d6072d4a1c3d/width=450/1783221.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UHGuL30KRN_3^%t89F?akWM{IV%M_N9GM_xu",
                                    "type": "image"
                                },
                                {
                                    "id": 1783374,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/78e370ac-c456-4b4d-a8fe-39d8d045562c/width=450/1783374.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UXIhdB-;xZ-;_NxuWDxu9wS3D%IUs:oeRjM{",
                                    "type": "image"
                                },
                                {
                                    "id": 1783364,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a79f93c4-7de2-4005-ac8c-d1745fd8db45/width=450/1783364.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USHxsb%N~p%M.9IppJWCIAD%W?RjkXxtxZt6",
                                    "type": "image"
                                },
                                {
                                    "id": 1783025,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/afe80536-514f-45e7-bf56-c81eac67be2a/width=450/1783025.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U5F$9K={00={00_3~q9ZE,-:nOoz?v8^wv%1",
                                    "type": "image"
                                },
                                {
                                    "id": 1783130,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/41cede39-8ae3-4156-9fdc-34f891218233/width=450/1783130.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9G*.:~C0KIV00E1XTE2%$Ipwuxa?Gxaxaxu",
                                    "type": "image"
                                },
                                {
                                    "id": 1783177,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4606072c-dfe4-4623-a7f1-a69a3fe0de9f/width=450/1783177.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UKG[pD4.00_28^R+R.t70f%1M{M{_N%2RPof",
                                    "type": "image"
                                },
                                {
                                    "id": 1783292,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b33218ad-7fde-4423-a4d5-6d3950288ebf/width=450/1783292.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U89QU0~VELNa^*-:xuozIoWBoLof9ZRk%2ae",
                                    "type": "image"
                                },
                                {
                                    "id": 1783330,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0d782d2e-dc54-49ce-a617-4058383ea422/width=450/1783330.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCC?r_D*OD?b?wxtWBNG01tRD%t74ot8sla}",
                                    "type": "image"
                                },
                                {
                                    "id": 1783415,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3b5ed695-b6d5-495b-b3ad-b40c26cf411d/width=450/1783415.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDI}O-%0oZ~C00aJE2%MYRD%D%IV.7%LTKo#",
                                    "type": "image"
                                },
                                {
                                    "id": 1783505,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d2f0c062-3d0e-4daf-9b50-bddb9e6306f3/width=450/1783505.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UOH^x7S~%$=|YkxG-pbvIVWBM{R*n5NuRPxG",
                                    "type": "image"
                                },
                                {
                                    "id": 1783922,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3c65d521-0a23-486a-a281-bc99f54f5151/width=450/1783922.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UXLgFdIUxvxuVrrrV@tR_NsAIToza#jFt7xa",
                                    "type": "image"
                                },
                                {
                                    "id": 1783969,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8ff21db5-572d-4402-aba6-a23612df2bd3/width=450/1783969.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UPKm-5XS_N-p?vMxRjSg_NxuxabHxuxGRjju",
                                    "type": "image"
                                },
                                {
                                    "id": 1784209,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bbdc9300-7cc3-4883-94ea-71847a81f725/width=450/1784209.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U69@I#ER0K_202~p~VD*.7S6?GWV-qxt4.%2",
                                    "type": "image"
                                },
                                {
                                    "id": 1784413,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/966e47c9-d6d6-4752-9f67-821e60bc18f3/width=450/1784413.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDHU^G00~p_3_300OZxuE1?aV@sSbbM{RPs.",
                                    "type": "image"
                                },
                                {
                                    "id": 1784521,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/24cb3777-8932-4fe2-a8e9-f7b947a30e3c/width=450/1784521.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 2560,
                                    "height": 3840,
                                    "hash": "UHHdjb~WrE4TD4R4Md=|xv%2_3t7RPELI.Nu",
                                    "type": "image"
                                },
                                {
                                    "id": 1785029,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bb199b51-5801-4ab7-acfd-61db0c60770d/width=450/1785029.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UOIDm^O?S5,E_Nv~IUbG~qwd=etQ$*jtRPXR",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/128601"
                        }
                    ]
                },
                {
                    "id": 110334,
                    "name": "epiCRealismHelper",
                    "description": "<p>Get better Skin Details, more imperfections, overall Realism boost any model</p><p></p><p><em>Description will follow</em></p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit"
                    ],
                    "allowDerivatives": false,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 66171,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3244,
                        "thumbsDownCount": 2,
                        "commentCount": 21,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 110
                    },
                    "creator": {
                        "username": "epinikion",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/529b3628-8929-4ef6-b63f-16d2999faa41/width=96/epinikion.jpeg"
                    },
                    "tags": [
                        "photography",
                        "photorealism",
                        "skin",
                        "tool",
                        "details"
                    ],
                    "modelVersions": [
                        {
                            "id": 118945,
                            "name": "V1",
                            "index": 0,
                            "modelId": 110334,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-07-16T13:36:07.018",
                            "availability": "Public",
                            "trainedWords": [],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 66171,
                                "ratingCount": 1763,
                                "rating": 4.99,
                                "thumbsUpCount": 3244,
                                "thumbsDownCount": 2
                            },
                            "files": [
                                {
                                    "id": 85185,
                                    "sizeKB": 57174.29296875,
                                    "name": "epiCRealismHelper.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-17T02:03:27.700Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "45DFBFF7",
                                        "AutoV2": "A08670315F",
                                        "SHA256": "A08670315FC5B150FC00279413840CF0353DB778A436B4ABAC2440A2FDF537D9",
                                        "CRC32": "6E212998",
                                        "BLAKE3": "E6D8E7E5CC22FF41FC18125DFFCE25BE5907F12B0D44A72A8BC76F73EB4057D6",
                                        "AutoV3": "C5E24D9BC4B5"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/118945",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1584452,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9243fbfd-d8d0-4f19-b1a5-7cdb9d64af5a/width=450/1584452.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UCC=}09G9uM|0gRP%MoME2Rk-UkV~BWBNGxa",
                                    "type": "image"
                                },
                                {
                                    "id": 1584450,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aa8d5af5-8880-4f2f-9283-138b15862633/width=450/1584450.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGJ[6S00_Nxt-=%NyDx]DiRj?GRP%MR*8{M|",
                                    "type": "image"
                                },
                                {
                                    "id": 1584474,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eb3127c9-067d-4c7c-97c3-a17f4a98d3f3/width=450/1584474.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UfFrkn_3bwtS~q-;t7%M-;t7f5xat7aeM{Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 1584451,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5cb1c12b-38f3-4cd9-94d7-4c397a933cd6/width=450/1584451.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDAc*b^$^jNw~T%0%KXRRis9t3xs0fRjMywc",
                                    "type": "image"
                                },
                                {
                                    "id": 1584453,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0a3255a7-faef-4e96-b15f-442e005e4191/width=450/1584453.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U7AJco|FX,9atlD*9]EM0zK5wJ-B9utQ=x={",
                                    "type": "image"
                                },
                                {
                                    "id": 1584454,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/74e7f1da-2732-4eb7-b92c-144012226aa7/width=450/1584454.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGHnKYtlu4~p0#_2-;-pO=aeIAIo%LR+?H%2",
                                    "type": "image"
                                },
                                {
                                    "id": 1584473,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e5b878d9-5afe-4556-acd0-402d4558ff46/width=450/1584473.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UjI;;a%L^*a}~qs:xufk%gR*NGay%MWBRjoe",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/118945"
                        }
                    ]
                },
                {
                    "id": 11457,
                    "name": "Jinx League of legends",
                    "description": "<p>Trained with NAI on 160 images in of Jinx this LoRA is capable of convincingly reproduce Jinx. It has outfit flexibility and most of the time gets the tattoo right. The triggerword is JinxLol</p><p>Very good with NSFW images , especially fellatio. Do let me know what you think about this model!</p><p><strong>Feel free to support my work on patreon</strong></p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/RakoszOppai\">Rakosz | Creating NSFW/Erotic illustrated Ai art | Patreon</a></p><p></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 15,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 29800,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3228,
                        "thumbsDownCount": 0,
                        "commentCount": 20,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 21
                    },
                    "creator": {
                        "username": "Rakosz",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/39eae325-e04d-4e5e-cd5e-555127486f00/width=96/Rakosz.jpeg"
                    },
                    "tags": [
                        "league of legends",
                        "character",
                        "girl",
                        "illustration",
                        "digital illustration",
                        "game character",
                        "video game",
                        "jinx league of legends"
                    ],
                    "modelVersions": [
                        {
                            "id": 13565,
                            "name": "v1.0",
                            "index": 0,
                            "modelId": 11457,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 15,
                            "description": null,
                            "publishedAt": "2023-02-21T15:47:45.41",
                            "availability": "Public",
                            "trainedWords": [
                                "jinxlol"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 29800,
                                "ratingCount": 2584,
                                "rating": 5,
                                "thumbsUpCount": 3228,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 11994,
                                    "sizeKB": 9324.0185546875,
                                    "name": "JinxLol.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-21T16:01:24.153Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "C89CAEE5",
                                        "AutoV2": "5D083880ED",
                                        "SHA256": "5D083880ED747CCB2E78A089F50D61446475F6D9F98207AA6FD70B77119AC359",
                                        "CRC32": "96B2CD07",
                                        "BLAKE3": "2A53014B3E4A82AA91238A2FE99E2E7FFD92E18E6DB725D91358B022CC2B0A5B",
                                        "AutoV3": "29D14D65E702"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/13565",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 131187,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/86ca454c-def6-4ccf-43cf-6509627c8400/width=450/131187.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USHV3bRjEJxt*0M{watQ.9oIROV@tmbX$%oM",
                                    "type": "image"
                                },
                                {
                                    "id": 131194,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b4f1d154-ae8a-4c31-1571-2ff156081100/width=450/131194.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULKd-?00TxoI.TD%?GxaI:VsDiSi5SaxM{t7",
                                    "type": "image"
                                },
                                {
                                    "id": 131193,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/33a992d3-fa6e-453f-3149-f5a45947ee00/width=450/131193.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UXH_iMD%9sV[?^M{%LM{%haei_WER+WBt6Wr",
                                    "type": "image"
                                },
                                {
                                    "id": 131192,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/98371077-cf82-4a8c-efcc-1240d7fbfe00/width=450/131192.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UbI#x]NGt,.8?^Wqt6xab_Iot5WBNdf7M|NG",
                                    "type": "image"
                                },
                                {
                                    "id": 131191,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fb31f072-773c-4571-01a4-7047806c8100/width=450/131191.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "USKT#z0L56?G?^RQ={M{JCR*xsf+9btQM|n$",
                                    "type": "image"
                                },
                                {
                                    "id": 131190,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ec77dab3-fb91-444b-4c6e-bae186eef500/width=450/131190.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEH1*:~W9rV@PDb^R$Ri0MM|xB9Z0fRPIA={",
                                    "type": "image"
                                },
                                {
                                    "id": 131189,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fd70b7b1-7dfb-4239-2f14-2a6b58083e00/width=450/131189.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDJ7t400G9^w~qnm#kW9xy01=fnT01s%%fDj",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/13565"
                        }
                    ]
                },
                {
                    "id": 11203,
                    "name": "Glass Sculptures",
                    "description": "<p>i know some models already have a good glass sculpture support, but many others, just don't, this is why i'm making this.</p><p></p><p>use:<br /><br />a glasssculpture of [], transparent, translucent, reflections, [style, etc]</p><p></p><p>if you are getting weird close ups, try using model at 0.6.</p><p>tested on DreamShaper and<strong> </strong>Grapefruit models</p><p></p><p>Consider donating pls</p>",
                    "poi": false,
                    "allowNoCredit": false,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 13,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 18318,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3203,
                        "thumbsDownCount": 0,
                        "commentCount": 12,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 154
                    },
                    "creator": {
                        "username": "allendimetri",
                        "image": "https://lh3.googleusercontent.com/a/ALm5wu0KFS6o_9__y51_8omXwdA9n5iZZy5dOZDhKUchhA=s96-c"
                    },
                    "tags": [
                        "style",
                        "illustration",
                        "artstyle",
                        "photography"
                    ],
                    "modelVersions": [
                        {
                            "id": 177888,
                            "name": "SDXL VERSION",
                            "index": 0,
                            "modelId": 11203,
                            "baseModel": "SDXL 1.0",
                            "nsfwLevel": 13,
                            "description": "<p>same as prev versions, still very untested </p>",
                            "publishedAt": "2023-10-07T16:49:37.865",
                            "availability": "Public",
                            "trainedWords": [
                                "translucent",
                                "transparent"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 6886,
                                "ratingCount": 419,
                                "rating": 4.99,
                                "thumbsUpCount": 860,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 136034,
                                    "sizeKB": 166543.34765625,
                                    "name": "sdxl_glass.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-10-07T16:50:51.557Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "666907FE",
                                        "AutoV2": "9FDBFA8164",
                                        "SHA256": "9FDBFA8164BD1F87CEDBCA1939F14018FECCB60CC4BF6767C50CCCB22993716A",
                                        "CRC32": "096D18CA",
                                        "BLAKE3": "96A5C18998ABFA2F88BE5FAD75EBAD375BBAD21D27A35BD7FED7EDCF0A14881F",
                                        "AutoV3": "F5398C66D3F3"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/177888",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2837951,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e91e24e1-17dc-457f-87ac-af22cbeee906/width=450/2837951.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1024,
                                    "hash": "UTJ*r5iv~Xt,+[r=I:W=x^NHo|xD%#bvV?so",
                                    "type": "image"
                                },
                                {
                                    "id": 2837940,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f092e15c-0594-4c7c-aed2-61bc1f0a2f35/width=450/2837940.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1024,
                                    "hash": "USF6U#-pMxWY%$RjX9Rj_N%1t7bbxuRjbcof",
                                    "type": "image"
                                },
                                {
                                    "id": 2837936,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/91c28461-c23c-4496-a263-d68e5557ec38/width=450/2837936.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1024,
                                    "hash": "UFC~C%}rI9oetS-UNFEMOrE*EMM{R-W?IpVs",
                                    "type": "image"
                                },
                                {
                                    "id": 2837944,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/909f85a2-e91c-4dd8-a558-b5c50caad43d/width=450/2837944.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1024,
                                    "hash": "UCLCkd?SIP4zAHIDOqE1ELW9xkMz_7-pRhI[",
                                    "type": "image"
                                },
                                {
                                    "id": 2837945,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fa336cbb-d647-4bf9-ae40-cb68f90aef6e/width=450/2837945.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 896,
                                    "height": 1024,
                                    "hash": "U8B|TTW9:h.6y-%1NuNZ%g#,RPN_=rENOZxV",
                                    "type": "image"
                                },
                                {
                                    "id": 2837938,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/649a0f4c-f03c-413c-aef2-5acccaee345b/width=450/2837938.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1024,
                                    "hash": "UNJ*bfNL~W-;MeM_9akDu5rqVsXA$yo#spxV",
                                    "type": "image"
                                },
                                {
                                    "id": 2837937,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/766e540c-4151-49db-a729-997bb1930f13/width=450/2837937.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 896,
                                    "height": 1024,
                                    "hash": "U49aT?H?00tmIoofIooz+Htl9ZxZ_MjZDiWX",
                                    "type": "image"
                                },
                                {
                                    "id": 2837939,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7946dc9b-5cf3-4705-95bf-0a51f0f0b48d/width=450/2837939.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1024,
                                    "hash": "U59%YM%2I9jE}mf+R*jtM_WVK7Wr=^s99uRj",
                                    "type": "image"
                                },
                                {
                                    "id": 2837948,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4bf0cfea-7dde-4988-b3e6-6848730c67ad/width=450/2837948.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1024,
                                    "hash": "UAC*j^uPRP?wu*^k8{R3MIELI.D*i{xGRRRN",
                                    "type": "image"
                                },
                                {
                                    "id": 2837946,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b04eca14-427e-4677-ad2a-6fd12f7b5793/width=450/2837946.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1024,
                                    "hash": "UDEfvh%$D4rpp{T0rVv|KRtSD%MxyFt7D*Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 2837947,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0d741a49-5ed5-430b-86c7-dfdc43884e64/width=450/2837947.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1024,
                                    "hash": "UFCtX+-;mmjIq]V@9ZadVrtRo#ay?^W?RPIo",
                                    "type": "image"
                                },
                                {
                                    "id": 2837949,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c112f11c-fbdb-48aa-a137-c0bbd47e797f/width=450/2837949.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1024,
                                    "hash": "UKFZB5oyyERj%%Ip?wofcZNHNJRkE3xuROxu",
                                    "type": "image"
                                },
                                {
                                    "id": 2837950,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/452155c6-1865-491a-8fa8-40ecda8c1d20/width=450/2837950.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1024,
                                    "hash": "UKC?}:NEwfXA?wnNO[k?pfn#O?of.8Irxtkp",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/177888"
                        },
                        {
                            "id": 23801,
                            "name": "v2.0 completely redone dataset",
                            "index": 1,
                            "modelId": 11203,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>fixed artifacts issues, now you can even force model up to 1.5 without any cuts or weird things on the final generation.</p><p>this took 8 attempts, 4100 steps and 41 imgs to make</p>",
                            "publishedAt": "2023-03-15T21:41:53.176",
                            "availability": "Public",
                            "trainedWords": [
                                "glasssculpture ",
                                "translucent",
                                "transparent",
                                "reflection"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 6651,
                                "ratingCount": 836,
                                "rating": 5,
                                "thumbsUpCount": 932,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 19754,
                                    "sizeKB": 76188.005859375,
                                    "name": "glasssculpture_v8.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-15T21:46:37.218Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "A093269C",
                                        "AutoV2": "AFB5E9B5DC",
                                        "SHA256": "AFB5E9B5DC390900842F91C23C28D9726E4523623EB571642CFFE84F7F5FC3CC",
                                        "CRC32": "81D609CC",
                                        "BLAKE3": "9965A8E1D642BD472022B874A84D98D272C4ADBD5434687975B60AF532B0E3F9",
                                        "AutoV3": "800D594F2FBB"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/23801",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 258590,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/05c02f4a-a793-47c0-48a7-113928f5a400/width=450/258590.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 896,
                                    "hash": "UBCGi0-ll=rt8xo}0iD+H}M|-Os;Q6oy}Usk",
                                    "type": "image"
                                },
                                {
                                    "id": 258589,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6d4b4ea1-ffd3-4730-d088-8cdb3657a600/width=450/258589.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 640,
                                    "hash": "UNE{qR.Rz:%2~UxuxuxD:jxapcXm^5-:TJS~",
                                    "type": "image"
                                },
                                {
                                    "id": 258588,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/15c3c6ee-621b-449f-ecc0-5c7eb7d40500/width=450/258588.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 896,
                                    "hash": "UICZRpE0jXxs_LM{s,t6^+M{WEogx[adWEof",
                                    "type": "image"
                                },
                                {
                                    "id": 258587,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2665ee6b-e9a8-46c1-3016-2290a937e800/width=450/258587.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDFr*G-:x]t7~qt8%Mof00D%xakCxvaxWBV@",
                                    "type": "image"
                                },
                                {
                                    "id": 258586,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e3ff9166-4173-42d6-b8d9-6c7248c09100/width=450/258586.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U8EfNc{ay@_3~U%JsjnMp0-o$w$fyZMx4myE",
                                    "type": "image"
                                },
                                {
                                    "id": 258585,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bc0e426a-02f2-4f95-9478-4664237f7800/width=450/258585.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 896,
                                    "hash": "U6Ci8S^h014=19of-PxD?dD,-N~9I]-nxaIX",
                                    "type": "image"
                                },
                                {
                                    "id": 258584,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0da642df-09ff-4035-7d85-5bcb1029f200/width=450/258584.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 640,
                                    "hash": "UBFO.Ls:4nxu+Hs:EMso?GV@%2kC~Vs;NGR*",
                                    "type": "image"
                                },
                                {
                                    "id": 258583,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f9503afe-b9a5-4920-e186-d9b26d3c7300/width=450/258583.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 640,
                                    "hash": "UCD+_9%NMvozIYRkRioeDNM{.9ay~pxuIUWC",
                                    "type": "image"
                                },
                                {
                                    "id": 258582,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3effde20-c012-4053-c949-3888f258aa00/width=450/258582.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 640,
                                    "hash": "UTDwK?.AIBM^yGt9xvWAxxtRM{NHM|WsM_tR",
                                    "type": "image"
                                },
                                {
                                    "id": 258581,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e938b6f9-1ca1-470d-6f02-323e8cd47800/width=450/258581.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 640,
                                    "hash": "UGG[sG?u?w?I.R%2%KM{x@R.R5xv4oxtIWxt",
                                    "type": "image"
                                },
                                {
                                    "id": 258580,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bfc79ec4-84e6-433e-adba-4d23886a0d00/width=450/258580.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 896,
                                    "hash": "U8I4;H~V1C~Q7k[|DVEd0}0w=5MzP}-UFl?Z",
                                    "type": "image"
                                },
                                {
                                    "id": 258579,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c8c28d75-28e0-4d20-a4ee-c7be1c4a4b00/width=450/258579.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 896,
                                    "hash": "UFE39fx]4Tnz0xxZWYax}ZMyIVoMX%s;t7R*",
                                    "type": "image"
                                },
                                {
                                    "id": 258578,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f54329da-66b3-44b0-9dca-920e2f964600/width=450/258578.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 896,
                                    "hash": "U8Gu8l-;Mc$%00M{4oM{~pRj?a?aIUs.4.M{",
                                    "type": "image"
                                },
                                {
                                    "id": 258577,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7c745955-9b9c-49f3-3315-f5688c847c00/width=450/258577.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 896,
                                    "hash": "UGGk|5IE00#+5R9aoeE1q[%J?w?H9wWAIWIo",
                                    "type": "image"
                                },
                                {
                                    "id": 258576,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7cba7e6d-6dfc-4e0c-7660-f928253b3800/width=450/258576.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 896,
                                    "hash": "UKHxQfM_McR+_4IoRiaeNhV?t6t7tSRi%1xt",
                                    "type": "image"
                                },
                                {
                                    "id": 258575,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/441f00f9-b418-45c9-b9f2-b84ad4d96400/width=450/258575.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 896,
                                    "hash": "ULEx^jR%9FX8}vNdx^Rj?dIoRjt7-=oejXnh",
                                    "type": "image"
                                },
                                {
                                    "id": 258574,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/39a817d4-0c7f-4a4d-89d1-86a0a0f96e00/width=450/258574.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 896,
                                    "hash": "U6C$Jt~U03~U034;MxM{D+NHbHShE3^%~URQ",
                                    "type": "image"
                                },
                                {
                                    "id": 258573,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/eb88bda3-f345-4a75-bb50-02cded04df00/width=450/258573.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 896,
                                    "hash": "UDECXxMx_N_3WDt8R%IU_3ozxuxunhoLM{IU",
                                    "type": "image"
                                },
                                {
                                    "id": 258572,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7a416c74-dce0-4649-829a-8205225c0300/width=450/258572.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 896,
                                    "hash": "UKGaX,NwZOoz[qWBM|j[~B%1Fwi{IBxaEzRP",
                                    "type": "image"
                                },
                                {
                                    "id": 258571,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a9c02b9c-797a-4ea3-1956-fd6021e4d100/width=450/258571.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 896,
                                    "hash": "U4CiaSrW00~W00OFWC9G^4~VD%D%%gE1WBtR",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/23801"
                        },
                        {
                            "id": 13271,
                            "name": "v0.5 Some Dall-e watermarks to remove",
                            "index": 2,
                            "modelId": 11203,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 13,
                            "description": "<p>some weird close ups and dall-e watermarks to fix</p>",
                            "publishedAt": "2023-02-20T22:53:38.163",
                            "availability": "Public",
                            "trainedWords": [
                                "transparent",
                                "translucent",
                                "glasssculpture"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4781,
                                "ratingCount": 1430,
                                "rating": 5,
                                "thumbsUpCount": 1431,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 11810,
                                    "sizeKB": 147567.3466796875,
                                    "name": "glassculpt.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-02-20T22:56:21.345Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "953F9FC0",
                                        "AutoV2": "C1BE21FE47",
                                        "SHA256": "C1BE21FE47CDC4FE26D4671880FCC642BAA141A6E8574BC49935459B2786E0A1",
                                        "CRC32": "689DFDDE",
                                        "BLAKE3": "19C5D7C2BA8797F9DA86C3E235D778F835825783DD07BEA93710D8467850FBD9",
                                        "AutoV3": "6B0C308629A3"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/13271",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 128310,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7d660529-c070-4759-5e2e-93029b0edf00/width=450/128310.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UEHK@Hxt9Fof4.j[M{Rj~Xj[RjoLNFf7WVj[",
                                    "type": "image"
                                },
                                {
                                    "id": 128329,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5d6c31fc-4eae-4189-1b9e-d9accbd7c800/width=450/128329.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UDD,1D={8{NH~V-nMxNH?F%1V[Rk?GxZkCR*",
                                    "type": "image"
                                },
                                {
                                    "id": 128328,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/de293d52-38ef-40ca-7103-c94797fc8300/width=450/128328.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 512,
                                    "hash": "UDE3VV^i4T0M.TRPROofyYxDM{Ip_4s8RjX9",
                                    "type": "image"
                                },
                                {
                                    "id": 128327,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b4513e23-0f80-461d-9f73-914b53547600/width=450/128327.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAECqW?a4U^P5xbJ~Ut700IW7|9^D~RjH?Rj",
                                    "type": "image"
                                },
                                {
                                    "id": 128326,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7632df76-c339-4fc2-47ab-747bbc6e4b00/width=450/128326.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 640,
                                    "height": 896,
                                    "hash": "U5BXyFKk00#*D$tl.Ti{4U$yR49a00IA.8xF",
                                    "type": "image"
                                },
                                {
                                    "id": 128325,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/32532282-9525-496e-b518-e2cae9ca2000/width=450/128325.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UHGQ^I0i~BNM?wn$tRxab{j=ait65ZxVIqS4",
                                    "type": "image"
                                },
                                {
                                    "id": 128324,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/74a1ebbe-6a30-42d2-0e3d-934e155a5700/width=450/128324.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "USE:fA0L#k%3_NM|V?s:-nM|axRi-VRlj?jF",
                                    "type": "image"
                                },
                                {
                                    "id": 128323,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/94eca07b-d077-4d3f-e03e-36437481ce00/width=450/128323.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 512,
                                    "hash": "UHEC:?4o00?v~pM|IAtR_NWBI9R-?bWBIVt6",
                                    "type": "image"
                                },
                                {
                                    "id": 128322,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f9d7858d-cde0-4c0e-5482-0a994977e300/width=450/128322.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UJGHl10$-njc_4NHt7WYGHNIkCkC~VI=xGof",
                                    "type": "image"
                                },
                                {
                                    "id": 128321,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/85535564-217b-4cfb-7282-e11d8aab0200/width=450/128321.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "U5EpG|xu00xu00WB00ay_Nj[aeof~pt7o}M{",
                                    "type": "image"
                                },
                                {
                                    "id": 128320,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7e9c32f4-7619-4e0c-80ba-c7d5b3094700/width=450/128320.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UGDTCW~qi^-:.T-;V?xu%#tRaeWE%hW=IoWE",
                                    "type": "image"
                                },
                                {
                                    "id": 128319,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ae1686c3-a9d0-4c26-be3e-af2f1ead5c00/width=450/128319.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 512,
                                    "hash": "UbHoj}yEn2xt?wpJr;xZOuXnxZs+NKIVW=bH",
                                    "type": "image"
                                },
                                {
                                    "id": 128318,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5623335f-c79d-4ba6-a206-43c2c000bb00/width=450/128318.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UJFP7.~TZM?EAeJCIBIV5DoexAn~IsR.r=WB",
                                    "type": "image"
                                },
                                {
                                    "id": 128317,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/611737ed-9eb1-4407-faf0-c631cf34e500/width=450/128317.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "ULEV~JrV$*?b*0Mx%Lt8yFn3oexuyDv}a~xY",
                                    "type": "image"
                                },
                                {
                                    "id": 128316,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f57b31c6-3a20-4c7f-ceae-ae1c80c73100/width=450/128316.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBEou*0f4TO=DN58_4={^h9ZJVxb$kWFF{V?",
                                    "type": "image"
                                },
                                {
                                    "id": 128315,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a75ec92c-abe0-421f-81c5-750b44e38900/width=450/128315.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UJE:*ttR00NF00baV?RPRPj@~qozWVRPR+x]",
                                    "type": "image"
                                },
                                {
                                    "id": 128314,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/40e695fe-2e83-4726-3387-b6429f532000/width=450/128314.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UJG+w9%M4T_N_3xvWAt7%3ogtQVs%Lxut7ju",
                                    "type": "image"
                                },
                                {
                                    "id": 128313,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d054282c-b1d2-4397-a371-112d59c11500/width=450/128313.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UBJ[Co?b00-;00~q%NozDNIo_3ae00xuD%ax",
                                    "type": "image"
                                },
                                {
                                    "id": 128312,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7568e022-8e28-42d6-25b4-2d9669d4d900/width=450/128312.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 512,
                                    "height": 768,
                                    "hash": "UAF5{kx]00azE2ofI;t6MHoe_Nxt%2ofaeRk",
                                    "type": "image"
                                },
                                {
                                    "id": 128311,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5944fe0b-f1a4-46b9-61cf-34c6e98b5200/width=450/128311.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1024,
                                    "hash": "UAFFNp13={oz0j%0Ipay9aRjRjR+~AR+xZs:",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/13271"
                        }
                    ]
                },
                {
                    "id": 16667,
                    "name": "【Character】Akiryo's Mai",
                    "description": "<h3 id=\"heading-69\">2023/7/17 update</h3><p><strong><span style=\"color:rgb(36, 41, 47)\">Upload the realistic version</span></strong><span style=\"color:rgb(36, 41, 47)\"> to generate images using arbitrary realistic models. </span><strong><span style=\"color:rgb(250, 82, 82)\">Please make sure to set the clip skip as 2 when generating images. </span></strong><span style=\"color:rgb(37, 38, 43)\">The generalization ability of the realistic version has been tested on multiple realistic models. See the preview images for details.</span></p><h3 id=\"heading-227\">2023/7/16 update</h3><p>Update dataset. Retrain the model using new craft.</p><h3 id=\"heading-228\">2023/3/11 update</h3><p>Update dataset and model. Reduce loss to 0.09 using Lion optimizer. <strong>If you want to stably generate good results, pls make sure your sampler settings are identical to the following settings (and make sure your clip_skip is set as 2):</strong></p><ul><li><p><strong>eta for DDIM: 1 (0.67~1 should be ok)</strong></p></li><li><p><strong>eta for ancestral samplers: 1 (must be set as 1)</strong></p></li><li><p><strong>sigma noise: 1</strong></p></li><li><p><strong>eta seed noise delta: 31337</strong></p></li></ul><h1 id=\"heading-229\">Introduction</h1><p>A LORA model trained with ~28 images of Shiranui Mai by <a target=\"_blank\" rel=\"ugc\" href=\"https://twitter.com/Akiryooooo\"><strong>Akiryo</strong></a>. <strong>The trigger tags are 'akiryo-mai' and 'shiranui mai'.</strong> 0.6~0.8 weights are good. <strong>The preview images are generated using latest version of </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/9139/yesmix\"><strong>YesMix </strong></a><strong>and </strong><a target=\"_blank\" rel=\"ugc\" href=\"https://civitai.com/models/7808/easynegative\"><strong>EasyNegative </strong></a><strong>embedding.</strong></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 28,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 17116,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3163,
                        "thumbsDownCount": 0,
                        "commentCount": 21,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 0
                    },
                    "creator": {
                        "username": "zakp",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/82d458b6-5669-447f-a826-7de19e18f9e9/width=96/zakp.jpeg"
                    },
                    "tags": [
                        "character",
                        "girl",
                        "3d",
                        "game character"
                    ],
                    "modelVersions": [
                        {
                            "id": 119417,
                            "name": "v2.0 (realistic)",
                            "index": 0,
                            "modelId": 16667,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 29,
                            "description": "<p>Upload the realistic version to generate images on arbitrary realistic models. <strong>Please make sure to set the clip skip as 2 when generating images.</strong></p>",
                            "publishedAt": "2023-07-17T07:04:13.136",
                            "availability": "Public",
                            "trainedWords": [
                                "akiryo-mai, shiranui mai, parted bangs, mature female, high ponytail,shiny skin"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3976,
                                "ratingCount": 247,
                                "rating": 5,
                                "thumbsUpCount": 447,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 85573,
                                    "sizeKB": 40861.3515625,
                                    "name": "akiryomai-v2-realistic-final-6ep.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-17T07:05:57.055Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "CE376FA6",
                                        "AutoV2": "B60C97F6A5",
                                        "SHA256": "B60C97F6A5FC2A70B50E2B04EFA2FEDD6ECC6AA3FE93C145543003F5897CF004",
                                        "CRC32": "A8A14172",
                                        "BLAKE3": "7E0901802A7676278740C9BB42BDF260377CCDC97E99C08307C0304DD50E279E",
                                        "AutoV3": "BF36BF2957E5"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/119417",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1594510,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c50e2a51-ff35-4a28-b6b5-84a537f80ab4/width=450/1594510.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "U5G81I00-M-=00R.K6019axaxaxZ02Nd~BV?",
                                    "type": "image"
                                },
                                {
                                    "id": 1594517,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0f798340-51d3-45e8-983c-fed170868040/width=450/1594517.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "U6Fq~|00000Mx,02~V0203^*~AkC00$%Iq_2",
                                    "type": "image"
                                },
                                {
                                    "id": 1594507,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e362f0cf-aabe-4868-9bfb-2f740bceba5d/width=450/1594507.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "U7Gt$n9j0000s+Nbwc=_00~8xw.74-D*~Vo#",
                                    "type": "image"
                                },
                                {
                                    "id": 1594509,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5c457563-abdf-4528-9eba-61c12ce3da2d/width=450/1594509.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "U8FOAP9b00~V57%L~BE29a?G?G9aE1xt={M|",
                                    "type": "image"
                                },
                                {
                                    "id": 1594515,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/51726420-9b01-41c6-a1a7-6c80d55d9c31/width=450/1594515.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "UDE2qQE2OrIUDgR.D%tRx]IV~Wt5D%I;RPxa",
                                    "type": "image"
                                },
                                {
                                    "id": 1594512,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b82c4644-4eeb-4a87-a834-aabf01c59511/width=450/1594512.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1840,
                                    "height": 1376,
                                    "hash": "UCHU2s~A0fnm00OBM|Ipo2-U^jbb^*%ME1I:",
                                    "type": "image"
                                },
                                {
                                    "id": 1594513,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4cdd9e50-46d3-4057-bae5-fdd648abccbd/width=450/1594513.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "U8IWA*Fs8wwM00$kml#S01Rj*JI:00pH^kR-",
                                    "type": "image"
                                },
                                {
                                    "id": 1594514,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4358ce8b-da04-4c81-abd3-0ae85f90920c/width=450/1594514.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "UCIX8DDOO=IU71IAOYV@0M9Z~V%2?HEK$*s.",
                                    "type": "image"
                                },
                                {
                                    "id": 1594516,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/21360b0a-04b4-4ae7-8812-23f8c0661e03/width=450/1594516.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "U7H^w[^+00I:0fR556^%IU~V~BWV0f0L9a={",
                                    "type": "image"
                                },
                                {
                                    "id": 1594518,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5d6cacb5-b60c-472c-b3bf-c4861065e338/width=450/1594518.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "UGIzx7MzE0Ne_M01E1X9yDMx?Z%3~VIpxt%2",
                                    "type": "image"
                                },
                                {
                                    "id": 1594519,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ee441479-6cb1-4425-9011-05410299a4ca/width=450/1594519.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "UBE_y|~V9tt69[IVt7-o4o9a~V%L%fNH4:NG",
                                    "type": "image"
                                },
                                {
                                    "id": 1594520,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/242fdfd6-9719-4f33-b9ec-f4666846c0f1/width=450/1594520.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 4000,
                                    "height": 2858,
                                    "hash": "UaL4B2_N_N.9.8WBjYoK%gRjjYWB%hRjoJjY",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/119417"
                        },
                        {
                            "id": 118997,
                            "name": "v2.0 (anime)",
                            "index": 1,
                            "modelId": 16667,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 28,
                            "description": "<p>Update dataset. Retrain the model using new craft.</p>",
                            "publishedAt": "2023-07-16T15:05:34.827",
                            "availability": "Public",
                            "trainedWords": [
                                "akiryo-mai",
                                "shiranui mai",
                                "parted bangs",
                                "high ponytail",
                                "lips"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1247,
                                "ratingCount": 88,
                                "rating": 5,
                                "thumbsUpCount": 99,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 85240,
                                    "sizeKB": 37295.310546875,
                                    "name": "akiryomai-v2-naivae-final-6ep.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-17T02:59:59.975Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "12702BD5",
                                        "AutoV2": "F49B273362",
                                        "SHA256": "F49B273362B89E4861CFE43EA7345BA0B0155F73440E223F63C6078880B1128F",
                                        "CRC32": "26F5762E",
                                        "BLAKE3": "C94A010D110A3F0ADEA97B019FB20F29ADF16E56F69FC2FD66738C94A224AB85",
                                        "AutoV3": "30A746541150"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/118997",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1585513,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6e30e5d6-5966-4fe8-8b3e-ad7f2b428da4/width=450/1585513.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "UFHnEH~W5QRPM_IoIUIU9t9a^k-;xt%MtRt7",
                                    "type": "image"
                                },
                                {
                                    "id": 1585497,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f30adfd2-81b8-4f2d-979b-4afce51c84cc/width=450/1585497.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "UBI|:r-;00tlAC%MIU^+$%I:~C-S01D%4:%1",
                                    "type": "image"
                                },
                                {
                                    "id": 1585496,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f665a5d4-d863-4f1a-87c4-6b7b370976ed/width=450/1585496.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "U9EKovIV0L~U^On%?Gt7AWof=yIp?GE2M|%1",
                                    "type": "image"
                                },
                                {
                                    "id": 1585498,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/59f03608-2fdc-4fd7-b79e-a2c457976ce2/width=450/1585498.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "UHGa?^xuI.%20eM|o2E1w]9ZNHxu9uR,~Voe",
                                    "type": "image"
                                },
                                {
                                    "id": 1585500,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0bd281c3-67b9-4127-baf3-61b656a9358c/width=450/1585500.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1840,
                                    "height": 1376,
                                    "hash": "U8Hwu%^*00-nxW00xti_0K0M_3I:~WE2xZ-p",
                                    "type": "image"
                                },
                                {
                                    "id": 1585499,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/792acc62-23d4-45bd-bc32-5bd6979a76ad/width=450/1585499.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "UBFq8j~A02,U0gV@}?%10gIpShNe?F=_$$j?",
                                    "type": "image"
                                },
                                {
                                    "id": 1585503,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/13456b94-d88d-4e63-8bd8-41ff1d0dee61/width=450/1585503.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "UEGRu1?u00R5%_-oR49F_M-;sV9Z-pnmD%In",
                                    "type": "image"
                                },
                                {
                                    "id": 1585501,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c9da1465-3c6b-4e71-9892-fc71cd7bb05d/width=450/1585501.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "UMH1lB=|^*~WobE1RPNF0L%LWBRjIV-oM|af",
                                    "type": "image"
                                },
                                {
                                    "id": 1585507,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9a01efc5-d906-4686-9d17-018ff6b9576b/width=450/1585507.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "UGJ78b$M00~V?uWCwI?GIoS4-o-oxZt7xtjF",
                                    "type": "image"
                                },
                                {
                                    "id": 1585504,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/63cf7dc9-79a1-437a-bbd4-7142c153537e/width=450/1585504.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "UAH-S*0LEexH0yIo4.xa00?H~C0Kof-V-p-p",
                                    "type": "image"
                                },
                                {
                                    "id": 1585508,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/55a7a0de-5dd6-4500-bfc2-0fb8af18c617/width=450/1585508.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "UaIqGm~CInaeIoay%2fkE1WBxaR*%Mofo0xu",
                                    "type": "image"
                                },
                                {
                                    "id": 1585509,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f6819ef4-4909-49e0-a6b5-507eb59c54bf/width=450/1585509.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "ULINQ{~B0e^*I:-p%2Rk9[I:%L%2IU$*%LS2",
                                    "type": "image"
                                },
                                {
                                    "id": 1585506,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/637f10aa-b468-40eb-8a77-e9b109b64f7e/width=450/1585506.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "UeG@-?xuRj-:~Vt7R*%L%Lt7s:ofW=oft6oK",
                                    "type": "image"
                                },
                                {
                                    "id": 1585510,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/af5858c2-447a-4fdd-9b02-f09a9d1c0499/width=450/1585510.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1840,
                                    "height": 1376,
                                    "hash": "U5ID?jEN00007GRj024;00Ri^l~W~B56014:",
                                    "type": "image"
                                },
                                {
                                    "id": 1585511,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3a73d751-894a-496c-9b45-1038d1540d07/width=450/1585511.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1840,
                                    "height": 1376,
                                    "hash": "U6ID:c~W00=e7exa00M}00V?-VE2wI0f4.0e",
                                    "type": "image"
                                },
                                {
                                    "id": 1585512,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/368ae5ef-2680-4c48-a693-4d47bf1c0e8b/width=450/1585512.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1840,
                                    "height": 1376,
                                    "hash": "UHIzu5={JU?G56I:M{n$9tD%=xNG~V%LxvX9",
                                    "type": "image"
                                },
                                {
                                    "id": 1585514,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e97f828b-ecbb-4543-8b79-8213228ad221/width=450/1585514.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1376,
                                    "height": 1840,
                                    "hash": "ULGRbk~VW-xa^+xuNaWC4.s:-pRkIos:-VR*",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/118997"
                        },
                        {
                            "id": 21625,
                            "name": "v1.5",
                            "index": 2,
                            "modelId": 16667,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 28,
                            "description": "<p>Update dataset and model. Reduce loss to 0.09 using Lion optimizer.</p>",
                            "publishedAt": "2023-03-11T13:21:09.108",
                            "availability": "Public",
                            "trainedWords": [
                                "akiryo-mai",
                                "shiranui mai",
                                "ponytail"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 7893,
                                "ratingCount": 1621,
                                "rating": 5,
                                "thumbsUpCount": 1629,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 18028,
                                    "sizeKB": 73849.255859375,
                                    "name": "akiryomai-lora-v1.5-64dim-18ep-naivae.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-11T13:26:34.536Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "DBE5DA83",
                                        "AutoV2": "4DBB37A723",
                                        "SHA256": "4DBB37A723E0A59DEA513C856581914FDCCE4322CC5575366315FC5233440A8A",
                                        "CRC32": "90A90831",
                                        "BLAKE3": "2F063331BB82F671DA1639E6DFD3A63429AB0B79407BBADC8AE00AE52D7CAE7F",
                                        "AutoV3": "CACB82557DA9"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/21625",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 230039,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7dfb9734-2eef-4b35-0c35-ad0aa3fe3700/width=450/230039.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UNHU{[_K?rs*%x?ZNYD%Rrno$+RjW[N2jGad",
                                    "type": "image"
                                },
                                {
                                    "id": 230038,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1cd1cb34-6deb-4825-233a-4d9814125500/width=450/230038.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U2FEr@00?X000002J~n500i}~V^+^jOsn401",
                                    "type": "image"
                                },
                                {
                                    "id": 230037,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2a243b18-d7a7-40ee-1453-960654a48100/width=450/230037.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UDF=K,00~p019G%LNGs:00?aD%%ME1jHxGxt",
                                    "type": "image"
                                },
                                {
                                    "id": 230036,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/af96a87a-fcdc-48b1-f22b-419befddfc00/width=450/230036.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UAGHrD00Ez-o00~q4.IpKiDj?a%1NHja-Ut7",
                                    "type": "image"
                                },
                                {
                                    "id": 230035,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d8ba71d2-1722-4ed0-b164-1ea16f267700/width=450/230035.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULHnTv?GNF~Vt5-:?HR+4.V@xaNGs;E19ZRj",
                                    "type": "image"
                                },
                                {
                                    "id": 230034,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e1c69bcc-8765-485c-8e80-9add840c0400/width=450/230034.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8Iq7S0K0KMd0J~C}Zt600j=~p?HB5E1i_E1",
                                    "type": "image"
                                },
                                {
                                    "id": 230033,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/70bf2de9-2820-442c-c77f-9d44e7219c00/width=450/230033.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5JtF-0000.8cX0L-:jX00~W?G^*9Y-;w^Ip",
                                    "type": "image"
                                },
                                {
                                    "id": 230032,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3372915a-21cc-4f9e-f472-1b3137d93a00/width=450/230032.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UOFOfU0LI:%L~W4.W=xuxtM{%2xa9tt7V@of",
                                    "type": "image"
                                },
                                {
                                    "id": 230031,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9e4599fa-17e7-46a2-26b8-49bb3116e100/width=450/230031.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5FX*T~V0J4:,,?G~V^*Md0L01xZ00Io9H9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 230029,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/affc2b73-3540-4c40-98b7-f9205135ef00/width=450/230029.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UGH1rV^*Ezo}xWNe~Vxa0KIp={n%~WRkE1IU",
                                    "type": "image"
                                },
                                {
                                    "id": 230028,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/471b8322-d02f-4f9e-082d-69109d597a00/width=450/230028.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEJjuJ000KWFtRIU^*M{%fM{~WRjkSIU?abI",
                                    "type": "image"
                                },
                                {
                                    "id": 230027,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4d42f8b1-361e-4ad0-89ff-c05c13038300/width=450/230027.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U8Hdpj-p00EkE29u-T~V0e-;~V9ZIn^*?b%2",
                                    "type": "image"
                                },
                                {
                                    "id": 230026,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/010e65fe-97ee-4e40-b935-2b5980d42700/width=450/230026.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "UNI|dr~BEL^*~VoxoLxuSgt6%2t7WBjuNHof",
                                    "type": "image"
                                },
                                {
                                    "id": 230025,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3fedadf4-e051-49b5-193e-5818199c7200/width=450/230025.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "U7I|j:-oK#?bAV019F0000bc~VD*D%V]Rj^*",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/21625"
                        },
                        {
                            "id": 19680,
                            "name": "v1.0",
                            "index": 3,
                            "modelId": 16667,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 28,
                            "description": null,
                            "publishedAt": "2023-03-07T04:12:48.722",
                            "availability": "Public",
                            "trainedWords": [
                                "akiryo-mai",
                                "shiranui mai"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 4000,
                                "ratingCount": 996,
                                "rating": 5,
                                "thumbsUpCount": 996,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 16430,
                                    "sizeKB": 36980.0234375,
                                    "name": "shiranuiakiryo-lora-v1-32dim-7ep.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-07T04:16:35.854Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "95ADA523",
                                        "AutoV2": "38C110908B",
                                        "SHA256": "38C110908BA4E08B29C1C62A4B035319AFC33278CDD3317E1F22156DA3BD1B08",
                                        "CRC32": "31786435",
                                        "BLAKE3": "94685BBA1FA853C9DAC93967B7A8E19434CEA9125D96D25E528620E7038F53B8",
                                        "AutoV3": "82EC4305EE55"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/19680",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 207056,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/22423e06-12f2-4246-e412-0d691e870600/width=450/207056.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "ULIXQ-I.EM4ogOMxs-M{O@RP%2Ri_NjYe.M{",
                                    "type": "image"
                                },
                                {
                                    "id": 207065,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2956db91-c07c-4675-29a2-a1a514bc0a00/width=450/207065.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UDH-c9~C9@J,TKoz$g-o0$NHxuRkK8xtE2-;",
                                    "type": "image"
                                },
                                {
                                    "id": 207064,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5f22b145-65bf-4a88-feec-b5430a18cb00/width=450/207064.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 768,
                                    "height": 1152,
                                    "hash": "UAJG~50K0d%M9DRj-o9a00xX%Mxu~n%1^%M{",
                                    "type": "image"
                                },
                                {
                                    "id": 207063,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a10bd190-2525-4eb5-cbc2-cd6cb2059d00/width=450/207063.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UIHB6%~VJT-o9tRjjYxt56tQ%2xtRkWCt7t7",
                                    "type": "image"
                                },
                                {
                                    "id": 207062,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/616ed0f4-b2f1-44f0-8128-ffe2cbdfe200/width=450/207062.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UEG[H1~VtQoft2Io-o?G8_RPM_%2Seae~Bn$",
                                    "type": "image"
                                },
                                {
                                    "id": 207061,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9a02290b-7ae8-4de4-bb31-6c9effec6f00/width=450/207061.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UTMjH-nhtm-=.TMxt7%MOFtRV@bbxvWqa}xt",
                                    "type": "image"
                                },
                                {
                                    "id": 207060,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/280c3864-fc95-4518-c4b9-6788313ec500/width=450/207060.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U5Hd,2N000k7000L01^%$y~p%3j^0*000L?b",
                                    "type": "image"
                                },
                                {
                                    "id": 207059,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c07240a6-1bf6-468d-c0f6-f7c13e993c00/width=450/207059.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1536,
                                    "height": 1024,
                                    "hash": "U6ID~,00009^00?H~Voc00bw~C-9?Za#9a%1",
                                    "type": "image"
                                },
                                {
                                    "id": 207058,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/74d6055e-8ac2-4eb0-3ef8-67c9412b4500/width=450/207058.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "U9KJ.000_NWBEKtl%1jw$_IqsS-;xFsR-;9Z",
                                    "type": "image"
                                },
                                {
                                    "id": 207057,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/402c4507-4639-4933-b457-396f91b4c300/width=450/207057.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1024,
                                    "height": 1536,
                                    "hash": "UBH1e_0L9txu56-p%0n%01E3~VIV%1E2E2xa",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/19680"
                        }
                    ]
                },
                {
                    "id": 124609,
                    "name": "Logo.Redmond - Logo Lora for SD XL 1.0",
                    "description": "<h1 id=\"heading-28\">Logo.Redmond is here!</h1><p>I'm grateful for the GPU time from <strong>Redmond.AI</strong> that allowed me to finish this LORA!</p><p>This is a <strong>LOGO </strong>LORA fine-tuned on <strong>SD XL 1.0.</strong></p><p>Test all my Loras <a target=\"_blank\" rel=\"ugc\" href=\"https://huggingface.co/spaces/artificialguybr/artificialguybr-demo-lora\">here</a> for free and unlimited. Thanks, HF, for Inference API!</p><p>The LORA has a high capacity to generate LOGOS in a wide variety of themes.<strong> It's a versatile LORA.</strong></p><p>I recommend gen in 1024x1024.</p><p>You can use detailed, minimalist, colorful, black and white as tag to control the results.</p><p><strong><u>The tag for the model:LogoRedAF</u></strong></p><p>LORA is not perfect and sometimes needs more than one gen to create good images. I recommend simple prompts.</p><p>I really hope you like the LORA and use it.</p><p>If you like the model and think it's worth it, you can make a donation to my <a target=\"_blank\" rel=\"ugc\" href=\"https://www.patreon.com/user?u=81570187\">Patreon</a> or <a target=\"_blank\" rel=\"ugc\" href=\"https://ko-fi.com/jvkape\">Ko-fi</a>.</p><p>Follow me in my twitter to know before all about new models:</p><p><a target=\"_blank\" rel=\"ugc\" href=\"https://twitter.com/artificialguybr/\"><u>https://twitter.com/artificialguybr/</u></a></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": false,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 1,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 37690,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3151,
                        "thumbsDownCount": 1,
                        "commentCount": 17,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 820
                    },
                    "creator": {
                        "username": "artificialguybr",
                        "image": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f00f0b34-bdf0-4884-9c0c-9d3b389613f4/width=96/artificialguybr.jpeg"
                    },
                    "tags": [
                        "digital art",
                        "logo",
                        "style",
                        "logos",
                        "brand"
                    ],
                    "modelVersions": [
                        {
                            "id": 177492,
                            "name": "v2.0",
                            "index": 0,
                            "modelId": 124609,
                            "baseModel": "SDXL 1.0",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-10-07T02:35:59.367",
                            "availability": "Public",
                            "trainedWords": [
                                "logo",
                                "logoredmaf"
                            ],
                            "baseModelType": null,
                            "stats": {
                                "downloadCount": 25432,
                                "ratingCount": 660,
                                "rating": 5,
                                "thumbsUpCount": 1528,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 135681,
                                    "sizeKB": 166542.99609375,
                                    "name": "LogoRedmondV2-Logo-LogoRedmAF.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-10-07T02:35:53.536Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "07D8DCA8",
                                        "AutoV2": "55F7F40883",
                                        "SHA256": "55F7F408831C34F84857B1A728D1DD70B76083D80E7279E22097CA5AC4430E13",
                                        "CRC32": "D265A6E4",
                                        "BLAKE3": "EEB64B0FA265FC7FB8F4868D52281BDB3A493C268A39979A091E34C7D5D69ED6",
                                        "AutoV3": "73EA578FFB4F"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/177492",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 2828404,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5b4fa0fe-93b9-41b7-9eca-311134aaaf62/width=450/2828404.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UYPj7Dt7~pt7WBj[t7ay_2a{9Gj[-:ayM{kC",
                                    "type": "image"
                                },
                                {
                                    "id": 2828405,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9194a8cf-6a4b-4fec-89a2-ae918085c7a6/width=450/2828405.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U5P#Q3=_0v=_]hj@Xmj[0cbH^SjZ?]j[iIjZ",
                                    "type": "image"
                                },
                                {
                                    "id": 2828406,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/019ed587-6f8f-4a9f-a3ed-4cdab7e41095/width=450/2828406.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U8D.E@o}8ux]tRofX8Rj8uj[@uWVpcRjr?x[",
                                    "type": "image"
                                },
                                {
                                    "id": 2828407,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bf8c1303-eebd-4157-a04d-f93a91af6440/width=450/2828407.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U88g?Oxa00IqX9ayn$of00NH~W$%rrofS$Rk",
                                    "type": "image"
                                },
                                {
                                    "id": 2828408,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/be13be44-b666-4ab5-a17f-b061f1b61dfe/width=450/2828408.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UAR2}Q%gqF-V-:kCbbe.p_jZUwX8%gaenOoz",
                                    "type": "image"
                                },
                                {
                                    "id": 2828409,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/ac86ca03-2825-4f10-82e3-bb7a51b9090b/width=450/2828409.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UEOWZ$xu~V%M-pj[NGa{~BkC4:V@Ntay%2oL",
                                    "type": "image"
                                },
                                {
                                    "id": 2828410,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/39f8aac0-2774-4cab-8d10-8321e8d89ab4/width=450/2828410.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U3Oy|a_29r~V~Vj[WUj[9rj[=#a{_2j[s:fj",
                                    "type": "image"
                                },
                                {
                                    "id": 2828412,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1aef035d-7213-4e47-9bfb-c228af40644b/width=450/2828412.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U5C*astk2[tkK5a|%1j[7dbH:+jZ~Vj[57WB",
                                    "type": "image"
                                },
                                {
                                    "id": 2828413,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/570f0408-1390-4f4e-a8f3-0f145715a037/width=450/2828413.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U4Nv[0?a+:?G~pj@ITj[vcWBKnofMcj[_4ay",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/177492"
                        },
                        {
                            "id": 136078,
                            "name": "v1.0",
                            "index": 1,
                            "modelId": 124609,
                            "baseModel": "SDXL 1.0",
                            "nsfwLevel": 1,
                            "description": null,
                            "publishedAt": "2023-08-07T19:28:35.796",
                            "availability": "Public",
                            "trainedWords": [
                                "LogoRedAF"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 12258,
                                "ratingCount": 1134,
                                "rating": 5,
                                "thumbsUpCount": 1635,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 99432,
                                    "sizeKB": 665266.12109375,
                                    "name": "LogoRedmond_LogoRedAF.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-08-07T19:26:01.327Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "B861CB57",
                                        "AutoV2": "8D22FAB0F7",
                                        "SHA256": "8D22FAB0F75DB3C804A17FF6CD57D831DED4C03C548D87D7111BAFFB524DD61A",
                                        "CRC32": "D9E7DFBD",
                                        "BLAKE3": "FA37874139B349F85FA1C9F6DE02854E41C9A4B399025F9A9A95D4EA6BADD62C",
                                        "AutoV3": "E736E5060615"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/136078",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1920805,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/86b90d3d-6fa2-4294-ae25-919a0f220e88/width=450/1920805.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UDFqhcw103L1o#WCnhxY04S~~Uz=n4s.o~Iq",
                                    "type": "image"
                                },
                                {
                                    "id": 1920795,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e3d0e64-3296-4c37-bb89-b6178e80b270/width=450/1920795.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UALpU7$k3rx]~UoJM|j]8cXRVERkM1WYTcWB",
                                    "type": "image"
                                },
                                {
                                    "id": 1920794,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/86388474-0ffb-420b-b311-cc4748046c58/width=450/1920794.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UHK2U}X98J-:}loeElWCCms:n4NI6UR+$xs:",
                                    "type": "image"
                                },
                                {
                                    "id": 1920801,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/7f4e60d1-bf11-499c-948d-c95c218c54e5/width=450/1920801.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U7AT8As=00SIoya{ahj]00WT~qssn.jvbWWm",
                                    "type": "image"
                                },
                                {
                                    "id": 1920793,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1409d481-e929-4453-9a63-9c8d75c70bfc/width=450/1920793.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U5Q0Eq.S3=}@}[t6O@Rj3prrujKjuiR*zo$*",
                                    "type": "image"
                                },
                                {
                                    "id": 1920798,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/beb1a6f8-8cd8-470d-b13a-97b1da2f59a7/width=450/1920798.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UMPYVc$T$$iz:@t09vn~{^WEwOo{OGS4=tWZ",
                                    "type": "image"
                                },
                                {
                                    "id": 1920799,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/f5236e99-2177-45b6-a1aa-d752611028ee/width=450/1920799.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UCL}52pJX4#7~WkqX9n39YRP00%f%gn4IUTK",
                                    "type": "image"
                                },
                                {
                                    "id": 1920796,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/23f30de7-1026-47e6-b664-476ff9f1da2c/width=450/1920796.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U6J*SLb_3G}@.6niRUS~3EsS:iJBw6OXpD+v",
                                    "type": "image"
                                },
                                {
                                    "id": 1920806,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/74170c47-ecf0-46a4-ac81-eed67695544a/width=450/1920806.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U6KAZt%2Fq%2^#j[E4e.E]jb#sbX0:ae~7kW",
                                    "type": "image"
                                },
                                {
                                    "id": 1920792,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6c6d5571-ad95-4d86-8902-a38bde101c98/width=450/1920792.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UEJu4Vxa?axctRbHsmn%~pbcD%W,xYr@NeOW",
                                    "type": "image"
                                },
                                {
                                    "id": 1920807,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e97c896-4d03-4cee-a91b-055966cdacec/width=450/1920807.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U3O:Rt_2PU~V~Vj[S#j[PBj[QmV@_Mj[m,js",
                                    "type": "image"
                                },
                                {
                                    "id": 1920797,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/add5c38d-9bbb-4986-b43e-bc96c7863f31/width=450/1920797.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UCPh8R%0_K%0-nj@R*ju_Ka}DloLoIjuxtfQ",
                                    "type": "image"
                                },
                                {
                                    "id": 1920800,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c7055156-cc22-4c62-86c2-3aeefdfbb7ff/width=450/1920800.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U4Kdom-r90-;~qf8IVj]4Xk9--V_9GkB_2WA",
                                    "type": "image"
                                },
                                {
                                    "id": 1920804,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9409ed66-b02c-4fef-9d5a-1da5a16ad3be/width=450/1920804.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U6MHZ9?G|Tpe~qofIVWB}3S606wGM|Rj-:xu",
                                    "type": "image"
                                },
                                {
                                    "id": 1920802,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3b30ff52-a80d-4bbd-a688-88cf16e200c2/width=450/1920802.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UAG[ECxa8woMs;j[afay00WB_Nofxaayofof",
                                    "type": "image"
                                },
                                {
                                    "id": 1920803,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/4dce67df-7cef-4252-9504-31033f822b57/width=450/1920803.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "UAM7oxxv_3%MghjuxDj[_NoKDiWX^Pj@E%a#",
                                    "type": "image"
                                },
                                {
                                    "id": 1920808,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8f216cce-81c9-4ec4-a401-1b59f7642b60/width=450/1920808.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1024,
                                    "hash": "U7NvYv-o~B-p?Gj[R*jt^*j[4:WBt7fQ%1j[",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/136078"
                        }
                    ]
                },
                {
                    "id": 25306,
                    "name": "Giantess | Concept",
                    "description": "<p>For generating really big girls<br /><br /><em>*5.0 update*</em> <br />Yet another complete overhaul, striving to get this to meet my own expectations but its difficult. This version has gone though over a dozen revisions before I decided to just push this one for public testing<br /><br />Cut out alot of data to focus entirely on city based scenarios but has drastically improved responsiveness to describing city scenes, may try to make additional loras with other focuses later<br /><br />Keywords:<br /><br />\"GTS\" - General use, some keyword dont seem to be as strong if this isnt present<br /><br />\"Aerial View\" - Trained on images taken from a mid air perspective<br /><br />\"Ground View\" - Trained on images from a street level view, but not directly under her<br /><br />\"Looming\" - Trained on images of a strong sense of low perspective<br /><br />\"BuildingSeat\" - Will have her use a building as a chair<br /><br />\"Rampage\" - Will surround her with collapsing buildings<br /><br />\"Stepping\" - Trained on low perspective shots featuring well detailed feet<br /><br />\"With Tiny\" - Trained on images also featuring a much smaller character<br /><br />\"Partially Obscured\" - Trained on images with her slightly hidden from view behind buildings<br /></p><p>Plays well with most other LoRAs<br />Recommend 0.8-1 Strength<br /><br />Join my discord for exclusive LoRAs!<br /><a target=\"_blank\" rel=\"ugc\" href=\"https://discord.gg/B89NRj8Uqh￼If\">https://discord.gg/B89NRj8Uqh<br /></a>If you've enjoyed my models, consider leaving a tip.<br /><a target=\"_blank\" rel=\"ugc\" href=\"https://ko-fi.com/leontalon￼Commission\">https://ko-fi.com/leontalon<br /></a>Commission requests are also open<br /><a target=\"_blank\" rel=\"ugc\" href=\"https://ko-fi.com/leontalon/commissions\">https://ko-fi.com/leontalon/commissions</a></p>",
                    "poi": false,
                    "allowNoCredit": true,
                    "allowCommercialUse": [
                        "Image",
                        "RentCivit",
                        "Rent",
                        "Sell"
                    ],
                    "allowDerivatives": true,
                    "allowDifferentLicense": true,
                    "type": "LORA",
                    "nsfw": false,
                    "nsfwLevel": 7,
                    "cosmetic": null,
                    "stats": {
                        "downloadCount": 32050,
                        "favoriteCount": 0,
                        "thumbsUpCount": 3144,
                        "thumbsDownCount": 1,
                        "commentCount": 30,
                        "ratingCount": 0,
                        "rating": 0,
                        "tippedAmountCount": 2938
                    },
                    "creator": {
                        "username": "LeonTalon",
                        "image": "https://lh3.googleusercontent.com/a/AEdFTp7zLM1fubX4omLmP2Jv6hnJw_jf7p8ANbPjEsTS=s96-c"
                    },
                    "tags": [
                        "anime",
                        "concept",
                        "fetish",
                        "giantess"
                    ],
                    "modelVersions": [
                        {
                            "id": 123205,
                            "name": "v5.0",
                            "index": 0,
                            "modelId": 25306,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>Major Changes</p>",
                            "publishedAt": "2023-07-22T12:09:44.411",
                            "availability": "Public",
                            "trainedWords": [
                                "GTS"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 14054,
                                "ratingCount": 635,
                                "rating": 4.98,
                                "thumbsUpCount": 1247,
                                "thumbsDownCount": 1
                            },
                            "files": [
                                {
                                    "id": 88752,
                                    "sizeKB": 73944.3994140625,
                                    "name": "GTS.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-07-22T11:41:12.447Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "7218DC80",
                                        "AutoV2": "9783CEF3C6",
                                        "SHA256": "9783CEF3C6A70644960A9CF00F4CCABBD2CA0ABCEFB8C2FB3B0F9BFBF2CAF92F",
                                        "CRC32": "44B5F15B",
                                        "BLAKE3": "4C689E623ED066E91C3290DA3076E4E0A5B72066483E7BE90B80B2FF1BDEE098",
                                        "AutoV3": "991FF1458AC0"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/123205",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 1668470,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d84e931c-27c7-4d1b-b690-8d56af431f28/width=450/1668470.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1152,
                                    "hash": "USG92DT00#I]PXt8kXJC5YR%%2%2Ist6j]xD",
                                    "type": "image"
                                },
                                {
                                    "id": 1668483,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5acdcf99-4906-43c1-8f26-1862f866f22f/width=450/1668483.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1024,
                                    "height": 1152,
                                    "hash": "UOG[c%Nf0eR..Txbt6EM9}NG-pozNKkCShxZ",
                                    "type": "image"
                                },
                                {
                                    "id": 1668430,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/628c78aa-7e54-47a2-a492-51d3c5bbfaeb/width=450/1668430.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1152,
                                    "hash": "URHC4di^_N-;O]V?b0ofE4of9GIWWZWBj?j]",
                                    "type": "image"
                                },
                                {
                                    "id": 1668442,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b3b9edc2-1f99-47c8-95cc-b382dd9edcbe/width=450/1668442.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1152,
                                    "hash": "UaEWF0fl%gX9pfazbwofE2jYIpWCIUWBWBRk",
                                    "type": "image"
                                },
                                {
                                    "id": 1668439,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8a43c8af-6026-44e9-a0ca-d41dafb97707/width=450/1668439.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1152,
                                    "hash": "URHC7qIASxpyKlwI%1kr=xWqkXRPE2xax]t7",
                                    "type": "image"
                                },
                                {
                                    "id": 1668453,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5ca91453-dea2-43c5-b5d5-d97c3fc0c48b/width=450/1668453.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1152,
                                    "hash": "UAHLVqBWpccu00jDi{a080;w-.0L=|bI%fD$",
                                    "type": "image"
                                },
                                {
                                    "id": 1668524,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d8a65deb-3688-4c23-94f3-7b373a3f2f1a/width=450/1668524.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1024,
                                    "height": 1152,
                                    "hash": "U7BfkT9a-.NtV[~B4:of9bofE14:D%E1ozoy",
                                    "type": "image"
                                },
                                {
                                    "id": 1668657,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/257b2ed9-5bb3-40c8-aabb-f80ee8d2a3d2/width=450/1668657.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1024,
                                    "height": 1152,
                                    "hash": "UEFGnPSi_MTf5JoI.7Nx8wa#8wR5-;xurBxE",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/123205"
                        },
                        {
                            "id": 63765,
                            "name": "4.0",
                            "index": 1,
                            "modelId": 25306,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-05-06T09:01:23.943",
                            "availability": "Public",
                            "trainedWords": [
                                "GTS",
                                "GTSCity",
                                "GTSGiga",
                                "GTSPlanet",
                                "GTSSpace",
                                "Looming",
                                "Stepping",
                                "Rampage",
                                "Sitting on Building"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 11030,
                                "ratingCount": 894,
                                "rating": 5,
                                "thumbsUpCount": 967,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 44870,
                                    "sizeKB": 73908.3037109375,
                                    "name": "GTSv5.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-05-06T08:45:47.938Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "DB1AF16E",
                                        "AutoV2": "670104D06E",
                                        "SHA256": "670104D06E092F675FC4EE439FEF806D71087094B68FA5FA6E39CFE88BC10C65",
                                        "CRC32": "40BADCFF",
                                        "BLAKE3": "772470491D9B164E7514292B229197DA926DFD09C1DB18E4EF721359B837ED2F",
                                        "AutoV3": "2F160A4C51BE"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/63765",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 703650,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/e6fe9b35-6906-478c-8b50-865988661629/width=450/703650.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1152,
                                    "height": 1280,
                                    "hash": "UFH.KXpy1RHXIcaOR;K69]oNv|aKNz?w?a-p",
                                    "type": "image"
                                },
                                {
                                    "id": 711803,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/48bf1a44-850a-4939-9b58-d3e2781840aa/width=450/711803.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1280,
                                    "hash": "UJHo5i?b~p-p_3%1IU%20fMxD*e:M|D*xtM|",
                                    "type": "image"
                                },
                                {
                                    "id": 703651,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/55ec42d8-f1de-48db-8f33-f58497f1c607/width=450/703651.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1280,
                                    "hash": "UKFr^tS~i^$*tnx]R%oz?wNIIT%3cFozx[tR",
                                    "type": "image"
                                },
                                {
                                    "id": 703653,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/9d862eb8-c6ae-4e49-9393-959dbdd7f291/width=450/703653.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1280,
                                    "hash": "UTHV3lx]N^bbYRWrx]S5NMRkR,M|ohM{IVfR",
                                    "type": "image"
                                },
                                {
                                    "id": 703675,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d5cca9e6-ea91-45d4-9639-e559d308f176/width=450/703675.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1472,
                                    "height": 1600,
                                    "hash": "UTH.A_$*bwi^5ZW=Io%1%%NvI;ozx_%M%MIU",
                                    "type": "image"
                                },
                                {
                                    "id": 703676,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b9d55126-cd14-4376-8cbe-391a392efadc/width=450/703676.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1472,
                                    "height": 1600,
                                    "hash": "UEF5%UnMPWQ-E-IT$-NZ*{O@M_pIMcOD~CIn",
                                    "type": "image"
                                },
                                {
                                    "id": 703654,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/736983f8-1778-47aa-b5c8-155968e48467/width=450/703654.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1280,
                                    "hash": "UaHe:~$~s*xt.TWUo}t7NyNdIpM|x^M|kDWB",
                                    "type": "image"
                                },
                                {
                                    "id": 703655,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/71dfe902-4a66-4054-ac7a-b9990d8db531/width=450/703655.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1280,
                                    "hash": "UGF~w5?btm~qW@Ip9x%0VDRP4:e-ofo#t7%M",
                                    "type": "image"
                                },
                                {
                                    "id": 703670,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0c5a87a4-8ae3-4a6d-b059-d5572966a753/width=450/703670.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1280,
                                    "hash": "U8HeLP{@7N~qWdIq.AD*01S$ni4:H_IX9Y%1",
                                    "type": "image"
                                },
                                {
                                    "id": 703669,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5bdc38cf-95e2-459b-b883-02963b6b6ed2/width=450/703669.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1280,
                                    "hash": "UEH2D{?I?wxZE8KQIV^j01E10Ktl$d#kxW4:",
                                    "type": "image"
                                },
                                {
                                    "id": 703692,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8ae4dff8-2dab-42a9-8b55-1e0a34362b7b/width=450/703692.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1472,
                                    "height": 1600,
                                    "hash": "UHF5~+K+rVX.%4.8?wWWTeohNa%1TLIoROX9",
                                    "type": "image"
                                },
                                {
                                    "id": 703673,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bc290276-9671-484b-a740-e309283d1be1/width=450/703673.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1280,
                                    "hash": "UbHoh1S6Y6o~T#ofN|j[Din#aLVswHW;V@xa",
                                    "type": "image"
                                },
                                {
                                    "id": 703663,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2e891621-6a94-44d9-bdb6-3ff4322c4b78/width=450/703663.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1280,
                                    "hash": "ULI}^xNI_N-;5Ea|NGIUT2adIVxt0M-;s:WX",
                                    "type": "image"
                                },
                                {
                                    "id": 703668,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/274105e4-bd28-48aa-8996-eedf3974fb10/width=450/703668.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1280,
                                    "hash": "UJFY=StmF#Mw%QWFNeaJ0KIU$$%1McogWAxt",
                                    "type": "image"
                                },
                                {
                                    "id": 711802,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3b149ece-bc18-4848-9ac6-fdb75374aa5b/width=450/711802.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 1152,
                                    "height": 1280,
                                    "hash": "UjI;bg~Wkq%Mo#ozkCWBV@ofododxat7RkRk",
                                    "type": "image"
                                },
                                {
                                    "id": 703660,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0324866d-18bf-472e-88d8-7f4fa93623bb/width=450/703660.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1152,
                                    "height": 1280,
                                    "hash": "UIG[pEo~01~pIokBxuxa0g%N^+oe-T-pNGM{",
                                    "type": "image"
                                },
                                {
                                    "id": 703659,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a9701d96-cf92-4b1c-9845-85a32bf4a3fd/width=450/703659.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1152,
                                    "height": 1280,
                                    "hash": "UlI#ost7%Nxt%fayWVoe_Ns:-;WUoeofjbR*",
                                    "type": "image"
                                },
                                {
                                    "id": 703656,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/c7647d92-5659-41d6-b3dd-2519038f277a/width=450/703656.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 1280,
                                    "hash": "U6IhEaG]0000HX00ui~V}n~V00D%4T57%he.",
                                    "type": "image"
                                },
                                {
                                    "id": 703658,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/b48e388c-78d5-4855-9d94-e192c2554400/width=450/703658.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1152,
                                    "height": 1280,
                                    "hash": "UCG[Wl-W00I:*JW=0KI:t,s;IARj4-WT~Bxa",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/63765"
                        },
                        {
                            "id": 40541,
                            "name": "3.0",
                            "index": 2,
                            "modelId": 25306,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 1,
                            "description": "<p>Added Keyword \"Cramped\"</p>",
                            "publishedAt": "2023-04-09T05:34:35.201",
                            "availability": "Public",
                            "trainedWords": [
                                "GTS",
                                "GigaGTS",
                                "Cramped",
                                "Sitting on Building",
                                "PlanetaryGTS",
                                "Looming"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 3376,
                                "ratingCount": 414,
                                "rating": 5,
                                "thumbsUpCount": 414,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 31409,
                                    "sizeKB": 147621.3115234375,
                                    "name": "GTSv4.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-09T05:25:50.684Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": null,
                                        "fp": null
                                    },
                                    "hashes": {
                                        "AutoV1": "FCCD5ABC",
                                        "AutoV2": "F5363932B2",
                                        "SHA256": "F5363932B20231375FEF2618E01DC5A9AD0CF49C3BADB1AA6F9C8B667A5DE9DD",
                                        "CRC32": "D936715E",
                                        "BLAKE3": "39A3CA7ABE60FBCFD4A7154F9FD3C3A1D50DD8382A316CF8F38D7439B920AFC3",
                                        "AutoV3": "1D9301827714"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/40541",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 448362,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/88797184-481f-4862-8b42-917fdfc82000/width=450/448362.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 896,
                                    "hash": "USF=%L~q.8b_={r=R%M|VXV?aeRiNGkCs:xZ",
                                    "type": "image"
                                },
                                {
                                    "id": 448376,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/43879272-573b-4fad-5976-6d858789d300/width=450/448376.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1152,
                                    "height": 896,
                                    "hash": "UCHe5x?a009v^*tRMxI@-U-U9_M{_Nx[of-:",
                                    "type": "image"
                                },
                                {
                                    "id": 448368,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6c798466-e182-490e-7f07-26c239b12e00/width=450/448368.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1152,
                                    "hash": "UNFG2+t.I9%hyGKRt-Rop0NfXARj-=i^McWB",
                                    "type": "image"
                                },
                                {
                                    "id": 448371,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3913a64f-c622-4a23-b883-36080f068900/width=450/448371.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1152,
                                    "hash": "UDH2QL?bIpWB~pxuE2S5McDiXnM{xF%MI;o#",
                                    "type": "image"
                                },
                                {
                                    "id": 448366,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bb4f8a6b-3a43-4641-de51-5316e42e0700/width=450/448366.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1152,
                                    "hash": "UDH.NTJB59_3~WaK9v#%t8tQKkIU_3i_o~%M",
                                    "type": "image"
                                },
                                {
                                    "id": 448369,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/72f5cd12-37df-4abb-5ae0-31932fe4b000/width=450/448369.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1152,
                                    "hash": "UOGIQ8~V4.9a=E$yE29aIUNGogWXOsXSj@sS",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/40541"
                        },
                        {
                            "id": 33263,
                            "name": "2.0",
                            "index": 3,
                            "modelId": 25306,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": "<p>Added keywords \"GigaGTS\" \"PlanetaryGTS\"</p>",
                            "publishedAt": "2023-04-01T17:00:21.498",
                            "availability": "Public",
                            "trainedWords": [
                                "gts",
                                "gigagts",
                                "planetarygts",
                                "looming",
                                "sitting on building"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1194,
                                "ratingCount": 127,
                                "rating": 5,
                                "thumbsUpCount": 128,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 27379,
                                    "sizeKB": 147611.7470703125,
                                    "name": "GTSv3.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-04-01T17:01:27.535Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "EF12196A",
                                        "AutoV2": "922687D320",
                                        "SHA256": "922687D3209578038D4CA337A01322C7A5E8DA441D09FA0E5FACD40F757097A8",
                                        "CRC32": "C0E77FBA",
                                        "BLAKE3": "435D7D8E67F14FBD78FFAD552561C0B22A628B3FFABE5FF7C6B6807EB3249177",
                                        "AutoV3": "0FEA4FD52295"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/33263",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 378949,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/a900fa17-34ea-4d6c-04b2-9edf92904300/width=450/378949.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UCH1}X-;01?b9*009Y~B0KI9=y=_?I^*9t9a",
                                    "type": "image"
                                },
                                {
                                    "id": 378948,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/2cec5b8f-0363-4dfd-b957-489ff2023000/width=450/378948.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UWHenMSiT0-:%%j@NdW;Otf5t6R-tmayj[bb",
                                    "type": "image"
                                },
                                {
                                    "id": 378947,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8e3119f1-05db-442b-aa1a-23c449818f00/width=450/378947.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UdH2K7t8S~Na_4ofX8WBx^oft7t7%gofS2W;",
                                    "type": "image"
                                },
                                {
                                    "id": 378946,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bbaed658-4b9e-41a8-db49-95a9cf6f5500/width=450/378946.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UdI#Jw%MEgM{?wSgWrs:KPkCxuaytR%2W.NG",
                                    "type": "image"
                                },
                                {
                                    "id": 378945,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/baac0ca1-1d6c-403c-8a24-1510b1060100/width=450/378945.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UEDSwUx^KkIU%%tStTaKNet8bct6xvfkS5xa",
                                    "type": "image"
                                },
                                {
                                    "id": 378944,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/fae5a887-1f93-4aaa-abfd-08d30d0f1f00/width=450/378944.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UAEex=o}00~C00R%9u4.sTIU?H^*57%f%1IU",
                                    "type": "image"
                                },
                                {
                                    "id": 378943,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/42f9da8c-87a2-4876-cfb3-52b282aac600/width=450/378943.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UWI5DF_2.SX9yZIpkrozx_xZtRW=M}aJWYkD",
                                    "type": "image"
                                },
                                {
                                    "id": 378942,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/953d75d6-9c62-45ba-462a-5b36b7e79700/width=450/378942.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "URE.-Lrpx]xWyZsR%Me-S*bHNGxuNIt7V@R+",
                                    "type": "image"
                                },
                                {
                                    "id": 378941,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/088319e9-a8ce-4199-f0b9-a5db7c785500/width=450/378941.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 1216,
                                    "height": 896,
                                    "hash": "UPFrkr~W9ZE1.9%LRP9ZI;NGRjRPkBR*xZ$%",
                                    "type": "image"
                                },
                                {
                                    "id": 378940,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/bbeb0adc-f8da-4a6b-30a5-56eaa8939e00/width=450/378940.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1152,
                                    "hash": "UNF6nYS6ysbx4UWXD*M{tmxuR4xsX.R*%Lfl",
                                    "type": "image"
                                },
                                {
                                    "id": 378939,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/35c3abfb-a229-40fe-0104-ed9394f15b00/width=450/378939.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1152,
                                    "hash": "UWF~,Fk9kqT0pfRkozS%yEt6M}WExcoeWoaL",
                                    "type": "image"
                                },
                                {
                                    "id": 378938,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/5362d4a7-037c-44d0-d82f-259543786700/width=450/378938.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UOGI+Yx[I-E1.Aa~S4R*Naxuo~ofx]WXkCt7",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/33263"
                        },
                        {
                            "id": 30934,
                            "name": "1.5",
                            "index": 4,
                            "modelId": 25306,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 30,
                            "description": "<p>Added Keywords \"Looming\" \"Sitting on Building\"<br /><br />Nonfuntional keyword: GigaGTS</p>",
                            "publishedAt": "2023-03-28T23:23:19.948",
                            "availability": "Public",
                            "trainedWords": [
                                "gts",
                                "looming",
                                "sitting on building"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 1533,
                                "ratingCount": 296,
                                "rating": 4.99,
                                "thumbsUpCount": 297,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 25519,
                                    "sizeKB": 147597.1865234375,
                                    "name": "GTSv2.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-28T23:26:31.843Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "4C9648D4",
                                        "AutoV2": "45985A11EB",
                                        "SHA256": "45985A11EBF826417C03D1A2722EC85901FD0C4F89B5D4495DDD7B2981AC6689",
                                        "CRC32": "1C589F80",
                                        "BLAKE3": "81395AA287D02F7ED8EC17B34CE05D3867654EAE93AAE9D94DC3F81875DAB901",
                                        "AutoV3": "E0EA7E6FB0B3"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/30934",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 351915,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/38311e74-f293-4149-6432-bc1846e44300/width=450/351915.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UJE{;FKlV@-6r|bx.TnhY8xGIUW?kr9ZM{RP",
                                    "type": "image"
                                },
                                {
                                    "id": 351914,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/21a27b99-d378-4d58-cce4-f4899b2f8400/width=450/351914.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "URFPjU%hyEER.AE1T1J:RQV?MxRkt8%Mn$M{",
                                    "type": "image"
                                },
                                {
                                    "id": 351913,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6bbb0e43-b154-42fb-2af0-248b1137e600/width=450/351913.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UQF$|rRkn#VX?wMdWBoeNHkDNaNJOYXmt7s9",
                                    "type": "image"
                                },
                                {
                                    "id": 351912,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/6b12de9e-9b0d-4932-982b-c98723f81800/width=450/351912.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 1216,
                                    "height": 1600,
                                    "hash": "UBIO*1?wIU%g0=vgGbI[i#E*U[=x}UIA%fEM",
                                    "type": "image"
                                },
                                {
                                    "id": 351911,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/8def7d6a-fe52-445d-b6f5-3289774df500/width=450/351911.jpeg",
                                    "nsfwLevel": 16,
                                    "width": 896,
                                    "height": 1152,
                                    "hash": "UhJR5WXnNZ9ayZR-WX%2E-W;s,%2Oss:$zR%",
                                    "type": "image"
                                },
                                {
                                    "id": 351910,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0070de9b-af49-433f-5efa-6670eab1e700/width=450/351910.jpeg",
                                    "nsfwLevel": 8,
                                    "width": 1216,
                                    "height": 1600,
                                    "hash": "UCJ[3UDO01oJ009]03nz0P^j=_xWnTt6~AE3",
                                    "type": "image"
                                },
                                {
                                    "id": 351909,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/357d4f0c-c205-42ab-e9a3-43191c0b9d00/width=450/351909.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UUHxjOxu9un#PXS5kDxFO[afxaj[o$s:NGog",
                                    "type": "image"
                                },
                                {
                                    "id": 351908,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/dfdcac3c-e28e-4057-921f-e89f93779d00/width=450/351908.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UUDvpGo~XURi%%o#Si%1I=RjM{%2WCRkRiaz",
                                    "type": "image"
                                },
                                {
                                    "id": 351907,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0b5f90a0-fede-405f-91b9-850c72f47600/width=450/351907.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UYFP8I%2x]xuyZSONyW=NIe.M{RjNbWUr?jY",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/30934"
                        },
                        {
                            "id": 30291,
                            "name": "1.0",
                            "index": 5,
                            "modelId": 25306,
                            "baseModel": "SD 1.5",
                            "nsfwLevel": 7,
                            "description": null,
                            "publishedAt": "2023-03-27T21:17:08.558",
                            "availability": "Public",
                            "trainedWords": [
                                "gts"
                            ],
                            "baseModelType": "Standard",
                            "stats": {
                                "downloadCount": 863,
                                "ratingCount": 132,
                                "rating": 5,
                                "thumbsUpCount": 132,
                                "thumbsDownCount": 0
                            },
                            "files": [
                                {
                                    "id": 25021,
                                    "sizeKB": 147582.7119140625,
                                    "name": "GTS.safetensors",
                                    "type": "Model",
                                    "pickleScanResult": "Success",
                                    "pickleScanMessage": "No Pickle imports",
                                    "virusScanResult": "Success",
                                    "virusScanMessage": null,
                                    "scannedAt": "2023-03-27T21:21:00.418Z",
                                    "metadata": {
                                        "format": "SafeTensor",
                                        "size": "full",
                                        "fp": "fp16"
                                    },
                                    "hashes": {
                                        "AutoV1": "F7A979C1",
                                        "AutoV2": "29ED9571A7",
                                        "SHA256": "29ED9571A7125A8B43F5646489AF303A35987BAE35B93663BB707DDAEB5F99EF",
                                        "CRC32": "7A82A802",
                                        "BLAKE3": "0B3429DF0CB7178D77FC4619C40083FE6739F22544118D32CDC50BAE15ABDA03",
                                        "AutoV3": "437EE8F23351"
                                    },
                                    "downloadUrl": "https://civitai.com/api/download/models/30291",
                                    "primary": true
                                }
                            ],
                            "images": [
                                {
                                    "id": 343945,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/032d7593-75b8-453b-28ab-8435c7d67400/width=450/343945.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UKH_V:^*xp-:.9SjOuIq.9bIIpWD_4tSIU={",
                                    "type": "image"
                                },
                                {
                                    "id": 343952,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/746de85a-4ba7-4e7c-8b20-e62e082ed600/width=450/343952.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UOI5AC=|Rj#*.TjYx^s:T1R%R,tS.9NIE1WB",
                                    "type": "image"
                                },
                                {
                                    "id": 343951,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/0efdc5af-6bb6-4582-968b-93184897ca00/width=450/343951.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UPGIp0Nf5nMx?dS6X:RjD%Rko#S%%2M{ROXn",
                                    "type": "image"
                                },
                                {
                                    "id": 343950,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/aadecbaf-81ef-414a-3e82-ca429cc7f900/width=450/343950.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UHJ7wF%M0e%L*0R+%1WC%zj]IoIVJox[xtt7",
                                    "type": "image"
                                },
                                {
                                    "id": 343949,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/3e1318ee-b563-49b7-4299-487f3c600e00/width=450/343949.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UCEBdQFf01-B1%-T}oNdOY-UENng?HOGI.r=",
                                    "type": "image"
                                },
                                {
                                    "id": 343948,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/1368010f-9070-49b8-73e8-151efc4d4900/width=450/343948.jpeg",
                                    "nsfwLevel": 1,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UGDc2eTMs*IU.TXnxBE2X-b_Nfs.Nf-pSi%2",
                                    "type": "image"
                                },
                                {
                                    "id": 343947,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/d064af67-04d9-468c-695e-6e94676efc00/width=450/343947.jpeg",
                                    "nsfwLevel": 4,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UAIha9={0O.T03xFI]EM0-RP}sMd=fEMSj%1",
                                    "type": "image"
                                },
                                {
                                    "id": 343946,
                                    "url": "https://image.civitai.com/xG1nkqKTMzGDvpLrqFT7WA/51cf7f59-2c9c-41fe-daf9-1d37dc197700/width=450/343946.jpeg",
                                    "nsfwLevel": 2,
                                    "width": 896,
                                    "height": 1216,
                                    "hash": "UlF~jpoztRxY.Tbcbbs,krozaeaeR.s:j?oL",
                                    "type": "image"
                                }
                            ],
                            "downloadUrl": "https://civitai.com/api/download/models/30291"
                        }
                    ]
                }
            ],
            "metadata": {
                "nextCursor": "3143:23022:7256",
                "nextPage": "https://civitai.com/api/v1/models?token=c78be941f274856f59fa771a44cd67a9&types=LORA&cursor=3143%3A23022%3A7256"
            }
        }
    }
}